Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
  value: function(y) {
    if (this == null)
      throw new TypeError("Array.prototype.find called on null or undefined");
    if (typeof y != "function")
      throw new TypeError("predicate must be a function");
    for (var e = Object(this), t = e.length >>> 0, n = arguments[1], s = 0; s !== t; s++)
      if (y.call(n, this[s], s, e))
        return this[s];
  }
});
Array.prototype.includes || (Array.prototype.includes = function(y) {
  if (this == null)
    throw new TypeError("Array.prototype.includes called on null or undefined");
  var e = Object(this), t = parseInt(e.length, 10) || 0;
  if (t === 0)
    return !1;
  var n = parseInt(arguments[1], 10) || 0, s;
  n >= 0 ? s = n : (s = t + n, s < 0 && (s = 0));
  for (var o; s < t; ) {
    if (o = e[s], y === o || y !== y && o !== o)
      return !0;
    s++;
  }
  return !1;
});
Array.prototype.map || (Array.prototype.map = function(y) {
  var e, t, n;
  if (this == null)
    throw new TypeError("this is null or not defined");
  var s = Object(this), o = s.length >>> 0;
  if (typeof y != "function")
    throw new TypeError(y + " is not a function");
  for (arguments.length > 1 && (e = arguments[1]), t = new Array(o), n = 0; n < o; ) {
    var h, c;
    n in s && (h = s[n], c = y.call(e, h, n, s), t[n] = c), n++;
  }
  return t;
});
String.prototype.startsWith || Object.defineProperty(String.prototype, "startsWith", {
  value: function(y, e) {
    var t = e > 0 ? e | 0 : 0;
    return this.substring(t, t + y.length) === y;
  }
});
String.prototype.endsWith || (String.prototype.endsWith = function(y, e) {
  return (e === void 0 || e > this.length) && (e = this.length), this.substring(e - y.length, e) === y;
});
var Ir = /* @__PURE__ */ ((y) => (y[y.Editor = 1] = "Editor", y[y.Viewer = 2] = "Viewer", y))(Ir || {}), Ja = /* @__PURE__ */ ((y) => (y.None = "None", y.Translate = "Translate", y.Rotate = "Rotate", y.Scaling = "Scaling", y))(Ja || {}), Py = /* @__PURE__ */ ((y) => (y[y.Customizer = 1] = "Customizer", y[y.Composer = 2] = "Composer", y[y.Viewer = 3] = "Viewer", y))(Py || {}), Uh = typeof Float32Array < "u" ? Float32Array : Array;
function Ny() {
  var y = new Uh(3);
  return Uh != Float32Array && (y[0] = 0, y[1] = 0, y[2] = 0), y;
}
function kh(y) {
  var e = y[0], t = y[1], n = y[2];
  return Math.sqrt(e * e + t * t + n * n);
}
(function() {
  var y = Ny();
  return function(e, t, n, s, o, h) {
    var c, m;
    for (t || (t = 3), n || (n = 0), s ? m = Math.min(s * t + n, e.length) : m = e.length, c = n; c < m; c += t)
      y[0] = e[c], y[1] = e[c + 1], y[2] = e[c + 2], o(y, y, h), e[c] = y[0], e[c + 1] = y[1], e[c + 2] = y[2];
    return e;
  };
})();
function Ry(y) {
  var e = y[0], t = y[1], n = y[2], s = y[3], o = y[4], h = y[5], c = y[6], m = y[7], x = y[8], B = y[9], I = y[10], F = y[11], M = y[12], Z = y[13], V = y[14], te = y[15], P = e * h - t * o, K = e * c - n * o, J = t * c - n * h, le = x * Z - B * M, fe = x * V - I * M, X = B * V - I * Z, W = e * X - t * fe + n * le, je = o * X - h * fe + c * le, Ee = x * J - B * K + I * P, He = M * J - Z * K + V * P;
  return m * W - s * je + te * Ee - F * He;
}
function Dy(y, e, t) {
  var n = e[0], s = e[1], o = e[2], h = e[3], c = e[4], m = e[5], x = e[6], B = e[7], I = e[8], F = e[9], M = e[10], Z = e[11], V = e[12], te = e[13], P = e[14], K = e[15], J = t[0], le = t[1], fe = t[2], X = t[3];
  return y[0] = J * n + le * c + fe * I + X * V, y[1] = J * s + le * m + fe * F + X * te, y[2] = J * o + le * x + fe * M + X * P, y[3] = J * h + le * B + fe * Z + X * K, J = t[4], le = t[5], fe = t[6], X = t[7], y[4] = J * n + le * c + fe * I + X * V, y[5] = J * s + le * m + fe * F + X * te, y[6] = J * o + le * x + fe * M + X * P, y[7] = J * h + le * B + fe * Z + X * K, J = t[8], le = t[9], fe = t[10], X = t[11], y[8] = J * n + le * c + fe * I + X * V, y[9] = J * s + le * m + fe * F + X * te, y[10] = J * o + le * x + fe * M + X * P, y[11] = J * h + le * B + fe * Z + X * K, J = t[12], le = t[13], fe = t[14], X = t[15], y[12] = J * n + le * c + fe * I + X * V, y[13] = J * s + le * m + fe * F + X * te, y[14] = J * o + le * x + fe * M + X * P, y[15] = J * h + le * B + fe * Z + X * K, y;
}
function zy(y, e) {
  var t = e[0], n = e[1], s = e[2], o = e[4], h = e[5], c = e[6], m = e[8], x = e[9], B = e[10];
  return y[0] = Math.sqrt(t * t + n * n + s * s), y[1] = Math.sqrt(o * o + h * h + c * c), y[2] = Math.sqrt(m * m + x * x + B * B), y;
}
function Fy(y, e) {
  var t = new Uh(3);
  zy(t, e);
  var n = 1 / t[0], s = 1 / t[1], o = 1 / t[2], h = e[0] * n, c = e[1] * s, m = e[2] * o, x = e[4] * n, B = e[5] * s, I = e[6] * o, F = e[8] * n, M = e[9] * s, Z = e[10] * o, V = h + B + Z, te = 0;
  return V > 0 ? (te = Math.sqrt(V + 1) * 2, y[3] = 0.25 * te, y[0] = (I - M) / te, y[1] = (F - m) / te, y[2] = (c - x) / te) : h > B && h > Z ? (te = Math.sqrt(1 + h - B - Z) * 2, y[3] = (I - M) / te, y[0] = 0.25 * te, y[1] = (c + x) / te, y[2] = (F + m) / te) : B > Z ? (te = Math.sqrt(1 + B - h - Z) * 2, y[3] = (F - m) / te, y[0] = (c + x) / te, y[1] = 0.25 * te, y[2] = (I + M) / te) : (te = Math.sqrt(1 + Z - h - B) * 2, y[3] = (c - x) / te, y[0] = (F + m) / te, y[1] = (I + M) / te, y[2] = 0.25 * te), y;
}
var tn, ml, Vh, la;
function Pi(y, e, t, n) {
  var s, o = arguments.length, h = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    h = Reflect.decorate(y, e, t, n);
  else
    for (var c = y.length - 1; c >= 0; c--)
      (s = y[c]) && (h = (o < 3 ? s(h) : o > 3 ? s(e, t, h) : s(e, t)) || h);
  return o > 3 && h && Object.defineProperty(e, t, h), h;
}
(function(y) {
  y.ACCESSOR = "Accessor", y.ANIMATION = "Animation", y.ANIMATION_CHANNEL = "AnimationChannel", y.ANIMATION_SAMPLER = "AnimationSampler", y.BUFFER = "Buffer", y.CAMERA = "Camera", y.MATERIAL = "Material", y.MESH = "Mesh", y.PRIMITIVE = "Primitive", y.PRIMITIVE_TARGET = "PrimitiveTarget", y.NODE = "Node", y.ROOT = "Root", y.SCENE = "Scene", y.SKIN = "Skin", y.TEXTURE = "Texture", y.TEXTURE_INFO = "TextureInfo";
})(tn || (tn = {})), function(y) {
  y.INTERLEAVED = "interleaved", y.SEPARATE = "separate";
}(ml || (ml = {})), function(y) {
  y[y.R = 4096] = "R", y[y.G = 256] = "G", y[y.B = 16] = "B", y[y.A = 1] = "A";
}(Vh || (Vh = {})), function(y) {
  y.GLTF = "GLTF", y.GLB = "GLB";
}(la || (la = {}));
class Bl {
  constructor(e, t, n) {
    if (this.t = void 0, this.i = void 0, this.h = void 0, this.o = !1, this.u = [], this.t = e, this.i = t, this.h = n, !t.canLink(n))
      throw new Error("Cannot link disconnected graphs/documents.");
  }
  getName() {
    return this.t;
  }
  getParent() {
    return this.i;
  }
  getChild() {
    return this.h;
  }
  setChild(e) {
    return this.h = e, this;
  }
  dispose() {
    this.o || (this.o = !0, this.u.forEach((e) => e()), this.u.length = 0);
  }
  onDispose(e) {
    return this.u.push(e), this;
  }
  isDisposed() {
    return this.o;
  }
}
class Uy {
  constructor() {
    this.l = /* @__PURE__ */ new Set(), this.p = /* @__PURE__ */ new Set(), this.g = /* @__PURE__ */ new Map(), this.v = /* @__PURE__ */ new Map(), this.u = {};
  }
  on(e, t) {
    return this.u[e] = this.u[e] || [], this.u[e].push(t), this;
  }
  emit(e, t) {
    for (const n of this.u[e] || [])
      n(t);
    return this;
  }
  getLinks() {
    return Array.from(this.p);
  }
  listParentLinks(e) {
    return Array.from(this.v.get(e) || this.l);
  }
  listParents(e) {
    return this.listParentLinks(e).map((t) => t.getParent());
  }
  listChildLinks(e) {
    return Array.from(this.g.get(e) || this.l);
  }
  listChildren(e) {
    return this.listChildLinks(e).map((t) => t.getChild());
  }
  disconnectChildren(e) {
    return (this.g.get(e) || this.l).forEach((t) => t.dispose()), this;
  }
  disconnectParents(e, t) {
    let n = Array.from(this.v.get(e) || this.l);
    return t && (n = n.filter((s) => t(s.getParent()))), n.forEach((s) => s.dispose()), this;
  }
  swapChild(e, t, n) {
    const s = this.g.get(e) || this.l;
    return Array.from(s).filter((o) => o.getChild() === t).forEach((o) => {
      this.v.get(t).delete(o), o.setChild(n), this.v.has(n) || this.v.set(n, /* @__PURE__ */ new Set()), this.v.get(n).add(o);
    }), this;
  }
  link(e, t, n) {
    if (!n)
      return null;
    const s = new Bl(e, t, n);
    return this.registerLink(s), s;
  }
  registerLink(e) {
    this.p.add(e);
    const t = e.getParent();
    this.g.has(t) || this.g.set(t, /* @__PURE__ */ new Set()), this.g.get(t).add(e);
    const n = e.getChild();
    return this.v.has(n) || this.v.set(n, /* @__PURE__ */ new Set()), this.v.get(n).add(e), e.onDispose(() => this.unlink(e)), e;
  }
  unlink(e) {
    return this.p.delete(e), this.g.get(e.getParent()).delete(e), this.v.get(e.getChild()).delete(e), this;
  }
}
function En(y, e) {
  Object.defineProperty(y, e, { get: function() {
    return this["__" + e];
  }, set: function(t) {
    const n = this["__" + e];
    n && !Array.isArray(n) && n.dispose(), t && !Array.isArray(t) && t.onDispose(() => {
      this["__" + e] = null;
    }), this["__" + e] = t;
  }, enumerable: !0 });
}
function Wn(y, e) {
}
class xr {
  static createBufferFromDataURI(e) {
    if (typeof Buffer > "u") {
      const t = atob(e.split(",")[1]), n = new Uint8Array(t.length);
      for (let s = 0; s < t.length; s++)
        n[s] = t.charCodeAt(s);
      return n.buffer;
    }
    {
      const t = e.split(",")[1], n = e.indexOf("base64") >= 0;
      return this.trim(Buffer.from(t, n ? "base64" : "utf8"));
    }
  }
  static encodeText(e) {
    return typeof TextEncoder < "u" ? new TextEncoder().encode(e).buffer : this.trim(Buffer.from(e));
  }
  static decodeText(e) {
    return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : Buffer.from(e).toString("utf8");
  }
  static trim(e) {
    const { byteOffset: t, byteLength: n } = e;
    return e.buffer.slice(t, t + n);
  }
  static concat(e) {
    let t = 0;
    for (const o of e)
      t += o.byteLength;
    const n = new Uint8Array(t);
    let s = 0;
    for (const o of e)
      n.set(new Uint8Array(o), s), s += o.byteLength;
    return n.buffer;
  }
  static pad(e, t = 0) {
    const n = this.padNumber(e.byteLength);
    if (n !== e.byteLength) {
      const s = new Uint8Array(n);
      if (s.set(new Uint8Array(e)), t !== 0)
        for (let o = e.byteLength; o < n; o++)
          s[o] = t;
      return s.buffer;
    }
    return e;
  }
  static padNumber(e) {
    return 4 * Math.ceil(e / 4);
  }
  static equals(e, t) {
    if (e === t)
      return !0;
    if (e.byteLength !== t.byteLength)
      return !1;
    const n = new DataView(e), s = new DataView(t);
    let o = e.byteLength;
    for (; o--; )
      if (n.getUint8(o) !== s.getUint8(o))
        return !1;
    return !0;
  }
}
class Ko {
  static hexToFactor(e, t) {
    e = Math.floor(e);
    const n = t;
    return n[0] = (e >> 16 & 255) / 255, n[1] = (e >> 8 & 255) / 255, n[2] = (255 & e) / 255, this.convertSRGBToLinear(t, t);
  }
  static factorToHex(e) {
    const t = [...e], [n, s, o] = this.convertLinearToSRGB(e, t);
    return 255 * n << 16 ^ 255 * s << 8 ^ 255 * o << 0;
  }
  static convertSRGBToLinear(e, t) {
    const n = e, s = t;
    for (let o = 0; o < 3; o++)
      s[o] = n[o] < 0.04045 ? 0.0773993808 * n[o] : Math.pow(0.9478672986 * n[o] + 0.0521327014, 2.4);
    return t;
  }
  static convertLinearToSRGB(e, t) {
    const n = e, s = t;
    for (let o = 0; o < 3; o++)
      s[o] = n[o] < 31308e-7 ? 12.92 * n[o] : 1.055 * Math.pow(n[o], 0.41666) - 0.055;
    return t;
  }
}
class _l {
  static basename(e) {
    const t = e.split(/[\\/]/).pop();
    return t.substr(0, t.lastIndexOf("."));
  }
  static extension(e) {
    return e.indexOf("data:") !== 0 ? e.split(/[\\/]/).pop().split(/[.]/).pop() : e.indexOf("data:image/png") === 0 ? "png" : e.indexOf("data:image/jpeg") === 0 ? "jpeg" : "bin";
  }
}
class kl {
  match(e) {
    const t = new Uint8Array(e);
    return t.length >= 8 && t[0] === 137 && t[1] === 80 && t[2] === 78 && t[3] === 71 && t[4] === 13 && t[5] === 10 && t[6] === 26 && t[7] === 10;
  }
  getSize(e) {
    const t = new DataView(e);
    return xr.decodeText(e.slice(12, 16)) === kl.PNG_FRIED_CHUNK_NAME ? [t.getUint32(32, !1), t.getUint32(36, !1)] : [t.getUint32(16, !1), t.getUint32(20, !1)];
  }
  getChannels(e) {
    return 4;
  }
}
kl.PNG_FRIED_CHUNK_NAME = "CgBI";
class Ba {
  static registerFormat(e, t) {
    this.impls[e] = t;
  }
  static getMimeType(e) {
    for (const t in this.impls)
      if (this.impls[t].match(e))
        return t;
    return null;
  }
  static getSize(e, t) {
    return this.impls[t] ? this.impls[t].getSize(e) : null;
  }
  static getChannels(e, t) {
    return this.impls[t] ? this.impls[t].getChannels(e) : null;
  }
  static getMemSize(e, t) {
    if (!this.impls[t])
      return null;
    if (this.impls[t].getGPUByteLength)
      return this.impls[t].getGPUByteLength(e);
    let n = 0;
    const s = this.getSize(e, t);
    if (!s)
      return null;
    for (; s[0] > 1 || s[1] > 1; )
      n += s[0] * s[1] * 4, s[0] = Math.max(Math.floor(s[0] / 2), 1), s[1] = Math.max(Math.floor(s[1] / 2), 1);
    return n += 4, n;
  }
  static mimeTypeToExtension(e) {
    return e === "image/jpeg" ? "jpg" : e.split("/").pop();
  }
  static extensionToMimeType(e) {
    return e === "jpg" ? "image/jpeg" : `image/${e}`;
  }
}
function Vy(y, e) {
  if (e > y.byteLength)
    throw new TypeError("Corrupt JPG, exceeded buffer limits");
  if (y.getUint8(e) !== 255)
    throw new TypeError("Invalid JPG, marker table corrupted");
  return y;
}
Ba.impls = { "image/jpeg": new class {
  match(y) {
    const e = new Uint8Array(y);
    return e.length >= 3 && e[0] === 255 && e[1] === 216 && e[2] === 255;
  }
  getSize(y) {
    let e, t, n = new DataView(y, 4);
    for (; n.byteLength; ) {
      if (e = n.getUint16(0, !1), Vy(n, e), t = n.getUint8(e + 1), t === 192 || t === 193 || t === 194)
        return [n.getUint16(e + 7, !1), n.getUint16(e + 5, !1)];
      n = new DataView(y, n.byteOffset + e + 2);
    }
    throw new TypeError("Invalid JPG, no size found");
  }
  getChannels(y) {
    return 3;
  }
}(), "image/png": new kl() };
class Kn {
  static identity(e) {
    return e;
  }
  static eq(e, t) {
    if (e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (Math.abs(e[n] - t[n]) > 1e-5)
        return !1;
    return !0;
  }
  static denormalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return e / 65535;
      case 5121:
        return e / 255;
      case 5122:
        return Math.max(e / 32767, -1);
      case 5120:
        return Math.max(e / 127, -1);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static normalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return Math.round(65535 * e);
      case 5121:
        return Math.round(255 * e);
      case 5122:
        return Math.round(32767 * e);
      case 5120:
        return Math.round(127 * e);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static decompose(e, t, n, s) {
    let o = kh([e[0], e[1], e[2]]);
    const h = kh([e[4], e[5], e[6]]), c = kh([e[8], e[9], e[10]]);
    Ry(e) < 0 && (o = -o), t[0] = e[12], t[1] = e[13], t[2] = e[14];
    const m = e.slice(), x = 1 / o, B = 1 / h, I = 1 / c;
    m[0] *= x, m[1] *= x, m[2] *= x, m[4] *= B, m[5] *= B, m[6] *= B, m[8] *= I, m[9] *= I, m[10] *= I, Fy(n, m), s[0] = o, s[1] = h, s[2] = c;
  }
  static compose(e, t, n, s) {
    const o = s, h = t[0], c = t[1], m = t[2], x = t[3], B = h + h, I = c + c, F = m + m, M = h * B, Z = h * I, V = h * F, te = c * I, P = c * F, K = m * F, J = x * B, le = x * I, fe = x * F, X = n[0], W = n[1], je = n[2];
    return o[0] = (1 - (te + K)) * X, o[1] = (Z + fe) * X, o[2] = (V - le) * X, o[3] = 0, o[4] = (Z - fe) * W, o[5] = (1 - (M + K)) * W, o[6] = (P + J) * W, o[7] = 0, o[8] = (V + le) * je, o[9] = (P - J) * je, o[10] = (1 - (M + te)) * je, o[11] = 0, o[12] = e[0], o[13] = e[1], o[14] = e[2], o[15] = 1, o;
  }
}
class Wr {
  constructor(e) {
    this.verbosity = void 0, this.verbosity = e;
  }
  debug(e) {
    this.verbosity <= Wr.Verbosity.DEBUG && console.debug(e);
  }
  info(e) {
    this.verbosity <= Wr.Verbosity.INFO && console.info(e);
  }
  warn(e) {
    this.verbosity <= Wr.Verbosity.WARN && console.warn(e);
  }
  error(e) {
    this.verbosity <= Wr.Verbosity.ERROR && console.error(e);
  }
}
Wr.Verbosity = { SILENT: 4, ERROR: 3, WARN: 2, INFO: 1, DEBUG: 0 }, Wr.DEFAULT_INSTANCE = new Wr(Wr.Verbosity.INFO);
const wf = "23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ", Sf = /* @__PURE__ */ new Set(), Hy = function() {
  let y = "";
  for (let e = 0; e < 6; e++)
    y += wf.charAt(Math.floor(Math.random() * wf.length));
  return y;
}, Yy = function() {
  for (let y = 0; y < 999; y++) {
    const e = Hy();
    if (!Sf.has(e))
      return Sf.add(e), e;
  }
  return "";
}, In = (y) => y;
class Ia extends class {
  constructor(e) {
    this.graph = void 0, this.o = !1, this.graph = e, this.graph = e;
  }
  canLink(e) {
    return this.graph === e.graph;
  }
  isDisposed() {
    return this.o;
  }
  dispose() {
    this.graph.disconnectChildren(this), this.graph.disconnectParents(this), this.o = !0, this.graph.emit("dispose", this);
  }
  detach() {
    return this.graph.disconnectParents(this), this;
  }
  swap(e, t) {
    return this.graph.swapChild(this, e, t), this;
  }
  addGraphChild(e, t) {
    return e.push(t), t.onDispose(() => {
      const n = e.filter((s) => s !== t);
      e.length = 0;
      for (const s of n)
        e.push(s);
    }), this;
  }
  removeGraphChild(e, t) {
    return e.filter((n) => n.getChild() === t).forEach((n) => n.dispose()), this;
  }
  clearGraphChildList(e) {
    for (; e.length > 0; )
      e[0].dispose();
    return this;
  }
  listGraphParents() {
    return this.graph.listParents(this);
  }
} {
  constructor(e, t = "") {
    super(e), this.graph = void 0, this.m = {}, this.t = "", this.graph = e, this.t = t;
  }
  getName() {
    return this.t;
  }
  setName(e) {
    return this.t = e, this;
  }
  getExtras() {
    return this.m;
  }
  setExtras(e) {
    return this.m = e, this;
  }
  clone() {
    const e = new this.constructor(this.graph).copy(this, In);
    return this.graph.emit("clone", e), e;
  }
  copy(e, t = In) {
    return this.t = e.t, this.m = JSON.parse(JSON.stringify(e.m)), this;
  }
  detach() {
    return this.graph.disconnectParents(this, (e) => e.propertyType !== "Root"), this;
  }
  listParents() {
    return this.listGraphParents();
  }
}
const Mf = "Pass extension name (string) as lookup token, not a constructor.";
class Zr extends Ia {
  constructor(...e) {
    super(...e), this.extensions = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.clearGraphChildList(this.extensions), e.extensions.forEach((n) => {
      const s = n.getChild();
      this.setExtension(s.extensionName, t(s));
    }), this;
  }
  getExtension(e) {
    if (typeof e != "string")
      throw new Error(Mf);
    const t = this.extensions.find((n) => n.getChild().extensionName === e);
    return t ? t.getChild() : null;
  }
  setExtension(e, t) {
    if (typeof e != "string")
      throw new Error(Mf);
    const n = this.getExtension(e);
    return n && this.removeGraphChild(this.extensions, n), t ? (t.T(this), this.addGraphChild(this.extensions, this.graph.link(e, this, t))) : this;
  }
  listExtensions() {
    return this.extensions.map((e) => e.getChild());
  }
}
Pi([Wn], Zr.prototype, "extensions", void 0);
class Bi extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.ACCESSOR, this.S = null, this.M = Bi.Type.SCALAR, this.I = Bi.ComponentType.FLOAT, this.N = !1, this.C = Kn.identity, this.O = Kn.identity, this.buffer = null;
  }
  copy(e, t = In) {
    return super.copy(e, t), this.M = e.M, this.I = e.I, this.N = e.N, this.C = e.C, this.O = e.O, e.S && (this.S = e.S.slice()), this.setBuffer(e.buffer ? t(e.buffer.getChild()) : null), this;
  }
  static getElementSize(e) {
    switch (e) {
      case Bi.Type.SCALAR:
        return 1;
      case Bi.Type.VEC2:
        return 2;
      case Bi.Type.VEC3:
        return 3;
      case Bi.Type.VEC4:
      case Bi.Type.MAT2:
        return 4;
      case Bi.Type.MAT3:
        return 9;
      case Bi.Type.MAT4:
        return 16;
      default:
        throw new Error("Unexpected type: " + e);
    }
  }
  static getComponentSize(e) {
    switch (e) {
      case Bi.ComponentType.BYTE:
      case Bi.ComponentType.UNSIGNED_BYTE:
        return 1;
      case Bi.ComponentType.SHORT:
      case Bi.ComponentType.UNSIGNED_SHORT:
        return 2;
      case Bi.ComponentType.UNSIGNED_INT:
      case Bi.ComponentType.FLOAT:
        return 4;
      default:
        throw new Error("Unexpected component type: " + e);
    }
  }
  getMinNormalized(e) {
    const t = this.getElementSize();
    this.getMin(e);
    for (let n = 0; n < t; n++)
      e[n] = this.O(e[n]);
    return e;
  }
  getMin(e) {
    const t = this.getCount(), n = this.getElementSize();
    for (let s = 0; s < n; s++)
      e[s] = 1 / 0;
    for (let s = 0; s < t * n; s += n)
      for (let o = 0; o < n; o++) {
        const h = this.S[s + o];
        Number.isFinite(h) && (e[o] = Math.min(e[o], h));
      }
    return e;
  }
  getMaxNormalized(e) {
    const t = this.getElementSize();
    this.getMax(e);
    for (let n = 0; n < t; n++)
      e[n] = this.O(e[n]);
    return e;
  }
  getMax(e) {
    const t = this.getCount(), n = this.getElementSize();
    for (let s = 0; s < n; s++)
      e[s] = -1 / 0;
    for (let s = 0; s < t * n; s += n)
      for (let o = 0; o < n; o++) {
        const h = this.S[s + o];
        Number.isFinite(h) && (e[o] = Math.max(e[o], h));
      }
    return e;
  }
  getCount() {
    return this.S ? this.S.length / this.getElementSize() : 0;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getElementSize() {
    return Bi.getElementSize(this.M);
  }
  getComponentSize() {
    return this.S.BYTES_PER_ELEMENT;
  }
  getComponentType() {
    return this.I;
  }
  getNormalized() {
    return this.N;
  }
  setNormalized(e) {
    return this.N = e, e ? (this.O = (t) => Kn.denormalize(t, this.I), this.C = (t) => Kn.normalize(t, this.I)) : (this.O = Kn.identity, this.C = Kn.identity), this;
  }
  getScalar(e) {
    const t = this.getElementSize();
    return this.O(this.S[e * t]);
  }
  setScalar(e, t) {
    return this.S[e * this.getElementSize()] = this.C(t), this;
  }
  getElement(e, t) {
    const n = this.getElementSize();
    for (let s = 0; s < n; s++)
      t[s] = this.O(this.S[e * n + s]);
    return t;
  }
  setElement(e, t) {
    const n = this.getElementSize();
    for (let s = 0; s < n; s++)
      this.S[e * n + s] = this.C(t[s]);
    return this;
  }
  getBuffer() {
    return this.buffer ? this.buffer.getChild() : null;
  }
  setBuffer(e) {
    return this.buffer = this.graph.link("buffer", this, e), this;
  }
  getArray() {
    return this.S;
  }
  setArray(e) {
    return this.I = e ? function(t) {
      switch (t.constructor) {
        case Float32Array:
          return Bi.ComponentType.FLOAT;
        case Uint32Array:
          return Bi.ComponentType.UNSIGNED_INT;
        case Uint16Array:
          return Bi.ComponentType.UNSIGNED_SHORT;
        case Uint8Array:
          return Bi.ComponentType.UNSIGNED_BYTE;
        case Int16Array:
          return Bi.ComponentType.SHORT;
        case Int8Array:
          return Bi.ComponentType.BYTE;
        default:
          throw new Error("Unknown accessor componentType.");
      }
    }(e) : Bi.ComponentType.FLOAT, this.S = e, this;
  }
  getByteLength() {
    return this.S ? this.S.byteLength : 0;
  }
}
Bi.Type = { SCALAR: "SCALAR", VEC2: "VEC2", VEC3: "VEC3", VEC4: "VEC4", MAT2: "MAT2", MAT3: "MAT3", MAT4: "MAT4" }, Bi.ComponentType = { BYTE: 5120, UNSIGNED_BYTE: 5121, SHORT: 5122, UNSIGNED_SHORT: 5123, UNSIGNED_INT: 5125, FLOAT: 5126 }, Pi([En], Bi.prototype, "buffer", void 0);
class vl extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.ANIMATION, this.channels = [], this.samplers = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.clearGraphChildList(this.channels), this.clearGraphChildList(this.samplers), e.channels.forEach((n) => this.addChannel(t(n.getChild()))), e.samplers.forEach((n) => this.addSampler(t(n.getChild()))), this;
  }
  addChannel(e) {
    const t = this.graph.link("channel", this, e);
    return this.addGraphChild(this.channels, t);
  }
  removeChannel(e) {
    return this.removeGraphChild(this.channels, e);
  }
  listChannels() {
    return this.channels.map((e) => e.getChild());
  }
  addSampler(e) {
    const t = this.graph.link("sampler", this, e);
    return this.addGraphChild(this.samplers, t);
  }
  removeSampler(e) {
    return this.removeGraphChild(this.samplers, e);
  }
  listSamplers() {
    return this.samplers.map((e) => e.getChild());
  }
}
Pi([Wn], vl.prototype, "channels", void 0), Pi([Wn], vl.prototype, "samplers", void 0);
class ll extends Ia {
  constructor(...e) {
    super(...e), this.propertyType = tn.ANIMATION_CHANNEL, this._ = null, this.targetNode = null, this.sampler = null;
  }
  copy(e, t = In) {
    return super.copy(e, t), this._ = e._, this.setTargetNode(e.targetNode ? t(e.targetNode.getChild()) : null), this.setSampler(e.sampler ? t(e.sampler.getChild()) : null), this;
  }
  getTargetPath() {
    return this._;
  }
  setTargetPath(e) {
    return this._ = e, this;
  }
  getTargetNode() {
    return this.targetNode ? this.targetNode.getChild() : null;
  }
  setTargetNode(e) {
    return this.targetNode = this.graph.link("target.node", this, e), this;
  }
  getSampler() {
    return this.sampler ? this.sampler.getChild() : null;
  }
  setSampler(e) {
    return this.sampler = this.graph.link("sampler", this, e), this;
  }
}
ll.TargetPath = { TRANSLATION: "translation", ROTATION: "rotation", SCALE: "scale", WEIGHTS: "weights" }, Pi([En], ll.prototype, "targetNode", void 0), Pi([En], ll.prototype, "sampler", void 0);
class ua extends Ia {
  constructor(...e) {
    super(...e), this.propertyType = tn.ANIMATION_SAMPLER, this.L = ua.Interpolation.LINEAR, this.input = null, this.output = null;
  }
  copy(e, t = In) {
    return super.copy(e, t), this.L = e.L, this.setInput(e.input ? t(e.input.getChild()) : null), this.setOutput(e.output ? t(e.output.getChild()) : null), this;
  }
  getInterpolation() {
    return this.L;
  }
  setInterpolation(e) {
    return this.L = e, this;
  }
  getInput() {
    return this.input ? this.input.getChild() : null;
  }
  setInput(e) {
    return this.input = this.graph.link("input", this, e), this;
  }
  getOutput() {
    return this.output ? this.output.getChild() : null;
  }
  setOutput(e) {
    return this.output = this.graph.link("output", this, e), this;
  }
}
ua.Interpolation = { LINEAR: "LINEAR", STEP: "STEP", CUBICSPLINE: "CUBICSPLINE" }, Pi([En], ua.prototype, "input", void 0), Pi([En], ua.prototype, "output", void 0);
let gd = class extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.BUFFER, this.P = "";
  }
  copy(e, t = In) {
    return super.copy(e, t), this.P = e.P, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this;
  }
};
class ca extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.CAMERA, this.M = ca.Type.PERSPECTIVE, this.U = 0.1, this.k = 100, this.F = null, this.j = 2 * Math.PI * 50 / 360, this.D = 1, this.J = 1;
  }
  copy(e, t = In) {
    return super.copy(e, t), this.M = e.M, this.U = e.U, this.k = e.k, this.F = e.F, this.j = e.j, this.D = e.D, this.J = e.J, this;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getZNear() {
    return this.U;
  }
  setZNear(e) {
    return this.U = e, this;
  }
  getZFar() {
    return this.k;
  }
  setZFar(e) {
    return this.k = e, this;
  }
  getAspectRatio() {
    return this.F;
  }
  setAspectRatio(e) {
    return this.F = e, this;
  }
  getYFov() {
    return this.j;
  }
  setYFov(e) {
    return this.j = e, this;
  }
  getXMag() {
    return this.D;
  }
  setXMag(e) {
    return this.D = e, this;
  }
  getYMag() {
    return this.J;
  }
  setYMag(e) {
    return this.J = e, this;
  }
}
ca.Type = { PERSPECTIVE: "perspective", ORTHOGRAPHIC: "orthographic" };
class pd extends Ia {
  constructor(e, t) {
    super(e), this.$ = void 0, this.$ = t, this.$.addExtensionProperty(this);
  }
  clone() {
    const e = new this.constructor(this.graph, this.$).copy(this, In);
    return this.graph.emit("clone", e), e;
  }
  dispose() {
    this.$.removeExtensionProperty(this), super.dispose();
  }
  T(e) {
    if (!this.parentTypes.includes(e.propertyType))
      throw new Error(`Parent "${e.propertyType}" invalid for child "${this.propertyType}".`);
  }
}
pd.EXTENSION_NAME = void 0;
class md extends Bl {
  constructor(...e) {
    super(...e), this.semantic = "";
  }
  copy(e) {
    return this.semantic = e.semantic, this;
  }
}
class _d extends Bl {
  copy(e) {
    return this;
  }
}
let Gy = class extends Bl {
  constructor(...e) {
    super(...e), this.channels = 0;
  }
  copy(e) {
    return this.channels = e.channels, this;
  }
};
class jy extends Uy {
  linkAttribute(e, t, n) {
    if (!n)
      return null;
    const s = new md(e, t, n);
    return s.semantic = e, this.registerLink(s), s;
  }
  linkIndex(e, t, n) {
    if (!n)
      return null;
    const s = new _d(e, t, n);
    return this.registerLink(s), s;
  }
  linkTexture(e, t, n, s) {
    if (!s)
      return null;
    const o = new Gy(e, n, s);
    return o.channels = t, this.registerLink(o), o;
  }
}
class gs extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.TEXTURE_INFO, this.V = 0, this.W = null, this.q = null, this.Y = gs.WrapMode.REPEAT, this.H = gs.WrapMode.REPEAT;
  }
  copy(e, t = In) {
    return super.copy(e, t), this.V = e.V, this.W = e.W, this.q = e.q, this.Y = e.Y, this.H = e.H, this;
  }
  equals(e) {
    return this.getTexCoord() === e.getTexCoord() && this.getMagFilter() === e.getMagFilter() && this.getMinFilter() === e.getMinFilter() && this.getWrapS() === e.getWrapS() && this.getWrapT() === e.getWrapT();
  }
  getTexCoord() {
    return this.V;
  }
  setTexCoord(e) {
    return this.V = e, this;
  }
  getMagFilter() {
    return this.W;
  }
  setMagFilter(e) {
    return this.W = e, this;
  }
  getMinFilter() {
    return this.q;
  }
  setMinFilter(e) {
    return this.q = e, this;
  }
  getWrapS() {
    return this.Y;
  }
  setWrapS(e) {
    return this.Y = e, this;
  }
  getWrapT() {
    return this.H;
  }
  setWrapT(e) {
    return this.H = e, this;
  }
}
gs.WrapMode = { CLAMP_TO_EDGE: 33071, MIRRORED_REPEAT: 33648, REPEAT: 10497 }, gs.MagFilter = { NEAREST: 9728, LINEAR: 9729 }, gs.MinFilter = { NEAREST: 9728, LINEAR: 9729, NEAREST_MIPMAP_NEAREST: 9984, LINEAR_MIPMAP_NEAREST: 9985, NEAREST_MIPMAP_LINEAR: 9986, LINEAR_MIPMAP_LINEAR: 9987 };
const { R: Jo, G: Qo, B: el, A: Wy } = Vh;
class nr extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.MATERIAL, this.Z = nr.AlphaMode.OPAQUE, this.K = 0.5, this.X = !1, this.tt = [1, 1, 1, 1], this.st = [0, 0, 0], this.et = 1, this.it = 1, this.rt = 1, this.nt = 1, this.baseColorTexture = null, this.baseColorTextureInfo = this.graph.link("baseColorTextureInfo", this, new gs(this.graph)), this.emissiveTexture = null, this.emissiveTextureInfo = this.graph.link("emissiveTextureInfo", this, new gs(this.graph)), this.normalTexture = null, this.normalTextureInfo = this.graph.link("normalTextureInfo", this, new gs(this.graph)), this.occlusionTexture = null, this.occlusionTextureInfo = this.graph.link("occlusionTextureInfo", this, new gs(this.graph)), this.metallicRoughnessTexture = null, this.metallicRoughnessTextureInfo = this.graph.link("metallicRoughnessTextureInfo", this, new gs(this.graph));
  }
  copy(e, t = In) {
    return super.copy(e, t), this.Z = e.Z, this.K = e.K, this.X = e.X, this.tt = [...e.tt], this.st = [...e.st], this.et = e.et, this.it = e.it, this.rt = e.rt, this.nt = e.nt, this.setBaseColorTexture(e.baseColorTexture ? t(e.baseColorTexture.getChild()) : null), this.baseColorTextureInfo.getChild().copy(t(e.baseColorTextureInfo.getChild()), t), this.setEmissiveTexture(e.emissiveTexture ? t(e.emissiveTexture.getChild()) : null), this.emissiveTextureInfo.getChild().copy(t(e.emissiveTextureInfo.getChild()), t), this.setNormalTexture(e.normalTexture ? t(e.normalTexture.getChild()) : null), this.normalTextureInfo.getChild().copy(t(e.normalTextureInfo.getChild()), t), this.setOcclusionTexture(e.occlusionTexture ? t(e.occlusionTexture.getChild()) : null), this.occlusionTextureInfo.getChild().copy(t(e.occlusionTextureInfo.getChild()), t), this.setMetallicRoughnessTexture(e.metallicRoughnessTexture ? t(e.metallicRoughnessTexture.getChild()) : null), this.metallicRoughnessTextureInfo.getChild().copy(t(e.metallicRoughnessTextureInfo.getChild()), t), this;
  }
  equals(e) {
    if (this.getAlphaMode() !== e.getAlphaMode() || this.getAlphaCutoff() !== e.getAlphaCutoff() || this.getDoubleSided() !== e.getDoubleSided() || !Kn.eq(this.getBaseColorFactor(), e.getBaseColorFactor()) || !Kn.eq(this.getEmissiveFactor(), e.getEmissiveFactor()) || this.getNormalScale() !== e.getNormalScale() || this.getOcclusionStrength() !== e.getOcclusionStrength() || this.getRoughnessFactor() !== e.getRoughnessFactor() || this.getMetallicFactor() !== e.getMetallicFactor() || (this.getBaseColorTexture() || e.getBaseColorTexture()) && (this.getBaseColorTexture() !== e.getBaseColorTexture() || this.getBaseColorTexture() && !this.getBaseColorTextureInfo().equals(e.getBaseColorTextureInfo())) || (this.getEmissiveTexture() || e.getEmissiveTexture()) && (this.getEmissiveTexture() !== e.getEmissiveTexture() || this.getEmissiveTexture() && !this.getEmissiveTextureInfo().equals(e.getEmissiveTextureInfo())) || (this.getNormalTexture() || e.getNormalTexture()) && (this.getNormalTexture() !== e.getNormalTexture() || this.getNormalTexture() && !this.getNormalTextureInfo().equals(e.getNormalTextureInfo())) || (this.getOcclusionTexture() || e.getOcclusionTexture()) && (this.getOcclusionTexture() !== e.getOcclusionTexture() || this.getOcclusionTexture() && !this.getOcclusionTextureInfo().equals(e.getOcclusionTextureInfo())) || (this.getMetallicRoughnessTexture() || e.getMetallicRoughnessTexture()) && (this.getMetallicRoughnessTexture() !== e.getMetallicRoughnessTexture() || this.getMetallicRoughnessTexture() && !this.getMetallicRoughnessTextureInfo().equals(e.getMetallicRoughnessTextureInfo())))
      return !1;
    const t = this.listExtensions(), n = e.listExtensions();
    if (t.length !== n.length)
      return !1;
    for (let s = 0; s < t.length; s++)
      if (t[s] !== n[s])
        return !1;
    return !0;
  }
  dispose() {
    this.baseColorTextureInfo.getChild().dispose(), this.emissiveTextureInfo.getChild().dispose(), this.normalTextureInfo.getChild().dispose(), this.occlusionTextureInfo.getChild().dispose(), this.metallicRoughnessTextureInfo.getChild().dispose(), super.dispose();
  }
  getDoubleSided() {
    return this.X;
  }
  setDoubleSided(e) {
    return this.X = e, this;
  }
  getAlpha() {
    return this.tt[3];
  }
  setAlpha(e) {
    return this.tt[3] = e, this;
  }
  getAlphaMode() {
    return this.Z;
  }
  setAlphaMode(e) {
    return this.Z = e, this;
  }
  getAlphaCutoff() {
    return this.K;
  }
  setAlphaCutoff(e) {
    return this.K = e, this;
  }
  getBaseColorFactor() {
    return this.tt;
  }
  setBaseColorFactor(e) {
    return this.tt = e, this;
  }
  getBaseColorHex() {
    return Ko.factorToHex(this.tt);
  }
  setBaseColorHex(e) {
    return Ko.hexToFactor(e, this.tt), this;
  }
  getBaseColorTexture() {
    return this.baseColorTexture ? this.baseColorTexture.getChild() : null;
  }
  getBaseColorTextureInfo() {
    return this.baseColorTexture ? this.baseColorTextureInfo.getChild() : null;
  }
  setBaseColorTexture(e) {
    return this.baseColorTexture = this.graph.linkTexture("baseColorTexture", Jo | Qo | el | Wy, this, e), this;
  }
  getEmissiveFactor() {
    return this.st;
  }
  setEmissiveFactor(e) {
    return this.st = e, this;
  }
  getEmissiveHex() {
    return Ko.factorToHex(this.st);
  }
  setEmissiveHex(e) {
    return Ko.hexToFactor(e, this.st), this;
  }
  getEmissiveTexture() {
    return this.emissiveTexture ? this.emissiveTexture.getChild() : null;
  }
  getEmissiveTextureInfo() {
    return this.emissiveTexture ? this.emissiveTextureInfo.getChild() : null;
  }
  setEmissiveTexture(e) {
    return this.emissiveTexture = this.graph.linkTexture("emissiveTexture", Jo | Qo | el, this, e), this;
  }
  getNormalScale() {
    return this.et;
  }
  setNormalScale(e) {
    return this.et = e, this;
  }
  getNormalTexture() {
    return this.normalTexture ? this.normalTexture.getChild() : null;
  }
  getNormalTextureInfo() {
    return this.normalTexture ? this.normalTextureInfo.getChild() : null;
  }
  setNormalTexture(e) {
    return this.normalTexture = this.graph.linkTexture("normalTexture", Jo | Qo | el, this, e), this;
  }
  getOcclusionStrength() {
    return this.it;
  }
  setOcclusionStrength(e) {
    return this.it = e, this;
  }
  getOcclusionTexture() {
    return this.occlusionTexture ? this.occlusionTexture.getChild() : null;
  }
  getOcclusionTextureInfo() {
    return this.occlusionTexture ? this.occlusionTextureInfo.getChild() : null;
  }
  setOcclusionTexture(e) {
    return this.occlusionTexture = this.graph.linkTexture("occlusionTexture", Jo, this, e), this;
  }
  getRoughnessFactor() {
    return this.rt;
  }
  setRoughnessFactor(e) {
    return this.rt = e, this;
  }
  getMetallicFactor() {
    return this.nt;
  }
  setMetallicFactor(e) {
    return this.nt = e, this;
  }
  getMetallicRoughnessTexture() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTexture.getChild() : null;
  }
  getMetallicRoughnessTextureInfo() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTextureInfo.getChild() : null;
  }
  setMetallicRoughnessTexture(e) {
    return this.metallicRoughnessTexture = this.graph.linkTexture("metallicRoughnessTexture", Qo | el, this, e), this;
  }
}
nr.AlphaMode = { OPAQUE: "OPAQUE", MASK: "MASK", BLEND: "BLEND" }, Pi([En], nr.prototype, "baseColorTexture", void 0), Pi([En], nr.prototype, "baseColorTextureInfo", void 0), Pi([En], nr.prototype, "emissiveTexture", void 0), Pi([En], nr.prototype, "emissiveTextureInfo", void 0), Pi([En], nr.prototype, "normalTexture", void 0), Pi([En], nr.prototype, "normalTextureInfo", void 0), Pi([En], nr.prototype, "occlusionTexture", void 0), Pi([En], nr.prototype, "occlusionTextureInfo", void 0), Pi([En], nr.prototype, "metallicRoughnessTexture", void 0), Pi([En], nr.prototype, "metallicRoughnessTextureInfo", void 0);
class nu extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.MESH, this.ht = [], this.primitives = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.ht = [...e.ht], this.clearGraphChildList(this.primitives), e.primitives.forEach((n) => this.addPrimitive(t(n.getChild()))), this;
  }
  addPrimitive(e) {
    return this.addGraphChild(this.primitives, this.graph.link("primitive", this, e));
  }
  removePrimitive(e) {
    return this.removeGraphChild(this.primitives, e);
  }
  listPrimitives() {
    return this.primitives.map((e) => e.getChild());
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
}
Pi([Wn], nu.prototype, "primitives", void 0);
class qs extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.NODE, this.ot = [0, 0, 0], this.ut = [0, 0, 0, 1], this.ct = [1, 1, 1], this.ht = [], this.i = null, this.camera = null, this.mesh = null, this.skin = null, this.children = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.ot = [...e.ot], this.ut = [...e.ut], this.ct = [...e.ct], this.ht = [...e.ht], this.setCamera(e.camera ? t(e.camera.getChild()) : null), this.setMesh(e.mesh ? t(e.mesh.getChild()) : null), this.setSkin(e.skin ? t(e.skin.getChild()) : null), t !== In && (this.clearGraphChildList(this.children), e.children.forEach((n) => this.addChild(t(n.getChild())))), this;
  }
  getTranslation() {
    return this.ot;
  }
  getRotation() {
    return this.ut;
  }
  getScale() {
    return this.ct;
  }
  setTranslation(e) {
    return this.ot = e, this;
  }
  setRotation(e) {
    return this.ut = e, this;
  }
  setScale(e) {
    return this.ct = e, this;
  }
  getMatrix() {
    return Kn.compose(this.ot, this.ut, this.ct, []);
  }
  setMatrix(e) {
    return Kn.decompose(e, this.ot, this.ut, this.ct), this;
  }
  getWorldTranslation() {
    const e = [0, 0, 0];
    return Kn.decompose(this.getWorldMatrix(), e, [0, 0, 0, 1], [1, 1, 1]), e;
  }
  getWorldRotation() {
    const e = [0, 0, 0, 1];
    return Kn.decompose(this.getWorldMatrix(), [0, 0, 0], e, [1, 1, 1]), e;
  }
  getWorldScale() {
    const e = [1, 1, 1];
    return Kn.decompose(this.getWorldMatrix(), [0, 0, 0], [0, 0, 0, 1], e), e;
  }
  getWorldMatrix() {
    const e = [];
    for (let s = this; s instanceof qs; s = s.i)
      e.push(s);
    let t;
    const n = e.pop().getMatrix();
    for (; t = e.pop(); )
      Dy(n, n, t.getMatrix());
    return n;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  getParent() {
    return this.i;
  }
  getMesh() {
    return this.mesh ? this.mesh.getChild() : null;
  }
  setMesh(e) {
    return this.mesh = this.graph.link("mesh", this, e), this;
  }
  getCamera() {
    return this.camera ? this.camera.getChild() : null;
  }
  setCamera(e) {
    return this.camera = this.graph.link("camera", this, e), this;
  }
  getSkin() {
    return this.skin ? this.skin.getChild() : null;
  }
  setSkin(e) {
    return this.skin = this.graph.link("skin", this, e), this;
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
  traverse(e) {
    e(this);
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
Pi([En], qs.prototype, "camera", void 0), Pi([En], qs.prototype, "mesh", void 0), Pi([En], qs.prototype, "skin", void 0), Pi([Wn], qs.prototype, "children", void 0);
class Ws extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.PRIMITIVE, this.at = Ws.Mode.TRIANGLES, this.material = null, this.indices = null, this.attributes = [], this.targets = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.at = e.at, this.setIndices(e.indices ? t(e.indices.getChild()) : null), this.setMaterial(e.material ? t(e.material.getChild()) : null), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((n) => {
      this.setAttribute(n, t(e.getAttribute(n)));
    }), this.clearGraphChildList(this.targets), e.targets.forEach((n) => this.addTarget(t(n.getChild()))), this;
  }
  getIndices() {
    return this.indices ? this.indices.getChild() : null;
  }
  setIndices(e) {
    return this.indices = this.graph.linkIndex("indices", this, e), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((n) => n.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const n = this.getAttribute(e);
    if (n && this.removeGraphChild(this.attributes, n), !t)
      return this;
    const s = this.graph.linkAttribute(e, this, t);
    return this.addGraphChild(this.attributes, s);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
  getMaterial() {
    return this.material ? this.material.getChild() : null;
  }
  setMaterial(e) {
    return this.material = this.graph.link("material", this, e), this;
  }
  getMode() {
    return this.at;
  }
  setMode(e) {
    return this.at = e, this;
  }
  listTargets() {
    return this.targets.map((e) => e.getChild());
  }
  addTarget(e) {
    return this.addGraphChild(this.targets, this.graph.link("target", this, e)), this;
  }
  removeTarget(e) {
    return this.removeGraphChild(this.targets, e);
  }
}
Ws.Mode = { POINTS: 0, LINES: 1, LINE_LOOP: 2, LINE_STRIP: 3, TRIANGLES: 4, TRIANGLE_STRIP: 5, TRIANGLE_FAN: 6 }, Pi([En], Ws.prototype, "material", void 0), Pi([En], Ws.prototype, "indices", void 0), Pi([Wn], Ws.prototype, "attributes", void 0), Pi([Wn], Ws.prototype, "targets", void 0);
class vd extends Ia {
  constructor(...e) {
    super(...e), this.propertyType = tn.PRIMITIVE_TARGET, this.attributes = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((n) => {
      this.setAttribute(n, t(e.getAttribute(n)));
    }), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((n) => n.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const n = this.getAttribute(e);
    if (n && this.removeGraphChild(this.attributes, n), !t)
      return this;
    const s = this.graph.linkAttribute(e, this, t);
    return s.semantic = e, this.addGraphChild(this.attributes, s);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
}
Pi([Wn], vd.prototype, "attributes", void 0);
class oo extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.SCENE, this.children = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), t !== In && (this.clearGraphChildList(this.children), e.children.forEach((n) => this.addChild(t(n.getChild())))), this;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  traverse(e) {
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
Pi([Wn], oo.prototype, "children", void 0);
class to extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.SKIN, this.skeleton = null, this.inverseBindMatrices = null, this.joints = [];
  }
  copy(e, t = In) {
    return super.copy(e, t), this.setSkeleton(e.skeleton ? t(e.skeleton.getChild()) : null), this.setInverseBindMatrices(e.inverseBindMatrices ? t(e.inverseBindMatrices.getChild()) : null), this.clearGraphChildList(this.joints), e.joints.forEach((n) => this.addJoint(t(n.getChild()))), this;
  }
  getSkeleton() {
    return this.skeleton ? this.skeleton.getChild() : null;
  }
  setSkeleton(e) {
    return this.skeleton = this.graph.link("skeleton", this, e), this;
  }
  getInverseBindMatrices() {
    return this.inverseBindMatrices ? this.inverseBindMatrices.getChild() : null;
  }
  setInverseBindMatrices(e) {
    return this.inverseBindMatrices = this.graph.link("inverseBindMatrices", this, e), this;
  }
  addJoint(e) {
    const t = this.graph.link("joint", this, e);
    return this.addGraphChild(this.joints, t);
  }
  removeJoint(e) {
    return this.removeGraphChild(this.joints, e);
  }
  listJoints() {
    return this.joints.map((e) => e.getChild());
  }
}
Pi([En], to.prototype, "skeleton", void 0), Pi([En], to.prototype, "inverseBindMatrices", void 0), Pi([Wn], to.prototype, "joints", void 0);
class yd extends Zr {
  constructor(...e) {
    super(...e), this.propertyType = tn.TEXTURE, this.lt = null, this.ft = "", this.P = "";
  }
  copy(e, t = In) {
    return super.copy(e, t), this.ft = e.ft, this.P = e.P, e.lt && (this.lt = e.lt.slice(0)), this;
  }
  getMimeType() {
    return this.ft || Ba.extensionToMimeType(_l.extension(this.P));
  }
  setMimeType(e) {
    return this.ft = e, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this.ft = Ba.extensionToMimeType(_l.extension(e)), this;
  }
  getImage() {
    return this.lt;
  }
  setImage(e) {
    return this.lt = e, this;
  }
  getSize() {
    return this.lt ? Ba.getSize(this.lt, this.getMimeType()) : null;
  }
}
class rs extends Ia {
  constructor(e) {
    super(e), this.propertyType = tn.ROOT, this.dt = { generator: "glTF-Transform v1.2.4", version: "2.0" }, this.gt = /* @__PURE__ */ new Set(), this.defaultScene = null, this.accessors = [], this.animations = [], this.buffers = [], this.cameras = [], this.materials = [], this.meshes = [], this.nodes = [], this.scenes = [], this.skins = [], this.textures = [], e.on("clone", (t) => this.wt(t));
  }
  clone() {
    throw new Error("Root cannot be cloned.");
  }
  copy(e, t = In) {
    if (super.copy(e, t), t === In)
      throw new Error("Root cannot be copied.");
    return Object.assign(this.dt, e.dt), e.accessors.forEach((n) => this.vt(t(n.getChild()))), e.animations.forEach((n) => this.Tt(t(n.getChild()))), e.buffers.forEach((n) => this.yt(t(n.getChild()))), e.cameras.forEach((n) => this.At(t(n.getChild()))), e.materials.forEach((n) => this.Et(t(n.getChild()))), e.meshes.forEach((n) => this.xt(t(n.getChild()))), e.nodes.forEach((n) => this.St(t(n.getChild()))), e.scenes.forEach((n) => this.Mt(t(n.getChild()))), e.skins.forEach((n) => this.It(t(n.getChild()))), e.textures.forEach((n) => this.bt(t(n.getChild()))), this.setDefaultScene(e.defaultScene ? t(e.defaultScene.getChild()) : null), this;
  }
  wt(e) {
    return e instanceof oo ? this.Mt(e) : e instanceof qs ? this.St(e) : e instanceof ca ? this.At(e) : e instanceof to ? this.It(e) : e instanceof nu ? this.xt(e) : e instanceof nr ? this.Et(e) : e instanceof yd ? this.bt(e) : e instanceof vl ? this.Tt(e) : e instanceof Bi ? this.vt(e) : e instanceof gd && this.yt(e), this;
  }
  getAsset() {
    return this.dt;
  }
  listExtensionsUsed() {
    return Array.from(this.gt);
  }
  listExtensionsRequired() {
    return this.listExtensionsUsed().filter((e) => e.isRequired());
  }
  Rt(e) {
    return this.gt.add(e), this;
  }
  Nt(e) {
    return this.gt.delete(e), this;
  }
  Mt(e) {
    return this.addGraphChild(this.scenes, this.graph.link("scene", this, e));
  }
  listScenes() {
    return this.scenes.map((e) => e.getChild());
  }
  setDefaultScene(e) {
    return this.defaultScene = this.graph.link("scene", this, e), this;
  }
  getDefaultScene() {
    return this.defaultScene ? this.defaultScene.getChild() : null;
  }
  St(e) {
    return this.addGraphChild(this.nodes, this.graph.link("node", this, e));
  }
  listNodes() {
    return this.nodes.map((e) => e.getChild());
  }
  At(e) {
    return this.addGraphChild(this.cameras, this.graph.link("camera", this, e));
  }
  listCameras() {
    return this.cameras.map((e) => e.getChild());
  }
  It(e) {
    return this.addGraphChild(this.skins, this.graph.link("skin", this, e));
  }
  listSkins() {
    return this.skins.map((e) => e.getChild());
  }
  xt(e) {
    return this.addGraphChild(this.meshes, this.graph.link("mesh", this, e));
  }
  listMeshes() {
    return this.meshes.map((e) => e.getChild());
  }
  Et(e) {
    return this.addGraphChild(this.materials, this.graph.link("material", this, e));
  }
  listMaterials() {
    return this.materials.map((e) => e.getChild());
  }
  bt(e) {
    return this.addGraphChild(this.textures, this.graph.link("texture", this, e));
  }
  listTextures() {
    return this.textures.map((e) => e.getChild());
  }
  Tt(e) {
    return this.addGraphChild(this.animations, this.graph.link("animation", this, e));
  }
  listAnimations() {
    return this.animations.map((e) => e.getChild());
  }
  vt(e) {
    return this.addGraphChild(this.accessors, this.graph.link("accessor", this, e));
  }
  listAccessors() {
    return this.accessors.map((e) => e.getChild());
  }
  yt(e) {
    return this.addGraphChild(this.buffers, this.graph.link("buffer", this, e));
  }
  listBuffers() {
    return this.buffers.map((e) => e.getChild());
  }
}
Pi([En], rs.prototype, "defaultScene", void 0), Pi([Wn], rs.prototype, "accessors", void 0), Pi([Wn], rs.prototype, "animations", void 0), Pi([Wn], rs.prototype, "buffers", void 0), Pi([Wn], rs.prototype, "cameras", void 0), Pi([Wn], rs.prototype, "materials", void 0), Pi([Wn], rs.prototype, "meshes", void 0), Pi([Wn], rs.prototype, "nodes", void 0), Pi([Wn], rs.prototype, "scenes", void 0), Pi([Wn], rs.prototype, "skins", void 0), Pi([Wn], rs.prototype, "textures", void 0);
class ru {
  constructor() {
    this.Ct = new jy(), this.Ot = new rs(this.Ct), this._t = Wr.DEFAULT_INSTANCE;
  }
  getRoot() {
    return this.Ot;
  }
  getGraph() {
    return this.Ct;
  }
  getLogger() {
    return this._t;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  clone() {
    return new ru().merge(this).setLogger(this._t);
  }
  merge(e) {
    const t = {};
    for (const h of e.getRoot().listExtensionsUsed()) {
      const c = this.createExtension(h.constructor);
      h.isRequired() && c.setRequired(!0), t[c.extensionName] = c;
    }
    const n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Map();
    n.add(e.Ot), s.set(e.Ot, this.Ot);
    for (const h of e.Ct.getLinks())
      for (const c of [h.getParent(), h.getChild()]) {
        if (n.has(c))
          continue;
        let m;
        if (c.propertyType === tn.TEXTURE_INFO)
          m = c;
        else {
          const x = c.constructor;
          m = c instanceof pd ? new x(this.Ct, t[c.extensionName]) : new x(this.Ct);
        }
        s.set(c, m), n.add(c);
      }
    const o = (h) => {
      const c = s.get(h);
      if (!c)
        throw new Error("Could resolve property.");
      return c;
    };
    for (const h of n) {
      const c = s.get(h);
      if (!c)
        throw new Error("Could resolve property.");
      c.copy(h, o);
    }
    return this;
  }
  async transform(...e) {
    const t = e.map((n) => n.name);
    for (const n of e)
      await n(this, { stack: t });
    return this;
  }
  createExtension(e) {
    const t = e.EXTENSION_NAME;
    return this.getRoot().listExtensionsUsed().find((n) => n.extensionName === t) || new e(this);
  }
  createScene(e = "") {
    const t = new oo(this.Ct, e);
    return this.Ot.Mt(t), t;
  }
  createNode(e = "") {
    const t = new qs(this.Ct, e);
    return this.Ot.St(t), t;
  }
  createCamera(e = "") {
    const t = new ca(this.Ct, e);
    return this.Ot.At(t), t;
  }
  createSkin(e = "") {
    const t = new to(this.Ct, e);
    return this.Ot.It(t), t;
  }
  createMesh(e = "") {
    const t = new nu(this.Ct, e);
    return this.Ot.xt(t), t;
  }
  createPrimitive() {
    return new Ws(this.Ct);
  }
  createPrimitiveTarget(e = "") {
    return new vd(this.Ct, e);
  }
  createMaterial(e = "") {
    const t = new nr(this.Ct, e);
    return this.Ot.Et(t), t;
  }
  createTexture(e = "") {
    const t = new yd(this.Ct, e);
    return this.Ot.bt(t), t;
  }
  createAnimation(e = "") {
    const t = new vl(this.Ct, e);
    return this.Ot.Tt(t), t;
  }
  createAnimationChannel(e = "") {
    return new ll(this.Ct, e);
  }
  createAnimationSampler(e = "") {
    return new ua(this.Ct, e);
  }
  createAccessor(e = "", t = null) {
    t || (t = this.getRoot().listBuffers()[0]);
    const n = new Bi(this.Ct, e).setBuffer(t);
    return this.Ot.vt(n), n;
  }
  createBuffer(e = "") {
    const t = new gd(this.Ct, e);
    return this.Ot.yt(t), t;
  }
}
function ss() {
  return (ss = Object.assign || function(y) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (y[n] = t[n]);
    }
    return y;
  }).apply(this, arguments);
}
class qy {
  constructor(e) {
    this.jsonDoc = void 0, this.buffers = [], this.bufferViews = [], this.bufferViewBuffers = [], this.accessors = [], this.textures = [], this.textureInfos = /* @__PURE__ */ new Map(), this.materials = [], this.meshes = [], this.cameras = [], this.nodes = [], this.skins = [], this.animations = [], this.scenes = [], this.jsonDoc = e;
  }
  setTextureInfo(e, t) {
    this.textureInfos.set(e, t), t.texCoord !== void 0 && e.setTexCoord(t.texCoord);
    const n = this.jsonDoc.json.textures[t.index];
    if (n.sampler === void 0)
      return;
    const s = this.jsonDoc.json.samplers[n.sampler];
    s.magFilter !== void 0 && e.setMagFilter(s.magFilter), s.minFilter !== void 0 && e.setMinFilter(s.minFilter), s.wrapS !== void 0 && e.setWrapS(s.wrapS), s.wrapT !== void 0 && e.setWrapT(s.wrapT);
  }
}
const Hh = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, Cf = { logger: Wr.DEFAULT_INSTANCE, extensions: [], dependencies: {} };
function tl(y, e) {
  const t = e.bufferViews[y.bufferView], n = e.jsonDoc.json.bufferViews[y.bufferView], s = Hh[y.componentType], o = Bi.getElementSize(y.type), h = s.BYTES_PER_ELEMENT;
  if (n.byteStride !== void 0 && n.byteStride !== o * h)
    return function(m, x) {
      const B = x.bufferViews[m.bufferView], I = x.jsonDoc.json.bufferViews[m.bufferView], F = Hh[m.componentType], M = Bi.getElementSize(m.type), Z = F.BYTES_PER_ELEMENT, V = m.byteOffset || 0, te = new F(m.count * M), P = new DataView(B.buffer, B.byteOffset, B.byteLength), K = I.byteStride;
      for (let J = 0; J < m.count; J++)
        for (let le = 0; le < M; le++) {
          const fe = V + J * K + le * Z;
          let X;
          switch (m.componentType) {
            case Bi.ComponentType.FLOAT:
              X = P.getFloat32(fe, !0);
              break;
            case Bi.ComponentType.UNSIGNED_INT:
              X = P.getUint32(fe, !0);
              break;
            case Bi.ComponentType.UNSIGNED_SHORT:
              X = P.getUint16(fe, !0);
              break;
            case Bi.ComponentType.UNSIGNED_BYTE:
              X = P.getUint8(fe);
              break;
            case Bi.ComponentType.SHORT:
              X = P.getInt16(fe, !0);
              break;
            case Bi.ComponentType.BYTE:
              X = P.getInt8(fe);
              break;
            default:
              throw new Error(`Unexpected componentType "${m.componentType}".`);
          }
          te[J * M + le] = X;
        }
      return te;
    }(y, e);
  const c = t.byteOffset + (y.byteOffset || 0);
  return new s(t.buffer.slice(c, c + y.count * o * h));
}
var io, no;
(function(y) {
  y[y.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", y[y.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER";
})(io || (io = {})), function(y) {
  y.ARRAY_BUFFER = "ARRAY_BUFFER", y.ELEMENT_ARRAY_BUFFER = "ELEMENT_ARRAY_BUFFER", y.INVERSE_BIND_MATRICES = "INVERSE_BIND_MATRICES", y.OTHER = "OTHER";
}(no || (no = {}));
class os {
  constructor(e, t, n) {
    this.Bt = void 0, this.jsonDoc = void 0, this.options = void 0, this.accessorIndexMap = /* @__PURE__ */ new Map(), this.bufferIndexMap = /* @__PURE__ */ new Map(), this.cameraIndexMap = /* @__PURE__ */ new Map(), this.skinIndexMap = /* @__PURE__ */ new Map(), this.materialIndexMap = /* @__PURE__ */ new Map(), this.meshIndexMap = /* @__PURE__ */ new Map(), this.nodeIndexMap = /* @__PURE__ */ new Map(), this.imageIndexMap = /* @__PURE__ */ new Map(), this.textureDefIndexMap = /* @__PURE__ */ new Map(), this.textureInfoDefMap = /* @__PURE__ */ new Map(), this.samplerDefIndexMap = /* @__PURE__ */ new Map(), this.imageBufferViews = [], this.otherBufferViews = /* @__PURE__ */ new Map(), this.otherBufferViewsIndexMap = /* @__PURE__ */ new Map(), this.extensionData = {}, this.bufferURIGenerator = void 0, this.imageURIGenerator = void 0, this.logger = void 0, this.Lt = /* @__PURE__ */ new Map(), this.accessorUsageGroupedByParent = /* @__PURE__ */ new Set(["ARRAY_BUFFER"]), this.accessorParents = /* @__PURE__ */ new Map(), this.Bt = e, this.jsonDoc = t, this.options = n;
    const s = e.getRoot(), o = s.listBuffers().length, h = s.listTextures().length;
    this.bufferURIGenerator = new Af(o > 1, n.basename), this.imageURIGenerator = new Af(h > 1, n.basename), this.logger = e.getLogger();
  }
  createTextureInfoDef(e, t) {
    const n = { magFilter: t.getMagFilter() || void 0, minFilter: t.getMinFilter() || void 0, wrapS: t.getWrapS(), wrapT: t.getWrapT() }, s = JSON.stringify(n);
    this.samplerDefIndexMap.has(s) || (this.samplerDefIndexMap.set(s, this.jsonDoc.json.samplers.length), this.jsonDoc.json.samplers.push(n));
    const o = { source: this.imageIndexMap.get(e), sampler: this.samplerDefIndexMap.get(s) }, h = JSON.stringify(o);
    this.textureDefIndexMap.has(h) || (this.textureDefIndexMap.set(h, this.jsonDoc.json.textures.length), this.jsonDoc.json.textures.push(o));
    const c = { index: this.textureDefIndexMap.get(h) };
    return t.getTexCoord() !== 0 && (c.texCoord = t.getTexCoord()), this.textureInfoDefMap.set(t, c), c;
  }
  createPropertyDef(e) {
    const t = {};
    return e.getName() && (t.name = e.getName()), Object.keys(e.getExtras()).length > 0 && (t.extras = e.getExtras()), t;
  }
  createAccessorDef(e) {
    const t = this.createPropertyDef(e);
    return t.type = e.getType(), t.componentType = e.getComponentType(), t.count = e.getCount(), this.Bt.getGraph().listParentLinks(e).some((n) => n.getName() === "POSITION" || n.getName() === "input") && (t.max = e.getMax([]).map(Math.fround), t.min = e.getMin([]).map(Math.fround)), e.getNormalized() && (t.normalized = e.getNormalized()), t;
  }
  createImageData(e, t, n) {
    if (this.options.format === la.GLB)
      this.imageBufferViews.push(t), e.bufferView = this.jsonDoc.json.bufferViews.length, this.jsonDoc.json.bufferViews.push({ buffer: 0, byteOffset: -1, byteLength: t.byteLength });
    else {
      const s = Ba.mimeTypeToExtension(n.getMimeType());
      e.uri = this.imageURIGenerator.createURI(n, s), this.jsonDoc.resources[e.uri] = t;
    }
  }
  getAccessorUsage(e) {
    const t = this.Lt.get(e);
    if (t)
      return t;
    for (const n of this.Bt.getGraph().listParentLinks(e)) {
      if (n.getName() === "inverseBindMatrices")
        return os.BufferViewUsage.INVERSE_BIND_MATRICES;
      if (n instanceof md)
        return os.BufferViewUsage.ARRAY_BUFFER;
      if (n instanceof _d)
        return os.BufferViewUsage.ELEMENT_ARRAY_BUFFER;
    }
    return os.BufferViewUsage.OTHER;
  }
  addAccessorToUsageGroup(e, t) {
    const n = this.Lt.get(e);
    if (n && n !== t)
      throw new Error(`Accessor with usage "${n}" cannot be reused as "${t}".`);
    return this.Lt.set(e, t), this;
  }
  listAccessorUsageGroups() {
    const e = {};
    for (const [t, n] of Array.from(this.Lt.entries()))
      e[n] = e[n] || [], e[n].push(t);
    return e;
  }
}
os.BufferViewTarget = io, os.BufferViewUsage = no, os.USAGE_TO_TARGET = { [no.ARRAY_BUFFER]: io.ARRAY_BUFFER, [no.ELEMENT_ARRAY_BUFFER]: io.ELEMENT_ARRAY_BUFFER };
class Af {
  constructor(e, t) {
    this.multiple = void 0, this.basename = void 0, this.counter = 1, this.multiple = e, this.basename = t;
  }
  createURI(e, t) {
    return e.getURI() ? e.getURI() : this.multiple ? `${this.basename}_${this.counter++}.${t}` : `${this.basename}.${t}`;
  }
}
const { BufferViewUsage: Eh } = os;
var yl;
(function(y) {
  y[y.JSON = 1313821514] = "JSON", y[y.BIN = 5130562] = "BIN";
})(yl || (yl = {}));
class Zy {
  constructor() {
    this._t = Wr.DEFAULT_INSTANCE, this.gt = /* @__PURE__ */ new Set(), this.Pt = {}, this.Ut = ml.INTERLEAVED;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  registerExtensions(e) {
    for (const t of e)
      this.gt.add(t), t.register();
    return this;
  }
  registerDependencies(e) {
    return Object.assign(this.Pt, e), this;
  }
  setVertexLayout(e) {
    return this.Ut = e, this;
  }
  kt(e) {
    function t(n) {
      if (n.uri && !(n.uri in e.resources) && n.uri.match(/data:/)) {
        const s = `__${Yy()}.${_l.extension(n.uri)}`;
        e.resources[s] = xr.createBufferFromDataURI(n.uri), n.uri = s;
      }
    }
    (e.json.images || []).forEach((n) => {
      if (n.bufferView === void 0 && n.uri === void 0)
        throw new Error("Missing resource URI or buffer view.");
      t(n);
    }), (e.json.buffers || []).forEach(t);
  }
  readJSON(e) {
    return e = this.Ft(e), this.kt(e), (class {
      static read(t, n = Cf) {
        const s = ss({}, Cf, n), { json: o } = t, h = new ru();
        this.validate(t, s);
        const c = new qy(t), m = o.asset, x = h.getRoot().getAsset();
        m.copyright && (x.copyright = m.copyright), m.extras && (x.extras = m.extras), o.extras !== void 0 && h.getRoot().setExtras(ss({}, o.extras));
        const B = o.extensionsUsed || [], I = o.extensionsRequired || [];
        for (const K of s.extensions)
          if (B.includes(K.EXTENSION_NAME)) {
            const J = h.createExtension(K).setRequired(I.includes(K.EXTENSION_NAME));
            for (const le of J.readDependencies)
              J.install(le, s.dependencies[le]);
          }
        const F = o.buffers || [];
        h.getRoot().listExtensionsUsed().filter((K) => K.prereadTypes.includes(tn.BUFFER)).forEach((K) => K.preread(c, tn.BUFFER)), c.buffers = F.map((K) => {
          const J = h.createBuffer(K.name);
          return K.extras && J.setExtras(K.extras), K.uri && K.uri.indexOf("__") !== 0 && J.setURI(K.uri), J;
        }), c.bufferViewBuffers = (o.bufferViews || []).map((K, J) => {
          if (!c.bufferViews[J]) {
            const le = t.json.buffers[K.buffer], fe = new Uint8Array(le.uri ? t.resources[le.uri] : t.resources["@glb.bin"], K.byteOffset || 0, K.byteLength);
            c.bufferViews[J] = fe;
          }
          return c.buffers[K.buffer];
        }), c.accessors = (o.accessors || []).map((K) => {
          const J = h.createAccessor(K.name, c.bufferViewBuffers[K.bufferView]).setType(K.type);
          if (K.extras && J.setExtras(K.extras), K.normalized !== void 0 && J.setNormalized(K.normalized), K.bufferView === void 0 && !K.sparse)
            return J;
          let le;
          return le = K.sparse !== void 0 ? function(fe, X) {
            const W = Hh[fe.componentType], je = Bi.getElementSize(fe.type);
            let Ee;
            Ee = fe.bufferView !== void 0 ? tl(fe, X) : new W(fe.count * je);
            const He = fe.sparse, ft = He.count, Le = ss({}, fe, He.indices, { count: ft, type: "SCALAR" }), $e = ss({}, fe, He.values, { count: ft }), ce = tl(Le, X), ut = tl($e, X);
            for (let ze = 0; ze < Le.count; ze++)
              for (let pt = 0; pt < je; pt++)
                Ee[ce[ze] * je + pt] = ut[ze * je + pt];
            return Ee;
          }(K, c) : tl(K, c), J.setArray(le), J;
        });
        const M = o.images || [], Z = o.textures || [];
        h.getRoot().listExtensionsUsed().filter((K) => K.prereadTypes.includes(tn.TEXTURE)).forEach((K) => K.preread(c, tn.TEXTURE)), c.textures = M.map((K) => {
          const J = h.createTexture(K.name);
          if (K.extras && J.setExtras(K.extras), K.bufferView !== void 0) {
            const le = o.bufferViews[K.bufferView], fe = t.json.buffers[le.buffer], X = le.byteOffset || 0, W = (fe.uri ? t.resources[fe.uri] : t.resources["@glb.bin"]).slice(X, X + le.byteLength);
            J.setImage(W);
          } else
            K.uri !== void 0 && (J.setImage(t.resources[K.uri]), K.uri.indexOf("__") !== 0 && J.setURI(K.uri));
          if (K.mimeType !== void 0)
            J.setMimeType(K.mimeType);
          else if (K.uri) {
            const le = _l.extension(K.uri);
            J.setMimeType(Ba.extensionToMimeType(le));
          }
          return J;
        }), c.materials = (o.materials || []).map((K) => {
          const J = h.createMaterial(K.name);
          K.extras && J.setExtras(K.extras), K.alphaMode !== void 0 && J.setAlphaMode(K.alphaMode), K.alphaCutoff !== void 0 && J.setAlphaCutoff(K.alphaCutoff), K.doubleSided !== void 0 && J.setDoubleSided(K.doubleSided);
          const le = K.pbrMetallicRoughness || {};
          if (le.baseColorFactor !== void 0 && J.setBaseColorFactor(le.baseColorFactor), K.emissiveFactor !== void 0 && J.setEmissiveFactor(K.emissiveFactor), le.metallicFactor !== void 0 && J.setMetallicFactor(le.metallicFactor), le.roughnessFactor !== void 0 && J.setRoughnessFactor(le.roughnessFactor), le.baseColorTexture !== void 0) {
            const fe = le.baseColorTexture;
            J.setBaseColorTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(J.getBaseColorTextureInfo(), fe);
          }
          if (K.emissiveTexture !== void 0) {
            const fe = K.emissiveTexture;
            J.setEmissiveTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(J.getEmissiveTextureInfo(), fe);
          }
          if (K.normalTexture !== void 0) {
            const fe = K.normalTexture;
            J.setNormalTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(J.getNormalTextureInfo(), fe), K.normalTexture.scale !== void 0 && J.setNormalScale(K.normalTexture.scale);
          }
          if (K.occlusionTexture !== void 0) {
            const fe = K.occlusionTexture;
            J.setOcclusionTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(J.getOcclusionTextureInfo(), fe), K.occlusionTexture.strength !== void 0 && J.setOcclusionStrength(K.occlusionTexture.strength);
          }
          if (le.metallicRoughnessTexture !== void 0) {
            const fe = le.metallicRoughnessTexture;
            J.setMetallicRoughnessTexture(c.textures[Z[fe.index].source]), c.setTextureInfo(J.getMetallicRoughnessTextureInfo(), fe);
          }
          return J;
        });
        const V = o.meshes || [];
        h.getRoot().listExtensionsUsed().filter((K) => K.prereadTypes.includes(tn.PRIMITIVE)).forEach((K) => K.preread(c, tn.PRIMITIVE)), c.meshes = V.map((K) => {
          const J = h.createMesh(K.name);
          return K.extras && J.setExtras(K.extras), K.weights !== void 0 && J.setWeights(K.weights), (K.primitives || []).forEach((le) => {
            const fe = h.createPrimitive();
            le.extras && fe.setExtras(le.extras), le.material !== void 0 && fe.setMaterial(c.materials[le.material]), le.mode !== void 0 && fe.setMode(le.mode);
            for (const [W, je] of Object.entries(le.attributes || {}))
              fe.setAttribute(W, c.accessors[je]);
            le.indices !== void 0 && fe.setIndices(c.accessors[le.indices]);
            const X = K.extras && K.extras.targetNames || [];
            (le.targets || []).forEach((W, je) => {
              const Ee = X[je] || je.toString(), He = h.createPrimitiveTarget(Ee);
              for (const [ft, Le] of Object.entries(W))
                He.setAttribute(ft, c.accessors[Le]);
              fe.addTarget(He);
            }), J.addPrimitive(fe);
          }), J;
        }), c.cameras = (o.cameras || []).map((K) => {
          const J = h.createCamera(K.name).setType(K.type);
          if (K.extras && J.setExtras(K.extras), K.type === ca.Type.PERSPECTIVE) {
            const le = K.perspective;
            J.setYFov(le.yfov), J.setZNear(le.znear), le.zfar !== void 0 && J.setZFar(le.zfar), le.aspectRatio !== void 0 && J.setAspectRatio(le.aspectRatio);
          } else {
            const le = K.orthographic;
            J.setZNear(le.znear).setZFar(le.zfar).setXMag(le.xmag).setYMag(le.ymag);
          }
          return J;
        });
        const te = o.nodes || [];
        h.getRoot().listExtensionsUsed().filter((K) => K.prereadTypes.includes(tn.NODE)).forEach((K) => K.preread(c, tn.NODE)), c.nodes = te.map((K) => {
          const J = h.createNode(K.name);
          if (K.extras && J.setExtras(K.extras), K.translation !== void 0 && J.setTranslation(K.translation), K.rotation !== void 0 && J.setRotation(K.rotation), K.scale !== void 0 && J.setScale(K.scale), K.matrix !== void 0) {
            const le = [0, 0, 0], fe = [0, 0, 0, 1], X = [1, 1, 1];
            Kn.decompose(K.matrix, le, fe, X), J.setTranslation(le), J.setRotation(fe), J.setScale(X);
          }
          return K.weights !== void 0 && J.setWeights(K.weights), J;
        }), c.skins = (o.skins || []).map((K) => {
          const J = h.createSkin(K.name);
          K.extras && J.setExtras(K.extras), K.inverseBindMatrices !== void 0 && J.setInverseBindMatrices(c.accessors[K.inverseBindMatrices]), K.skeleton !== void 0 && J.setSkeleton(c.nodes[K.skeleton]);
          for (const le of K.joints)
            J.addJoint(c.nodes[le]);
          return J;
        }), te.map((K, J) => {
          const le = c.nodes[J];
          (K.children || []).forEach((fe) => le.addChild(c.nodes[fe])), K.mesh !== void 0 && le.setMesh(c.meshes[K.mesh]), K.camera !== void 0 && le.setCamera(c.cameras[K.camera]), K.skin !== void 0 && le.setSkin(c.skins[K.skin]);
        }), c.animations = (o.animations || []).map((K) => {
          const J = h.createAnimation(K.name);
          K.extras && J.setExtras(K.extras);
          const le = (K.samplers || []).map((fe) => {
            const X = h.createAnimationSampler().setInput(c.accessors[fe.input]).setOutput(c.accessors[fe.output]).setInterpolation(fe.interpolation || ua.Interpolation.LINEAR);
            return fe.extras && X.setExtras(fe.extras), J.addSampler(X), X;
          });
          return (K.channels || []).forEach((fe) => {
            const X = h.createAnimationChannel().setSampler(le[fe.sampler]).setTargetNode(c.nodes[fe.target.node]).setTargetPath(fe.target.path);
            fe.extras && X.setExtras(fe.extras), J.addChannel(X);
          }), J;
        });
        const P = o.scenes || [];
        return h.getRoot().listExtensionsUsed().filter((K) => K.prereadTypes.includes(tn.SCENE)).forEach((K) => K.preread(c, tn.SCENE)), c.scenes = P.map((K) => {
          const J = h.createScene(K.name);
          return K.extras && J.setExtras(K.extras), (K.nodes || []).map((le) => c.nodes[le]).forEach((le) => J.addChild(le)), J;
        }), o.scene !== void 0 && h.getRoot().setDefaultScene(c.scenes[o.scene]), h.getRoot().listExtensionsUsed().forEach((K) => K.read(c)), h;
      }
      static validate(t, n) {
        const s = t.json;
        if (s.asset.version !== "2.0")
          throw new Error(`Unsupported glTF version, "${s.asset.version}".`);
        if (s.extensionsRequired) {
          for (const o of s.extensionsRequired)
            if (!n.extensions.find((h) => h.EXTENSION_NAME === o))
              throw new Error(`Missing required extension, "${o}".`);
        }
        if (s.extensionsUsed)
          for (const o of s.extensionsUsed)
            n.extensions.find((h) => h.EXTENSION_NAME === o) || n.logger.warn(`Missing optional extension, "${o}".`);
      }
    }).read(e, { extensions: Array.from(this.gt), dependencies: this.Pt, logger: this._t });
  }
  writeJSON(e, t = {}) {
    if (t.format === la.GLB && e.getRoot().listBuffers().length > 1)
      throw new Error("GLB must have 0–1 buffers.");
    return (class {
      static write(n, s) {
        const o = n.getRoot(), h = { asset: ss({ generator: "glTF-Transform v1.2.4" }, o.getAsset()), extras: ss({}, o.getExtras()) }, c = { json: h, resources: {} }, m = new os(n, c, s), x = s.logger || Wr.DEFAULT_INSTANCE, B = new Set(s.extensions.map((P) => P.EXTENSION_NAME)), I = n.getRoot().listExtensionsUsed().filter((P) => B.has(P.extensionName)), F = n.getRoot().listExtensionsRequired().filter((P) => B.has(P.extensionName));
        I.length < n.getRoot().listExtensionsUsed().length && x.debug("Some extensions were not registered for I/O, and will not be written.");
        for (const P of I)
          for (const K of P.writeDependencies)
            P.install(K, s.dependencies[K]);
        function M(P, K, J, le) {
          const fe = [];
          let X = 0;
          for (const je of P) {
            const Ee = m.createAccessorDef(je);
            Ee.bufferView = h.bufferViews.length;
            const He = xr.pad(je.getArray().buffer);
            Ee.byteOffset = X, X += He.byteLength, fe.push(He), m.accessorIndexMap.set(je, h.accessors.length), h.accessors.push(Ee);
          }
          const W = { buffer: K, byteOffset: J, byteLength: xr.concat(fe).byteLength };
          return le && (W.target = le), h.bufferViews.push(W), { buffers: fe, byteLength: X };
        }
        function Z(P, K, J) {
          const le = P[0].getCount();
          let fe = 0;
          for (const Ee of P) {
            const He = m.createAccessorDef(Ee);
            He.bufferView = h.bufferViews.length, He.byteOffset = fe;
            const ft = Ee.getElementSize(), Le = Ee.getComponentSize();
            fe += xr.padNumber(ft * Le), m.accessorIndexMap.set(Ee, h.accessors.length), h.accessors.push(He);
          }
          const X = le * fe, W = new ArrayBuffer(X), je = new DataView(W);
          for (let Ee = 0; Ee < le; Ee++) {
            let He = 0;
            for (const ft of P) {
              const Le = ft.getElementSize(), $e = ft.getComponentSize(), ce = ft.getComponentType(), ut = ft.getArray();
              for (let ze = 0; ze < Le; ze++) {
                const pt = Ee * fe + He + ze * $e, qt = ut[Ee * Le + ze];
                switch (ce) {
                  case Bi.ComponentType.FLOAT:
                    je.setFloat32(pt, qt, !0);
                    break;
                  case Bi.ComponentType.BYTE:
                    je.setInt8(pt, qt);
                    break;
                  case Bi.ComponentType.SHORT:
                    je.setInt16(pt, qt, !0);
                    break;
                  case Bi.ComponentType.UNSIGNED_BYTE:
                    je.setUint8(pt, qt);
                    break;
                  case Bi.ComponentType.UNSIGNED_SHORT:
                    je.setUint16(pt, qt, !0);
                    break;
                  case Bi.ComponentType.UNSIGNED_INT:
                    je.setUint32(pt, qt, !0);
                    break;
                  default:
                    throw new Error("Unexpected component type: " + ce);
                }
              }
              He += xr.padNumber(Le * $e);
            }
          }
          return h.bufferViews.push({ buffer: K, byteOffset: J, byteLength: X, byteStride: fe, target: os.BufferViewTarget.ARRAY_BUFFER }), { byteLength: X, buffers: [W] };
        }
        const V = /* @__PURE__ */ new Map();
        for (const P of n.getGraph().getLinks()) {
          if (P.getParent() === o)
            continue;
          const K = P.getChild();
          if (K instanceof Bi) {
            const J = V.get(K) || [];
            J.push(P), V.set(K, J);
          }
        }
        if (h.accessors = [], h.bufferViews = [], h.samplers = [], h.textures = [], h.images = o.listTextures().map((P, K) => {
          const J = m.createPropertyDef(P);
          P.getMimeType() && (J.mimeType = P.getMimeType());
          const le = P.getImage();
          return le && m.createImageData(J, le, P), m.imageIndexMap.set(P, K), J;
        }), I.filter((P) => P.prewriteTypes.includes(tn.ACCESSOR)).forEach((P) => P.prewrite(m, tn.ACCESSOR)), o.listAccessors().forEach((P) => {
          const K = m.accessorUsageGroupedByParent, J = m.accessorParents;
          if (m.accessorIndexMap.has(P))
            return;
          const le = V.get(P) || [], fe = m.getAccessorUsage(P);
          if (m.addAccessorToUsageGroup(P, fe), K.has(fe)) {
            const X = le[0].getParent(), W = J.get(X) || /* @__PURE__ */ new Set();
            W.add(P), J.set(X, W);
          }
        }), I.filter((P) => P.prewriteTypes.includes(tn.BUFFER)).forEach((P) => P.prewrite(m, tn.BUFFER)), (o.listAccessors().length > 0 || o.listTextures().length > 0 || m.otherBufferViews.size > 0) && o.listBuffers().length === 0)
          throw new Error("Buffer required for Document resources, but none was found.");
        h.buffers = [], o.listBuffers().forEach((P, K) => {
          const J = m.createPropertyDef(P), le = m.accessorUsageGroupedByParent, fe = m.accessorParents, X = P.listParents().filter((Le) => Le instanceof Bi), W = new Set(X), je = [], Ee = h.buffers.length;
          let He = 0;
          const ft = m.listAccessorUsageGroups();
          for (const Le in ft)
            if (le.has(Le))
              for (const $e of Array.from(fe.values())) {
                const ce = Array.from($e).filter((ut) => W.has(ut)).filter((ut) => m.getAccessorUsage(ut) === Le);
                if (ce.length)
                  if (Le !== Eh.ARRAY_BUFFER || s.vertexLayout === ml.INTERLEAVED) {
                    const ut = Le === Eh.ARRAY_BUFFER ? Z(ce, Ee, He) : M(ce, Ee, He);
                    He += ut.byteLength, je.push(...ut.buffers);
                  } else
                    for (const ut of ce) {
                      const ze = Z([ut], Ee, He);
                      He += ze.byteLength, je.push(...ze.buffers);
                    }
              }
            else {
              const $e = ft[Le].filter((ut) => W.has(ut));
              if (!$e.length)
                continue;
              const ce = M($e, Ee, He, Le === Eh.ELEMENT_ARRAY_BUFFER ? os.BufferViewTarget.ELEMENT_ARRAY_BUFFER : void 0);
              He += ce.byteLength, je.push(...ce.buffers);
            }
          if (m.imageBufferViews.length && K === 0) {
            for (let Le = 0; Le < m.imageBufferViews.length; Le++)
              if (h.bufferViews[h.images[Le].bufferView].byteOffset = He, He += m.imageBufferViews[Le].byteLength, je.push(m.imageBufferViews[Le]), He % 8) {
                const $e = 8 - He % 8;
                He += $e, je.push(new ArrayBuffer($e));
              }
          }
          if (m.otherBufferViews.has(P))
            for (const Le of m.otherBufferViews.get(P))
              h.bufferViews.push({ buffer: Ee, byteOffset: He, byteLength: Le.byteLength }), m.otherBufferViewsIndexMap.set(Le, h.bufferViews.length - 1), He += Le.byteLength, je.push(Le);
          if (He) {
            let Le;
            s.format === la.GLB ? Le = "@glb.bin" : (Le = m.bufferURIGenerator.createURI(P, "bin"), J.uri = Le), J.byteLength = He, c.resources[Le] = xr.concat(je);
          }
          h.buffers.push(J), m.bufferIndexMap.set(P, K);
        }), o.listAccessors().find((P) => !P.getBuffer()) && x.warn("Skipped writing one or more Accessors: no Buffer assigned."), h.materials = o.listMaterials().map((P, K) => {
          const J = m.createPropertyDef(P);
          if (P.getAlphaMode() !== nr.AlphaMode.OPAQUE && (J.alphaMode = P.getAlphaMode()), P.getAlphaMode() === nr.AlphaMode.MASK && (J.alphaCutoff = P.getAlphaCutoff()), P.getDoubleSided() && (J.doubleSided = !0), J.pbrMetallicRoughness = {}, Kn.eq(P.getBaseColorFactor(), [1, 1, 1, 1]) || (J.pbrMetallicRoughness.baseColorFactor = P.getBaseColorFactor()), Kn.eq(P.getEmissiveFactor(), [0, 0, 0]) || (J.emissiveFactor = P.getEmissiveFactor()), P.getRoughnessFactor() !== 1 && (J.pbrMetallicRoughness.roughnessFactor = P.getRoughnessFactor()), P.getMetallicFactor() !== 1 && (J.pbrMetallicRoughness.metallicFactor = P.getMetallicFactor()), P.getBaseColorTexture()) {
            const le = P.getBaseColorTexture(), fe = P.getBaseColorTextureInfo();
            J.pbrMetallicRoughness.baseColorTexture = m.createTextureInfoDef(le, fe);
          }
          if (P.getEmissiveTexture()) {
            const le = P.getEmissiveTexture(), fe = P.getEmissiveTextureInfo();
            J.emissiveTexture = m.createTextureInfoDef(le, fe);
          }
          if (P.getNormalTexture()) {
            const le = P.getNormalTexture(), fe = P.getNormalTextureInfo(), X = m.createTextureInfoDef(le, fe);
            P.getNormalScale() !== 1 && (X.scale = P.getNormalScale()), J.normalTexture = X;
          }
          if (P.getOcclusionTexture()) {
            const le = P.getOcclusionTexture(), fe = P.getOcclusionTextureInfo(), X = m.createTextureInfoDef(le, fe);
            P.getOcclusionStrength() !== 1 && (X.strength = P.getOcclusionStrength()), J.occlusionTexture = X;
          }
          if (P.getMetallicRoughnessTexture()) {
            const le = P.getMetallicRoughnessTexture(), fe = P.getMetallicRoughnessTextureInfo();
            J.pbrMetallicRoughness.metallicRoughnessTexture = m.createTextureInfoDef(le, fe);
          }
          return m.materialIndexMap.set(P, K), J;
        }), h.meshes = o.listMeshes().map((P, K) => {
          const J = m.createPropertyDef(P);
          let le = null;
          return J.primitives = P.listPrimitives().map((fe) => {
            const X = { attributes: {} };
            X.mode = fe.getMode();
            const W = fe.getMaterial();
            W && (X.material = m.materialIndexMap.get(W)), Object.keys(fe.getExtras()).length && (X.extras = fe.getExtras());
            const je = fe.getIndices();
            je && (X.indices = m.accessorIndexMap.get(je));
            for (const Ee of fe.listSemantics())
              X.attributes[Ee] = m.accessorIndexMap.get(fe.getAttribute(Ee));
            for (const Ee of fe.listTargets()) {
              const He = {};
              for (const ft of Ee.listSemantics())
                He[ft] = m.accessorIndexMap.get(Ee.getAttribute(ft));
              X.targets = X.targets || [], X.targets.push(He);
            }
            return fe.listTargets().length && !le && (le = fe.listTargets().map((Ee) => Ee.getName())), X;
          }), P.getWeights().length && (J.weights = P.getWeights()), le && (J.extras = J.extras || {}, J.extras.targetNames = le), m.meshIndexMap.set(P, K), J;
        }), h.cameras = o.listCameras().map((P, K) => {
          const J = m.createPropertyDef(P);
          if (J.type = P.getType(), J.type === ca.Type.PERSPECTIVE) {
            J.perspective = { znear: P.getZNear(), zfar: P.getZFar(), yfov: P.getYFov() };
            const le = P.getAspectRatio();
            le !== null && (J.perspective.aspectRatio = le);
          } else
            J.orthographic = { znear: P.getZNear(), zfar: P.getZFar(), xmag: P.getXMag(), ymag: P.getYMag() };
          return m.cameraIndexMap.set(P, K), J;
        }), h.nodes = o.listNodes().map((P, K) => {
          const J = m.createPropertyDef(P);
          return Kn.eq(P.getTranslation(), [0, 0, 0]) || (J.translation = P.getTranslation()), Kn.eq(P.getRotation(), [0, 0, 0, 1]) || (J.rotation = P.getRotation()), Kn.eq(P.getScale(), [1, 1, 1]) || (J.scale = P.getScale()), P.getWeights().length && (J.weights = P.getWeights()), m.nodeIndexMap.set(P, K), J;
        }), h.skins = o.listSkins().map((P, K) => {
          const J = m.createPropertyDef(P), le = P.getInverseBindMatrices();
          le && (J.inverseBindMatrices = m.accessorIndexMap.get(le));
          const fe = P.getSkeleton();
          return fe && (J.skeleton = m.nodeIndexMap.get(fe)), J.joints = P.listJoints().map((X) => m.nodeIndexMap.get(X)), m.skinIndexMap.set(P, K), J;
        }), o.listNodes().forEach((P, K) => {
          const J = h.nodes[K], le = P.getMesh();
          le && (J.mesh = m.meshIndexMap.get(le));
          const fe = P.getCamera();
          fe && (J.camera = m.cameraIndexMap.get(fe));
          const X = P.getSkin();
          X && (J.skin = m.skinIndexMap.get(X)), P.listChildren().length > 0 && (J.children = P.listChildren().map((W) => m.nodeIndexMap.get(W)));
        }), h.animations = o.listAnimations().map((P) => {
          const K = m.createPropertyDef(P), J = /* @__PURE__ */ new Map();
          return K.samplers = P.listSamplers().map((le, fe) => {
            const X = m.createPropertyDef(le);
            return X.input = m.accessorIndexMap.get(le.getInput()), X.output = m.accessorIndexMap.get(le.getOutput()), X.interpolation = le.getInterpolation(), J.set(le, fe), X;
          }), K.channels = P.listChannels().map((le) => {
            const fe = m.createPropertyDef(le);
            return fe.sampler = J.get(le.getSampler()), fe.target = { node: m.nodeIndexMap.get(le.getTargetNode()), path: le.getTargetPath() }, fe;
          }), K;
        }), h.scenes = o.listScenes().map((P) => {
          const K = m.createPropertyDef(P);
          return K.nodes = P.listChildren().map((J) => m.nodeIndexMap.get(J)), K;
        });
        const te = o.getDefaultScene();
        return te && (h.scene = o.listScenes().indexOf(te)), h.extensionsUsed = I.map((P) => P.extensionName), h.extensionsRequired = F.map((P) => P.extensionName), I.forEach((P) => P.write(m)), function(P) {
          const K = [];
          for (const J in P) {
            const le = P[J];
            (Array.isArray(le) && le.length === 0 || le === null || le === "" || le && typeof le == "object" && Object.keys(le).length === 0) && K.push(J);
          }
          for (const J of K)
            delete P[J];
        }(h), c;
      }
    }).write(e, { format: t.format || la.GLTF, basename: t.basename || "", logger: this._t, vertexLayout: this.Ut, dependencies: ss({}, this.Pt), extensions: Array.from(this.gt) });
  }
  Ft(e) {
    const { images: t, buffers: n } = e.json;
    return e = { json: ss({}, e.json), resources: ss({}, e.resources) }, t && (e.json.images = t.map((s) => ss({}, s))), n && (e.json.buffers = n.map((s) => ss({}, s))), e;
  }
  binaryToJSON(e) {
    const t = this.Gt(e);
    this.kt(t);
    const n = t.json;
    if (n.buffers && n.buffers.some((s) => function(o, h) {
      return h.uri !== void 0 && !(h.uri in o.resources);
    }(t, s)))
      throw new Error("Cannot resolve external buffers with binaryToJSON().");
    if (n.images && n.images.some((s) => function(o, h) {
      return h.uri !== void 0 && !(h.uri in o.resources) && h.bufferView === void 0;
    }(t, s)))
      throw new Error("Cannot resolve external images with binaryToJSON().");
    return t;
  }
  Gt(e) {
    const t = new Uint32Array(e, 0, 3);
    if (t[0] !== 1179937895)
      throw new Error("Invalid glTF asset.");
    if (t[1] !== 2)
      throw new Error(`Unsupported glTF binary version, "${t[1]}".`);
    const n = new Uint32Array(e, 12, 2);
    if (n[1] !== yl.JSON)
      throw new Error("Missing required GLB JSON chunk.");
    const s = n[0], o = xr.decodeText(e.slice(20, 20 + s)), h = JSON.parse(o), c = 20 + s;
    if (e.byteLength <= c)
      return { json: h, resources: {} };
    const m = new Uint32Array(e, c, 2);
    if (m[1] !== yl.BIN)
      throw new Error("Expected GLB BIN in second chunk.");
    return { json: h, resources: { "@glb.bin": e.slice(c + 8, c + 8 + m[0]) } };
  }
  readBinary(e) {
    return this.readJSON(this.binaryToJSON(e));
  }
  writeBinary(e) {
    const { json: t, resources: n } = this.writeJSON(e, { format: la.GLB }), s = new Uint32Array([1179937895, 2, 12]), o = JSON.stringify(t), h = xr.pad(xr.encodeText(o), 32), c = new Uint32Array([h.byteLength, 1313821514]).buffer, m = xr.concat([c, h]);
    s[s.length - 1] += m.byteLength;
    const x = Object.values(n)[0];
    if (!x || !x.byteLength)
      return xr.concat([s.buffer, m]);
    const B = xr.pad(x, 0), I = new Uint32Array([B.byteLength, 5130562]).buffer, F = xr.concat([I, B]);
    return s[s.length - 1] += F.byteLength, xr.concat([s.buffer, m, F]);
  }
}
const $y = {};
class Tf extends Zy {
  constructor(e = $y) {
    super(), this.qt = void 0, this.qt = e;
  }
  read(e) {
    return this.readAsJSON(e).then((t) => this.readJSON(t));
  }
  readAsJSON(e) {
    return e.match(/^data:application\/octet-stream;/) || new URL(e, window.location.href).pathname.match(/\.glb$/) ? this.Jt(e) : this.zt(e);
  }
  Wt(e, t) {
    const n = [...e.json.images || [], ...e.json.buffers || []].map((s) => {
      const o = s.uri;
      return !o || o.match(/data:/) ? Promise.resolve() : fetch(function(h, c) {
        if (!function(B) {
          return !/^(?:[a-zA-Z]+:)?\//.test(B);
        }(c))
          return c;
        const m = h.split("/"), x = c.split("/");
        m.pop();
        for (let B = 0; B < x.length; B++)
          x[B] !== "." && (x[B] === ".." ? m.pop() : m.push(x[B]));
        return m.join("/");
      }(t, o), this.qt).then((h) => h.arrayBuffer()).then((h) => {
        e.resources[o] = h;
      });
    });
    return Promise.all(n).then(() => {
    });
  }
  zt(e) {
    var t = this;
    const n = { json: {}, resources: {} };
    return fetch(e, this.qt).then((s) => s.json()).then(async function(s) {
      return n.json = s, await t.Wt(n, Lf(e)), t.kt(n), n;
    });
  }
  Jt(e) {
    var t = this;
    return fetch(e, this.qt).then((n) => n.arrayBuffer()).then(async function(n) {
      const s = t.Gt(n);
      return await t.Wt(s, Lf(e)), t.kt(s), s;
    });
  }
}
function Lf(y) {
  const e = y.lastIndexOf("/");
  return e === -1 ? "./" : y.substr(0, e + 1);
}
var Xy = Object.defineProperty, Ky = (y, e, t) => e in y ? Xy(y, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : y[e] = t, il = (y, e, t) => Ky(y, typeof e != "symbol" ? e + "" : e, t);
function Jy(y) {
  return y && y.__esModule && Object.prototype.hasOwnProperty.call(y, "default") ? y.default : y;
}
function Qy(y) {
  if (Object.prototype.hasOwnProperty.call(y, "__esModule"))
    return y;
  var e = y.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(y).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(y, n);
    Object.defineProperty(t, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return y[n];
      }
    });
  }), t;
}
function eb(y) {
  throw new Error('Could not dynamically require "' + y + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Yh = { exports: {} };
const tb = {}, ib = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tb
}, Symbol.toStringTag, { value: "Module" })), Bf = /* @__PURE__ */ Qy(ib);
/*!
 * Paper.js v0.12.18 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Wed Jul 17 14:57:24 2024 +0200
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
var nb = Yh.exports, kf;
function rb() {
  return kf || (kf = 1, function(y) {
    (function(e, t) {
      e = e || Bf;
      var n = e.window, s = e.document, o = new function() {
        var i = /^(statics|enumerable|beans|preserve)$/, r = [], a = r.slice, l = Object.create, u = Object.getOwnPropertyDescriptor, d = Object.defineProperty, v = r.forEach || function(A, T) {
          for (var G = 0, D = this.length; G < D; G++)
            A.call(T, this[G], G, this);
        }, p = function(A, T) {
          for (var G in this)
            this.hasOwnProperty(G) && A.call(T, this[G], G, this);
        }, b = Object.assign || function(A) {
          for (var T = 1, G = arguments.length; T < G; T++) {
            var D = arguments[T];
            for (var Y in D)
              D.hasOwnProperty(Y) && (A[Y] = D[Y]);
          }
          return A;
        }, S = function(A, T, G) {
          if (A) {
            var D = u(A, "length");
            (D && typeof D.value == "number" ? v : p).call(A, T, G = G || A);
          }
          return G;
        };
        function L(A, T, G, D, Y) {
          var k = {};
          function z(H, ie) {
            ie = ie || (ie = u(T, H)) && (ie.get ? ie : ie.value), typeof ie == "string" && ie[0] === "#" && (ie = A[ie.substring(1)] || ie);
            var ae = typeof ie == "function", ue = ie, me = Y || ae && !ie.base ? ie && ie.get ? H in A : A[H] : null, se;
            (!Y || !me) && (ae && me && (ie.base = me), ae && D !== !1 && (se = H.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (k[se[3].toLowerCase() + se[4]] = se[2]), (!ue || ae || !ue.get || typeof ue.get != "function" || !E.isPlainObject(ue)) && (ue = { value: ue, writable: !0 }), (u(A, H) || { configurable: !0 }).configurable && (ue.configurable = !0, ue.enumerable = G ?? !se), d(A, H, ue));
          }
          if (T) {
            for (var C in T)
              T.hasOwnProperty(C) && !i.test(C) && z(C);
            for (var C in k) {
              var O = k[C], j = A["set" + O], q = A["get" + O] || j && A["is" + O];
              q && (D === !0 || q.length === 0) && z(C, { get: q, set: j });
            }
          }
          return A;
        }
        function E() {
          for (var A = 0, T = arguments.length; A < T; A++) {
            var G = arguments[A];
            G && b(this, G);
          }
          return this;
        }
        return L(E, {
          inject: function(A) {
            if (A) {
              var T = A.statics === !0 ? A : A.statics, G = A.beans, D = A.preserve;
              T !== A && L(this.prototype, A, A.enumerable, G, D), L(this, T, null, G, D);
            }
            for (var Y = 1, k = arguments.length; Y < k; Y++)
              this.inject(arguments[Y]);
            return this;
          },
          extend: function() {
            for (var A = this, T, G, D = 0, Y, k = arguments.length; D < k && !(T && G); D++)
              Y = arguments[D], T = T || Y.initialize, G = G || Y.prototype;
            return T = T || function() {
              A.apply(this, arguments);
            }, G = T.prototype = G || l(this.prototype), d(
              G,
              "constructor",
              { value: T, writable: !0, configurable: !0 }
            ), L(T, this), arguments.length && this.inject.apply(T, arguments), T.base = A, T;
          }
        }).inject({
          enumerable: !1,
          initialize: E,
          set: E,
          inject: function() {
            for (var A = 0, T = arguments.length; A < T; A++) {
              var G = arguments[A];
              G && L(this, G, G.enumerable, G.beans, G.preserve);
            }
            return this;
          },
          extend: function() {
            var A = l(this);
            return A.inject.apply(A, arguments);
          },
          each: function(A, T) {
            return S(this, A, T);
          },
          clone: function() {
            return new this.constructor(this);
          },
          statics: {
            set: b,
            each: S,
            create: l,
            define: d,
            describe: u,
            clone: function(A) {
              return b(new A.constructor(), A);
            },
            isPlainObject: function(A) {
              var T = A != null && A.constructor;
              return T && (T === Object || T === E || T.name === "Object");
            },
            pick: function(A, T) {
              return A !== t ? A : T;
            },
            slice: function(A, T, G) {
              return a.call(A, T, G);
            }
          }
        });
      }();
      y.exports = o, o.inject({
        enumerable: !1,
        toString: function() {
          return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + o.each(this, function(i, r) {
            if (!/^_/.test(r)) {
              var a = typeof i;
              this.push(r + ": " + (a === "number" ? B.instance.number(i) : a === "string" ? "'" + i + "'" : i));
            }
          }, []).join(", ") + " }";
        },
        getClassName: function() {
          return this._class || "";
        },
        importJSON: function(i) {
          return o.importJSON(i, this);
        },
        exportJSON: function(i) {
          return o.exportJSON(this, i);
        },
        toJSON: function() {
          return o.serialize(this);
        },
        set: function(i, r) {
          return i && o.filter(this, i, r, this._prioritize), this;
        }
      }, {
        beans: !1,
        statics: {
          exports: {},
          extend: function i() {
            var r = i.base.apply(this, arguments), a = r.prototype._class;
            return a && !o.exports[a] && (o.exports[a] = r), r;
          },
          equals: function(i, r) {
            if (i === r)
              return !0;
            if (i && i.equals)
              return i.equals(r);
            if (r && r.equals)
              return r.equals(i);
            if (i && r && typeof i == "object" && typeof r == "object") {
              if (Array.isArray(i) && Array.isArray(r)) {
                var a = i.length;
                if (a !== r.length)
                  return !1;
                for (; a--; )
                  if (!o.equals(i[a], r[a]))
                    return !1;
              } else {
                var l = Object.keys(i), a = l.length;
                if (a !== Object.keys(r).length)
                  return !1;
                for (; a--; ) {
                  var u = l[a];
                  if (!(r.hasOwnProperty(u) && o.equals(i[u], r[u])))
                    return !1;
                }
              }
              return !0;
            }
            return !1;
          },
          read: function(i, r, a, l) {
            if (this === o) {
              var u = this.peek(i, r);
              return i.__index++, u;
            }
            var d = this.prototype, v = d._readIndex, p = r || v && i.__index || 0, b = i.length, S = i[p];
            if (l = l || b - p, S instanceof this || a && a.readNull && S == null && l <= 1)
              return v && (i.__index = p + 1), S && a && a.clone ? S.clone() : S;
            if (S = o.create(d), v && (S.__read = !0), S = S.initialize.apply(S, p > 0 || p + l < b ? o.slice(i, p, p + l) : i) || S, v) {
              i.__index = p + S.__read;
              var L = S.__filtered;
              L && (i.__filtered = L, S.__filtered = t), S.__read = t;
            }
            return S;
          },
          peek: function(i, r) {
            return i[i.__index = r || i.__index || 0];
          },
          remain: function(i) {
            return i.length - (i.__index || 0);
          },
          readList: function(i, r, a, l) {
            for (var u = [], d, v = r || 0, p = l ? v + l : i.length, b = v; b < p; b++)
              u.push(Array.isArray(d = i[b]) ? this.read(d, 0, a) : this.read(i, b, a, 1));
            return u;
          },
          readNamed: function(i, r, a, l, u) {
            var d = this.getNamed(i, r), v = d !== t;
            if (v) {
              var p = i.__filtered;
              if (!p) {
                var b = this.getSource(i);
                p = i.__filtered = o.create(b), p.__unfiltered = b;
              }
              p[r] = t;
            }
            return this.read(v ? [d] : i, a, l, u);
          },
          readSupported: function(i, r) {
            var a = this.getSource(i), l = this, u = !1;
            return a && Object.keys(a).forEach(function(d) {
              if (d in r) {
                var v = l.readNamed(i, d);
                v !== t && (r[d] = v), u = !0;
              }
            }), u;
          },
          getSource: function(i) {
            var r = i.__source;
            if (r === t) {
              var a = i.length === 1 && i[0];
              r = i.__source = a && o.isPlainObject(a) ? a : null;
            }
            return r;
          },
          getNamed: function(i, r) {
            var a = this.getSource(i);
            if (a)
              return r ? a[r] : i.__filtered || a;
          },
          hasNamed: function(i, r) {
            return !!this.getNamed(i, r);
          },
          filter: function(i, r, a, l) {
            var u;
            function d(L) {
              if (!(a && L in a) && !(u && L in u)) {
                var E = r[L];
                E !== t && (i[L] = E);
              }
            }
            if (l) {
              for (var v = {}, p = 0, b, S = l.length; p < S; p++)
                (b = l[p]) in r && (d(b), v[b] = !0);
              u = v;
            }
            return Object.keys(r.__unfiltered || r).forEach(d), i;
          },
          isPlainValue: function(i, r) {
            return o.isPlainObject(i) || Array.isArray(i) || r && typeof i == "string";
          },
          serialize: function(i, r, a, l) {
            r = r || {};
            var u = !l, d;
            if (u && (r.formatter = new B(r.precision), l = {
              length: 0,
              definitions: {},
              references: {},
              add: function(E, A) {
                var T = "#" + E._id, G = this.references[T];
                if (!G) {
                  this.length++;
                  var D = A.call(E), Y = E._class;
                  Y && D[0] !== Y && D.unshift(Y), this.definitions[T] = D, G = this.references[T] = [T];
                }
                return G;
              }
            }), i && i._serialize) {
              d = i._serialize(r, l);
              var v = i._class;
              v && !i._compactSerialize && (u || !a) && d[0] !== v && d.unshift(v);
            } else if (Array.isArray(i)) {
              d = [];
              for (var p = 0, b = i.length; p < b; p++)
                d[p] = o.serialize(i[p], r, a, l);
            } else if (o.isPlainObject(i)) {
              d = {};
              for (var S = Object.keys(i), p = 0, b = S.length; p < b; p++) {
                var L = S[p];
                d[L] = o.serialize(
                  i[L],
                  r,
                  a,
                  l
                );
              }
            } else
              typeof i == "number" ? d = r.formatter.number(i, r.precision) : d = i;
            return u && l.length > 0 ? [["dictionary", l.definitions], d] : d;
          },
          deserialize: function(i, r, a, l, u) {
            var d = i, v = !a, p = v && i && i.length && i[0][0] === "dictionary";
            if (a = a || {}, Array.isArray(i)) {
              var b = i[0], S = b === "dictionary";
              if (i.length == 1 && /^#/.test(b))
                return a.dictionary[b];
              b = o.exports[b], d = [];
              for (var L = b ? 1 : 0, E = i.length; L < E; L++)
                d.push(o.deserialize(
                  i[L],
                  r,
                  a,
                  S,
                  p
                ));
              if (b) {
                var A = d;
                r ? d = r(b, A, v || u) : d = new b(A);
              }
            } else if (o.isPlainObject(i)) {
              d = {}, l && (a.dictionary = d);
              for (var T in i)
                d[T] = o.deserialize(i[T], r, a);
            }
            return p ? d[1] : d;
          },
          exportJSON: function(i, r) {
            var a = o.serialize(i, r);
            return r && r.asString == !1 ? a : JSON.stringify(a);
          },
          importJSON: function(i, r) {
            return o.deserialize(
              typeof i == "string" ? JSON.parse(i) : i,
              function(a, l, u) {
                var d = u && r && r.constructor === a, v = d ? r : o.create(a.prototype);
                if (l.length === 1 && v instanceof X && (d || !(v instanceof je))) {
                  var p = l[0];
                  o.isPlainObject(p) && (p.insert = !1, d && (l = l.concat([X.INSERT])));
                }
                return (d ? v.set : a).apply(v, l), d && (r = null), v;
              }
            );
          },
          push: function(i, r) {
            var a = r.length;
            if (a < 4096)
              i.push.apply(i, r);
            else {
              var l = i.length;
              i.length += a;
              for (var u = 0; u < a; u++)
                i[l + u] = r[u];
            }
            return i;
          },
          splice: function(i, r, a, l) {
            var u = r && r.length, d = a === t;
            a = d ? i.length : a, a > i.length && (a = i.length);
            for (var v = 0; v < u; v++)
              r[v]._index = a + v;
            if (d)
              return o.push(i, r), [];
            var p = [a, l];
            r && o.push(p, r);
            for (var b = i.splice.apply(i, p), v = 0, S = b.length; v < S; v++)
              b[v]._index = t;
            for (var v = a + u, S = i.length; v < S; v++)
              i[v]._index = v;
            return b;
          },
          capitalize: function(i) {
            return i.replace(/\b[a-z]/g, function(r) {
              return r.toUpperCase();
            });
          },
          camelize: function(i) {
            return i.replace(/-(.)/g, function(r, a) {
              return a.toUpperCase();
            });
          },
          hyphenate: function(i) {
            return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
          }
        }
      });
      var h = {
        on: function(i, r) {
          if (typeof i != "string")
            o.each(i, function(d, v) {
              this.on(v, d);
            }, this);
          else {
            var a = this._eventTypes, l = a && a[i], u = this._callbacks = this._callbacks || {};
            u = u[i] = u[i] || [], u.indexOf(r) === -1 && (u.push(r), l && l.install && u.length === 1 && l.install.call(this, i));
          }
          return this;
        },
        off: function(i, r) {
          if (typeof i != "string") {
            o.each(i, function(v, p) {
              this.off(p, v);
            }, this);
            return;
          }
          var a = this._eventTypes, l = a && a[i], u = this._callbacks && this._callbacks[i], d;
          return u && (!r || (d = u.indexOf(r)) !== -1 && u.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : d !== -1 && u.splice(d, 1)), this;
        },
        once: function(i, r) {
          return this.on(i, function a() {
            r.apply(this, arguments), this.off(i, a);
          });
        },
        emit: function(i, r) {
          var a = this._callbacks && this._callbacks[i];
          if (!a)
            return !1;
          var l = o.slice(arguments, 1), u = r && r.target && !r.currentTarget;
          a = a.slice(), u && (r.currentTarget = this);
          for (var d = 0, v = a.length; d < v; d++)
            if (a[d].apply(this, l) == !1) {
              r && r.stop && r.stop();
              break;
            }
          return u && delete r.currentTarget, !0;
        },
        responds: function(i) {
          return !!(this._callbacks && this._callbacks[i]);
        },
        attach: "#on",
        detach: "#off",
        fire: "#emit",
        _installEvents: function(i) {
          var r = this._eventTypes, a = this._callbacks, l = i ? "install" : "uninstall";
          if (r) {
            for (var u in a)
              if (a[u].length > 0) {
                var d = r[u], v = d && d[l];
                v && v.call(this, u);
              }
          }
        },
        statics: {
          inject: function i(r) {
            var a = r._events;
            if (a) {
              var l = {};
              o.each(a, function(u, d) {
                var v = typeof u == "string", p = v ? u : d, b = o.capitalize(p), S = p.substring(2).toLowerCase();
                l[S] = v ? {} : u, p = "_" + p, r["get" + b] = function() {
                  return this[p];
                }, r["set" + b] = function(L) {
                  var E = this[p];
                  E && this.off(S, E), L && this.on(S, L), this[p] = L;
                };
              }), r._eventTypes = l;
            }
            return i.base.apply(this, arguments);
          }
        }
      }, c = o.extend({
        _class: "PaperScope",
        initialize: function i() {
          Ye = this, this.settings = new o({
            applyMatrix: !0,
            insertItems: !0,
            handleSize: 4,
            hitTolerance: 0
          }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
          var r = i.prototype;
          if (!this.support) {
            var a = vt.getContext(1, 1) || {};
            r.support = {
              nativeDash: "setLineDash" in a || "mozDash" in a,
              nativeBlendModes: Qe.nativeModes
            }, vt.release(a);
          }
          if (!this.agent) {
            var l = e.navigator.userAgent.toLowerCase(), u = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], d = u === "darwin" ? "mac" : u, v = r.agent = r.browser = { platform: d };
            d && (v[d] = !0), l.replace(
              /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
              function(p, b, S, L, E) {
                if (!v.chrome) {
                  var A = b === "opera" ? L : /^(node|trident)$/.test(b) ? E : S;
                  v.version = A, v.versionNumber = parseFloat(A), b = { trident: "msie", jsdom: "node" }[b] || b, v.name = b, v[b] = !0;
                }
              }
            ), v.chrome && delete v.webkit, v.atom && delete v.chrome;
          }
        },
        version: "0.12.18",
        getView: function() {
          var i = this.project;
          return i && i._view;
        },
        getPaper: function() {
          return this;
        },
        execute: function(i, r) {
          var a = Ye.PaperScript.execute(i, this, r);
          return Qt.updateFocus(), a;
        },
        install: function(i) {
          var r = this;
          o.each(["project", "view", "tool"], function(l) {
            o.define(i, l, {
              configurable: !0,
              get: function() {
                return r[l];
              }
            });
          });
          for (var a in this)
            !/^_/.test(a) && this[a] && (i[a] = this[a]);
        },
        setup: function(i) {
          return Ye = this, this.project = new fe(i), this;
        },
        createCanvas: function(i, r) {
          return vt.getCanvas(i, r);
        },
        activate: function() {
          Ye = this;
        },
        clear: function() {
          for (var i = this.projects, r = this.tools, a = i.length - 1; a >= 0; a--)
            i[a].remove();
          for (var a = r.length - 1; a >= 0; a--)
            r[a].remove();
        },
        remove: function() {
          this.clear(), delete c._scopes[this._id];
        },
        statics: new function() {
          function i(r) {
            return r += "Attribute", function(a, l) {
              return a[r](l) || a[r]("data-paper-" + l);
            };
          }
          return {
            _scopes: {},
            _id: 0,
            get: function(r) {
              return this._scopes[r] || null;
            },
            getAttribute: i("get"),
            hasAttribute: i("has")
          };
        }()
      }), m = o.extend(h, {
        initialize: function(i) {
          this._scope = Ye, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
        },
        activate: function() {
          if (!this._scope)
            return !1;
          var i = this._scope[this._reference];
          return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
        },
        isActive: function() {
          return this._scope[this._reference] === this;
        },
        remove: function() {
          return this._index == null ? !1 : (o.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
        },
        getView: function() {
          return this._scope.getView();
        }
      }), x = {
        findItemBoundsCollisions: function(i, r, a) {
          function l(v) {
            for (var p = new Array(v.length), b = 0; b < v.length; b++) {
              var S = v[b].getBounds();
              p[b] = [S.left, S.top, S.right, S.bottom];
            }
            return p;
          }
          var u = l(i), d = !r || r === i ? u : l(r);
          return this.findBoundsCollisions(u, d, a || 0);
        },
        findCurveBoundsCollisions: function(i, r, a, l) {
          function u(A) {
            for (var T = Math.min, G = Math.max, D = new Array(A.length), Y = 0; Y < A.length; Y++) {
              var k = A[Y];
              D[Y] = [
                T(k[0], k[2], k[4], k[6]),
                T(k[1], k[3], k[5], k[7]),
                G(k[0], k[2], k[4], k[6]),
                G(k[1], k[3], k[5], k[7])
              ];
            }
            return D;
          }
          var d = u(i), v = !r || r === i ? d : u(r);
          if (l) {
            for (var p = this.findBoundsCollisions(
              d,
              v,
              a || 0,
              !1,
              !0
            ), b = this.findBoundsCollisions(
              d,
              v,
              a || 0,
              !0,
              !0
            ), S = [], L = 0, E = p.length; L < E; L++)
              S[L] = { hor: p[L], ver: b[L] };
            return S;
          }
          return this.findBoundsCollisions(d, v, a || 0);
        },
        findBoundsCollisions: function(i, r, a, l, u) {
          var d = !r || i === r, v = d ? i : i.concat(r), p = i.length, b = v.length;
          function S(et, st, _t) {
            for (var Re = 0, Fe = et.length; Re < Fe; ) {
              var at = Fe + Re >>> 1;
              v[et[at]][st] < _t ? Re = at + 1 : Fe = at;
            }
            return Re - 1;
          }
          for (var L = l ? 1 : 0, E = L + 2, A = l ? 0 : 1, T = A + 2, G = new Array(b), D = 0; D < b; D++)
            G[D] = D;
          G.sort(function(et, st) {
            return v[et][L] - v[st][L];
          });
          for (var Y = [], k = new Array(p), D = 0; D < b; D++) {
            var z = G[D], C = v[z], O = d ? z : z - p, j = z < p, q = d || !j, H = j ? [] : null;
            if (Y.length) {
              var ie = S(
                Y,
                E,
                C[L] - a
              ) + 1;
              if (Y.splice(0, ie), d && u) {
                H = H.concat(Y);
                for (var ae = 0; ae < Y.length; ae++) {
                  var ue = Y[ae];
                  k[ue].push(O);
                }
              } else
                for (var me = C[T], se = C[A], ae = 0; ae < Y.length; ae++) {
                  var ue = Y[ae], de = v[ue], ve = ue < p, we = d || ue >= p;
                  (u || (j && we || q && ve) && me >= de[A] - a && se <= de[T] + a) && (j && we && H.push(
                    d ? ue : ue - p
                  ), q && ve && k[ue].push(O));
                }
            }
            if (j && (i === r && H.push(z), k[z] = H), Y.length) {
              var Se = C[E], Ae = S(Y, E, Se);
              Y.splice(Ae + 1, 0, z);
            } else
              Y.push(z);
          }
          for (var D = 0; D < k.length; D++) {
            var Ge = k[D];
            Ge && Ge.sort(function(st, _t) {
              return st - _t;
            });
          }
          return k;
        }
      }, B = o.extend({
        initialize: function(i) {
          this.precision = o.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
        },
        number: function(i) {
          return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
        },
        pair: function(i, r, a) {
          return this.number(i) + (a || ",") + this.number(r);
        },
        point: function(i, r) {
          return this.number(i.x) + (r || ",") + this.number(i.y);
        },
        size: function(i, r) {
          return this.number(i.width) + (r || ",") + this.number(i.height);
        },
        rectangle: function(i, r) {
          return this.point(i, r) + (r || ",") + this.size(i, r);
        }
      });
      B.instance = new B();
      var I = new function() {
        var i = [
          [0.5773502691896257],
          [0, 0.7745966692414834],
          [0.33998104358485626, 0.8611363115940526],
          [0, 0.5384693101056831, 0.906179845938664],
          [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
          [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
          [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
          [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
          [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
          [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
          [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
          [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
          [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
          [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
          [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
        ], r = [
          [1],
          [0.8888888888888888, 0.5555555555555556],
          [0.6521451548625461, 0.34785484513745385],
          [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
          [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
          [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
          [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
          [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
          [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
          [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
          [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
          [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
          [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
          [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
          [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
        ], a = Math.abs, l = Math.sqrt, u = Math.pow, d = Math.log2 || function(E) {
          return Math.log(E) * Math.LOG2E;
        }, v = 1e-12, p = 112e-18;
        function b(E, A, T) {
          return E < A ? A : E > T ? T : E;
        }
        function S(E, A, T) {
          function G(ie) {
            var ae = ie * 134217729, ue = ie - ae, me = ue + ae, se = ie - me;
            return [me, se];
          }
          var D = A * A - E * T, Y = A * A + E * T;
          if (a(D) * 3 < Y) {
            var k = G(E), z = G(A), C = G(T), O = A * A, j = z[0] * z[0] - O + 2 * z[0] * z[1] + z[1] * z[1], q = E * T, H = k[0] * C[0] - q + k[0] * C[1] + k[1] * C[0] + k[1] * C[1];
            D = O - q + (j - H);
          }
          return D;
        }
        function L() {
          var E = Math.max.apply(Math, arguments);
          return E && (E < 1e-8 || E > 1e8) ? u(2, -Math.round(d(E))) : 0;
        }
        return {
          EPSILON: v,
          MACHINE_EPSILON: p,
          CURVETIME_EPSILON: 1e-8,
          GEOMETRIC_EPSILON: 1e-7,
          TRIGONOMETRIC_EPSILON: 1e-8,
          ANGULAR_EPSILON: 1e-5,
          KAPPA: 4 * (l(2) - 1) / 3,
          isZero: function(E) {
            return E >= -v && E <= v;
          },
          isMachineZero: function(E) {
            return E >= -p && E <= p;
          },
          clamp: b,
          integrate: function(E, A, T, G) {
            for (var D = i[G - 2], Y = r[G - 2], k = (T - A) * 0.5, z = k + A, C = 0, O = G + 1 >> 1, j = G & 1 ? Y[C++] * E(z) : 0; C < O; ) {
              var q = k * D[C];
              j += Y[C++] * (E(z + q) + E(z - q));
            }
            return k * j;
          },
          findRoot: function(E, A, T, G, D, Y, k) {
            for (var z = 0; z < Y; z++) {
              var C = E(T), O = C / A(T), j = T - O;
              if (a(O) < k) {
                T = j;
                break;
              }
              C > 0 ? (D = T, T = j <= G ? (G + D) * 0.5 : j) : (G = T, T = j >= D ? (G + D) * 0.5 : j);
            }
            return b(T, G, D);
          },
          solveQuadratic: function(E, A, T, G, D, Y) {
            var k, z = 1 / 0;
            if (a(E) < v) {
              if (a(A) < v)
                return a(T) < v ? -1 : 0;
              k = -T / A;
            } else {
              A *= -0.5;
              var C = S(E, A, T);
              if (C && a(C) < p) {
                var O = L(a(E), a(A), a(T));
                O && (E *= O, A *= O, T *= O, C = S(E, A, T));
              }
              if (C >= -p) {
                var j = C < 0 ? 0 : l(C), q = A + (A < 0 ? -j : j);
                q === 0 ? (k = T / E, z = -k) : (k = q / E, z = T / q);
              }
            }
            var H = 0, ie = D == null, ae = D - v, ue = Y + v;
            return isFinite(k) && (ie || k > ae && k < ue) && (G[H++] = ie ? k : b(k, D, Y)), z !== k && isFinite(z) && (ie || z > ae && z < ue) && (G[H++] = ie ? z : b(z, D, Y)), H;
          },
          solveCubic: function(E, A, T, G, D, Y, k) {
            var z = L(a(E), a(A), a(T), a(G)), C, O, j, q, H;
            z && (E *= z, A *= z, T *= z, G *= z);
            function ie(Ae) {
              C = Ae;
              var Ge = E * C;
              O = Ge + A, j = O * C + T, q = (Ge + O) * C + j, H = j * C + G;
            }
            if (a(E) < v)
              E = A, O = T, j = G, C = 1 / 0;
            else if (a(G) < v)
              O = A, j = T, C = 0;
            else {
              ie(-(A / E) / 3);
              var ae = H / E, ue = u(a(ae), 1 / 3), me = ae < 0 ? -1 : 1, se = -q / E, de = se > 0 ? 1.324717957244746 * Math.max(ue, l(se)) : ue, ve = C - me * de;
              if (ve !== C) {
                do
                  ie(ve), ve = q === 0 ? C : C - H / q / (1 + p);
                while (me * ve > me * C);
                a(E) * C * C > a(G / C) && (j = -G / C, O = (j - T) / C);
              }
            }
            var we = I.solveQuadratic(E, O, j, D, Y, k), Se = Y == null;
            return isFinite(C) && (we === 0 || we > 0 && C !== D[0] && C !== D[1]) && (Se || C > Y - v && C < k + v) && (D[we++] = Se ? C : b(C, Y, k)), we;
          }
        };
      }(), F = {
        _id: 1,
        _pools: {},
        get: function(i) {
          if (i) {
            var r = this._pools[i];
            return r || (r = this._pools[i] = { _id: 1 }), r._id++;
          } else
            return this._id++;
        }
      }, M = o.extend({
        _class: "Point",
        _readIndex: !0,
        initialize: function(i, r) {
          var a = typeof i, l = this.__read, u = 0;
          if (a === "number") {
            var d = typeof r == "number";
            this._set(i, d ? r : i), l && (u = d ? 2 : 1);
          } else if (a === "undefined" || i === null)
            this._set(0, 0), l && (u = i === null ? 1 : 0);
          else {
            var v = a === "string" ? i.split(/[\s,]+/) || [] : i;
            u = 1, Array.isArray(v) ? this._set(+v[0], +(v.length > 1 ? v[1] : v[0])) : "x" in v ? this._set(v.x || 0, v.y || 0) : "width" in v ? this._set(v.width || 0, v.height || 0) : "angle" in v ? (this._set(v.length || 0, 0), this.setAngle(v.angle || 0)) : (this._set(0, 0), u = 0);
          }
          return l && (this.__read = u), this;
        },
        set: "#initialize",
        _set: function(i, r) {
          return this.x = i, this.y = r, this;
        },
        equals: function(i) {
          return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
        },
        clone: function() {
          return new M(this.x, this.y);
        },
        toString: function() {
          var i = B.instance;
          return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
        },
        _serialize: function(i) {
          var r = i.formatter;
          return [r.number(this.x), r.number(this.y)];
        },
        getLength: function() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        },
        setLength: function(i) {
          if (this.isZero()) {
            var r = this._angle || 0;
            this._set(
              Math.cos(r) * i,
              Math.sin(r) * i
            );
          } else {
            var a = i / this.getLength();
            I.isZero(a) && this.getAngle(), this._set(
              this.x * a,
              this.y * a
            );
          }
        },
        getAngle: function() {
          return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
        },
        setAngle: function(i) {
          this.setAngleInRadians.call(this, i * Math.PI / 180);
        },
        getAngleInDegrees: "#getAngle",
        setAngleInDegrees: "#setAngle",
        getAngleInRadians: function() {
          if (arguments.length) {
            var i = M.read(arguments), r = this.getLength() * i.getLength();
            if (I.isZero(r))
              return NaN;
            var a = this.dot(i) / r;
            return Math.acos(a < -1 ? -1 : a > 1 ? 1 : a);
          } else
            return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
        },
        setAngleInRadians: function(i) {
          if (this._angle = i, !this.isZero()) {
            var r = this.getLength();
            this._set(
              Math.cos(i) * r,
              Math.sin(i) * r
            );
          }
        },
        getQuadrant: function() {
          return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
        }
      }, {
        beans: !1,
        getDirectedAngle: function() {
          var i = M.read(arguments);
          return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
        },
        getDistance: function() {
          var i = arguments, r = M.read(i), a = r.x - this.x, l = r.y - this.y, u = a * a + l * l, d = o.read(i);
          return d ? u : Math.sqrt(u);
        },
        normalize: function(i) {
          i === t && (i = 1);
          var r = this.getLength(), a = r !== 0 ? i / r : 0, l = new M(this.x * a, this.y * a);
          return a >= 0 && (l._angle = this._angle), l;
        },
        rotate: function(i, r) {
          if (i === 0)
            return this.clone();
          i = i * Math.PI / 180;
          var a = r ? this.subtract(r) : this, l = Math.sin(i), u = Math.cos(i);
          return a = new M(
            a.x * u - a.y * l,
            a.x * l + a.y * u
          ), r ? a.add(r) : a;
        },
        transform: function(i) {
          return i ? i._transformPoint(this) : this;
        },
        add: function() {
          var i = M.read(arguments);
          return new M(this.x + i.x, this.y + i.y);
        },
        subtract: function() {
          var i = M.read(arguments);
          return new M(this.x - i.x, this.y - i.y);
        },
        multiply: function() {
          var i = M.read(arguments);
          return new M(this.x * i.x, this.y * i.y);
        },
        divide: function() {
          var i = M.read(arguments);
          return new M(this.x / i.x, this.y / i.y);
        },
        modulo: function() {
          var i = M.read(arguments);
          return new M(this.x % i.x, this.y % i.y);
        },
        negate: function() {
          return new M(-this.x, -this.y);
        },
        isInside: function() {
          return P.read(arguments).contains(this);
        },
        isClose: function() {
          var i = arguments, r = M.read(i), a = o.read(i);
          return this.getDistance(r) <= a;
        },
        isCollinear: function() {
          var i = M.read(arguments);
          return M.isCollinear(this.x, this.y, i.x, i.y);
        },
        isColinear: "#isCollinear",
        isOrthogonal: function() {
          var i = M.read(arguments);
          return M.isOrthogonal(this.x, this.y, i.x, i.y);
        },
        isZero: function() {
          var i = I.isZero;
          return i(this.x) && i(this.y);
        },
        isNaN: function() {
          return isNaN(this.x) || isNaN(this.y);
        },
        isInQuadrant: function(i) {
          return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
        },
        dot: function() {
          var i = M.read(arguments);
          return this.x * i.x + this.y * i.y;
        },
        cross: function() {
          var i = M.read(arguments);
          return this.x * i.y - this.y * i.x;
        },
        project: function() {
          var i = M.read(arguments), r = i.isZero() ? 0 : this.dot(i) / i.dot(i);
          return new M(
            i.x * r,
            i.y * r
          );
        },
        statics: {
          min: function() {
            var i = arguments, r = M.read(i), a = M.read(i);
            return new M(
              Math.min(r.x, a.x),
              Math.min(r.y, a.y)
            );
          },
          max: function() {
            var i = arguments, r = M.read(i), a = M.read(i);
            return new M(
              Math.max(r.x, a.x),
              Math.max(r.y, a.y)
            );
          },
          random: function() {
            return new M(Math.random(), Math.random());
          },
          isCollinear: function(i, r, a, l) {
            return Math.abs(i * l - r * a) <= Math.sqrt((i * i + r * r) * (a * a + l * l)) * 1e-8;
          },
          isOrthogonal: function(i, r, a, l) {
            return Math.abs(i * a + r * l) <= Math.sqrt((i * i + r * r) * (a * a + l * l)) * 1e-8;
          }
        }
      }, o.each(["round", "ceil", "floor", "abs"], function(i) {
        var r = Math[i];
        this[i] = function() {
          return new M(r(this.x), r(this.y));
        };
      }, {})), Z = M.extend({
        initialize: function(i, r, a, l) {
          this._x = i, this._y = r, this._owner = a, this._setter = l;
        },
        _set: function(i, r, a) {
          return this._x = i, this._y = r, a || this._owner[this._setter](this), this;
        },
        getX: function() {
          return this._x;
        },
        setX: function(i) {
          this._x = i, this._owner[this._setter](this);
        },
        getY: function() {
          return this._y;
        },
        setY: function(i) {
          this._y = i, this._owner[this._setter](this);
        },
        isSelected: function() {
          return !!(this._owner._selection & this._getSelection());
        },
        setSelected: function(i) {
          this._owner._changeSelection(this._getSelection(), i);
        },
        _getSelection: function() {
          return this._setter === "setPosition" ? 4 : 0;
        }
      }), V = o.extend({
        _class: "Size",
        _readIndex: !0,
        initialize: function(i, r) {
          var a = typeof i, l = this.__read, u = 0;
          if (a === "number") {
            var d = typeof r == "number";
            this._set(i, d ? r : i), l && (u = d ? 2 : 1);
          } else if (a === "undefined" || i === null)
            this._set(0, 0), l && (u = i === null ? 1 : 0);
          else {
            var v = a === "string" ? i.split(/[\s,]+/) || [] : i;
            u = 1, Array.isArray(v) ? this._set(+v[0], +(v.length > 1 ? v[1] : v[0])) : "width" in v ? this._set(v.width || 0, v.height || 0) : "x" in v ? this._set(v.x || 0, v.y || 0) : (this._set(0, 0), u = 0);
          }
          return l && (this.__read = u), this;
        },
        set: "#initialize",
        _set: function(i, r) {
          return this.width = i, this.height = r, this;
        },
        equals: function(i) {
          return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
        },
        clone: function() {
          return new V(this.width, this.height);
        },
        toString: function() {
          var i = B.instance;
          return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
        },
        _serialize: function(i) {
          var r = i.formatter;
          return [
            r.number(this.width),
            r.number(this.height)
          ];
        },
        add: function() {
          var i = V.read(arguments);
          return new V(this.width + i.width, this.height + i.height);
        },
        subtract: function() {
          var i = V.read(arguments);
          return new V(this.width - i.width, this.height - i.height);
        },
        multiply: function() {
          var i = V.read(arguments);
          return new V(this.width * i.width, this.height * i.height);
        },
        divide: function() {
          var i = V.read(arguments);
          return new V(this.width / i.width, this.height / i.height);
        },
        modulo: function() {
          var i = V.read(arguments);
          return new V(this.width % i.width, this.height % i.height);
        },
        negate: function() {
          return new V(-this.width, -this.height);
        },
        isZero: function() {
          var i = I.isZero;
          return i(this.width) && i(this.height);
        },
        isNaN: function() {
          return isNaN(this.width) || isNaN(this.height);
        },
        statics: {
          min: function(i, r) {
            return new V(
              Math.min(i.width, r.width),
              Math.min(i.height, r.height)
            );
          },
          max: function(i, r) {
            return new V(
              Math.max(i.width, r.width),
              Math.max(i.height, r.height)
            );
          },
          random: function() {
            return new V(Math.random(), Math.random());
          }
        }
      }, o.each(["round", "ceil", "floor", "abs"], function(i) {
        var r = Math[i];
        this[i] = function() {
          return new V(r(this.width), r(this.height));
        };
      }, {})), te = V.extend({
        initialize: function(i, r, a, l) {
          this._width = i, this._height = r, this._owner = a, this._setter = l;
        },
        _set: function(i, r, a) {
          return this._width = i, this._height = r, a || this._owner[this._setter](this), this;
        },
        getWidth: function() {
          return this._width;
        },
        setWidth: function(i) {
          this._width = i, this._owner[this._setter](this);
        },
        getHeight: function() {
          return this._height;
        },
        setHeight: function(i) {
          this._height = i, this._owner[this._setter](this);
        }
      }), P = o.extend({
        _class: "Rectangle",
        _readIndex: !0,
        beans: !0,
        initialize: function(i, r, a, l) {
          var u = arguments, d = typeof i, v;
          if (d === "number" ? (this._set(i, r, a, l), v = 4) : d === "undefined" || i === null ? (this._set(0, 0, 0, 0), v = i === null ? 1 : 0) : u.length === 1 && (Array.isArray(i) ? (this._set.apply(this, i), v = 1) : i.x !== t || i.width !== t ? (this._set(
            i.x || 0,
            i.y || 0,
            i.width || 0,
            i.height || 0
          ), v = 1) : i.from === t && i.to === t && (this._set(0, 0, 0, 0), o.readSupported(u, this) && (v = 1))), v === t) {
            var p = M.readNamed(u, "from"), b = o.peek(u), S = p.x, L = p.y, E, A;
            if (b && b.x !== t || o.hasNamed(u, "to")) {
              var T = M.readNamed(u, "to");
              E = T.x - S, A = T.y - L, E < 0 && (S = T.x, E = -E), A < 0 && (L = T.y, A = -A);
            } else {
              var G = V.read(u);
              E = G.width, A = G.height;
            }
            this._set(S, L, E, A), v = u.__index;
          }
          var D = u.__filtered;
          return D && (this.__filtered = D), this.__read && (this.__read = v), this;
        },
        set: "#initialize",
        _set: function(i, r, a, l) {
          return this.x = i, this.y = r, this.width = a, this.height = l, this;
        },
        clone: function() {
          return new P(this.x, this.y, this.width, this.height);
        },
        equals: function(i) {
          var r = o.isPlainValue(i) ? P.read(arguments) : i;
          return r === this || r && this.x === r.x && this.y === r.y && this.width === r.width && this.height === r.height || !1;
        },
        toString: function() {
          var i = B.instance;
          return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
        },
        _serialize: function(i) {
          var r = i.formatter;
          return [
            r.number(this.x),
            r.number(this.y),
            r.number(this.width),
            r.number(this.height)
          ];
        },
        getPoint: function(i) {
          var r = i ? M : Z;
          return new r(this.x, this.y, this, "setPoint");
        },
        setPoint: function() {
          var i = M.read(arguments);
          this.x = i.x, this.y = i.y;
        },
        getSize: function(i) {
          var r = i ? V : te;
          return new r(this.width, this.height, this, "setSize");
        },
        _fw: 1,
        _fh: 1,
        setSize: function() {
          var i = V.read(arguments), r = this._sx, a = this._sy, l = i.width, u = i.height;
          r && (this.x += (this.width - l) * r), a && (this.y += (this.height - u) * a), this.width = l, this.height = u, this._fw = this._fh = 1;
        },
        getLeft: function() {
          return this.x;
        },
        setLeft: function(i) {
          if (!this._fw) {
            var r = i - this.x;
            this.width -= this._sx === 0.5 ? r * 2 : r;
          }
          this.x = i, this._sx = this._fw = 0;
        },
        getTop: function() {
          return this.y;
        },
        setTop: function(i) {
          if (!this._fh) {
            var r = i - this.y;
            this.height -= this._sy === 0.5 ? r * 2 : r;
          }
          this.y = i, this._sy = this._fh = 0;
        },
        getRight: function() {
          return this.x + this.width;
        },
        setRight: function(i) {
          if (!this._fw) {
            var r = i - this.x;
            this.width = this._sx === 0.5 ? r * 2 : r;
          }
          this.x = i - this.width, this._sx = 1, this._fw = 0;
        },
        getBottom: function() {
          return this.y + this.height;
        },
        setBottom: function(i) {
          if (!this._fh) {
            var r = i - this.y;
            this.height = this._sy === 0.5 ? r * 2 : r;
          }
          this.y = i - this.height, this._sy = 1, this._fh = 0;
        },
        getCenterX: function() {
          return this.x + this.width / 2;
        },
        setCenterX: function(i) {
          this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
        },
        getCenterY: function() {
          return this.y + this.height / 2;
        },
        setCenterY: function(i) {
          this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
        },
        getCenter: function(i) {
          var r = i ? M : Z;
          return new r(this.getCenterX(), this.getCenterY(), this, "setCenter");
        },
        setCenter: function() {
          var i = M.read(arguments);
          return this.setCenterX(i.x), this.setCenterY(i.y), this;
        },
        getArea: function() {
          return this.width * this.height;
        },
        isEmpty: function() {
          return this.width === 0 || this.height === 0;
        },
        contains: function(i) {
          return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(P.read(arguments)) : this._containsPoint(M.read(arguments));
        },
        _containsPoint: function(i) {
          var r = i.x, a = i.y;
          return r >= this.x && a >= this.y && r <= this.x + this.width && a <= this.y + this.height;
        },
        _containsRectangle: function(i) {
          var r = i.x, a = i.y;
          return r >= this.x && a >= this.y && r + i.width <= this.x + this.width && a + i.height <= this.y + this.height;
        },
        intersects: function() {
          var i = P.read(arguments), r = o.read(arguments) || 0;
          return i.x + i.width > this.x - r && i.y + i.height > this.y - r && i.x < this.x + this.width + r && i.y < this.y + this.height + r;
        },
        intersect: function() {
          var i = P.read(arguments), r = Math.max(this.x, i.x), a = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), u = Math.min(this.y + this.height, i.y + i.height);
          return new P(r, a, l - r, u - a);
        },
        unite: function() {
          var i = P.read(arguments), r = Math.min(this.x, i.x), a = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), u = Math.max(this.y + this.height, i.y + i.height);
          return new P(r, a, l - r, u - a);
        },
        include: function() {
          var i = M.read(arguments), r = Math.min(this.x, i.x), a = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), u = Math.max(this.y + this.height, i.y);
          return new P(r, a, l - r, u - a);
        },
        expand: function() {
          var i = V.read(arguments), r = i.width, a = i.height;
          return new P(
            this.x - r / 2,
            this.y - a / 2,
            this.width + r,
            this.height + a
          );
        },
        scale: function(i, r) {
          return this.expand(
            this.width * i - this.width,
            this.height * (r === t ? i : r) - this.height
          );
        }
      }, o.each(
        [
          ["Top", "Left"],
          ["Top", "Right"],
          ["Bottom", "Left"],
          ["Bottom", "Right"],
          ["Left", "Center"],
          ["Top", "Center"],
          ["Right", "Center"],
          ["Bottom", "Center"]
        ],
        function(i, r) {
          var a = i.join(""), l = /^[RL]/.test(a);
          r >= 4 && (i[1] += l ? "Y" : "X");
          var u = i[l ? 0 : 1], d = i[l ? 1 : 0], v = "get" + u, p = "get" + d, b = "set" + u, S = "set" + d, L = "get" + a, E = "set" + a;
          this[L] = function(A) {
            var T = A ? M : Z;
            return new T(this[v](), this[p](), this, E);
          }, this[E] = function() {
            var A = M.read(arguments);
            this[b](A.x), this[S](A.y);
          };
        },
        {
          beans: !0
        }
      )), K = P.extend(
        {
          initialize: function(i, r, a, l, u, d) {
            this._set(i, r, a, l, !0), this._owner = u, this._setter = d;
          },
          _set: function(i, r, a, l, u) {
            return this._x = i, this._y = r, this._width = a, this._height = l, u || this._owner[this._setter](this), this;
          }
        },
        new function() {
          var i = P.prototype;
          return o.each(
            ["x", "y", "width", "height"],
            function(r) {
              var a = o.capitalize(r), l = "_" + r;
              this["get" + a] = function() {
                return this[l];
              }, this["set" + a] = function(u) {
                this[l] = u, this._dontNotify || this._owner[this._setter](this);
              };
            },
            o.each(
              [
                "Point",
                "Size",
                "Center",
                "Left",
                "Top",
                "Right",
                "Bottom",
                "CenterX",
                "CenterY",
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ],
              function(r) {
                var a = "set" + r;
                this[a] = function() {
                  this._dontNotify = !0, i[a].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
                };
              },
              {
                isSelected: function() {
                  return !!(this._owner._selection & 2);
                },
                setSelected: function(r) {
                  var a = this._owner;
                  a._changeSelection && a._changeSelection(2, r);
                }
              }
            )
          );
        }()
      ), J = o.extend({
        _class: "Matrix",
        initialize: function i(r, a) {
          var l = arguments, u = l.length, d = !0;
          if (u >= 6 ? this._set.apply(this, l) : u === 1 || u === 2 ? r instanceof i ? this._set(
            r._a,
            r._b,
            r._c,
            r._d,
            r._tx,
            r._ty,
            a
          ) : Array.isArray(r) ? this._set.apply(
            this,
            a ? r.concat([a]) : r
          ) : d = !1 : u ? d = !1 : this.reset(), !d)
            throw new Error("Unsupported matrix parameters");
          return this;
        },
        set: "#initialize",
        _set: function(i, r, a, l, u, d, v) {
          return this._a = i, this._b = r, this._c = a, this._d = l, this._tx = u, this._ty = d, v || this._changed(), this;
        },
        _serialize: function(i, r) {
          return o.serialize(this.getValues(), i, !0, r);
        },
        _changed: function() {
          var i = this._owner;
          i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
        },
        clone: function() {
          return new J(
            this._a,
            this._b,
            this._c,
            this._d,
            this._tx,
            this._ty
          );
        },
        equals: function(i) {
          return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
        },
        toString: function() {
          var i = B.instance;
          return "[[" + [
            i.number(this._a),
            i.number(this._c),
            i.number(this._tx)
          ].join(", ") + "], [" + [
            i.number(this._b),
            i.number(this._d),
            i.number(this._ty)
          ].join(", ") + "]]";
        },
        reset: function(i) {
          return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
        },
        apply: function(i, r) {
          var a = this._owner;
          return a ? (a.transform(null, o.pick(i, !0), r), this.isIdentity()) : !1;
        },
        translate: function() {
          var i = M.read(arguments), r = i.x, a = i.y;
          return this._tx += r * this._a + a * this._c, this._ty += r * this._b + a * this._d, this._changed(), this;
        },
        scale: function() {
          var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 });
          return a && this.translate(a), this._a *= r.x, this._b *= r.x, this._c *= r.y, this._d *= r.y, a && this.translate(a.negate()), this._changed(), this;
        },
        rotate: function(i) {
          i *= Math.PI / 180;
          var r = M.read(arguments, 1), a = r.x, l = r.y, u = Math.cos(i), d = Math.sin(i), v = a - a * u + l * d, p = l - a * d - l * u, b = this._a, S = this._b, L = this._c, E = this._d;
          return this._a = u * b + d * L, this._b = u * S + d * E, this._c = -d * b + u * L, this._d = -d * S + u * E, this._tx += v * b + p * L, this._ty += v * S + p * E, this._changed(), this;
        },
        shear: function() {
          var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 });
          a && this.translate(a);
          var l = this._a, u = this._b;
          return this._a += r.y * this._c, this._b += r.y * this._d, this._c += r.x * l, this._d += r.x * u, a && this.translate(a.negate()), this._changed(), this;
        },
        skew: function() {
          var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 }), l = Math.PI / 180, u = new M(
            Math.tan(r.x * l),
            Math.tan(r.y * l)
          );
          return this.shear(u, a);
        },
        append: function(i, r) {
          if (i) {
            var a = this._a, l = this._b, u = this._c, d = this._d, v = i._a, p = i._c, b = i._b, S = i._d, L = i._tx, E = i._ty;
            this._a = v * a + b * u, this._c = p * a + S * u, this._b = v * l + b * d, this._d = p * l + S * d, this._tx += L * a + E * u, this._ty += L * l + E * d, r || this._changed();
          }
          return this;
        },
        prepend: function(i, r) {
          if (i) {
            var a = this._a, l = this._b, u = this._c, d = this._d, v = this._tx, p = this._ty, b = i._a, S = i._c, L = i._b, E = i._d, A = i._tx, T = i._ty;
            this._a = b * a + S * l, this._c = b * u + S * d, this._b = L * a + E * l, this._d = L * u + E * d, this._tx = b * v + S * p + A, this._ty = L * v + E * p + T, r || this._changed();
          }
          return this;
        },
        appended: function(i) {
          return this.clone().append(i);
        },
        prepended: function(i) {
          return this.clone().prepend(i);
        },
        invert: function() {
          var i = this._a, r = this._b, a = this._c, l = this._d, u = this._tx, d = this._ty, v = i * l - r * a, p = null;
          return v && !isNaN(v) && isFinite(u) && isFinite(d) && (this._a = l / v, this._b = -r / v, this._c = -a / v, this._d = i / v, this._tx = (a * d - l * u) / v, this._ty = (r * u - i * d) / v, p = this), p;
        },
        inverted: function() {
          return this.clone().invert();
        },
        concatenate: "#append",
        preConcatenate: "#prepend",
        chain: "#appended",
        _shiftless: function() {
          return new J(this._a, this._b, this._c, this._d, 0, 0);
        },
        _orNullIfIdentity: function() {
          return this.isIdentity() ? null : this;
        },
        isIdentity: function() {
          return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
        },
        isInvertible: function() {
          var i = this._a * this._d - this._c * this._b;
          return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
        },
        isSingular: function() {
          return !this.isInvertible();
        },
        transform: function(i, r, a) {
          return arguments.length < 3 ? this._transformPoint(M.read(arguments)) : this._transformCoordinates(i, r, a);
        },
        _transformPoint: function(i, r, a) {
          var l = i.x, u = i.y;
          return r || (r = new M()), r._set(
            l * this._a + u * this._c + this._tx,
            l * this._b + u * this._d + this._ty,
            a
          );
        },
        _transformCoordinates: function(i, r, a) {
          for (var l = 0, u = 2 * a; l < u; l += 2) {
            var d = i[l], v = i[l + 1];
            r[l] = d * this._a + v * this._c + this._tx, r[l + 1] = d * this._b + v * this._d + this._ty;
          }
          return r;
        },
        _transformCorners: function(i) {
          var r = i.x, a = i.y, l = r + i.width, u = a + i.height, d = [r, a, l, a, l, u, r, u];
          return this._transformCoordinates(d, d, 4);
        },
        _transformBounds: function(i, r, a) {
          for (var l = this._transformCorners(i), u = l.slice(0, 2), d = u.slice(), v = 2; v < 8; v++) {
            var p = l[v], b = v & 1;
            p < u[b] ? u[b] = p : p > d[b] && (d[b] = p);
          }
          return r || (r = new P()), r._set(
            u[0],
            u[1],
            d[0] - u[0],
            d[1] - u[1],
            a
          );
        },
        inverseTransform: function() {
          return this._inverseTransform(M.read(arguments));
        },
        _inverseTransform: function(i, r, a) {
          var l = this._a, u = this._b, d = this._c, v = this._d, p = this._tx, b = this._ty, S = l * v - u * d, L = null;
          if (S && !isNaN(S) && isFinite(p) && isFinite(b)) {
            var E = i.x - this._tx, A = i.y - this._ty;
            r || (r = new M()), L = r._set(
              (E * v - A * d) / S,
              (A * l - E * u) / S,
              a
            );
          }
          return L;
        },
        decompose: function() {
          var i = this._a, r = this._b, a = this._c, l = this._d, u = i * l - r * a, d = Math.sqrt, v = Math.atan2, p = 180 / Math.PI, b, S, L;
          if (i !== 0 || r !== 0) {
            var E = d(i * i + r * r);
            b = Math.acos(i / E) * (r > 0 ? 1 : -1), S = [E, u / E], L = [v(i * a + r * l, E * E), 0];
          } else if (a !== 0 || l !== 0) {
            var A = d(a * a + l * l);
            b = Math.asin(a / A) * (l > 0 ? 1 : -1), S = [u / A, A], L = [0, v(i * a + r * l, A * A)];
          } else
            b = 0, L = S = [0, 0];
          return {
            translation: this.getTranslation(),
            rotation: b * p,
            scaling: new M(S),
            skewing: new M(L[0] * p, L[1] * p)
          };
        },
        getValues: function() {
          return [this._a, this._b, this._c, this._d, this._tx, this._ty];
        },
        getTranslation: function() {
          return new M(this._tx, this._ty);
        },
        getScaling: function() {
          return this.decompose().scaling;
        },
        getRotation: function() {
          return this.decompose().rotation;
        },
        applyToContext: function(i) {
          this.isIdentity() || i.transform(
            this._a,
            this._b,
            this._c,
            this._d,
            this._tx,
            this._ty
          );
        }
      }, o.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
        var r = o.capitalize(i), a = "_" + i;
        this["get" + r] = function() {
          return this[a];
        }, this["set" + r] = function(l) {
          this[a] = l, this._changed();
        };
      }, {})), le = o.extend({
        _class: "Line",
        initialize: function(i, r, a, l, u) {
          var d = !1;
          arguments.length >= 4 ? (this._px = i, this._py = r, this._vx = a, this._vy = l, d = u) : (this._px = i.x, this._py = i.y, this._vx = r.x, this._vy = r.y, d = a), d || (this._vx -= this._px, this._vy -= this._py);
        },
        getPoint: function() {
          return new M(this._px, this._py);
        },
        getVector: function() {
          return new M(this._vx, this._vy);
        },
        getLength: function() {
          return this.getVector().getLength();
        },
        intersect: function(i, r) {
          return le.intersect(
            this._px,
            this._py,
            this._vx,
            this._vy,
            i._px,
            i._py,
            i._vx,
            i._vy,
            !0,
            r
          );
        },
        getSide: function(i, r) {
          return le.getSide(
            this._px,
            this._py,
            this._vx,
            this._vy,
            i.x,
            i.y,
            !0,
            r
          );
        },
        getDistance: function(i) {
          return Math.abs(this.getSignedDistance(i));
        },
        getSignedDistance: function(i) {
          return le.getSignedDistance(
            this._px,
            this._py,
            this._vx,
            this._vy,
            i.x,
            i.y,
            !0
          );
        },
        isCollinear: function(i) {
          return M.isCollinear(this._vx, this._vy, i._vx, i._vy);
        },
        isOrthogonal: function(i) {
          return M.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
        },
        statics: {
          intersect: function(i, r, a, l, u, d, v, p, b, S) {
            b || (a -= i, l -= r, v -= u, p -= d);
            var L = a * p - l * v;
            if (!I.isMachineZero(L)) {
              var E = i - u, A = r - d, T = (v * A - p * E) / L, G = (a * A - l * E) / L, D = 1e-12, Y = -D, k = 1 + D;
              if (S || Y < T && T < k && Y < G && G < k)
                return S || (T = T <= 0 ? 0 : T >= 1 ? 1 : T), new M(
                  i + T * a,
                  r + T * l
                );
            }
          },
          getSide: function(i, r, a, l, u, d, v, p) {
            v || (a -= i, l -= r);
            var b = u - i, S = d - r, L = b * l - S * a;
            return !p && I.isMachineZero(L) && (L = (b * a + b * a) / (a * a + l * l), L >= 0 && L <= 1 && (L = 0)), L < 0 ? -1 : L > 0 ? 1 : 0;
          },
          getSignedDistance: function(i, r, a, l, u, d, v) {
            return v || (a -= i, l -= r), a === 0 ? l > 0 ? u - i : i - u : l === 0 ? a < 0 ? d - r : r - d : ((u - i) * l - (d - r) * a) / (l > a ? l * Math.sqrt(1 + a * a / (l * l)) : a * Math.sqrt(1 + l * l / (a * a)));
          },
          getDistance: function(i, r, a, l, u, d, v) {
            return Math.abs(
              le.getSignedDistance(i, r, a, l, u, d, v)
            );
          }
        }
      }), fe = m.extend({
        _class: "Project",
        _list: "projects",
        _reference: "project",
        _compactSerialize: !0,
        initialize: function(i) {
          m.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new ui(null, null, this), this._view = Qt.create(
            this,
            i || vt.getCanvas(1, 1)
          ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
        },
        _serialize: function(i, r) {
          return o.serialize(this._children, i, !0, r);
        },
        _changed: function(i, r) {
          if (i & 1) {
            var a = this._view;
            a && (a._needsUpdate = !0, !a._requested && a._autoUpdate && a.requestUpdate());
          }
          var l = this._changes;
          if (l && r) {
            var u = this._changesById, d = r._id, v = u[d];
            v ? v.flags |= i : l.push(u[d] = { item: r, flags: i });
          }
        },
        clear: function() {
          for (var i = this._children, r = i.length - 1; r >= 0; r--)
            i[r].remove();
        },
        isEmpty: function() {
          return !this._children.length;
        },
        remove: function i() {
          return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
        },
        getView: function() {
          return this._view;
        },
        getCurrentStyle: function() {
          return this._currentStyle;
        },
        setCurrentStyle: function(i) {
          this._currentStyle.set(i);
        },
        getIndex: function() {
          return this._index;
        },
        getOptions: function() {
          return this._scope.settings;
        },
        getLayers: function() {
          return this._children;
        },
        getActiveLayer: function() {
          return this._activeLayer || new je({ project: this, insert: !0 });
        },
        getSymbolDefinitions: function() {
          var i = [], r = {};
          return this.getItems({
            class: ft,
            match: function(a) {
              var l = a._definition, u = l._id;
              return r[u] || (r[u] = !0, i.push(l)), !1;
            }
          }), i;
        },
        getSymbols: "getSymbolDefinitions",
        getSelectedItems: function() {
          var i = this._selectionItems, r = [];
          for (var a in i) {
            var l = i[a], u = l._selection;
            u & 1 && l.isInserted() ? r.push(l) : u || this._updateSelection(l);
          }
          return r;
        },
        _updateSelection: function(i) {
          var r = i._id, a = this._selectionItems;
          i._selection ? a[r] !== i && (this._selectionCount++, a[r] = i) : a[r] === i && (this._selectionCount--, delete a[r]);
        },
        selectAll: function() {
          for (var i = this._children, r = 0, a = i.length; r < a; r++)
            i[r].setFullySelected(!0);
        },
        deselectAll: function() {
          var i = this._selectionItems;
          for (var r in i)
            i[r].setFullySelected(!1);
        },
        addLayer: function(i) {
          return this.insertLayer(t, i);
        },
        insertLayer: function(i, r) {
          if (r instanceof je) {
            r._remove(!1, !0), o.splice(this._children, [r], i, 0), r._setProject(this, !0);
            var a = r._name;
            a && r.setName(a), this._changes && r._changed(5), this._activeLayer || (this._activeLayer = r);
          } else
            r = null;
          return r;
        },
        _insertItem: function(i, r, a) {
          return r = this.insertLayer(i, r) || (this._activeLayer || this._insertItem(
            t,
            new je(X.NO_INSERT),
            !0
          )).insertChild(i, r), a && r.activate && r.activate(), r;
        },
        getItems: function(i) {
          return X._getItems(this, i);
        },
        getItem: function(i) {
          return X._getItems(this, i, null, null, !0)[0] || null;
        },
        importJSON: function(i) {
          this.activate();
          var r = this._activeLayer;
          return o.importJSON(i, r && r.isEmpty() && r);
        },
        removeOn: function(i) {
          var r = this._removeSets;
          if (r) {
            i === "mouseup" && (r.mousedrag = null);
            var a = r[i];
            if (a) {
              for (var l in a) {
                var u = a[l];
                for (var d in r) {
                  var v = r[d];
                  v && v != a && delete v[u._id];
                }
                u.remove();
              }
              r[i] = null;
            }
          }
        },
        draw: function(i, r, a) {
          this._updateVersion++, i.save(), r.applyToContext(i);
          for (var l = this._children, u = new o({
            offset: new M(0, 0),
            pixelRatio: a,
            viewMatrix: r.isIdentity() ? null : r,
            matrices: [new J()],
            updateMatrix: !0
          }), d = 0, v = l.length; d < v; d++)
            l[d].draw(i, u);
          if (i.restore(), this._selectionCount > 0) {
            i.save(), i.strokeWidth = 1;
            var p = this._selectionItems, b = this._scope.settings.handleSize, S = this._updateVersion;
            for (var L in p)
              p[L]._drawSelection(i, r, b, p, S);
            i.restore();
          }
        }
      }), X = o.extend(
        h,
        {
          statics: {
            extend: function i(r) {
              return r._serializeFields && (r._serializeFields = o.set(
                {},
                this.prototype._serializeFields,
                r._serializeFields
              )), i.base.apply(this, arguments);
            },
            INSERT: { insert: !0 },
            NO_INSERT: { insert: !1 }
          },
          _class: "Item",
          _name: null,
          _applyMatrix: !0,
          _canApplyMatrix: !0,
          _canScaleStroke: !1,
          _pivot: null,
          _visible: !0,
          _blendMode: "normal",
          _opacity: 1,
          _locked: !1,
          _guide: !1,
          _clipMask: !1,
          _selection: 0,
          _selectBounds: !0,
          _selectChildren: !1,
          _serializeFields: {
            name: null,
            applyMatrix: null,
            matrix: new J(),
            pivot: null,
            visible: !0,
            blendMode: "normal",
            opacity: 1,
            locked: !1,
            guide: !1,
            clipMask: !1,
            selected: !1,
            data: {}
          },
          _prioritize: ["applyMatrix"]
        },
        new function() {
          var i = [
            "onMouseDown",
            "onMouseUp",
            "onMouseDrag",
            "onClick",
            "onDoubleClick",
            "onMouseMove",
            "onMouseEnter",
            "onMouseLeave"
          ];
          return o.each(
            i,
            function(r) {
              this._events[r] = {
                install: function(a) {
                  this.getView()._countItemEvent(a, 1);
                },
                uninstall: function(a) {
                  this.getView()._countItemEvent(a, -1);
                }
              };
            },
            {
              _events: {
                onFrame: {
                  install: function() {
                    this.getView()._animateItem(this, !0);
                  },
                  uninstall: function() {
                    this.getView()._animateItem(this, !1);
                  }
                },
                onLoad: {},
                onError: {}
              },
              statics: {
                _itemHandlers: i
              }
            }
          );
        }(),
        {
          initialize: function() {
          },
          _initialize: function(i, r) {
            var a = i && o.isPlainObject(i), l = a && i.internal === !0, u = this._matrix = new J(), d = a && i.project || Ye.project, v = Ye.settings;
            return this._id = l ? null : F.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && v.applyMatrix, r && u.translate(r), u._owner = this, this._style = new ui(d._currentStyle, this, d), l || a && i.insert == !1 || !v.insertItems && !(a && i.insert == !0) ? this._setProject(d) : (a && i.parent || d)._insertItem(t, this, !0), a && i !== X.NO_INSERT && i !== X.INSERT && this.set(i, {
              internal: !0,
              insert: !0,
              project: !0,
              parent: !0
            }), a;
          },
          _serialize: function(i, r) {
            var a = {}, l = this;
            function u(d) {
              for (var v in d) {
                var p = l[v];
                o.equals(p, v === "leading" ? d.fontSize * 1.2 : d[v]) || (a[v] = o.serialize(
                  p,
                  i,
                  v !== "data",
                  r
                ));
              }
            }
            return u(this._serializeFields), this instanceof W || u(this._style._defaults), [this._class, a];
          },
          _changed: function(i) {
            var r = this._symbol, a = this._parent || r, l = this._project;
            i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), a && i & 72 && X._clearBoundsCache(a), i & 2 && X._clearBoundsCache(this), l && l._changed(i, this), r && r._changed(i);
          },
          getId: function() {
            return this._id;
          },
          getName: function() {
            return this._name;
          },
          setName: function(i) {
            if (this._name && this._removeNamed(), i === +i + "")
              throw new Error(
                "Names consisting only of numbers are not supported."
              );
            var r = this._getOwner();
            if (i && r) {
              var a = r._children, l = r._namedChildren;
              (l[i] = l[i] || []).push(this), i in a || (a[i] = this);
            }
            this._name = i || t, this._changed(256);
          },
          getStyle: function() {
            return this._style;
          },
          setStyle: function(i) {
            this.getStyle().set(i);
          }
        },
        o.each(
          ["locked", "visible", "blendMode", "opacity", "guide"],
          function(i) {
            var r = o.capitalize(i), a = "_" + i, l = {
              locked: 256,
              visible: 265
            };
            this["get" + r] = function() {
              return this[a];
            }, this["set" + r] = function(u) {
              u != this[a] && (this[a] = u, this._changed(l[i] || 257));
            };
          },
          {}
        ),
        {
          beans: !0,
          getSelection: function() {
            return this._selection;
          },
          setSelection: function(i) {
            if (i !== this._selection) {
              this._selection = i;
              var r = this._project;
              r && (r._updateSelection(this), this._changed(257));
            }
          },
          _changeSelection: function(i, r) {
            var a = this._selection;
            this.setSelection(r ? a | i : a & ~i);
          },
          isSelected: function() {
            if (this._selectChildren) {
              for (var i = this._children, r = 0, a = i.length; r < a; r++)
                if (i[r].isSelected())
                  return !0;
            }
            return !!(this._selection & 1);
          },
          setSelected: function(i) {
            if (this._selectChildren)
              for (var r = this._children, a = 0, l = r.length; a < l; a++)
                r[a].setSelected(i);
            this._changeSelection(1, i);
          },
          isFullySelected: function() {
            var i = this._children, r = !!(this._selection & 1);
            if (i && r) {
              for (var a = 0, l = i.length; a < l; a++)
                if (!i[a].isFullySelected())
                  return !1;
              return !0;
            }
            return r;
          },
          setFullySelected: function(i) {
            var r = this._children;
            if (r)
              for (var a = 0, l = r.length; a < l; a++)
                r[a].setFullySelected(i);
            this._changeSelection(1, i);
          },
          isClipMask: function() {
            return this._clipMask;
          },
          setClipMask: function(i) {
            this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
          },
          getData: function() {
            return this._data || (this._data = {}), this._data;
          },
          setData: function(i) {
            this._data = i;
          },
          getPosition: function(i) {
            var r = i ? M : Z, a = this._position || (this._position = this._getPositionFromBounds());
            return new r(a.x, a.y, this, "setPosition");
          },
          setPosition: function() {
            this.translate(M.read(arguments).subtract(this.getPosition(!0)));
          },
          _getPositionFromBounds: function(i) {
            return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
          },
          getPivot: function() {
            var i = this._pivot;
            return i ? new Z(i.x, i.y, this, "setPivot") : null;
          },
          setPivot: function() {
            this._pivot = M.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
          }
        },
        o.each(
          {
            getStrokeBounds: { stroke: !0 },
            getHandleBounds: { handle: !0 },
            getInternalBounds: { internal: !0 }
          },
          function(i, r) {
            this[r] = function(a) {
              return this.getBounds(a, i);
            };
          },
          {
            beans: !0,
            getBounds: function(i, r) {
              var a = r || i instanceof J, l = o.set(
                {},
                a ? r : i,
                this._boundsOptions
              );
              (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
              var u = this._getCachedBounds(a && i, l).rect;
              return arguments.length ? u : new K(
                u.x,
                u.y,
                u.width,
                u.height,
                this,
                "setBounds"
              );
            },
            setBounds: function() {
              var i = P.read(arguments), r = this.getBounds(), a = this._matrix, l = new J(), u = i.getCenter();
              l.translate(u), (i.width != r.width || i.height != r.height) && (a.isInvertible() || (a.set(a._backup || new J().translate(a.getTranslation())), r = this.getBounds()), l.scale(
                r.width !== 0 ? i.width / r.width : 0,
                r.height !== 0 ? i.height / r.height : 0
              )), u = r.getCenter(), l.translate(-u.x, -u.y), this.transform(l);
            },
            _getBounds: function(i, r) {
              var a = this._children;
              return !a || !a.length ? new P() : (X._updateBoundsCache(this, r.cacheItem), X._getBounds(a, i, r));
            },
            _getBoundsCacheKey: function(i, r) {
              return [
                i.stroke ? 1 : 0,
                i.handle ? 1 : 0,
                r ? 1 : 0
              ].join("");
            },
            _getCachedBounds: function(i, r, a) {
              i = i && i._orNullIfIdentity();
              var l = r.internal && !a, u = r.cacheItem, d = l ? null : this._matrix._orNullIfIdentity(), v = u && (!i || i.equals(d)) && this._getBoundsCacheKey(r, l), p = this._bounds;
              if (X._updateBoundsCache(this._parent || this._symbol, u), v && p && v in p) {
                var b = p[v];
                return {
                  rect: b.rect.clone(),
                  nonscaling: b.nonscaling
                };
              }
              var S = this._getBounds(i || d, r), L = S.rect || S, E = this._style, A = S.nonscaling || E.hasStroke() && !E.getStrokeScaling();
              if (v) {
                p || (this._bounds = p = {});
                var b = p[v] = {
                  rect: L.clone(),
                  nonscaling: A,
                  internal: l
                };
              }
              return {
                rect: L,
                nonscaling: A
              };
            },
            _getStrokeMatrix: function(i, r) {
              var a = this.getStrokeScaling() ? null : r && r.internal ? this : this._parent || this._symbol && this._symbol._item, l = a ? a.getViewMatrix().invert() : i;
              return l && l._shiftless();
            },
            statics: {
              _updateBoundsCache: function(i, r) {
                if (i && r) {
                  var a = r._id, l = i._boundsCache = i._boundsCache || {
                    ids: {},
                    list: []
                  };
                  l.ids[a] || (l.list.push(r), l.ids[a] = r);
                }
              },
              _clearBoundsCache: function(i) {
                var r = i._boundsCache;
                if (r) {
                  i._bounds = i._position = i._boundsCache = t;
                  for (var a = 0, l = r.list, u = l.length; a < u; a++) {
                    var d = l[a];
                    d !== i && (d._bounds = d._position = t, d._boundsCache && X._clearBoundsCache(d));
                  }
                }
              },
              _getBounds: function(i, r, a) {
                var l = 1 / 0, u = -l, d = l, v = u, p = !1;
                a = a || {};
                for (var b = 0, S = i.length; b < S; b++) {
                  var L = i[b];
                  if (L._visible && !L.isEmpty(!0)) {
                    var E = L._getCachedBounds(
                      r && r.appended(L._matrix),
                      a,
                      !0
                    ), A = E.rect;
                    l = Math.min(A.x, l), d = Math.min(A.y, d), u = Math.max(A.x + A.width, u), v = Math.max(A.y + A.height, v), E.nonscaling && (p = !0);
                  }
                }
                return {
                  rect: isFinite(l) ? new P(l, d, u - l, v - d) : new P(),
                  nonscaling: p
                };
              }
            }
          }
        ),
        {
          beans: !0,
          _decompose: function() {
            return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
          },
          getRotation: function() {
            var i = this._decompose();
            return i ? i.rotation : 0;
          },
          setRotation: function(i) {
            var r = this.getRotation();
            if (r != null && i != null) {
              var a = this._decomposed;
              this.rotate(i - r), a && (a.rotation = i, this._decomposed = a);
            }
          },
          getScaling: function() {
            var i = this._decompose(), r = i && i.scaling;
            return new Z(r ? r.x : 1, r ? r.y : 1, this, "setScaling");
          },
          setScaling: function() {
            var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
            if (i && r && !i.equals(r)) {
              var a = this.getRotation(), l = this._decomposed, u = new J(), d = I.isZero;
              if (d(i.x) || d(i.y))
                u.translate(l.translation), a && u.rotate(a), u.scale(r.x, r.y), this._matrix.set(u);
              else {
                var v = this.getPosition(!0);
                u.translate(v), a && u.rotate(a), u.scale(r.x / i.x, r.y / i.y), a && u.rotate(-a), u.translate(v.negate()), this.transform(u);
              }
              l && (l.scaling = r, this._decomposed = l);
            }
          },
          getMatrix: function() {
            return this._matrix;
          },
          setMatrix: function() {
            var i = this._matrix;
            i.set.apply(i, arguments);
          },
          getGlobalMatrix: function(i) {
            var r = this._globalMatrix;
            if (r)
              for (var a = this._parent, l = []; a; ) {
                if (!a._globalMatrix) {
                  r = null;
                  for (var u = 0, d = l.length; u < d; u++)
                    l[u]._globalMatrix = null;
                  break;
                }
                l.push(a), a = a._parent;
              }
            if (!r) {
              r = this._globalMatrix = this._matrix.clone();
              var a = this._parent;
              a && r.prepend(a.getGlobalMatrix(!0));
            }
            return i ? r : r.clone();
          },
          getViewMatrix: function() {
            return this.getGlobalMatrix().prepend(this.getView()._matrix);
          },
          getApplyMatrix: function() {
            return this._applyMatrix;
          },
          setApplyMatrix: function(i) {
            (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
          },
          getTransformContent: "#getApplyMatrix",
          setTransformContent: "#setApplyMatrix"
        },
        {
          getProject: function() {
            return this._project;
          },
          _setProject: function(i, r) {
            if (this._project !== i) {
              this._project && this._installEvents(!1), this._project = i;
              for (var a = this._children, l = 0, u = a && a.length; l < u; l++)
                a[l]._setProject(i);
              r = !0;
            }
            r && this._installEvents(!0);
          },
          getView: function() {
            return this._project._view;
          },
          _installEvents: function i(r) {
            i.base.call(this, r);
            for (var a = this._children, l = 0, u = a && a.length; l < u; l++)
              a[l]._installEvents(r);
          },
          getLayer: function() {
            for (var i = this; i = i._parent; )
              if (i instanceof je)
                return i;
            return null;
          },
          getParent: function() {
            return this._parent;
          },
          setParent: function(i) {
            return i.addChild(this);
          },
          _getOwner: "#getParent",
          getChildren: function() {
            return this._children;
          },
          setChildren: function(i) {
            this.removeChildren(), this.addChildren(i);
          },
          getFirstChild: function() {
            return this._children && this._children[0] || null;
          },
          getLastChild: function() {
            return this._children && this._children[this._children.length - 1] || null;
          },
          getNextSibling: function() {
            var i = this._getOwner();
            return i && i._children[this._index + 1] || null;
          },
          getPreviousSibling: function() {
            var i = this._getOwner();
            return i && i._children[this._index - 1] || null;
          },
          getIndex: function() {
            return this._index;
          },
          setIndex: function(i) {
            var r = this._parent, a = r && r._children;
            a && r.insertChildren(
              i in a ? i : t,
              [this]
            );
          },
          equals: function(i) {
            return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
          },
          _equals: function(i) {
            return o.equals(this._children, i._children);
          },
          clone: function(i) {
            var r = new this.constructor(X.NO_INSERT), a = this._children, l = o.pick(
              i ? i.insert : t,
              i === t || i === !0
            ), u = o.pick(i ? i.deep : t, !0);
            a && r.copyAttributes(this), (!a || u) && r.copyContent(this), a || r.copyAttributes(this), l && r.insertAbove(this);
            var d = this._name, v = this._parent;
            if (d && v) {
              for (var a = v._children, p = d, b = 1; a[d]; )
                d = p + " " + b++;
              d !== p && r.setName(d);
            }
            return r;
          },
          copyContent: function(i) {
            for (var r = i._children, a = 0, l = r && r.length; a < l; a++)
              this.addChild(r[a].clone(!1), !0);
          },
          copyAttributes: function(i, r) {
            this.setStyle(i._style);
            for (var a = [
              "_locked",
              "_visible",
              "_blendMode",
              "_opacity",
              "_clipMask",
              "_guide"
            ], l = 0, u = a.length; l < u; l++) {
              var d = a[l];
              i.hasOwnProperty(d) && (this[d] = i[d]);
            }
            r || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
            var v = i._data, p = i._name;
            this._data = v ? o.clone(v) : null, p && this.setName(p);
          },
          rasterize: function(i, r) {
            var a, l, u;
            o.isPlainObject(i) ? (a = i.resolution, l = i.insert, u = i.raster) : (a = i, l = r), u || (u = new He(X.NO_INSERT));
            var d = this.getStrokeBounds(), v = (a || this.getView().getResolution()) / 72, p = d.getTopLeft().floor(), b = d.getBottomRight().ceil(), S = new V(b.subtract(p)), L = S.multiply(v);
            if (u.setSize(L, !0), !L.isZero()) {
              var E = u.getContext(!0), A = new J().scale(v).translate(p.negate());
              E.save(), A.applyToContext(E), this.draw(E, new o({ matrices: [A] })), E.restore();
            }
            return u._matrix.set(
              new J().translate(p.add(S.divide(2))).scale(1 / v)
            ), (l === t || l) && u.insertAbove(this), u;
          },
          contains: function() {
            var i = this._matrix;
            return i.isInvertible() && !!this._contains(i._inverseTransform(M.read(arguments)));
          },
          _contains: function(i) {
            var r = this._children;
            if (r) {
              for (var a = r.length - 1; a >= 0; a--)
                if (r[a].contains(i))
                  return !0;
              return !1;
            }
            return i.isInside(this.getInternalBounds());
          },
          isInside: function() {
            return P.read(arguments).contains(this.getBounds());
          },
          _asPathItem: function() {
            return new We.Rectangle({
              rectangle: this.getInternalBounds(),
              matrix: this._matrix,
              insert: !1
            });
          },
          intersects: function(i, r) {
            return i instanceof X ? this._asPathItem().getIntersections(
              i._asPathItem(),
              null,
              r,
              !0
            ).length > 0 : !1;
          }
        },
        new function() {
          function i() {
            var l = arguments;
            return this._hitTest(
              M.read(l),
              $e.getOptions(l)
            );
          }
          function r() {
            var l = arguments, u = M.read(l), d = $e.getOptions(l), v = [];
            return this._hitTest(u, new o({ all: v }, d)), v;
          }
          function a(l, u, d, v) {
            var p = this._children;
            if (p)
              for (var b = p.length - 1; b >= 0; b--) {
                var S = p[b], L = S !== v && S._hitTest(
                  l,
                  u,
                  d
                );
                if (L && !u.all)
                  return L;
              }
            return null;
          }
          return fe.inject({
            hitTest: i,
            hitTestAll: r,
            _hitTest: a
          }), {
            hitTest: i,
            hitTestAll: r,
            _hitTestChildren: a
          };
        }(),
        {
          _hitTest: function(i, r, a) {
            if (this._locked || !this._visible || this._guide && !r.guides || this.isEmpty())
              return null;
            var l = this._matrix, u = a ? a.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), d = Math.max(r.tolerance, 1e-12), v = r._tolerancePadding = new V(
              We._getStrokePadding(
                d,
                l._shiftless().invert()
              )
            );
            if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(v.multiply(2))._containsPoint(i))
              return null;
            var p = !(r.guides && !this._guide || r.selected && !this.isSelected() || r.type && r.type !== o.hyphenate(this._class) || r.class && !(this instanceof r.class)), b = r.match, S = this, L, E;
            function A(C) {
              return C && b && !b(C) && (C = null), C && r.all && r.all.push(C), C;
            }
            function T(C, O) {
              var j = O ? L["get" + O]() : S.getPosition();
              if (i.subtract(j).divide(v).length <= 1)
                return new $e(C, S, {
                  name: O ? o.hyphenate(O) : C,
                  point: j
                });
            }
            var G = r.position, D = r.center, Y = r.bounds;
            if (p && this._parent && (G || D || Y)) {
              if ((D || Y) && (L = this.getInternalBounds()), E = G && T("position") || D && T("center", "Center"), !E && Y)
                for (var k = [
                  "TopLeft",
                  "TopRight",
                  "BottomLeft",
                  "BottomRight",
                  "LeftCenter",
                  "TopCenter",
                  "RightCenter",
                  "BottomCenter"
                ], z = 0; z < 8 && !E; z++)
                  E = T("bounds", k[z]);
              E = A(E);
            }
            return E || (E = this._hitTestChildren(i, r, u) || p && A(this._hitTestSelf(
              i,
              r,
              u,
              this.getStrokeScaling() ? null : u._shiftless().invert()
            )) || null), E && E.point && (E.point = l.transform(E.point)), E;
          },
          _hitTestSelf: function(i, r) {
            if (r.fill && this.hasFill() && this._contains(i))
              return new $e("fill", this);
          },
          matches: function(i, r) {
            function a(v, p) {
              for (var b in v)
                if (v.hasOwnProperty(b)) {
                  var S = v[b], L = p[b];
                  if (o.isPlainObject(S) && o.isPlainObject(L)) {
                    if (!a(S, L))
                      return !1;
                  } else if (!o.equals(S, L))
                    return !1;
                }
              return !0;
            }
            var l = typeof i;
            if (l === "object") {
              for (var u in i)
                if (i.hasOwnProperty(u) && !this.matches(u, i[u]))
                  return !1;
              return !0;
            } else {
              if (l === "function")
                return i(this);
              if (i === "match")
                return r(this);
              var d = /^(empty|editable)$/.test(i) ? this["is" + o.capitalize(i)]() : i === "type" ? o.hyphenate(this._class) : this[i];
              if (i === "class") {
                if (typeof r == "function")
                  return this instanceof r;
                d = this._class;
              }
              if (typeof r == "function")
                return !!r(d);
              if (r) {
                if (r.test)
                  return r.test(d);
                if (o.isPlainObject(r))
                  return a(r, d);
              }
              return o.equals(d, r);
            }
          },
          getItems: function(i) {
            return X._getItems(this, i, this._matrix);
          },
          getItem: function(i) {
            return X._getItems(this, i, this._matrix, null, !0)[0] || null;
          },
          statics: {
            _getItems: function i(r, a, l, u, d) {
              if (!u) {
                var v = typeof a == "object" && a, p = v && v.overlapping, b = v && v.inside, S = p || b, A = S && P.read([S]);
                u = {
                  items: [],
                  recursive: v && v.recursive !== !1,
                  inside: !!b,
                  overlapping: !!p,
                  rect: A,
                  path: p && new We.Rectangle({
                    rectangle: A,
                    insert: !1
                  })
                }, v && (a = o.filter({}, a, {
                  recursive: !0,
                  inside: !0,
                  overlapping: !0
                }));
              }
              var L = r._children, E = u.items, A = u.rect;
              l = A && (l || new J());
              for (var T = 0, G = L && L.length; T < G; T++) {
                var D = L[T], Y = l && l.appended(D._matrix), k = !0;
                if (A) {
                  var S = D.getBounds(Y);
                  if (!A.intersects(S))
                    continue;
                  A.contains(S) || u.overlapping && (S.contains(A) || u.path.intersects(D, Y)) || (k = !1);
                }
                if (k && D.matches(a) && (E.push(D), d) || (u.recursive !== !1 && i(D, a, Y, u, d), d && E.length > 0))
                  break;
              }
              return E;
            }
          }
        },
        {
          importJSON: function(i) {
            var r = o.importJSON(i, this);
            return r !== this ? this.addChild(r) : r;
          },
          addChild: function(i) {
            return this.insertChild(t, i);
          },
          insertChild: function(i, r) {
            var a = r ? this.insertChildren(i, [r]) : null;
            return a && a[0];
          },
          addChildren: function(i) {
            return this.insertChildren(this._children.length, i);
          },
          insertChildren: function(i, r) {
            var a = this._children;
            if (a && r && r.length > 0) {
              r = o.slice(r);
              for (var l = {}, u = r.length - 1; u >= 0; u--) {
                var d = r[u], v = d && d._id;
                !d || l[v] ? r.splice(u, 1) : (d._remove(!1, !0), l[v] = !0);
              }
              o.splice(a, r, i, 0);
              for (var p = this._project, b = p._changes, u = 0, S = r.length; u < S; u++) {
                var d = r[u], L = d._name;
                d._parent = this, d._setProject(p, !0), L && d.setName(L), b && d._changed(5);
              }
              this._changed(11);
            } else
              r = null;
            return r;
          },
          _insertItem: "#insertChild",
          _insertAt: function(i, r) {
            var a = i && i._getOwner(), l = i !== this && a ? this : null;
            return l && (l._remove(!1, !0), a._insertItem(i._index + r, l)), l;
          },
          insertAbove: function(i) {
            return this._insertAt(i, 1);
          },
          insertBelow: function(i) {
            return this._insertAt(i, 0);
          },
          sendToBack: function() {
            var i = this._getOwner();
            return i ? i._insertItem(0, this) : null;
          },
          bringToFront: function() {
            var i = this._getOwner();
            return i ? i._insertItem(t, this) : null;
          },
          appendTop: "#addChild",
          appendBottom: function(i) {
            return this.insertChild(0, i);
          },
          moveAbove: "#insertAbove",
          moveBelow: "#insertBelow",
          addTo: function(i) {
            return i._insertItem(t, this);
          },
          copyTo: function(i) {
            return this.clone(!1).addTo(i);
          },
          reduce: function(i) {
            var r = this._children;
            if (r && r.length === 1) {
              var a = r[0].reduce(i);
              return this._parent ? (a.insertAbove(this), this.remove()) : a.remove(), a;
            }
            return this;
          },
          _removeNamed: function() {
            var i = this._getOwner();
            if (i) {
              var r = i._children, a = i._namedChildren, l = this._name, u = a[l], d = u ? u.indexOf(this) : -1;
              d !== -1 && (r[l] == this && delete r[l], u.splice(d, 1), u.length ? r[l] = u[0] : delete a[l]);
            }
          },
          _remove: function(i, r) {
            var a = this._getOwner(), l = this._project, u = this._index;
            return this._style && this._style._dispose(), a ? (this._name && this._removeNamed(), u != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), o.splice(a._children, null, u, 1)), this._installEvents(!1), i && l._changes && this._changed(5), r && a._changed(11, this), this._parent = null, !0) : !1;
          },
          remove: function() {
            return this._remove(!0, !0);
          },
          replaceWith: function(i) {
            var r = i && i.insertBelow(this);
            return r && this.remove(), r;
          },
          removeChildren: function(i, r) {
            if (!this._children)
              return null;
            i = i || 0, r = o.pick(r, this._children.length);
            for (var a = o.splice(this._children, null, i, r - i), l = a.length - 1; l >= 0; l--)
              a[l]._remove(!0, !1);
            return a.length > 0 && this._changed(11), a;
          },
          clear: "#removeChildren",
          reverseChildren: function() {
            if (this._children) {
              this._children.reverse();
              for (var i = 0, r = this._children.length; i < r; i++)
                this._children[i]._index = i;
              this._changed(11);
            }
          },
          isEmpty: function(i) {
            var r = this._children, a = r ? r.length : 0;
            if (i) {
              for (var l = 0; l < a; l++)
                if (!r[l].isEmpty(i))
                  return !1;
              return !0;
            }
            return !a;
          },
          isEditable: function() {
            for (var i = this; i; ) {
              if (!i._visible || i._locked)
                return !1;
              i = i._parent;
            }
            return !0;
          },
          hasFill: function() {
            return this.getStyle().hasFill();
          },
          hasStroke: function() {
            return this.getStyle().hasStroke();
          },
          hasShadow: function() {
            return this.getStyle().hasShadow();
          },
          _getOrder: function(i) {
            function r(v) {
              var p = [];
              do
                p.unshift(v);
              while (v = v._parent);
              return p;
            }
            for (var a = r(this), l = r(i), u = 0, d = Math.min(a.length, l.length); u < d; u++)
              if (a[u] != l[u])
                return a[u]._index < l[u]._index ? 1 : -1;
            return 0;
          },
          hasChildren: function() {
            return this._children && this._children.length > 0;
          },
          isInserted: function() {
            return this._parent ? this._parent.isInserted() : !1;
          },
          isAbove: function(i) {
            return this._getOrder(i) === -1;
          },
          isBelow: function(i) {
            return this._getOrder(i) === 1;
          },
          isParent: function(i) {
            return this._parent === i;
          },
          isChild: function(i) {
            return i && i._parent === this;
          },
          isDescendant: function(i) {
            for (var r = this; r = r._parent; )
              if (r === i)
                return !0;
            return !1;
          },
          isAncestor: function(i) {
            return i ? i.isDescendant(this) : !1;
          },
          isSibling: function(i) {
            return this._parent === i._parent;
          },
          isGroupedWith: function(i) {
            for (var r = this._parent; r; ) {
              if (r._parent && /^(Group|Layer|CompoundPath)$/.test(r._class) && i.isDescendant(r))
                return !0;
              r = r._parent;
            }
            return !1;
          }
        },
        o.each(["rotate", "scale", "shear", "skew"], function(i) {
          var r = i === "rotate";
          this[i] = function() {
            var a = arguments, l = (r ? o : M).read(a), u = M.read(a, 0, { readNull: !0 });
            return this.transform(new J()[i](
              l,
              u || this.getPosition(!0)
            ));
          };
        }, {
          translate: function() {
            var i = new J();
            return this.transform(i.translate.apply(i, arguments));
          },
          transform: function(i, r, a) {
            var l = this._matrix, u = i && !i.isIdentity(), d = a && this._canApplyMatrix || this._applyMatrix && (u || !l.isIdentity() || r && this._children);
            if (!u && !d)
              return this;
            if (u) {
              !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
              var v = this._style, p = v.getFillColor(!0), b = v.getStrokeColor(!0);
              p && p.transform(i), b && b.transform(i);
            }
            if (d && (d = this._transformContent(
              l,
              r,
              a
            ))) {
              var S = this._pivot;
              S && l._transformPoint(S, S, !0), l.reset(!0), a && this._canApplyMatrix && (this._applyMatrix = !0);
            }
            var L = this._bounds, E = this._position;
            (u || d) && this._changed(25);
            var A = u && L && i.decompose();
            if (A && A.skewing.isZero() && A.rotation % 90 === 0) {
              for (var T in L) {
                var G = L[T];
                if (G.nonscaling)
                  delete L[T];
                else if (d || !G.internal) {
                  var D = G.rect;
                  i._transformBounds(D, D);
                }
              }
              this._bounds = L;
              var Y = L[this._getBoundsCacheKey(
                this._boundsOptions || {}
              )];
              Y && (this._position = this._getPositionFromBounds(Y.rect));
            } else
              u && E && this._pivot && (this._position = i._transformPoint(E, E));
            return this;
          },
          _transformContent: function(i, r, a) {
            var l = this._children;
            if (l) {
              for (var u = 0, d = l.length; u < d; u++)
                l[u].transform(i, r, a);
              return !0;
            }
          },
          globalToLocal: function() {
            return this.getGlobalMatrix(!0)._inverseTransform(
              M.read(arguments)
            );
          },
          localToGlobal: function() {
            return this.getGlobalMatrix(!0)._transformPoint(
              M.read(arguments)
            );
          },
          parentToLocal: function() {
            return this._matrix._inverseTransform(M.read(arguments));
          },
          localToParent: function() {
            return this._matrix._transformPoint(M.read(arguments));
          },
          fitBounds: function(i, r) {
            i = P.read(arguments);
            var a = this.getBounds(), l = a.height / a.width, u = i.height / i.width, d = (r ? l > u : l < u) ? i.width / a.width : i.height / a.height, v = new P(
              new M(),
              new V(a.width * d, a.height * d)
            );
            v.setCenter(i.getCenter()), this.setBounds(v);
          }
        }),
        {
          _setStyles: function(i, r, a) {
            var l = this._style, u = this._matrix;
            if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, u)), l.hasStroke()) {
              i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, u), i.lineWidth = l.getStrokeWidth();
              var d = l.getStrokeJoin(), v = l.getStrokeCap(), p = l.getMiterLimit();
              if (d && (i.lineJoin = d), v && (i.lineCap = v), p && (i.miterLimit = p), Ye.support.nativeDash) {
                var b = l.getDashArray(), S = l.getDashOffset();
                b && b.length && ("setLineDash" in i ? (i.setLineDash(b), i.lineDashOffset = S) : (i.mozDash = b, i.mozDashOffset = S));
              }
            }
            if (l.hasShadow()) {
              var L = r.pixelRatio || 1, E = a._shiftless().prepend(
                new J().scale(L, L)
              ), A = E.transform(new M(l.getShadowBlur(), 0)), T = E.transform(this.getShadowOffset());
              i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = A.getLength(), i.shadowOffsetX = T.x, i.shadowOffsetY = T.y;
            }
          },
          draw: function(i, r, a) {
            if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
              var l = r.matrices, u = r.viewMatrix, d = this._matrix, v = l[l.length - 1].appended(d);
              if (v.isInvertible()) {
                u = u ? u.appended(v) : v, l.push(v), r.updateMatrix && (this._globalMatrix = v);
                var p = this._blendMode, b = I.clamp(this._opacity, 0, 1), S = p === "normal", L = Qe.nativeModes[p], E = S && b === 1 || r.dontStart || r.clip || (L || S && b < 1) && this._canComposite(), A = r.pixelRatio || 1, T, G, D;
                if (!E) {
                  var Y = this.getStrokeBounds(u);
                  if (!Y.width || !Y.height) {
                    l.pop();
                    return;
                  }
                  D = r.offset, G = r.offset = Y.getTopLeft().floor(), T = i, i = vt.getContext(Y.getSize().ceil().add(1).multiply(A)), A !== 1 && i.scale(A, A);
                }
                i.save();
                var k = a ? a.appended(d) : this._canScaleStroke && !this.getStrokeScaling(!0) && u, z = !E && r.clipItem, C = !k || z;
                if (E ? (i.globalAlpha = b, L && (i.globalCompositeOperation = p)) : C && i.translate(-G.x, -G.y), C && (E ? d : u).applyToContext(i), z && r.clipItem.draw(i, r.extend({ clip: !0 })), k) {
                  i.setTransform(A, 0, 0, A, 0, 0);
                  var O = r.offset;
                  O && i.translate(-O.x, -O.y);
                }
                this._draw(i, r, u, k), i.restore(), l.pop(), r.clip && !r.dontFinish && i.clip(this.getFillRule()), E || (Qe.process(
                  p,
                  i,
                  T,
                  b,
                  G.subtract(D).multiply(A)
                ), vt.release(i), r.offset = D);
              }
            }
          },
          _isUpdated: function(i) {
            var r = this._parent;
            if (r instanceof Et)
              return r._isUpdated(i);
            var a = this._updateVersion === i;
            return !a && r && r._visible && r._isUpdated(i) && (this._updateVersion = i, a = !0), a;
          },
          _drawSelection: function(i, r, a, l, u) {
            var d = this._selection, v = d & 1, p = d & 2 || v && this._selectBounds, b = d & 4;
            if (this._drawSelected || (v = !1), (v || p || b) && this._isUpdated(u)) {
              var S, L = this.getSelectedColor(!0) || (S = this.getLayer()) && S.getSelectedColor(!0), E = r.appended(this.getGlobalMatrix(!0)), A = a / 2;
              if (i.strokeStyle = i.fillStyle = L ? L.toCanvasStyle(i) : "#009dec", v && this._drawSelected(i, E, l), b) {
                var T = this.getPosition(!0), G = this._parent, D = G ? G.localToGlobal(T) : T, Y = D.x, k = D.y;
                i.beginPath(), i.arc(Y, k, A, 0, Math.PI * 2, !0), i.stroke();
                for (var z = [[0, -1], [1, 0], [0, 1], [-1, 0]], C = A, O = a + 1, j = 0; j < 4; j++) {
                  var q = z[j], H = q[0], ie = q[1];
                  i.moveTo(Y + H * C, k + ie * C), i.lineTo(Y + H * O, k + ie * O), i.stroke();
                }
              }
              if (p) {
                var ae = E._transformCorners(this.getInternalBounds());
                i.beginPath();
                for (var j = 0; j < 8; j++)
                  i[j ? "lineTo" : "moveTo"](ae[j], ae[++j]);
                i.closePath(), i.stroke();
                for (var j = 0; j < 8; j++)
                  i.fillRect(
                    ae[j] - A,
                    ae[++j] - A,
                    a,
                    a
                  );
              }
            }
          },
          _canComposite: function() {
            return !1;
          }
        },
        o.each(["down", "drag", "up", "move"], function(i) {
          this["removeOn" + o.capitalize(i)] = function() {
            var r = {};
            return r[i] = !0, this.removeOn(r);
          };
        }, {
          removeOn: function(i) {
            for (var r in i)
              if (i[r]) {
                var a = "mouse" + r, l = this._project, u = l._removeSets = l._removeSets || {};
                u[a] = u[a] || {}, u[a][this._id] = this;
              }
            return this;
          }
        }),
        {
          tween: function(i, r, a) {
            a || (a = r, r = i, i = null, a || (a = r, r = null));
            var l = a && a.easing, u = a && a.start, d = a != null && (typeof a == "number" ? a : a.duration), v = new Je(this, i, r, d, l, u);
            function p(b) {
              v._handleFrame(b.time * 1e3), v.running || this.off("frame", p);
            }
            return d && this.on("frame", p), v;
          },
          tweenTo: function(i, r) {
            return this.tween(null, i, r);
          },
          tweenFrom: function(i, r) {
            return this.tween(i, null, r);
          }
        }
      ), W = X.extend({
        _class: "Group",
        _selectBounds: !1,
        _selectChildren: !0,
        _serializeFields: {
          children: []
        },
        initialize: function(i) {
          this._children = [], this._namedChildren = {}, this._initialize(i) || this.addChildren(Array.isArray(i) ? i : arguments);
        },
        _changed: function i(r) {
          i.base.call(this, r), r & 2050 && (this._clipItem = t);
        },
        _getClipItem: function() {
          var i = this._clipItem;
          if (i === t) {
            i = null;
            for (var r = this._children, a = 0, l = r.length; a < l; a++)
              if (r[a]._clipMask) {
                i = r[a];
                break;
              }
            this._clipItem = i;
          }
          return i;
        },
        isClipped: function() {
          return !!this._getClipItem();
        },
        setClipped: function(i) {
          var r = this.getFirstChild();
          r && r.setClipMask(i);
        },
        _getBounds: function i(r, a) {
          var l = this._getClipItem();
          return l ? l._getCachedBounds(
            l._matrix.prepended(r),
            o.set({}, a, { stroke: !1 })
          ) : i.base.call(this, r, a);
        },
        _hitTestChildren: function i(r, a, l) {
          var u = this._getClipItem();
          return (!u || u.contains(r)) && i.base.call(
            this,
            r,
            a,
            l,
            u
          );
        },
        _draw: function(i, r) {
          var a = r.clip, l = !a && this._getClipItem();
          r = r.extend({ clipItem: l, clip: !1 }), a ? (i.beginPath(), r.dontStart = r.dontFinish = !0) : l && l.draw(i, r.extend({ clip: !0 }));
          for (var u = this._children, d = 0, v = u.length; d < v; d++) {
            var p = u[d];
            p !== l && p.draw(i, r);
          }
        }
      }), je = W.extend({
        _class: "Layer",
        initialize: function() {
          W.apply(this, arguments);
        },
        _getOwner: function() {
          return this._parent || this._index != null && this._project;
        },
        isInserted: function i() {
          return this._parent ? i.base.call(this) : this._index != null;
        },
        activate: function() {
          this._project._activeLayer = this;
        },
        _hitTestSelf: function() {
        }
      }), Ee = X.extend(
        {
          _class: "Shape",
          _applyMatrix: !1,
          _canApplyMatrix: !1,
          _canScaleStroke: !0,
          _serializeFields: {
            type: null,
            size: null,
            radius: null
          },
          initialize: function(i, r) {
            this._initialize(i, r);
          },
          _equals: function(i) {
            return this._type === i._type && this._size.equals(i._size) && o.equals(this._radius, i._radius);
          },
          copyContent: function(i) {
            this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
          },
          getType: function() {
            return this._type;
          },
          setType: function(i) {
            this._type = i;
          },
          getShape: "#getType",
          setShape: "#setType",
          getSize: function() {
            var i = this._size;
            return new te(i.width, i.height, this, "setSize");
          },
          setSize: function() {
            var i = V.read(arguments);
            if (!this._size)
              this._size = i.clone();
            else if (!this._size.equals(i)) {
              var r = this._type, a = i.width, l = i.height;
              r === "rectangle" ? this._radius.set(V.min(this._radius, i.divide(2).abs())) : r === "circle" ? (a = l = (a + l) / 2, this._radius = a / 2) : r === "ellipse" && this._radius._set(a / 2, l / 2), this._size._set(a, l), this._changed(9);
            }
          },
          getRadius: function() {
            var i = this._radius;
            return this._type === "circle" ? i : new te(i.width, i.height, this, "setRadius");
          },
          setRadius: function(i) {
            var r = this._type;
            if (r === "circle") {
              if (i === this._radius)
                return;
              var a = i * 2;
              this._radius = i, this._size._set(a, a);
            } else if (i = V.read(arguments), !this._radius)
              this._radius = i.clone();
            else {
              if (this._radius.equals(i))
                return;
              if (this._radius.set(i), r === "rectangle") {
                var a = V.max(this._size, i.multiply(2));
                this._size.set(a);
              } else
                r === "ellipse" && this._size._set(i.width * 2, i.height * 2);
            }
            this._changed(9);
          },
          isEmpty: function() {
            return !1;
          },
          toPath: function(i) {
            var r = new We[o.capitalize(this._type)]({
              center: new M(),
              size: this._size,
              radius: this._radius,
              insert: !1
            });
            return r.copyAttributes(this), Ye.settings.applyMatrix && r.setApplyMatrix(!0), (i === t || i) && r.insertAbove(this), r;
          },
          toShape: "#clone",
          _asPathItem: function() {
            return this.toPath(!1);
          },
          _draw: function(i, r, a, l) {
            var u = this._style, d = u.hasFill(), v = u.hasStroke(), p = r.dontFinish || r.clip, b = !l;
            if (d || v || p) {
              var S = this._type, L = this._radius, E = S === "circle";
              if (r.dontStart || i.beginPath(), b && E)
                i.arc(0, 0, L, 0, Math.PI * 2, !0);
              else {
                var A = E ? L : L.width, T = E ? L : L.height, G = this._size, D = G.width, Y = G.height;
                if (b && S === "rectangle" && A === 0 && T === 0)
                  i.rect(-D / 2, -Y / 2, D, Y);
                else {
                  var k = D / 2, z = Y / 2, C = 1 - 0.5522847498307936, O = A * C, j = T * C, q = [
                    -k,
                    -z + T,
                    -k,
                    -z + j,
                    -k + O,
                    -z,
                    -k + A,
                    -z,
                    k - A,
                    -z,
                    k - O,
                    -z,
                    k,
                    -z + j,
                    k,
                    -z + T,
                    k,
                    z - T,
                    k,
                    z - j,
                    k - O,
                    z,
                    k - A,
                    z,
                    -k + A,
                    z,
                    -k + O,
                    z,
                    -k,
                    z - j,
                    -k,
                    z - T
                  ];
                  l && l.transform(q, q, 32), i.moveTo(q[0], q[1]), i.bezierCurveTo(q[2], q[3], q[4], q[5], q[6], q[7]), k !== A && i.lineTo(q[8], q[9]), i.bezierCurveTo(q[10], q[11], q[12], q[13], q[14], q[15]), z !== T && i.lineTo(q[16], q[17]), i.bezierCurveTo(q[18], q[19], q[20], q[21], q[22], q[23]), k !== A && i.lineTo(q[24], q[25]), i.bezierCurveTo(q[26], q[27], q[28], q[29], q[30], q[31]);
                }
              }
              i.closePath();
            }
            !p && (d || v) && (this._setStyles(i, r, a), d && (i.fill(u.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), v && i.stroke());
          },
          _canComposite: function() {
            return !(this.hasFill() && this.hasStroke());
          },
          _getBounds: function(i, r) {
            var a = new P(this._size).setCenter(0, 0), l = this._style, u = r.stroke && l.hasStroke() && l.getStrokeWidth();
            return i && (a = i._transformBounds(a)), u ? a.expand(We._getStrokePadding(
              u,
              this._getStrokeMatrix(i, r)
            )) : a;
          }
        },
        new function() {
          function i(a, l, u) {
            var d = a._radius;
            if (!d.isZero())
              for (var v = a._size.divide(2), p = 1; p <= 4; p++) {
                var b = new M(p > 1 && p < 4 ? -1 : 1, p > 2 ? -1 : 1), S = b.multiply(v), L = S.subtract(b.multiply(d)), E = new P(
                  u ? S.add(b.multiply(u)) : S,
                  L
                );
                if (E.contains(l))
                  return { point: L, quadrant: p };
              }
          }
          function r(a, l, u, d) {
            var v = a.divide(l);
            return (!d || v.isInQuadrant(d)) && v.subtract(v.normalize()).multiply(l).divide(u).length <= 1;
          }
          return {
            _contains: function a(l) {
              if (this._type === "rectangle") {
                var u = i(this, l);
                return u ? l.subtract(u.point).divide(this._radius).getLength() <= 1 : a.base.call(this, l);
              } else
                return l.divide(this.size).getLength() <= 0.5;
            },
            _hitTestSelf: function a(l, u, d, v) {
              var p = !1, b = this._style, S = u.stroke && b.hasStroke(), L = u.fill && b.hasFill();
              if (S || L) {
                var E = this._type, A = this._radius, T = S ? b.getStrokeWidth() / 2 : 0, G = u._tolerancePadding.add(
                  We._getStrokePadding(
                    T,
                    !b.getStrokeScaling() && v
                  )
                );
                if (E === "rectangle") {
                  var D = G.multiply(2), Y = i(this, l, D);
                  if (Y)
                    p = r(
                      l.subtract(Y.point),
                      A,
                      G,
                      Y.quadrant
                    );
                  else {
                    var k = new P(this._size).setCenter(0, 0), z = k.expand(D), C = k.expand(D.negate());
                    p = z._containsPoint(l) && !C._containsPoint(l);
                  }
                } else
                  p = r(l, A, G);
              }
              return p ? new $e(S ? "stroke" : "fill", this) : a.base.apply(this, arguments);
            }
          };
        }(),
        {
          statics: new function() {
            function i(r, a, l, u, d) {
              var v = o.create(Ee.prototype);
              return v._type = r, v._size = l, v._radius = u, v._initialize(o.getNamed(d), a), v;
            }
            return {
              Circle: function() {
                var r = arguments, a = M.readNamed(r, "center"), l = o.readNamed(r, "radius");
                return i(
                  "circle",
                  a,
                  new V(l * 2),
                  l,
                  r
                );
              },
              Rectangle: function() {
                var r = arguments, a = P.readNamed(r, "rectangle"), l = V.min(
                  V.readNamed(r, "radius"),
                  a.getSize(!0).divide(2)
                );
                return i(
                  "rectangle",
                  a.getCenter(!0),
                  a.getSize(!0),
                  l,
                  r
                );
              },
              Ellipse: function() {
                var r = arguments, a = Ee._readEllipse(r), l = a.radius;
                return i(
                  "ellipse",
                  a.center,
                  l.multiply(2),
                  l,
                  r
                );
              },
              _readEllipse: function(r) {
                var a, l;
                if (o.hasNamed(r, "radius"))
                  a = M.readNamed(r, "center"), l = V.readNamed(r, "radius");
                else {
                  var u = P.readNamed(r, "rectangle");
                  a = u.getCenter(!0), l = u.getSize(!0).divide(2);
                }
                return { center: a, radius: l };
              }
            };
          }()
        }
      ), He = X.extend({
        _class: "Raster",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _boundsOptions: { stroke: !1, handle: !1 },
        _serializeFields: {
          crossOrigin: null,
          source: null
        },
        _prioritize: ["crossOrigin"],
        _smoothing: "low",
        beans: !0,
        initialize: function(i, r) {
          if (!this._initialize(
            i,
            r !== t && M.read(arguments)
          )) {
            var a, l = typeof i, u = l === "string" ? s.getElementById(i) : l === "object" ? i : null;
            if (u && u !== X.NO_INSERT) {
              if (u.getContext || u.naturalHeight != null)
                a = u;
              else if (u) {
                var d = V.read(arguments);
                d.isZero() || (a = vt.getCanvas(d));
              }
            }
            a ? this.setImage(a) : this.setSource(i);
          }
          this._size || (this._size = new V(), this._loaded = !1);
        },
        _equals: function(i) {
          return this.getSource() === i.getSource();
        },
        copyContent: function(i) {
          var r = i._image, a = i._canvas;
          if (r)
            this._setImage(r);
          else if (a) {
            var l = vt.getCanvas(i._size);
            l.getContext("2d").drawImage(a, 0, 0), this._setImage(l);
          }
          this._crossOrigin = i._crossOrigin;
        },
        getSize: function() {
          var i = this._size;
          return new te(
            i ? i.width : 0,
            i ? i.height : 0,
            this,
            "setSize"
          );
        },
        setSize: function(i, r) {
          var a = V.read(arguments);
          if (a.equals(this._size))
            r && this.clear();
          else if (a.width > 0 && a.height > 0) {
            var l = !r && this.getElement();
            this._setImage(vt.getCanvas(a)), l && this.getContext(!0).drawImage(
              l,
              0,
              0,
              a.width,
              a.height
            );
          } else
            this._canvas && vt.release(this._canvas), this._size = a.clone();
        },
        getWidth: function() {
          return this._size ? this._size.width : 0;
        },
        setWidth: function(i) {
          this.setSize(i, this.getHeight());
        },
        getHeight: function() {
          return this._size ? this._size.height : 0;
        },
        setHeight: function(i) {
          this.setSize(this.getWidth(), i);
        },
        getLoaded: function() {
          return this._loaded;
        },
        isEmpty: function() {
          var i = this._size;
          return !i || i.width === 0 && i.height === 0;
        },
        getResolution: function() {
          var i = this._matrix, r = new M(0, 0).transform(i), a = new M(1, 0).transform(i).subtract(r), l = new M(0, 1).transform(i).subtract(r);
          return new V(
            72 / a.getLength(),
            72 / l.getLength()
          );
        },
        getPpi: "#getResolution",
        getImage: function() {
          return this._image;
        },
        setImage: function(i) {
          var r = this;
          function a(l) {
            var u = r.getView(), d = l && l.type || "load";
            u && r.responds(d) && (Ye = u._scope, r.emit(d, new Di(l)));
          }
          this._setImage(i), this._loaded ? setTimeout(a, 0) : i && Xt.add(i, {
            load: function(l) {
              r._setImage(i), a(l);
            },
            error: a
          });
        },
        _setImage: function(i) {
          this._canvas && vt.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new V(
            i ? i.naturalWidth || i.width : 0,
            i ? i.naturalHeight || i.height : 0
          ), this._context = null, this._changed(1033);
        },
        getCanvas: function() {
          if (!this._canvas) {
            var i = vt.getContext(this._size);
            try {
              this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
            } catch {
              vt.release(i);
            }
          }
          return this._canvas;
        },
        setCanvas: "#setImage",
        getContext: function(i) {
          return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
        },
        setContext: function(i) {
          this._context = i;
        },
        getSource: function() {
          var i = this._image;
          return i && i.src || this.toDataURL();
        },
        setSource: function(i) {
          var r = new e.Image(), a = this._crossOrigin;
          a && (r.crossOrigin = a), i && (r.src = i), this.setImage(r);
        },
        getCrossOrigin: function() {
          var i = this._image;
          return i && i.crossOrigin || this._crossOrigin || "";
        },
        setCrossOrigin: function(i) {
          this._crossOrigin = i;
          var r = this._image;
          r && (r.crossOrigin = i);
        },
        getSmoothing: function() {
          return this._smoothing;
        },
        setSmoothing: function(i) {
          this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
        },
        getElement: function() {
          return this._canvas || this._loaded && this._image;
        }
      }, {
        beans: !1,
        getSubCanvas: function() {
          var i = P.read(arguments), r = vt.getContext(i.getSize());
          return r.drawImage(
            this.getCanvas(),
            i.x,
            i.y,
            i.width,
            i.height,
            0,
            0,
            i.width,
            i.height
          ), r.canvas;
        },
        getSubRaster: function() {
          var i = P.read(arguments), r = new He(X.NO_INSERT);
          return r._setImage(this.getSubCanvas(i)), r.translate(i.getCenter().subtract(this.getSize().divide(2))), r._matrix.prepend(this._matrix), r.insertAbove(this), r;
        },
        toDataURL: function() {
          var i = this._image, r = i && i.src;
          if (/^data:/.test(r))
            return r;
          var a = this.getCanvas();
          return a ? a.toDataURL.apply(a, arguments) : null;
        },
        drawImage: function(i) {
          var r = M.read(arguments, 1);
          this.getContext(!0).drawImage(i, r.x, r.y);
        },
        getAverageColor: function(i) {
          var r, a;
          if (i ? i instanceof qt ? (a = i, r = i.getBounds()) : typeof i == "object" && ("width" in i ? r = new P(i) : "x" in i && (r = new P(i.x - 0.5, i.y - 0.5, 1, 1))) : r = this.getBounds(), !r)
            return null;
          var l = 32, u = Math.min(r.width, l), d = Math.min(r.height, l), v = He._sampleContext;
          v ? v.clearRect(0, 0, l + 1, l + 1) : v = He._sampleContext = vt.getContext(
            new V(l)
          ), v.save();
          var p = new J().scale(u / r.width, d / r.height).translate(-r.x, -r.y);
          p.applyToContext(v), a && a.draw(v, new o({ clip: !0, matrices: [p] })), this._matrix.applyToContext(v);
          var b = this.getElement(), S = this._size;
          b && v.drawImage(b, -S.width / 2, -S.height / 2), v.restore();
          for (var L = v.getImageData(
            0.5,
            0.5,
            Math.ceil(u),
            Math.ceil(d)
          ).data, E = [0, 0, 0], A = 0, T = 0, G = L.length; T < G; T += 4) {
            var D = L[T + 3];
            A += D, D /= 255, E[0] += L[T] * D, E[1] += L[T + 1] * D, E[2] += L[T + 2] * D;
          }
          for (var T = 0; T < 3; T++)
            E[T] /= A;
          return A ? Lt.read(E) : null;
        },
        getPixel: function() {
          var i = M.read(arguments), r = this.getContext().getImageData(i.x, i.y, 1, 1).data;
          return new Lt(
            "rgb",
            [r[0] / 255, r[1] / 255, r[2] / 255],
            r[3] / 255
          );
        },
        setPixel: function() {
          var i = arguments, r = M.read(i), a = Lt.read(i), l = a._convert("rgb"), u = a._alpha, d = this.getContext(!0), v = d.createImageData(1, 1), p = v.data;
          p[0] = l[0] * 255, p[1] = l[1] * 255, p[2] = l[2] * 255, p[3] = u != null ? u * 255 : 255, d.putImageData(v, r.x, r.y);
        },
        clear: function() {
          var i = this._size;
          this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
        },
        createImageData: function() {
          var i = V.read(arguments);
          return this.getContext().createImageData(i.width, i.height);
        },
        getImageData: function() {
          var i = P.read(arguments);
          return i.isEmpty() && (i = new P(this._size)), this.getContext().getImageData(
            i.x,
            i.y,
            i.width,
            i.height
          );
        },
        putImageData: function(i) {
          var r = M.read(arguments, 1);
          this.getContext(!0).putImageData(i, r.x, r.y);
        },
        setImageData: function(i) {
          this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
        },
        _getBounds: function(i, r) {
          var a = new P(this._size).setCenter(0, 0);
          return i ? i._transformBounds(a) : a;
        },
        _hitTestSelf: function(i) {
          if (this._contains(i)) {
            var r = this;
            return new $e("pixel", r, {
              offset: i.add(r._size.divide(2)).round(),
              color: {
                get: function() {
                  return r.getPixel(this.offset);
                }
              }
            });
          }
        },
        _draw: function(i, r, a) {
          var l = this.getElement();
          if (l && l.width > 0 && l.height > 0) {
            i.globalAlpha = I.clamp(this._opacity, 0, 1), this._setStyles(i, r, a);
            var u = this._smoothing, d = u === "off";
            Gt.setPrefixed(
              i,
              d ? "imageSmoothingEnabled" : "imageSmoothingQuality",
              d ? !1 : u
            ), i.drawImage(
              l,
              -this._size.width / 2,
              -this._size.height / 2
            );
          }
        },
        _canComposite: function() {
          return !0;
        }
      }), ft = X.extend({
        _class: "SymbolItem",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _boundsOptions: { stroke: !0 },
        _serializeFields: {
          symbol: null
        },
        initialize: function(i, r) {
          this._initialize(
            i,
            r !== t && M.read(arguments, 1)
          ) || this.setDefinition(i instanceof Le ? i : new Le(i));
        },
        _equals: function(i) {
          return this._definition === i._definition;
        },
        copyContent: function(i) {
          this.setDefinition(i._definition);
        },
        getDefinition: function() {
          return this._definition;
        },
        setDefinition: function(i) {
          this._definition = i, this._changed(9);
        },
        getSymbol: "#getDefinition",
        setSymbol: "#setDefinition",
        isEmpty: function() {
          return this._definition._item.isEmpty();
        },
        _getBounds: function(i, r) {
          var a = this._definition._item;
          return a._getCachedBounds(a._matrix.prepended(i), r);
        },
        _hitTestSelf: function(i, r, a) {
          var l = r.extend({ all: !1 }), u = this._definition._item._hitTest(i, l, a);
          return u && (u.item = this), u;
        },
        _draw: function(i, r) {
          this._definition._item.draw(i, r);
        }
      }), Le = o.extend({
        _class: "SymbolDefinition",
        initialize: function(i, r) {
          this._id = F.get(), this.project = Ye.project, i && this.setItem(i, r);
        },
        _serialize: function(i, r) {
          return r.add(this, function() {
            return o.serialize(
              [this._class, this._item],
              i,
              !1,
              r
            );
          });
        },
        _changed: function(i) {
          i & 8 && X._clearBoundsCache(this), i & 1 && this.project._changed(i);
        },
        getItem: function() {
          return this._item;
        },
        setItem: function(i, r) {
          i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), r || i.setPosition(new M()), i._symbol = this, this._changed(9);
        },
        getDefinition: "#getItem",
        setDefinition: "#setItem",
        place: function(i) {
          return new ft(this, i);
        },
        clone: function() {
          return new Le(this._item.clone(!1));
        },
        equals: function(i) {
          return i === this || i && this._item.equals(i._item) || !1;
        }
      }), $e = o.extend({
        _class: "HitResult",
        initialize: function(i, r, a) {
          this.type = i, this.item = r, a && this.inject(a);
        },
        statics: {
          getOptions: function(i) {
            var r = i && o.read(i);
            return new o({
              type: null,
              tolerance: Ye.settings.hitTolerance,
              fill: !r,
              stroke: !r,
              segments: !r,
              handles: !1,
              ends: !1,
              position: !1,
              center: !1,
              bounds: !1,
              guides: !1,
              selected: !1
            }, r);
          }
        }
      }), ce = o.extend({
        _class: "Segment",
        beans: !0,
        _selection: 0,
        initialize: function(i, r, a, l, u, d) {
          var v = arguments.length, p, b, S, L;
          v > 0 && (i == null || typeof i == "object" ? v === 1 && i && "point" in i ? (p = i.point, b = i.handleIn, S = i.handleOut, L = i.selection) : (p = i, b = r, S = a, L = l) : (p = [i, r], b = a !== t ? [a, l] : null, S = u !== t ? [u, d] : null)), new ut(p, this, "_point"), new ut(b, this, "_handleIn"), new ut(S, this, "_handleOut"), L && this.setSelection(L);
        },
        _serialize: function(i, r) {
          var a = this._point, l = this._selection, u = l || this.hasHandles() ? [a, this._handleIn, this._handleOut] : a;
          return l && u.push(l), o.serialize(u, i, !0, r);
        },
        _changed: function(i) {
          var r = this._path;
          if (r) {
            var a = r._curves, l = this._index, u;
            a && ((!i || i === this._point || i === this._handleIn) && (u = l > 0 ? a[l - 1] : r._closed ? a[a.length - 1] : null) && u._changed(), (!i || i === this._point || i === this._handleOut) && (u = a[l]) && u._changed()), r._changed(41);
          }
        },
        getPoint: function() {
          return this._point;
        },
        setPoint: function() {
          this._point.set(M.read(arguments));
        },
        getHandleIn: function() {
          return this._handleIn;
        },
        setHandleIn: function() {
          this._handleIn.set(M.read(arguments));
        },
        getHandleOut: function() {
          return this._handleOut;
        },
        setHandleOut: function() {
          this._handleOut.set(M.read(arguments));
        },
        hasHandles: function() {
          return !this._handleIn.isZero() || !this._handleOut.isZero();
        },
        isSmooth: function() {
          var i = this._handleIn, r = this._handleOut;
          return !i.isZero() && !r.isZero() && i.isCollinear(r);
        },
        clearHandles: function() {
          this._handleIn._set(0, 0), this._handleOut._set(0, 0);
        },
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          var r = this._selection, a = this._path;
          this._selection = i = i || 0, a && i !== r && (a._updateSelection(this, r, i), a._changed(257));
        },
        _changeSelection: function(i, r) {
          var a = this._selection;
          this.setSelection(r ? a | i : a & ~i);
        },
        isSelected: function() {
          return !!(this._selection & 7);
        },
        setSelected: function(i) {
          this._changeSelection(7, i);
        },
        getIndex: function() {
          return this._index !== t ? this._index : null;
        },
        getPath: function() {
          return this._path || null;
        },
        getCurve: function() {
          var i = this._path, r = this._index;
          return i ? (r > 0 && !i._closed && r === i._segments.length - 1 && r--, i.getCurves()[r] || null) : null;
        },
        getLocation: function() {
          var i = this.getCurve();
          return i ? new pt(i, this === i._segment1 ? 0 : 1) : null;
        },
        getNext: function() {
          var i = this._path && this._path._segments;
          return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
        },
        smooth: function(i, r, a) {
          var l = i || {}, u = l.type, d = l.factor, v = this.getPrevious(), p = this.getNext(), b = (v || this)._point, S = this._point, L = (p || this)._point, E = b.getDistance(S), A = S.getDistance(L);
          if (!u || u === "catmull-rom") {
            var T = d === t ? 0.5 : d, G = Math.pow(E, T), D = G * G, Y = Math.pow(A, T), k = Y * Y;
            if (!r && v) {
              var z = 2 * k + 3 * Y * G + D, C = 3 * Y * (Y + G);
              this.setHandleIn(C !== 0 ? new M(
                (k * b._x + z * S._x - D * L._x) / C - S._x,
                (k * b._y + z * S._y - D * L._y) / C - S._y
              ) : new M());
            }
            if (!a && p) {
              var z = 2 * D + 3 * G * Y + k, C = 3 * G * (G + Y);
              this.setHandleOut(C !== 0 ? new M(
                (D * L._x + z * S._x - k * b._x) / C - S._x,
                (D * L._y + z * S._y - k * b._y) / C - S._y
              ) : new M());
            }
          } else if (u === "geometric") {
            if (v && p) {
              var O = b.subtract(L), j = d === t ? 0.4 : d, q = j * E / (E + A);
              r || this.setHandleIn(O.multiply(q)), a || this.setHandleOut(O.multiply(q - j));
            }
          } else
            throw new Error("Smoothing method '" + u + "' not supported.");
        },
        getPrevious: function() {
          var i = this._path && this._path._segments;
          return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._index === i._segments.length - 1 || !1;
        },
        reverse: function() {
          var i = this._handleIn, r = this._handleOut, a = i.clone();
          i.set(r), r.set(a);
        },
        reversed: function() {
          return new ce(this._point, this._handleOut, this._handleIn);
        },
        remove: function() {
          return this._path ? !!this._path.removeSegment(this._index) : !1;
        },
        clone: function() {
          return new ce(this._point, this._handleIn, this._handleOut);
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
        },
        toString: function() {
          var i = ["point: " + this._point];
          return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
        },
        transform: function(i) {
          this._transformCoordinates(i, new Array(6), !0), this._changed();
        },
        interpolate: function(i, r, a) {
          var l = 1 - a, u = a, d = i._point, v = r._point, p = i._handleIn, b = r._handleIn, S = r._handleOut, L = i._handleOut;
          this._point._set(
            l * d._x + u * v._x,
            l * d._y + u * v._y,
            !0
          ), this._handleIn._set(
            l * p._x + u * b._x,
            l * p._y + u * b._y,
            !0
          ), this._handleOut._set(
            l * L._x + u * S._x,
            l * L._y + u * S._y,
            !0
          ), this._changed();
        },
        _transformCoordinates: function(i, r, a) {
          var l = this._point, u = !a || !this._handleIn.isZero() ? this._handleIn : null, d = !a || !this._handleOut.isZero() ? this._handleOut : null, v = l._x, p = l._y, b = 2;
          return r[0] = v, r[1] = p, u && (r[b++] = u._x + v, r[b++] = u._y + p), d && (r[b++] = d._x + v, r[b++] = d._y + p), i && (i._transformCoordinates(r, r, b / 2), v = r[0], p = r[1], a ? (l._x = v, l._y = p, b = 2, u && (u._x = r[b++] - v, u._y = r[b++] - p), d && (d._x = r[b++] - v, d._y = r[b++] - p)) : (u || (r[b++] = v, r[b++] = p), d || (r[b++] = v, r[b++] = p))), r;
        }
      }), ut = M.extend({
        initialize: function(i, r, a) {
          var l, u, d;
          if (!i)
            l = u = 0;
          else if ((l = i[0]) !== t)
            u = i[1];
          else {
            var v = i;
            (l = v.x) === t && (v = M.read(arguments), l = v.x), u = v.y, d = v.selected;
          }
          this._x = l, this._y = u, this._owner = r, r[a] = this, d && this.setSelected(!0);
        },
        _set: function(i, r) {
          return this._x = i, this._y = r, this._owner._changed(this), this;
        },
        getX: function() {
          return this._x;
        },
        setX: function(i) {
          this._x = i, this._owner._changed(this);
        },
        getY: function() {
          return this._y;
        },
        setY: function(i) {
          this._y = i, this._owner._changed(this);
        },
        isZero: function() {
          var i = I.isZero;
          return i(this._x) && i(this._y);
        },
        isSelected: function() {
          return !!(this._owner._selection & this._getSelection());
        },
        setSelected: function(i) {
          this._owner._changeSelection(this._getSelection(), i);
        },
        _getSelection: function() {
          var i = this._owner;
          return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
        }
      }), ze = o.extend(
        {
          _class: "Curve",
          beans: !0,
          initialize: function(i, r, a, l, u, d, v, p) {
            var b = arguments.length, S, L, E, A, T, G;
            b === 3 ? (this._path = i, S = r, L = a) : b ? b === 1 ? "segment1" in i ? (S = new ce(i.segment1), L = new ce(i.segment2)) : "point1" in i ? (E = i.point1, T = i.handle1, G = i.handle2, A = i.point2) : Array.isArray(i) && (E = [i[0], i[1]], A = [i[6], i[7]], T = [i[2] - i[0], i[3] - i[1]], G = [i[4] - i[6], i[5] - i[7]]) : b === 2 ? (S = new ce(i), L = new ce(r)) : b === 4 ? (E = i, T = r, G = a, A = l) : b === 8 && (E = [i, r], A = [v, p], T = [a - i, l - r], G = [u - v, d - p]) : (S = new ce(), L = new ce()), this._segment1 = S || new ce(E, null, T), this._segment2 = L || new ce(A, G, null);
          },
          _serialize: function(i, r) {
            return o.serialize(
              this.hasHandles() ? [
                this.getPoint1(),
                this.getHandle1(),
                this.getHandle2(),
                this.getPoint2()
              ] : [this.getPoint1(), this.getPoint2()],
              i,
              !0,
              r
            );
          },
          _changed: function() {
            this._length = this._bounds = t;
          },
          clone: function() {
            return new ze(this._segment1, this._segment2);
          },
          toString: function() {
            var i = ["point1: " + this._segment1._point];
            return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
          },
          classify: function() {
            return ze.classify(this.getValues());
          },
          remove: function() {
            var i = !1;
            if (this._path) {
              var r = this._segment2, a = r._handleOut;
              i = r.remove(), i && this._segment1._handleOut.set(a);
            }
            return i;
          },
          getPoint1: function() {
            return this._segment1._point;
          },
          setPoint1: function() {
            this._segment1._point.set(M.read(arguments));
          },
          getPoint2: function() {
            return this._segment2._point;
          },
          setPoint2: function() {
            this._segment2._point.set(M.read(arguments));
          },
          getHandle1: function() {
            return this._segment1._handleOut;
          },
          setHandle1: function() {
            this._segment1._handleOut.set(M.read(arguments));
          },
          getHandle2: function() {
            return this._segment2._handleIn;
          },
          setHandle2: function() {
            this._segment2._handleIn.set(M.read(arguments));
          },
          getSegment1: function() {
            return this._segment1;
          },
          getSegment2: function() {
            return this._segment2;
          },
          getPath: function() {
            return this._path;
          },
          getIndex: function() {
            return this._segment1._index;
          },
          getNext: function() {
            var i = this._path && this._path._curves;
            return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
          },
          getPrevious: function() {
            var i = this._path && this._path._curves;
            return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
          },
          isFirst: function() {
            return !this._segment1._index;
          },
          isLast: function() {
            var i = this._path;
            return i && this._segment1._index === i._curves.length - 1 || !1;
          },
          isSelected: function() {
            return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
          },
          setSelected: function(i) {
            this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
          },
          getValues: function(i) {
            return ze.getValues(this._segment1, this._segment2, i);
          },
          getPoints: function() {
            for (var i = this.getValues(), r = [], a = 0; a < 8; a += 2)
              r.push(new M(i[a], i[a + 1]));
            return r;
          }
        },
        {
          getLength: function() {
            return this._length == null && (this._length = ze.getLength(this.getValues(), 0, 1)), this._length;
          },
          getArea: function() {
            return ze.getArea(this.getValues());
          },
          getLine: function() {
            return new le(this._segment1._point, this._segment2._point);
          },
          getPart: function(i, r) {
            return new ze(ze.getPart(this.getValues(), i, r));
          },
          getPartLength: function(i, r) {
            return ze.getLength(this.getValues(), i, r);
          },
          divideAt: function(i) {
            return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
          },
          divideAtTime: function(i, r) {
            var a = 1e-8, l = 1 - a, u = null;
            if (i >= a && i <= l) {
              var d = ze.subdivide(this.getValues(), i), v = d[0], p = d[1], b = r || this.hasHandles(), S = this._segment1, L = this._segment2, E = this._path;
              b && (S._handleOut._set(v[2] - v[0], v[3] - v[1]), L._handleIn._set(p[4] - p[6], p[5] - p[7]));
              var A = v[6], T = v[7], G = new ce(
                new M(A, T),
                b && new M(v[4] - A, v[5] - T),
                b && new M(p[2] - A, p[3] - T)
              );
              E ? (E.insert(S._index + 1, G), u = this.getNext()) : (this._segment2 = G, this._changed(), u = new ze(G, L));
            }
            return u;
          },
          splitAt: function(i) {
            var r = this._path;
            return r ? r.splitAt(i) : null;
          },
          splitAtTime: function(i) {
            return this.splitAt(this.getLocationAtTime(i));
          },
          divide: function(i, r) {
            return this.divideAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
          },
          split: function(i, r) {
            return this.splitAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
          },
          reversed: function() {
            return new ze(this._segment2.reversed(), this._segment1.reversed());
          },
          clearHandles: function() {
            this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
          },
          statics: {
            getValues: function(i, r, a, l) {
              var u = i._point, d = i._handleOut, v = r._handleIn, p = r._point, b = u.x, S = u.y, L = p.x, E = p.y, A = l ? [b, S, b, S, L, E, L, E] : [
                b,
                S,
                b + d._x,
                S + d._y,
                L + v._x,
                E + v._y,
                L,
                E
              ];
              return a && a._transformCoordinates(A, A, 4), A;
            },
            subdivide: function(i, r) {
              var a = i[0], l = i[1], u = i[2], d = i[3], v = i[4], p = i[5], b = i[6], S = i[7];
              r === t && (r = 0.5);
              var L = 1 - r, E = L * a + r * u, A = L * l + r * d, T = L * u + r * v, G = L * d + r * p, D = L * v + r * b, Y = L * p + r * S, k = L * E + r * T, z = L * A + r * G, C = L * T + r * D, O = L * G + r * Y, j = L * k + r * C, q = L * z + r * O;
              return [
                [a, l, E, A, k, z, j, q],
                [j, q, C, O, D, Y, b, S]
              ];
            },
            getMonoCurves: function(i, r) {
              var a = [], l = r ? 0 : 1, u = i[l + 0], d = i[l + 2], v = i[l + 4], p = i[l + 6];
              if (u >= d == d >= v && d >= v == v >= p || ze.isStraight(i))
                a.push(i);
              else {
                var b = 3 * (d - v) - u + p, S = 2 * (u + v) - 4 * d, L = d - u, E = 1e-8, A = 1 - E, T = [], G = I.solveQuadratic(b, S, L, T, E, A);
                if (!G)
                  a.push(i);
                else {
                  T.sort();
                  var D = T[0], Y = ze.subdivide(i, D);
                  a.push(Y[0]), G > 1 && (D = (T[1] - D) / (1 - D), Y = ze.subdivide(Y[1], D), a.push(Y[0])), a.push(Y[1]);
                }
              }
              return a;
            },
            solveCubic: function(i, r, a, l, u, d) {
              var v = i[r], p = i[r + 2], b = i[r + 4], S = i[r + 6], L = 0;
              if (!(v < a && S < a && p < a && b < a || v > a && S > a && p > a && b > a)) {
                var E = 3 * (p - v), A = 3 * (b - p) - E, T = S - v - E - A;
                L = I.solveCubic(T, A, E, v - a, l, u, d);
              }
              return L;
            },
            getTimeOf: function(i, r) {
              var a = new M(i[0], i[1]), l = new M(i[6], i[7]), u = 1e-12, d = 1e-7, v = r.isClose(a, u) ? 0 : r.isClose(l, u) ? 1 : null;
              if (v === null)
                for (var p = [r.x, r.y], b = [], S = 0; S < 2; S++)
                  for (var L = ze.solveCubic(i, S, p[S], b, 0, 1), E = 0; E < L; E++) {
                    var A = b[E];
                    if (r.isClose(ze.getPoint(i, A), d))
                      return A;
                  }
              return r.isClose(a, d) ? 0 : r.isClose(l, d) ? 1 : null;
            },
            getNearestTime: function(i, r) {
              if (ze.isStraight(i)) {
                var a = i[0], l = i[1], u = i[6], d = i[7], v = u - a, p = d - l, b = v * v + p * p;
                if (b === 0)
                  return 0;
                var S = ((r.x - a) * v + (r.y - l) * p) / b;
                return S < 1e-12 ? 0 : S > 0.999999999999 ? 1 : ze.getTimeOf(
                  i,
                  new M(a + S * v, l + S * p)
                );
              }
              var L = 100, E = 1 / 0, A = 0;
              function T(Y) {
                if (Y >= 0 && Y <= 1) {
                  var k = r.getDistance(ze.getPoint(i, Y), !0);
                  if (k < E)
                    return E = k, A = Y, !0;
                }
              }
              for (var G = 0; G <= L; G++)
                T(G / L);
              for (var D = 1 / (L * 2); D > 1e-8; )
                !T(A - D) && !T(A + D) && (D /= 2);
              return A;
            },
            getPart: function(i, r, a) {
              var l = r > a;
              if (l) {
                var u = r;
                r = a, a = u;
              }
              return r > 0 && (i = ze.subdivide(i, r)[1]), a < 1 && (i = ze.subdivide(i, (a - r) / (1 - r))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
            },
            isFlatEnough: function(i, r) {
              var a = i[0], l = i[1], u = i[2], d = i[3], v = i[4], p = i[5], b = i[6], S = i[7], L = 3 * u - 2 * a - b, E = 3 * d - 2 * l - S, A = 3 * v - 2 * b - a, T = 3 * p - 2 * S - l;
              return Math.max(L * L, A * A) + Math.max(E * E, T * T) <= 16 * r * r;
            },
            getArea: function(i) {
              var r = i[0], a = i[1], l = i[2], u = i[3], d = i[4], v = i[5], p = i[6], b = i[7];
              return 3 * ((b - a) * (l + d) - (p - r) * (u + v) + u * (r - d) - l * (a - v) + b * (d + r / 3) - p * (v + a / 3)) / 20;
            },
            getBounds: function(i) {
              for (var r = i.slice(0, 2), a = r.slice(), l = [0, 0], u = 0; u < 2; u++)
                ze._addBounds(
                  i[u],
                  i[u + 2],
                  i[u + 4],
                  i[u + 6],
                  u,
                  0,
                  r,
                  a,
                  l
                );
              return new P(r[0], r[1], a[0] - r[0], a[1] - r[1]);
            },
            _addBounds: function(i, r, a, l, u, d, v, p, b) {
              function S(j, q) {
                var H = j - q, ie = j + q;
                H < v[u] && (v[u] = H), ie > p[u] && (p[u] = ie);
              }
              d /= 2;
              var L = v[u] + d, E = p[u] - d;
              if (i < L || r < L || a < L || l < L || i > E || r > E || a > E || l > E)
                if (r < i != r < l && a < i != a < l)
                  S(i, 0), S(l, 0);
                else {
                  var A = 3 * (r - a) - i + l, T = 2 * (i + a) - 4 * r, G = r - i, D = I.solveQuadratic(A, T, G, b), Y = 1e-8, k = 1 - Y;
                  S(l, 0);
                  for (var z = 0; z < D; z++) {
                    var C = b[z], O = 1 - C;
                    Y <= C && C <= k && S(
                      O * O * O * i + 3 * O * O * C * r + 3 * O * C * C * a + C * C * C * l,
                      d
                    );
                  }
                }
            }
          }
        },
        o.each(
          ["getBounds", "getStrokeBounds", "getHandleBounds"],
          function(i) {
            this[i] = function() {
              this._bounds || (this._bounds = {});
              var r = this._bounds[i];
              return r || (r = this._bounds[i] = We[i](
                [this._segment1, this._segment2],
                !1,
                this._path
              )), r.clone();
            };
          },
          {}
        ),
        o.each({
          isStraight: function(i, r, a, l) {
            if (r.isZero() && a.isZero())
              return !0;
            var u = l.subtract(i);
            if (u.isZero())
              return !1;
            if (u.isCollinear(r) && u.isCollinear(a)) {
              var d = new le(i, l), v = 1e-7;
              if (d.getDistance(i.add(r)) < v && d.getDistance(l.add(a)) < v) {
                var p = u.dot(u), b = u.dot(r) / p, S = u.dot(a) / p;
                return b >= 0 && b <= 1 && S <= 0 && S >= -1;
              }
            }
            return !1;
          },
          isLinear: function(i, r, a, l) {
            var u = l.subtract(i).divide(3);
            return r.equals(u) && a.negate().equals(u);
          }
        }, function(i, r) {
          this[r] = function(a) {
            var l = this._segment1, u = this._segment2;
            return i(
              l._point,
              l._handleOut,
              u._handleIn,
              u._point,
              a
            );
          }, this.statics[r] = function(a, l) {
            var u = a[0], d = a[1], v = a[6], p = a[7];
            return i(
              new M(u, d),
              new M(a[2] - u, a[3] - d),
              new M(a[4] - v, a[5] - p),
              new M(v, p),
              l
            );
          };
        }, {
          statics: {},
          hasHandles: function() {
            return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
          },
          hasLength: function(i) {
            return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
          },
          isCollinear: function(i) {
            return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
          },
          isHorizontal: function() {
            return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
          },
          isVertical: function() {
            return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
          }
        }),
        {
          beans: !1,
          getLocationAt: function(i, r) {
            return this.getLocationAtTime(
              r ? i : this.getTimeAt(i)
            );
          },
          getLocationAtTime: function(i) {
            return i != null && i >= 0 && i <= 1 ? new pt(this, i) : null;
          },
          getTimeAt: function(i, r) {
            return ze.getTimeAt(this.getValues(), i, r);
          },
          getParameterAt: "#getTimeAt",
          getTimesWithTangent: function() {
            var i = M.read(arguments);
            return i.isZero() ? [] : ze.getTimesWithTangent(this.getValues(), i);
          },
          getOffsetAtTime: function(i) {
            return this.getPartLength(0, i);
          },
          getLocationOf: function() {
            return this.getLocationAtTime(this.getTimeOf(M.read(arguments)));
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getTimeOf: function() {
            return ze.getTimeOf(this.getValues(), M.read(arguments));
          },
          getParameterOf: "#getTimeOf",
          getNearestLocation: function() {
            var i = M.read(arguments), r = this.getValues(), a = ze.getNearestTime(r, i), l = ze.getPoint(r, a);
            return new pt(this, a, l, null, i.getDistance(l));
          },
          getNearestPoint: function() {
            var i = this.getNearestLocation.apply(this, arguments);
            return i && i.getPoint();
          }
        },
        new function() {
          var i = [
            "getPoint",
            "getTangent",
            "getNormal",
            "getWeightedTangent",
            "getWeightedNormal",
            "getCurvature"
          ];
          return o.each(
            i,
            function(r) {
              this[r + "At"] = function(a, l) {
                var u = this.getValues();
                return ze[r](u, l ? a : ze.getTimeAt(u, a));
              }, this[r + "AtTime"] = function(a) {
                return ze[r](this.getValues(), a);
              };
            },
            {
              statics: {
                _evaluateMethods: i
              }
            }
          );
        }(),
        new function() {
          function i(l) {
            var u = l[0], d = l[1], v = l[2], p = l[3], b = l[4], S = l[5], L = l[6], E = l[7], A = 9 * (v - b) + 3 * (L - u), T = 6 * (u + b) - 12 * v, G = 3 * (v - u), D = 9 * (p - S) + 3 * (E - d), Y = 6 * (d + S) - 12 * p, k = 3 * (p - d);
            return function(z) {
              var C = (A * z + T) * z + G, O = (D * z + Y) * z + k;
              return Math.sqrt(C * C + O * O);
            };
          }
          function r(l, u) {
            return Math.max(2, Math.min(16, Math.ceil(Math.abs(u - l) * 32)));
          }
          function a(l, u, d, v) {
            if (u == null || u < 0 || u > 1)
              return null;
            var p = l[0], b = l[1], S = l[2], L = l[3], E = l[4], A = l[5], T = l[6], G = l[7], D = I.isZero;
            D(S - p) && D(L - b) && (S = p, L = b), D(E - T) && D(A - G) && (E = T, A = G);
            var Y = 3 * (S - p), k = 3 * (E - S) - Y, z = T - p - Y - k, C = 3 * (L - b), O = 3 * (A - L) - C, j = G - b - C - O, q, H;
            if (d === 0)
              q = u === 0 ? p : u === 1 ? T : ((z * u + k) * u + Y) * u + p, H = u === 0 ? b : u === 1 ? G : ((j * u + O) * u + C) * u + b;
            else {
              var ie = 1e-8, ae = 1 - ie;
              if (u < ie ? (q = Y, H = C) : u > ae ? (q = 3 * (T - E), H = 3 * (G - A)) : (q = (3 * z * u + 2 * k) * u + Y, H = (3 * j * u + 2 * O) * u + C), v) {
                q === 0 && H === 0 && (u < ie || u > ae) && (q = E - S, H = A - L);
                var ue = Math.sqrt(q * q + H * H);
                ue && (q /= ue, H /= ue);
              }
              if (d === 3) {
                var E = 6 * z * u + 2 * k, A = 6 * j * u + 2 * O, me = Math.pow(q * q + H * H, 3 / 2);
                q = me !== 0 ? (q * A - H * E) / me : 0, H = 0;
              }
            }
            return d === 2 ? new M(H, -q) : new M(q, H);
          }
          return { statics: {
            classify: function(l) {
              var u = l[0], d = l[1], v = l[2], p = l[3], b = l[4], S = l[5], L = l[6], E = l[7], A = u * (E - S) + d * (b - L) + L * S - E * b, T = v * (d - E) + p * (L - u) + u * E - d * L, G = b * (p - d) + S * (u - v) + v * d - p * u, D = 3 * G, Y = D - T, k = Y - T + A, z = Math.sqrt(k * k + Y * Y + D * D), C = z !== 0 ? 1 / z : 0, O = I.isZero, j = "serpentine";
              k *= C, Y *= C, D *= C;
              function q(ue, me, se) {
                var de = me !== t, ve = de && me > 0 && me < 1, we = de && se > 0 && se < 1;
                return de && (!(ve || we) || ue === "loop" && !(ve && we)) && (ue = "arch", ve = we = !1), {
                  type: ue,
                  roots: ve || we ? ve && we ? me < se ? [me, se] : [se, me] : [ve ? me : se] : null
                };
              }
              if (O(k))
                return O(Y) ? q(O(D) ? "line" : "quadratic") : q(j, D / (3 * Y));
              var H = 3 * Y * Y - 4 * k * D;
              if (O(H))
                return q("cusp", Y / (2 * k));
              var ie = H > 0 ? Math.sqrt(H / 3) : Math.sqrt(-H), ae = 2 * k;
              return q(
                H > 0 ? j : "loop",
                (Y + ie) / ae,
                (Y - ie) / ae
              );
            },
            getLength: function(l, u, d, v) {
              if (u === t && (u = 0), d === t && (d = 1), ze.isStraight(l)) {
                var p = l;
                d < 1 && (p = ze.subdivide(p, d)[0], u /= d), u > 0 && (p = ze.subdivide(p, u)[1]);
                var b = p[6] - p[0], S = p[7] - p[1];
                return Math.sqrt(b * b + S * S);
              }
              return I.integrate(
                v || i(l),
                u,
                d,
                r(u, d)
              );
            },
            getTimeAt: function(l, u, d) {
              if (d === t && (d = u < 0 ? 1 : 0), u === 0)
                return d;
              var v = Math.abs, p = 1e-12, b = u > 0, S = b ? d : 0, L = b ? 1 : d, E = i(l), A = ze.getLength(l, S, L, E), T = v(u) - A;
              if (v(T) < p)
                return b ? L : S;
              if (T > p)
                return null;
              var G = u / A, D = 0;
              function Y(k) {
                return D += I.integrate(
                  E,
                  d,
                  k,
                  r(d, k)
                ), d = k, D - u;
              }
              return I.findRoot(
                Y,
                E,
                d + G,
                S,
                L,
                32,
                1e-12
              );
            },
            getPoint: function(l, u) {
              return a(l, u, 0, !1);
            },
            getTangent: function(l, u) {
              return a(l, u, 1, !0);
            },
            getWeightedTangent: function(l, u) {
              return a(l, u, 1, !1);
            },
            getNormal: function(l, u) {
              return a(l, u, 2, !0);
            },
            getWeightedNormal: function(l, u) {
              return a(l, u, 2, !1);
            },
            getCurvature: function(l, u) {
              return a(l, u, 3, !1).x;
            },
            getPeaks: function(l) {
              var u = l[0], d = l[1], v = l[2], p = l[3], b = l[4], S = l[5], L = l[6], E = l[7], A = -u + 3 * v - 3 * b + L, T = 3 * u - 6 * v + 3 * b, G = -3 * u + 3 * v, D = -d + 3 * p - 3 * S + E, Y = 3 * d - 6 * p + 3 * S, k = -3 * d + 3 * p, z = 1e-8, C = 1 - z, O = [];
              return I.solveCubic(
                9 * (A * A + D * D),
                9 * (A * T + Y * D),
                2 * (T * T + Y * Y) + 3 * (G * A + k * D),
                G * T + Y * k,
                O,
                z,
                C
              ), O.sort();
            }
          } };
        }(),
        new function() {
          function i(T, G, D, Y, k, z, C) {
            var O = !C && D.getPrevious() === k, j = !C && D !== k && D.getNext() === k, q = 1e-8, H = 1 - q;
            if (Y !== null && Y >= (O ? q : 0) && Y <= (j ? H : 1) && z !== null && z >= (j ? q : 0) && z <= (O ? H : 1)) {
              var ie = new pt(D, Y, null, C), ae = new pt(k, z, null, C);
              ie._intersection = ae, ae._intersection = ie, (!G || G(ie)) && pt.insert(T, ie, !0);
            }
          }
          function r(T, G, D, Y, k, z, C, O, j, q, H, ie, ae) {
            if (++j >= 4096 || ++O >= 40)
              return j;
            var ue = 1e-9, me = G[0], se = G[1], de = G[6], ve = G[7], we = le.getSignedDistance, Se = we(me, se, de, ve, G[2], G[3]), Ae = we(me, se, de, ve, G[4], G[5]), Ge = Se * Ae > 0 ? 3 / 4 : 4 / 9, et = Ge * Math.min(0, Se, Ae), st = Ge * Math.max(0, Se, Ae), _t = we(me, se, de, ve, T[0], T[1]), Re = we(me, se, de, ve, T[2], T[3]), Fe = we(me, se, de, ve, T[4], T[5]), at = we(me, se, de, ve, T[6], T[7]), yt = a(_t, Re, Fe, at), bt = yt[0], Rt = yt[1], It, Ht;
            if (Se === 0 && Ae === 0 && _t === 0 && Re === 0 && Fe === 0 && at === 0 || (It = l(bt, Rt, et, st)) == null || (Ht = l(
              bt.reverse(),
              Rt.reverse(),
              et,
              st
            )) == null)
              return j;
            var jt = q + (H - q) * It, Vt = q + (H - q) * Ht;
            if (Math.max(ae - ie, Vt - jt) < ue) {
              var Ti = (jt + Vt) / 2, ki = (ie + ae) / 2;
              i(
                k,
                z,
                C ? Y : D,
                C ? ki : Ti,
                C ? D : Y,
                C ? Ti : ki
              );
            } else {
              T = ze.getPart(T, It, Ht);
              var Li = ae - ie;
              if (Ht - It > 0.8)
                if (Vt - jt > Li) {
                  var bi = ze.subdivide(T, 0.5), Ti = (jt + Vt) / 2;
                  j = r(
                    G,
                    bi[0],
                    Y,
                    D,
                    k,
                    z,
                    !C,
                    O,
                    j,
                    ie,
                    ae,
                    jt,
                    Ti
                  ), j = r(
                    G,
                    bi[1],
                    Y,
                    D,
                    k,
                    z,
                    !C,
                    O,
                    j,
                    ie,
                    ae,
                    Ti,
                    Vt
                  );
                } else {
                  var bi = ze.subdivide(G, 0.5), ki = (ie + ae) / 2;
                  j = r(
                    bi[0],
                    T,
                    Y,
                    D,
                    k,
                    z,
                    !C,
                    O,
                    j,
                    ie,
                    ki,
                    jt,
                    Vt
                  ), j = r(
                    bi[1],
                    T,
                    Y,
                    D,
                    k,
                    z,
                    !C,
                    O,
                    j,
                    ki,
                    ae,
                    jt,
                    Vt
                  );
                }
              else
                Li === 0 || Li >= ue ? j = r(
                  G,
                  T,
                  Y,
                  D,
                  k,
                  z,
                  !C,
                  O,
                  j,
                  ie,
                  ae,
                  jt,
                  Vt
                ) : j = r(
                  T,
                  G,
                  D,
                  Y,
                  k,
                  z,
                  C,
                  O,
                  j,
                  jt,
                  Vt,
                  ie,
                  ae
                );
            }
            return j;
          }
          function a(T, G, D, Y) {
            var k = [0, T], z = [1 / 3, G], C = [2 / 3, D], O = [1, Y], j = G - (2 * T + Y) / 3, q = D - (T + 2 * Y) / 3, H;
            if (j * q < 0)
              H = [[k, z, O], [k, C, O]];
            else {
              var ie = j / q;
              H = [
                ie >= 2 ? [k, z, O] : ie <= 0.5 ? [k, C, O] : [k, z, C, O],
                [k, O]
              ];
            }
            return (j || q) < 0 ? H.reverse() : H;
          }
          function l(T, G, D, Y) {
            return T[0][1] < D ? u(T, !0, D) : G[0][1] > Y ? u(G, !1, Y) : T[0][0];
          }
          function u(T, G, D) {
            for (var Y = T[0][0], k = T[0][1], z = 1, C = T.length; z < C; z++) {
              var O = T[z][0], j = T[z][1];
              if (G ? j >= D : j <= D)
                return j === D ? O : Y + (D - k) * (O - Y) / (j - k);
              Y = O, k = j;
            }
            return null;
          }
          function d(T, G, D, Y, k) {
            var z = I.isZero;
            if (z(Y) && z(k)) {
              var C = ze.getTimeOf(T, new M(G, D));
              return C === null ? [] : [C];
            }
            for (var O = Math.atan2(-k, Y), j = Math.sin(O), q = Math.cos(O), H = [], ie = [], ae = 0; ae < 8; ae += 2) {
              var ue = T[ae] - G, me = T[ae + 1] - D;
              H.push(
                ue * q - me * j,
                ue * j + me * q
              );
            }
            return ze.solveCubic(H, 1, 0, ie, 0, 1), ie;
          }
          function v(T, G, D, Y, k, z, C) {
            for (var O = G[0], j = G[1], q = G[6], H = G[7], ie = d(T, O, j, q - O, H - j), ae = 0, ue = ie.length; ae < ue; ae++) {
              var me = ie[ae], se = ze.getPoint(T, me), de = ze.getTimeOf(G, se);
              de !== null && i(
                k,
                z,
                C ? Y : D,
                C ? de : me,
                C ? D : Y,
                C ? me : de
              );
            }
          }
          function p(T, G, D, Y, k, z) {
            var C = le.intersect(
              T[0],
              T[1],
              T[6],
              T[7],
              G[0],
              G[1],
              G[6],
              G[7]
            );
            C && i(
              k,
              z,
              D,
              ze.getTimeOf(T, C),
              Y,
              ze.getTimeOf(G, C)
            );
          }
          function b(T, G, D, Y, k, z) {
            var C = 1e-12, O = Math.min, j = Math.max;
            if (j(T[0], T[2], T[4], T[6]) + C > O(G[0], G[2], G[4], G[6]) && O(T[0], T[2], T[4], T[6]) - C < j(G[0], G[2], G[4], G[6]) && j(T[1], T[3], T[5], T[7]) + C > O(G[1], G[3], G[5], G[7]) && O(T[1], T[3], T[5], T[7]) - C < j(G[1], G[3], G[5], G[7])) {
              var q = E(T, G);
              if (q)
                for (var H = 0; H < 2; H++) {
                  var ie = q[H];
                  i(
                    k,
                    z,
                    D,
                    ie[0],
                    Y,
                    ie[1],
                    !0
                  );
                }
              else {
                var ae = ze.isStraight(T), ue = ze.isStraight(G), me = ae && ue, se = ae && !ue, de = k.length;
                if ((me ? p : ae || ue ? v : r)(
                  se ? G : T,
                  se ? T : G,
                  se ? Y : D,
                  se ? D : Y,
                  k,
                  z,
                  se,
                  0,
                  0,
                  0,
                  1,
                  0,
                  1
                ), !me || k.length === de)
                  for (var H = 0; H < 4; H++) {
                    var ve = H >> 1, we = H & 1, Se = ve * 6, Ae = we * 6, Ge = new M(T[Se], T[Se + 1]), et = new M(G[Ae], G[Ae + 1]);
                    Ge.isClose(et, C) && i(
                      k,
                      z,
                      D,
                      ve,
                      Y,
                      we
                    );
                  }
              }
            }
            return k;
          }
          function S(T, G, D, Y) {
            var k = ze.classify(T);
            if (k.type === "loop") {
              var z = k.roots;
              i(
                D,
                Y,
                G,
                z[0],
                G,
                z[1]
              );
            }
            return D;
          }
          function L(T, G, D, Y, k, z) {
            var C = 1e-7, O = !G;
            O && (G = T);
            for (var j = T.length, q = G.length, H = new Array(j), ie = O ? H : new Array(q), ae = [], ue = 0; ue < j; ue++)
              H[ue] = T[ue].getValues(Y);
            if (!O)
              for (var ue = 0; ue < q; ue++)
                ie[ue] = G[ue].getValues(k);
            for (var me = x.findCurveBoundsCollisions(
              H,
              ie,
              C
            ), se = 0; se < j; se++) {
              var de = T[se], ve = H[se];
              O && S(ve, de, ae, D);
              var we = me[se];
              if (we)
                for (var Se = 0; Se < we.length; Se++) {
                  if (z && ae.length)
                    return ae;
                  var Ae = we[Se];
                  if (!O || Ae > se) {
                    var Ge = G[Ae], et = ie[Ae];
                    b(
                      ve,
                      et,
                      de,
                      Ge,
                      ae,
                      D
                    );
                  }
                }
            }
            return ae;
          }
          function E(T, G) {
            function D(at) {
              var yt = at[6] - at[0], bt = at[7] - at[1];
              return yt * yt + bt * bt;
            }
            var Y = Math.abs, k = le.getDistance, z = 1e-8, C = 1e-7, O = ze.isStraight(T), j = ze.isStraight(G), q = O && j, H = D(T) < D(G), ie = H ? G : T, ae = H ? T : G, ue = ie[0], me = ie[1], se = ie[6] - ue, de = ie[7] - me;
            if (k(ue, me, se, de, ae[0], ae[1], !0) < C && k(ue, me, se, de, ae[6], ae[7], !0) < C)
              !q && k(ue, me, se, de, ie[2], ie[3], !0) < C && k(ue, me, se, de, ie[4], ie[5], !0) < C && k(ue, me, se, de, ae[2], ae[3], !0) < C && k(ue, me, se, de, ae[4], ae[5], !0) < C && (O = j = q = !0);
            else if (q)
              return null;
            if (O ^ j)
              return null;
            for (var ve = [T, G], we = [], Se = 0; Se < 4 && we.length < 2; Se++) {
              var Ae = Se & 1, Ge = Ae ^ 1, et = Se >> 1, st = ze.getTimeOf(ve[Ae], new M(
                ve[Ge][et ? 6 : 0],
                ve[Ge][et ? 7 : 1]
              ));
              if (st != null) {
                var _t = Ae ? [et, st] : [st, et];
                (!we.length || Y(_t[0] - we[0][0]) > z && Y(_t[1] - we[0][1]) > z) && we.push(_t);
              }
              if (Se > 2 && !we.length)
                break;
            }
            if (we.length !== 2)
              we = null;
            else if (!q) {
              var Re = ze.getPart(T, we[0][0], we[1][0]), Fe = ze.getPart(G, we[0][1], we[1][1]);
              (Y(Fe[2] - Re[2]) > C || Y(Fe[3] - Re[3]) > C || Y(Fe[4] - Re[4]) > C || Y(Fe[5] - Re[5]) > C) && (we = null);
            }
            return we;
          }
          function A(T, G) {
            var D = T[0], Y = T[1], k = T[2], z = T[3], C = T[4], O = T[5], j = T[6], q = T[7], H = G.normalize(), ie = H.x, ae = H.y, ue = 3 * j - 9 * C + 9 * k - 3 * D, me = 3 * q - 9 * O + 9 * z - 3 * Y, se = 6 * C - 12 * k + 6 * D, de = 6 * O - 12 * z + 6 * Y, ve = 3 * k - 3 * D, we = 3 * z - 3 * Y, Se = 2 * ue * ae - 2 * me * ie, Ae = [];
            if (Math.abs(Se) < I.CURVETIME_EPSILON) {
              var Ge = ue * we - me * ve, Se = ue * de - me * se;
              if (Se != 0) {
                var et = -Ge / Se;
                et >= 0 && et <= 1 && Ae.push(et);
              }
            } else {
              var st = (se * se - 4 * ue * ve) * ae * ae + (-2 * se * de + 4 * me * ve + 4 * ue * we) * ie * ae + (de * de - 4 * me * we) * ie * ie, _t = se * ae - de * ie;
              if (st >= 0 && Se != 0) {
                var Re = Math.sqrt(st), Fe = -(_t + Re) / Se, at = (-_t + Re) / Se;
                Fe >= 0 && Fe <= 1 && Ae.push(Fe), at >= 0 && at <= 1 && Ae.push(at);
              }
            }
            return Ae;
          }
          return {
            getIntersections: function(T) {
              var G = this.getValues(), D = T && T !== this && T.getValues();
              return D ? b(G, D, this, T, []) : S(G, this, []);
            },
            statics: {
              getOverlaps: E,
              getIntersections: L,
              getCurveLineIntersections: d,
              getTimesWithTangent: A
            }
          };
        }()
      ), pt = o.extend(
        {
          _class: "CurveLocation",
          initialize: function(i, r, a, l, u) {
            if (r >= 0.99999999) {
              var d = i.getNext();
              d && (r = 0, i = d);
            }
            this._setCurve(i), this._time = r, this._point = a || i.getPointAtTime(r), this._overlap = l, this._distance = u, this._intersection = this._next = this._previous = null;
          },
          _setPath: function(i) {
            this._path = i, this._version = i ? i._version : 0;
          },
          _setCurve: function(i) {
            this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
          },
          _setSegment: function(i) {
            var r = i.getCurve();
            r ? this._setCurve(r) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
          },
          getSegment: function() {
            var i = this._segment;
            if (!i) {
              var r = this.getCurve(), a = this.getTime();
              a === 0 ? i = r._segment1 : a === 1 ? i = r._segment2 : a != null && (i = r.getPartLength(0, a) < r.getPartLength(a, 1) ? r._segment1 : r._segment2), this._segment = i;
            }
            return i;
          },
          getCurve: function() {
            var i = this._path, r = this;
            i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
            function a(l) {
              var u = l && l.getCurve();
              if (u && (r._time = u.getTimeOf(r._point)) != null)
                return r._setCurve(u), u;
            }
            return this._curve || a(this._segment) || a(this._segment1) || a(this._segment2.getPrevious());
          },
          getPath: function() {
            var i = this.getCurve();
            return i && i._path;
          },
          getIndex: function() {
            var i = this.getCurve();
            return i && i.getIndex();
          },
          getTime: function() {
            var i = this.getCurve(), r = this._time;
            return i && r == null ? this._time = i.getTimeOf(this._point) : r;
          },
          getParameter: "#getTime",
          getPoint: function() {
            return this._point;
          },
          getOffset: function() {
            var i = this._offset;
            if (i == null) {
              i = 0;
              var r = this.getPath(), a = this.getIndex();
              if (r && a != null)
                for (var l = r.getCurves(), u = 0; u < a; u++)
                  i += l[u].getLength();
              this._offset = i += this.getCurveOffset();
            }
            return i;
          },
          getCurveOffset: function() {
            var i = this._curveOffset;
            if (i == null) {
              var r = this.getCurve(), a = this.getTime();
              this._curveOffset = i = a != null && r && r.getPartLength(0, a);
            }
            return i;
          },
          getIntersection: function() {
            return this._intersection;
          },
          getDistance: function() {
            return this._distance;
          },
          divide: function() {
            var i = this.getCurve(), r = i && i.divideAtTime(this.getTime());
            return r && this._setSegment(r._segment1), r;
          },
          split: function() {
            var i = this.getCurve(), r = i._path, a = i && i.splitAtTime(this.getTime());
            return a && this._setSegment(r.getLastSegment()), a;
          },
          equals: function(i, r) {
            var a = this === i;
            if (!a && i instanceof pt) {
              var l = this.getCurve(), u = i.getCurve(), d = l._path, v = u._path;
              if (d === v) {
                var p = Math.abs, b = 1e-7, S = p(this.getOffset() - i.getOffset()), L = !r && this._intersection, E = !r && i._intersection;
                a = (S < b || d && p(d.getLength() - S) < b) && (!L && !E || L && E && L.equals(E, !0));
              }
            }
            return a;
          },
          toString: function() {
            var i = [], r = this.getPoint(), a = B.instance;
            r && i.push("point: " + r);
            var l = this.getIndex();
            l != null && i.push("index: " + l);
            var u = this.getTime();
            return u != null && i.push("time: " + a.number(u)), this._distance != null && i.push("distance: " + a.number(this._distance)), "{ " + i.join(", ") + " }";
          },
          isTouching: function() {
            var i = this._intersection;
            if (i && this.getTangent().isCollinear(i.getTangent())) {
              var r = this.getCurve(), a = i.getCurve();
              return !(r.isStraight() && a.isStraight() && r.getLine().intersect(a.getLine()));
            }
            return !1;
          },
          isCrossing: function() {
            var i = this._intersection;
            if (!i)
              return !1;
            var r = this.getTime(), a = i.getTime(), l = 1e-8, u = 1 - l, d = r >= l && r <= u, v = a >= l && a <= u;
            if (d && v)
              return !this.isTouching();
            var p = this.getCurve(), b = p && r < l ? p.getPrevious() : p, S = i.getCurve(), L = S && a < l ? S.getPrevious() : S;
            if (r > u && (p = p.getNext()), a > u && (S = S.getNext()), !b || !p || !L || !S)
              return !1;
            var E = [];
            function A(ie, ae) {
              var ue = ie.getValues(), me = ze.classify(ue).roots || ze.getPeaks(ue), se = me.length, de = ze.getLength(
                ue,
                ae && se ? me[se - 1] : 0,
                !ae && se ? me[0] : 1
              );
              E.push(se ? de : de / 32);
            }
            function T(ie, ae, ue) {
              return ae < ue ? ie > ae && ie < ue : ie > ae || ie < ue;
            }
            d || (A(b, !0), A(p, !1)), v || (A(L, !0), A(S, !1));
            var G = this.getPoint(), D = Math.min.apply(Math, E), Y = d ? p.getTangentAtTime(r) : p.getPointAt(D).subtract(G), k = d ? Y.negate() : b.getPointAt(-D).subtract(G), z = v ? S.getTangentAtTime(a) : S.getPointAt(D).subtract(G), C = v ? z.negate() : L.getPointAt(-D).subtract(G), O = k.getAngle(), j = Y.getAngle(), q = C.getAngle(), H = z.getAngle();
            return !!(d ? T(O, q, H) ^ T(j, q, H) && T(O, H, q) ^ T(j, H, q) : T(q, O, j) ^ T(H, O, j) && T(q, j, O) ^ T(H, j, O));
          },
          hasOverlap: function() {
            return !!this._overlap;
          }
        },
        o.each(ze._evaluateMethods, function(i) {
          var r = i + "At";
          this[i] = function() {
            var a = this.getCurve(), l = this.getTime();
            return l != null && a && a[r](l, !0);
          };
        }, {
          preserve: !0
        }),
        new function() {
          function i(r, a, l) {
            var u = r.length, d = 0, v = u - 1;
            function p(G, D) {
              for (var Y = G + D; Y >= -1 && Y <= u; Y += D) {
                var k = r[(Y % u + u) % u];
                if (!a.getPoint().isClose(
                  k.getPoint(),
                  1e-7
                ))
                  break;
                if (a.equals(k))
                  return k;
              }
              return null;
            }
            for (; d <= v; ) {
              var b = d + v >>> 1, S = r[b], L;
              if (l && (L = a.equals(S) ? S : p(b, -1) || p(b, 1)))
                return a._overlap && (L._overlap = L._intersection._overlap = !0), L;
              var E = a.getPath(), A = S.getPath(), T = E !== A ? E._id - A._id : a.getIndex() + a.getTime() - (S.getIndex() + S.getTime());
              T < 0 ? v = b - 1 : d = b + 1;
            }
            return r.splice(d, 0, a), a;
          }
          return { statics: {
            insert: i,
            expand: function(r) {
              for (var a = r.slice(), l = r.length - 1; l >= 0; l--)
                i(a, r[l]._intersection, !1);
              return a;
            }
          } };
        }()
      ), qt = X.extend({
        _class: "PathItem",
        _selectBounds: !1,
        _canScaleStroke: !0,
        beans: !0,
        initialize: function() {
        },
        statics: {
          create: function(i) {
            var r, a, l;
            if (o.isPlainObject(i) ? (a = i.segments, r = i.pathData) : Array.isArray(i) ? a = i : typeof i == "string" && (r = i), a) {
              var u = a[0];
              l = u && Array.isArray(u[0]);
            } else
              r && (l = (r.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(r));
            var d = l ? Et : We;
            return new d(i);
          }
        },
        _asPathItem: function() {
          return this;
        },
        isClockwise: function() {
          return this.getArea() >= 0;
        },
        setClockwise: function(i) {
          this.isClockwise() != (i = !!i) && this.reverse();
        },
        setPathData: function(i) {
          var r = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), a, l = !1, u, d, v = new M(), p = new M();
          function b(C, O) {
            var j = +a[C];
            return l && (j += v[O]), j;
          }
          function S(C) {
            return new M(
              b(C, "x"),
              b(C + 1, "y")
            );
          }
          this.clear();
          for (var L = 0, E = r && r.length; L < E; L++) {
            var A = r[L], T = A[0], G = T.toLowerCase();
            a = A.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
            var D = a && a.length;
            switch (l = T === G, u === "z" && !/[mz]/.test(G) && this.moveTo(v), G) {
              case "m":
              case "l":
                for (var Y = G === "m", k = 0; k < D; k += 2)
                  this[Y ? "moveTo" : "lineTo"](v = S(k)), Y && (p = v, Y = !1);
                d = v;
                break;
              case "h":
              case "v":
                var z = G === "h" ? "x" : "y";
                v = v.clone();
                for (var k = 0; k < D; k++)
                  v[z] = b(k, z), this.lineTo(v);
                d = v;
                break;
              case "c":
                for (var k = 0; k < D; k += 6)
                  this.cubicCurveTo(
                    S(k),
                    d = S(k + 2),
                    v = S(k + 4)
                  );
                break;
              case "s":
                for (var k = 0; k < D; k += 4)
                  this.cubicCurveTo(
                    /[cs]/.test(u) ? v.multiply(2).subtract(d) : v,
                    d = S(k),
                    v = S(k + 2)
                  ), u = G;
                break;
              case "q":
                for (var k = 0; k < D; k += 4)
                  this.quadraticCurveTo(
                    d = S(k),
                    v = S(k + 2)
                  );
                break;
              case "t":
                for (var k = 0; k < D; k += 2)
                  this.quadraticCurveTo(
                    d = /[qt]/.test(u) ? v.multiply(2).subtract(d) : v,
                    v = S(k)
                  ), u = G;
                break;
              case "a":
                for (var k = 0; k < D; k += 7)
                  this.arcTo(
                    v = S(k + 5),
                    new V(+a[k], +a[k + 1]),
                    +a[k + 2],
                    +a[k + 4],
                    +a[k + 3]
                  );
                break;
              case "z":
                this.closePath(1e-12), v = p;
                break;
            }
            u = G;
          }
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _contains: function(i) {
          var r = i.isInside(
            this.getBounds({ internal: !0, handle: !0 })
          ) ? this._getWinding(i) : {};
          return r.onPath || !!(this.getFillRule() === "evenodd" ? r.windingL & 1 || r.windingR & 1 : r.winding);
        },
        getIntersections: function(i, r, a, l) {
          var u = this === i || !i, d = this._matrix._orNullIfIdentity(), v = u ? d : (a || i._matrix)._orNullIfIdentity();
          return u || this.getBounds(d).intersects(
            i.getBounds(v),
            1e-12
          ) ? ze.getIntersections(
            this.getCurves(),
            !u && i.getCurves(),
            r,
            d,
            v,
            l
          ) : [];
        },
        getCrossings: function(i) {
          return this.getIntersections(i, function(r) {
            return r.isCrossing();
          });
        },
        getNearestLocation: function() {
          for (var i = M.read(arguments), r = this.getCurves(), a = 1 / 0, l = null, u = 0, d = r.length; u < d; u++) {
            var v = r[u].getNearestLocation(i);
            v._distance < a && (a = v._distance, l = v);
          }
          return l;
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        },
        interpolate: function(i, r, a) {
          var l = !this._children, u = l ? "_segments" : "_children", d = i[u], v = r[u], p = this[u];
          if (!d || !v || d.length !== v.length)
            throw new Error("Invalid operands in interpolate() call: " + i + ", " + r);
          var b = p.length, S = v.length;
          if (b < S)
            for (var L = l ? ce : We, E = b; E < S; E++)
              this.add(new L());
          else
            b > S && this[l ? "removeSegments" : "removeChildren"](S, b);
          for (var E = 0; E < S; E++)
            p[E].interpolate(d[E], v[E], a);
          l && (this.setClosed(i._closed), this._changed(9));
        },
        compare: function(i) {
          var r = !1;
          if (i) {
            var a = this._children || [this], l = i._children ? i._children.slice() : [i], u = a.length, d = l.length, v = [], p = 0;
            r = !0;
            for (var b = x.findItemBoundsCollisions(a, l, I.GEOMETRIC_EPSILON), S = u - 1; S >= 0 && r; S--) {
              var L = a[S];
              r = !1;
              var E = b[S];
              if (E)
                for (var A = E.length - 1; A >= 0 && !r; A--)
                  L.compare(l[E[A]]) && (v[E[A]] || (v[E[A]] = !0, p++), r = !0);
            }
            r = r && p === d;
          }
          return r;
        }
      }), We = qt.extend(
        {
          _class: "Path",
          _serializeFields: {
            segments: [],
            closed: !1
          },
          initialize: function(i) {
            this._closed = !1, this._segments = [], this._version = 0;
            var r = arguments, a = Array.isArray(i) ? typeof i[0] == "object" ? i : r : i && i.size === t && (i.x !== t || i.point !== t) ? r : null;
            a && a.length > 0 ? this.setSegments(a) : (this._curves = t, this._segmentSelection = 0, !a && typeof i == "string" && (this.setPathData(i), i = null)), this._initialize(!a && i);
          },
          _equals: function(i) {
            return this._closed === i._closed && o.equals(this._segments, i._segments);
          },
          copyContent: function(i) {
            this.setSegments(i._segments), this._closed = i._closed;
          },
          _changed: function i(r) {
            if (i.base.call(this, r), r & 8) {
              if (this._length = this._area = t, r & 32)
                this._version++;
              else if (this._curves)
                for (var a = 0, l = this._curves.length; a < l; a++)
                  this._curves[a]._changed();
            } else
              r & 64 && (this._bounds = t);
          },
          getStyle: function() {
            var i = this._parent;
            return (i instanceof Et ? i : this)._style;
          },
          getSegments: function() {
            return this._segments;
          },
          setSegments: function(i) {
            var r = this.isFullySelected(), a = i && i.length;
            if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, a) {
              var l = i[a - 1];
              typeof l == "boolean" && (this.setClosed(l), a--), this._add(ce.readList(i, 0, {}, a));
            }
            r && this.setFullySelected(!0);
          },
          getFirstSegment: function() {
            return this._segments[0];
          },
          getLastSegment: function() {
            return this._segments[this._segments.length - 1];
          },
          getCurves: function() {
            var i = this._curves, r = this._segments;
            if (!i) {
              var a = this._countCurves();
              i = this._curves = new Array(a);
              for (var l = 0; l < a; l++)
                i[l] = new ze(
                  this,
                  r[l],
                  r[l + 1] || r[0]
                );
            }
            return i;
          },
          getFirstCurve: function() {
            return this.getCurves()[0];
          },
          getLastCurve: function() {
            var i = this.getCurves();
            return i[i.length - 1];
          },
          isClosed: function() {
            return this._closed;
          },
          setClosed: function(i) {
            if (this._closed != (i = !!i)) {
              if (this._closed = i, this._curves) {
                var r = this._curves.length = this._countCurves();
                i && (this._curves[r - 1] = new ze(
                  this,
                  this._segments[r - 1],
                  this._segments[0]
                ));
              }
              this._changed(41);
            }
          }
        },
        {
          beans: !0,
          getPathData: function(i, r) {
            var a = this._segments, l = a.length, u = new B(r), d = new Array(6), v = !0, p, b, S, L, E, A, T, G, D = [];
            function Y(z, C) {
              if (z._transformCoordinates(i, d), p = d[0], b = d[1], v)
                D.push("M" + u.pair(p, b)), v = !1;
              else if (E = d[2], A = d[3], E === p && A === b && T === S && G === L) {
                if (!C) {
                  var O = p - S, j = b - L;
                  D.push(
                    O === 0 ? "v" + u.number(j) : j === 0 ? "h" + u.number(O) : "l" + u.pair(O, j)
                  );
                }
              } else
                D.push("c" + u.pair(T - S, G - L) + " " + u.pair(E - S, A - L) + " " + u.pair(p - S, b - L));
              S = p, L = b, T = d[4], G = d[5];
            }
            if (!l)
              return "";
            for (var k = 0; k < l; k++)
              Y(a[k]);
            return this._closed && l > 0 && (Y(a[0], !0), D.push("z")), D.join("");
          },
          isEmpty: function() {
            return !this._segments.length;
          },
          _transformContent: function(i) {
            for (var r = this._segments, a = new Array(6), l = 0, u = r.length; l < u; l++)
              r[l]._transformCoordinates(i, a, !0);
            return !0;
          },
          _add: function(i, r) {
            for (var a = this._segments, l = this._curves, u = i.length, d = r == null, r = d ? a.length : r, v = 0; v < u; v++) {
              var p = i[v];
              p._path && (p = i[v] = p.clone()), p._path = this, p._index = r + v, p._selection && this._updateSelection(p, 0, p._selection);
            }
            if (d)
              o.push(a, i);
            else {
              a.splice.apply(a, [r, 0].concat(i));
              for (var v = r + u, b = a.length; v < b; v++)
                a[v]._index = v;
            }
            if (l) {
              var S = this._countCurves(), L = r > 0 && r + u - 1 === S ? r - 1 : r, E = L, A = Math.min(L + u, S);
              i._curves && (l.splice.apply(l, [L, 0].concat(i._curves)), E += i._curves.length);
              for (var v = E; v < A; v++)
                l.splice(v, 0, new ze(this, null, null));
              this._adjustCurves(L, A);
            }
            return this._changed(41), i;
          },
          _adjustCurves: function(i, r) {
            for (var a = this._segments, l = this._curves, u, d = i; d < r; d++)
              u = l[d], u._path = this, u._segment1 = a[d], u._segment2 = a[d + 1] || a[0], u._changed();
            (u = l[this._closed && !i ? a.length - 1 : i - 1]) && (u._segment2 = a[i] || a[0], u._changed()), (u = l[r]) && (u._segment1 = a[r], u._changed());
          },
          _countCurves: function() {
            var i = this._segments.length;
            return !this._closed && i > 0 ? i - 1 : i;
          },
          add: function(i) {
            var r = arguments;
            return r.length > 1 && typeof i != "number" ? this._add(ce.readList(r)) : this._add([ce.read(r)])[0];
          },
          insert: function(i, r) {
            var a = arguments;
            return a.length > 2 && typeof r != "number" ? this._add(ce.readList(a, 1), i) : this._add([ce.read(a, 1)], i)[0];
          },
          addSegment: function() {
            return this._add([ce.read(arguments)])[0];
          },
          insertSegment: function(i) {
            return this._add([ce.read(arguments, 1)], i)[0];
          },
          addSegments: function(i) {
            return this._add(ce.readList(i));
          },
          insertSegments: function(i, r) {
            return this._add(ce.readList(r), i);
          },
          removeSegment: function(i) {
            return this.removeSegments(i, i + 1)[0] || null;
          },
          removeSegments: function(i, r, a) {
            i = i || 0, r = o.pick(r, this._segments.length);
            var l = this._segments, u = this._curves, d = l.length, v = l.splice(i, r - i), p = v.length;
            if (!p)
              return v;
            for (var b = 0; b < p; b++) {
              var S = v[b];
              S._selection && this._updateSelection(S, S._selection, 0), S._index = S._path = null;
            }
            for (var b = i, L = l.length; b < L; b++)
              l[b]._index = b;
            if (u) {
              for (var E = i > 0 && r === d + (this._closed ? 1 : 0) ? i - 1 : i, u = u.splice(E, p), b = u.length - 1; b >= 0; b--)
                u[b]._path = null;
              a && (v._curves = u.slice(1)), this._adjustCurves(E, E);
            }
            return this._changed(41), v;
          },
          clear: "#removeSegments",
          hasHandles: function() {
            for (var i = this._segments, r = 0, a = i.length; r < a; r++)
              if (i[r].hasHandles())
                return !0;
            return !1;
          },
          clearHandles: function() {
            for (var i = this._segments, r = 0, a = i.length; r < a; r++)
              i[r].clearHandles();
          },
          getLength: function() {
            if (this._length == null) {
              for (var i = this.getCurves(), r = 0, a = 0, l = i.length; a < l; a++)
                r += i[a].getLength();
              this._length = r;
            }
            return this._length;
          },
          getArea: function() {
            var i = this._area;
            if (i == null) {
              var r = this._segments, a = this._closed;
              i = 0;
              for (var l = 0, u = r.length; l < u; l++) {
                var d = l + 1 === u;
                i += ze.getArea(ze.getValues(
                  r[l],
                  r[d ? 0 : l + 1],
                  null,
                  d && !a
                ));
              }
              this._area = i;
            }
            return i;
          },
          isFullySelected: function() {
            var i = this._segments.length;
            return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
          },
          setFullySelected: function(i) {
            i && this._selectSegments(!0), this.setSelected(i);
          },
          setSelection: function i(r) {
            r & 1 || this._selectSegments(!1), i.base.call(this, r);
          },
          _selectSegments: function(i) {
            var r = this._segments, a = r.length, l = i ? 7 : 0;
            this._segmentSelection = l * a;
            for (var u = 0; u < a; u++)
              r[u]._selection = l;
          },
          _updateSelection: function(i, r, a) {
            i._selection = a;
            var l = this._segmentSelection += a - r;
            l > 0 && this.setSelected(!0);
          },
          divideAt: function(i) {
            var r = this.getLocationAt(i), a;
            return r && (a = r.getCurve().divideAt(r.getCurveOffset())) ? a._segment1 : null;
          },
          splitAt: function(i) {
            var r = this.getLocationAt(i), a = r && r.index, l = r && r.time, u = 1e-8, d = 1 - u;
            l > d && (a++, l = 0);
            var v = this.getCurves();
            if (a >= 0 && a < v.length) {
              l >= u && v[a++].divideAtTime(l);
              var p = this.removeSegments(a, this._segments.length, !0), b;
              return this._closed ? (this.setClosed(!1), b = this) : (b = new We(X.NO_INSERT), b.insertAbove(this), b.copyAttributes(this)), b._add(p, 0), this.addSegment(p[0]), b;
            }
            return null;
          },
          split: function(i, r) {
            var a, l = r === t ? i : (a = this.getCurves()[i]) && a.getLocationAtTime(r);
            return l != null ? this.splitAt(l) : null;
          },
          join: function(i, r) {
            var a = r || 0;
            if (i && i !== this) {
              var l = i._segments, u = this.getLastSegment(), d = i.getLastSegment();
              if (!d)
                return this;
              u && u._point.isClose(d._point, a) && i.reverse();
              var v = i.getFirstSegment();
              if (u && u._point.isClose(v._point, a))
                u.setHandleOut(v._handleOut), this._add(l.slice(1));
              else {
                var p = this.getFirstSegment();
                p && p._point.isClose(v._point, a) && i.reverse(), d = i.getLastSegment(), p && p._point.isClose(d._point, a) ? (p.setHandleIn(d._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
              }
              i._closed && this._add([l[0]]), i.remove();
            }
            var b = this.getFirstSegment(), S = this.getLastSegment();
            return b !== S && b._point.isClose(S._point, a) && (b.setHandleIn(S._handleIn), S.remove(), this.setClosed(!0)), this;
          },
          reduce: function(i) {
            for (var r = this.getCurves(), a = i && i.simplify, l = a ? 1e-7 : 0, u = r.length - 1; u >= 0; u--) {
              var d = r[u];
              !d.hasHandles() && (!d.hasLength(l) || a && d.isCollinear(d.getNext())) && d.remove();
            }
            return this;
          },
          reverse: function() {
            this._segments.reverse();
            for (var i = 0, r = this._segments.length; i < r; i++) {
              var a = this._segments[i], l = a._handleIn;
              a._handleIn = a._handleOut, a._handleOut = l, a._index = i;
            }
            this._curves = null, this._changed(9);
          },
          flatten: function(i) {
            for (var r = new rt(this, i || 0.25, 256, !0), a = r.parts, l = a.length, u = [], d = 0; d < l; d++)
              u.push(new ce(a[d].curve.slice(0, 2)));
            !this._closed && l > 0 && u.push(new ce(a[l - 1].curve.slice(6))), this.setSegments(u);
          },
          simplify: function(i) {
            var r = new it(this).fit(i || 2.5);
            return r && this.setSegments(r), !!r;
          },
          smooth: function(i) {
            var r = this, a = i || {}, l = a.type || "asymmetric", u = this._segments, d = u.length, v = this._closed;
            function p(bt, Rt) {
              var It = bt && bt.index;
              if (It != null) {
                var Ht = bt.path;
                if (Ht && Ht !== r)
                  throw new Error(bt._class + " " + It + " of " + Ht + " is not part of " + r);
                Rt && bt instanceof ze && It++;
              } else
                It = typeof bt == "number" ? bt : Rt;
              return Math.min(It < 0 && v ? It % d : It < 0 ? It + d : It, d - 1);
            }
            var b = v && a.from === t && a.to === t, S = p(a.from, 0), L = p(a.to, d - 1);
            if (S > L)
              if (v)
                S -= d;
              else {
                var E = S;
                S = L, L = E;
              }
            if (/^(?:asymmetric|continuous)$/.test(l)) {
              var A = l === "asymmetric", T = Math.min, G = L - S + 1, D = G - 1, Y = b ? T(G, 4) : 1, k = Y, z = Y, C = [];
              if (v || (k = T(1, S), z = T(1, d - L - 1)), D += k + z, D <= 1)
                return;
              for (var O = 0, j = S - k; O <= D; O++, j++)
                C[O] = u[(j < 0 ? j + d : j) % d]._point;
              for (var q = C[0]._x + 2 * C[1]._x, H = C[0]._y + 2 * C[1]._y, ie = 2, ae = D - 1, ue = [q], me = [H], se = [ie], de = [], ve = [], O = 1; O < D; O++) {
                var we = O < ae, Se = we || A ? 1 : 2, Ae = we ? 4 : A ? 2 : 7, Ge = we ? 4 : A ? 3 : 8, et = we ? 2 : A ? 0 : 1, st = Se / ie;
                ie = se[O] = Ae - st, q = ue[O] = Ge * C[O]._x + et * C[O + 1]._x - st * q, H = me[O] = Ge * C[O]._y + et * C[O + 1]._y - st * H;
              }
              de[ae] = ue[ae] / se[ae], ve[ae] = me[ae] / se[ae];
              for (var O = D - 2; O >= 0; O--)
                de[O] = (ue[O] - de[O + 1]) / se[O], ve[O] = (me[O] - ve[O + 1]) / se[O];
              de[D] = (3 * C[D]._x - de[ae]) / 2, ve[D] = (3 * C[D]._y - ve[ae]) / 2;
              for (var O = k, _t = D - z, j = S; O <= _t; O++, j++) {
                var Re = u[j < 0 ? j + d : j], Fe = Re._point, at = de[O] - Fe._x, yt = ve[O] - Fe._y;
                (b || O < _t) && Re.setHandleOut(at, yt), (b || O > k) && Re.setHandleIn(-at, -yt);
              }
            } else
              for (var O = S; O <= L; O++)
                u[O < 0 ? O + d : O].smooth(
                  a,
                  !b && O === S,
                  !b && O === L
                );
          },
          toShape: function(i) {
            if (!this._closed)
              return null;
            var r = this._segments, a, l, u, d;
            function v(A, T) {
              var G = r[A], D = G.getNext(), Y = r[T], k = Y.getNext();
              return G._handleOut.isZero() && D._handleIn.isZero() && Y._handleOut.isZero() && k._handleIn.isZero() && D._point.subtract(G._point).isCollinear(
                k._point.subtract(Y._point)
              );
            }
            function p(A) {
              var T = r[A], G = T.getPrevious(), D = T.getNext();
              return G._handleOut.isZero() && T._handleIn.isZero() && T._handleOut.isZero() && D._handleIn.isZero() && T._point.subtract(G._point).isOrthogonal(
                D._point.subtract(T._point)
              );
            }
            function b(A) {
              var T = r[A], G = T.getNext(), D = T._handleOut, Y = G._handleIn, k = 0.5522847498307936;
              if (D.isOrthogonal(Y)) {
                var z = T._point, C = G._point, O = new le(z, D, !0).intersect(
                  new le(C, Y, !0),
                  !0
                );
                return O && I.isZero(D.getLength() / O.subtract(z).getLength() - k) && I.isZero(Y.getLength() / O.subtract(C).getLength() - k);
              }
              return !1;
            }
            function S(A, T) {
              return r[A]._point.getDistance(r[T]._point);
            }
            if (!this.hasHandles() && r.length === 4 && v(0, 2) && v(1, 3) && p(1) ? (a = Ee.Rectangle, l = new V(S(0, 3), S(0, 1)), d = r[1]._point.add(r[2]._point).divide(2)) : r.length === 8 && b(0) && b(2) && b(4) && b(6) && v(1, 5) && v(3, 7) ? (a = Ee.Rectangle, l = new V(S(1, 6), S(0, 3)), u = l.subtract(new V(
              S(0, 7),
              S(1, 2)
            )).divide(2), d = r[3]._point.add(r[4]._point).divide(2)) : r.length === 4 && b(0) && b(1) && b(2) && b(3) && (I.isZero(S(0, 2) - S(1, 3)) ? (a = Ee.Circle, u = S(0, 2) / 2) : (a = Ee.Ellipse, u = new V(S(2, 0) / 2, S(3, 1) / 2)), d = r[1]._point), a) {
              var L = this.getPosition(!0), E = new a({
                center: L,
                size: l,
                radius: u,
                insert: !1
              });
              return E.copyAttributes(this, !0), E._matrix.prepend(this._matrix), E.rotate(d.subtract(L).getAngle() + 90), (i === t || i) && E.insertAbove(this), E;
            }
            return null;
          },
          toPath: "#clone",
          compare: function i(r) {
            if (!r || r instanceof Et)
              return i.base.call(this, r);
            var a = this.getCurves(), l = r.getCurves(), u = a.length, d = l.length;
            if (!u || !d)
              return u == d;
            for (var v = a[0].getValues(), p = [], b = 0, S, L = 0, E, A = 0; A < d; A++) {
              var T = l[A].getValues();
              p.push(T);
              var G = ze.getOverlaps(v, T);
              if (G) {
                S = !A && G[0][0] > 0 ? d - 1 : A, E = G[0][1];
                break;
              }
            }
            for (var D = Math.abs, Y = 1e-8, T = p[S], k; v && T; ) {
              var G = ze.getOverlaps(v, T);
              if (G) {
                var z = G[0][0];
                if (D(z - L) < Y) {
                  L = G[1][0], L === 1 && (v = ++b < u ? a[b].getValues() : null, L = 0);
                  var C = G[0][1];
                  if (D(C - E) < Y) {
                    if (k || (k = [S, C]), E = G[1][1], E === 1 && (++S >= d && (S = 0), T = p[S] || l[S].getValues(), E = 0), !v)
                      return k[0] === S && k[1] === E;
                    continue;
                  }
                }
              }
              break;
            }
            return !1;
          },
          _hitTestSelf: function(i, r, a, l) {
            var u = this, d = this.getStyle(), v = this._segments, p = v.length, b = this._closed, S = r._tolerancePadding, L = S, E, A, T, G, D, Y, k = r.stroke && d.hasStroke(), z = r.fill && d.hasFill(), C = r.curves, O = k ? d.getStrokeWidth() / 2 : z && r.tolerance > 0 || C ? 0 : null;
            O !== null && (O > 0 ? (E = d.getStrokeJoin(), A = d.getStrokeCap(), T = d.getMiterLimit(), L = L.add(
              We._getStrokePadding(O, l)
            )) : E = A = "round");
            function j(de, ve) {
              return i.subtract(de).divide(ve).length <= 1;
            }
            function q(de, ve, we) {
              if (!r.selected || ve.isSelected()) {
                var Se = de._point;
                if (ve !== Se && (ve = ve.add(Se)), j(ve, L))
                  return new $e(we, u, {
                    segment: de,
                    point: ve
                  });
              }
            }
            function H(de, ve) {
              return (ve || r.segments) && q(de, de._point, "segment") || !ve && r.handles && (q(de, de._handleIn, "handle-in") || q(de, de._handleOut, "handle-out"));
            }
            function ie(de) {
              G.add(de);
            }
            function ae(de) {
              var ve = b || de._index > 0 && de._index < p - 1;
              if ((ve ? E : A) === "round")
                return j(de._point, L);
              if (G = new We({ internal: !0, closed: !0 }), ve ? de.isSmooth() || We._addBevelJoin(
                de,
                E,
                O,
                T,
                null,
                l,
                ie,
                !0
              ) : A === "square" && We._addSquareCap(
                de,
                A,
                O,
                null,
                l,
                ie,
                !0
              ), !G.isEmpty()) {
                var we;
                return G.contains(i) || (we = G.getNearestLocation(i)) && j(we.getPoint(), S);
              }
            }
            if (r.ends && !r.segments && !b) {
              if (Y = H(v[0], !0) || H(v[p - 1], !0))
                return Y;
            } else if (r.segments || r.handles) {
              for (var ue = 0; ue < p; ue++)
                if (Y = H(v[ue]))
                  return Y;
            }
            if (O !== null) {
              if (D = this.getNearestLocation(i), D) {
                var me = D.getTime();
                me === 0 || me === 1 && p > 1 ? ae(D.getSegment()) || (D = null) : j(D.getPoint(), L) || (D = null);
              }
              if (!D && E === "miter" && p > 1)
                for (var ue = 0; ue < p; ue++) {
                  var se = v[ue];
                  if (i.getDistance(se._point) <= T * O && ae(se)) {
                    D = se.getLocation();
                    break;
                  }
                }
            }
            return !D && z && this._contains(i) || D && !k && !C ? new $e("fill", this) : D ? new $e(k ? "stroke" : "curve", this, {
              location: D,
              point: D.getPoint()
            }) : null;
          }
        },
        o.each(
          ze._evaluateMethods,
          function(i) {
            this[i + "At"] = function(r) {
              var a = this.getLocationAt(r);
              return a && a[i]();
            };
          },
          {
            beans: !1,
            getLocationOf: function() {
              for (var i = M.read(arguments), r = this.getCurves(), a = 0, l = r.length; a < l; a++) {
                var u = r[a].getLocationOf(i);
                if (u)
                  return u;
              }
              return null;
            },
            getOffsetOf: function() {
              var i = this.getLocationOf.apply(this, arguments);
              return i ? i.getOffset() : null;
            },
            getLocationAt: function(i) {
              if (typeof i == "number") {
                for (var r = this.getCurves(), a = 0, l = 0, u = r.length; l < u; l++) {
                  var d = a, v = r[l];
                  if (a += v.getLength(), a > i)
                    return v.getLocationAt(i - d);
                }
                if (r.length > 0 && i <= this.getLength())
                  return new pt(r[r.length - 1], 1);
              } else if (i && i.getPath && i.getPath() === this)
                return i;
              return null;
            },
            getOffsetsWithTangent: function() {
              var i = M.read(arguments);
              if (i.isZero())
                return [];
              for (var r = [], a = 0, l = this.getCurves(), u = 0, d = l.length; u < d; u++) {
                for (var v = l[u], p = v.getTimesWithTangent(i), b = 0, S = p.length; b < S; b++) {
                  var L = a + v.getOffsetAtTime(p[b]);
                  r.indexOf(L) < 0 && r.push(L);
                }
                a += v.length;
              }
              return r;
            }
          }
        ),
        new function() {
          function i(a, l, u, d) {
            if (d <= 0)
              return;
            var v = d / 2, p = d - 2, b = v - 1, S = new Array(6), L, E;
            function A(z) {
              var C = S[z], O = S[z + 1];
              (L != C || E != O) && (a.beginPath(), a.moveTo(L, E), a.lineTo(C, O), a.stroke(), a.beginPath(), a.arc(C, O, v, 0, Math.PI * 2, !0), a.fill());
            }
            for (var T = 0, G = l.length; T < G; T++) {
              var D = l[T], Y = D._selection;
              if (D._transformCoordinates(u, S), L = S[0], E = S[1], Y & 2 && A(2), Y & 4 && A(4), a.fillRect(L - v, E - v, d, d), p > 0 && !(Y & 1)) {
                var k = a.fillStyle;
                a.fillStyle = "#ffffff", a.fillRect(L - b, E - b, p, p), a.fillStyle = k;
              }
            }
          }
          function r(a, l, u) {
            var d = l._segments, v = d.length, p = new Array(6), b = !0, S, L, E, A, T, G, D, Y;
            function k(C) {
              if (u)
                C._transformCoordinates(u, p), S = p[0], L = p[1];
              else {
                var O = C._point;
                S = O._x, L = O._y;
              }
              if (b)
                a.moveTo(S, L), b = !1;
              else {
                if (u)
                  T = p[2], G = p[3];
                else {
                  var j = C._handleIn;
                  T = S + j._x, G = L + j._y;
                }
                T === S && G === L && D === E && Y === A ? a.lineTo(S, L) : a.bezierCurveTo(D, Y, T, G, S, L);
              }
              if (E = S, A = L, u)
                D = p[4], Y = p[5];
              else {
                var j = C._handleOut;
                D = E + j._x, Y = A + j._y;
              }
            }
            for (var z = 0; z < v; z++)
              k(d[z]);
            l._closed && v > 0 && k(d[0]);
          }
          return {
            _draw: function(a, l, u, d) {
              var v = l.dontStart, p = l.dontFinish || l.clip, b = this.getStyle(), S = b.hasFill(), L = b.hasStroke(), E = b.getDashArray(), A = !Ye.support.nativeDash && L && E && E.length;
              v || a.beginPath(), (S || L && !A || p) && (r(a, this, d), this._closed && a.closePath());
              function T(C) {
                return E[(C % A + A) % A];
              }
              if (!p && (S || L) && (this._setStyles(a, l, u), S && (a.fill(b.getFillRule()), a.shadowColor = "rgba(0,0,0,0)"), L)) {
                if (A) {
                  v || a.beginPath();
                  for (var G = new rt(
                    this,
                    0.25,
                    32,
                    !1,
                    d
                  ), D = G.length, Y = -b.getDashOffset(), k, z = 0; Y > 0; )
                    Y -= T(z--) + T(z--);
                  for (; Y < D; )
                    k = Y + T(z++), (Y > 0 || k > 0) && G.drawPart(
                      a,
                      Math.max(Y, 0),
                      Math.max(k, 0)
                    ), Y = k + T(z++);
                }
                a.stroke();
              }
            },
            _drawSelected: function(a, l) {
              a.beginPath(), r(a, this, l), a.stroke(), i(a, this._segments, l, Ye.settings.handleSize);
            }
          };
        }(),
        new function() {
          function i(r) {
            var a = r._segments;
            if (!a.length)
              throw new Error("Use a moveTo() command first");
            return a[a.length - 1];
          }
          return {
            moveTo: function() {
              var r = this._segments;
              r.length === 1 && this.removeSegment(0), r.length || this._add([new ce(M.read(arguments))]);
            },
            moveBy: function() {
              throw new Error("moveBy() is unsupported on Path items.");
            },
            lineTo: function() {
              this._add([new ce(M.read(arguments))]);
            },
            cubicCurveTo: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = M.read(r), d = i(this);
              d.setHandleOut(a.subtract(d._point)), this._add([new ce(u, l.subtract(u))]);
            },
            quadraticCurveTo: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = i(this)._point;
              this.cubicCurveTo(
                a.add(u.subtract(a).multiply(1 / 3)),
                a.add(l.subtract(a).multiply(1 / 3)),
                l
              );
            },
            curveTo: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = o.pick(o.read(r), 0.5), d = 1 - u, v = i(this)._point, p = a.subtract(v.multiply(d * d)).subtract(l.multiply(u * u)).divide(2 * u * d);
              if (p.isNaN())
                throw new Error(
                  "Cannot put a curve through points with parameter = " + u
                );
              this.quadraticCurveTo(p, l);
            },
            arcTo: function() {
              var r = arguments, a = Math.abs, l = Math.sqrt, u = i(this), d = u._point, v = M.read(r), G, p = o.peek(r), b = o.pick(p, !0), S, L, E, A;
              if (typeof b == "boolean")
                var T = d.add(v).divide(2), G = T.add(T.subtract(d).rotate(
                  b ? -90 : 90
                ));
              else if (o.remain(r) <= 2)
                G = v, v = M.read(r);
              else if (!d.equals(v)) {
                var D = V.read(r), Y = I.isZero;
                if (Y(D.width) || Y(D.height))
                  return this.lineTo(v);
                var k = o.read(r), b = !!o.read(r), z = !!o.read(r), T = d.add(v).divide(2), C = d.subtract(T).rotate(-k), O = C.x, j = C.y, q = a(D.width), H = a(D.height), ie = q * q, ae = H * H, ue = O * O, me = j * j, se = l(ue / ie + me / ae);
                if (se > 1 && (q *= se, H *= se, ie = q * q, ae = H * H), se = (ie * ae - ie * me - ae * ue) / (ie * me + ae * ue), a(se) < 1e-12 && (se = 0), se < 0)
                  throw new Error(
                    "Cannot create an arc with the given arguments"
                  );
                S = new M(q * j / H, -H * O / q).multiply((z === b ? -1 : 1) * l(se)).rotate(k).add(T), A = new J().translate(S).rotate(k).scale(q, H), E = A._inverseTransform(d), L = E.getDirectedAngle(A._inverseTransform(v)), !b && L > 0 ? L -= 360 : b && L < 0 && (L += 360);
              }
              if (G) {
                var de = new le(
                  d.add(G).divide(2),
                  G.subtract(d).rotate(90),
                  !0
                ), ve = new le(
                  G.add(v).divide(2),
                  v.subtract(G).rotate(90),
                  !0
                ), we = new le(d, v), Se = we.getSide(G);
                if (S = de.intersect(ve, !0), !S) {
                  if (!Se)
                    return this.lineTo(v);
                  throw new Error(
                    "Cannot create an arc with the given arguments"
                  );
                }
                E = d.subtract(S), L = E.getDirectedAngle(v.subtract(S));
                var Ae = we.getSide(S, !0);
                Ae === 0 ? L = Se * a(L) : Se === Ae && (L += L < 0 ? 360 : -360);
              }
              if (L) {
                for (var Ge = 1e-5, et = a(L), st = et >= 360 ? 4 : Math.ceil((et - Ge) / 90), _t = L / st, Re = _t * Math.PI / 360, Fe = 4 / 3 * Math.sin(Re) / (1 + Math.cos(Re)), at = [], yt = 0; yt <= st; yt++) {
                  var C = v, bt = null;
                  if (yt < st && (bt = E.rotate(90).multiply(Fe), A ? (C = A._transformPoint(E), bt = A._transformPoint(E.add(bt)).subtract(C)) : C = S.add(E)), !yt)
                    u.setHandleOut(bt);
                  else {
                    var Rt = E.rotate(-90).multiply(Fe);
                    A && (Rt = A._transformPoint(E.add(Rt)).subtract(C)), at.push(new ce(C, Rt, bt));
                  }
                  E = E.rotate(_t);
                }
                this._add(at);
              }
            },
            lineBy: function() {
              var r = M.read(arguments), a = i(this)._point;
              this.lineTo(a.add(r));
            },
            curveBy: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = o.read(r), d = i(this)._point;
              this.curveTo(d.add(a), d.add(l), u);
            },
            cubicCurveBy: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = M.read(r), d = i(this)._point;
              this.cubicCurveTo(
                d.add(a),
                d.add(l),
                d.add(u)
              );
            },
            quadraticCurveBy: function() {
              var r = arguments, a = M.read(r), l = M.read(r), u = i(this)._point;
              this.quadraticCurveTo(u.add(a), u.add(l));
            },
            arcBy: function() {
              var r = arguments, a = i(this)._point, l = a.add(M.read(r)), u = o.pick(o.peek(r), !0);
              typeof u == "boolean" ? this.arcTo(l, u) : this.arcTo(l, a.add(M.read(r)));
            },
            closePath: function(r) {
              this.setClosed(!0), this.join(this, r);
            }
          };
        }(),
        {
          _getBounds: function(i, r) {
            var a = r.handle ? "getHandleBounds" : r.stroke ? "getStrokeBounds" : "getBounds";
            return We[a](this._segments, this._closed, this, i, r);
          },
          statics: {
            getBounds: function(i, r, a, l, u, d) {
              var v = i[0];
              if (!v)
                return new P();
              var p = new Array(6), b = v._transformCoordinates(l, new Array(6)), S = b.slice(0, 2), L = S.slice(), E = new Array(2);
              function A(D) {
                D._transformCoordinates(l, p);
                for (var Y = 0; Y < 2; Y++)
                  ze._addBounds(
                    b[Y],
                    b[Y + 4],
                    p[Y + 2],
                    p[Y],
                    Y,
                    d ? d[Y] : 0,
                    S,
                    L,
                    E
                  );
                var k = b;
                b = p, p = k;
              }
              for (var T = 1, G = i.length; T < G; T++)
                A(i[T]);
              return r && A(v), new P(S[0], S[1], L[0] - S[0], L[1] - S[1]);
            },
            getStrokeBounds: function(i, r, a, l, u) {
              var d = a.getStyle(), v = d.hasStroke(), p = d.getStrokeWidth(), b = v && a._getStrokeMatrix(l, u), S = v && We._getStrokePadding(
                p,
                b
              ), L = We.getBounds(
                i,
                r,
                a,
                l,
                u,
                S
              );
              if (!v)
                return L;
              var E = p / 2, A = d.getStrokeJoin(), T = d.getStrokeCap(), G = d.getMiterLimit(), D = new P(new V(S));
              function Y(q) {
                L = L.include(q);
              }
              function k(q) {
                L = L.unite(
                  D.setCenter(q._point.transform(l))
                );
              }
              function z(q, H) {
                H === "round" || q.isSmooth() ? k(q) : We._addBevelJoin(
                  q,
                  H,
                  E,
                  G,
                  l,
                  b,
                  Y
                );
              }
              function C(q, H) {
                H === "round" ? k(q) : We._addSquareCap(
                  q,
                  H,
                  E,
                  l,
                  b,
                  Y
                );
              }
              var O = i.length - (r ? 0 : 1);
              if (O > 0) {
                for (var j = 1; j < O; j++)
                  z(i[j], A);
                r ? z(i[0], A) : (C(i[0], T), C(i[i.length - 1], T));
              }
              return L;
            },
            _getStrokePadding: function(i, r) {
              if (!r)
                return [i, i];
              var a = new M(i, 0).transform(r), l = new M(0, i).transform(r), u = a.getAngleInRadians(), d = a.getLength(), v = l.getLength(), p = Math.sin(u), b = Math.cos(u), S = Math.tan(u), L = Math.atan2(v * S, d), E = Math.atan2(v, S * d);
              return [
                Math.abs(d * Math.cos(L) * b + v * Math.sin(L) * p),
                Math.abs(v * Math.sin(E) * b + d * Math.cos(E) * p)
              ];
            },
            _addBevelJoin: function(i, r, a, l, u, d, v, p) {
              var b = i.getCurve(), S = b.getPrevious(), L = b.getPoint1().transform(u), E = S.getNormalAtTime(1).multiply(a).transform(d), A = b.getNormalAtTime(0).multiply(a).transform(d), T = E.getDirectedAngle(A);
              if ((T < 0 || T >= 180) && (E = E.negate(), A = A.negate()), p && v(L), v(L.add(E)), r === "miter") {
                var G = new le(
                  L.add(E),
                  new M(-E.y, E.x),
                  !0
                ).intersect(new le(
                  L.add(A),
                  new M(-A.y, A.x),
                  !0
                ), !0);
                G && L.getDistance(G) <= l * a && v(G);
              }
              v(L.add(A));
            },
            _addSquareCap: function(i, r, a, l, u, d, v) {
              var p = i._point.transform(l), b = i.getLocation(), S = b.getNormal().multiply(b.getTime() === 0 ? a : -a).transform(u);
              r === "square" && (v && (d(p.subtract(S)), d(p.add(S))), p = p.add(S.rotate(-90))), d(p.add(S)), d(p.subtract(S));
            },
            getHandleBounds: function(i, r, a, l, u) {
              var d = a.getStyle(), v = u.stroke && d.hasStroke(), p, b;
              if (v) {
                var S = a._getStrokeMatrix(l, u), L = d.getStrokeWidth() / 2, E = L;
                d.getStrokeJoin() === "miter" && (E = L * d.getMiterLimit()), d.getStrokeCap() === "square" && (E = Math.max(E, L * Math.SQRT2)), p = We._getStrokePadding(L, S), b = We._getStrokePadding(E, S);
              }
              for (var A = new Array(6), T = 1 / 0, G = -T, D = T, Y = G, k = 0, z = i.length; k < z; k++) {
                var C = i[k];
                C._transformCoordinates(l, A);
                for (var O = 0; O < 6; O += 2) {
                  var j = O ? p : b, q = j ? j[0] : 0, H = j ? j[1] : 0, ie = A[O], ae = A[O + 1], ue = ie - q, me = ie + q, se = ae - H, de = ae + H;
                  ue < T && (T = ue), me > G && (G = me), se < D && (D = se), de > Y && (Y = de);
                }
              }
              return new P(T, D, G - T, Y - D);
            }
          }
        }
      );
      We.inject({ statics: new function() {
        var i = 0.5522847498307936, r = [
          new ce([-1, 0], [0, i], [0, -i]),
          new ce([0, -1], [-i, 0], [i, 0]),
          new ce([1, 0], [0, -i], [0, i]),
          new ce([0, 1], [i, 0], [-i, 0])
        ];
        function a(u, d, v) {
          var p = o.getNamed(v), b = new We(p && (p.insert == !0 ? X.INSERT : p.insert == !1 ? X.NO_INSERT : null));
          return b._add(u), b._closed = d, b.set(p, X.INSERT);
        }
        function l(u, d, v) {
          for (var p = new Array(4), b = 0; b < 4; b++) {
            var S = r[b];
            p[b] = new ce(
              S._point.multiply(d).add(u),
              S._handleIn.multiply(d),
              S._handleOut.multiply(d)
            );
          }
          return a(p, !0, v);
        }
        return {
          Line: function() {
            var u = arguments;
            return a([
              new ce(M.readNamed(u, "from")),
              new ce(M.readNamed(u, "to"))
            ], !1, u);
          },
          Circle: function() {
            var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "radius");
            return l(d, new V(v), u);
          },
          Rectangle: function() {
            var u = arguments, d = P.readNamed(u, "rectangle"), v = V.readNamed(
              u,
              "radius",
              0,
              { readNull: !0 }
            ), p = d.getBottomLeft(!0), b = d.getTopLeft(!0), S = d.getTopRight(!0), L = d.getBottomRight(!0), E;
            if (!v || v.isZero())
              E = [
                new ce(p),
                new ce(b),
                new ce(S),
                new ce(L)
              ];
            else {
              v = V.min(v, d.getSize(!0).divide(2));
              var A = v.width, T = v.height, G = A * i, D = T * i;
              E = [
                new ce(p.add(A, 0), null, [-G, 0]),
                new ce(p.subtract(0, T), [0, D]),
                new ce(b.add(0, T), null, [0, -D]),
                new ce(b.add(A, 0), [-G, 0], null),
                new ce(S.subtract(A, 0), null, [G, 0]),
                new ce(S.add(0, T), [0, -D], null),
                new ce(L.subtract(0, T), null, [0, D]),
                new ce(L.subtract(A, 0), [G, 0])
              ];
            }
            return a(E, !0, u);
          },
          RoundRectangle: "#Rectangle",
          Ellipse: function() {
            var u = arguments, d = Ee._readEllipse(u);
            return l(d.center, d.radius, u);
          },
          Oval: "#Ellipse",
          Arc: function() {
            var u = arguments, d = M.readNamed(u, "from"), v = M.readNamed(u, "through"), p = M.readNamed(u, "to"), b = o.getNamed(u), S = new We(b && b.insert == !1 && X.NO_INSERT);
            return S.moveTo(d), S.arcTo(v, p), S.set(b);
          },
          RegularPolygon: function() {
            for (var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "sides"), p = o.readNamed(u, "radius"), b = 360 / v, S = v % 3 === 0, L = new M(0, S ? -p : p), E = S ? -1 : 0.5, A = new Array(v), T = 0; T < v; T++)
              A[T] = new ce(d.add(
                L.rotate((T + E) * b)
              ));
            return a(A, !0, u);
          },
          Star: function() {
            for (var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "points") * 2, p = o.readNamed(u, "radius1"), b = o.readNamed(u, "radius2"), S = 360 / v, L = new M(0, -1), E = new Array(v), A = 0; A < v; A++)
              E[A] = new ce(d.add(L.rotate(S * A).multiply(A % 2 ? b : p)));
            return a(E, !0, u);
          }
        };
      }() });
      var Et = qt.extend(
        {
          _class: "CompoundPath",
          _serializeFields: {
            children: []
          },
          beans: !0,
          initialize: function(i) {
            this._children = [], this._namedChildren = {}, this._initialize(i) || (typeof i == "string" ? this.setPathData(i) : this.addChildren(Array.isArray(i) ? i : arguments));
          },
          insertChildren: function i(r, a) {
            var l = a, u = l[0];
            u && typeof u[0] == "number" && (l = [l]);
            for (var d = a.length - 1; d >= 0; d--) {
              var v = l[d];
              l === a && !(v instanceof We) && (l = o.slice(l)), Array.isArray(v) ? l[d] = new We({ segments: v, insert: !1 }) : v instanceof Et && (l.splice.apply(l, [d, 1].concat(v.removeChildren())), v.remove());
            }
            return i.base.call(this, r, l);
          },
          reduce: function i(r) {
            for (var a = this._children, l = a.length - 1; l >= 0; l--) {
              var u = a[l].reduce(r);
              u.isEmpty() && u.remove();
            }
            if (!a.length) {
              var u = new We(X.NO_INSERT);
              return u.copyAttributes(this), u.insertAbove(this), this.remove(), u;
            }
            return i.base.call(this);
          },
          isClosed: function() {
            for (var i = this._children, r = 0, a = i.length; r < a; r++)
              if (!i[r]._closed)
                return !1;
            return !0;
          },
          setClosed: function(i) {
            for (var r = this._children, a = 0, l = r.length; a < l; a++)
              r[a].setClosed(i);
          },
          getFirstSegment: function() {
            var i = this.getFirstChild();
            return i && i.getFirstSegment();
          },
          getLastSegment: function() {
            var i = this.getLastChild();
            return i && i.getLastSegment();
          },
          getCurves: function() {
            for (var i = this._children, r = [], a = 0, l = i.length; a < l; a++)
              o.push(r, i[a].getCurves());
            return r;
          },
          getFirstCurve: function() {
            var i = this.getFirstChild();
            return i && i.getFirstCurve();
          },
          getLastCurve: function() {
            var i = this.getLastChild();
            return i && i.getLastCurve();
          },
          getArea: function() {
            for (var i = this._children, r = 0, a = 0, l = i.length; a < l; a++)
              r += i[a].getArea();
            return r;
          },
          getLength: function() {
            for (var i = this._children, r = 0, a = 0, l = i.length; a < l; a++)
              r += i[a].getLength();
            return r;
          },
          getPathData: function(i, r) {
            for (var a = this._children, l = [], u = 0, d = a.length; u < d; u++) {
              var v = a[u], p = v._matrix;
              l.push(v.getPathData(i && !p.isIdentity() ? i.appended(p) : i, r));
            }
            return l.join("");
          },
          _hitTestChildren: function i(r, a, l) {
            return i.base.call(
              this,
              r,
              a.class === We || a.type === "path" ? a : o.set({}, a, { fill: !1 }),
              l
            );
          },
          _draw: function(i, r, a, l) {
            var u = this._children;
            if (u.length) {
              r = r.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
              for (var d = 0, v = u.length; d < v; d++)
                u[d].draw(i, r, l);
              if (!r.clip) {
                this._setStyles(i, r, a);
                var p = this._style;
                p.hasFill() && (i.fill(p.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), p.hasStroke() && i.stroke();
              }
            }
          },
          _drawSelected: function(i, r, a) {
            for (var l = this._children, u = 0, d = l.length; u < d; u++) {
              var v = l[u], p = v._matrix;
              a[v._id] || v._drawSelected(i, p.isIdentity() ? r : r.appended(p));
            }
          }
        },
        new function() {
          function i(r, a) {
            var l = r._children;
            if (a && !l.length)
              throw new Error("Use a moveTo() command first");
            return l[l.length - 1];
          }
          return o.each(
            [
              "lineTo",
              "cubicCurveTo",
              "quadraticCurveTo",
              "curveTo",
              "arcTo",
              "lineBy",
              "cubicCurveBy",
              "quadraticCurveBy",
              "curveBy",
              "arcBy"
            ],
            function(r) {
              this[r] = function() {
                var a = i(this, !0);
                a[r].apply(a, arguments);
              };
            },
            {
              moveTo: function() {
                var r = i(this), a = r && r.isEmpty() ? r : new We(X.NO_INSERT);
                a !== r && this.addChild(a), a.moveTo.apply(a, arguments);
              },
              moveBy: function() {
                var r = i(this, !0), a = r && r.getLastSegment(), l = M.read(arguments);
                this.moveTo(a ? l.add(a._point) : l);
              },
              closePath: function(r) {
                i(this, !0).closePath(r);
              }
            }
          );
        }(),
        o.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
          this[i] = function(r) {
            for (var a = this._children, l, u = 0, d = a.length; u < d; u++)
              l = a[u][i](r) || l;
            return l;
          };
        }, {})
      );
      qt.inject(new function() {
        var i = Math.min, r = Math.max, a = Math.abs, l = {
          unite: { 1: !0, 2: !0 },
          intersect: { 2: !0 },
          subtract: { 1: !0 },
          exclude: { 1: !0, "-1": !0 }
        };
        function u(k) {
          return k._children || [k];
        }
        function d(k, z) {
          var C = k.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
          if (z) {
            for (var O = u(C), j = 0, q = O.length; j < q; j++) {
              var k = O[j];
              !k._closed && !k.isEmpty() && (k.closePath(1e-12), k.getFirstSegment().setHandleIn(0, 0), k.getLastSegment().setHandleOut(0, 0));
            }
            C = C.resolveCrossings().reorient(C.getFillRule() === "nonzero", !0);
          }
          return C;
        }
        function v(k, z, C, O, j) {
          var q = new Et(X.NO_INSERT);
          return q.addChildren(k, !0), q = q.reduce({ simplify: z }), j && j.insert == !1 || q.insertAbove(O && C.isSibling(O) && C.getIndex() < O.getIndex() ? O : C), q.copyAttributes(C, !0), q;
        }
        function p(k) {
          return k.hasOverlap() || k.isCrossing();
        }
        function b(k, z, C, O) {
          if (O && (O.trace == !1 || O.stroke) && /^(subtract|intersect)$/.test(C))
            return S(k, z, C);
          var j = d(k, !0), q = z && k !== z && d(z, !0), H = l[C];
          H[C] = !0, q && (H.subtract || H.exclude) ^ (q.isClockwise() ^ j.isClockwise()) && q.reverse();
          var ie = T(pt.expand(
            j.getIntersections(q, p)
          )), ae = u(j), ue = q && u(q), me = [], se = [], de;
          function ve(bt) {
            for (var Rt = 0, It = bt.length; Rt < It; Rt++) {
              var Ht = bt[Rt];
              o.push(me, Ht._segments), o.push(se, Ht.getCurves()), Ht._overlapsOnly = !0;
            }
          }
          function we(bt) {
            for (var Rt = [], It = 0, Ht = bt && bt.length; It < Ht; It++)
              Rt.push(se[bt[It]]);
            return Rt;
          }
          if (ie.length) {
            ve(ae), ue && ve(ue);
            for (var Se = new Array(se.length), Ae = 0, Ge = se.length; Ae < Ge; Ae++)
              Se[Ae] = se[Ae].getValues();
            for (var et = x.findCurveBoundsCollisions(
              Se,
              Se,
              0,
              !0
            ), st = {}, Ae = 0; Ae < se.length; Ae++) {
              var _t = se[Ae], Re = _t._path._id, Fe = st[Re] = st[Re] || {};
              Fe[_t.getIndex()] = {
                hor: we(et[Ae].hor),
                ver: we(et[Ae].ver)
              };
            }
            for (var Ae = 0, Ge = ie.length; Ae < Ge; Ae++)
              D(
                ie[Ae]._segment,
                j,
                q,
                st,
                H
              );
            for (var Ae = 0, Ge = me.length; Ae < Ge; Ae++) {
              var at = me[Ae], yt = at._intersection;
              at._winding || D(
                at,
                j,
                q,
                st,
                H
              ), yt && yt._overlap || (at._path._overlapsOnly = !1);
            }
            de = Y(me, H);
          } else
            de = A(
              ue ? ae.concat(ue) : ae.slice(),
              function(bt) {
                return !!H[bt];
              }
            );
          return v(de, !0, k, z, O);
        }
        function S(k, z, C) {
          var O = d(k), j = d(z), q = O.getIntersections(j, p), H = C === "subtract", ie = C === "divide", ae = {}, ue = [];
          function me(ve) {
            if (!ae[ve._id] && (ie || j.contains(ve.getPointAt(ve.getLength() / 2)) ^ H))
              return ue.unshift(ve), ae[ve._id] = !0;
          }
          for (var se = q.length - 1; se >= 0; se--) {
            var de = q[se].split();
            de && (me(de) && de.getFirstSegment().setHandleIn(0, 0), O.getLastSegment().setHandleOut(0, 0));
          }
          return me(O), v(ue, !1, k, z);
        }
        function L(k, z) {
          for (var C = k; C; ) {
            if (C === z)
              return;
            C = C._previous;
          }
          for (; k._next && k._next !== z; )
            k = k._next;
          if (!k._next) {
            for (; z._previous; )
              z = z._previous;
            k._next = z, z._previous = k;
          }
        }
        function E(k) {
          for (var z = k.length - 1; z >= 0; z--)
            k[z].clearHandles();
        }
        function A(k, z, C) {
          var O = k && k.length;
          if (O) {
            var j = o.each(k, function(et, st) {
              this[et._id] = {
                container: null,
                winding: et.isClockwise() ? 1 : -1,
                index: st
              };
            }, {}), q = k.slice().sort(function(et, st) {
              return a(st.getArea()) - a(et.getArea());
            }), H = q[0], ie = x.findItemBoundsCollisions(
              q,
              null,
              I.GEOMETRIC_EPSILON
            );
            C == null && (C = H.isClockwise());
            for (var ae = 0; ae < O; ae++) {
              var ue = q[ae], me = j[ue._id], se = 0, de = ie[ae];
              if (de) {
                for (var ve = null, we = de.length - 1; we >= 0; we--)
                  if (de[we] < ae) {
                    ve = ve || ue.getInteriorPoint();
                    var Se = q[de[we]];
                    if (Se.contains(ve)) {
                      var Ae = j[Se._id];
                      se = Ae.winding, me.winding += se, me.container = Ae.exclude ? Ae.container : Se;
                      break;
                    }
                  }
              }
              if (z(me.winding) === z(se))
                me.exclude = !0, k[me.index] = null;
              else {
                var Ge = me.container;
                ue.setClockwise(
                  Ge ? !Ge.isClockwise() : C
                );
              }
            }
          }
          return k;
        }
        function T(k, z, C) {
          var O = z && [], j = 1e-8, q = 1 - j, H = !1, ie = C || [], ae = C && {}, ue, me, se;
          function de(Rt) {
            return Rt._path._id + "." + Rt._segment1._index;
          }
          for (var ve = (C && C.length) - 1; ve >= 0; ve--) {
            var we = C[ve];
            we._path && (ae[de(we)] = !0);
          }
          for (var ve = k.length - 1; ve >= 0; ve--) {
            var Se = k[ve], Ae = Se._time, Ge = Ae, et = z && !z(Se), we = Se._curve, st;
            if (we && (we !== me ? (H = !we.hasHandles() || ae && ae[de(we)], ue = [], se = null, me = we) : se >= j && (Ae /= se)), et) {
              ue && ue.push(Se);
              continue;
            } else
              z && O.unshift(Se);
            if (se = Ge, Ae < j)
              st = we._segment1;
            else if (Ae > q)
              st = we._segment2;
            else {
              var _t = we.divideAtTime(Ae, !0);
              H && ie.push(we, _t), st = _t._segment1;
              for (var Re = ue.length - 1; Re >= 0; Re--) {
                var Fe = ue[Re];
                Fe._time = (Fe._time - Ae) / (1 - Ae);
              }
            }
            Se._setSegment(st);
            var at = st._intersection, yt = Se._intersection;
            if (at) {
              L(at, yt);
              for (var bt = at; bt; )
                L(bt._intersection, at), bt = bt._next;
            } else
              st._intersection = yt;
          }
          return C || E(ie), O || k;
        }
        function G(k, z, C, O, j) {
          var q = Array.isArray(z) ? z : z[C ? "hor" : "ver"], H = C ? 1 : 0, ie = H ^ 1, ae = [k.x, k.y], ue = ae[H], me = ae[ie], se = 1e-9, de = 1e-6, ve = ue - se, we = ue + se, Se = 0, Ae = 0, Ge = 0, et = 0, st = !1, _t = !1, Re = 1, Fe = [], at, yt;
          function bt(si) {
            var Nt = si[ie + 0], Vi = si[ie + 6];
            if (!(me < i(Nt, Vi) || me > r(Nt, Vi))) {
              var ci = si[H + 0], nn = si[H + 2], Yi = si[H + 4], qi = si[H + 6];
              if (Nt === Vi) {
                (ci < we && qi > ve || qi < we && ci > ve) && (st = !0);
                return;
              }
              var Qi = me === Nt ? 0 : me === Vi || ve > r(ci, nn, Yi, qi) || we < i(ci, nn, Yi, qi) ? 1 : ze.solveCubic(si, ie, me, Fe, 0, 1) > 0 ? Fe[0] : 1, Gi = Qi === 0 ? ci : Qi === 1 ? qi : ze.getPoint(si, Qi)[C ? "y" : "x"], Xi = Nt > Vi ? 1 : -1, _n = at[ie] > at[ie + 6] ? 1 : -1, Ki = at[H + 6];
              return me !== Nt ? (Gi < ve ? Ge += Xi : Gi > we ? et += Xi : st = !0, Gi > ue - de && Gi < ue + de && (Re /= 2)) : (Xi !== _n ? ci < ve ? Ge += Xi : ci > we && (et += Xi) : ci != Ki && (Ki < we && Gi > we ? (et += Xi, st = !0) : Ki > ve && Gi < ve && (Ge += Xi, st = !0)), Re /= 4), at = si, !j && Gi > ve && Gi < we && ze.getTangent(si, Qi)[C ? "x" : "y"] === 0 && G(k, z, !C, O, !0);
            }
          }
          function Rt(si) {
            var Nt = si[ie + 0], Vi = si[ie + 2], ci = si[ie + 4], nn = si[ie + 6];
            if (me <= r(Nt, Vi, ci, nn) && me >= i(Nt, Vi, ci, nn)) {
              for (var Yi = si[H + 0], qi = si[H + 2], Qi = si[H + 4], Gi = si[H + 6], Xi = ve > r(Yi, qi, Qi, Gi) || we < i(Yi, qi, Qi, Gi) ? [si] : ze.getMonoCurves(si, C), _n, Ki = 0, cn = Xi.length; Ki < cn; Ki++)
                if (_n = bt(Xi[Ki]))
                  return _n;
            }
          }
          for (var It = 0, Ht = q.length; It < Ht; It++) {
            var jt = q[It], Vt = jt._path, Ti = jt.getValues(), ki;
            if ((!It || q[It - 1]._path !== Vt) && (at = null, Vt._closed || (yt = ze.getValues(
              Vt.getLastCurve().getSegment2(),
              jt.getSegment1(),
              null,
              !O
            ), yt[ie] !== yt[ie + 6] && (at = yt)), !at)) {
              at = Ti;
              for (var Li = Vt.getLastCurve(); Li && Li !== jt; ) {
                var bi = Li.getValues();
                if (bi[ie] !== bi[ie + 6]) {
                  at = bi;
                  break;
                }
                Li = Li.getPrevious();
              }
            }
            if (ki = Rt(Ti))
              return ki;
            if (It + 1 === Ht || q[It + 1]._path !== Vt) {
              if (yt && (ki = Rt(yt)))
                return ki;
              st && !Ge && !et && (Ge = et = Vt.isClockwise(O) ^ C ? 1 : -1), Se += Ge, Ae += et, Ge = et = 0, st && (_t = !0, st = !1), yt = null;
            }
          }
          return Se = a(Se), Ae = a(Ae), {
            winding: r(Se, Ae),
            windingL: Se,
            windingR: Ae,
            quality: Re,
            onPath: _t
          };
        }
        function D(k, z, C, O, j) {
          var q = [], H = k, ie = 0, ae;
          do {
            var ue = k.getCurve();
            if (ue) {
              var me = ue.getLength();
              q.push({ segment: k, curve: ue, length: me }), ie += me;
            }
            k = k.getNext();
          } while (k && !k._intersection && k !== H);
          for (var se = [0.5, 0.25, 0.75], ae = { winding: 0, quality: -1 }, de = 1e-3, ve = 1 - de, we = 0; we < se.length && ae.quality < 0.5; we++)
            for (var me = ie * se[we], Se = 0, Ae = q.length; Se < Ae; Se++) {
              var Ge = q[Se], et = Ge.length;
              if (me <= et) {
                var ue = Ge.curve, st = ue._path, _t = st._parent, Re = _t instanceof Et ? _t : st, Fe = I.clamp(ue.getTimeAt(me), de, ve), at = ue.getPointAtTime(Fe), yt = a(ue.getTangentAtTime(Fe).y) < Math.SQRT1_2, bt = null;
                if (j.subtract && C) {
                  var Rt = Re === z ? C : z, It = Rt._getWinding(at, yt, !0);
                  if (Re === z && It.winding || Re === C && !It.winding) {
                    if (It.quality < 1)
                      continue;
                    bt = { winding: 0, quality: 1 };
                  }
                }
                bt = bt || G(
                  at,
                  O[st._id][ue.getIndex()],
                  yt,
                  !0
                ), bt.quality > ae.quality && (ae = bt);
                break;
              }
              me -= et;
            }
          for (var Se = q.length - 1; Se >= 0; Se--)
            q[Se].segment._winding = ae;
        }
        function Y(k, z) {
          var C = [], O;
          function j(Ht) {
            var jt;
            return !!(Ht && !Ht._visited && (!z || z[(jt = Ht._winding || {}).winding] && !(z.unite && jt.winding === 2 && jt.windingL && jt.windingR)));
          }
          function q(Ht) {
            if (Ht) {
              for (var jt = 0, Vt = O.length; jt < Vt; jt++)
                if (Ht === O[jt])
                  return !0;
            }
            return !1;
          }
          function H(Ht) {
            for (var jt = Ht._segments, Vt = 0, Ti = jt.length; Vt < Ti; Vt++)
              jt[Vt]._visited = !0;
          }
          function ie(Ht, jt) {
            var Vt = Ht._intersection, Ti = Vt, ki = [];
            jt && (O = [Ht]);
            function Li(bi, si) {
              for (; bi && bi !== si; ) {
                var Nt = bi._segment, Vi = Nt && Nt._path;
                if (Vi) {
                  var ci = Nt.getNext() || Vi.getFirstSegment(), nn = ci._intersection;
                  Nt !== Ht && (q(Nt) || q(ci) || ci && j(Nt) && (j(ci) || nn && j(nn._segment))) && ki.push(Nt), jt && O.push(Nt);
                }
                bi = bi._next;
              }
            }
            if (Vt) {
              for (Li(Vt); Vt && Vt._previous; )
                Vt = Vt._previous;
              Li(Vt, Ti);
            }
            return ki;
          }
          k.sort(function(Ht, jt) {
            var Vt = Ht._intersection, Ti = jt._intersection, ki = !!(Vt && Vt._overlap), Li = !!(Ti && Ti._overlap), bi = Ht._path, si = jt._path;
            return ki ^ Li ? ki ? 1 : -1 : !Vt ^ !Ti ? Vt ? 1 : -1 : bi !== si ? bi._id - si._id : Ht._index - jt._index;
          });
          for (var ae = 0, ue = k.length; ae < ue; ae++) {
            var me = k[ae], se = j(me), de = null, ve = !1, we = !0, Se = [], Ae, Ge, et;
            if (se && me._path._overlapsOnly) {
              var st = me._path, _t = me._intersection._segment._path;
              st.compare(_t) && (st.getArea() && C.push(st.clone(!1)), H(st), H(_t), se = !1);
            }
            for (; se; ) {
              var Re = !de, Fe = ie(me, Re), at = Fe.shift(), ve = !Re && (q(me) || q(at)), yt = !ve && at;
              if (Re && (de = new We(X.NO_INSERT), Ae = null), ve) {
                (me.isFirst() || me.isLast()) && (we = me._path._closed), me._visited = !0;
                break;
              }
              if (yt && Ae && (Se.push(Ae), Ae = null), Ae || (yt && Fe.push(me), Ae = {
                start: de._segments.length,
                crossings: Fe,
                visited: Ge = [],
                handleIn: et
              }), yt && (me = at), !j(me)) {
                de.removeSegments(Ae.start);
                for (var bt = 0, Rt = Ge.length; bt < Rt; bt++)
                  Ge[bt]._visited = !1;
                Ge.length = 0;
                do
                  me = Ae && Ae.crossings.shift(), (!me || !me._path) && (me = null, Ae = Se.pop(), Ae && (Ge = Ae.visited, et = Ae.handleIn));
                while (Ae && !j(me));
                if (!me)
                  break;
              }
              var It = me.getNext();
              de.add(new ce(
                me._point,
                et,
                It && me._handleOut
              )), me._visited = !0, Ge.push(me), me = It || me._path.getFirstSegment(), et = It && It._handleIn;
            }
            ve && (we && (de.getFirstSegment().setHandleIn(et), de.setClosed(we)), de.getArea() !== 0 && C.push(de));
          }
          return C;
        }
        return {
          _getWinding: function(k, z, C) {
            return G(k, this.getCurves(), z, C);
          },
          unite: function(k, z) {
            return b(this, k, "unite", z);
          },
          intersect: function(k, z) {
            return b(this, k, "intersect", z);
          },
          subtract: function(k, z) {
            return b(this, k, "subtract", z);
          },
          exclude: function(k, z) {
            return b(this, k, "exclude", z);
          },
          divide: function(k, z) {
            return z && (z.trace == !1 || z.stroke) ? S(this, k, "divide") : v([
              this.subtract(k, z),
              this.intersect(k, z)
            ], !0, this, k, z);
          },
          resolveCrossings: function() {
            var k = this._children, z = k || [this];
            function C(Ae, Ge) {
              var et = Ae && Ae._intersection;
              return et && et._overlap && et._path === Ge;
            }
            var O = !1, j = !1, q = this.getIntersections(null, function(Ae) {
              return Ae.hasOverlap() && (O = !0) || Ae.isCrossing() && (j = !0);
            }), H = O && j && [];
            if (q = pt.expand(q), O)
              for (var ie = T(q, function(Ae) {
                return Ae.hasOverlap();
              }, H), ae = ie.length - 1; ae >= 0; ae--) {
                var ue = ie[ae], me = ue._path, se = ue._segment, de = se.getPrevious(), ve = se.getNext();
                C(de, me) && C(ve, me) && (se.remove(), de._handleOut._set(0, 0), ve._handleIn._set(0, 0), de !== se && !de.getCurve().hasLength() && (ve._handleIn.set(de._handleIn), de.remove()));
              }
            j && (T(q, O && function(Ae) {
              var Ge = Ae.getCurve(), et = Ae.getSegment(), st = Ae._intersection, _t = st._curve, Re = st._segment;
              if (Ge && _t && Ge._path && _t._path)
                return !0;
              et && (et._intersection = null), Re && (Re._intersection = null);
            }, H), H && E(H), z = Y(o.each(z, function(Ae) {
              o.push(this, Ae._segments);
            }, [])));
            var we = z.length, Se;
            return we > 1 && k ? (z !== k && this.setChildren(z), Se = this) : we === 1 && !k && (z[0] !== this && this.setSegments(z[0].removeSegments()), Se = this), Se || (Se = new Et(X.NO_INSERT), Se.addChildren(z), Se = Se.reduce(), Se.copyAttributes(this), this.replaceWith(Se)), Se;
          },
          reorient: function(k, z) {
            var C = this._children;
            return C && C.length ? this.setChildren(A(
              this.removeChildren(),
              function(O) {
                return !!(k ? O : O & 1);
              },
              z
            )) : z !== t && this.setClockwise(z), this;
          },
          getInteriorPoint: function() {
            var k = this.getBounds(), z = k.getCenter(!0);
            if (!this.contains(z)) {
              for (var C = this.getCurves(), O = z.y, j = [], q = [], H = 0, ie = C.length; H < ie; H++) {
                var ae = C[H].getValues(), ue = ae[1], me = ae[3], se = ae[5], de = ae[7];
                if (O >= i(ue, me, se, de) && O <= r(ue, me, se, de))
                  for (var ve = ze.getMonoCurves(ae), we = 0, Se = ve.length; we < Se; we++) {
                    var Ae = ve[we], Ge = Ae[1], et = Ae[7];
                    if (Ge !== et && (O >= Ge && O <= et || O >= et && O <= Ge)) {
                      var st = O === Ge ? Ae[0] : O === et ? Ae[6] : ze.solveCubic(Ae, 1, O, q, 0, 1) === 1 ? ze.getPoint(Ae, q[0]).x : (Ae[0] + Ae[6]) / 2;
                      j.push(st);
                    }
                  }
              }
              j.length > 1 && (j.sort(function(_t, Re) {
                return _t - Re;
              }), z.x = (j[0] + j[1]) / 2);
            }
            return z;
          }
        };
      }());
      var rt = o.extend(
        {
          _class: "PathFlattener",
          initialize: function(i, r, a, l, u) {
            var d = [], v = [], p = 0, b = 1 / (a || 32), S = i._segments, L = S[0], E;
            function A(Y, k) {
              var z = ze.getValues(Y, k, u);
              d.push(z), T(z, Y._index, 0, 1);
            }
            function T(Y, k, z, C) {
              if (C - z > b && !(l && ze.isStraight(Y)) && !ze.isFlatEnough(Y, r || 0.25)) {
                var O = ze.subdivide(Y, 0.5), j = (z + C) / 2;
                T(O[0], k, z, j), T(O[1], k, j, C);
              } else {
                var q = Y[6] - Y[0], H = Y[7] - Y[1], ie = Math.sqrt(q * q + H * H);
                ie > 0 && (p += ie, v.push({
                  offset: p,
                  curve: Y,
                  index: k,
                  time: C
                }));
              }
            }
            for (var G = 1, D = S.length; G < D; G++)
              E = S[G], A(L, E), L = E;
            i._closed && A(E || L, S[0]), this.curves = d, this.parts = v, this.length = p, this.index = 0;
          },
          _get: function(i) {
            for (var r = this.parts, a = r.length, l, u = this.index; l = u, !(!u || r[--u].offset < i); )
              ;
            for (; l < a; l++) {
              var d = r[l];
              if (d.offset >= i) {
                this.index = l;
                var v = r[l - 1], p = v && v.index === d.index ? v.time : 0, b = v ? v.offset : 0;
                return {
                  index: d.index,
                  time: p + (d.time - p) * (i - b) / (d.offset - b)
                };
              }
            }
            return {
              index: r[a - 1].index,
              time: 1
            };
          },
          drawPart: function(i, r, a) {
            for (var l = this._get(r), u = this._get(a), d = l.index, v = u.index; d <= v; d++) {
              var p = ze.getPart(
                this.curves[d],
                d === l.index ? l.time : 0,
                d === u.index ? u.time : 1
              );
              d === l.index && i.moveTo(p[0], p[1]), i.bezierCurveTo.apply(i, p.slice(2));
            }
          }
        },
        o.each(
          ze._evaluateMethods,
          function(i) {
            this[i + "At"] = function(r) {
              var a = this._get(r);
              return ze[i](this.curves[a.index], a.time);
            };
          },
          {}
        )
      ), it = o.extend({
        initialize: function(i) {
          for (var r = this.points = [], a = i._segments, l = i._closed, u = 0, d, v = a.length; u < v; u++) {
            var p = a[u].point;
            (!d || !d.equals(p)) && r.push(d = p.clone());
          }
          l && (r.unshift(r[r.length - 1]), r.push(r[1])), this.closed = l;
        },
        fit: function(i) {
          var r = this.points, a = r.length, l = null;
          return a > 0 && (l = [new ce(r[0])], a > 1 && (this.fitCubic(
            l,
            i,
            0,
            a - 1,
            r[1].subtract(r[0]),
            r[a - 2].subtract(r[a - 1])
          ), this.closed && (l.shift(), l.pop()))), l;
        },
        fitCubic: function(i, r, a, l, u, d) {
          var v = this.points;
          if (l - a === 1) {
            var p = v[a], b = v[l], S = p.getDistance(b) / 3;
            this.addCurve(i, [
              p,
              p.add(u.normalize(S)),
              b.add(d.normalize(S)),
              b
            ]);
            return;
          }
          for (var L = this.chordLengthParameterize(a, l), E = Math.max(r, r * r), A, T = !0, G = 0; G <= 4; G++) {
            var D = this.generateBezier(a, l, L, u, d), Y = this.findMaxError(a, l, D, L);
            if (Y.error < r && T) {
              this.addCurve(i, D);
              return;
            }
            if (A = Y.index, Y.error >= E)
              break;
            T = this.reparameterize(a, l, L, D), E = Y.error;
          }
          var k = v[A - 1].subtract(v[A + 1]);
          this.fitCubic(i, r, a, A, u, k), this.fitCubic(i, r, A, l, k.negate(), d);
        },
        addCurve: function(i, r) {
          var a = i[i.length - 1];
          a.setHandleOut(r[1].subtract(r[0])), i.push(new ce(r[3], r[2].subtract(r[3])));
        },
        generateBezier: function(i, r, a, l, u) {
          for (var d = 1e-12, v = Math.abs, p = this.points, b = p[i], S = p[r], L = [[0, 0], [0, 0]], E = [0, 0], A = 0, T = r - i + 1; A < T; A++) {
            var G = a[A], D = 1 - G, Y = 3 * G * D, k = D * D * D, z = Y * D, C = Y * G, O = G * G * G, j = l.normalize(z), q = u.normalize(C), H = p[i + A].subtract(b.multiply(k + z)).subtract(S.multiply(C + O));
            L[0][0] += j.dot(j), L[0][1] += j.dot(q), L[1][0] = L[0][1], L[1][1] += q.dot(q), E[0] += j.dot(H), E[1] += q.dot(H);
          }
          var ie = L[0][0] * L[1][1] - L[1][0] * L[0][1], ae, ue;
          if (v(ie) > d) {
            var me = L[0][0] * E[1] - L[1][0] * E[0], se = E[0] * L[1][1] - E[1] * L[0][1];
            ae = se / ie, ue = me / ie;
          } else {
            var de = L[0][0] + L[0][1], ve = L[1][0] + L[1][1];
            ae = ue = v(de) > d ? E[0] / de : v(ve) > d ? E[1] / ve : 0;
          }
          var we = S.getDistance(b), Se = d * we, Ae, Ge;
          if (ae < Se || ue < Se)
            ae = ue = we / 3;
          else {
            var et = S.subtract(b);
            Ae = l.normalize(ae), Ge = u.normalize(ue), Ae.dot(et) - Ge.dot(et) > we * we && (ae = ue = we / 3, Ae = Ge = null);
          }
          return [
            b,
            b.add(Ae || l.normalize(ae)),
            S.add(Ge || u.normalize(ue)),
            S
          ];
        },
        reparameterize: function(i, r, a, l) {
          for (var u = i; u <= r; u++)
            a[u - i] = this.findRoot(l, this.points[u], a[u - i]);
          for (var u = 1, d = a.length; u < d; u++)
            if (a[u] <= a[u - 1])
              return !1;
          return !0;
        },
        findRoot: function(i, r, a) {
          for (var l = [], u = [], d = 0; d <= 2; d++)
            l[d] = i[d + 1].subtract(i[d]).multiply(3);
          for (var d = 0; d <= 1; d++)
            u[d] = l[d + 1].subtract(l[d]).multiply(2);
          var v = this.evaluate(3, i, a), p = this.evaluate(2, l, a), b = this.evaluate(1, u, a), S = v.subtract(r), L = p.dot(p) + S.dot(b);
          return I.isMachineZero(L) ? a : a - S.dot(p) / L;
        },
        evaluate: function(i, r, a) {
          for (var l = r.slice(), u = 1; u <= i; u++)
            for (var d = 0; d <= i - u; d++)
              l[d] = l[d].multiply(1 - a).add(l[d + 1].multiply(a));
          return l[0];
        },
        chordLengthParameterize: function(i, r) {
          for (var a = [0], l = i + 1; l <= r; l++)
            a[l - i] = a[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
          for (var l = 1, u = r - i; l <= u; l++)
            a[l] /= a[u];
          return a;
        },
        findMaxError: function(i, r, a, l) {
          for (var u = Math.floor((r - i + 1) / 2), d = 0, v = i + 1; v < r; v++) {
            var p = this.evaluate(3, a, l[v - i]), b = p.subtract(this.points[v]), S = b.x * b.x + b.y * b.y;
            S >= d && (d = S, u = v);
          }
          return {
            error: d,
            index: u
          };
        }
      }), Zt = X.extend({
        _class: "TextItem",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _serializeFields: {
          content: null
        },
        _boundsOptions: { stroke: !1, handle: !1 },
        initialize: function(i) {
          this._content = "", this._lines = [];
          var r = i && o.isPlainObject(i) && i.x === t && i.y === t;
          this._initialize(r && i, !r && M.read(arguments));
        },
        _equals: function(i) {
          return this._content === i._content;
        },
        copyContent: function(i) {
          this.setContent(i._content);
        },
        getContent: function() {
          return this._content;
        },
        setContent: function(i) {
          this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
        },
        isEmpty: function() {
          return !this._content;
        },
        getCharacterStyle: "#getStyle",
        setCharacterStyle: "#setStyle",
        getParagraphStyle: "#getStyle",
        setParagraphStyle: "#setStyle"
      }), $t = Zt.extend({
        _class: "PointText",
        initialize: function() {
          Zt.apply(this, arguments);
        },
        getPoint: function() {
          var i = this._matrix.getTranslation();
          return new Z(i.x, i.y, this, "setPoint");
        },
        setPoint: function() {
          var i = M.read(arguments);
          this.translate(i.subtract(this._matrix.getTranslation()));
        },
        _draw: function(i, r, a) {
          if (this._content) {
            this._setStyles(i, r, a);
            var l = this._lines, u = this._style, d = u.hasFill(), v = u.hasStroke(), p = u.getLeading(), b = i.shadowColor;
            i.font = u.getFontStyle(), i.textAlign = u.getJustification();
            for (var S = 0, L = l.length; S < L; S++) {
              i.shadowColor = b;
              var E = l[S];
              d && (i.fillText(E, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), v && i.strokeText(E, 0, 0), i.translate(0, p);
            }
          }
        },
        _getBounds: function(i, r) {
          var a = this._style, l = this._lines, u = l.length, d = a.getJustification(), v = a.getLeading(), p = this.getView().getTextWidth(a.getFontStyle(), l), b = 0;
          d !== "left" && (b -= p / (d === "center" ? 2 : 1));
          var S = new P(
            b,
            u ? -0.75 * v : 0,
            p,
            u * v
          );
          return i ? i._transformBounds(S, S) : S;
        }
      }), Lt = o.extend(
        new function() {
          var i = {
            gray: ["gray"],
            rgb: ["red", "green", "blue"],
            hsb: ["hue", "saturation", "brightness"],
            hsl: ["hue", "saturation", "lightness"],
            gradient: ["gradient", "origin", "destination", "highlight"]
          }, r = {}, a = {
            transparent: [0, 0, 0, 0]
          }, l;
          function u(p) {
            var b = p.match(
              /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
            ) || p.match(
              /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
            ), S = "rgb", L;
            if (b) {
              var E = b[4] ? 4 : 3;
              L = new Array(E);
              for (var A = 0; A < E; A++) {
                var T = b[A + 1];
                L[A] = parseInt(T.length == 1 ? T + T : T, 16) / 255;
              }
            } else if (b = p.match(/^(rgb|hsl)a?\((.*)\)$/)) {
              S = b[1], L = b[2].trim().split(/[,\s]+/g);
              for (var G = S === "hsl", A = 0, D = Math.min(L.length, 4); A < D; A++) {
                var Y = L[A], T = parseFloat(Y);
                if (G)
                  if (A === 0) {
                    var k = Y.match(/([a-z]*)$/)[1];
                    T *= {
                      turn: 360,
                      rad: 180 / Math.PI,
                      grad: 0.9
                    }[k] || 1;
                  } else
                    A < 3 && (T /= 100);
                else
                  A < 3 && (T /= /%$/.test(Y) ? 100 : 255);
                L[A] = T;
              }
            } else {
              var z = a[p];
              if (!z)
                if (n) {
                  l || (l = vt.getContext(1, 1, {
                    willReadFrequently: !0
                  }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = p, l.fillRect(0, 0, 1, 1);
                  var C = l.getImageData(0, 0, 1, 1).data;
                  z = a[p] = [
                    C[0] / 255,
                    C[1] / 255,
                    C[2] / 255
                  ];
                } else
                  z = [0, 0, 0];
              L = z.slice();
            }
            return [S, L];
          }
          var d = [
            [0, 3, 1],
            [2, 0, 1],
            [1, 0, 3],
            [1, 2, 0],
            [3, 1, 0],
            [0, 1, 2]
          ], v = {
            "rgb-hsb": function(p, b, S) {
              var L = Math.max(p, b, S), E = Math.min(p, b, S), A = L - E, T = A === 0 ? 0 : (L == p ? (b - S) / A + (b < S ? 6 : 0) : L == b ? (S - p) / A + 2 : (p - b) / A + 4) * 60;
              return [T, L === 0 ? 0 : A / L, L];
            },
            "hsb-rgb": function(p, b, S) {
              p = (p / 60 % 6 + 6) % 6;
              var E = Math.floor(p), L = p - E, E = d[E], A = [
                S,
                S * (1 - b),
                S * (1 - b * L),
                S * (1 - b * (1 - L))
              ];
              return [A[E[0]], A[E[1]], A[E[2]]];
            },
            "rgb-hsl": function(p, b, S) {
              var L = Math.max(p, b, S), E = Math.min(p, b, S), A = L - E, T = A === 0, G = T ? 0 : (L == p ? (b - S) / A + (b < S ? 6 : 0) : L == b ? (S - p) / A + 2 : (p - b) / A + 4) * 60, D = (L + E) / 2, Y = T ? 0 : D < 0.5 ? A / (L + E) : A / (2 - L - E);
              return [G, Y, D];
            },
            "hsl-rgb": function(p, b, S) {
              if (p = (p / 360 % 1 + 1) % 1, b === 0)
                return [S, S, S];
              for (var L = [p + 1 / 3, p, p - 1 / 3], E = S < 0.5 ? S * (1 + b) : S + b - S * b, A = 2 * S - E, T = [], G = 0; G < 3; G++) {
                var D = L[G];
                D < 0 && (D += 1), D > 1 && (D -= 1), T[G] = 6 * D < 1 ? A + (E - A) * 6 * D : 2 * D < 1 ? E : 3 * D < 2 ? A + (E - A) * (2 / 3 - D) * 6 : A;
              }
              return T;
            },
            "rgb-gray": function(p, b, S) {
              return [p * 0.2989 + b * 0.587 + S * 0.114];
            },
            "gray-rgb": function(p) {
              return [p, p, p];
            },
            "gray-hsb": function(p) {
              return [0, 0, p];
            },
            "gray-hsl": function(p) {
              return [0, 0, p];
            },
            "gradient-rgb": function() {
              return [];
            },
            "rgb-gradient": function() {
              return [];
            }
          };
          return o.each(i, function(p, b) {
            r[b] = [], o.each(p, function(S, L) {
              var E = o.capitalize(S), A = /^(hue|saturation)$/.test(S), T = r[b][L] = b === "gradient" ? S === "gradient" ? function(G) {
                var D = this._components[0];
                return G = ii.read(
                  Array.isArray(G) ? G : arguments,
                  0,
                  { readNull: !0 }
                ), D !== G && (D && D._removeOwner(this), G && G._addOwner(this)), G;
              } : function() {
                return M.read(arguments, 0, {
                  readNull: S === "highlight",
                  clone: !0
                });
              } : function(G) {
                return G == null || isNaN(G) ? 0 : +G;
              };
              this["get" + E] = function() {
                return this._type === b || A && /^hs[bl]$/.test(this._type) ? this._components[L] : this._convert(b)[L];
              }, this["set" + E] = function(G) {
                this._type !== b && !(A && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(b), this._properties = i[b], this._type = b), this._components[L] = T.call(this, G), this._changed();
              };
            }, this);
          }, {
            _class: "Color",
            _readIndex: !0,
            initialize: function p(b) {
              var S = arguments, L = this.__read, E = 0, A, T, G, D;
              Array.isArray(b) && (S = b, b = S[0]);
              var Y = b != null && typeof b;
              if (Y === "string" && b in i && (A = b, b = S[1], Array.isArray(b) ? (T = b, G = S[2]) : (L && (E = 1), S = o.slice(S, 1), Y = typeof b)), !T) {
                if (D = Y === "number" ? S : Y === "object" && b.length != null ? b : null, D) {
                  A || (A = D.length >= 3 ? "rgb" : "gray");
                  var k = i[A].length;
                  G = D[k], L && (E += D === arguments ? k + (G != null ? 1 : 0) : 1), D.length > k && (D = o.slice(D, 0, k));
                } else if (Y === "string") {
                  var z = u(b);
                  A = z[0], T = z[1], T.length === 4 && (G = T[3], T.length--);
                } else if (Y === "object")
                  if (b.constructor === p) {
                    if (A = b._type, T = b._components.slice(), G = b._alpha, A === "gradient")
                      for (var C = 1, O = T.length; C < O; C++) {
                        var j = T[C];
                        j && (T[C] = j.clone());
                      }
                  } else if (b.constructor === ii)
                    A = "gradient", D = S;
                  else {
                    A = "hue" in b ? "lightness" in b ? "hsl" : "hsb" : "gradient" in b || "stops" in b || "radial" in b ? "gradient" : "gray" in b ? "gray" : "rgb";
                    var q = i[A], H = r[A];
                    this._components = T = [];
                    for (var C = 0, O = q.length; C < O; C++) {
                      var ie = b[q[C]];
                      ie == null && !C && A === "gradient" && "stops" in b && (ie = {
                        stops: b.stops,
                        radial: b.radial
                      }), ie = H[C].call(this, ie), ie != null && (T[C] = ie);
                    }
                    G = b.alpha;
                  }
                L && A && (E = 1);
              }
              if (this._type = A || "rgb", !T) {
                this._components = T = [];
                for (var H = r[this._type], C = 0, O = H.length; C < O; C++) {
                  var ie = H[C].call(this, D && D[C]);
                  ie != null && (T[C] = ie);
                }
              }
              return this._components = T, this._properties = i[this._type], this._alpha = G, L && (this.__read = E), this;
            },
            set: "#initialize",
            _serialize: function(p, b) {
              var S = this.getComponents();
              return o.serialize(
                /^(gray|rgb)$/.test(this._type) ? S : [this._type].concat(S),
                p,
                !0,
                b
              );
            },
            _changed: function() {
              this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
            },
            _convert: function(p) {
              var b;
              return this._type === p ? this._components.slice() : (b = v[this._type + "-" + p]) ? b.apply(this, this._components) : v["rgb-" + p].apply(
                this,
                v[this._type + "-rgb"].apply(
                  this,
                  this._components
                )
              );
            },
            convert: function(p) {
              return new Lt(p, this._convert(p), this._alpha);
            },
            getType: function() {
              return this._type;
            },
            setType: function(p) {
              this._components = this._convert(p), this._properties = i[p], this._type = p;
            },
            getComponents: function() {
              var p = this._components.slice();
              return this._alpha != null && p.push(this._alpha), p;
            },
            getAlpha: function() {
              return this._alpha != null ? this._alpha : 1;
            },
            setAlpha: function(p) {
              this._alpha = p == null ? null : Math.min(Math.max(p, 0), 1), this._changed();
            },
            hasAlpha: function() {
              return this._alpha != null;
            },
            equals: function(p) {
              var b = o.isPlainValue(p, !0) ? Lt.read(arguments) : p;
              return b === this || b && this._class === b._class && this._type === b._type && this.getAlpha() === b.getAlpha() && o.equals(this._components, b._components) || !1;
            },
            toString: function() {
              for (var p = this._properties, b = [], S = this._type === "gradient", L = B.instance, E = 0, A = p.length; E < A; E++) {
                var T = this._components[E];
                T != null && b.push(p[E] + ": " + (S ? T : L.number(T)));
              }
              return this._alpha != null && b.push("alpha: " + L.number(this._alpha)), "{ " + b.join(", ") + " }";
            },
            toCSS: function(p) {
              var b = this._convert("rgb"), S = p || this._alpha == null ? 1 : this._alpha;
              function L(E) {
                return Math.round((E < 0 ? 0 : E > 1 ? 1 : E) * 255);
              }
              return b = [
                L(b[0]),
                L(b[1]),
                L(b[2])
              ], S < 1 && b.push(S < 0 ? 0 : S), p ? "#" + ((1 << 24) + (b[0] << 16) + (b[1] << 8) + b[2]).toString(16).slice(1) : (b.length == 4 ? "rgba(" : "rgb(") + b.join(",") + ")";
            },
            toCanvasStyle: function(p, b) {
              if (this._canvasStyle)
                return this._canvasStyle;
              if (this._type !== "gradient")
                return this._canvasStyle = this.toCSS();
              var S = this._components, L = S[0], E = L._stops, A = S[1], T = S[2], G = S[3], D = b && b.inverted(), Y;
              if (D && (A = D._transformPoint(A), T = D._transformPoint(T), G && (G = D._transformPoint(G))), L._radial) {
                var k = T.getDistance(A);
                if (G) {
                  var z = G.subtract(A);
                  z.getLength() > k && (G = A.add(z.normalize(k - 0.1)));
                }
                var C = G || A;
                Y = p.createRadialGradient(
                  C.x,
                  C.y,
                  0,
                  A.x,
                  A.y,
                  k
                );
              } else
                Y = p.createLinearGradient(
                  A.x,
                  A.y,
                  T.x,
                  T.y
                );
              for (var O = 0, j = E.length; O < j; O++) {
                var q = E[O], H = q._offset;
                Y.addColorStop(
                  H ?? O / (j - 1),
                  q._color.toCanvasStyle()
                );
              }
              return this._canvasStyle = Y;
            },
            transform: function(p) {
              if (this._type === "gradient") {
                for (var b = this._components, S = 1, L = b.length; S < L; S++) {
                  var E = b[S];
                  p._transformPoint(E, E, !0);
                }
                this._changed();
              }
            },
            statics: {
              _types: i,
              random: function() {
                var p = Math.random;
                return new Lt(p(), p(), p());
              },
              _setOwner: function(p, b, S) {
                return p && (p._owner && b && p._owner !== b && (p = p.clone()), !p._owner ^ !b && (p._owner = b || null, p._setter = S || null)), p;
              }
            }
          });
        }(),
        new function() {
          var i = {
            add: function(r, a) {
              return r + a;
            },
            subtract: function(r, a) {
              return r - a;
            },
            multiply: function(r, a) {
              return r * a;
            },
            divide: function(r, a) {
              return r / a;
            }
          };
          return o.each(i, function(r, a) {
            this[a] = function(l) {
              l = Lt.read(arguments);
              for (var u = this._type, d = this._components, v = l._convert(u), p = 0, b = d.length; p < b; p++)
                v[p] = r(d[p], v[p]);
              return new Lt(
                u,
                v,
                this._alpha != null ? r(this._alpha, l.getAlpha()) : null
              );
            };
          }, {});
        }()
      ), ii = o.extend({
        _class: "Gradient",
        initialize: function(i, r) {
          this._id = F.get(), i && o.isPlainObject(i) && (this.set(i), i = r = null), this._stops == null && this.setStops(i || ["white", "black"]), this._radial == null && this.setRadial(typeof r == "string" && r === "radial" || r || !1);
        },
        _serialize: function(i, r) {
          return r.add(this, function() {
            return o.serialize(
              [this._stops, this._radial],
              i,
              !0,
              r
            );
          });
        },
        _changed: function() {
          for (var i = 0, r = this._owners && this._owners.length; i < r; i++)
            this._owners[i]._changed();
        },
        _addOwner: function(i) {
          this._owners || (this._owners = []), this._owners.push(i);
        },
        _removeOwner: function(i) {
          var r = this._owners ? this._owners.indexOf(i) : -1;
          r != -1 && (this._owners.splice(r, 1), this._owners.length || (this._owners = t));
        },
        clone: function() {
          for (var i = [], r = 0, a = this._stops.length; r < a; r++)
            i[r] = this._stops[r].clone();
          return new ii(i, this._radial);
        },
        getStops: function() {
          return this._stops;
        },
        setStops: function(i) {
          if (i.length < 2)
            throw new Error(
              "Gradient stop list needs to contain at least two stops."
            );
          var r = this._stops;
          if (r)
            for (var a = 0, l = r.length; a < l; a++)
              r[a]._owner = t;
          r = this._stops = Ci.readList(i, 0, { clone: !0 });
          for (var a = 0, l = r.length; a < l; a++)
            r[a]._owner = this;
          this._changed();
        },
        getRadial: function() {
          return this._radial;
        },
        setRadial: function(i) {
          this._radial = i, this._changed();
        },
        equals: function(i) {
          if (i === this)
            return !0;
          if (i && this._class === i._class) {
            var r = this._stops, a = i._stops, l = r.length;
            if (l === a.length) {
              for (var u = 0; u < l; u++)
                if (!r[u].equals(a[u]))
                  return !1;
              return !0;
            }
          }
          return !1;
        }
      }), Ci = o.extend({
        _class: "GradientStop",
        initialize: function(i, r) {
          var a = i, l = r;
          typeof i == "object" && r === t && (Array.isArray(i) && typeof i[0] != "number" ? (a = i[0], l = i[1]) : ("color" in i || "offset" in i || "rampPoint" in i) && (a = i.color, l = i.offset || i.rampPoint || 0)), this.setColor(a), this.setOffset(l);
        },
        clone: function() {
          return new Ci(this._color.clone(), this._offset);
        },
        _serialize: function(i, r) {
          var a = this._color, l = this._offset;
          return o.serialize(
            l == null ? [a] : [a, l],
            i,
            !0,
            r
          );
        },
        _changed: function() {
          this._owner && this._owner._changed(129);
        },
        getOffset: function() {
          return this._offset;
        },
        setOffset: function(i) {
          this._offset = i, this._changed();
        },
        getRampPoint: "#getOffset",
        setRampPoint: "#setOffset",
        getColor: function() {
          return this._color;
        },
        setColor: function() {
          Lt._setOwner(this._color, null), this._color = Lt._setOwner(
            Lt.read(arguments, 0),
            this,
            "setColor"
          ), this._changed();
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
        }
      }), ui = o.extend(new function() {
        var i = {
          fillColor: null,
          fillRule: "nonzero",
          strokeColor: null,
          strokeWidth: 1,
          strokeCap: "butt",
          strokeJoin: "miter",
          strokeScaling: !0,
          miterLimit: 10,
          dashOffset: 0,
          dashArray: [],
          shadowColor: null,
          shadowBlur: 0,
          shadowOffset: new M(),
          selectedColor: null
        }, r = o.set({}, i, {
          fontFamily: "sans-serif",
          fontWeight: "normal",
          fontSize: 12,
          leading: null,
          justification: "left"
        }), a = o.set({}, r, {
          fillColor: new Lt()
        }), l = {
          strokeWidth: 193,
          strokeCap: 193,
          strokeJoin: 193,
          strokeScaling: 201,
          miterLimit: 193,
          fontFamily: 9,
          fontWeight: 9,
          fontSize: 9,
          font: 9,
          leading: 9,
          justification: 9
        }, u = {
          beans: !0
        }, d = {
          _class: "Style",
          beans: !0,
          initialize: function(v, p, b) {
            this._values = {}, this._owner = p, this._project = p && p._project || b || Ye.project, this._defaults = !p || p instanceof W ? r : p instanceof Zt ? a : i, v && this.set(v);
          }
        };
        return o.each(r, function(v, p) {
          var b = /Color$/.test(p), S = p === "shadowOffset", L = o.capitalize(p), E = l[p], A = "set" + L, T = "get" + L;
          d[A] = function(G) {
            var D = this._owner, Y = D && D._children, k = Y && Y.length > 0 && !(D instanceof Et);
            if (k)
              for (var z = 0, C = Y.length; z < C; z++)
                Y[z]._style[A](G);
            if ((p === "selectedColor" || !k) && p in this._defaults) {
              var O = this._values[p];
              O !== G && (b && (O && (Lt._setOwner(O, null), O._canvasStyle = null), G && G.constructor === Lt && (G = Lt._setOwner(
                G,
                D,
                k && A
              ))), this._values[p] = G, D && D._changed(E || 129));
            }
          }, d[T] = function(G) {
            var D = this._owner, Y = D && D._children, k = Y && Y.length > 0 && !(D instanceof Et), z;
            if (k && !G)
              for (var C = 0, O = Y.length; C < O; C++) {
                var j = Y[C]._style[T]();
                if (!C)
                  z = j;
                else if (!o.equals(z, j))
                  return t;
              }
            else if (p in this._defaults) {
              var z = this._values[p];
              if (z === t)
                z = this._defaults[p], z && z.clone && (z = z.clone());
              else {
                var q = b ? Lt : S ? M : null;
                q && !(z && z.constructor === q) && (this._values[p] = z = q.read(
                  [z],
                  0,
                  { readNull: !0, clone: !0 }
                ));
              }
            }
            return z && b && (z = Lt._setOwner(z, D, k && A)), z;
          }, u[T] = function(G) {
            return this._style[T](G);
          }, u[A] = function(G) {
            this._style[A](G);
          };
        }), o.each({
          Font: "FontFamily",
          WindingRule: "FillRule"
        }, function(v, p) {
          var b = "get" + p, S = "set" + p;
          d[b] = u[b] = "#get" + v, d[S] = u[S] = "#set" + v;
        }), X.inject(u), d;
      }(), {
        set: function(i) {
          var r = i instanceof ui, a = r ? i._values : i;
          if (a) {
            for (var l in a)
              if (l in this._defaults) {
                var u = a[l];
                this[l] = u && r && u.clone ? u.clone() : u;
              }
          }
        },
        equals: function(i) {
          function r(a, l, u) {
            var d = a._values, v = l._values, p = l._defaults;
            for (var b in d) {
              var S = d[b], L = v[b];
              if (!(u && b in v) && !o.equals(
                S,
                L === t ? p[b] : L
              ))
                return !1;
            }
            return !0;
          }
          return i === this || i && this._class === i._class && r(this, i) && r(i, this, !0) || !1;
        },
        _dispose: function() {
          var i;
          i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
        },
        hasFill: function() {
          var i = this.getFillColor();
          return !!i && i.alpha > 0;
        },
        hasStroke: function() {
          var i = this.getStrokeColor();
          return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
        },
        hasShadow: function() {
          var i = this.getShadowColor();
          return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
        },
        getView: function() {
          return this._project._view;
        },
        getFontStyle: function() {
          var i = this.getFontSize();
          return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
        },
        getFont: "#getFontFamily",
        setFont: "#setFontFamily",
        getLeading: function i() {
          var r = i.base.call(this), a = this.getFontSize();
          return /pt|em|%|px/.test(a) && (a = this.getView().getPixelSize(a)), r ?? a * 1.2;
        }
      }), Gt = new function() {
        function i(r, a, l, u) {
          for (var d = ["", "webkit", "moz", "Moz", "ms", "o"], v = a[0].toUpperCase() + a.substring(1), p = 0; p < 6; p++) {
            var b = d[p], S = b ? b + v : a;
            if (S in r) {
              if (l)
                r[S] = u;
              else
                return r[S];
              break;
            }
          }
        }
        return {
          getStyles: function(r) {
            var a = r && r.nodeType !== 9 ? r.ownerDocument : r, l = a && a.defaultView;
            return l && l.getComputedStyle(r, "");
          },
          getBounds: function(r, a) {
            var l = r.ownerDocument, u = l.body, d = l.documentElement, v;
            try {
              v = r.getBoundingClientRect();
            } catch {
              v = { left: 0, top: 0, width: 0, height: 0 };
            }
            var p = v.left - (d.clientLeft || u.clientLeft || 0), b = v.top - (d.clientTop || u.clientTop || 0);
            if (!a) {
              var S = l.defaultView;
              p += S.pageXOffset || d.scrollLeft || u.scrollLeft, b += S.pageYOffset || d.scrollTop || u.scrollTop;
            }
            return new P(p, b, v.width, v.height);
          },
          getViewportBounds: function(r) {
            var a = r.ownerDocument, l = a.defaultView, u = a.documentElement;
            return new P(
              0,
              0,
              l.innerWidth || u.clientWidth,
              l.innerHeight || u.clientHeight
            );
          },
          getOffset: function(r, a) {
            return Gt.getBounds(r, a).getPoint();
          },
          getSize: function(r) {
            return Gt.getBounds(r, !0).getSize();
          },
          isInvisible: function(r) {
            return Gt.getSize(r).equals(new V(0, 0));
          },
          isInView: function(r) {
            return !Gt.isInvisible(r) && Gt.getViewportBounds(r).intersects(
              Gt.getBounds(r, !0)
            );
          },
          isInserted: function(r) {
            return s.body.contains(r);
          },
          getPrefixed: function(r, a) {
            return r && i(r, a);
          },
          setPrefixed: function(r, a, l) {
            if (typeof a == "object")
              for (var u in a)
                i(r, u, !0, a[u]);
            else
              i(r, a, !0, l);
          }
        };
      }(), Xt = {
        add: function(i, r) {
          if (i)
            for (var a in r)
              for (var l = r[a], u = a.split(/[\s,]+/g), d = 0, v = u.length; d < v; d++) {
                var p = u[d], b = i === s && (p === "touchstart" || p === "touchmove") ? { passive: !1 } : !1;
                i.addEventListener(p, l, b);
              }
        },
        remove: function(i, r) {
          if (i)
            for (var a in r)
              for (var l = r[a], u = a.split(/[\s,]+/g), d = 0, v = u.length; d < v; d++)
                i.removeEventListener(u[d], l, !1);
        },
        getPoint: function(i) {
          var r = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
          return new M(
            r.pageX || r.clientX + s.documentElement.scrollLeft,
            r.pageY || r.clientY + s.documentElement.scrollTop
          );
        },
        getTarget: function(i) {
          return i.target || i.srcElement;
        },
        getRelatedTarget: function(i) {
          return i.relatedTarget || i.toElement;
        },
        getOffset: function(i, r) {
          return Xt.getPoint(i).subtract(Gt.getOffset(
            r || Xt.getTarget(i)
          ));
        }
      };
      Xt.requestAnimationFrame = new function() {
        var i = Gt.getPrefixed(n, "requestAnimationFrame"), r = !1, a = [], l;
        function u() {
          var d = a;
          a = [];
          for (var v = 0, p = d.length; v < p; v++)
            d[v]();
          r = i && a.length, r && i(u);
        }
        return function(d) {
          a.push(d), i ? r || (i(u), r = !0) : l || (l = setInterval(u, 1e3 / 60));
        };
      }();
      var Qt = o.extend(
        h,
        {
          _class: "View",
          initialize: function i(r, a) {
            function l(E) {
              return a[E] || parseInt(a.getAttribute(E), 10);
            }
            function u() {
              var E = Gt.getSize(a);
              return E.isNaN() || E.isZero() ? new V(l("width"), l("height")) : E;
            }
            var d;
            if (n && a) {
              this._id = a.getAttribute("id"), this._id == null && a.setAttribute("id", this._id = "paper-view-" + i._id++), Xt.add(a, this._viewEvents);
              var v = "none";
              if (Gt.setPrefixed(a.style, {
                userDrag: v,
                userSelect: v,
                touchCallout: v,
                contentZooming: v,
                tapHighlightColor: "rgba(0,0,0,0)"
              }), c.hasAttribute(a, "resize")) {
                var p = this;
                Xt.add(n, this._windowEvents = {
                  resize: function() {
                    p.setViewSize(u());
                  }
                });
              }
              if (d = u(), c.hasAttribute(a, "stats") && typeof Stats < "u") {
                this._stats = new Stats();
                var b = this._stats.domElement, S = b.style, L = Gt.getOffset(a);
                S.position = "absolute", S.left = L.x + "px", S.top = L.y + "px", s.body.appendChild(b);
              }
            } else
              d = new V(a), a = null;
            this._project = r, this._scope = r._scope, this._element = a, this._pixelRatio || (this._pixelRatio = n && n.devicePixelRatio || 1), this._setElementSize(d.width, d.height), this._viewSize = d, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new J())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !Ye.agent.node, this._needsUpdate = !1;
          },
          remove: function() {
            if (!this._project)
              return !1;
            Qt._focused === this && (Qt._focused = null), Qt._views.splice(Qt._views.indexOf(this), 1), delete Qt._viewsById[this._id];
            var i = this._project;
            return i._view === this && (i._view = null), Xt.remove(this._element, this._viewEvents), Xt.remove(n, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
          },
          _events: o.each(
            X._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
            function(i) {
              this[i] = {};
            },
            {
              onFrame: {
                install: function() {
                  this.play();
                },
                uninstall: function() {
                  this.pause();
                }
              }
            }
          ),
          _animate: !1,
          _time: 0,
          _count: 0,
          getAutoUpdate: function() {
            return this._autoUpdate;
          },
          setAutoUpdate: function(i) {
            this._autoUpdate = i, i && this.requestUpdate();
          },
          update: function() {
          },
          draw: function() {
            this.update();
          },
          requestUpdate: function() {
            if (!this._requested) {
              var i = this;
              Xt.requestAnimationFrame(function() {
                if (i._requested = !1, i._animate) {
                  i.requestUpdate();
                  var r = i._element;
                  (!Gt.getPrefixed(s, "hidden") || c.getAttribute(r, "keepalive") === "true") && Gt.isInView(r) && i._handleFrame();
                }
                i._autoUpdate && i.update();
              }), this._requested = !0;
            }
          },
          play: function() {
            this._animate = !0, this.requestUpdate();
          },
          pause: function() {
            this._animate = !1;
          },
          _handleFrame: function() {
            Ye = this._scope;
            var i = Date.now() / 1e3, r = this._last ? i - this._last : 0;
            this._last = i, this.emit("frame", new o({
              delta: r,
              time: this._time += r,
              count: this._count++
            })), this._stats && this._stats.update();
          },
          _animateItem: function(i, r) {
            var a = this._frameItems;
            r ? (a[i._id] = {
              item: i,
              time: 0,
              count: 0
            }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete a[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
          },
          _handleFrameItems: function(i) {
            for (var r in this._frameItems) {
              var a = this._frameItems[r];
              a.item.emit("frame", new o(i, {
                time: a.time += i.delta,
                count: a.count++
              }));
            }
          },
          _changed: function() {
            this._project._changed(4097), this._bounds = this._decomposed = t;
          },
          getElement: function() {
            return this._element;
          },
          getPixelRatio: function() {
            return this._pixelRatio;
          },
          getResolution: function() {
            return this._pixelRatio * 72;
          },
          getViewSize: function() {
            var i = this._viewSize;
            return new te(i.width, i.height, this, "setViewSize");
          },
          setViewSize: function() {
            var i = V.read(arguments), r = i.subtract(this._viewSize);
            r.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: r }), this._autoUpdate && this.update());
          },
          _setElementSize: function(i, r) {
            var a = this._element;
            a && (a.width !== i && (a.width = i), a.height !== r && (a.height = r));
          },
          getBounds: function() {
            return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
              new P(new M(), this._viewSize)
            )), this._bounds;
          },
          getSize: function() {
            return this.getBounds().getSize();
          },
          isVisible: function() {
            return Gt.isInView(this._element);
          },
          isInserted: function() {
            return Gt.isInserted(this._element);
          },
          getPixelSize: function(i) {
            var r = this._element, a;
            if (r) {
              var l = r.parentNode, u = s.createElement("div");
              u.style.fontSize = i, l.appendChild(u), a = parseFloat(Gt.getStyles(u).fontSize), l.removeChild(u);
            } else
              a = parseFloat(a);
            return a;
          },
          getTextWidth: function(i, r) {
            return 0;
          }
        },
        o.each(["rotate", "scale", "shear", "skew"], function(i) {
          var r = i === "rotate";
          this[i] = function() {
            var a = arguments, l = (r ? o : M).read(a), u = M.read(a, 0, { readNull: !0 });
            return this.transform(new J()[i](
              l,
              u || this.getCenter(!0)
            ));
          };
        }, {
          _decompose: function() {
            return this._decomposed || (this._decomposed = this._matrix.decompose());
          },
          translate: function() {
            var i = new J();
            return this.transform(i.translate.apply(i, arguments));
          },
          getCenter: function() {
            return this.getBounds().getCenter();
          },
          setCenter: function() {
            var i = M.read(arguments);
            this.translate(this.getCenter().subtract(i));
          },
          getZoom: function() {
            var i = this._decompose().scaling;
            return (i.x + i.y) / 2;
          },
          setZoom: function(i) {
            this.transform(new J().scale(
              i / this.getZoom(),
              this.getCenter()
            ));
          },
          getRotation: function() {
            return this._decompose().rotation;
          },
          setRotation: function(i) {
            var r = this.getRotation();
            r != null && i != null && this.rotate(i - r);
          },
          getScaling: function() {
            var i = this._decompose().scaling;
            return new Z(i.x, i.y, this, "setScaling");
          },
          setScaling: function() {
            var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
            i && r && this.scale(r.x / i.x, r.y / i.y);
          },
          getMatrix: function() {
            return this._matrix;
          },
          setMatrix: function() {
            var i = this._matrix;
            i.set.apply(i, arguments);
          },
          transform: function(i) {
            this._matrix.append(i);
          },
          scrollBy: function() {
            this.translate(M.read(arguments).negate());
          }
        }),
        {
          projectToView: function() {
            return this._matrix._transformPoint(M.read(arguments));
          },
          viewToProject: function() {
            return this._matrix._inverseTransform(M.read(arguments));
          },
          getEventPoint: function(i) {
            return this.viewToProject(Xt.getOffset(i, this._element));
          }
        },
        {
          statics: {
            _views: [],
            _viewsById: {},
            _id: 0,
            create: function(i, r) {
              s && typeof r == "string" && (r = s.getElementById(r));
              var a = n ? Ni : Qt;
              return new a(i, r);
            }
          }
        },
        new function() {
          if (!n)
            return;
          var i, r, a = !1, l = !1;
          function u(se) {
            var de = Xt.getTarget(se);
            return de.getAttribute && Qt._viewsById[de.getAttribute("id")];
          }
          function d() {
            var se = Qt._focused;
            if (!se || !se.isVisible()) {
              for (var de = 0, ve = Qt._views.length; de < ve; de++)
                if ((se = Qt._views[de]).isVisible()) {
                  Qt._focused = r = se;
                  break;
                }
            }
          }
          function v(se, de, ve) {
            se._handleMouseEvent("mousemove", de, ve);
          }
          var p = n.navigator, b, S, L;
          p.pointerEnabled || p.msPointerEnabled ? (b = "pointerdown MSPointerDown", S = "pointermove MSPointerMove", L = "pointerup pointercancel MSPointerUp MSPointerCancel") : (b = "touchstart", S = "touchmove", L = "touchend touchcancel", "ontouchstart" in n && p.userAgent.match(
            /mobile|tablet|ip(ad|hone|od)|android|silk/i
          ) || (b += " mousedown", S += " mousemove", L += " mouseup"));
          var E = {}, A = {
            mouseout: function(se) {
              var de = Qt._focused, ve = Xt.getRelatedTarget(se);
              if (de && (!ve || ve.nodeName === "HTML")) {
                var we = Xt.getOffset(se, de._element), Se = we.x, Ae = Math.abs, Ge = Ae(Se), et = 1 << 25, st = Ge - et;
                we.x = Ae(st) < Ge ? st * (Se < 0 ? -1 : 1) : Se, v(de, se, de.viewToProject(we));
              }
            },
            scroll: d
          };
          E[b] = function(se) {
            var de = Qt._focused = u(se);
            a || (a = !0, de._handleMouseEvent("mousedown", se));
          }, A[S] = function(se) {
            var de = Qt._focused;
            if (!l) {
              var ve = u(se);
              ve ? de !== ve && (de && v(de, se), i || (i = de), de = Qt._focused = r = ve) : r && r === de && (i && !i.isInserted() && (i = null), de = Qt._focused = i, i = null, d());
            }
            de && v(de, se);
          }, A[b] = function() {
            l = !0;
          }, A[L] = function(se) {
            var de = Qt._focused;
            de && a && de._handleMouseEvent("mouseup", se), l = a = !1;
          }, Xt.add(s, A), Xt.add(n, {
            load: d
          });
          var T = !1, G = !1, D = {
            doubleclick: "click",
            mousedrag: "mousemove"
          }, Y = !1, k, z, C, O, j, q, H, ie;
          function ae(se, de, ve, we, Se, Ae, Ge) {
            var et = !1, st;
            function _t(Re, Fe) {
              if (Re.responds(Fe)) {
                if (st || (st = new tt(
                  Fe,
                  we,
                  Se,
                  de || Re,
                  Ae ? Se.subtract(Ae) : null
                )), Re.emit(Fe, st) && (T = !0, st.prevented && (G = !0), st.stopped))
                  return et = !0;
              } else {
                var at = D[Fe];
                if (at)
                  return _t(Re, at);
              }
            }
            for (; se && se !== Ge && !_t(se, ve); )
              se = se._parent;
            return et;
          }
          function ue(se, de, ve, we, Se, Ae) {
            return se._project.removeOn(ve), G = T = !1, j && ae(
              j,
              null,
              ve,
              we,
              Se,
              Ae
            ) || de && de !== j && !de.isDescendant(j) && ae(de, null, ve === "mousedrag" ? "mousemove" : ve, we, Se, Ae, j) || ae(
              se,
              j || de || se,
              ve,
              we,
              Se,
              Ae
            );
          }
          var me = {
            mousedown: {
              mousedown: 1,
              mousedrag: 1,
              click: 1,
              doubleclick: 1
            },
            mouseup: {
              mouseup: 1,
              mousedrag: 1,
              click: 1,
              doubleclick: 1
            },
            mousemove: {
              mousedrag: 1,
              mousemove: 1,
              mouseenter: 1,
              mouseleave: 1
            }
          };
          return {
            _viewEvents: E,
            _handleMouseEvent: function(se, de, ve) {
              var we = this._itemEvents, Se = we.native[se], Ae = se === "mousemove", Ge = this._scope.tool, et = this;
              function st(Rt) {
                return we.virtual[Rt] || et.responds(Rt) || Ge && Ge.responds(Rt);
              }
              Ae && a && st("mousedrag") && (se = "mousedrag"), ve || (ve = this.getEventPoint(de));
              var _t = this.getBounds().contains(ve), Re = Se && _t && et._project.hitTest(ve, {
                tolerance: 0,
                fill: !0,
                stroke: !0
              }), Fe = Re && Re.item || null, at = !1, yt = {};
              if (yt[se.substr(5)] = !0, Se && Fe !== O && (O && ae(O, null, "mouseleave", de, ve), Fe && ae(Fe, null, "mouseenter", de, ve), O = Fe), Y ^ _t && (ae(
                this,
                null,
                _t ? "mouseenter" : "mouseleave",
                de,
                ve
              ), at = !0), (_t || yt.drag) && !ve.equals(z) && (ue(
                this,
                Fe,
                Ae ? se : "mousemove",
                de,
                ve,
                z
              ), at = !0), Y = _t, yt.down && _t || yt.up && k) {
                if (ue(this, Fe, se, de, ve, k), yt.down) {
                  if (ie = Fe === q && Date.now() - H < 300, C = q = Fe, !G && Fe) {
                    for (var bt = Fe; bt && !bt.responds("mousedrag"); )
                      bt = bt._parent;
                    bt && (j = Fe);
                  }
                  k = ve;
                } else
                  yt.up && (!G && Fe === C && (H = Date.now(), ue(this, Fe, ie ? "doubleclick" : "click", de, ve, k), ie = !1), C = j = null);
                Y = !1, at = !0;
              }
              z = ve, at && Ge && (T = Ge._handleMouseEvent(se, de, ve, yt) || T), de.cancelable !== !1 && (T && !yt.move || yt.down && st("mouseup")) && de.preventDefault();
            },
            _handleKeyEvent: function(se, de, ve, we) {
              var Se = this._scope, Ae = Se.tool, Ge;
              function et(st) {
                st.responds(se) && (Ye = Se, st.emit(se, Ge = Ge || new pe(se, de, ve, we)));
              }
              this.isVisible() && (et(this), Ae && Ae.responds(se) && et(Ae));
            },
            _countItemEvent: function(se, de) {
              var ve = this._itemEvents, we = ve.native, Se = ve.virtual;
              for (var Ae in me)
                we[Ae] = (we[Ae] || 0) + (me[Ae][se] || 0) * de;
              Se[se] = (Se[se] || 0) + de;
            },
            statics: {
              updateFocus: d,
              _resetState: function() {
                a = l = T = Y = !1, i = r = k = z = C = O = j = q = H = ie = null;
              }
            }
          };
        }()
      ), Ni = Qt.extend({
        _class: "CanvasView",
        initialize: function(i, r) {
          if (!(r instanceof n.HTMLCanvasElement)) {
            var a = V.read(arguments, 1);
            if (a.isZero())
              throw new Error(
                "Cannot create CanvasView with the provided argument: " + o.slice(arguments, 1)
              );
            r = vt.getCanvas(a);
          }
          var l = this._context = r.getContext("2d");
          if (l.save(), this._pixelRatio = 1, !/^off|false$/.test(c.getAttribute(r, "hidpi"))) {
            var u = n.devicePixelRatio || 1, d = Gt.getPrefixed(
              l,
              "backingStorePixelRatio"
            ) || 1;
            this._pixelRatio = u / d;
          }
          Qt.call(this, i, r), this._needsUpdate = !0;
        },
        remove: function i() {
          return this._context.restore(), i.base.call(this);
        },
        _setElementSize: function i(r, a) {
          var l = this._pixelRatio;
          if (i.base.call(this, r * l, a * l), l !== 1) {
            var u = this._element, d = this._context;
            if (!c.hasAttribute(u, "resize")) {
              var v = u.style;
              v.width = r + "px", v.height = a + "px";
            }
            d.restore(), d.save(), d.scale(l, l);
          }
        },
        getContext: function() {
          return this._context;
        },
        getPixelSize: function i(r) {
          var a = Ye.agent, l;
          if (a && a.firefox)
            l = i.base.call(this, r);
          else {
            var u = this._context, d = u.font;
            u.font = r + " serif", l = parseFloat(u.font), u.font = d;
          }
          return l;
        },
        getTextWidth: function(i, r) {
          var a = this._context, l = a.font, u = 0;
          a.font = i;
          for (var d = 0, v = r.length; d < v; d++)
            u = Math.max(u, a.measureText(r[d]).width);
          return a.font = l, u;
        },
        update: function() {
          if (!this._needsUpdate)
            return !1;
          var i = this._project, r = this._context, a = this._viewSize;
          return r.clearRect(0, 0, a.width + 1, a.height + 1), i && i.draw(r, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
        }
      }), Di = o.extend({
        _class: "Event",
        initialize: function(i) {
          this.event = i, this.type = i && i.type;
        },
        prevented: !1,
        stopped: !1,
        preventDefault: function() {
          this.prevented = !0, this.event.preventDefault();
        },
        stopPropagation: function() {
          this.stopped = !0, this.event.stopPropagation();
        },
        stop: function() {
          this.stopPropagation(), this.preventDefault();
        },
        getTimeStamp: function() {
          return this.event.timeStamp;
        },
        getModifiers: function() {
          return xt.modifiers;
        }
      }), pe = Di.extend({
        _class: "KeyEvent",
        initialize: function(i, r, a, l) {
          this.type = i, this.event = r, this.key = a, this.character = l;
        },
        toString: function() {
          return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
        }
      }), xt = new function() {
        var i = {
          "	": "tab",
          " ": "space",
          "\b": "backspace",
          "": "delete",
          Spacebar: "space",
          Del: "delete",
          Win: "meta",
          Esc: "escape"
        }, r = {
          tab: "	",
          space: " ",
          enter: "\r"
        }, a = {}, l = {}, u, d, v = new o({
          shift: !1,
          control: !1,
          alt: !1,
          meta: !1,
          capsLock: !1,
          space: !1
        }).inject({
          option: {
            get: function() {
              return this.alt;
            }
          },
          command: {
            get: function() {
              var S = Ye && Ye.agent;
              return S && S.mac ? this.meta : this.control;
            }
          }
        });
        function p(S) {
          var L = S.key || S.keyIdentifier;
          return L = /^U\+/.test(L) ? String.fromCharCode(parseInt(L.substr(2), 16)) : /^Arrow[A-Z]/.test(L) ? L.substr(5) : L === "Unidentified" || L === t ? String.fromCharCode(S.keyCode) : L, i[L] || (L.length > 1 ? o.hyphenate(L) : L.toLowerCase());
        }
        function b(S, L, E, A) {
          var T = Qt._focused, G;
          if (a[L] = S, S ? l[L] = E : delete l[L], L.length > 1 && (G = o.camelize(L)) in v) {
            v[G] = S;
            var D = Ye && Ye.agent;
            if (G === "meta" && D && D.mac)
              if (S)
                u = {};
              else {
                for (var Y in u)
                  Y in l && b(!1, Y, u[Y], A);
                u = null;
              }
          } else
            S && u && (u[L] = E);
          T && T._handleKeyEvent(
            S ? "keydown" : "keyup",
            A,
            L,
            E
          );
        }
        return Xt.add(s, {
          keydown: function(S) {
            var L = p(S), E = Ye && Ye.agent;
            L.length > 1 || E && E.chrome && (S.altKey || E.mac && S.metaKey || !E.mac && S.ctrlKey) ? b(
              !0,
              L,
              r[L] || (L.length > 1 ? "" : L),
              S
            ) : d = L;
          },
          keypress: function(S) {
            if (d) {
              var L = p(S), E = S.charCode, A = E >= 32 ? String.fromCharCode(E) : L.length > 1 ? "" : L;
              L !== d && (L = A.toLowerCase()), b(!0, L, A, S), d = null;
            }
          },
          keyup: function(S) {
            var L = p(S);
            L in l && b(!1, L, l[L], S);
          }
        }), Xt.add(n, {
          blur: function(S) {
            for (var L in l)
              b(!1, L, l[L], S);
          }
        }), {
          modifiers: v,
          isDown: function(S) {
            return !!a[S];
          }
        };
      }(), tt = Di.extend({
        _class: "MouseEvent",
        initialize: function(i, r, a, l, u) {
          this.type = i, this.event = r, this.point = a, this.target = l, this.delta = u;
        },
        toString: function() {
          return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
        }
      }), Pe = Di.extend({
        _class: "ToolEvent",
        _item: null,
        initialize: function(i, r, a) {
          this.tool = i, this.type = r, this.event = a;
        },
        _choosePoint: function(i, r) {
          return i || (r ? r.clone() : null);
        },
        getPoint: function() {
          return this._choosePoint(this._point, this.tool._point);
        },
        setPoint: function(i) {
          this._point = i;
        },
        getLastPoint: function() {
          return this._choosePoint(this._lastPoint, this.tool._lastPoint);
        },
        setLastPoint: function(i) {
          this._lastPoint = i;
        },
        getDownPoint: function() {
          return this._choosePoint(this._downPoint, this.tool._downPoint);
        },
        setDownPoint: function(i) {
          this._downPoint = i;
        },
        getMiddlePoint: function() {
          return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
        },
        setMiddlePoint: function(i) {
          this._middlePoint = i;
        },
        getDelta: function() {
          return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
        },
        setDelta: function(i) {
          this._delta = i;
        },
        getCount: function() {
          return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
        },
        setCount: function(i) {
          this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
        },
        getItem: function() {
          if (!this._item) {
            var i = this.tool._scope.project.hitTest(this.getPoint());
            if (i) {
              for (var r = i.item, a = r._parent; /^(Group|CompoundPath)$/.test(a._class); )
                r = a, a = a._parent;
              this._item = r;
            }
          }
          return this._item;
        },
        setItem: function(i) {
          this._item = i;
        },
        toString: function() {
          return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
        }
      }), ke = m.extend({
        _class: "Tool",
        _list: "tools",
        _reference: "tool",
        _events: [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onMouseMove",
          "onActivate",
          "onDeactivate",
          "onEditOptions",
          "onKeyDown",
          "onKeyUp"
        ],
        initialize: function(i) {
          m.call(this), this._moveCount = -1, this._downCount = -1, this.set(i);
        },
        getMinDistance: function() {
          return this._minDistance;
        },
        setMinDistance: function(i) {
          this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
        },
        getMaxDistance: function() {
          return this._maxDistance;
        },
        setMaxDistance: function(i) {
          this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
        },
        getFixedDistance: function() {
          return this._minDistance == this._maxDistance ? this._minDistance : null;
        },
        setFixedDistance: function(i) {
          this._minDistance = this._maxDistance = i;
        },
        _handleMouseEvent: function(i, r, a, l) {
          Ye = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
          var u = l.move || l.drag, d = this.responds(i), v = !1, p = this;
          function b(L, E) {
            var A = a, T = u ? p._point : p._downPoint || A;
            if (u) {
              if (p._moveCount >= 0 && A.equals(T))
                return !1;
              if (T && (L != null || E != null)) {
                var G = A.subtract(T), D = G.getLength();
                if (D < (L || 0))
                  return !1;
                E && (A = T.add(G.normalize(
                  Math.min(D, E)
                )));
              }
              p._moveCount++;
            }
            return p._point = A, p._lastPoint = T || A, l.down && (p._moveCount = -1, p._downPoint = A, p._downCount++), !0;
          }
          function S() {
            d && (v = p.emit(i, new Pe(p, i, r)) || v);
          }
          if (l.down)
            b(), S();
          else if (l.up)
            b(null, this._maxDistance), S();
          else if (d)
            for (; b(this._minDistance, this._maxDistance); )
              S();
          return v;
        }
      }), Je = o.extend(h, {
        _class: "Tween",
        statics: {
          easings: new o({
            linear: function(i) {
              return i;
            },
            easeInQuad: function(i) {
              return i * i;
            },
            easeOutQuad: function(i) {
              return i * (2 - i);
            },
            easeInOutQuad: function(i) {
              return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
            },
            easeInCubic: function(i) {
              return i * i * i;
            },
            easeOutCubic: function(i) {
              return --i * i * i + 1;
            },
            easeInOutCubic: function(i) {
              return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
            },
            easeInQuart: function(i) {
              return i * i * i * i;
            },
            easeOutQuart: function(i) {
              return 1 - --i * i * i * i;
            },
            easeInOutQuart: function(i) {
              return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
            },
            easeInQuint: function(i) {
              return i * i * i * i * i;
            },
            easeOutQuint: function(i) {
              return 1 + --i * i * i * i * i;
            },
            easeInOutQuint: function(i) {
              return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
            }
          })
        },
        initialize: function i(r, a, l, u, d, v) {
          this.object = r;
          var p = typeof d, b = p === "function";
          this.type = b ? p : p === "string" ? d : "linear", this.easing = b ? d : i.easings[this.type], this.duration = u, this.running = !1, this._then = null, this._startTime = null;
          var S = a || l;
          this._keys = S ? Object.keys(S) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = S && this._getState(a), this._to = S && this._getState(l), v !== !1 && this.start();
        },
        then: function(i) {
          return this._then = i, this;
        },
        start: function() {
          return this._startTime = null, this.running = !0, this;
        },
        stop: function() {
          return this.running = !1, this;
        },
        update: function(i) {
          if (this.running) {
            i >= 1 && (i = 1, this.running = !1);
            for (var r = this.easing(i), a = this._keys, l = function(L) {
              return typeof L == "function" ? L(r, i) : L;
            }, u = 0, d = a && a.length; u < d; u++) {
              var v = a[u], p = l(this._from[v]), b = l(this._to[v]), S = p && b && p.__add && b.__add ? b.__subtract(p).__multiply(r).__add(p) : (b - p) * r + p;
              this._setProperty(this._parsedKeys[v], S);
            }
            this.responds("update") && this.emit("update", new o({
              progress: i,
              factor: r
            })), !this.running && this._then && this._then(this.object);
          }
          return this;
        },
        _events: {
          onUpdate: {}
        },
        _handleFrame: function(i) {
          var r = this._startTime, a = r ? (i - r) / this.duration : 0;
          r || (this._startTime = i), this.update(a);
        },
        _getState: function(i) {
          for (var r = this._keys, a = {}, l = 0, u = r.length; l < u; l++) {
            var d = r[l], v = this._parsedKeys[d], p = this._getProperty(v), b;
            if (i) {
              var S = this._resolveValue(p, i[d]);
              this._setProperty(v, S), b = this._getProperty(v), b = b && b.clone ? b.clone() : b, this._setProperty(v, p);
            } else
              b = p && p.clone ? p.clone() : p;
            a[d] = b;
          }
          return a;
        },
        _resolveValue: function(i, r) {
          if (r) {
            if (Array.isArray(r) && r.length === 2) {
              var a = r[0];
              return a && a.match && a.match(/^[+\-\*\/]=/) ? this._calculate(i, a[0], r[1]) : r;
            } else if (typeof r == "string") {
              var l = r.match(/^[+\-*/]=(.*)/);
              if (l) {
                var u = JSON.parse(l[1].replace(
                  /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                  '"$2": '
                ));
                return this._calculate(i, r[0], u);
              }
            }
          }
          return r;
        },
        _calculate: function(i, r, a) {
          return Ye.PaperScript.calculateBinary(i, r, a);
        },
        _parseKeys: function(i) {
          for (var r = {}, a = 0, l = i.length; a < l; a++) {
            var u = i[a], d = u.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
            r[u] = d.split("/");
          }
          return r;
        },
        _getProperty: function(i, r) {
          for (var a = this.object, l = 0, u = i.length - (r || 0); l < u && a; l++)
            a = a[i[l]];
          return a;
        },
        _setProperty: function(i, r) {
          var a = this._getProperty(i, 1);
          a && (a[i[i.length - 1]] = r);
        }
      }), kt = {
        request: function(i) {
          var r = new e.XMLHttpRequest();
          return r.open(
            (i.method || "get").toUpperCase(),
            i.url,
            o.pick(i.async, !0)
          ), i.mimeType && r.overrideMimeType(i.mimeType), r.onload = function() {
            var a = r.status;
            a === 0 || a === 200 ? i.onLoad && i.onLoad.call(r, r.responseText) : r.onerror();
          }, r.onerror = function() {
            var a = r.status, l = 'Could not load "' + i.url + '" (Status: ' + a + ")";
            if (i.onError)
              i.onError(l, a);
            else
              throw new Error(l);
          }, r.send(null);
        }
      }, vt = o.exports.CanvasProvider = {
        canvases: [],
        getCanvas: function(i, r, a) {
          if (!n)
            return null;
          var l, u = !0;
          typeof i == "object" && (r = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = s.createElement("canvas"), u = !1);
          var d = l.getContext("2d", a || {});
          if (!d)
            throw new Error("Canvas " + l + " is unable to provide a 2D context.");
          return l.width === i && l.height === r ? u && d.clearRect(0, 0, i + 1, r + 1) : (l.width = i, l.height = r), d.save(), l;
        },
        getContext: function(i, r, a) {
          var l = this.getCanvas(i, r, a);
          return l ? l.getContext("2d", a || {}) : null;
        },
        release: function(i) {
          var r = i && i.canvas ? i.canvas : i;
          r && r.getContext && (r.getContext("2d").restore(), this.canvases.push(r));
        }
      }, Qe = new function() {
        var i = Math.min, r = Math.max, a = Math.abs, l, u, d, v, p, b, S, L, E, A, T;
        function G(j, q, H) {
          return 0.2989 * j + 0.587 * q + 0.114 * H;
        }
        function D(j, q, H, ue) {
          var ae = ue - G(j, q, H);
          E = j + ae, A = q + ae, T = H + ae;
          var ue = G(E, A, T), me = i(E, A, T), se = r(E, A, T);
          if (me < 0) {
            var de = ue - me;
            E = ue + (E - ue) * ue / de, A = ue + (A - ue) * ue / de, T = ue + (T - ue) * ue / de;
          }
          if (se > 255) {
            var ve = 255 - ue, we = se - ue;
            E = ue + (E - ue) * ve / we, A = ue + (A - ue) * ve / we, T = ue + (T - ue) * ve / we;
          }
        }
        function Y(j, q, H) {
          return r(j, q, H) - i(j, q, H);
        }
        function k(j, q, H, ie) {
          var ae = [j, q, H], ue = r(j, q, H), me = i(j, q, H), se;
          me = me === j ? 0 : me === q ? 1 : 2, ue = ue === j ? 0 : ue === q ? 1 : 2, se = i(me, ue) === 0 ? r(me, ue) === 1 ? 2 : 1 : 0, ae[ue] > ae[me] ? (ae[se] = (ae[se] - ae[me]) * ie / (ae[ue] - ae[me]), ae[ue] = ie) : ae[se] = ae[ue] = 0, ae[me] = 0, E = ae[0], A = ae[1], T = ae[2];
        }
        var z = {
          multiply: function() {
            E = p * l / 255, A = b * u / 255, T = S * d / 255;
          },
          screen: function() {
            E = p + l - p * l / 255, A = b + u - b * u / 255, T = S + d - S * d / 255;
          },
          overlay: function() {
            E = p < 128 ? 2 * p * l / 255 : 255 - 2 * (255 - p) * (255 - l) / 255, A = b < 128 ? 2 * b * u / 255 : 255 - 2 * (255 - b) * (255 - u) / 255, T = S < 128 ? 2 * S * d / 255 : 255 - 2 * (255 - S) * (255 - d) / 255;
          },
          "soft-light": function() {
            var j = l * p / 255;
            E = j + p * (255 - (255 - p) * (255 - l) / 255 - j) / 255, j = u * b / 255, A = j + b * (255 - (255 - b) * (255 - u) / 255 - j) / 255, j = d * S / 255, T = j + S * (255 - (255 - S) * (255 - d) / 255 - j) / 255;
          },
          "hard-light": function() {
            E = l < 128 ? 2 * l * p / 255 : 255 - 2 * (255 - l) * (255 - p) / 255, A = u < 128 ? 2 * u * b / 255 : 255 - 2 * (255 - u) * (255 - b) / 255, T = d < 128 ? 2 * d * S / 255 : 255 - 2 * (255 - d) * (255 - S) / 255;
          },
          "color-dodge": function() {
            E = p === 0 ? 0 : l === 255 ? 255 : i(255, 255 * p / (255 - l)), A = b === 0 ? 0 : u === 255 ? 255 : i(255, 255 * b / (255 - u)), T = S === 0 ? 0 : d === 255 ? 255 : i(255, 255 * S / (255 - d));
          },
          "color-burn": function() {
            E = p === 255 ? 255 : l === 0 ? 0 : r(0, 255 - (255 - p) * 255 / l), A = b === 255 ? 255 : u === 0 ? 0 : r(0, 255 - (255 - b) * 255 / u), T = S === 255 ? 255 : d === 0 ? 0 : r(0, 255 - (255 - S) * 255 / d);
          },
          darken: function() {
            E = p < l ? p : l, A = b < u ? b : u, T = S < d ? S : d;
          },
          lighten: function() {
            E = p > l ? p : l, A = b > u ? b : u, T = S > d ? S : d;
          },
          difference: function() {
            E = p - l, E < 0 && (E = -E), A = b - u, A < 0 && (A = -A), T = S - d, T < 0 && (T = -T);
          },
          exclusion: function() {
            E = p + l * (255 - p - p) / 255, A = b + u * (255 - b - b) / 255, T = S + d * (255 - S - S) / 255;
          },
          hue: function() {
            k(l, u, d, Y(p, b, S)), D(E, A, T, G(p, b, S));
          },
          saturation: function() {
            k(p, b, S, Y(l, u, d)), D(E, A, T, G(p, b, S));
          },
          luminosity: function() {
            D(p, b, S, G(l, u, d));
          },
          color: function() {
            D(l, u, d, G(p, b, S));
          },
          add: function() {
            E = i(p + l, 255), A = i(b + u, 255), T = i(S + d, 255);
          },
          subtract: function() {
            E = r(p - l, 0), A = r(b - u, 0), T = r(S - d, 0);
          },
          average: function() {
            E = (p + l) / 2, A = (b + u) / 2, T = (S + d) / 2;
          },
          negation: function() {
            E = 255 - a(255 - l - p), A = 255 - a(255 - u - b), T = 255 - a(255 - d - S);
          }
        }, C = this.nativeModes = o.each([
          "source-over",
          "source-in",
          "source-out",
          "source-atop",
          "destination-over",
          "destination-in",
          "destination-out",
          "destination-atop",
          "lighter",
          "darker",
          "copy",
          "xor"
        ], function(j) {
          this[j] = !0;
        }, {}), O = vt.getContext(1, 1, { willReadFrequently: !0 });
        O && (o.each(z, function(j, q) {
          var H = q === "darken", ie = !1;
          O.save();
          try {
            O.fillStyle = H ? "#300" : "#a00", O.fillRect(0, 0, 1, 1), O.globalCompositeOperation = q, O.globalCompositeOperation === q && (O.fillStyle = H ? "#a00" : "#300", O.fillRect(0, 0, 1, 1), ie = O.getImageData(0, 0, 1, 1).data[0] !== H ? 170 : 51);
          } catch {
          }
          O.restore(), C[q] = ie;
        }), vt.release(O)), this.process = function(j, q, H, ie, ae) {
          var ue = q.canvas, me = j === "normal";
          if (me || C[j])
            H.save(), H.setTransform(1, 0, 0, 1, 0, 0), H.globalAlpha = ie, me || (H.globalCompositeOperation = j), H.drawImage(ue, ae.x, ae.y), H.restore();
          else {
            var se = z[j];
            if (!se)
              return;
            for (var de = H.getImageData(
              ae.x,
              ae.y,
              ue.width,
              ue.height
            ), ve = de.data, we = q.getImageData(
              0,
              0,
              ue.width,
              ue.height
            ).data, Se = 0, Ae = ve.length; Se < Ae; Se += 4) {
              l = we[Se], p = ve[Se], u = we[Se + 1], b = ve[Se + 1], d = we[Se + 2], S = ve[Se + 2], v = we[Se + 3], L = ve[Se + 3], se();
              var Ge = v * ie / 255, et = 1 - Ge;
              ve[Se] = Ge * E + et * p, ve[Se + 1] = Ge * A + et * b, ve[Se + 2] = Ge * T + et * S, ve[Se + 3] = v * ie + et * L;
            }
            H.putImageData(de, ae.x, ae.y);
          }
        };
      }(), wt = new function() {
        var i = "http://www.w3.org/2000/svg", r = "http://www.w3.org/2000/xmlns", a = "http://www.w3.org/1999/xlink", l = {
          href: a,
          xlink: r,
          xmlns: r + "/",
          "xmlns:xlink": r + "/"
        };
        function u(p, b, S) {
          return v(s.createElementNS(i, p), b, S);
        }
        function d(p, b) {
          var S = l[b], L = S ? p.getAttributeNS(S, b) : p.getAttribute(b);
          return L === "null" ? null : L;
        }
        function v(p, b, S) {
          for (var L in b) {
            var E = b[L], A = l[L];
            typeof E == "number" && S && (E = S.number(E)), A ? p.setAttributeNS(A, L, E) : p.setAttribute(L, E);
          }
          return p;
        }
        return {
          svg: i,
          xmlns: r,
          xlink: a,
          create: u,
          get: d,
          set: v
        };
      }(), Yt = o.each({
        fillColor: ["fill", "color"],
        fillRule: ["fill-rule", "string"],
        strokeColor: ["stroke", "color"],
        strokeWidth: ["stroke-width", "number"],
        strokeCap: ["stroke-linecap", "string"],
        strokeJoin: ["stroke-linejoin", "string"],
        strokeScaling: ["vector-effect", "lookup", {
          true: "none",
          false: "non-scaling-stroke"
        }, function(i, r) {
          return !r && (i instanceof qt || i instanceof Ee || i instanceof Zt);
        }],
        miterLimit: ["stroke-miterlimit", "number"],
        dashArray: ["stroke-dasharray", "array"],
        dashOffset: ["stroke-dashoffset", "number"],
        fontFamily: ["font-family", "string"],
        fontWeight: ["font-weight", "string"],
        fontSize: ["font-size", "number"],
        justification: ["text-anchor", "lookup", {
          left: "start",
          center: "middle",
          right: "end"
        }],
        opacity: ["opacity", "number"],
        blendMode: ["mix-blend-mode", "style"]
      }, function(i, r) {
        var a = o.capitalize(r), l = i[2];
        this[r] = {
          type: i[1],
          property: r,
          attribute: i[0],
          toSVG: l,
          fromSVG: l && o.each(l, function(u, d) {
            this[u] = d;
          }, {}),
          exportFilter: i[3],
          get: "get" + a,
          set: "set" + a
        };
      }, {});
      new function() {
        var i;
        function r(z, C, O) {
          var j = new o(), q = z.getTranslation();
          if (C) {
            var H;
            z.isInvertible() ? (z = z._shiftless(), H = z._inverseTransform(q), q = null) : H = new M(), j[O ? "cx" : "x"] = H.x, j[O ? "cy" : "y"] = H.y;
          }
          if (!z.isIdentity()) {
            var ie = z.decompose();
            if (ie) {
              var ae = [], ue = ie.rotation, me = ie.scaling, se = ie.skewing;
              q && !q.isZero() && ae.push("translate(" + i.point(q) + ")"), ue && ae.push("rotate(" + i.number(ue) + ")"), (!I.isZero(me.x - 1) || !I.isZero(me.y - 1)) && ae.push("scale(" + i.point(me) + ")"), se.x && ae.push("skewX(" + i.number(se.x) + ")"), se.y && ae.push("skewY(" + i.number(se.y) + ")"), j.transform = ae.join(" ");
            } else
              j.transform = "matrix(" + z.getValues().join(",") + ")";
          }
          return j;
        }
        function a(z, C) {
          for (var O = r(z._matrix), j = z._children, q = wt.create("g", O, i), H = 0, ie = j.length; H < ie; H++) {
            var ae = j[H], ue = Y(ae, C);
            if (ue)
              if (ae.isClipMask()) {
                var me = wt.create("clipPath");
                me.appendChild(ue), G(ae, me, "clip"), wt.set(q, {
                  "clip-path": "url(#" + me.id + ")"
                });
              } else
                q.appendChild(ue);
          }
          return q;
        }
        function l(z, C) {
          var O = r(z._matrix, !0), j = z.getSize(), q = z.getImage();
          return O.x -= j.width / 2, O.y -= j.height / 2, O.width = j.width, O.height = j.height, O.href = C.embedImages == !1 && q && q.src || z.toDataURL(), wt.create("image", O, i);
        }
        function u(z, C) {
          var O = C.matchShapes;
          if (O) {
            var j = z.toShape(!1);
            if (j)
              return d(j);
          }
          var q = z._segments, H = q.length, ie, ae = r(z._matrix);
          if (O && H >= 2 && !z.hasHandles())
            if (H > 2) {
              ie = z._closed ? "polygon" : "polyline";
              for (var ue = [], me = 0; me < H; me++)
                ue.push(i.point(q[me]._point));
              ae.points = ue.join(" ");
            } else {
              ie = "line";
              var se = q[0]._point, de = q[1]._point;
              ae.set({
                x1: se.x,
                y1: se.y,
                x2: de.x,
                y2: de.y
              });
            }
          else
            ie = "path", ae.d = z.getPathData(null, C.precision);
          return wt.create(ie, ae, i);
        }
        function d(z) {
          var C = z._type, O = z._radius, j = r(z._matrix, !0, C !== "rectangle");
          if (C === "rectangle") {
            C = "rect";
            var q = z._size, H = q.width, ie = q.height;
            j.x -= H / 2, j.y -= ie / 2, j.width = H, j.height = ie, O.isZero() && (O = null);
          }
          return O && (C === "circle" ? j.r = O : (j.rx = O.width, j.ry = O.height)), wt.create(C, j, i);
        }
        function v(z, C) {
          var O = r(z._matrix), j = z.getPathData(null, C.precision);
          return j && (O.d = j), wt.create("path", O, i);
        }
        function p(z, C) {
          var O = r(z._matrix, !0), j = z._definition, q = T(j, "symbol"), H = j._item, ie = H.getStrokeBounds();
          return q || (q = wt.create("symbol", {
            viewBox: i.rectangle(ie)
          }), q.appendChild(Y(H, C)), G(j, q, "symbol")), O.href = "#" + q.id, O.x += ie.x, O.y += ie.y, O.width = ie.width, O.height = ie.height, O.overflow = "visible", wt.create("use", O, i);
        }
        function b(z) {
          var C = T(z, "color");
          if (!C) {
            var O = z.getGradient(), j = O._radial, q = z.getOrigin(), H = z.getDestination(), ie;
            if (j) {
              ie = {
                cx: q.x,
                cy: q.y,
                r: q.getDistance(H)
              };
              var ae = z.getHighlight();
              ae && (ie.fx = ae.x, ie.fy = ae.y);
            } else
              ie = {
                x1: q.x,
                y1: q.y,
                x2: H.x,
                y2: H.y
              };
            ie.gradientUnits = "userSpaceOnUse", C = wt.create((j ? "radial" : "linear") + "Gradient", ie, i);
            for (var ue = O._stops, me = 0, se = ue.length; me < se; me++) {
              var de = ue[me], ve = de._color, we = ve.getAlpha(), Se = de._offset;
              ie = {
                offset: Se ?? me / (se - 1)
              }, ve && (ie["stop-color"] = ve.toCSS(!0)), we < 1 && (ie["stop-opacity"] = we), C.appendChild(
                wt.create("stop", ie, i)
              );
            }
            G(z, C, "color");
          }
          return "url(#" + C.id + ")";
        }
        function S(z) {
          var C = wt.create(
            "text",
            r(z._matrix, !0),
            i
          );
          return C.textContent = z._content, C;
        }
        var L = {
          Group: a,
          Layer: a,
          Raster: l,
          Path: u,
          Shape: d,
          CompoundPath: v,
          SymbolItem: p,
          PointText: S
        };
        function E(z, C, O, j) {
          var q = {}, H = !j && z.getParent(), ie = [];
          return z._name != null && (q.id = z._name), o.each(Yt, function(ae) {
            var ue = ae.get, me = ae.type, se = z[ue]();
            if (ae.exportFilter ? ae.exportFilter(z, se) : O.reduceAttributes == !1 || !H || !o.equals(H[ue](), se)) {
              if (me === "color" && se != null) {
                var de = se.getAlpha();
                de < 1 && (q[ae.attribute + "-opacity"] = de);
              }
              me === "style" ? ie.push(ae.attribute + ": " + se) : q[ae.attribute] = se == null ? "none" : me === "color" ? se.gradient ? b(se) : se.toCSS(!0) : me === "array" ? se.join(",") : me === "lookup" ? ae.toSVG[se] : se;
            }
          }), ie.length && (q.style = ie.join(";")), q.opacity === 1 && delete q.opacity, z._visible || (q.visibility = "hidden"), wt.set(C, q, i);
        }
        var A;
        function T(z, C) {
          return A || (A = { ids: {}, svgs: {} }), z && A.svgs[C + "-" + (z._id || z.__id || (z.__id = F.get("svg")))];
        }
        function G(z, C, O) {
          A || T();
          var j = A.ids[O] = (A.ids[O] || 0) + 1;
          C.id = O + "-" + j, A.svgs[O + "-" + (z._id || z.__id)] = C;
        }
        function D(z, C) {
          var O = z, j = null;
          if (A) {
            O = z.nodeName.toLowerCase() === "svg" && z;
            for (var q in A.svgs)
              j || (O || (O = wt.create("svg"), O.appendChild(z)), j = O.insertBefore(
                wt.create("defs"),
                O.firstChild
              )), j.appendChild(A.svgs[q]);
            A = null;
          }
          return C.asString ? new e.XMLSerializer().serializeToString(O) : O;
        }
        function Y(z, C, O) {
          var j = L[z._class], q = j && j(z, C);
          if (q) {
            var H = C.onExport;
            H && (q = H(z, q, C) || q);
            var ie = JSON.stringify(z._data);
            ie && ie !== "{}" && ie !== "null" && q.setAttribute("data-paper-data", ie);
          }
          return q && E(z, q, C, O);
        }
        function k(z) {
          return z || (z = {}), i = new B(z.precision), z;
        }
        X.inject({
          exportSVG: function(z) {
            return z = k(z), D(Y(this, z, !0), z);
          }
        }), fe.inject({
          exportSVG: function(z) {
            z = k(z);
            var C = this._children, O = this.getView(), j = o.pick(z.bounds, "view"), q = z.matrix || j === "view" && O._matrix, H = q && J.read([q]), ie = j === "view" ? new P([0, 0], O.getViewSize()) : j === "content" ? X._getBounds(C, H, { stroke: !0 }).rect : P.read([j], 0, { readNull: !0 }), ae = {
              version: "1.1",
              xmlns: wt.svg,
              "xmlns:xlink": wt.xlink
            };
            ie && (ae.width = ie.width, ae.height = ie.height, (ie.x || ie.x === 0 || ie.y || ie.y === 0) && (ae.viewBox = i.rectangle(ie)));
            var ue = wt.create("svg", ae, i), me = ue;
            H && !H.isIdentity() && (me = ue.appendChild(wt.create(
              "g",
              r(H),
              i
            )));
            for (var se = 0, de = C.length; se < de; se++)
              me.appendChild(Y(C[se], z, !0));
            return D(ue, z);
          }
        });
      }(), new function() {
        var i = {}, r;
        function a(C, O, j, q, H, ie) {
          var ae = wt.get(C, O) || ie, ue = ae == null ? q ? null : j ? "" : 0 : j ? ae : parseFloat(ae);
          return /%\s*$/.test(ae) ? ue / 100 * (H ? 1 : r[/x|^width/.test(O) ? "width" : "height"]) : ue;
        }
        function l(C, O, j, q, H, ie, ae) {
          return O = a(C, O || "x", !1, q, H, ie), j = a(C, j || "y", !1, q, H, ae), q && (O == null || j == null) ? null : new M(O, j);
        }
        function u(C, O, j, q, H) {
          return O = a(C, O || "width", !1, q, H), j = a(C, j || "height", !1, q, H), q && (O == null || j == null) ? null : new V(O, j);
        }
        function d(C, O, j) {
          return C === "none" ? null : O === "number" ? parseFloat(C) : O === "array" ? C ? C.split(/[\s,]+/g).map(parseFloat) : [] : O === "color" ? Y(C) || C : O === "lookup" ? j[C] : C;
        }
        function v(C, O, j, q) {
          var H = C.childNodes, ie = O === "clippath", ae = O === "defs", ue = new W(), me = ue._project, se = me._currentStyle, de = [];
          if (!ie && !ae && (ue = D(ue, C, q), me._currentStyle = ue._style.clone()), q)
            for (var ve = C.querySelectorAll("defs"), we = 0, Se = ve.length; we < Se; we++)
              k(ve[we], j, !1);
          for (var we = 0, Se = H.length; we < Se; we++) {
            var Ae = H[we], Ge;
            Ae.nodeType === 1 && !/^defs$/i.test(Ae.nodeName) && (Ge = k(Ae, j, !1)) && !(Ge instanceof Le) && de.push(Ge);
          }
          return ue.addChildren(de), ie && (ue = D(ue.reduce(), C, q)), me._currentStyle = se, (ie || ae) && (ue.remove(), ue = null), ue;
        }
        function p(C, O) {
          for (var j = C.getAttribute("points").match(
            /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
          ), q = [], H = 0, ie = j.length; H < ie; H += 2)
            q.push(new M(
              parseFloat(j[H]),
              parseFloat(j[H + 1])
            ));
          var ae = new We(q);
          return O === "polygon" && ae.closePath(), ae;
        }
        function b(C) {
          return qt.create(C.getAttribute("d"));
        }
        function S(C, O) {
          var j = (a(C, "href", !0) || "").substring(1), q = O === "radialgradient", H;
          if (j)
            H = i[j].getGradient(), H._radial ^ q && (H = H.clone(), H._radial = q);
          else {
            for (var ie = C.childNodes, ae = [], ue = 0, me = ie.length; ue < me; ue++) {
              var se = ie[ue];
              se.nodeType === 1 && ae.push(D(new Ci(), se));
            }
            H = new ii(ae, q);
          }
          var de, ve, we, Se = a(C, "gradientUnits", !0) !== "userSpaceOnUse";
          q ? (de = l(
            C,
            "cx",
            "cy",
            !1,
            Se,
            "50%",
            "50%"
          ), ve = de.add(
            a(C, "r", !1, !1, Se, "50%"),
            0
          ), we = l(C, "fx", "fy", !0, Se)) : (de = l(
            C,
            "x1",
            "y1",
            !1,
            Se,
            "0%",
            "0%"
          ), ve = l(
            C,
            "x2",
            "y2",
            !1,
            Se,
            "100%",
            "0%"
          ));
          var Ae = D(
            new Lt(H, de, ve, we),
            C
          );
          return Ae._scaleToBounds = Se, null;
        }
        var L = {
          "#document": function(C, O, j, q) {
            for (var H = C.childNodes, ie = 0, ae = H.length; ie < ae; ie++) {
              var ue = H[ie];
              if (ue.nodeType === 1)
                return k(ue, j, q);
            }
          },
          g: v,
          svg: v,
          clippath: v,
          polygon: p,
          polyline: p,
          path: b,
          lineargradient: S,
          radialgradient: S,
          image: function(C) {
            var O = new He(a(C, "href", !0));
            return O.on("load", function() {
              var j = u(C);
              this.setSize(j);
              var q = l(C).add(j.divide(2));
              this._matrix.append(new J().translate(q));
            }), O;
          },
          symbol: function(C, O, j, q) {
            return new Le(
              v(C, O, j, q),
              !0
            );
          },
          defs: v,
          use: function(C) {
            var O = (a(C, "href", !0) || "").substring(1), j = i[O], q = l(C);
            return j ? j instanceof Le ? j.place(q) : j.clone().translate(q) : null;
          },
          circle: function(C) {
            return new Ee.Circle(
              l(C, "cx", "cy"),
              a(C, "r")
            );
          },
          ellipse: function(C) {
            return new Ee.Ellipse({
              center: l(C, "cx", "cy"),
              radius: u(C, "rx", "ry")
            });
          },
          rect: function(C) {
            return new Ee.Rectangle(new P(
              l(C),
              u(C)
            ), u(C, "rx", "ry"));
          },
          line: function(C) {
            return new We.Line(
              l(C, "x1", "y1"),
              l(C, "x2", "y2")
            );
          },
          text: function(C) {
            var O = new $t(l(C).add(
              l(C, "dx", "dy")
            ));
            return O.setContent(C.textContent.trim() || ""), O;
          },
          switch: v
        };
        function E(C, O, j, q) {
          if (C.transform) {
            for (var H = (q.getAttribute(j) || "").split(/\)\s*/g), ie = new J(), ae = 0, ue = H.length; ae < ue; ae++) {
              var me = H[ae];
              if (!me)
                break;
              for (var se = me.split(/\(\s*/), de = se[0].trim(), ve = se[1].split(/[\s,]+/g), we = 0, Se = ve.length; we < Se; we++)
                ve[we] = parseFloat(ve[we]);
              switch (de) {
                case "matrix":
                  ie.append(
                    new J(ve[0], ve[1], ve[2], ve[3], ve[4], ve[5])
                  );
                  break;
                case "rotate":
                  ie.rotate(ve[0], ve[1] || 0, ve[2] || 0);
                  break;
                case "translate":
                  ie.translate(ve[0], ve[1] || 0);
                  break;
                case "scale":
                  ie.scale(ve);
                  break;
                case "skewX":
                  ie.skew(ve[0], 0);
                  break;
                case "skewY":
                  ie.skew(0, ve[0]);
                  break;
              }
            }
            C.transform(ie);
          }
        }
        function A(C, O, j) {
          var q = j === "fill-opacity" ? "getFillColor" : "getStrokeColor", H = C[q] && C[q]();
          H && H.setAlpha(parseFloat(O));
        }
        var T = o.set(o.each(Yt, function(C) {
          this[C.attribute] = function(O, j) {
            if (O[C.set] && (O[C.set](d(j, C.type, C.fromSVG)), C.type === "color")) {
              var q = O[C.get]();
              if (q && q._scaleToBounds) {
                var H = O.getBounds();
                q.transform(new J().translate(H.getPoint()).scale(H.getSize()));
              }
            }
          };
        }, {}), {
          id: function(C, O) {
            i[O] = C, C.setName && C.setName(O);
          },
          "clip-path": function(C, O) {
            var j = Y(O);
            if (j)
              if (j = j.clone(), j.setClipMask(!0), C instanceof W)
                C.insertChild(0, j);
              else
                return new W(j, C);
          },
          gradientTransform: E,
          transform: E,
          "fill-opacity": A,
          "stroke-opacity": A,
          visibility: function(C, O) {
            C.setVisible && C.setVisible(O === "visible");
          },
          display: function(C, O) {
            C.setVisible && C.setVisible(O !== null);
          },
          "stop-color": function(C, O) {
            C.setColor && C.setColor(O);
          },
          "stop-opacity": function(C, O) {
            C._color && C._color.setAlpha(parseFloat(O));
          },
          offset: function(C, O) {
            if (C.setOffset) {
              var j = O.match(/(.*)%$/);
              C.setOffset(j ? j[1] / 100 : parseFloat(O));
            }
          },
          viewBox: function(C, O, j, q, H) {
            var ie = new P(d(O, "array")), ae = u(q, null, null, !0), ue, me;
            if (C instanceof W) {
              var se = ae ? ae.divide(ie.getSize()) : 1, me = new J().scale(se).translate(ie.getPoint().negate());
              ue = C;
            } else
              C instanceof Le && (ae && ie.setSize(ae), ue = C._item);
            if (ue) {
              if (G(q, "overflow", H) !== "visible") {
                var de = new Ee.Rectangle(ie);
                de.setClipMask(!0), ue.addChild(de);
              }
              me && ue.transform(me);
            }
          }
        });
        function G(C, O, j) {
          var q = C.attributes[O], H = q && q.value;
          if (!H && C.style) {
            var ie = o.camelize(O);
            H = C.style[ie], !H && j.node[ie] !== j.parent[ie] && (H = j.node[ie]);
          }
          return H ? H === "none" ? null : H : t;
        }
        function D(C, O, j) {
          var q = O.parentNode, H = {
            node: Gt.getStyles(O) || {},
            parent: !j && !/^defs$/i.test(q.tagName) && Gt.getStyles(q) || {}
          };
          return o.each(T, function(ie, ae) {
            var ue = G(O, ae, H);
            C = ue !== t && ie(C, ue, ae, O, H) || C;
          }), C;
        }
        function Y(C) {
          var O = C && C.match(/\((?:["'#]*)([^"')]+)/), j = O && O[1], q = j && i[n ? j.replace(n.location.href.split("#")[0] + "#", "") : j];
          return q && q._scaleToBounds && (q = q.clone(), q._scaleToBounds = !0), q;
        }
        function k(C, O, j) {
          var q = C.nodeName.toLowerCase(), H = q !== "#document", ie = s.body, ae, ue, me;
          j && H && (r = Ye.getView().getSize(), r = u(C, null, null, !0) || r, ae = wt.create("svg", {
            style: "stroke-width: 1px; stroke-miterlimit: 10"
          }), ue = C.parentNode, me = C.nextSibling, ae.appendChild(C), ie.appendChild(ae));
          var se = Ye.settings, de = se.applyMatrix, ve = se.insertItems;
          se.applyMatrix = !1, se.insertItems = !1;
          var we = L[q], Se = we && we(C, q, O, j) || null;
          if (se.insertItems = ve, se.applyMatrix = de, Se) {
            H && !(Se instanceof W) && (Se = D(Se, C, j));
            var Ae = O.onImport, Ge = H && C.getAttribute("data-paper-data");
            Ae && (Se = Ae(C, Se, O) || Se), O.expandShapes && Se instanceof Ee && (Se.remove(), Se = Se.toPath()), Ge && (Se._data = JSON.parse(Ge));
          }
          return ae && (ie.removeChild(ae), ue && (me ? ue.insertBefore(C, me) : ue.appendChild(C))), j && (i = {}, Se && o.pick(O.applyMatrix, de) && Se.matrix.apply(!0, !0)), Se;
        }
        function z(C, O, j) {
          if (!C)
            return null;
          O = typeof O == "function" ? { onLoad: O } : O || {};
          var q = Ye, H = null;
          function ie(se) {
            try {
              var de = typeof se == "object" ? se : new e.DOMParser().parseFromString(
                se.trim(),
                "image/svg+xml"
              );
              if (!de.nodeName)
                throw de = null, new Error("Unsupported SVG source: " + C);
              Ye = q, H = k(de, O, !0), (!O || O.insert !== !1) && j._insertItem(t, H);
              var ve = O.onLoad;
              ve && ve(H, se);
            } catch (we) {
              ae(we);
            }
          }
          function ae(se, de) {
            var ve = O.onError;
            if (ve)
              ve(se, de);
            else
              throw new Error(se);
          }
          if (typeof C == "string" && !/^[\s\S]*</.test(C)) {
            var ue = s.getElementById(C);
            ue ? ie(ue) : kt.request({
              url: C,
              async: !0,
              onLoad: ie,
              onError: ae
            });
          } else if (typeof File < "u" && C instanceof File) {
            var me = new FileReader();
            return me.onload = function() {
              ie(me.result);
            }, me.onerror = function() {
              ae(me.error);
            }, me.readAsText(C);
          } else
            ie(C);
          return H;
        }
        X.inject({
          importSVG: function(C, O) {
            return z(C, O, this);
          }
        }), fe.inject({
          importSVG: function(C, O) {
            return this.activate(), z(C, O, this);
          }
        });
      }(), o.exports.PaperScript = (function() {
        var i = this, r = i.acorn;
        if (!r && typeof eb < "u")
          try {
            r = require("acorn");
          } catch {
          }
        if (!r) {
          var a, l;
          r = a = l = {}, function(D, Y) {
            if (typeof a == "object" && typeof l == "object")
              return Y(a);
            if (typeof t == "function" && t.amd)
              return t(["exports"], Y);
            Y(D.acorn || (D.acorn = {}));
          }(this, function(D) {
            D.version = "0.5.0";
            var Y, k, z, C;
            D.parse = function(Q, oe) {
              return k = String(Q), z = k.length, j(oe), _e(), Js(Y.program);
            };
            var O = D.defaultOptions = {
              ecmaVersion: 5,
              strictSemicolons: !1,
              allowTrailingCommas: !0,
              forbidReserved: !1,
              allowReturnOutsideFunction: !1,
              locations: !1,
              onComment: null,
              ranges: !1,
              program: null,
              sourceFile: null,
              directSourceFile: null
            };
            function j(Q) {
              Y = Q || {};
              for (var oe in O)
                Object.prototype.hasOwnProperty.call(Y, oe) || (Y[oe] = O[oe]);
              C = Y.sourceFile || null;
            }
            var q = D.getLineInfo = function(Q, oe) {
              for (var Me = 1, Be = 0; ; ) {
                N.lastIndex = Be;
                var ht = N.exec(Q);
                if (ht && ht.index < oe)
                  ++Me, Be = ht.index + ht[0].length;
                else
                  break;
              }
              return { line: Me, column: oe - Be };
            };
            D.tokenize = function(Q, oe) {
              k = String(Q), z = k.length, j(oe), _e();
              var Me = {};
              function Be(ht) {
                return Ge = ae, an(ht), Me.start = ie, Me.end = ae, Me.startLoc = ue, Me.endLoc = me, Me.type = se, Me.value = de, Me;
              }
              return Be.jumpTo = function(ht, gt) {
                if (H = ht, Y.locations) {
                  we = 1, Se = N.lastIndex = 0;
                  for (var Mt; (Mt = N.exec(k)) && Mt.index < ht; )
                    ++we, Se = Mt.index + Mt[0].length;
                }
                ve = gt, qe();
              }, Be;
            };
            var H, ie, ae, ue, me, se, de, ve, we, Se, Ae, Ge, et, st, _t, Re;
            function Fe(Q, oe) {
              var Me = q(k, Q);
              oe += " (" + Me.line + ":" + Me.column + ")";
              var Be = new SyntaxError(oe);
              throw Be.pos = Q, Be.loc = Me, Be.raisedAt = H, Be;
            }
            var at = [], yt = { type: "num" }, bt = { type: "regexp" }, Rt = { type: "string" }, It = { type: "name" }, Ht = { type: "eof" }, jt = { keyword: "break" }, Vt = { keyword: "case", beforeExpr: !0 }, Ti = { keyword: "catch" }, ki = { keyword: "continue" }, Li = { keyword: "debugger" }, bi = { keyword: "default" }, si = { keyword: "do", isLoop: !0 }, Nt = { keyword: "else", beforeExpr: !0 }, Vi = { keyword: "finally" }, ci = { keyword: "for", isLoop: !0 }, nn = { keyword: "function" }, Yi = { keyword: "if" }, qi = { keyword: "return", beforeExpr: !0 }, Qi = { keyword: "switch" }, Gi = { keyword: "throw", beforeExpr: !0 }, Xi = { keyword: "try" }, _n = { keyword: "var" }, Ki = { keyword: "while", isLoop: !0 }, cn = { keyword: "with" }, Cn = { keyword: "new", beforeExpr: !0 }, $r = { keyword: "this" }, Pr = { keyword: "null", atomValue: null }, An = { keyword: "true", atomValue: !0 }, Xr = { keyword: "false", atomValue: !1 }, Vn = { keyword: "in", binop: 7, beforeExpr: !0 }, gr = {
              break: jt,
              case: Vt,
              catch: Ti,
              continue: ki,
              debugger: Li,
              default: bi,
              do: si,
              else: Nt,
              finally: Vi,
              for: ci,
              function: nn,
              if: Yi,
              return: qi,
              switch: Qi,
              throw: Gi,
              try: Xi,
              var: _n,
              while: Ki,
              with: cn,
              null: Pr,
              true: An,
              false: Xr,
              new: Cn,
              in: Vn,
              instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
              this: $r,
              typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
              void: { keyword: "void", prefix: !0, beforeExpr: !0 },
              delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
            }, Hn = { type: "[", beforeExpr: !0 }, fn = { type: "]" }, dn = { type: "{", beforeExpr: !0 }, bn = { type: "}" }, sn = { type: "(", beforeExpr: !0 }, ri = { type: ")" }, gn = { type: ",", beforeExpr: !0 }, rn = { type: ";", beforeExpr: !0 }, On = { type: ":", beforeExpr: !0 }, pr = { type: "." }, Nr = { type: "?", beforeExpr: !0 }, wr = { binop: 10, beforeExpr: !0 }, Sr = { isAssign: !0, beforeExpr: !0 }, g = { isAssign: !0, beforeExpr: !0 }, U = { postfix: !0, prefix: !0, isUpdate: !0 }, he = { prefix: !0, beforeExpr: !0 }, ye = { binop: 1, beforeExpr: !0 }, Ie = { binop: 2, beforeExpr: !0 }, ot = { binop: 3, beforeExpr: !0 }, dt = { binop: 4, beforeExpr: !0 }, zt = { binop: 5, beforeExpr: !0 }, Kt = { binop: 6, beforeExpr: !0 }, fi = { binop: 7, beforeExpr: !0 }, ti = { binop: 8, beforeExpr: !0 }, hi = { binop: 9, prefix: !0, beforeExpr: !0 }, vn = { binop: 10, beforeExpr: !0 };
            D.tokTypes = {
              bracketL: Hn,
              bracketR: fn,
              braceL: dn,
              braceR: bn,
              parenL: sn,
              parenR: ri,
              comma: gn,
              semi: rn,
              colon: On,
              dot: pr,
              question: Nr,
              slash: wr,
              eq: Sr,
              name: It,
              eof: Ht,
              num: yt,
              regexp: bt,
              string: Rt
            };
            for (var ar in gr)
              D.tokTypes["_" + ar] = gr[ar];
            function Tn(Q) {
              Q = Q.split(" ");
              var oe = "", Me = [];
              e:
                for (var Be = 0; Be < Q.length; ++Be) {
                  for (var ht = 0; ht < Me.length; ++ht)
                    if (Me[ht][0].length == Q[Be].length) {
                      Me[ht].push(Q[Be]);
                      continue e;
                    }
                  Me.push([Q[Be]]);
                }
              function gt(Wt) {
                if (Wt.length == 1)
                  return oe += "return str === " + JSON.stringify(Wt[0]) + ";";
                oe += "switch(str){";
                for (var xi = 0; xi < Wt.length; ++xi)
                  oe += "case " + JSON.stringify(Wt[xi]) + ":";
                oe += "return true}return false;";
              }
              if (Me.length > 3) {
                Me.sort(function(Wt, xi) {
                  return xi.length - Wt.length;
                }), oe += "switch(str.length){";
                for (var Be = 0; Be < Me.length; ++Be) {
                  var Mt = Me[Be];
                  oe += "case " + Mt[0].length + ":", gt(Mt);
                }
                oe += "}";
              } else
                gt(Q);
              return new Function("str", oe);
            }
            var Mr = Tn("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), Cr = Tn("class enum extends super const export import"), or = Tn("implements interface let package private protected public static yield"), Ar = Tn("eval arguments"), ls = Tn("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), Sn = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Rr = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Dr = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", vs = new RegExp("[" + Rr + "]"), Ts = new RegExp("[" + Rr + Dr + "]"), w = /[\n\r\u2028\u2029]/, N = /\r\n|[\n\r\u2028\u2029]/g, ee = D.isIdentifierStart = function(Q) {
              return Q < 65 ? Q === 36 : Q < 91 ? !0 : Q < 97 ? Q === 95 : Q < 123 ? !0 : Q >= 170 && vs.test(String.fromCharCode(Q));
            }, re = D.isIdentifierChar = function(Q) {
              return Q < 48 ? Q === 36 : Q < 58 ? !0 : Q < 65 ? !1 : Q < 91 ? !0 : Q < 97 ? Q === 95 : Q < 123 ? !0 : Q >= 170 && Ts.test(String.fromCharCode(Q));
            };
            function ge() {
              this.line = we, this.column = H - Se;
            }
            function _e() {
              we = 1, H = Se = 0, ve = !0, qe();
            }
            function xe(Q, oe) {
              ae = H, Y.locations && (me = new ge()), se = Q, qe(), de = oe, ve = Q.beforeExpr;
            }
            function Ue() {
              var Q = Y.onComment && Y.locations && new ge(), oe = H, Me = k.indexOf("*/", H += 2);
              if (Me === -1 && Fe(H - 2, "Unterminated comment"), H = Me + 2, Y.locations) {
                N.lastIndex = oe;
                for (var Be; (Be = N.exec(k)) && Be.index < H; )
                  ++we, Se = Be.index + Be[0].length;
              }
              Y.onComment && Y.onComment(
                !0,
                k.slice(oe + 2, Me),
                oe,
                H,
                Q,
                Y.locations && new ge()
              );
            }
            function De() {
              for (var Q = H, oe = Y.onComment && Y.locations && new ge(), Me = k.charCodeAt(H += 2); H < z && Me !== 10 && Me !== 13 && Me !== 8232 && Me !== 8233; )
                ++H, Me = k.charCodeAt(H);
              Y.onComment && Y.onComment(
                !1,
                k.slice(Q + 2, H),
                Q,
                H,
                oe,
                Y.locations && new ge()
              );
            }
            function qe() {
              for (; H < z; ) {
                var Q = k.charCodeAt(H);
                if (Q === 32)
                  ++H;
                else if (Q === 13) {
                  ++H;
                  var oe = k.charCodeAt(H);
                  oe === 10 && ++H, Y.locations && (++we, Se = H);
                } else if (Q === 10 || Q === 8232 || Q === 8233)
                  ++H, Y.locations && (++we, Se = H);
                else if (Q > 8 && Q < 14)
                  ++H;
                else if (Q === 47) {
                  var oe = k.charCodeAt(H + 1);
                  if (oe === 42)
                    Ue();
                  else if (oe === 47)
                    De();
                  else
                    break;
                } else if (Q === 160)
                  ++H;
                else if (Q >= 5760 && Sn.test(String.fromCharCode(Q)))
                  ++H;
                else
                  break;
              }
            }
            function At() {
              var Q = k.charCodeAt(H + 1);
              return Q >= 48 && Q <= 57 ? en(!0) : (++H, xe(pr));
            }
            function Bt() {
              var Q = k.charCodeAt(H + 1);
              return ve ? (++H, Ii()) : Q === 61 ? Si(g, 2) : Si(wr, 1);
            }
            function ct() {
              var Q = k.charCodeAt(H + 1);
              return Q === 61 ? Si(g, 2) : Si(vn, 1);
            }
            function Ft(Q) {
              var oe = k.charCodeAt(H + 1);
              return oe === Q ? Si(Q === 124 ? ye : Ie, 2) : oe === 61 ? Si(g, 2) : Si(Q === 124 ? ot : zt, 1);
            }
            function pi() {
              var Q = k.charCodeAt(H + 1);
              return Q === 61 ? Si(g, 2) : Si(dt, 1);
            }
            function ai(Q) {
              var oe = k.charCodeAt(H + 1);
              return oe === Q ? oe == 45 && k.charCodeAt(H + 2) == 62 && w.test(k.slice(Ge, H)) ? (H += 3, De(), qe(), an()) : Si(U, 2) : oe === 61 ? Si(g, 2) : Si(hi, 1);
            }
            function mi(Q) {
              var oe = k.charCodeAt(H + 1), Me = 1;
              return oe === Q ? (Me = Q === 62 && k.charCodeAt(H + 2) === 62 ? 3 : 2, k.charCodeAt(H + Me) === 61 ? Si(g, Me + 1) : Si(ti, Me)) : oe == 33 && Q == 60 && k.charCodeAt(H + 2) == 45 && k.charCodeAt(H + 3) == 45 ? (H += 4, De(), qe(), an()) : (oe === 61 && (Me = k.charCodeAt(H + 2) === 61 ? 3 : 2), Si(fi, Me));
            }
            function xn(Q) {
              var oe = k.charCodeAt(H + 1);
              return oe === 61 ? Si(Kt, k.charCodeAt(H + 2) === 61 ? 3 : 2) : Si(Q === 61 ? Sr : he, 1);
            }
            function wn(Q) {
              switch (Q) {
                case 46:
                  return At();
                case 40:
                  return ++H, xe(sn);
                case 41:
                  return ++H, xe(ri);
                case 59:
                  return ++H, xe(rn);
                case 44:
                  return ++H, xe(gn);
                case 91:
                  return ++H, xe(Hn);
                case 93:
                  return ++H, xe(fn);
                case 123:
                  return ++H, xe(dn);
                case 125:
                  return ++H, xe(bn);
                case 58:
                  return ++H, xe(On);
                case 63:
                  return ++H, xe(Nr);
                case 48:
                  var oe = k.charCodeAt(H + 1);
                  if (oe === 120 || oe === 88)
                    return Fi();
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                  return en(!1);
                case 34:
                case 39:
                  return lr(Q);
                case 47:
                  return Bt();
                case 37:
                case 42:
                  return ct();
                case 124:
                case 38:
                  return Ft(Q);
                case 94:
                  return pi();
                case 43:
                case 45:
                  return ai(Q);
                case 60:
                case 62:
                  return mi(Q);
                case 61:
                case 33:
                  return xn(Q);
                case 126:
                  return Si(he, 1);
              }
              return !1;
            }
            function an(Q) {
              if (Q ? H = ie + 1 : ie = H, Y.locations && (ue = new ge()), Q)
                return Ii();
              if (H >= z)
                return xe(Ht);
              var oe = k.charCodeAt(H);
              if (ee(oe) || oe === 92)
                return Yn();
              var Me = wn(oe);
              if (Me === !1) {
                var Be = String.fromCharCode(oe);
                if (Be === "\\" || vs.test(Be))
                  return Yn();
                Fe(H, "Unexpected character '" + Be + "'");
              }
              return Me;
            }
            function Si(Q, oe) {
              var Me = k.slice(H, H + oe);
              H += oe, xe(Q, Me);
            }
            function Ii() {
              for (var ht = "", Q, oe, Me = H; ; ) {
                H >= z && Fe(Me, "Unterminated regular expression");
                var Be = k.charAt(H);
                if (w.test(Be) && Fe(Me, "Unterminated regular expression"), Q)
                  Q = !1;
                else {
                  if (Be === "[")
                    oe = !0;
                  else if (Be === "]" && oe)
                    oe = !1;
                  else if (Be === "/" && !oe)
                    break;
                  Q = Be === "\\";
                }
                ++H;
              }
              var ht = k.slice(Me, H);
              ++H;
              var gt = Tr();
              gt && !/^[gmsiy]*$/.test(gt) && Fe(Me, "Invalid regexp flag");
              try {
                var Mt = new RegExp(ht, gt);
              } catch (Wt) {
                Wt instanceof SyntaxError && Fe(Me, Wt.message), Fe(Wt);
              }
              return xe(bt, Mt);
            }
            function Dn(Q, oe) {
              for (var Me = H, Be = 0, ht = 0, gt = oe ?? 1 / 0; ht < gt; ++ht) {
                var Mt = k.charCodeAt(H), Wt;
                if (Mt >= 97 ? Wt = Mt - 97 + 10 : Mt >= 65 ? Wt = Mt - 65 + 10 : Mt >= 48 && Mt <= 57 ? Wt = Mt - 48 : Wt = 1 / 0, Wt >= Q)
                  break;
                ++H, Be = Be * Q + Wt;
              }
              return H === Me || oe != null && H - Me !== oe ? null : Be;
            }
            function Fi() {
              H += 2;
              var Q = Dn(16);
              return Q == null && Fe(ie + 2, "Expected hexadecimal number"), ee(k.charCodeAt(H)) && Fe(H, "Identifier directly after number"), xe(yt, Q);
            }
            function en(Q) {
              var oe = H, Me = !1, Be = k.charCodeAt(H) === 48;
              !Q && Dn(10) === null && Fe(oe, "Invalid number"), k.charCodeAt(H) === 46 && (++H, Dn(10), Me = !0);
              var ht = k.charCodeAt(H);
              (ht === 69 || ht === 101) && (ht = k.charCodeAt(++H), (ht === 43 || ht === 45) && ++H, Dn(10) === null && Fe(oe, "Invalid number"), Me = !0), ee(k.charCodeAt(H)) && Fe(H, "Identifier directly after number");
              var gt = k.slice(oe, H), Mt;
              return Me ? Mt = parseFloat(gt) : !Be || gt.length === 1 ? Mt = parseInt(gt, 10) : /[89]/.test(gt) || Re ? Fe(oe, "Invalid number") : Mt = parseInt(gt, 8), xe(yt, Mt);
            }
            function lr(Q) {
              H++;
              for (var oe = ""; ; ) {
                H >= z && Fe(ie, "Unterminated string constant");
                var Me = k.charCodeAt(H);
                if (Me === Q)
                  return ++H, xe(Rt, oe);
                if (Me === 92) {
                  Me = k.charCodeAt(++H);
                  var Be = /^[0-7]+/.exec(k.slice(H, H + 3));
                  for (Be && (Be = Be[0]); Be && parseInt(Be, 8) > 255; )
                    Be = Be.slice(0, -1);
                  if (Be === "0" && (Be = null), ++H, Be)
                    Re && Fe(H - 2, "Octal literal in strict mode"), oe += String.fromCharCode(parseInt(Be, 8)), H += Be.length - 1;
                  else
                    switch (Me) {
                      case 110:
                        oe += `
`;
                        break;
                      case 114:
                        oe += "\r";
                        break;
                      case 120:
                        oe += String.fromCharCode(mr(2));
                        break;
                      case 117:
                        oe += String.fromCharCode(mr(4));
                        break;
                      case 85:
                        oe += String.fromCharCode(mr(8));
                        break;
                      case 116:
                        oe += "	";
                        break;
                      case 98:
                        oe += "\b";
                        break;
                      case 118:
                        oe += "\v";
                        break;
                      case 102:
                        oe += "\f";
                        break;
                      case 48:
                        oe += "\0";
                        break;
                      case 13:
                        k.charCodeAt(H) === 10 && ++H;
                      case 10:
                        Y.locations && (Se = H, ++we);
                        break;
                      default:
                        oe += String.fromCharCode(Me);
                        break;
                    }
                } else
                  (Me === 13 || Me === 10 || Me === 8232 || Me === 8233) && Fe(ie, "Unterminated string constant"), oe += String.fromCharCode(Me), ++H;
              }
            }
            function mr(Q) {
              var oe = Dn(16, Q);
              return oe === null && Fe(ie, "Bad character escape sequence"), oe;
            }
            var pn;
            function Tr() {
              pn = !1;
              for (var Q, oe = !0, Me = H; ; ) {
                var Be = k.charCodeAt(H);
                if (re(Be))
                  pn && (Q += k.charAt(H)), ++H;
                else if (Be === 92) {
                  pn || (Q = k.slice(Me, H)), pn = !0, k.charCodeAt(++H) != 117 && Fe(H, "Expecting Unicode escape sequence \\uXXXX"), ++H;
                  var ht = mr(4), gt = String.fromCharCode(ht);
                  gt || Fe(H - 1, "Invalid Unicode escape"), (oe ? ee(ht) : re(ht)) || Fe(H - 4, "Invalid Unicode escape"), Q += gt;
                } else
                  break;
                oe = !1;
              }
              return pn ? Q : k.slice(Me, H);
            }
            function Yn() {
              var Q = Tr(), oe = It;
              return !pn && ls(Q) && (oe = gr[Q]), xe(oe, Q);
            }
            function ei() {
              Ae = ie, Ge = ae, et = me, an();
            }
            function Zn(Q) {
              if (Re = Q, H = ie, Y.locations)
                for (; H < Se; )
                  Se = k.lastIndexOf(`
`, Se - 2) + 1, --we;
              qe(), an();
            }
            function Gn() {
              this.type = null, this.start = ie, this.end = null;
            }
            function zr() {
              this.start = ue, this.end = null, C !== null && (this.source = C);
            }
            function Ai() {
              var Q = new Gn();
              return Y.locations && (Q.loc = new zr()), Y.directSourceFile && (Q.sourceFile = Y.directSourceFile), Y.ranges && (Q.range = [ie, 0]), Q;
            }
            function hn(Q) {
              var oe = new Gn();
              return oe.start = Q.start, Y.locations && (oe.loc = new zr(), oe.loc.start = Q.loc.start), Y.ranges && (oe.range = [Q.range[0], 0]), oe;
            }
            function Jt(Q, oe) {
              return Q.type = oe, Q.end = Ge, Y.locations && (Q.loc.end = et), Y.ranges && (Q.range[1] = Ge), Q;
            }
            function Ln(Q) {
              return Y.ecmaVersion >= 5 && Q.type === "ExpressionStatement" && Q.expression.type === "Literal" && Q.expression.value === "use strict";
            }
            function _i(Q) {
              if (se === Q)
                return ei(), !0;
            }
            function Ei() {
              return !Y.strictSemicolons && (se === Ht || se === bn || w.test(k.slice(Ge, ie)));
            }
            function Bn() {
              !_i(rn) && !Ei() && un();
            }
            function di(Q) {
              se === Q ? ei() : un();
            }
            function un() {
              Fe(ie, "Unexpected token");
            }
            function Fr(Q) {
              Q.type !== "Identifier" && Q.type !== "MemberExpression" && Fe(Q.start, "Assigning to rvalue"), Re && Q.type === "Identifier" && Ar(Q.name) && Fe(Q.start, "Assigning to " + Q.name + " in strict mode");
            }
            function Js(Q) {
              Ae = Ge = H, Y.locations && (et = new ge()), st = Re = null, _t = [], an();
              var oe = Q || Ai(), Me = !0;
              for (Q || (oe.body = []); se !== Ht; ) {
                var Be = Ji();
                oe.body.push(Be), Me && Ln(Be) && Zn(!0), Me = !1;
              }
              return Jt(oe, "Program");
            }
            var Kr = { kind: "loop" }, Ur = { kind: "switch" };
            function Ji() {
              (se === wr || se === g && de == "/=") && an(!0);
              var Q = se, oe = Ai();
              switch (Q) {
                case jt:
                case ki:
                  ei();
                  var Me = Q === jt;
                  _i(rn) || Ei() ? oe.label = null : se !== It ? un() : (oe.label = Ze(), Bn());
                  for (var Be = 0; Be < _t.length; ++Be) {
                    var ht = _t[Be];
                    if ((oe.label == null || ht.name === oe.label.name) && (ht.kind != null && (Me || ht.kind === "loop") || oe.label && Me))
                      break;
                  }
                  return Be === _t.length && Fe(oe.start, "Unsyntactic " + Q.keyword), Jt(oe, Me ? "BreakStatement" : "ContinueStatement");
                case Li:
                  return ei(), Bn(), Jt(oe, "DebuggerStatement");
                case si:
                  return ei(), _t.push(Kr), oe.body = Ji(), _t.pop(), di(Ki), oe.test = Pn(), Bn(), Jt(oe, "DoWhileStatement");
                case ci:
                  if (ei(), _t.push(Kr), di(sn), se === rn)
                    return tr(oe, null);
                  if (se === _n) {
                    var gt = Ai();
                    return ei(), $n(gt, !0), Jt(gt, "VariableDeclaration"), gt.declarations.length === 1 && _i(Vn) ? Vr(oe, gt) : tr(oe, gt);
                  }
                  var gt = Ri(!1, !0);
                  return _i(Vn) ? (Fr(gt), Vr(oe, gt)) : tr(oe, gt);
                case nn:
                  return ei(), Tt(oe, !0);
                case Yi:
                  return ei(), oe.test = Pn(), oe.consequent = Ji(), oe.alternate = _i(Nt) ? Ji() : null, Jt(oe, "IfStatement");
                case qi:
                  return !st && !Y.allowReturnOutsideFunction && Fe(ie, "'return' outside of function"), ei(), _i(rn) || Ei() ? oe.argument = null : (oe.argument = Ri(), Bn()), Jt(oe, "ReturnStatement");
                case Qi:
                  ei(), oe.discriminant = Pn(), oe.cases = [], di(dn), _t.push(Ur);
                  for (var Mt, Wt; se != bn; )
                    if (se === Vt || se === bi) {
                      var xi = se === Vt;
                      Mt && Jt(Mt, "SwitchCase"), oe.cases.push(Mt = Ai()), Mt.consequent = [], ei(), xi ? Mt.test = Ri() : (Wt && Fe(Ae, "Multiple default clauses"), Wt = !0, Mt.test = null), di(On);
                    } else
                      Mt || un(), Mt.consequent.push(Ji());
                  return Mt && Jt(Mt, "SwitchCase"), ei(), _t.pop(), Jt(oe, "SwitchStatement");
                case Gi:
                  return ei(), w.test(k.slice(Ge, ie)) && Fe(Ge, "Illegal newline after throw"), oe.argument = Ri(), Bn(), Jt(oe, "ThrowStatement");
                case Xi:
                  if (ei(), oe.block = hr(), oe.handler = null, se === Ti) {
                    var ji = Ai();
                    ei(), di(sn), ji.param = Ze(), Re && Ar(ji.param.name) && Fe(ji.param.start, "Binding " + ji.param.name + " in strict mode"), di(ri), ji.guard = null, ji.body = hr(), oe.handler = Jt(ji, "CatchClause");
                  }
                  return oe.guardedHandlers = at, oe.finalizer = _i(Vi) ? hr() : null, !oe.handler && !oe.finalizer && Fe(oe.start, "Missing catch or finally clause"), Jt(oe, "TryStatement");
                case _n:
                  return ei(), $n(oe), Bn(), Jt(oe, "VariableDeclaration");
                case Ki:
                  return ei(), oe.test = Pn(), _t.push(Kr), oe.body = Ji(), _t.pop(), Jt(oe, "WhileStatement");
                case cn:
                  return Re && Fe(ie, "'with' in strict mode"), ei(), oe.object = Pn(), oe.body = Ji(), Jt(oe, "WithStatement");
                case dn:
                  return hr();
                case rn:
                  return ei(), Jt(oe, "EmptyStatement");
                default:
                  var Nn = de, mn = Ri();
                  if (Q === It && mn.type === "Identifier" && _i(On)) {
                    for (var Be = 0; Be < _t.length; ++Be)
                      _t[Be].name === Nn && Fe(mn.start, "Label '" + Nn + "' is already declared");
                    var _r = se.isLoop ? "loop" : se === Qi ? "switch" : null;
                    return _t.push({ name: Nn, kind: _r }), oe.body = Ji(), _t.pop(), oe.label = mn, Jt(oe, "LabeledStatement");
                  } else
                    return oe.expression = mn, Bn(), Jt(oe, "ExpressionStatement");
              }
            }
            function Pn() {
              di(sn);
              var Q = Ri();
              return di(ri), Q;
            }
            function hr(Q) {
              var oe = Ai(), Me = !0, Be = !1, ht;
              for (oe.body = [], di(dn); !_i(bn); ) {
                var gt = Ji();
                oe.body.push(gt), Me && Q && Ln(gt) && (ht = Be, Zn(Be = !0)), Me = !1;
              }
              return Be && !ht && Zn(!1), Jt(oe, "BlockStatement");
            }
            function tr(Q, oe) {
              return Q.init = oe, di(rn), Q.test = se === rn ? null : Ri(), di(rn), Q.update = se === ri ? null : Ri(), di(ri), Q.body = Ji(), _t.pop(), Jt(Q, "ForStatement");
            }
            function Vr(Q, oe) {
              return Q.left = oe, Q.right = Ri(), di(ri), Q.body = Ji(), _t.pop(), Jt(Q, "ForInStatement");
            }
            function $n(Q, oe) {
              for (Q.declarations = [], Q.kind = "var"; ; ) {
                var Me = Ai();
                if (Me.id = Ze(), Re && Ar(Me.id.name) && Fe(Me.id.start, "Binding " + Me.id.name + " in strict mode"), Me.init = _i(Sr) ? Ri(!0, oe) : null, Q.declarations.push(Jt(Me, "VariableDeclarator")), !_i(gn))
                  break;
              }
              return Q;
            }
            function Ri(Q, oe) {
              var Me = hs(oe);
              if (!Q && se === gn) {
                var Be = hn(Me);
                for (Be.expressions = [Me]; _i(gn); )
                  Be.expressions.push(hs(oe));
                return Jt(Be, "SequenceExpression");
              }
              return Me;
            }
            function hs(Q) {
              var oe = ys(Q);
              if (se.isAssign) {
                var Me = hn(oe);
                return Me.operator = de, Me.left = oe, ei(), Me.right = hs(Q), Fr(oe), Jt(Me, "AssignmentExpression");
              }
              return oe;
            }
            function ys(Q) {
              var oe = Ls(Q);
              if (_i(Nr)) {
                var Me = hn(oe);
                return Me.test = oe, Me.consequent = Ri(!0), di(On), Me.alternate = Ri(!0, Q), Jt(Me, "ConditionalExpression");
              }
              return oe;
            }
            function Ls(Q) {
              return Jn(zn(), -1, Q);
            }
            function Jn(Q, oe, Me) {
              var Be = se.binop;
              if (Be != null && (!Me || se !== Vn) && Be > oe) {
                var ht = hn(Q);
                ht.left = Q, ht.operator = de;
                var gt = se;
                ei(), ht.right = Jn(zn(), Be, Me);
                var Mt = Jt(ht, gt === ye || gt === Ie ? "LogicalExpression" : "BinaryExpression");
                return Jn(Mt, oe, Me);
              }
              return Q;
            }
            function zn() {
              if (se.prefix) {
                var Q = Ai(), oe = se.isUpdate;
                return Q.operator = de, Q.prefix = !0, ve = !0, ei(), Q.argument = zn(), oe ? Fr(Q.argument) : Re && Q.operator === "delete" && Q.argument.type === "Identifier" && Fe(Q.start, "Deleting local variable in strict mode"), Jt(Q, oe ? "UpdateExpression" : "UnaryExpression");
              }
              for (var Me = bs(); se.postfix && !Ei(); ) {
                var Q = hn(Me);
                Q.operator = de, Q.prefix = !1, Q.argument = Me, Fr(Me), ei(), Me = Jt(Q, "UpdateExpression");
              }
              return Me;
            }
            function bs() {
              return ur(Oe());
            }
            function ur(Q, oe) {
              if (_i(pr)) {
                var Me = hn(Q);
                return Me.object = Q, Me.property = Ze(!0), Me.computed = !1, ur(Jt(Me, "MemberExpression"), oe);
              } else if (_i(Hn)) {
                var Me = hn(Q);
                return Me.object = Q, Me.property = Ri(), Me.computed = !0, di(fn), ur(Jt(Me, "MemberExpression"), oe);
              } else if (!oe && _i(sn)) {
                var Me = hn(Q);
                return Me.callee = Q, Me.arguments = Ne(ri, !1), ur(Jt(Me, "CallExpression"), oe);
              } else
                return Q;
            }
            function Oe() {
              switch (se) {
                case $r:
                  var Be = Ai();
                  return ei(), Jt(Be, "ThisExpression");
                case It:
                  return Ze();
                case yt:
                case Rt:
                case bt:
                  var Be = Ai();
                  return Be.value = de, Be.raw = k.slice(ie, ae), ei(), Jt(Be, "Literal");
                case Pr:
                case An:
                case Xr:
                  var Be = Ai();
                  return Be.value = se.atomValue, Be.raw = se.keyword, ei(), Jt(Be, "Literal");
                case sn:
                  var Q = ue, oe = ie;
                  ei();
                  var Me = Ri();
                  return Me.start = oe, Me.end = ae, Y.locations && (Me.loc.start = Q, Me.loc.end = me), Y.ranges && (Me.range = [oe, ae]), di(ri), Me;
                case Hn:
                  var Be = Ai();
                  return ei(), Be.elements = Ne(fn, !0, !0), Jt(Be, "ArrayExpression");
                case dn:
                  return mt();
                case nn:
                  var Be = Ai();
                  return ei(), Tt(Be, !1);
                case Cn:
                  return Ke();
                default:
                  un();
              }
            }
            function Ke() {
              var Q = Ai();
              return ei(), Q.callee = ur(Oe(), !0), _i(sn) ? Q.arguments = Ne(ri, !1) : Q.arguments = at, Jt(Q, "NewExpression");
            }
            function mt() {
              var Q = Ai(), oe = !0, Me = !1;
              for (Q.properties = [], ei(); !_i(bn); ) {
                if (oe)
                  oe = !1;
                else if (di(gn), Y.allowTrailingCommas && _i(bn))
                  break;
                var Be = { key: St() }, ht = !1, gt;
                if (_i(On) ? (Be.value = Ri(!0), gt = Be.kind = "init") : Y.ecmaVersion >= 5 && Be.key.type === "Identifier" && (Be.key.name === "get" || Be.key.name === "set") ? (ht = Me = !0, gt = Be.kind = Be.key.name, Be.key = St(), se !== sn && un(), Be.value = Tt(Ai(), !1)) : un(), Be.key.type === "Identifier" && (Re || Me))
                  for (var Mt = 0; Mt < Q.properties.length; ++Mt) {
                    var Wt = Q.properties[Mt];
                    if (Wt.key.name === Be.key.name) {
                      var xi = gt == Wt.kind || ht && Wt.kind === "init" || gt === "init" && (Wt.kind === "get" || Wt.kind === "set");
                      xi && !Re && gt === "init" && Wt.kind === "init" && (xi = !1), xi && Fe(Be.key.start, "Redefinition of property");
                    }
                  }
                Q.properties.push(Be);
              }
              return Jt(Q, "ObjectExpression");
            }
            function St() {
              return se === yt || se === Rt ? Oe() : Ze(!0);
            }
            function Tt(Q, oe) {
              se === It ? Q.id = Ze() : oe ? un() : Q.id = null, Q.params = [];
              var Me = !0;
              for (di(sn); !_i(ri); )
                Me ? Me = !1 : di(gn), Q.params.push(Ze());
              var Be = st, ht = _t;
              if (st = !0, _t = [], Q.body = hr(!0), st = Be, _t = ht, Re || Q.body.body.length && Ln(Q.body.body[0]))
                for (var gt = Q.id ? -1 : 0; gt < Q.params.length; ++gt) {
                  var Mt = gt < 0 ? Q.id : Q.params[gt];
                  if ((or(Mt.name) || Ar(Mt.name)) && Fe(Mt.start, "Defining '" + Mt.name + "' in strict mode"), gt >= 0)
                    for (var Wt = 0; Wt < gt; ++Wt)
                      Mt.name === Q.params[Wt].name && Fe(Mt.start, "Argument name clash in strict mode");
                }
              return Jt(Q, oe ? "FunctionDeclaration" : "FunctionExpression");
            }
            function Ne(Q, oe, Me) {
              for (var Be = [], ht = !0; !_i(Q); ) {
                if (ht)
                  ht = !1;
                else if (di(gn), oe && Y.allowTrailingCommas && _i(Q))
                  break;
                Me && se === gn ? Be.push(null) : Be.push(Ri(!0));
              }
              return Be;
            }
            function Ze(Q) {
              var oe = Ai();
              return Q && Y.forbidReserved == "everywhere" && (Q = !1), se === It ? (!Q && (Y.forbidReserved && (Y.ecmaVersion === 3 ? Mr : Cr)(de) || Re && or(de)) && k.slice(ie, ae).indexOf("\\") == -1 && Fe(ie, "The keyword '" + de + "' is reserved"), oe.name = de) : Q && se.keyword ? oe.name = se.keyword : un(), ve = !1, ei(), Jt(oe, "Identifier");
            }
          }), r.version || (r = null);
        }
        function u(D, Y) {
          return (i.acorn || r).parse(D, Y);
        }
        var d = {
          "+": "__add",
          "-": "__subtract",
          "*": "__multiply",
          "/": "__divide",
          "%": "__modulo",
          "==": "__equals",
          "!=": "__equals"
        }, v = {
          "-": "__negate",
          "+": "__self"
        }, p = o.each(
          ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
          function(D) {
            this["__" + D] = "#" + D;
          },
          {
            __self: function() {
              return this;
            }
          }
        );
        M.inject(p), V.inject(p), Lt.inject(p);
        function b(D, Y, k) {
          var z = d[Y];
          if (D && D[z]) {
            var C = D[z](k);
            return Y === "!=" ? !C : C;
          }
          switch (Y) {
            case "+":
              return D + k;
            case "-":
              return D - k;
            case "*":
              return D * k;
            case "/":
              return D / k;
            case "%":
              return D % k;
            case "==":
              return D == k;
            case "!=":
              return D != k;
          }
        }
        function S(D, Y) {
          var k = v[D];
          if (Y && Y[k])
            return Y[k]();
          switch (D) {
            case "+":
              return +Y;
            case "-":
              return -Y;
          }
        }
        function L(D, Y) {
          if (!D)
            return "";
          Y = Y || {};
          var k = [];
          function z(Re) {
            for (var Fe = 0, at = k.length; Fe < at; Fe++) {
              var yt = k[Fe];
              if (yt[0] >= Re)
                break;
              Re += yt[1];
            }
            return Re;
          }
          function C(Re) {
            return D.substring(
              z(Re.range[0]),
              z(Re.range[1])
            );
          }
          function O(Re, Fe) {
            return D.substring(
              z(Re.range[1]),
              z(Fe.range[0])
            );
          }
          function j(Re, Fe) {
            for (var at = z(Re.range[0]), yt = z(Re.range[1]), bt = 0, Rt = k.length - 1; Rt >= 0; Rt--)
              if (at > k[Rt][0]) {
                bt = Rt + 1;
                break;
              }
            k.splice(bt, 0, [at, Fe.length - yt + at]), D = D.substring(0, at) + Fe + D.substring(yt);
          }
          function q(Re, Fe) {
            switch (Re.type) {
              case "UnaryExpression":
                if (Re.operator in v && Re.argument.type !== "Literal") {
                  var at = C(Re.argument);
                  j(Re, '$__("' + Re.operator + '", ' + at + ")");
                }
                break;
              case "BinaryExpression":
                if (Re.operator in d && Re.left.type !== "Literal") {
                  var yt = C(Re.left), bt = C(Re.right), Rt = O(Re.left, Re.right), It = Re.operator;
                  j(Re, "__$__(" + yt + "," + Rt.replace(
                    new RegExp("\\" + It),
                    '"' + It + '"'
                  ) + ", " + bt + ")");
                }
                break;
              case "UpdateExpression":
              case "AssignmentExpression":
                var Ht = Fe && Fe.type;
                if (!(Ht === "ForStatement" || Ht === "BinaryExpression" && /^[=!<>]/.test(Fe.operator) || Ht === "MemberExpression" && Fe.computed)) {
                  if (Re.type === "UpdateExpression") {
                    var at = C(Re.argument), jt = "__$__(" + at + ', "' + Re.operator[0] + '", 1)', Vt = at + " = " + jt;
                    Re.prefix ? Vt = "(" + Vt + ")" : (Ht === "AssignmentExpression" || Ht === "VariableDeclarator" || Ht === "BinaryExpression") && (C(Fe.left || Fe.id) === at && (Vt = jt), Vt = at + "; " + Vt), j(Re, Vt);
                  } else if (/^.=$/.test(Re.operator) && Re.left.type !== "Literal") {
                    var yt = C(Re.left), bt = C(Re.right), jt = yt + " = __$__(" + yt + ', "' + Re.operator[0] + '", ' + bt + ")";
                    j(Re, /^\(.*\)$/.test(C(Re)) ? "(" + jt + ")" : jt);
                  }
                }
                break;
            }
          }
          function H(Re) {
            switch (Re.type) {
              case "ExportDefaultDeclaration":
                j({
                  range: [Re.start, Re.declaration.start]
                }, "module.exports = ");
                break;
              case "ExportNamedDeclaration":
                var Fe = Re.declaration, at = Re.specifiers;
                if (Fe) {
                  var yt = Fe.declarations;
                  yt && (yt.forEach(function(Rt) {
                    j(Rt, "module.exports." + C(Rt));
                  }), j({
                    range: [
                      Re.start,
                      Fe.start + Fe.kind.length
                    ]
                  }, ""));
                } else if (at) {
                  var bt = at.map(function(Rt) {
                    var It = C(Rt);
                    return "module.exports." + It + " = " + It + "; ";
                  }).join("");
                  bt && j(Re, bt);
                }
                break;
            }
          }
          function ie(Re, Fe, at) {
            if (Re) {
              for (var yt in Re)
                if (yt !== "range" && yt !== "loc") {
                  var bt = Re[yt];
                  if (Array.isArray(bt))
                    for (var Rt = 0, It = bt.length; Rt < It; Rt++)
                      ie(bt[Rt], Re, at);
                  else
                    bt && typeof bt == "object" && ie(bt, Re, at);
                }
              at.operatorOverloading !== !1 && q(Re, Fe), at.moduleExports !== !1 && H(Re);
            }
          }
          function ae(Re) {
            var Fe = "", at = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for (Re = (Math.abs(Re) << 1) + (Re < 0 ? 1 : 0); Re || !Fe; ) {
              var yt = Re & 31;
              Re >>= 5, Re && (yt |= 32), Fe += at[yt];
            }
            return Fe;
          }
          var ue = Y.url || "", me = Y.sourceMaps, se = Y.paperFeatures || {}, de = Y.source || D, ve = Y.offset || 0, we = Ye.agent, Se = we.versionNumber, Ae = !1, Ge = /\r\n|\n|\r/mg, et;
          if (me && (we.chrome && Se >= 30 || we.webkit && Se >= 537.76 || we.firefox && Se >= 23 || we.node)) {
            if (we.node)
              ve -= 2;
            else if (n && ue && !n.location.href.indexOf(ue)) {
              var st = s.getElementsByTagName("html")[0].innerHTML;
              ve = st.substr(0, st.indexOf(D) + 1).match(
                Ge
              ).length + 1;
            }
            Ae = ve > 0 && !(we.chrome && Se >= 36 || we.safari && Se >= 600 || we.firefox && Se >= 40 || we.node);
            var _t = ["AA" + ae(Ae ? 0 : ve) + "A"];
            _t.length = (D.match(Ge) || []).length + 1 + (Ae ? ve : 0), et = {
              version: 3,
              file: ue,
              names: [],
              mappings: _t.join(";AACA"),
              sourceRoot: "",
              sources: [ue],
              sourcesContent: [de]
            };
          }
          return (se.operatorOverloading !== !1 || se.moduleExports !== !1) && ie(u(D, {
            ranges: !0,
            preserveParens: !0,
            sourceType: "module"
          }), null, se), et && (Ae && (D = new Array(ve + 1).join(`
`) + D), /^(inline|both)$/.test(me) && (D += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
            JSON.stringify(et)
          )))), D += `
//# sourceURL=` + (ue || "paperscript")), {
            url: ue,
            source: de,
            code: D,
            map: et
          };
        }
        function E(D, Y, k) {
          Ye = Y;
          var z = Y.getView(), C = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(D) && !/\bnew\s+Tool\b/.test(D) ? new ke() : null, O = C ? C._events : [], j = ["onFrame", "onResize"].concat(O), q = [], H = [], ie, ae = typeof D == "object" ? D : L(D, k);
          D = ae.code;
          function ue(Se, Ae) {
            for (var Ge in Se)
              (Ae || !/^_/.test(Ge)) && new RegExp("([\\b\\s\\W]|^)" + Ge.replace(/\$/g, "\\$") + "\\b").test(D) && (q.push(Ge), H.push(Se[Ge]));
          }
          ue(
            { __$__: b, $__: S, paper: Y, tool: C },
            !0
          ), ue(Y), D = "var module = { exports: {} }; " + D;
          var ve = o.each(j, function(Se) {
            new RegExp("\\s+" + Se + "\\b").test(D) && (q.push(Se), this.push("module.exports." + Se + " = " + Se + ";"));
          }, []).join(`
`);
          ve && (D += `
` + ve), D += `
return module.exports;`;
          var me = Ye.agent;
          if (s && (me.chrome || me.firefox && me.versionNumber < 40)) {
            var se = s.createElement("script"), de = s.head || s.getElementsByTagName("head")[0];
            me.firefox && (D = `
` + D), se.appendChild(s.createTextNode(
              "document.__paperscript__ = function(" + q + ") {" + D + `
}`
            )), de.appendChild(se), ie = s.__paperscript__, delete s.__paperscript__, de.removeChild(se);
          } else
            ie = Function(q, D);
          var ve = ie && ie.apply(Y, H), we = ve || {};
          return o.each(O, function(Se) {
            var Ae = we[Se];
            Ae && (C[Se] = Ae);
          }), z && (we.onResize && z.setOnResize(we.onResize), z.emit("resize", {
            size: z.size,
            delta: new M()
          }), we.onFrame && z.setOnFrame(we.onFrame), z.requestUpdate()), ve;
        }
        function A(D) {
          if (/^text\/(?:x-|)paperscript$/.test(D.type) && c.getAttribute(D, "ignore") !== "true") {
            var Y = c.getAttribute(D, "canvas"), k = s.getElementById(Y), z = D.src || D.getAttribute("data-src"), C = c.hasAttribute(D, "async"), O = "data-paper-scope";
            if (!k)
              throw new Error('Unable to find canvas with id "' + Y + '"');
            var j = c.get(k.getAttribute(O)) || new c().setup(k);
            return k.setAttribute(O, j._id), z ? kt.request({
              url: z,
              async: C,
              mimeType: "text/plain",
              onLoad: function(q) {
                E(q, j, z);
              }
            }) : E(D.innerHTML, j, D.baseURI), D.setAttribute("data-paper-ignore", "true"), j;
          }
        }
        function T() {
          o.each(
            s && s.getElementsByTagName("script"),
            A
          );
        }
        function G(D) {
          return D ? A(D) : T();
        }
        return n && (s.readyState === "complete" ? setTimeout(T) : Xt.add(n, { load: T })), {
          compile: L,
          execute: E,
          load: G,
          parse: u,
          calculateBinary: b,
          calculateUnary: S
        };
      }).call(this);
      var Ye = new (c.inject(o.exports, {
        Base: o,
        Numerical: I,
        Key: xt,
        DomEvent: Xt,
        DomElement: Gt,
        document: s,
        window: n,
        Symbol: Le,
        PlacedSymbol: ft
      }))();
      return Ye.agent.node && Bf(Ye), typeof t == "function" && t.amd ? t("paper", Ye) : y && (y.exports = Ye), Ye;
    }).call(nb, typeof self == "object" ? self : null);
  }(Yh)), Yh.exports;
}
var sb = rb();
const Ef = /* @__PURE__ */ Jy(sb);
class ab {
  constructor() {
    il(this, "_paperScope", new Ef.PaperScope()), il(this, "_baseMaterial", null), il(this, "_borderMaterial", null), il(this, "transparentMaterial", null);
    const e = document.createElement("canvas");
    e.width = 1, e.height = 1, this._paperScope.setup(new Ef.Size(1, 1));
  }
  async generatePreview3D(e, t) {
    if (!e.columns || isNaN(e.columns) || e.columns < 1 || e.rows < 1 || !e.rows || isNaN(e.rows))
      throw new Error("Invalid columns or rows value. Columns and rows must be greater than 0 and must be a number.");
    console.log("Generating 3D preview for resizable canvas...", e);
    const { textureWidth: n, textureHeight: s } = await this.prepareMaterials(e, t), o = e.shape === "ellipse" ? await this.generateEllipseMesh(e, t, n, s) : this.buildRectangleMeshGroups(e, t, n, s);
    if (!o)
      return null;
    const {
      bordersList: h,
      backsList: c,
      frontsList: m,
      texturedBordersList: x,
      texturedBacksList: B,
      texturedFrontsList: I
    } = o, F = new BABYLON.Mesh("groupMesh", t), M = BABYLON.Mesh.MergeMeshes(h, !0, !0, void 0, !1, !1), Z = BABYLON.Mesh.MergeMeshes(c, !0, !0, void 0, !1, !1), V = BABYLON.Mesh.MergeMeshes(m, !0, !0, void 0, !1, !1), te = BABYLON.Mesh.MergeMeshes(x, !0, !0, void 0, !1, !1), P = BABYLON.Mesh.MergeMeshes(B, !0, !0, void 0, !1, !1), K = BABYLON.Mesh.MergeMeshes(I, !0, !0, void 0, !1, !1);
    if (!M || !Z || !V || !te || !P || !K)
      return null;
    M.material = this.transparentMaterial, Z.material = this.transparentMaterial, V.material = this.transparentMaterial, te.material = this._borderMaterial, P.material = this._baseMaterial, K.material = this._baseMaterial, M.parent = F, Z.parent = F, V.parent = F, te.parent = F, P.parent = F, K.parent = F, M.name = "borders", Z.name = "back", V.name = "front", te.name = "texturedBorders", P.name = "texturedBack", K.name = "texturedFront";
    const J = BABYLON.SceneSerializer.SerializeMesh(F, !1, !0);
    return F.dispose(), [...h, ...c, ...m, ...x, ...B, ...I].forEach(
      (le) => le && !le.isDisposed() && le.dispose()
    ), J;
  }
  // Common material preparation
  async prepareMaterials(e, t) {
    this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("baseMaterial", t)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("borderMaterial", t)), this.transparentMaterial || (this.transparentMaterial = new BABYLON.StandardMaterial("transparentMaterial", t)), this._baseMaterial.albedoColor = BABYLON.Color3.FromHexString(e.backgroundColor ?? "#FFFFFF"), this._baseMaterial.metallic = 0, this._baseMaterial.roughness = 0.5, this._borderMaterial.albedoColor = BABYLON.Color3.FromHexString(e.borderColor ?? e.backgroundColor ?? "#000000"), this._borderMaterial.metallic = 0, this._borderMaterial.roughness = 0.5, this.transparentMaterial.alpha = 0, this.transparentMaterial.backFaceCulling = !0, this.transparentMaterial.diffuseColor = BABYLON.Color3.FromHexString("#FF0000");
    let n, s;
    const o = (h) => {
      h && (h.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, h.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
    };
    if (e.useCheckerTexture) {
      const h = new Image();
      h.src = "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", await new Promise((c, m) => {
        h.onload = () => c(null), h.onerror = (x) => m(x);
      }), n = h.width, s = h.height, this._baseMaterial.albedoTexture = new BABYLON.Texture(
        "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png",
        t
      ), o(this._baseMaterial.albedoTexture), this._borderMaterial.albedoTexture = new BABYLON.Texture(
        "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png",
        t
      ), o(this._borderMaterial.albedoTexture);
    } else if (e.backgroundUrl) {
      const h = new Image();
      h.src = e.backgroundUrl, await new Promise((c, m) => {
        h.onload = () => c(null), h.onerror = (x) => m(x);
      }), n = h.width, s = h.height, this._baseMaterial.albedoTexture = new BABYLON.Texture(e.backgroundUrl, t), o(this._baseMaterial.albedoTexture), this._baseMaterial.albedoColor = new BABYLON.Color3(1, 1, 1), e.borderColor || (this._borderMaterial.albedoTexture = new BABYLON.Texture(e.backgroundUrl, t), o(this._borderMaterial.albedoTexture), this._borderMaterial.albedoColor = new BABYLON.Color3(1, 1, 1));
    }
    return { textureWidth: n, textureHeight: s };
  }
  // Rectangle mesh groups builder (non-ellipse)
  buildRectangleMeshGroups(e, t, n, s) {
    const o = [], h = [], c = [], m = [], x = [], B = [];
    for (let I = 0; I < e.columns; I++)
      for (let F = 0; F < e.rows; F++) {
        const [M, Z, V] = this.generateCanvasMesh(e, t, I, F, !1), [te, P, K] = this.generateCanvasMesh(e, t, I, F, !0, n, s);
        o.push(M), h.push(Z), c.push(V), m.push(te), x.push(P), B.push(K);
      }
    return { bordersList: o, backsList: h, frontsList: c, texturedBordersList: m, texturedBacksList: x, texturedFrontsList: B };
  }
  // Procedural extruded ellipse (filled). Generates vertices, normals, uvs, indices manually.
  async generateEllipseMesh(e, t, n, s) {
    const o = e.width / 2, h = e.height / 2;
    let c;
    if (e.radiusResolution && e.radiusResolution > 1)
      c = Math.max(8, Math.round(e.radiusResolution));
    else {
      const a = e.radiusResolution && e.radiusResolution > 0 ? e.radiusResolution : 0.1;
      c = Math.max(32, Math.round(2 * Math.PI / a));
    }
    const m = e.depth, x = m / 2, B = -m / 2;
    let I = 1, F = 1, M = 0, Z = 0;
    if (n && s) {
      const a = n / s, l = 2 * o / (2 * h);
      a > l ? (F = 1, I = l / a, M = (I - 1) / 2, Z = 0) : (I = 1, F = a / l, M = 0, Z = (F - 1) / 2);
    }
    const V = (a, l) => ({ u: a / (2 * o) + 0.5, v: l / (2 * h) + 0.5 }), te = [], P = [], K = [], J = [], le = (a, l, u, d, v) => {
      te.push(a, l, u), P.push(0, 0, 1), K.push(d, v);
    };
    let fe = V(0, 0);
    le(0, 0, x, fe.u, fe.v);
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, v = V(u, d);
      le(u, d, x, v.u, v.v);
    }
    for (let a = 0; a < c; a++) {
      const l = 1 + a, u = 1 + (a + 1) % c;
      J.push(0, u, l);
    }
    const X = [], W = [], je = [], Ee = [], He = (a, l, u, d, v) => {
      X.push(a, l, u), W.push(0, 0, -1), je.push(d, v);
    };
    fe = V(0, 0), He(0, 0, B, fe.u, fe.v);
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, v = V(u, d);
      He(u, d, B, v.u, v.v);
    }
    for (let a = 0; a < c; a++) {
      const l = 1 + a, u = 1 + (a + 1) % c;
      Ee.push(0, l, u);
    }
    const ft = [], Le = [], $e = [], ce = [], ut = (a, l, u, d, v, p, b, S) => {
      ft.push(a, l, u), Le.push(d, v, p), $e.push(b, S);
    };
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let v = u / o, p = d / h;
      const b = Math.hypot(v, p);
      b > 0 && (v /= b, p /= b);
      const S = a / c, L = S <= 0.5 ? S * 2 : (1 - S) * 2, E = 1, A = 1 - L;
      ut(u, d, B, v, p, 0, E, A);
    }
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let v = u / o, p = d / h;
      const b = Math.hypot(v, p);
      b > 0 && (v /= b, p /= b);
      const S = a / c, L = S <= 0.5 ? S * 2 : (1 - S) * 2, E = 0, A = 1 - L;
      ut(u, d, x, v, p, 0, E, A);
    }
    const ze = c;
    for (let a = 0; a < c; a++) {
      const l = a, u = (a + 1) % c, d = ze + a, v = ze + (a + 1) % c;
      ce.push(l, d, v), ce.push(l, v, u);
    }
    const pt = new BABYLON.Mesh("groupMeshEllipse", t), qt = new BABYLON.Mesh("back", t), We = new BABYLON.Mesh("front", t), Et = new BABYLON.Mesh("borders", t), rt = new BABYLON.VertexData();
    rt.positions = te, rt.normals = P, rt.uvs = K, rt.indices = J, rt.applyToMesh(qt);
    const it = new BABYLON.VertexData();
    it.positions = X, it.normals = W, it.uvs = je, it.indices = Ee, it.applyToMesh(We);
    const Zt = new BABYLON.VertexData();
    Zt.positions = ft, Zt.normals = Le, Zt.uvs = $e, Zt.indices = ce, Zt.applyToMesh(Et), this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("ellipseBaseMat", t)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("ellipseBorderMat", t)), qt.material = this._baseMaterial, We.material = this._baseMaterial, Et.material = this._borderMaterial, qt.parent = pt, We.parent = pt, Et.parent = pt;
    const $t = (a, l) => {
      let u = a / (2 * o) + 0.5, d = l / (2 * h) + 0.5;
      return u = u * I - M, d = d * F - Z, { u, v: d };
    }, Lt = [], ii = [], Ci = [], ui = [], Gt = (a, l, u, d, v) => {
      Lt.push(a, l, u), ii.push(0, 0, -1), Ci.push(d, v);
    };
    let Xt = V(0, 0);
    Gt(0, 0, B, Xt.u, Xt.v);
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, v = $t(u, d);
      Gt(u, d, B, v.u, v.v);
    }
    for (let a = 0; a < c; a++) {
      const l = 1 + a, u = 1 + (a + 1) % c;
      ui.push(0, l, u);
    }
    const Qt = [], Ni = [], Di = [], pe = [], xt = (a, l, u, d, v) => {
      Qt.push(a, l, u), Ni.push(0, 0, 1), Di.push(d, v);
    };
    Xt = V(0, 0), xt(0, 0, x, Xt.u, Xt.v);
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, v = $t(u, d);
      xt(u, d, x, v.u, v.v);
    }
    for (let a = 0; a < c; a++) {
      const l = 1 + a, u = 1 + (a + 1) % c;
      pe.push(0, u, l);
    }
    const tt = [], Pe = [], ke = [], Je = [], kt = (a, l, u, d, v, p, b, S) => {
      tt.push(a, l, u), Pe.push(d, v, p), ke.push(b, S);
    };
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let v = u / o, p = d / h;
      const b = Math.hypot(v, p);
      b > 0 && (v /= b, p /= b);
      const S = a / c;
      kt(u, d, B, v, p, 0, S, 0);
    }
    for (let a = 0; a < c; a++) {
      const l = a / c * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let v = u / o, p = d / h;
      const b = Math.hypot(v, p);
      b > 0 && (v /= b, p /= b);
      const S = a / c;
      kt(u, d, x, v, p, 0, S, 1);
    }
    const vt = c;
    for (let a = 0; a < c; a++) {
      const l = a, u = (a + 1) % c, d = vt + a, v = vt + (a + 1) % c;
      Je.push(l, d, v), Je.push(l, v, u);
    }
    const Qe = new BABYLON.Mesh("texturedBack", t), wt = new BABYLON.Mesh("texturedFront", t), Yt = new BABYLON.Mesh("texturedBorders", t), Ye = new BABYLON.VertexData();
    Ye.positions = Qt, Ye.normals = Ni, Ye.uvs = Di, Ye.indices = pe, Ye.applyToMesh(Qe);
    const i = new BABYLON.VertexData();
    i.positions = Lt, i.normals = ii, i.uvs = Ci, i.indices = ui, i.applyToMesh(wt);
    const r = new BABYLON.VertexData();
    return r.positions = tt, r.normals = Pe, r.uvs = ke, r.indices = Je, r.applyToMesh(Yt), Qe.material = this._baseMaterial, wt.material = this._baseMaterial, Yt.material = this._borderMaterial, Qe.parent = pt, wt.parent = pt, Yt.parent = pt, {
      bordersList: [Et],
      backsList: [qt],
      frontsList: [We],
      texturedBordersList: [Yt],
      texturedBacksList: [Qe],
      texturedFrontsList: [wt]
    };
  }
  generateCanvasMesh(e, t, n, s, o = !1, h, c) {
    const m = e.width / e.columns, x = e.height / e.rows, B = m * 0.1, I = BABYLON.MeshBuilder.CreateBox(
      "borders",
      {
        width: m,
        height: x,
        depth: e.depth
      },
      t
    ), F = BABYLON.MeshBuilder.CreatePlane(
      "front",
      {
        width: m,
        height: x
      },
      t
    ), M = BABYLON.MeshBuilder.CreatePlane(
      "back",
      {
        width: m,
        height: x
      },
      t
    );
    I.position = new BABYLON.Vector3(m / 2 + n * (m + B), x / 2 + s * (x + B)), F.position = new BABYLON.Vector3(m / 2 + n * (m + B), x / 2 + s * (x + B), -e.depth / 2), M.position = new BABYLON.Vector3(m / 2 + n * (m + B), x / 2 + s * (x + B), e.depth / 2), M.rotate(BABYLON.Axis.X, Math.PI, BABYLON.Space.WORLD), M.rotate(BABYLON.Axis.Z, Math.PI, BABYLON.Space.WORLD), I.material = this._borderMaterial, M.material = this._borderMaterial, F.material = this._baseMaterial;
    const Z = I.getVerticesData(BABYLON.VertexBuffer.NormalKind), V = I.getVerticesData(BABYLON.VertexBuffer.UVKind), te = F.getVerticesData(BABYLON.VertexBuffer.UVKind), P = M.getVerticesData(BABYLON.VertexBuffer.UVKind);
    e.borderRadius > 0 && console.warn("Mirror canvas effect will not work for border radius > 0"), e.borderRadius === 0 && (o && h && c ? this.applyTexturedUVMapping(
      e,
      I,
      F,
      M,
      V,
      te,
      P,
      Z,
      m,
      x,
      n,
      s,
      h,
      c
    ) : this.applyMirrorUVMapping(e, I, F, M, V, te, P, Z, m, x, n, s)), F.isVisible = !1, M.isVisible = !1;
    const K = I.getVerticesData(BABYLON.VertexBuffer.PositionKind) ?? [], J = I.getVerticesData(BABYLON.VertexBuffer.NormalKind) ?? [], le = I.getVerticesData(BABYLON.VertexBuffer.UVKind) ?? [], fe = I.getIndices() ?? [];
    return K.splice(0, 24), J.splice(0, 24), le.splice(0, 16), fe.splice(fe.length - 12, 12), I.updateVerticesData(BABYLON.VertexBuffer.PositionKind, K), I.updateVerticesData(BABYLON.VertexBuffer.NormalKind, J), I.updateVerticesData(BABYLON.VertexBuffer.UVKind, le), I.updateIndices(fe), [I, M, F];
  }
  // This method generate a UV map that stretches with the mesh, the aspect ratio
  // is compensated in the MeshSide canvas matrix.
  applyMirrorUVMapping(e, t, n, s, o, h, c, m, x, B, I, F) {
    const M = e.depth / e.width, Z = e.depth / e.height, V = Math.min(M, Z), te = x / e.width, P = B / e.height;
    for (var K = 0; K < o.length; K += 2) {
      const fe = Math.round(m[K / 2 * 3]), X = Math.round(m[K / 2 * 3 + 1]), W = Math.round(m[K / 2 * 3 + 2]), je = fe == -1 && X == 0 && W == 0, Ee = fe == 1 && X == 0 && W == 0, He = fe == 0 && X == 1 && W == 0, ft = fe == 0 && X == -1 && W == 0;
      if (je) {
        var J = o[K], le = o[K + 1];
        o[K] = le * V + te * I, o[K + 1] = J * P + P * F;
      }
      if (Ee) {
        var J = o[K], le = o[K + 1];
        o[K] = le * V + (1 - V) - te * (e.columns - 1 - I), o[K + 1] = J * P + P * F;
      }
      if (ft) {
        var J = o[K], le = o[K + 1];
        o[K] = le * te + te * I, o[K + 1] = J * V + P * F;
      }
      if (He) {
        var J = o[K], le = o[K + 1];
        o[K] = (-le + 1) * te + te * I, o[K + 1] = (-J + 1) * V + (1 - V);
      }
    }
    t.setVerticesData(BABYLON.VertexBuffer.UVKind, o);
    for (var K = 0; K < h.length; K += 2) {
      var J = h[K], le = h[K + 1];
      h[K] = J * te + te * I, h[K + 1] = le * P + P * F;
    }
    n.setVerticesData(BABYLON.VertexBuffer.UVKind, h);
    for (var K = 0; K < c.length; K += 2) {
      var J = c[K], le = c[K + 1];
      c[K] = J * te + te * (e.columns - 1 - I), c[K + 1] = le * P + P * F;
    }
    s.setVerticesData(BABYLON.VertexBuffer.UVKind, c);
  }
  // This method generate a UV map that don't stretch with the mesh.
  applyTexturedUVMapping(e, t, n, s, o, h, c, m, x, B, I, F, M, Z) {
    const V = M / Z, te = e.width / e.height;
    let P, K, J, le;
    V > te ? (K = 1, P = te / V, J = (P - 1) / 2, le = 0) : (P = 1, K = V / te, J = 0, le = (K - 1) / 2);
    const fe = x / e.width, X = B / e.height, W = e.depth / e.width * P, je = e.depth / e.height * K, Ee = Math.min(W, je);
    for (var He = 0; He < o.length; He += 2) {
      const $e = Math.round(m[He / 2 * 3]), ce = Math.round(m[He / 2 * 3 + 1]), ut = Math.round(m[He / 2 * 3 + 2]), ze = $e == -1 && ce == 0 && ut == 0, pt = $e == 1 && ce == 0 && ut == 0, qt = $e == 0 && ce == 1 && ut == 0, We = $e == 0 && ce == -1 && ut == 0;
      if (ze) {
        var ft = o[He], Le = o[He + 1];
        o[He] = (Le * Ee + fe * I) * P - J, o[He + 1] = (ft * X + X * F) * K - le;
      }
      if (pt) {
        var ft = o[He], Le = o[He + 1];
        o[He] = (Le * Ee + (1 - Ee) - fe * (e.columns - 1 - I)) * P - J, o[He + 1] = (ft * X + X * F) * K - le;
      }
      if (We) {
        var ft = o[He], Le = o[He + 1];
        o[He] = (Le * fe + fe * I) * P - J, o[He + 1] = (ft * Ee + X * F) * K - le;
      }
      if (qt) {
        var ft = o[He], Le = o[He + 1];
        o[He] = ((-Le + 1) * fe + fe * I) * P - J, o[He + 1] = ((-ft + 1) * Ee + (1 - Ee)) * K - le;
      }
    }
    t.setVerticesData(BABYLON.VertexBuffer.UVKind, o);
    for (var He = 0; He < h.length; He += 2) {
      var ft = h[He], Le = h[He + 1];
      h[He] = (ft * fe + fe * I) * P - J, h[He + 1] = (Le * X + X * F) * K - le;
    }
    n.setVerticesData(BABYLON.VertexBuffer.UVKind, h);
    for (var He = 0; He < c.length; He += 2) {
      var ft = c[He], Le = c[He + 1];
      c[He] = (ft * fe + fe * (e.columns - 1 - I)) * P - J, c[He + 1] = (Le * X + X * F) * K - le;
    }
    s.setVerticesData(BABYLON.VertexBuffer.UVKind, c);
  }
}
function bd(y, e) {
  return function() {
    return y.apply(e, arguments);
  };
}
const { toString: ob } = Object.prototype, { getPrototypeOf: ka } = Object, { iterator: mo, toStringTag: xd } = Symbol, bl = (({ hasOwnProperty: y }) => (e, t) => y.call(e, t))(Object.prototype), lo = (y, e) => {
  let t = y;
  const n = [];
  for (; t != null && t !== Object.prototype; ) {
    if (n.indexOf(t) !== -1)
      return !1;
    if (n.push(t), bl(t, e))
      return !0;
    t = ka(t);
  }
  return !1;
}, lb = (y, e) => y != null && lo(y, e) ? y[e] : void 0, su = ((y) => (e) => {
  const t = ob.call(e);
  return y[t] || (y[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ps = (y) => (y = y.toLowerCase(), (e) => su(e) === y), El = (y) => (e) => typeof e === y, { isArray: fa } = Array, Ea = El("undefined");
function Oa(y) {
  return y !== null && !Ea(y) && y.constructor !== null && !Ea(y.constructor) && Or(y.constructor.isBuffer) && y.constructor.isBuffer(y);
}
const wd = ps("ArrayBuffer");
function hb(y) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(y) : e = y && y.buffer && wd(y.buffer), e;
}
const ub = El("string"), Or = El("function"), Sd = El("number"), Pa = (y) => y !== null && typeof y == "object", cb = (y) => y === !0 || y === !1, hl = (y) => {
  if (!Pa(y))
    return !1;
  const e = ka(y);
  return (e === null || e === Object.prototype || ka(e) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !lo(y, xd) && !lo(y, mo);
}, fb = (y) => {
  if (!Pa(y) || Oa(y))
    return !1;
  try {
    return Object.keys(y).length === 0 && Object.getPrototypeOf(y) === Object.prototype;
  } catch {
    return !1;
  }
}, db = ps("Date"), gb = ps("File"), pb = (y) => !!(y && typeof y.uri < "u"), mb = (y) => y && typeof y.getParts < "u", _b = ps("Blob"), vb = ps("FileList"), yb = (y) => Pa(y) && Or(y.pipe);
function bb() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const If = bb(), Of = typeof If.FormData < "u" ? If.FormData : void 0, xb = (y) => {
  if (!y)
    return !1;
  if (Of && y instanceof Of)
    return !0;
  const e = ka(y);
  if (!e || e === Object.prototype || !Or(y.append))
    return !1;
  const t = su(y);
  return t === "formdata" || // detect form-data instance
  t === "object" && Or(y.toString) && y.toString() === "[object FormData]";
}, wb = ps("URLSearchParams"), [Sb, Mb, Cb, Ab] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(ps), Tb = (y) => y.trim ? y.trim() : y.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function _o(y, e, { allOwnKeys: t = !1 } = {}) {
  if (y === null || typeof y > "u")
    return;
  let n, s;
  if (typeof y != "object" && (y = [y]), fa(y))
    for (n = 0, s = y.length; n < s; n++)
      e.call(null, y[n], n, y);
  else {
    if (Oa(y))
      return;
    const o = t ? Object.getOwnPropertyNames(y) : Object.keys(y), h = o.length;
    let c;
    for (n = 0; n < h; n++)
      c = o[n], e.call(null, y[c], c, y);
  }
}
function Md(y, e) {
  if (Oa(y))
    return null;
  e = e.toLowerCase();
  const t = Object.keys(y);
  let n = t.length, s;
  for (; n-- > 0; )
    if (s = t[n], e === s.toLowerCase())
      return s;
  return null;
}
const ha = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Cd = (y) => !Ea(y) && y !== ha;
function Gh(...y) {
  const { caseless: e, skipUndefined: t } = Cd(this) && this || {}, n = {}, s = (o, h) => {
    if (h === "__proto__" || h === "constructor" || h === "prototype")
      return;
    const c = e && typeof h == "string" && Md(n, h) || h, m = bl(n, c) ? n[c] : void 0;
    hl(m) && hl(o) ? n[c] = Gh(m, o) : hl(o) ? n[c] = Gh({}, o) : fa(o) ? n[c] = o.slice() : (!t || !Ea(o)) && (n[c] = o);
  };
  for (let o = 0, h = y.length; o < h; o++) {
    const c = y[o];
    if (!c || Oa(c) || (_o(c, s), typeof c != "object" || fa(c)))
      continue;
    const m = Object.getOwnPropertySymbols(c);
    for (let x = 0; x < m.length; x++) {
      const B = m[x];
      Fb.call(c, B) && s(c[B], B);
    }
  }
  return n;
}
const Lb = (y, e, t, { allOwnKeys: n } = {}) => (_o(
  e,
  (s, o) => {
    t && Or(s) ? Object.defineProperty(y, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: bd(s, t),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(y, o, {
      __proto__: null,
      value: s,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: n }
), y), Bb = (y) => (y.charCodeAt(0) === 65279 && (y = y.slice(1)), y), kb = (y, e, t, n) => {
  y.prototype = Object.create(e.prototype, n), Object.defineProperty(y.prototype, "constructor", {
    __proto__: null,
    value: y,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(y, "super", {
    __proto__: null,
    value: e.prototype
  }), t && Object.assign(y.prototype, t);
}, Eb = (y, e, t, n) => {
  let s, o, h;
  const c = {};
  if (e = e || {}, y == null)
    return e;
  do {
    for (s = Object.getOwnPropertyNames(y), o = s.length; o-- > 0; )
      h = s[o], (!n || n(h, y, e)) && !c[h] && (e[h] = y[h], c[h] = !0);
    y = t !== !1 && ka(y);
  } while (y && (!t || t(y, e)) && y !== Object.prototype);
  return e;
}, Ib = (y, e, t) => {
  y = String(y), (t === void 0 || t > y.length) && (t = y.length), t -= e.length;
  const n = y.indexOf(e, t);
  return n !== -1 && n === t;
}, Ob = (y) => {
  if (!y)
    return null;
  if (fa(y))
    return y;
  let e = y.length;
  if (!Sd(e))
    return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = y[e];
  return t;
}, Pb = ((y) => (e) => y && e instanceof y)(typeof Uint8Array < "u" && ka(Uint8Array)), Nb = (y, e) => {
  const n = (y && y[mo]).call(y);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const o = s.value;
    e.call(y, o[0], o[1]);
  }
}, Rb = (y, e) => {
  let t;
  const n = [];
  for (; (t = y.exec(e)) !== null; )
    n.push(t);
  return n;
}, Db = ps("HTMLFormElement"), zb = (y) => y.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, n, s) {
  return n.toUpperCase() + s;
}), { propertyIsEnumerable: Fb } = Object.prototype, Ub = ps("RegExp"), Ad = (y, e) => {
  const t = Object.getOwnPropertyDescriptors(y), n = {};
  _o(t, (s, o) => {
    let h;
    (h = e(s, o, y)) !== !1 && (n[o] = h || s);
  }), Object.defineProperties(y, n);
}, Vb = (y) => {
  Ad(y, (e, t) => {
    if (Or(y) && ["arguments", "caller", "callee"].includes(t))
      return !1;
    const n = y[t];
    if (Or(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, Hb = (y, e) => {
  const t = {}, n = (s) => {
    s.forEach((o) => {
      t[o] = !0;
    });
  };
  return fa(y) ? n(y) : n(String(y).split(e)), t;
}, Yb = () => {
}, Gb = (y, e) => y != null && Number.isFinite(y = +y) ? y : e;
function jb(y) {
  return !!(y && Or(y.append) && y[xd] === "FormData" && y[mo]);
}
const Wb = (y) => {
  const e = /* @__PURE__ */ new WeakSet(), t = (n) => {
    if (Pa(n)) {
      if (e.has(n))
        return;
      if (Oa(n))
        return n;
      if (!("toJSON" in n)) {
        e.add(n);
        const s = fa(n) ? [] : {};
        return _o(n, (o, h) => {
          const c = t(o);
          !Ea(c) && (s[h] = c);
        }), e.delete(n), s;
      }
    }
    return n;
  };
  return t(y);
}, qb = ps("AsyncFunction"), Zb = (y) => y && (Pa(y) || Or(y)) && Or(y.then) && Or(y.catch), Td = ((y, e) => y ? setImmediate : e ? ((t, n) => (ha.addEventListener(
  "message",
  ({ source: s, data: o }) => {
    s === ha && o === t && n.length && n.shift()();
  },
  !1
), (s) => {
  n.push(s), ha.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(typeof setImmediate == "function", Or(ha.postMessage)), $b = typeof queueMicrotask < "u" ? queueMicrotask.bind(ha) : typeof process < "u" && process.nextTick || Td, Ld = (y) => y != null && Or(y[mo]), Xb = (y) => y != null && lo(y, mo) && Ld(y), nt = {
  isArray: fa,
  isArrayBuffer: wd,
  isBuffer: Oa,
  isFormData: xb,
  isArrayBufferView: hb,
  isString: ub,
  isNumber: Sd,
  isBoolean: cb,
  isObject: Pa,
  isPlainObject: hl,
  isEmptyObject: fb,
  isReadableStream: Sb,
  isRequest: Mb,
  isResponse: Cb,
  isHeaders: Ab,
  isUndefined: Ea,
  isDate: db,
  isFile: gb,
  isReactNativeBlob: pb,
  isReactNative: mb,
  isBlob: _b,
  isRegExp: Ub,
  isFunction: Or,
  isStream: yb,
  isURLSearchParams: wb,
  isTypedArray: Pb,
  isFileList: vb,
  forEach: _o,
  merge: Gh,
  extend: Lb,
  trim: Tb,
  stripBOM: Bb,
  inherits: kb,
  toFlatObject: Eb,
  kindOf: su,
  kindOfTest: ps,
  endsWith: Ib,
  toArray: Ob,
  forEachEntry: Nb,
  matchAll: Rb,
  isHTMLForm: Db,
  hasOwnProperty: bl,
  hasOwnProp: bl,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: lo,
  getSafeProp: lb,
  reduceDescriptors: Ad,
  freezeMethods: Vb,
  toObjectSet: Hb,
  toCamelCase: zb,
  noop: Yb,
  toFiniteNumber: Gb,
  findKey: Md,
  global: ha,
  isContextDefined: Cd,
  isSpecCompliantForm: jb,
  toJSONObject: Wb,
  isAsyncFn: qb,
  isThenable: Zb,
  setImmediate: Td,
  asap: $b,
  isIterable: Ld,
  isSafeIterable: Xb
}, Kb = nt.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Jb = (y) => {
  const e = {};
  let t, n, s;
  return y && y.split(`
`).forEach(function(h) {
    s = h.indexOf(":"), t = h.substring(0, s).trim().toLowerCase(), n = h.substring(s + 1).trim(), !(!t || e[t] && Kb[t]) && (t === "set-cookie" ? e[t] ? e[t].push(n) : e[t] = [n] : e[t] = e[t] ? e[t] + ", " + n : n);
  }), e;
};
function Qb(y) {
  let e = 0, t = y.length;
  for (; e < t; ) {
    const n = y.charCodeAt(e);
    if (n !== 9 && n !== 32)
      break;
    e += 1;
  }
  for (; t > e; ) {
    const n = y.charCodeAt(t - 1);
    if (n !== 9 && n !== 32)
      break;
    t -= 1;
  }
  return e === 0 && t === y.length ? y : y.slice(e, t);
}
const ex = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), tx = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function au(y, e) {
  return nt.isArray(y) ? y.map((t) => au(t, e)) : Qb(String(y).replace(e, ""));
}
const ix = (y) => au(y, ex), nx = (y) => au(y, tx);
function Bd(y) {
  const e = /* @__PURE__ */ Object.create(null);
  return nt.forEach(y.toJSON(), (t, n) => {
    e[n] = nx(t);
  }), e;
}
const Pf = Symbol("internals");
function $a(y) {
  return y && String(y).trim().toLowerCase();
}
function ul(y) {
  return y === !1 || y == null ? y : nt.isArray(y) ? y.map(ul) : ix(String(y));
}
function rx(y) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = t.exec(y); )
    e[n[1]] = n[2];
  return e;
}
const sx = (y) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(y.trim());
function Ih(y, e, t, n, s) {
  if (nt.isFunction(n))
    return n.call(this, e, t);
  if (s && (e = t), !!nt.isString(e)) {
    if (nt.isString(n))
      return e.indexOf(n) !== -1;
    if (nt.isRegExp(n))
      return n.test(e);
  }
}
function ax(y) {
  return y.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function ox(y, e) {
  const t = nt.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(y, n + t, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(s, o, h) {
        return this[n].call(this, e, s, o, h);
      },
      configurable: !0
    });
  });
}
class Il {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    const s = this;
    function o(c, m, x) {
      const B = $a(m);
      if (!B)
        return;
      const I = nt.findKey(s, B);
      (!I || s[I] === void 0 || x === !0 || x === void 0 && s[I] !== !1) && (s[I || m] = ul(c));
    }
    const h = (c, m) => nt.forEach(c, (x, B) => o(x, B, m));
    if (nt.isPlainObject(e) || e instanceof this.constructor)
      h(e, t);
    else if (nt.isString(e) && (e = e.trim()) && !sx(e))
      h(Jb(e), t);
    else if (nt.isObject(e) && nt.isSafeIterable(e)) {
      let c = /* @__PURE__ */ Object.create(null), m, x;
      for (const B of e) {
        if (!nt.isArray(B))
          throw new TypeError("Object iterator must return a key-value pair");
        x = B[0], nt.hasOwnProp(c, x) ? (m = c[x], c[x] = nt.isArray(m) ? [...m, B[1]] : [m, B[1]]) : c[x] = B[1];
      }
      h(c, t);
    } else
      e != null && o(t, e, n);
    return this;
  }
  get(e, t) {
    if (e = $a(e), e) {
      const n = nt.findKey(this, e);
      if (n) {
        const s = this[n];
        if (!t)
          return s;
        if (t === !0)
          return rx(s);
        if (nt.isFunction(t))
          return t.call(this, s, n);
        if (nt.isRegExp(t))
          return t.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = $a(e), e) {
      const n = nt.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || Ih(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    const n = this;
    let s = !1;
    function o(h) {
      if (h = $a(h), h) {
        const c = nt.findKey(n, h);
        c && (!t || Ih(n, n[c], c, t)) && (delete n[c], s = !0);
      }
    }
    return nt.isArray(e) ? e.forEach(o) : o(e), s;
  }
  clear(e) {
    const t = Object.keys(this);
    let n = t.length, s = !1;
    for (; n--; ) {
      const o = t[n];
      (!e || Ih(this, this[o], o, e, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(e) {
    const t = this, n = {};
    return nt.forEach(this, (s, o) => {
      const h = nt.findKey(n, o);
      if (h) {
        t[h] = ul(s), delete t[o];
        return;
      }
      const c = e ? ax(o) : String(o).trim();
      c !== o && delete t[o], t[c] = ul(s), n[c] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return nt.forEach(this, (n, s) => {
      n != null && n !== !1 && (t[s] = e && nt.isArray(n) ? n.join(", ") : n);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const n = new this(e);
    return t.forEach((s) => n.set(s)), n;
  }
  static accessor(e) {
    const n = (this[Pf] = this[Pf] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(h) {
      const c = $a(h);
      n[c] || (ox(s, h), n[c] = !0);
    }
    return nt.isArray(e) ? e.forEach(o) : o(e), this;
  }
}
Il.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
nt.reduceDescriptors(Il.prototype, ({ value: y }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => y,
    set(n) {
      this[t] = n;
    }
  };
});
nt.freezeMethods(Il);
const qr = Il, lx = "[REDACTED ****]";
function hx(y) {
  if (nt.hasOwnProp(y, "toJSON"))
    return !0;
  let e = Object.getPrototypeOf(y);
  for (; e && e !== Object.prototype; ) {
    if (nt.hasOwnProp(e, "toJSON"))
      return !0;
    e = Object.getPrototypeOf(e);
  }
  return !1;
}
function ux(y, e) {
  const t = new Set(e.map((o) => String(o).toLowerCase())), n = [], s = (o) => {
    if (o === null || typeof o != "object" || nt.isBuffer(o))
      return o;
    if (n.indexOf(o) !== -1)
      return;
    o instanceof qr && (o = o.toJSON()), n.push(o);
    let h;
    if (nt.isArray(o))
      h = [], o.forEach((c, m) => {
        const x = s(c);
        nt.isUndefined(x) || (h[m] = x);
      });
    else {
      if (!nt.isPlainObject(o) && hx(o))
        return n.pop(), o;
      h = /* @__PURE__ */ Object.create(null);
      for (const [c, m] of Object.entries(o)) {
        const x = t.has(c.toLowerCase()) ? lx : s(m);
        nt.isUndefined(x) || (h[c] = x);
      }
    }
    return n.pop(), h;
  };
  return s(y);
}
class sr extends Error {
  static from(e, t, n, s, o, h) {
    const c = new sr(e.message, t || e.code, n, s, o);
    return Object.defineProperty(c, "cause", {
      __proto__: null,
      value: e,
      writable: !0,
      enumerable: !1,
      configurable: !0
    }), c.name = e.name, e.status != null && c.status == null && (c.status = e.status), h && Object.assign(c, h), c;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(e, t, n, s, o) {
    super(e), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: e,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), s && (this.request = s), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const e = this.config, t = e && nt.hasOwnProp(e, "redact") ? e.redact : void 0, n = nt.isArray(t) && t.length > 0 ? ux(e, t) : nt.toJSONObject(e);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: n,
      code: this.code,
      status: this.status
    };
  }
}
sr.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
sr.ERR_BAD_OPTION = "ERR_BAD_OPTION";
sr.ECONNABORTED = "ECONNABORTED";
sr.ETIMEDOUT = "ETIMEDOUT";
sr.ECONNREFUSED = "ECONNREFUSED";
sr.ERR_NETWORK = "ERR_NETWORK";
sr.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
sr.ERR_DEPRECATED = "ERR_DEPRECATED";
sr.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
sr.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
sr.ERR_CANCELED = "ERR_CANCELED";
sr.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
sr.ERR_INVALID_URL = "ERR_INVALID_URL";
sr.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const oi = sr, cx = null, kd = 100;
function jh(y) {
  return nt.isPlainObject(y) || nt.isArray(y);
}
function Ed(y) {
  return nt.endsWith(y, "[]") ? y.slice(0, -2) : y;
}
function Oh(y, e, t) {
  return y ? y.concat(e).map(function(s, o) {
    return s = Ed(s), !t && o ? "[" + s + "]" : s;
  }).join(t ? "." : "") : e;
}
function fx(y) {
  return nt.isArray(y) && !y.some(jh);
}
const dx = nt.toFlatObject(nt, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Ol(y, e, t) {
  if (!nt.isObject(y))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = nt.toFlatObject(
    t,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(K, J) {
      return !nt.isUndefined(J[K]);
    }
  );
  const n = t.metaTokens, s = t.visitor || Z, o = t.dots, h = t.indexes, c = t.Blob || typeof Blob < "u" && Blob, m = t.maxDepth === void 0 ? kd : t.maxDepth, x = c && nt.isSpecCompliantForm(e), B = [];
  if (!nt.isFunction(s))
    throw new TypeError("visitor must be a function");
  function I(P) {
    if (P === null)
      return "";
    if (nt.isDate(P))
      return P.toISOString();
    if (nt.isBoolean(P))
      return P.toString();
    if (!x && nt.isBlob(P))
      throw new oi("Blob is not supported. Use a Buffer instead.");
    if (nt.isArrayBuffer(P) || nt.isTypedArray(P)) {
      if (x && typeof c == "function")
        return new c([P]);
      if (typeof Buffer < "u")
        return Buffer.from(P);
      throw new oi("Blob is not supported. Use a Buffer instead.", oi.ERR_NOT_SUPPORT);
    }
    return P;
  }
  function F(P) {
    if (P > m)
      throw new oi(
        "Object is too deeply nested (" + P + " levels). Max depth: " + m,
        oi.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function M(P, K) {
    if (m === 1 / 0)
      return JSON.stringify(P);
    const J = [];
    return JSON.stringify(P, function(fe, X) {
      if (!nt.isObject(X))
        return X;
      for (; J.length && J[J.length - 1] !== this; )
        J.pop();
      return J.push(X), F(K + J.length - 1), X;
    });
  }
  function Z(P, K, J) {
    let le = P;
    if (nt.isReactNative(e) && nt.isReactNativeBlob(P))
      return e.append(Oh(J, K, o), I(P)), !1;
    if (P && !J && typeof P == "object") {
      if (nt.endsWith(K, "{}"))
        K = n ? K : K.slice(0, -2), P = M(P, 1);
      else if (nt.isArray(P) && fx(P) || (nt.isFileList(P) || nt.endsWith(K, "[]")) && (le = nt.toArray(P)))
        return K = Ed(K), le.forEach(function(X, W) {
          !(nt.isUndefined(X) || X === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            h === !0 ? Oh([K], W, o) : h === null ? K : K + "[]",
            I(X)
          );
        }), !1;
    }
    return jh(P) ? !0 : (e.append(Oh(J, K, o), I(P)), !1);
  }
  const V = Object.assign(dx, {
    defaultVisitor: Z,
    convertValue: I,
    isVisitable: jh
  });
  function te(P, K, J = 0) {
    if (!nt.isUndefined(P)) {
      if (F(J), B.indexOf(P) !== -1)
        throw new Error("Circular reference detected in " + K.join("."));
      B.push(P), nt.forEach(P, function(fe, X) {
        (!(nt.isUndefined(fe) || fe === null) && s.call(e, fe, nt.isString(X) ? X.trim() : X, K, V)) === !0 && te(fe, K ? K.concat(X) : [X], J + 1);
      }), B.pop();
    }
  }
  if (!nt.isObject(y))
    throw new TypeError("data must be an object");
  return te(y), e;
}
function Nf(y) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(y).replace(/[!'()~]|%20/g, function(n) {
    return e[n];
  });
}
function ou(y, e) {
  this._pairs = [], y && Ol(y, this, e);
}
const Id = ou.prototype;
Id.append = function(e, t) {
  this._pairs.push([e, t]);
};
Id.toString = function(e) {
  const t = e ? (n) => e.call(this, n, Nf) : Nf;
  return this._pairs.map(function(s) {
    return t(s[0]) + "=" + t(s[1]);
  }, "").join("&");
};
function gx(y) {
  return encodeURIComponent(y).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Od(y, e, t) {
  if (!e)
    return y;
  y = y || "";
  const n = nt.isFunction(t) ? {
    serialize: t
  } : t, s = nt.getSafeProp(n, "encode") || gx, o = nt.getSafeProp(n, "serialize");
  let h;
  if (o ? h = o(e, n) : h = nt.isURLSearchParams(e) ? e.toString() : new ou(e, n).toString(s), h) {
    const c = y.indexOf("#");
    c !== -1 && (y = y.slice(0, c)), y += (y.indexOf("?") === -1 ? "?" : "&") + h;
  }
  return y;
}
class px {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    nt.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const Rf = px, lu = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, mx = typeof URLSearchParams < "u" ? URLSearchParams : ou, _x = typeof FormData < "u" ? FormData : null, vx = typeof Blob < "u" ? Blob : null, yx = {
  isBrowser: !0,
  classes: {
    URLSearchParams: mx,
    FormData: _x,
    Blob: vx
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hu = typeof window < "u" && typeof document < "u", Wh = typeof navigator == "object" && navigator || void 0, bx = hu && (!Wh || ["ReactNative", "NativeScript", "NS"].indexOf(Wh.product) < 0), xx = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), wx = hu && window.location.href || "http://localhost", Sx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: hu,
  hasStandardBrowserEnv: bx,
  hasStandardBrowserWebWorkerEnv: xx,
  navigator: Wh,
  origin: wx
}, Symbol.toStringTag, { value: "Module" })), rr = {
  ...Sx,
  ...yx
};
function Mx(y, e) {
  return Ol(y, new rr.classes.URLSearchParams(), {
    visitor: function(t, n, s, o) {
      return rr.isNode && nt.isBuffer(t) ? (this.append(n, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
const Df = kd;
function Pd(y) {
  if (y > Df)
    throw new oi(
      "FormData field is too deeply nested (" + y + " levels). Max depth: " + Df,
      oi.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function Cx(y) {
  const e = [], t = /\w+|\[(\w*)]/g;
  let n;
  for (; (n = t.exec(y)) !== null; )
    Pd(e.length), e.push(n[0] === "[]" ? "" : n[1] || n[0]);
  return e;
}
function Ax(y) {
  const e = {}, t = Object.keys(y);
  let n;
  const s = t.length;
  let o;
  for (n = 0; n < s; n++)
    o = t[n], e[o] = y[o];
  return e;
}
function Nd(y) {
  function e(t, n, s, o) {
    Pd(o);
    let h = t[o++];
    if (h === "__proto__")
      return !0;
    const c = Number.isFinite(+h), m = o >= t.length;
    return h = !h && nt.isArray(s) ? s.length : h, m ? (nt.hasOwnProp(s, h) ? s[h] = nt.isArray(s[h]) ? s[h].concat(n) : [s[h], n] : s[h] = n, !c) : ((!nt.hasOwnProp(s, h) || !nt.isObject(s[h])) && (s[h] = []), e(t, n, s[h], o) && nt.isArray(s[h]) && (s[h] = Ax(s[h])), !c);
  }
  if (nt.isFormData(y) && nt.isFunction(y.entries)) {
    const t = {};
    return nt.forEachEntry(y, (n, s) => {
      e(Cx(n), s, t, 0);
    }), t;
  }
  return null;
}
const Sa = (y, e) => y != null && nt.hasOwnProp(y, e) ? y[e] : void 0;
function Tx(y, e, t) {
  if (nt.isString(y))
    try {
      return (e || JSON.parse)(y), nt.trim(y);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (t || JSON.stringify)(y);
}
const uu = {
  transitional: lu,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(e, t) {
      const n = t.getContentType() || "", s = n.indexOf("application/json") > -1, o = nt.isObject(e);
      if (o && nt.isHTMLForm(e) && (e = new FormData(e)), nt.isFormData(e))
        return s ? JSON.stringify(Nd(e)) : e;
      if (nt.isArrayBuffer(e) || nt.isBuffer(e) || nt.isStream(e) || nt.isFile(e) || nt.isBlob(e) || nt.isReadableStream(e))
        return e;
      if (nt.isArrayBufferView(e))
        return e.buffer;
      if (nt.isURLSearchParams(e))
        return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
      let c;
      if (o) {
        const m = Sa(this, "formSerializer");
        if (n.indexOf("application/x-www-form-urlencoded") > -1)
          return Mx(e, m).toString();
        if ((c = nt.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
          const x = Sa(this, "env"), B = x && x.FormData;
          return Ol(
            c ? { "files[]": e } : e,
            B && new B(),
            m
          );
        }
      }
      return o || s ? (t.setContentType("application/json", !1), Tx(e)) : e;
    }
  ],
  transformResponse: [
    function(e) {
      const t = Sa(this, "transitional") || uu.transitional, n = t && t.forcedJSONParsing, s = Sa(this, "responseType"), o = s === "json";
      if (nt.isResponse(e) || nt.isReadableStream(e))
        return e;
      if (e && nt.isString(e) && (n && !s || o)) {
        const c = !(t && t.silentJSONParsing) && o;
        try {
          return JSON.parse(e, Sa(this, "parseReviver"));
        } catch (m) {
          if (c)
            throw m.name === "SyntaxError" ? oi.from(m, oi.ERR_BAD_RESPONSE, this, null, Sa(this, "response")) : m;
        }
      }
      return e;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: rr.classes.FormData,
    Blob: rr.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
nt.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (y) => {
  uu.headers[y] = {};
});
const cu = uu;
function Ph(y, e) {
  const t = this || cu, n = e || t, s = qr.from(n.headers);
  let o = n.data;
  return nt.forEach(y, function(c) {
    o = c.call(t, o, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), o;
}
function Rd(y) {
  return !!(y && y.__CANCEL__);
}
class Lx extends oi {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(e, t, n) {
    super(e ?? "canceled", oi.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
}
const vo = Lx;
function Dd(y, e, t) {
  const n = t.config.validateStatus;
  !t.status || !n || n(t.status) ? y(t) : e(new oi(
    "Request failed with status code " + t.status,
    t.status >= 400 && t.status < 500 ? oi.ERR_BAD_REQUEST : oi.ERR_BAD_RESPONSE,
    t.config,
    t.request,
    t
  ));
}
function Bx(y) {
  const e = /^([-+\w]{1,25}):(?:\/\/)?/.exec(y);
  return e && e[1] || "";
}
function kx(y, e) {
  y = y || 10;
  const t = new Array(y), n = new Array(y);
  let s = 0, o = 0, h;
  return e = e !== void 0 ? e : 1e3, function(m) {
    const x = Date.now(), B = n[o];
    h || (h = x), t[s] = m, n[s] = x;
    let I = o, F = 0;
    for (; I !== s; )
      F += t[I++], I = I % y;
    if (s = (s + 1) % y, s === o && (o = (o + 1) % y), x - h < e)
      return;
    const M = B && x - B;
    return M ? Math.round(F * 1e3 / M) : void 0;
  };
}
function Ex(y, e) {
  let t = 0, n = 1e3 / e, s, o;
  const h = (x, B = Date.now()) => {
    t = B, s = null, o && (clearTimeout(o), o = null), y(...x);
  };
  return [(...x) => {
    const B = Date.now(), I = B - t;
    I >= n ? h(x, B) : (s = x, o || (o = setTimeout(() => {
      o = null, h(s);
    }, n - I)));
  }, () => s && h(s)];
}
const xl = (y, e, t = 3) => {
  let n = 0;
  const s = kx(50, 250);
  return Ex((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const h = o.loaded, c = o.lengthComputable ? o.total : void 0, m = c != null ? Math.min(h, c) : h, x = Math.max(0, m - n), B = s(x);
    n = Math.max(n, m);
    const I = {
      loaded: m,
      total: c,
      progress: c ? m / c : void 0,
      bytes: x,
      rate: B || void 0,
      estimated: B && c ? (c - m) / B : void 0,
      event: o,
      lengthComputable: c != null,
      [e ? "download" : "upload"]: !0
    };
    y(I);
  }, t);
}, zf = (y, e) => {
  const t = y != null;
  return [
    (n) => e[0]({
      lengthComputable: t,
      total: y,
      loaded: n
    }),
    e[1]
  ];
}, Ff = (y) => (...e) => nt.asap(() => y(...e)), Ix = rr.hasStandardBrowserEnv ? ((y, e) => (t) => (t = new URL(t, rr.origin), y.protocol === t.protocol && y.host === t.host && (e || y.port === t.port)))(
  new URL(rr.origin),
  rr.navigator && /(msie|trident)/i.test(rr.navigator.userAgent)
) : () => !0, Ox = rr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(y, e, t, n, s, o, h) {
      if (typeof document > "u")
        return;
      const c = [`${y}=${encodeURIComponent(e)}`];
      nt.isNumber(t) && c.push(`expires=${new Date(t).toUTCString()}`), nt.isString(n) && c.push(`path=${n}`), nt.isString(s) && c.push(`domain=${s}`), o === !0 && c.push("secure"), nt.isString(h) && c.push(`SameSite=${h}`), document.cookie = c.join("; ");
    },
    read(y) {
      if (typeof document > "u")
        return null;
      const e = document.cookie.split(";");
      for (let t = 0; t < e.length; t++) {
        const n = e[t].replace(/^\s+/, ""), s = n.indexOf("=");
        if (s !== -1 && n.slice(0, s) === y)
          try {
            return decodeURIComponent(n.slice(s + 1));
          } catch {
            return n.slice(s + 1);
          }
      }
      return null;
    },
    remove(y) {
      this.write(y, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Px(y) {
  return typeof y != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(y);
}
function Nx(y, e) {
  return e ? y.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : y;
}
const Rx = /^https?:(?!\/\/)/i, Dx = /[\t\n\r]/g;
function zx(y) {
  let e = 0;
  for (; e < y.length && y.charCodeAt(e) <= 32; )
    e++;
  return y.slice(e);
}
function Fx(y) {
  return zx(y).replace(Dx, "");
}
function Uf(y, e) {
  if (typeof y == "string" && Rx.test(Fx(y)))
    throw new oi(
      'Invalid URL: missing "//" after protocol',
      oi.ERR_INVALID_URL,
      e
    );
}
function zd(y, e, t, n) {
  Uf(e, n);
  let s = !Px(e);
  return y && (s || t === !1) ? (Uf(y, n), Nx(y, e)) : e;
}
const Vf = (y) => y instanceof qr ? { ...y } : y;
function da(y, e) {
  y = y || {}, e = e || {};
  const t = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(t, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function n(B, I, F, M) {
    return nt.isPlainObject(B) && nt.isPlainObject(I) ? nt.merge.call({ caseless: M }, B, I) : nt.isPlainObject(I) ? nt.merge({}, I) : nt.isArray(I) ? I.slice() : I;
  }
  function s(B, I, F, M) {
    if (nt.isUndefined(I)) {
      if (!nt.isUndefined(B))
        return n(void 0, B, F, M);
    } else
      return n(B, I, F, M);
  }
  function o(B, I) {
    if (!nt.isUndefined(I))
      return n(void 0, I);
  }
  function h(B, I) {
    if (nt.isUndefined(I)) {
      if (!nt.isUndefined(B))
        return n(void 0, B);
    } else
      return n(void 0, I);
  }
  function c(B) {
    const I = nt.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (!nt.isUndefined(I))
      if (nt.isPlainObject(I)) {
        if (nt.hasOwnProp(I, B))
          return I[B];
      } else
        return;
    const F = nt.hasOwnProp(y, "transitional") ? y.transitional : void 0;
    if (nt.isPlainObject(F) && nt.hasOwnProp(F, B))
      return F[B];
  }
  function m(B, I, F) {
    if (nt.hasOwnProp(e, F))
      return n(B, I);
    if (nt.hasOwnProp(y, F))
      return n(void 0, B);
  }
  const x = {
    url: o,
    method: o,
    data: o,
    baseURL: h,
    transformRequest: h,
    transformResponse: h,
    paramsSerializer: h,
    timeout: h,
    timeoutMessage: h,
    withCredentials: h,
    withXSRFToken: h,
    adapter: h,
    responseType: h,
    xsrfCookieName: h,
    xsrfHeaderName: h,
    onUploadProgress: h,
    onDownloadProgress: h,
    decompress: h,
    maxContentLength: h,
    maxBodyLength: h,
    beforeRedirect: h,
    transport: h,
    httpAgent: h,
    httpsAgent: h,
    cancelToken: h,
    socketPath: h,
    allowedSocketPaths: h,
    responseEncoding: h,
    validateStatus: m,
    headers: (B, I, F) => s(Vf(B), Vf(I), F, !0)
  };
  return nt.forEach(Object.keys({ ...y, ...e }), function(I) {
    if (I === "__proto__" || I === "constructor" || I === "prototype")
      return;
    const F = nt.hasOwnProp(x, I) ? x[I] : s, M = nt.hasOwnProp(y, I) ? y[I] : void 0, Z = nt.hasOwnProp(e, I) ? e[I] : void 0, V = F(M, Z, I);
    nt.isUndefined(V) && F !== m || (t[I] = V);
  }), nt.hasOwnProp(e, "validateStatus") && nt.isUndefined(e.validateStatus) && c("validateStatusUndefinedResolves") === !1 && (nt.hasOwnProp(y, "validateStatus") ? t.validateStatus = n(void 0, y.validateStatus) : delete t.validateStatus), t;
}
const Ux = ["content-type", "content-length"];
function Vx(y, e, t) {
  if (t !== "content-only") {
    y.set(e);
    return;
  }
  Object.entries(e || {}).forEach(([n, s]) => {
    Ux.includes(n.toLowerCase()) && y.set(n, s);
  });
}
const Hx = (y) => encodeURIComponent(y).replace(
  /%([0-9A-F]{2})/gi,
  (e, t) => String.fromCharCode(parseInt(t, 16))
);
function Fd(y) {
  const e = da({}, y), t = (F) => nt.hasOwnProp(e, F) ? e[F] : void 0, n = t("data");
  let s = t("withXSRFToken");
  const o = t("xsrfHeaderName"), h = t("xsrfCookieName");
  let c = t("headers");
  const m = t("auth"), x = t("baseURL"), B = t("allowAbsoluteUrls"), I = t("url");
  if (e.headers = c = qr.from(c), e.url = Od(
    zd(x, I, B, e),
    t("params"),
    t("paramsSerializer")
  ), m) {
    const F = nt.getSafeProp(m, "username") || "", M = nt.getSafeProp(m, "password") || "";
    try {
      c.set(
        "Authorization",
        "Basic " + btoa(F + ":" + (M ? Hx(M) : ""))
      );
    } catch (Z) {
      throw oi.from(Z, oi.ERR_BAD_OPTION_VALUE, y);
    }
  }
  if (nt.isFormData(n) && (rr.hasStandardBrowserEnv || rr.hasStandardBrowserWebWorkerEnv || nt.isReactNative(n) ? c.setContentType(void 0) : nt.isFunction(n.getHeaders) && Vx(c, n.getHeaders(), t("formDataHeaderPolicy"))), rr.hasStandardBrowserEnv && (nt.isFunction(s) && (s = s(e)), s === !0 || s == null && Ix(e.url))) {
    const M = o && h && Ox.read(h);
    M && c.set(o, M);
  }
  return e;
}
const Yx = typeof XMLHttpRequest < "u", Gx = Yx && function(y) {
  return new Promise(function(t, n) {
    const s = Fd(y);
    let o = s.data;
    const h = qr.from(s.headers).normalize();
    let { responseType: c, onUploadProgress: m, onDownloadProgress: x } = s, B, I, F, M, Z;
    function V() {
      M && M(), Z && Z(), s.cancelToken && s.cancelToken.unsubscribe(B), s.signal && s.signal.removeEventListener("abort", B);
    }
    let te = new XMLHttpRequest();
    te.open(s.method.toUpperCase(), s.url, !0), te.timeout = s.timeout;
    function P() {
      if (!te)
        return;
      const J = qr.from(
        "getAllResponseHeaders" in te && te.getAllResponseHeaders()
      ), fe = {
        data: !c || c === "text" || c === "json" ? te.responseText : te.response,
        status: te.status,
        statusText: te.statusText,
        headers: J,
        config: y,
        request: te
      };
      Dd(
        function(W) {
          t(W), V();
        },
        function(W) {
          n(W), V();
        },
        fe
      ), te = null;
    }
    "onloadend" in te ? te.onloadend = P : te.onreadystatechange = function() {
      !te || te.readyState !== 4 || te.status === 0 && !(te.responseURL && te.responseURL.startsWith("file:")) || setTimeout(P);
    }, te.onabort = function() {
      te && (n(new oi("Request aborted", oi.ECONNABORTED, y, te)), V(), te = null);
    }, te.onerror = function(le) {
      const fe = le && le.message ? le.message : "Network Error", X = new oi(fe, oi.ERR_NETWORK, y, te);
      X.event = le || null, n(X), V(), te = null;
    }, te.ontimeout = function() {
      let le = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const fe = s.transitional || lu;
      s.timeoutErrorMessage && (le = s.timeoutErrorMessage), n(
        new oi(
          le,
          fe.clarifyTimeoutError ? oi.ETIMEDOUT : oi.ECONNABORTED,
          y,
          te
        )
      ), V(), te = null;
    }, o === void 0 && h.setContentType(null), "setRequestHeader" in te && nt.forEach(Bd(h), function(le, fe) {
      te.setRequestHeader(fe, le);
    }), nt.isUndefined(s.withCredentials) || (te.withCredentials = !!s.withCredentials), c && c !== "json" && (te.responseType = s.responseType), x && ([F, Z] = xl(x, !0), te.addEventListener("progress", F)), m && te.upload && ([I, M] = xl(m), te.upload.addEventListener("progress", I), te.upload.addEventListener("loadend", M)), (s.cancelToken || s.signal) && (B = (J) => {
      te && (n(!J || J.type ? new vo(null, y, te) : J), te.abort(), V(), te = null);
    }, s.cancelToken && s.cancelToken.subscribe(B), s.signal && (s.signal.aborted ? B() : s.signal.addEventListener("abort", B)));
    const K = Bx(s.url);
    if (K && !rr.protocols.includes(K)) {
      n(
        new oi(
          "Unsupported protocol " + K + ":",
          oi.ERR_BAD_REQUEST,
          y
        )
      ), V();
      return;
    }
    te.send(o || null);
  });
}, jx = (y, e) => {
  if (y = y ? y.filter(Boolean) : [], !e && !y.length)
    return;
  const t = new AbortController();
  let n = !1;
  const s = function(m) {
    if (!n) {
      n = !0, h();
      const x = m instanceof Error ? m : this.reason;
      t.abort(
        x instanceof oi ? x : new vo(x instanceof Error ? x.message : x)
      );
    }
  };
  let o = e && setTimeout(() => {
    o = null, s(new oi(`timeout of ${e}ms exceeded`, oi.ETIMEDOUT));
  }, e);
  const h = () => {
    y && (o && clearTimeout(o), o = null, y.forEach((m) => {
      m.unsubscribe ? m.unsubscribe(s) : m.removeEventListener("abort", s);
    }), y = null);
  };
  y.forEach((m) => m.addEventListener("abort", s, { once: !0 }));
  const { signal: c } = t;
  return c.unsubscribe = () => nt.asap(h), c;
}, Wx = jx, qx = function* (y, e) {
  let t = y.byteLength;
  if (!e || t < e) {
    yield y;
    return;
  }
  let n = 0, s;
  for (; n < t; )
    s = n + e, yield y.slice(n, s), n = s;
}, Zx = async function* (y, e) {
  for await (const t of $x(y))
    yield* qx(t, e);
}, $x = async function* (y) {
  if (y[Symbol.asyncIterator]) {
    yield* y;
    return;
  }
  const e = y.getReader();
  try {
    for (; ; ) {
      const { done: t, value: n } = await e.read();
      if (t)
        break;
      yield n;
    }
  } finally {
    await e.cancel();
  }
}, Hf = (y, e, t, n) => {
  const s = Zx(y, e);
  let o = 0, h, c = (m) => {
    h || (h = !0, n && n(m));
  };
  return new ReadableStream(
    {
      async pull(m) {
        try {
          const { done: x, value: B } = await s.next();
          if (x) {
            c(), m.close();
            return;
          }
          let I = B.byteLength;
          if (t) {
            let F = o += I;
            t(F);
          }
          m.enqueue(new Uint8Array(B));
        } catch (x) {
          throw c(x), x;
        }
      },
      cancel(m) {
        return c(m), s.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, wl = (y) => y >= 48 && y <= 57 || y >= 65 && y <= 70 || y >= 97 && y <= 102, Xx = (y, e, t) => e + 2 < t && wl(y.charCodeAt(e + 1)) && wl(y.charCodeAt(e + 2));
function Kx(y) {
  if (!y || typeof y != "string" || !y.startsWith("data:"))
    return 0;
  const e = y.indexOf(",");
  if (e < 0)
    return 0;
  const t = y.slice(5, e), n = y.slice(e + 1);
  if (/;base64/i.test(t)) {
    let h = n.length;
    const c = n.length;
    for (let M = 0; M < c; M++)
      if (n.charCodeAt(M) === 37 && M + 2 < c) {
        const Z = n.charCodeAt(M + 1), V = n.charCodeAt(M + 2);
        wl(Z) && wl(V) && (h -= 2, M += 2);
      }
    let m = 0, x = c - 1;
    const B = (M) => M >= 2 && n.charCodeAt(M - 2) === 37 && // '%'
    n.charCodeAt(M - 1) === 51 && // '3'
    (n.charCodeAt(M) === 68 || n.charCodeAt(M) === 100);
    x >= 0 && (n.charCodeAt(x) === 61 ? (m++, x--) : B(x) && (m++, x -= 3)), m === 1 && x >= 0 && (n.charCodeAt(x) === 61 || B(x)) && m++;
    const F = Math.floor(h / 4) * 3 - (m || 0);
    return F > 0 ? F : 0;
  }
  let o = 0;
  for (let h = 0, c = n.length; h < c; h++) {
    const m = n.charCodeAt(h);
    if (m === 37 && Xx(n, h, c))
      o += 1, h += 2;
    else if (m < 128)
      o += 1;
    else if (m < 2048)
      o += 2;
    else if (m >= 55296 && m <= 56319 && h + 1 < c) {
      const x = n.charCodeAt(h + 1);
      x >= 56320 && x <= 57343 ? (o += 4, h++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const fu = "1.18.1", Yf = 64 * 1024, { isFunction: nl } = nt, Jx = (y) => encodeURIComponent(y).replace(
  /%([0-9A-F]{2})/gi,
  (e, t) => String.fromCharCode(parseInt(t, 16))
), Gf = (y) => {
  if (!nt.isString(y))
    return y;
  try {
    return decodeURIComponent(y);
  } catch {
    return y;
  }
}, jf = (y, ...e) => {
  try {
    return !!y(...e);
  } catch {
    return !1;
  }
}, Qx = (y) => {
  const e = y.indexOf("://");
  let t = y;
  return e !== -1 && (t = t.slice(e + 3)), t.includes("@") || t.includes(":");
}, ew = (y) => {
  const e = nt.global !== void 0 && nt.global !== null ? nt.global : globalThis, { ReadableStream: t, TextEncoder: n } = e;
  y = nt.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: e.Request,
      Response: e.Response
    },
    y
  );
  const { fetch: s, Request: o, Response: h } = y, c = s ? nl(s) : typeof fetch == "function", m = nl(o), x = nl(h);
  if (!c)
    return !1;
  const B = c && nl(t), I = c && (typeof n == "function" ? ((P) => (K) => P.encode(K))(new n()) : async (P) => new Uint8Array(await new o(P).arrayBuffer())), F = m && B && jf(() => {
    let P = !1;
    const K = new o(rr.origin, {
      body: new t(),
      method: "POST",
      get duplex() {
        return P = !0, "half";
      }
    }), J = K.headers.has("Content-Type");
    return K.body != null && K.body.cancel(), P && !J;
  }), M = x && B && jf(() => nt.isReadableStream(new h("").body)), Z = {
    stream: M && ((P) => P.body)
  };
  c && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((P) => {
    !Z[P] && (Z[P] = (K, J) => {
      let le = K && K[P];
      if (le)
        return le.call(K);
      throw new oi(
        `Response type '${P}' is not supported`,
        oi.ERR_NOT_SUPPORT,
        J
      );
    });
  });
  const V = async (P) => {
    if (P == null)
      return 0;
    if (nt.isBlob(P))
      return P.size;
    if (nt.isSpecCompliantForm(P))
      return (await new o(rr.origin, {
        method: "POST",
        body: P
      }).arrayBuffer()).byteLength;
    if (nt.isArrayBufferView(P) || nt.isArrayBuffer(P))
      return P.byteLength;
    if (nt.isURLSearchParams(P) && (P = P + ""), nt.isString(P))
      return (await I(P)).byteLength;
  }, te = async (P, K) => {
    const J = nt.toFiniteNumber(P.getContentLength());
    return J ?? V(K);
  };
  return async (P) => {
    let {
      url: K,
      method: J,
      data: le,
      signal: fe,
      cancelToken: X,
      timeout: W,
      onDownloadProgress: je,
      onUploadProgress: Ee,
      responseType: He,
      headers: ft,
      withCredentials: Le = "same-origin",
      fetchOptions: $e,
      maxContentLength: ce,
      maxBodyLength: ut
    } = Fd(P);
    const ze = nt.isNumber(ce) && ce > -1, pt = nt.isNumber(ut) && ut > -1, qt = (ii) => nt.hasOwnProp(P, ii) ? P[ii] : void 0;
    let We = s || fetch;
    He = He ? (He + "").toLowerCase() : "text";
    let Et = Wx(
      [fe, X && X.toAbortSignal()],
      W
    ), rt = null;
    const it = Et && Et.unsubscribe && (() => {
      Et.unsubscribe();
    });
    let Zt, $t = null;
    const Lt = () => new oi(
      "Request body larger than maxBodyLength limit",
      oi.ERR_BAD_REQUEST,
      P,
      rt
    );
    try {
      let ii;
      const Ci = qt("auth");
      if (Ci) {
        const tt = nt.getSafeProp(Ci, "username") || "", Pe = nt.getSafeProp(Ci, "password") || "";
        ii = {
          username: tt,
          password: Pe
        };
      }
      if (Qx(K)) {
        const tt = new URL(K, rr.origin);
        if (!ii && (tt.username || tt.password)) {
          const Pe = Gf(tt.username), ke = Gf(tt.password);
          ii = {
            username: Pe,
            password: ke
          };
        }
        (tt.username || tt.password) && (tt.username = "", tt.password = "", K = tt.href);
      }
      if (ii && (ft.delete("authorization"), ft.set(
        "Authorization",
        "Basic " + btoa(Jx((ii.username || "") + ":" + (ii.password || "")))
      )), ze && typeof K == "string" && K.startsWith("data:") && Kx(K) > ce)
        throw new oi(
          "maxContentLength size of " + ce + " exceeded",
          oi.ERR_BAD_RESPONSE,
          P,
          rt
        );
      if (pt && J !== "get" && J !== "head") {
        const tt = await V(le);
        if (typeof tt == "number" && isFinite(tt) && (Zt = tt, tt > ut))
          throw Lt();
      }
      const ui = pt && (nt.isReadableStream(le) || nt.isStream(le)), Gt = (tt, Pe, ke) => Hf(
        tt,
        Yf,
        (Je) => {
          if (pt && Je > ut)
            throw $t = Lt();
          Pe && Pe(Je);
        },
        ke
      );
      if (F && J !== "get" && J !== "head" && (Ee || ui)) {
        if (Zt = Zt ?? await te(ft, le), Zt !== 0 || ui) {
          let tt = new o(K, {
            method: "POST",
            body: le,
            duplex: "half"
          }), Pe;
          if (nt.isFormData(le) && (Pe = tt.headers.get("content-type")) && ft.setContentType(Pe), tt.body) {
            const [ke, Je] = Ee && zf(
              Zt,
              xl(Ff(Ee))
            ) || [];
            le = Gt(tt.body, ke, Je);
          }
        }
      } else if (ui && !m && B && J !== "get" && J !== "head")
        le = Gt(le);
      else if (ui && m && !F && J !== "get" && J !== "head")
        throw new oi(
          "Stream request bodies are not supported by the current fetch implementation",
          oi.ERR_NOT_SUPPORT,
          P,
          rt
        );
      nt.isString(Le) || (Le = Le ? "include" : "omit");
      const Xt = m && "credentials" in o.prototype;
      if (nt.isFormData(le)) {
        const tt = ft.getContentType();
        tt && /^multipart\/form-data/i.test(tt) && !/boundary=/i.test(tt) && ft.delete("content-type");
      }
      ft.set("User-Agent", "axios/" + fu, !1);
      const Qt = {
        ...$e,
        signal: Et,
        method: J.toUpperCase(),
        headers: Bd(ft.normalize()),
        body: le,
        duplex: "half",
        credentials: Xt ? Le : void 0
      };
      rt = m && new o(K, Qt);
      let Ni = await (m ? We(rt, $e) : We(K, Qt));
      const Di = qr.from(Ni.headers);
      if (ze) {
        const tt = nt.toFiniteNumber(Di.getContentLength());
        if (tt != null && tt > ce)
          throw new oi(
            "maxContentLength size of " + ce + " exceeded",
            oi.ERR_BAD_RESPONSE,
            P,
            rt
          );
      }
      const pe = M && (He === "stream" || He === "response");
      if (M && Ni.body && (je || ze || pe && it)) {
        const tt = {};
        ["status", "statusText", "headers"].forEach((Qe) => {
          tt[Qe] = Ni[Qe];
        });
        const Pe = nt.toFiniteNumber(Di.getContentLength()), [ke, Je] = je && zf(
          Pe,
          xl(Ff(je), !0)
        ) || [];
        let kt = 0;
        const vt = (Qe) => {
          if (ze && (kt = Qe, kt > ce))
            throw new oi(
              "maxContentLength size of " + ce + " exceeded",
              oi.ERR_BAD_RESPONSE,
              P,
              rt
            );
          ke && ke(Qe);
        };
        Ni = new h(
          Hf(Ni.body, Yf, vt, () => {
            Je && Je(), it && it();
          }),
          tt
        );
      }
      He = He || "text";
      let xt = await Z[nt.findKey(Z, He) || "text"](
        Ni,
        P
      );
      if (ze && !M && !pe) {
        let tt;
        if (xt != null && (typeof xt.byteLength == "number" ? tt = xt.byteLength : typeof xt.size == "number" ? tt = xt.size : typeof xt == "string" && (tt = typeof n == "function" ? new n().encode(xt).byteLength : xt.length)), typeof tt == "number" && tt > ce)
          throw new oi(
            "maxContentLength size of " + ce + " exceeded",
            oi.ERR_BAD_RESPONSE,
            P,
            rt
          );
      }
      return !pe && it && it(), await new Promise((tt, Pe) => {
        Dd(tt, Pe, {
          data: xt,
          headers: qr.from(Ni.headers),
          status: Ni.status,
          statusText: Ni.statusText,
          config: P,
          request: rt
        });
      });
    } catch (ii) {
      if (it && it(), Et && Et.aborted && Et.reason instanceof oi) {
        const Ci = Et.reason;
        throw Ci.config = P, rt && (Ci.request = rt), ii !== Ci && Object.defineProperty(Ci, "cause", {
          __proto__: null,
          value: ii,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), Ci;
      }
      if ($t)
        throw rt && !$t.request && ($t.request = rt), $t;
      if (ii instanceof oi)
        throw rt && !ii.request && (ii.request = rt), ii;
      if (ii && ii.name === "TypeError" && /Load failed|fetch/i.test(ii.message)) {
        const Ci = new oi(
          "Network Error",
          oi.ERR_NETWORK,
          P,
          rt,
          ii && ii.response
        );
        throw Object.defineProperty(Ci, "cause", {
          __proto__: null,
          value: ii.cause || ii,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), Ci;
      }
      throw oi.from(ii, ii && ii.code, P, rt, ii && ii.response);
    }
  };
}, tw = /* @__PURE__ */ new Map(), Ud = (y) => {
  let e = y && y.env || {};
  const { fetch: t, Request: n, Response: s } = e, o = [n, s, t];
  let h = o.length, c = h, m, x, B = tw;
  for (; c--; )
    m = o[c], x = B.get(m), x === void 0 && B.set(m, x = c ? /* @__PURE__ */ new Map() : ew(e)), B = x;
  return x;
};
Ud();
const du = {
  http: cx,
  xhr: Gx,
  fetch: {
    get: Ud
  }
};
nt.forEach(du, (y, e) => {
  if (y) {
    try {
      Object.defineProperty(y, "name", { __proto__: null, value: e });
    } catch {
    }
    Object.defineProperty(y, "adapterName", { __proto__: null, value: e });
  }
});
const Wf = (y) => `- ${y}`, iw = (y) => nt.isFunction(y) || y === null || y === !1;
function nw(y, e) {
  y = nt.isArray(y) ? y : [y];
  const { length: t } = y;
  let n, s;
  const o = {};
  for (let h = 0; h < t; h++) {
    n = y[h];
    let c;
    if (s = n, !iw(n) && (s = du[(c = String(n)).toLowerCase()], s === void 0))
      throw new oi(`Unknown adapter '${c}'`);
    if (s && (nt.isFunction(s) || (s = s.get(e))))
      break;
    o[c || "#" + h] = s;
  }
  if (!s) {
    const h = Object.entries(o).map(
      ([m, x]) => `adapter ${m} ` + (x === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let c = t ? h.length > 1 ? `since :
` + h.map(Wf).join(`
`) : " " + Wf(h[0]) : "as no adapter specified";
    throw new oi(
      "There is no suitable adapter to dispatch the request " + c,
      oi.ERR_NOT_SUPPORT
    );
  }
  return s;
}
const Vd = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: nw,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: du
};
function Nh(y) {
  if (y.cancelToken && y.cancelToken.throwIfRequested(), y.signal && y.signal.aborted)
    throw new vo(null, y);
}
function qf(y) {
  return Nh(y), y.headers = qr.from(y.headers), y.data = Ph.call(y, y.transformRequest), ["post", "put", "patch"].indexOf(y.method) !== -1 && y.headers.setContentType("application/x-www-form-urlencoded", !1), Vd.getAdapter(y.adapter || cu.adapter, y)(y).then(
    function(n) {
      Nh(y), y.response = n;
      try {
        n.data = Ph.call(y, y.transformResponse, n);
      } finally {
        delete y.response;
      }
      return n.headers = qr.from(n.headers), n;
    },
    function(n) {
      if (!Rd(n) && (Nh(y), n && n.response)) {
        y.response = n.response;
        try {
          n.response.data = Ph.call(
            y,
            y.transformResponse,
            n.response
          );
        } finally {
          delete y.response;
        }
        n.response.headers = qr.from(n.response.headers);
      }
      return Promise.reject(n);
    }
  );
}
const Pl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((y, e) => {
  Pl[y] = function(n) {
    return typeof n === y || "a" + (e < 1 ? "n " : " ") + y;
  };
});
const Zf = {};
Pl.transitional = function(e, t, n) {
  function s(o, h) {
    return "[Axios v" + fu + "] Transitional option '" + o + "'" + h + (n ? ". " + n : "");
  }
  return (o, h, c) => {
    if (e === !1)
      throw new oi(
        s(h, " has been removed" + (t ? " in " + t : "")),
        oi.ERR_DEPRECATED
      );
    return t && !Zf[h] && (Zf[h] = !0, console.warn(
      s(
        h,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, h, c) : !0;
  };
};
Pl.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function rw(y, e, t) {
  if (typeof y != "object" || y === null)
    throw new oi("options must be an object", oi.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(y);
  let s = n.length;
  for (; s-- > 0; ) {
    const o = n[s], h = Object.prototype.hasOwnProperty.call(e, o) ? e[o] : void 0;
    if (h) {
      const c = y[o], m = c === void 0 || h(c, o, y);
      if (m !== !0)
        throw new oi(
          "option " + o + " must be " + m,
          oi.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (t !== !0)
      throw new oi("Unknown option " + o, oi.ERR_BAD_OPTION);
  }
}
const cl = {
  assertOptions: rw,
  validators: Pl
}, dr = cl.validators;
class Sl {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Rf(),
      response: new Rf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const o = (() => {
          if (!s.stack)
            return "";
          const h = s.stack.indexOf(`
`);
          return h === -1 ? "" : s.stack.slice(h + 1);
        })();
        try {
          if (!n.stack)
            n.stack = o;
          else if (o) {
            const h = o.indexOf(`
`), c = h === -1 ? -1 : o.indexOf(`
`, h + 1), m = c === -1 ? "" : o.slice(c + 1);
            String(n.stack).endsWith(m) || (n.stack += `
` + o);
          }
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = da(this.defaults, t);
    const { transitional: n, paramsSerializer: s, headers: o } = t;
    n !== void 0 && cl.assertOptions(
      n,
      {
        silentJSONParsing: dr.transitional(dr.boolean),
        forcedJSONParsing: dr.transitional(dr.boolean),
        clarifyTimeoutError: dr.transitional(dr.boolean),
        legacyInterceptorReqResOrdering: dr.transitional(dr.boolean),
        advertiseZstdAcceptEncoding: dr.transitional(dr.boolean),
        validateStatusUndefinedResolves: dr.transitional(dr.boolean)
      },
      !1
    ), s != null && (nt.isFunction(s) ? t.paramsSerializer = {
      serialize: s
    } : cl.assertOptions(
      s,
      {
        encode: dr.function,
        serialize: dr.function
      },
      !0
    )), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), cl.assertOptions(
      t,
      {
        baseUrl: dr.spelling("baseURL"),
        withXsrfToken: dr.spelling("withXSRFToken")
      },
      !0
    ), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let h = o && nt.merge(o.common, o[t.method]);
    o && nt.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (Z) => {
      delete o[Z];
    }), t.headers = qr.concat(h, o);
    const c = [];
    let m = !0;
    this.interceptors.request.forEach(function(V) {
      if (typeof V.runWhen == "function" && V.runWhen(t) === !1)
        return;
      m = m && V.synchronous;
      const te = t.transitional || lu;
      te && te.legacyInterceptorReqResOrdering ? c.unshift(V.fulfilled, V.rejected) : c.push(V.fulfilled, V.rejected);
    });
    const x = [];
    this.interceptors.response.forEach(function(V) {
      x.push(V.fulfilled, V.rejected);
    });
    let B, I = 0, F;
    if (!m) {
      const Z = [qf.bind(this), void 0];
      for (Z.unshift(...c), Z.push(...x), F = Z.length, B = Promise.resolve(t); I < F; )
        B = B.then(Z[I++], Z[I++]);
      return B;
    }
    F = c.length;
    let M = t;
    for (; I < F; ) {
      const Z = c[I++], V = c[I++];
      try {
        M = Z(M);
      } catch (te) {
        V.call(this, te);
        break;
      }
    }
    try {
      B = qf.call(this, M);
    } catch (Z) {
      return Promise.reject(Z);
    }
    for (I = 0, F = x.length; I < F; )
      B = B.then(x[I++], x[I++]);
    return B;
  }
  getUri(e) {
    e = da(this.defaults, e);
    const t = zd(e.baseURL, e.url, e.allowAbsoluteUrls, e);
    return Od(t, e.params, e.paramsSerializer);
  }
}
nt.forEach(["delete", "get", "head", "options"], function(e) {
  Sl.prototype[e] = function(t, n) {
    return this.request(
      da(n || {}, {
        method: e,
        url: t,
        data: n && nt.hasOwnProp(n, "data") ? n.data : void 0
      })
    );
  };
});
nt.forEach(["post", "put", "patch", "query"], function(e) {
  function t(n) {
    return function(o, h, c) {
      return this.request(
        da(c || {}, {
          method: e,
          headers: n ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: h
        })
      );
    };
  }
  Sl.prototype[e] = t(), e !== "query" && (Sl.prototype[e + "Form"] = t(!0));
});
const fl = Sl;
class gu {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const h = new Promise((c) => {
        n.subscribe(c), o = c;
      }).then(s);
      return h.cancel = function() {
        n.unsubscribe(o);
      }, h;
    }, e(function(o, h, c) {
      n.reason || (n.reason = new vo(o, h, c), t(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), t = (n) => {
      e.abort(n);
    };
    return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new gu(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
const sw = gu;
function aw(y) {
  return function(t) {
    return y.apply(null, t);
  };
}
function ow(y) {
  return nt.isObject(y) && y.isAxiosError === !0;
}
const qh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(qh).forEach(([y, e]) => {
  qh[e] = y;
});
const lw = qh;
function Hd(y) {
  const e = new fl(y), t = bd(fl.prototype.request, e);
  return nt.extend(t, fl.prototype, e, { allOwnKeys: !0 }), nt.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(s) {
    return Hd(da(y, s));
  }, t;
}
const qn = Hd(cu);
qn.Axios = fl;
qn.CanceledError = vo;
qn.CancelToken = sw;
qn.isCancel = Rd;
qn.VERSION = fu;
qn.toFormData = Ol;
qn.AxiosError = oi;
qn.Cancel = qn.CanceledError;
qn.all = function(e) {
  return Promise.all(e);
};
qn.spread = aw;
qn.isAxiosError = ow;
qn.mergeConfig = da;
qn.AxiosHeaders = qr;
qn.formToJSON = (y) => Nd(nt.isHTMLForm(y) ? new FormData(y) : y);
qn.getAdapter = Vd.getAdapter;
qn.HttpStatusCode = lw;
qn.default = qn;
const $f = qn;
class Xf {
  constructor(e, t, n = !0) {
    this.tasksUrl = e, this.token = t, this.upload = async (s, o) => await this.uploadFileChunked(s, s.type, Zakeke.generateUUID(), o), this.uploadFileChunked = async (s, o, h, c, m) => {
      if (await this.resumableUpload(s, o, h, m) === "OK") {
        let B = await this.createTask(h, c);
        if (B !== -1) {
          let I = await this.getResultFromTask(B);
          if (I)
            return I.files;
        } else
          throw "Upload failed";
      }
      return null;
    }, this.resumableUpload = async (s, o, h, c) => new Promise((m, x) => {
      let B = new Resumable({
        target: Zakeke.config.baseApiUrl + "filechunks/upload",
        generateUniqueIdentifier: function() {
          return h;
        },
        maxFiles: 1,
        testChunks: !1,
        headers: this.headers,
        query: { resumableType: o },
        simultaneousUploads: 3
      });
      B.addFile(s), B.on("fileError", function(I, F) {
        m("KO"), console.error("fileError", I, F);
      }), B.on("error", function(I, F) {
        m("KO"), console.error("error", I, F);
      }), B.on("progress", function() {
        let I = B.progress() * 100;
        c && c(I);
      }), B.on("fileAdded", function(I, F) {
        B.upload();
      }), B.on("complete", function() {
        m("OK");
      });
    }), this.createTask = async (s, o) => {
      let h = { fileID: s, options: o }, c = await $f.post(Zakeke.config.baseApiUrl + this.tasksUrl, h, { headers: this.headers });
      return c ? c.data.taskID : -1;
    }, this.getResultFromTask = async (s) => {
      let o = 0;
      for (; ; ) {
        try {
          let h = await $f.get(
            Zakeke.config.baseApiUrl + this.tasksUrl + "/results/" + s,
            { headers: this.headers }
          );
          if (h && h.data.state === 2)
            return h.data;
          if (h && h.data.state === 3)
            return null;
        } catch {
          return null;
        }
        if (o++, o > 200)
          return null;
        await new Promise((h) => setTimeout(h, 1e3));
      }
    }, n ? this.headers = {
      Authorization: "Bearer " + this.token,
      "Accept-Language": "en-US"
    } : this.headers = {
      "X-Auth-Token": this.token,
      "Accept-Language": "en-US"
    };
  }
}
class gi {
}
gi.Environment = {
  //EnvironmentTextureName: "environmentSpecular.dds",
  EnvironmentTextureName: "environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env",
  GroundTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundGround9.png",
  SkyboxTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundSkybox.dds",
  //EnvironmentTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/environmentSpecular.dds"
  //EnvironmentTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/environmentSpecular.dds"
  EnvironmentTextureCDNUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/environments/environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env"
};
gi.TryonReferences = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/tryon/references/",
  ReferenceGlassesFrameName: "Reference Glasses Frame",
  ReferenceGlassesFrameFileName: "Reference_Glasses_Frame_001.json",
  EyewearName: "glasses_VTO_Reference",
  EyewearURL: "Eyewear_VTO_Reference.babylon",
  EyewearDownloadableURL: "Eyewear_VTO_Reference.glb",
  ScarvesName: "scarves_VTO_Reference",
  ScarvesURL: "Scarves_VTO_Reference.babylon",
  ScarvesDownloadableURL: "Scarves_VTO_Reference.glb",
  EarringsName: "earrings_VTO_Reference",
  EarringsURL: "Earrings_VTO_Reference.babylon",
  EarringsDownloadableURL: "Earrings_VTO_Reference.glb",
  HeadwearName: "headwear_VTO_Reference",
  HeadwearURL: "Headwear_VTO_Reference.babylon",
  HeadwearDownloadableURL: "Headwear_VTO_Reference.glb",
  NecklaceName: "necklace_VTO_Reference",
  NecklaceURL: "Necklace_VTO_Reference.babylon",
  NecklaceDownloadableURL: "Necklace_VTO_Reference.glb",
  ShoeName: "foot_VTO_Reference",
  ShoeURL: "Foot_VTO_Reference.babylon",
  ShoeDownloadableURL: "Foot_VTO_Reference.glb"
};
gi.Shapes = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/shapes/",
  RoundedCubeName: "Rounded Cube",
  RoundedCubeFileName: "rounded_cube.babylon",
  RoundedCylinderName: "Rounded Cylinder",
  RoundedCylinderFileName: "rounded_cylinder.babylon",
  MatBallName: "Mat Ball",
  MatBallFileName: "mat_ball.babylon",
  MaleHeadName: "Group48944",
  MaleHeadFileName: "DemoHead.babylon",
  FemaleHeadName: "Group12208",
  FemaleHeadFileName: "FemaleHead.babylon",
  PokemonBallName: "PokemonBall",
  PokemonBallFileName: "PokemonBall.babylon",
  ShaderBallName: "Elements",
  ShaderBallFileName: "ShaderBall.babylon",
  BootsFolder: "boots/",
  BootsName: "shoe",
  BootsFileName: "boots.incremental.babylon",
  SuzanneName: "Suzanne",
  SuzanneFileName: "suzanne.babylon",
  StepPyramidName: "Pyramid",
  StepPyramidFileName: "step-pyramid.babylon",
  TeapotName: "Teapot",
  TeapotFileName: "teapot.babylon",
  AlloyWheelName: "Wheel",
  AlloyWheelFolder: "alloy_wheel/",
  AlloyWheelFileName: "alloy_wheel.incremental.babylon"
};
class Ms {
  /**
   * Checks for a matching suffix at the end of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static EndsWith(e, t) {
    return e.indexOf(t, e.length - t.length) !== -1;
  }
  /**
   * Checks for a matching suffix at the beginning of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static StartsWith(e, t) {
    return e.indexOf(t) === 0;
  }
  /**
   * Decodes a buffer into a string
   * @param buffer The buffer to decode
   * @returns The decoded string
   */
  static Decode(e) {
    if (typeof TextDecoder < "u")
      return new TextDecoder().decode(e);
    let t = "";
    for (let n = 0; n < e.byteLength; n++)
      t += String.fromCharCode(e[n]);
    return t;
  }
  /**
   * Encode a buffer to a base64 string
   * @param buffer defines the buffer to encode
   * @returns the encoded string
   */
  static EncodeArrayBufferToBase64(e) {
    for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", n = "", s, o, h, c, m, x, B, I = 0, F = ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e); I < F.length; )
      s = F[I++], o = I < F.length ? F[I++] : Number.NaN, h = I < F.length ? F[I++] : Number.NaN, c = s >> 2, m = (s & 3) << 4 | o >> 4, x = (o & 15) << 2 | h >> 6, B = h & 63, isNaN(o) ? x = B = 64 : isNaN(h) && (B = 64), n += t.charAt(c) + t.charAt(m) + t.charAt(x) + t.charAt(B);
    return n;
  }
}
class hw {
  constructor() {
    this._mesh = null, this._scene = null, this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  dispose() {
  }
  resetDataModel() {
    this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  prepareDataModel() {
    if (this.resetDataModel(), this._mesh && this._scene && (this._facesOfVertices = [], this._sharedFacesOfVertices = {}, this._meshVerticesPositions = this._mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind), this._meshVerticesNormals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), this._meshIndices = this._mesh.getIndices(), this._meshPositions = [], this._meshFacesNormals = [], this._meshVerticesPositions && this._meshVerticesNormals && this._meshIndices)) {
      for (let e = 0; e < this._meshVerticesPositions.length; e += 3)
        this._meshPositions.push(new BABYLON.Vector3(this._meshVerticesPositions[e], this._meshVerticesPositions[e + 1], this._meshVerticesPositions[e + 2]));
      for (let e = 0; e < this._mesh.getTotalIndices() / 3; e++)
        this._computeFaceNormal(e);
      this._getFacesOfVertices();
    }
  }
  _getFaceVerticesIndex(e) {
    return this._meshIndices ? {
      v1: this._meshIndices[e * 3],
      v2: this._meshIndices[e * 3 + 1],
      v3: this._meshIndices[e * 3 + 2]
    } : null;
  }
  // La normale ad una faccia è calcolata come prodotto vettoriale (cross product)
  // tra i vettori che connettono gli spigoli
  _computeFaceNormal(e) {
    if (this._meshPositions && this._meshIndices && this._meshFacesNormals) {
      const t = this._getFaceVerticesIndex(e);
      if (t) {
        const n = this._meshPositions[t.v1].subtract(this._meshPositions[t.v2]), s = this._meshPositions[t.v3].subtract(this._meshPositions[t.v2]);
        this._meshFacesNormals[e] = BABYLON.Vector3.Normalize(BABYLON.Vector3.Cross(n, s));
      }
    }
  }
  _getPositionKey(e) {
    return `${e.x}_${e.y}_${e.z}`;
  }
  // Determina le facce di ogni vertice sia considerando vertici uguali ripetuti più volte (_facesOfVertices)
  // che quelle condivise da uno stesso vertice ripetuto (_sharedFacesOfVertices). Queste ultime saranno
  // quelle che verranno considerate per il calcolo della normale risultante da tutte le facce che hanno
  // un vertice come spigolo.
  _getFacesOfVertices() {
    if (this._mesh && this._meshPositions && this._meshIndices) {
      this._sharedFacesOfVertices = {}, this._facesOfVertices = [];
      for (let e = 0; e < this._meshPositions.length; e++) {
        this._facesOfVertices[e] = [];
        const t = this._meshPositions[e], n = this._getPositionKey(t);
        this._sharedFacesOfVertices.hasOwnProperty(n) || (this._sharedFacesOfVertices[n] = /* @__PURE__ */ new Set());
      }
      for (let e = 0; e < this._meshIndices.length; e++) {
        const t = this._meshIndices[e], n = e / 3 | 0;
        this._facesOfVertices[t].push(n);
        const s = this._meshPositions[t], o = this._getPositionKey(s);
        this._sharedFacesOfVertices.hasOwnProperty(o) && this._sharedFacesOfVertices[o].add(n);
      }
    }
  }
  expandMesh(e, t = 0.01) {
    if (e instanceof BABYLON.Mesh && (this._mesh = e, this._scene = e.getScene(), this.prepareDataModel(), this._meshPositions && this._meshVerticesPositions && this._meshVerticesNormals)) {
      for (let n = 0; n < this._meshPositions.length; n++) {
        const s = this._meshPositions[n], o = this._getVertexComputedNormal(n);
        if (o) {
          const h = o.scale(t);
          s.addInPlace(h), this._meshVerticesPositions[n * 3] = s.x, this._meshVerticesPositions[n * 3 + 1] = s.y, this._meshVerticesPositions[n * 3 + 2] = s.z;
        }
      }
      this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.PositionKind, !0), this._mesh.updateVerticesData(BABYLON.VertexBuffer.PositionKind, this._meshVerticesPositions), this._mesh.computeWorldMatrix(!0);
    }
  }
  _reComputeNormals() {
    const e = [];
    if (this._meshPositions && this._facesOfVertices) {
      for (let n = 0; n < this._meshPositions.length; n++) {
        const s = this._facesOfVertices[n];
        for (let o = 0; o < s.length; o++)
          e[s[o]] = !0;
      }
      let t;
      for (t in e)
        this._computeFaceNormal(t);
      for (t in e) {
        const n = this._getFaceVerticesIndex(t);
        n && (this._computeNormal(n.v1), this._computeNormal(n.v2), this._computeNormal(n.v3));
      }
    }
  }
  _getVertexComputedNormal(e) {
    let t = null;
    if (this._meshPositions && this._meshFacesNormals) {
      const n = this._meshPositions, s = this._meshFacesNormals, o = n[e], h = this._getPositionKey(o);
      if (this._sharedFacesOfVertices.hasOwnProperty(h)) {
        const c = this._sharedFacesOfVertices[h];
        t = BABYLON.Vector3.Zero(), c.forEach((m) => {
          const x = s[m];
          t && x && (t = t.add(x));
        }), t = BABYLON.Vector3.Normalize(t.scale(1 / c.size));
      }
    }
    return t;
  }
  _computeNormal(e) {
    const t = this._getVertexComputedNormal(e);
    t && this._meshVerticesNormals && (this._meshVerticesNormals[e * 3] = t.x, this._meshVerticesNormals[e * 3 + 1] = t.y, this._meshVerticesNormals[e * 3 + 2] = t.z);
  }
}
class uw {
  static async convertGlbToUsdz(e) {
    return new Promise((t, n) => {
      let s = null;
      new THREE.GLTFLoader().load(e, async function(h) {
        h.scene.updateWorldMatrix(!0, !0);
        const m = await new THREE.USDZExporter().parse(h.scene);
        s = new Blob([m], { type: "model/vnd.usdz+zip" }), t(s);
      });
    });
  }
}
var as = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pu(y) {
  return y && y.__esModule && Object.prototype.hasOwnProperty.call(y, "default") ? y.default : y;
}
function cw(y) {
  if (y.__esModule)
    return y;
  var e = y.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(y).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(y, n);
    Object.defineProperty(t, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return y[n];
      }
    });
  }), t;
}
function Qa(y) {
  throw new Error('Could not dynamically require "' + y + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Yd = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(y, e) {
  (function(t) {
    y.exports = t();
  })(function() {
    return function t(n, s, o) {
      function h(x, B) {
        if (!s[x]) {
          if (!n[x]) {
            var I = typeof Qa == "function" && Qa;
            if (!B && I)
              return I(x, !0);
            if (c)
              return c(x, !0);
            var F = new Error("Cannot find module '" + x + "'");
            throw F.code = "MODULE_NOT_FOUND", F;
          }
          var M = s[x] = { exports: {} };
          n[x][0].call(M.exports, function(Z) {
            var V = n[x][1][Z];
            return h(V || Z);
          }, M, M.exports, t, n, s, o);
        }
        return s[x].exports;
      }
      for (var c = typeof Qa == "function" && Qa, m = 0; m < o.length; m++)
        h(o[m]);
      return h;
    }({ 1: [function(t, n, s) {
      var o = t("./utils"), h = t("./support"), c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      s.encode = function(m) {
        for (var x, B, I, F, M, Z, V, te = [], P = 0, K = m.length, J = K, le = o.getTypeOf(m) !== "string"; P < m.length; )
          J = K - P, I = le ? (x = m[P++], B = P < K ? m[P++] : 0, P < K ? m[P++] : 0) : (x = m.charCodeAt(P++), B = P < K ? m.charCodeAt(P++) : 0, P < K ? m.charCodeAt(P++) : 0), F = x >> 2, M = (3 & x) << 4 | B >> 4, Z = 1 < J ? (15 & B) << 2 | I >> 6 : 64, V = 2 < J ? 63 & I : 64, te.push(c.charAt(F) + c.charAt(M) + c.charAt(Z) + c.charAt(V));
        return te.join("");
      }, s.decode = function(m) {
        var x, B, I, F, M, Z, V = 0, te = 0, P = "data:";
        if (m.substr(0, P.length) === P)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var K, J = 3 * (m = m.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (m.charAt(m.length - 1) === c.charAt(64) && J--, m.charAt(m.length - 2) === c.charAt(64) && J--, J % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (K = h.uint8array ? new Uint8Array(0 | J) : new Array(0 | J); V < m.length; )
          x = c.indexOf(m.charAt(V++)) << 2 | (F = c.indexOf(m.charAt(V++))) >> 4, B = (15 & F) << 4 | (M = c.indexOf(m.charAt(V++))) >> 2, I = (3 & M) << 6 | (Z = c.indexOf(m.charAt(V++))), K[te++] = x, M !== 64 && (K[te++] = B), Z !== 64 && (K[te++] = I);
        return K;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(t, n, s) {
      var o = t("./external"), h = t("./stream/DataWorker"), c = t("./stream/Crc32Probe"), m = t("./stream/DataLengthProbe");
      function x(B, I, F, M, Z) {
        this.compressedSize = B, this.uncompressedSize = I, this.crc32 = F, this.compression = M, this.compressedContent = Z;
      }
      x.prototype = { getContentWorker: function() {
        var B = new h(o.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new m("data_length")), I = this;
        return B.on("end", function() {
          if (this.streamInfo.data_length !== I.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), B;
      }, getCompressedWorker: function() {
        return new h(o.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, x.createWorkerFrom = function(B, I, F) {
        return B.pipe(new c()).pipe(new m("uncompressedSize")).pipe(I.compressWorker(F)).pipe(new m("compressedSize")).withStreamInfo("compression", I);
      }, n.exports = x;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(t, n, s) {
      var o = t("./stream/GenericWorker");
      s.STORE = { magic: "\0\0", compressWorker: function() {
        return new o("STORE compression");
      }, uncompressWorker: function() {
        return new o("STORE decompression");
      } }, s.DEFLATE = t("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(t, n, s) {
      var o = t("./utils"), h = function() {
        for (var c, m = [], x = 0; x < 256; x++) {
          c = x;
          for (var B = 0; B < 8; B++)
            c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
          m[x] = c;
        }
        return m;
      }();
      n.exports = function(c, m) {
        return c !== void 0 && c.length ? o.getTypeOf(c) !== "string" ? function(x, B, I, F) {
          var M = h, Z = F + I;
          x ^= -1;
          for (var V = F; V < Z; V++)
            x = x >>> 8 ^ M[255 & (x ^ B[V])];
          return -1 ^ x;
        }(0 | m, c, c.length, 0) : function(x, B, I, F) {
          var M = h, Z = F + I;
          x ^= -1;
          for (var V = F; V < Z; V++)
            x = x >>> 8 ^ M[255 & (x ^ B.charCodeAt(V))];
          return -1 ^ x;
        }(0 | m, c, c.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(t, n, s) {
      s.base64 = !1, s.binary = !1, s.dir = !1, s.createFolders = !0, s.date = null, s.compression = null, s.compressionOptions = null, s.comment = null, s.unixPermissions = null, s.dosPermissions = null;
    }, {}], 6: [function(t, n, s) {
      var o = null;
      o = typeof Promise < "u" ? Promise : t("lie"), n.exports = { Promise: o };
    }, { lie: 37 }], 7: [function(t, n, s) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", h = t("pako"), c = t("./utils"), m = t("./stream/GenericWorker"), x = o ? "uint8array" : "array";
      function B(I, F) {
        m.call(this, "FlateWorker/" + I), this._pako = null, this._pakoAction = I, this._pakoOptions = F, this.meta = {};
      }
      s.magic = "\b\0", c.inherits(B, m), B.prototype.processChunk = function(I) {
        this.meta = I.meta, this._pako === null && this._createPako(), this._pako.push(c.transformTo(x, I.data), !1);
      }, B.prototype.flush = function() {
        m.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, B.prototype.cleanUp = function() {
        m.prototype.cleanUp.call(this), this._pako = null;
      }, B.prototype._createPako = function() {
        this._pako = new h[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var I = this;
        this._pako.onData = function(F) {
          I.push({ data: F, meta: I.meta });
        };
      }, s.compressWorker = function(I) {
        return new B("Deflate", I);
      }, s.uncompressWorker = function() {
        return new B("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(t, n, s) {
      function o(M, Z) {
        var V, te = "";
        for (V = 0; V < Z; V++)
          te += String.fromCharCode(255 & M), M >>>= 8;
        return te;
      }
      function h(M, Z, V, te, P, K) {
        var J, le, fe = M.file, X = M.compression, W = K !== x.utf8encode, je = c.transformTo("string", K(fe.name)), Ee = c.transformTo("string", x.utf8encode(fe.name)), He = fe.comment, ft = c.transformTo("string", K(He)), Le = c.transformTo("string", x.utf8encode(He)), $e = Ee.length !== fe.name.length, ce = Le.length !== He.length, ut = "", ze = "", pt = "", qt = fe.dir, We = fe.date, Et = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        Z && !V || (Et.crc32 = M.crc32, Et.compressedSize = M.compressedSize, Et.uncompressedSize = M.uncompressedSize);
        var rt = 0;
        Z && (rt |= 8), W || !$e && !ce || (rt |= 2048);
        var it = 0, Zt = 0;
        qt && (it |= 16), P === "UNIX" ? (Zt = 798, it |= function(Lt, ii) {
          var Ci = Lt;
          return Lt || (Ci = ii ? 16893 : 33204), (65535 & Ci) << 16;
        }(fe.unixPermissions, qt)) : (Zt = 20, it |= function(Lt) {
          return 63 & (Lt || 0);
        }(fe.dosPermissions)), J = We.getUTCHours(), J <<= 6, J |= We.getUTCMinutes(), J <<= 5, J |= We.getUTCSeconds() / 2, le = We.getUTCFullYear() - 1980, le <<= 4, le |= We.getUTCMonth() + 1, le <<= 5, le |= We.getUTCDate(), $e && (ze = o(1, 1) + o(B(je), 4) + Ee, ut += "up" + o(ze.length, 2) + ze), ce && (pt = o(1, 1) + o(B(ft), 4) + Le, ut += "uc" + o(pt.length, 2) + pt);
        var $t = "";
        return $t += `
\0`, $t += o(rt, 2), $t += X.magic, $t += o(J, 2), $t += o(le, 2), $t += o(Et.crc32, 4), $t += o(Et.compressedSize, 4), $t += o(Et.uncompressedSize, 4), $t += o(je.length, 2), $t += o(ut.length, 2), { fileRecord: I.LOCAL_FILE_HEADER + $t + je + ut, dirRecord: I.CENTRAL_FILE_HEADER + o(Zt, 2) + $t + o(ft.length, 2) + "\0\0\0\0" + o(it, 4) + o(te, 4) + je + ut + ft };
      }
      var c = t("../utils"), m = t("../stream/GenericWorker"), x = t("../utf8"), B = t("../crc32"), I = t("../signature");
      function F(M, Z, V, te) {
        m.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = Z, this.zipPlatform = V, this.encodeFileName = te, this.streamFiles = M, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      c.inherits(F, m), F.prototype.push = function(M) {
        var Z = M.meta.percent || 0, V = this.entriesCount, te = this._sources.length;
        this.accumulate ? this.contentBuffer.push(M) : (this.bytesWritten += M.data.length, m.prototype.push.call(this, { data: M.data, meta: { currentFile: this.currentFile, percent: V ? (Z + 100 * (V - te - 1)) / V : 100 } }));
      }, F.prototype.openedSource = function(M) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = M.file.name;
        var Z = this.streamFiles && !M.file.dir;
        if (Z) {
          var V = h(M, Z, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: V.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = !0;
      }, F.prototype.closedSource = function(M) {
        this.accumulate = !1;
        var Z = this.streamFiles && !M.file.dir, V = h(M, Z, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(V.dirRecord), Z)
          this.push({ data: function(te) {
            return I.DATA_DESCRIPTOR + o(te.crc32, 4) + o(te.compressedSize, 4) + o(te.uncompressedSize, 4);
          }(M), meta: { percent: 100 } });
        else
          for (this.push({ data: V.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, F.prototype.flush = function() {
        for (var M = this.bytesWritten, Z = 0; Z < this.dirRecords.length; Z++)
          this.push({ data: this.dirRecords[Z], meta: { percent: 100 } });
        var V = this.bytesWritten - M, te = function(P, K, J, le, fe) {
          var X = c.transformTo("string", fe(le));
          return I.CENTRAL_DIRECTORY_END + "\0\0\0\0" + o(P, 2) + o(P, 2) + o(K, 4) + o(J, 4) + o(X.length, 2) + X;
        }(this.dirRecords.length, V, M, this.zipComment, this.encodeFileName);
        this.push({ data: te, meta: { percent: 100 } });
      }, F.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, F.prototype.registerPrevious = function(M) {
        this._sources.push(M);
        var Z = this;
        return M.on("data", function(V) {
          Z.processChunk(V);
        }), M.on("end", function() {
          Z.closedSource(Z.previous.streamInfo), Z._sources.length ? Z.prepareNextSource() : Z.end();
        }), M.on("error", function(V) {
          Z.error(V);
        }), this;
      }, F.prototype.resume = function() {
        return !!m.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, F.prototype.error = function(M) {
        var Z = this._sources;
        if (!m.prototype.error.call(this, M))
          return !1;
        for (var V = 0; V < Z.length; V++)
          try {
            Z[V].error(M);
          } catch {
          }
        return !0;
      }, F.prototype.lock = function() {
        m.prototype.lock.call(this);
        for (var M = this._sources, Z = 0; Z < M.length; Z++)
          M[Z].lock();
      }, n.exports = F;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(t, n, s) {
      var o = t("../compressions"), h = t("./ZipFileWorker");
      s.generateWorker = function(c, m, x) {
        var B = new h(m.streamFiles, x, m.platform, m.encodeFileName), I = 0;
        try {
          c.forEach(function(F, M) {
            I++;
            var Z = function(K, J) {
              var le = K || J, fe = o[le];
              if (!fe)
                throw new Error(le + " is not a valid compression method !");
              return fe;
            }(M.options.compression, m.compression), V = M.options.compressionOptions || m.compressionOptions || {}, te = M.dir, P = M.date;
            M._compressWorker(Z, V).withStreamInfo("file", { name: F, dir: te, date: P, comment: M.comment || "", unixPermissions: M.unixPermissions, dosPermissions: M.dosPermissions }).pipe(B);
          }), B.entriesCount = I;
        } catch (F) {
          B.error(F);
        }
        return B;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(t, n, s) {
      function o() {
        if (!(this instanceof o))
          return new o();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var h = new o();
          for (var c in this)
            typeof this[c] != "function" && (h[c] = this[c]);
          return h;
        };
      }
      (o.prototype = t("./object")).loadAsync = t("./load"), o.support = t("./support"), o.defaults = t("./defaults"), o.version = "3.10.1", o.loadAsync = function(h, c) {
        return new o().loadAsync(h, c);
      }, o.external = t("./external"), n.exports = o;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(t, n, s) {
      var o = t("./utils"), h = t("./external"), c = t("./utf8"), m = t("./zipEntries"), x = t("./stream/Crc32Probe"), B = t("./nodejsUtils");
      function I(F) {
        return new h.Promise(function(M, Z) {
          var V = F.decompressed.getContentWorker().pipe(new x());
          V.on("error", function(te) {
            Z(te);
          }).on("end", function() {
            V.streamInfo.crc32 !== F.decompressed.crc32 ? Z(new Error("Corrupted zip : CRC32 mismatch")) : M();
          }).resume();
        });
      }
      n.exports = function(F, M) {
        var Z = this;
        return M = o.extend(M || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: c.utf8decode }), B.isNode && B.isStream(F) ? h.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : o.prepareContent("the loaded zip file", F, !0, M.optimizedBinaryString, M.base64).then(function(V) {
          var te = new m(M);
          return te.load(V), te;
        }).then(function(V) {
          var te = [h.Promise.resolve(V)], P = V.files;
          if (M.checkCRC32)
            for (var K = 0; K < P.length; K++)
              te.push(I(P[K]));
          return h.Promise.all(te);
        }).then(function(V) {
          for (var te = V.shift(), P = te.files, K = 0; K < P.length; K++) {
            var J = P[K], le = J.fileNameStr, fe = o.resolve(J.fileNameStr);
            Z.file(fe, J.decompressed, { binary: !0, optimizedBinaryString: !0, date: J.date, dir: J.dir, comment: J.fileCommentStr.length ? J.fileCommentStr : null, unixPermissions: J.unixPermissions, dosPermissions: J.dosPermissions, createFolders: M.createFolders }), J.dir || (Z.file(fe).unsafeOriginalName = le);
          }
          return te.zipComment.length && (Z.comment = te.zipComment), Z;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(t, n, s) {
      var o = t("../utils"), h = t("../stream/GenericWorker");
      function c(m, x) {
        h.call(this, "Nodejs stream input adapter for " + m), this._upstreamEnded = !1, this._bindStream(x);
      }
      o.inherits(c, h), c.prototype._bindStream = function(m) {
        var x = this;
        (this._stream = m).pause(), m.on("data", function(B) {
          x.push({ data: B, meta: { percent: 0 } });
        }).on("error", function(B) {
          x.isPaused ? this.generatedError = B : x.error(B);
        }).on("end", function() {
          x.isPaused ? x._upstreamEnded = !0 : x.end();
        });
      }, c.prototype.pause = function() {
        return !!h.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, c.prototype.resume = function() {
        return !!h.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, n.exports = c;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(t, n, s) {
      var o = t("readable-stream").Readable;
      function h(c, m, x) {
        o.call(this, m), this._helper = c;
        var B = this;
        c.on("data", function(I, F) {
          B.push(I) || B._helper.pause(), x && x(F);
        }).on("error", function(I) {
          B.emit("error", I);
        }).on("end", function() {
          B.push(null);
        });
      }
      t("../utils").inherits(h, o), h.prototype._read = function() {
        this._helper.resume();
      }, n.exports = h;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(t, n, s) {
      n.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(o, h) {
        if (Buffer.from && Buffer.from !== Uint8Array.from)
          return Buffer.from(o, h);
        if (typeof o == "number")
          throw new Error('The "data" argument must not be a number');
        return new Buffer(o, h);
      }, allocBuffer: function(o) {
        if (Buffer.alloc)
          return Buffer.alloc(o);
        var h = new Buffer(o);
        return h.fill(0), h;
      }, isBuffer: function(o) {
        return Buffer.isBuffer(o);
      }, isStream: function(o) {
        return o && typeof o.on == "function" && typeof o.pause == "function" && typeof o.resume == "function";
      } };
    }, {}], 15: [function(t, n, s) {
      function o(fe, X, W) {
        var je, Ee = c.getTypeOf(X), He = c.extend(W || {}, B);
        He.date = He.date || /* @__PURE__ */ new Date(), He.compression !== null && (He.compression = He.compression.toUpperCase()), typeof He.unixPermissions == "string" && (He.unixPermissions = parseInt(He.unixPermissions, 8)), He.unixPermissions && 16384 & He.unixPermissions && (He.dir = !0), He.dosPermissions && 16 & He.dosPermissions && (He.dir = !0), He.dir && (fe = P(fe)), He.createFolders && (je = te(fe)) && K.call(this, je, !0);
        var ft = Ee === "string" && He.binary === !1 && He.base64 === !1;
        W && W.binary !== void 0 || (He.binary = !ft), (X instanceof I && X.uncompressedSize === 0 || He.dir || !X || X.length === 0) && (He.base64 = !1, He.binary = !0, X = "", He.compression = "STORE", Ee = "string");
        var Le = null;
        Le = X instanceof I || X instanceof m ? X : Z.isNode && Z.isStream(X) ? new V(fe, X) : c.prepareContent(fe, X, He.binary, He.optimizedBinaryString, He.base64);
        var $e = new F(fe, Le, He);
        this.files[fe] = $e;
      }
      var h = t("./utf8"), c = t("./utils"), m = t("./stream/GenericWorker"), x = t("./stream/StreamHelper"), B = t("./defaults"), I = t("./compressedObject"), F = t("./zipObject"), M = t("./generate"), Z = t("./nodejsUtils"), V = t("./nodejs/NodejsStreamInputAdapter"), te = function(fe) {
        fe.slice(-1) === "/" && (fe = fe.substring(0, fe.length - 1));
        var X = fe.lastIndexOf("/");
        return 0 < X ? fe.substring(0, X) : "";
      }, P = function(fe) {
        return fe.slice(-1) !== "/" && (fe += "/"), fe;
      }, K = function(fe, X) {
        return X = X !== void 0 ? X : B.createFolders, fe = P(fe), this.files[fe] || o.call(this, fe, null, { dir: !0, createFolders: X }), this.files[fe];
      };
      function J(fe) {
        return Object.prototype.toString.call(fe) === "[object RegExp]";
      }
      var le = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(fe) {
        var X, W, je;
        for (X in this.files)
          je = this.files[X], (W = X.slice(this.root.length, X.length)) && X.slice(0, this.root.length) === this.root && fe(W, je);
      }, filter: function(fe) {
        var X = [];
        return this.forEach(function(W, je) {
          fe(W, je) && X.push(je);
        }), X;
      }, file: function(fe, X, W) {
        if (arguments.length !== 1)
          return fe = this.root + fe, o.call(this, fe, X, W), this;
        if (J(fe)) {
          var je = fe;
          return this.filter(function(He, ft) {
            return !ft.dir && je.test(He);
          });
        }
        var Ee = this.files[this.root + fe];
        return Ee && !Ee.dir ? Ee : null;
      }, folder: function(fe) {
        if (!fe)
          return this;
        if (J(fe))
          return this.filter(function(Ee, He) {
            return He.dir && fe.test(Ee);
          });
        var X = this.root + fe, W = K.call(this, X), je = this.clone();
        return je.root = W.name, je;
      }, remove: function(fe) {
        fe = this.root + fe;
        var X = this.files[fe];
        if (X || (fe.slice(-1) !== "/" && (fe += "/"), X = this.files[fe]), X && !X.dir)
          delete this.files[fe];
        else
          for (var W = this.filter(function(Ee, He) {
            return He.name.slice(0, fe.length) === fe;
          }), je = 0; je < W.length; je++)
            delete this.files[W[je].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(fe) {
        var X, W = {};
        try {
          if ((W = c.extend(fe || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: h.utf8encode })).type = W.type.toLowerCase(), W.compression = W.compression.toUpperCase(), W.type === "binarystring" && (W.type = "string"), !W.type)
            throw new Error("No output type specified.");
          c.checkSupport(W.type), W.platform !== "darwin" && W.platform !== "freebsd" && W.platform !== "linux" && W.platform !== "sunos" || (W.platform = "UNIX"), W.platform === "win32" && (W.platform = "DOS");
          var je = W.comment || this.comment || "";
          X = M.generateWorker(this, W, je);
        } catch (Ee) {
          (X = new m("error")).error(Ee);
        }
        return new x(X, W.type || "string", W.mimeType);
      }, generateAsync: function(fe, X) {
        return this.generateInternalStream(fe).accumulate(X);
      }, generateNodeStream: function(fe, X) {
        return (fe = fe || {}).type || (fe.type = "nodebuffer"), this.generateInternalStream(fe).toNodejsStream(X);
      } };
      n.exports = le;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(t, n, s) {
      n.exports = t("stream");
    }, { stream: void 0 }], 17: [function(t, n, s) {
      var o = t("./DataReader");
      function h(c) {
        o.call(this, c);
        for (var m = 0; m < this.data.length; m++)
          c[m] = 255 & c[m];
      }
      t("../utils").inherits(h, o), h.prototype.byteAt = function(c) {
        return this.data[this.zero + c];
      }, h.prototype.lastIndexOfSignature = function(c) {
        for (var m = c.charCodeAt(0), x = c.charCodeAt(1), B = c.charCodeAt(2), I = c.charCodeAt(3), F = this.length - 4; 0 <= F; --F)
          if (this.data[F] === m && this.data[F + 1] === x && this.data[F + 2] === B && this.data[F + 3] === I)
            return F - this.zero;
        return -1;
      }, h.prototype.readAndCheckSignature = function(c) {
        var m = c.charCodeAt(0), x = c.charCodeAt(1), B = c.charCodeAt(2), I = c.charCodeAt(3), F = this.readData(4);
        return m === F[0] && x === F[1] && B === F[2] && I === F[3];
      }, h.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0)
          return [];
        var m = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, m;
      }, n.exports = h;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(t, n, s) {
      var o = t("../utils");
      function h(c) {
        this.data = c, this.length = c.length, this.index = 0, this.zero = 0;
      }
      h.prototype = { checkOffset: function(c) {
        this.checkIndex(this.index + c);
      }, checkIndex: function(c) {
        if (this.length < this.zero + c || c < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + c + "). Corrupted zip ?");
      }, setIndex: function(c) {
        this.checkIndex(c), this.index = c;
      }, skip: function(c) {
        this.setIndex(this.index + c);
      }, byteAt: function() {
      }, readInt: function(c) {
        var m, x = 0;
        for (this.checkOffset(c), m = this.index + c - 1; m >= this.index; m--)
          x = (x << 8) + this.byteAt(m);
        return this.index += c, x;
      }, readString: function(c) {
        return o.transformTo("string", this.readData(c));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var c = this.readInt(4);
        return new Date(Date.UTC(1980 + (c >> 25 & 127), (c >> 21 & 15) - 1, c >> 16 & 31, c >> 11 & 31, c >> 5 & 63, (31 & c) << 1));
      } }, n.exports = h;
    }, { "../utils": 32 }], 19: [function(t, n, s) {
      var o = t("./Uint8ArrayReader");
      function h(c) {
        o.call(this, c);
      }
      t("../utils").inherits(h, o), h.prototype.readData = function(c) {
        this.checkOffset(c);
        var m = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, m;
      }, n.exports = h;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(t, n, s) {
      var o = t("./DataReader");
      function h(c) {
        o.call(this, c);
      }
      t("../utils").inherits(h, o), h.prototype.byteAt = function(c) {
        return this.data.charCodeAt(this.zero + c);
      }, h.prototype.lastIndexOfSignature = function(c) {
        return this.data.lastIndexOf(c) - this.zero;
      }, h.prototype.readAndCheckSignature = function(c) {
        return c === this.readData(4);
      }, h.prototype.readData = function(c) {
        this.checkOffset(c);
        var m = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, m;
      }, n.exports = h;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(t, n, s) {
      var o = t("./ArrayReader");
      function h(c) {
        o.call(this, c);
      }
      t("../utils").inherits(h, o), h.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0)
          return new Uint8Array(0);
        var m = this.data.subarray(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, m;
      }, n.exports = h;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(t, n, s) {
      var o = t("../utils"), h = t("../support"), c = t("./ArrayReader"), m = t("./StringReader"), x = t("./NodeBufferReader"), B = t("./Uint8ArrayReader");
      n.exports = function(I) {
        var F = o.getTypeOf(I);
        return o.checkSupport(F), F !== "string" || h.uint8array ? F === "nodebuffer" ? new x(I) : h.uint8array ? new B(o.transformTo("uint8array", I)) : new c(o.transformTo("array", I)) : new m(I);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(t, n, s) {
      s.LOCAL_FILE_HEADER = "PK", s.CENTRAL_FILE_HEADER = "PK", s.CENTRAL_DIRECTORY_END = "PK", s.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", s.ZIP64_CENTRAL_DIRECTORY_END = "PK", s.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(t, n, s) {
      var o = t("./GenericWorker"), h = t("../utils");
      function c(m) {
        o.call(this, "ConvertWorker to " + m), this.destType = m;
      }
      h.inherits(c, o), c.prototype.processChunk = function(m) {
        this.push({ data: h.transformTo(this.destType, m.data), meta: m.meta });
      }, n.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(t, n, s) {
      var o = t("./GenericWorker"), h = t("../crc32");
      function c() {
        o.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      t("../utils").inherits(c, o), c.prototype.processChunk = function(m) {
        this.streamInfo.crc32 = h(m.data, this.streamInfo.crc32 || 0), this.push(m);
      }, n.exports = c;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(t, n, s) {
      var o = t("../utils"), h = t("./GenericWorker");
      function c(m) {
        h.call(this, "DataLengthProbe for " + m), this.propName = m, this.withStreamInfo(m, 0);
      }
      o.inherits(c, h), c.prototype.processChunk = function(m) {
        if (m) {
          var x = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = x + m.data.length;
        }
        h.prototype.processChunk.call(this, m);
      }, n.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(t, n, s) {
      var o = t("../utils"), h = t("./GenericWorker");
      function c(m) {
        h.call(this, "DataWorker");
        var x = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, m.then(function(B) {
          x.dataIsReady = !0, x.data = B, x.max = B && B.length || 0, x.type = o.getTypeOf(B), x.isPaused || x._tickAndRepeat();
        }, function(B) {
          x.error(B);
        });
      }
      o.inherits(c, h), c.prototype.cleanUp = function() {
        h.prototype.cleanUp.call(this), this.data = null;
      }, c.prototype.resume = function() {
        return !!h.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, o.delay(this._tickAndRepeat, [], this)), !0);
      }, c.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (o.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, c.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return !1;
        var m = null, x = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            m = this.data.substring(this.index, x);
            break;
          case "uint8array":
            m = this.data.subarray(this.index, x);
            break;
          case "array":
          case "nodebuffer":
            m = this.data.slice(this.index, x);
        }
        return this.index = x, this.push({ data: m, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, n.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(t, n, s) {
      function o(h) {
        this.name = h || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      o.prototype = { push: function(h) {
        this.emit("data", h);
      }, end: function() {
        if (this.isFinished)
          return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (h) {
          this.emit("error", h);
        }
        return !0;
      }, error: function(h) {
        return !this.isFinished && (this.isPaused ? this.generatedError = h : (this.isFinished = !0, this.emit("error", h), this.previous && this.previous.error(h), this.cleanUp()), !0);
      }, on: function(h, c) {
        return this._listeners[h].push(c), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(h, c) {
        if (this._listeners[h])
          for (var m = 0; m < this._listeners[h].length; m++)
            this._listeners[h][m].call(this, c);
      }, pipe: function(h) {
        return h.registerPrevious(this);
      }, registerPrevious: function(h) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = h.streamInfo, this.mergeStreamInfo(), this.previous = h;
        var c = this;
        return h.on("data", function(m) {
          c.processChunk(m);
        }), h.on("end", function() {
          c.end();
        }), h.on("error", function(m) {
          c.error(m);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return !1;
        var h = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), h = !0), this.previous && this.previous.resume(), !h;
      }, flush: function() {
      }, processChunk: function(h) {
        this.push(h);
      }, withStreamInfo: function(h, c) {
        return this.extraStreamInfo[h] = c, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var h in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, h) && (this.streamInfo[h] = this.extraStreamInfo[h]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var h = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + h : h;
      } }, n.exports = o;
    }, {}], 29: [function(t, n, s) {
      var o = t("../utils"), h = t("./ConvertWorker"), c = t("./GenericWorker"), m = t("../base64"), x = t("../support"), B = t("../external"), I = null;
      if (x.nodestream)
        try {
          I = t("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
      function F(Z, V) {
        return new B.Promise(function(te, P) {
          var K = [], J = Z._internalType, le = Z._outputType, fe = Z._mimeType;
          Z.on("data", function(X, W) {
            K.push(X), V && V(W);
          }).on("error", function(X) {
            K = [], P(X);
          }).on("end", function() {
            try {
              var X = function(W, je, Ee) {
                switch (W) {
                  case "blob":
                    return o.newBlob(o.transformTo("arraybuffer", je), Ee);
                  case "base64":
                    return m.encode(je);
                  default:
                    return o.transformTo(W, je);
                }
              }(le, function(W, je) {
                var Ee, He = 0, ft = null, Le = 0;
                for (Ee = 0; Ee < je.length; Ee++)
                  Le += je[Ee].length;
                switch (W) {
                  case "string":
                    return je.join("");
                  case "array":
                    return Array.prototype.concat.apply([], je);
                  case "uint8array":
                    for (ft = new Uint8Array(Le), Ee = 0; Ee < je.length; Ee++)
                      ft.set(je[Ee], He), He += je[Ee].length;
                    return ft;
                  case "nodebuffer":
                    return Buffer.concat(je);
                  default:
                    throw new Error("concat : unsupported type '" + W + "'");
                }
              }(J, K), fe);
              te(X);
            } catch (W) {
              P(W);
            }
            K = [];
          }).resume();
        });
      }
      function M(Z, V, te) {
        var P = V;
        switch (V) {
          case "blob":
          case "arraybuffer":
            P = "uint8array";
            break;
          case "base64":
            P = "string";
        }
        try {
          this._internalType = P, this._outputType = V, this._mimeType = te, o.checkSupport(P), this._worker = Z.pipe(new h(P)), Z.lock();
        } catch (K) {
          this._worker = new c("error"), this._worker.error(K);
        }
      }
      M.prototype = { accumulate: function(Z) {
        return F(this, Z);
      }, on: function(Z, V) {
        var te = this;
        return Z === "data" ? this._worker.on(Z, function(P) {
          V.call(te, P.data, P.meta);
        }) : this._worker.on(Z, function() {
          o.delay(V, arguments, te);
        }), this;
      }, resume: function() {
        return o.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(Z) {
        if (o.checkSupport("nodestream"), this._outputType !== "nodebuffer")
          throw new Error(this._outputType + " is not supported by this method");
        return new I(this, { objectMode: this._outputType !== "nodebuffer" }, Z);
      } }, n.exports = M;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(t, n, s) {
      if (s.base64 = !0, s.array = !0, s.string = !0, s.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", s.nodebuffer = typeof Buffer < "u", s.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u")
        s.blob = !1;
      else {
        var o = new ArrayBuffer(0);
        try {
          s.blob = new Blob([o], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var h = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            h.append(o), s.blob = h.getBlob("application/zip").size === 0;
          } catch {
            s.blob = !1;
          }
        }
      }
      try {
        s.nodestream = !!t("readable-stream").Readable;
      } catch {
        s.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(t, n, s) {
      for (var o = t("./utils"), h = t("./support"), c = t("./nodejsUtils"), m = t("./stream/GenericWorker"), x = new Array(256), B = 0; B < 256; B++)
        x[B] = 252 <= B ? 6 : 248 <= B ? 5 : 240 <= B ? 4 : 224 <= B ? 3 : 192 <= B ? 2 : 1;
      x[254] = x[254] = 1;
      function I() {
        m.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function F() {
        m.call(this, "utf-8 encode");
      }
      s.utf8encode = function(M) {
        return h.nodebuffer ? c.newBufferFrom(M, "utf-8") : function(Z) {
          var V, te, P, K, J, le = Z.length, fe = 0;
          for (K = 0; K < le; K++)
            (64512 & (te = Z.charCodeAt(K))) == 55296 && K + 1 < le && (64512 & (P = Z.charCodeAt(K + 1))) == 56320 && (te = 65536 + (te - 55296 << 10) + (P - 56320), K++), fe += te < 128 ? 1 : te < 2048 ? 2 : te < 65536 ? 3 : 4;
          for (V = h.uint8array ? new Uint8Array(fe) : new Array(fe), K = J = 0; J < fe; K++)
            (64512 & (te = Z.charCodeAt(K))) == 55296 && K + 1 < le && (64512 & (P = Z.charCodeAt(K + 1))) == 56320 && (te = 65536 + (te - 55296 << 10) + (P - 56320), K++), te < 128 ? V[J++] = te : (te < 2048 ? V[J++] = 192 | te >>> 6 : (te < 65536 ? V[J++] = 224 | te >>> 12 : (V[J++] = 240 | te >>> 18, V[J++] = 128 | te >>> 12 & 63), V[J++] = 128 | te >>> 6 & 63), V[J++] = 128 | 63 & te);
          return V;
        }(M);
      }, s.utf8decode = function(M) {
        return h.nodebuffer ? o.transformTo("nodebuffer", M).toString("utf-8") : function(Z) {
          var V, te, P, K, J = Z.length, le = new Array(2 * J);
          for (V = te = 0; V < J; )
            if ((P = Z[V++]) < 128)
              le[te++] = P;
            else if (4 < (K = x[P]))
              le[te++] = 65533, V += K - 1;
            else {
              for (P &= K === 2 ? 31 : K === 3 ? 15 : 7; 1 < K && V < J; )
                P = P << 6 | 63 & Z[V++], K--;
              1 < K ? le[te++] = 65533 : P < 65536 ? le[te++] = P : (P -= 65536, le[te++] = 55296 | P >> 10 & 1023, le[te++] = 56320 | 1023 & P);
            }
          return le.length !== te && (le.subarray ? le = le.subarray(0, te) : le.length = te), o.applyFromCharCode(le);
        }(M = o.transformTo(h.uint8array ? "uint8array" : "array", M));
      }, o.inherits(I, m), I.prototype.processChunk = function(M) {
        var Z = o.transformTo(h.uint8array ? "uint8array" : "array", M.data);
        if (this.leftOver && this.leftOver.length) {
          if (h.uint8array) {
            var V = Z;
            (Z = new Uint8Array(V.length + this.leftOver.length)).set(this.leftOver, 0), Z.set(V, this.leftOver.length);
          } else
            Z = this.leftOver.concat(Z);
          this.leftOver = null;
        }
        var te = function(K, J) {
          var le;
          for ((J = J || K.length) > K.length && (J = K.length), le = J - 1; 0 <= le && (192 & K[le]) == 128; )
            le--;
          return le < 0 || le === 0 ? J : le + x[K[le]] > J ? le : J;
        }(Z), P = Z;
        te !== Z.length && (h.uint8array ? (P = Z.subarray(0, te), this.leftOver = Z.subarray(te, Z.length)) : (P = Z.slice(0, te), this.leftOver = Z.slice(te, Z.length))), this.push({ data: s.utf8decode(P), meta: M.meta });
      }, I.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: s.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, s.Utf8DecodeWorker = I, o.inherits(F, m), F.prototype.processChunk = function(M) {
        this.push({ data: s.utf8encode(M.data), meta: M.meta });
      }, s.Utf8EncodeWorker = F;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(t, n, s) {
      var o = t("./support"), h = t("./base64"), c = t("./nodejsUtils"), m = t("./external");
      function x(V) {
        return V;
      }
      function B(V, te) {
        for (var P = 0; P < V.length; ++P)
          te[P] = 255 & V.charCodeAt(P);
        return te;
      }
      t("setimmediate"), s.newBlob = function(V, te) {
        s.checkSupport("blob");
        try {
          return new Blob([V], { type: te });
        } catch {
          try {
            var P = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return P.append(V), P.getBlob(te);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var I = { stringifyByChunk: function(V, te, P) {
        var K = [], J = 0, le = V.length;
        if (le <= P)
          return String.fromCharCode.apply(null, V);
        for (; J < le; )
          te === "array" || te === "nodebuffer" ? K.push(String.fromCharCode.apply(null, V.slice(J, Math.min(J + P, le)))) : K.push(String.fromCharCode.apply(null, V.subarray(J, Math.min(J + P, le)))), J += P;
        return K.join("");
      }, stringifyByChar: function(V) {
        for (var te = "", P = 0; P < V.length; P++)
          te += String.fromCharCode(V[P]);
        return te;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return o.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return o.nodebuffer && String.fromCharCode.apply(null, c.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function F(V) {
        var te = 65536, P = s.getTypeOf(V), K = !0;
        if (P === "uint8array" ? K = I.applyCanBeUsed.uint8array : P === "nodebuffer" && (K = I.applyCanBeUsed.nodebuffer), K)
          for (; 1 < te; )
            try {
              return I.stringifyByChunk(V, P, te);
            } catch {
              te = Math.floor(te / 2);
            }
        return I.stringifyByChar(V);
      }
      function M(V, te) {
        for (var P = 0; P < V.length; P++)
          te[P] = V[P];
        return te;
      }
      s.applyFromCharCode = F;
      var Z = {};
      Z.string = { string: x, array: function(V) {
        return B(V, new Array(V.length));
      }, arraybuffer: function(V) {
        return Z.string.uint8array(V).buffer;
      }, uint8array: function(V) {
        return B(V, new Uint8Array(V.length));
      }, nodebuffer: function(V) {
        return B(V, c.allocBuffer(V.length));
      } }, Z.array = { string: F, array: x, arraybuffer: function(V) {
        return new Uint8Array(V).buffer;
      }, uint8array: function(V) {
        return new Uint8Array(V);
      }, nodebuffer: function(V) {
        return c.newBufferFrom(V);
      } }, Z.arraybuffer = { string: function(V) {
        return F(new Uint8Array(V));
      }, array: function(V) {
        return M(new Uint8Array(V), new Array(V.byteLength));
      }, arraybuffer: x, uint8array: function(V) {
        return new Uint8Array(V);
      }, nodebuffer: function(V) {
        return c.newBufferFrom(new Uint8Array(V));
      } }, Z.uint8array = { string: F, array: function(V) {
        return M(V, new Array(V.length));
      }, arraybuffer: function(V) {
        return V.buffer;
      }, uint8array: x, nodebuffer: function(V) {
        return c.newBufferFrom(V);
      } }, Z.nodebuffer = { string: F, array: function(V) {
        return M(V, new Array(V.length));
      }, arraybuffer: function(V) {
        return Z.nodebuffer.uint8array(V).buffer;
      }, uint8array: function(V) {
        return M(V, new Uint8Array(V.length));
      }, nodebuffer: x }, s.transformTo = function(V, te) {
        if (te = te || "", !V)
          return te;
        s.checkSupport(V);
        var P = s.getTypeOf(te);
        return Z[P][V](te);
      }, s.resolve = function(V) {
        for (var te = V.split("/"), P = [], K = 0; K < te.length; K++) {
          var J = te[K];
          J === "." || J === "" && K !== 0 && K !== te.length - 1 || (J === ".." ? P.pop() : P.push(J));
        }
        return P.join("/");
      }, s.getTypeOf = function(V) {
        return typeof V == "string" ? "string" : Object.prototype.toString.call(V) === "[object Array]" ? "array" : o.nodebuffer && c.isBuffer(V) ? "nodebuffer" : o.uint8array && V instanceof Uint8Array ? "uint8array" : o.arraybuffer && V instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, s.checkSupport = function(V) {
        if (!o[V.toLowerCase()])
          throw new Error(V + " is not supported by this platform");
      }, s.MAX_VALUE_16BITS = 65535, s.MAX_VALUE_32BITS = -1, s.pretty = function(V) {
        var te, P, K = "";
        for (P = 0; P < (V || "").length; P++)
          K += "\\x" + ((te = V.charCodeAt(P)) < 16 ? "0" : "") + te.toString(16).toUpperCase();
        return K;
      }, s.delay = function(V, te, P) {
        setImmediate(function() {
          V.apply(P || null, te || []);
        });
      }, s.inherits = function(V, te) {
        function P() {
        }
        P.prototype = te.prototype, V.prototype = new P();
      }, s.extend = function() {
        var V, te, P = {};
        for (V = 0; V < arguments.length; V++)
          for (te in arguments[V])
            Object.prototype.hasOwnProperty.call(arguments[V], te) && P[te] === void 0 && (P[te] = arguments[V][te]);
        return P;
      }, s.prepareContent = function(V, te, P, K, J) {
        return m.Promise.resolve(te).then(function(le) {
          return o.blob && (le instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(le)) !== -1) && typeof FileReader < "u" ? new m.Promise(function(fe, X) {
            var W = new FileReader();
            W.onload = function(je) {
              fe(je.target.result);
            }, W.onerror = function(je) {
              X(je.target.error);
            }, W.readAsArrayBuffer(le);
          }) : le;
        }).then(function(le) {
          var fe = s.getTypeOf(le);
          return fe ? (fe === "arraybuffer" ? le = s.transformTo("uint8array", le) : fe === "string" && (J ? le = h.decode(le) : P && K !== !0 && (le = function(X) {
            return B(X, o.uint8array ? new Uint8Array(X.length) : new Array(X.length));
          }(le))), le) : m.Promise.reject(new Error("Can't read the data of '" + V + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(t, n, s) {
      var o = t("./reader/readerFor"), h = t("./utils"), c = t("./signature"), m = t("./zipEntry"), x = t("./support");
      function B(I) {
        this.files = [], this.loadOptions = I;
      }
      B.prototype = { checkSignature: function(I) {
        if (!this.reader.readAndCheckSignature(I)) {
          this.reader.index -= 4;
          var F = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + h.pretty(F) + ", expected " + h.pretty(I) + ")");
        }
      }, isSignature: function(I, F) {
        var M = this.reader.index;
        this.reader.setIndex(I);
        var Z = this.reader.readString(4) === F;
        return this.reader.setIndex(M), Z;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var I = this.reader.readData(this.zipCommentLength), F = x.uint8array ? "uint8array" : "array", M = h.transformTo(F, I);
        this.zipComment = this.loadOptions.decodeFileName(M);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var I, F, M, Z = this.zip64EndOfCentralSize - 44; 0 < Z; )
          I = this.reader.readInt(2), F = this.reader.readInt(4), M = this.reader.readData(F), this.zip64ExtensibleData[I] = { id: I, length: F, value: M };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var I, F;
        for (I = 0; I < this.files.length; I++)
          F = this.files[I], this.reader.setIndex(F.localHeaderOffset), this.checkSignature(c.LOCAL_FILE_HEADER), F.readLocalPart(this.reader), F.handleUTF8(), F.processAttributes();
      }, readCentralDir: function() {
        var I;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(c.CENTRAL_FILE_HEADER); )
          (I = new m({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(I);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var I = this.reader.lastIndexOfSignature(c.CENTRAL_DIRECTORY_END);
        if (I < 0)
          throw this.isSignature(0, c.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(I);
        var F = I;
        if (this.checkSignature(c.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === h.MAX_VALUE_16BITS || this.diskWithCentralDirStart === h.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === h.MAX_VALUE_16BITS || this.centralDirRecords === h.MAX_VALUE_16BITS || this.centralDirSize === h.MAX_VALUE_32BITS || this.centralDirOffset === h.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (I = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(I), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, c.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var M = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (M += 20, M += 12 + this.zip64EndOfCentralSize);
        var Z = F - M;
        if (0 < Z)
          this.isSignature(F, c.CENTRAL_FILE_HEADER) || (this.reader.zero = Z);
        else if (Z < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(Z) + " bytes.");
      }, prepareReader: function(I) {
        this.reader = o(I);
      }, load: function(I) {
        this.prepareReader(I), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, n.exports = B;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(t, n, s) {
      var o = t("./reader/readerFor"), h = t("./utils"), c = t("./compressedObject"), m = t("./crc32"), x = t("./utf8"), B = t("./compressions"), I = t("./support");
      function F(M, Z) {
        this.options = M, this.loadOptions = Z;
      }
      F.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(M) {
        var Z, V;
        if (M.skip(22), this.fileNameLength = M.readInt(2), V = M.readInt(2), this.fileName = M.readData(this.fileNameLength), M.skip(V), this.compressedSize === -1 || this.uncompressedSize === -1)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((Z = function(te) {
          for (var P in B)
            if (Object.prototype.hasOwnProperty.call(B, P) && B[P].magic === te)
              return B[P];
          return null;
        }(this.compressionMethod)) === null)
          throw new Error("Corrupted zip : compression " + h.pretty(this.compressionMethod) + " unknown (inner file : " + h.transformTo("string", this.fileName) + ")");
        this.decompressed = new c(this.compressedSize, this.uncompressedSize, this.crc32, Z, M.readData(this.compressedSize));
      }, readCentralPart: function(M) {
        this.versionMadeBy = M.readInt(2), M.skip(2), this.bitFlag = M.readInt(2), this.compressionMethod = M.readString(2), this.date = M.readDate(), this.crc32 = M.readInt(4), this.compressedSize = M.readInt(4), this.uncompressedSize = M.readInt(4);
        var Z = M.readInt(2);
        if (this.extraFieldsLength = M.readInt(2), this.fileCommentLength = M.readInt(2), this.diskNumberStart = M.readInt(2), this.internalFileAttributes = M.readInt(2), this.externalFileAttributes = M.readInt(4), this.localHeaderOffset = M.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        M.skip(Z), this.readExtraFields(M), this.parseZIP64ExtraField(M), this.fileComment = M.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var M = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), M == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), M == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var M = o(this.extraFields[1].value);
          this.uncompressedSize === h.MAX_VALUE_32BITS && (this.uncompressedSize = M.readInt(8)), this.compressedSize === h.MAX_VALUE_32BITS && (this.compressedSize = M.readInt(8)), this.localHeaderOffset === h.MAX_VALUE_32BITS && (this.localHeaderOffset = M.readInt(8)), this.diskNumberStart === h.MAX_VALUE_32BITS && (this.diskNumberStart = M.readInt(4));
        }
      }, readExtraFields: function(M) {
        var Z, V, te, P = M.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); M.index + 4 < P; )
          Z = M.readInt(2), V = M.readInt(2), te = M.readData(V), this.extraFields[Z] = { id: Z, length: V, value: te };
        M.setIndex(P);
      }, handleUTF8: function() {
        var M = I.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = x.utf8decode(this.fileName), this.fileCommentStr = x.utf8decode(this.fileComment);
        else {
          var Z = this.findExtraFieldUnicodePath();
          if (Z !== null)
            this.fileNameStr = Z;
          else {
            var V = h.transformTo(M, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(V);
          }
          var te = this.findExtraFieldUnicodeComment();
          if (te !== null)
            this.fileCommentStr = te;
          else {
            var P = h.transformTo(M, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(P);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var M = this.extraFields[28789];
        if (M) {
          var Z = o(M.value);
          return Z.readInt(1) !== 1 || m(this.fileName) !== Z.readInt(4) ? null : x.utf8decode(Z.readData(M.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var M = this.extraFields[25461];
        if (M) {
          var Z = o(M.value);
          return Z.readInt(1) !== 1 || m(this.fileComment) !== Z.readInt(4) ? null : x.utf8decode(Z.readData(M.length - 5));
        }
        return null;
      } }, n.exports = F;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(t, n, s) {
      function o(Z, V, te) {
        this.name = Z, this.dir = te.dir, this.date = te.date, this.comment = te.comment, this.unixPermissions = te.unixPermissions, this.dosPermissions = te.dosPermissions, this._data = V, this._dataBinary = te.binary, this.options = { compression: te.compression, compressionOptions: te.compressionOptions };
      }
      var h = t("./stream/StreamHelper"), c = t("./stream/DataWorker"), m = t("./utf8"), x = t("./compressedObject"), B = t("./stream/GenericWorker");
      o.prototype = { internalStream: function(Z) {
        var V = null, te = "string";
        try {
          if (!Z)
            throw new Error("No output type specified.");
          var P = (te = Z.toLowerCase()) === "string" || te === "text";
          te !== "binarystring" && te !== "text" || (te = "string"), V = this._decompressWorker();
          var K = !this._dataBinary;
          K && !P && (V = V.pipe(new m.Utf8EncodeWorker())), !K && P && (V = V.pipe(new m.Utf8DecodeWorker()));
        } catch (J) {
          (V = new B("error")).error(J);
        }
        return new h(V, te, "");
      }, async: function(Z, V) {
        return this.internalStream(Z).accumulate(V);
      }, nodeStream: function(Z, V) {
        return this.internalStream(Z || "nodebuffer").toNodejsStream(V);
      }, _compressWorker: function(Z, V) {
        if (this._data instanceof x && this._data.compression.magic === Z.magic)
          return this._data.getCompressedWorker();
        var te = this._decompressWorker();
        return this._dataBinary || (te = te.pipe(new m.Utf8EncodeWorker())), x.createWorkerFrom(te, Z, V);
      }, _decompressWorker: function() {
        return this._data instanceof x ? this._data.getContentWorker() : this._data instanceof B ? this._data : new c(this._data);
      } };
      for (var I = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], F = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, M = 0; M < I.length; M++)
        o.prototype[I[M]] = F;
      n.exports = o;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(t, n, s) {
      (function(o) {
        var h, c, m = o.MutationObserver || o.WebKitMutationObserver;
        if (m) {
          var x = 0, B = new m(Z), I = o.document.createTextNode("");
          B.observe(I, { characterData: !0 }), h = function() {
            I.data = x = ++x % 2;
          };
        } else if (o.setImmediate || o.MessageChannel === void 0)
          h = "document" in o && "onreadystatechange" in o.document.createElement("script") ? function() {
            var V = o.document.createElement("script");
            V.onreadystatechange = function() {
              Z(), V.onreadystatechange = null, V.parentNode.removeChild(V), V = null;
            }, o.document.documentElement.appendChild(V);
          } : function() {
            setTimeout(Z, 0);
          };
        else {
          var F = new o.MessageChannel();
          F.port1.onmessage = Z, h = function() {
            F.port2.postMessage(0);
          };
        }
        var M = [];
        function Z() {
          var V, te;
          c = !0;
          for (var P = M.length; P; ) {
            for (te = M, M = [], V = -1; ++V < P; )
              te[V]();
            P = M.length;
          }
          c = !1;
        }
        n.exports = function(V) {
          M.push(V) !== 1 || c || h();
        };
      }).call(this, typeof as < "u" ? as : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(t, n, s) {
      var o = t("immediate");
      function h() {
      }
      var c = {}, m = ["REJECTED"], x = ["FULFILLED"], B = ["PENDING"];
      function I(P) {
        if (typeof P != "function")
          throw new TypeError("resolver must be a function");
        this.state = B, this.queue = [], this.outcome = void 0, P !== h && V(this, P);
      }
      function F(P, K, J) {
        this.promise = P, typeof K == "function" && (this.onFulfilled = K, this.callFulfilled = this.otherCallFulfilled), typeof J == "function" && (this.onRejected = J, this.callRejected = this.otherCallRejected);
      }
      function M(P, K, J) {
        o(function() {
          var le;
          try {
            le = K(J);
          } catch (fe) {
            return c.reject(P, fe);
          }
          le === P ? c.reject(P, new TypeError("Cannot resolve promise with itself")) : c.resolve(P, le);
        });
      }
      function Z(P) {
        var K = P && P.then;
        if (P && (typeof P == "object" || typeof P == "function") && typeof K == "function")
          return function() {
            K.apply(P, arguments);
          };
      }
      function V(P, K) {
        var J = !1;
        function le(W) {
          J || (J = !0, c.reject(P, W));
        }
        function fe(W) {
          J || (J = !0, c.resolve(P, W));
        }
        var X = te(function() {
          K(fe, le);
        });
        X.status === "error" && le(X.value);
      }
      function te(P, K) {
        var J = {};
        try {
          J.value = P(K), J.status = "success";
        } catch (le) {
          J.status = "error", J.value = le;
        }
        return J;
      }
      (n.exports = I).prototype.finally = function(P) {
        if (typeof P != "function")
          return this;
        var K = this.constructor;
        return this.then(function(J) {
          return K.resolve(P()).then(function() {
            return J;
          });
        }, function(J) {
          return K.resolve(P()).then(function() {
            throw J;
          });
        });
      }, I.prototype.catch = function(P) {
        return this.then(null, P);
      }, I.prototype.then = function(P, K) {
        if (typeof P != "function" && this.state === x || typeof K != "function" && this.state === m)
          return this;
        var J = new this.constructor(h);
        return this.state !== B ? M(J, this.state === x ? P : K, this.outcome) : this.queue.push(new F(J, P, K)), J;
      }, F.prototype.callFulfilled = function(P) {
        c.resolve(this.promise, P);
      }, F.prototype.otherCallFulfilled = function(P) {
        M(this.promise, this.onFulfilled, P);
      }, F.prototype.callRejected = function(P) {
        c.reject(this.promise, P);
      }, F.prototype.otherCallRejected = function(P) {
        M(this.promise, this.onRejected, P);
      }, c.resolve = function(P, K) {
        var J = te(Z, K);
        if (J.status === "error")
          return c.reject(P, J.value);
        var le = J.value;
        if (le)
          V(P, le);
        else {
          P.state = x, P.outcome = K;
          for (var fe = -1, X = P.queue.length; ++fe < X; )
            P.queue[fe].callFulfilled(K);
        }
        return P;
      }, c.reject = function(P, K) {
        P.state = m, P.outcome = K;
        for (var J = -1, le = P.queue.length; ++J < le; )
          P.queue[J].callRejected(K);
        return P;
      }, I.resolve = function(P) {
        return P instanceof this ? P : c.resolve(new this(h), P);
      }, I.reject = function(P) {
        var K = new this(h);
        return c.reject(K, P);
      }, I.all = function(P) {
        var K = this;
        if (Object.prototype.toString.call(P) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var J = P.length, le = !1;
        if (!J)
          return this.resolve([]);
        for (var fe = new Array(J), X = 0, W = -1, je = new this(h); ++W < J; )
          Ee(P[W], W);
        return je;
        function Ee(He, ft) {
          K.resolve(He).then(function(Le) {
            fe[ft] = Le, ++X !== J || le || (le = !0, c.resolve(je, fe));
          }, function(Le) {
            le || (le = !0, c.reject(je, Le));
          });
        }
      }, I.race = function(P) {
        var K = this;
        if (Object.prototype.toString.call(P) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var J = P.length, le = !1;
        if (!J)
          return this.resolve([]);
        for (var fe = -1, X = new this(h); ++fe < J; )
          W = P[fe], K.resolve(W).then(function(je) {
            le || (le = !0, c.resolve(X, je));
          }, function(je) {
            le || (le = !0, c.reject(X, je));
          });
        var W;
        return X;
      };
    }, { immediate: 36 }], 38: [function(t, n, s) {
      var o = {};
      (0, t("./lib/utils/common").assign)(o, t("./lib/deflate"), t("./lib/inflate"), t("./lib/zlib/constants")), n.exports = o;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(t, n, s) {
      var o = t("./zlib/deflate"), h = t("./utils/common"), c = t("./utils/strings"), m = t("./zlib/messages"), x = t("./zlib/zstream"), B = Object.prototype.toString, I = 0, F = -1, M = 0, Z = 8;
      function V(P) {
        if (!(this instanceof V))
          return new V(P);
        this.options = h.assign({ level: F, method: Z, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: M, to: "" }, P || {});
        var K = this.options;
        K.raw && 0 < K.windowBits ? K.windowBits = -K.windowBits : K.gzip && 0 < K.windowBits && K.windowBits < 16 && (K.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new x(), this.strm.avail_out = 0;
        var J = o.deflateInit2(this.strm, K.level, K.method, K.windowBits, K.memLevel, K.strategy);
        if (J !== I)
          throw new Error(m[J]);
        if (K.header && o.deflateSetHeader(this.strm, K.header), K.dictionary) {
          var le;
          if (le = typeof K.dictionary == "string" ? c.string2buf(K.dictionary) : B.call(K.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(K.dictionary) : K.dictionary, (J = o.deflateSetDictionary(this.strm, le)) !== I)
            throw new Error(m[J]);
          this._dict_set = !0;
        }
      }
      function te(P, K) {
        var J = new V(K);
        if (J.push(P, !0), J.err)
          throw J.msg || m[J.err];
        return J.result;
      }
      V.prototype.push = function(P, K) {
        var J, le, fe = this.strm, X = this.options.chunkSize;
        if (this.ended)
          return !1;
        le = K === ~~K ? K : K === !0 ? 4 : 0, typeof P == "string" ? fe.input = c.string2buf(P) : B.call(P) === "[object ArrayBuffer]" ? fe.input = new Uint8Array(P) : fe.input = P, fe.next_in = 0, fe.avail_in = fe.input.length;
        do {
          if (fe.avail_out === 0 && (fe.output = new h.Buf8(X), fe.next_out = 0, fe.avail_out = X), (J = o.deflate(fe, le)) !== 1 && J !== I)
            return this.onEnd(J), !(this.ended = !0);
          fe.avail_out !== 0 && (fe.avail_in !== 0 || le !== 4 && le !== 2) || (this.options.to === "string" ? this.onData(c.buf2binstring(h.shrinkBuf(fe.output, fe.next_out))) : this.onData(h.shrinkBuf(fe.output, fe.next_out)));
        } while ((0 < fe.avail_in || fe.avail_out === 0) && J !== 1);
        return le === 4 ? (J = o.deflateEnd(this.strm), this.onEnd(J), this.ended = !0, J === I) : le !== 2 || (this.onEnd(I), !(fe.avail_out = 0));
      }, V.prototype.onData = function(P) {
        this.chunks.push(P);
      }, V.prototype.onEnd = function(P) {
        P === I && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = h.flattenChunks(this.chunks)), this.chunks = [], this.err = P, this.msg = this.strm.msg;
      }, s.Deflate = V, s.deflate = te, s.deflateRaw = function(P, K) {
        return (K = K || {}).raw = !0, te(P, K);
      }, s.gzip = function(P, K) {
        return (K = K || {}).gzip = !0, te(P, K);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(t, n, s) {
      var o = t("./zlib/inflate"), h = t("./utils/common"), c = t("./utils/strings"), m = t("./zlib/constants"), x = t("./zlib/messages"), B = t("./zlib/zstream"), I = t("./zlib/gzheader"), F = Object.prototype.toString;
      function M(V) {
        if (!(this instanceof M))
          return new M(V);
        this.options = h.assign({ chunkSize: 16384, windowBits: 0, to: "" }, V || {});
        var te = this.options;
        te.raw && 0 <= te.windowBits && te.windowBits < 16 && (te.windowBits = -te.windowBits, te.windowBits === 0 && (te.windowBits = -15)), !(0 <= te.windowBits && te.windowBits < 16) || V && V.windowBits || (te.windowBits += 32), 15 < te.windowBits && te.windowBits < 48 && !(15 & te.windowBits) && (te.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new B(), this.strm.avail_out = 0;
        var P = o.inflateInit2(this.strm, te.windowBits);
        if (P !== m.Z_OK)
          throw new Error(x[P]);
        this.header = new I(), o.inflateGetHeader(this.strm, this.header);
      }
      function Z(V, te) {
        var P = new M(te);
        if (P.push(V, !0), P.err)
          throw P.msg || x[P.err];
        return P.result;
      }
      M.prototype.push = function(V, te) {
        var P, K, J, le, fe, X, W = this.strm, je = this.options.chunkSize, Ee = this.options.dictionary, He = !1;
        if (this.ended)
          return !1;
        K = te === ~~te ? te : te === !0 ? m.Z_FINISH : m.Z_NO_FLUSH, typeof V == "string" ? W.input = c.binstring2buf(V) : F.call(V) === "[object ArrayBuffer]" ? W.input = new Uint8Array(V) : W.input = V, W.next_in = 0, W.avail_in = W.input.length;
        do {
          if (W.avail_out === 0 && (W.output = new h.Buf8(je), W.next_out = 0, W.avail_out = je), (P = o.inflate(W, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && Ee && (X = typeof Ee == "string" ? c.string2buf(Ee) : F.call(Ee) === "[object ArrayBuffer]" ? new Uint8Array(Ee) : Ee, P = o.inflateSetDictionary(this.strm, X)), P === m.Z_BUF_ERROR && He === !0 && (P = m.Z_OK, He = !1), P !== m.Z_STREAM_END && P !== m.Z_OK)
            return this.onEnd(P), !(this.ended = !0);
          W.next_out && (W.avail_out !== 0 && P !== m.Z_STREAM_END && (W.avail_in !== 0 || K !== m.Z_FINISH && K !== m.Z_SYNC_FLUSH) || (this.options.to === "string" ? (J = c.utf8border(W.output, W.next_out), le = W.next_out - J, fe = c.buf2string(W.output, J), W.next_out = le, W.avail_out = je - le, le && h.arraySet(W.output, W.output, J, le, 0), this.onData(fe)) : this.onData(h.shrinkBuf(W.output, W.next_out)))), W.avail_in === 0 && W.avail_out === 0 && (He = !0);
        } while ((0 < W.avail_in || W.avail_out === 0) && P !== m.Z_STREAM_END);
        return P === m.Z_STREAM_END && (K = m.Z_FINISH), K === m.Z_FINISH ? (P = o.inflateEnd(this.strm), this.onEnd(P), this.ended = !0, P === m.Z_OK) : K !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), !(W.avail_out = 0));
      }, M.prototype.onData = function(V) {
        this.chunks.push(V);
      }, M.prototype.onEnd = function(V) {
        V === m.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = h.flattenChunks(this.chunks)), this.chunks = [], this.err = V, this.msg = this.strm.msg;
      }, s.Inflate = M, s.inflate = Z, s.inflateRaw = function(V, te) {
        return (te = te || {}).raw = !0, Z(V, te);
      }, s.ungzip = Z;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(t, n, s) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      s.assign = function(m) {
        for (var x = Array.prototype.slice.call(arguments, 1); x.length; ) {
          var B = x.shift();
          if (B) {
            if (typeof B != "object")
              throw new TypeError(B + "must be non-object");
            for (var I in B)
              B.hasOwnProperty(I) && (m[I] = B[I]);
          }
        }
        return m;
      }, s.shrinkBuf = function(m, x) {
        return m.length === x ? m : m.subarray ? m.subarray(0, x) : (m.length = x, m);
      };
      var h = { arraySet: function(m, x, B, I, F) {
        if (x.subarray && m.subarray)
          m.set(x.subarray(B, B + I), F);
        else
          for (var M = 0; M < I; M++)
            m[F + M] = x[B + M];
      }, flattenChunks: function(m) {
        var x, B, I, F, M, Z;
        for (x = I = 0, B = m.length; x < B; x++)
          I += m[x].length;
        for (Z = new Uint8Array(I), x = F = 0, B = m.length; x < B; x++)
          M = m[x], Z.set(M, F), F += M.length;
        return Z;
      } }, c = { arraySet: function(m, x, B, I, F) {
        for (var M = 0; M < I; M++)
          m[F + M] = x[B + M];
      }, flattenChunks: function(m) {
        return [].concat.apply([], m);
      } };
      s.setTyped = function(m) {
        m ? (s.Buf8 = Uint8Array, s.Buf16 = Uint16Array, s.Buf32 = Int32Array, s.assign(s, h)) : (s.Buf8 = Array, s.Buf16 = Array, s.Buf32 = Array, s.assign(s, c));
      }, s.setTyped(o);
    }, {}], 42: [function(t, n, s) {
      var o = t("./common"), h = !0, c = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        h = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        c = !1;
      }
      for (var m = new o.Buf8(256), x = 0; x < 256; x++)
        m[x] = 252 <= x ? 6 : 248 <= x ? 5 : 240 <= x ? 4 : 224 <= x ? 3 : 192 <= x ? 2 : 1;
      function B(I, F) {
        if (F < 65537 && (I.subarray && c || !I.subarray && h))
          return String.fromCharCode.apply(null, o.shrinkBuf(I, F));
        for (var M = "", Z = 0; Z < F; Z++)
          M += String.fromCharCode(I[Z]);
        return M;
      }
      m[254] = m[254] = 1, s.string2buf = function(I) {
        var F, M, Z, V, te, P = I.length, K = 0;
        for (V = 0; V < P; V++)
          (64512 & (M = I.charCodeAt(V))) == 55296 && V + 1 < P && (64512 & (Z = I.charCodeAt(V + 1))) == 56320 && (M = 65536 + (M - 55296 << 10) + (Z - 56320), V++), K += M < 128 ? 1 : M < 2048 ? 2 : M < 65536 ? 3 : 4;
        for (F = new o.Buf8(K), V = te = 0; te < K; V++)
          (64512 & (M = I.charCodeAt(V))) == 55296 && V + 1 < P && (64512 & (Z = I.charCodeAt(V + 1))) == 56320 && (M = 65536 + (M - 55296 << 10) + (Z - 56320), V++), M < 128 ? F[te++] = M : (M < 2048 ? F[te++] = 192 | M >>> 6 : (M < 65536 ? F[te++] = 224 | M >>> 12 : (F[te++] = 240 | M >>> 18, F[te++] = 128 | M >>> 12 & 63), F[te++] = 128 | M >>> 6 & 63), F[te++] = 128 | 63 & M);
        return F;
      }, s.buf2binstring = function(I) {
        return B(I, I.length);
      }, s.binstring2buf = function(I) {
        for (var F = new o.Buf8(I.length), M = 0, Z = F.length; M < Z; M++)
          F[M] = I.charCodeAt(M);
        return F;
      }, s.buf2string = function(I, F) {
        var M, Z, V, te, P = F || I.length, K = new Array(2 * P);
        for (M = Z = 0; M < P; )
          if ((V = I[M++]) < 128)
            K[Z++] = V;
          else if (4 < (te = m[V]))
            K[Z++] = 65533, M += te - 1;
          else {
            for (V &= te === 2 ? 31 : te === 3 ? 15 : 7; 1 < te && M < P; )
              V = V << 6 | 63 & I[M++], te--;
            1 < te ? K[Z++] = 65533 : V < 65536 ? K[Z++] = V : (V -= 65536, K[Z++] = 55296 | V >> 10 & 1023, K[Z++] = 56320 | 1023 & V);
          }
        return B(K, Z);
      }, s.utf8border = function(I, F) {
        var M;
        for ((F = F || I.length) > I.length && (F = I.length), M = F - 1; 0 <= M && (192 & I[M]) == 128; )
          M--;
        return M < 0 || M === 0 ? F : M + m[I[M]] > F ? M : F;
      };
    }, { "./common": 41 }], 43: [function(t, n, s) {
      n.exports = function(o, h, c, m) {
        for (var x = 65535 & o | 0, B = o >>> 16 & 65535 | 0, I = 0; c !== 0; ) {
          for (c -= I = 2e3 < c ? 2e3 : c; B = B + (x = x + h[m++] | 0) | 0, --I; )
            ;
          x %= 65521, B %= 65521;
        }
        return x | B << 16 | 0;
      };
    }, {}], 44: [function(t, n, s) {
      n.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(t, n, s) {
      var o = function() {
        for (var h, c = [], m = 0; m < 256; m++) {
          h = m;
          for (var x = 0; x < 8; x++)
            h = 1 & h ? 3988292384 ^ h >>> 1 : h >>> 1;
          c[m] = h;
        }
        return c;
      }();
      n.exports = function(h, c, m, x) {
        var B = o, I = x + m;
        h ^= -1;
        for (var F = x; F < I; F++)
          h = h >>> 8 ^ B[255 & (h ^ c[F])];
        return -1 ^ h;
      };
    }, {}], 46: [function(t, n, s) {
      var o, h = t("../utils/common"), c = t("./trees"), m = t("./adler32"), x = t("./crc32"), B = t("./messages"), I = 0, F = 4, M = 0, Z = -2, V = -1, te = 4, P = 2, K = 8, J = 9, le = 286, fe = 30, X = 19, W = 2 * le + 1, je = 15, Ee = 3, He = 258, ft = He + Ee + 1, Le = 42, $e = 113, ce = 1, ut = 2, ze = 3, pt = 4;
      function qt(pe, xt) {
        return pe.msg = B[xt], xt;
      }
      function We(pe) {
        return (pe << 1) - (4 < pe ? 9 : 0);
      }
      function Et(pe) {
        for (var xt = pe.length; 0 <= --xt; )
          pe[xt] = 0;
      }
      function rt(pe) {
        var xt = pe.state, tt = xt.pending;
        tt > pe.avail_out && (tt = pe.avail_out), tt !== 0 && (h.arraySet(pe.output, xt.pending_buf, xt.pending_out, tt, pe.next_out), pe.next_out += tt, xt.pending_out += tt, pe.total_out += tt, pe.avail_out -= tt, xt.pending -= tt, xt.pending === 0 && (xt.pending_out = 0));
      }
      function it(pe, xt) {
        c._tr_flush_block(pe, 0 <= pe.block_start ? pe.block_start : -1, pe.strstart - pe.block_start, xt), pe.block_start = pe.strstart, rt(pe.strm);
      }
      function Zt(pe, xt) {
        pe.pending_buf[pe.pending++] = xt;
      }
      function $t(pe, xt) {
        pe.pending_buf[pe.pending++] = xt >>> 8 & 255, pe.pending_buf[pe.pending++] = 255 & xt;
      }
      function Lt(pe, xt) {
        var tt, Pe, ke = pe.max_chain_length, Je = pe.strstart, kt = pe.prev_length, vt = pe.nice_match, Qe = pe.strstart > pe.w_size - ft ? pe.strstart - (pe.w_size - ft) : 0, wt = pe.window, Yt = pe.w_mask, Ye = pe.prev, i = pe.strstart + He, r = wt[Je + kt - 1], a = wt[Je + kt];
        pe.prev_length >= pe.good_match && (ke >>= 2), vt > pe.lookahead && (vt = pe.lookahead);
        do
          if (wt[(tt = xt) + kt] === a && wt[tt + kt - 1] === r && wt[tt] === wt[Je] && wt[++tt] === wt[Je + 1]) {
            Je += 2, tt++;
            do
              ;
            while (wt[++Je] === wt[++tt] && wt[++Je] === wt[++tt] && wt[++Je] === wt[++tt] && wt[++Je] === wt[++tt] && wt[++Je] === wt[++tt] && wt[++Je] === wt[++tt] && wt[++Je] === wt[++tt] && wt[++Je] === wt[++tt] && Je < i);
            if (Pe = He - (i - Je), Je = i - He, kt < Pe) {
              if (pe.match_start = xt, vt <= (kt = Pe))
                break;
              r = wt[Je + kt - 1], a = wt[Je + kt];
            }
          }
        while ((xt = Ye[xt & Yt]) > Qe && --ke != 0);
        return kt <= pe.lookahead ? kt : pe.lookahead;
      }
      function ii(pe) {
        var xt, tt, Pe, ke, Je, kt, vt, Qe, wt, Yt, Ye = pe.w_size;
        do {
          if (ke = pe.window_size - pe.lookahead - pe.strstart, pe.strstart >= Ye + (Ye - ft)) {
            for (h.arraySet(pe.window, pe.window, Ye, Ye, 0), pe.match_start -= Ye, pe.strstart -= Ye, pe.block_start -= Ye, xt = tt = pe.hash_size; Pe = pe.head[--xt], pe.head[xt] = Ye <= Pe ? Pe - Ye : 0, --tt; )
              ;
            for (xt = tt = Ye; Pe = pe.prev[--xt], pe.prev[xt] = Ye <= Pe ? Pe - Ye : 0, --tt; )
              ;
            ke += Ye;
          }
          if (pe.strm.avail_in === 0)
            break;
          if (kt = pe.strm, vt = pe.window, Qe = pe.strstart + pe.lookahead, wt = ke, Yt = void 0, Yt = kt.avail_in, wt < Yt && (Yt = wt), tt = Yt === 0 ? 0 : (kt.avail_in -= Yt, h.arraySet(vt, kt.input, kt.next_in, Yt, Qe), kt.state.wrap === 1 ? kt.adler = m(kt.adler, vt, Yt, Qe) : kt.state.wrap === 2 && (kt.adler = x(kt.adler, vt, Yt, Qe)), kt.next_in += Yt, kt.total_in += Yt, Yt), pe.lookahead += tt, pe.lookahead + pe.insert >= Ee)
            for (Je = pe.strstart - pe.insert, pe.ins_h = pe.window[Je], pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[Je + 1]) & pe.hash_mask; pe.insert && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[Je + Ee - 1]) & pe.hash_mask, pe.prev[Je & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = Je, Je++, pe.insert--, !(pe.lookahead + pe.insert < Ee)); )
              ;
        } while (pe.lookahead < ft && pe.strm.avail_in !== 0);
      }
      function Ci(pe, xt) {
        for (var tt, Pe; ; ) {
          if (pe.lookahead < ft) {
            if (ii(pe), pe.lookahead < ft && xt === I)
              return ce;
            if (pe.lookahead === 0)
              break;
          }
          if (tt = 0, pe.lookahead >= Ee && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + Ee - 1]) & pe.hash_mask, tt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), tt !== 0 && pe.strstart - tt <= pe.w_size - ft && (pe.match_length = Lt(pe, tt)), pe.match_length >= Ee)
            if (Pe = c._tr_tally(pe, pe.strstart - pe.match_start, pe.match_length - Ee), pe.lookahead -= pe.match_length, pe.match_length <= pe.max_lazy_match && pe.lookahead >= Ee) {
              for (pe.match_length--; pe.strstart++, pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + Ee - 1]) & pe.hash_mask, tt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart, --pe.match_length != 0; )
                ;
              pe.strstart++;
            } else
              pe.strstart += pe.match_length, pe.match_length = 0, pe.ins_h = pe.window[pe.strstart], pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + 1]) & pe.hash_mask;
          else
            Pe = c._tr_tally(pe, 0, pe.window[pe.strstart]), pe.lookahead--, pe.strstart++;
          if (Pe && (it(pe, !1), pe.strm.avail_out === 0))
            return ce;
        }
        return pe.insert = pe.strstart < Ee - 1 ? pe.strstart : Ee - 1, xt === F ? (it(pe, !0), pe.strm.avail_out === 0 ? ze : pt) : pe.last_lit && (it(pe, !1), pe.strm.avail_out === 0) ? ce : ut;
      }
      function ui(pe, xt) {
        for (var tt, Pe, ke; ; ) {
          if (pe.lookahead < ft) {
            if (ii(pe), pe.lookahead < ft && xt === I)
              return ce;
            if (pe.lookahead === 0)
              break;
          }
          if (tt = 0, pe.lookahead >= Ee && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + Ee - 1]) & pe.hash_mask, tt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), pe.prev_length = pe.match_length, pe.prev_match = pe.match_start, pe.match_length = Ee - 1, tt !== 0 && pe.prev_length < pe.max_lazy_match && pe.strstart - tt <= pe.w_size - ft && (pe.match_length = Lt(pe, tt), pe.match_length <= 5 && (pe.strategy === 1 || pe.match_length === Ee && 4096 < pe.strstart - pe.match_start) && (pe.match_length = Ee - 1)), pe.prev_length >= Ee && pe.match_length <= pe.prev_length) {
            for (ke = pe.strstart + pe.lookahead - Ee, Pe = c._tr_tally(pe, pe.strstart - 1 - pe.prev_match, pe.prev_length - Ee), pe.lookahead -= pe.prev_length - 1, pe.prev_length -= 2; ++pe.strstart <= ke && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + Ee - 1]) & pe.hash_mask, tt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), --pe.prev_length != 0; )
              ;
            if (pe.match_available = 0, pe.match_length = Ee - 1, pe.strstart++, Pe && (it(pe, !1), pe.strm.avail_out === 0))
              return ce;
          } else if (pe.match_available) {
            if ((Pe = c._tr_tally(pe, 0, pe.window[pe.strstart - 1])) && it(pe, !1), pe.strstart++, pe.lookahead--, pe.strm.avail_out === 0)
              return ce;
          } else
            pe.match_available = 1, pe.strstart++, pe.lookahead--;
        }
        return pe.match_available && (Pe = c._tr_tally(pe, 0, pe.window[pe.strstart - 1]), pe.match_available = 0), pe.insert = pe.strstart < Ee - 1 ? pe.strstart : Ee - 1, xt === F ? (it(pe, !0), pe.strm.avail_out === 0 ? ze : pt) : pe.last_lit && (it(pe, !1), pe.strm.avail_out === 0) ? ce : ut;
      }
      function Gt(pe, xt, tt, Pe, ke) {
        this.good_length = pe, this.max_lazy = xt, this.nice_length = tt, this.max_chain = Pe, this.func = ke;
      }
      function Xt() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = K, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new h.Buf16(2 * W), this.dyn_dtree = new h.Buf16(2 * (2 * fe + 1)), this.bl_tree = new h.Buf16(2 * (2 * X + 1)), Et(this.dyn_ltree), Et(this.dyn_dtree), Et(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new h.Buf16(je + 1), this.heap = new h.Buf16(2 * le + 1), Et(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new h.Buf16(2 * le + 1), Et(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function Qt(pe) {
        var xt;
        return pe && pe.state ? (pe.total_in = pe.total_out = 0, pe.data_type = P, (xt = pe.state).pending = 0, xt.pending_out = 0, xt.wrap < 0 && (xt.wrap = -xt.wrap), xt.status = xt.wrap ? Le : $e, pe.adler = xt.wrap === 2 ? 0 : 1, xt.last_flush = I, c._tr_init(xt), M) : qt(pe, Z);
      }
      function Ni(pe) {
        var xt = Qt(pe);
        return xt === M && function(tt) {
          tt.window_size = 2 * tt.w_size, Et(tt.head), tt.max_lazy_match = o[tt.level].max_lazy, tt.good_match = o[tt.level].good_length, tt.nice_match = o[tt.level].nice_length, tt.max_chain_length = o[tt.level].max_chain, tt.strstart = 0, tt.block_start = 0, tt.lookahead = 0, tt.insert = 0, tt.match_length = tt.prev_length = Ee - 1, tt.match_available = 0, tt.ins_h = 0;
        }(pe.state), xt;
      }
      function Di(pe, xt, tt, Pe, ke, Je) {
        if (!pe)
          return Z;
        var kt = 1;
        if (xt === V && (xt = 6), Pe < 0 ? (kt = 0, Pe = -Pe) : 15 < Pe && (kt = 2, Pe -= 16), ke < 1 || J < ke || tt !== K || Pe < 8 || 15 < Pe || xt < 0 || 9 < xt || Je < 0 || te < Je)
          return qt(pe, Z);
        Pe === 8 && (Pe = 9);
        var vt = new Xt();
        return (pe.state = vt).strm = pe, vt.wrap = kt, vt.gzhead = null, vt.w_bits = Pe, vt.w_size = 1 << vt.w_bits, vt.w_mask = vt.w_size - 1, vt.hash_bits = ke + 7, vt.hash_size = 1 << vt.hash_bits, vt.hash_mask = vt.hash_size - 1, vt.hash_shift = ~~((vt.hash_bits + Ee - 1) / Ee), vt.window = new h.Buf8(2 * vt.w_size), vt.head = new h.Buf16(vt.hash_size), vt.prev = new h.Buf16(vt.w_size), vt.lit_bufsize = 1 << ke + 6, vt.pending_buf_size = 4 * vt.lit_bufsize, vt.pending_buf = new h.Buf8(vt.pending_buf_size), vt.d_buf = 1 * vt.lit_bufsize, vt.l_buf = 3 * vt.lit_bufsize, vt.level = xt, vt.strategy = Je, vt.method = tt, Ni(pe);
      }
      o = [new Gt(0, 0, 0, 0, function(pe, xt) {
        var tt = 65535;
        for (tt > pe.pending_buf_size - 5 && (tt = pe.pending_buf_size - 5); ; ) {
          if (pe.lookahead <= 1) {
            if (ii(pe), pe.lookahead === 0 && xt === I)
              return ce;
            if (pe.lookahead === 0)
              break;
          }
          pe.strstart += pe.lookahead, pe.lookahead = 0;
          var Pe = pe.block_start + tt;
          if ((pe.strstart === 0 || pe.strstart >= Pe) && (pe.lookahead = pe.strstart - Pe, pe.strstart = Pe, it(pe, !1), pe.strm.avail_out === 0) || pe.strstart - pe.block_start >= pe.w_size - ft && (it(pe, !1), pe.strm.avail_out === 0))
            return ce;
        }
        return pe.insert = 0, xt === F ? (it(pe, !0), pe.strm.avail_out === 0 ? ze : pt) : (pe.strstart > pe.block_start && (it(pe, !1), pe.strm.avail_out), ce);
      }), new Gt(4, 4, 8, 4, Ci), new Gt(4, 5, 16, 8, Ci), new Gt(4, 6, 32, 32, Ci), new Gt(4, 4, 16, 16, ui), new Gt(8, 16, 32, 32, ui), new Gt(8, 16, 128, 128, ui), new Gt(8, 32, 128, 256, ui), new Gt(32, 128, 258, 1024, ui), new Gt(32, 258, 258, 4096, ui)], s.deflateInit = function(pe, xt) {
        return Di(pe, xt, K, 15, 8, 0);
      }, s.deflateInit2 = Di, s.deflateReset = Ni, s.deflateResetKeep = Qt, s.deflateSetHeader = function(pe, xt) {
        return pe && pe.state ? pe.state.wrap !== 2 ? Z : (pe.state.gzhead = xt, M) : Z;
      }, s.deflate = function(pe, xt) {
        var tt, Pe, ke, Je;
        if (!pe || !pe.state || 5 < xt || xt < 0)
          return pe ? qt(pe, Z) : Z;
        if (Pe = pe.state, !pe.output || !pe.input && pe.avail_in !== 0 || Pe.status === 666 && xt !== F)
          return qt(pe, pe.avail_out === 0 ? -5 : Z);
        if (Pe.strm = pe, tt = Pe.last_flush, Pe.last_flush = xt, Pe.status === Le)
          if (Pe.wrap === 2)
            pe.adler = 0, Zt(Pe, 31), Zt(Pe, 139), Zt(Pe, 8), Pe.gzhead ? (Zt(Pe, (Pe.gzhead.text ? 1 : 0) + (Pe.gzhead.hcrc ? 2 : 0) + (Pe.gzhead.extra ? 4 : 0) + (Pe.gzhead.name ? 8 : 0) + (Pe.gzhead.comment ? 16 : 0)), Zt(Pe, 255 & Pe.gzhead.time), Zt(Pe, Pe.gzhead.time >> 8 & 255), Zt(Pe, Pe.gzhead.time >> 16 & 255), Zt(Pe, Pe.gzhead.time >> 24 & 255), Zt(Pe, Pe.level === 9 ? 2 : 2 <= Pe.strategy || Pe.level < 2 ? 4 : 0), Zt(Pe, 255 & Pe.gzhead.os), Pe.gzhead.extra && Pe.gzhead.extra.length && (Zt(Pe, 255 & Pe.gzhead.extra.length), Zt(Pe, Pe.gzhead.extra.length >> 8 & 255)), Pe.gzhead.hcrc && (pe.adler = x(pe.adler, Pe.pending_buf, Pe.pending, 0)), Pe.gzindex = 0, Pe.status = 69) : (Zt(Pe, 0), Zt(Pe, 0), Zt(Pe, 0), Zt(Pe, 0), Zt(Pe, 0), Zt(Pe, Pe.level === 9 ? 2 : 2 <= Pe.strategy || Pe.level < 2 ? 4 : 0), Zt(Pe, 3), Pe.status = $e);
          else {
            var kt = K + (Pe.w_bits - 8 << 4) << 8;
            kt |= (2 <= Pe.strategy || Pe.level < 2 ? 0 : Pe.level < 6 ? 1 : Pe.level === 6 ? 2 : 3) << 6, Pe.strstart !== 0 && (kt |= 32), kt += 31 - kt % 31, Pe.status = $e, $t(Pe, kt), Pe.strstart !== 0 && ($t(Pe, pe.adler >>> 16), $t(Pe, 65535 & pe.adler)), pe.adler = 1;
          }
        if (Pe.status === 69)
          if (Pe.gzhead.extra) {
            for (ke = Pe.pending; Pe.gzindex < (65535 & Pe.gzhead.extra.length) && (Pe.pending !== Pe.pending_buf_size || (Pe.gzhead.hcrc && Pe.pending > ke && (pe.adler = x(pe.adler, Pe.pending_buf, Pe.pending - ke, ke)), rt(pe), ke = Pe.pending, Pe.pending !== Pe.pending_buf_size)); )
              Zt(Pe, 255 & Pe.gzhead.extra[Pe.gzindex]), Pe.gzindex++;
            Pe.gzhead.hcrc && Pe.pending > ke && (pe.adler = x(pe.adler, Pe.pending_buf, Pe.pending - ke, ke)), Pe.gzindex === Pe.gzhead.extra.length && (Pe.gzindex = 0, Pe.status = 73);
          } else
            Pe.status = 73;
        if (Pe.status === 73)
          if (Pe.gzhead.name) {
            ke = Pe.pending;
            do {
              if (Pe.pending === Pe.pending_buf_size && (Pe.gzhead.hcrc && Pe.pending > ke && (pe.adler = x(pe.adler, Pe.pending_buf, Pe.pending - ke, ke)), rt(pe), ke = Pe.pending, Pe.pending === Pe.pending_buf_size)) {
                Je = 1;
                break;
              }
              Je = Pe.gzindex < Pe.gzhead.name.length ? 255 & Pe.gzhead.name.charCodeAt(Pe.gzindex++) : 0, Zt(Pe, Je);
            } while (Je !== 0);
            Pe.gzhead.hcrc && Pe.pending > ke && (pe.adler = x(pe.adler, Pe.pending_buf, Pe.pending - ke, ke)), Je === 0 && (Pe.gzindex = 0, Pe.status = 91);
          } else
            Pe.status = 91;
        if (Pe.status === 91)
          if (Pe.gzhead.comment) {
            ke = Pe.pending;
            do {
              if (Pe.pending === Pe.pending_buf_size && (Pe.gzhead.hcrc && Pe.pending > ke && (pe.adler = x(pe.adler, Pe.pending_buf, Pe.pending - ke, ke)), rt(pe), ke = Pe.pending, Pe.pending === Pe.pending_buf_size)) {
                Je = 1;
                break;
              }
              Je = Pe.gzindex < Pe.gzhead.comment.length ? 255 & Pe.gzhead.comment.charCodeAt(Pe.gzindex++) : 0, Zt(Pe, Je);
            } while (Je !== 0);
            Pe.gzhead.hcrc && Pe.pending > ke && (pe.adler = x(pe.adler, Pe.pending_buf, Pe.pending - ke, ke)), Je === 0 && (Pe.status = 103);
          } else
            Pe.status = 103;
        if (Pe.status === 103 && (Pe.gzhead.hcrc ? (Pe.pending + 2 > Pe.pending_buf_size && rt(pe), Pe.pending + 2 <= Pe.pending_buf_size && (Zt(Pe, 255 & pe.adler), Zt(Pe, pe.adler >> 8 & 255), pe.adler = 0, Pe.status = $e)) : Pe.status = $e), Pe.pending !== 0) {
          if (rt(pe), pe.avail_out === 0)
            return Pe.last_flush = -1, M;
        } else if (pe.avail_in === 0 && We(xt) <= We(tt) && xt !== F)
          return qt(pe, -5);
        if (Pe.status === 666 && pe.avail_in !== 0)
          return qt(pe, -5);
        if (pe.avail_in !== 0 || Pe.lookahead !== 0 || xt !== I && Pe.status !== 666) {
          var vt = Pe.strategy === 2 ? function(Qe, wt) {
            for (var Yt; ; ) {
              if (Qe.lookahead === 0 && (ii(Qe), Qe.lookahead === 0)) {
                if (wt === I)
                  return ce;
                break;
              }
              if (Qe.match_length = 0, Yt = c._tr_tally(Qe, 0, Qe.window[Qe.strstart]), Qe.lookahead--, Qe.strstart++, Yt && (it(Qe, !1), Qe.strm.avail_out === 0))
                return ce;
            }
            return Qe.insert = 0, wt === F ? (it(Qe, !0), Qe.strm.avail_out === 0 ? ze : pt) : Qe.last_lit && (it(Qe, !1), Qe.strm.avail_out === 0) ? ce : ut;
          }(Pe, xt) : Pe.strategy === 3 ? function(Qe, wt) {
            for (var Yt, Ye, i, r, a = Qe.window; ; ) {
              if (Qe.lookahead <= He) {
                if (ii(Qe), Qe.lookahead <= He && wt === I)
                  return ce;
                if (Qe.lookahead === 0)
                  break;
              }
              if (Qe.match_length = 0, Qe.lookahead >= Ee && 0 < Qe.strstart && (Ye = a[i = Qe.strstart - 1]) === a[++i] && Ye === a[++i] && Ye === a[++i]) {
                r = Qe.strstart + He;
                do
                  ;
                while (Ye === a[++i] && Ye === a[++i] && Ye === a[++i] && Ye === a[++i] && Ye === a[++i] && Ye === a[++i] && Ye === a[++i] && Ye === a[++i] && i < r);
                Qe.match_length = He - (r - i), Qe.match_length > Qe.lookahead && (Qe.match_length = Qe.lookahead);
              }
              if (Qe.match_length >= Ee ? (Yt = c._tr_tally(Qe, 1, Qe.match_length - Ee), Qe.lookahead -= Qe.match_length, Qe.strstart += Qe.match_length, Qe.match_length = 0) : (Yt = c._tr_tally(Qe, 0, Qe.window[Qe.strstart]), Qe.lookahead--, Qe.strstart++), Yt && (it(Qe, !1), Qe.strm.avail_out === 0))
                return ce;
            }
            return Qe.insert = 0, wt === F ? (it(Qe, !0), Qe.strm.avail_out === 0 ? ze : pt) : Qe.last_lit && (it(Qe, !1), Qe.strm.avail_out === 0) ? ce : ut;
          }(Pe, xt) : o[Pe.level].func(Pe, xt);
          if (vt !== ze && vt !== pt || (Pe.status = 666), vt === ce || vt === ze)
            return pe.avail_out === 0 && (Pe.last_flush = -1), M;
          if (vt === ut && (xt === 1 ? c._tr_align(Pe) : xt !== 5 && (c._tr_stored_block(Pe, 0, 0, !1), xt === 3 && (Et(Pe.head), Pe.lookahead === 0 && (Pe.strstart = 0, Pe.block_start = 0, Pe.insert = 0))), rt(pe), pe.avail_out === 0))
            return Pe.last_flush = -1, M;
        }
        return xt !== F ? M : Pe.wrap <= 0 ? 1 : (Pe.wrap === 2 ? (Zt(Pe, 255 & pe.adler), Zt(Pe, pe.adler >> 8 & 255), Zt(Pe, pe.adler >> 16 & 255), Zt(Pe, pe.adler >> 24 & 255), Zt(Pe, 255 & pe.total_in), Zt(Pe, pe.total_in >> 8 & 255), Zt(Pe, pe.total_in >> 16 & 255), Zt(Pe, pe.total_in >> 24 & 255)) : ($t(Pe, pe.adler >>> 16), $t(Pe, 65535 & pe.adler)), rt(pe), 0 < Pe.wrap && (Pe.wrap = -Pe.wrap), Pe.pending !== 0 ? M : 1);
      }, s.deflateEnd = function(pe) {
        var xt;
        return pe && pe.state ? (xt = pe.state.status) !== Le && xt !== 69 && xt !== 73 && xt !== 91 && xt !== 103 && xt !== $e && xt !== 666 ? qt(pe, Z) : (pe.state = null, xt === $e ? qt(pe, -3) : M) : Z;
      }, s.deflateSetDictionary = function(pe, xt) {
        var tt, Pe, ke, Je, kt, vt, Qe, wt, Yt = xt.length;
        if (!pe || !pe.state || (Je = (tt = pe.state).wrap) === 2 || Je === 1 && tt.status !== Le || tt.lookahead)
          return Z;
        for (Je === 1 && (pe.adler = m(pe.adler, xt, Yt, 0)), tt.wrap = 0, Yt >= tt.w_size && (Je === 0 && (Et(tt.head), tt.strstart = 0, tt.block_start = 0, tt.insert = 0), wt = new h.Buf8(tt.w_size), h.arraySet(wt, xt, Yt - tt.w_size, tt.w_size, 0), xt = wt, Yt = tt.w_size), kt = pe.avail_in, vt = pe.next_in, Qe = pe.input, pe.avail_in = Yt, pe.next_in = 0, pe.input = xt, ii(tt); tt.lookahead >= Ee; ) {
          for (Pe = tt.strstart, ke = tt.lookahead - (Ee - 1); tt.ins_h = (tt.ins_h << tt.hash_shift ^ tt.window[Pe + Ee - 1]) & tt.hash_mask, tt.prev[Pe & tt.w_mask] = tt.head[tt.ins_h], tt.head[tt.ins_h] = Pe, Pe++, --ke; )
            ;
          tt.strstart = Pe, tt.lookahead = Ee - 1, ii(tt);
        }
        return tt.strstart += tt.lookahead, tt.block_start = tt.strstart, tt.insert = tt.lookahead, tt.lookahead = 0, tt.match_length = tt.prev_length = Ee - 1, tt.match_available = 0, pe.next_in = vt, pe.input = Qe, pe.avail_in = kt, tt.wrap = Je, M;
      }, s.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(t, n, s) {
      n.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(t, n, s) {
      n.exports = function(o, h) {
        var c, m, x, B, I, F, M, Z, V, te, P, K, J, le, fe, X, W, je, Ee, He, ft, Le, $e, ce, ut;
        c = o.state, m = o.next_in, ce = o.input, x = m + (o.avail_in - 5), B = o.next_out, ut = o.output, I = B - (h - o.avail_out), F = B + (o.avail_out - 257), M = c.dmax, Z = c.wsize, V = c.whave, te = c.wnext, P = c.window, K = c.hold, J = c.bits, le = c.lencode, fe = c.distcode, X = (1 << c.lenbits) - 1, W = (1 << c.distbits) - 1;
        e:
          do {
            J < 15 && (K += ce[m++] << J, J += 8, K += ce[m++] << J, J += 8), je = le[K & X];
            t:
              for (; ; ) {
                if (K >>>= Ee = je >>> 24, J -= Ee, (Ee = je >>> 16 & 255) === 0)
                  ut[B++] = 65535 & je;
                else {
                  if (!(16 & Ee)) {
                    if (!(64 & Ee)) {
                      je = le[(65535 & je) + (K & (1 << Ee) - 1)];
                      continue t;
                    }
                    if (32 & Ee) {
                      c.mode = 12;
                      break e;
                    }
                    o.msg = "invalid literal/length code", c.mode = 30;
                    break e;
                  }
                  He = 65535 & je, (Ee &= 15) && (J < Ee && (K += ce[m++] << J, J += 8), He += K & (1 << Ee) - 1, K >>>= Ee, J -= Ee), J < 15 && (K += ce[m++] << J, J += 8, K += ce[m++] << J, J += 8), je = fe[K & W];
                  i:
                    for (; ; ) {
                      if (K >>>= Ee = je >>> 24, J -= Ee, !(16 & (Ee = je >>> 16 & 255))) {
                        if (!(64 & Ee)) {
                          je = fe[(65535 & je) + (K & (1 << Ee) - 1)];
                          continue i;
                        }
                        o.msg = "invalid distance code", c.mode = 30;
                        break e;
                      }
                      if (ft = 65535 & je, J < (Ee &= 15) && (K += ce[m++] << J, (J += 8) < Ee && (K += ce[m++] << J, J += 8)), M < (ft += K & (1 << Ee) - 1)) {
                        o.msg = "invalid distance too far back", c.mode = 30;
                        break e;
                      }
                      if (K >>>= Ee, J -= Ee, (Ee = B - I) < ft) {
                        if (V < (Ee = ft - Ee) && c.sane) {
                          o.msg = "invalid distance too far back", c.mode = 30;
                          break e;
                        }
                        if ($e = P, (Le = 0) === te) {
                          if (Le += Z - Ee, Ee < He) {
                            for (He -= Ee; ut[B++] = P[Le++], --Ee; )
                              ;
                            Le = B - ft, $e = ut;
                          }
                        } else if (te < Ee) {
                          if (Le += Z + te - Ee, (Ee -= te) < He) {
                            for (He -= Ee; ut[B++] = P[Le++], --Ee; )
                              ;
                            if (Le = 0, te < He) {
                              for (He -= Ee = te; ut[B++] = P[Le++], --Ee; )
                                ;
                              Le = B - ft, $e = ut;
                            }
                          }
                        } else if (Le += te - Ee, Ee < He) {
                          for (He -= Ee; ut[B++] = P[Le++], --Ee; )
                            ;
                          Le = B - ft, $e = ut;
                        }
                        for (; 2 < He; )
                          ut[B++] = $e[Le++], ut[B++] = $e[Le++], ut[B++] = $e[Le++], He -= 3;
                        He && (ut[B++] = $e[Le++], 1 < He && (ut[B++] = $e[Le++]));
                      } else {
                        for (Le = B - ft; ut[B++] = ut[Le++], ut[B++] = ut[Le++], ut[B++] = ut[Le++], 2 < (He -= 3); )
                          ;
                        He && (ut[B++] = ut[Le++], 1 < He && (ut[B++] = ut[Le++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (m < x && B < F);
        m -= He = J >> 3, K &= (1 << (J -= He << 3)) - 1, o.next_in = m, o.next_out = B, o.avail_in = m < x ? x - m + 5 : 5 - (m - x), o.avail_out = B < F ? F - B + 257 : 257 - (B - F), c.hold = K, c.bits = J;
      };
    }, {}], 49: [function(t, n, s) {
      var o = t("../utils/common"), h = t("./adler32"), c = t("./crc32"), m = t("./inffast"), x = t("./inftrees"), B = 1, I = 2, F = 0, M = -2, Z = 1, V = 852, te = 592;
      function P(Le) {
        return (Le >>> 24 & 255) + (Le >>> 8 & 65280) + ((65280 & Le) << 8) + ((255 & Le) << 24);
      }
      function K() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new o.Buf16(320), this.work = new o.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function J(Le) {
        var $e;
        return Le && Le.state ? ($e = Le.state, Le.total_in = Le.total_out = $e.total = 0, Le.msg = "", $e.wrap && (Le.adler = 1 & $e.wrap), $e.mode = Z, $e.last = 0, $e.havedict = 0, $e.dmax = 32768, $e.head = null, $e.hold = 0, $e.bits = 0, $e.lencode = $e.lendyn = new o.Buf32(V), $e.distcode = $e.distdyn = new o.Buf32(te), $e.sane = 1, $e.back = -1, F) : M;
      }
      function le(Le) {
        var $e;
        return Le && Le.state ? (($e = Le.state).wsize = 0, $e.whave = 0, $e.wnext = 0, J(Le)) : M;
      }
      function fe(Le, $e) {
        var ce, ut;
        return Le && Le.state ? (ut = Le.state, $e < 0 ? (ce = 0, $e = -$e) : (ce = 1 + ($e >> 4), $e < 48 && ($e &= 15)), $e && ($e < 8 || 15 < $e) ? M : (ut.window !== null && ut.wbits !== $e && (ut.window = null), ut.wrap = ce, ut.wbits = $e, le(Le))) : M;
      }
      function X(Le, $e) {
        var ce, ut;
        return Le ? (ut = new K(), (Le.state = ut).window = null, (ce = fe(Le, $e)) !== F && (Le.state = null), ce) : M;
      }
      var W, je, Ee = !0;
      function He(Le) {
        if (Ee) {
          var $e;
          for (W = new o.Buf32(512), je = new o.Buf32(32), $e = 0; $e < 144; )
            Le.lens[$e++] = 8;
          for (; $e < 256; )
            Le.lens[$e++] = 9;
          for (; $e < 280; )
            Le.lens[$e++] = 7;
          for (; $e < 288; )
            Le.lens[$e++] = 8;
          for (x(B, Le.lens, 0, 288, W, 0, Le.work, { bits: 9 }), $e = 0; $e < 32; )
            Le.lens[$e++] = 5;
          x(I, Le.lens, 0, 32, je, 0, Le.work, { bits: 5 }), Ee = !1;
        }
        Le.lencode = W, Le.lenbits = 9, Le.distcode = je, Le.distbits = 5;
      }
      function ft(Le, $e, ce, ut) {
        var ze, pt = Le.state;
        return pt.window === null && (pt.wsize = 1 << pt.wbits, pt.wnext = 0, pt.whave = 0, pt.window = new o.Buf8(pt.wsize)), ut >= pt.wsize ? (o.arraySet(pt.window, $e, ce - pt.wsize, pt.wsize, 0), pt.wnext = 0, pt.whave = pt.wsize) : (ut < (ze = pt.wsize - pt.wnext) && (ze = ut), o.arraySet(pt.window, $e, ce - ut, ze, pt.wnext), (ut -= ze) ? (o.arraySet(pt.window, $e, ce - ut, ut, 0), pt.wnext = ut, pt.whave = pt.wsize) : (pt.wnext += ze, pt.wnext === pt.wsize && (pt.wnext = 0), pt.whave < pt.wsize && (pt.whave += ze))), 0;
      }
      s.inflateReset = le, s.inflateReset2 = fe, s.inflateResetKeep = J, s.inflateInit = function(Le) {
        return X(Le, 15);
      }, s.inflateInit2 = X, s.inflate = function(Le, $e) {
        var ce, ut, ze, pt, qt, We, Et, rt, it, Zt, $t, Lt, ii, Ci, ui, Gt, Xt, Qt, Ni, Di, pe, xt, tt, Pe, ke = 0, Je = new o.Buf8(4), kt = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!Le || !Le.state || !Le.output || !Le.input && Le.avail_in !== 0)
          return M;
        (ce = Le.state).mode === 12 && (ce.mode = 13), qt = Le.next_out, ze = Le.output, Et = Le.avail_out, pt = Le.next_in, ut = Le.input, We = Le.avail_in, rt = ce.hold, it = ce.bits, Zt = We, $t = Et, xt = F;
        e:
          for (; ; )
            switch (ce.mode) {
              case Z:
                if (ce.wrap === 0) {
                  ce.mode = 13;
                  break;
                }
                for (; it < 16; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                if (2 & ce.wrap && rt === 35615) {
                  Je[ce.check = 0] = 255 & rt, Je[1] = rt >>> 8 & 255, ce.check = c(ce.check, Je, 2, 0), it = rt = 0, ce.mode = 2;
                  break;
                }
                if (ce.flags = 0, ce.head && (ce.head.done = !1), !(1 & ce.wrap) || (((255 & rt) << 8) + (rt >> 8)) % 31) {
                  Le.msg = "incorrect header check", ce.mode = 30;
                  break;
                }
                if ((15 & rt) != 8) {
                  Le.msg = "unknown compression method", ce.mode = 30;
                  break;
                }
                if (it -= 4, pe = 8 + (15 & (rt >>>= 4)), ce.wbits === 0)
                  ce.wbits = pe;
                else if (pe > ce.wbits) {
                  Le.msg = "invalid window size", ce.mode = 30;
                  break;
                }
                ce.dmax = 1 << pe, Le.adler = ce.check = 1, ce.mode = 512 & rt ? 10 : 12, it = rt = 0;
                break;
              case 2:
                for (; it < 16; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                if (ce.flags = rt, (255 & ce.flags) != 8) {
                  Le.msg = "unknown compression method", ce.mode = 30;
                  break;
                }
                if (57344 & ce.flags) {
                  Le.msg = "unknown header flags set", ce.mode = 30;
                  break;
                }
                ce.head && (ce.head.text = rt >> 8 & 1), 512 & ce.flags && (Je[0] = 255 & rt, Je[1] = rt >>> 8 & 255, ce.check = c(ce.check, Je, 2, 0)), it = rt = 0, ce.mode = 3;
              case 3:
                for (; it < 32; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                ce.head && (ce.head.time = rt), 512 & ce.flags && (Je[0] = 255 & rt, Je[1] = rt >>> 8 & 255, Je[2] = rt >>> 16 & 255, Je[3] = rt >>> 24 & 255, ce.check = c(ce.check, Je, 4, 0)), it = rt = 0, ce.mode = 4;
              case 4:
                for (; it < 16; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                ce.head && (ce.head.xflags = 255 & rt, ce.head.os = rt >> 8), 512 & ce.flags && (Je[0] = 255 & rt, Je[1] = rt >>> 8 & 255, ce.check = c(ce.check, Je, 2, 0)), it = rt = 0, ce.mode = 5;
              case 5:
                if (1024 & ce.flags) {
                  for (; it < 16; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  ce.length = rt, ce.head && (ce.head.extra_len = rt), 512 & ce.flags && (Je[0] = 255 & rt, Je[1] = rt >>> 8 & 255, ce.check = c(ce.check, Je, 2, 0)), it = rt = 0;
                } else
                  ce.head && (ce.head.extra = null);
                ce.mode = 6;
              case 6:
                if (1024 & ce.flags && (We < (Lt = ce.length) && (Lt = We), Lt && (ce.head && (pe = ce.head.extra_len - ce.length, ce.head.extra || (ce.head.extra = new Array(ce.head.extra_len)), o.arraySet(ce.head.extra, ut, pt, Lt, pe)), 512 & ce.flags && (ce.check = c(ce.check, ut, Lt, pt)), We -= Lt, pt += Lt, ce.length -= Lt), ce.length))
                  break e;
                ce.length = 0, ce.mode = 7;
              case 7:
                if (2048 & ce.flags) {
                  if (We === 0)
                    break e;
                  for (Lt = 0; pe = ut[pt + Lt++], ce.head && pe && ce.length < 65536 && (ce.head.name += String.fromCharCode(pe)), pe && Lt < We; )
                    ;
                  if (512 & ce.flags && (ce.check = c(ce.check, ut, Lt, pt)), We -= Lt, pt += Lt, pe)
                    break e;
                } else
                  ce.head && (ce.head.name = null);
                ce.length = 0, ce.mode = 8;
              case 8:
                if (4096 & ce.flags) {
                  if (We === 0)
                    break e;
                  for (Lt = 0; pe = ut[pt + Lt++], ce.head && pe && ce.length < 65536 && (ce.head.comment += String.fromCharCode(pe)), pe && Lt < We; )
                    ;
                  if (512 & ce.flags && (ce.check = c(ce.check, ut, Lt, pt)), We -= Lt, pt += Lt, pe)
                    break e;
                } else
                  ce.head && (ce.head.comment = null);
                ce.mode = 9;
              case 9:
                if (512 & ce.flags) {
                  for (; it < 16; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  if (rt !== (65535 & ce.check)) {
                    Le.msg = "header crc mismatch", ce.mode = 30;
                    break;
                  }
                  it = rt = 0;
                }
                ce.head && (ce.head.hcrc = ce.flags >> 9 & 1, ce.head.done = !0), Le.adler = ce.check = 0, ce.mode = 12;
                break;
              case 10:
                for (; it < 32; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                Le.adler = ce.check = P(rt), it = rt = 0, ce.mode = 11;
              case 11:
                if (ce.havedict === 0)
                  return Le.next_out = qt, Le.avail_out = Et, Le.next_in = pt, Le.avail_in = We, ce.hold = rt, ce.bits = it, 2;
                Le.adler = ce.check = 1, ce.mode = 12;
              case 12:
                if ($e === 5 || $e === 6)
                  break e;
              case 13:
                if (ce.last) {
                  rt >>>= 7 & it, it -= 7 & it, ce.mode = 27;
                  break;
                }
                for (; it < 3; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                switch (ce.last = 1 & rt, it -= 1, 3 & (rt >>>= 1)) {
                  case 0:
                    ce.mode = 14;
                    break;
                  case 1:
                    if (He(ce), ce.mode = 20, $e !== 6)
                      break;
                    rt >>>= 2, it -= 2;
                    break e;
                  case 2:
                    ce.mode = 17;
                    break;
                  case 3:
                    Le.msg = "invalid block type", ce.mode = 30;
                }
                rt >>>= 2, it -= 2;
                break;
              case 14:
                for (rt >>>= 7 & it, it -= 7 & it; it < 32; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                if ((65535 & rt) != (rt >>> 16 ^ 65535)) {
                  Le.msg = "invalid stored block lengths", ce.mode = 30;
                  break;
                }
                if (ce.length = 65535 & rt, it = rt = 0, ce.mode = 15, $e === 6)
                  break e;
              case 15:
                ce.mode = 16;
              case 16:
                if (Lt = ce.length) {
                  if (We < Lt && (Lt = We), Et < Lt && (Lt = Et), Lt === 0)
                    break e;
                  o.arraySet(ze, ut, pt, Lt, qt), We -= Lt, pt += Lt, Et -= Lt, qt += Lt, ce.length -= Lt;
                  break;
                }
                ce.mode = 12;
                break;
              case 17:
                for (; it < 14; ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                if (ce.nlen = 257 + (31 & rt), rt >>>= 5, it -= 5, ce.ndist = 1 + (31 & rt), rt >>>= 5, it -= 5, ce.ncode = 4 + (15 & rt), rt >>>= 4, it -= 4, 286 < ce.nlen || 30 < ce.ndist) {
                  Le.msg = "too many length or distance symbols", ce.mode = 30;
                  break;
                }
                ce.have = 0, ce.mode = 18;
              case 18:
                for (; ce.have < ce.ncode; ) {
                  for (; it < 3; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  ce.lens[kt[ce.have++]] = 7 & rt, rt >>>= 3, it -= 3;
                }
                for (; ce.have < 19; )
                  ce.lens[kt[ce.have++]] = 0;
                if (ce.lencode = ce.lendyn, ce.lenbits = 7, tt = { bits: ce.lenbits }, xt = x(0, ce.lens, 0, 19, ce.lencode, 0, ce.work, tt), ce.lenbits = tt.bits, xt) {
                  Le.msg = "invalid code lengths set", ce.mode = 30;
                  break;
                }
                ce.have = 0, ce.mode = 19;
              case 19:
                for (; ce.have < ce.nlen + ce.ndist; ) {
                  for (; Gt = (ke = ce.lencode[rt & (1 << ce.lenbits) - 1]) >>> 16 & 255, Xt = 65535 & ke, !((ui = ke >>> 24) <= it); ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  if (Xt < 16)
                    rt >>>= ui, it -= ui, ce.lens[ce.have++] = Xt;
                  else {
                    if (Xt === 16) {
                      for (Pe = ui + 2; it < Pe; ) {
                        if (We === 0)
                          break e;
                        We--, rt += ut[pt++] << it, it += 8;
                      }
                      if (rt >>>= ui, it -= ui, ce.have === 0) {
                        Le.msg = "invalid bit length repeat", ce.mode = 30;
                        break;
                      }
                      pe = ce.lens[ce.have - 1], Lt = 3 + (3 & rt), rt >>>= 2, it -= 2;
                    } else if (Xt === 17) {
                      for (Pe = ui + 3; it < Pe; ) {
                        if (We === 0)
                          break e;
                        We--, rt += ut[pt++] << it, it += 8;
                      }
                      it -= ui, pe = 0, Lt = 3 + (7 & (rt >>>= ui)), rt >>>= 3, it -= 3;
                    } else {
                      for (Pe = ui + 7; it < Pe; ) {
                        if (We === 0)
                          break e;
                        We--, rt += ut[pt++] << it, it += 8;
                      }
                      it -= ui, pe = 0, Lt = 11 + (127 & (rt >>>= ui)), rt >>>= 7, it -= 7;
                    }
                    if (ce.have + Lt > ce.nlen + ce.ndist) {
                      Le.msg = "invalid bit length repeat", ce.mode = 30;
                      break;
                    }
                    for (; Lt--; )
                      ce.lens[ce.have++] = pe;
                  }
                }
                if (ce.mode === 30)
                  break;
                if (ce.lens[256] === 0) {
                  Le.msg = "invalid code -- missing end-of-block", ce.mode = 30;
                  break;
                }
                if (ce.lenbits = 9, tt = { bits: ce.lenbits }, xt = x(B, ce.lens, 0, ce.nlen, ce.lencode, 0, ce.work, tt), ce.lenbits = tt.bits, xt) {
                  Le.msg = "invalid literal/lengths set", ce.mode = 30;
                  break;
                }
                if (ce.distbits = 6, ce.distcode = ce.distdyn, tt = { bits: ce.distbits }, xt = x(I, ce.lens, ce.nlen, ce.ndist, ce.distcode, 0, ce.work, tt), ce.distbits = tt.bits, xt) {
                  Le.msg = "invalid distances set", ce.mode = 30;
                  break;
                }
                if (ce.mode = 20, $e === 6)
                  break e;
              case 20:
                ce.mode = 21;
              case 21:
                if (6 <= We && 258 <= Et) {
                  Le.next_out = qt, Le.avail_out = Et, Le.next_in = pt, Le.avail_in = We, ce.hold = rt, ce.bits = it, m(Le, $t), qt = Le.next_out, ze = Le.output, Et = Le.avail_out, pt = Le.next_in, ut = Le.input, We = Le.avail_in, rt = ce.hold, it = ce.bits, ce.mode === 12 && (ce.back = -1);
                  break;
                }
                for (ce.back = 0; Gt = (ke = ce.lencode[rt & (1 << ce.lenbits) - 1]) >>> 16 & 255, Xt = 65535 & ke, !((ui = ke >>> 24) <= it); ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                if (Gt && !(240 & Gt)) {
                  for (Qt = ui, Ni = Gt, Di = Xt; Gt = (ke = ce.lencode[Di + ((rt & (1 << Qt + Ni) - 1) >> Qt)]) >>> 16 & 255, Xt = 65535 & ke, !(Qt + (ui = ke >>> 24) <= it); ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  rt >>>= Qt, it -= Qt, ce.back += Qt;
                }
                if (rt >>>= ui, it -= ui, ce.back += ui, ce.length = Xt, Gt === 0) {
                  ce.mode = 26;
                  break;
                }
                if (32 & Gt) {
                  ce.back = -1, ce.mode = 12;
                  break;
                }
                if (64 & Gt) {
                  Le.msg = "invalid literal/length code", ce.mode = 30;
                  break;
                }
                ce.extra = 15 & Gt, ce.mode = 22;
              case 22:
                if (ce.extra) {
                  for (Pe = ce.extra; it < Pe; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  ce.length += rt & (1 << ce.extra) - 1, rt >>>= ce.extra, it -= ce.extra, ce.back += ce.extra;
                }
                ce.was = ce.length, ce.mode = 23;
              case 23:
                for (; Gt = (ke = ce.distcode[rt & (1 << ce.distbits) - 1]) >>> 16 & 255, Xt = 65535 & ke, !((ui = ke >>> 24) <= it); ) {
                  if (We === 0)
                    break e;
                  We--, rt += ut[pt++] << it, it += 8;
                }
                if (!(240 & Gt)) {
                  for (Qt = ui, Ni = Gt, Di = Xt; Gt = (ke = ce.distcode[Di + ((rt & (1 << Qt + Ni) - 1) >> Qt)]) >>> 16 & 255, Xt = 65535 & ke, !(Qt + (ui = ke >>> 24) <= it); ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  rt >>>= Qt, it -= Qt, ce.back += Qt;
                }
                if (rt >>>= ui, it -= ui, ce.back += ui, 64 & Gt) {
                  Le.msg = "invalid distance code", ce.mode = 30;
                  break;
                }
                ce.offset = Xt, ce.extra = 15 & Gt, ce.mode = 24;
              case 24:
                if (ce.extra) {
                  for (Pe = ce.extra; it < Pe; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  ce.offset += rt & (1 << ce.extra) - 1, rt >>>= ce.extra, it -= ce.extra, ce.back += ce.extra;
                }
                if (ce.offset > ce.dmax) {
                  Le.msg = "invalid distance too far back", ce.mode = 30;
                  break;
                }
                ce.mode = 25;
              case 25:
                if (Et === 0)
                  break e;
                if (Lt = $t - Et, ce.offset > Lt) {
                  if ((Lt = ce.offset - Lt) > ce.whave && ce.sane) {
                    Le.msg = "invalid distance too far back", ce.mode = 30;
                    break;
                  }
                  ii = Lt > ce.wnext ? (Lt -= ce.wnext, ce.wsize - Lt) : ce.wnext - Lt, Lt > ce.length && (Lt = ce.length), Ci = ce.window;
                } else
                  Ci = ze, ii = qt - ce.offset, Lt = ce.length;
                for (Et < Lt && (Lt = Et), Et -= Lt, ce.length -= Lt; ze[qt++] = Ci[ii++], --Lt; )
                  ;
                ce.length === 0 && (ce.mode = 21);
                break;
              case 26:
                if (Et === 0)
                  break e;
                ze[qt++] = ce.length, Et--, ce.mode = 21;
                break;
              case 27:
                if (ce.wrap) {
                  for (; it < 32; ) {
                    if (We === 0)
                      break e;
                    We--, rt |= ut[pt++] << it, it += 8;
                  }
                  if ($t -= Et, Le.total_out += $t, ce.total += $t, $t && (Le.adler = ce.check = ce.flags ? c(ce.check, ze, $t, qt - $t) : h(ce.check, ze, $t, qt - $t)), $t = Et, (ce.flags ? rt : P(rt)) !== ce.check) {
                    Le.msg = "incorrect data check", ce.mode = 30;
                    break;
                  }
                  it = rt = 0;
                }
                ce.mode = 28;
              case 28:
                if (ce.wrap && ce.flags) {
                  for (; it < 32; ) {
                    if (We === 0)
                      break e;
                    We--, rt += ut[pt++] << it, it += 8;
                  }
                  if (rt !== (4294967295 & ce.total)) {
                    Le.msg = "incorrect length check", ce.mode = 30;
                    break;
                  }
                  it = rt = 0;
                }
                ce.mode = 29;
              case 29:
                xt = 1;
                break e;
              case 30:
                xt = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return M;
            }
        return Le.next_out = qt, Le.avail_out = Et, Le.next_in = pt, Le.avail_in = We, ce.hold = rt, ce.bits = it, (ce.wsize || $t !== Le.avail_out && ce.mode < 30 && (ce.mode < 27 || $e !== 4)) && ft(Le, Le.output, Le.next_out, $t - Le.avail_out) ? (ce.mode = 31, -4) : (Zt -= Le.avail_in, $t -= Le.avail_out, Le.total_in += Zt, Le.total_out += $t, ce.total += $t, ce.wrap && $t && (Le.adler = ce.check = ce.flags ? c(ce.check, ze, $t, Le.next_out - $t) : h(ce.check, ze, $t, Le.next_out - $t)), Le.data_type = ce.bits + (ce.last ? 64 : 0) + (ce.mode === 12 ? 128 : 0) + (ce.mode === 20 || ce.mode === 15 ? 256 : 0), (Zt == 0 && $t === 0 || $e === 4) && xt === F && (xt = -5), xt);
      }, s.inflateEnd = function(Le) {
        if (!Le || !Le.state)
          return M;
        var $e = Le.state;
        return $e.window && ($e.window = null), Le.state = null, F;
      }, s.inflateGetHeader = function(Le, $e) {
        var ce;
        return Le && Le.state && 2 & (ce = Le.state).wrap ? ((ce.head = $e).done = !1, F) : M;
      }, s.inflateSetDictionary = function(Le, $e) {
        var ce, ut = $e.length;
        return Le && Le.state ? (ce = Le.state).wrap !== 0 && ce.mode !== 11 ? M : ce.mode === 11 && h(1, $e, ut, 0) !== ce.check ? -3 : ft(Le, $e, ut, ut) ? (ce.mode = 31, -4) : (ce.havedict = 1, F) : M;
      }, s.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(t, n, s) {
      var o = t("../utils/common"), h = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], c = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], m = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], x = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      n.exports = function(B, I, F, M, Z, V, te, P) {
        var K, J, le, fe, X, W, je, Ee, He, ft = P.bits, Le = 0, $e = 0, ce = 0, ut = 0, ze = 0, pt = 0, qt = 0, We = 0, Et = 0, rt = 0, it = null, Zt = 0, $t = new o.Buf16(16), Lt = new o.Buf16(16), ii = null, Ci = 0;
        for (Le = 0; Le <= 15; Le++)
          $t[Le] = 0;
        for ($e = 0; $e < M; $e++)
          $t[I[F + $e]]++;
        for (ze = ft, ut = 15; 1 <= ut && $t[ut] === 0; ut--)
          ;
        if (ut < ze && (ze = ut), ut === 0)
          return Z[V++] = 20971520, Z[V++] = 20971520, P.bits = 1, 0;
        for (ce = 1; ce < ut && $t[ce] === 0; ce++)
          ;
        for (ze < ce && (ze = ce), Le = We = 1; Le <= 15; Le++)
          if (We <<= 1, (We -= $t[Le]) < 0)
            return -1;
        if (0 < We && (B === 0 || ut !== 1))
          return -1;
        for (Lt[1] = 0, Le = 1; Le < 15; Le++)
          Lt[Le + 1] = Lt[Le] + $t[Le];
        for ($e = 0; $e < M; $e++)
          I[F + $e] !== 0 && (te[Lt[I[F + $e]]++] = $e);
        if (W = B === 0 ? (it = ii = te, 19) : B === 1 ? (it = h, Zt -= 257, ii = c, Ci -= 257, 256) : (it = m, ii = x, -1), Le = ce, X = V, qt = $e = rt = 0, le = -1, fe = (Et = 1 << (pt = ze)) - 1, B === 1 && 852 < Et || B === 2 && 592 < Et)
          return 1;
        for (; ; ) {
          for (je = Le - qt, He = te[$e] < W ? (Ee = 0, te[$e]) : te[$e] > W ? (Ee = ii[Ci + te[$e]], it[Zt + te[$e]]) : (Ee = 96, 0), K = 1 << Le - qt, ce = J = 1 << pt; Z[X + (rt >> qt) + (J -= K)] = je << 24 | Ee << 16 | He | 0, J !== 0; )
            ;
          for (K = 1 << Le - 1; rt & K; )
            K >>= 1;
          if (K !== 0 ? (rt &= K - 1, rt += K) : rt = 0, $e++, --$t[Le] == 0) {
            if (Le === ut)
              break;
            Le = I[F + te[$e]];
          }
          if (ze < Le && (rt & fe) !== le) {
            for (qt === 0 && (qt = ze), X += ce, We = 1 << (pt = Le - qt); pt + qt < ut && !((We -= $t[pt + qt]) <= 0); )
              pt++, We <<= 1;
            if (Et += 1 << pt, B === 1 && 852 < Et || B === 2 && 592 < Et)
              return 1;
            Z[le = rt & fe] = ze << 24 | pt << 16 | X - V | 0;
          }
        }
        return rt !== 0 && (Z[X + rt] = Le - qt << 24 | 64 << 16 | 0), P.bits = ze, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(t, n, s) {
      n.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(t, n, s) {
      var o = t("../utils/common"), h = 0, c = 1;
      function m(ke) {
        for (var Je = ke.length; 0 <= --Je; )
          ke[Je] = 0;
      }
      var x = 0, B = 29, I = 256, F = I + 1 + B, M = 30, Z = 19, V = 2 * F + 1, te = 15, P = 16, K = 7, J = 256, le = 16, fe = 17, X = 18, W = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], je = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], Ee = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], He = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], ft = new Array(2 * (F + 2));
      m(ft);
      var Le = new Array(2 * M);
      m(Le);
      var $e = new Array(512);
      m($e);
      var ce = new Array(256);
      m(ce);
      var ut = new Array(B);
      m(ut);
      var ze, pt, qt, We = new Array(M);
      function Et(ke, Je, kt, vt, Qe) {
        this.static_tree = ke, this.extra_bits = Je, this.extra_base = kt, this.elems = vt, this.max_length = Qe, this.has_stree = ke && ke.length;
      }
      function rt(ke, Je) {
        this.dyn_tree = ke, this.max_code = 0, this.stat_desc = Je;
      }
      function it(ke) {
        return ke < 256 ? $e[ke] : $e[256 + (ke >>> 7)];
      }
      function Zt(ke, Je) {
        ke.pending_buf[ke.pending++] = 255 & Je, ke.pending_buf[ke.pending++] = Je >>> 8 & 255;
      }
      function $t(ke, Je, kt) {
        ke.bi_valid > P - kt ? (ke.bi_buf |= Je << ke.bi_valid & 65535, Zt(ke, ke.bi_buf), ke.bi_buf = Je >> P - ke.bi_valid, ke.bi_valid += kt - P) : (ke.bi_buf |= Je << ke.bi_valid & 65535, ke.bi_valid += kt);
      }
      function Lt(ke, Je, kt) {
        $t(ke, kt[2 * Je], kt[2 * Je + 1]);
      }
      function ii(ke, Je) {
        for (var kt = 0; kt |= 1 & ke, ke >>>= 1, kt <<= 1, 0 < --Je; )
          ;
        return kt >>> 1;
      }
      function Ci(ke, Je, kt) {
        var vt, Qe, wt = new Array(te + 1), Yt = 0;
        for (vt = 1; vt <= te; vt++)
          wt[vt] = Yt = Yt + kt[vt - 1] << 1;
        for (Qe = 0; Qe <= Je; Qe++) {
          var Ye = ke[2 * Qe + 1];
          Ye !== 0 && (ke[2 * Qe] = ii(wt[Ye]++, Ye));
        }
      }
      function ui(ke) {
        var Je;
        for (Je = 0; Je < F; Je++)
          ke.dyn_ltree[2 * Je] = 0;
        for (Je = 0; Je < M; Je++)
          ke.dyn_dtree[2 * Je] = 0;
        for (Je = 0; Je < Z; Je++)
          ke.bl_tree[2 * Je] = 0;
        ke.dyn_ltree[2 * J] = 1, ke.opt_len = ke.static_len = 0, ke.last_lit = ke.matches = 0;
      }
      function Gt(ke) {
        8 < ke.bi_valid ? Zt(ke, ke.bi_buf) : 0 < ke.bi_valid && (ke.pending_buf[ke.pending++] = ke.bi_buf), ke.bi_buf = 0, ke.bi_valid = 0;
      }
      function Xt(ke, Je, kt, vt) {
        var Qe = 2 * Je, wt = 2 * kt;
        return ke[Qe] < ke[wt] || ke[Qe] === ke[wt] && vt[Je] <= vt[kt];
      }
      function Qt(ke, Je, kt) {
        for (var vt = ke.heap[kt], Qe = kt << 1; Qe <= ke.heap_len && (Qe < ke.heap_len && Xt(Je, ke.heap[Qe + 1], ke.heap[Qe], ke.depth) && Qe++, !Xt(Je, vt, ke.heap[Qe], ke.depth)); )
          ke.heap[kt] = ke.heap[Qe], kt = Qe, Qe <<= 1;
        ke.heap[kt] = vt;
      }
      function Ni(ke, Je, kt) {
        var vt, Qe, wt, Yt, Ye = 0;
        if (ke.last_lit !== 0)
          for (; vt = ke.pending_buf[ke.d_buf + 2 * Ye] << 8 | ke.pending_buf[ke.d_buf + 2 * Ye + 1], Qe = ke.pending_buf[ke.l_buf + Ye], Ye++, vt === 0 ? Lt(ke, Qe, Je) : (Lt(ke, (wt = ce[Qe]) + I + 1, Je), (Yt = W[wt]) !== 0 && $t(ke, Qe -= ut[wt], Yt), Lt(ke, wt = it(--vt), kt), (Yt = je[wt]) !== 0 && $t(ke, vt -= We[wt], Yt)), Ye < ke.last_lit; )
            ;
        Lt(ke, J, Je);
      }
      function Di(ke, Je) {
        var kt, vt, Qe, wt = Je.dyn_tree, Yt = Je.stat_desc.static_tree, Ye = Je.stat_desc.has_stree, i = Je.stat_desc.elems, r = -1;
        for (ke.heap_len = 0, ke.heap_max = V, kt = 0; kt < i; kt++)
          wt[2 * kt] !== 0 ? (ke.heap[++ke.heap_len] = r = kt, ke.depth[kt] = 0) : wt[2 * kt + 1] = 0;
        for (; ke.heap_len < 2; )
          wt[2 * (Qe = ke.heap[++ke.heap_len] = r < 2 ? ++r : 0)] = 1, ke.depth[Qe] = 0, ke.opt_len--, Ye && (ke.static_len -= Yt[2 * Qe + 1]);
        for (Je.max_code = r, kt = ke.heap_len >> 1; 1 <= kt; kt--)
          Qt(ke, wt, kt);
        for (Qe = i; kt = ke.heap[1], ke.heap[1] = ke.heap[ke.heap_len--], Qt(ke, wt, 1), vt = ke.heap[1], ke.heap[--ke.heap_max] = kt, ke.heap[--ke.heap_max] = vt, wt[2 * Qe] = wt[2 * kt] + wt[2 * vt], ke.depth[Qe] = (ke.depth[kt] >= ke.depth[vt] ? ke.depth[kt] : ke.depth[vt]) + 1, wt[2 * kt + 1] = wt[2 * vt + 1] = Qe, ke.heap[1] = Qe++, Qt(ke, wt, 1), 2 <= ke.heap_len; )
          ;
        ke.heap[--ke.heap_max] = ke.heap[1], function(a, l) {
          var u, d, v, p, b, S, L = l.dyn_tree, E = l.max_code, A = l.stat_desc.static_tree, T = l.stat_desc.has_stree, G = l.stat_desc.extra_bits, D = l.stat_desc.extra_base, Y = l.stat_desc.max_length, k = 0;
          for (p = 0; p <= te; p++)
            a.bl_count[p] = 0;
          for (L[2 * a.heap[a.heap_max] + 1] = 0, u = a.heap_max + 1; u < V; u++)
            Y < (p = L[2 * L[2 * (d = a.heap[u]) + 1] + 1] + 1) && (p = Y, k++), L[2 * d + 1] = p, E < d || (a.bl_count[p]++, b = 0, D <= d && (b = G[d - D]), S = L[2 * d], a.opt_len += S * (p + b), T && (a.static_len += S * (A[2 * d + 1] + b)));
          if (k !== 0) {
            do {
              for (p = Y - 1; a.bl_count[p] === 0; )
                p--;
              a.bl_count[p]--, a.bl_count[p + 1] += 2, a.bl_count[Y]--, k -= 2;
            } while (0 < k);
            for (p = Y; p !== 0; p--)
              for (d = a.bl_count[p]; d !== 0; )
                E < (v = a.heap[--u]) || (L[2 * v + 1] !== p && (a.opt_len += (p - L[2 * v + 1]) * L[2 * v], L[2 * v + 1] = p), d--);
          }
        }(ke, Je), Ci(wt, r, ke.bl_count);
      }
      function pe(ke, Je, kt) {
        var vt, Qe, wt = -1, Yt = Je[1], Ye = 0, i = 7, r = 4;
        for (Yt === 0 && (i = 138, r = 3), Je[2 * (kt + 1) + 1] = 65535, vt = 0; vt <= kt; vt++)
          Qe = Yt, Yt = Je[2 * (vt + 1) + 1], ++Ye < i && Qe === Yt || (Ye < r ? ke.bl_tree[2 * Qe] += Ye : Qe !== 0 ? (Qe !== wt && ke.bl_tree[2 * Qe]++, ke.bl_tree[2 * le]++) : Ye <= 10 ? ke.bl_tree[2 * fe]++ : ke.bl_tree[2 * X]++, wt = Qe, r = (Ye = 0) === Yt ? (i = 138, 3) : Qe === Yt ? (i = 6, 3) : (i = 7, 4));
      }
      function xt(ke, Je, kt) {
        var vt, Qe, wt = -1, Yt = Je[1], Ye = 0, i = 7, r = 4;
        for (Yt === 0 && (i = 138, r = 3), vt = 0; vt <= kt; vt++)
          if (Qe = Yt, Yt = Je[2 * (vt + 1) + 1], !(++Ye < i && Qe === Yt)) {
            if (Ye < r)
              for (; Lt(ke, Qe, ke.bl_tree), --Ye != 0; )
                ;
            else
              Qe !== 0 ? (Qe !== wt && (Lt(ke, Qe, ke.bl_tree), Ye--), Lt(ke, le, ke.bl_tree), $t(ke, Ye - 3, 2)) : Ye <= 10 ? (Lt(ke, fe, ke.bl_tree), $t(ke, Ye - 3, 3)) : (Lt(ke, X, ke.bl_tree), $t(ke, Ye - 11, 7));
            wt = Qe, r = (Ye = 0) === Yt ? (i = 138, 3) : Qe === Yt ? (i = 6, 3) : (i = 7, 4);
          }
      }
      m(We);
      var tt = !1;
      function Pe(ke, Je, kt, vt) {
        $t(ke, (x << 1) + (vt ? 1 : 0), 3), function(Qe, wt, Yt, Ye) {
          Gt(Qe), Ye && (Zt(Qe, Yt), Zt(Qe, ~Yt)), o.arraySet(Qe.pending_buf, Qe.window, wt, Yt, Qe.pending), Qe.pending += Yt;
        }(ke, Je, kt, !0);
      }
      s._tr_init = function(ke) {
        tt || (function() {
          var Je, kt, vt, Qe, wt, Yt = new Array(te + 1);
          for (Qe = vt = 0; Qe < B - 1; Qe++)
            for (ut[Qe] = vt, Je = 0; Je < 1 << W[Qe]; Je++)
              ce[vt++] = Qe;
          for (ce[vt - 1] = Qe, Qe = wt = 0; Qe < 16; Qe++)
            for (We[Qe] = wt, Je = 0; Je < 1 << je[Qe]; Je++)
              $e[wt++] = Qe;
          for (wt >>= 7; Qe < M; Qe++)
            for (We[Qe] = wt << 7, Je = 0; Je < 1 << je[Qe] - 7; Je++)
              $e[256 + wt++] = Qe;
          for (kt = 0; kt <= te; kt++)
            Yt[kt] = 0;
          for (Je = 0; Je <= 143; )
            ft[2 * Je + 1] = 8, Je++, Yt[8]++;
          for (; Je <= 255; )
            ft[2 * Je + 1] = 9, Je++, Yt[9]++;
          for (; Je <= 279; )
            ft[2 * Je + 1] = 7, Je++, Yt[7]++;
          for (; Je <= 287; )
            ft[2 * Je + 1] = 8, Je++, Yt[8]++;
          for (Ci(ft, F + 1, Yt), Je = 0; Je < M; Je++)
            Le[2 * Je + 1] = 5, Le[2 * Je] = ii(Je, 5);
          ze = new Et(ft, W, I + 1, F, te), pt = new Et(Le, je, 0, M, te), qt = new Et(new Array(0), Ee, 0, Z, K);
        }(), tt = !0), ke.l_desc = new rt(ke.dyn_ltree, ze), ke.d_desc = new rt(ke.dyn_dtree, pt), ke.bl_desc = new rt(ke.bl_tree, qt), ke.bi_buf = 0, ke.bi_valid = 0, ui(ke);
      }, s._tr_stored_block = Pe, s._tr_flush_block = function(ke, Je, kt, vt) {
        var Qe, wt, Yt = 0;
        0 < ke.level ? (ke.strm.data_type === 2 && (ke.strm.data_type = function(Ye) {
          var i, r = 4093624447;
          for (i = 0; i <= 31; i++, r >>>= 1)
            if (1 & r && Ye.dyn_ltree[2 * i] !== 0)
              return h;
          if (Ye.dyn_ltree[18] !== 0 || Ye.dyn_ltree[20] !== 0 || Ye.dyn_ltree[26] !== 0)
            return c;
          for (i = 32; i < I; i++)
            if (Ye.dyn_ltree[2 * i] !== 0)
              return c;
          return h;
        }(ke)), Di(ke, ke.l_desc), Di(ke, ke.d_desc), Yt = function(Ye) {
          var i;
          for (pe(Ye, Ye.dyn_ltree, Ye.l_desc.max_code), pe(Ye, Ye.dyn_dtree, Ye.d_desc.max_code), Di(Ye, Ye.bl_desc), i = Z - 1; 3 <= i && Ye.bl_tree[2 * He[i] + 1] === 0; i--)
            ;
          return Ye.opt_len += 3 * (i + 1) + 5 + 5 + 4, i;
        }(ke), Qe = ke.opt_len + 3 + 7 >>> 3, (wt = ke.static_len + 3 + 7 >>> 3) <= Qe && (Qe = wt)) : Qe = wt = kt + 5, kt + 4 <= Qe && Je !== -1 ? Pe(ke, Je, kt, vt) : ke.strategy === 4 || wt === Qe ? ($t(ke, 2 + (vt ? 1 : 0), 3), Ni(ke, ft, Le)) : ($t(ke, 4 + (vt ? 1 : 0), 3), function(Ye, i, r, a) {
          var l;
          for ($t(Ye, i - 257, 5), $t(Ye, r - 1, 5), $t(Ye, a - 4, 4), l = 0; l < a; l++)
            $t(Ye, Ye.bl_tree[2 * He[l] + 1], 3);
          xt(Ye, Ye.dyn_ltree, i - 1), xt(Ye, Ye.dyn_dtree, r - 1);
        }(ke, ke.l_desc.max_code + 1, ke.d_desc.max_code + 1, Yt + 1), Ni(ke, ke.dyn_ltree, ke.dyn_dtree)), ui(ke), vt && Gt(ke);
      }, s._tr_tally = function(ke, Je, kt) {
        return ke.pending_buf[ke.d_buf + 2 * ke.last_lit] = Je >>> 8 & 255, ke.pending_buf[ke.d_buf + 2 * ke.last_lit + 1] = 255 & Je, ke.pending_buf[ke.l_buf + ke.last_lit] = 255 & kt, ke.last_lit++, Je === 0 ? ke.dyn_ltree[2 * kt]++ : (ke.matches++, Je--, ke.dyn_ltree[2 * (ce[kt] + I + 1)]++, ke.dyn_dtree[2 * it(Je)]++), ke.last_lit === ke.lit_bufsize - 1;
      }, s._tr_align = function(ke) {
        $t(ke, 2, 3), Lt(ke, J, ft), function(Je) {
          Je.bi_valid === 16 ? (Zt(Je, Je.bi_buf), Je.bi_buf = 0, Je.bi_valid = 0) : 8 <= Je.bi_valid && (Je.pending_buf[Je.pending++] = 255 & Je.bi_buf, Je.bi_buf >>= 8, Je.bi_valid -= 8);
        }(ke);
      };
    }, { "../utils/common": 41 }], 53: [function(t, n, s) {
      n.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(t, n, s) {
      (function(o) {
        (function(h, c) {
          if (!h.setImmediate) {
            var m, x, B, I, F = 1, M = {}, Z = !1, V = h.document, te = Object.getPrototypeOf && Object.getPrototypeOf(h);
            te = te && te.setTimeout ? te : h, m = {}.toString.call(h.process) === "[object process]" ? function(le) {
              process.nextTick(function() {
                K(le);
              });
            } : function() {
              if (h.postMessage && !h.importScripts) {
                var le = !0, fe = h.onmessage;
                return h.onmessage = function() {
                  le = !1;
                }, h.postMessage("", "*"), h.onmessage = fe, le;
              }
            }() ? (I = "setImmediate$" + Math.random() + "$", h.addEventListener ? h.addEventListener("message", J, !1) : h.attachEvent("onmessage", J), function(le) {
              h.postMessage(I + le, "*");
            }) : h.MessageChannel ? ((B = new MessageChannel()).port1.onmessage = function(le) {
              K(le.data);
            }, function(le) {
              B.port2.postMessage(le);
            }) : V && "onreadystatechange" in V.createElement("script") ? (x = V.documentElement, function(le) {
              var fe = V.createElement("script");
              fe.onreadystatechange = function() {
                K(le), fe.onreadystatechange = null, x.removeChild(fe), fe = null;
              }, x.appendChild(fe);
            }) : function(le) {
              setTimeout(K, 0, le);
            }, te.setImmediate = function(le) {
              typeof le != "function" && (le = new Function("" + le));
              for (var fe = new Array(arguments.length - 1), X = 0; X < fe.length; X++)
                fe[X] = arguments[X + 1];
              var W = { callback: le, args: fe };
              return M[F] = W, m(F), F++;
            }, te.clearImmediate = P;
          }
          function P(le) {
            delete M[le];
          }
          function K(le) {
            if (Z)
              setTimeout(K, 0, le);
            else {
              var fe = M[le];
              if (fe) {
                Z = !0;
                try {
                  (function(X) {
                    var W = X.callback, je = X.args;
                    switch (je.length) {
                      case 0:
                        W();
                        break;
                      case 1:
                        W(je[0]);
                        break;
                      case 2:
                        W(je[0], je[1]);
                        break;
                      case 3:
                        W(je[0], je[1], je[2]);
                        break;
                      default:
                        W.apply(c, je);
                    }
                  })(fe);
                } finally {
                  P(le), Z = !1;
                }
              }
            }
          }
          function J(le) {
            le.source === h && typeof le.data == "string" && le.data.indexOf(I) === 0 && K(+le.data.slice(I.length));
          }
        })(typeof self > "u" ? o === void 0 ? this : o : self);
      }).call(this, typeof as < "u" ? as : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(Yd);
var fw = Yd.exports;
const Kf = /* @__PURE__ */ pu(fw), Gd = class Mn {
  constructor(e) {
    this._hemiLight = null, this._pointLight = null, this._onPrePointerObservableObserver = null, this._isPointerDown = !1, this._radiusScale = 1.05, this._positionScale = 0.5, this._limitLowerRadius = !0, this._zoomEnabled = !0, this._minZoomPerc = null, this._maxZoomPerc = null, this._cameraZoom = null, this._minZObserver = null, this._cameraPivot = null, this._resizableCanvas3DGenerator = new ab(), this.parentNode = null, this.enableShadows = !1, this.areShadowVisible = !0, this.setInitialZoomToBoundingBox = !0, this.changeRotationDirection = !1, this.initialZoomToBBInertiaDamping = 0.68, this._initialZoomToBBModelSizeRadius = 0.7, this.initialZoomToBBScrollZoomEnabled = !0, this.initialZoomToBBScrollLowerLimit = 2, this.initialZoomToBBScrollUpperLimit = 2, this.animateIntro = !1, this._defHemiLightID = "f90aba65-3b60-44ac-87f4-1b6441aee44b", this._defPointLightID = "b6491635-c471-45a4-bbb8-3f08556e5b3c", this._targetAnimationID = "6225769c-0113-4236-ab17-c39d24013de4", this._radiusAnimationID = "6f946c2f-af8d-46ab-9bea-9e22dedc4e9d", this._alphaAnimationID = "10713520-fe06-4cbf-bc6a-bab881d516e6", this._betaAnimationID = "6096ba34-852a-4423-bab3-dc97c1a9268f", this._dummyMaterialID = "081796b8-0908-44dc-a38a-d786b14cA6fc", this._loadingMaterials = {}, this._authorizationToken = null, this.getVTOMeshes = () => {
      const t = [
        "vto_reference",
        "ground",
        "shadowGround",
        "shadow",
        "skybox",
        "environment",
        "axes",
        "grid",
        "boundingbox",
        "highlight",
        "EditControl",
        "guideCtl",
        "bxAxis",
        "byAxis",
        "bzAxis",
        "xAxis",
        "yAxis",
        "zAxis",
        "pALL",
        "pXZ",
        "pZY",
        "pYX",
        "pickPlanes",
        "tarnsCtl",
        "X",
        "Y",
        "Z",
        "XZ",
        "ZY",
        "YX",
        "ALL",
        "tEndX",
        "tEndY",
        "tEndZ",
        "XZ",
        "ZY",
        "YX",
        "tEndAll"
      ], n = (c) => t.filter((m) => c.toLowerCase() === m.toLowerCase()).length > 0, s = (c) => c.toLowerCase().includes("vto_reference"), o = this._scene.meshes.filter((c) => s(c.name)), h = this._scene.meshes.filter((c) => !n(c.name) && !s(c.name));
      return {
        tryonReferencesModels: o,
        userMeshes: h
      };
    }, this._loadedMeshes = [], this._isLoading = !1, this._lastVisibilityStates = /* @__PURE__ */ new Map(), this._scene = e, this._engine = e.getEngine(), this._camera = e.activeCamera, this._canvas = e.getEngine().getRenderingCanvas(), this.init();
  }
  get initialZoomToBBModelSizeRadius() {
    return console.log("Getting initialZoomToBBModelSizeRadius: ", this._initialZoomToBBModelSizeRadius), this._initialZoomToBBModelSizeRadius;
  }
  set initialZoomToBBModelSizeRadius(e) {
    console.log("Setting initialZoomToBBModelSizeRadius to: ", e), this._initialZoomToBBModelSizeRadius = e;
  }
  get camera() {
    return this._camera;
  }
  /**
   * Imposta il token di autorizzazione per le chiamate API
   * @param token Il token di autorizzazione
   */
  setAuthorizationToken(e) {
    this._authorizationToken = e;
  }
  /**
   * Ottiene il token di autorizzazione attualmente impostato
   * @returns Il token di autorizzazione o null se non impostato
   */
  getAuthorizationToken() {
    return this._authorizationToken;
  }
  static checkAllMaterialTextureReady(e) {
    const t = e.getActiveTextures();
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      if (s.isReady())
        s instanceof BABYLON.ProceduralTexture && s.getEffect();
      else
        return !1;
    }
    return !0;
  }
  removeDefaultBackground(e) {
    e && (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0));
  }
  setUpSceneToneMapping(e) {
    var h, c, m, x;
    const t = (h = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : h.get("toneMappingEnabled");
    t != null && (this._scene.imageProcessingConfiguration.toneMappingEnabled = t);
    const n = (c = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : c.get("toneMappingType");
    n != null && (this._scene.imageProcessingConfiguration.toneMappingType = n);
    const s = (m = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : m.get("exposure"), o = (x = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : x.get("contrast");
    o && (this._scene.imageProcessingConfiguration.contrast = o), s && (this._scene.imageProcessingConfiguration.exposure = s);
  }
  cleanUnusedMaterialsMappings(e) {
    if (!e)
      return;
    const t = e.get("materialMappings"), n = this.getAllMaterials().filter((o) => t.find((h) => h.get("sceneMaterialID") === o.id)), s = new Zakeke.SceneMaterialMappings();
    for (const o of t.toArray()) {
      const h = o.get("sceneMaterialID");
      n.find((c) => c.id === h) ? s.push(o) : e.removeMappingForSceneMaterial(h);
    }
    e.set("materialMappings", s);
  }
  static whenAllMaterialTexturesAreReady(e) {
    return new Promise((t, n) => {
      if (this.checkAllMaterialTextureReady(e))
        t();
      else {
        let s = setInterval(() => {
          this.checkAllMaterialTextureReady(e) && (clearInterval(s), t());
        }, 5);
      }
    });
  }
  static whenTextureIsReadyAsync(e) {
    return new Promise((t, n) => {
      if (e.isReady())
        t();
      else {
        let s = setInterval(() => {
          e.isReady() && (clearInterval(s), e instanceof BABYLON.ProceduralTexture && e.getEffect(), t());
        }, 5);
      }
    });
  }
  static whenMeshMaterialIsReady(e) {
    return new Promise((t, n) => {
      let s = setInterval(() => {
        (!e.material || e.material.isReady(e)) && (clearInterval(s), t());
      }, 5);
    });
  }
  static whenMaterialIsReadyForSubMeshAsync(e, t, n) {
    return new Promise((s, o) => {
      if (e.isReadyForSubMesh(t, n))
        Logger.info(`Material ${e.name} ready`), s();
      else {
        Logger.info(`Material ${e.name} NOT ready`);
        let h = setInterval(() => {
          e.isReadyForSubMesh(t, n) && (!t.material || t.material != e || t.material.isReady(t)) && (Logger.info(`Material ${e.name} ready`), clearInterval(h), s());
        }, 5);
      }
    });
  }
  static getMeshGeometry(e) {
    if (e.geometry)
      return e.geometry;
    const n = e.getScene().getGeometries();
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      if (o.meshes.find((h) => h === e))
        return o;
    }
    return null;
  }
  static checkMeshIsReady(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e._checkDelayState(), e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED)
        return !1;
      if (!e.geometry) {
        const n = e.getScene().getGeometries();
        for (let s = 0; s < n.length; s++) {
          const o = n[s];
          if (o.meshes.find((h) => h === e) && !o.isReady())
            return !1;
        }
      }
      if (e.geometry && !e.geometry.isReady())
        return !1;
      for (let t = 0; t < e.getChildMeshes().length; t++) {
        const n = e.getChildMeshes()[t];
        if (!this.checkMeshIsReady(n))
          return !1;
      }
    }
    return e.isReady(!0);
  }
  static checkAllMeshesAreReady(e) {
    let t = !0;
    for (let n = 0; n < e.length; n++)
      this.checkMeshIsReady(e[n]) || (t = !1);
    return t;
  }
  static whenAllMeshesAreReadyAsync(e) {
    return new Promise((t, n) => {
      if (this.checkAllMeshesAreReady(e))
        t();
      else {
        let s = setInterval(() => {
          this.checkAllMeshesAreReady(e) && (clearInterval(s), t());
        }, 5);
      }
    });
  }
  static async whenAllVisibleMeshesAreReadyAsync(e) {
    await this.whenAllMeshesAreReadyAsync(e);
  }
  static whenMeshIsReadyAsync(e) {
    return new Promise((t, n) => {
      if (this.checkMeshIsReady(e))
        t();
      else {
        let s = setInterval(() => {
          this.checkMeshIsReady(e) && (clearInterval(s), t());
        }, 100);
      }
    });
  }
  static visibleMeshesRequireDelayedLoading(e) {
    const t = e.meshes.filter((n) => n.isVisible);
    for (let n = 0; n < t.length; n++)
      if (this.meshRequiresDelayedLoading(t[n]))
        return !0;
    return !1;
  }
  static meshRequiresDelayedLoading(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED || e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING)
        return !0;
      const t = Mn.getMeshGeometry(e);
      if (t && (t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING || t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED))
        return !0;
    }
    return !1;
  }
  materialRequiresDelayedLoading(e) {
    return this._scene.getMaterialByID(e) ? !1 : !!(this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) || this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e));
  }
  /**
   * Recupera il token di autenticazione con strategia di fallback
   * @returns Il token di autenticazione o null se non trovato
   */
  getAuthToken() {
    if (this._authorizationToken && this._authorizationToken.trim() !== "")
      return this._authorizationToken;
    if (window.token && typeof window.token == "string" && window.token.trim() !== "")
      return window.token;
    try {
      console.log("strategia cookie");
      const e = document.cookie.split(";");
      for (let t of e) {
        const [n, s] = t.trim().split("=");
        if (n === "zakeke_token" && s && s.trim() !== "")
          return decodeURIComponent(s);
      }
    } catch (e) {
      console.warn("Error accessing cookies for zakeke_token:", e);
    }
    try {
      if (this._scene && this._scene.metadata && this._scene.metadata.viewer) {
        const e = this._scene.metadata.viewer;
        if (e._authorizationToken && typeof e._authorizationToken == "string" && e._authorizationToken.trim() !== "")
          return e._authorizationToken;
      }
      if (window.sceneEditor && window.sceneEditor._authorizationToken) {
        const e = window.sceneEditor._authorizationToken;
        if (e && typeof e == "string" && e.trim() !== "")
          return e;
      }
      if (window.sceneViewer && window.sceneViewer._authorizationToken) {
        const e = window.sceneViewer._authorizationToken;
        if (e && typeof e == "string" && e.trim() !== "")
          return e;
      }
    } catch (e) {
      console.warn("Error accessing viewer/editor token:", e);
    }
    if (typeof MPlaza < "u" && MPlaza.UserIdentity)
      try {
        if (window.userIdentity && typeof window.userIdentity.get == "function") {
          const e = window.userIdentity.get("token");
          if (e && typeof e == "string" && e.trim() !== "")
            return e;
        }
      } catch (e) {
        console.warn("Error accessing MPlaza.UserIdentity token:", e);
      }
    if (this._scene.metadata && this._scene.metadata.authToken) {
      const e = this._scene.metadata.authToken;
      if (e && typeof e == "string" && e.trim() !== "")
        return e;
    }
    if (typeof Zakeke < "u" && Zakeke.config)
      try {
        const e = Zakeke.config;
        if (e.authToken && typeof e.authToken == "string" && e.authToken.trim() !== "")
          return e.authToken;
        if (e.token && typeof e.token == "string" && e.token.trim() !== "")
          return e.token;
      } catch (e) {
        console.warn("Error accessing Zakeke.config token:", e);
      }
    try {
      const e = localStorage.getItem("authToken") || localStorage.getItem("token") || localStorage.getItem("zakeke_token");
      if (e && e.trim() !== "")
        return e;
    } catch (e) {
      console.warn("Error accessing localStorage token:", e);
    }
    try {
      const e = sessionStorage.getItem("authToken") || sessionStorage.getItem("token") || sessionStorage.getItem("zakeke_token");
      if (e && e.trim() !== "")
        return e;
    } catch (e) {
      console.warn("Error accessing sessionStorage token:", e);
    }
    return console.warn("No authentication token found in any fallback strategy"), null;
  }
  init() {
    this._onPrePointerObservableObserver = this._scene.onPrePointerObservable.add((e) => {
      if (e.type === BABYLON.PointerEventTypes.POINTERDOWN) {
        this._isPointerDown = !0;
        return;
      }
      e.type === BABYLON.PointerEventTypes.POINTERUP && (this._isPointerDown = !1);
    });
  }
  dispose() {
    this._scene && this._onPrePointerObservableObserver && this._scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver), this._camera && this._minZObserver && (this._camera.onAfterCheckInputsObservable.remove(this._minZObserver), this._minZObserver = null);
  }
  switchFullScreen(e) {
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement ? this.quitFullscreen(e || this._canvas) : this.launchFullscreen(e || this._canvas), this._canvas && (this._canvas.width = document.body.clientWidth, this._canvas.height = document.body.clientHeight, this.adjustCamera(void 0, !0, !0, !1));
  }
  quitFullscreen(e) {
    let t = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen;
    t && t.call(document);
  }
  launchFullscreen(e) {
    let t = e.requestFullscreen || e.webkitRequestFullscreen || e.msRequestFullscreen || e.mozRequestFullScreen;
    t && t.call(e);
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    const t = e.getHierarchyBoundingVectors(!0), n = t.max.subtract(t.min);
    return t.min.add(n.scale(0.5));
  }
  getSceneBoundingInfo() {
    if (!this._scene)
      return null;
    const e = this.getWorldExtends();
    return e ? new BABYLON.BoundingInfo(e.min, e.max) : null;
  }
  setupShadows(e) {
    var fe, X, W, je, Ee, He, ft, Le, $e, ce, ut, ze, pt, qt, We, Et, rt;
    if (!e)
      return;
    const t = (fe = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : fe.get("enableShadows");
    t != null && (this.enableShadows = t), this.areShadowVisible || (this.enableShadows = !1);
    const n = (X = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : X.get("shadowMapSize"), s = (W = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : W.get("contactHardeningUVRatio"), o = (je = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : je.get("useContactHardeningShadow"), h = (Ee = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ee.get("useBlurCloseExponentialShadowMap"), c = (He = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : He.get("usePercentageCloserFiltering"), m = (ft = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ft.get("usePoissonSampling"), x = (Le = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Le.get("useKernelBlur"), B = ($e = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : $e.get("blurBoxOffset"), I = (ce = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ce.get("blurScale"), F = (ut = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ut.get("blurKernel"), M = (ze = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ze.get("depthScale"), Z = (pt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : pt.get("shadowDarkness"), V = (qt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : qt.get("shadowMinZ"), te = (We = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : We.get("shadowMaxZ");
    if (!this.enableShadows) {
      const it = (Et = this._scene) == null ? void 0 : Et.getMeshByName("shadowGround");
      it && it.dispose();
      const Zt = (rt = this._scene) == null ? void 0 : rt.getMaterialByName("shadowMaterial");
      Zt && Zt.dispose();
      const $t = this._scene.getLightByName("shadowDirectionalLight");
      $t && $t.dispose();
      return;
    }
    if (!this._scene)
      throw new Error("Scene is not defined");
    const P = this._scene.getLightByName("shadowDirectionalLight"), K = new BABYLON.Vector3(0, -2, 0), J = P ?? new BABYLON.DirectionalLight("shadowDirectionalLight", K, this._scene);
    J.intensity = 0, J.shadowMinZ = V ?? void 0, J.shadowMaxZ = te ?? void 0, Mn._shadowGenerator = new BABYLON.ShadowGenerator(Number(n), J), Mn._shadowGenerator.usePoissonSampling = !!m, Mn._shadowGenerator.usePercentageCloserFiltering = !!c, Mn._shadowGenerator.useBlurCloseExponentialShadowMap = !!h, Mn._shadowGenerator.useKernelBlur = !!x, Mn._shadowGenerator.blurBoxOffset = Number(B), Mn._shadowGenerator.blurScale = Number(I), Mn._shadowGenerator.blurKernel = Number(F), Mn._shadowGenerator.depthScale = Number(M), Mn._shadowGenerator.setDarkness(Number(Z)), Mn._shadowGenerator.useContactHardeningShadow = !!o, Mn._shadowGenerator.contactHardeningLightSizeUVRatio = Number(s), Mn._shadowGenerator.transparencyShadow = !0, Mn._shadowGenerator.enableSoftTransparentShadow = !0;
    const le = Mn._shadowGenerator.getShadowMap();
    this._scene.meshes.forEach((it) => {
      var Zt;
      (Zt = le == null ? void 0 : le.renderList) == null || Zt.push(it);
    }), this.createGroundFromBoundingBox(e);
  }
  setShadowsVisibility(e) {
    Mn._shadowGenerator && (this.areShadowVisible = e);
  }
  pauseAllAnimations() {
    var e;
    this._scene && ((e = this._scene.animationGroups) == null || e.forEach((t) => t.pause()));
  }
  /**
   * Deprecated (keeping only for backwards-compat), use pauseAllAnimations instead or _scene
   * directly
   */
  stopAllAnimations() {
    this.pauseAllAnimations();
  }
  hasAnimations() {
    return this._scene ? this._scene.animationGroups.length > 0 : !1;
  }
  playAnimations() {
    this._scene && this.hasAnimations() && this._scene.animationGroups[0].play();
  }
  setupAnimations(e) {
    var m;
    const t = e == null ? void 0 : e.getAnimationsConfig(), n = !!(t != null && t.get("runAtStart")), s = !!(t != null && t.get("loop")), o = (t == null ? void 0 : t.get("speed")) || 1, h = (m = this._scene) == null ? void 0 : m.animationGroups, c = h && this._scene.animationGroups.length > 0;
    if (h && h.forEach((x) => {
      x.stop(), x.reset();
    }), n && c) {
      const x = h[0];
      x.start(s, o, x.from, x.to, !1);
    }
  }
  createGroundFromBoundingBox(e) {
    var M, Z, V, te, P, K, J, le, fe;
    if (!e)
      return;
    const t = (M = this._scene) == null ? void 0 : M.getMeshByName("shadowGround");
    t && t.dispose();
    const n = (Z = this._scene) == null ? void 0 : Z.getMaterialByName("shadowMaterial");
    n && n.dispose();
    const s = (V = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : V.get("enableShadows");
    if (s != null && (this.enableShadows = s), !this.enableShadows) {
      console.log("Shadows are not enabled");
      return;
    }
    const o = this.getSceneBoundingInfo();
    if (!o || !o.boundingBox) {
      console.error("Cannot create ground: No bounding box information available.");
      return;
    }
    const h = (te = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : te.get("shadowHexColor"), c = (P = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : P.get("groundSizeMultiplierWidth"), m = (K = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : K.get("groundSizeMultiplierLength"), x = o.boundingBox.minimumWorld, I = o.boundingBox.maximumWorld.subtract(x), F = x.add(I.scale(0.5));
    if (this._scene !== null) {
      const X = BABYLON.MeshBuilder.CreateGround(
        "shadowGround",
        {
          width: I.x * Number(c),
          height: I.z * Number(m)
        },
        this._scene
      );
      X.position = new BABYLON.Vector3(F.x, x.y, F.z), X.rotation.y = Math.PI;
      const W = new BABYLON.ShadowOnlyMaterial("bbmat", this._scene);
      X.material = W, X.receiveShadows = !0, X.material.shadowColor = BABYLON.Color3.FromHexString(
        String(h)
      ), X.metadata = { AR: !1, isRealMesh: !1 };
      const je = (J = Mn._shadowGenerator) == null ? void 0 : J.getShadowMap();
      Mn._shadowGenerator && je ? ((le = je.renderList) == null || le.push(X), X.receiveShadows = !0) : console.error("Failed to add ground mesh to shadow map render list.");
    } else
      console.error("Cannot create ground: Scene is null.");
    console.log("Shadow ground created"), (fe = this._scene) == null || fe.render();
  }
  userIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0 || this._isPointerDown;
  }
  cameraIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0;
  }
  cameraLimitsReached() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.lowerRadiusLimit !== void 0 && this._camera.lowerRadiusLimit !== null && this._camera.radius === this._camera.lowerRadiusLimit || this._camera.upperRadiusLimit !== void 0 && this._camera.upperRadiusLimit !== null && this._camera.radius === this._camera.upperRadiusLimit;
  }
  restoreCameraState() {
    this._camera && this._camera.restoreState();
  }
  isTextureWithUrl(e) {
    return e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture);
  }
  getTextureUrl(e) {
    if (e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture)) {
      let t = e.url;
      if (e.getInternalTexture) {
        const n = e.getInternalTexture();
        n && n.url && (t = n.url);
      }
      return t;
    }
    return null;
  }
  isEditControl(e) {
    return e && (e.name == "EditoControl" || e.metadata && e.metadata.isEditControl);
  }
  isRealMesh(e) {
    return !(this.isEditControl(e) || e.metadata && (e.metadata.boundingBox || e.metadata.isAxis || e.metadata.isGround || e.metadata.isEnvironmentNode || e.metadata.hasOwnProperty("isRealMesh") && !e.metadata.isRealMesh));
  }
  meshFineTuningSettings(e) {
    return e.metadata && e.metadata.hasOwnProperty("tryOnFineTuningSettings") && e.metadata.tryOnFineTuningSettings ? e.metadata.tryOnFineTuningSettings : null;
  }
  meshHasParent(e, t) {
    if (this._scene) {
      let n = this._scene.getMeshById(e);
      if (n)
        for (; n.parent; ) {
          if (n.parent.id === t)
            return !0;
          n = n.parent;
        }
    }
    return !1;
  }
  countSceneMeshes() {
    let e = 0;
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e++;
    }), e;
  }
  sceneHasRealMeshes() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      if (this.isRealMesh(this._scene.meshes[e]))
        return !0;
    return !1;
  }
  getSceneMeshes() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e.push(t);
    }), e;
  }
  getSceneMeshesByName(e) {
    let t = [];
    if (this._scene) {
      const s = function(o) {
        return o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      };
      if (e) {
        var n = new RegExp(s(e).replace(/\\\*/g, ".*"), "i");
        for (let o = 0; o < this._scene.meshes.length; o++) {
          const h = this._scene.meshes[o];
          this.isRealMesh(h) && h.name && n.test(h.name) && t.push(h);
        }
      }
    }
    return t;
  }
  isVisibleMesh(e) {
    return this.isRealMesh(e) && e.isVisible;
  }
  getVisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isVisibleMesh(t) && e.push(t);
    }), e;
  }
  getInvisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && !t.isVisible && e.push(t);
    }), e;
  }
  getSubMesh(e, t) {
    return e.subMeshes && e.subMeshes.length > 0 && t >= 0 && t < e.subMeshes.length ? e.subMeshes[t] : null;
  }
  getMeshHierarchy(e) {
    const t = [];
    let n = this._scene.getMeshById(e);
    if (!n)
      return t;
    let s = (o) => {
      t.push(o);
      let h = o.getChildMeshes(!0);
      for (let c = 0; c < h.length; c++)
        s(h[c]);
    };
    return s(n), t;
  }
  getTryOnMeshHierarchy(e) {
    const t = [];
    let n = this._scene.getMeshById(e);
    if (!n)
      return t;
    let s = (o) => {
      t.push(o);
      let h = o.getChildMeshes(!0);
      for (const c of h)
        (this.isVisibleCanvasMesh(c) || this.isVisibleTryOnMesh(c)) && s(c);
    };
    return s(n), t;
  }
  isVisibleCanvasMesh(e) {
    return this.isCanvasMesh(e) && e.isVisible;
  }
  isCanvasMesh(e) {
    return !e || !e.metadata ? !1 : e.metadata.hasOwnProperty("iscanvasMesh") && typeof e.metadata.iscanvasMesh == "boolean" ? e.metadata.iscanvasMesh : !1;
  }
  isAREnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.AR === void 0 || e.metadata.AR === null || typeof e.metadata.AR != "boolean" ? !0 : e.metadata.AR : !1;
  }
  isTryOnEnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.TryOn === void 0 || e.metadata.TryOn === null || typeof e.metadata.TryOn != "boolean" ? !0 : e.metadata.TryOn : !1;
  }
  isVisibleTryOnMesh(e) {
    return this.isTryOnEnabledForMesh(e) && this.isVisibleMesh(e);
  }
  getMeshesForAR() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isAREnabledForMesh(t) && e.push(t);
    }), e;
  }
  checkMaterialsForAR() {
    const e = this.getMeshesMaterials(this.getMeshesForAR());
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      if (!(n instanceof BABYLON.PBRMaterial) && !(n instanceof BABYLON.PBRMetallicRoughnessMaterial) && !(n instanceof BABYLON.StandardMaterial))
        return !1;
    }
    return !0;
  }
  getMeshesMaterials(e) {
    const t = [], n = [];
    for (let s = 0; s < e.length; s++) {
      let o = e[s];
      if (o.material)
        if (o.material instanceof BABYLON.MultiMaterial)
          for (let h = 0; h < o.material.subMaterials.length; h++) {
            let c = o.material.subMaterials[h];
            c && t.indexOf(c.id) === -1 && (n.push(c), t.push(c.id));
          }
        else
          t.indexOf(o.material.id) === -1 && (n.push(o.material), t.push(o.material.id));
    }
    return n;
  }
  getMeshMaterials(e) {
    const t = [];
    if (e && e.material)
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let n = 0; n < e.material.subMaterials.length; n++) {
          let s = e.material.subMaterials[n];
          s && t.push(s);
        }
      else
        t.push(e.material);
    return t;
  }
  getHiddenMeshTotalVertices() {
    return this.getTotalVertices((e) => !e.isVisible);
  }
  getTotalVertices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((n) => {
      this.isRealMesh(n) && (e && !e(n) || (t += n.getTotalVertices()));
    }), t;
  }
  getHiddenMeshTotalIndices() {
    return this.getTotalIndices((e) => !e.isVisible);
  }
  getTotalIndices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((n) => {
      this.isRealMesh(n) && (e && !e(n) || (t += n.getTotalIndices()));
    }), t;
  }
  getAllMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t.metadata && (t.metadata.isRealMaterial !== void 0 && !t.metadata.isRealMaterial || t.metadata.isEnvironmentNode !== void 0 && t.metadata.isEnvironmentNode) || t.id !== "groundMaterial" && t.id !== "default material" && e.push(t);
    }), e;
  }
  getMeshesUsingMaterial(e) {
    const t = [], n = this.getSceneMeshes();
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      this.isMeshUsingMaterial(o, e) && t.push(o);
    }
    return t;
  }
  isMeshUsingMaterial(e, t) {
    if (e.material) {
      if (e.material.id === t)
        return !0;
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let n = 0; n < e.material.subMaterials.length; n++) {
          const s = e.material.subMaterials[n];
          if (s && s.id === t)
            return !0;
        }
    }
    return !1;
  }
  getAllUnusedMaterials() {
    const e = this.getAllMaterials(), t = [];
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      this.getMeshesUsingMaterial(s.id).length === 0 && t.push(s);
    }
    return t;
  }
  async getSceneScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    let n = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, n, "image/png");
  }
  containsPBRMaterials() {
    if (this._scene) {
      for (let e = 0; e < this._scene.materials.length; e++)
        if (this._scene.materials[e] instanceof BABYLON.PBRBaseMaterial)
          return !0;
    }
    return !1;
  }
  getMeshesForTryOn() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isTryOnEnabledForMesh(t) && e.push(t);
    }), e;
  }
  setupLights() {
    this._hemiLight = null, this._pointLight = null;
    let e = null, t = null;
    this._scene.lights.forEach((n) => {
      n instanceof BABYLON.HemisphericLight && (e === null && (e = n), n.id === this._defHemiLightID && (this._hemiLight = n)), n instanceof BABYLON.PointLight && (t === null && (t = n), n.id === this._defPointLightID && (this._pointLight = n));
    }), this._hemiLight === null && (e !== null ? this._hemiLight = e : (this._hemiLight = new BABYLON.HemisphericLight(
      "Default Hemispheric Light",
      BABYLON.Vector3.Up(),
      this._scene
    ), this._hemiLight.intensity = 0.5), this._hemiLight && (this._hemiLight.id = this._defHemiLightID)), this._pointLight === null && (t !== null ? this._pointLight = t : (this._pointLight = new BABYLON.PointLight(
      "Default Point Light",
      new BABYLON.Vector3(0, 5, 0),
      this._scene
    ), this._pointLight.intensity = 0.5), this._pointLight && (this._pointLight.id = this._defPointLightID));
  }
  setUpCustomLights(e) {
    Object.entries(e).forEach((t) => {
      const n = t[0], s = t[1].position, o = t[1].general.intensity, h = t[1].general.visible, c = {
        position: s,
        intensity: o,
        visible: h
      };
      this.createOrUpdateLight(n, c);
    });
  }
  createOrUpdateLight(e, t) {
    const n = this._scene.getLightByName(e);
    if (n && (this._scene.removeLight(n), n.dispose()), !t.visible)
      return;
    const s = new BABYLON.Vector3(t.position.x, t.position.y, t.position.z);
    let o;
    e.match(/directional/i) ? (o = new BABYLON.DirectionalLight(e, s, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID()) : e.match(/pointLight/i) ? (o = new BABYLON.PointLight(e, s, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID()) : e.match(/hemisphere/i) && (o = new BABYLON.HemisphericLight(e, s, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID());
  }
  getDefaultHemisphericLight() {
    return this._hemiLight;
  }
  getDefaultPointLight() {
    return this._pointLight;
  }
  isDefaultLight(e) {
    return e.id == this._defHemiLightID || e.id == this._defPointLightID;
  }
  setUpCameraByOptions(e) {
    if (e && this._scene) {
      let t = this._scene.cameras.find((n) => n instanceof BABYLON.ArcRotateCamera);
      e && t instanceof BABYLON.ArcRotateCamera && (t.beta = e.beta ?? t.beta, t.alpha = e.alpha ?? t.alpha, t.fov = e.fov ?? t.fov);
    }
  }
  setupCamera() {
    if (this._scene) {
      let e = this._scene.cameras.find((t) => t instanceof BABYLON.ArcRotateCamera);
      e ? this._camera = e : (this._camera = new BABYLON.ArcRotateCamera("camera1", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene), this._camera.setPosition(new BABYLON.Vector3(0, 3, -8))), this.setupCameraLimits(), this._canvas && this._camera.attachControl(this._canvas, !1);
    }
  }
  setCameraRadiusParameters(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      this._camera.lowerRadiusLimit = e * (this._zoomEnabled ? 0.01 : 1), this._camera.upperRadiusLimit = e * (this._zoomEnabled ? 3 : 1), this._camera.wheelPrecision = 100 / e, this._camera.pinchPrecision = 100 / e, this._camera.minZ = e * 0.01, this._camera.maxZ = e * 1e3, this._camera.speed = e * 0.2, this._camera.wheelDeltaPercentage = 0.01, this._camera.pinchDeltaPercentage = 6e-4, this._camera.panningSensibility = 0, this._camera.wheelPrecision = 100 / e, this._camera.panningAxis = BABYLON.Vector3.Zero(), this._camera.panningInertia = 0;
      const t = this._camera.inputs.attached.pointers;
      t && (t.multiTouchPanning = !1, t.multiTouchPanAndZoom = !1), this._camera.radius = e, this._minZObserver || (this._minZObserver = this._camera.onAfterCheckInputsObservable.add(() => {
        this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.minZ = Math.max(0.01, this._camera.radius * 0.01));
      }));
    }
  }
  removeCameraLimits() {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerRadiusLimit = null, this._camera.upperRadiusLimit = null, this._camera.minZ = 1, this._camera.maxZ = 1e4);
  }
  getWorldExtends() {
    return this._scene ? this._scene.getWorldExtends((e) => this.isRealMesh(e) && e.isVisible) : null;
  }
  getCameraWorldExtends() {
    let e = null;
    if (this._scene) {
      let t = this._cameraPivot;
      if (!t)
        for (let n = 0; n < this._scene.meshes.length; n++) {
          const s = this._scene.meshes[n];
          if (s.metadata && s.metadata.isCameraPivot !== void 0 && s.metadata.isCameraPivot) {
            t = s;
            break;
          }
        }
      t && (e = this._scene.getWorldExtends((n) => n === t || this.meshHasParent(n.id, t.id)));
    }
    return e || (e = this.getWorldExtends()), e;
  }
  /**
   * Configura i parametri di input touch della camera (panning, pinch-to-zoom, observer minZ).
   * NON dipende da worldExtends, quindi funziona sempre anche se le mesh sono appena
   * diventate visibili (es. dopo Show Object action) e i world extends non sono ancora validi.
   */
  configureCameraTouchInput() {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    this._camera.panningSensibility = 0, this._camera.panningAxis = BABYLON.Vector3.Zero(), this._camera.panningInertia = 0, this._camera.pinchDeltaPercentage = 6e-4, this._camera.wheelDeltaPercentage = 0.01;
    const e = this._camera.inputs.attached.pointers;
    e && (e.multiTouchPanning = !1, e.multiTouchPanAndZoom = !1), this._minZObserver || (this._minZObserver = this._camera.onAfterCheckInputsObservable.add(() => {
      this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.minZ = Math.max(0.01, this._camera.radius * 0.01));
    }));
  }
  setupCameraLimits(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      if (e == null) {
        let n = this.getCameraWorldExtends();
        n && (e = n);
      }
      if (!e)
        return;
      const t = e.max.subtract(e.min);
      if (isFinite(t.length())) {
        this.removeCameraLimits();
        const n = this.calculateCameraRadius(e);
        if (this.setCameraRadiusParameters(n), this._limitLowerRadius && this._scene.meshes.length && this._zoomEnabled) {
          this._camera.useFramingBehavior = !0;
          const s = this._camera.getBehaviorByName("Framing");
          s && s instanceof BABYLON.FramingBehavior && (s.elevationReturnTime = -1, this._minZoomPerc !== null && this._minZoomPerc !== void 0 && this._minZoomPerc > 0 && (this._camera.lowerRadiusLimit = n * this._minZoomPerc), this._maxZoomPerc !== null && this._maxZoomPerc !== void 0 && this._maxZoomPerc > 0 && (this._camera.upperRadiusLimit = n * this._maxZoomPerc));
        }
      }
    }
  }
  adjustCamera(e, t = !0, n = !0, s = !0, o = !1) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let h = this.getCameraWorldExtends();
    if (!h)
      return;
    const c = h.max.subtract(h.min);
    if (!isFinite(c.length()))
      return;
    const m = h.min.add(c.scale(0.5));
    this.removeCameraLimits();
    const x = this.calculateCameraRadius(h);
    let B = this._camera.alpha;
    t || (B = -(Math.PI / 2), e && e === "gltf" && (B += Math.PI));
    let I = this._camera.beta;
    n || (I = Math.PI / 2 - 0.3);
    let F = m.clone(), M = h.min.y, Z = h.max.y, V = M + (Z - M) * this._positionScale;
    if (F.y = V, !s)
      this._camera.alpha = B, this._camera.beta = I, this._camera.radius = x, this._camera.target = F, this.setupCameraLimits(h);
    else {
      if (o) {
        const te = this.calculateCameraRadius(h);
        this._camera.radius = te;
      }
      this.animateCameraToFinalParamters(B, I, x, F, 2, () => {
        this.setupCameraLimits(h);
      });
    }
  }
  normalizeAngleOfView(e, t) {
    const n = BABYLON.Vector3.Zero(), s = new BABYLON.ArcRotateCamera("ghostCamera", e, t, 1, n, this._scene), o = s.position;
    return s.dispose(), this.computeCameraAngleOfView(n, o);
  }
  computeCameraAngleOfView(e, t) {
    const n = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    n.setPosition(t);
    const s = n.alpha, o = n.beta;
    return n.dispose(), {
      alpha: s,
      beta: o
    };
  }
  moveCamera(e, t) {
    var n = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    n.setPosition(t);
    var s = n.alpha, o = n.beta, h = n.radius;
    n.dispose(), this.moveCameraToFinalParameters(s, o, h, e), this.configureCameraTouchInput();
  }
  animateCamera(e, t, n, s) {
    var o = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    o.setPosition(t);
    var h = o.alpha, c = o.beta, m = o.radius;
    o.dispose(), this.configureCameraTouchInput(), this.animateCameraToFinalParamters(h, c, m, e, n, s);
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  wrap2Pi(e) {
    let t = e % (Math.PI * 2);
    return t < 0 && (t += Math.PI * 2), t;
  }
  zoomIn() {
    this.zoom(0.85);
  }
  zoomOut() {
    this.zoom(1.15);
  }
  zoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let n = this._camera.radius, s = this._camera.lowerRadiusLimit !== null && this._camera.lowerRadiusLimit !== void 0 ? this._camera.lowerRadiusLimit : 0, o = Math.max(0, s), h = Number.MAX_VALUE;
      this._camera.upperRadiusLimit != null && (h = this._camera.upperRadiusLimit);
      var t = Math.max(o, Math.min(h, n * e));
      t !== n && this.animateCameraToFinalParamters(
        this._camera.alpha,
        this._camera.beta,
        t,
        this._camera.target,
        0.5
      );
    }
  }
  moveCameraToFinalParameters(e, t, n, s) {
    !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) || (this._camera.target = s, this._camera.alpha = e, this._camera.beta = t, this._camera.radius = n);
  }
  animateCameraToFinalParamters(e, t, n, s, o, h) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let c = this._camera.radius, m = () => {
      if (this._camera) {
        this._scene.stopAnimation(this._camera);
        for (let Le = 0; Le < this._camera.animations.length; Le++)
          this._camera.animations[Le], this._camera.animations.splice(Le--, 1);
      }
    };
    m();
    let x = this._camera.alpha;
    !this._camera.lowerAlphaLimit && !this._camera.upperAlphaLimit && (x = this.wrap2Pi(this._camera.alpha));
    let B = this._camera.beta;
    !this._camera.lowerBetaLimit && !this._camera.upperBetaLimit && (B = this.wrap2Pi(this._camera.beta));
    let I = isFinite(e) ? this.wrapPi(e) : x;
    Math.abs(x - I) > Math.PI && (I += Math.PI * 2);
    let F = isFinite(t) ? this.wrapPi(t) : B;
    Math.abs(B - F) > Math.PI && (F += Math.PI * 2);
    let M = 2;
    o && typeof o == "number" && o > 0 && (M = o);
    let Z = 60, V = Math.floor(M * Z), K = this._camera.target.subtract(s).length() / this._camera.radius, J = [], le = new BABYLON.CubicEase();
    le.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
    let fe = null;
    this._camera.target !== s && (K >= 5e-3 ? (fe = new BABYLON.Animation(
      "camTargetAnimation",
      "target",
      Z,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: this._camera.target
      },
      {
        frame: V,
        value: s
      }
    ], fe.setKeys(J), fe.setEasingFunction(le)) : this._camera.target = s);
    let X = null;
    x !== I && (X = new BABYLON.Animation(
      "camAlphaAnimation",
      "alpha",
      Z,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: x
      },
      {
        frame: V,
        value: I
      }
    ], X.setKeys(J), X.setEasingFunction(le));
    let W = null;
    B !== F && (W = new BABYLON.Animation(
      "camBetaAnimation",
      "beta",
      Z,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: B
      },
      {
        frame: V,
        value: F
      }
    ], W.setKeys(J), W.setEasingFunction(le));
    let je = Math.abs(this._camera.radius - n) / this._camera.radius, Ee = null;
    this._camera.radius !== n && (je >= 5e-3 ? (Ee = new BABYLON.Animation(
      "camRadiusAnimation",
      "radius",
      Z,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: c
      },
      {
        frame: V,
        value: n
      }
    ], Ee.setKeys(J), Ee.setEasingFunction(le)) : this._camera.radius = n);
    let He = this._camera.animations.length;
    if (fe && this._camera.animations.push(fe), X && this._camera.animations.push(X), W && this._camera.animations.push(W), Ee && this._camera.animations.push(Ee), this._camera.animations.length > He) {
      var ft = this._scene.beginAnimation(this._camera, 0, V, !1, 1);
      ft.onAnimationEnd = () => {
        m(), this.setupShaderMaterialsCameraPosition(), h && h();
      };
    } else
      h && h();
  }
  //Returns the frustum slope based on the canvas ratio and camera FOV
  //returns The frustum slope represented as a Vector2 with X and Y slopes
  getFrustumSlope() {
    let e = this._camera;
    if (!e)
      return BABYLON.Vector2.Zero();
    let n = this._engine.getAspectRatio(e), s = Math.tan(e.fov / 2), o = s * n;
    return new BABYLON.Vector2(o, s);
  }
  calculateCameraRadius(e) {
    if (e == null) {
      let n = this.getCameraWorldExtends();
      n && (e = n);
    }
    if (!e)
      return 1;
    var t = this.calculateLowerRadiusFromModelBoundingSphere(e.min, e.max);
    return isFinite(t) || (t = 1), t + (this._cameraZoom ?? 0);
  }
  // Calculates the lowest radius for the camera based on the bounding box of the mesh.
  calculateLowerRadiusFromModelBoundingSphere(e, t) {
    const s = t.subtract(e).length(), o = this.getFrustumSlope(), h = s * 0.5, c = this._radiusScale, m = h * c, x = m * Math.sqrt(1 + 1 / (o.x * o.x)), B = m * Math.sqrt(1 + 1 / (o.y * o.y));
    let I = Math.max(x, B);
    var F = this._camera;
    return !F || !(F instanceof BABYLON.ArcRotateCamera) ? 0 : (F.upperRadiusLimit && (I = I > F.upperRadiusLimit ? F.upperRadiusLimit : I), I);
  }
  getWorldCenter(e) {
    if (e == null) {
      let s = this.getCameraWorldExtends();
      s && (e = s);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraWorldCenter(e) {
    if (e == null) {
      let s = this.getCameraWorldExtends();
      s && (e = s);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraRadius(e) {
    if (e == null) {
      let s = this.getCameraWorldExtends();
      s && (e = s);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? this.calculateCameraRadius(e) : null;
  }
  setCameraLimitLowerRadius(e, t = !1) {
    if (this._limitLowerRadius = e, this.setupCameraLimits(), t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      let n = this._camera.target.clone(), s = this.getCameraWorldExtends();
      if (s) {
        let o = s.min.y, h = s.max.y, c = o + (h - o) * this._positionScale;
        n.y = c, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          n,
          0.5
        );
      }
    }
  }
  setCameraPositionScale(e, t = !1) {
    if (this._positionScale = e, t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      var n = this._camera.target.clone(), s = this.getCameraWorldExtends();
      if (s) {
        var o = s.min.y, h = s.max.y, c = o + (h - o) * this._positionScale;
        n.y = c, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          n,
          0.5
        );
      }
    }
  }
  setCameraPositionFOV(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.fov = e);
  }
  getCameraPivot() {
    return this._cameraPivot;
  }
  setCameraPivot(e) {
    this._cameraPivot = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setZoomEnabled(e) {
    this._zoomEnabled = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setMinZoomPerc(e) {
    const t = e ?? null;
    t !== this._minZoomPerc && (this._minZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setMaxZoomPerc(e) {
    const t = e ?? null;
    t !== this._maxZoomPerc && (this._maxZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraZoom(e) {
    e != null && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._cameraZoom = -(e / 10), this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraAlphaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).alpha;
      this.setCameraLowerAlphaLimit(e), this.setCameraUpperAlphaLimit(t), this._camera.alpha = n;
    }
  }
  setCameraLowerAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.upperAlphaLimit && t > this._camera.upperAlphaLimit && (this._camera.upperAlphaLimit += Math.PI * 2), this._camera.lowerAlphaLimit = t;
      }
  }
  setCameraUpperAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.lowerAlphaLimit && t < this._camera.lowerAlphaLimit && (t += Math.PI * 2), this._camera.upperAlphaLimit = t;
      }
  }
  setCameraLowerBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerBetaLimit = 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.upperBetaLimit && t > this._camera.upperBetaLimit && (this._camera.upperBetaLimit += Math.PI * 2), this._camera.lowerBetaLimit = t;
      }
  }
  setCameraUpperBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperBetaLimit = Math.PI - 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.lowerBetaLimit && t < this._camera.lowerBetaLimit && (this._camera.lowerBetaLimit -= Math.PI * 2), this._camera.upperBetaLimit = t;
      }
  }
  setCameraBetaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).beta;
      this.setCameraLowerBetaLimit(e), this.setCameraUpperBetaLimit(t), this._camera.beta = n;
    }
  }
  zoomOnMesh(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      this._camera.useFramingBehavior = !0;
      const t = this._camera.getBehaviorByName("Framing");
      t && t instanceof BABYLON.FramingBehavior && (t.framingTime = 0, t.elevationReturnTime = -1, t.radiusScale = this._radiusScale, t.positionScale = this._positionScale, t.zoomOnMeshHierarchy(e));
    }
  }
  async takeScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    const n = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, n, "image/png");
  }
  async takeContentScreenshotAsync(e, t, n) {
    if (!this._camera)
      return "";
    var s = this._scene.clearColor.clone();
    this._scene.clearColor = n || new BABYLON.Color4(0, 0, 0, 0), this._scene.render();
    let o = { width: e, height: t };
    const h = BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, o, "image/png");
    this._scene.render(), this._scene.getEngine().endFrame();
    const c = await h;
    return this._scene.clearColor = s, c;
  }
  async takeMaterialScreenshotAsync(e, t, n) {
    let s = this._scene.getMaterialByID(e);
    if (!s)
      return "";
    let o = this.getVisibleMeshes();
    for (let F = 0; F < o.length; F++) {
      var h = o[F];
      h.isVisible = !1;
    }
    let c = this._scene.clearColor.clone();
    this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
    let m = BABYLON.Mesh.CreateSphere("temp_sphere", 32, 2, this._scene);
    m.material = s;
    let x = new BABYLON.ArcRotateCamera("temp_camera", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
    x.setPosition(new BABYLON.Vector3(0, 0, -4)), this._scene.activeCamera = x, this._scene.render();
    let B = { width: t, height: n }, I = await BABYLON.Tools.CreateScreenshotAsync(this._engine, x, B, "image/png");
    this._scene.clearColor = c, m.dispose();
    for (let F = 0; F < o.length; F++) {
      var h = o[F];
      h.isVisible = !0;
    }
    return this._scene.activeCamera = this._camera, x.dispose(), I;
  }
  getScenePBRMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t instanceof BABYLON.PBRBaseMaterial && e.push(t);
    }), e;
  }
  resetPBRMaterialsImageProcessingConfiguration() {
    var e = this.getScenePBRMaterials();
    e.forEach((t) => {
      this.adjustPBRMaterialImageProcessingConfiguration(t);
    });
  }
  adjustPBRMaterialImageProcessingConfiguration(e) {
    e instanceof BABYLON.PBRMaterial && e.imageProcessingConfiguration && (e.imageProcessingConfiguration.colorGradingWithGreenDepth = !1, e.imageProcessingConfiguration.colorGradingBGR = !1, e.imageProcessingConfiguration.exposure = 1, e.imageProcessingConfiguration.toneMappingEnabled = !1, e.imageProcessingConfiguration.contrast = 1);
  }
  animateMeshToFinalParameters(e, t, n, s, o, h = 2, c) {
    if (this._scene && e) {
      e.id;
      const B = () => {
        this._scene.stopAnimation(e);
        for (let le = 0; le < e.animations.length; le++)
          e.animations.splice(le--, 1);
      };
      B();
      const I = h, F = 60, M = Math.floor(I * F);
      let Z, V = null;
      e.position !== t && (V = new BABYLON.Animation(
        "positionAnimation",
        "position",
        F,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), Z = [
        {
          frame: 0,
          value: e.position
        },
        {
          frame: M,
          value: t
        }
      ], V.setKeys(Z));
      let te = null, P = null;
      if (e.rotationQuaternion == null) {
        var m;
        n != null ? m = n.clone() : m = s.toEulerAngles().clone(), e.rotation != m && (te = new BABYLON.Animation(
          "eulerAnimation",
          "rotation",
          F,
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), Z = [
          {
            frame: 0,
            value: e.rotation
          },
          {
            frame: M,
            value: m
          }
        ], te.setKeys(Z));
      } else {
        let le;
        s != null ? le = s.clone() : (le = BABYLON.Quaternion.Identity(), le.copyFrom(BABYLON.Quaternion.RotationYawPitchRoll(n.y, n.x, n.z))), P = new BABYLON.Animation(
          "quaternionAnimation",
          "rotationQuaternion",
          F,
          BABYLON.Animation.ANIMATIONTYPE_QUATERNION,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), Z = [
          {
            frame: 0,
            value: e.rotationQuaternion
          },
          {
            frame: M,
            value: le
          }
        ], P.setKeys(Z);
      }
      let K = null;
      e.scaling !== o && (K = new BABYLON.Animation(
        "scalingAnimation",
        "scaling",
        F,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), Z = [
        {
          frame: 0,
          value: e.scaling
        },
        {
          frame: M,
          value: o
        }
      ], K.setKeys(Z));
      let J = e.animations.length;
      if (V && e.animations.push(V), te && e.animations.push(te), P && e.animations.push(P), K && e.animations.push(K), e.animations.length > J) {
        var x = this._scene.beginAnimation(e, 0, M, !1, 1);
        x.onAnimationEnd = () => {
          B(), c && c();
        };
      }
    }
  }
  getMaterialsUsingTexture(e) {
    var t = this.getTextureMaterialsMap();
    return this._scene.materials.forEach((n) => {
      var s = this.getTexturesForMaterial(n);
      s.forEach((o) => {
        t.hasOwnProperty(o.uid) || (t[o.uid] = []), t[o.uid].push(n);
      });
    }), t.hasOwnProperty(e.uid) ? t[e.uid] : [];
  }
  getTextureMaterialsMap() {
    let e = {};
    return this._scene && this._scene.materials.forEach((t) => {
      var n = this.getTexturesForMaterial(t);
      n.forEach((s) => {
        e.hasOwnProperty(s.uid) || (e[s.uid] = []), e[s.uid].push(t);
      });
    }), e;
  }
  // Recupera tutte le texture di un materiale
  getTexturesForMaterial(e) {
    return e.getActiveTextures();
  }
  getTexturesExclusivelyForMaterial(e) {
    let t = this.getTexturesForMaterial(e), n = this.getTextureMaterialsMap();
    for (var s = 0; s < t.length; s++) {
      let h = t[s];
      var o = n.hasOwnProperty(h.uid) ? n[h.uid] : [];
      o.length > 1 && t.splice(s--, 1);
    }
    return t;
  }
  getStandardMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getNewPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  createMeshesFromSubMeshes(e) {
    let t = e.getChildMeshes(!0);
    for (let o = 0; o < t.length; o++)
      this.createMeshesFromSubMeshes(t[o]);
    let n = [];
    if (e.subMeshes && e.subMeshes.length > 0)
      for (let o = 0; o < e.subMeshes.length; o++) {
        let h = this.createMeshFromSubMesh(e, o);
        h && n.push(h);
      }
    let s = new BABYLON.VertexData();
    s.positions = [], s.indices = [], s.normals = [], s.uvs = [], s.uvs2 = [], s.applyToMesh(e, !0), e.subMeshes = [], e.material = null, n.forEach((o) => {
      o.parent = e;
    });
  }
  createMeshFromSubMesh(e, t, n) {
    let s = null, o = e.subMeshes[t], h = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), c = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), m = e.getIndices();
    if (h && c && m) {
      let B = h.slice(
        3 * o.verticesStart,
        3 * (o.verticesStart + o.verticesCount)
      ), I = c.slice(
        3 * o.verticesStart,
        3 * (o.verticesStart + o.verticesCount)
      ), F = m.slice(o.indexStart, o.indexStart + o.indexCount), M = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UVKind)) {
        let te = e.getVerticesData(BABYLON.VertexBuffer.UVKind);
        te && (M = te.slice(2 * o.verticesStart, 2 * (o.verticesStart + o.verticesCount)));
      }
      var x = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UV2Kind)) {
        let te = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
        te && (x = te.slice(
          2 * o.verticesStart,
          2 * (o.verticesStart + o.verticesCount)
        ));
      }
      for (let te = 0; te < F.length; te++)
        F[te] -= o.verticesStart;
      let Z = new BABYLON.Mesh(n || e.name + "_part_" + o._id, this._scene), V = new BABYLON.VertexData();
      V.positions = B, V.normals = I, V.indices = F, M && (V.uvs = M), x && (V.uvs2 = x), V.applyToMesh(Z), e.material && (Z.material = e.material instanceof BABYLON.MultiMaterial ? e.material.subMaterials[o.materialIndex] : e.material);
    }
    return s;
  }
  getNextIncrementalName(e) {
    let t = e;
    if (e) {
      let c;
      for (var n = 0; this._scene.getMeshByName(t); ) {
        if (!c) {
          c = e;
          var s = e.lastIndexOf("_");
          if (s > 0) {
            var o = e.substring(s + 1), h = parseInt(o);
            h.toString() === o && (c = e.substring(0, s));
          }
        }
        n++, t = c + "_" + n;
      }
    }
    return t;
  }
  createBox(e, t) {
    let n = t || "Box";
    n = this.getNextIncrementalName(n);
    let s = BABYLON.Mesh.CreateBox(n, 5, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createBoundingBox(e, t) {
    let n = t || "BoundingBox";
    n = this.getNextIncrementalName(n);
    const s = e ? e.getHierarchyBoundingVectors() : this.getWorldExtends();
    if (!s)
      return this.createBox(e, t);
    const o = s.min, h = s.max, c = new BABYLON.BoundingInfo(o, h), m = h.subtract(o);
    if (!isFinite(m.length()))
      return this.createBox(e, t);
    const x = h.x - o.x, B = h.y - o.y, I = h.z - o.z, F = BABYLON.VertexData.CreateBox({ width: x, height: B, depth: I }), M = new BABYLON.Mesh(n, this._scene);
    return F.applyToMesh(M), M.position.copyFrom(c.boundingBox.centerWorld), M.refreshBoundingInfo(), e && e.parent && (M.parent = e.parent), M;
  }
  createSphere(e, t) {
    let n = t || "Sphere";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreateSphere(n, 30, 5, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createPlane(e, t) {
    let n = t || "Plane";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreatePlane(n, 10, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createDisc(e, t) {
    let n = t || "Disc";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.MeshBuilder.CreateDisc(n, { tessellation: 70 }, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createCylinder(e, t) {
    let n = t || "Cylinder";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreateCylinder(n, 6, 6, 6, 30, 1, this._scene, !1);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createTorus(e, t) {
    let n = t || "Torus";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreateTorus(n, 8, 1, 50, this._scene, !1);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createKnot(e, t) {
    let n = t || "Knot";
    n = this.getNextIncrementalName(n);
    const s = BABYLON.Mesh.CreateTorusKnot(n, 2, 0.5, 128, 64, 2, 3, this._scene);
    return s.id = Zakeke.generateUUID(), e && (s.parent = e), s;
  }
  createRibbon(e, t) {
    let n = t || "Ribbon";
    n = this.getNextIncrementalName(n);
    const s = function(m) {
      for (var x = [], B = -10; B < 10; B++)
        x.push(new BABYLON.Vector3(m, B, Math.sin(m / 3) * 5 * Math.exp(-(B - m) * (B - m) / 60) + B / 3));
      return x;
    };
    for (var o = [], h = 0; h < 20; h++)
      o[h] = s(h);
    const c = BABYLON.Mesh.CreateRibbon("ribbon", o, !1, !1, 0, this._scene);
    return c.id = Zakeke.generateUUID(), e && (c.parent = e), c;
  }
  async createRoundedCubeAsync(e, t, n) {
    const s = gi.Shapes.RoundedCubeName, o = gi.Shapes.RootUrl, h = gi.Shapes.RoundedCubeFileName;
    let c = t || "Rounded Cube";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createRoundedCylinderAsync(e, t, n) {
    const s = gi.Shapes.RoundedCylinderName, o = gi.Shapes.RootUrl, h = gi.Shapes.RoundedCylinderFileName;
    let c = t || "Rounded Cylinder";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createMatBallAsync(e, t, n) {
    const s = gi.Shapes.MatBallName, o = gi.Shapes.RootUrl, h = gi.Shapes.MatBallFileName;
    let c = t || "Mat Ball";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createMaleHeadAsync(e, t, n) {
    const s = gi.Shapes.MaleHeadName, o = gi.Shapes.RootUrl, h = gi.Shapes.MaleHeadFileName;
    let c = t || "Male Head";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createFemaleHeadAsync(e, t, n) {
    const s = gi.Shapes.FemaleHeadName, o = gi.Shapes.RootUrl, h = gi.Shapes.FemaleHeadFileName;
    let c = t || "Female Head";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createPokemonBallAsync(e, t, n) {
    const s = gi.Shapes.PokemonBallName, o = gi.Shapes.RootUrl, h = gi.Shapes.PokemonBallFileName;
    let c = t || "Pokemon Ball";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createShaderBallAsync(e, t, n) {
    const s = gi.Shapes.ShaderBallName, o = gi.Shapes.RootUrl, h = gi.Shapes.ShaderBallFileName;
    let c = t || "Shader Ball";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createBootsAsync(e, t, n) {
    const s = gi.Shapes.BootsName, o = gi.Shapes.RootUrl, h = gi.Shapes.BootsFolder, c = gi.Shapes.BootsFileName;
    let m = t || "Boots";
    return m = this.getNextIncrementalName(m), await this.importPrimitiveShapeAsync(s, o + h, c, e, m, n);
  }
  async createSuzanneAsync(e, t, n) {
    const s = gi.Shapes.SuzanneName, o = gi.Shapes.RootUrl, h = gi.Shapes.SuzanneFileName;
    let c = t || "Suzanne";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createStepPyramidAsync(e, t, n) {
    const s = gi.Shapes.StepPyramidName, o = gi.Shapes.RootUrl, h = gi.Shapes.StepPyramidFileName;
    let c = t || "Step Pyramid";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createTeapotAsync(e, t, n) {
    const s = gi.Shapes.TeapotName, o = gi.Shapes.RootUrl, h = gi.Shapes.TeapotFileName;
    let c = t || "Teapot";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createAlloyWheelAsync(e, t, n) {
    const s = gi.Shapes.AlloyWheelName, o = gi.Shapes.RootUrl, h = gi.Shapes.AlloyWheelFolder, c = gi.Shapes.AlloyWheelFileName;
    let m = t || "Wheel";
    return m = this.getNextIncrementalName(m), await this.importPrimitiveShapeAsync(s, o + h, c, e, m, n);
  }
  async createTryonReferenceGlassesFrameAsync(e, t, n) {
    const s = gi.TryonReferences.ReferenceGlassesFrameName, o = gi.TryonReferences.RootUrl, h = gi.TryonReferences.ReferenceGlassesFrameFileName;
    let c = t || "Reference Glasses Frame";
    return c = this.getNextIncrementalName(c), await this.importPrimitiveShapeAsync(s, o, h, e, c, n);
  }
  async createTryOnReferenceModelsAsync(e, t, n, s) {
    return await this.importPrimitiveShapeAsync(
      "",
      gi.TryonReferences.RootUrl,
      n,
      e,
      t,
      s,
      !0
    );
  }
  async importPrimitiveShapeAsync(e, t, n, s, o, h, c = !1) {
    let m = [], x = await BABYLON.SceneLoader.ImportMeshAsync(e, t, n, this._scene, h);
    if (x && x.meshes) {
      m = x.meshes;
      for (let B = 0; B < m.length; B++) {
        let I = m[B];
        if (I.name === "__root__") {
          let F = I.getChildMeshes();
          for (let M = 0; M < F.length; M++) {
            let Z = F[M];
            Z.parent = null;
          }
          I.dispose(), m.splice(B--, 1);
          continue;
        }
        I.id = Zakeke.generateUUID(), s && (I.parent = s);
      }
    }
    return m;
  }
  setTryOnReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.isVisible = e;
    });
  }
  setTryOnReferenceEnabled(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.setEnabled(e);
    });
  }
  isTryOnReferenceVisible() {
    const { tryonReferencesModels: e } = this.getVTOMeshes();
    return e.length > 0 && e[0].isVisible;
  }
  transformEntireScene(e, t, n, s) {
    var h;
    const o = (h = this._scene) == null ? void 0 : h.meshes;
    o == null || o.forEach((c) => {
      c.parent == null && c.setParent(s);
    }), e && (s.position = new BABYLON.Vector3(e.x, e.y, e.z)), t && (s.rotation = new BABYLON.Vector3(t.x, t.y, t.z)), n && (s.scaling = new BABYLON.Vector3(n.x, n.y, n.z)), o == null || o.forEach((c) => {
      c.parent == s && c.setParent(null);
    });
  }
  scaleSceneToTryonReferenceModels(e) {
    this.setSceneScalePercentageForVTO(100, e), this.setScenePositionPercentageForVTO(0, 0, 0, e);
  }
  getSceneScalingPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return 100;
    const n = this._scene.getWorldExtends((M) => t.includes(M)), s = this._scene.getWorldExtends((M) => e.includes(M)), o = n.max.x - n.min.x, h = n.max.y - n.min.y, c = n.max.z - n.min.z, m = s.max.x - s.min.x, x = s.max.y - s.min.y, B = s.max.z - s.min.z;
    return 1 / Math.min(
      o / m,
      h / x,
      c / B
    ) * 100;
  }
  setSceneScalePercentageForVTO(e, t) {
    const { userMeshes: n, tryonReferencesModels: s } = this.getVTOMeshes();
    if (s.length === 0 || n.length === 0)
      return;
    const o = this._scene.getWorldExtends((P) => s.includes(P)), h = this._scene.getWorldExtends((P) => n.includes(P)), c = o.max.x - o.min.x, m = o.max.y - o.min.y, x = o.max.z - o.min.z, B = h.max.x - h.min.x, I = h.max.y - h.min.y, F = h.max.z - h.min.z, M = Math.min(
      c / B,
      m / I,
      x / F
    ), { x: Z, y: V, z: te } = this.getScenePositionPercentageForVTO();
    n.filter((P) => !P.parent).forEach((P) => {
      P.scaling.scaleInPlace(M), P.scaling.scaleInPlace(e / 100), t === "shoes" && P.scaling.scaleInPlace(1.3);
    }), this.setScenePositionPercentageForVTO(Z, V, te);
  }
  getScenePositionPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const n = this._scene.getWorldExtends((m) => t.includes(m)), s = this._scene.getWorldExtends((m) => e.includes(m)), o = n.max.add(n.min).scale(0.5), c = s.max.add(s.min).scale(0.5).subtract(o);
    return {
      x: c.x / (n.max.x - n.min.x) * 100,
      y: c.y / (n.max.y - n.min.y) * 100,
      z: c.z / (n.max.z - n.min.z) * 100
    };
  }
  setScenePositionPercentageForVTO(e, t, n, s) {
    const { userMeshes: o, tryonReferencesModels: h } = this.getVTOMeshes();
    if (h.length === 0 || o.length === 0)
      return;
    const c = this._scene.getWorldExtends((M) => h.includes(M)), m = this._scene.getWorldExtends((M) => o.includes(M)), x = c.max.add(c.min).scale(0.5), B = m.max.add(m.min).scale(0.5), I = x.subtract(B), F = new BABYLON.Vector3(
      e / 100 * (c.max.x - c.min.x),
      t / 100 * (c.max.y - c.min.y),
      n / 100 * (c.max.z - c.min.z)
    );
    o.filter((M) => !M.parent).forEach((M) => {
      M.position.addInPlace(I), M.position.addInPlace(F), s === "shoes" && (console.log("shoes down and scale up to 0.3"), M.position.y = 0);
    });
  }
  getSceneRotationForVTO() {
    var h;
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const n = e.filter((c) => !c.parent)[0], s = ((h = n.rotationQuaternion) == null ? void 0 : h.toEulerAngles()) ?? n.rotation, o = {
      x: s.x / Math.PI * 180,
      y: s.y / Math.PI * 180,
      z: s.z / Math.PI * 180
    };
    return o.x = o.x < 0 ? 360 + o.x : o.x, o.y = o.y < 0 ? 360 + o.y : o.y, o.z = o.z < 0 ? 360 + o.z : o.z, o;
  }
  setSceneRotationForVTO(e, t, n) {
    const { userMeshes: s, tryonReferencesModels: o } = this.getVTOMeshes();
    if (o.length === 0 || s.length === 0)
      return;
    const h = new BABYLON.Vector3(e / 180 * Math.PI, t / 180 * Math.PI, n / 180 * Math.PI);
    s.filter((c) => !c.parent).forEach((c) => {
      c.rotation = h;
    });
  }
  setVTOReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.isVisible = e;
    });
  }
  replaceTransformNodeWithMesh(e) {
    let t = null;
    if (this._scene) {
      const n = e.parent, s = e.getChildren();
      t = new BABYLON.Mesh(e.name, this._scene, n), t.id = Zakeke.generateUUID(), t.scaling = e.scaling.clone(), t.position = e.position.clone(), t.rotation = e.rotation.clone(), e.rotationQuaternion && (t.rotationQuaternion = e.rotationQuaternion.clone()), s.forEach((o) => o.parent = t), e.dispose(), e.animations.forEach((o) => {
        t.animations.push(o.clone());
      }), this._scene.animationGroups.forEach((o) => {
        o.targetedAnimations.forEach((h) => {
          h.target === e && (h.target = t);
        });
      }), this._scene.skeletons.forEach((o) => {
        o.bones.forEach((h) => {
          h.getTransformNode() === e && h.linkTransformNode(t);
        });
      });
    }
    return t;
  }
  // import 3d model from a remote url
  async importMeshesFromUrlAsync(e, t, n, s, o, h) {
    let c;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((Z) => {
      c = Z.name;
    });
    let m = [];
    const x = await BABYLON.SceneLoader.ImportMeshAsync(
      "",
      e,
      void 0,
      this._scene,
      n,
      o
    );
    x && (x.meshes.forEach((Z) => {
      Z.id = Zakeke.generateUUID(), m.push(Z), this.getMeshMaterials(Z).forEach((te) => te.id = Zakeke.generateUUID());
    }), x.transformNodes.forEach((Z) => {
      Z.id = Zakeke.generateUUID();
      const V = this.replaceTransformNodeWithMesh(Z);
      V && m.push(V);
    }), x.geometries.forEach((Z) => Z.id = Zakeke.generateUUID()));
    let B = BABYLON.Tools.GetFilename(e), I = B, F = B.lastIndexOf(".");
    F !== -1 && (I = B.substr(0, F));
    const M = m.filter((Z) => !Z.parent);
    if (M.length > 1 || M.length === 1 && M[0].name !== "__root__") {
      const Z = new BABYLON.Mesh(I, this._scene);
      Z.id = Zakeke.generateUUID(), Z.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, m.push(Z), M.forEach((V) => {
        V.setParent(Z);
      }), c === "obj" && (Z.scaling = new BABYLON.Vector3(-Z.scaling.x, Z.scaling.y, Z.scaling.z), Z.rotation = new BABYLON.Vector3(0, Math.PI, 0));
    } else if (M.length === 1) {
      const Z = M[0];
      if (Z.name === "__root__") {
        let te = BABYLON.Tools.GetFilename(e), P = B.lastIndexOf(".");
        P !== -1 && (te = B.substring(0, P)), Z.name = te, c === "obj" && (Z.scaling = new BABYLON.Vector3(-Z.scaling.x, Z.scaling.y, -Z.scaling.z), Z.rotation = new BABYLON.Vector3(0, Math.PI, 0));
      }
      if (["gltf", "glb", "obj"].includes(c)) {
        Z.name += "_transforms", Z.metadata = {
          isGltfTransformNode: !0
        };
        const te = new BABYLON.Mesh(I, this._scene);
        te.id = Zakeke.generateUUID(), te.metadata = {
          isRealMesh: !0,
          isGroup: !0
        }, m.push(te), Z.parent = te;
      }
    }
    if (!h && c === "gltf" || c === "glb") {
      const Z = [];
      m.forEach((V) => {
        if (V instanceof BABYLON.Mesh) {
          const P = BABYLON.VertexData.ExtractFromMesh(V), K = ["uvs", "uvs2", "uvs3", "uvs4", "uvs5", "uvs6"];
          for (const J of K)
            if (P && P[J] && P[J].length > 0)
              for (let le = 0; le < P[J].length; le += 2)
                P[J][le + 1] = 1 - P[J][le + 1];
          P.applyToMesh(V);
        }
        this.getMeshMaterials(V).forEach((P) => {
          Z.includes(P) || Z.push(P);
        });
      }), Z.forEach((V) => {
        V.getActiveTextures().forEach((te) => {
          te instanceof BABYLON.Texture && (te.vScale *= -1);
        });
      });
    }
    return this.adjustCamera(c, !1, !1, s, !0), this.setupShaderMaterialsCameraPosition(), m;
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let t = 0; t < this._scene.materials.length; t++) {
        var e = this._scene.materials[t];
        this.setupShaderMaterialCameraPosition(e);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    if (this._scene && e && e instanceof BABYLON.ShaderMaterial) {
      const t = this._scene.activeCamera;
      t && e.setVector3("cameraPosition", t.position);
    }
  }
  getSceneCmScalingFactor(e = null, t = null) {
    let n = null;
    if (this._scene) {
      let o = null;
      for (let h = 0; h < this._scene.meshes.length; h++) {
        var s = this._scene.meshes[h];
        if (s.metadata && s.metadata.sizecm) {
          o = s;
          break;
        }
      }
      if (e && t && (o = t), o) {
        const h = o.getHierarchyBoundingVectors(), c = h.min, m = h.max, x = m.subtract(c);
        if (isFinite(x.length())) {
          const B = m.x - c.x, I = m.y - c.y, F = m.z - c.z, M = e || o.metadata.sizecm;
          return M.width !== void 0 && typeof M.width == "number" && !isNaN(M.width) && B !== 0 ? n = M.width / B : M.height !== void 0 && typeof M.height == "number" && !isNaN(M.height) && I !== 0 ? n = M.height / I : M.depth !== void 0 && typeof M.depth == "number" && !isNaN(M.depth) && F !== 0 && (n = M.depth / F), n;
        }
      }
    }
    return n;
  }
  async exportSceneToUsdzAsync(e, t, n, s, o = null, h = null, c = !0) {
    const m = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      m,
      n,
      s,
      "usdz",
      o,
      h,
      c
    );
  }
  async exportMeshToUsdzAsync(e, t, n = null, s = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let c = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      c,
      e,
      h,
      void 0,
      void 0,
      "usdz",
      n,
      s,
      o
    );
  }
  async exportSceneToRemoteGlTFAsync(e, t, n, s, o = null, h = null, c = !0) {
    const m = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      m,
      n,
      s,
      "glTF",
      o,
      h,
      c
    );
  }
  async exportMeshToRemoteGlTFAsync(e, t, n = null, s = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let c = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      c,
      e,
      h,
      void 0,
      void 0,
      "glTF",
      n,
      s,
      o
    );
  }
  async exportSceneToRemoteGLBAsync(e, t, n, s, o = null, h = null, c = !0) {
    const m = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      m,
      n,
      s,
      "glb",
      o,
      h,
      c
    );
  }
  async exportMeshToRemoteGLBAsync(e, t, n = null, s = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let c = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      c,
      e,
      h,
      void 0,
      void 0,
      "glb",
      n,
      s,
      o
    );
  }
  async exportSceneToARMultiformatAsync(e, t, n = ["usdz", "glb", "png"], s, o, h = null, c = null, m = !0) {
    const x = this.getMeshesForAR();
    let B = e || "scene";
    return B = B.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARMultiformatAsync(
      B,
      t,
      x,
      n,
      h,
      c,
      m,
      s,
      o
    );
  }
  async exportMeshToARMultiformatAsync(e, t, n = ["usdz", "glb", "png"], s = null, o = null, h = !0, c, m) {
    const x = this.getMeshHierarchy(t.id);
    let B = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARMultiformatAsync(
      B,
      e,
      x,
      n,
      s,
      o,
      h,
      c,
      m
    );
  }
  convertGltfTransformNodes(e) {
    const t = [];
    return e.filter((n) => n.metadata && n.metadata.isGltfTransformNode).forEach((n) => {
      const s = new BABYLON.TransformNode(n.name + "-transform-node", this._scene);
      s.scaling.z = -1;
      const o = new BABYLON.Quaternion();
      o.set(0, 1, 0, 0), s.rotationQuaternion = o, t.push([n, n.parent, s]), n.setParent(s);
    }), t;
  }
  restoreGltfTransformNodes(e) {
    e.forEach(([t, n, s]) => {
      t.setParent(n), s.dispose();
    });
  }
  async getGltfBlobForARExport(e, t, n) {
    var m;
    const s = this.convertGltfTransformNodes(n);
    (m = this._scene) == null || m.render();
    const o = {
      meshes: n,
      materials: this.getMeshesMaterials(n),
      transformNodes: this._scene.transformNodes,
      lights: void 0,
      exportTextureUrls: t != null,
      rootUrl: t,
      shouldExportNode: (x) => {
        for (let B = 0; B < n.length; B++)
          if (n[B] === x)
            return !0;
        return !1;
      }
    }, h = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, o);
    if (h) {
      const x = new Kf(), B = h.serverImages && h.glTFFiles.hasOwnProperty("TextureUrls.txt") ? h.serverImages : [];
      for (var c in h.glTFFiles)
        if (B.indexOf(c) === -1) {
          let F = h.glTFFiles[c];
          Ms.EndsWith(c, ".gltf") || Ms.EndsWith(c, ".bin") ? x.file(c, F, {
            compression: "DEFLATE",
            compressionOptions: {
              level: 9
              // force a compression and a compression level for this file
            }
          }) : x.file(c, F, {
            compression: "STORE"
            // no compression
          });
        }
      this.restoreGltfTransformNodes(s), this._scene.render();
      let I = await x.generateAsync({ type: "blob" });
      if (I)
        return I = I, I.lastModifiedDate = /* @__PURE__ */ new Date(), I.name = "arobj.zip", I;
    }
    return null;
  }
  async exportMeshToGLBBlob(e, t) {
    const n = this.getTryOnMeshHierarchy(t), s = this.convertGltfTransformNodes(n), o = {
      meshes: n,
      materials: this.getMeshesMaterials(n),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: e != null,
      rootUrl: e,
      shouldExportNode: (m) => {
        for (let x = 0; x < n.length; x++)
          if (n[x] === m)
            return !0;
        return !1;
      }
    }, h = await BABYLON.GLTF2Export.GLBAsync(this._scene, "model", o).catch((m) => (console.error(m), null));
    let c = null;
    if (h && h.glTFFiles) {
      for (let m in h.glTFFiles)
        if (Ms.EndsWith(m, ".glb")) {
          const x = new Tf(), B = await h.glTFFiles[m].arrayBuffer(), I = x.readBinary(B);
          I.getRoot().listNodes().filter((Z) => Z.getParent() === null || Z.getParent() instanceof oo).forEach((Z) => {
          });
          const M = x.writeBinary(I);
          c = new Blob([M], { type: "model/gltf-binary" });
        }
    }
    return this.restoreGltfTransformNodes(s), c;
  }
  async exportMeshesToARAsync(e, t, n, s, o, h = "usdz", c = null, m = null, x = !0) {
    let B = "";
    if (console.log("sono in exportMeshesToARAsync ==> window token ", window.token), s && o && Zakeke.config) {
      const I = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + s + "/" + o + "/" + h;
      try {
        B = await jQuery.ajax({
          url: I,
          cache: !1,
          contentType: !1,
          processData: !1,
          type: "GET"
        });
      } catch {
        B = "";
      }
    }
    if (!B) {
      console.log("sono in !cachedArFile  ==> window token ", window.token);
      const I = this.getAuthToken();
      if (!I)
        return console.error("No authentication token available"), "";
      let F = this.getSceneCmScalingFactor(c, m);
      const M = await this.getGltfBlobForARExport(e, t, n);
      if (M) {
        const Z = {
          flipTextures: !0,
          formats: [h]
        };
        s && (Z.sceneID = s), o && (Z.sceneCode = o), F && (Z.scale = F);
        let V = !0;
        window.isOwin != null && (V = window.isOwin);
        const P = await new Xf("artasks", I, V).upload(M, Z);
        P && P.length > 0 && (B = P[0].arFileUrl);
      }
    }
    return B;
  }
  async exportMeshesToARMultiformatAsync(e, t, n, s = ["usdz", "glb", "png"], o = null, h = null, c = !0, m, x) {
    let B = [], I = [];
    if (m && x && Zakeke.config)
      for (let F = 0; F < s.length; F++) {
        const M = s[F], Z = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + m + "/" + x + "/" + M;
        try {
          const V = await jQuery.ajax({
            url: Z,
            cache: !1,
            contentType: !1,
            processData: !1,
            type: "GET"
          });
          V && I.push({ format: M, arFileUrl: V });
        } catch {
        }
        B = I;
      }
    if (I.length !== s.length) {
      const F = this.getAuthToken();
      if (console.log(
        "sono in cachedArFiles.length !== formats.length  ==> provo a recuperare il token con getAuthToken ",
        F
      ), !F)
        return console.error("No authentication token available"), B;
      const M = this.getSceneCmScalingFactor(o, h), Z = I.map((P) => P.format), V = s.filter((P) => !Z.includes(P)), te = await this.getGltfBlobForARExport(e, t, n);
      if (te) {
        const P = {
          flipTextures: !0,
          formats: V
          // Escludo i formati cachati
        };
        m && (P.sceneID = m), x && (P.sceneCode = x), M && (P.scale = M);
        let K = !0;
        window.isOwin !== void 0 && (K = window.isOwin);
        const le = await new Xf("artasks", F, K).upload(te, P);
        if (le && le.length > 0)
          for (const fe of le)
            fe && fe.arFileUrl && B.push({ format: fe.format, arFileUrl: fe.arFileUrl });
      }
    }
    return B;
  }
  // Metodi per esportazione on-the-fly client side
  async exportSceneToLocalGlTFBlobsAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), n = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    let s = [];
    for (let o in n.glTFFiles)
      s.push(n.glTFFiles[o]);
    return s;
  }
  async exportSceneToLocalGlTFUrlsAsync() {
    const e = [], t = Zakeke.generateUUID(), n = this.getSceneToGltfExportOptions(), s = await BABYLON.GLTF2Export.GLTFAsync(this._scene, t, n);
    if (s)
      for (let h in s.glTFFiles) {
        var o = s.glTFFiles[h];
        e.push(this.getGltfFileUrl(h, o));
      }
    return e;
  }
  async downloadSceneLocalGltfAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), n = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    n && n.downloadFiles();
  }
  async exportSceneToLocalGLBBlobAsync() {
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalGLBBase64Async() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let n = new FileReader();
      n.readAsDataURL(t.blob), n.onloadend = () => {
        let s = n.result;
        typeof s == "string" && (e = s);
      };
    }
    return e;
  }
  async exportSceneToLocalGLBUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getGltfFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalGLBAsync() {
    var n;
    (n = this._scene) == null || n.meshes.forEach((s) => {
      s.isVisible = !0;
    });
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let s = this.getGltfFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = s, t.click(), document.body.removeChild(t), URL.revokeObjectURL(s);
    }
  }
  async getSceneLocalGLBBlobInfoAsync(e = null, t = null) {
    let n = {
      name: null,
      blob: null
    };
    const s = Zakeke.generateUUID(), o = this.getSceneToGltfExportOptions();
    let h = await BABYLON.GLTF2Export.GLBAsync(this._scene, s, o).catch((c) => (console.error(c), null));
    if (h && h.glTFFiles) {
      for (let c in h.glTFFiles)
        if (Ms.EndsWith(c, ".glb")) {
          let m = this.getSceneCmScalingFactor(), x = 1;
          m && (x = m / 100);
          const B = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, 2 * Math.PI), I = new Tf(), F = await h.glTFFiles[c].arrayBuffer(), M = I.readBinary(F), Z = M.getRoot().listNodes().filter((J) => J.getParent() === null || J.getParent() instanceof oo), V = [0, 1, 0, 0], te = Z.every((J) => {
            const le = J.getRotation();
            return V.length === le.length && V.every((fe, X) => fe === le[X]);
          });
          Z.forEach((J) => {
            J.setScale([x, x, x]), te && J.setRotation([B.x, B.y, B.z, B.w]);
          });
          const P = I.writeBinary(M), K = new Blob([P], { type: "model/gltf-binary" });
          n.name = c, n.blob = K;
          break;
        }
    }
    return n;
  }
  // -----------------------------------------------------------------------
  // Metodi per exportazione della scena in USDZ su client (on-the-fly)
  async exportSceneToLocalUSDZBlobAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalUSDZBase64Async() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let n = new FileReader();
      n.readAsDataURL(t.blob), n.onloadend = () => {
        let s = n.result;
        typeof s == "string" && (e = s);
      };
    }
    return e;
  }
  async exportSceneToLocalUSDZUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getUsdzFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalUSDZAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let n = this.getUsdzFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = n, t.click(), document.body.removeChild(t), URL.revokeObjectURL(n);
    }
  }
  async getSceneLocalUSDZBlobInfoAsync() {
    let e = {
      name: null,
      blob: null
    };
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.name && t.blob && t.blob instanceof Blob) {
      const n = this.getGltfFileUrl(t.name, t.blob), s = await uw.convertGlbToUsdz(n);
      e.name = t.name.replace(".glb", ".usdz"), e.blob = s;
    }
    return e;
  }
  // -----------------------------------------------------------------------
  getSceneToGltfExportOptions() {
    var e = this.getMeshesForAR(), t = {
      meshes: e,
      materials: this.getMeshesMaterials(e),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: !1,
      rootUrl: null,
      shouldExportNode: (n) => {
        for (var s = 0; s < e.length; s++)
          if (e[s] === n)
            return !0;
        return !1;
      }
    };
    return t;
  }
  getGltfFileUrl(e, t) {
    var n = void 0;
    return Ms.EndsWith(e, ".glb") ? n = { type: "model/gltf-binary" } : Ms.EndsWith(e, ".bin") ? n = { type: "application/octet-stream" } : Ms.EndsWith(e, ".gltf") ? n = { type: "model/gltf+json" } : Ms.EndsWith(e, ".jpeg") ? n = { type: "image/jpeg" } : Ms.EndsWith(e, ".png") && (n = { type: "image/png" }), window.URL.createObjectURL(new Blob([t], n));
  }
  getUsdzFileUrl(e, t) {
    var n = { type: "model/vnd.usdz+zip" };
    return window.URL.createObjectURL(new Blob([t], n));
  }
  exportSceneToBabylon() {
    const e = BABYLON.SceneSerializer.Serialize(this._scene);
    return JSON.stringify(e);
  }
  exportVisibleMeshesToBabylon() {
    const e = this.getVisibleMeshes(), t = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
    return JSON.stringify(t);
  }
  downloadImageFromBase64(e, t, n) {
    var s = document.createElement("a");
    s.href = e, s.download = t, s.click(), s.remove();
  }
  getStandardMaterialTextureType(e, t) {
    return e.diffuseTexture === t ? "diffuse" : e.emissiveTexture === t ? "emissive" : e.ambientTexture === t ? "ambient" : e.lightmapTexture === t ? "lightmap" : e.opacityTexture === t ? "opacity" : e.specularTexture === t ? "specular" : e.reflectionTexture === t ? "reflection" : e.refractionTexture === t ? "refraction" : e.bumpTexture === t ? "bump" : null;
  }
  getPBRMetallicRoughnessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.baseTexture === t ? "base" : e.metallicRoughnessTexture === t ? "metallicRoughness" : null;
  }
  getPBRSpecularGlossinessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.diffuseTexture === t ? "diffuse" : e.specularGlossinessTexture === t ? "specularGlossiness" : null;
  }
  getPBRMaterialTextureType(e, t) {
    if (e.cameraColorGradingTexture === t)
      return "cameraColorGrading";
    if (e.albedoTexture === t)
      return "albedo";
    if (e.ambientTexture === t)
      return "ambient";
    if (e.opacityTexture === t)
      return "opacity";
    if (e.reflectionTexture === t)
      return "reflection";
    if (e.emissiveTexture === t)
      return "emissive";
    if (e.reflectivityTexture === t)
      return "reflectivity";
    if (e.metallicTexture === t)
      return "metallic";
    if (e.microSurfaceTexture === t)
      return "microSurface";
    if (e.bumpTexture === t)
      return "bump";
    if (e.lightmapTexture === t)
      return "lightmap";
    if (e.refractionTexture === t)
      return "refraction";
    if (e.clearCoat) {
      if (e.clearCoat.texture === t)
        return "clearCoat";
      if (e.clearCoat.bumpTexture === t)
        return "clearCoat_bump";
      if (e.clearCoat.tintTexture === t)
        return "clearCoat_tint";
      if (e.clearCoat.textureRoughness === t)
        return "clearCoat_textureRoughness";
      if (e.clearCoat.texture === t)
        return "clearCoat_texture";
    }
    if (e.anisotropy && e.anisotropy.texture === t)
      return "anisotropy_texture";
    if (e.sheen) {
      if (e.sheen.texture === t)
        return "sheen_texture";
      if (e.sheen.textureRoughness === t)
        return "sheen_textureRoughness";
    }
    if (e.subSurface) {
      if (e.subSurface.thicknessTexture === t)
        return "subSurface_thickness";
      if (e.subSurface.refractionIntensityTexture === t)
        return "subSurface_refractionIntensity";
      if (e.subSurface.translucencyIntensityTexture === t)
        return "subSurface_translucencyIntensity";
    }
    return null;
  }
  getZakekePBRMaterialTextureType(e, t) {
    return e.albedoTexture === t ? "albedo" : e.bumpTexture === t ? "bump" : e.reflectionTexture === t ? "reflection" : e.matCapReflectionTexture === t ? "matCapReflection" : e.reflectivityTexture === t ? "reflectivity" : e.microsurfaceTexture === t ? "microsurface" : e.ambientTexture === t ? "ambient" : e.aoTexture === t ? "ao" : e.opacityTexture === t ? "opacity" : null;
  }
  getMaterialTextureType(e, t) {
    return e instanceof BABYLON.StandardMaterial ? this.getStandardMaterialTextureType(e, t) : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? this.getPBRMetallicRoughnessMaterialTextureType(e, t) : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? this.getPBRSpecularGlossinessMaterialTextureType(e, t) : e instanceof BABYLON.PBRMaterial ? this.getPBRMaterialTextureType(e, t) : e instanceof Zakeke.PBRMaterial ? this.getZakekePBRMaterialTextureType(e, t) : null;
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          return e[`${t}Texture`];
        case "refraction":
          return e.refractionTexture;
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  applyTexture(e, t, n) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (n) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${n}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(n, e) : t.removeTexture(n);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (n) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
  }
  applyTextureOnSerializedMaterial(e, t, n, s) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (s === "BABYLON.StandardMaterial" || s === "BABYLON.PBRMaterial" || s === "BABYLON.PBRBaseSimpleMaterial") && (t.useLightmapAsShadowmap = !0)), s === "BABYLON.StandardMaterial")
      t[`${n}Texture`] = e;
    else if (s === "BABYLON.PBRMetallicRoughnessMaterial")
      t[`${n}Texture`] = e;
    else if (s === "BABYLON.PBRSpecularGlossinessMaterial")
      t[`${n}Texture`] = e;
    else if (s === "BABYLON.PBRMaterial")
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          t[`${n}Texture`] = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else
      s === "Zakeke.PBRMaterial" && (t[`${n}Texture`] = e);
  }
  getSerializedMaterialTexture(e, t, n) {
    if (n === "BABYLON.StandardMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRMetallicRoughnessMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRSpecularGlossinessMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRMaterial")
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          return e[`${t}Texture`];
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (n === "Zakeke.PBRMaterial")
      return e[`${t}Texture`];
    return null;
  }
  getMaterialTypeName(e) {
    return e instanceof BABYLON.StandardMaterial ? "BABYLON.StandardMaterial" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "BABYLON.PBRMetallicRoughnessMaterial" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "BABYLON.PBRSpecularGlossinessMaterial" : e instanceof BABYLON.PBRMaterial ? "BABYLON.PBRMaterial" : e instanceof BABYLON.ShaderMaterial ? "BABYLON.ShaderMaterial" : e instanceof Zakeke.PBRMaterial ? "Zakeke.PBRMaterial" : "BABYLON.StandardMaterial";
  }
  async exportMeshToBabylon(e) {
    const t = this.getMeshHierarchy(e.id);
    return await this.exportMeshesToBabylon(t);
  }
  async exportMeshesToBabylon(e) {
    const t = this.getMeshesMaterials(e), n = e.map((o) => ({ id: o.id, doNotSerialize: o.doNotSerialize })), s = t.map((o) => ({ id: o.id, doNotSerialize: o.doNotSerialize }));
    e.forEach((o) => o.doNotSerialize = !1), t.forEach((o) => o.doNotSerialize = !1);
    try {
      const o = {};
      for (let m = 0; m < t.length; m++) {
        const x = t[m], B = x.id, I = this.getMaterialDynamicTextures(x);
        if (I.length > 0) {
          o[B] = {
            materialType: this.getMaterialTypeName(x),
            textures: []
          };
          for (let F = 0; F < I.length; F++) {
            const M = I[F], Z = Zakeke.generateUUID(), V = this.getMaterialTextureType(x, M), te = await this.exportTextureToBase64Async(M, "image/png");
            if (V && te) {
              const P = {
                id: Z,
                type: V,
                base64String: te,
                isProcedural: M instanceof BABYLON.ProceduralTexture
              };
              o[B].textures.push(P);
            }
          }
        }
      }
      const h = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
      for (const m of h.materials) {
        const x = Object.getOwnPropertyNames(m).filter(
          (I) => I.slice(-7) === "Texture" && typeof m[I] == "object"
        ), B = m.id;
        if (o.hasOwnProperty(B)) {
          const I = o[B], F = I.materialType, M = I.textures;
          for (const Z of M) {
            const V = this.getSerializedMaterialTexture(
              m,
              Z.type,
              I.materialType
            );
            if (V) {
              if (Z.isProcedural) {
                const te = new BABYLON.Texture(
                  Z.base64String,
                  this._scene,
                  void 0,
                  void 0,
                  void 0,
                  void 0
                );
                await Mn.whenTextureIsReadyAsync(te), te.uScale = V.uScale, te.vScale = V.vScale, te.uOffset = V.uOffset, te.vOffset = V.vOffset, te.uAng = V.uAng, te.vAng = V.vAng, te.level = V.level, te.coordinatesIndex = V.coordinatesIndex, te.coordinatesMode = V.coordinatesMode, te.wrapU = V.wrapU, te.wrapV = V.wrapV;
                const P = te.serialize();
                P.url = Z.base64String, P.name = "prcedural texture", this.applyTextureOnSerializedMaterial(
                  P,
                  m,
                  Z.type,
                  F
                ), te.dispose();
              }
            } else
              V.url = Z.base64String, V.name = "dynamic texture";
          }
        }
      }
      let c = JSON.stringify(h);
      return e.forEach((m) => {
        var x;
        return m.doNotSerialize = (x = n.find((B) => B.id === m.id)) == null ? void 0 : x.doNotSerialize;
      }), t.forEach(
        (m) => m.doNotSerialize = s.find((x) => x.id === m.id).doNotSerialize
      ), c;
    } finally {
      e.forEach((o) => {
        var h;
        return o.doNotSerialize = (h = n.find((c) => c.id === o.id)) == null ? void 0 : h.doNotSerialize;
      }), t.forEach(
        (o) => o.doNotSerialize = s.find((h) => h.id === o.id).doNotSerialize
      );
    }
  }
  async exportMeshesForTyOnToBabylon() {
    const e = this.getMeshesForTryOn();
    return await this.exportMeshesToBabylon(e);
  }
  downloadBlob(e) {
    const t = URL.createObjectURL(e), n = document.createElement("a");
    n.download = "mesh.json", n.href = t, n.click(), URL.revokeObjectURL(t);
  }
  async downloadMeshBabylonAsync(e) {
    const t = await this.exportMeshToBabylon(e);
    if (t) {
      const n = new Blob([t], { type: "application/json" });
      this.downloadBlob(n);
    }
  }
  async downloadMeshesBabylonAsync(e) {
    const t = await this.exportMeshesToBabylon(e);
    if (t) {
      const n = new Blob([t], { type: "application/json" });
      this.downloadBlob(n);
    }
  }
  async loadAllDelayedMaterialFromZip(e, t, n) {
    console.log("Loading delayed materials from zip");
    const s = e + `materials_${t}.zip`, h = await (await fetch(s)).blob(), c = new File([h], "materials.zip", { type: "application/zip" }), m = new Kf();
    await m.loadAsync(c);
    const x = m.file(/\.json$/) || [], B = [], I = [];
    if (x.length === 0)
      throw console.warn("No material files found in the zip archive."), new Error("No material files found in the zip archive.");
    for (const [F, M] of x.entries()) {
      const Z = M.name.match(/material_\d+_(.*)\.json/);
      if (!Z)
        continue;
      const V = Z[1].replace(/_/g, "-");
      I.push(
        new Promise(async (te, P) => {
          console.log("Loading material: " + V);
          try {
            const K = await M.async("string"), J = JSON.parse(K), le = BABYLON.Material.Parse(J, this._scene, e);
            le ? (le.metadata = le.metadata || {}, le.metadata.fromZip = !0, B.push(le), await (n == null ? void 0 : n(F + 1, x.length)), te(le)) : P(new Error("Failed to parse material " + V));
          } catch (K) {
            P(K);
          }
        })
      );
    }
    return await Promise.all(I), B;
  }
  // In case loadAllDelayedMaterialAsync failed, we can cleanup all temporary materials.
  // They're recognized by the metadata property `fromZip` set to true.
  async cleanupAllTemporaryMaterialsAsync() {
    try {
      const e = this._scene.materials.filter((t) => {
        var n;
        return (n = t.metadata) == null ? void 0 : n.fromZip;
      });
      console.log("Cleaning up temporary materials loaded from zip, found:", e.length), e.forEach((t) => {
        t.dispose(!1, !0);
      });
    } catch (e) {
      console.warn("Error during cleanup of temporary materials:", e);
    }
  }
  async loadAllDelayedMaterialsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var s = {};
      for (var o in this._scene.metadata.delayedMaterials)
        s[o] = {
          name: this._scene.metadata.delayedMaterials[o].name,
          file: this._scene.metadata.delayedMaterials[o].file
        };
      n = await this.loadMaterialsAsync(e, s, t);
    }
    return n;
  }
  async loadDelayedMaterialsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      for (var s = {}, o = 0; o < t.length; o++)
        this._scene.metadata.delayedMaterials.hasOwnProperty(t[o]) && (s[t[o]] = {
          name: this._scene.metadata.delayedMaterials[t[o]].name,
          file: this._scene.metadata.delayedMaterials[t[o]].file
        });
      n = await this.loadMaterialsAsync(e, s);
    }
    return n;
  }
  async loadDelayedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var n = {};
      if (this._scene.metadata.delayedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.delayedMaterials[t].name,
          file: this._scene.metadata.delayedMaterials[t].file
        };
        let s = await this.loadMaterialsAsync(e, n);
        if (s.length > 0)
          return s[0];
      }
    }
    return null;
  }
  async loadMaterialsAsync(e, t, n) {
    const s = [];
    let o = [];
    for (let c in t) {
      const m = this._scene.getMaterialByID(c);
      if (m)
        s.push(m);
      else {
        const x = t[c];
        o.push(this.loadMaterialInternalAsync(c, e, x.file));
      }
    }
    const h = await Promise.all(o);
    for (let c = 0; c < h.length; c++) {
      const m = h[c], x = JSON.parse(m), B = BABYLON.Material.Parse(x, this._scene, e);
      B && (console.debug("Waiting for material ready: " + B.id + " - " + B.name), this._scene.useDelayedTextureLoading || await Mn.whenAllMaterialTexturesAreReady(B), Logger.info("Material ready: " + B.id + " - " + B.name), s.push(B), await (n == null ? void 0 : n(c + 1, h.length)));
    }
    return this.setupShaderMaterialsCameraPosition(), s;
  }
  loadMaterialInternalAsync(e, t, n) {
    if (Logger.info("Loading delayed material: " + e), this._loadingMaterials.hasOwnProperty(e))
      return this._loadingMaterials[e];
    let s = Ms.EndsWith(t, "/") ? "" : "/";
    var o = t + s + n;
    let h = new Promise((c, m) => {
      BABYLON.Tools.LoadFile(
        o,
        (x) => {
          Logger.info("Loaded delayed material: " + e), c(x), delete this._loadingMaterials[e];
        },
        void 0,
        void 0,
        !1,
        (x, B) => {
          m(B), delete this._loadingMaterials[e];
        }
      );
    });
    return this._loadingMaterials[e] = h, h;
  }
  showMesh(e) {
    this.showHideMesh(e, !0);
  }
  hideMesh(e) {
    this.showHideMesh(e, !1);
  }
  showHideMesh(e, t) {
    var n = (o, h) => {
      o.isVisible = h;
      var c = o.getChildMeshes(!0);
      c && c.forEach((m) => {
        n(m, h);
      });
    }, s = this._scene.getMeshById(e);
    s && n(s, t);
  }
  changeMaterialColor(e, t, n) {
    for (let s = 0; s < this._scene.meshes.length && this._scene.meshes[s].material !== e; s++)
      ;
    t && e[t] !== void 0 && (e[t] = n);
  }
  applyMaterialByName(e, t) {
    if (this._scene) {
      let n = this._scene.getMaterialByName(e);
      n && this.applyMaterial(n, t);
    }
  }
  applyMaterial(e, t) {
    var n = (s) => {
      if (s.subMeshes && s.subMeshes.length > 0 && s.material && s.material instanceof BABYLON.MultiMaterial)
        for (let h = 0; h < s.subMeshes.length; h++) {
          let c = s.subMeshes[h];
          this.applyMaterialToSubMesh(e, s, c);
        }
      else
        s.material = e;
      var o = s.getChildMeshes(!0);
      o && o.forEach((h) => {
        n(h);
      });
    };
    t && n(t);
  }
  applyMaterialToSubMeshByName(e, t, n) {
    var s = this._scene.getMaterialByName(e);
    s && this.applyMaterialToSubMesh(s, t, n);
  }
  applyMaterialToSubMesh(e, t, n) {
    const s = n.materialIndex, o = t || n.getMesh();
    o.material instanceof BABYLON.MultiMaterial && s >= 0 && s < o.material.subMaterials.length && (o.material.subMaterials[s] = e);
  }
  getSubMeshMaterial(e, t) {
    const n = t.materialIndex, s = e || t.getMesh();
    return s.material instanceof BABYLON.MultiMaterial && n >= 0 && n < s.material.subMaterials.length ? s.material.subMaterials[n] : null;
  }
  async prefetchTexturesFormMeshAsync(e) {
    e.material && await this.prefetchTexturesForMaterialAsync(e.material);
    var t = e.getChildMeshes(!0);
    for (let n = 0; n < t.length; n++) {
      let s = t[n];
      s.material && await this.prefetchTexturesForMaterialAsync(s.material);
    }
  }
  async prefetchTexturesForMaterialAsync(e) {
    if (e) {
      var t = this.getTexturesForMaterial(e);
      for (let n = 0; n < t.length; n++)
        await Mn.whenTextureIsReadyAsync(t[n]);
    }
  }
  checkDelayState(e) {
    e instanceof BABYLON.Mesh && e._checkDelayState();
    var t = e.getChildMeshes(!0);
    t.forEach((n) => this.checkDelayState(n));
  }
  // Crea una nuova mesh data da una minima espansione di quella passata in input
  // in modo che ne costituisca un rivestimento
  createEnvelopeMesh(e) {
    let t = 0.01;
    const n = e.getHierarchyBoundingVectors();
    if (n) {
      const o = n.min, h = n.max;
      t = new BABYLON.BoundingInfo(o, h).boundingSphere.radius * 5e-3;
    }
    const s = this.cloneMesh(e.id, !0, !0);
    return s && s instanceof BABYLON.Mesh && this.expandMesh(s, t), s;
  }
  expandMesh(e, t) {
    const n = new hw();
    if (e && e instanceof BABYLON.Mesh) {
      n.expandMesh(e, t);
      const s = e.getChildMeshes();
      for (const o of s)
        o instanceof BABYLON.Mesh && n.expandMesh(o, t);
    }
  }
  cloneMesh(e, t = !1, n = !1) {
    let s = null;
    if (this._scene) {
      const o = this._scene.getMeshById(e);
      if (o) {
        const h = this.getNextIncrementalName(o.name);
        if (s = o.clone(h, o.parent), s) {
          s.id = Zakeke.generateUUID(), t && this.duplicateGeometry(o, s, n);
          const c = s.getChildMeshes();
          for (const m of c) {
            const x = this._scene.getMeshById(m.id);
            m.id = Zakeke.generateUUID();
            const B = m.parent ? m.parent.name : null;
            if (B) {
              const I = m.name.indexOf(B + ".") + B.length + 1;
              m.name = m.name.substr(I);
            }
            x && t && this.duplicateGeometry(x, m, n);
          }
        }
      }
    }
    return s;
  }
  duplicateGeometry(e, t, n = !1) {
    if (e instanceof BABYLON.Mesh && t instanceof BABYLON.Mesh) {
      const s = BABYLON.VertexData.ExtractFromMesh(e, !0, !0);
      return new BABYLON.Geometry(
        Zakeke.generateUUID(),
        t.getScene(),
        s,
        n,
        t
      );
    }
    return null;
  }
  // Material metadata
  getSceneMaterialMetadata(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) ? this._scene.metadata.materialsMetadata[e] : null;
  }
  getOrCreateSceneMaterialMetadata(e) {
    let t = this.getSceneMaterialMetadata(e);
    return t || (t = {}, this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.materialsMetadata || (this._scene.metadata.materialsMetadata = {}), this._scene.metadata.materialsMetadata[e] = t), t;
  }
  removeSceneMaterialMetadata(e) {
    this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) && delete this._scene.metadata.materialsMetadata[e];
  }
  offloadAllUnusedMaterials() {
    this.getAllUnusedMaterials().forEach((t) => this.offloadMaterial(t.id));
  }
  // Salva la serializzazione del materiale e lo rimuove dalla scena (eliminando anche le relative texture).
  // Lo scopo è quello di liberare la memoria occupata dalle texture
  offloadMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    t && t.id !== "default material" && this.getMeshesUsingMaterial(e).length === 0 && (Logger.info("Offloading material: " + t.id + " - " + t.name), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials || (this._scene.metadata.offloadedMaterials = {}), this._scene.metadata.offloadedMaterials[e] = this.getOffloadedMaterialInfo(t), Logger.info("Disposing material: " + e), t.dispose(!1, !0));
  }
  getOffloadedMaterialInfo(e) {
    return { name: e.name, data: e.serialize() };
  }
  // Il materiale restituito dalla versione sincrona potrebbe non essere pronto per l'applicazione alla mesh
  loadAllOffloadedMaterials(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = this.loadOffloadedMaterials(e, this._scene.metadata.offloadedMaterials)), t;
  }
  loadOffloadedMaterialsByIDs(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const s = {};
      for (let o = 0; o < t.length; o++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[o]) && (s[t[o]] = {
          name: this._scene.metadata.offloadedMaterials[t[o]].name,
          data: this._scene.metadata.offloadedMaterials[t[o]].data
        });
      n = this.loadOffloadedMaterials(e, s);
    }
    return n;
  }
  loadOffloadedMaterial(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const n = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const s = this.loadOffloadedMaterials(e, n);
        if (s.length > 0)
          return s[0];
      }
    }
    return null;
  }
  loadOffloadedMaterials(e, t) {
    const n = [];
    for (const s in t) {
      const o = t[s], h = this.loadOffloadedMaterialInternal(s, o.name, e, o.data);
      h && n.push(h);
    }
    return n;
  }
  // Il nome viene passato solo ai fini del log
  loadOffloadedMaterialInternal(e, t, n, s) {
    const o = this._scene.getMaterialByID(e);
    if (o)
      return o;
    const h = t ? ` - ${t}` : "";
    return Logger.info("Loading offloaded material: " + e + h), BABYLON.Material.Parse(s, this._scene, n);
  }
  // Nella versione asincrona si aspetta che tutte le texture del materiale caricato siano pronte
  async loadAllOffloadedMaterialsAsync(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = await this.loadOffloadedMaterialsAsync(e, this._scene.metadata.offloadedMaterials)), t;
  }
  async loadOffloadedMaterialsByIDsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const s = {};
      for (let o = 0; o < t.length; o++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[o]) && (s[t[o]] = {
          name: this._scene.metadata.offloadedMaterials[t[o]].name,
          data: this._scene.metadata.offloadedMaterials[t[o]].data
        });
      n = await this.loadOffloadedMaterialsAsync(e, s);
    }
    return n;
  }
  async loadOffloadedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const n = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const s = await this.loadOffloadedMaterialsAsync(e, n);
        if (s.length > 0)
          return s[0];
      }
    }
    return null;
  }
  async loadOffloadedMaterialsAsync(e, t) {
    const n = [], s = [];
    for (const h in t) {
      const c = t[h];
      s.push(this.loadOffloadedMaterialInternalAsync(h, c.name, e, c.data));
    }
    return (await Promise.all(s)).forEach((h) => {
      h && n.push(h);
    }), n;
  }
  // Il nome viene passato solo ai fini del log
  async loadOffloadedMaterialInternalAsync(e, t, n, s) {
    const o = this._scene.getMaterialByID(e);
    if (o)
      return o;
    const h = t ? ` - ${t}` : "";
    Logger.info("Loading offloaded material: " + e + h);
    const c = BABYLON.Material.Parse(s, this._scene, n);
    return c ? (Logger.info("Waiting for material ready: " + e + h), await Mn.whenAllMaterialTexturesAreReady(c), Logger.info("Material ready: " + e + h)) : Logger.info("No material was created from offloaded material: " + e + h), c;
  }
  loadTextureFiles(e, t) {
    if (e)
      for (let n = 0; n < t.length; n++) {
        const s = t[n], o = /^(?:\/|[a-z]+:\/\/)/.test(s);
        let h = s;
        o || (h = e + s);
        const c = h.lastIndexOf("."), m = c > -1 ? h.substring(c).toLowerCase() : "";
        m === ".dds" || m === ".env" || m === ".hdr" ? BABYLON.Tools.LoadFile(h, () => {
        }) : (m === ".png" || m === ".jpg") && BABYLON.Tools.LoadImage(
          h,
          (Z) => {
          },
          function() {
          },
          null
        );
      }
  }
  // Recupera il materiale specificato, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  async getOrLoadMaterialAsync(e, t) {
    let n = this._scene.getMaterialByID(e);
    return !n && this._scene.metadata && (this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e) ? n = await this.loadOffloadedMaterialAsync(t, e) : this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) && (n = await this.loadDelayedMaterialAsync(t, e))), n;
  }
  getOrCreateDummyMaterial() {
    let e = this._scene.getMaterialByID(this._dummyMaterialID);
    return e || (e = new BABYLON.StandardMaterial("Dummy Material", this._scene), e.id = this._dummyMaterialID, e.metadata = { isRealMaterial: !1 }), e;
  }
  isDummyMaterial(e) {
    return e.id === this._dummyMaterialID;
  }
  meshHasDummyMaterial(e, t) {
    var n;
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let s = 0; s < e.subMeshes.length; s++) {
        const h = e.subMeshes[s].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID)
          return !0;
      }
    else if (e.material && e.material.id === this._dummyMaterialID)
      return !0;
    if (t) {
      const s = e.getChildMeshes(!0);
      for (const o of s)
        if (this.meshHasDummyMaterial(o, !0))
          return !0;
    }
    return !1;
  }
  getMeshDelayedMaterialIDs(e) {
    var n;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let s = 0; s < e.subMeshes.length; s++) {
        const h = e.subMeshes[s].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
          const c = `${e.id}_${h}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(c)) {
            const m = this._scene.metadata.originalMeshMaterials[c];
            this._scene.metadata.delayedMaterials.hasOwnProperty(m) && t.indexOf(m) === -1 && t.push(m);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const s = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.delayedMaterials.hasOwnProperty(s) && t.indexOf(s) === -1 && t.push(s);
    }
    return e.getChildMeshes().forEach(
      (s) => Array.prototype.push.apply(t, this.getMeshDelayedMaterialIDs(s))
    ), t;
  }
  getMeshOffloadedMaterialIDs(e) {
    var n;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let s = 0; s < e.subMeshes.length; s++) {
        const h = e.subMeshes[s].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
          const c = `${e.id}_${h}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(c)) {
            const m = this._scene.metadata.originalMeshMaterials[c];
            this._scene.metadata.offloadedMaterials.hasOwnProperty(m) && t.indexOf(m) === -1 && t.push(m);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const s = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.offloadedMaterials.hasOwnProperty(s) && t.indexOf(s) === -1 && t.push(s);
    }
    return e.getChildMeshes().forEach(
      (s) => Array.prototype.push.apply(t, this.getMeshOffloadedMaterialIDs(s))
    ), t;
  }
  setDummyMaterialToInvisibleMeshes() {
    this.getInvisibleMeshes().forEach((t) => {
      this.setMeshDummyMaterial(t, !1);
    });
  }
  setMeshDummyMaterial(e, t) {
    this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.originalMeshMaterials || (this._scene.metadata.originalMeshMaterials = {});
    const n = this.getOrCreateDummyMaterial();
    if (e.material)
      if (e.subMeshes && e.subMeshes.length > 0 && e.material instanceof BABYLON.MultiMaterial)
        for (let s = 0; s < e.subMeshes.length; s++) {
          const h = e.subMeshes[s].materialIndex, c = e.material.subMaterials[h];
          if (c && !this.isDummyMaterial(c)) {
            const m = `${e.id}_${h}`;
            this._scene.metadata.originalMeshMaterials[m] = c.id, e.material.subMaterials[h] = n;
          }
        }
      else
        e.material && !this.isDummyMaterial(e.material) && (this._scene.metadata.originalMeshMaterials[e.id] = e.material.id, e.material = n);
    t && e.getChildMeshes().forEach((s) => this.setMeshDummyMaterial(s, !0));
  }
  // Il metodo è sincrono perché mi aspetto che tutti i materiali originali siano già presenti nella scena
  unsetAllDummyMaterials() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      this.unsetMeshDummyMaterial(this._scene.meshes[e], !1);
  }
  // Il metodo è asincrono perché ci sia aspetta che non tutti i materiali siano presenti nella scena, in qual caso verranno caricati
  async unsetAllDummyMaterialsAsync(e) {
    for (let t = 0; t < this._scene.meshes.length; t++)
      await this.unsetMeshDummyMaterialAsync(this._scene.meshes[t], e, !1);
  }
  // Il metodo è sincrono perché mi aspetto che i materiali originali siano tutti gà presenti nella scena
  unsetMeshDummyMaterial(e, t) {
    var n;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let s = 0; s < e.subMeshes.length; s++) {
          const h = e.subMeshes[s].materialIndex;
          if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
            const c = `${e.id}_${h}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(c)) {
              const m = this._scene.metadata.originalMeshMaterials[c], x = this._scene.getMaterialByID(m);
              x && (e.material.subMaterials[h] = x, delete this._scene.metadata.originalMeshMaterials[c]);
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const s = this._scene.metadata.originalMeshMaterials[e.id], o = this._scene.getMaterialByID(s);
        o && (e.material = o, delete this._scene.metadata.originalMeshMaterials[e.id]);
      }
      t && e.getChildMeshes().forEach((s) => this.unsetMeshDummyMaterial(s, !0));
    }
  }
  // Il metodo è asincrono perché ci si aspetta che non tutti i materiali siano presenti sulla scena, nel qual caso verranno caricati
  async unsetMeshDummyMaterialAsync(e, t, n) {
    var s;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let o = 0; o < e.subMeshes.length; o++) {
          const c = e.subMeshes[o].materialIndex;
          if (e.material.subMaterials[c] && ((s = e.material.subMaterials[c]) == null ? void 0 : s.id) === this._dummyMaterialID) {
            const m = `${e.id}_${c}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(m)) {
              const x = this._scene.metadata.originalMeshMaterials[m], B = await this.getOrLoadMaterialAsync(x, t);
              e.material.subMaterials[c] = B, delete this._scene.metadata.originalMeshMaterials[m];
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const o = this._scene.metadata.originalMeshMaterials[e.id], h = await this.getOrLoadMaterialAsync(o, t);
        e.material = h, delete this._scene.metadata.originalMeshMaterials[e.id];
      }
      if (n) {
        const o = e.getChildMeshes();
        for (const h of o)
          await this.unsetMeshDummyMaterialAsync(h, t, !0);
      }
    }
  }
  async reloadAllLoadingErrorTexturesAsync(e) {
    for (const t of this._scene.textures)
      await this.reloadLoadingErrorTextureAsync(e, t);
  }
  async reloadMaterialLoadingErrorTexturesAsync(e, t) {
    for (const n of t.getActiveTextures())
      await this.reloadLoadingErrorTextureAsync(e, n);
  }
  reloadLoadingErrorTextureAsync(e, t) {
    if (t instanceof BABYLON.Texture && t.url) {
      const s = t.getInternalTexture();
      if (t.loadingError || s && s.loadingError) {
        const o = t.url, h = /^(?:\/|[a-z]+:\/\/)/.test(t.url);
        var n = t.url;
        return h || (n = e + t.url), new Promise((c, m) => {
          t.updateURL(
            n,
            null,
            () => {
              t.url = o, c();
            },
            void 0,
            () => {
              t.url = o, m();
            }
          );
        });
      }
    }
    return Promise.resolve();
  }
  isTextureLoadingError(e) {
    if (e.loadingError)
      return !0;
    const t = e.getInternalTexture();
    return t !== null && t.loadingError;
  }
  materialHasLoadingErrorTextues(e) {
    return e.getActiveTextures().some((t) => this.isTextureLoadingError(t));
  }
  // A dynamic texture is a procedural texture or a texture created from a Blob
  getMaterialDynamicTextures(e) {
    return e.getActiveTextures().filter(
      (n) => n instanceof BABYLON.ProceduralTexture || n instanceof BABYLON.Texture && n.url && n.url.indexOf("blob:") !== -1
    );
  }
  exportTextureToBase64Async(e, t = "image/png", n = !1) {
    return Promise.resolve().then(async () => {
      const s = await this.getPixelsFromTexture(e);
      if (!s)
        return null;
      const o = e.getSize();
      if (e.mimeType)
        switch (e.mimeType) {
          case "image/jpeg":
            t = "image/jpeg";
            break;
          case "image/png":
            t = "image/png";
            break;
        }
      return this.createBase64FromCanvasAsync(s, o.width, o.height, t, n);
    });
  }
  createBase64FromCanvasAsync(e, t, n, s, o = !1) {
    return new Promise(async (h, c) => {
      const m = BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, x = this._scene, B = x.getEngine(), I = B.createRawTexture(
        e,
        t,
        n,
        BABYLON.Constants.TEXTUREFORMAT_RGBA,
        !1,
        o,
        BABYLON.Texture.NEAREST_SAMPLINGMODE,
        null,
        m
      );
      await BABYLON.TextureTools.ApplyPostProcess(
        "pass",
        I,
        x,
        m,
        BABYLON.Constants.TEXTURE_NEAREST_SAMPLINGMODE,
        BABYLON.Constants.TEXTUREFORMAT_RGBA
      );
      const F = await B._readTexturePixels(I, t, n), M = await BABYLON.Tools.DumpDataAsync(
        t,
        n,
        F,
        s,
        void 0,
        !0,
        !1
      );
      h(M);
    });
  }
  getPixelsFromTexture(e) {
    return e.textureType === BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, e.readPixels();
  }
  comparePBRMaterials(e, t) {
    (e.albedoColor && !t.albedoColor || !e.albedoColor && t.albedoColor || e.albedoColor && t.albedoColor && !e.albedoColor.equals(t.albedoColor)) && console.log("albedoColor"), e.allowShaderHotSwapping !== t.allowShaderHotSwapping && console.log("allowShaderHotSwapping"), e.alphaCutOff !== t.alphaCutOff && console.log("alphaCutOff"), (e.ambientColor && !t.ambientColor || !e.ambientColor && t.ambientColor || e.ambientColor && t.ambientColor && !e.ambientColor.equals(t.ambientColor)) && console.log("ambientColor"), e.ambientTextureStrength !== t.ambientTextureStrength && console.log("ambientTextureStrength"), this.compareAnisotropy(e.anisotropy, t.anisotropy), this.compareBRDF(e.brdf, t.brdf), this.compareClearCoat(e.clearCoat, t.clearCoat), e.depthFunction !== t.depthFunction && console.log("depthFunction"), this.compareDetailMap(e.detailMap, t.detailMap), e.directIntensity !== t.directIntensity && console.log("directIntensity"), e.disableBumpMap !== t.disableBumpMap && console.log("disableBumpMap"), e.disableColorWrite !== t.disableColorWrite && console.log("disableColorWrite"), e.disableDepthWrite !== t.disableDepthWrite && console.log("disableDepthWrite"), e.disableLighting !== t.disableLighting && console.log("disableLighting"), (e.emissiveColor && !t.emissiveColor || !e.emissiveColor && t.emissiveColor || e.emissiveColor && t.emissiveColor && !e.emissiveColor.equals(t.emissiveColor)) && console.log("emissiveColor"), e.emissiveIntensity !== t.emissiveIntensity && console.log("emissiveIntensity"), e.enableSpecularAntiAliasing !== t.enableSpecularAntiAliasing && console.log("enableSpecularAntiAliasing"), e.environmentIntensity !== t.environmentIntensity && console.log("environmentIntensity"), e.forceAlphaTest !== t.forceAlphaTest && console.log("forceAlphaTest"), e.forceDepthWrite !== t.forceDepthWrite && console.log("forceDepthWrite"), e.forceIrradianceInFragment !== t.forceIrradianceInFragment && console.log("forceIrradianceInFragment"), e.forceNormalForward !== t.forceNormalForward && console.log("forceNormalForward"), e.invertNormalMapX !== t.invertNormalMapX && console.log("invertNormalMapX"), e.invertNormalMapY !== t.invertNormalMapY && console.log("invertNormalMapY"), e.maxSimultaneousLights !== t.maxSimultaneousLights && console.log("maxSimultaneousLights"), e.metallic !== t.metallic && console.log("metallic"), e.metallicF0Factor !== t.metallicF0Factor && console.log("metallicF0Factor"), (e.metallicReflectanceColor && !t.metallicReflectanceColor || !e.metallicReflectanceColor && t.metallicReflectanceColor || e.metallicReflectanceColor && t.metallicReflectanceColor && !e.metallicReflectanceColor.equals(t.metallicReflectanceColor)) && console.log("metallicReflectanceColor"), e.microSurface !== t.microSurface && console.log("microSurface"), e.parallaxScaleBias !== t.parallaxScaleBias && console.log("parallaxScaleBias"), e.pointSize !== t.pointSize && console.log("pointSize"), this.comparePrePassConfiguration(e.prePassConfiguration, t.prePassConfiguration), (e.reflectionColor && !t.reflectionColor || !e.reflectionColor && t.reflectionColor || e.reflectionColor && t.reflectionColor && !e.reflectionColor.equals(t.reflectionColor)) && console.log("reflectionColor"), (e.reflectivityColor && !t.reflectivityColor || !e.reflectivityColor && t.reflectivityColor || e.reflectivityColor && t.reflectivityColor && !e.reflectivityColor.equals(t.reflectivityColor)) && console.log("reflectivityColor"), e.roughness !== t.roughness && console.log("roughness"), e.separateCullingPass !== t.separateCullingPass && console.log("separateCullingPass"), this.compareSheen(e.sheen, t.sheen), e.sideOrientation !== t.sideOrientation && console.log("sideOrientation"), e.specularIntensity !== t.specularIntensity && console.log("specularIntensity"), this.compareSubSurface(e.subSurface, t.subSurface), e.twoSidedLighting !== t.twoSidedLighting && console.log("twoSidedLighting"), e.unlit !== t.unlit && console.log("unlit"), e.useAlphaFresnel !== t.useAlphaFresnel && console.log("useAlphaFresnel"), e.useAlphaFromAlbedoTexture !== t.useAlphaFromAlbedoTexture && console.log("useAlphaFromAlbedoTexture"), e.useAmbientInGrayScale !== t.useAmbientInGrayScale && console.log("useAmbientInGrayScale"), e.useAmbientOcclusionFromMetallicTextureRed !== t.useAmbientOcclusionFromMetallicTextureRed && console.log("useAmbientOcclusionFromMetallicTextureRed"), e.useAutoMicroSurfaceFromReflectivityMap !== t.useAutoMicroSurfaceFromReflectivityMap && console.log("useAutoMicroSurfaceFromReflectivityMap"), e.useHorizonOcclusion !== t.useHorizonOcclusion && console.log("useHorizonOcclusion"), e.useLightmapAsShadowmap !== t.useLightmapAsShadowmap && console.log("useLightmapAsShadowmap"), e.useLinearAlphaFresnel !== t.useLinearAlphaFresnel && console.log("useLinearAlphaFresnel"), e.useMetallnessFromMetallicTextureBlue !== t.useMetallnessFromMetallicTextureBlue && console.log("useMetallnessFromMetallicTextureBlue"), e.useMicroSurfaceFromReflectivityMapAlpha !== t.useMicroSurfaceFromReflectivityMapAlpha && console.log("useMicroSurfaceFromReflectivityMapAlpha"), e.useObjectSpaceNormalMap !== t.useObjectSpaceNormalMap && console.log("useObjectSpaceNormalMap"), e.useOnlyMetallicFromMetallicReflectanceTexture !== t.useOnlyMetallicFromMetallicReflectanceTexture && console.log("useOnlyMetallicFromMetallicReflectanceTexture"), e.useParallax !== t.useParallax && console.log("useParallax"), e.useParallaxOcclusion !== t.useParallaxOcclusion && console.log("useParallaxOcclusion"), e.useRadianceOcclusion !== t.useRadianceOcclusion && console.log("useRadianceOcclusion"), e.useRadianceOverAlpha !== t.useRadianceOverAlpha && console.log("useRadianceOverAlpha"), e.useRoughnessFromMetallicTextureAlpha !== t.useRoughnessFromMetallicTextureAlpha && console.log("useRoughnessFromMetallicTextureAlpha"), e.useRoughnessFromMetallicTextureGreen !== t.useRoughnessFromMetallicTextureGreen && console.log("useRoughnessFromMetallicTextureGreen"), e.useSpecularOverAlpha !== t.useSpecularOverAlpha && console.log("useSpecularOverAlpha"), e.zOffset !== t.zOffset && console.log("zOffset"), e.zOffsetUnits !== t.zOffsetUnits && console.log("zOffsetUnits"), e.alpha !== t.alpha && console.log("alpha"), e.alphaMode !== t.alphaMode && console.log("alphaMode"), e.backFaceCulling !== t.backFaceCulling && console.log("backFaceCulling"), this.compareCameraCurve("", e.cameraColorCurves, t.cameraColorCurves), e.cameraColorCurvesEnabled !== t.cameraColorCurvesEnabled && console.log("cameraColorCurvesEnabled"), e.cameraColorGradingEnabled !== t.cameraColorGradingEnabled && console.log("cameraColorGradingEnabled"), e.cameraContrast !== t.cameraContrast && console.log("cameraContrast"), e.cameraExposure !== t.cameraExposure && console.log("cameraExposure"), e.cameraToneMappingEnabled !== t.cameraToneMappingEnabled && console.log("cameraToneMappingEnabled"), e.canRenderToMRT !== t.canRenderToMRT && console.log("canRenderToMRT"), e.cullBackFaces !== t.cullBackFaces && console.log("cullBackFaces"), e.fillMode !== t.fillMode && console.log("fillMode"), e.fogEnabled !== t.fogEnabled && console.log("fogEnabled"), e.hasRenderTargetTextures !== t.hasRenderTargetTextures && console.log("hasRenderTargetTextures"), this.compareImageProcessingConfiguration(e.imageProcessingConfiguration, t.imageProcessingConfiguration), e.indexOfRefraction !== t.indexOfRefraction && console.log("indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log("invertRefractionY"), e.isFrozen !== t.isFrozen && console.log("isFrozen"), e.isPrePassCapable !== t.isPrePassCapable && console.log("isPrePassCapable"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log("linkRefractionWithTransparency"), e.needDepthPrePass !== t.needDepthPrePass && console.log("needDepthPrePass"), e.realTimeFiltering !== t.realTimeFiltering && console.log("realTimeFiltering"), e.realTimeFilteringQuality !== t.realTimeFilteringQuality && console.log("realTimeFilteringQuality"), e.transparencyMode !== t.transparencyMode && console.log("transparencyMode"), e.useGLTFLightFalloff !== t.useGLTFLightFalloff && console.log("useGLTFLightFalloff"), e.useLogarithmicDepth !== t.useLogarithmicDepth && console.log("useLogarithmicDepth"), e.usePhysicalLightFalloff !== t.usePhysicalLightFalloff && console.log("usePhysicalLightFalloff"), this.compareTexture("albedo", e.albedoTexture, t.albedoTexture), this.compareTexture("emissive", e.emissiveTexture, t.emissiveTexture);
  }
  compareAnisotropy(e, t) {
    const n = "anisotropy";
    (e.direction && !t.direction || !e.direction && t.direction || e.direction && t.direction && !e.direction.equals(t.direction)) && console.log(n + " - direction"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled");
  }
  compareBRDF(e, t) {
    const n = "brdf";
    e.useEnergyConservation !== t.useEnergyConservation && console.log(n + " - useEnergyConservation"), e.useSmithVisibilityHeightCorrelated !== t.useSmithVisibilityHeightCorrelated && console.log(n + " - useSmithVisibilityHeightCorrelated"), e.useSpecularGlossinessInputEnergyConservation !== t.useSpecularGlossinessInputEnergyConservation && console.log(n + " - useSpecularGlossinessInputEnergyConservation"), e.useSphericalHarmonics !== t.useSphericalHarmonics && console.log(n + " - useSphericalHarmonics");
  }
  compareClearCoat(e, t) {
    const n = "clearCoat";
    e.indexOfRefraction !== t.indexOfRefraction && console.log(n + " - indexOfRefraction"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.isTintEnabled !== t.isTintEnabled && console.log(n + " - isTintEnabled"), e.roughness !== t.roughness && console.log(n + " - roughness"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(n + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(n + " - tintColorAtDistance"), e.tintThickness !== t.tintThickness && console.log(n + " - tintThickness"), e.useRoughnessFromMainTexture != t.useRoughnessFromMainTexture && console.log(n + " - useRoughnessFromMainTexture");
  }
  compareDetailMap(e, t) {
    const n = "detailMap";
    e.bumpLevel !== t.bumpLevel && console.log(n + " - bumpLevel"), e.diffuseBlendLevel !== t.diffuseBlendLevel && console.log(n + " - diffuseBlendLevel"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.normalBlendMethod !== t.normalBlendMethod && console.log(n + " - normalBlendMethod"), e.roughnessBlendLevel !== t.roughnessBlendLevel && console.log(n + " - roughnessBlendLevel");
  }
  comparePrePassConfiguration(e, t) {
    const n = "PrePassConfiguration";
    (e.currentViewProjection && !t.currentViewProjection || !e.currentViewProjection && t.currentViewProjection || e.currentViewProjection && t.currentViewProjection && !e.currentViewProjection.equals(t.currentViewProjection)) && console.log(n + " - currentViewProjection"), (e.previousViewProjection && !t.previousViewProjection || !e.previousViewProjection && t.previousViewProjection || e.previousViewProjection && t.previousViewProjection && !e.previousViewProjection.equals(t.previousViewProjection)) && console.log(n + " - previousViewProjection");
  }
  compareSheen(e, t) {
    const n = "Sheen";
    e.albedoScaling !== t.albedoScaling && console.log(n + " - albedoScaling"), (e.color && !t.color || !e.color && t.color || e.color && t.color && !e.color.equals(t.color)) && console.log(n + " - color"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.linkSheenWithAlbedo !== t.linkSheenWithAlbedo && console.log(n + " - linkSheenWithAlbedo"), e.roughness !== t.roughness && console.log(n + " - roughness"), e.useRoughnessFromMainTexture !== t.useRoughnessFromMainTexture && console.log(n + " - useRoughnessFromMainTexture");
  }
  compareSubSurface(e, t) {
    const n = "SubSurface";
    (e.diffusionDistance && !t.diffusionDistance || !e.diffusionDistance && t.diffusionDistance || e.diffusionDistance && t.diffusionDistance && !e.diffusionDistance.equals(t.diffusionDistance)) && console.log(n + " - diffusionDistance"), e.indexOfRefraction !== t.indexOfRefraction && console.log(n + " - indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log(n + " - invertRefractionY"), e.isRefractionEnabled !== t.isRefractionEnabled && console.log(n + " - isRefractionEnabled"), e.isScatteringEnabled !== t.isScatteringEnabled && console.log(n + " - isScatteringEnabled"), e.isTranslucencyEnabled !== t.isTranslucencyEnabled && console.log(n + " - isTranslucencyEnabled"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log(n + " - linkRefractionWithTransparency"), e.maximumThickness !== t.maximumThickness && console.log(n + " - maximumThickness"), e.minimumThickness !== t.minimumThickness && console.log(n + " - minimumThickness"), e.refractionIntensity !== t.refractionIntensity && console.log(n + " - refractionIntensity"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(n + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(n + " - tintColorAtDistance"), e.translucencyIntensity !== t.translucencyIntensity && console.log(n + " - translucencyIntensity"), e.useAlbedoToTintRefraction !== t.useAlbedoToTintRefraction && console.log(n + " - useAlbedoToTintRefraction"), e.useAlbedoToTintTranslucency !== t.useAlbedoToTintTranslucency && console.log(n + " - useAlbedoToTintTranslucency"), e.useGltfStyleTextures !== t.useGltfStyleTextures && console.log(n + " - useGltfStyleTextures"), e.useMaskFromThicknessTexture !== t.useMaskFromThicknessTexture && console.log(n + " - useMaskFromThicknessTexture"), e.useThicknessAsDepth !== t.useThicknessAsDepth && console.log(n + " - useThicknessAsDepth");
  }
  compareCameraCurve(e, t, n) {
    if ((t === null && n !== null || t !== null && n === null) && console.log("cameraColorCurves"), t && n) {
      const s = e ? e + " - cameraColorCurves" : "cameraColorCurves";
      t.globalDensity !== n.globalDensity && console.log(s + " - globalDensity"), t.globalExposure !== n.globalExposure && console.log(s + "- globalExposure"), t.globalHue !== n.globalHue && console.log(s + " - globalHue"), t.globalSaturation !== n.globalSaturation && console.log(s + " - globalSaturation"), t.highlightsDensity !== n.highlightsDensity && console.log(s + " - highlightsDensity"), t.highlightsExposure !== n.highlightsExposure && console.log(s + " - highlightsExposure"), t.highlightsHue !== n.highlightsHue && console.log(s + " - highlightsHue"), t.highlightsSaturation !== n.highlightsSaturation && console.log(s + " - highlightsSaturation"), t.midtonesDensity !== n.midtonesDensity && console.log(s + " - midtonesDensity"), t.midtonesExposure !== n.midtonesExposure && console.log(s + " - midtonesExposure"), t.midtonesHue !== n.midtonesHue && console.log(s + " - midtonesHue"), t.midtonesSaturation !== n.midtonesSaturation && console.log(s + " - midtonesSaturation"), t.shadowsDensity !== n.shadowsDensity && console.log(s + " - shadowsDensity"), t.shadowsExposure !== n.shadowsExposure && console.log(s + " - shadowsExposure"), t.shadowsHue !== n.shadowsHue && console.log(s + " - shadowsHue"), t.shadowsSaturation !== n.shadowsSaturation && console.log(s + " - shadowsSaturation");
    }
  }
  compareImageProcessingConfiguration(e, t) {
    const n = "imageProcessingConfiguration";
    this.compareCameraCurve(n, e.colorCurves, t.colorCurves), e.vignetteCameraFov !== t.vignetteCameraFov && console.log(n + " - vignetteCameraFov"), e.vignetteCentreX !== t.vignetteCentreX && console.log(n + " - vignetteCentreX"), e.vignetteCentreY !== t.vignetteCentreY && console.log(n + " - vignetteCentreY"), (e.vignetteColor && !t.vignetteColor || !e.vignetteColor && t.vignetteColor || e.vignetteColor && t.vignetteColor && !e.vignetteColor.equals(t.vignetteColor)) && console.log(n + " - vignetteColor"), e.vignetteStretch !== t.vignetteStretch && console.log(n + " - vignetteStretch"), e.vignetteWeight !== t.vignetteWeight && console.log(n + " - vignetteWeight"), e.applyByPostProcess !== t.applyByPostProcess && console.log(n + " - applyByPostProcess"), e.colorCurvesEnabled !== t.colorCurvesEnabled && console.log(n + " - colorCurvesEnabled"), e.colorGradingBGR !== t.colorGradingBGR && console.log(n + " - colorGradingBGR"), e.colorGradingEnabled !== t.colorGradingEnabled && console.log(n + " - colorGradingEnabled"), e.colorGradingWithGreenDepth !== t.colorGradingWithGreenDepth && console.log(n + " - colorGradingWithGreenDepth"), e.contrast !== t.contrast && console.log(n + " - contrast"), e.exposure !== t.exposure && console.log(n + " - exposure"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.toneMappingEnabled !== t.toneMappingEnabled && console.log(n + " - toneMappingEnabled"), e.toneMappingType !== t.toneMappingType && console.log(n + " - toneMappingType"), e.vignetteBlendMode !== t.vignetteBlendMode && console.log(n + " - vignetteBlendMode"), e.vignetteEnabled !== t.vignetteEnabled && console.log(n + " - vignetteEnabled");
  }
  compareTexture(e, t, n) {
    if (t && !n || !t && n) {
      console.log(e);
      return;
    }
    if (t instanceof BABYLON.Texture && !(n instanceof BABYLON.Texture) || n instanceof BABYLON.Texture && !(t instanceof BABYLON.Texture)) {
      console.log(e);
      return;
    }
    t && n && (t.anisotropicFilteringLevel !== n.anisotropicFilteringLevel && console.log(e + " - anisotropicFilteringLevel"), t instanceof BABYLON.Texture && n instanceof BABYLON.Texture && (t.homogeneousRotationInUVTransform !== n.homogeneousRotationInUVTransform && console.log(e + " - homogeneousRotationInUVTransform"), t.uAng !== n.uAng && console.log(e + " - uAng"), t.uOffset !== n.uOffset && console.log(e + " - uOffset"), t.uRotationCenter !== n.uRotationCenter && console.log(e + " - uRotationCenterSearch"), t.uScale !== n.uScale && console.log(e + " - uScale"), t.vAng !== n.vAng && console.log(e + " - vAng"), t.vOffset !== n.vOffset && console.log(e + " - vOffset"), t.vRotationCenter !== n.vRotationCenter && console.log(e + " - vRotationCenterSearch"), t.vScale !== n.vScale && console.log(e + " - vScale"), t.wAng !== n.wAng && console.log(e + " - wAng"), t.wRotationCenter !== n.wRotationCenter && console.log(e + " - wRotationCenterSearch"), t.invertY !== n.invertY && console.log(e + " - invertY"), t.mimeType !== n.mimeType && console.log(e + " - mimeType")), t.invertZ !== n.invertZ && console.log(e + " - invertZ"), t.isRenderTarget !== n.isRenderTarget && console.log(e + " - isRenderTarget"), t.level !== n.level && console.log(e + " - level"), t.wrapR !== n.wrapR && console.log(e + " - wrapR"), t.canRescale !== n.canRescale && console.log(e + " - canRescale"), t.coordinatesIndex !== n.coordinatesIndex && console.log(e + " - coordinatesIndex"), t.coordinatesMode !== n.coordinatesMode && console.log(e + " - coordinatesMode"), t.gammaSpace !== n.gammaSpace && console.log(e + " - gammaSpace"), t.getAlphaFromRGB !== n.getAlphaFromRGB && console.log(e + " - getAlphaFromRGB"), t.hasAlpha !== n.hasAlpha && console.log(e + "- hasAlpha"), t.is2DArray !== n.is2DArray && console.log(e + " - is2DArray"), t.is3D !== n.is3D && console.log(e + " - is3D"), t.isBlocking !== n.isBlocking && console.log(e + " - isBlocking"), t.isCube !== n.isCube && console.log(e + " - isCube"), t.isRGBD !== n.isRGBD && console.log(e + " - isRGBD"), t.linearSpecularLOD !== n.linearSpecularLOD && console.log(e + " - linearSpecularLOD"), t.lodGenerationOffset !== n.lodGenerationOffset && console.log(e + " - lodGenerationOffset"), t.lodGenerationScale !== n.lodGenerationScale && console.log(e + " - lodGenerationScale"), t.noMipmap !== n.noMipmap && console.log(e + " - noMipmap"), t.samplingMode !== n.samplingMode && console.log(e + " - samplingMode"), t.textureFormat !== n.textureFormat && console.log(e + " - textureFormat"), t.textureType !== n.textureType && console.log(e + " - textureType"), t.wrapU !== n.wrapU && console.log(e + " - wrapU"), t.wrapV !== n.wrapV && console.log(e + " - wrapV"));
  }
  async showResizableCanvas(e, t, n, s, o, h, c, m, x, B, I, F) {
    if (!this._isLoading) {
      if (this._isLoading = !0, this._scene) {
        this.clearResizableMeshes();
        const M = await this._resizableCanvas3DGenerator.generatePreview3D(
          {
            width: e,
            height: t,
            depth: n,
            borderRadius: s,
            radiusResolution: 0.1,
            type: o,
            borderColor: h,
            columns: c,
            rows: m,
            useCheckerTexture: !1,
            backgroundUrl: I,
            backgroundColor: B,
            shape: F
          },
          this._scene
        ), Z = await BABYLON.SceneLoader.ImportMeshAsync(
          "",
          "",
          "data:" + JSON.stringify(M)
        );
        this._loadedMeshes.push(...Z.meshes);
        const V = Z.meshes[0], te = 2 / Math.max(e, t);
        if (V.scaling.scaleInPlace(te), V.position.z = 0, V.rotate(BABYLON.Axis.Y, Math.PI, BABYLON.Space.LOCAL), this.camera && this.camera instanceof BABYLON.ArcRotateCamera && this.camera.setPosition(new BABYLON.Vector3(0, 1, 4)), !this._scene.lights.find((J) => J.name === "resizableLight")) {
          console.log("Creating light...");
          const J = new BABYLON.HemisphericLight(
            "resizableLight",
            new BABYLON.Vector3(0.1, 1, 0.1),
            this._scene
          );
          J.groundColor = new BABYLON.Color3(0.6, 0.6, 0.6), J.intensity = 1;
          const le = this.getDefaultHemisphericLight();
          le && this._scene.removeLight(le);
        }
        const K = Z.meshes.find((J) => !J.parent);
        return K.metadata = {
          isResizable: !0,
          AR: !0,
          sizecm: {
            height: t / x
          }
        }, this._isLoading = !1, Z.meshes;
      }
      return this._isLoading = !1, null;
    }
  }
  /**
   * Remove all meshes from the scene
   */
  clearResizableMeshes() {
    this._scene.meshes.filter((e) => {
      var t;
      return (t = e.metadata) == null ? void 0 : t.isResizable;
    }).forEach((e) => e.dispose());
  }
  switchMode(e) {
    var s;
    console.log("Switch 3D mode", e);
    const t = this._scene.lights.find((o) => o.name === "resizableLight"), n = this.getDefaultHemisphericLight();
    e === "resizable" ? this._lastVisibilityStates.size === 0 && ((s = this._scene) == null || s.meshes.forEach((o) => {
      (!o.metadata || !o.metadata.isResizable) && (this._lastVisibilityStates.set(o, o.isVisible), o.isVisible = !1);
    })) : (t && (t.dispose(), this._scene.removeLight(t)), n && this._scene.addLight(n), this._lastVisibilityStates.forEach((o, h) => h.isVisible = o), this._lastVisibilityStates.clear(), this.clearResizableMeshes());
  }
  async rotate(e, t, n) {
    return new Promise((s) => {
      if (this._scene) {
        console.log(`Rotating scene on axis ${t} by ${e} degrees`);
        const o = e * Math.PI / 180;
        this._scene.meshes.filter((h) => !h.parent).forEach((h) => {
          if (!n)
            h.rotate(t, o, BABYLON.Space.WORLD), s();
          else {
            const c = h.rotationQuaternion ?? h.rotation.toQuaternion(), m = BABYLON.Quaternion.RotationAxis(t, o).multiply(
              c
            ), x = BABYLON.Animation.CreateAndStartAnimation(
              h.id + "rotation",
              h,
              "rotationQuaternion",
              60,
              20,
              c,
              m,
              BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT,
              void 0,
              () => {
                x == null || x.stop(), s();
              }
            );
          }
        });
      }
    });
  }
  // ===== CAMERA ROTATION METHODS =====
  /**
   * Ruota la camera a sinistra di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraLeft(e = 5, t = !0) {
    this.rotateCameraHorizontal(-e, t);
  }
  /**
   * Ruota la camera a destra di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraRight(e = 5, t = !0) {
    this.rotateCameraHorizontal(e, t);
  }
  /**
   * Ruota la camera verso l'alto di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraUp(e = 5, t = !0) {
    this.rotateCameraVertical(-e, t);
  }
  /**
   * Ruota la camera verso il basso di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraDown(e = 5, t = !0) {
    this.rotateCameraVertical(e, t);
  }
  /**
   * Ruota la camera orizzontalmente (attorno all'asse Y).
   * @param degrees Angolo in gradi (positivo = destra, negativo = sinistra)
   * @param animate Se true, anima il movimento
   */
  rotateCameraHorizontal(e, t = !0) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    const n = e * Math.PI / 180;
    let s = this._camera.alpha + n;
    this._camera.lowerAlphaLimit !== null && this._camera.lowerAlphaLimit !== void 0 && (s = Math.max(this._camera.lowerAlphaLimit, s)), this._camera.upperAlphaLimit !== null && this._camera.upperAlphaLimit !== void 0 && (s = Math.min(this._camera.upperAlphaLimit, s)), t ? this.animateCameraToFinalParamters(
      s,
      this._camera.beta,
      this._camera.radius,
      this._camera.target,
      0.3
    ) : this._camera.alpha = s;
  }
  /**
   * Ruota la camera verticalmente (attorno all'asse orizzontale).
   * @param degrees Angolo in gradi (positivo = giù, negativo = su)
   * @param animate Se true, anima il movimento
   */
  rotateCameraVertical(e, t = !0) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    const n = e * Math.PI / 180;
    let s = this._camera.beta + n;
    s = Math.max(0.1, Math.min(Math.PI - 0.1, s)), this._camera.lowerBetaLimit !== null && this._camera.lowerBetaLimit !== void 0 && (s = Math.max(this._camera.lowerBetaLimit, s)), this._camera.upperBetaLimit !== null && this._camera.upperBetaLimit !== void 0 && (s = Math.min(this._camera.upperBetaLimit, s)), t ? this.animateCameraToFinalParamters(
      this._camera.alpha,
      s,
      this._camera.radius,
      this._camera.target,
      0.3
    ) : this._camera.beta = s;
  }
};
Gd._shadowGenerator = null;
let yi = Gd;
class $s extends BABYLON.ProceduralTexture {
  constructor(e, t, n, s, o, h, c) {
    super(e, t, n, s, h, c), this._initializing = !1, this._baseTexture = o, this.updateShaderUniforms();
  }
  get initializing() {
    return this._initializing;
  }
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  isReadyAsync() {
    return yi.whenTextureIsReadyAsync(this);
  }
  dispose() {
    super.dispose(), this._baseTexture && this._baseTexture.dispose();
  }
  beginInit() {
    this._initializing = !0;
  }
  endInit() {
    this._initializing = !1, this.updateShaderUniforms();
  }
  updateShaderUniforms() {
    this._initializing || this.setBaseTextureUniform();
  }
  setBaseTextureUniform() {
    this.setTexture("uSampler", this._baseTexture);
  }
}
const mu = class jd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, jd.FRAGMENT_SHADER, n, s, o, h), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  //@BABYLON.serialize()
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurXProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurXProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurXProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
mu.FRAGMENT_SHADER = "zakeke_BlurXProceduralTexture";
mu.CUSTOM_TYPE = "Zakeke.BlurXProceduralTexture";
let ho = mu;
const dw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x - 4.0*blur, vUV.y)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x - blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x + blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 4.0*blur, vUV.y)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], gw = dw.join(`
`);
BABYLON.Effect.ShadersStore[`${ho.FRAGMENT_SHADER}PixelShader`] = gw;
const _u = class Wd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, Wd.FRAGMENT_SHADER, n, s, o, h), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurYProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurYProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurYProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
_u.FRAGMENT_SHADER = "zakeke_BlurYProceduralTexture";
_u.CUSTOM_TYPE = "Zakeke.BlurYProceduralTexture";
let uo = _u;
const pw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 4.0*blur)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 4.0*blur)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], mw = pw.join(`
`);
BABYLON.Effect.ShadersStore[`${uo.FRAGMENT_SHADER}PixelShader`] = mw;
const vu = class qd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, qd.FRAGMENT_SHADER, n, s, o, h), this._foreColor = new BABYLON.Vector3(1, 1, 1), this._backColor = new BABYLON.Vector3(0, 0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get foreColor() {
    return this._foreColor;
  }
  set foreColor(e) {
    this._foreColor = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get backColor() {
    return this._backColor;
  }
  set backColor(e) {
    this._backColor = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._foreColor || new BABYLON.Vector3(1, 1, 1), t = this._backColor || new BABYLON.Vector3(0, 0, 0);
    this.setVector3("foreColor", e), this.setVector3("backColor", t);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = ForegroundBackgroundProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): ForegroundBackgroundProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new ForegroundBackgroundProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
vu.FRAGMENT_SHADER = "zakeke_ForegroundBackgroundProceduralTexture";
vu.CUSTOM_TYPE = "Zakeke.ForegroundBackgroundProceduralTexture";
let co = vu;
const _w = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec3 foreColor;",
  "uniform vec3 backColor;",
  "void main(void) {",
  "   // background color",
  "   vec4 background = vec4(backColor.xyz, 1);",
  "   vec4 foreground = vec4(foreColor.xyz, 1);",
  "   // texel",
  "	vec4 t0 = texture2D(uSampler, vUV.xy);",
  "   // change in white",
  "   t0 = vec4(foreground.xyz, t0.a);",
  "   gl_FragColor = mix(background, t0, t0.a);",
  "}"
], vw = _w.join(`
`);
BABYLON.Effect.ShadersStore[`${co.FRAGMENT_SHADER}PixelShader`] = vw;
const yu = class Zd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, Zd.FRAGMENT_SHADER, n, s, o, h), this._offset = new BABYLON.Vector2(0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector2()
  get offset() {
    return this._offset;
  }
  set offset(e) {
    this._offset = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this.getRenderSize(), t = this._offset || new BABYLON.Vector2();
    this.setVector2("offset", new BABYLON.Vector2(t.x / e, t.y / e));
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = MoveProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): MoveProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new MoveProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
yu.FRAGMENT_SHADER = "zakeke_MoveProceduralTexture";
yu.CUSTOM_TYPE = "Zakeke.MoveProceduralTexture";
let bu = yu;
const yw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec2 offset;",
  "void main(void) {",
  "   // translated texel",
  "   gl_FragColor = texture2D(uSampler, vec2(vUV.x - offset.x, vUV.y + offset.y));",
  //'   gl_FragColor = texture2D(uSampler, vUV.xy - offset);',
  "}"
], bw = yw.join(`
`);
BABYLON.Effect.ShadersStore[`${bu.FRAGMENT_SHADER}PixelShader`] = bw;
const xu = class $d extends $s {
  constructor(e, t, n, s, o, h, c) {
    super(e, t, $d.FRAGMENT_SHADER, n, s, h, c), this._blendTexture = o, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
xu.FRAGMENT_SHADER = "zakeke_MultiplyProceduralTexture";
xu.CUSTOM_TYPE = "Zakeke.MultiplyProceduralTexture";
let ro = xu;
const xw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = base * blend;",
  "}"
], ww = xw.join(`
`);
BABYLON.Effect.ShadersStore[`${ro.FRAGMENT_SHADER}PixelShader`] = ww;
const wu = class Xd extends $s {
  constructor(e, t, n, s, o, h) {
    super(e, t, Xd.FRAGMENT_SHADER, n, s, o, h), this._bias = 50, this._invertR = !1, this._invertG = !1, this._bevel = !1, this._intensity = 0.5, this.updateShaderUniforms();
  }
  get bias() {
    return this._bias == null ? 50 : this._bias;
  }
  set bias(e) {
    this._bias = e, this.updateShaderUniforms();
  }
  get invertR() {
    return this._invertR == null ? !1 : this._invertR;
  }
  set invertR(e) {
    this._invertR = e, this.updateShaderUniforms();
  }
  get invertG() {
    return this._invertG == null ? !1 : this._invertG;
  }
  set invertG(e) {
    this._invertG = e, this.updateShaderUniforms();
  }
  get bevel() {
    return this._bevel == null ? !1 : this._bevel;
  }
  set bevel(e) {
    this._bevel = e, this.updateShaderUniforms();
  }
  get intensity() {
    return this._intensity == null ? 0.5 : this._intensity;
  }
  set intensity(e) {
    this._intensity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = this.getRenderSize(), t = e < 1024 ? e * 2 : e;
      this.setFloat("size", e), this.setVector2("u_textureSize", new BABYLON.Vector2(e, e)), this.setVector3("dimensions", new BABYLON.Vector3(t, t, 0)), this.setFloat("bias", this.bias), this.setFloat("invertR", this.invertR ? -1 : 1), this.setFloat("invertG", this.invertG ? -1 : 1), this.setFloat("bevel", this.bevel ? 1 : 0), this.setFloat("intensity", this.intensity);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
wu.FRAGMENT_SHADER = "zakeke_normalMapProceduralTexture";
wu.CUSTOM_TYPE = "Zakeke.NormalMapProceduralTexture";
let Kd = wu;
const Sw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform vec3 dimensions;",
  "uniform sampler2D uSampler;",
  "uniform vec2 u_textureSize;",
  "uniform float bias;",
  "uniform float invertR;",
  "uniform float invertG;",
  "uniform float bevel;",
  "uniform float intensity;",
  "void main(void) {",
  "   vec2 step = vec2(1.0, 1.0) / dimensions.xy;",
  "   vec4 black = vec4(0, 0, 0, 1);",
  "	vec4 bk = vec4(1, 1, 1, 1);",
  "	vec4 t0 = texture2D(uSampler, vUV.xy + vec2(0.0, 0.0));",
  "	vec4 t1 = texture2D(uSampler, vUV.xy + vec2(step.x, 0.0));",
  "	vec4 t2 = texture2D(uSampler, vUV.xy + vec2(-step.x, 0.0));",
  "	vec4 t3 = texture2D(uSampler, vUV.xy + vec2(0.0, step.y));",
  "	vec4 t4 = texture2D(uSampler, vUV.xy + vec2(0.0, -step.y));",
  "   if (bevel != 0.0) ",
  "   {",
  "      t0 = vec4(0, 0, 0, t0.a);",
  "      t1 = vec4(0, 0, 0, t1.a);",
  "      t2 = vec4(0, 0, 0, t2.a);",
  "      t3 = vec4(0, 0, 0, t3.a);",
  "      t4 = vec4(0, 0, 0, t4.a);",
  "   }",
  "	t0 = mix(bk, t0, t0.a);",
  "	t1 = mix(bk, t1, t1.a);",
  "	t2 = mix(bk, t2, t2.a);",
  "	t3 = mix(bk, t3, t3.a);",
  "	t4 = mix(bk, t4, t4.a);",
  "	float d0 = abs(t0.r);",
  "	float d1 = abs(t1.r);",
  "	float d2 = abs(t2.r);",
  "	float d3 = abs(t3.r);",
  "	float d4 = abs(t4.r);",
  "	float dx = ((d2 - d0) + (d0 - d1)) * intensity;",
  "	float dy = ((d4 - d0) + (d0 - d3)) * intensity;",
  "	vec4 normal = vec4(normalize(vec3(dx * invertR, dy * invertG, 1.0 - ((bias - 0.1) / 100.0))), 1.0);",
  "	gl_FragColor = vec4(normal.xyz * 0.5 + 0.5, 1.0);",
  "}"
], Mw = Sw.join(`
`);
BABYLON.Effect.ShadersStore[`${Kd.FRAGMENT_SHADER}PixelShader`] = Mw;
const Su = class Jd extends $s {
  constructor(e, t, n, s, o, h, c) {
    super(e, t, Jd.FRAGMENT_SHADER, n, s, h, c), this._opacity = 1, this.updateShaderUniforms();
  }
  get opacity() {
    return this._opacity == null ? 1 : this._opacity;
  }
  set opacity(e) {
    this._opacity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    super.updateShaderUniforms(), !this.initializing && this.setFloat("opacity", this.opacity);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
Su.FRAGMENT_SHADER = "zakeke_OpacityProceduralTexture";
Su.CUSTOM_TYPE = "Zakeke.OpacityProceduralTexture";
let Cw = Su;
const Aw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform float opacity;",
  "void main(void) {",
  "	vec4 color = texture2D(uSampler, vUV.xy);",
  "   color.a = opacity;",
  "   gl_FragColor = color;",
  "}"
], Tw = Aw.join(`
`);
BABYLON.Effect.ShadersStore[`${Cw.FRAGMENT_SHADER}PixelShader`] = Tw;
const Mu = class Qd extends $s {
  constructor(e, t, n, s, o, h, c) {
    super(e, t, Qd.FRAGMENT_SHADER, n, s, h, c), this._blendTexture = o, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
Mu.FRAGMENT_SHADER = "zakeke_OverlayProceduralTexture";
Mu.CUSTOM_TYPE = "Zakeke.OverlayProceduralTexture";
let dl = Mu;
var Lw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], Bw = Lw.join(`
`);
BABYLON.Effect.ShadersStore[`${dl.FRAGMENT_SHADER}PixelShader`] = Bw;
const Cu = class gl extends BABYLON.ProceduralTexture {
  constructor(e, t, n = null, s, o) {
    super(e, t, gl.FRAGMENT_SHADER, n, s, o), this._baseTexture = null, this._blendTexture = null, this.updateShaderUniforms();
  }
  dispose() {
    this._baseTexture && this._baseTexture.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    this._baseTexture ? (this.setTexture("uSampler", this._baseTexture), this.setInt("hasSampler", 1), this.setVector2("uSamplerScale", new BABYLON.Vector2(this._baseTexture.uScale, this._baseTexture.vScale))) : (this.setInt("hasSampler", 0), this.setVector2("uSamplerScale", new BABYLON.Vector2(1, 1))), this._blendTexture ? (this.setTexture("uBlendSampler", this._blendTexture), this.setInt("hasBlend", 1), this.setVector2("uBlendScale", new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale))) : (this.setInt("hasBlend", 0), this.setVector2("uBlendScale", new BABYLON.Vector2(1, 1))), this.setFloat("size", this.getRenderSize());
  }
  render(e) {
    super.render(e);
  }
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  isReady() {
    return this._baseTexture && !this._baseTexture.isReady() || this._blendTexture && !this._blendTexture.isReady() ? !1 : super.isReady();
  }
  //@BABYLON.serializeAsTexture()
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  /**
   * Serializes this normal map procedural texture
   * @returns a serialized normal map procedural texture object
   */
  serialize() {
    var e = BABYLON.SerializationHelper.Serialize(this, super.serialize());
    return e.customType = gl.CUSTOM_TYPE, this.baseTexture ? e.baseTexture = this.baseTexture.serialize() : e.baseTexture = null, this.blendTexture ? e.blendTexture = this.blendTexture.serialize() : e.blendTexture = null, e;
  }
  /**
   * Creates a Normal Map Procedural Texture from parsed normal map procedural texture data
   * @param parsedTexture defines parsed texture data
   * @param scene defines the current scene
   * @param rootUrl defines the root URL containing normal map procedural texture information
   * @returns a parsed Normal Map Procedural Texture
   */
  static Parse(e, t, n) {
    var s = BABYLON.SerializationHelper.Parse(
      () => new gl(
        e.name,
        e._size,
        t,
        void 0,
        e._generateMipMaps
      ),
      e,
      t,
      n
    );
    return e.baseTexture && (s.baseTexture = BABYLON.Texture.Parse(e.baseTexture, t, n)), e.blendTexture && (s.blendTexture = BABYLON.Texture.Parse(e.blendTexture, t, n)), s;
  }
};
Cu.FRAGMENT_SHADER = "zakeke_BlendProceduralTexture";
Cu.CUSTOM_TYPE = "Zakeke.BlendProceduralTexture";
let eg = Cu;
var kw = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "uniform bool hasSampler;",
  "uniform bool hasBlend;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "   if (!hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);",
  "       return;",
  "   }",
  "   if (hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "       return;",
  "   }",
  "   if (!hasSampler && hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "       return;",
  "   }",
  "   vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "   vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], Ew = kw.join(`
`);
BABYLON.Effect.ShadersStore[`${eg.FRAGMENT_SHADER}PixelShader`] = Ew;
BABYLON.RegisterClass("Zakeke.BlendProceduralTexture", eg);
class tg {
  constructor() {
  }
  getSubmeshIdx(e) {
    let t = e.lastIndexOf("-");
    if (t != -1) {
      e = e.substring(0, t);
      let n = Number(e.substring(t + 1));
      if (n && !isNaN(n))
        return n;
    }
    return null;
  }
  getRegExp(e, t) {
    if ((t & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
      let n = e.lastIndexOf("-");
      n != -1 && (e = e.substring(0, n), Number(e.substring(n + 1)));
    }
    return new RegExp(this.escapeRegExp(e).replace(/\\\*/g, ".*"), "i");
  }
  getElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let m = 0; m < c.length; m++) {
      const x = c[m];
      let B = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const F = this.getMeshes(e, t, n, I, B);
        Array.prototype.push.apply(h, F);
      }
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let F = this.getSubmeshIdx(B);
        if (F) {
          const M = this.getSubMeshes(e, t, n, I, B, F);
          Array.prototype.push.apply(h, M);
        }
      }
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const F = this.getMaterials(e, t, n, I, B);
        Array.prototype.push.apply(h, F);
      }
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const F = this.getLights(e, t, n, I, B);
        Array.prototype.push.apply(h, F);
      }
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const F = this.getCameras(e, t, n, I, B);
        Array.prototype.push.apply(h, F);
      }
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const F = this.getCameraLocations(e, t, n, I);
        Array.prototype.push.apply(h, F);
      }
    }
    return h;
  }
  getMeshElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let m = 0; m < c.length; m++) {
      const x = c[m];
      let B = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const F = this.getMeshes(e, t, n, I, B);
        Array.prototype.push.apply(h, F);
      }
    }
    return h;
  }
  getSubMeshElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let m = 0; m < c.length; m++) {
      const x = c[m];
      let B = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let F = this.getSubmeshIdx(B);
        if (F) {
          const M = this.getSubMeshes(e, t, n, I, B, F);
          Array.prototype.push.apply(h, M);
        }
      }
    }
    return h;
  }
  getMaterialElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let m = 0; m < c.length; m++) {
      const x = c[m];
      let B = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const F = this.getMaterials(e, t, n, I, B);
        Array.prototype.push.apply(h, F);
      }
    }
    return h;
  }
  getLightElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let m = 0; m < c.length; m++) {
      const x = c[m];
      let B = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const F = this.getLights(e, t, n, I, B);
        Array.prototype.push.apply(h, F);
      }
    }
    return h;
  }
  getCameraElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let m = 0; m < c.length; m++) {
      const x = c[m];
      let B = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const F = this.getCameras(e, t, n, I, B);
        Array.prototype.push.apply(h, F);
      }
    }
    return h;
  }
  getCameraLocationElements(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let m = 0; m < c.length; m++) {
      const x = c[m];
      let B = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const I = this.getCameraLocations(e, t, n, B);
        Array.prototype.push.apply(h, I);
      }
    }
    return h;
  }
  getOffloadedElementIDs(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let I = 0; I < c.length; I++) {
      const F = c[I];
      let M = F;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var m = F.lastIndexOf("-");
        m != -1 && (M = F.substring(0, m), Number(F.substring(m + 1)));
      }
      var x = new RegExp(this.escapeRegExp(M).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var B = this.getOffloadedMaterialIDs(e, t, n, x, M);
        Array.prototype.push.apply(h, B);
      }
    }
    return h;
  }
  getDelayedElementIDs(e, t, n, s, o) {
    const h = [], c = s.split(";");
    for (let I = 0; I < c.length; I++) {
      const F = c[I];
      let M = F;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var m = F.lastIndexOf("-");
        m != -1 && (M = F.substring(0, m), Number(F.substring(m + 1)));
      }
      var x = new RegExp(this.escapeRegExp(M).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var B = this.getDelayedMaterialIDs(e, t, n, x, M);
        Array.prototype.push.apply(h, B);
      }
    }
    return h;
  }
  getMeshes(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.meshes.length; c++) {
        const m = t.meshes[c];
        (m.name && s.test(m.name) || m.id && m.id == o) && this.verifyFilter(m.id, n) && h.push(m);
      }
    return h;
  }
  getSubMeshes(e, t, n, s, o, h) {
    const c = [];
    if (t && t instanceof BABYLON.Scene)
      for (let m = 0; m < t.meshes.length; m++) {
        const x = t.meshes[m];
        (x.name && s.test(x.name) || x.id && x.id == o) && this.verifyFilter(x.id, n) && h < x.subMeshes.length && h >= 0 && c.push(x.subMeshes[h]);
      }
    return c;
  }
  getMaterials(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.materials.length; c++) {
        const m = t.materials[c];
        (m.name && s.test(m.name) || m.id && m.id == o || m.metadata && !m.metadata.isRealMaterial && m.metadata.originalMaterialID == o) && this.verifyFilter(m.id, n) && h.push(m);
      }
    return h;
  }
  getOffloadedMaterialIDs(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.offloadedMaterials)
      for (let c in t.metadata.offloadedMaterials) {
        const m = t.metadata.offloadedMaterials[c];
        (m.name && s.test(m.name) || c && c == o) && this.verifyFilter(c, n) && h.push(c);
      }
    return h;
  }
  getDelayedMaterialIDs(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.delayedMaterials)
      for (let c in t.metadata.delayedMaterials) {
        const m = t.metadata.delayedMaterials[c];
        (m.name && s.test(m.name) || c && c == o) && this.verifyFilter(c, n) && h.push(c);
      }
    return h;
  }
  getLights(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.lights.length; c++) {
        const m = t.lights[c];
        (m.name && s.test(m.name) || m.id && m.id == o) && this.verifyFilter(m.id, n) && h.push(m);
      }
    return h;
  }
  getCameras(e, t, n, s, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.cameras.length; c++) {
        const m = t.cameras[c];
        (m.name && s.test(m.name) || m.id && m.id == o) && this.verifyFilter(m.id, n) && h.push(m);
      }
    return h;
  }
  getCameraLocations(e, t, n, s) {
    var o = [];
    if (e && e instanceof Zakeke.Scene)
      for (var h = 0; h < e.get("cameraLocations").length; h++) {
        var c = e.get("cameraLocations").at(h), m = c.getLocationID(), x = c.get("name");
        (x && s.test(x) || m && s.test(m)) && this.verifyFilter(m, n) && o.push(c);
      }
    return o;
  }
  getYesNoElements(e, t, n, s, o) {
    const h = { yes: [], no: [] }, c = s.split(";");
    for (let m = 0; m < c.length; m++) {
      const x = c[m];
      let B = x, I = 0;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let M = x.lastIndexOf("-");
        if (M != -1) {
          B = x.substring(0, M);
          let Z = Number(x.substring(M + 1));
          Z && !isNaN(Z) && (I = Z);
        }
      }
      const F = new RegExp(this.escapeRegExp(B).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const M = this.getYesNoMeshes(e, t, n, F);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        const M = this.getYesNoSubMeshes(e, t, n, F, I);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const M = this.getYesNoMaterials(e, t, n, F);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const M = this.getYesNoLights(e, t, n, F);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const M = this.getYesNoCameras(e, t, n, F);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const M = this.getYesNoCameraLocations(e, t, n, F);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
    }
    return h;
  }
  getYesNoMeshes(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.meshes.length; h++) {
        let c = t.meshes[h], m = o.no;
        (c.name && s.test(c.name) || c.id && s.test(c.id)) && this.verifyFilter(c.id, n) && (m = o.yes), m.push(c);
      }
    return o;
  }
  getYesNoSubMeshes(e, t, n, s, o) {
    const h = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.meshes.length; c++) {
        let m = t.meshes[c];
        if ((m.name && s.test(m.name) || m.id && s.test(m.id)) && this.verifyFilter(m.id, n) && m.subMeshes)
          for (let x = 0; x < m.subMeshes.length; x++)
            x == o ? h.yes.push(m.subMeshes[x]) : h.no.push(m.subMeshes[x]);
      }
    return h;
  }
  getYesNoMaterials(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.materials.length; h++) {
        let c = t.materials[h];
        (c.name && s.test(c.name) || c.id && s.test(c.id)) && this.verifyFilter(c.id, n) ? o.yes.push(c) : o.no.push(c);
      }
    return o;
  }
  getYesNoLights(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.lights.length; h++) {
        let c = t.lights[h];
        (c.name && s.test(c.name) || c.id && s.test(c.id)) && this.verifyFilter(c.id, n) ? o.yes.push(c) : o.no.push(c);
      }
    return o;
  }
  getYesNoCameras(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.cameras.length; h++) {
        let c = t.cameras[h];
        (c.name && s.test(c.name) || c.id && s.test(c.id)) && this.verifyFilter(c.id, n) ? o.yes.push(c) : o.no.push(c);
      }
    return o;
  }
  getYesNoCameraLocations(e, t, n, s) {
    const o = { yes: [], no: [] };
    if (e && e instanceof Zakeke.Scene)
      for (let h = 0; h < e.get("cameraLocations").length; h++) {
        let c = e.get("cameraLocations").at(h), m = c.getLocationID(), x = c.get("name");
        (x && s.test(x) || m && s.test(m)) && this.verifyFilter(m, n) ? o.yes.push(c) : o.no.push(c);
      }
    return o;
  }
  escapeRegExp(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  verifyFilter(e, t) {
    return !t || t.length == 0 ? !0 : t.indexOf(e) !== -1;
  }
}
class Iw {
  constructor(e, t, n) {
    this._zkModel = null, this._sceneHelper = null, this._deviceType = MPlaza.DeviceType.All, this._meshDesignRefreshRequiredListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._useMaterialOffloading = !1, this._prefetchMeshes = !0, this._prefetchMaterials = !0, Logger.info("[SceneActionExecutor] Constructor called"), this._zkScene = e, this._scene = t, this._sceneHelper = new yi(t), this._elementSelector = new tg(), n && (this._zkModel = n), Logger.info(`[SceneActionExecutor] Initialized successfully | Device type: ${this._deviceType}`);
  }
  get deviceType() {
    return this._deviceType;
  }
  set deviceType(e) {
    this._deviceType != e && (this._deviceType = e);
  }
  get useMaterialOffloading() {
    return this._useMaterialOffloading;
  }
  set useMaterialOffloading(e) {
    this._useMaterialOffloading != e && (this._useMaterialOffloading = e);
  }
  get prefetchMeshes() {
    return this._prefetchMeshes;
  }
  set prefetchMeshes(e) {
    this._prefetchMeshes !== e && (this._prefetchMeshes = e);
  }
  get prefetchMaterials() {
    return this._prefetchMaterials;
  }
  set prefetchMaterials(e) {
    this._prefetchMaterials !== e && (this._prefetchMaterials = e);
  }
  dispose() {
    this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
  }
  // -------------------------------------------------------
  // Events
  // -------------------------------------------------------
  addMeshDesignRefreshRequiredListeners(e) {
    this._meshDesignRefreshRequiredListeners.push(e);
  }
  fireMeshDesignRefreshRequiredEvent(e, t) {
    const n = { meshes: e, effect: t };
    for (let s = 0; s < this._meshDesignRefreshRequiredListeners.length; ++s)
      this._meshDesignRefreshRequiredListeners[s](n);
  }
  addBeginAssetsLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginAssetsLoadingEvent() {
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndAssetsLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndAssetsLoadingEvent() {
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  // -------------------------------------------------------
  // Actions Helpers Methods
  // -------------------------------------------------------
  isActionForDevice(e) {
    const t = e.get("deviceTypes");
    return Logger.info(`[IsActionForDevice] Checking device compatibility | DeviceType from action: ${t} | Current device: ${this._deviceType}`), t === MPlaza.DeviceType.Any || t === MPlaza.DeviceType.All ? (Logger.info("[IsActionForDevice] ✓ Action is for Any/All devices"), !0) : (t & this._deviceType) === this._deviceType ? (Logger.info("[IsActionForDevice] ✓ Action matches current device"), !0) : (Logger.warn("[IsActionForDevice] ❌ Action not compatible with current device"), !1);
  }
  // ad una mesh vengono associati dei dati aggiuntivi che servono per l'utilizzo dei filtri.
  // Un filtro consente di creare un contesto di mesh da associare ad una opzione di un attributo.
  // Quando si utilizza un'azione di tipo filtro, verranno visualizzate solo le mesh specificate dal filtro.
  // Per esempio, per un orologio potrei avere un attributo "modello" con le opzioni "classico", "moderno", "sportivo".
  // Selezionando un modello, potrebbe essere utile attivare solo le mesh che hanno a che fare con il
  // modello selezionato. Questo consentirebbe di specificare azioni su altre opzioni indipendentemente dal modello.
  // Ad esempio potrei avere un altro attributo "vetro" con le opzioni "zaffiro" e "normale" con le azioni
  // che visualizzano il vetro nel materiale selezionato, diverso per modello.
  // Un filtro è relativo ad un attributo, così da permettere la definizione di contesti più restrittivi
  // andando a cumulare filtri relativi ad attributi diversi.
  // Inizializza la struttura dati associata ad una mesh
  setupMeshData(e) {
    e.data || (e.data = {
      filters: {},
      toShow: e.isVisible
    });
  }
  // Imposta il filtro legato ad un attributo (da un'azione filtro)
  async setMeshFilterAsync(e, t, n) {
    this.setupMeshData(e), e.data.filters[t] = n, await this.chekMeshVisibilityAsync(e);
  }
  // Richiede la visibilità di una mesh (da un'azione show/hide)
  async setMeshVisibilityAsync(e, t) {
    this.setupMeshData(e), e.data.toShow = t, await this.chekMeshVisibilityAsync(e);
  }
  // Determina se dopo l'applicazione di un filtro o una richiesta di visibilità
  // la mesh debba essere mostrata o nascosta. Il risultato andrà ad agire sulla
  // effettiva visibilità della mesh, secondo l'espressione booleana:
  // mesh.isVisible = F1 && F2 && ... && Fn && toShow
  async chekMeshVisibilityAsync(e) {
    let t = null;
    if (e && e.data && (t = e.data.toShow, t))
      for (const n in e.data.filters)
        t = t && e.data.filters[n];
    if (t !== null && this._sceneHelper) {
      if (t) {
        const n = this._zkScene.get("rootUrl");
        n && await this._sceneHelper.unsetMeshDummyMaterialAsync(e, n, !0), await yi.whenMeshIsReadyAsync(e);
      }
      this._sceneHelper.showHideMesh(e.id, t);
    }
  }
  getMeshByID(e) {
    return this._scene.getMeshByID(e);
  }
  getMaterialByID(e) {
    return this._scene.getMaterialByID(e);
  }
  setCameraLocation(e) {
    const t = this._zkScene.getCameraLocation(e);
    if (t) {
      const n = new BABYLON.Vector3(
        t.get("px"),
        t.get("py"),
        t.get("pz")
      ), s = new BABYLON.Vector3(
        t.get("tx"),
        t.get("ty"),
        t.get("tz")
      );
      this._sceneHelper && this._sceneHelper.animateCamera(s, n, 0.5);
    }
  }
  adjustCamera(e) {
    this._sceneHelper && (e !== void 0 && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera());
  }
  zoomIn() {
    this._sceneHelper && this._sceneHelper.zoomIn();
  }
  zoomOut() {
    this._sceneHelper && this._sceneHelper.zoomOut();
  }
  zoom(e) {
    this._sceneHelper && this._sceneHelper.zoom(e);
  }
  setCameraPivot(e) {
    if (this._sceneHelper) {
      const t = e ? this._scene.getMeshByID(e) : null;
      this._sceneHelper.setCameraPivot(t);
    }
  }
  setCameraZoomEnabled(e) {
    this._sceneHelper && this._sceneHelper.setZoomEnabled(e);
  }
  async setMeshMaterial(e, t) {
    if (this._sceneHelper) {
      await yi.whenAllMaterialTexturesAreReady(e);
      const n = t.material;
      Logger.info(
        `Setting material to mesh | mesh: ${t.id} - ${t.name} | material: ${e.id} - ${e.name}`
      ), this._sceneHelper.applyMaterial(e, t), this._useMaterialOffloading && n && this._sceneHelper.offloadMaterial(n.id);
    }
  }
  async setSubmeshMaterial(e, t, n) {
    if (this._sceneHelper) {
      await yi.whenAllMaterialTexturesAreReady(e);
      const s = this._sceneHelper.getSubMeshMaterial(t, n);
      this._sceneHelper.applyMaterialToSubMesh(e, t, n), this._useMaterialOffloading && s && this._sceneHelper.offloadMaterial(s.id);
    }
  }
  getMaterialFromActionValue(e) {
    if (this._elementSelector) {
      const t = e.get("value");
      if (t != null && t != null) {
        let n = this._scene.getMaterialByID(t);
        return n || (n = this._scene.getMaterialByName(t)), n;
      }
    }
    return null;
  }
  getDelayedMaterialIDFromAction(e) {
    if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      const t = e.get("value");
      if (t != null && t != null) {
        if (this._scene.metadata.delayedMaterials.hasOwnProperty(t))
          return t;
        for (let n in this._scene.metadata.delayedMaterials)
          if (this._scene.metadata.delayedMaterials[n].name === t)
            return n;
      }
    }
    return null;
  }
  async checkDelayedMaterial(e) {
    let t = this.getMaterialByID(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      n != null && n != null && (t = await this._sceneHelper.loadDelayedMaterialAsync(n, e));
    }
    return t;
  }
  getOffloadedMaterialIDFromAction(e) {
    if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const t = e.get("value");
      if (t != null) {
        if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t))
          return t;
        for (let n in this._scene.metadata.offloadedMaterials)
          if (this._scene.metadata.offloadedMaterials[n].name === t)
            return n;
      }
    }
    return null;
  }
  async checkOffloadedMaterialAsync(e) {
    let t = this.getMaterialByID(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      n != null && (t = await this._sceneHelper.loadOffloadedMaterialAsync(n, e));
    }
    return t;
  }
  // Recupera il materiale specificato nel valore di un'azione, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  async getDeepMaterialFromActionValueAsync(e) {
    let t = this.getMaterialFromActionValue(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      if (n != null) {
        let s = this.getOffloadedMaterialIDFromAction(e);
        s ? (Logger.info("Requesting offloaded material - id: ", s), t = await this._sceneHelper.loadOffloadedMaterialAsync(n, s), Logger.info("Obtained offloaded material - id: ", s)) : (s = this.getDelayedMaterialIDFromAction(e), s && (Logger.info("Requesting delayed material - id: ", s), t = await this._sceneHelper.loadDelayedMaterialAsync(n, s), Logger.info("Obtained delayed material - id: ", s)));
      }
    }
    return t;
  }
  scriptRequiresDelayedLoading(e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      if (this.actionsRequireDelayedLoading(n.actions))
        return !0;
    }
    return !1;
  }
  actionsRequireDelayedLoading(e) {
    for (let t = 0; t < e.length; t++)
      if (this.actionRequiresDelayedLoading(e[t]))
        return !0;
    return !1;
  }
  actionRequiresDelayedLoading(e) {
    if (this._sceneHelper && e.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && e.get("value") === "show") {
      const t = e.get("selector");
      if (t != null) {
        const n = this._elementSelector.getElements(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Mesh
        );
        for (let s = 0; s < n.length; s++) {
          const o = n[s];
          if (o instanceof BABYLON.AbstractMesh && !o.isVisible) {
            const h = this._sceneHelper.getMeshDelayedMaterialIDs(o), c = this._sceneHelper.getMeshOffloadedMaterialIDs(o);
            if (h.length > 0 || c.length > 0 || yi.meshRequiresDelayedLoading(o))
              return !0;
          }
        }
      }
    }
    if ((e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor || e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshDesignMaterial) && !this.getMaterialFromActionValue(e) && (this.getDelayedMaterialIDFromAction(e) || this.getOffloadedMaterialIDFromAction(e)))
      return !0;
    if (e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
      const t = e.get("selector");
      if (t != null) {
        const n = this._elementSelector.getDelayedElementIDs(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Material
        ), s = this._elementSelector.getOffloadedElementIDs(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Material
        );
        if (n.length > 0 || s.length > 0)
          return !0;
      }
    }
    return !1;
  }
  async getAllMaterialElementsAsync(e) {
    const t = [];
    if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector) {
      const n = this._elementSelector.getMaterialElements(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      );
      Array.prototype.push.apply(t, n);
      const s = n.map((m) => m.id), o = this._elementSelector.getDelayedElementIDs(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      ), h = this._elementSelector.getOffloadedElementIDs(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      ), c = this._zkScene.get("rootUrl");
      if (c != null) {
        const m = [];
        if (o.forEach((B) => {
          s.indexOf(B) === -1 && m.push(B);
        }), m.length > 0) {
          const B = await this._sceneHelper.loadDelayedMaterialsAsync(
            c,
            m
          );
          Array.prototype.push.apply(t, B);
        }
        const x = [];
        if (h.forEach((B) => {
          s.indexOf(B) === -1 && x.push(B);
        }), x.length > 0) {
          const B = await this._sceneHelper.loadOffloadedMaterialsByIDsAsync(
            c,
            x
          );
          Array.prototype.push.apply(t, B);
        }
      }
    }
    return t;
  }
  // Uno script è un array di oggetti ognuno dei quali rappresenta le azioni da eseguire
  // conseguentemente alla selezione di un valore per un attributo
  // si suppone che le azioni siano già ordinate per ordine di esecuzione
  // script: [{attributeID, selectedValue, actions}]
  async executeScriptAsync(e) {
    Logger.info("[ExecuteScript] ========== SCRIPT EXECUTION START =========="), Logger.info(`[ExecuteScript] Script length: ${e.length} script actions`);
    const t = this.scriptRequiresDelayedLoading(e);
    Logger.info(`[ExecuteScript] Requires delayed loading: ${t}`), t && this.fireBeginAssetsLoadingEvent();
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      Logger.info(`[ExecuteScript] >>> Processing script action ${n + 1}/${e.length} | AttributeID: ${s.attributeID} | Value: ${s.selectedValue} | Actions: ${s.actions.length}`), await this.executeActionsAsync(
        s.attributeID,
        s.selectedValue,
        s.actions,
        !1
      );
    }
    t && this.fireEndAssetsLoadingEvent(), Logger.info("[ExecuteScript] ========== SCRIPT EXECUTION COMPLETED ==========");
  }
  async executeActionsAsync(e, t, n, s = !0) {
    if (Logger.info("[ExecuteActions] ========== STARTING ACTIONS EXECUTION =========="), Logger.info(`[ExecuteActions] AttributeID: ${e} | SelectedValue: ${t} | Actions count: ${n.length}`), n.length > 0) {
      const o = this.actionsRequireDelayedLoading(n);
      s && o && this.fireBeginAssetsLoadingEvent(), await this.checkActionsAssetsAreReadyAsync(n);
      for (let h = 0; h < n.length; h++) {
        const c = n[h];
        Logger.info(`[ExecuteActions] >>> Processing action ${h + 1}/${n.length} | Type: ${c.get("actionTypeID")} | Selector: '${c.get("selector")}'`), await this.executeActionAsync(e, t, c);
      }
      s && o && this.fireEndAssetsLoadingEvent(), Logger.info("[ExecuteActions] ========== ACTIONS EXECUTION COMPLETED ==========");
    }
  }
  // Esegue una singola azione generata dalla selezione di un attributo
  // action: MPlaza.AttributeSceneAction
  async executeActionAsync(e, t, n) {
    if (!this.isActionForDevice(n)) {
      Logger.info(`[ExecuteAction] ❌ Action not for device | ActionType: ${n.get("actionTypeID")} | DeviceType: ${this._deviceType}`);
      return;
    }
    const s = n.get("actionTypeID"), o = n.get("selector"), h = n.get("value"), c = n.get("propertyName");
    if (Logger.info("[ExecuteAction] ========== EXECUTING ACTION =========="), Logger.info(`[ExecuteAction] AttributeID: ${e} | SelectedValue: ${t}`), Logger.info(`[ExecuteAction] ActionTypeID: ${s} | Selector: '${o}' | Value: '${h}'`), Logger.info(`[ExecuteAction] PropertyName: '${c}'`), console.log(`🔥 EXECUTING ACTION ${s} - ${o} - ${h}`), n) {
      switch (s) {
        case MPlaza.SceneActionType.Filter:
          await this.executeFilterActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.ShowHideMesh:
          await this.executeShowHideActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshMaterial:
          await this.executeSetMeshMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetSubMeshMaterial:
          await this.executeSetSubMeshMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMaterialColor:
          await this.executeSetMaterialColorActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetCameraLocation:
          await this.executeSetCameraLocationActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.AdjustCamera:
          await this.executeAdjustCameraActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetCameraPivot:
          await this.executeSetCameraPivotActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.ResetCameraPivot:
          await this.executeResetCameraPivotActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.EnableDiableZoom:
          await this.executeEnableDisableZoomActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshDesignMaterial:
          await this.executeSetMeshDesignMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshDesignEffect:
          await this.executeSetMeshDesignEffectActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMaterialParameter:
          console.log(`🎯 MATCHED SetMaterialParameter case! Type: ${s}`), console.warn(`🎯 MATCHED SetMaterialParameter case! Type: ${s}`), Logger.info(`[ExecuteAction] ✓ CALLING SetMaterialParameter action | Type: ${s}`), await this.executeSetMaterialParameterActionAsync(e, t, n);
          break;
      }
      Logger.info(`[ExecuteAction] ✓ Action execution completed | ActionType: ${s}`);
    } else
      Logger.warn("[ExecuteAction] ❌ No action provided to execute");
  }
  async executeFilterActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && e !== null && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        const o = this._elementSelector.getYesNoElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value") === "enable";
        for (let c = 0; c < o.yes.length; c++)
          await this.setMeshFilterAsync(o.yes[c], e, h);
        for (let c = 0; c < o.no.length; c++)
          await this.setMeshFilterAsync(o.yes[c], e, !h);
      }
    }
  }
  async executeShowHideActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value") === "show";
        for (let c = 0; c < o.length; c++)
          await this.setMeshVisibilityAsync(o[c], h);
      }
    }
  }
  async executeSetMeshMaterialActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h)
          for (let c = 0; c < o.length; c++)
            await this.setMeshMaterial(h, o[c]);
      }
    }
  }
  async executeSetSubMeshMaterialActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        const o = this._elementSelector.getSubMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.SubMesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h)
          for (let c = 0; c < o.length; c++)
            await this.setSubmeshMaterial(h, null, o[c]);
      }
    }
  }
  async executeSetMaterialColorActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null) {
        Logger.info(`[SetMaterialColor] Start | selector: '${s}'`);
        const o = await this.getAllMaterialElementsAsync(s);
        Logger.info(`[SetMaterialColor] Found ${o.length} material(s)`);
        const h = n.get("propertyName");
        let c = n.get("value");
        if (h && c) {
          if (Logger.info(`[SetMaterialColor] PropertyName: '${h}' | Original value: '${c}'`), t) {
            const x = c;
            c = c.replace(/%value%/g, t), x !== c && Logger.info(
              `[SetMaterialColor] Replaced %value% with '${t}' | Result: '${c}'`
            );
          }
          const m = BABYLON.Color3.FromHexString(c);
          Logger.info(`[SetMaterialColor] Applying color ${c} to ${o.length} material(s)`);
          for (let x = 0; x < o.length; x++)
            Logger.info(
              `[SetMaterialColor] Applying to material '${o[x].id}' - property '${h}'`
            ), this._sceneHelper.changeMaterialColor(
              o[x],
              h,
              m
            );
          Logger.info("[SetMaterialColor] Completed successfully");
        } else
          Logger.warn(
            `[SetMaterialColor] Missing propertyName or value | propertyName: ${h} | value: ${c}`
          );
      } else
        Logger.warn("[SetMaterialColor] No selector specified");
    }
  }
  async executeSetCameraLocationActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("value");
      let o = null;
      if (s)
        for (let h = 0; h < this._zkScene.get("cameraLocations").length; h++) {
          const c = this._zkScene.get("cameraLocations").at(h);
          if (c.get("locationID") === s || c.get("name") === s) {
            o = c;
            break;
          }
        }
      o !== null && this.setCameraLocation(o.get("locationID"));
    }
  }
  async executeAdjustCameraActionAsync(e, t, n) {
    this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction && this._sceneHelper.adjustCamera();
  }
  async executeSetCameraPivotActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("value");
      let o = null;
      if (s)
        for (let h = 0; h < this._scene.meshes.length; h++) {
          const c = this._scene.meshes[h];
          if (c.id === s || c.name === s) {
            o = c;
            break;
          }
        }
      o && this.setCameraPivot(o.id);
    }
  }
  async executeResetCameraPivotActionAsync(e, t, n) {
    this.isActionForDevice(n) && this.setCameraPivot(null);
  }
  async executeEnableDisableZoomActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("value") === "enable";
      this.setCameraZoomEnabled(s);
    }
  }
  async executeSetMeshDesignMaterialActionAsync(e, t, n) {
    if (this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null && s != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h) {
          for (let c = 0; c < o.length; c++) {
            const m = o[c];
            m.metadata = m.metadata || {}, m.metadata.designMaterialID = h.id;
          }
          this.fireMeshDesignRefreshRequiredEvent(o, null);
        }
      }
    }
  }
  async executeSetMeshDesignEffectActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const s = n.get("selector");
      if (s != null && s != null) {
        let o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value"), c = null;
        if (h != null && h != null && this._zkModel)
          for (let x = 0; x < this._zkModel.get("scenes").length; x++) {
            const B = this._zkModel.get("scenes").at(x);
            if (B.get("isDefault")) {
              const I = B.get("meshDesignEffects");
              if (I)
                for (let F = 0; F < I.length; F++) {
                  const M = I.at(F);
                  if (M.get("effectID") === h || M.get("name") === h) {
                    c = M;
                    break;
                  }
                }
            }
            if (c)
              break;
          }
        let m = null;
        if (c) {
          const x = c.get("materialID");
          x && (m = await this.checkOffloadedMaterialAsync(x), m || (m = await this.checkDelayedMaterial(x)));
        }
        this.fireMeshDesignRefreshRequiredEvent(o, c);
      }
    }
  }
  async executeSetMaterialParameterActionAsync(e, t, n) {
    if (console.log(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), console.warn(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), console.error(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), Logger.info("[SetMaterialParameter] >>>>>>>>>> METHOD CALLED <<<<<<<<<<"), Logger.info(`[SetMaterialParameter] Input parameters - AttributeID: ${e} | SelectedValue: ${t}`), !this.isActionForDevice(n)) {
      Logger.warn("[SetMaterialParameter] ❌ Action not for device, exiting");
      return;
    }
    if (Logger.info("[SetMaterialParameter] ========== START =========="), Logger.info(`[SetMaterialParameter] AttributeID: ${e} | SelectedValue: ${t}`), this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      console.log("🔍 All dependencies OK, proceeding...");
      const s = n.get("selector");
      if (console.log(`🎯 Material selector: '${s}'`), Logger.info(`[SetMaterialParameter] Selector expression: '${s}'`), s == null) {
        console.error("❌ No selector found!"), Logger.warn("[SetMaterialParameter] ❌ Action has no selector (material)");
        return;
      }
      const o = this._elementSelector.getMaterialElements(
        this._zkScene,
        this._scene,
        null,
        s,
        MPlaza.SceneElementType.Material
      );
      if (console.log(`📦 Found ${o.length} materials for selector`), Logger.info(`[SetMaterialParameter] Found ${o.length} material(s) matching selector`), !o || o.length === 0) {
        console.error(`❌ NO MATERIALS FOUND for selector: '${s}'`), Logger.warn(`[SetMaterialParameter] ❌ No materials found for selector '${s}'`);
        return;
      }
      o.forEach((m, x) => {
        console.log(`📋 Material[${x}]: id='${m.id}' name='${m.name}' type='${m.getClassName()}'`), Logger.info(`[SetMaterialParameter]   Material[${x}]: id='${m.id}' name='${m.name}'`), x === 0 && this.analyzeMaterialStructure(m);
      });
      const h = n.get("propertyName"), c = n.get("value");
      if (console.log("🎨 Property details:"), console.log(`   PropertyPath: '${h}'`), console.log(`   PropertyValue: '${c}'`), Logger.info(`[SetMaterialParameter] PropertyPath (dot notation): '${h}'`), Logger.info(`[SetMaterialParameter] PropertyValue: '${c}'`), !h) {
        console.error("❌ NO PROPERTY NAME found in action"), Logger.warn("[SetMaterialParameter] ❌ No propertyName found in action");
        return;
      }
      console.log(`🚀 Starting to apply property to ${o.length} material(s)...`), Logger.info(`[SetMaterialParameter] Applying property to ${o.length} material(s)...`);
      for (let m = 0; m < o.length; m++) {
        const x = o[m];
        console.log(`🔧 Processing material[${m}]: '${x.id}' (${x.getClassName()})`), Logger.info(`[SetMaterialParameter] >>> Processing material[${m}]: '${x.id}'`), this.applyMaterialProperty(x, h, c);
      }
      console.log("✅ SetMaterialParameter completed successfully!"), Logger.info("[SetMaterialParameter] ========== COMPLETED ==========");
    } else
      Logger.warn("[SetMaterialParameter] ❌ Missing required dependencies (_zkScene, _scene, _elementSelector)");
  }
  // Helper method per analizzare la struttura di un materiale
  analyzeMaterialStructure(e) {
    console.log(`🔍 Material Analysis for: ${e.id} (${e.getClassName()})`);
    const t = e, n = [], s = {};
    for (const o in t)
      if (t.hasOwnProperty(o)) {
        const h = t[o];
        if (h && typeof h == "object" && h.constructor && h.constructor.name && h.constructor.name !== "Color3" && h.constructor.name !== "Vector3" && h.constructor.name !== "Texture" && !Array.isArray(h)) {
          const c = [];
          for (const m in h)
            h.hasOwnProperty(m) && c.push(m);
          c.length > 0 && (s[o] = c);
        }
        (typeof h == "string" || typeof h == "number" || typeof h == "boolean" || h && h.constructor && (h.constructor.name === "Color3" || h.constructor.name === "Vector3")) && n.push(`${o} (${typeof h}${h.constructor ? " - " + h.constructor.name : ""})`);
      }
    console.log(`📋 Direct Properties (${n.length}):`, n.slice(0, 10)), console.log("🏗️ Nested Properties:", s);
  }
  applyMaterialProperty(e, t, n) {
    try {
      const s = this.normalizePropertyPath(t);
      console.log("🔨 ApplyMaterialProperty START"), console.log(`   Material: '${e.id}' (${e.getClassName()})`), console.log(`   Path (original): '${t}'`), console.log(`   Path (normalized): '${s}'`), console.log(`   Value: '${n}' (${typeof n})`), Logger.info(
        `[ApplyMaterialProperty] Start | Material: '${e.id}' | Path: '${t}' → '${s}' | Value: '${n}'`
      ), this.ensureSubPropertyEnabled(e, s);
      const o = this.resolveMaterialPropertyPath(e, s);
      if (!o) {
        console.error(`❌ Cannot resolve property path '${s}' on material '${e.id}'`), Logger.error(`[ApplyMaterialProperty] ❌ Cannot resolve property path '${s}' on material '${e.id}'`);
        return;
      }
      if (console.log(`✅ Resolved path: ${o.description}`), Logger.info(`[ApplyMaterialProperty] ✅ Resolved path: ${o.description}`), this.isTextureProperty(s)) {
        console.log("🖼️ TEXTURE property detected"), Logger.info("[ApplyMaterialProperty] ✓ Detected TEXTURE property");
        try {
          console.log("🖼️ Calling applyTextureProperty..."), Logger.info(`[ApplyMaterialProperty] Calling applyTextureProperty with path: '${s}' and value: '${n}'`), this.applyTextureProperty(e, s, n), console.log("🖼️ applyTextureProperty completed"), Logger.info("[ApplyMaterialProperty] ✓ Texture property applied successfully");
        } catch (h) {
          console.error("❌ Error in applyTextureProperty:", h), Logger.error("[ApplyMaterialProperty] ❌ Error in applyTextureProperty:", h);
        }
        return;
      }
      if (typeof n == "string" && n.startsWith("#")) {
        console.log("🎨 COLOR property detected (hex format)"), Logger.info("[ApplyMaterialProperty] ✓ Detected COLOR property (hex format)"), this.applySmartColorProperty(e, o, n), Logger.info("[ApplyMaterialProperty] ✓ Color property applied successfully");
        return;
      }
      console.log("⚙️ STANDARD property detected"), Logger.info("[ApplyMaterialProperty] ✓ Detected STANDARD property (boolean/number/string)"), this.applySmartStandardProperty(e, o, n), Logger.info("[ApplyMaterialProperty] ✓ Standard property applied successfully");
    } catch (s) {
      Logger.error(
        `[ApplyMaterialProperty] ❌ Error applying property '${t}' to material '${e.id}'`,
        s
      );
    }
  }
  /**
   * Normalizza il propertyPath per correggere casi malformati e inconsistenze
   * Es: "clearcoat.clearCoat_bumpTexture" → "clearCoat_bumpTexture"
   * Es: "anisotropic.anisotropy.texture" → "anisotropy.texture"
   * Es: "subsurface.tintColor" → "subSurface.tintColor"
   */
  normalizePropertyPath(e) {
    console.log(`🔧 [NormalizePropertyPath] Input: '${e}'`);
    const t = {
      subsurface: "subSurface",
      anisotropic: "anisotropy"
    };
    let n = e;
    for (const [s, o] of Object.entries(t)) {
      const h = new RegExp(`\\b${s}\\b`, "gi");
      n = n.replace(h, o);
    }
    if (n !== e && console.log(`🔧 [NormalizePropertyPath] Fixed property names: '${e}' → '${n}'`), n.includes(".")) {
      const s = n.split(".");
      if (s.length === 3 && s[0].toLowerCase() === s[1].toLowerCase())
        n = s[1] + "." + s[2], console.log(`🔧 [NormalizePropertyPath] Removed duplicate prefix: '${e}' → '${n}'`);
      else if (s.length === 2) {
        const o = s[0].toLowerCase();
        s[1].toLowerCase().startsWith(o + "_") && (n = s[1], console.log(`🔧 [NormalizePropertyPath] Fixed malformed underscore path: '${e}' → '${n}'`));
      }
    }
    return n !== e && Logger.info(`[NormalizePropertyPath] Normalized: '${e}' → '${n}'`), n;
  }
  /**
   * Abilita automaticamente le sotto-proprietà (clearCoat, sheen, subSurface, anisotropy) 
   * quando si sta per applicare una texture o proprietà su di esse
   */
  ensureSubPropertyEnabled(e, t) {
    const n = e;
    t.toLowerCase().includes("clearcoat") && (n.clearCoat.isEnabled || (n.clearCoat.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled clearCoat for material '${e.id}'`), console.log(`✅ Enabled clearCoat for material '${e.id}'`))), t.toLowerCase().includes("sheen") && (n.sheen.isEnabled || (n.sheen.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled sheen for material '${e.id}'`), console.log(`✅ Enabled sheen for material '${e.id}'`))), t.toLowerCase().includes("subsurface") && (n.subSurface.isEnabled || (n.subSurface.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled subSurface for material '${e.id}'`), console.log(`✅ Enabled subSurface for material '${e.id}'`))), t.toLowerCase().includes("anisotropy") && (n.anisotropy.isEnabled || (n.anisotropy.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled anisotropy for material '${e.id}'`), console.log(`✅ Enabled anisotropy for material '${e.id}'`)));
  }
  isTextureProperty(e) {
    return e.endsWith("Texture") || e.includes("_texture") || e.includes("TextureRoughnessTexture") || e.includes("bumpTexture") || e.includes("tintTexture");
  }
  applyTextureProperty(e, t, n) {
    console.log(`🖼️ [ApplyTextureProperty] ENTRY - Material: '${e.id}' | Path: '${t}' | URL: '${n}'`), Logger.info(`[ApplyTextureProperty] ENTRY - Material: '${e.id}' | Path: '${t}' | URL: '${n}'`);
    try {
      Logger.info(
        `[ApplyTextureProperty] Material: '${e.id}' | Path: '${t}' | URL: '${n}'`
      ), this.ensureSubPropertyEnabled(e, t), Logger.info(`[ApplyTextureProperty] Step 2: 🚩 Loading texture from URL: '${n}'`), Logger.info("[ApplyTextureProperty] 🔄 Step 2: Converting propertyPath to textureType..."), console.log(`[ApplyTextureProperty] 🔄 Step 2: Converting propertyPath '${t}' to textureType...`);
      const s = this.convertPropertyPathToTextureType(t);
      if (Logger.info(`[ApplyTextureProperty] Step 2: 🛠️ Converting propertyPath '${t}' to textureType '${s}'`), !s) {
        Logger.warn(`[ApplyTextureProperty] ❌ Step 2 FAILED: Could not convert propertyPath '${t}' to texture type`), console.error("[ApplyTextureProperty] ❌ Step 2 FAILED: Could not convert propertyPath");
        return;
      }
      if (Logger.info(`[ApplyTextureProperty] ✅ Step 2 SUCCESS: textureType = '${s}'`), console.log(`[ApplyTextureProperty] ✅ Step 2 SUCCESS: textureType = '${s}'`), Logger.info("[ApplyTextureProperty] 🚦 About to proceed to Step 3..."), console.log("[ApplyTextureProperty] 🚦 About to proceed to Step 3..."), Logger.info("[ApplyTextureProperty] 🔍 Step 3: Checking SceneHelper availability..."), console.log("[ApplyTextureProperty] 🔍 Step 3: SceneHelper check:", {
        hasSceneHelper: !!this._sceneHelper,
        sceneHelperType: typeof this._sceneHelper,
        sceneHelperValue: this._sceneHelper
      }), !this._sceneHelper) {
        Logger.warn("[ApplyTextureProperty] ❌ Step 3 FAILED: SceneHelper not available, trying to recreate..."), console.error("[ApplyTextureProperty] ❌ Step 3 FAILED: SceneHelper not available");
        try {
          this._sceneHelper = new yi(this._scene), Logger.info("[ApplyTextureProperty] ✅ SceneHelper recreated successfully"), console.log("[ApplyTextureProperty] ✅ SceneHelper recreated successfully");
        } catch (h) {
          Logger.error("[ApplyTextureProperty] ❌ Failed to recreate SceneHelper:", h), console.error("[ApplyTextureProperty] ❌ Failed to recreate SceneHelper:", h);
          return;
        }
      }
      Logger.info("[ApplyTextureProperty] ✅ Step 3 SUCCESS: SceneHelper is available"), console.log("[ApplyTextureProperty] ✅ Step 3 SUCCESS: SceneHelper is available"), Logger.info("[ApplyTextureProperty] 🏗️ Step 4: Creating BABYLON.Texture object..."), console.log("[ApplyTextureProperty] 🏗️ Step 4: Creating BABYLON.Texture with params:", {
        url: n,
        noMipMap: !1,
        invertY: !0,
        samplingMode: "TRILINEAR"
      });
      const o = new BABYLON.Texture(
        n,
        this._scene,
        !1,
        // noMipMap: false (genera mipmaps come nel backoffice)
        !0,
        // invertY: true (default nel backoffice)
        BABYLON.Texture.TRILINEAR_SAMPLINGMODE,
        // sampling mode
        () => {
          Logger.info("[ApplyTextureProperty] 🔥 Texture onLoad callback fired!"), console.log("[ApplyTextureProperty] 🔥 Texture onLoad callback fired!"), this._scene.render();
        },
        (h) => {
          Logger.warn(`[ApplyTextureProperty] ❌ Texture onError callback fired: ${h}`), console.error("[ApplyTextureProperty] ❌ Texture onError callback fired:", h);
        }
      );
      Logger.info("[ApplyTextureProperty] ✅ Step 5: Texture object created"), console.log("[ApplyTextureProperty] ✅ Step 5: Texture object created:", o), Logger.info("[ApplyTextureProperty] 📝 Step 6: Setting texture metadata..."), console.log("[ApplyTextureProperty] 📝 Step 6: Setting texture metadata..."), o.metadata = { fileUrl: n }, o.name = t, Logger.info("[ApplyTextureProperty] ✅ Step 6: Metadata set"), console.log(`[ApplyTextureProperty] ✅ Step 6: Metadata set - name: '${t}', fileUrl: '${n}'`), Logger.info("[ApplyTextureProperty] ⏳ Step 7: Calling SceneHelper.whenTextureIsReadyAsync()..."), console.log("[ApplyTextureProperty] ⏳ Step 7: Calling SceneHelper.whenTextureIsReadyAsync()..."), console.log("[ApplyTextureProperty] Texture object:", o), console.log("[ApplyTextureProperty] Texture.isReady():", o.isReady ? o.isReady() : "isReady() not available"), console.log("[ApplyTextureProperty] SceneHelper.whenTextureIsReadyAsync exists?", typeof yi.whenTextureIsReadyAsync), yi.whenTextureIsReadyAsync(o).then(() => {
        var c, m, x, B, I, F;
        Logger.info("[ApplyTextureProperty] 🎉 Step 8: Texture is ready! Applying now..."), console.log("[ApplyTextureProperty] 🎉 Step 8: Texture is ready! Applying now..."), Logger.info("[ApplyTextureProperty] 🔧 Step 9: Calling SceneHelper.applyTexture()..."), console.log("[ApplyTextureProperty] 🔧 Step 9: Parameters - texture:", o, "material:", e, "type:", s), this._sceneHelper.applyTexture(o, e, s), Logger.info("[ApplyTextureProperty] ✅ Step 10: Applied texture via SceneHelper"), console.log("[ApplyTextureProperty] ✅ Step 10: Applied texture via SceneHelper"), Logger.info("[ApplyTextureProperty] 🔄 Step 11: Calling markMaterialDirty()..."), console.log("[ApplyTextureProperty] 🔄 Step 11: Calling markMaterialDirty()..."), this.markMaterialDirty(e), Logger.info("[ApplyTextureProperty] ✅ Step 12: markMaterialDirty() completed"), console.log("[ApplyTextureProperty] ✅ Step 12: markMaterialDirty() completed"), Logger.info("[ApplyTextureProperty] 🎨 Step 13: Calling scene.render()..."), console.log("[ApplyTextureProperty] 🎨 Step 13: Calling scene.render()..."), this._scene.render(), Logger.info("[ApplyTextureProperty] ✅ Step 14: scene.render() completed"), console.log("[ApplyTextureProperty] ✅ Step 14: scene.render() completed");
        const h = e;
        Logger.info("[ApplyTextureProperty] 📊 Step 15: Checking material state..."), console.log(`[DEBUG] 🎨 Step 15: Stato materiale '${e.id}' dopo applicazione texture:`), console.log("  - albedoTexture:", h.albedoTexture), console.log("  - albedoColor:", h.albedoColor), console.log("  - texture.isReady():", (m = (c = h.albedoTexture) == null ? void 0 : c.isReady) == null ? void 0 : m.call(c)), console.log("  - material.isReady():", (x = h.isReady) == null ? void 0 : x.call(h)), console.log("  - material.alpha:", h.alpha), console.log("  - material.disableLighting:", h.disableLighting), Logger.info(`[DEBUG] albedoTexture: ${h.albedoTexture ? "SET ✅" : "NULL ❌"}`), Logger.info(`[DEBUG] albedoColor: ${h.albedoColor}`), Logger.info(`[DEBUG] texture.isReady: ${(I = (B = h.albedoTexture) == null ? void 0 : B.isReady) == null ? void 0 : I.call(B)}`), Logger.info(`[DEBUG] material.isReady: ${(F = h.isReady) == null ? void 0 : F.call(h)}`), Logger.info("[ApplyTextureProperty] 🏁 TEXTURE APPLICATION COMPLETE!"), console.log("[ApplyTextureProperty] 🏁 TEXTURE APPLICATION COMPLETE!");
      }).catch((h) => {
        Logger.error("[ApplyTextureProperty] ❌ ERROR in Step 8 - Promise rejected:", h), console.error("[ApplyTextureProperty] ❌ ERROR in Step 8 - Promise rejected:", h), console.error("[ApplyTextureProperty] Error stack:", h == null ? void 0 : h.stack);
      });
    } catch (s) {
      Logger.error(
        `[ApplyTextureProperty] ❌ Error applying texture property '${t}' to material '${e.id}'`,
        s
      );
    }
  }
  /**
   * Converte un property path (es: "albedoTexture", "albedo.albedoTexture", "clearCoat_textureRoughnessTexture") 
   * in texture type per SceneHelper (es: "albedo", "clearCoat_textureRoughness")
   */
  convertPropertyPathToTextureType(e) {
    if (console.log(`[convertPropertyPathToTextureType] 🔄 Input: '${e}'`), Logger.info(`[convertPropertyPathToTextureType] Input: '${e}'`), e.includes(".")) {
      console.log("[convertPropertyPathToTextureType] 📍 Detected DOT notation");
      const s = e.split("."), o = s[0], h = s[1];
      console.log(`[convertPropertyPathToTextureType]   Base: '${o}', Texture: '${h}'`);
      let c = h;
      c.endsWith("Texture") && (c = c.substring(0, c.length - 7));
      const m = o;
      return console.log(`[convertPropertyPathToTextureType] ✅ Dot notation result: '${m}'`), Logger.info(`[convertPropertyPathToTextureType] Converted dot notation '${e}' → '${m}'`), m;
    }
    if (e.includes("_")) {
      console.log("[convertPropertyPathToTextureType] 🔗 Detected UNDERSCORE notation");
      let s = e;
      return s.endsWith("Texture") && (s = s.substring(0, s.length - 7)), console.log(`[convertPropertyPathToTextureType] ✅ Underscore notation result: '${s}'`), Logger.info(`[convertPropertyPathToTextureType] Converted underscore notation '${e}' → '${s}'`), s;
    }
    console.log("[convertPropertyPathToTextureType] 🗺️ Using DIRECT mapping");
    const n = {
      albedoTexture: "albedo",
      bumpTexture: "bump",
      metallicTexture: "metallic",
      reflectivityTexture: "reflectivity",
      emissiveTexture: "emissive",
      opacityTexture: "opacity",
      ambientTexture: "ambient",
      microsurfaceTexture: "microSurface",
      reflectionTexture: "reflection",
      matCapReflectionTexture: "matCapReflection",
      aoTexture: "ao"
    }[e] || null;
    return n ? (console.log(`[convertPropertyPathToTextureType] ✅ Direct mapping result: '${n}'`), Logger.info(`[convertPropertyPathToTextureType] Converted via direct mapping '${e}' → '${n}'`)) : (console.error(`[convertPropertyPathToTextureType] ❌ No mapping found for '${e}'`), Logger.warn(`[convertPropertyPathToTextureType] No mapping found for '${e}'`)), n;
  }
  /**
   * Fallback alla logica precedente per texture non mappabili
   */
  applyTexturePropertyFallback(e, t, n) {
    Logger.info(`[ApplyTexturePropertyFallback] Using direct assignment for '${t}'`);
    const s = e;
    t === "albedoTexture" ? (s.albedoTexture = n, this.markMaterialDirty(s), Logger.info(`[ApplyTexturePropertyFallback] ✓ Set albedoTexture for material '${e.id}'`)) : t === "bumpTexture" ? (s.bumpTexture = n, this.markMaterialDirty(s), Logger.info(`[ApplyTexturePropertyFallback] ✓ Set bumpTexture for material '${e.id}'`)) : Logger.warn(
      `[ApplyTexturePropertyFallback] ❌ Unknown texture property: ${t} for material '${e.id}'`
    );
  }
  removeTextureProperty(e, t) {
    Logger.info(`[RemoveTextureProperty] Material: '${e.id}' | Path: '${t}'`);
    const n = e;
    t === "clearCoat_textureRoughnessTexture" ? n.clearCoat && (n.clearCoat.texture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.texture for material '${e.id}'`)) : t === "clearCoat_bumpTexture" ? n.clearCoat && (n.clearCoat.bumpTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.bumpTexture for material '${e.id}'`)) : t === "clearCoat_tintTexture" ? n.clearCoat && (n.clearCoat.tintTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.tintTexture for material '${e.id}'`)) : t === "subSurface_thicknessTexture" ? n.subSurface && (n.subSurface.thicknessTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.thicknessTexture for material '${e.id}'`
    )) : t === "subSurface_tint_tintColorTexture" ? n.subSurface && (n.subSurface.tintColorTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.tintColorTexture for material '${e.id}'`
    )) : t === "subSurface_refractionTexture" ? n.subSurface && (n.subSurface.refractionTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.refractionTexture for material '${e.id}'`
    )) : t === "albedoTexture" ? (n.albedoTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed albedoTexture for material '${e.id}'`)) : t === "bumpTexture" ? (n.bumpTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed bumpTexture for material '${e.id}'`)) : t === "metallicTexture" ? (n.metallicTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed metallicTexture for material '${e.id}'`)) : t === "reflectivityTexture" ? (n.reflectivityTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed reflectivityTexture for material '${e.id}'`)) : t === "emissiveTexture" ? (n.emissiveTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed emissiveTexture for material '${e.id}'`)) : t === "opacityTexture" ? (n.opacityTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed opacityTexture for material '${e.id}'`)) : t === "ambientTexture" ? (n.ambientTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed ambientTexture for material '${e.id}'`)) : Logger.warn(`[RemoveTextureProperty] ❌ Unknown texture property: ${t}`);
  }
  applyColorProperty(e, t, n) {
    try {
      console.log("🎨 ApplyColorProperty START"), console.log(`   Material: '${e.id}'`), console.log(`   Path: '${t}'`), console.log(`   Hex: '${n}'`), Logger.info(
        `[ApplyColorProperty] Material: '${e.id}' | Path: '${t}' | Hex: '${n}'`
      );
      const s = BABYLON.Color3.FromHexString(n);
      console.log(`🌈 Converted to Color3: R=${s.r.toFixed(3)}, G=${s.g.toFixed(3)}, B=${s.b.toFixed(3)}`), Logger.info(
        `[ApplyColorProperty] Converted to Color3: R=${s.r.toFixed(3)}, G=${s.g.toFixed(
          3
        )}, B=${s.b.toFixed(3)}`
      );
      const o = t.split(".");
      if (console.log(`📍 Path parts: [${o.join(" → ")}]`), Logger.info(`[ApplyColorProperty] Path parts: [${o.join(" → ")}]`), o.length === 2 && o[0] === "albedo") {
        const x = o[1];
        if (console.log(`🔍 Checking for direct property: '${x}'`), e.hasOwnProperty(x)) {
          console.log(`🔄 Smart fix: Found direct property '${x}' instead of '${t}'`), Logger.info(`[ApplyColorProperty] Smart fix: Using direct property '${x}' instead of nested path`);
          const B = e[x];
          e[x] = s, console.log(`✅ Applied color directly to '${x}'!`), console.log(`   Old value: ${B}`), console.log(`   New value: ${n} (Color3)`), Logger.info(`[ApplyColorProperty] ✓ Set direct property '${x}' | Old: ${B} | New: ${n}`);
          return;
        } else
          console.log(`⚠️ Direct property '${x}' not found, trying nested path...`);
      }
      let h = e;
      for (let x = 0; x < o.length - 1; x++) {
        const B = o[x];
        if (console.log(`🔍 Checking property: '${B}' on ${h.constructor.name}`), h[B] === void 0 || h[B] === null) {
          console.error(`❌ Property '${B}' does not exist on material '${e.id}'`), Logger.warn(
            `[ApplyColorProperty] ❌ Property path '${t}' is invalid: '${B}' does not exist on material '${e.id}'`
          );
          return;
        }
        console.log(`✅ Found property: '${B}'`), Logger.info(`[ApplyColorProperty] Navigating: ${B}`), h = h[B];
      }
      const c = o[o.length - 1], m = h[c];
      console.log(`🎯 Setting final property: '${c}'`), console.log(`   Old value: ${m}`), console.log(`   New value: ${n} (Color3)`), h[c] = s, console.log("✅ Color property applied successfully!"), Logger.info(
        `[ApplyColorProperty] ✓ Set color property '${t}' to material '${e.id}' | Old: ${m} | New: ${n}`
      );
    } catch (s) {
      Logger.error(
        `[ApplyColorProperty] ❌ Error applying color property '${t}' to material '${e.id}'`,
        s
      );
    }
  }
  applyStandardProperty(e, t, n) {
    try {
      Logger.info(
        `[ApplyStandardProperty] Material: '${e.id}' | Path: '${t}' | Value: '${n}' | Type: ${typeof n}`
      );
      const s = t.split(".");
      if (Logger.info(`[ApplyStandardProperty] Path parts: [${s.join(" → ")}]`), s.length === 2 && s[0] === "albedo") {
        const x = s[1];
        if (e.hasOwnProperty(x)) {
          Logger.info(`[ApplyStandardProperty] Smart fix: Using direct property '${x}' instead of nested path`);
          const B = e[x];
          let I = n;
          if (typeof B == "boolean")
            I = n === "true" || n === !0;
          else if (typeof B == "number") {
            if (I = parseFloat(n), isNaN(I)) {
              Logger.warn(`[ApplyStandardProperty] ❌ Cannot convert '${n}' to number for property '${t}'`);
              return;
            }
          } else
            typeof B == "string" && (I = String(n));
          e[x] = I, Logger.info(`[ApplyStandardProperty] ✓ Set direct property '${x}' | Old: ${B} | New: ${I}`);
          return;
        }
      }
      let o = e;
      for (let x = 0; x < s.length - 1; x++) {
        const B = s[x];
        if (o[B] === void 0 || o[B] === null) {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Property path '${t}' is invalid: '${B}' does not exist on material '${e.id}'`
          );
          return;
        }
        Logger.info(`[ApplyStandardProperty] Navigating: ${B}`), o = o[B];
      }
      const h = s[s.length - 1], c = o[h];
      Logger.info(
        `[ApplyStandardProperty] Final property: '${h}' | Old value: '${c}' | Old type: ${typeof c}`
      );
      let m = n;
      if (typeof c == "boolean")
        m = n === "true" || n === !0, Logger.info(
          `[ApplyStandardProperty] Type conversion: String → Boolean | "${n}" → ${m}`
        );
      else if (typeof c == "number") {
        if (m = parseFloat(n), isNaN(m)) {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Cannot convert '${n}' to number for property '${t}'`
          );
          return;
        }
        Logger.info(
          `[ApplyStandardProperty] Type conversion: String → Number | "${n}" → ${m}`
        );
      } else if (typeof c == "string")
        m = String(n), Logger.info(
          `[ApplyStandardProperty] Type conversion: String → String | "${n}" → "${m}"`
        );
      else if (c instanceof BABYLON.Color3)
        if (typeof n == "string" && n.startsWith("#"))
          m = BABYLON.Color3.FromHexString(n), Logger.info(`[ApplyStandardProperty] Type conversion: Hex → Color3 | "${n}" → Color3`);
        else {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Expected hex color for property '${t}', got: ${n}`
          );
          return;
        }
      else
        Logger.info("[ApplyStandardProperty] No type conversion needed, using value as-is");
      o[h] = m, Logger.info(
        `[ApplyStandardProperty] ✓ Set property '${t}' to material '${e.id}' | Old: ${c} | New: ${m}`
      );
    } catch (s) {
      Logger.error(
        `[ApplyStandardProperty] ❌ Error applying standard property '${t}' to material '${e.id}'`,
        s
      );
    }
  }
  async prefetchMeshesForUnselectedOptionsAsync(e) {
    if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper && this._prefetchMeshes)
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n && n instanceof MPlaza.AttributeSceneAction && n.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && n.get("value") == "show") {
          const s = n.get("selector");
          if (s != null && s != null) {
            const o = this._elementSelector.getElements(
              this._zkScene,
              this._scene,
              null,
              s,
              MPlaza.SceneElementType.Mesh
            );
            for (let h = 0; h < o.length; h++) {
              const c = o[h];
              if (c instanceof BABYLON.AbstractMesh && !c.isVisible) {
                this._sceneHelper.checkDelayState(c);
                const m = c.material;
                m && await this._sceneHelper.prefetchTexturesForMaterialAsync(m);
              }
            }
          }
        }
      }
  }
  async checkActionsAssetsAreReadyAsync(e) {
    if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper) {
      for (let t = 0; t < e.length; t++) {
        const n = e[t], s = [];
        if (n && n instanceof MPlaza.AttributeSceneAction && n.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && n.get("value") === "show") {
          const o = n.get("selector");
          if (o != null) {
            const h = this._elementSelector.getElements(
              this._zkScene,
              this._scene,
              null,
              o,
              MPlaza.SceneElementType.Mesh
            );
            for (let c = 0; c < h.length; c++) {
              const m = h[c];
              if (m instanceof BABYLON.AbstractMesh && !m.isVisible) {
                const x = this._zkScene.get("rootUrl");
                if (x) {
                  const B = this._sceneHelper.getMeshDelayedMaterialIDs(m), I = this._sceneHelper.getMeshOffloadedMaterialIDs(m);
                  B.length > 0 && await this._sceneHelper.loadDelayedMaterialsAsync(
                    x,
                    B
                  ), I.length > 0 && await this._sceneHelper.loadOffloadedMaterialsByIDsAsync(
                    x,
                    I
                  );
                }
                s.push(m);
              }
            }
          }
        }
        await yi.whenAllMeshesAreReadyAsync(s);
      }
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n && n instanceof MPlaza.AttributeSceneAction) {
          if (n.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || n.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial) {
            let s = this.getMaterialFromActionValue(n);
            s || (s = await this.getDeepMaterialFromActionValueAsync(n));
          }
          if (n.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
            const s = n.get("selector");
            s != null && await this.getAllMaterialElementsAsync(s);
          }
        }
      }
    }
  }
  async prefetchDataForUnselectedOptionsAsync(e) {
  }
  // Nuovo metodo per risolvere dinamicamente i path delle proprietà basandosi sulla struttura reale del materiale
  resolveMaterialPropertyPath(e, t) {
    try {
      if (console.log(`🔍 Resolving property path: '${t}' on ${e.getClassName()}`), t.includes("_")) {
        const o = t.split("_"), h = o[0], c = o.slice(1).join("_");
        console.log(`🔗 Underscore notation detected: subProperty='${h}', finalProperty='${c}'`);
        const m = e;
        if (m[h] !== void 0 && m[h] !== null) {
          const x = m[h];
          if (x[c] !== void 0)
            return console.log(`✅ Found underscore notation property: material.${h}.${c}`), {
              target: x,
              property: c,
              description: `Underscore notation: material.${h}.${c}`
            };
          console.warn(`⚠️ Property '${c}' not found in material.${h}`);
        } else
          console.warn(`⚠️ Sub-property '${h}' not found on material`);
      }
      const n = t.split("."), s = n[n.length - 1];
      if (n.length === 1 && e[s] !== void 0)
        return console.log(`✅ Found direct property: ${s}`), {
          target: e,
          property: s,
          description: `Direct property: material.${s}`
        };
      if (n.length > 1) {
        let o = e;
        for (let h = 0; h < n.length - 1; h++) {
          const c = n[h];
          if (o[c] !== void 0 && o[c] !== null)
            o = o[c];
          else {
            o = null;
            break;
          }
        }
        if (o && o[s] !== void 0)
          return console.log(`✅ Found nested property: ${t}`), {
            target: o,
            property: s,
            description: `Nested property: material.${t}`
          };
        if (e[s] !== void 0)
          return console.log(`✅ Found direct property as fallback: ${s} (from ${t})`), {
            target: e,
            property: s,
            description: `Direct property (fallback): material.${s} (requested: ${t})`
          };
      }
      return console.error(`❌ Property '${t}' not found on material`), null;
    } catch (n) {
      return console.error(`❌ Error resolving property path '${t}':`, n), null;
    }
  }
  applySmartColorProperty(e, t, n) {
    try {
      console.log("🎨 ApplySmartColorProperty START"), console.log(`   ${t.description}`), console.log(`   Hex: '${n}'`);
      const s = BABYLON.Color3.FromHexString(n);
      console.log(`🌈 Converted to Color3: R=${s.r.toFixed(3)}, G=${s.g.toFixed(3)}, B=${s.b.toFixed(3)}`);
      const o = t.target[t.property];
      console.log(`   Old value: ${o}`), t.target[t.property] = s, console.log("✅ Smart color property applied successfully!"), Logger.info(`[ApplySmartColorProperty] ✓ Set ${t.description} | Old: ${o} | New: ${n}`);
    } catch (s) {
      console.error("❌ Error in applySmartColorProperty:", s), Logger.error(`[ApplySmartColorProperty] ❌ Error: ${s}`);
    }
  }
  applySmartStandardProperty(e, t, n) {
    try {
      console.log("⚙️ ApplySmartStandardProperty START"), console.log(`   ${t.description}`), console.log(`   Value: '${n}' (${typeof n})`);
      const s = t.target[t.property];
      console.log(`   Old value: '${s}' (${typeof s})`);
      let o = n;
      if (typeof s == "boolean")
        o = n === "true" || n === !0, console.log(`🔄 Type conversion: String → Boolean | "${n}" → ${o}`);
      else if (typeof s == "number") {
        if (o = parseFloat(n), isNaN(o)) {
          console.error(`❌ Cannot convert '${n}' to number`);
          return;
        }
        console.log(`🔄 Type conversion: String → Number | "${n}" → ${o}`);
      } else if (typeof s == "string")
        o = String(n), console.log(`🔄 Type conversion: String → String | "${n}" → "${o}"`);
      else if (s instanceof BABYLON.Color3)
        if (typeof n == "string" && n.startsWith("#"))
          o = BABYLON.Color3.FromHexString(n), console.log(`🔄 Type conversion: Hex → Color3 | "${n}" → Color3`);
        else {
          console.error(`❌ Expected hex color, got: ${n}`);
          return;
        }
      t.target[t.property] = o, console.log("✅ Smart standard property applied successfully!"), Logger.info(`[ApplySmartStandardProperty] ✓ Set ${t.description} | Old: ${s} | New: ${o}`);
    } catch (s) {
      console.error("❌ Error in applySmartStandardProperty:", s), Logger.error(`[ApplySmartStandardProperty] ❌ Error: ${s}`);
    }
  }
  /**
   * Forza il refresh del materiale dopo l'assegnazione di texture
   */
  markMaterialDirty(e) {
    try {
      typeof e.markDirty == "function" ? (e.markDirty(), Logger.info(`[MarkMaterialDirty] ✓ Called material.markDirty() for '${e.id}'`)) : typeof e._markAllSubMeshesAsTexturesDirty == "function" ? (e._markAllSubMeshesAsTexturesDirty(), Logger.info(`[MarkMaterialDirty] ✓ Called _markAllSubMeshesAsTexturesDirty() for '${e.id}'`)) : (this._scene.markAllMaterialsAsDirty(BABYLON.Material.TextureDirtyFlag), Logger.info("[MarkMaterialDirty] ✓ Marked all materials as texture dirty for scene"));
    } catch (t) {
      Logger.warn(`[MarkMaterialDirty] ⚠️ Could not mark material '${e.id}' as dirty: ${t}`);
    }
  }
}
class Ow {
  constructor() {
    this._zkScene = null, this._scene = null, this._sceneHelper = null, this._meshLocationCache = {}, this._cameraAnimationCompletedListeners = [], this._meshAnimationCompletedListeners = [], this._beforeSaveMeshLocationListeners = [], this._afterSaveMeshLocationListeners = [];
  }
  dispose() {
    for (; this._cameraAnimationCompletedListeners.length > 0; )
      this._cameraAnimationCompletedListeners.pop();
    for (; this._meshAnimationCompletedListeners.length > 0; )
      this._meshAnimationCompletedListeners.pop();
    for (; this._beforeSaveMeshLocationListeners.length > 0; )
      this._beforeSaveMeshLocationListeners.pop();
    for (; this._afterSaveMeshLocationListeners.length > 0; )
      this._afterSaveMeshLocationListeners.pop();
    this.disposeSceneHelper();
  }
  setScene(e) {
    this._scene = e, this.resetSceneHelper(), this.resetCache();
  }
  setModel(e) {
    this._zkScene = e, this.resetCache();
  }
  setModelAndScene(e, t) {
    this._zkScene = e, this._scene = t, this.resetSceneHelper(), this.resetCache();
  }
  resetCache() {
    this._meshLocationCache = {};
  }
  invalidateCache(e) {
    this._meshLocationCache && delete this._meshLocationCache[e];
  }
  disposeSceneHelper() {
    this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
  }
  resetSceneHelper() {
    this.disposeSceneHelper(), this._scene && (this._sceneHelper = new yi(this._scene));
  }
  clearMeshLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("meshLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
    }
  }
  async setMeshLocationByID(e) {
    if (this._zkScene && this._scene) {
      const t = this._zkScene.getMeshLocation(e);
      t && await this.setMeshLocation(t);
    }
  }
  async setMeshLocation(e) {
    if (this._zkScene && this._scene && this._sceneHelper) {
      let x, B = !0;
      if (e) {
        let I = e.get("locationID");
        if (B = e.get("adjustCamera"), this._meshLocationCache.hasOwnProperty(I))
          x = this._meshLocationCache[I];
        else {
          let F = e.get("data"), M = null;
          if (typeof F == "string") {
            let Z = window.atob(F), V = Z.length, te = new Uint8Array(V);
            for (let K = 0; K < V; K++)
              te[K] = Z.charCodeAt(K);
            let P = te.buffer;
            M = new Uint8Array(P);
          } else
            Object.prototype.toString.call(F) === "[object Array]" && (M = Uint8Array.from(F));
          if (M != null) {
            let Z = LZString.decompressFromUint8Array(M);
            if (x = JSON.parse(Z), x) {
              for (var t in x) {
                var n = x[t];
                n.p && (n.p = new BABYLON.Vector3(n.p.x, n.p.y, n.p.z)), n.rE && (n.rE = new BABYLON.Vector3(n.rE.x, n.rE.y, n.rE.z)), n.rQ && (n.rQ = new BABYLON.Quaternion(n.rQ.x, n.rQ.y, n.rQ.z, n.rQ.w)), n.s && (n.s = new BABYLON.Vector3(n.s.x, n.s.y, n.s.z));
              }
              this._meshLocationCache[I] = x;
            }
          }
        }
      }
      if (x) {
        const I = [];
        if (B && x.hasOwnProperty("wemin") && x.hasOwnProperty("wemax")) {
          var s = {
            min: new BABYLON.Vector3(x.wemin.x, x.wemin.y, x.wemin.z),
            max: new BABYLON.Vector3(x.wemax.x, x.wemax.y, x.wemax.z)
          };
          let F = this._sceneHelper.camera;
          if (F && F instanceof BABYLON.ArcRotateCamera) {
            F.upperRadiusLimit = null;
            var o = this._sceneHelper.calculateCameraRadius(s), h = this._sceneHelper.getWorldCenter(s);
            h && (this._sceneHelper.setCameraRadiusParameters(o), I.push(new Promise((M) => {
              F && F instanceof BABYLON.ArcRotateCamera && this._sceneHelper.animateCameraToFinalParamters(F.alpha, F.beta, o, h, 1, () => {
                this._sceneHelper && (this._sceneHelper.setupCameraLimits(s), this.fireCameraAnimationCompletedEvent(), M());
              });
            })));
          }
        }
        for (var c = 0; c < this._scene.meshes.length; c++) {
          var m = this._scene.meshes[c], t = m.id;
          if (x.hasOwnProperty(t)) {
            var n = x[t];
            I.push(new Promise((Z) => {
              this._sceneHelper.animateMeshToFinalParameters(m, n.p, n.rE, n.rQ, n.s, 1, () => {
                this.fireMeshAnimationCompletedEvent(), Z();
              });
            }));
          }
        }
        await Promise.all(I);
      }
    }
  }
  saveMeshLocation(e) {
    if (this._zkScene && this._scene) {
      var t = new Zakeke.SceneMeshLocation();
      t.set("name", e), this.updateMeshLocation(t), this._zkScene.get("meshLocations").push(t);
    }
  }
  saveExplodedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateExplodedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  saveCollapsedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateCollapsedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  updateMeshLocation(e) {
    if (this.fireBeforeSaveMeshLocationEvent(), this._scene && this._sceneHelper) {
      var t = this.getMeshPRSs(), n = this._sceneHelper.getWorldExtends();
      if (n) {
        let c = {
          x: n.min.x,
          y: n.min.y,
          z: n.min.z
        }, m = {
          x: n.max.x,
          y: n.max.y,
          z: n.max.z
        };
        t.wemin = c, t.wemax = m;
      }
      var s = JSON.stringify(t);
      let o = LZString.compressToUint8Array(s), h = [].slice.call(o);
      e.set("data", h), this.invalidateCache(e.get("locationID"));
    }
    this.fireAfterSaveMeshLocationEvent();
  }
  getMeshPRSs() {
    let e = {
      wemin: void 0,
      wemax: void 0
    };
    if (this._scene && this._sceneHelper)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const n = this._scene.meshes[t];
        if (this._sceneHelper.isRealMesh(n)) {
          let s = n.id, o = {
            p: void 0,
            rQ: void 0,
            rE: void 0,
            s: void 0
          }, h = {
            x: n.position.x,
            y: n.position.y,
            z: n.position.z
          };
          if (o.p = h, n.rotationQuaternion == null) {
            o.rQ = null;
            let m = {
              x: n.rotation.x,
              y: n.rotation.y,
              z: n.rotation.z
            };
            o.rE = m;
          } else {
            let m = {
              w: n.rotationQuaternion.w,
              x: n.rotationQuaternion.x,
              y: n.rotationQuaternion.y,
              z: n.rotationQuaternion.z
            };
            o.rQ = m, o.rE = null;
          }
          let c = {
            x: n.scaling.x,
            y: n.scaling.y,
            z: n.scaling.z
          };
          o.s = c, e[s] = o;
        }
      }
    return e;
  }
  async explodeMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstExplodedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  async collapseMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstCollapsedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  // Events
  fireCameraAnimationCompletedEvent() {
    for (let e = 0; e < this._cameraAnimationCompletedListeners.length; ++e)
      this._cameraAnimationCompletedListeners[e]();
  }
  addCameraAnimationCompletedListener(e) {
    this._cameraAnimationCompletedListeners.push(e);
  }
  fireMeshAnimationCompletedEvent() {
    for (let e = 0; e < this._meshAnimationCompletedListeners.length; ++e)
      this._meshAnimationCompletedListeners[e]();
  }
  addMeshAnimationCompletedListener(e) {
    this._meshAnimationCompletedListeners.push(e);
  }
  fireBeforeSaveMeshLocationEvent() {
    for (let e = 0; e < this._beforeSaveMeshLocationListeners.length; ++e)
      this._beforeSaveMeshLocationListeners[e]();
  }
  addBeforeSaveMeshLocationListener(e) {
    this._beforeSaveMeshLocationListeners.push(e);
  }
  fireAfterSaveMeshLocationEvent() {
    for (let e = 0; e < this._afterSaveMeshLocationListeners.length; ++e)
      this._afterSaveMeshLocationListeners[e]();
  }
  addAfterSaveMeshLocationListener(e) {
    this._afterSaveMeshLocationListeners.push(e);
  }
}
class Pw {
  constructor(e, t) {
    this._glowLayer = null, this._zkScene = e, this._scene = t, this._sceneHelper = new yi(this._scene), this._glowLayer = this._scene.getGlowLayerByName("glow");
  }
  get enabled() {
    const e = this.getGlowConfig();
    return e && e.get("enabled") != null && typeof e.get("enabled") == "boolean" && e.get("enabled"), !1;
  }
  set enabled(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("enabled", e), this.update();
  }
  get intensity() {
    const e = this.getGlowConfig();
    return e && e.get("intensity") != null && typeof e.get("intensity") == "number" && e.get("intensity"), 1;
  }
  set intensity(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("intensity", e), this.update();
  }
  get blurSize() {
    const e = this.getGlowConfig();
    return e && e.get("blurSize") != null && typeof e.get("blurSize") == "number" && e.get("blurSize"), 1;
  }
  set blurSize(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("blurSize", e), this.update();
  }
  dispose() {
    this.destroyGlowLayer();
  }
  destroyGlowLayer() {
    this._glowLayer && (this._glowLayer.dispose(), this._glowLayer = null);
  }
  createOrUpdateGlowLayer(e, t) {
    this._glowLayer || (this._glowLayer = new BABYLON.GlowLayer("glow", this._scene)), this._glowLayer && (this._glowLayer.intensity = e, this._glowLayer.blurKernelSize = t);
  }
  update() {
    if (this._scene) {
      var e = this.getGlowConfig();
      if (e) {
        const t = this.enabled, n = this.intensity, s = this.blurSize;
        t ? this.createOrUpdateGlowLayer(n, s) : this.destroyGlowLayer();
      } else
        this.destroyGlowLayer();
    }
  }
  turnOffGlow() {
    this.destroyGlowLayer();
  }
  turnOnGlow() {
    this.update();
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  isGlowEnabledForMesh(e) {
    return e ? e.metadata && e.metadata.enableGlow : !1;
  }
  // La possibilità di abilitare solo alcune mesh al glow viene disabilitata
  // perché c'è il problema che l'effetto glow è visibile attraverso le mesh
  // per cui il glow è diabilitato
  enableGlowForMesh(e) {
  }
  disableGlowForMesh(e) {
  }
  getGlowConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGlowConfig();
      if (e)
        return e;
    }
    return null;
  }
  getOrCreateGlowConfig() {
    return this.sanityCheck() ? this._zkScene.getOrCreateGlowConfig() : null;
  }
}
class Au {
  /**
   * Constructor
   * @param workers Array of workers to use for actions
   */
  constructor(e) {
    this._pendingActions = new Array(), this._workerInfos = e.map((t) => ({
      worker: t,
      active: !1
    }));
  }
  /**
   * Terminates all workers and clears any pending actions.
   */
  dispose() {
    for (const e of this._workerInfos)
      e.worker.terminate();
    delete this._workerInfos, delete this._pendingActions;
  }
  /**
   * Pushes an action to the worker pool. If all the workers are active, the action will be
   * pended until a worker has completed its action.
   * @param action The action to perform. Call onComplete when the action is complete.
   */
  push(e) {
    for (const t of this._workerInfos)
      if (!t.active) {
        this._execute(t, e);
        return;
      }
    this._pendingActions.push(e);
  }
  _execute(e, t) {
    e.active = !0, t(e.worker, () => {
      e.active = !1;
      const n = this._pendingActions.shift();
      n && this._execute(e, n);
    });
  }
}
function ig(y) {
  return typeof importScripts == "function" ? (importScripts(y), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(y, () => {
      e();
    }, (n) => {
      t(new Error(n));
    });
  });
}
function ng(y) {
  if (y.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < y.length; t++)
    e.push(ig(y[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function rg(y, e, t) {
  return new MakeIncremental().getSceneIncrementalFiles(y, e, t);
}
function Nw() {
  let y;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.urls;
        y = ng(n), postMessage("done");
        break;
      }
      case "makeIncremental": {
        if (!y)
          throw new Error("Worker not initialized");
        y.then(() => {
          const n = t.sceneJson, s = t.version, o = t.options, h = rg(n, s, o);
          postMessage({ id: "result", files: h }), postMessage("done");
        });
        break;
      }
    }
  };
}
function Rw(y) {
  return typeof document != "object" || typeof y != "string" ? y : BABYLON.Tools.GetAbsoluteUrl(y);
}
const Ml = class Ma {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the incremental file maker
   */
  static get Default() {
    return Ma._Default || (Ma._Default = new Ma([])), Ma._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
  */
  constructor(e, t = Ma.DefaultNumWorkers) {
    const n = e.map((s) => Rw(s));
    if (t && typeof Worker == "function") {
      const s = `${ig}${ng}${rg}(${Nw})()`, o = URL.createObjectURL(new Blob([s], { type: "application/javascript" })), h = new Array(t);
      for (let c = 0; c < h.length; c++)
        h[c] = new Promise((m, x) => {
          const B = new Worker(o), I = (M) => {
            B.removeEventListener("error", I), B.removeEventListener("message", F), x(M);
          }, F = (M) => {
            M.data === "done" && (B.removeEventListener("error", I), B.removeEventListener("message", F), m(B));
          };
          B.addEventListener("error", I), B.addEventListener("message", F), B.postMessage({
            id: "init",
            urls: n
          });
        });
      this._workerPoolPromise = Promise.all(h).then((c) => new Au(c));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getIncrementalFilesAsync(e, t, n) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((s) => new Promise((o, h) => {
        s.push((c, m) => {
          let x = [];
          const B = (F) => {
            c.removeEventListener("error", B), c.removeEventListener("message", I), h(F), m();
          }, I = (F) => {
            F.data === "done" ? (c.removeEventListener("error", B), c.removeEventListener("message", I), o(x), m()) : F.data.id === "result" && (x = F.data.files);
          };
          c.addEventListener("error", B), c.addEventListener("message", I), c.postMessage({ id: "makeIncremental", sceneJson: e, version: t, options: n });
        });
      }));
    throw new Error("Incremental file worker is not available");
  }
};
Ml.DefaultNumWorkers = Ml.GetDefaultNumWorkers();
Ml._Default = null;
let Dw = Ml;
var sg = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function(y) {
  (function(e, t) {
    y.exports = e.document ? t(e, !0) : function(n) {
      if (!n.document)
        throw new Error("jQuery requires a window with a document");
      return t(n);
    };
  })(typeof window < "u" ? window : as, function(e, t) {
    var n = [], s = Object.getPrototypeOf, o = n.slice, h = n.flat ? function(w) {
      return n.flat.call(w);
    } : function(w) {
      return n.concat.apply([], w);
    }, c = n.push, m = n.indexOf, x = {}, B = x.toString, I = x.hasOwnProperty, F = I.toString, M = F.call(Object), Z = {}, V = function(N) {
      return typeof N == "function" && typeof N.nodeType != "number" && typeof N.item != "function";
    }, te = function(N) {
      return N != null && N === N.window;
    }, P = e.document, K = {
      type: !0,
      src: !0,
      nonce: !0,
      noModule: !0
    };
    function J(w, N, ee) {
      ee = ee || P;
      var re, ge, _e = ee.createElement("script");
      if (_e.text = w, N)
        for (re in K)
          ge = N[re] || N.getAttribute && N.getAttribute(re), ge && _e.setAttribute(re, ge);
      ee.head.appendChild(_e).parentNode.removeChild(_e);
    }
    function le(w) {
      return w == null ? w + "" : typeof w == "object" || typeof w == "function" ? x[B.call(w)] || "object" : typeof w;
    }
    var fe = "3.7.1", X = /HTML$/i, W = function(w, N) {
      return new W.fn.init(w, N);
    };
    W.fn = W.prototype = {
      // The current version of jQuery being used
      jquery: fe,
      constructor: W,
      // The default length of a jQuery object is 0
      length: 0,
      toArray: function() {
        return o.call(this);
      },
      // Get the Nth element in the matched element set OR
      // Get the whole matched element set as a clean array
      get: function(w) {
        return w == null ? o.call(this) : w < 0 ? this[w + this.length] : this[w];
      },
      // Take an array of elements and push it onto the stack
      // (returning the new matched element set)
      pushStack: function(w) {
        var N = W.merge(this.constructor(), w);
        return N.prevObject = this, N;
      },
      // Execute a callback for every element in the matched set.
      each: function(w) {
        return W.each(this, w);
      },
      map: function(w) {
        return this.pushStack(W.map(this, function(N, ee) {
          return w.call(N, ee, N);
        }));
      },
      slice: function() {
        return this.pushStack(o.apply(this, arguments));
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      even: function() {
        return this.pushStack(W.grep(this, function(w, N) {
          return (N + 1) % 2;
        }));
      },
      odd: function() {
        return this.pushStack(W.grep(this, function(w, N) {
          return N % 2;
        }));
      },
      eq: function(w) {
        var N = this.length, ee = +w + (w < 0 ? N : 0);
        return this.pushStack(ee >= 0 && ee < N ? [this[ee]] : []);
      },
      end: function() {
        return this.prevObject || this.constructor();
      },
      // For internal use only.
      // Behaves like an Array's method, not like a jQuery method.
      push: c,
      sort: n.sort,
      splice: n.splice
    }, W.extend = W.fn.extend = function() {
      var w, N, ee, re, ge, _e, xe = arguments[0] || {}, Ue = 1, De = arguments.length, qe = !1;
      for (typeof xe == "boolean" && (qe = xe, xe = arguments[Ue] || {}, Ue++), typeof xe != "object" && !V(xe) && (xe = {}), Ue === De && (xe = this, Ue--); Ue < De; Ue++)
        if ((w = arguments[Ue]) != null)
          for (N in w)
            re = w[N], !(N === "__proto__" || xe === re) && (qe && re && (W.isPlainObject(re) || (ge = Array.isArray(re))) ? (ee = xe[N], ge && !Array.isArray(ee) ? _e = [] : !ge && !W.isPlainObject(ee) ? _e = {} : _e = ee, ge = !1, xe[N] = W.extend(qe, _e, re)) : re !== void 0 && (xe[N] = re));
      return xe;
    }, W.extend({
      // Unique for each copy of jQuery on the page
      expando: "jQuery" + (fe + Math.random()).replace(/\D/g, ""),
      // Assume jQuery is ready without the ready module
      isReady: !0,
      error: function(w) {
        throw new Error(w);
      },
      noop: function() {
      },
      isPlainObject: function(w) {
        var N, ee;
        return !w || B.call(w) !== "[object Object]" ? !1 : (N = s(w), N ? (ee = I.call(N, "constructor") && N.constructor, typeof ee == "function" && F.call(ee) === M) : !0);
      },
      isEmptyObject: function(w) {
        var N;
        for (N in w)
          return !1;
        return !0;
      },
      // Evaluates a script in a provided context; falls back to the global one
      // if not specified.
      globalEval: function(w, N, ee) {
        J(w, { nonce: N && N.nonce }, ee);
      },
      each: function(w, N) {
        var ee, re = 0;
        if (je(w))
          for (ee = w.length; re < ee && N.call(w[re], re, w[re]) !== !1; re++)
            ;
        else
          for (re in w)
            if (N.call(w[re], re, w[re]) === !1)
              break;
        return w;
      },
      // Retrieve the text value of an array of DOM nodes
      text: function(w) {
        var N, ee = "", re = 0, ge = w.nodeType;
        if (!ge)
          for (; N = w[re++]; )
            ee += W.text(N);
        return ge === 1 || ge === 11 ? w.textContent : ge === 9 ? w.documentElement.textContent : ge === 3 || ge === 4 ? w.nodeValue : ee;
      },
      // results is for internal usage only
      makeArray: function(w, N) {
        var ee = N || [];
        return w != null && (je(Object(w)) ? W.merge(
          ee,
          typeof w == "string" ? [w] : w
        ) : c.call(ee, w)), ee;
      },
      inArray: function(w, N, ee) {
        return N == null ? -1 : m.call(N, w, ee);
      },
      isXMLDoc: function(w) {
        var N = w && w.namespaceURI, ee = w && (w.ownerDocument || w).documentElement;
        return !X.test(N || ee && ee.nodeName || "HTML");
      },
      // Support: Android <=4.0 only, PhantomJS 1 only
      // push.apply(_, arraylike) throws on ancient WebKit
      merge: function(w, N) {
        for (var ee = +N.length, re = 0, ge = w.length; re < ee; re++)
          w[ge++] = N[re];
        return w.length = ge, w;
      },
      grep: function(w, N, ee) {
        for (var re, ge = [], _e = 0, xe = w.length, Ue = !ee; _e < xe; _e++)
          re = !N(w[_e], _e), re !== Ue && ge.push(w[_e]);
        return ge;
      },
      // arg is for internal usage only
      map: function(w, N, ee) {
        var re, ge, _e = 0, xe = [];
        if (je(w))
          for (re = w.length; _e < re; _e++)
            ge = N(w[_e], _e, ee), ge != null && xe.push(ge);
        else
          for (_e in w)
            ge = N(w[_e], _e, ee), ge != null && xe.push(ge);
        return h(xe);
      },
      // A global GUID counter for objects
      guid: 1,
      // jQuery.support is not used in Core but other projects attach their
      // properties to it so it needs to exist.
      support: Z
    }), typeof Symbol == "function" && (W.fn[Symbol.iterator] = n[Symbol.iterator]), W.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(w, N) {
        x["[object " + N + "]"] = N.toLowerCase();
      }
    );
    function je(w) {
      var N = !!w && "length" in w && w.length, ee = le(w);
      return V(w) || te(w) ? !1 : ee === "array" || N === 0 || typeof N == "number" && N > 0 && N - 1 in w;
    }
    function Ee(w, N) {
      return w.nodeName && w.nodeName.toLowerCase() === N.toLowerCase();
    }
    var He = n.pop, ft = n.sort, Le = n.splice, $e = "[\\x20\\t\\r\\n\\f]", ce = new RegExp(
      "^" + $e + "+|((?:^|[^\\\\])(?:\\\\.)*)" + $e + "+$",
      "g"
    );
    W.contains = function(w, N) {
      var ee = N && N.parentNode;
      return w === ee || !!(ee && ee.nodeType === 1 && // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      (w.contains ? w.contains(ee) : w.compareDocumentPosition && w.compareDocumentPosition(ee) & 16));
    };
    var ut = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function ze(w, N) {
      return N ? w === "\0" ? "�" : w.slice(0, -1) + "\\" + w.charCodeAt(w.length - 1).toString(16) + " " : "\\" + w;
    }
    W.escapeSelector = function(w) {
      return (w + "").replace(ut, ze);
    };
    var pt = P, qt = c;
    (function() {
      var w, N, ee, re, ge, _e = qt, xe, Ue, De, qe, At, Bt = W.expando, ct = 0, Ft = 0, pi = Bn(), ai = Bn(), mi = Bn(), xn = Bn(), wn = function(Oe, Ke) {
        return Oe === Ke && (ge = !0), 0;
      }, an = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", Si = "(?:\\\\[\\da-fA-F]{1,6}" + $e + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", Ii = "\\[" + $e + "*(" + Si + ")(?:" + $e + // Operator (capture 2)
      "*([*^$|!~]?=)" + $e + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
      `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + Si + "))|)" + $e + "*\\]", Dn = ":(" + Si + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + Ii + ")*)|.*)\\)|)", Fi = new RegExp($e + "+", "g"), en = new RegExp("^" + $e + "*," + $e + "*"), lr = new RegExp("^" + $e + "*([>+~]|" + $e + ")" + $e + "*"), mr = new RegExp($e + "|>"), pn = new RegExp(Dn), Tr = new RegExp("^" + Si + "$"), Yn = {
        ID: new RegExp("^#(" + Si + ")"),
        CLASS: new RegExp("^\\.(" + Si + ")"),
        TAG: new RegExp("^(" + Si + "|[*])"),
        ATTR: new RegExp("^" + Ii),
        PSEUDO: new RegExp("^" + Dn),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + $e + "*(even|odd|(([+-]|)(\\d*)n|)" + $e + "*(?:([+-]|)" + $e + "*(\\d+)|))" + $e + "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + an + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + $e + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + $e + "*((?:-\\d)?\\d*)" + $e + "*\\)|)(?=[^-]|$)", "i")
      }, ei = /^(?:input|select|textarea|button)$/i, Zn = /^h\d$/i, Gn = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, zr = /[+~]/, Ai = new RegExp("\\\\[\\da-fA-F]{1,6}" + $e + "?|\\\\([^\\r\\n\\f])", "g"), hn = function(Oe, Ke) {
        var mt = "0x" + Oe.slice(1) - 65536;
        return Ke || (mt < 0 ? String.fromCharCode(mt + 65536) : String.fromCharCode(mt >> 10 | 55296, mt & 1023 | 56320));
      }, Jt = function() {
        Pn();
      }, Ln = $n(
        function(Oe) {
          return Oe.disabled === !0 && Ee(Oe, "fieldset");
        },
        { dir: "parentNode", next: "legend" }
      );
      function _i() {
        try {
          return xe.activeElement;
        } catch {
        }
      }
      try {
        _e.apply(
          n = o.call(pt.childNodes),
          pt.childNodes
        ), n[pt.childNodes.length].nodeType;
      } catch {
        _e = {
          apply: function(Ke, mt) {
            qt.apply(Ke, o.call(mt));
          },
          call: function(Ke) {
            qt.apply(Ke, o.call(arguments, 1));
          }
        };
      }
      function Ei(Oe, Ke, mt, St) {
        var Tt, Ne, Ze, Q, oe, Me, Be, ht = Ke && Ke.ownerDocument, gt = Ke ? Ke.nodeType : 9;
        if (mt = mt || [], typeof Oe != "string" || !Oe || gt !== 1 && gt !== 9 && gt !== 11)
          return mt;
        if (!St && (Pn(Ke), Ke = Ke || xe, De)) {
          if (gt !== 11 && (oe = Gn.exec(Oe)))
            if (Tt = oe[1]) {
              if (gt === 9)
                if (Ze = Ke.getElementById(Tt)) {
                  if (Ze.id === Tt)
                    return _e.call(mt, Ze), mt;
                } else
                  return mt;
              else if (ht && (Ze = ht.getElementById(Tt)) && Ei.contains(Ke, Ze) && Ze.id === Tt)
                return _e.call(mt, Ze), mt;
            } else {
              if (oe[2])
                return _e.apply(mt, Ke.getElementsByTagName(Oe)), mt;
              if ((Tt = oe[3]) && Ke.getElementsByClassName)
                return _e.apply(mt, Ke.getElementsByClassName(Tt)), mt;
            }
          if (!xn[Oe + " "] && (!qe || !qe.test(Oe))) {
            if (Be = Oe, ht = Ke, gt === 1 && (mr.test(Oe) || lr.test(Oe))) {
              for (ht = zr.test(Oe) && Ji(Ke.parentNode) || Ke, (ht != Ke || !Z.scope) && ((Q = Ke.getAttribute("id")) ? Q = W.escapeSelector(Q) : Ke.setAttribute("id", Q = Bt)), Me = tr(Oe), Ne = Me.length; Ne--; )
                Me[Ne] = (Q ? "#" + Q : ":scope") + " " + Vr(Me[Ne]);
              Be = Me.join(",");
            }
            try {
              return _e.apply(
                mt,
                ht.querySelectorAll(Be)
              ), mt;
            } catch {
              xn(Oe, !0);
            } finally {
              Q === Bt && Ke.removeAttribute("id");
            }
          }
        }
        return ur(Oe.replace(ce, "$1"), Ke, mt, St);
      }
      function Bn() {
        var Oe = [];
        function Ke(mt, St) {
          return Oe.push(mt + " ") > N.cacheLength && delete Ke[Oe.shift()], Ke[mt + " "] = St;
        }
        return Ke;
      }
      function di(Oe) {
        return Oe[Bt] = !0, Oe;
      }
      function un(Oe) {
        var Ke = xe.createElement("fieldset");
        try {
          return !!Oe(Ke);
        } catch {
          return !1;
        } finally {
          Ke.parentNode && Ke.parentNode.removeChild(Ke), Ke = null;
        }
      }
      function Fr(Oe) {
        return function(Ke) {
          return Ee(Ke, "input") && Ke.type === Oe;
        };
      }
      function Js(Oe) {
        return function(Ke) {
          return (Ee(Ke, "input") || Ee(Ke, "button")) && Ke.type === Oe;
        };
      }
      function Kr(Oe) {
        return function(Ke) {
          return "form" in Ke ? Ke.parentNode && Ke.disabled === !1 ? "label" in Ke ? "label" in Ke.parentNode ? Ke.parentNode.disabled === Oe : Ke.disabled === Oe : Ke.isDisabled === Oe || // Where there is no isDisabled, check manually
          Ke.isDisabled !== !Oe && Ln(Ke) === Oe : Ke.disabled === Oe : "label" in Ke ? Ke.disabled === Oe : !1;
        };
      }
      function Ur(Oe) {
        return di(function(Ke) {
          return Ke = +Ke, di(function(mt, St) {
            for (var Tt, Ne = Oe([], mt.length, Ke), Ze = Ne.length; Ze--; )
              mt[Tt = Ne[Ze]] && (mt[Tt] = !(St[Tt] = mt[Tt]));
          });
        });
      }
      function Ji(Oe) {
        return Oe && typeof Oe.getElementsByTagName < "u" && Oe;
      }
      function Pn(Oe) {
        var Ke, mt = Oe ? Oe.ownerDocument || Oe : pt;
        return mt == xe || mt.nodeType !== 9 || !mt.documentElement || (xe = mt, Ue = xe.documentElement, De = !W.isXMLDoc(xe), At = Ue.matches || Ue.webkitMatchesSelector || Ue.msMatchesSelector, Ue.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        pt != xe && (Ke = xe.defaultView) && Ke.top !== Ke && Ke.addEventListener("unload", Jt), Z.getById = un(function(St) {
          return Ue.appendChild(St).id = W.expando, !xe.getElementsByName || !xe.getElementsByName(W.expando).length;
        }), Z.disconnectedMatch = un(function(St) {
          return At.call(St, "*");
        }), Z.scope = un(function() {
          return xe.querySelectorAll(":scope");
        }), Z.cssHas = un(function() {
          try {
            return xe.querySelector(":has(*,:jqfake)"), !1;
          } catch {
            return !0;
          }
        }), Z.getById ? (N.filter.ID = function(St) {
          var Tt = St.replace(Ai, hn);
          return function(Ne) {
            return Ne.getAttribute("id") === Tt;
          };
        }, N.find.ID = function(St, Tt) {
          if (typeof Tt.getElementById < "u" && De) {
            var Ne = Tt.getElementById(St);
            return Ne ? [Ne] : [];
          }
        }) : (N.filter.ID = function(St) {
          var Tt = St.replace(Ai, hn);
          return function(Ne) {
            var Ze = typeof Ne.getAttributeNode < "u" && Ne.getAttributeNode("id");
            return Ze && Ze.value === Tt;
          };
        }, N.find.ID = function(St, Tt) {
          if (typeof Tt.getElementById < "u" && De) {
            var Ne, Ze, Q, oe = Tt.getElementById(St);
            if (oe) {
              if (Ne = oe.getAttributeNode("id"), Ne && Ne.value === St)
                return [oe];
              for (Q = Tt.getElementsByName(St), Ze = 0; oe = Q[Ze++]; )
                if (Ne = oe.getAttributeNode("id"), Ne && Ne.value === St)
                  return [oe];
            }
            return [];
          }
        }), N.find.TAG = function(St, Tt) {
          return typeof Tt.getElementsByTagName < "u" ? Tt.getElementsByTagName(St) : Tt.querySelectorAll(St);
        }, N.find.CLASS = function(St, Tt) {
          if (typeof Tt.getElementsByClassName < "u" && De)
            return Tt.getElementsByClassName(St);
        }, qe = [], un(function(St) {
          var Tt;
          Ue.appendChild(St).innerHTML = "<a id='" + Bt + "' href='' disabled='disabled'></a><select id='" + Bt + "-\r\\' disabled='disabled'><option selected=''></option></select>", St.querySelectorAll("[selected]").length || qe.push("\\[" + $e + "*(?:value|" + an + ")"), St.querySelectorAll("[id~=" + Bt + "-]").length || qe.push("~="), St.querySelectorAll("a#" + Bt + "+*").length || qe.push(".#.+[+~]"), St.querySelectorAll(":checked").length || qe.push(":checked"), Tt = xe.createElement("input"), Tt.setAttribute("type", "hidden"), St.appendChild(Tt).setAttribute("name", "D"), Ue.appendChild(St).disabled = !0, St.querySelectorAll(":disabled").length !== 2 && qe.push(":enabled", ":disabled"), Tt = xe.createElement("input"), Tt.setAttribute("name", ""), St.appendChild(Tt), St.querySelectorAll("[name='']").length || qe.push("\\[" + $e + "*name" + $e + "*=" + $e + `*(?:''|"")`);
        }), Z.cssHas || qe.push(":has"), qe = qe.length && new RegExp(qe.join("|")), wn = function(St, Tt) {
          if (St === Tt)
            return ge = !0, 0;
          var Ne = !St.compareDocumentPosition - !Tt.compareDocumentPosition;
          return Ne || (Ne = (St.ownerDocument || St) == (Tt.ownerDocument || Tt) ? St.compareDocumentPosition(Tt) : (
            // Otherwise we know they are disconnected
            1
          ), Ne & 1 || !Z.sortDetached && Tt.compareDocumentPosition(St) === Ne ? St === xe || St.ownerDocument == pt && Ei.contains(pt, St) ? -1 : Tt === xe || Tt.ownerDocument == pt && Ei.contains(pt, Tt) ? 1 : re ? m.call(re, St) - m.call(re, Tt) : 0 : Ne & 4 ? -1 : 1);
        }), xe;
      }
      Ei.matches = function(Oe, Ke) {
        return Ei(Oe, null, null, Ke);
      }, Ei.matchesSelector = function(Oe, Ke) {
        if (Pn(Oe), De && !xn[Ke + " "] && (!qe || !qe.test(Ke)))
          try {
            var mt = At.call(Oe, Ke);
            if (mt || Z.disconnectedMatch || // As well, disconnected nodes are said to be in a document
            // fragment in IE 9
            Oe.document && Oe.document.nodeType !== 11)
              return mt;
          } catch {
            xn(Ke, !0);
          }
        return Ei(Ke, xe, null, [Oe]).length > 0;
      }, Ei.contains = function(Oe, Ke) {
        return (Oe.ownerDocument || Oe) != xe && Pn(Oe), W.contains(Oe, Ke);
      }, Ei.attr = function(Oe, Ke) {
        (Oe.ownerDocument || Oe) != xe && Pn(Oe);
        var mt = N.attrHandle[Ke.toLowerCase()], St = mt && I.call(N.attrHandle, Ke.toLowerCase()) ? mt(Oe, Ke, !De) : void 0;
        return St !== void 0 ? St : Oe.getAttribute(Ke);
      }, Ei.error = function(Oe) {
        throw new Error("Syntax error, unrecognized expression: " + Oe);
      }, W.uniqueSort = function(Oe) {
        var Ke, mt = [], St = 0, Tt = 0;
        if (ge = !Z.sortStable, re = !Z.sortStable && o.call(Oe, 0), ft.call(Oe, wn), ge) {
          for (; Ke = Oe[Tt++]; )
            Ke === Oe[Tt] && (St = mt.push(Tt));
          for (; St--; )
            Le.call(Oe, mt[St], 1);
        }
        return re = null, Oe;
      }, W.fn.uniqueSort = function() {
        return this.pushStack(W.uniqueSort(o.apply(this)));
      }, N = W.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: di,
        match: Yn,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(Oe) {
            return Oe[1] = Oe[1].replace(Ai, hn), Oe[3] = (Oe[3] || Oe[4] || Oe[5] || "").replace(Ai, hn), Oe[2] === "~=" && (Oe[3] = " " + Oe[3] + " "), Oe.slice(0, 4);
          },
          CHILD: function(Oe) {
            return Oe[1] = Oe[1].toLowerCase(), Oe[1].slice(0, 3) === "nth" ? (Oe[3] || Ei.error(Oe[0]), Oe[4] = +(Oe[4] ? Oe[5] + (Oe[6] || 1) : 2 * (Oe[3] === "even" || Oe[3] === "odd")), Oe[5] = +(Oe[7] + Oe[8] || Oe[3] === "odd")) : Oe[3] && Ei.error(Oe[0]), Oe;
          },
          PSEUDO: function(Oe) {
            var Ke, mt = !Oe[6] && Oe[2];
            return Yn.CHILD.test(Oe[0]) ? null : (Oe[3] ? Oe[2] = Oe[4] || Oe[5] || "" : mt && pn.test(mt) && // Get excess from tokenize (recursively)
            (Ke = tr(mt, !0)) && // advance to the next closing parenthesis
            (Ke = mt.indexOf(")", mt.length - Ke) - mt.length) && (Oe[0] = Oe[0].slice(0, Ke), Oe[2] = mt.slice(0, Ke)), Oe.slice(0, 3));
          }
        },
        filter: {
          TAG: function(Oe) {
            var Ke = Oe.replace(Ai, hn).toLowerCase();
            return Oe === "*" ? function() {
              return !0;
            } : function(mt) {
              return Ee(mt, Ke);
            };
          },
          CLASS: function(Oe) {
            var Ke = pi[Oe + " "];
            return Ke || (Ke = new RegExp("(^|" + $e + ")" + Oe + "(" + $e + "|$)")) && pi(Oe, function(mt) {
              return Ke.test(
                typeof mt.className == "string" && mt.className || typeof mt.getAttribute < "u" && mt.getAttribute("class") || ""
              );
            });
          },
          ATTR: function(Oe, Ke, mt) {
            return function(St) {
              var Tt = Ei.attr(St, Oe);
              return Tt == null ? Ke === "!=" : Ke ? (Tt += "", Ke === "=" ? Tt === mt : Ke === "!=" ? Tt !== mt : Ke === "^=" ? mt && Tt.indexOf(mt) === 0 : Ke === "*=" ? mt && Tt.indexOf(mt) > -1 : Ke === "$=" ? mt && Tt.slice(-mt.length) === mt : Ke === "~=" ? (" " + Tt.replace(Fi, " ") + " ").indexOf(mt) > -1 : Ke === "|=" ? Tt === mt || Tt.slice(0, mt.length + 1) === mt + "-" : !1) : !0;
            };
          },
          CHILD: function(Oe, Ke, mt, St, Tt) {
            var Ne = Oe.slice(0, 3) !== "nth", Ze = Oe.slice(-4) !== "last", Q = Ke === "of-type";
            return St === 1 && Tt === 0 ? (
              // Shortcut for :nth-*(n)
              function(oe) {
                return !!oe.parentNode;
              }
            ) : function(oe, Me, Be) {
              var ht, gt, Mt, Wt, xi, ji = Ne !== Ze ? "nextSibling" : "previousSibling", Nn = oe.parentNode, mn = Q && oe.nodeName.toLowerCase(), _r = !Be && !Q, jn = !1;
              if (Nn) {
                if (Ne) {
                  for (; ji; ) {
                    for (Mt = oe; Mt = Mt[ji]; )
                      if (Q ? Ee(Mt, mn) : Mt.nodeType === 1)
                        return !1;
                    xi = ji = Oe === "only" && !xi && "nextSibling";
                  }
                  return !0;
                }
                if (xi = [Ze ? Nn.firstChild : Nn.lastChild], Ze && _r) {
                  for (gt = Nn[Bt] || (Nn[Bt] = {}), ht = gt[Oe] || [], Wt = ht[0] === ct && ht[1], jn = Wt && ht[2], Mt = Wt && Nn.childNodes[Wt]; Mt = ++Wt && Mt && Mt[ji] || // Fallback to seeking `elem` from the start
                  (jn = Wt = 0) || xi.pop(); )
                    if (Mt.nodeType === 1 && ++jn && Mt === oe) {
                      gt[Oe] = [ct, Wt, jn];
                      break;
                    }
                } else if (_r && (gt = oe[Bt] || (oe[Bt] = {}), ht = gt[Oe] || [], Wt = ht[0] === ct && ht[1], jn = Wt), jn === !1)
                  for (; (Mt = ++Wt && Mt && Mt[ji] || (jn = Wt = 0) || xi.pop()) && !((Q ? Ee(Mt, mn) : Mt.nodeType === 1) && ++jn && (_r && (gt = Mt[Bt] || (Mt[Bt] = {}), gt[Oe] = [ct, jn]), Mt === oe)); )
                    ;
                return jn -= Tt, jn === St || jn % St === 0 && jn / St >= 0;
              }
            };
          },
          PSEUDO: function(Oe, Ke) {
            var mt, St = N.pseudos[Oe] || N.setFilters[Oe.toLowerCase()] || Ei.error("unsupported pseudo: " + Oe);
            return St[Bt] ? St(Ke) : St.length > 1 ? (mt = [Oe, Oe, "", Ke], N.setFilters.hasOwnProperty(Oe.toLowerCase()) ? di(function(Tt, Ne) {
              for (var Ze, Q = St(Tt, Ke), oe = Q.length; oe--; )
                Ze = m.call(Tt, Q[oe]), Tt[Ze] = !(Ne[Ze] = Q[oe]);
            }) : function(Tt) {
              return St(Tt, 0, mt);
            }) : St;
          }
        },
        pseudos: {
          // Potentially complex pseudos
          not: di(function(Oe) {
            var Ke = [], mt = [], St = bs(Oe.replace(ce, "$1"));
            return St[Bt] ? di(function(Tt, Ne, Ze, Q) {
              for (var oe, Me = St(Tt, null, Q, []), Be = Tt.length; Be--; )
                (oe = Me[Be]) && (Tt[Be] = !(Ne[Be] = oe));
            }) : function(Tt, Ne, Ze) {
              return Ke[0] = Tt, St(Ke, null, Ze, mt), Ke[0] = null, !mt.pop();
            };
          }),
          has: di(function(Oe) {
            return function(Ke) {
              return Ei(Oe, Ke).length > 0;
            };
          }),
          contains: di(function(Oe) {
            return Oe = Oe.replace(Ai, hn), function(Ke) {
              return (Ke.textContent || W.text(Ke)).indexOf(Oe) > -1;
            };
          }),
          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // https://www.w3.org/TR/selectors/#lang-pseudo
          lang: di(function(Oe) {
            return Tr.test(Oe || "") || Ei.error("unsupported lang: " + Oe), Oe = Oe.replace(Ai, hn).toLowerCase(), function(Ke) {
              var mt;
              do
                if (mt = De ? Ke.lang : Ke.getAttribute("xml:lang") || Ke.getAttribute("lang"))
                  return mt = mt.toLowerCase(), mt === Oe || mt.indexOf(Oe + "-") === 0;
              while ((Ke = Ke.parentNode) && Ke.nodeType === 1);
              return !1;
            };
          }),
          // Miscellaneous
          target: function(Oe) {
            var Ke = e.location && e.location.hash;
            return Ke && Ke.slice(1) === Oe.id;
          },
          root: function(Oe) {
            return Oe === Ue;
          },
          focus: function(Oe) {
            return Oe === _i() && xe.hasFocus() && !!(Oe.type || Oe.href || ~Oe.tabIndex);
          },
          // Boolean properties
          enabled: Kr(!1),
          disabled: Kr(!0),
          checked: function(Oe) {
            return Ee(Oe, "input") && !!Oe.checked || Ee(Oe, "option") && !!Oe.selected;
          },
          selected: function(Oe) {
            return Oe.parentNode && Oe.parentNode.selectedIndex, Oe.selected === !0;
          },
          // Contents
          empty: function(Oe) {
            for (Oe = Oe.firstChild; Oe; Oe = Oe.nextSibling)
              if (Oe.nodeType < 6)
                return !1;
            return !0;
          },
          parent: function(Oe) {
            return !N.pseudos.empty(Oe);
          },
          // Element/input types
          header: function(Oe) {
            return Zn.test(Oe.nodeName);
          },
          input: function(Oe) {
            return ei.test(Oe.nodeName);
          },
          button: function(Oe) {
            return Ee(Oe, "input") && Oe.type === "button" || Ee(Oe, "button");
          },
          text: function(Oe) {
            var Ke;
            return Ee(Oe, "input") && Oe.type === "text" && // Support: IE <10 only
            // New HTML5 attribute values (e.g., "search") appear
            // with elem.type === "text"
            ((Ke = Oe.getAttribute("type")) == null || Ke.toLowerCase() === "text");
          },
          // Position-in-collection
          first: Ur(function() {
            return [0];
          }),
          last: Ur(function(Oe, Ke) {
            return [Ke - 1];
          }),
          eq: Ur(function(Oe, Ke, mt) {
            return [mt < 0 ? mt + Ke : mt];
          }),
          even: Ur(function(Oe, Ke) {
            for (var mt = 0; mt < Ke; mt += 2)
              Oe.push(mt);
            return Oe;
          }),
          odd: Ur(function(Oe, Ke) {
            for (var mt = 1; mt < Ke; mt += 2)
              Oe.push(mt);
            return Oe;
          }),
          lt: Ur(function(Oe, Ke, mt) {
            var St;
            for (mt < 0 ? St = mt + Ke : mt > Ke ? St = Ke : St = mt; --St >= 0; )
              Oe.push(St);
            return Oe;
          }),
          gt: Ur(function(Oe, Ke, mt) {
            for (var St = mt < 0 ? mt + Ke : mt; ++St < Ke; )
              Oe.push(St);
            return Oe;
          })
        }
      }, N.pseudos.nth = N.pseudos.eq;
      for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        N.pseudos[w] = Fr(w);
      for (w in { submit: !0, reset: !0 })
        N.pseudos[w] = Js(w);
      function hr() {
      }
      hr.prototype = N.filters = N.pseudos, N.setFilters = new hr();
      function tr(Oe, Ke) {
        var mt, St, Tt, Ne, Ze, Q, oe, Me = ai[Oe + " "];
        if (Me)
          return Ke ? 0 : Me.slice(0);
        for (Ze = Oe, Q = [], oe = N.preFilter; Ze; ) {
          (!mt || (St = en.exec(Ze))) && (St && (Ze = Ze.slice(St[0].length) || Ze), Q.push(Tt = [])), mt = !1, (St = lr.exec(Ze)) && (mt = St.shift(), Tt.push({
            value: mt,
            // Cast descendant combinators to space
            type: St[0].replace(ce, " ")
          }), Ze = Ze.slice(mt.length));
          for (Ne in N.filter)
            (St = Yn[Ne].exec(Ze)) && (!oe[Ne] || (St = oe[Ne](St))) && (mt = St.shift(), Tt.push({
              value: mt,
              type: Ne,
              matches: St
            }), Ze = Ze.slice(mt.length));
          if (!mt)
            break;
        }
        return Ke ? Ze.length : Ze ? Ei.error(Oe) : (
          // Cache the tokens
          ai(Oe, Q).slice(0)
        );
      }
      function Vr(Oe) {
        for (var Ke = 0, mt = Oe.length, St = ""; Ke < mt; Ke++)
          St += Oe[Ke].value;
        return St;
      }
      function $n(Oe, Ke, mt) {
        var St = Ke.dir, Tt = Ke.next, Ne = Tt || St, Ze = mt && Ne === "parentNode", Q = Ft++;
        return Ke.first ? (
          // Check against closest ancestor/preceding element
          function(oe, Me, Be) {
            for (; oe = oe[St]; )
              if (oe.nodeType === 1 || Ze)
                return Oe(oe, Me, Be);
            return !1;
          }
        ) : (
          // Check against all ancestor/preceding elements
          function(oe, Me, Be) {
            var ht, gt, Mt = [ct, Q];
            if (Be) {
              for (; oe = oe[St]; )
                if ((oe.nodeType === 1 || Ze) && Oe(oe, Me, Be))
                  return !0;
            } else
              for (; oe = oe[St]; )
                if (oe.nodeType === 1 || Ze)
                  if (gt = oe[Bt] || (oe[Bt] = {}), Tt && Ee(oe, Tt))
                    oe = oe[St] || oe;
                  else {
                    if ((ht = gt[Ne]) && ht[0] === ct && ht[1] === Q)
                      return Mt[2] = ht[2];
                    if (gt[Ne] = Mt, Mt[2] = Oe(oe, Me, Be))
                      return !0;
                  }
            return !1;
          }
        );
      }
      function Ri(Oe) {
        return Oe.length > 1 ? function(Ke, mt, St) {
          for (var Tt = Oe.length; Tt--; )
            if (!Oe[Tt](Ke, mt, St))
              return !1;
          return !0;
        } : Oe[0];
      }
      function hs(Oe, Ke, mt) {
        for (var St = 0, Tt = Ke.length; St < Tt; St++)
          Ei(Oe, Ke[St], mt);
        return mt;
      }
      function ys(Oe, Ke, mt, St, Tt) {
        for (var Ne, Ze = [], Q = 0, oe = Oe.length, Me = Ke != null; Q < oe; Q++)
          (Ne = Oe[Q]) && (!mt || mt(Ne, St, Tt)) && (Ze.push(Ne), Me && Ke.push(Q));
        return Ze;
      }
      function Ls(Oe, Ke, mt, St, Tt, Ne) {
        return St && !St[Bt] && (St = Ls(St)), Tt && !Tt[Bt] && (Tt = Ls(Tt, Ne)), di(function(Ze, Q, oe, Me) {
          var Be, ht, gt, Mt, Wt = [], xi = [], ji = Q.length, Nn = Ze || hs(
            Ke || "*",
            oe.nodeType ? [oe] : oe,
            []
          ), mn = Oe && (Ze || !Ke) ? ys(Nn, Wt, Oe, oe, Me) : Nn;
          if (mt ? (Mt = Tt || (Ze ? Oe : ji || St) ? (
            // ...intermediate processing is necessary
            []
          ) : (
            // ...otherwise use results directly
            Q
          ), mt(mn, Mt, oe, Me)) : Mt = mn, St)
            for (Be = ys(Mt, xi), St(Be, [], oe, Me), ht = Be.length; ht--; )
              (gt = Be[ht]) && (Mt[xi[ht]] = !(mn[xi[ht]] = gt));
          if (Ze) {
            if (Tt || Oe) {
              if (Tt) {
                for (Be = [], ht = Mt.length; ht--; )
                  (gt = Mt[ht]) && Be.push(mn[ht] = gt);
                Tt(null, Mt = [], Be, Me);
              }
              for (ht = Mt.length; ht--; )
                (gt = Mt[ht]) && (Be = Tt ? m.call(Ze, gt) : Wt[ht]) > -1 && (Ze[Be] = !(Q[Be] = gt));
            }
          } else
            Mt = ys(
              Mt === Q ? Mt.splice(ji, Mt.length) : Mt
            ), Tt ? Tt(null, Q, Mt, Me) : _e.apply(Q, Mt);
        });
      }
      function Jn(Oe) {
        for (var Ke, mt, St, Tt = Oe.length, Ne = N.relative[Oe[0].type], Ze = Ne || N.relative[" "], Q = Ne ? 1 : 0, oe = $n(function(ht) {
          return ht === Ke;
        }, Ze, !0), Me = $n(function(ht) {
          return m.call(Ke, ht) > -1;
        }, Ze, !0), Be = [function(ht, gt, Mt) {
          var Wt = !Ne && (Mt || gt != ee) || ((Ke = gt).nodeType ? oe(ht, gt, Mt) : Me(ht, gt, Mt));
          return Ke = null, Wt;
        }]; Q < Tt; Q++)
          if (mt = N.relative[Oe[Q].type])
            Be = [$n(Ri(Be), mt)];
          else {
            if (mt = N.filter[Oe[Q].type].apply(null, Oe[Q].matches), mt[Bt]) {
              for (St = ++Q; St < Tt && !N.relative[Oe[St].type]; St++)
                ;
              return Ls(
                Q > 1 && Ri(Be),
                Q > 1 && Vr(
                  // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                  Oe.slice(0, Q - 1).concat({ value: Oe[Q - 2].type === " " ? "*" : "" })
                ).replace(ce, "$1"),
                mt,
                Q < St && Jn(Oe.slice(Q, St)),
                St < Tt && Jn(Oe = Oe.slice(St)),
                St < Tt && Vr(Oe)
              );
            }
            Be.push(mt);
          }
        return Ri(Be);
      }
      function zn(Oe, Ke) {
        var mt = Ke.length > 0, St = Oe.length > 0, Tt = function(Ne, Ze, Q, oe, Me) {
          var Be, ht, gt, Mt = 0, Wt = "0", xi = Ne && [], ji = [], Nn = ee, mn = Ne || St && N.find.TAG("*", Me), _r = ct += Nn == null ? 1 : Math.random() || 0.1, jn = mn.length;
          for (Me && (ee = Ze == xe || Ze || Me); Wt !== jn && (Be = mn[Wt]) != null; Wt++) {
            if (St && Be) {
              for (ht = 0, !Ze && Be.ownerDocument != xe && (Pn(Be), Q = !De); gt = Oe[ht++]; )
                if (gt(Be, Ze || xe, Q)) {
                  _e.call(oe, Be);
                  break;
                }
              Me && (ct = _r);
            }
            mt && ((Be = !gt && Be) && Mt--, Ne && xi.push(Be));
          }
          if (Mt += Wt, mt && Wt !== Mt) {
            for (ht = 0; gt = Ke[ht++]; )
              gt(xi, ji, Ze, Q);
            if (Ne) {
              if (Mt > 0)
                for (; Wt--; )
                  xi[Wt] || ji[Wt] || (ji[Wt] = He.call(oe));
              ji = ys(ji);
            }
            _e.apply(oe, ji), Me && !Ne && ji.length > 0 && Mt + Ke.length > 1 && W.uniqueSort(oe);
          }
          return Me && (ct = _r, ee = Nn), xi;
        };
        return mt ? di(Tt) : Tt;
      }
      function bs(Oe, Ke) {
        var mt, St = [], Tt = [], Ne = mi[Oe + " "];
        if (!Ne) {
          for (Ke || (Ke = tr(Oe)), mt = Ke.length; mt--; )
            Ne = Jn(Ke[mt]), Ne[Bt] ? St.push(Ne) : Tt.push(Ne);
          Ne = mi(
            Oe,
            zn(Tt, St)
          ), Ne.selector = Oe;
        }
        return Ne;
      }
      function ur(Oe, Ke, mt, St) {
        var Tt, Ne, Ze, Q, oe, Me = typeof Oe == "function" && Oe, Be = !St && tr(Oe = Me.selector || Oe);
        if (mt = mt || [], Be.length === 1) {
          if (Ne = Be[0] = Be[0].slice(0), Ne.length > 2 && (Ze = Ne[0]).type === "ID" && Ke.nodeType === 9 && De && N.relative[Ne[1].type]) {
            if (Ke = (N.find.ID(
              Ze.matches[0].replace(Ai, hn),
              Ke
            ) || [])[0], Ke)
              Me && (Ke = Ke.parentNode);
            else
              return mt;
            Oe = Oe.slice(Ne.shift().value.length);
          }
          for (Tt = Yn.needsContext.test(Oe) ? 0 : Ne.length; Tt-- && (Ze = Ne[Tt], !N.relative[Q = Ze.type]); )
            if ((oe = N.find[Q]) && (St = oe(
              Ze.matches[0].replace(Ai, hn),
              zr.test(Ne[0].type) && Ji(Ke.parentNode) || Ke
            ))) {
              if (Ne.splice(Tt, 1), Oe = St.length && Vr(Ne), !Oe)
                return _e.apply(mt, St), mt;
              break;
            }
        }
        return (Me || bs(Oe, Be))(
          St,
          Ke,
          !De,
          mt,
          !Ke || zr.test(Oe) && Ji(Ke.parentNode) || Ke
        ), mt;
      }
      Z.sortStable = Bt.split("").sort(wn).join("") === Bt, Pn(), Z.sortDetached = un(function(Oe) {
        return Oe.compareDocumentPosition(xe.createElement("fieldset")) & 1;
      }), W.find = Ei, W.expr[":"] = W.expr.pseudos, W.unique = W.uniqueSort, Ei.compile = bs, Ei.select = ur, Ei.setDocument = Pn, Ei.tokenize = tr, Ei.escape = W.escapeSelector, Ei.getText = W.text, Ei.isXML = W.isXMLDoc, Ei.selectors = W.expr, Ei.support = W.support, Ei.uniqueSort = W.uniqueSort;
    })();
    var We = function(w, N, ee) {
      for (var re = [], ge = ee !== void 0; (w = w[N]) && w.nodeType !== 9; )
        if (w.nodeType === 1) {
          if (ge && W(w).is(ee))
            break;
          re.push(w);
        }
      return re;
    }, Et = function(w, N) {
      for (var ee = []; w; w = w.nextSibling)
        w.nodeType === 1 && w !== N && ee.push(w);
      return ee;
    }, rt = W.expr.match.needsContext, it = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function Zt(w, N, ee) {
      return V(N) ? W.grep(w, function(re, ge) {
        return !!N.call(re, ge, re) !== ee;
      }) : N.nodeType ? W.grep(w, function(re) {
        return re === N !== ee;
      }) : typeof N != "string" ? W.grep(w, function(re) {
        return m.call(N, re) > -1 !== ee;
      }) : W.filter(N, w, ee);
    }
    W.filter = function(w, N, ee) {
      var re = N[0];
      return ee && (w = ":not(" + w + ")"), N.length === 1 && re.nodeType === 1 ? W.find.matchesSelector(re, w) ? [re] : [] : W.find.matches(w, W.grep(N, function(ge) {
        return ge.nodeType === 1;
      }));
    }, W.fn.extend({
      find: function(w) {
        var N, ee, re = this.length, ge = this;
        if (typeof w != "string")
          return this.pushStack(W(w).filter(function() {
            for (N = 0; N < re; N++)
              if (W.contains(ge[N], this))
                return !0;
          }));
        for (ee = this.pushStack([]), N = 0; N < re; N++)
          W.find(w, ge[N], ee);
        return re > 1 ? W.uniqueSort(ee) : ee;
      },
      filter: function(w) {
        return this.pushStack(Zt(this, w || [], !1));
      },
      not: function(w) {
        return this.pushStack(Zt(this, w || [], !0));
      },
      is: function(w) {
        return !!Zt(
          this,
          // If this is a positional/relative selector, check membership in the returned set
          // so $("p:first").is("p:last") won't return true for a doc with two "p".
          typeof w == "string" && rt.test(w) ? W(w) : w || [],
          !1
        ).length;
      }
    });
    var $t, Lt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, ii = W.fn.init = function(w, N, ee) {
      var re, ge;
      if (!w)
        return this;
      if (ee = ee || $t, typeof w == "string")
        if (w[0] === "<" && w[w.length - 1] === ">" && w.length >= 3 ? re = [null, w, null] : re = Lt.exec(w), re && (re[1] || !N))
          if (re[1]) {
            if (N = N instanceof W ? N[0] : N, W.merge(this, W.parseHTML(
              re[1],
              N && N.nodeType ? N.ownerDocument || N : P,
              !0
            )), it.test(re[1]) && W.isPlainObject(N))
              for (re in N)
                V(this[re]) ? this[re](N[re]) : this.attr(re, N[re]);
            return this;
          } else
            return ge = P.getElementById(re[2]), ge && (this[0] = ge, this.length = 1), this;
        else
          return !N || N.jquery ? (N || ee).find(w) : this.constructor(N).find(w);
      else {
        if (w.nodeType)
          return this[0] = w, this.length = 1, this;
        if (V(w))
          return ee.ready !== void 0 ? ee.ready(w) : (
            // Execute immediately if ready is not present
            w(W)
          );
      }
      return W.makeArray(w, this);
    };
    ii.prototype = W.fn, $t = W(P);
    var Ci = /^(?:parents|prev(?:Until|All))/, ui = {
      children: !0,
      contents: !0,
      next: !0,
      prev: !0
    };
    W.fn.extend({
      has: function(w) {
        var N = W(w, this), ee = N.length;
        return this.filter(function() {
          for (var re = 0; re < ee; re++)
            if (W.contains(this, N[re]))
              return !0;
        });
      },
      closest: function(w, N) {
        var ee, re = 0, ge = this.length, _e = [], xe = typeof w != "string" && W(w);
        if (!rt.test(w)) {
          for (; re < ge; re++)
            for (ee = this[re]; ee && ee !== N; ee = ee.parentNode)
              if (ee.nodeType < 11 && (xe ? xe.index(ee) > -1 : (
                // Don't pass non-elements to jQuery#find
                ee.nodeType === 1 && W.find.matchesSelector(ee, w)
              ))) {
                _e.push(ee);
                break;
              }
        }
        return this.pushStack(_e.length > 1 ? W.uniqueSort(_e) : _e);
      },
      // Determine the position of an element within the set
      index: function(w) {
        return w ? typeof w == "string" ? m.call(W(w), this[0]) : m.call(
          this,
          // If it receives a jQuery object, the first element is used
          w.jquery ? w[0] : w
        ) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      },
      add: function(w, N) {
        return this.pushStack(
          W.uniqueSort(
            W.merge(this.get(), W(w, N))
          )
        );
      },
      addBack: function(w) {
        return this.add(
          w == null ? this.prevObject : this.prevObject.filter(w)
        );
      }
    });
    function Gt(w, N) {
      for (; (w = w[N]) && w.nodeType !== 1; )
        ;
      return w;
    }
    W.each({
      parent: function(w) {
        var N = w.parentNode;
        return N && N.nodeType !== 11 ? N : null;
      },
      parents: function(w) {
        return We(w, "parentNode");
      },
      parentsUntil: function(w, N, ee) {
        return We(w, "parentNode", ee);
      },
      next: function(w) {
        return Gt(w, "nextSibling");
      },
      prev: function(w) {
        return Gt(w, "previousSibling");
      },
      nextAll: function(w) {
        return We(w, "nextSibling");
      },
      prevAll: function(w) {
        return We(w, "previousSibling");
      },
      nextUntil: function(w, N, ee) {
        return We(w, "nextSibling", ee);
      },
      prevUntil: function(w, N, ee) {
        return We(w, "previousSibling", ee);
      },
      siblings: function(w) {
        return Et((w.parentNode || {}).firstChild, w);
      },
      children: function(w) {
        return Et(w.firstChild);
      },
      contents: function(w) {
        return w.contentDocument != null && // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        s(w.contentDocument) ? w.contentDocument : (Ee(w, "template") && (w = w.content || w), W.merge([], w.childNodes));
      }
    }, function(w, N) {
      W.fn[w] = function(ee, re) {
        var ge = W.map(this, N, ee);
        return w.slice(-5) !== "Until" && (re = ee), re && typeof re == "string" && (ge = W.filter(re, ge)), this.length > 1 && (ui[w] || W.uniqueSort(ge), Ci.test(w) && ge.reverse()), this.pushStack(ge);
      };
    });
    var Xt = /[^\x20\t\r\n\f]+/g;
    function Qt(w) {
      var N = {};
      return W.each(w.match(Xt) || [], function(ee, re) {
        N[re] = !0;
      }), N;
    }
    W.Callbacks = function(w) {
      w = typeof w == "string" ? Qt(w) : W.extend({}, w);
      var N, ee, re, ge, _e = [], xe = [], Ue = -1, De = function() {
        for (ge = ge || w.once, re = N = !0; xe.length; Ue = -1)
          for (ee = xe.shift(); ++Ue < _e.length; )
            _e[Ue].apply(ee[0], ee[1]) === !1 && w.stopOnFalse && (Ue = _e.length, ee = !1);
        w.memory || (ee = !1), N = !1, ge && (ee ? _e = [] : _e = "");
      }, qe = {
        // Add a callback or a collection of callbacks to the list
        add: function() {
          return _e && (ee && !N && (Ue = _e.length - 1, xe.push(ee)), function At(Bt) {
            W.each(Bt, function(ct, Ft) {
              V(Ft) ? (!w.unique || !qe.has(Ft)) && _e.push(Ft) : Ft && Ft.length && le(Ft) !== "string" && At(Ft);
            });
          }(arguments), ee && !N && De()), this;
        },
        // Remove a callback from the list
        remove: function() {
          return W.each(arguments, function(At, Bt) {
            for (var ct; (ct = W.inArray(Bt, _e, ct)) > -1; )
              _e.splice(ct, 1), ct <= Ue && Ue--;
          }), this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function(At) {
          return At ? W.inArray(At, _e) > -1 : _e.length > 0;
        },
        // Remove all callbacks from the list
        empty: function() {
          return _e && (_e = []), this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function() {
          return ge = xe = [], _e = ee = "", this;
        },
        disabled: function() {
          return !_e;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function() {
          return ge = xe = [], !ee && !N && (_e = ee = ""), this;
        },
        locked: function() {
          return !!ge;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function(At, Bt) {
          return ge || (Bt = Bt || [], Bt = [At, Bt.slice ? Bt.slice() : Bt], xe.push(Bt), N || De()), this;
        },
        // Call all the callbacks with the given arguments
        fire: function() {
          return qe.fireWith(this, arguments), this;
        },
        // To know if the callbacks have already been called at least once
        fired: function() {
          return !!re;
        }
      };
      return qe;
    };
    function Ni(w) {
      return w;
    }
    function Di(w) {
      throw w;
    }
    function pe(w, N, ee, re) {
      var ge;
      try {
        w && V(ge = w.promise) ? ge.call(w).done(N).fail(ee) : w && V(ge = w.then) ? ge.call(w, N, ee) : N.apply(void 0, [w].slice(re));
      } catch (_e) {
        ee.apply(void 0, [_e]);
      }
    }
    W.extend({
      Deferred: function(w) {
        var N = [
          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          [
            "notify",
            "progress",
            W.Callbacks("memory"),
            W.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            W.Callbacks("once memory"),
            W.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            W.Callbacks("once memory"),
            W.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ], ee = "pending", re = {
          state: function() {
            return ee;
          },
          always: function() {
            return ge.done(arguments).fail(arguments), this;
          },
          catch: function(_e) {
            return re.then(null, _e);
          },
          // Keep pipe for back-compat
          pipe: function() {
            var _e = arguments;
            return W.Deferred(function(xe) {
              W.each(N, function(Ue, De) {
                var qe = V(_e[De[4]]) && _e[De[4]];
                ge[De[1]](function() {
                  var At = qe && qe.apply(this, arguments);
                  At && V(At.promise) ? At.promise().progress(xe.notify).done(xe.resolve).fail(xe.reject) : xe[De[0] + "With"](
                    this,
                    qe ? [At] : arguments
                  );
                });
              }), _e = null;
            }).promise();
          },
          then: function(_e, xe, Ue) {
            var De = 0;
            function qe(At, Bt, ct, Ft) {
              return function() {
                var pi = this, ai = arguments, mi = function() {
                  var wn, an;
                  if (!(At < De)) {
                    if (wn = ct.apply(pi, ai), wn === Bt.promise())
                      throw new TypeError("Thenable self-resolution");
                    an = wn && // Support: Promises/A+ section 2.3.4
                    // https://promisesaplus.com/#point-64
                    // Only check objects and functions for thenability
                    (typeof wn == "object" || typeof wn == "function") && wn.then, V(an) ? Ft ? an.call(
                      wn,
                      qe(De, Bt, Ni, Ft),
                      qe(De, Bt, Di, Ft)
                    ) : (De++, an.call(
                      wn,
                      qe(De, Bt, Ni, Ft),
                      qe(De, Bt, Di, Ft),
                      qe(
                        De,
                        Bt,
                        Ni,
                        Bt.notifyWith
                      )
                    )) : (ct !== Ni && (pi = void 0, ai = [wn]), (Ft || Bt.resolveWith)(pi, ai));
                  }
                }, xn = Ft ? mi : function() {
                  try {
                    mi();
                  } catch (wn) {
                    W.Deferred.exceptionHook && W.Deferred.exceptionHook(
                      wn,
                      xn.error
                    ), At + 1 >= De && (ct !== Di && (pi = void 0, ai = [wn]), Bt.rejectWith(pi, ai));
                  }
                };
                At ? xn() : (W.Deferred.getErrorHook ? xn.error = W.Deferred.getErrorHook() : W.Deferred.getStackHook && (xn.error = W.Deferred.getStackHook()), e.setTimeout(xn));
              };
            }
            return W.Deferred(function(At) {
              N[0][3].add(
                qe(
                  0,
                  At,
                  V(Ue) ? Ue : Ni,
                  At.notifyWith
                )
              ), N[1][3].add(
                qe(
                  0,
                  At,
                  V(_e) ? _e : Ni
                )
              ), N[2][3].add(
                qe(
                  0,
                  At,
                  V(xe) ? xe : Di
                )
              );
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function(_e) {
            return _e != null ? W.extend(_e, re) : re;
          }
        }, ge = {};
        return W.each(N, function(_e, xe) {
          var Ue = xe[2], De = xe[5];
          re[xe[1]] = Ue.add, De && Ue.add(
            function() {
              ee = De;
            },
            // rejected_callbacks.disable
            // fulfilled_callbacks.disable
            N[3 - _e][2].disable,
            // rejected_handlers.disable
            // fulfilled_handlers.disable
            N[3 - _e][3].disable,
            // progress_callbacks.lock
            N[0][2].lock,
            // progress_handlers.lock
            N[0][3].lock
          ), Ue.add(xe[3].fire), ge[xe[0]] = function() {
            return ge[xe[0] + "With"](this === ge ? void 0 : this, arguments), this;
          }, ge[xe[0] + "With"] = Ue.fireWith;
        }), re.promise(ge), w && w.call(ge, ge), ge;
      },
      // Deferred helper
      when: function(w) {
        var N = arguments.length, ee = N, re = Array(ee), ge = o.call(arguments), _e = W.Deferred(), xe = function(Ue) {
          return function(De) {
            re[Ue] = this, ge[Ue] = arguments.length > 1 ? o.call(arguments) : De, --N || _e.resolveWith(re, ge);
          };
        };
        if (N <= 1 && (pe(
          w,
          _e.done(xe(ee)).resolve,
          _e.reject,
          !N
        ), _e.state() === "pending" || V(ge[ee] && ge[ee].then)))
          return _e.then();
        for (; ee--; )
          pe(ge[ee], xe(ee), _e.reject);
        return _e.promise();
      }
    });
    var xt = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    W.Deferred.exceptionHook = function(w, N) {
      e.console && e.console.warn && w && xt.test(w.name) && e.console.warn(
        "jQuery.Deferred exception: " + w.message,
        w.stack,
        N
      );
    }, W.readyException = function(w) {
      e.setTimeout(function() {
        throw w;
      });
    };
    var tt = W.Deferred();
    W.fn.ready = function(w) {
      return tt.then(w).catch(function(N) {
        W.readyException(N);
      }), this;
    }, W.extend({
      // Is the DOM ready to be used? Set to true once it occurs.
      isReady: !1,
      // A counter to track how many items to wait for before
      // the ready event fires. See trac-6781
      readyWait: 1,
      // Handle when the DOM is ready
      ready: function(w) {
        (w === !0 ? --W.readyWait : W.isReady) || (W.isReady = !0, !(w !== !0 && --W.readyWait > 0) && tt.resolveWith(P, [W]));
      }
    }), W.ready.then = tt.then;
    function Pe() {
      P.removeEventListener("DOMContentLoaded", Pe), e.removeEventListener("load", Pe), W.ready();
    }
    P.readyState === "complete" || P.readyState !== "loading" && !P.documentElement.doScroll ? e.setTimeout(W.ready) : (P.addEventListener("DOMContentLoaded", Pe), e.addEventListener("load", Pe));
    var ke = function(w, N, ee, re, ge, _e, xe) {
      var Ue = 0, De = w.length, qe = ee == null;
      if (le(ee) === "object") {
        ge = !0;
        for (Ue in ee)
          ke(w, N, Ue, ee[Ue], !0, _e, xe);
      } else if (re !== void 0 && (ge = !0, V(re) || (xe = !0), qe && (xe ? (N.call(w, re), N = null) : (qe = N, N = function(At, Bt, ct) {
        return qe.call(W(At), ct);
      })), N))
        for (; Ue < De; Ue++)
          N(
            w[Ue],
            ee,
            xe ? re : re.call(w[Ue], Ue, N(w[Ue], ee))
          );
      return ge ? w : qe ? N.call(w) : De ? N(w[0], ee) : _e;
    }, Je = /^-ms-/, kt = /-([a-z])/g;
    function vt(w, N) {
      return N.toUpperCase();
    }
    function Qe(w) {
      return w.replace(Je, "ms-").replace(kt, vt);
    }
    var wt = function(w) {
      return w.nodeType === 1 || w.nodeType === 9 || !+w.nodeType;
    };
    function Yt() {
      this.expando = W.expando + Yt.uid++;
    }
    Yt.uid = 1, Yt.prototype = {
      cache: function(w) {
        var N = w[this.expando];
        return N || (N = {}, wt(w) && (w.nodeType ? w[this.expando] = N : Object.defineProperty(w, this.expando, {
          value: N,
          configurable: !0
        }))), N;
      },
      set: function(w, N, ee) {
        var re, ge = this.cache(w);
        if (typeof N == "string")
          ge[Qe(N)] = ee;
        else
          for (re in N)
            ge[Qe(re)] = N[re];
        return ge;
      },
      get: function(w, N) {
        return N === void 0 ? this.cache(w) : (
          // Always use camelCase key (gh-2257)
          w[this.expando] && w[this.expando][Qe(N)]
        );
      },
      access: function(w, N, ee) {
        return N === void 0 || N && typeof N == "string" && ee === void 0 ? this.get(w, N) : (this.set(w, N, ee), ee !== void 0 ? ee : N);
      },
      remove: function(w, N) {
        var ee, re = w[this.expando];
        if (re !== void 0) {
          if (N !== void 0)
            for (Array.isArray(N) ? N = N.map(Qe) : (N = Qe(N), N = N in re ? [N] : N.match(Xt) || []), ee = N.length; ee--; )
              delete re[N[ee]];
          (N === void 0 || W.isEmptyObject(re)) && (w.nodeType ? w[this.expando] = void 0 : delete w[this.expando]);
        }
      },
      hasData: function(w) {
        var N = w[this.expando];
        return N !== void 0 && !W.isEmptyObject(N);
      }
    };
    var Ye = new Yt(), i = new Yt(), r = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, a = /[A-Z]/g;
    function l(w) {
      return w === "true" ? !0 : w === "false" ? !1 : w === "null" ? null : w === +w + "" ? +w : r.test(w) ? JSON.parse(w) : w;
    }
    function u(w, N, ee) {
      var re;
      if (ee === void 0 && w.nodeType === 1)
        if (re = "data-" + N.replace(a, "-$&").toLowerCase(), ee = w.getAttribute(re), typeof ee == "string") {
          try {
            ee = l(ee);
          } catch {
          }
          i.set(w, N, ee);
        } else
          ee = void 0;
      return ee;
    }
    W.extend({
      hasData: function(w) {
        return i.hasData(w) || Ye.hasData(w);
      },
      data: function(w, N, ee) {
        return i.access(w, N, ee);
      },
      removeData: function(w, N) {
        i.remove(w, N);
      },
      // TODO: Now that all calls to _data and _removeData have been replaced
      // with direct calls to dataPriv methods, these can be deprecated.
      _data: function(w, N, ee) {
        return Ye.access(w, N, ee);
      },
      _removeData: function(w, N) {
        Ye.remove(w, N);
      }
    }), W.fn.extend({
      data: function(w, N) {
        var ee, re, ge, _e = this[0], xe = _e && _e.attributes;
        if (w === void 0) {
          if (this.length && (ge = i.get(_e), _e.nodeType === 1 && !Ye.get(_e, "hasDataAttrs"))) {
            for (ee = xe.length; ee--; )
              xe[ee] && (re = xe[ee].name, re.indexOf("data-") === 0 && (re = Qe(re.slice(5)), u(_e, re, ge[re])));
            Ye.set(_e, "hasDataAttrs", !0);
          }
          return ge;
        }
        return typeof w == "object" ? this.each(function() {
          i.set(this, w);
        }) : ke(this, function(Ue) {
          var De;
          if (_e && Ue === void 0)
            return De = i.get(_e, w), De !== void 0 || (De = u(_e, w), De !== void 0) ? De : void 0;
          this.each(function() {
            i.set(this, w, Ue);
          });
        }, null, N, arguments.length > 1, null, !0);
      },
      removeData: function(w) {
        return this.each(function() {
          i.remove(this, w);
        });
      }
    }), W.extend({
      queue: function(w, N, ee) {
        var re;
        if (w)
          return N = (N || "fx") + "queue", re = Ye.get(w, N), ee && (!re || Array.isArray(ee) ? re = Ye.access(w, N, W.makeArray(ee)) : re.push(ee)), re || [];
      },
      dequeue: function(w, N) {
        N = N || "fx";
        var ee = W.queue(w, N), re = ee.length, ge = ee.shift(), _e = W._queueHooks(w, N), xe = function() {
          W.dequeue(w, N);
        };
        ge === "inprogress" && (ge = ee.shift(), re--), ge && (N === "fx" && ee.unshift("inprogress"), delete _e.stop, ge.call(w, xe, _e)), !re && _e && _e.empty.fire();
      },
      // Not public - generate a queueHooks object, or return the current one
      _queueHooks: function(w, N) {
        var ee = N + "queueHooks";
        return Ye.get(w, ee) || Ye.access(w, ee, {
          empty: W.Callbacks("once memory").add(function() {
            Ye.remove(w, [N + "queue", ee]);
          })
        });
      }
    }), W.fn.extend({
      queue: function(w, N) {
        var ee = 2;
        return typeof w != "string" && (N = w, w = "fx", ee--), arguments.length < ee ? W.queue(this[0], w) : N === void 0 ? this : this.each(function() {
          var re = W.queue(this, w, N);
          W._queueHooks(this, w), w === "fx" && re[0] !== "inprogress" && W.dequeue(this, w);
        });
      },
      dequeue: function(w) {
        return this.each(function() {
          W.dequeue(this, w);
        });
      },
      clearQueue: function(w) {
        return this.queue(w || "fx", []);
      },
      // Get a promise resolved when queues of a certain type
      // are emptied (fx is the type by default)
      promise: function(w, N) {
        var ee, re = 1, ge = W.Deferred(), _e = this, xe = this.length, Ue = function() {
          --re || ge.resolveWith(_e, [_e]);
        };
        for (typeof w != "string" && (N = w, w = void 0), w = w || "fx"; xe--; )
          ee = Ye.get(_e[xe], w + "queueHooks"), ee && ee.empty && (re++, ee.empty.add(Ue));
        return Ue(), ge.promise(N);
      }
    });
    var d = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, v = new RegExp("^(?:([+-])=|)(" + d + ")([a-z%]*)$", "i"), p = ["Top", "Right", "Bottom", "Left"], b = P.documentElement, S = function(w) {
      return W.contains(w.ownerDocument, w);
    }, L = { composed: !0 };
    b.getRootNode && (S = function(w) {
      return W.contains(w.ownerDocument, w) || w.getRootNode(L) === w.ownerDocument;
    });
    var E = function(w, N) {
      return w = N || w, w.style.display === "none" || w.style.display === "" && // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      S(w) && W.css(w, "display") === "none";
    };
    function A(w, N, ee, re) {
      var ge, _e, xe = 20, Ue = re ? function() {
        return re.cur();
      } : function() {
        return W.css(w, N, "");
      }, De = Ue(), qe = ee && ee[3] || (W.cssNumber[N] ? "" : "px"), At = w.nodeType && (W.cssNumber[N] || qe !== "px" && +De) && v.exec(W.css(w, N));
      if (At && At[3] !== qe) {
        for (De = De / 2, qe = qe || At[3], At = +De || 1; xe--; )
          W.style(w, N, At + qe), (1 - _e) * (1 - (_e = Ue() / De || 0.5)) <= 0 && (xe = 0), At = At / _e;
        At = At * 2, W.style(w, N, At + qe), ee = ee || [];
      }
      return ee && (At = +At || +De || 0, ge = ee[1] ? At + (ee[1] + 1) * ee[2] : +ee[2], re && (re.unit = qe, re.start = At, re.end = ge)), ge;
    }
    var T = {};
    function G(w) {
      var N, ee = w.ownerDocument, re = w.nodeName, ge = T[re];
      return ge || (N = ee.body.appendChild(ee.createElement(re)), ge = W.css(N, "display"), N.parentNode.removeChild(N), ge === "none" && (ge = "block"), T[re] = ge, ge);
    }
    function D(w, N) {
      for (var ee, re, ge = [], _e = 0, xe = w.length; _e < xe; _e++)
        re = w[_e], re.style && (ee = re.style.display, N ? (ee === "none" && (ge[_e] = Ye.get(re, "display") || null, ge[_e] || (re.style.display = "")), re.style.display === "" && E(re) && (ge[_e] = G(re))) : ee !== "none" && (ge[_e] = "none", Ye.set(re, "display", ee)));
      for (_e = 0; _e < xe; _e++)
        ge[_e] != null && (w[_e].style.display = ge[_e]);
      return w;
    }
    W.fn.extend({
      show: function() {
        return D(this, !0);
      },
      hide: function() {
        return D(this);
      },
      toggle: function(w) {
        return typeof w == "boolean" ? w ? this.show() : this.hide() : this.each(function() {
          E(this) ? W(this).show() : W(this).hide();
        });
      }
    });
    var Y = /^(?:checkbox|radio)$/i, k = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, z = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
      var w = P.createDocumentFragment(), N = w.appendChild(P.createElement("div")), ee = P.createElement("input");
      ee.setAttribute("type", "radio"), ee.setAttribute("checked", "checked"), ee.setAttribute("name", "t"), N.appendChild(ee), Z.checkClone = N.cloneNode(!0).cloneNode(!0).lastChild.checked, N.innerHTML = "<textarea>x</textarea>", Z.noCloneChecked = !!N.cloneNode(!0).lastChild.defaultValue, N.innerHTML = "<option></option>", Z.option = !!N.lastChild;
    })();
    var C = {
      // XHTML parsers do not magically insert elements in the
      // same way that tag soup parsers do. So we cannot shorten
      // this by omitting <tbody> or other required elements.
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    C.tbody = C.tfoot = C.colgroup = C.caption = C.thead, C.th = C.td, Z.option || (C.optgroup = C.option = [1, "<select multiple='multiple'>", "</select>"]);
    function O(w, N) {
      var ee;
      return typeof w.getElementsByTagName < "u" ? ee = w.getElementsByTagName(N || "*") : typeof w.querySelectorAll < "u" ? ee = w.querySelectorAll(N || "*") : ee = [], N === void 0 || N && Ee(w, N) ? W.merge([w], ee) : ee;
    }
    function j(w, N) {
      for (var ee = 0, re = w.length; ee < re; ee++)
        Ye.set(
          w[ee],
          "globalEval",
          !N || Ye.get(N[ee], "globalEval")
        );
    }
    var q = /<|&#?\w+;/;
    function H(w, N, ee, re, ge) {
      for (var _e, xe, Ue, De, qe, At, Bt = N.createDocumentFragment(), ct = [], Ft = 0, pi = w.length; Ft < pi; Ft++)
        if (_e = w[Ft], _e || _e === 0)
          if (le(_e) === "object")
            W.merge(ct, _e.nodeType ? [_e] : _e);
          else if (!q.test(_e))
            ct.push(N.createTextNode(_e));
          else {
            for (xe = xe || Bt.appendChild(N.createElement("div")), Ue = (k.exec(_e) || ["", ""])[1].toLowerCase(), De = C[Ue] || C._default, xe.innerHTML = De[1] + W.htmlPrefilter(_e) + De[2], At = De[0]; At--; )
              xe = xe.lastChild;
            W.merge(ct, xe.childNodes), xe = Bt.firstChild, xe.textContent = "";
          }
      for (Bt.textContent = "", Ft = 0; _e = ct[Ft++]; ) {
        if (re && W.inArray(_e, re) > -1) {
          ge && ge.push(_e);
          continue;
        }
        if (qe = S(_e), xe = O(Bt.appendChild(_e), "script"), qe && j(xe), ee)
          for (At = 0; _e = xe[At++]; )
            z.test(_e.type || "") && ee.push(_e);
      }
      return Bt;
    }
    var ie = /^([^.]*)(?:\.(.+)|)/;
    function ae() {
      return !0;
    }
    function ue() {
      return !1;
    }
    function me(w, N, ee, re, ge, _e) {
      var xe, Ue;
      if (typeof N == "object") {
        typeof ee != "string" && (re = re || ee, ee = void 0);
        for (Ue in N)
          me(w, Ue, ee, re, N[Ue], _e);
        return w;
      }
      if (re == null && ge == null ? (ge = ee, re = ee = void 0) : ge == null && (typeof ee == "string" ? (ge = re, re = void 0) : (ge = re, re = ee, ee = void 0)), ge === !1)
        ge = ue;
      else if (!ge)
        return w;
      return _e === 1 && (xe = ge, ge = function(De) {
        return W().off(De), xe.apply(this, arguments);
      }, ge.guid = xe.guid || (xe.guid = W.guid++)), w.each(function() {
        W.event.add(this, N, ge, re, ee);
      });
    }
    W.event = {
      global: {},
      add: function(w, N, ee, re, ge) {
        var _e, xe, Ue, De, qe, At, Bt, ct, Ft, pi, ai, mi = Ye.get(w);
        if (wt(w))
          for (ee.handler && (_e = ee, ee = _e.handler, ge = _e.selector), ge && W.find.matchesSelector(b, ge), ee.guid || (ee.guid = W.guid++), (De = mi.events) || (De = mi.events = /* @__PURE__ */ Object.create(null)), (xe = mi.handle) || (xe = mi.handle = function(xn) {
            return typeof W < "u" && W.event.triggered !== xn.type ? W.event.dispatch.apply(w, arguments) : void 0;
          }), N = (N || "").match(Xt) || [""], qe = N.length; qe--; )
            Ue = ie.exec(N[qe]) || [], Ft = ai = Ue[1], pi = (Ue[2] || "").split(".").sort(), Ft && (Bt = W.event.special[Ft] || {}, Ft = (ge ? Bt.delegateType : Bt.bindType) || Ft, Bt = W.event.special[Ft] || {}, At = W.extend({
              type: Ft,
              origType: ai,
              data: re,
              handler: ee,
              guid: ee.guid,
              selector: ge,
              needsContext: ge && W.expr.match.needsContext.test(ge),
              namespace: pi.join(".")
            }, _e), (ct = De[Ft]) || (ct = De[Ft] = [], ct.delegateCount = 0, (!Bt.setup || Bt.setup.call(w, re, pi, xe) === !1) && w.addEventListener && w.addEventListener(Ft, xe)), Bt.add && (Bt.add.call(w, At), At.handler.guid || (At.handler.guid = ee.guid)), ge ? ct.splice(ct.delegateCount++, 0, At) : ct.push(At), W.event.global[Ft] = !0);
      },
      // Detach an event or set of events from an element
      remove: function(w, N, ee, re, ge) {
        var _e, xe, Ue, De, qe, At, Bt, ct, Ft, pi, ai, mi = Ye.hasData(w) && Ye.get(w);
        if (!(!mi || !(De = mi.events))) {
          for (N = (N || "").match(Xt) || [""], qe = N.length; qe--; ) {
            if (Ue = ie.exec(N[qe]) || [], Ft = ai = Ue[1], pi = (Ue[2] || "").split(".").sort(), !Ft) {
              for (Ft in De)
                W.event.remove(w, Ft + N[qe], ee, re, !0);
              continue;
            }
            for (Bt = W.event.special[Ft] || {}, Ft = (re ? Bt.delegateType : Bt.bindType) || Ft, ct = De[Ft] || [], Ue = Ue[2] && new RegExp("(^|\\.)" + pi.join("\\.(?:.*\\.|)") + "(\\.|$)"), xe = _e = ct.length; _e--; )
              At = ct[_e], (ge || ai === At.origType) && (!ee || ee.guid === At.guid) && (!Ue || Ue.test(At.namespace)) && (!re || re === At.selector || re === "**" && At.selector) && (ct.splice(_e, 1), At.selector && ct.delegateCount--, Bt.remove && Bt.remove.call(w, At));
            xe && !ct.length && ((!Bt.teardown || Bt.teardown.call(w, pi, mi.handle) === !1) && W.removeEvent(w, Ft, mi.handle), delete De[Ft]);
          }
          W.isEmptyObject(De) && Ye.remove(w, "handle events");
        }
      },
      dispatch: function(w) {
        var N, ee, re, ge, _e, xe, Ue = new Array(arguments.length), De = W.event.fix(w), qe = (Ye.get(this, "events") || /* @__PURE__ */ Object.create(null))[De.type] || [], At = W.event.special[De.type] || {};
        for (Ue[0] = De, N = 1; N < arguments.length; N++)
          Ue[N] = arguments[N];
        if (De.delegateTarget = this, !(At.preDispatch && At.preDispatch.call(this, De) === !1)) {
          for (xe = W.event.handlers.call(this, De, qe), N = 0; (ge = xe[N++]) && !De.isPropagationStopped(); )
            for (De.currentTarget = ge.elem, ee = 0; (_e = ge.handlers[ee++]) && !De.isImmediatePropagationStopped(); )
              (!De.rnamespace || _e.namespace === !1 || De.rnamespace.test(_e.namespace)) && (De.handleObj = _e, De.data = _e.data, re = ((W.event.special[_e.origType] || {}).handle || _e.handler).apply(ge.elem, Ue), re !== void 0 && (De.result = re) === !1 && (De.preventDefault(), De.stopPropagation()));
          return At.postDispatch && At.postDispatch.call(this, De), De.result;
        }
      },
      handlers: function(w, N) {
        var ee, re, ge, _e, xe, Ue = [], De = N.delegateCount, qe = w.target;
        if (De && // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        qe.nodeType && // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !(w.type === "click" && w.button >= 1)) {
          for (; qe !== this; qe = qe.parentNode || this)
            if (qe.nodeType === 1 && !(w.type === "click" && qe.disabled === !0)) {
              for (_e = [], xe = {}, ee = 0; ee < De; ee++)
                re = N[ee], ge = re.selector + " ", xe[ge] === void 0 && (xe[ge] = re.needsContext ? W(ge, this).index(qe) > -1 : W.find(ge, this, null, [qe]).length), xe[ge] && _e.push(re);
              _e.length && Ue.push({ elem: qe, handlers: _e });
            }
        }
        return qe = this, De < N.length && Ue.push({ elem: qe, handlers: N.slice(De) }), Ue;
      },
      addProp: function(w, N) {
        Object.defineProperty(W.Event.prototype, w, {
          enumerable: !0,
          configurable: !0,
          get: V(N) ? function() {
            if (this.originalEvent)
              return N(this.originalEvent);
          } : function() {
            if (this.originalEvent)
              return this.originalEvent[w];
          },
          set: function(ee) {
            Object.defineProperty(this, w, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: ee
            });
          }
        });
      },
      fix: function(w) {
        return w[W.expando] ? w : new W.Event(w);
      },
      special: {
        load: {
          // Prevent triggered image.load events from bubbling to window.load
          noBubble: !0
        },
        click: {
          // Utilize native event to ensure correct state for checkable inputs
          setup: function(w) {
            var N = this || w;
            return Y.test(N.type) && N.click && Ee(N, "input") && se(N, "click", !0), !1;
          },
          trigger: function(w) {
            var N = this || w;
            return Y.test(N.type) && N.click && Ee(N, "input") && se(N, "click"), !0;
          },
          // For cross-browser consistency, suppress native .click() on links
          // Also prevent it if we're currently inside a leveraged native-event stack
          _default: function(w) {
            var N = w.target;
            return Y.test(N.type) && N.click && Ee(N, "input") && Ye.get(N, "click") || Ee(N, "a");
          }
        },
        beforeunload: {
          postDispatch: function(w) {
            w.result !== void 0 && w.originalEvent && (w.originalEvent.returnValue = w.result);
          }
        }
      }
    };
    function se(w, N, ee) {
      if (!ee) {
        Ye.get(w, N) === void 0 && W.event.add(w, N, ae);
        return;
      }
      Ye.set(w, N, !1), W.event.add(w, N, {
        namespace: !1,
        handler: function(re) {
          var ge, _e = Ye.get(this, N);
          if (re.isTrigger & 1 && this[N]) {
            if (_e)
              (W.event.special[N] || {}).delegateType && re.stopPropagation();
            else if (_e = o.call(arguments), Ye.set(this, N, _e), this[N](), ge = Ye.get(this, N), Ye.set(this, N, !1), _e !== ge)
              return re.stopImmediatePropagation(), re.preventDefault(), ge;
          } else
            _e && (Ye.set(this, N, W.event.trigger(
              _e[0],
              _e.slice(1),
              this
            )), re.stopPropagation(), re.isImmediatePropagationStopped = ae);
        }
      });
    }
    W.removeEvent = function(w, N, ee) {
      w.removeEventListener && w.removeEventListener(N, ee);
    }, W.Event = function(w, N) {
      if (!(this instanceof W.Event))
        return new W.Event(w, N);
      w && w.type ? (this.originalEvent = w, this.type = w.type, this.isDefaultPrevented = w.defaultPrevented || w.defaultPrevented === void 0 && // Support: Android <=2.3 only
      w.returnValue === !1 ? ae : ue, this.target = w.target && w.target.nodeType === 3 ? w.target.parentNode : w.target, this.currentTarget = w.currentTarget, this.relatedTarget = w.relatedTarget) : this.type = w, N && W.extend(this, N), this.timeStamp = w && w.timeStamp || Date.now(), this[W.expando] = !0;
    }, W.Event.prototype = {
      constructor: W.Event,
      isDefaultPrevented: ue,
      isPropagationStopped: ue,
      isImmediatePropagationStopped: ue,
      isSimulated: !1,
      preventDefault: function() {
        var w = this.originalEvent;
        this.isDefaultPrevented = ae, w && !this.isSimulated && w.preventDefault();
      },
      stopPropagation: function() {
        var w = this.originalEvent;
        this.isPropagationStopped = ae, w && !this.isSimulated && w.stopPropagation();
      },
      stopImmediatePropagation: function() {
        var w = this.originalEvent;
        this.isImmediatePropagationStopped = ae, w && !this.isSimulated && w.stopImmediatePropagation(), this.stopPropagation();
      }
    }, W.each({
      altKey: !0,
      bubbles: !0,
      cancelable: !0,
      changedTouches: !0,
      ctrlKey: !0,
      detail: !0,
      eventPhase: !0,
      metaKey: !0,
      pageX: !0,
      pageY: !0,
      shiftKey: !0,
      view: !0,
      char: !0,
      code: !0,
      charCode: !0,
      key: !0,
      keyCode: !0,
      button: !0,
      buttons: !0,
      clientX: !0,
      clientY: !0,
      offsetX: !0,
      offsetY: !0,
      pointerId: !0,
      pointerType: !0,
      screenX: !0,
      screenY: !0,
      targetTouches: !0,
      toElement: !0,
      touches: !0,
      which: !0
    }, W.event.addProp), W.each({ focus: "focusin", blur: "focusout" }, function(w, N) {
      function ee(re) {
        if (P.documentMode) {
          var ge = Ye.get(this, "handle"), _e = W.event.fix(re);
          _e.type = re.type === "focusin" ? "focus" : "blur", _e.isSimulated = !0, ge(re), _e.target === _e.currentTarget && ge(_e);
        } else
          W.event.simulate(
            N,
            re.target,
            W.event.fix(re)
          );
      }
      W.event.special[w] = {
        // Utilize native event if possible so blur/focus sequence is correct
        setup: function() {
          var re;
          if (se(this, w, !0), P.documentMode)
            re = Ye.get(this, N), re || this.addEventListener(N, ee), Ye.set(this, N, (re || 0) + 1);
          else
            return !1;
        },
        trigger: function() {
          return se(this, w), !0;
        },
        teardown: function() {
          var re;
          if (P.documentMode)
            re = Ye.get(this, N) - 1, re ? Ye.set(this, N, re) : (this.removeEventListener(N, ee), Ye.remove(this, N));
          else
            return !1;
        },
        // Suppress native focus or blur if we're currently inside
        // a leveraged native-event stack
        _default: function(re) {
          return Ye.get(re.target, w);
        },
        delegateType: N
      }, W.event.special[N] = {
        setup: function() {
          var re = this.ownerDocument || this.document || this, ge = P.documentMode ? this : re, _e = Ye.get(ge, N);
          _e || (P.documentMode ? this.addEventListener(N, ee) : re.addEventListener(w, ee, !0)), Ye.set(ge, N, (_e || 0) + 1);
        },
        teardown: function() {
          var re = this.ownerDocument || this.document || this, ge = P.documentMode ? this : re, _e = Ye.get(ge, N) - 1;
          _e ? Ye.set(ge, N, _e) : (P.documentMode ? this.removeEventListener(N, ee) : re.removeEventListener(w, ee, !0), Ye.remove(ge, N));
        }
      };
    }), W.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function(w, N) {
      W.event.special[w] = {
        delegateType: N,
        bindType: N,
        handle: function(ee) {
          var re, ge = this, _e = ee.relatedTarget, xe = ee.handleObj;
          return (!_e || _e !== ge && !W.contains(ge, _e)) && (ee.type = xe.origType, re = xe.handler.apply(this, arguments), ee.type = N), re;
        }
      };
    }), W.fn.extend({
      on: function(w, N, ee, re) {
        return me(this, w, N, ee, re);
      },
      one: function(w, N, ee, re) {
        return me(this, w, N, ee, re, 1);
      },
      off: function(w, N, ee) {
        var re, ge;
        if (w && w.preventDefault && w.handleObj)
          return re = w.handleObj, W(w.delegateTarget).off(
            re.namespace ? re.origType + "." + re.namespace : re.origType,
            re.selector,
            re.handler
          ), this;
        if (typeof w == "object") {
          for (ge in w)
            this.off(ge, N, w[ge]);
          return this;
        }
        return (N === !1 || typeof N == "function") && (ee = N, N = void 0), ee === !1 && (ee = ue), this.each(function() {
          W.event.remove(this, w, ee, N);
        });
      }
    });
    var de = /<script|<style|<link/i, ve = /checked\s*(?:[^=]|=\s*.checked.)/i, we = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    function Se(w, N) {
      return Ee(w, "table") && Ee(N.nodeType !== 11 ? N : N.firstChild, "tr") && W(w).children("tbody")[0] || w;
    }
    function Ae(w) {
      return w.type = (w.getAttribute("type") !== null) + "/" + w.type, w;
    }
    function Ge(w) {
      return (w.type || "").slice(0, 5) === "true/" ? w.type = w.type.slice(5) : w.removeAttribute("type"), w;
    }
    function et(w, N) {
      var ee, re, ge, _e, xe, Ue, De;
      if (N.nodeType === 1) {
        if (Ye.hasData(w) && (_e = Ye.get(w), De = _e.events, De)) {
          Ye.remove(N, "handle events");
          for (ge in De)
            for (ee = 0, re = De[ge].length; ee < re; ee++)
              W.event.add(N, ge, De[ge][ee]);
        }
        i.hasData(w) && (xe = i.access(w), Ue = W.extend({}, xe), i.set(N, Ue));
      }
    }
    function st(w, N) {
      var ee = N.nodeName.toLowerCase();
      ee === "input" && Y.test(w.type) ? N.checked = w.checked : (ee === "input" || ee === "textarea") && (N.defaultValue = w.defaultValue);
    }
    function _t(w, N, ee, re) {
      N = h(N);
      var ge, _e, xe, Ue, De, qe, At = 0, Bt = w.length, ct = Bt - 1, Ft = N[0], pi = V(Ft);
      if (pi || Bt > 1 && typeof Ft == "string" && !Z.checkClone && ve.test(Ft))
        return w.each(function(ai) {
          var mi = w.eq(ai);
          pi && (N[0] = Ft.call(this, ai, mi.html())), _t(mi, N, ee, re);
        });
      if (Bt && (ge = H(N, w[0].ownerDocument, !1, w, re), _e = ge.firstChild, ge.childNodes.length === 1 && (ge = _e), _e || re)) {
        for (xe = W.map(O(ge, "script"), Ae), Ue = xe.length; At < Bt; At++)
          De = ge, At !== ct && (De = W.clone(De, !0, !0), Ue && W.merge(xe, O(De, "script"))), ee.call(w[At], De, At);
        if (Ue)
          for (qe = xe[xe.length - 1].ownerDocument, W.map(xe, Ge), At = 0; At < Ue; At++)
            De = xe[At], z.test(De.type || "") && !Ye.access(De, "globalEval") && W.contains(qe, De) && (De.src && (De.type || "").toLowerCase() !== "module" ? W._evalUrl && !De.noModule && W._evalUrl(De.src, {
              nonce: De.nonce || De.getAttribute("nonce")
            }, qe) : J(De.textContent.replace(we, ""), De, qe));
      }
      return w;
    }
    function Re(w, N, ee) {
      for (var re, ge = N ? W.filter(N, w) : w, _e = 0; (re = ge[_e]) != null; _e++)
        !ee && re.nodeType === 1 && W.cleanData(O(re)), re.parentNode && (ee && S(re) && j(O(re, "script")), re.parentNode.removeChild(re));
      return w;
    }
    W.extend({
      htmlPrefilter: function(w) {
        return w;
      },
      clone: function(w, N, ee) {
        var re, ge, _e, xe, Ue = w.cloneNode(!0), De = S(w);
        if (!Z.noCloneChecked && (w.nodeType === 1 || w.nodeType === 11) && !W.isXMLDoc(w))
          for (xe = O(Ue), _e = O(w), re = 0, ge = _e.length; re < ge; re++)
            st(_e[re], xe[re]);
        if (N)
          if (ee)
            for (_e = _e || O(w), xe = xe || O(Ue), re = 0, ge = _e.length; re < ge; re++)
              et(_e[re], xe[re]);
          else
            et(w, Ue);
        return xe = O(Ue, "script"), xe.length > 0 && j(xe, !De && O(w, "script")), Ue;
      },
      cleanData: function(w) {
        for (var N, ee, re, ge = W.event.special, _e = 0; (ee = w[_e]) !== void 0; _e++)
          if (wt(ee)) {
            if (N = ee[Ye.expando]) {
              if (N.events)
                for (re in N.events)
                  ge[re] ? W.event.remove(ee, re) : W.removeEvent(ee, re, N.handle);
              ee[Ye.expando] = void 0;
            }
            ee[i.expando] && (ee[i.expando] = void 0);
          }
      }
    }), W.fn.extend({
      detach: function(w) {
        return Re(this, w, !0);
      },
      remove: function(w) {
        return Re(this, w);
      },
      text: function(w) {
        return ke(this, function(N) {
          return N === void 0 ? W.text(this) : this.empty().each(function() {
            (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = N);
          });
        }, null, w, arguments.length);
      },
      append: function() {
        return _t(this, arguments, function(w) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var N = Se(this, w);
            N.appendChild(w);
          }
        });
      },
      prepend: function() {
        return _t(this, arguments, function(w) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var N = Se(this, w);
            N.insertBefore(w, N.firstChild);
          }
        });
      },
      before: function() {
        return _t(this, arguments, function(w) {
          this.parentNode && this.parentNode.insertBefore(w, this);
        });
      },
      after: function() {
        return _t(this, arguments, function(w) {
          this.parentNode && this.parentNode.insertBefore(w, this.nextSibling);
        });
      },
      empty: function() {
        for (var w, N = 0; (w = this[N]) != null; N++)
          w.nodeType === 1 && (W.cleanData(O(w, !1)), w.textContent = "");
        return this;
      },
      clone: function(w, N) {
        return w = w ?? !1, N = N ?? w, this.map(function() {
          return W.clone(this, w, N);
        });
      },
      html: function(w) {
        return ke(this, function(N) {
          var ee = this[0] || {}, re = 0, ge = this.length;
          if (N === void 0 && ee.nodeType === 1)
            return ee.innerHTML;
          if (typeof N == "string" && !de.test(N) && !C[(k.exec(N) || ["", ""])[1].toLowerCase()]) {
            N = W.htmlPrefilter(N);
            try {
              for (; re < ge; re++)
                ee = this[re] || {}, ee.nodeType === 1 && (W.cleanData(O(ee, !1)), ee.innerHTML = N);
              ee = 0;
            } catch {
            }
          }
          ee && this.empty().append(N);
        }, null, w, arguments.length);
      },
      replaceWith: function() {
        var w = [];
        return _t(this, arguments, function(N) {
          var ee = this.parentNode;
          W.inArray(this, w) < 0 && (W.cleanData(O(this)), ee && ee.replaceChild(N, this));
        }, w);
      }
    }), W.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function(w, N) {
      W.fn[w] = function(ee) {
        for (var re, ge = [], _e = W(ee), xe = _e.length - 1, Ue = 0; Ue <= xe; Ue++)
          re = Ue === xe ? this : this.clone(!0), W(_e[Ue])[N](re), c.apply(ge, re.get());
        return this.pushStack(ge);
      };
    });
    var Fe = new RegExp("^(" + d + ")(?!px)[a-z%]+$", "i"), at = /^--/, yt = function(w) {
      var N = w.ownerDocument.defaultView;
      return (!N || !N.opener) && (N = e), N.getComputedStyle(w);
    }, bt = function(w, N, ee) {
      var re, ge, _e = {};
      for (ge in N)
        _e[ge] = w.style[ge], w.style[ge] = N[ge];
      re = ee.call(w);
      for (ge in N)
        w.style[ge] = _e[ge];
      return re;
    }, Rt = new RegExp(p.join("|"), "i");
    (function() {
      function w() {
        if (qe) {
          De.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", qe.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", b.appendChild(De).appendChild(qe);
          var At = e.getComputedStyle(qe);
          ee = At.top !== "1%", Ue = N(At.marginLeft) === 12, qe.style.right = "60%", _e = N(At.right) === 36, re = N(At.width) === 36, qe.style.position = "absolute", ge = N(qe.offsetWidth / 3) === 12, b.removeChild(De), qe = null;
        }
      }
      function N(At) {
        return Math.round(parseFloat(At));
      }
      var ee, re, ge, _e, xe, Ue, De = P.createElement("div"), qe = P.createElement("div");
      qe.style && (qe.style.backgroundClip = "content-box", qe.cloneNode(!0).style.backgroundClip = "", Z.clearCloneStyle = qe.style.backgroundClip === "content-box", W.extend(Z, {
        boxSizingReliable: function() {
          return w(), re;
        },
        pixelBoxStyles: function() {
          return w(), _e;
        },
        pixelPosition: function() {
          return w(), ee;
        },
        reliableMarginLeft: function() {
          return w(), Ue;
        },
        scrollboxSize: function() {
          return w(), ge;
        },
        // Support: IE 9 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Behavior in IE 9 is more subtle than in newer versions & it passes
        // some versions of this test; make sure not to make it pass there!
        //
        // Support: Firefox 70+
        // Only Firefox includes border widths
        // in computed dimensions. (gh-4529)
        reliableTrDimensions: function() {
          var At, Bt, ct, Ft;
          return xe == null && (At = P.createElement("table"), Bt = P.createElement("tr"), ct = P.createElement("div"), At.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", Bt.style.cssText = "box-sizing:content-box;border:1px solid", Bt.style.height = "1px", ct.style.height = "9px", ct.style.display = "block", b.appendChild(At).appendChild(Bt).appendChild(ct), Ft = e.getComputedStyle(Bt), xe = parseInt(Ft.height, 10) + parseInt(Ft.borderTopWidth, 10) + parseInt(Ft.borderBottomWidth, 10) === Bt.offsetHeight, b.removeChild(At)), xe;
        }
      }));
    })();
    function It(w, N, ee) {
      var re, ge, _e, xe, Ue = at.test(N), De = w.style;
      return ee = ee || yt(w), ee && (xe = ee.getPropertyValue(N) || ee[N], Ue && xe && (xe = xe.replace(ce, "$1") || void 0), xe === "" && !S(w) && (xe = W.style(w, N)), !Z.pixelBoxStyles() && Fe.test(xe) && Rt.test(N) && (re = De.width, ge = De.minWidth, _e = De.maxWidth, De.minWidth = De.maxWidth = De.width = xe, xe = ee.width, De.width = re, De.minWidth = ge, De.maxWidth = _e)), xe !== void 0 ? (
        // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        xe + ""
      ) : xe;
    }
    function Ht(w, N) {
      return {
        get: function() {
          if (w()) {
            delete this.get;
            return;
          }
          return (this.get = N).apply(this, arguments);
        }
      };
    }
    var jt = ["Webkit", "Moz", "ms"], Vt = P.createElement("div").style, Ti = {};
    function ki(w) {
      for (var N = w[0].toUpperCase() + w.slice(1), ee = jt.length; ee--; )
        if (w = jt[ee] + N, w in Vt)
          return w;
    }
    function Li(w) {
      var N = W.cssProps[w] || Ti[w];
      return N || (w in Vt ? w : Ti[w] = ki(w) || w);
    }
    var bi = /^(none|table(?!-c[ea]).+)/, si = { position: "absolute", visibility: "hidden", display: "block" }, Nt = {
      letterSpacing: "0",
      fontWeight: "400"
    };
    function Vi(w, N, ee) {
      var re = v.exec(N);
      return re ? (
        // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, re[2] - (ee || 0)) + (re[3] || "px")
      ) : N;
    }
    function ci(w, N, ee, re, ge, _e) {
      var xe = N === "width" ? 1 : 0, Ue = 0, De = 0, qe = 0;
      if (ee === (re ? "border" : "content"))
        return 0;
      for (; xe < 4; xe += 2)
        ee === "margin" && (qe += W.css(w, ee + p[xe], !0, ge)), re ? (ee === "content" && (De -= W.css(w, "padding" + p[xe], !0, ge)), ee !== "margin" && (De -= W.css(w, "border" + p[xe] + "Width", !0, ge))) : (De += W.css(w, "padding" + p[xe], !0, ge), ee !== "padding" ? De += W.css(w, "border" + p[xe] + "Width", !0, ge) : Ue += W.css(w, "border" + p[xe] + "Width", !0, ge));
      return !re && _e >= 0 && (De += Math.max(0, Math.ceil(
        w["offset" + N[0].toUpperCase() + N.slice(1)] - _e - De - Ue - 0.5
        // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
        // Use an explicit zero to avoid NaN (gh-3964)
      )) || 0), De + qe;
    }
    function nn(w, N, ee) {
      var re = yt(w), ge = !Z.boxSizingReliable() || ee, _e = ge && W.css(w, "boxSizing", !1, re) === "border-box", xe = _e, Ue = It(w, N, re), De = "offset" + N[0].toUpperCase() + N.slice(1);
      if (Fe.test(Ue)) {
        if (!ee)
          return Ue;
        Ue = "auto";
      }
      return (!Z.boxSizingReliable() && _e || // Support: IE 10 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Interestingly, in some cases IE 9 doesn't suffer from this issue.
      !Z.reliableTrDimensions() && Ee(w, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      Ue === "auto" || // Support: Android <=4.1 - 4.3 only
      // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
      !parseFloat(Ue) && W.css(w, "display", !1, re) === "inline") && // Make sure the element is visible & connected
      w.getClientRects().length && (_e = W.css(w, "boxSizing", !1, re) === "border-box", xe = De in w, xe && (Ue = w[De])), Ue = parseFloat(Ue) || 0, Ue + ci(
        w,
        N,
        ee || (_e ? "border" : "content"),
        xe,
        re,
        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        Ue
      ) + "px";
    }
    W.extend({
      // Add in style property hooks for overriding the default
      // behavior of getting and setting a style property
      cssHooks: {
        opacity: {
          get: function(w, N) {
            if (N) {
              var ee = It(w, "opacity");
              return ee === "" ? "1" : ee;
            }
          }
        }
      },
      // Don't automatically add "px" to these possibly-unitless properties
      cssNumber: {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageSlice: !0,
        columnCount: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        scale: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0
      },
      // Add in properties whose names you wish to fix before
      // setting or getting the value
      cssProps: {},
      // Get and set the style property on a DOM Node
      style: function(w, N, ee, re) {
        if (!(!w || w.nodeType === 3 || w.nodeType === 8 || !w.style)) {
          var ge, _e, xe, Ue = Qe(N), De = at.test(N), qe = w.style;
          if (De || (N = Li(Ue)), xe = W.cssHooks[N] || W.cssHooks[Ue], ee !== void 0) {
            if (_e = typeof ee, _e === "string" && (ge = v.exec(ee)) && ge[1] && (ee = A(w, N, ge), _e = "number"), ee == null || ee !== ee)
              return;
            _e === "number" && !De && (ee += ge && ge[3] || (W.cssNumber[Ue] ? "" : "px")), !Z.clearCloneStyle && ee === "" && N.indexOf("background") === 0 && (qe[N] = "inherit"), (!xe || !("set" in xe) || (ee = xe.set(w, ee, re)) !== void 0) && (De ? qe.setProperty(N, ee) : qe[N] = ee);
          } else
            return xe && "get" in xe && (ge = xe.get(w, !1, re)) !== void 0 ? ge : qe[N];
        }
      },
      css: function(w, N, ee, re) {
        var ge, _e, xe, Ue = Qe(N), De = at.test(N);
        return De || (N = Li(Ue)), xe = W.cssHooks[N] || W.cssHooks[Ue], xe && "get" in xe && (ge = xe.get(w, !0, ee)), ge === void 0 && (ge = It(w, N, re)), ge === "normal" && N in Nt && (ge = Nt[N]), ee === "" || ee ? (_e = parseFloat(ge), ee === !0 || isFinite(_e) ? _e || 0 : ge) : ge;
      }
    }), W.each(["height", "width"], function(w, N) {
      W.cssHooks[N] = {
        get: function(ee, re, ge) {
          if (re)
            return bi.test(W.css(ee, "display")) && // Support: Safari 8+
            // Table columns in Safari have non-zero offsetWidth & zero
            // getBoundingClientRect().width unless display is changed.
            // Support: IE <=11 only
            // Running getBoundingClientRect on a disconnected node
            // in IE throws an error.
            (!ee.getClientRects().length || !ee.getBoundingClientRect().width) ? bt(ee, si, function() {
              return nn(ee, N, ge);
            }) : nn(ee, N, ge);
        },
        set: function(ee, re, ge) {
          var _e, xe = yt(ee), Ue = !Z.scrollboxSize() && xe.position === "absolute", De = Ue || ge, qe = De && W.css(ee, "boxSizing", !1, xe) === "border-box", At = ge ? ci(
            ee,
            N,
            ge,
            qe,
            xe
          ) : 0;
          return qe && Ue && (At -= Math.ceil(
            ee["offset" + N[0].toUpperCase() + N.slice(1)] - parseFloat(xe[N]) - ci(ee, N, "border", !1, xe) - 0.5
          )), At && (_e = v.exec(re)) && (_e[3] || "px") !== "px" && (ee.style[N] = re, re = W.css(ee, N)), Vi(ee, re, At);
        }
      };
    }), W.cssHooks.marginLeft = Ht(
      Z.reliableMarginLeft,
      function(w, N) {
        if (N)
          return (parseFloat(It(w, "marginLeft")) || w.getBoundingClientRect().left - bt(w, { marginLeft: 0 }, function() {
            return w.getBoundingClientRect().left;
          })) + "px";
      }
    ), W.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function(w, N) {
      W.cssHooks[w + N] = {
        expand: function(ee) {
          for (var re = 0, ge = {}, _e = typeof ee == "string" ? ee.split(" ") : [ee]; re < 4; re++)
            ge[w + p[re] + N] = _e[re] || _e[re - 2] || _e[0];
          return ge;
        }
      }, w !== "margin" && (W.cssHooks[w + N].set = Vi);
    }), W.fn.extend({
      css: function(w, N) {
        return ke(this, function(ee, re, ge) {
          var _e, xe, Ue = {}, De = 0;
          if (Array.isArray(re)) {
            for (_e = yt(ee), xe = re.length; De < xe; De++)
              Ue[re[De]] = W.css(ee, re[De], !1, _e);
            return Ue;
          }
          return ge !== void 0 ? W.style(ee, re, ge) : W.css(ee, re);
        }, w, N, arguments.length > 1);
      }
    });
    function Yi(w, N, ee, re, ge) {
      return new Yi.prototype.init(w, N, ee, re, ge);
    }
    W.Tween = Yi, Yi.prototype = {
      constructor: Yi,
      init: function(w, N, ee, re, ge, _e) {
        this.elem = w, this.prop = ee, this.easing = ge || W.easing._default, this.options = N, this.start = this.now = this.cur(), this.end = re, this.unit = _e || (W.cssNumber[ee] ? "" : "px");
      },
      cur: function() {
        var w = Yi.propHooks[this.prop];
        return w && w.get ? w.get(this) : Yi.propHooks._default.get(this);
      },
      run: function(w) {
        var N, ee = Yi.propHooks[this.prop];
        return this.options.duration ? this.pos = N = W.easing[this.easing](
          w,
          this.options.duration * w,
          0,
          1,
          this.options.duration
        ) : this.pos = N = w, this.now = (this.end - this.start) * N + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), ee && ee.set ? ee.set(this) : Yi.propHooks._default.set(this), this;
      }
    }, Yi.prototype.init.prototype = Yi.prototype, Yi.propHooks = {
      _default: {
        get: function(w) {
          var N;
          return w.elem.nodeType !== 1 || w.elem[w.prop] != null && w.elem.style[w.prop] == null ? w.elem[w.prop] : (N = W.css(w.elem, w.prop, ""), !N || N === "auto" ? 0 : N);
        },
        set: function(w) {
          W.fx.step[w.prop] ? W.fx.step[w.prop](w) : w.elem.nodeType === 1 && (W.cssHooks[w.prop] || w.elem.style[Li(w.prop)] != null) ? W.style(w.elem, w.prop, w.now + w.unit) : w.elem[w.prop] = w.now;
        }
      }
    }, Yi.propHooks.scrollTop = Yi.propHooks.scrollLeft = {
      set: function(w) {
        w.elem.nodeType && w.elem.parentNode && (w.elem[w.prop] = w.now);
      }
    }, W.easing = {
      linear: function(w) {
        return w;
      },
      swing: function(w) {
        return 0.5 - Math.cos(w * Math.PI) / 2;
      },
      _default: "swing"
    }, W.fx = Yi.prototype.init, W.fx.step = {};
    var qi, Qi, Gi = /^(?:toggle|show|hide)$/, Xi = /queueHooks$/;
    function _n() {
      Qi && (P.hidden === !1 && e.requestAnimationFrame ? e.requestAnimationFrame(_n) : e.setTimeout(_n, W.fx.interval), W.fx.tick());
    }
    function Ki() {
      return e.setTimeout(function() {
        qi = void 0;
      }), qi = Date.now();
    }
    function cn(w, N) {
      var ee, re = 0, ge = { height: w };
      for (N = N ? 1 : 0; re < 4; re += 2 - N)
        ee = p[re], ge["margin" + ee] = ge["padding" + ee] = w;
      return N && (ge.opacity = ge.width = w), ge;
    }
    function Cn(w, N, ee) {
      for (var re, ge = (An.tweeners[N] || []).concat(An.tweeners["*"]), _e = 0, xe = ge.length; _e < xe; _e++)
        if (re = ge[_e].call(ee, N, w))
          return re;
    }
    function $r(w, N, ee) {
      var re, ge, _e, xe, Ue, De, qe, At, Bt = "width" in N || "height" in N, ct = this, Ft = {}, pi = w.style, ai = w.nodeType && E(w), mi = Ye.get(w, "fxshow");
      ee.queue || (xe = W._queueHooks(w, "fx"), xe.unqueued == null && (xe.unqueued = 0, Ue = xe.empty.fire, xe.empty.fire = function() {
        xe.unqueued || Ue();
      }), xe.unqueued++, ct.always(function() {
        ct.always(function() {
          xe.unqueued--, W.queue(w, "fx").length || xe.empty.fire();
        });
      }));
      for (re in N)
        if (ge = N[re], Gi.test(ge)) {
          if (delete N[re], _e = _e || ge === "toggle", ge === (ai ? "hide" : "show"))
            if (ge === "show" && mi && mi[re] !== void 0)
              ai = !0;
            else
              continue;
          Ft[re] = mi && mi[re] || W.style(w, re);
        }
      if (De = !W.isEmptyObject(N), !(!De && W.isEmptyObject(Ft))) {
        Bt && w.nodeType === 1 && (ee.overflow = [pi.overflow, pi.overflowX, pi.overflowY], qe = mi && mi.display, qe == null && (qe = Ye.get(w, "display")), At = W.css(w, "display"), At === "none" && (qe ? At = qe : (D([w], !0), qe = w.style.display || qe, At = W.css(w, "display"), D([w]))), (At === "inline" || At === "inline-block" && qe != null) && W.css(w, "float") === "none" && (De || (ct.done(function() {
          pi.display = qe;
        }), qe == null && (At = pi.display, qe = At === "none" ? "" : At)), pi.display = "inline-block")), ee.overflow && (pi.overflow = "hidden", ct.always(function() {
          pi.overflow = ee.overflow[0], pi.overflowX = ee.overflow[1], pi.overflowY = ee.overflow[2];
        })), De = !1;
        for (re in Ft)
          De || (mi ? "hidden" in mi && (ai = mi.hidden) : mi = Ye.access(w, "fxshow", { display: qe }), _e && (mi.hidden = !ai), ai && D([w], !0), ct.done(function() {
            ai || D([w]), Ye.remove(w, "fxshow");
            for (re in Ft)
              W.style(w, re, Ft[re]);
          })), De = Cn(ai ? mi[re] : 0, re, ct), re in mi || (mi[re] = De.start, ai && (De.end = De.start, De.start = 0));
      }
    }
    function Pr(w, N) {
      var ee, re, ge, _e, xe;
      for (ee in w)
        if (re = Qe(ee), ge = N[re], _e = w[ee], Array.isArray(_e) && (ge = _e[1], _e = w[ee] = _e[0]), ee !== re && (w[re] = _e, delete w[ee]), xe = W.cssHooks[re], xe && "expand" in xe) {
          _e = xe.expand(_e), delete w[re];
          for (ee in _e)
            ee in w || (w[ee] = _e[ee], N[ee] = ge);
        } else
          N[re] = ge;
    }
    function An(w, N, ee) {
      var re, ge, _e = 0, xe = An.prefilters.length, Ue = W.Deferred().always(function() {
        delete De.elem;
      }), De = function() {
        if (ge)
          return !1;
        for (var Bt = qi || Ki(), ct = Math.max(0, qe.startTime + qe.duration - Bt), Ft = ct / qe.duration || 0, pi = 1 - Ft, ai = 0, mi = qe.tweens.length; ai < mi; ai++)
          qe.tweens[ai].run(pi);
        return Ue.notifyWith(w, [qe, pi, ct]), pi < 1 && mi ? ct : (mi || Ue.notifyWith(w, [qe, 1, 0]), Ue.resolveWith(w, [qe]), !1);
      }, qe = Ue.promise({
        elem: w,
        props: W.extend({}, N),
        opts: W.extend(!0, {
          specialEasing: {},
          easing: W.easing._default
        }, ee),
        originalProperties: N,
        originalOptions: ee,
        startTime: qi || Ki(),
        duration: ee.duration,
        tweens: [],
        createTween: function(Bt, ct) {
          var Ft = W.Tween(
            w,
            qe.opts,
            Bt,
            ct,
            qe.opts.specialEasing[Bt] || qe.opts.easing
          );
          return qe.tweens.push(Ft), Ft;
        },
        stop: function(Bt) {
          var ct = 0, Ft = Bt ? qe.tweens.length : 0;
          if (ge)
            return this;
          for (ge = !0; ct < Ft; ct++)
            qe.tweens[ct].run(1);
          return Bt ? (Ue.notifyWith(w, [qe, 1, 0]), Ue.resolveWith(w, [qe, Bt])) : Ue.rejectWith(w, [qe, Bt]), this;
        }
      }), At = qe.props;
      for (Pr(At, qe.opts.specialEasing); _e < xe; _e++)
        if (re = An.prefilters[_e].call(qe, w, At, qe.opts), re)
          return V(re.stop) && (W._queueHooks(qe.elem, qe.opts.queue).stop = re.stop.bind(re)), re;
      return W.map(At, Cn, qe), V(qe.opts.start) && qe.opts.start.call(w, qe), qe.progress(qe.opts.progress).done(qe.opts.done, qe.opts.complete).fail(qe.opts.fail).always(qe.opts.always), W.fx.timer(
        W.extend(De, {
          elem: w,
          anim: qe,
          queue: qe.opts.queue
        })
      ), qe;
    }
    W.Animation = W.extend(An, {
      tweeners: {
        "*": [function(w, N) {
          var ee = this.createTween(w, N);
          return A(ee.elem, w, v.exec(N), ee), ee;
        }]
      },
      tweener: function(w, N) {
        V(w) ? (N = w, w = ["*"]) : w = w.match(Xt);
        for (var ee, re = 0, ge = w.length; re < ge; re++)
          ee = w[re], An.tweeners[ee] = An.tweeners[ee] || [], An.tweeners[ee].unshift(N);
      },
      prefilters: [$r],
      prefilter: function(w, N) {
        N ? An.prefilters.unshift(w) : An.prefilters.push(w);
      }
    }), W.speed = function(w, N, ee) {
      var re = w && typeof w == "object" ? W.extend({}, w) : {
        complete: ee || !ee && N || V(w) && w,
        duration: w,
        easing: ee && N || N && !V(N) && N
      };
      return W.fx.off ? re.duration = 0 : typeof re.duration != "number" && (re.duration in W.fx.speeds ? re.duration = W.fx.speeds[re.duration] : re.duration = W.fx.speeds._default), (re.queue == null || re.queue === !0) && (re.queue = "fx"), re.old = re.complete, re.complete = function() {
        V(re.old) && re.old.call(this), re.queue && W.dequeue(this, re.queue);
      }, re;
    }, W.fn.extend({
      fadeTo: function(w, N, ee, re) {
        return this.filter(E).css("opacity", 0).show().end().animate({ opacity: N }, w, ee, re);
      },
      animate: function(w, N, ee, re) {
        var ge = W.isEmptyObject(w), _e = W.speed(N, ee, re), xe = function() {
          var Ue = An(this, W.extend({}, w), _e);
          (ge || Ye.get(this, "finish")) && Ue.stop(!0);
        };
        return xe.finish = xe, ge || _e.queue === !1 ? this.each(xe) : this.queue(_e.queue, xe);
      },
      stop: function(w, N, ee) {
        var re = function(ge) {
          var _e = ge.stop;
          delete ge.stop, _e(ee);
        };
        return typeof w != "string" && (ee = N, N = w, w = void 0), N && this.queue(w || "fx", []), this.each(function() {
          var ge = !0, _e = w != null && w + "queueHooks", xe = W.timers, Ue = Ye.get(this);
          if (_e)
            Ue[_e] && Ue[_e].stop && re(Ue[_e]);
          else
            for (_e in Ue)
              Ue[_e] && Ue[_e].stop && Xi.test(_e) && re(Ue[_e]);
          for (_e = xe.length; _e--; )
            xe[_e].elem === this && (w == null || xe[_e].queue === w) && (xe[_e].anim.stop(ee), ge = !1, xe.splice(_e, 1));
          (ge || !ee) && W.dequeue(this, w);
        });
      },
      finish: function(w) {
        return w !== !1 && (w = w || "fx"), this.each(function() {
          var N, ee = Ye.get(this), re = ee[w + "queue"], ge = ee[w + "queueHooks"], _e = W.timers, xe = re ? re.length : 0;
          for (ee.finish = !0, W.queue(this, w, []), ge && ge.stop && ge.stop.call(this, !0), N = _e.length; N--; )
            _e[N].elem === this && _e[N].queue === w && (_e[N].anim.stop(!0), _e.splice(N, 1));
          for (N = 0; N < xe; N++)
            re[N] && re[N].finish && re[N].finish.call(this);
          delete ee.finish;
        });
      }
    }), W.each(["toggle", "show", "hide"], function(w, N) {
      var ee = W.fn[N];
      W.fn[N] = function(re, ge, _e) {
        return re == null || typeof re == "boolean" ? ee.apply(this, arguments) : this.animate(cn(N, !0), re, ge, _e);
      };
    }), W.each({
      slideDown: cn("show"),
      slideUp: cn("hide"),
      slideToggle: cn("toggle"),
      fadeIn: { opacity: "show" },
      fadeOut: { opacity: "hide" },
      fadeToggle: { opacity: "toggle" }
    }, function(w, N) {
      W.fn[w] = function(ee, re, ge) {
        return this.animate(N, ee, re, ge);
      };
    }), W.timers = [], W.fx.tick = function() {
      var w, N = 0, ee = W.timers;
      for (qi = Date.now(); N < ee.length; N++)
        w = ee[N], !w() && ee[N] === w && ee.splice(N--, 1);
      ee.length || W.fx.stop(), qi = void 0;
    }, W.fx.timer = function(w) {
      W.timers.push(w), W.fx.start();
    }, W.fx.interval = 13, W.fx.start = function() {
      Qi || (Qi = !0, _n());
    }, W.fx.stop = function() {
      Qi = null;
    }, W.fx.speeds = {
      slow: 600,
      fast: 200,
      // Default speed
      _default: 400
    }, W.fn.delay = function(w, N) {
      return w = W.fx && W.fx.speeds[w] || w, N = N || "fx", this.queue(N, function(ee, re) {
        var ge = e.setTimeout(ee, w);
        re.stop = function() {
          e.clearTimeout(ge);
        };
      });
    }, function() {
      var w = P.createElement("input"), N = P.createElement("select"), ee = N.appendChild(P.createElement("option"));
      w.type = "checkbox", Z.checkOn = w.value !== "", Z.optSelected = ee.selected, w = P.createElement("input"), w.value = "t", w.type = "radio", Z.radioValue = w.value === "t";
    }();
    var Xr, Vn = W.expr.attrHandle;
    W.fn.extend({
      attr: function(w, N) {
        return ke(this, W.attr, w, N, arguments.length > 1);
      },
      removeAttr: function(w) {
        return this.each(function() {
          W.removeAttr(this, w);
        });
      }
    }), W.extend({
      attr: function(w, N, ee) {
        var re, ge, _e = w.nodeType;
        if (!(_e === 3 || _e === 8 || _e === 2)) {
          if (typeof w.getAttribute > "u")
            return W.prop(w, N, ee);
          if ((_e !== 1 || !W.isXMLDoc(w)) && (ge = W.attrHooks[N.toLowerCase()] || (W.expr.match.bool.test(N) ? Xr : void 0)), ee !== void 0) {
            if (ee === null) {
              W.removeAttr(w, N);
              return;
            }
            return ge && "set" in ge && (re = ge.set(w, ee, N)) !== void 0 ? re : (w.setAttribute(N, ee + ""), ee);
          }
          return ge && "get" in ge && (re = ge.get(w, N)) !== null ? re : (re = W.find.attr(w, N), re ?? void 0);
        }
      },
      attrHooks: {
        type: {
          set: function(w, N) {
            if (!Z.radioValue && N === "radio" && Ee(w, "input")) {
              var ee = w.value;
              return w.setAttribute("type", N), ee && (w.value = ee), N;
            }
          }
        }
      },
      removeAttr: function(w, N) {
        var ee, re = 0, ge = N && N.match(Xt);
        if (ge && w.nodeType === 1)
          for (; ee = ge[re++]; )
            w.removeAttribute(ee);
      }
    }), Xr = {
      set: function(w, N, ee) {
        return N === !1 ? W.removeAttr(w, ee) : w.setAttribute(ee, ee), ee;
      }
    }, W.each(W.expr.match.bool.source.match(/\w+/g), function(w, N) {
      var ee = Vn[N] || W.find.attr;
      Vn[N] = function(re, ge, _e) {
        var xe, Ue, De = ge.toLowerCase();
        return _e || (Ue = Vn[De], Vn[De] = xe, xe = ee(re, ge, _e) != null ? De : null, Vn[De] = Ue), xe;
      };
    });
    var gr = /^(?:input|select|textarea|button)$/i, Hn = /^(?:a|area)$/i;
    W.fn.extend({
      prop: function(w, N) {
        return ke(this, W.prop, w, N, arguments.length > 1);
      },
      removeProp: function(w) {
        return this.each(function() {
          delete this[W.propFix[w] || w];
        });
      }
    }), W.extend({
      prop: function(w, N, ee) {
        var re, ge, _e = w.nodeType;
        if (!(_e === 3 || _e === 8 || _e === 2))
          return (_e !== 1 || !W.isXMLDoc(w)) && (N = W.propFix[N] || N, ge = W.propHooks[N]), ee !== void 0 ? ge && "set" in ge && (re = ge.set(w, ee, N)) !== void 0 ? re : w[N] = ee : ge && "get" in ge && (re = ge.get(w, N)) !== null ? re : w[N];
      },
      propHooks: {
        tabIndex: {
          get: function(w) {
            var N = W.find.attr(w, "tabindex");
            return N ? parseInt(N, 10) : gr.test(w.nodeName) || Hn.test(w.nodeName) && w.href ? 0 : -1;
          }
        }
      },
      propFix: {
        for: "htmlFor",
        class: "className"
      }
    }), Z.optSelected || (W.propHooks.selected = {
      get: function(w) {
        var N = w.parentNode;
        return N && N.parentNode && N.parentNode.selectedIndex, null;
      },
      set: function(w) {
        var N = w.parentNode;
        N && (N.selectedIndex, N.parentNode && N.parentNode.selectedIndex);
      }
    }), W.each([
      "tabIndex",
      "readOnly",
      "maxLength",
      "cellSpacing",
      "cellPadding",
      "rowSpan",
      "colSpan",
      "useMap",
      "frameBorder",
      "contentEditable"
    ], function() {
      W.propFix[this.toLowerCase()] = this;
    });
    function fn(w) {
      var N = w.match(Xt) || [];
      return N.join(" ");
    }
    function dn(w) {
      return w.getAttribute && w.getAttribute("class") || "";
    }
    function bn(w) {
      return Array.isArray(w) ? w : typeof w == "string" ? w.match(Xt) || [] : [];
    }
    W.fn.extend({
      addClass: function(w) {
        var N, ee, re, ge, _e, xe;
        return V(w) ? this.each(function(Ue) {
          W(this).addClass(w.call(this, Ue, dn(this)));
        }) : (N = bn(w), N.length ? this.each(function() {
          if (re = dn(this), ee = this.nodeType === 1 && " " + fn(re) + " ", ee) {
            for (_e = 0; _e < N.length; _e++)
              ge = N[_e], ee.indexOf(" " + ge + " ") < 0 && (ee += ge + " ");
            xe = fn(ee), re !== xe && this.setAttribute("class", xe);
          }
        }) : this);
      },
      removeClass: function(w) {
        var N, ee, re, ge, _e, xe;
        return V(w) ? this.each(function(Ue) {
          W(this).removeClass(w.call(this, Ue, dn(this)));
        }) : arguments.length ? (N = bn(w), N.length ? this.each(function() {
          if (re = dn(this), ee = this.nodeType === 1 && " " + fn(re) + " ", ee) {
            for (_e = 0; _e < N.length; _e++)
              for (ge = N[_e]; ee.indexOf(" " + ge + " ") > -1; )
                ee = ee.replace(" " + ge + " ", " ");
            xe = fn(ee), re !== xe && this.setAttribute("class", xe);
          }
        }) : this) : this.attr("class", "");
      },
      toggleClass: function(w, N) {
        var ee, re, ge, _e, xe = typeof w, Ue = xe === "string" || Array.isArray(w);
        return V(w) ? this.each(function(De) {
          W(this).toggleClass(
            w.call(this, De, dn(this), N),
            N
          );
        }) : typeof N == "boolean" && Ue ? N ? this.addClass(w) : this.removeClass(w) : (ee = bn(w), this.each(function() {
          if (Ue)
            for (_e = W(this), ge = 0; ge < ee.length; ge++)
              re = ee[ge], _e.hasClass(re) ? _e.removeClass(re) : _e.addClass(re);
          else
            (w === void 0 || xe === "boolean") && (re = dn(this), re && Ye.set(this, "__className__", re), this.setAttribute && this.setAttribute(
              "class",
              re || w === !1 ? "" : Ye.get(this, "__className__") || ""
            ));
        }));
      },
      hasClass: function(w) {
        var N, ee, re = 0;
        for (N = " " + w + " "; ee = this[re++]; )
          if (ee.nodeType === 1 && (" " + fn(dn(ee)) + " ").indexOf(N) > -1)
            return !0;
        return !1;
      }
    });
    var sn = /\r/g;
    W.fn.extend({
      val: function(w) {
        var N, ee, re, ge = this[0];
        return arguments.length ? (re = V(w), this.each(function(_e) {
          var xe;
          this.nodeType === 1 && (re ? xe = w.call(this, _e, W(this).val()) : xe = w, xe == null ? xe = "" : typeof xe == "number" ? xe += "" : Array.isArray(xe) && (xe = W.map(xe, function(Ue) {
            return Ue == null ? "" : Ue + "";
          })), N = W.valHooks[this.type] || W.valHooks[this.nodeName.toLowerCase()], (!N || !("set" in N) || N.set(this, xe, "value") === void 0) && (this.value = xe));
        })) : ge ? (N = W.valHooks[ge.type] || W.valHooks[ge.nodeName.toLowerCase()], N && "get" in N && (ee = N.get(ge, "value")) !== void 0 ? ee : (ee = ge.value, typeof ee == "string" ? ee.replace(sn, "") : ee ?? "")) : void 0;
      }
    }), W.extend({
      valHooks: {
        option: {
          get: function(w) {
            var N = W.find.attr(w, "value");
            return N ?? // Support: IE <=10 - 11 only
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            fn(W.text(w));
          }
        },
        select: {
          get: function(w) {
            var N, ee, re, ge = w.options, _e = w.selectedIndex, xe = w.type === "select-one", Ue = xe ? null : [], De = xe ? _e + 1 : ge.length;
            for (_e < 0 ? re = De : re = xe ? _e : 0; re < De; re++)
              if (ee = ge[re], (ee.selected || re === _e) && // Don't return options that are disabled or in a disabled optgroup
              !ee.disabled && (!ee.parentNode.disabled || !Ee(ee.parentNode, "optgroup"))) {
                if (N = W(ee).val(), xe)
                  return N;
                Ue.push(N);
              }
            return Ue;
          },
          set: function(w, N) {
            for (var ee, re, ge = w.options, _e = W.makeArray(N), xe = ge.length; xe--; )
              re = ge[xe], (re.selected = W.inArray(W.valHooks.option.get(re), _e) > -1) && (ee = !0);
            return ee || (w.selectedIndex = -1), _e;
          }
        }
      }
    }), W.each(["radio", "checkbox"], function() {
      W.valHooks[this] = {
        set: function(w, N) {
          if (Array.isArray(N))
            return w.checked = W.inArray(W(w).val(), N) > -1;
        }
      }, Z.checkOn || (W.valHooks[this].get = function(w) {
        return w.getAttribute("value") === null ? "on" : w.value;
      });
    });
    var ri = e.location, gn = { guid: Date.now() }, rn = /\?/;
    W.parseXML = function(w) {
      var N, ee;
      if (!w || typeof w != "string")
        return null;
      try {
        N = new e.DOMParser().parseFromString(w, "text/xml");
      } catch {
      }
      return ee = N && N.getElementsByTagName("parsererror")[0], (!N || ee) && W.error("Invalid XML: " + (ee ? W.map(ee.childNodes, function(re) {
        return re.textContent;
      }).join(`
`) : w)), N;
    };
    var On = /^(?:focusinfocus|focusoutblur)$/, pr = function(w) {
      w.stopPropagation();
    };
    W.extend(W.event, {
      trigger: function(w, N, ee, re) {
        var ge, _e, xe, Ue, De, qe, At, Bt, ct = [ee || P], Ft = I.call(w, "type") ? w.type : w, pi = I.call(w, "namespace") ? w.namespace.split(".") : [];
        if (_e = Bt = xe = ee = ee || P, !(ee.nodeType === 3 || ee.nodeType === 8) && !On.test(Ft + W.event.triggered) && (Ft.indexOf(".") > -1 && (pi = Ft.split("."), Ft = pi.shift(), pi.sort()), De = Ft.indexOf(":") < 0 && "on" + Ft, w = w[W.expando] ? w : new W.Event(Ft, typeof w == "object" && w), w.isTrigger = re ? 2 : 3, w.namespace = pi.join("."), w.rnamespace = w.namespace ? new RegExp("(^|\\.)" + pi.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, w.result = void 0, w.target || (w.target = ee), N = N == null ? [w] : W.makeArray(N, [w]), At = W.event.special[Ft] || {}, !(!re && At.trigger && At.trigger.apply(ee, N) === !1))) {
          if (!re && !At.noBubble && !te(ee)) {
            for (Ue = At.delegateType || Ft, On.test(Ue + Ft) || (_e = _e.parentNode); _e; _e = _e.parentNode)
              ct.push(_e), xe = _e;
            xe === (ee.ownerDocument || P) && ct.push(xe.defaultView || xe.parentWindow || e);
          }
          for (ge = 0; (_e = ct[ge++]) && !w.isPropagationStopped(); )
            Bt = _e, w.type = ge > 1 ? Ue : At.bindType || Ft, qe = (Ye.get(_e, "events") || /* @__PURE__ */ Object.create(null))[w.type] && Ye.get(_e, "handle"), qe && qe.apply(_e, N), qe = De && _e[De], qe && qe.apply && wt(_e) && (w.result = qe.apply(_e, N), w.result === !1 && w.preventDefault());
          return w.type = Ft, !re && !w.isDefaultPrevented() && (!At._default || At._default.apply(ct.pop(), N) === !1) && wt(ee) && De && V(ee[Ft]) && !te(ee) && (xe = ee[De], xe && (ee[De] = null), W.event.triggered = Ft, w.isPropagationStopped() && Bt.addEventListener(Ft, pr), ee[Ft](), w.isPropagationStopped() && Bt.removeEventListener(Ft, pr), W.event.triggered = void 0, xe && (ee[De] = xe)), w.result;
        }
      },
      // Piggyback on a donor event to simulate a different one
      // Used only for `focus(in | out)` events
      simulate: function(w, N, ee) {
        var re = W.extend(
          new W.Event(),
          ee,
          {
            type: w,
            isSimulated: !0
          }
        );
        W.event.trigger(re, null, N);
      }
    }), W.fn.extend({
      trigger: function(w, N) {
        return this.each(function() {
          W.event.trigger(w, N, this);
        });
      },
      triggerHandler: function(w, N) {
        var ee = this[0];
        if (ee)
          return W.event.trigger(w, N, ee, !0);
      }
    });
    var Nr = /\[\]$/, wr = /\r?\n/g, Sr = /^(?:submit|button|image|reset|file)$/i, g = /^(?:input|select|textarea|keygen)/i;
    function U(w, N, ee, re) {
      var ge;
      if (Array.isArray(N))
        W.each(N, function(_e, xe) {
          ee || Nr.test(w) ? re(w, xe) : U(
            w + "[" + (typeof xe == "object" && xe != null ? _e : "") + "]",
            xe,
            ee,
            re
          );
        });
      else if (!ee && le(N) === "object")
        for (ge in N)
          U(w + "[" + ge + "]", N[ge], ee, re);
      else
        re(w, N);
    }
    W.param = function(w, N) {
      var ee, re = [], ge = function(_e, xe) {
        var Ue = V(xe) ? xe() : xe;
        re[re.length] = encodeURIComponent(_e) + "=" + encodeURIComponent(Ue ?? "");
      };
      if (w == null)
        return "";
      if (Array.isArray(w) || w.jquery && !W.isPlainObject(w))
        W.each(w, function() {
          ge(this.name, this.value);
        });
      else
        for (ee in w)
          U(ee, w[ee], N, ge);
      return re.join("&");
    }, W.fn.extend({
      serialize: function() {
        return W.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var w = W.prop(this, "elements");
          return w ? W.makeArray(w) : this;
        }).filter(function() {
          var w = this.type;
          return this.name && !W(this).is(":disabled") && g.test(this.nodeName) && !Sr.test(w) && (this.checked || !Y.test(w));
        }).map(function(w, N) {
          var ee = W(this).val();
          return ee == null ? null : Array.isArray(ee) ? W.map(ee, function(re) {
            return { name: N.name, value: re.replace(wr, `\r
`) };
          }) : { name: N.name, value: ee.replace(wr, `\r
`) };
        }).get();
      }
    });
    var he = /%20/g, ye = /#.*$/, Ie = /([?&])_=[^&]*/, ot = /^(.*?):[ \t]*([^\r\n]*)$/mg, dt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, zt = /^(?:GET|HEAD)$/, Kt = /^\/\//, fi = {}, ti = {}, hi = "*/".concat("*"), vn = P.createElement("a");
    vn.href = ri.href;
    function ar(w) {
      return function(N, ee) {
        typeof N != "string" && (ee = N, N = "*");
        var re, ge = 0, _e = N.toLowerCase().match(Xt) || [];
        if (V(ee))
          for (; re = _e[ge++]; )
            re[0] === "+" ? (re = re.slice(1) || "*", (w[re] = w[re] || []).unshift(ee)) : (w[re] = w[re] || []).push(ee);
      };
    }
    function Tn(w, N, ee, re) {
      var ge = {}, _e = w === ti;
      function xe(Ue) {
        var De;
        return ge[Ue] = !0, W.each(w[Ue] || [], function(qe, At) {
          var Bt = At(N, ee, re);
          if (typeof Bt == "string" && !_e && !ge[Bt])
            return N.dataTypes.unshift(Bt), xe(Bt), !1;
          if (_e)
            return !(De = Bt);
        }), De;
      }
      return xe(N.dataTypes[0]) || !ge["*"] && xe("*");
    }
    function Mr(w, N) {
      var ee, re, ge = W.ajaxSettings.flatOptions || {};
      for (ee in N)
        N[ee] !== void 0 && ((ge[ee] ? w : re || (re = {}))[ee] = N[ee]);
      return re && W.extend(!0, w, re), w;
    }
    function Cr(w, N, ee) {
      for (var re, ge, _e, xe, Ue = w.contents, De = w.dataTypes; De[0] === "*"; )
        De.shift(), re === void 0 && (re = w.mimeType || N.getResponseHeader("Content-Type"));
      if (re) {
        for (ge in Ue)
          if (Ue[ge] && Ue[ge].test(re)) {
            De.unshift(ge);
            break;
          }
      }
      if (De[0] in ee)
        _e = De[0];
      else {
        for (ge in ee) {
          if (!De[0] || w.converters[ge + " " + De[0]]) {
            _e = ge;
            break;
          }
          xe || (xe = ge);
        }
        _e = _e || xe;
      }
      if (_e)
        return _e !== De[0] && De.unshift(_e), ee[_e];
    }
    function or(w, N, ee, re) {
      var ge, _e, xe, Ue, De, qe = {}, At = w.dataTypes.slice();
      if (At[1])
        for (xe in w.converters)
          qe[xe.toLowerCase()] = w.converters[xe];
      for (_e = At.shift(); _e; )
        if (w.responseFields[_e] && (ee[w.responseFields[_e]] = N), !De && re && w.dataFilter && (N = w.dataFilter(N, w.dataType)), De = _e, _e = At.shift(), _e) {
          if (_e === "*")
            _e = De;
          else if (De !== "*" && De !== _e) {
            if (xe = qe[De + " " + _e] || qe["* " + _e], !xe) {
              for (ge in qe)
                if (Ue = ge.split(" "), Ue[1] === _e && (xe = qe[De + " " + Ue[0]] || qe["* " + Ue[0]], xe)) {
                  xe === !0 ? xe = qe[ge] : qe[ge] !== !0 && (_e = Ue[0], At.unshift(Ue[1]));
                  break;
                }
            }
            if (xe !== !0)
              if (xe && w.throws)
                N = xe(N);
              else
                try {
                  N = xe(N);
                } catch (Bt) {
                  return {
                    state: "parsererror",
                    error: xe ? Bt : "No conversion from " + De + " to " + _e
                  };
                }
          }
        }
      return { state: "success", data: N };
    }
    W.extend({
      // Counter for holding the number of active queries
      active: 0,
      // Last-Modified header cache for next request
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: ri.href,
        type: "GET",
        isLocal: dt.test(ri.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        /*
        timeout: 0,
        data: null,
        dataType: null,
        username: null,
        password: null,
        cache: null,
        throws: false,
        traditional: false,
        headers: {},
        */
        accepts: {
          "*": hi,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        // Data converters
        // Keys separate source (or catchall "*") and destination types with a single space
        converters: {
          // Convert anything to text
          "* text": String,
          // Text to html (true = no transformation)
          "text html": !0,
          // Evaluate text as a json expression
          "text json": JSON.parse,
          // Parse text as xml
          "text xml": W.parseXML
        },
        // For options that shouldn't be deep extended:
        // you can add your own custom options here if
        // and when you create one that shouldn't be
        // deep extended (see ajaxExtend)
        flatOptions: {
          url: !0,
          context: !0
        }
      },
      // Creates a full fledged settings object into target
      // with both ajaxSettings and settings fields.
      // If target is omitted, writes into ajaxSettings.
      ajaxSetup: function(w, N) {
        return N ? (
          // Building a settings object
          Mr(Mr(w, W.ajaxSettings), N)
        ) : (
          // Extending ajaxSettings
          Mr(W.ajaxSettings, w)
        );
      },
      ajaxPrefilter: ar(fi),
      ajaxTransport: ar(ti),
      // Main method
      ajax: function(w, N) {
        typeof w == "object" && (N = w, w = void 0), N = N || {};
        var ee, re, ge, _e, xe, Ue, De, qe, At, Bt, ct = W.ajaxSetup({}, N), Ft = ct.context || ct, pi = ct.context && (Ft.nodeType || Ft.jquery) ? W(Ft) : W.event, ai = W.Deferred(), mi = W.Callbacks("once memory"), xn = ct.statusCode || {}, wn = {}, an = {}, Si = "canceled", Ii = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function(Fi) {
            var en;
            if (De) {
              if (!_e)
                for (_e = {}; en = ot.exec(ge); )
                  _e[en[1].toLowerCase() + " "] = (_e[en[1].toLowerCase() + " "] || []).concat(en[2]);
              en = _e[Fi.toLowerCase() + " "];
            }
            return en == null ? null : en.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function() {
            return De ? ge : null;
          },
          // Caches the header
          setRequestHeader: function(Fi, en) {
            return De == null && (Fi = an[Fi.toLowerCase()] = an[Fi.toLowerCase()] || Fi, wn[Fi] = en), this;
          },
          // Overrides response content-type header
          overrideMimeType: function(Fi) {
            return De == null && (ct.mimeType = Fi), this;
          },
          // Status-dependent callbacks
          statusCode: function(Fi) {
            var en;
            if (Fi)
              if (De)
                Ii.always(Fi[Ii.status]);
              else
                for (en in Fi)
                  xn[en] = [xn[en], Fi[en]];
            return this;
          },
          // Cancel the request
          abort: function(Fi) {
            var en = Fi || Si;
            return ee && ee.abort(en), Dn(0, en), this;
          }
        };
        if (ai.promise(Ii), ct.url = ((w || ct.url || ri.href) + "").replace(Kt, ri.protocol + "//"), ct.type = N.method || N.type || ct.method || ct.type, ct.dataTypes = (ct.dataType || "*").toLowerCase().match(Xt) || [""], ct.crossDomain == null) {
          Ue = P.createElement("a");
          try {
            Ue.href = ct.url, Ue.href = Ue.href, ct.crossDomain = vn.protocol + "//" + vn.host != Ue.protocol + "//" + Ue.host;
          } catch {
            ct.crossDomain = !0;
          }
        }
        if (ct.data && ct.processData && typeof ct.data != "string" && (ct.data = W.param(ct.data, ct.traditional)), Tn(fi, ct, N, Ii), De)
          return Ii;
        qe = W.event && ct.global, qe && W.active++ === 0 && W.event.trigger("ajaxStart"), ct.type = ct.type.toUpperCase(), ct.hasContent = !zt.test(ct.type), re = ct.url.replace(ye, ""), ct.hasContent ? ct.data && ct.processData && (ct.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (ct.data = ct.data.replace(he, "+")) : (Bt = ct.url.slice(re.length), ct.data && (ct.processData || typeof ct.data == "string") && (re += (rn.test(re) ? "&" : "?") + ct.data, delete ct.data), ct.cache === !1 && (re = re.replace(Ie, "$1"), Bt = (rn.test(re) ? "&" : "?") + "_=" + gn.guid++ + Bt), ct.url = re + Bt), ct.ifModified && (W.lastModified[re] && Ii.setRequestHeader("If-Modified-Since", W.lastModified[re]), W.etag[re] && Ii.setRequestHeader("If-None-Match", W.etag[re])), (ct.data && ct.hasContent && ct.contentType !== !1 || N.contentType) && Ii.setRequestHeader("Content-Type", ct.contentType), Ii.setRequestHeader(
          "Accept",
          ct.dataTypes[0] && ct.accepts[ct.dataTypes[0]] ? ct.accepts[ct.dataTypes[0]] + (ct.dataTypes[0] !== "*" ? ", " + hi + "; q=0.01" : "") : ct.accepts["*"]
        );
        for (At in ct.headers)
          Ii.setRequestHeader(At, ct.headers[At]);
        if (ct.beforeSend && (ct.beforeSend.call(Ft, Ii, ct) === !1 || De))
          return Ii.abort();
        if (Si = "abort", mi.add(ct.complete), Ii.done(ct.success), Ii.fail(ct.error), ee = Tn(ti, ct, N, Ii), !ee)
          Dn(-1, "No Transport");
        else {
          if (Ii.readyState = 1, qe && pi.trigger("ajaxSend", [Ii, ct]), De)
            return Ii;
          ct.async && ct.timeout > 0 && (xe = e.setTimeout(function() {
            Ii.abort("timeout");
          }, ct.timeout));
          try {
            De = !1, ee.send(wn, Dn);
          } catch (Fi) {
            if (De)
              throw Fi;
            Dn(-1, Fi);
          }
        }
        function Dn(Fi, en, lr, mr) {
          var pn, Tr, Yn, ei, Zn, Gn = en;
          De || (De = !0, xe && e.clearTimeout(xe), ee = void 0, ge = mr || "", Ii.readyState = Fi > 0 ? 4 : 0, pn = Fi >= 200 && Fi < 300 || Fi === 304, lr && (ei = Cr(ct, Ii, lr)), !pn && W.inArray("script", ct.dataTypes) > -1 && W.inArray("json", ct.dataTypes) < 0 && (ct.converters["text script"] = function() {
          }), ei = or(ct, ei, Ii, pn), pn ? (ct.ifModified && (Zn = Ii.getResponseHeader("Last-Modified"), Zn && (W.lastModified[re] = Zn), Zn = Ii.getResponseHeader("etag"), Zn && (W.etag[re] = Zn)), Fi === 204 || ct.type === "HEAD" ? Gn = "nocontent" : Fi === 304 ? Gn = "notmodified" : (Gn = ei.state, Tr = ei.data, Yn = ei.error, pn = !Yn)) : (Yn = Gn, (Fi || !Gn) && (Gn = "error", Fi < 0 && (Fi = 0))), Ii.status = Fi, Ii.statusText = (en || Gn) + "", pn ? ai.resolveWith(Ft, [Tr, Gn, Ii]) : ai.rejectWith(Ft, [Ii, Gn, Yn]), Ii.statusCode(xn), xn = void 0, qe && pi.trigger(
            pn ? "ajaxSuccess" : "ajaxError",
            [Ii, ct, pn ? Tr : Yn]
          ), mi.fireWith(Ft, [Ii, Gn]), qe && (pi.trigger("ajaxComplete", [Ii, ct]), --W.active || W.event.trigger("ajaxStop")));
        }
        return Ii;
      },
      getJSON: function(w, N, ee) {
        return W.get(w, N, ee, "json");
      },
      getScript: function(w, N) {
        return W.get(w, void 0, N, "script");
      }
    }), W.each(["get", "post"], function(w, N) {
      W[N] = function(ee, re, ge, _e) {
        return V(re) && (_e = _e || ge, ge = re, re = void 0), W.ajax(W.extend({
          url: ee,
          type: N,
          dataType: _e,
          data: re,
          success: ge
        }, W.isPlainObject(ee) && ee));
      };
    }), W.ajaxPrefilter(function(w) {
      var N;
      for (N in w.headers)
        N.toLowerCase() === "content-type" && (w.contentType = w.headers[N] || "");
    }), W._evalUrl = function(w, N, ee) {
      return W.ajax({
        url: w,
        // Make this explicit, since user can override this through ajaxSetup (trac-11264)
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        // Only evaluate the response if it is successful (gh-4126)
        // dataFilter is not invoked for failure responses, so using it instead
        // of the default converter is kludgy but it works.
        converters: {
          "text script": function() {
          }
        },
        dataFilter: function(re) {
          W.globalEval(re, N, ee);
        }
      });
    }, W.fn.extend({
      wrapAll: function(w) {
        var N;
        return this[0] && (V(w) && (w = w.call(this[0])), N = W(w, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && N.insertBefore(this[0]), N.map(function() {
          for (var ee = this; ee.firstElementChild; )
            ee = ee.firstElementChild;
          return ee;
        }).append(this)), this;
      },
      wrapInner: function(w) {
        return V(w) ? this.each(function(N) {
          W(this).wrapInner(w.call(this, N));
        }) : this.each(function() {
          var N = W(this), ee = N.contents();
          ee.length ? ee.wrapAll(w) : N.append(w);
        });
      },
      wrap: function(w) {
        var N = V(w);
        return this.each(function(ee) {
          W(this).wrapAll(N ? w.call(this, ee) : w);
        });
      },
      unwrap: function(w) {
        return this.parent(w).not("body").each(function() {
          W(this).replaceWith(this.childNodes);
        }), this;
      }
    }), W.expr.pseudos.hidden = function(w) {
      return !W.expr.pseudos.visible(w);
    }, W.expr.pseudos.visible = function(w) {
      return !!(w.offsetWidth || w.offsetHeight || w.getClientRects().length);
    }, W.ajaxSettings.xhr = function() {
      try {
        return new e.XMLHttpRequest();
      } catch {
      }
    };
    var Ar = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    }, ls = W.ajaxSettings.xhr();
    Z.cors = !!ls && "withCredentials" in ls, Z.ajax = ls = !!ls, W.ajaxTransport(function(w) {
      var N, ee;
      if (Z.cors || ls && !w.crossDomain)
        return {
          send: function(re, ge) {
            var _e, xe = w.xhr();
            if (xe.open(
              w.type,
              w.url,
              w.async,
              w.username,
              w.password
            ), w.xhrFields)
              for (_e in w.xhrFields)
                xe[_e] = w.xhrFields[_e];
            w.mimeType && xe.overrideMimeType && xe.overrideMimeType(w.mimeType), !w.crossDomain && !re["X-Requested-With"] && (re["X-Requested-With"] = "XMLHttpRequest");
            for (_e in re)
              xe.setRequestHeader(_e, re[_e]);
            N = function(Ue) {
              return function() {
                N && (N = ee = xe.onload = xe.onerror = xe.onabort = xe.ontimeout = xe.onreadystatechange = null, Ue === "abort" ? xe.abort() : Ue === "error" ? typeof xe.status != "number" ? ge(0, "error") : ge(
                  // File: protocol always yields status 0; see trac-8605, trac-14207
                  xe.status,
                  xe.statusText
                ) : ge(
                  Ar[xe.status] || xe.status,
                  xe.statusText,
                  // Support: IE <=9 only
                  // IE9 has no XHR2 but throws on binary (trac-11426)
                  // For XHR2 non-text, let the caller handle it (gh-2498)
                  (xe.responseType || "text") !== "text" || typeof xe.responseText != "string" ? { binary: xe.response } : { text: xe.responseText },
                  xe.getAllResponseHeaders()
                ));
              };
            }, xe.onload = N(), ee = xe.onerror = xe.ontimeout = N("error"), xe.onabort !== void 0 ? xe.onabort = ee : xe.onreadystatechange = function() {
              xe.readyState === 4 && e.setTimeout(function() {
                N && ee();
              });
            }, N = N("abort");
            try {
              xe.send(w.hasContent && w.data || null);
            } catch (Ue) {
              if (N)
                throw Ue;
            }
          },
          abort: function() {
            N && N();
          }
        };
    }), W.ajaxPrefilter(function(w) {
      w.crossDomain && (w.contents.script = !1);
    }), W.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function(w) {
          return W.globalEval(w), w;
        }
      }
    }), W.ajaxPrefilter("script", function(w) {
      w.cache === void 0 && (w.cache = !1), w.crossDomain && (w.type = "GET");
    }), W.ajaxTransport("script", function(w) {
      if (w.crossDomain || w.scriptAttrs) {
        var N, ee;
        return {
          send: function(re, ge) {
            N = W("<script>").attr(w.scriptAttrs || {}).prop({ charset: w.scriptCharset, src: w.url }).on("load error", ee = function(_e) {
              N.remove(), ee = null, _e && ge(_e.type === "error" ? 404 : 200, _e.type);
            }), P.head.appendChild(N[0]);
          },
          abort: function() {
            ee && ee();
          }
        };
      }
    });
    var Sn = [], Rr = /(=)\?(?=&|$)|\?\?/;
    W.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function() {
        var w = Sn.pop() || W.expando + "_" + gn.guid++;
        return this[w] = !0, w;
      }
    }), W.ajaxPrefilter("json jsonp", function(w, N, ee) {
      var re, ge, _e, xe = w.jsonp !== !1 && (Rr.test(w.url) ? "url" : typeof w.data == "string" && (w.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Rr.test(w.data) && "data");
      if (xe || w.dataTypes[0] === "jsonp")
        return re = w.jsonpCallback = V(w.jsonpCallback) ? w.jsonpCallback() : w.jsonpCallback, xe ? w[xe] = w[xe].replace(Rr, "$1" + re) : w.jsonp !== !1 && (w.url += (rn.test(w.url) ? "&" : "?") + w.jsonp + "=" + re), w.converters["script json"] = function() {
          return _e || W.error(re + " was not called"), _e[0];
        }, w.dataTypes[0] = "json", ge = e[re], e[re] = function() {
          _e = arguments;
        }, ee.always(function() {
          ge === void 0 ? W(e).removeProp(re) : e[re] = ge, w[re] && (w.jsonpCallback = N.jsonpCallback, Sn.push(re)), _e && V(ge) && ge(_e[0]), _e = ge = void 0;
        }), "script";
    }), Z.createHTMLDocument = function() {
      var w = P.implementation.createHTMLDocument("").body;
      return w.innerHTML = "<form></form><form></form>", w.childNodes.length === 2;
    }(), W.parseHTML = function(w, N, ee) {
      if (typeof w != "string")
        return [];
      typeof N == "boolean" && (ee = N, N = !1);
      var re, ge, _e;
      return N || (Z.createHTMLDocument ? (N = P.implementation.createHTMLDocument(""), re = N.createElement("base"), re.href = P.location.href, N.head.appendChild(re)) : N = P), ge = it.exec(w), _e = !ee && [], ge ? [N.createElement(ge[1])] : (ge = H([w], N, _e), _e && _e.length && W(_e).remove(), W.merge([], ge.childNodes));
    }, W.fn.load = function(w, N, ee) {
      var re, ge, _e, xe = this, Ue = w.indexOf(" ");
      return Ue > -1 && (re = fn(w.slice(Ue)), w = w.slice(0, Ue)), V(N) ? (ee = N, N = void 0) : N && typeof N == "object" && (ge = "POST"), xe.length > 0 && W.ajax({
        url: w,
        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: ge || "GET",
        dataType: "html",
        data: N
      }).done(function(De) {
        _e = arguments, xe.html(re ? (
          // If a selector was specified, locate the right elements in a dummy div
          // Exclude scripts to avoid IE 'Permission Denied' errors
          W("<div>").append(W.parseHTML(De)).find(re)
        ) : (
          // Otherwise use the full result
          De
        ));
      }).always(ee && function(De, qe) {
        xe.each(function() {
          ee.apply(this, _e || [De.responseText, qe, De]);
        });
      }), this;
    }, W.expr.pseudos.animated = function(w) {
      return W.grep(W.timers, function(N) {
        return w === N.elem;
      }).length;
    }, W.offset = {
      setOffset: function(w, N, ee) {
        var re, ge, _e, xe, Ue, De, qe, At = W.css(w, "position"), Bt = W(w), ct = {};
        At === "static" && (w.style.position = "relative"), Ue = Bt.offset(), _e = W.css(w, "top"), De = W.css(w, "left"), qe = (At === "absolute" || At === "fixed") && (_e + De).indexOf("auto") > -1, qe ? (re = Bt.position(), xe = re.top, ge = re.left) : (xe = parseFloat(_e) || 0, ge = parseFloat(De) || 0), V(N) && (N = N.call(w, ee, W.extend({}, Ue))), N.top != null && (ct.top = N.top - Ue.top + xe), N.left != null && (ct.left = N.left - Ue.left + ge), "using" in N ? N.using.call(w, ct) : Bt.css(ct);
      }
    }, W.fn.extend({
      // offset() relates an element's border box to the document origin
      offset: function(w) {
        if (arguments.length)
          return w === void 0 ? this : this.each(function(ge) {
            W.offset.setOffset(this, w, ge);
          });
        var N, ee, re = this[0];
        if (re)
          return re.getClientRects().length ? (N = re.getBoundingClientRect(), ee = re.ownerDocument.defaultView, {
            top: N.top + ee.pageYOffset,
            left: N.left + ee.pageXOffset
          }) : { top: 0, left: 0 };
      },
      // position() relates an element's margin box to its offset parent's padding box
      // This corresponds to the behavior of CSS absolute positioning
      position: function() {
        if (this[0]) {
          var w, N, ee, re = this[0], ge = { top: 0, left: 0 };
          if (W.css(re, "position") === "fixed")
            N = re.getBoundingClientRect();
          else {
            for (N = this.offset(), ee = re.ownerDocument, w = re.offsetParent || ee.documentElement; w && (w === ee.body || w === ee.documentElement) && W.css(w, "position") === "static"; )
              w = w.parentNode;
            w && w !== re && w.nodeType === 1 && (ge = W(w).offset(), ge.top += W.css(w, "borderTopWidth", !0), ge.left += W.css(w, "borderLeftWidth", !0));
          }
          return {
            top: N.top - ge.top - W.css(re, "marginTop", !0),
            left: N.left - ge.left - W.css(re, "marginLeft", !0)
          };
        }
      },
      // This method will return documentElement in the following cases:
      // 1) For the element inside the iframe without offsetParent, this method will return
      //    documentElement of the parent window
      // 2) For the hidden or detached element
      // 3) For body or html element, i.e. in case of the html node - it will return itself
      //
      // but those exceptions were never presented as a real life use-cases
      // and might be considered as more preferable results.
      //
      // This logic, however, is not guaranteed and can change at any point in the future
      offsetParent: function() {
        return this.map(function() {
          for (var w = this.offsetParent; w && W.css(w, "position") === "static"; )
            w = w.offsetParent;
          return w || b;
        });
      }
    }), W.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(w, N) {
      var ee = N === "pageYOffset";
      W.fn[w] = function(re) {
        return ke(this, function(ge, _e, xe) {
          var Ue;
          if (te(ge) ? Ue = ge : ge.nodeType === 9 && (Ue = ge.defaultView), xe === void 0)
            return Ue ? Ue[N] : ge[_e];
          Ue ? Ue.scrollTo(
            ee ? Ue.pageXOffset : xe,
            ee ? xe : Ue.pageYOffset
          ) : ge[_e] = xe;
        }, w, re, arguments.length);
      };
    }), W.each(["top", "left"], function(w, N) {
      W.cssHooks[N] = Ht(
        Z.pixelPosition,
        function(ee, re) {
          if (re)
            return re = It(ee, N), Fe.test(re) ? W(ee).position()[N] + "px" : re;
        }
      );
    }), W.each({ Height: "height", Width: "width" }, function(w, N) {
      W.each({
        padding: "inner" + w,
        content: N,
        "": "outer" + w
      }, function(ee, re) {
        W.fn[re] = function(ge, _e) {
          var xe = arguments.length && (ee || typeof ge != "boolean"), Ue = ee || (ge === !0 || _e === !0 ? "margin" : "border");
          return ke(this, function(De, qe, At) {
            var Bt;
            return te(De) ? re.indexOf("outer") === 0 ? De["inner" + w] : De.document.documentElement["client" + w] : De.nodeType === 9 ? (Bt = De.documentElement, Math.max(
              De.body["scroll" + w],
              Bt["scroll" + w],
              De.body["offset" + w],
              Bt["offset" + w],
              Bt["client" + w]
            )) : At === void 0 ? (
              // Get width or height on the element, requesting but not forcing parseFloat
              W.css(De, qe, Ue)
            ) : (
              // Set width or height on the element
              W.style(De, qe, At, Ue)
            );
          }, N, xe ? ge : void 0, xe);
        };
      });
    }), W.each([
      "ajaxStart",
      "ajaxStop",
      "ajaxComplete",
      "ajaxError",
      "ajaxSuccess",
      "ajaxSend"
    ], function(w, N) {
      W.fn[N] = function(ee) {
        return this.on(N, ee);
      };
    }), W.fn.extend({
      bind: function(w, N, ee) {
        return this.on(w, null, N, ee);
      },
      unbind: function(w, N) {
        return this.off(w, null, N);
      },
      delegate: function(w, N, ee, re) {
        return this.on(N, w, ee, re);
      },
      undelegate: function(w, N, ee) {
        return arguments.length === 1 ? this.off(w, "**") : this.off(N, w || "**", ee);
      },
      hover: function(w, N) {
        return this.on("mouseenter", w).on("mouseleave", N || w);
      }
    }), W.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
      function(w, N) {
        W.fn[N] = function(ee, re) {
          return arguments.length > 0 ? this.on(N, null, ee, re) : this.trigger(N);
        };
      }
    );
    var Dr = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    W.proxy = function(w, N) {
      var ee, re, ge;
      if (typeof N == "string" && (ee = w[N], N = w, w = ee), !!V(w))
        return re = o.call(arguments, 2), ge = function() {
          return w.apply(N || this, re.concat(o.call(arguments)));
        }, ge.guid = w.guid = w.guid || W.guid++, ge;
    }, W.holdReady = function(w) {
      w ? W.readyWait++ : W.ready(!0);
    }, W.isArray = Array.isArray, W.parseJSON = JSON.parse, W.nodeName = Ee, W.isFunction = V, W.isWindow = te, W.camelCase = Qe, W.type = le, W.now = Date.now, W.isNumeric = function(w) {
      var N = W.type(w);
      return (N === "number" || N === "string") && // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(w - parseFloat(w));
    }, W.trim = function(w) {
      return w == null ? "" : (w + "").replace(Dr, "$1");
    };
    var vs = e.jQuery, Ts = e.$;
    return W.noConflict = function(w) {
      return e.$ === W && (e.$ = Ts), w && e.jQuery === W && (e.jQuery = vs), W;
    }, typeof t > "u" && (e.jQuery = e.$ = W), W;
  });
})(sg);
var zw = sg.exports;
const zs = /* @__PURE__ */ pu(zw);
function J1() {
  const y = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, e = window.devicePixelRatio || 1, t = {
    width: window.screen.width * e,
    height: window.screen.height * e
  };
  return !!(y && t.width === 1125 && t.height === 2436);
}
function Q1() {
  return /android/i.test(navigator.userAgent);
}
function eS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
function Fw() {
  const y = navigator.userAgent || navigator.vendor || self.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    y
  ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    y.substr(0, 4)
  );
}
function tS() {
  const y = document.compatMode === "CSS1Compat";
  return {
    l: window.pageXOffset || (y ? document.documentElement.scrollLeft : document.body.scrollLeft),
    t: window.pageYOffset || (y ? document.documentElement.scrollTop : document.body.scrollTop),
    w: window.innerWidth || (y ? document.documentElement.clientWidth : document.body.clientWidth),
    h: window.innerHeight || (y ? document.documentElement.clientHeight : document.body.clientHeight)
  };
}
function iS(y, e, t) {
  var n = (y * 299 + e * 587 + t * 114) / 1e3;
  return n >= 128 ? "black" : "white";
}
function nS(y) {
  var e = parseInt(y.substr(0, 2), 16), t = parseInt(y.substr(2, 2), 16), n = parseInt(y.substr(4, 2), 16), s = (e * 299 + t * 587 + n * 114) / 1e3;
  return s >= 128 ? "black" : "white";
}
function oa(y, e) {
  return typeof e > "u" || typeof e === null ? !1 : function(n, s) {
    let o = s !== s, h;
    return !o && typeof Array.prototype.indexOf == "function" ? (h = Array.prototype.indexOf, h.call(n, s) > -1) : (h = function(c, m) {
      var x = -1, B = -1;
      for (x = 0; x < c.length; x++) {
        var I = c[x];
        if (o && I !== I || I === m) {
          B = x;
          break;
        }
      }
      return B;
    }, h(n, s) > -1);
  }(y, e);
}
function Uw(y) {
  y = String(y).replace(/[^0-9a-f]/gi, ""), y.length < 6 && (y = y[0] + y[0] + y[1] + y[1] + y[2] + y[2]);
  var e = parseInt(y.substr(0 * 2, 2), 16), t = parseInt(y.substr(1 * 2, 2), 16), n = parseInt(y.substr(2 * 2, 2), 16), s = Math.sqrt(e * e * 0.241 + t * t * 0.691 + n * n * 0.068);
  return s;
}
function Vw(y) {
  return Uw(y) < 130;
}
function Hw(y, e = 0) {
  y = String(y).replace(/[^0-9a-f]/gi, ""), y.length < 6 && (y = y[0] + y[0] + y[1] + y[1] + y[2] + y[2]), e = e || 0;
  var t = "#", n, s;
  for (s = 0; s < 3; s++)
    n = parseInt(y.substr(s * 2, 2), 16), n = Math.round(Math.min(Math.max(0, n + n * e), 255)).toString(16), t += ("00" + n).substr(n.length);
  return t;
}
function Yw(y, e, t, n) {
  var s = new Image(), o = zs("<canvas>"), h = o[0], c = h.getContext("2d");
  s.crossOrigin = "anonymous", s.onload = function() {
    if (o.attr({ width: s.width, height: s.height }), c = h.getContext("2d"), c) {
      c.drawImage(s, 0, 0);
      let m = ag(h, s.width, s.height, e, t);
      n && n(m);
    } else
      alert("Get a real browser!");
  }, s.src = y;
}
async function Zh(y) {
  return new Promise((e, t) => {
    const n = new Image(), s = zs("<canvas>");
    let o = s[0], h = o.getContext("2d");
    n.crossOrigin = "anonymous", n.onload = function() {
      if (s.attr({ width: n.width, height: n.height }), h = o.getContext("2d"), h) {
        h.drawImage(n, 0, 0);
        let c = Gw(o);
        e(c);
      } else
        t(new Error("HTML5 Canvas not supported"));
    }, n.src = y;
  });
}
function Gw(y) {
  const e = y.getContext("2d");
  if (!e)
    return null;
  const t = y.width, n = y.height, o = e.getImageData(0, 0, y.width, y.height).data, h = (te, P) => o[(t * P + te) * 4 + 3], c = (te) => te < 10, m = (te) => {
    const P = te ? 1 : -1;
    for (var K = te ? 0 : n - 1; te ? K < n : K > -1; K += P)
      for (var J = 0; J < t; J++)
        if (!c(h(J, K)))
          return K;
    return null;
  }, x = (te) => {
    const P = te ? 1 : -1;
    for (var K = te ? 0 : t - 1; te ? K < t : K > -1; K += P)
      for (var J = 0; J < n; J++)
        if (!c(h(K, J)))
          return K;
    return null;
  }, B = m(!0), I = m(!1), F = x(!0), M = x(!1);
  if (B != null && I != null && F != null && M != null) {
    const te = M - F + 1, P = I - B + 1, J = zs("<canvas>").attr({ width: te, height: P })[0];
    var Z = J.getContext("2d");
    if (!Z)
      return null;
    Z.drawImage(y, F, B, te, P, 0, 0, te, P), Z.getImageData(0, 0, J.width, J.height);
    var V = J.toDataURL();
    return V;
  } else
    return null;
}
async function jw(y, e, t = 30) {
  return new Promise((n, s) => {
    const o = new Image();
    o.crossOrigin = "anonymous", o.onload = () => {
      const c = zs("<canvas>").attr({ width: o.width, height: o.height })[0], m = c.getContext("2d");
      if (!m)
        return s(new Error("Canvas 2D not supported"));
      m.drawImage(o, 0, 0);
      const x = Ww(c, e, t);
      n(x);
    }, o.onerror = () => s(new Error("Failed to load image for crop")), o.src = y;
  });
}
function Ww(y, e, t) {
  const n = y.getContext("2d");
  if (!n)
    return null;
  const s = y.width, o = y.height, h = n.getImageData(0, 0, s, o).data;
  let c = 255, m = 255, x = 255, B = !1;
  if (e === "transparent")
    B = !0;
  else if (e === !0)
    h[3] < 10 ? B = !0 : (c = h[0], m = h[1], x = h[2]);
  else if (typeof e == "string") {
    const W = qw(e);
    c = W.r, m = W.g, x = W.b;
  }
  const I = (W, je) => {
    const Ee = (s * je + W) * 4;
    return B ? h[Ee + 3] < t : Math.abs(h[Ee] - c) < t && Math.abs(h[Ee + 1] - m) < t && Math.abs(h[Ee + 2] - x) < t;
  }, F = (W) => {
    const je = W ? 1 : -1;
    for (let Ee = W ? 0 : o - 1; W ? Ee < o : Ee > -1; Ee += je)
      for (let He = 0; He < s; He++)
        if (!I(He, Ee))
          return Ee;
    return null;
  }, M = (W) => {
    const je = W ? 1 : -1;
    for (let Ee = W ? 0 : s - 1; W ? Ee < s : Ee > -1; Ee += je)
      for (let He = 0; He < o; He++)
        if (!I(Ee, He))
          return Ee;
    return null;
  }, Z = F(!0), V = F(!1), te = M(!0), P = M(!1);
  if (Z == null || V == null || te == null || P == null)
    return null;
  const K = P - te + 1, J = V - Z + 1, fe = zs("<canvas>").attr({ width: K, height: J })[0], X = fe.getContext("2d");
  return X ? (X.drawImage(y, te, Z, K, J, 0, 0, K, J), fe.toDataURL()) : null;
}
function qw(y) {
  return y = y.replace(/^#/, ""), y.length === 3 && (y = y[0] + y[0] + y[1] + y[1] + y[2] + y[2]), {
    r: parseInt(y.substring(0, 2), 16),
    g: parseInt(y.substring(2, 4), 16),
    b: parseInt(y.substring(4, 6), 16)
  };
}
async function rS(y, e, t) {
  return new Promise((n, s) => {
    const o = new Image(), h = zs("<canvas>");
    let c = h[0], m = c.getContext("2d");
    o.crossOrigin = "anonymous", o.onload = function() {
      if (h.attr({ width: o.width, height: o.height }), m = c.getContext("2d"), m) {
        m.drawImage(o, 0, 0);
        let x = ag(c, o.width, o.height, e, t);
        n(x);
      } else
        s(new Error("HTML5 Canvas not supported"));
    }, o.src = y;
  });
}
function ag(y, e, t, n, s) {
  const o = y.getContext("2d");
  if (!o)
    return null;
  const c = o.getImageData(0, 0, y.width, y.height).data, m = (K, J) => c[(e * J + K) * 4 + 3], x = (K) => K === 0, B = (K) => {
    const J = K ? 1 : -1;
    for (var le = K ? 0 : t - 1; K ? le < t : le > -1; le += J)
      for (var fe = 0; fe < e; fe++)
        if (!x(m(fe, le)))
          return le;
    return null;
  }, I = (K) => {
    const J = K ? 1 : -1;
    for (var le = K ? 0 : e - 1; K ? le < e : le > -1; le += J)
      for (var fe = 0; fe < t; fe++)
        if (!x(m(le, fe)))
          return le;
    return null;
  }, F = B(!0), M = B(!1), Z = I(!0), V = I(!1);
  if (F != null && M != null && Z != null && V != null) {
    const K = V - Z, J = M - F, le = n, fe = s, X = le / K, W = fe / J;
    let je = K * X, Ee = J * X;
    Ee > fe && (je = K * W, Ee = J * W);
    const ft = zs("<canvas>").attr({ width: le, height: fe })[0];
    var te = ft.getContext("2d");
    if (!te)
      return null;
    te.drawImage(
      y,
      Z,
      F,
      K,
      J,
      (le - je) / 2,
      (fe - Ee) / 2,
      je,
      Ee
    ), te.getImageData(0, 0, ft.width, ft.height);
    var P = ft.toDataURL();
    return P;
  } else
    return null;
}
async function Zw(y, e, t, n) {
  return new Promise((s) => {
    const o = new Image();
    o.crossOrigin = "anonymous", o.onload = function() {
      let c = zs("<canvas>")[0], m = c.getContext("2d");
      if (m) {
        c.width = e, c.height = t;
        const x = Math.min(e / o.width, t / o.height), B = o.width * x, I = o.height * x;
        m.drawImage(
          o,
          0,
          0,
          o.width,
          o.height,
          (e - B + n) / 2,
          (t - I + n) / 2,
          B - n,
          I - n
        );
        const F = c.toDataURL();
        s(F);
      }
    }, o.src = y;
  });
}
function sS(y, e, t) {
  var n = zs("<canvas>");
  n.attr({ width: e, height: t });
  var s = n[0], o = s.getContext("2d");
  if (o) {
    o.fillStyle = y, o.fillRect(0, 0, e, t);
    var h = s.toDataURL();
    return h;
  } else
    return null;
}
function aS(y, e) {
  return y ? y.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function oS(y) {
  let e = 0, t, n;
  if (y.length === 0)
    return e;
  for (t = 0; t < y.length; t++)
    n = y.charCodeAt(t), e = (e << 5) - e + n, e |= 0;
  return e;
}
function lS(y) {
  var e = document.createElement("a");
  return e.href = y, e.href;
}
function og(y) {
  for (var e = atob(y.split(",")[1]), t = y.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(e.length), s = new Uint8Array(n), o = 0; o < e.length; o++)
    s[o] = e.charCodeAt(o);
  var h = new Blob([n], { type: t });
  return h;
}
function hS(y, e) {
  if (typeof y != "number" && y < 1)
    throw new RangeError("Length must be a positive integer!");
  e === void 0 && (e = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
  let t = "";
  const n = e.length;
  for (var s = 0; s < y; s++)
    t += e.charAt(Math.floor(Math.random() * n));
  return t;
}
async function uS(y, e) {
  return new Promise((t) => {
    const n = new Uint8Array(y), s = new Blob([n], { type: e }), h = (window.URL || window.webkitURL).createObjectURL(s), c = new Image();
    c.src = h, c.onload = async () => {
      const m = document.createElement("canvas"), x = m.getContext("2d");
      m.width = c.width, m.height = c.height, x.translate(0, c.height), x.scale(1, -1), x.drawImage(c, 0, 0), m.toBlob((B) => {
        const I = new FileReader();
        I.addEventListener("loadend", () => {
          const F = I.result;
          t(F);
        }), I.readAsArrayBuffer(B);
      }, e);
    };
  });
}
function rl(y) {
  return y instanceof BABYLON.PBRMaterial;
}
function cS() {
  const y = new URL(window.location.href);
  return new URLSearchParams(y.search);
}
class $w {
  constructor() {
    this.previewFiles = {};
  }
  downloadFiles() {
    function e(t, n) {
      return t.toLowerCase().indexOf(n, t.length - n.length) !== -1;
    }
    for (let t in this.previewFiles) {
      let n = null;
      const s = this.previewFiles[t];
      if (typeof s == "string" ? n = og(s) : n = s, n) {
        let o = null;
        if (e(t, ".jpeg") || e(t, ".jpg") ? o = { type: "image/jpeg" } : e(t, ".png") && (o = { type: "image/png" }), o) {
          let h = document.createElement("a");
          document.body.appendChild(h), h.setAttribute("type", "hidden"), h.download = t, h.href = window.URL.createObjectURL(new Blob([n], o)), h.click();
        }
      }
    }
  }
}
class fo {
  static async getPreviewsAsync(e, t, n, s, o = !0) {
    await e.whenReadyAsync();
    const h = new Xw(e, t, n, s), c = await h.getPreviewsAsync(o);
    return h.dispose(), c;
  }
  static async downloadPreviewsAsync(e, t, n, s) {
    (await fo.getPreviewsAsync(e, t, n, s)).downloadFiles();
  }
}
class Xw {
  constructor(e, t, n, s) {
    this._width = 256, this._height = 256, this._crop = !1, this._materials = [], this._localEngine = null, this._hostingScene = null, this._hostingSceneHelper = null, this._hostingMesh = null, this._scene = e, this._rootUrl = t, this._materialIDs = n, this._options = s || {}, this.setupPreviewSize(), this._options.crop != null && (this._crop = this._options.crop), this.readMaterials();
  }
  dispose() {
    this.disposeHostingScene(), this.disposeLocalEngine();
  }
  getLocalEngine() {
    if (!this._localEngine) {
      const e = document.createElement("canvas");
      e.id = "MaterialPreviewCanvas", e.width = 1024, e.height = 1024, this._localEngine = new BABYLON.Engine(e, !0, {
        premultipliedAlpha: !1,
        preserveDrawingBuffer: !0
      }), this._localEngine.setSize(this._width, this._height);
    }
    return this._localEngine;
  }
  disposeLocalEngine() {
    this._localEngine && this._localEngine.dispose();
  }
  disposeHostingScene() {
    this._hostingSceneHelper && (this._hostingSceneHelper.dispose(), this._hostingSceneHelper = null), this._hostingScene && (this._hostingScene.dispose(), this._hostingScene = null);
  }
  setupPreviewSize() {
    let e = this._options;
    e.width != null && e.height == null ? (this._width = e.width, this._height = e.width) : e.width == null && e.height != null ? (this._width = e.height, this._height = e.height) : e.width != null && e.height != null && (this._width = e.width, this._height = e.height);
  }
  readMaterials() {
    this._materialIDs.forEach((e) => {
      const t = this._scene.getMaterialByID(e);
      t && this._materials.push(t);
    });
  }
  async downloadPreviewsAsync() {
    (await this.getPreviewsAsync()).downloadFiles();
  }
  async getPreviewsAsync(e = !0) {
    const t = this.getLocalEngine();
    this._hostingScene = new BABYLON.Scene(t), this._hostingSceneHelper = new yi(this._hostingScene), this._hostingSceneHelper.setupCamera();
    const n = this._hostingScene.activeCamera;
    return n && (/firefox/i.test(navigator.userAgent) || new BABYLON.PassPostProcess("scale_pass", 4, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 2, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 1, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE)), new Promise((s) => {
      const o = new BABYLON.CubeTexture(
        gi.Environment.EnvironmentTextureCDNUrl,
        this._hostingScene,
        null,
        !1,
        null,
        async () => {
          if (!this._hostingScene || !this._hostingSceneHelper)
            return;
          this._hostingScene.environmentTexture = o, this._hostingSceneHelper.setupLights(), this._hostingMesh = this._hostingSceneHelper.createSphere(null), this._hostingSceneHelper.adjustCamera(void 0, void 0, void 0, !1);
          const h = new $w();
          for (let c = 0; c < this._materials.length; c++) {
            const m = this._materials[c];
            await this.createMaterialPreviewFileAsync(m, h, e);
          }
          this.disposeHostingScene(), this.disposeLocalEngine(), s(h);
        },
        null,
        void 0,
        !0,
        void 0,
        !0
      );
    });
  }
  async createMaterialPreviewFileAsync(e, t, n = !0) {
    if (this._hostingScene && this._hostingSceneHelper && this._hostingMesh) {
      const s = e.serialize(), o = BABYLON.Material.Parse(s, this._hostingScene, this._rootUrl);
      if (o) {
        this._hostingMesh.material = o, await yi.whenMeshMaterialIsReady(this._hostingMesh), this._hostingScene.render();
        let h = await this._hostingSceneHelper.takeContentScreenshotAsync(this._width, this._height);
        if (this._crop) {
          const x = await Zh(h);
          x && (h = x);
        }
        let c = o.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
        c = this.getNextIncrementalName(c, ".png", t) + ".png", Logger.info("preview: " + c);
        let m = h;
        n && (m = og(h)), t.previewFiles[c] = m;
      }
    }
  }
  getNextIncrementalName(e, t, n) {
    let s = e;
    if (e) {
      let m, x = 0;
      for (; n.previewFiles.hasOwnProperty(s + t); ) {
        if (!m) {
          m = e;
          var o = e.lastIndexOf("_");
          if (o > 0) {
            var h = e.substring(o + 1), c = parseInt(h);
            c.toString() === h && (m = e.substring(0, o));
          }
        }
        x++, s = m + "_" + x;
      }
    }
    return s;
  }
}
class Kw {
  constructor(e, t, n, s) {
    this._bias = 50, this._invertR = !1, this._invertG = !1, this._preBlurEnabled = !1, this._preBlur = 3, this._postBlurEnabled = !1, this._postBlur = 3, this._bevel = !0, this._intensity = 0.5, this._activeTextures = [], this._preBlurXTexture = null, this._preBlurYTexture = null, this._normalMapTexture = null, this._postBlurXTexture = null, this._postBlurYTexture = null, this._baseTexture = e, this._size = t, this._scene = s, this.init(n);
  }
  init(e) {
    for (this._bias = e.get("bias"), this._invertR = e.get("invertR"), this._invertG = e.get("invertG"), this._bevel = e.get("bevel"), this._intensity = e.get("intensity"), this._preBlurEnabled = e.get("preBlurEnabled"), this._preBlur = e.get("preBlur"), this._postBlurEnabled = e.get("postBlurEnabled"), this._postBlur = e.get("postBlur"); this._activeTextures.length > 0; )
      this._activeTextures.pop();
    this.updateTextures();
  }
  updateTextures() {
    let e = this.updatePreBlurTexture();
    e = this.updateNormalmapTexture(e), e = this.updatePostBlurTexture(e);
  }
  updatePreBlurTexture() {
    let e = this._baseTexture;
    return this._preBlurEnabled && (this._preBlurXTexture ? this._preBlurXTexture.baseTexture = this._baseTexture : this._preBlurXTexture = new ho("preBlurX", this._size, this._scene, this._baseTexture, void 0, !1), this._preBlurXTexture.beginInit(), this._preBlurXTexture.blur = this._preBlur, this._preBlurXTexture.refreshRate = 0, this._preBlurXTexture.endInit(), this._activeTextures.push(this._preBlurXTexture), this._preBlurYTexture ? this._preBlurYTexture.baseTexture = this._preBlurXTexture : this._preBlurYTexture = new uo("preBlurY", this._size, this._scene, this._preBlurXTexture, void 0, !1), this._preBlurYTexture.beginInit(), this._preBlurYTexture.blur = this._preBlur, this._preBlurYTexture.refreshRate = 0, this._preBlurYTexture.endInit(), this._activeTextures.push(this._preBlurYTexture), e = this._preBlurYTexture), e;
  }
  updateNormalmapTexture(e) {
    return this._normalMapTexture ? this._normalMapTexture.baseTexture = e : this._normalMapTexture = new Kd("procNormal", this._size, this._scene, e, void 0, !1), this._normalMapTexture.beginInit(), this._normalMapTexture.bias = this._bias, this._normalMapTexture.invertR = this._invertR, this._normalMapTexture.invertG = this._invertG, this._normalMapTexture.bevel = this._bevel, this._normalMapTexture.intensity = this._intensity, this._normalMapTexture.refreshRate = 0, this._normalMapTexture.endInit(), this._activeTextures.push(this._normalMapTexture), this._normalMapTexture;
  }
  updatePostBlurTexture(e) {
    let t = e;
    return this._postBlurEnabled && (this._postBlurXTexture ? this._postBlurXTexture.baseTexture = e : this._postBlurXTexture = new ho("postBlurX", this._size, this._scene, e, void 0, !1), this._postBlurXTexture && (this._postBlurXTexture.beginInit(), this._postBlurXTexture.blur = this._postBlur, this._postBlurXTexture.refreshRate = 0, this._postBlurXTexture.endInit(), this._activeTextures.push(this._postBlurXTexture), this._postBlurYTexture ? this._postBlurYTexture.baseTexture = this._postBlurXTexture : this._postBlurYTexture = new uo("postBlurY", this._size, this._scene, this._postBlurXTexture, void 0, !1), this._postBlurYTexture && (this._postBlurYTexture.beginInit(), this._postBlurYTexture.blur = this._postBlur, this._postBlurYTexture.refreshRate = 0, this._postBlurYTexture.endInit(), this._activeTextures.push(this._postBlurYTexture), t = this._postBlurYTexture))), t;
  }
  dispose() {
    this._preBlurXTexture && (this._preBlurXTexture.dispose(), this._preBlurXTexture = null), this._preBlurYTexture && (this._preBlurYTexture.dispose(), this._preBlurYTexture = null), this._normalMapTexture && (this._normalMapTexture.dispose(), this._normalMapTexture = null), this._postBlurXTexture && (this._postBlurXTexture.dispose(), this._postBlurXTexture = null), this._postBlurYTexture && (this._postBlurYTexture.dispose(), this._postBlurYTexture = null);
  }
  async getNormalMapTextureAsync(e, t) {
    return await this.updateAsync(e, t), this._activeTextures.length > 0 ? this._activeTextures[this._activeTextures.length - 1] : null;
  }
  async updateAsync(e, t) {
    if (this.init(t), this._activeTextures.length > 0) {
      this._activeTextures[0].baseTexture = e;
      for (var n = 0; n < this._activeTextures.length; n++)
        await this._activeTextures[n].isReadyAsync(), this._activeTextures[n].render();
    }
  }
}
class Jw {
  constructor(e, t, n, s) {
    this._baseTexture = e, this._size = t, this._scene = s, this._mask = new co("mask", this._size, this._scene, this._baseTexture), this._mask.backColor = new BABYLON.Vector3(0, 0, 0), this._mask.foreColor = new BABYLON.Vector3(1, 1, 1), this._mask.refreshRate = 0, this._shadow = new co("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(0.1, 0.1, 0.1), this._shadow.foreColor = new BABYLON.Vector3(1, 1, 1), this._shadow.refreshRate = 0, this._shadowBlurX = new ho("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 5, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new uo("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 5, this._shadowBlurY.refreshRate = 0, this._shadowMove = new bu("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this._lightmap = new ro("lightmap", this._size, this._scene, this._shadowMove, this._mask), this._lightmap.refreshRate = 0, this.updateParameters(n);
  }
  updateParameters(e) {
    if (e) {
      let t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        const x = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(x.r, x.g, x.b);
      }
      this._shadow.backColor = t;
      let n = 1, s = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (s = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (n = e.get("distance"));
      let o = s * Math.PI / 180;
      o = this.wrapPi(o);
      const h = Math.cos(o) * n, c = Math.sin(o) * n;
      this._shadowMove.offset = new BABYLON.Vector2(-h, c);
      let m = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (m = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = m, this._shadowBlurY.blur = m;
    }
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  dispose() {
    this._mask.dispose(), this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose(), this._lightmap.dispose();
  }
  async getInnerShadowTextureAsync(e) {
    return await this.updateAsync(e), this._lightmap;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await yi.whenTextureIsReadyAsync(this._baseTexture), this._mask.baseTexture = this._baseTexture, await this._mask.isReadyAsync(), this._mask.render(), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render(), await this._lightmap.isReadyAsync(), this._lightmap.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
class Qw {
  constructor(e, t, n, s) {
    this._size = t, this._baseTexture = e, this._scene = s, this._shadow = new co("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(1, 1, 1), this._shadow.foreColor = new BABYLON.Vector3(0.2, 0.2, 0.2), this._shadow.refreshRate = 0, this._shadowBlurX = new ho("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 15, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new uo("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 15, this._shadowBlurY.refreshRate = 0, this._shadowMove = new bu("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this.updateParameters(n);
  }
  updateParameters(e) {
    if (e) {
      var t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        var n = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(n.r, n.g, n.b);
      }
      this._shadow.foreColor = t;
      let s = 1, o = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (o = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (s = e.get("distance"));
      let h = o * Math.PI / 180;
      h = this.wrapPi(h);
      const c = Math.cos(h) * s, m = Math.sin(h) * s;
      this._shadowMove.offset = new BABYLON.Vector2(-c, m);
      let x = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (x = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = x, this._shadowBlurY.blur = x;
    }
  }
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  dispose() {
    this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose();
  }
  async getOuterShadowTextureAsync(e) {
    return await this.updateAsync(e), this._shadowMove;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await yi.whenTextureIsReadyAsync(this._baseTexture), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
globalThis && globalThis.__awaiter;
globalThis && globalThis.__generator;
function Rh(y, e, t) {
  e === void 0 && (e = 50), t === void 0 && (t = {
    isImmediate: !1
  });
  var n;
  return function() {
    for (var s = [], o = 0; o < arguments.length; o++)
      s[o] = arguments[o];
    var h = this, c = function() {
      n = void 0, t.isImmediate || y.apply(h, s);
    }, m = t.isImmediate && n === void 0;
    n !== void 0 && clearTimeout(n), n = setTimeout(c, e), m && y.apply(h, s);
  };
}
const Jf = /android/i.test(navigator.userAgent), Qf = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, lg = class As {
  constructor(e, t, n, s, o, h, c, m = !0, x, B = 0) {
    this._subMesh = null, this._isRefreshing = !1, this._showDesign = !0, this._viewRotation = 0, this._designTextureResolution = 1024, this._effect = null, this._meshSide = null, this._side = null, this._isDisposed = !1, this._baseWidth = As.DEFAULT_SIZE, this._baseHeight = As.DEFAULT_SIZE, this._textureWidth = As.DEFAULT_SIZE, this._textureHeight = As.DEFAULT_SIZE, this._coordinatesIndex = 0, this._currentVisibliity = !0, this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null, this._normalmapMaterial = null, this._originalMaterial = null, this._blankDataUrl = null, this._innerCanvasMesh = null, this._outerCanvasMesh = null, this._ownDynamicMaterial = !1, this._dynamicMaterial = null, this._dynamicTexture = null, this._normalmapTexture = null, this._dynamicOpacityTexture = null, this._ownOldDynamicMaterial = !1, this._oldDynamicMaterial = null, this._originalDiffuseTexture = null, this._combinedDiffuseTexture = null, this._originalMeshNormalmapTexture = null, this._originalDesignNormalmapTexture = null, this._meshCombinedNormalmapTexture = null, this._designCombinedNormalmapTexture = null, this._originalMeshLightmapTexture = null, this._originalDesignLightmapTexture = null, this._meshCombinedLightmapTexture = null, this._designCombinedLightmapTexture = null, this._innerShadowTexture = null, this._outerShadowTexture = null, this._context = null, this._canvas = null, this._canvasID = Zakeke.generateUUID(), this._customizer = null, this._renderingNeededListeners = [], this._proceduralNormalMap = null, this._innerShadowGenerator = null, this._outerShadowGenerator = null, this._debouncedUpdateDynamicTexture = null, this._originalViewMatrixValues = null, this._grids = [], this._lastUpdateTextureWasDynamic = !0, this.isFirstRender = !0, this._scene = e, this._sceneHelper = new yi(e), this._zkScene = t, this._mesh = n, this._subMesh = s, this._zkModel = o, this._zkDesign = h, this._grids = c, this._showDesign = m, this._viewRotation = B, x && (this._effect = x);
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e);
  }
  get rotation() {
    return this._viewRotation;
  }
  set rotation(e) {
    this._viewRotation != e && (this._viewRotation = e);
  }
  get side() {
    return this._side;
  }
  // Temporary until we can access internal matrix (speak with Matteo)
  getInternalCustomizer() {
    return this._customizer;
  }
  // Factory method for async object creation and initialization
  static async createMeshDesignManagerAsync(e, t, n, s, o, h, c, m = !0, x, B = 0) {
    const I = new As(
      e,
      t,
      n,
      s,
      o,
      h,
      c,
      m,
      x,
      B
    );
    return await I.initAsync(), I;
  }
  async initAsync() {
    const e = this._zkScene.get("rootUrl");
    e && await this._sceneHelper.unsetMeshDummyMaterialAsync(this._mesh, e, !0), this.setupMeshSide(), this.setupTextureSize(), this.checkDefaultEffect(), this.refreshModelSide(), await this.setupClonedObjectsAsync(), await this.setupCanvasAsync(), await this.setupDynamicMaterialAsync(), await this.refreshAsync();
  }
  isForMesh(e, t) {
    return !e || !this._mesh || e.id !== this._mesh.id ? !1 : !this._subMesh && !t ? !0 : !this._subMesh || !t ? !1 : t.materialIndex === this._subMesh.materialIndex;
  }
  getMeshID() {
    return this._mesh ? this._mesh.id : null;
  }
  getSubMeshIdx() {
    return this._subMesh ? this._subMesh.materialIndex : 0;
  }
  getMaterialIDForDesign() {
    let e;
    return this._effect && this._effect.get("materialID") ? e = this._effect.get("materialID") : this._mesh && this._mesh.metadata && this._mesh.metadata.designMaterialID ? e = this._mesh.metadata.designMaterialID : this._meshSide && this._meshSide.get("materialID") && (e = this._meshSide.get("materialID")), e;
  }
  getDesignConfig() {
    let e;
    return this._effect && this._effect.get("config") ? e = this._effect.get("config") : this._meshSide && this._meshSide.get("config") && (e = this._meshSide.get("config")), e || (e = new MPlaza.MeshDesignConfig()), e;
  }
  dispose() {
    this._isDisposed = !0, this._customizer && (this._customizer.clearMemoryForIOS(), this._customizer = null), this.disposeOuterInnerCanvasMeshes(), this._canvasMesh && (this._canvasMesh.dispose(), this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null), this.disposeDynamicMaterial(), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.dispose(), this._dynamicOpacityTexture = null), this._dynamicTexture && (this._dynamicTexture.dispose(), this._dynamicTexture = null), this._renderingNeededListeners = [], $("#" + this._canvasID).remove(), this.restoreOrignalMaterial(), this.disposeNormalmapMaterial(), this._proceduralNormalMap && (this._proceduralNormalMap.dispose(), this._proceduralNormalMap = null), this._innerShadowGenerator && (this._innerShadowGenerator.dispose(), this._innerShadowGenerator = null), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.dispose(), this._combinedDiffuseTexture = null), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.dispose(), this._meshCombinedNormalmapTexture = null), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.dispose(), this._designCombinedNormalmapTexture = null), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.dispose(), this._meshCombinedLightmapTexture = null), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.dispose(), this._designCombinedLightmapTexture = null);
  }
  disposeOuterInnerCanvasMeshes() {
    this._innerCanvasMesh && (this._innerCanvasMesh.dispose(), this._innerCanvasMesh = null), this._outerCanvasMesh && (this._outerCanvasMesh.dispose(), this._outerCanvasMesh = null);
  }
  disposeNormalmapMaterial() {
    this._normalmapMaterial && this._originalMaterial && this._normalmapMaterial.id !== this._originalMaterial.id && this._sceneHelper.getMeshesUsingMaterial(this._normalmapMaterial.id).length == 0 && (this._normalmapMaterial.dispose(), this._normalmapMaterial = null), this._originalMeshNormalmapTexture = null, this._originalMeshLightmapTexture = null;
  }
  disposeDynamicMaterial() {
    this._ownDynamicMaterial && this._dynamicMaterial && this._dynamicMaterial.dispose(), this._dynamicMaterial = null, this._originalDesignNormalmapTexture = null, this._originalDesignLightmapTexture = null;
  }
  disposeOldDynamicMaterial() {
    this._ownOldDynamicMaterial && this._oldDynamicMaterial && this._dynamicMaterial && this._oldDynamicMaterial != this._dynamicMaterial && this._oldDynamicMaterial.dispose(), this._oldDynamicMaterial = null;
  }
  createCanvasMeshClone(e) {
    if (this._canvasMesh) {
      const t = this._canvasMesh.clone(e + " - clone outer", null);
      if (t)
        return t.id = Zakeke.generateUUID(), this._canvasMesh.metadata && this._canvasMesh.metadata.AR !== void 0 && this._canvasMesh.metadata.AR !== null && (t.metadata || (t.metadata = {}), t.metadata.AR = this._canvasMesh.metadata.AR), t;
    }
    return null;
  }
  expandCanvasMesh(e) {
    if (!this._mesh || !this._canvasMesh)
      return;
    this.disposeOuterInnerCanvasMeshes();
    const t = this.getMeshHierarchySize(this._mesh), n = this.getMeshHierarchySize(this._canvasMesh);
    if (!t.equals(n))
      return;
    let s = 4e-3;
    e && (s += e);
    const o = 0.2;
    if (this._outerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " outer clone"), this._canvasMesh.isVisible = !1, this._outerCanvasMesh)
      if (Math.abs(t.x) <= 0.01 || Math.abs(t.y) <= 0.01 || Math.abs(t.z) <= 0.01) {
        const x = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), B = BABYLON.Vector3.FromArray(
          x,
          0
        ).normalize();
        this._outerCanvasMesh.position = this._outerCanvasMesh.position.add(B.scale(o));
      } else {
        const x = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind)], B = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.NormalKind)];
        for (var h = 0; h < x.length; h += 3) {
          const M = new BABYLON.Vector3(B[h], B[h + 1], B[h + 2]), Z = new BABYLON.Vector3(
            x[h] + M.x * s,
            x[h + 1] + M.y * s,
            x[h + 2] + M.z * s
          );
          x[h] = Z.x, x[h + 1] = Z.y, x[h + 2] = Z.z;
        }
        const I = BABYLON.VertexData.ExtractFromMesh(this._canvasMesh, !0, !0);
        I.positions = x;
        const F = new BABYLON.Geometry(this._canvasMesh.name + " outer geometry", this._scene);
        I.applyToGeometry(F), F.applyToMesh(this._outerCanvasMesh), this._scene.render();
      }
  }
  // Nel caso in cui la mesh non sia un piano, espande la mesh clone in modo che
  // racchiuda quella originale e che eviti il problema z- fighting.
  // Nel caso in cui si tratti di un piano (o di un disco o equivalenti), la mesh clone verrà solo
  // spostata leggermente nella direzione della normale al piano
  // Tale possibilità verrà sfruttata soprattutto in fase di esportazione in altro formato che non preveda
  // proprietà simili al zOffset di Babylon JS
  expandCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh)
      return;
    const e = 0.01, t = 1 + e, n = this.getMeshHierarchySize(this._mesh), s = this.getMeshHierarchySize(this._canvasMesh);
    if (!n.equals(s))
      return;
    const o = 0.1;
    if (Math.abs(n.x) <= o || Math.abs(n.y) <= o || Math.abs(n.z) <= o) {
      let c = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), m = BABYLON.Vector3.FromArray(
        c,
        0
      ).normalize();
      this._canvasMesh.position = this._canvasMesh.position.add(m.scale(e));
    } else {
      let c = this._canvasMesh.scaling;
      c = c.multiplyByFloats(t, t, t), this._canvasMesh.scaling = c;
      let m = this.getMeshHierarchyCenter(this._mesh), x = this.getMeshHierarchyCenter(this._canvasMesh);
      const B = m.subtract(x);
      B.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(B);
    }
  }
  contractCanvasMesh() {
    this._canvasMesh && (this._canvasMesh.isVisible = !0), this.disposeOuterInnerCanvasMeshes();
  }
  // Riporta la mesh clone allo stato originale, continuando a sfruttare unicamente la proprietà
  // zOffset per superare il problema dello z-fighting
  contractCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh || !this._originalCanvasMeshScaling || !this._originalCanvasMeshPosition)
      return;
    this._canvasMesh.scaling = this._originalCanvasMeshScaling, this._canvasMesh.position = this._originalCanvasMeshPosition;
    const e = this.getMeshHierarchyCenter(this._mesh), t = this.getMeshHierarchyCenter(this._canvasMesh), n = e.subtract(t);
    n.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(n);
  }
  setupMeshSide() {
    if (this._meshSide = null, this._coordinatesIndex = 0, this._zkModel && this._mesh && this._mesh.id)
      for (let n = 0; n < this._zkModel.get("scenes").length; n++) {
        var e = this._zkModel.get("scenes").at(n);
        if (e.get("isDefault"))
          for (let s = 0; s < e.get("meshSides").length; s++) {
            var t = e.get("meshSides").at(s);
            if (t.get("meshID") == this._mesh.id) {
              this._meshSide = t, this._meshSide.get("uvChannel") >= 0 && (this._coordinatesIndex = this._meshSide.get("uvChannel"));
              return;
            }
          }
      }
  }
  setupTextureSize() {
    this._meshSide && (!Jf && !Qf ? (this._baseWidth = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionWidth() ?? As.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionHeight() ?? As.DEFAULT_SIZE) : Jf ? (this._baseWidth = this._meshSide.getOrCreateConfig().getMobileTextureResolutionWidth() ?? As.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getMobileTextureResolutionHeight() ?? As.DEFAULT_SIZE) : Qf && (this._baseWidth = 512, this._baseHeight = 512)), console.log("Texture size: " + this._baseWidth + "x" + this._baseHeight);
  }
  checkDefaultEffect() {
    if (!this._effect && this._meshSide) {
      var e = this._meshSide.getParentModel();
      if (e && e instanceof MPlaza.ModelScene) {
        let t = this.getMeshID();
        if (t) {
          let n = e.getDefaultDesignEffect(t, this.getSubMeshIdx());
          n && (this._effect = n);
        }
      }
    }
  }
  getAllSides() {
    const e = [];
    return this._zkModel.get("colors").each((t) => {
      t.get("sides").each((n) => {
        e.find((s) => s.get("sideID") == n.get("sideID")) || e.push(n);
      });
    }), e;
  }
  // Recupera il lato del modello corrispondente alla mesh in input
  // Del lato abbiamo solo sideID, mentre per il modello i lati sono per colore. Recuperiamo il colorID
  // in base agli elementi del design, considerando buono il primo colore con elementi grafici
  refreshModelSide() {
    if (this._side = null, this._meshSide && this._zkDesign) {
      const e = this._meshSide.get("sideID"), t = this._meshSide.tempID;
      let n = null;
      if (n = this.getAllSides().find(function(s) {
        return s.get("sideID") == e;
      }) || null, n) {
        let s = null;
        for (const o of this._zkDesign.get("designItems").models)
          if (s = o, s.isOnSide(n)) {
            const h = s && s.get("areas").length > 0 ? s.get("areas").at(0).get("colorID") : null;
            h && this._zkModel.get("colors").each(function(c) {
              c.get("colorID") == h && c.get("sides").each(function(m) {
                (m.tempID ? m.tempID == t : m.get("sideID") == e) && (n = m);
              });
            });
            break;
          }
        this._side = n;
      }
    }
  }
  async setupClonedObjectsAsync() {
    if (this._side) {
      for (var e = 0; e < this._scene.meshes.length; e++) {
        let t = this._scene.meshes[e];
        if (t && t.metadata && t.metadata.originalMeshID && t.metadata.originalMeshID == this._mesh.id) {
          this._canvasMesh = t, this._canvasMesh.isVisible = this._currentVisibliity, this._normalmapMaterial = this._mesh.material, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
          break;
        }
      }
      if (!this._canvasMesh) {
        let t = this._mesh.name + " - clone";
        this._canvasMesh = this._mesh.clone(t, null), this._canvasMesh && (this._canvasMesh.id = Zakeke.generateUUID(), this._canvasMesh.isVisible = this._currentVisibliity, this._canvasMesh.doNotSerialize = !0, this._canvasMesh.isPickable = !1, this._canvasMesh.metadata = {}, this._canvasMesh.metadata.originalMeshID = this._mesh.id, this._canvasMesh.metadata.isRealMesh = !1, this._canvasMesh.metadata.iscanvasMesh = !0, this._mesh.metadata && this._mesh.metadata.AR !== void 0 && this._mesh.metadata.AR !== null && (this._canvasMesh.metadata.AR = this._mesh.metadata.AR));
      }
      this._canvasMesh && (this._originalCanvasMeshPosition = this._canvasMesh.position, this._originalCanvasMeshScaling = this._canvasMesh.scaling), this._normalmapMaterial || await this.setupNormalmapMaterialAsync();
    }
  }
  // Prepara il materiale per la normalmap da applicare alla mesh originale
  // posizionata sotto quella su cui è apposto il design.
  // Tale materiale viene utilizzato anche per l'eventuale lightmap di dropshadow (outer shadow)
  // quindi il nome andrebbe cambiato
  async setupNormalmapMaterialAsync() {
    this.disposeNormalmapMaterial(), this._originalMaterial = this._mesh.material;
    let e = Zakeke.generateUUID(), t = "normalmapMaterial - " + e;
    this._originalMaterial ? (t = this._originalMaterial.name + " - normalmap", this._normalmapMaterial = await this.cloneMaterialAsync(this._originalMaterial, t)) : this._normalmapMaterial = new BABYLON.StandardMaterial(t, this._scene), this._normalmapMaterial && (this._normalmapMaterial.id = e, this._normalmapMaterial.doNotSerialize = !0, this._normalmapMaterial.metadata = {}, this._originalMaterial ? this._normalmapMaterial.metadata.originalMaterialID = this._originalMaterial.id : this._normalmapMaterial.metadata.originalMaterialID = null, this._normalmapMaterial.metadata.isRealMaterial = !1, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial));
  }
  // private getOriginalTexture(): BABYLON.Texture | null {
  //     if (this._originalMaterial) {
  //         var propertyName = this.getMaterialDiffuseTexturePropertyName(this._originalMaterial);
  //         if (!this._originalMaterial[propertyName])
  //             return null;
  //         return this._originalMaterial[propertyName];
  //     }
  //     return null;
  // }
  getMaterialDiffuseTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "baseTexture" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? "albedoTexture" : "diffuseTexture";
  }
  getMaterialOpacityTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "opacityTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? null : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "opacityTexture");
  }
  getMaterialNormalmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "bumpTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "normalTexture" : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "bumpTexture");
  }
  getMaterialLightmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "ambientTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "occlusionTexture" : e instanceof BABYLON.PBRMaterial ? "ambientTexture" : e instanceof Zakeke.PBRMaterial ? "aoTexture" : "lightmapTexture";
  }
  getMaterialDiffuse(e) {
    let t = this.getMaterialDiffuseTexturePropertyName(e);
    return e[t];
  }
  getMaterialNormalmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialNormalmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialLightmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialLightmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialOpacity(e) {
    if (!e)
      return null;
    let t = this.getMaterialOpacityTexturePropertyName(e);
    return t ? e[t] : null;
  }
  setMaterialLightmap(e, t) {
    if (e) {
      var n = this.getMaterialLightmapTexturePropertyName(e);
      n && (e[n] = t, e instanceof Zakeke.PBRMaterial && (e.useAOTextureAsLightmap = !0));
    }
  }
  setTextureWrapping(e) {
    e && (e.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, e.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
  }
  async setupCanvasAsync() {
    if (this._side && this._canvasMesh && this._meshSide && !this._isRefreshing) {
      this._isRefreshing = !0;
      var e = this._baseWidth;
      this._meshSide.get("percWidth") > 0 && (e *= this._meshSide.get("percWidth"));
      var t = this._baseHeight;
      this._meshSide.get("percHeight") > 0 && (t *= this._meshSide.get("percHeight")), this._textureWidth = e, this._textureHeight = t;
      var n = $("<canvas>", { id: this._canvasID }).attr({ width: e, height: t });
      this._canvas = n[0], this._context = this._canvas.getContext("2d"), this._context && (this._context.imageSmoothingQuality = "high", this._context.imageSmoothingEnabled = !0, this._customizer = new MPlaza.Customizer(!0, !1, this._canvas, !0), this._blankDataUrl = this._canvas.toDataURL(), this._customizer.showSideImage = !1, this._customizer.model = this._zkModel, this._customizer.fitToScreenMargin = this._zkScene.getFitToScreenMargin(), this._customizer.setGrids(this._grids), this._customizer.setDesign(this._zkDesign), await new Promise(async (s) => {
        var o, h;
        await ((o = this._customizer) == null ? void 0 : o.setSide(this._side)), (h = this._customizer) == null || h.refresh({ boundsToAreas: !0 }, async () => {
          if (this._customizer) {
            if (this._meshSide) {
              let c = this._meshSide.get("matrix");
              if (c) {
                const m = JSON.parse(c);
                let x = new this._customizer.paper.Matrix(m);
                this._customizer.paper.view.matrix = x, this._customizer.paper.view.update();
              }
            }
            await this.updateDynamicTextureAsync();
          }
          s();
        });
      }));
    }
    this._isRefreshing = !1;
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._customizer) == null || t.setGrids(e);
  }
  // Ripristino il materiale originale sulla mesh, a meno che non sia stato già cambiato
  restoreOrignalMaterial() {
    this._mesh && this._originalMaterial && this._mesh.material && this._normalmapMaterial && this._mesh.material.id === this._normalmapMaterial.id && (this._mesh.material = this._originalMaterial);
  }
  getMeshesUsingMaterial(e) {
    for (var t = [], n = this._scene.meshes, s = 0; s < n.length; s++) {
      var o = n[s];
      if (o.material) {
        if (o.material.id == e)
          t.push(o);
        else if (o.material instanceof BABYLON.MultiMaterial)
          for (var h = 0; h < o.material.subMaterials.length; h++) {
            let c = o.material.subMaterials[h];
            if (c != null && c.id === e) {
              t.push(o);
              break;
            }
          }
      }
    }
    return t;
  }
  async checkNormalmapMaterialAsync() {
    this._mesh && this._normalmapMaterial && (!this._mesh.material || this._mesh.material.id !== this._normalmapMaterial.id) && await this.setupNormalmapMaterialAsync();
  }
  // Se il materiale associato alla mesh è cambiato lo ricrea
  async checkDynamicMaterialAsync() {
    let e = this.getMaterialIDForDesign();
    e && this._side && this._canvasMesh && this._meshSide && this._dynamicMaterial && this._dynamicMaterial.id != e && await this.setupDynamicMaterialAsync();
  }
  async setupDynamicMaterialAsync() {
    if (this._side && this._canvasMesh && this._meshSide) {
      this._ownOldDynamicMaterial = this._ownDynamicMaterial, this._oldDynamicMaterial = this._dynamicMaterial;
      var e = this.getMaterialIDForDesign();
      if (e) {
        this._zkScene.get("rootUrl") && await this._sceneHelper.loadDelayedMaterialAsync(this._zkScene.get("rootUrl"), e);
        let t = this._scene.getMaterialById(e);
        t && (this._dynamicMaterial = await this.cloneMaterialAsync(t, t.name + " - clone"), this._ownDynamicMaterial = !0);
      }
      if (!this._dynamicMaterial) {
        if (this._mesh.material && this._mesh.material instanceof BABYLON.PBRBaseMaterial) {
          const t = new BABYLON.PBRMaterial(
            "dynamicMaterial",
            this._scene
          );
          t.enableSpecularAntiAliasing = !0, t.backFaceCulling = !1, t.albedoColor = BABYLON.Color3.White(), t.reflectivityColor = BABYLON.Color3.Black(), t.transparencyMode = this._zkScene.getDefaultDesignMaterialTransparencyMode(), t.useAlphaFromAlbedoTexture = !0, this._mesh.material.subSurface.indexOfRefraction != null && (t.subSurface.indexOfRefraction = this._mesh.material.subSurface.indexOfRefraction), rl(this._mesh.material) && this._mesh.material.roughness != null && (t.roughness = this._mesh.material.roughness), rl(this._mesh.material) && this._mesh.material.metallic != null && (t.metallic = this._mesh.material.metallic), rl(this._mesh.material) && this._mesh.material.reflectionTexture != null && (t.reflectionTexture = this._mesh.material.reflectionTexture), rl(this._mesh.material) && this._mesh.material.microSurface != null && (t.microSurface = this._mesh.material.microSurface), this._dynamicMaterial = t;
        } else
          this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene), this._dynamicMaterial.backFaceCulling = !1, this._dynamicMaterial.specularColor = BABYLON.Color3.Black(), this._dynamicMaterial.ambientColor = BABYLON.Color3.White(), this._dynamicMaterial.diffuseColor = BABYLON.Color3.White();
        this._dynamicMaterial.id = Zakeke.generateUUID(), this._ownDynamicMaterial = !0;
      }
      this._dynamicMaterial.zOffset = -1, this._dynamicMaterial.metadata = { isRealMaterial: !1 }, this._dynamicMaterial.doNotSerialize = this._ownDynamicMaterial, this._originalDiffuseTexture = this.getMaterialDiffuse(this._dynamicMaterial), this._originalDesignNormalmapTexture = this.getMaterialNormalmap(this._dynamicMaterial), this._originalDesignLightmapTexture = this.getMaterialLightmap(this._dynamicMaterial);
    }
  }
  /*
      private whenTextureIsReadyAsync(texture: BABYLON.BaseTexture): Promise<void> {
          return new Promise<void>((resolve, reject) => {
  
              let t = setInterval(() => {
                  if (texture.isReady()) {
                      clearInterval(t);
                      if (texture instanceof BABYLON.ProceduralTexture)
                          texture.getEffect();
                      resolve();
                  }
              }, 5);
  
          });
      }
      */
  async cloneMaterialAsync(e, t) {
    if (e) {
      var n = e.getActiveTextures();
      n.forEach(async (o) => {
        await yi.whenTextureIsReadyAsync(o);
      });
      var s = t || e.name + " - clone";
      if (e instanceof BABYLON.ShaderMaterial) {
        const o = this._zkScene.get("rootUrl");
        if (!o)
          return null;
        let h = e.serialize();
        return BABYLON.Material.Parse(h, this._scene, o);
      } else
        return e.clone(s);
    }
    return null;
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    let t = e.getHierarchyBoundingVectors(!0), n = t.max.subtract(t.min);
    return t.min.add(n.scale(0.5));
  }
  async refreshAsync(e) {
    this._isRefreshing || (this._isRefreshing = !0, typeof e < "u" && (this._effect = e), await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync(), this.refreshModelSide(), await new Promise(async (t) => {
      var n, s, o;
      if (this._meshSide && this.side && this._customizer) {
        if (await ((n = this._customizer) == null ? void 0 : n.setSide(this.side)), await ((s = this._customizer) == null ? void 0 : s.updateGrids()), (o = this._customizer) == null || o.adaptZoomToSideAreas(!1), this._meshSide && this._customizer) {
          let h = this._meshSide.get("matrix");
          if (h) {
            const c = JSON.parse(h);
            let m = new this._customizer.paper.Matrix(c);
            if (this._customizer.paper.view.matrix = m, this._customizer.paper.view.rotation += -this._viewRotation, this._textureWidth !== 1024) {
              const x = 1024 / this._textureWidth;
              let B = new paper.Matrix();
              B = B.scale(1 / x, 1 / x);
              const I = m.prepend(B);
              this._customizer.paper.view.matrix = I;
            }
          } else
            this._customizer.paper.view.rotation = -this._viewRotation;
          this._customizer.paper.view.update();
        }
        await this.updateDynamicTextureAsync(), t();
      } else
        t();
    }), this._isRefreshing = !1);
  }
  async updateDynamicTextureAsync() {
    if (this.isFirstRender) {
      await this.updateDynamicTextureInternalAsync(), this.isFirstRender = !1;
      return;
    }
    this._debouncedUpdateDynamicTexture || (this._debouncedUpdateDynamicTexture = Rh(this.updateDynamicTextureInternalAsync, 10)), this._debouncedUpdateDynamicTexture();
  }
  async updateDynamicTextureInternalAsync(e = !0) {
    if (Logger.info("updateDynamicTextureInternal"), !this._side || !this._meshSide || !this._canvas || !this._canvasMesh || !this._dynamicMaterial)
      return;
    const t = this.getDesignConfig(), n = this._lastUpdateTextureWasDynamic != e;
    this._lastUpdateTextureWasDynamic = e, await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync();
    let s = t.getDiffuseEnabled(), o = t.getDiffuseBlendMode(), h = t.getDiffuseLevel();
    o !== "normal" && o !== "multiply" && o !== "overlay" && (o = "normal");
    const c = t.getOpacityEnabled();
    t.getOrCreateOpacityConfig();
    const m = t.getNormalmapEnabled(), x = t.getOrCreateNormalmapConfig(), B = t.getInnerShadowEnabled(), I = t.getOrCreateInnerShadowConfig(), F = t.getOuterShadowEnabled(), M = t.getOrCreateOuterShadowConfig();
    let Z = "diffuseTexture";
    const V = this._meshSide.get("materialTexture");
    V ? Z = V : Z = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
    let te = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial), P = this._dynamicTexture;
    n && P && (P.dispose(), this._dynamicTexture = null);
    let K = this._canvas.toDataURL(), J = K == this._blankDataUrl, le = this.dataURItoBlob(K), X = (window.URL || window.webkitURL).createObjectURL(le);
    this._dynamicTexture || (e ? (this._dynamicTexture = new BABYLON.DynamicTexture("dynamicTexture", this._canvas, this._scene), this._dynamicTexture.hasAlpha = !0) : (this._dynamicTexture = new BABYLON.Texture(X, this._scene), this._dynamicTexture.hasAlpha = !0)), e ? this._dynamicTexture.update() : await yi.whenTextureIsReadyAsync(this._dynamicTexture), !J && this._dynamicTexture && (m && await this.updateNormalmapTextureAsync(x), B && await this.updateInnerShadowTextureAsync(I), F && await this.updateOuterShadowTextureAsync(M), c && await this.updateOpacityTextureAsync(), this._originalDiffuseTexture && s && o !== "normal" && await this.combineDiffuseTexturesAsync(o, h), this._showDesign && (s && Z && (o === "normal" || !this._originalDiffuseTexture || !this._combinedDiffuseTexture ? (this._dynamicTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicTexture), this._dynamicMaterial[Z] = this._dynamicTexture) : this._combinedDiffuseTexture && (this._combinedDiffuseTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._combinedDiffuseTexture), this._dynamicMaterial[Z] = this._combinedDiffuseTexture), this._dynamicMaterial[Z].hasAlpha = !1, this._dynamicMaterial[Z].hasAlpha = !0), !s && Z && !this.compareTextures(
      this._dynamicMaterial[Z],
      this._originalDiffuseTexture
    ) && (this._dynamicMaterial[Z] = this._originalDiffuseTexture), c && te && this._dynamicOpacityTexture && (this._dynamicOpacityTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicOpacityTexture), this._dynamicMaterial instanceof BABYLON.ShaderMaterial ? this._dynamicMaterial.setTexture(
      te,
      this._dynamicOpacityTexture
    ) : this._dynamicMaterial[te] = this._dynamicOpacityTexture), !c && te && (this._dynamicMaterial[te] = null), this._canvasMesh.material !== this._dynamicMaterial && (this._canvasMesh.material = this._dynamicMaterial), m && this._normalmapTexture ? await this.setNormalmapTextureAsync(x) : (this.resetMeshNormalmapTexture(), this.resetDesignNormalmapTexture()), B && this._innerShadowTexture ? await this.setInnerShadowTextureAsync(I) : this.removeInnerShadowTexture(), F && this._outerShadowTexture ? await this.setOuterShadowTextureAsync(M) : this.removeOuterShadowTexture(), this.disposeOldDynamicMaterial(), this._canvasMesh.isVisible = this._currentVisibliity && t.getShowDesign())), J && (this._canvasMesh.isVisible = !1), this.fireRenderingNeededEvent();
  }
  resetDynamicTextures() {
    if (this._dynamicMaterial) {
      let e = "diffuseTexture";
      const t = this._meshSide ? this._meshSide.get("materialTexture") : null;
      t ? e = t : e = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial), e && !this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDiffuseTexture
      ) && (this._dynamicMaterial[e] = this._originalDiffuseTexture || new BABYLON.Texture(this._blankDataUrl, this._scene), this._dynamicMaterial[e].hasAlpha = !1, this._dynamicMaterial[e].hasAlpha = !0), this.resetDesignNormalmapTexture();
      let n = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
      n && (this._dynamicMaterial[n] = null), this.removeInnerShadowTexture();
    }
    this._normalmapMaterial && (this.resetMeshNormalmapTexture(), this.removeOuterShadowTexture());
  }
  async updateOpacityTextureAsync() {
    this._dynamicTexture && (await yi.whenTextureIsReadyAsync(this._dynamicTexture), this._dynamicOpacityTexture || (this._dynamicOpacityTexture = new co(
      "dynamicOpacity",
      this._textureWidth,
      this._scene,
      this._dynamicTexture
    ), this._dynamicOpacityTexture.backColor = new BABYLON.Vector3(0, 0, 0), this._dynamicOpacityTexture.foreColor = new BABYLON.Vector3(1, 1, 1), this._dynamicOpacityTexture.refreshRate = 0, this._dynamicOpacityTexture.getAlphaFromRGB = !0), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.baseTexture = this._dynamicTexture, await yi.whenTextureIsReadyAsync(this._dynamicOpacityTexture), this._dynamicOpacityTexture.render()));
  }
  async combineDiffuseTexturesAsync(e, t) {
    if (!this._originalDiffuseTexture || !this._dynamicTexture)
      return;
    await yi.whenTextureIsReadyAsync(this._originalDiffuseTexture), await yi.whenTextureIsReadyAsync(this._dynamicTexture);
    const n = t === 0 ? this._dynamicTexture : this._originalDiffuseTexture, s = t === 0 ? this._originalDiffuseTexture : this._dynamicTexture;
    this._combinedDiffuseTexture || (e == "multiply" ? this._combinedDiffuseTexture = new ro(
      "multiplyDiffuse",
      this._textureWidth,
      this._scene,
      n,
      s
    ) : this._combinedDiffuseTexture = new dl(
      "overlayDiffuse",
      this._textureWidth,
      this._scene,
      n,
      s
    ), this._combinedDiffuseTexture.refreshRate = 0), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.baseTexture = n, this._combinedDiffuseTexture.blendTexture = s, await yi.whenTextureIsReadyAsync(this._combinedDiffuseTexture), this._combinedDiffuseTexture.render());
  }
  // NORMAL MAP
  async updateNormalmapTextureAsync(e) {
    this._dynamicTexture && (await yi.whenTextureIsReadyAsync(this._dynamicTexture), this._proceduralNormalMap || (this._proceduralNormalMap = new Kw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    )), this._normalmapTexture = await this._proceduralNormalMap.getNormalMapTextureAsync(
      this._dynamicTexture,
      e
    ), this._normalmapTexture && (this._normalmapTexture.coordinatesIndex = this._coordinatesIndex));
  }
  // Aggiorna i materiali con la normalmapTexture
  // La complicazione principale qui è che le normalmap eventualmente devono essere combinate con quelle preesistenti
  // sul materiale. Inoltre, essendo i materiali clonati (per non modificare quelli originari) è necessario controllare
  // che le texture siano pronte
  async setNormalmapTextureAsync(e) {
    var s;
    let t = this._normalmapTexture, n = this._normalmapTexture;
    if (e.get("showOnMesh") && this._originalMeshNormalmapTexture && this._normalmapTexture && (await this.combineMeshNormalmapTexturesAsync(), this._meshCombinedNormalmapTexture && (t = this._meshCombinedNormalmapTexture)), e.get("showOnDesign") && this._originalDesignNormalmapTexture && this._normalmapTexture && (await this.combineDesignNormalmapTexturesAsync(), this._designCombinedNormalmapTexture && (n = this._designCombinedNormalmapTexture)), this._normalmapMaterial && t) {
      t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t);
      const o = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      e.get("showOnMesh") ? this._normalmapMaterial[o] = t : this.resetMeshNormalmapTexture(), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial, this._mesh.metadata || (this._mesh.metadata = {}), this._mesh.metadata.originalNormalmapMaterialID = (s = this._originalMaterial) == null ? void 0 : s.id);
    }
    if (this._dynamicMaterial && n) {
      n.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(n);
      const o = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      e.get("showOnDesign") ? this._dynamicMaterial[o] = n : this.resetDesignNormalmapTexture();
    }
  }
  async combineMeshNormalmapTexturesAsync() {
    !this._originalMeshNormalmapTexture || !this._normalmapTexture || (await yi.whenTextureIsReadyAsync(this._originalMeshNormalmapTexture), await yi.whenTextureIsReadyAsync(this._normalmapTexture), this._meshCombinedNormalmapTexture || (this._meshCombinedNormalmapTexture = new dl(
      "overlayMeshNormal",
      this._textureWidth,
      this._scene,
      this._originalMeshNormalmapTexture,
      this._normalmapTexture
    ), this._meshCombinedNormalmapTexture.refreshRate = 0), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.baseTexture = this._originalMeshNormalmapTexture, this._meshCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await yi.whenTextureIsReadyAsync(this._meshCombinedNormalmapTexture), this._meshCombinedNormalmapTexture.render()));
  }
  resetMeshNormalmapTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      this.compareTextures(
        this._normalmapMaterial[e],
        this._originalMeshNormalmapTexture
      ) || (this._originalMeshNormalmapTexture ? this._normalmapMaterial[e] = this._originalMeshNormalmapTexture : this._normalmapMaterial[e] = null);
    }
  }
  resetDesignNormalmapTexture() {
    if (this._dynamicMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDesignNormalmapTexture
      ) || (this._originalDesignNormalmapTexture ? this._dynamicMaterial[e] = this._originalDesignNormalmapTexture : this._dynamicMaterial[e] = null);
    }
  }
  async combineDesignNormalmapTexturesAsync() {
    !this._originalDesignNormalmapTexture || !this._normalmapTexture || (await yi.whenTextureIsReadyAsync(this._originalDesignNormalmapTexture), await yi.whenTextureIsReadyAsync(this._normalmapTexture), this._designCombinedNormalmapTexture || (this._designCombinedNormalmapTexture = new dl(
      "overlayDesignNormal",
      this._textureWidth,
      this._scene,
      this._originalDesignNormalmapTexture,
      this._normalmapTexture
    ), this._designCombinedNormalmapTexture.refreshRate = 0), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.baseTexture = this._originalDesignNormalmapTexture, this._designCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await yi.whenTextureIsReadyAsync(this._designCombinedNormalmapTexture), this._designCombinedNormalmapTexture.render()));
  }
  // INNER SHADOW
  async updateInnerShadowTextureAsync(e) {
    this._dynamicTexture && (await yi.whenTextureIsReadyAsync(this._dynamicTexture), this._innerShadowGenerator ? await this._innerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._innerShadowGenerator = new Jw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._innerShadowTexture = await this._innerShadowGenerator.getInnerShadowTextureAsync(
      this._dynamicTexture
    ), this._innerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setInnerShadowTextureAsync(e) {
    let t = this._innerShadowTexture;
    this._originalDesignLightmapTexture && this._innerShadowTexture && (await this.combineDesignLightmapTexturesAsync(), this._designCombinedLightmapTexture && (t = this._designCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._dynamicMaterial, t));
  }
  async combineDesignLightmapTexturesAsync() {
    !this._originalDesignLightmapTexture || !this._innerShadowTexture || (await yi.whenTextureIsReadyAsync(this._originalDesignLightmapTexture), await yi.whenTextureIsReadyAsync(this._innerShadowTexture), this._designCombinedLightmapTexture || (this._designCombinedLightmapTexture = new ro(
      "overlayDesignLightmaps",
      this._textureWidth,
      this._scene,
      this._originalDesignLightmapTexture,
      this._innerShadowTexture
    ), this._designCombinedLightmapTexture.refreshRate = 0), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.baseTexture = this._originalDesignLightmapTexture, this._designCombinedLightmapTexture.blendTexture = this._innerShadowTexture, await yi.whenTextureIsReadyAsync(this._designCombinedLightmapTexture), this._designCombinedLightmapTexture.render()));
  }
  removeInnerShadowTexture() {
    if (this._dynamicMaterial) {
      let e = this.getMaterialLightmap(this._dynamicMaterial), t = this._originalDesignLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._dynamicMaterial, t);
    }
  }
  // OUTER SHADOW
  async updateOuterShadowTextureAsync(e) {
    this._dynamicTexture && (await yi.whenTextureIsReadyAsync(this._dynamicTexture), this._outerShadowGenerator ? await this._outerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._outerShadowGenerator = new Qw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._outerShadowTexture = await this._outerShadowGenerator.getOuterShadowTextureAsync(
      this._dynamicTexture
    ), this._outerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setOuterShadowTextureAsync(e) {
    let t = this._outerShadowTexture;
    this._originalMeshLightmapTexture && this._outerShadowTexture && (await this.combineMeshLightmapTexturesAsync(), this._meshCombinedLightmapTexture && (t = this._meshCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._normalmapMaterial, t), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial));
  }
  async combineMeshLightmapTexturesAsync() {
    !this._originalMeshLightmapTexture || !this._outerShadowTexture || this._isDisposed || (await yi.whenTextureIsReadyAsync(this._originalMeshLightmapTexture), await yi.whenTextureIsReadyAsync(this._outerShadowTexture), this._meshCombinedLightmapTexture || (this._meshCombinedLightmapTexture = new ro(
      "overlayMeshLightmap",
      this._textureWidth,
      this._scene,
      this._originalMeshLightmapTexture,
      this._outerShadowTexture
    ), this._meshCombinedLightmapTexture.refreshRate = 0), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.baseTexture = this._originalMeshLightmapTexture, this._meshCombinedLightmapTexture.blendTexture = this._outerShadowTexture, await yi.whenTextureIsReadyAsync(this._meshCombinedLightmapTexture), this._meshCombinedLightmapTexture.render()));
  }
  removeOuterShadowTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialLightmap(this._normalmapMaterial), t = this._originalMeshLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._normalmapMaterial, t);
    }
  }
  compareTextures(e, t) {
    return typeof e > "u" && typeof t > "u" || e === null && t === null ? !0 : !e || !t ? !1 : e === t;
  }
  dataURItoBlob(e) {
    let t = atob(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], s = new ArrayBuffer(t.length), o = new Uint8Array(s);
    for (let c = 0; c < t.length; c++)
      o[c] = t.charCodeAt(c);
    return new Blob([s], { type: n });
  }
  downloadImage(e, t) {
    let n = this.dataURItoBlob(e), s = window.URL.createObjectURL(n), o = t || "image.png", h = document.createElement("a");
    h.download = o, h.innerHTML = "Download File", h.href = s, h.onclick = (c) => {
      document.body.removeChild(h);
    }, h.style.display = "none", h.setAttribute("type", "hidden"), document.body.appendChild(h), h.click();
  }
  setDesignMeshVisibility(e) {
    this._currentVisibliity = e, this._canvasMesh && (this._canvasMesh.isVisible = e);
  }
  getItemsInfo() {
    return this._customizer ? this._customizer.getItemsInfo() : [];
  }
  removeItem(e) {
    this._customizer && this._customizer.removeItemByGuid(e);
  }
  addItemText(e) {
    this._customizer && this._customizer.addTextElement(null, e, !1);
  }
  setItemText(e, t) {
    var n, s, o;
    this._customizer && (this._customizer.modifyTextElementContentByGuid(e, t), (o = (s = (n = this._customizer.paper) == null ? void 0 : n.project) == null ? void 0 : s.view) == null || o.update());
  }
  async refreshTextureOnly() {
    var e, t, n;
    this._customizer && ((n = (t = (e = this._customizer.paper) == null ? void 0 : e.project) == null ? void 0 : t.view) == null || n.update()), await this.updateDynamicTextureInternalAsync(!0);
  }
  /**
   * Get font weights from font variations
   * Returns array of {style, weight} for available font faces
   */
  getFontWeights(e) {
    let t = e.faces.map((F) => F.variation), n = t.filter((F) => F.startsWith("i")).map((F) => parseInt(F.charAt(F.length - 1)) * 100), s = t.filter((F) => F.startsWith("n")).map((F) => parseInt(F.charAt(F.length - 1)) * 100), o = s.filter((F) => F <= 500).sort((F, M) => M - F)[0], h = n.filter((F) => F <= 500).sort((F, M) => M - F)[0], c = s.filter((F) => F == 700), m = (c.length ? c : s.filter((F) => F > 500)).sort((F, M) => F - M)[0], x = n.filter((F) => F == m);
    x = x.length ? x : n.filter((F) => F == 700);
    let B = (x.length ? x : n.filter((F) => F > 500)).sort((F, M) => F - M)[0];
    const I = [];
    return o && I.push({ style: "normal", weight: o }), m && I.push({ style: "normal", weight: m }), h && I.push({ style: "italic", weight: h }), B && I.push({ style: "italic", weight: B }), I;
  }
  setItemBold(e, t, n) {
    var s, o;
    if (this._customizer) {
      let h = this._customizer.findItemByGuid(e);
      if (h) {
        let x = this._customizer.getTextItemInfo(h).fontWeight.split(" ").includes("italic") ? "italic" : "normal";
        const B = this.getFontWeights(n);
        let I;
        if (x === "italic") {
          const F = B.filter((M) => M.style === "italic");
          if (t) {
            const M = F.filter((Z) => Z.weight > 500).sort((Z, V) => Z.weight - V.weight)[0];
            I = M == null ? void 0 : M.weight;
          } else {
            const M = F.filter((Z) => Z.weight <= 500).sort((Z, V) => V.weight - Z.weight)[0];
            I = M == null ? void 0 : M.weight;
          }
          if (I === void 0) {
            const M = B.filter((Z) => Z.style === "normal");
            if (t) {
              const Z = M.filter((V) => V.weight > 500).sort((V, te) => V.weight - te.weight)[0];
              I = (Z == null ? void 0 : Z.weight) || ((s = M[0]) == null ? void 0 : s.weight);
            } else {
              const Z = M.filter((V) => V.weight <= 500).sort((V, te) => te.weight - V.weight)[0];
              I = (Z == null ? void 0 : Z.weight) || ((o = M[0]) == null ? void 0 : o.weight);
            }
            x = "normal";
          }
        } else {
          const F = B.filter((M) => M.style === "normal");
          if (t) {
            const M = F.filter((Z) => Z.weight > 500).sort((Z, V) => Z.weight - V.weight)[0];
            I = M == null ? void 0 : M.weight;
          } else {
            const M = F.filter((Z) => Z.weight <= 500).sort((Z, V) => V.weight - Z.weight)[0];
            I = M == null ? void 0 : M.weight;
          }
          I === void 0 && F.length > 0 && (I = F[0].weight);
        }
        if (I !== void 0) {
          let F = x === "italic" ? `italic ${I}` : I.toString();
          this._customizer.modifyTextElementFontWeight(h, F);
        }
      }
    }
  }
  setItemItalic(e, t, n) {
    var s, o;
    if (this._customizer) {
      let h = this._customizer.findItemByGuid(e);
      if (h) {
        let m = this._customizer.getTextItemInfo(h).fontWeight.split(" "), x = !1;
        for (let F of m) {
          let M = parseInt(F);
          if (!isNaN(M)) {
            x = M > 500;
            break;
          }
        }
        const B = this.getFontWeights(n);
        let I;
        if (t) {
          const F = B.filter((M) => M.style === "italic");
          if (x) {
            const M = F.filter((Z) => Z.weight > 500).sort((Z, V) => Z.weight - V.weight)[0];
            I = M == null ? void 0 : M.weight;
          } else {
            const M = F.filter((Z) => Z.weight <= 500).sort((Z, V) => V.weight - Z.weight)[0];
            I = M == null ? void 0 : M.weight;
          }
          if (I === void 0) {
            const M = B.filter((Z) => Z.style === "normal");
            if (x) {
              const Z = M.filter((V) => V.weight > 500).sort((V, te) => V.weight - te.weight)[0];
              I = (Z == null ? void 0 : Z.weight) || ((s = M[0]) == null ? void 0 : s.weight);
            } else {
              const Z = M.filter((V) => V.weight <= 500).sort((V, te) => te.weight - V.weight)[0];
              I = (Z == null ? void 0 : Z.weight) || ((o = M[0]) == null ? void 0 : o.weight);
            }
            t = !1;
          }
        } else {
          const F = B.filter((M) => M.style === "normal");
          if (x) {
            const M = F.filter((Z) => Z.weight > 500).sort((Z, V) => Z.weight - V.weight)[0];
            I = M == null ? void 0 : M.weight;
          } else {
            const M = F.filter((Z) => Z.weight <= 500).sort((Z, V) => V.weight - Z.weight)[0];
            I = M == null ? void 0 : M.weight;
          }
          I === void 0 && F.length > 0 && (I = F[0].weight);
        }
        if (I !== void 0) {
          let F = t ? `italic ${I}` : I.toString();
          this._customizer.modifyTextElementFontWeight(h, F);
        }
      }
    }
  }
  setItemColor(e, t) {
    this._customizer && this._customizer.modifyTextElementFillColorByGuid(e, t);
  }
  setItemFontFamily(e, t) {
    this._customizer && this._customizer.modifyTextElementFontFamilyByGuid(e, t);
  }
  setItemFontWeight(e, t, n) {
    if (!this._customizer)
      return;
    if (n) {
      const h = this.getFontWeights(n).map((c) => c.weight);
      h.length > 0 && (t = h.reduce(
        (c, m) => Math.abs(m - t) < Math.abs(c - t) ? m : c
      ));
    }
    let s = this._customizer.findItemByGuid(e);
    if (s) {
      let m = (this._customizer.getTextItemInfo(s).fontWeight.split(" ").includes("italic") ? "italic" : "normal") === "italic" ? `italic ${t}` : t.toString();
      this._customizer.modifyTextElementFontWeight(s, m);
    }
  }
  async addItemImage(e) {
    return this._customizer ? await this._customizer.insertImageById(e) : null;
  }
  async setItemImage(e, t) {
    this._customizer && await this._customizer.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t) {
    if (this._customizer) {
      let n = this._customizer.findItemByGuid(e);
      t ? this._customizer.convertToTextOnPath(n) : this._customizer.convertToTextArea(n);
    }
  }
  removeItemImage(e) {
    this._customizer && this._customizer.removeImageByGuid(e);
  }
  async setItemSize(e, t, n) {
    this._customizer && await this._customizer.setItemSize(e, t, n);
  }
  setItemConstraints(e, t) {
    this._customizer && this._customizer.setItemConstraints(e, t);
  }
  setDesignPrintingMethod(e) {
    this._customizer && this._side && this._customizer.setDesignPrintingMethod(e, this._side.get("sideID"));
  }
  containsItem(e) {
    if (this._customizer) {
      const t = this._customizer.findItemByGuid(e);
      return t != null && t != null;
    }
    return !1;
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  addNotifyMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let n = Rh(
        (s, o, h, c, m, x, B, I, F) => {
          e(
            t.side.getSideID(),
            s,
            o,
            h,
            c,
            m,
            I.requiredWidth,
            I.requiredHeight,
            F
          );
        },
        50
      );
      t.addNotifyMessageListeners(n);
    }
  }
  addRemoveMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let n = Rh((s) => {
        e(t.side.getSideID(), s);
      }, 50);
      t.addRemoveMessageListeners(n);
    }
  }
  setEventMessages(e) {
    this._customizer && this._customizer.setCustomizedMessages(e);
  }
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t) {
    if (this._meshSide && this._customizer) {
      let h = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
      var n = JSON.parse(h), s = this._customizer.getTranslatedMatrixValues(n, e, t), o = JSON.stringify(s);
      this._meshSide.set("matrix", o);
    }
  }
  rotateDesignView(e, t, n) {
    if (this._meshSide && this._customizer) {
      var s = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), o = JSON.parse(s), h = this._customizer.getRotatedMatrixValues(o, e, t, n), c = JSON.stringify(h);
      this._meshSide.set("matrix", c);
    }
  }
  scaleDesignView(e, t, n, s) {
    if (this._meshSide && this._customizer) {
      var o = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), h = JSON.parse(o), c = this._customizer.getScaledMatrixValues(h, e, t, n, s), m = JSON.stringify(c);
      this._meshSide.set("matrix", m);
    }
  }
  async setDesignViewTextureUVChannelAsync(e) {
    this._meshSide && (this._meshSide.set("uvChannel", e), await this.updateDynamicTextureAsync());
  }
  async setDesignViewFormFactorAsync(e, t) {
    this._meshSide && (this._meshSide.set("percWidth", e), this._meshSide.set("percHeight", t), await this.refreshAsync());
  }
  async changeToDynamicTexture() {
    await this.updateDynamicTextureInternalAsync(!0);
  }
  async changeToRasterizedTexture() {
    await this.updateDynamicTextureInternalAsync(!1);
  }
  moveItemUp(e) {
    console.log("MeshDesignManager.moveItemUp", e), this._customizer && this._customizer.moveItemUp(e);
  }
  moveItemDown(e) {
    console.log("MeshDesignManager.moveItemDown", e), this._customizer && this._customizer.moveItemDown(e);
  }
};
lg.DEFAULT_SIZE = 1024;
let hg = lg;
class e1 {
  constructor(e, t, n, s, o = !0) {
    this._rotation = 0, this._grids = [], this._meshDesignManagers = [], this._renderingNeededListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._meshDesignManagersRefreshing = /* @__PURE__ */ new Set(), this._scene = e, this._zkScene = t, this._zkModel = n, this._zkDesign = s, this._showDesign = o, this.init();
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e, this._meshDesignManagers.forEach((t) => t.showDesign = e));
  }
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation != e && (this._rotation = e, this._meshDesignManagers.forEach((t) => t.rotation = e));
  }
  dispose() {
    this._meshDesignManagers.forEach((e) => e.dispose());
  }
  init() {
  }
  isForModels(e, t, n) {
    return this._scene == e && this._zkModel == t && this._zkDesign == n;
  }
  getDefaultModelScene() {
    if (this._zkModel) {
      let e = this._zkModel.get("scenes").findWhere({ isDefault: !0 });
      if (e)
        return e;
    }
    return null;
  }
  getModelSceneMeshSide(e, t = 0) {
    if (this._scene && this._zkModel) {
      const n = this.getDefaultModelScene();
      if (n)
        for (let s = 0; s < n.get("meshSides").length; s++) {
          let o = n.get("meshSides").at(s);
          if (o.get("meshID") == e && o.get("subMeshID") == t)
            return o;
        }
    }
    return null;
  }
  async refreshAsync() {
    if (this._scene && this._zkModel && this._zkDesign) {
      const e = this.getDefaultModelScene();
      if (e) {
        let t = null, n = null, s = null;
        for (let o = 0; o < this._meshDesignManagers.length; o++) {
          t = this._meshDesignManagers[o];
          let h = !1;
          for (let m = 0; m < e.get("meshSides").length; m++)
            if (s = e.get("meshSides").at(m), s.get("meshID") == t.getMeshID() && s.get("subMeshID") == t.getSubMeshIdx()) {
              h = !0;
              break;
            }
          let c = !0;
          if (h) {
            let m = t.getMeshID();
            m && (n = this._scene.getMeshByID(m), n && (c = n.isVisible));
          }
          (!h || !c) && (t.dispose(), this._meshDesignManagers.splice(o--, 1));
        }
        for (let o = 0; o < e.get("meshSides").length; o++) {
          s = e.get("meshSides").at(o);
          const h = s.get("meshID"), c = s.get("subMeshID");
          h && await this.refreshMeshDesignAsync(h, c);
        }
      }
    }
  }
  isValidEffectForMesh(e, t, n) {
    if (n && n instanceof MPlaza.ModelSceneMeshDesignEffect) {
      const s = n.getParentModel();
      if (s && s instanceof MPlaza.ModelScene)
        return s.isEffectForMesh(e, t, n.get("effectID"));
    }
    return !1;
  }
  async refreshMeshDesignAsync(e, t = 0, n) {
    const s = this._scene.getMeshByID(e);
    let o = n;
    if (n && !this.isValidEffectForMesh(e, t, n) && (o = void 0), s && s.isVisible) {
      let h = null;
      s.subMeshes && s.subMeshes.length > 0 && t >= 0 && t < s.subMeshes.length && (h = s.subMeshes[t]);
      let c = this.getMeshDesignMananger(s, h);
      if (c)
        c.showDesign = this._showDesign, c.rotation = this._rotation, await c.refreshAsync(o);
      else {
        c = await hg.createMeshDesignManagerAsync(
          this._scene,
          this._zkScene,
          s,
          h,
          this._zkModel,
          this._zkDesign,
          this._grids,
          this._showDesign,
          o,
          this.rotation
        ), c.addRenderingNeededListener(() => this.fireRenderingNeededEvent()), c.setEventMessages(this._designEventMessages);
        for (let m of this._designNotifyMessageListeners)
          c.addNotifyMessageListener(m);
        for (let m of this._designRemoveMessageListeners)
          c.addRemoveMessageListener(m);
        this._meshDesignManagers.push(c);
      }
    }
  }
  getMeshDesignMananger(e, t) {
    for (let n = 0; n < this._meshDesignManagers.length; n++) {
      const s = this._meshDesignManagers[n];
      if (s.isForMesh(e, t))
        return s;
    }
    return null;
  }
  clearMeshDesignManagers() {
    this._meshDesignManagers = [];
  }
  setCustomizerGrids(e) {
    this._grids = e, this._meshDesignManagers.forEach((t) => t.setCustomizerGrids(e));
  }
  getItemsInfo(e) {
    let t = [];
    for (let n = 0; n < this._meshDesignManagers.length; n++) {
      const o = this._meshDesignManagers[n].getItemsInfo();
      for (let h = 0; h < o.length; h++) {
        const c = o[h];
        let m = !1;
        for (let x = 0; x < t.length; x++)
          if (t[x].itemGuid == c.itemGuid) {
            m = !0;
            break;
          }
        m || t.push(c);
      }
    }
    if (e) {
      const n = e.getItemsInfo();
      for (let s = 0; s < n.length; s++) {
        const o = n[s];
        let h = !1;
        for (let c = 0; c < t.length; c++)
          if (t[c].itemGuid == o.itemGuid) {
            h = !0;
            break;
          }
        h || t.push(o);
      }
    }
    return t;
  }
  async execOnMeshManagersContainingItem(e, t) {
    for (const n of this._meshDesignManagers)
      n.containsItem(e) && await t(n);
  }
  removeItem(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItem(e));
  }
  moveItemUp(e) {
    console.log("sceneDesignManager moveItemUp", e), this.execOnMeshManagersContainingItem(e, async (t) => t.moveItemUp(e));
  }
  moveItemDown(e) {
    console.log("sceneDesignManager moveItemDown", e), this.execOnMeshManagersContainingItem(e, async (t) => t.moveItemDown(e));
  }
  addItemText(e, t) {
    let n = this._meshDesignManagers.find((s) => s.side != null && s.side.get("sideID") === t);
    n && n.addItemText(e);
  }
  async addItemImage(e, t) {
    let n = this._meshDesignManagers.find((s) => s.side != null && s.side.get("sideID") === t);
    return n ? await n.addItemImage(e) : null;
  }
  setItemText(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemText(e, t));
  }
  async refreshTextureForItem(e) {
    await this.execOnMeshManagersContainingItem(e, async (t) => t.refreshTextureOnly());
  }
  setItemItalic(e, t, n) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemItalic(e, t, n));
  }
  setItemBold(e, t, n) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemBold(e, t, n));
  }
  setItemColor(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemColor(e, t));
  }
  setItemFontFamily(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemFontFamily(e, t));
  }
  async setItemImage(e, t) {
    await this.execOnMeshManagersContainingItem(e, async (n) => n.setItemImage(e, t));
  }
  async setItemSize(e, t, n) {
    await this.execOnMeshManagersContainingItem(e, async (s) => s.setItemSize(e, t, n));
  }
  setItemConstraints(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemConstraints(e, t));
  }
  setItemTextOnPath(e, t, n) {
    const s = this._meshDesignManagers.find(
      (o) => o.side != null && o.side.get("sideID") === t
    );
    s && s.setItemTextOnPath(e, n);
  }
  removeItemImage(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItemImage(e));
  }
  setDesignVisibility(e, t) {
    const n = this._scene.getMeshByID(e);
    if (n) {
      const s = this.getMeshDesignMananger(n, n.subMeshes.length > 0 ? n.subMeshes[0] : null);
      s && s.setDesignMeshVisibility(t);
    }
  }
  setDesignPrintingMethod(e, t) {
    let n = this._meshDesignManagers.find((s) => s.side != null && s.side.get("sideID") === t);
    n && n.setDesignPrintingMethod(e);
  }
  getDesignItemsJson() {
    let e = "";
    for (let t = 0; t < this._zkDesign.get("designItems").length; t++)
      e && (e += `
`), e += this._zkDesign.get("designItems").at(t).get("json");
    return e;
  }
  getDesignID() {
    return this._zkDesign.getDesignID();
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addRemoveMessageListener(e);
  }
  setEventMessages(e) {
    this._designEventMessages = e;
    for (let t of this._meshDesignManagers)
      t.setEventMessages(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, n, s) {
    const o = this.getMeshDesignMananger(e, t);
    o && o.translateDesignView(n, s);
  }
  rotateDesignView(e, t, n, s, o) {
    const h = this.getMeshDesignMananger(e, t);
    h && h.rotateDesignView(n, s, o);
  }
  scaleDesignView(e, t, n, s, o, h) {
    const c = this.getMeshDesignMananger(e, t);
    c && c.scaleDesignView(n, s, o, h);
  }
  async setDesignViewTextureUVChannelAsync(e, t, n) {
    const s = this.getMeshDesignMananger(e, t);
    s && await s.setDesignViewTextureUVChannelAsync(n);
  }
  async setDesignViewFormFactorAsync(e, t, n, s) {
    const o = this.getMeshDesignMananger(e, t);
    o && await o.setDesignViewFormFactorAsync(n, s);
  }
  // -------------------------------------------------------------
  // Mesh - Side connection
  // -------------------------------------------------------------
  async connectMeshToModelSideAsync(e, t, n) {
    let s = this.getModelSceneMeshSide(e, t);
    if (!s && this._scene && this._zkModel) {
      let o = this._scene.getMeshByID(e);
      if (o && o.subMeshes && o.subMeshes.length > 0 && t >= 0 && t < o.subMeshes.length) {
        o.subMeshes[t];
        let h = this.getDefaultModelScene();
        h && (s = new MPlaza.ModelSceneMeshSide(), s.set("meshID", e), s.set("subMeshID", t), s.set("sideID", n), h.get("meshSides").add(s), await this.refreshAsync());
      }
    }
  }
  expandCanvasMeshes(e) {
    console.log("expandRatio ", e), this._meshDesignManagers.forEach((t) => t.expandCanvasMesh(e));
  }
  contractCanvasMeshes() {
    this._meshDesignManagers.forEach((e) => e.contractCanvasMesh());
  }
  async changeToRasterizedTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToRasterizedTexture();
    console.log("All tasks for rasterized textures completed.");
  }
  async changeToDynamicTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToDynamicTexture();
    console.log("All dynamic textures changes completed.");
  }
}
const ns = "base_model";
class fS {
  constructor(e, t, n) {
    this._zkModel = e, this._zkScene = t, this._scene = n, this._sceneHelper = new yi(n);
  }
  /**
   * Replace the product model, used when discarding changes
   * @param newModel The new model to replace the current one
   */
  replaceModel(e) {
    this._zkModel = e;
  }
  getOrCreateMaterialsForVariant(e) {
    const t = this.getVariantMeshes(e), n = [];
    return t.forEach((s) => {
      const o = this._scene.getMeshById(s);
      o && o.getChildMeshes().forEach((h) => n.push(h));
    }), this.hasVariantCustomModel(e) ? this.getMaterialsForMeshes(n) : (this.getMaterialsForMeshes(n).forEach((o) => {
      this.isSceneMaterialForVariant(o) || this.setVariableMaterialID(o.id);
    }), this.getVariantMaterials(e));
  }
  // restituisce tutti materiali della scena per cui è possibile specificare se sono
  // variabili o meno in base alle varianti del prodotto. Da tale elenco verranno esclusi
  // tutti i materiali che sono stati già clonati per rappresentare la variazione.
  // verranno esclusi anche tutti i materiali che comunque sono stati marcati (metadata)
  // come materiali creati ad hoc per una preview di prodotto (isForPreview = true)
  // e verranno esclusi tutti i materiali non assegnati a nessuna mesh.
  // Verranno considerati quindi tutti i materiali non clonati assegnati ad almeno una mesh (direttamente
  // o indirettamente)
  getPossibleVariableMaterials() {
    const e = this._sceneHelper.getAllMaterials(), t = [];
    for (let n = 0; n < e.length; n++) {
      const s = e[n], o = this.getMeshesUsingMaterial(s.id), h = this.isSceneMaterialForVariant(s);
      o.length > 0 && !h && t.push(s);
    }
    return t;
  }
  // Restituisce l'elenco dei materiali della scena già selezionati come variabili
  getVariableMaterials() {
    const e = [], t = this._zkModel.getPreview3D();
    if (t) {
      const n = t.getVariantsAttributeOptions();
      if (n)
        for (let s = 0; s < n.get("variableMaterials").length; s++) {
          let o = n.get("variableMaterials").at(s).get("materialID"), h = this._scene.getMaterialById(o);
          h && e.push(h);
        }
    }
    return e;
  }
  getVariableMaterialsSelection() {
    const t = this.getVariableMaterials().map((o) => o.id);
    return this.getPossibleVariableMaterials().map((o) => ({
      id: o.id,
      name: o.name,
      selected: t.indexOf(o.id) != -1
    }));
  }
  getVariantMaterialsWithOriginal(e) {
    const t = [], n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const s = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o) {
        const h = o.getVariantOption(s);
        if (h)
          for (let c = 0; c < h.get("materials").length; c++) {
            const m = h.get("materials").at(c), x = m.get("optionMaterialID"), B = this._scene.getMaterialById(x), I = m.get("variableMaterialID"), F = this._scene.getMaterialById(I);
            B && F && t.push({ material: B, variableMaterial: F });
          }
      }
    }
    return t;
  }
  // Per tutti i materiali impostati come variabili, verifica che questi materiali esistano ancora.
  // Se un materiale esiste, aggiorna l'indicazione delle mesh alle quali è impostato e le azioni per opzione.
  // Se un materiale non esiste, lo elimina tra i materiali variabili.
  updateVariableMaterials() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t) {
        const n = [], s = [];
        for (let o = 0; o < t.get("variableMaterials").length; o++) {
          const c = t.get("variableMaterials").at(o).get("materialID");
          this._scene.getMaterialById(c) ? n.push(c) : s.push(c);
        }
        n.forEach((o) => this.setVariableMaterialID(o)), s.forEach((o) => this.unsetVariableMaterialID(o));
      }
    }
  }
  // Imposta un materiale come NON variabile per variante. Questo significa che vanno eliminate
  // tutte le eventuali azioni relative al materiale ed eventualmente le opzioni
  unsetVariableMaterialID(e) {
    const t = this._zkModel.getPreview3D();
    if (t) {
      const n = t.getVariantsAttributeOptions();
      if (n) {
        const s = this._zkModel.getAttributeByGuid(n.get("attributeGuid")), o = n.get("variableMaterials").getVariableMaterial(e);
        if (o) {
          const c = this._scene.getMaterialById(e);
          if (c)
            for (let m = 0; m < o.get("meshes").length; m++) {
              const x = this._scene.getMeshById(o.get("meshes")[m]);
              x && this._sceneHelper.applyMaterial(c, x);
            }
        }
        n.removeVariableMaterial(e);
        const h = [];
        for (let c = 0; c < n.get("variantOptions").length; c++) {
          const m = n.get("variantOptions").at(c);
          let x = null;
          s && (x = s.getOptionByGuid(m.get("optionGuid")));
          const B = [];
          for (let I = 0; I < m.get("materials").length; I++) {
            const F = m.get("materials").at(I);
            if (F.get("variableMaterialID") === e) {
              for (let M = 0; M < F.get("actions").length; M++) {
                const Z = F.get("actions").at(M);
                if (x) {
                  const V = x.get("actions").getActionByGuid(Z.get("actionGuid"));
                  V && x.get("actions").remove(V);
                }
              }
              this.deleteSceneMaterial(F.get("optionMaterialID")), B.push(F);
            }
          }
          m.get("materials").remove(B), m.get("materials").length === 0 && h.push(m);
        }
        for (let c = 0; c < h.length; c++)
          this.removeVariantOption(n, h[c]);
      }
    }
  }
  // Imposta un materiale come variabile. Vengono generati i materiali cloni per le varie opzioni
  // e create le azioni di trasformazione della scena che impostano il materiale sulle varie mesh
  setVariableMaterialID(e) {
    const t = this._scene.getMaterialById(e);
    if (t) {
      const n = this.getMeshesUsingMaterial(t.id), s = n.map((m) => m.id), h = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions();
      h.setVariableMaterial(e, s);
      const c = [];
      for (let m = 0; m < this._zkModel.get("colors").length; m++) {
        const x = this._zkModel.get("colors").at(m), B = this.getVariantID(x);
        c.push(B), this.checkVariantOption(h, t, n, x);
      }
      for (let m = 0; m < h.get("variantOptions").length; m++) {
        const x = h.get("variantOptions").at(m);
        c.indexOf(x.get("variantID")) === -1 && this.removeVariantOption(h, x);
      }
    }
  }
  getVariantAttribute() {
    const e = this._zkModel.getPreview3D();
    if (!e)
      return null;
    const t = e.getVariantsAttributeOptions();
    if (!t)
      return null;
    let n = null;
    return t.get("attributeGuid") && (n = this._zkModel.getAttributeByGuid(t.get("attributeGuid"))), n || (n = this._zkModel.get("attributes").getAttributeByCode("variants_attribute")), n;
  }
  checkVariantOption(e, t, n, s) {
    const o = this.getVariantID(s);
    let h = e.get("variantOptions").getVariantOption(o);
    h || (h = this.createVariantOption(e, s)), this.checkVariantOptionMaterial(e, h, t, n, s);
  }
  createVariantOption(e, t) {
    const n = this.getVariantID(t), s = this.getOrCreateVariantAttribute(e), o = this.getOrCreateVariantAttributeOption(e, t, s), h = new MPlaza.VariantOption();
    return h.set("variantID", n), h.set("optionGuid", o.get("optionGuid")), e.get("variantOptions").push(h), h;
  }
  removeVariantOption(e, t) {
    const n = this._zkModel.getAttributeByGuid(e.get("attributeGuid"));
    if (n) {
      const s = n.getOptionByGuid(t.get("optionGuid"));
      s && n.get("options").remove(s);
    }
    for (let s = 0; s < t.get("materials").length; s++) {
      const h = t.get("materials").at(s).get("optionMaterialID");
      this.deleteSceneMaterial(h);
    }
    e.get("variantOptions").remove(t);
  }
  getOrCreateVariantAttribute(e) {
    let t = this.getVariantAttribute();
    if (!t) {
      for (let n = 0; n < e.get("variantOptions").length; n++)
        this.removeVariantOption(
          e,
          e.get("variantOptions").at(n)
        );
      t = new MPlaza.Attribute(), t.set("attributeGuid", MPlaza.generateUUID()), t.set("name", "Variants attribute"), t.set("attributeCode", "variants_attribute"), t.set("attributeTypeID", MPlaza.AttributeType.Options), this._zkModel.get("attributes").push(t);
    }
    return e.set("attributeGuid", t.get("attributeGuid")), t;
  }
  getOrCreateVariantAttributeOption(e, t, n) {
    const s = this.getVariantID(t);
    let o = n.getOptionByCode(s);
    return o || (o = new MPlaza.AttributeOption(), o.set("optionCode", s), o.set("name", t.get("name")), n.get("options").push(o)), o;
  }
  getVariantID(e) {
    return `${e.getModelID()}_${e.getColorID()}`;
  }
  checkVariantOptionMaterial(e, t, n, s, o) {
    const h = this.getVariantID(o);
    let c = null;
    for (let m = 0; m < t.get("materials").length; m++) {
      const x = t.get("materials").at(m);
      if (x.get("variableMaterialID") === n.id) {
        c = x;
        break;
      }
    }
    if (!c) {
      let m = this.getSceneMaterialForVariant(h, n.id);
      if (!m) {
        const x = `${n.name} - ${o.get("name")}`;
        m = this.cloneSceneMaterial(n.id, void 0, x), m && this.setupSceneMaterialForVariant(m, h, n.id);
      }
      m && (c = new MPlaza.VariantOptionMaterial(), c.set("optionMaterialID", m.id), c.set("variableMaterialID", n.id), t.get("materials").push(c));
    }
    c && this.checkVariantOptionActions(
      e,
      t,
      c,
      n,
      s,
      o
    );
  }
  // Una materiale creato per una variante viene marcato con dei metadati. Questo significa che i materiali creati in altro modo
  // e con i materiali giusti verrano riconosciuti e utilizzati per le azioni delle opzioni
  setupSceneMaterialForVariant(e, t, n) {
    const s = this.getOrCreateSceneMaterialMetadata(e.id);
    s.isForPreview = !0, s.autoCreate = !0, s.variantID = t, s.variableMaterialID = n;
  }
  getSceneMaterialForVariant(e, t) {
    const n = this._sceneHelper.getAllMaterials();
    for (let s = 0; s < n.length; s++) {
      const o = n[s], h = this.getSceneMaterialMetadata(o.id);
      if (h && h.isForPreview && h.variantID === e && h.variableMaterialID === t)
        return n[s];
    }
    return null;
  }
  isSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return t && t.isForPreview;
  }
  canDeleteSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return !t || t.isForPreview === void 0 || t.isForPreview === null || t.autoCreate === void 0 || t.autoCreate === null ? !0 : t.isForPreview && t.autoCreate;
  }
  getSceneMaterialMetadata(e) {
    return this._sceneHelper.getSceneMaterialMetadata(e);
  }
  getOrCreateSceneMaterialMetadata(e) {
    return this._sceneHelper.getOrCreateSceneMaterialMetadata(e);
  }
  removeSceneMaterialMetadata(e) {
    this._sceneHelper.removeSceneMaterialMetadata(e);
  }
  // Clona un materiale
  cloneSceneMaterial(e, t, n) {
    let s = this._scene.getMaterialById(e), o = null;
    if (s) {
      const h = n || `${s.name} - clone`;
      if (o = s.clone(h), o) {
        const c = t || MPlaza.generateUUID();
        o.id = c;
        const m = this._zkScene.getMappingForSceneMaterial(s.id);
        if (m) {
          const x = m.get("libraryMaterialID");
          this._zkScene.mapLibraryMaterial(x, o.id);
          const B = this._sceneHelper.getTexturesForMaterial(o), I = this._sceneHelper.getTexturesForMaterial(o);
          for (let F = 0; F < I.length; F++) {
            const M = I[F], Z = B[F];
            M.materialMapping = Z.materialMapping;
          }
        }
      }
    }
    return o;
  }
  deleteSceneMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    if (t && this.canDeleteSceneMaterialForVariant(t)) {
      this.removeSceneMaterialMetadata(e);
      const n = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e);
      n && this._zkScene.unregisterShaderMaterial(n), this._zkScene.removeMappingForSceneMaterial(t.id);
      const s = this._sceneHelper.getTexturesExclusivelyForMaterial(t);
      t.dispose();
      for (let o = 0; o < s.length; o++)
        s[o].dispose();
    }
  }
  checkVariantOptionActions(e, t, n, s, o, h) {
    let c = [];
    o.forEach((I) => c.push(I.id));
    let m = this.getOrCreateVariantAttribute(e), x = this.getOrCreateVariantAttributeOption(e, h, m);
    for (let I = 0; I < o.length; I++) {
      let F = o[I], M = n.get("actions").getActionForMesh(F.id);
      if (!M) {
        let Z = new MPlaza.AttributeSceneAction();
        Z.set("name", ""), Z.set("actionTypeID", MPlaza.SceneActionType.SetMeshMaterial), Z.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), Z.set("selector", F.id), Z.set("value", n.get("optionMaterialID")), x.get("actions").push(Z), M = new MPlaza.VariantOptionMaterialAction(), M.set("actionGuid", Z.get("actionGuid")), M.set("meshID", F.id), n.get("actions").push(M);
      }
    }
    let B = [];
    for (let I = 0; I < n.get("actions").length; I++) {
      let F = n.get("actions").at(I);
      if (c.indexOf(F.get("meshID")) === -1) {
        let M = x.getActionByGuid(F.get("actionGuid"));
        M && x.get("actions").remove(M), B.push(F);
      }
    }
    n.get("actions").remove(B);
  }
  isMaterialReal(e) {
    var s, o;
    const t = ((s = e.metadata) == null ? void 0 : s.isRealMaterial) !== !1 && e.id !== "default material", n = ((o = e.metadata) == null ? void 0 : o.isDesignMaterial) === !0;
    return t && !n;
  }
  getVariantMaterials(e) {
    let t = [];
    const n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const s = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o) {
        const h = o.getVariantOption(s);
        if (h)
          for (let c = 0; c < h.get("materials").length; c++) {
            const x = h.get("materials").at(c).get("optionMaterialID"), B = this._scene.getMaterialById(x);
            B && this.isMaterialReal(B) && t.push(B);
          }
      }
    }
    return t;
  }
  getSelectedAttributeOption(e) {
    let t = {
      attributeID: null,
      attributeGuid: null,
      optionID: null,
      optionGuid: null
    };
    const n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const s = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o && o.get("attributeGuid")) {
        const h = this._zkModel.getAttributeByGuid(o.get("attributeGuid"));
        if (h) {
          const c = o.getVariantOption(s);
          if (c) {
            const m = h.getOptionByGuid(c.get("optionGuid"));
            m && (t.attributeID = h.get("attributeID"), t.attributeGuid = h.get("attributeGuid"), t.optionID = m.get("optionID"), t.optionGuid = m.get("optionGuid"));
          }
        }
      }
    }
    return t;
  }
  resetOriginaMaterialsOnMeshes() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t)
        for (let n = 0; n < t.get("variableMaterials").length; n++) {
          const s = t.get("variableMaterials").at(n), o = s.get("materialID"), h = s.get("meshes"), c = this._scene.getMaterialByID(o);
          if (c)
            for (let m = 0; m < h.length; m++) {
              const x = this._scene.getMeshById(s.get("meshes")[m]);
              x && this._sceneHelper.applyMaterial(c, x);
            }
        }
    }
  }
  // Una mesh usa un materiale se sulla mesh è impostato direttamente quel materiale o se sulla mesh è
  // attualmente impostato un materiale creato ad hoc per la preview 3D e che deriva dal materiale in oggetto (clone)
  getMeshesUsingMaterial(e) {
    const t = [], n = this._sceneHelper.getSceneMeshes();
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      if (this._sceneHelper.isMeshUsingMaterial(o, e))
        t.push(o);
      else {
        const h = this._sceneHelper.getMeshMaterials(o);
        for (let c = 0; c < h.length; c++) {
          const m = h[c], x = this.getSceneMaterialMetadata(m.id);
          if (x && x.isForPreview && x.variableMaterialID && x.variableMaterialID === e) {
            t.push(o);
            break;
          }
        }
      }
    }
    return t;
  }
  getMaterialsForMeshes(e) {
    const t = e.map((s) => typeof s == "string" ? this._scene.getMeshById(s) : s), n = [];
    for (let s = 0; s < t.length; s++) {
      const o = t[s];
      if (o) {
        const h = this._sceneHelper.getMeshMaterials(o);
        for (let c = 0; c < h.length; c++) {
          const m = h[c];
          n.indexOf(m) === -1 && this.isMaterialReal(m) && n.push(m);
        }
      }
    }
    return n;
  }
  // Restituisce l'elenco delle mesh associate ad una variante
  // Se la variante non ha mesh associate, restituisce le mesh base
  getVariantMeshes(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return [ns];
    const n = t == null ? void 0 : t.getVariantsAttributeOptions();
    if (!n)
      return [ns];
    const s = this.getVariantID(e), o = n.get("variantOptions").getVariantOption(s);
    if (!o)
      return [ns];
    const h = o.get("meshes");
    return h.length > 0 ? h : [ns];
  }
  /**
   * Given a mesh, returns the variant it is associated with.
   * If the mesh is not associated with any variant, it returns null, which would be the base mesh.
   * It is used for AR, to know which variant was used for the measurement.
   * @param meshID The ID of the mesh to get the variant for.
   * @returns The variant associated with the mesh, or null if the mesh is not associated with any variant.
   */
  getVariantByMeshID(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return null;
    const n = t.getVariantsAttributeOptions();
    if (!n)
      return null;
    for (let s = 0; s < this._zkModel.get("colors").length; s++) {
      const o = this._zkModel.get("colors").at(s), h = this.getVariantID(o), c = n.getVariantOption(h);
      if (c && c.get("meshes").indexOf(e) !== -1)
        return o;
    }
    return null;
  }
  /**
   * Check if a variant has custom meshes associated with it.
   * @param modelColor  The color of the variant to check.
   * @returns True if the variant has custom meshes, false otherwise.
   */
  hasVariantCustomModel(e) {
    const t = this.getVariantMeshes(e);
    return !(t.length === 1 && t[0] === ns);
  }
  /**
   * Set the meshes associated with a variant.
   * @param modelColor The color of the variant to set meshes for.
   * @param meshIDs The list of mesh IDs to set as variant meshes.
   */
  setVariantMeshes(e, t) {
    const s = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), o = this.getVariantID(e);
    let h = s.get("variantOptions").getVariantOption(o);
    h || (h = this.createVariantOption(s, e)), h.set("meshes", t), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Remove all meshes associated with a variant.
   * @param modelColor The color of the variant to remove meshes from.
   */
  removeVariantMeshes(e) {
    const n = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), s = this.getVariantID(e);
    let o = n.get("variantOptions").getVariantOption(s);
    if (o) {
      const h = o.get("meshes");
      for (const c of h) {
        const m = this._scene.getMeshById(c);
        m == null || m.dispose(!1, !0);
      }
      o.set("meshes", []);
    }
    this.updateVariableMaterials(), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Set the current base meshes for the scene.
   * @param meshIDs The list of mesh IDs to set as base meshes.
   */
  setBaseMeshes(e) {
    let t = this._scene.getMeshById(ns);
    t || (t = new BABYLON.Mesh(ns, this._scene), t.id = ns);
    for (const n of e) {
      const s = this._scene.getMeshById(n);
      s && s.setParent(t);
    }
  }
  /**
   * Remove current base meshes from the scene.
   */
  removeBaseMeshes() {
    const e = this._scene.getMeshById(ns);
    if (e) {
      const t = e.getChildMeshes(!0);
      for (const n of t)
        n.setParent(null);
    }
  }
  /**
   * Upgrade an old preview 3D scene to the new base mesh system.
   */
  upgradeToBaseMeshes() {
    this._scene.getMeshById(ns) !== null || this.setBaseMeshes(
      this._scene.meshes.filter((t) => !t.parent && t.id !== ns).map((t) => t.id) ?? []
    );
  }
  /**
   * This method will create or update all options by setting the correct show/hide actions
   * to show the base model or the variant model.
   */
  refreshOptionsShowHideVariantModels() {
    const t = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), n = this.getOrCreateVariantAttribute(t);
    for (let s = 0; s < this._zkModel.get("colors").length; s++) {
      const o = this._zkModel.get("colors").at(s), h = this.getVariantID(o);
      let c = t.get("variantOptions").getVariantOption(h);
      c || (c = this.createVariantOption(t, o));
      const m = this.getOrCreateVariantAttributeOption(t, o, n);
      let x = m.get("actions").find(
        (B) => B.get("selector") === "*" && B.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh
      );
      x || (x = new MPlaza.AttributeSceneAction(), x.set("name", ""), x.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), x.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), x.set("selector", "*"), x.set("value", "hide"), m.get("actions").push(x));
      for (let B = 0; B < m.get("actions").length; B++) {
        const I = m.get("actions").at(B);
        I.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && I.get("selector") !== "*" && (m.get("actions").remove(I), B--);
      }
      if ((c == null ? void 0 : c.get("meshes").length) === 0) {
        const B = new MPlaza.AttributeSceneAction();
        B.set("name", ""), B.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), B.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), B.set("selector", ns), B.set("value", "show"), m.get("actions").push(B);
      } else
        for (const B of c.get("meshes")) {
          const I = new MPlaza.AttributeSceneAction();
          I.set("name", ""), I.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), I.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), I.set("selector", B), I.set("value", "show"), m.get("actions").push(I);
        }
    }
  }
  // Design materials
  setDesignMaterialForVariantEnabled(e, t) {
    var c;
    const n = this.hasVariantCustomModel(e) ? e.get("colorID") : null, s = this._zkModel.get("scenes").at(0).get("meshSides").filter((m) => m.get("colorID") === n), o = (c = s.at(0)) == null ? void 0 : c.get("materialID");
    let h = o ? this._scene.getMaterialById(o) : null;
    t || (s.forEach((m) => {
      m.set("materialID", null);
    }), h && (s.some(
      (x) => x.get("materialID") === h.id
    ) || h.dispose())), t && !h && (h = new BABYLON.PBRMaterial("Design material", this._scene), h.id = Zakeke.generateUUID(), h.zOffset = -1, h.metallic = 0.5, h.roughness = 0.2, s.forEach((m) => {
      m.set("materialID", h.id);
    }));
  }
  getDesignMaterialForVariant(e) {
    const t = this.hasVariantCustomModel(e) ? e.get("colorID") : null, n = this._zkModel.get("scenes").at(0).get("meshSides").find((o) => o.get("colorID") === t), s = n ? n.get("materialID") : null;
    return s ? this._scene.getMaterialById(s) : null;
  }
}
function ug(y) {
  return typeof importScripts == "function" ? (importScripts(y), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(y, () => {
      e();
    }, (n) => {
      t(new Error(n));
    });
  });
}
function t1(y) {
  return new Promise((e, t) => {
    BABYLON.Tools.LoadFile(y, (n) => {
      e(n);
    }, void 0, void 0, !0, (n, s) => {
      t(s);
    });
  });
}
function $h(y, e, t) {
  const n = e && y || t;
  if (n)
    return ug(n).then(() => new Promise((s) => {
      DracoDecoderModule({ wasmBinary: e }).then((o) => {
        s({ module: o });
      });
    }));
}
function Xh(y, e, t, n, s) {
  const o = new y.DecoderBuffer();
  o.Init(e, e.byteLength);
  const h = new y.Decoder();
  let c, m;
  try {
    const B = h.GetEncodedGeometryType(o);
    switch (B) {
      case y.TRIANGULAR_MESH:
        c = new y.Mesh(), m = h.DecodeBufferToMesh(o, c);
        break;
      case y.POINT_CLOUD:
        c = new y.PointCloud(), m = h.DecodeBufferToPointCloud(o, c);
        break;
      default:
        throw new Error(`Invalid geometry type ${B}`);
    }
    if (!m.ok() || !c.ptr)
      throw new Error(m.error_msg());
    const I = c.num_points();
    if (B === y.TRIANGULAR_MESH) {
      const M = c.num_faces(), Z = new y.DracoInt32Array();
      try {
        const V = new Uint32Array(M * 3);
        for (let te = 0; te < M; te++) {
          h.GetFaceFromMesh(c, te, Z);
          const P = te * 3;
          V[P + 0] = Z.GetValue(0), V[P + 1] = Z.GetValue(1), V[P + 2] = Z.GetValue(2);
        }
        n(V);
      } finally {
        y.destroy(Z);
      }
    }
    const F = (M, Z) => {
      const V = new y.DracoFloat32Array();
      try {
        h.GetAttributeFloatForAllPoints(c, Z, V);
        const te = new Float32Array(I * Z.num_components());
        for (let P = 0; P < te.length; P++)
          te[P] = V.GetValue(P);
        s(M, te);
      } finally {
        y.destroy(V);
      }
    };
    if (t)
      for (const M in t) {
        const Z = t[M], V = h.GetAttributeByUniqueId(c, Z);
        F(M, V);
      }
    else {
      const M = {
        position: "POSITION",
        normal: "NORMAL",
        color: "COLOR",
        uv: "TEX_COORD",
        uv2: "TEX_COORD",
        uv3: "TEX_COORD",
        uv4: "TEX_COORD",
        uv5: "TEX_COORD",
        uv6: "TEX_COORD"
      }, Z = /^uv(\d+)$/;
      for (const V in M) {
        const te = V.match(Z);
        let P = -1;
        if (te && te.length > 1) {
          var x = parseInt(te[1], 10);
          const K = h.GetAttributeId(c, y.TEX_COORD);
          K !== -1 && (P = K + x - 1);
        } else
          P = h.GetAttributeId(c, y[M[V]]);
        if (P !== -1) {
          const K = h.GetAttributeByUniqueId(c, P);
          K && K.size() > 0 && F(V, K);
        }
      }
    }
  } finally {
    c && y.destroy(c), y.destroy(h), y.destroy(o);
  }
}
function i1() {
  let y;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.decoder;
        y = $h(n.wasmUrl, n.wasmBinary, n.fallbackUrl), postMessage("done");
        break;
      }
      case "decodeMesh": {
        if (!y)
          throw new Error("Draco decoder module is not available");
        y.then((n) => {
          Xh(n.module, t.dataView, t.attributes, (s) => {
            postMessage({ id: "indices", value: s }, [s.buffer]);
          }, (s, o) => {
            postMessage({ id: s, value: o }, [o.buffer]);
          }), postMessage("done");
        });
        break;
      }
    }
  };
}
function Dh(y) {
  return typeof document != "object" || typeof y != "string" ? y : BABYLON.Tools.GetAbsoluteUrl(y);
}
const go = class js {
  /**
   * Returns true if the decoder configuration is available.
   */
  static get DecoderAvailable() {
    const e = js.Configuration.decoder;
    return !!(e.wasmUrl && e.wasmBinaryUrl && typeof WebAssembly == "object" || e.fallbackUrl);
  }
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 1);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return js._Default || (js._Default = new js()), js._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e = js.DefaultNumWorkers) {
    const t = js.Configuration.decoder, n = t.wasmUrl && t.wasmBinaryUrl && typeof WebAssembly == "object" ? t1(Dh(t.wasmBinaryUrl)) : Promise.resolve(void 0);
    e && typeof Worker == "function" ? this._workerPoolPromise = n.then((s) => {
      const o = `${ug}${$h}${Xh}(${i1})()`, h = URL.createObjectURL(new Blob([o], { type: "application/javascript" })), c = new Array(e);
      for (let m = 0; m < c.length; m++)
        c[m] = new Promise((x, B) => {
          const I = new Worker(h), F = (Z) => {
            I.removeEventListener("error", F), I.removeEventListener("message", M), B(Z);
          }, M = (Z) => {
            Z.data === "done" && (I.removeEventListener("error", F), I.removeEventListener("message", M), x(I));
          };
          I.addEventListener("error", F), I.addEventListener("message", M), I.postMessage({
            id: "init",
            decoder: {
              wasmUrl: Dh(t.wasmUrl),
              wasmBinary: s,
              fallbackUrl: Dh(t.fallbackUrl)
            }
          });
        });
      return Promise.all(c).then((m) => new Au(m));
    }) : this._decoderModulePromise = n.then((s) => $h(t.wasmUrl, s, t.fallbackUrl));
  }
  /**
   * Stop all async operations and release resources.
   */
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : this._decoderModulePromise ? this._decoderModulePromise.then(() => {
    }) : Promise.resolve();
  }
  /**
    * Decode Draco compressed mesh data to vertex data.
    * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
    * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
    * @returns A promise that resolves with the decoded vertex data
    */
  decodeMeshAsync(e, t) {
    const n = e instanceof ArrayBuffer ? new Uint8Array(e) : e;
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((s) => new Promise((o, h) => {
        s.push((c, m) => {
          const x = new BABYLON.VertexData(), B = (M) => {
            c.removeEventListener("error", B), c.removeEventListener("message", I), h(M), m();
          }, I = (M) => {
            M.data === "done" ? (c.removeEventListener("error", B), c.removeEventListener("message", I), o(x), m()) : M.data.id === "indices" ? x.indices = M.data.value : x.set(M.data.value, M.data.id);
          };
          c.addEventListener("error", B), c.addEventListener("message", I);
          const F = new Uint8Array(n.byteLength);
          F.set(new Uint8Array(n.buffer, n.byteOffset, n.byteLength)), c.postMessage({ id: "decodeMesh", dataView: F, attributes: t }, [F.buffer]);
        });
      }));
    if (this._decoderModulePromise)
      return this._decoderModulePromise.then((s) => {
        const o = new BABYLON.VertexData();
        return Xh(s.module, n, t, (h) => {
          o.indices = h;
        }, (h, c) => {
          o.set(c, h);
        }), o;
      });
    throw new Error("Draco decoder module is not available");
  }
};
go.Configuration = {
  decoder: {
    //wasmUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_wasm_wrapper.js"),
    //wasmBinaryUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.wasm"),
    //fallbackUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.js")
    /*
    wasmUrl: "https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js",
    wasmBinaryUrl: "https://preview.babylonjs.com/draco_decoder_gltf.wasm",
    fallbackUrl: "https://preview.babylonjs.com/draco_decoder_gltf.js"
    */
    wasmUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js",
    wasmBinaryUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm",
    fallbackUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
  }
};
go.DefaultNumWorkers = go.GetDefaultNumWorkers();
go._Default = null;
let n1 = go;
class cg {
  constructor(e, t, n = !1) {
    this._originalSceneClearColor = null, this._originalCameraAutoRotate = null, this._environmentHelper = null, this._shadowLight = null, this._isHologram = !1, this._zkScene = e, this._scene = t, this._sceneHelper = new yi(this._scene), this._isHologram = n;
  }
  get zkScene() {
    return this._zkScene;
  }
  get scene() {
    return this._scene;
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, this.update();
  }
  dispose() {
    this._shadowLight && this._shadowLight.dispose(), this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this.removeOldSkybox();
  }
  update() {
    this.configureScene(), this.configureCamera(), this.configureSkybox();
  }
  configureSkybox() {
    this.removeOldSkybox(), this._isHologram || this.createSkybox();
  }
  removeOldSkybox() {
    const e = this.getSkyboxMesh(), t = this.getSkyboxMaterial();
    e && e.dispose(), t && t.dispose();
  }
  createSkybox() {
    var n, s;
    this.getGeneralConfig();
    const e = this.getEnvironmentConfig(), t = this.getSkyboxConfig();
    if (t && t.get("createSkybox") != null && t.get("createSkybox")) {
      e && e.get("sizeAuto") != null && e.get("sizeAuto") != null && typeof e.get("sizeAuto") == "boolean" && e.get("sizeAuto");
      let o = null;
      t.get("size") != null && typeof t.get("size") == "number" && (o = t.get("size"));
      let h = null;
      t.get("texture") != null && typeof t.get("texture") == "string" && (h = t.get("texture"));
      let c = 0;
      t.get("blur") > 0 && (c = t.get("blur"));
      let m = null;
      t.get("extensions") != null && t.get("extensions") != null && Object.prototype.toString.call(t.get("extensions")) === "[object Array]" && ((n = t.get("extensions")) == null ? void 0 : n.length) === 6 && (m = t.get("extensions"));
      let x = null;
      if (t.get("files") != null && t.get("files") != null && Object.prototype.toString.call(t.get("files")) === "[object Array]" && ((s = t.get("files")) == null ? void 0 : s.length) === 6 && (x = t.get("files")), h) {
        let B = null;
        if (h.endsWith(".dds") ? B = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene) : h.endsWith(".hdr") ? B = new BABYLON.HDRCubeTexture(h, this._scene, 256, !1, !0, !1, !0) : h.endsWith(".env") ? B = new BABYLON.CubeTexture(
          h,
          this._scene,
          null,
          !1,
          null,
          void 0,
          null,
          void 0,
          !0,
          void 0,
          !0
        ) : h.endsWith(".basis") ? B = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene) : m && x ? B = new BABYLON.CubeTexture(h, this._scene, m, !1, x, void 0) : B = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene), B) {
          let I = 1e3;
          o != null && o > 0 ? I = o : I = (this._scene.activeCamera.maxZ - this._scene.activeCamera.minZ) / 2;
          const F = this._scene.createDefaultSkybox(B, !0, I, c, !1);
          if (F) {
            F.metadata = { isSkyboxMesh: !0, isRealMesh: !1 }, F.doNotSerialize = !0;
            const M = F.material;
            M && (M.metadata = { isSkyboxMaterial: !0, isRealMaterial: !1 }, M.doNotSerialize = !0);
          }
        }
      }
    }
  }
  getSkyboxMesh() {
    return this._scene.meshes.find((t) => t.metadata && t.metadata.isSkyboxMesh) || null;
  }
  getSkyboxMaterial() {
    let e = this._scene.materials.find((t) => t.metadata && t.metadata.isSkyboxMaterial);
    return e || null;
  }
  getSkyboxTexture() {
    const e = this.getSkyboxMaterial();
    return e ? e.reflectionTexture : null;
  }
  update_OLD() {
    this.configureScene(), this.configureCamera(), this.configureEnvironment();
  }
  configureScene() {
    if (this._scene) {
      if (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0), this._originalSceneClearColor = this._scene.clearColor.clone(), this._isHologram) {
        this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 1);
        return;
      }
      var e = this.getGeneralConfig();
      if (e) {
        let t = null;
        e.get("backgroundAlpha") != null && e.get("backgroundAlpha") != null && typeof e.get("backgroundAlpha") == "number" && (t = e.get("backgroundAlpha"));
        let n = null;
        if (e.get("backgroundColor") != null && typeof e.get("backgroundColor") == "string" && this.isValidHexColor(e.get("backgroundColor")) && (n = e.get("backgroundColor")), t || n) {
          this._originalSceneClearColor = this._scene.clearColor;
          let s = this._scene.clearColor;
          if (n != null) {
            let o = BABYLON.Color3.FromHexString(n);
            s.r = o.r, s.g = o.g, s.b = o.b;
          }
          t != null && (s.a = t);
        }
      }
    }
  }
  configureEnvironment() {
    if (this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._sceneHelper.countSceneMeshes() != 0) {
      var e = this.buildEnvironmentHelperOptions();
      if (e) {
        this._environmentHelper = this._scene.createDefaultEnvironment(e);
        const t = this.getEnvironmentSceneNodes();
        for (let n = 0; n < t.length; n++) {
          const s = t[n];
          s && (this.setDoNotSerialize(s), s.metadata || (s.metadata = {}), s.metadata.isEnvironmentNode = !0, s instanceof BABYLON.AbstractMesh && (s.isPickable = !1, s.metadata.isRealMesh = !1), s instanceof BABYLON.Material && (s.metadata.isRealMaterial = !1));
        }
      }
    }
  }
  buildEnvironmentHelperOptions() {
    let e = null;
    const t = this.getGeneralConfig(), n = this.getEnvironmentConfig(), s = this.getSkyboxConfig(), o = this.getGroundConfig(), h = this.getCameraConfig();
    let c = null;
    t && t.get("environmentTexture") != null && t.get("environmentTexture") != null && (c = t.get("environmentTexture"));
    let m = null;
    h && h.get("contrast") != null && typeof h.get("contrast") == "number" && (m = h.get("contrast"));
    let x = null;
    h && h.get("exposure") != null && typeof h.get("exposure") == "number" && (x = h.get("exposure"));
    let B = null;
    h && h.get("toneMappingEnabled") != null && typeof h.get("toneMappingEnabled") == "boolean" && (B = h.get("toneMappingEnabled"));
    let I = null;
    n && n.get("sizeAuto") != null && n.get("sizeAuto") != null && typeof n.get("sizeAuto") == "boolean" && (I = n.get("sizeAuto"));
    let F = null;
    n && n.get("mainColor") != null && typeof n.get("mainColor") == "string" && this.isValidHexColor(n.get("mainColor")) && (F = n.get("mainColor"));
    let M = null;
    o && o.get("size") != null && typeof o.get("size") == "number" && (M = o.get("size"));
    let Z = null;
    o && o.get("color") != null && typeof o.get("color") == "string" && this.isValidHexColor(o.get("color")) && (Z = o.get("color"));
    let V = null;
    o && o.get("enableShadow") != null && typeof o.get("enableShadow") == "boolean" && (V = o.get("enableShadow"));
    let te = null;
    o && o.get("shadowLevel") != null && typeof o.get("shadowLevel") == "number" && (te = o.get("shadowLevel"));
    let P = null;
    o && o.get("enableMirror") != null && typeof o.get("enableMirror") == "boolean" && (P = o.get("enableMirror"));
    let K = null;
    o && o.get("texture") != null && typeof o.get("texture") == "string" && (K = o.get("texture"));
    let J = null;
    o && o.get("opacity") != null && typeof o.get("opacity") == "number" && (J = o.get("opacity"));
    let le = null;
    o && o.get("mirrorBlurKernel") != null && typeof o.get("mirrorBlurKernel") == "number" && (le = o.get("mirrorBlurKernel"));
    let fe = null;
    s && s.get("size") != null && typeof s.get("size") == "number" && (fe = s.get("size"));
    let X = null;
    s && s.get("color") != null && typeof s.get("color") == "string" && this.isValidHexColor(s.get("color")) && (X = s.get("color"));
    let W = null;
    s && s.get("texture") != null && typeof s.get("texture") == "string" && (W = s.get("texture"));
    let je = c != null || m != null || x != null || B;
    return (s || o || je) && (e = e || {
      createSkybox: s && s.get("createSkybox"),
      createGround: o && o.get("createGround")
    }, e.setupImageProcessing = !1, c != null && (e.environmentTexture = c), (e.createSkybox || e.createGround) && (I != null && (e.sizeAuto = I), F != null && (e.mainColor = BABYLON.Color3.FromHexString(F)), e.createGround && (!e.sizeAuto && M != null && (e.groundSize = M), !e.mainColor && Z != null && (e.groundColor = BABYLON.Color3.FromHexString(Z)), V != null && (e.enableGroundShadow = V), e.enableGroundShadow && this.createShadowLight(), te != null && (e.groundShadowLevel = te), P != null && (e.enableGroundMirror = P), K != null && (e.groundTexture = K), J != null && (e.groundOpacity = J), e.enableGroundMirror && le != null && (e.groundMirrorBlurKernel = le)), e.createSkybox && (!e.sizeAuto && fe != null && (e.skyboxSize = fe), !e.mainColor && X != null && (e.skyboxColor = BABYLON.Color3.FromHexString(X)), W != null && (e.skyboxTexture = W)), h && (m != null && (e.cameraContrast = m), x != null && (e.cameraExposure = x), B != null && (e.toneMappingEnabled = B)))), e && (!e.environmentTexture && !this._scene.environmentTexture && (e.environmentTexture = gi.Environment.EnvironmentTextureCDNUrl), e.createGround != null && e.createGround && !e.groundTexture && (e.groundTexture = gi.Environment.GroundTextureCDNUrl), e.createSkybox != null && e.createSkybox && !e.skyboxTexture && (e.skyboxTexture = gi.Environment.SkyboxTextureCDNUrl)), e;
  }
  createShadowLight() {
    if (this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._scene && this._sceneHelper) {
      var e = this._sceneHelper.getSceneBoundingInfo();
      if (e && e.boundingBox) {
        const n = e.boundingBox.vectorsWorld, s = Number(n[1].x - n[0].x), o = Number(n[1].y - n[0].y), h = Number(n[1].z - n[0].z), c = e.boundingBox.centerWorld;
        e.boundingBox.maximumWorld;
        const m = c.x + s * 2.67, x = c.y + o * 4.5, B = c.z + h * 1, I = new BABYLON.Vector3(m, x, B);
        let M = c.subtract(I);
        M = BABYLON.Vector3.Normalize(M), M = new BABYLON.Vector3(-2, -3, 1), this._shadowLight = new BABYLON.DirectionalLight("shadowLight", M, this._scene), this._shadowLight.position = I, this._shadowLight.intensity = 0.1;
        var t = new BABYLON.ShadowGenerator(512, this._shadowLight);
        t.useBlurExponentialShadowMap = !0, t.useKernelBlur = !0, t.usePercentageCloserFiltering = !0, t.blurKernel = 32;
        for (let Z = 0; Z < this._scene.meshes.length; Z++) {
          const V = this._scene.meshes[Z];
          !this.isEnvironmentNode(V) && this._sceneHelper.isRealMesh(V) && (V.receiveShadows = !1, t.addShadowCaster(V));
        }
      }
    }
  }
  configureCamera() {
    if (!this._scene || !this._scene.activeCamera || !(this._scene.activeCamera instanceof BABYLON.ArcRotateCamera))
      return;
    const e = this.getCameraConfig();
    if (e) {
      const t = this._scene.activeCamera;
      this._originalCameraAutoRotate = t.useAutoRotationBehavior;
      let n = e.get("autoRotate");
      t.useAutoRotationBehavior = n != null && n;
      let s = t.getBehaviorByName("AutoRotation"), o = Number(e.get("rotationSpeed")), h = e.get("changeRotationDirection");
      if (n && o) {
        let c = h ? -1 : 1;
        s.idleRotationSpeed = o * c;
      }
    }
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  getSceneConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSceneConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGeneralConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGeneralConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getEnvironmentConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getEnvironmentConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getSkyboxConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSkyboxConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGroundConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGroundConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getCameraConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getCameraConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  isValidHexColor(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  }
  getEnvironmentSceneNodes() {
    const e = [];
    return this._environmentHelper && (this._environmentHelper.rootMesh && e.push(this._environmentHelper.rootMesh), this._environmentHelper.skybox && e.push(this._environmentHelper.skybox), this._environmentHelper.skyboxMaterial && e.push(this._environmentHelper.skyboxMaterial), this._environmentHelper.skyboxTexture && e.push(this._environmentHelper.skyboxTexture), this._environmentHelper.ground && e.push(this._environmentHelper.ground), this._environmentHelper.groundMaterial && e.push(this._environmentHelper.groundMaterial), this._environmentHelper.groundTexture && e.push(this._environmentHelper.groundTexture), this._environmentHelper.groundMirror && e.push(this._environmentHelper.groundMirror), this._shadowLight && e.push(this._shadowLight)), e;
  }
  isEnvironmentNode(e) {
    const t = this.getEnvironmentSceneNodes();
    for (let n = 0; n < t.length; n++)
      if (e == t[n])
        return !0;
    return !1;
  }
  setDoNotSerialize(e) {
    (e instanceof BABYLON.AbstractMesh || e instanceof BABYLON.Material || e instanceof BABYLON.Light) && (e.doNotSerialize = !0);
  }
  reset() {
    this._scene && (this._originalSceneClearColor && (this._scene.clearColor = this._originalSceneClearColor), this._originalCameraAutoRotate != null && this._scene.activeCamera && this._scene.activeCamera instanceof BABYLON.ArcRotateCamera && (this._scene.activeCamera.useAutoRotationBehavior = this._originalCameraAutoRotate), this._environmentHelper && this._environmentHelper.updateOptions({}));
  }
}
function fg(y) {
  return typeof importScripts == "function" ? (importScripts(y), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(
      y,
      () => {
        e();
      },
      (n) => {
        t(new Error(n));
      }
    );
  });
}
function dg(y) {
  if (y.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < y.length; t++)
    e.push(fg(y[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function gg(y, e) {
  return y ? y.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function pg(y, e, t) {
  let n = "scene_" + e + ".babylon", s = y;
  const o = [];
  if (s.length <= 5e6) {
    let c = !1;
    s.length > 180 && s.length <= 1e6 && (s = LZString.compressToUint8Array(s), n = "compressed_" + n, c = !0);
    let m = null;
    if (!c)
      m = new Blob([s], { type: "text/plain" });
    else {
      let x = s.buffer;
      m = new Blob([x]);
    }
    m && o.push({
      name: n,
      blob: m
    });
  } else {
    let c = gg(s, 8e5);
    if (c)
      for (let m = 0; m < c.length; m++) {
        let x = c[m], B = n + "_part_" + m, I = !1;
        x.length > 180 && (x = LZString.compressToUint8Array(x), B = "compressed_" + B, I = !0);
        let F = null;
        if (!I)
          F = new Blob([x], { type: "text/plain" });
        else {
          var h = x.buffer;
          F = new Blob([h]);
        }
        F && o.push({
          name: B,
          blob: F
        }), t(m / c.length * 100);
      }
  }
  return o;
}
function r1(y) {
  return typeof document != "object" || typeof y != "string" ? y : BABYLON.Tools.GetAbsoluteUrl(y);
}
function s1() {
  let y;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.urls;
        y = dg(n), postMessage("done");
        break;
      }
      case "makeBlobs": {
        if (!y)
          throw new Error("Worker not initialized");
        y.then(() => {
          const n = t.json, s = t.version, o = pg(n, s, (h) => {
            postMessage({ id: "progress", perc: h });
          });
          postMessage({ id: "result", blobInfos: o }), postMessage("done");
        });
        break;
      }
    }
  };
}
const Cl = class Ca {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return Ca._Default || (Ca._Default = new Ca([])), Ca._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e, t = Ca.DefaultNumWorkers) {
    const n = e.map((s) => r1(s));
    if (t && typeof Worker == "function") {
      const s = `${fg}${dg}${gg}${pg}(${s1})()`, o = URL.createObjectURL(new Blob([s], { type: "application/javascript" })), h = new Array(t);
      for (let c = 0; c < h.length; c++)
        h[c] = new Promise((m, x) => {
          const B = new Worker(o), I = (M) => {
            B.removeEventListener("error", I), B.removeEventListener("message", F), x(M);
          }, F = (M) => {
            M.data === "done" && (B.removeEventListener("error", I), B.removeEventListener("message", F), m(B));
          };
          B.addEventListener("error", I), B.addEventListener("message", F), B.postMessage({
            id: "init",
            urls: n
          });
        });
      this._workerPoolPromise = Promise.all(h).then((c) => new Au(c));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getSceneBlobsAsync(e, t, n) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((s) => new Promise((o, h) => {
        s.push((c, m) => {
          let x = [];
          const B = (F) => {
            c.removeEventListener("error", B), c.removeEventListener("message", I), h(F), m();
          }, I = (F) => {
            F.data === "done" ? (c.removeEventListener("error", B), c.removeEventListener("message", I), o(x), m()) : F.data.id === "progress" ? n(F.data.perc) : F.data.id === "result" && (x = F.data.blobInfos);
          };
          c.addEventListener("error", B), c.addEventListener("message", I), c.postMessage({ id: "makeBlobs", json: e, version: t });
        });
      }));
    throw new Error("SceneToBlob worker is not available");
  }
};
Cl.DefaultNumWorkers = Cl.GetDefaultNumWorkers();
Cl._Default = null;
let a1 = Cl;
class Nl {
  static openSceneViewer(e, t, n = !0, s = null) {
    if (this._fallbackInvoked)
      return;
    const o = self.location.toString(), h = new URL(o), c = new URL(e), m = new URLSearchParams(c.search);
    if (h.hash = this._noArViewerSigil, m.set("mode", "ar_preferred"), m.has("disable_occlusion") || m.set("disable_occlusion", "true"), n || m.set("resizable", "false"), s && s.toLowerCase() === "wall" && m.set("enable_vertical_placement", "true"), m.has("sound")) {
      const I = new URL(m.get("sound"), o);
      m.set("sound", I.toString());
    }
    if (m.has("link")) {
      const I = new URL(m.get("link"), o);
      m.set("link", I.toString());
    }
    const x = `intent://arvr.google.com/scene-viewer/1.0?${m.toString() + "&file=" + encodeURIComponent(
      c.toString()
    )}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(h.toString())};end;`;
    console.log(x);
    const B = () => {
      self.location.hash === this._noArViewerSigil && !this._fallbackInvoked && (this._fallbackInvoked = !0, t && t(), self.history.back());
    };
    self.addEventListener("hashchange", B, { once: !0 }), this._anchor.setAttribute("href", x), this._anchor.setAttribute("target", "_blank"), document.body.appendChild(this._anchor), this._anchor.click();
  }
}
Nl._anchor = document.createElement("a");
Nl._linkOrTitle = /(link|title)(=|&)|(\?|&)(link|title)$/;
Nl._noArViewerSigil = "#model-viewer-no-ar-fallback";
Nl._fallbackInvoked = !1;
class o1 {
  constructor(e, t, n) {
    this._meshesInfoPoints = {}, this._infoPoints = [], this._imageUrls = [], this._currentIdx = 0, this._imagePanel = null, this._loadingText = null, this._image = null, this._closeImageButton = null, this._moveNextImageButton = null, this._movePrevImageButton = null, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this._lastCameraPosition = null, this.onBeforeShowImages = null, this.onAfterShowImages = null, this._infoPointsShown = !0, this._canShowInfoPointsContent = !0, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._renderingNeededListeners = [], this.CLOSE_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-close' style='fill:§color§'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_LEFT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-left'%3E%3Cpath fill='§color§' d='M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_RIGHT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-right'%3E%3Cpath fill='§color§' d='M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this._zkScene = e, this._scene = t, this._sceneHelper = new yi(t), this._style = {}, this.setDefaultStyle(), n && this.setStyle(n), this._rootContainer = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene);
  }
  get infoPointsShown() {
    return this._infoPointsShown;
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this.hideImages();
  }
  dispose() {
    this._renderingNeededListeners = [], this._rootContainer.dispose();
  }
  setDefaultStyle() {
    this._style.infoPointsStyle = {
      borderColor: "#ffffff",
      innerPointColor: "#ffffff",
      color: "#a01c20",
      highlightColor: "#bb2025"
    }, this._style.imagePanelStyle = {
      backgroundColor: this._scene.clearColor.toHexString(),
      loadingTextColor: "#ffffff",
      buttonsBorderColor: "#a01c20",
      buttonsColor: "#a01c20",
      buttonsBorderHighlightColor: "#bb2025",
      buttonsHighlightColor: "#bb2025",
      buttonsIconColor: "white"
    };
  }
  setStyle(e) {
    e ? (e.infoPointsStyle && (this._style.infoPointsStyle || (this._style.infoPointsStyle = {}), e.infoPointsStyle.borderColor && (this._style.infoPointsStyle.borderColor = e.infoPointsStyle.borderColor), e.infoPointsStyle.innerPointColor && (this._style.infoPointsStyle.innerPointColor = e.infoPointsStyle.innerPointColor), e.infoPointsStyle.color && (this._style.infoPointsStyle.color = e.infoPointsStyle.color), e.infoPointsStyle.highlightColor && (this._style.infoPointsStyle.highlightColor = e.infoPointsStyle.highlightColor)), e.imagePanelStyle && (this._style.imagePanelStyle || (this._style.imagePanelStyle = {}), e.imagePanelStyle.backgroundColor && (this._style.imagePanelStyle.backgroundColor = e.imagePanelStyle.backgroundColor), e.imagePanelStyle.loadingTextColor && (this._style.imagePanelStyle.loadingTextColor = e.imagePanelStyle.loadingTextColor), e.imagePanelStyle.buttonsBorderColor && (this._style.imagePanelStyle.buttonsBorderColor = e.imagePanelStyle.buttonsBorderColor), e.imagePanelStyle.buttonsColor && (this._style.imagePanelStyle.buttonsColor = e.imagePanelStyle.buttonsColor), e.imagePanelStyle.buttonsBorderHighlightColor && (this._style.imagePanelStyle.buttonsBorderHighlightColor = e.imagePanelStyle.buttonsBorderHighlightColor), e.imagePanelStyle.buttonsHighlightColor && (this._style.imagePanelStyle.buttonsHighlightColor = e.imagePanelStyle.buttonsHighlightColor), e.imagePanelStyle.buttonsIconColor && (this._style.imagePanelStyle.buttonsIconColor = e.imagePanelStyle.buttonsIconColor))) : this.setDefaultStyle();
  }
  applyStyle(e) {
    this.setStyle(e), this.refresh();
  }
  showInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !0), this._infoPointsShown = !0, this.fireRenderingNeededEvent();
  }
  hideInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !1), this._infoPointsShown = !1, this.fireRenderingNeededEvent();
  }
  refresh() {
    this.hideImages(), this.refreshInfoPoints(), this.updateGuiElementsStyle(), this.fireRenderingNeededEvent();
  }
  getAllInfoPoints() {
    const e = [];
    for (const t in this._meshesInfoPoints)
      e.push(this._meshesInfoPoints[t]);
    return e;
  }
  refreshInfoPoints() {
    for (let e = 0; e < this._scene.meshes.length; e++) {
      const t = this._scene.meshes[e], n = t.metadata && t.metadata.showInfoPoints && (t.isVisible || t.metadata.forceShowInfoPoints), s = t.material, o = s ? this.getMaterialPhotoUrls(s) : [];
      if (n && o.length > 0) {
        const h = this.getOrCreateMeshInfoPoint(t);
        this.updateInfoPointUrls(h, o);
      } else
        this.removeMeshInfoPoints(t);
    }
  }
  removeMeshInfoPoints(e) {
    this._meshesInfoPoints.hasOwnProperty(e.id) && (this._meshesInfoPoints[e.id].dispose(), delete this._meshesInfoPoints[e.id]);
  }
  getOrCreateMeshInfoPoint(e) {
    if (this._meshesInfoPoints.hasOwnProperty(e.id))
      return this._meshesInfoPoints[e.id];
    const t = this.createMeshInfoPoint(e);
    return this._meshesInfoPoints[e.id] = t, t;
  }
  updateInfoPointUrls(e, t) {
    e.metadata || (e.metadata = {}), e.metadata.urls = t;
  }
  createMeshInfoPoint(e) {
    var s, o, h, c;
    const t = new BABYLON.GUI.Ellipse("infoPoint");
    t.width = "29px", t.height = "29px", t.color = ((s = this._style.infoPointsStyle) == null ? void 0 : s.borderColor) || "#dddddd", t.thickness = 4, t.background = ((o = this._style.infoPointsStyle) == null ? void 0 : o.color) || "#a01c20", t.alpha = 1, t.onPointerEnterObservable.add((m) => {
      var x;
      t.background = ((x = this._style.infoPointsStyle) == null ? void 0 : x.highlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), t.onPointerOutObservable.add((m) => {
      var x;
      t.background = ((x = this._style.infoPointsStyle) == null ? void 0 : x.color) || "#a01c20", this.fireRenderingNeededEvent();
    }), this._rootContainer.addControl(t);
    const n = new BABYLON.GUI.Ellipse("innerPoint");
    return n.width = 0.29, n.height = 0.29, n.color = ((h = this._style.infoPointsStyle) == null ? void 0 : h.innerPointColor) || "White", n.thickness = 0, n.background = ((c = this._style.infoPointsStyle) == null ? void 0 : c.innerPointColor) || "White", t.addControl(n), t.linkWithMesh(e), t.linkOffsetY = 0, t.shadowBlur = 6, t.shadowOffsetX = 2, t.shadowOffsetY = 2, t.isPointerBlocker = !0, t.hoverCursor = "pointer", t.onPointerClickObservable.add((m) => {
      if (t.metadata && t.metadata.urls) {
        const x = {
          meshID: e.id,
          materialID: e.material ? e.material.id : null,
          materialPhotoUrl: t.metadata.urls
        };
        this.fireInfoPointPickedEvent(x), this.showImages(t.metadata.urls);
      }
      this.fireRenderingNeededEvent();
    }), t;
  }
  getMaterialInfoPoint(e) {
    for (let t = 0; t < this._infoPoints.length; t++) {
      const n = this._infoPoints[t];
      if (n.metadata && n.metadata.materialID && n.metadata.materialID === e)
        return n;
    }
    return null;
  }
  getMaterialPhotoUrls(e) {
    return this._zkScene.get("materialPhotos").getMaterialPhotoUrls(e.id);
  }
  getOrCreateImagePanel() {
    return this._imagePanel || this.createImagePanel(), this._imagePanel;
  }
  createImagePanel() {
    var t;
    const e = new BABYLON.GUI.Rectangle("imagePanel");
    return e.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.backgroundColor) || this._scene.clearColor.toHexString(), e.width = 1, e.height = 1, e.zIndex = 1e4, e.isVisible = !1, this._imagePanel = e, this._rootContainer.addControl(e), this.addCloseButton(e), this.addMoveNextImageButton(e), this.addMovePrevImageButton(e), e;
  }
  addCloseButton(e) {
    var o, h, c;
    const t = new BABYLON.GUI.StackPanel("closePanel");
    t.height = "48px", t.width = "48px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP, t.isVertical = !1, t.zIndex = 10003, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("closeRect");
    n.width = "24px", n.height = "24px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((m) => {
      var x, B;
      n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderHighlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((m) => {
      var x, B;
      n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderColor) || "#a01c20", this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((m) => {
      this.hideImages(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const s = new BABYLON.GUI.Image("close", this.getCloseSvg(((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsIconColor) || "white"));
    s.width = 1, s.height = 1, s.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, n.addControl(s), this._closeImageButton = t;
  }
  addMoveNextImageButton(e) {
    var o, h, c;
    const t = new BABYLON.GUI.StackPanel("rightPanel");
    t.width = "48px", t.height = "48px", t.paddingRight = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.zIndex = 10003, t.alpha = 0.3, t.isVisible = !1, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("rightRect");
    n.width = "24px", n.height = "48px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((m) => {
      var x, B;
      this._isOnMoveNextButton = !0, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderHighlightColor) || "#bb2025", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((m) => {
      var x, B;
      this._isOnMoveNextButton = !1, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderColor) || "#a01c20", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((m) => {
      this.moveNextImage(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const s = new BABYLON.GUI.Image("move-next", this.getChevronRightSvg(((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsIconColor) || "white"));
    s.width = 1, s.height = 1, s.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, s.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.addControl(s), this._moveNextImageButton = t;
  }
  addMovePrevImageButton(e) {
    var o, h, c;
    const t = new BABYLON.GUI.StackPanel("leftPanel");
    t.width = "48px", t.height = "48px", t.paddingLeft = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.alpha = 0.3, t.zIndex = 10003, t.isVisible = !1, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("leftRect");
    n.width = "24px", n.height = "48px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((m) => {
      var x, B;
      this._isOnMovePrevButton = !0, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderHighlightColor) || "#bb2025", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((m) => {
      var x, B;
      this._isOnMovePrevButton = !1, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((B = this._style.imagePanelStyle) == null ? void 0 : B.buttonsBorderColor) || "#a01c20", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((m) => {
      this.movePrevImage(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const s = new BABYLON.GUI.Image("move-prev", this.getChevronLeftSvg(((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsIconColor) || "white"));
    s.width = 1, s.height = 1, s.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, s.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.addControl(s), this._movePrevImageButton = t;
  }
  updateMoveNextImageButton() {
    this._moveNextImageButton && (this._imageUrls.length <= 1 ? this._moveNextImageButton.isVisible = !1 : (this._moveNextImageButton.isVisible = !0, this._moveNextImageButton.alpha = this.canMoveNextImage() ? this._isOnMoveNextButton ? 1 : 0.3 : 0.1));
  }
  updateMovePrevImageButton() {
    this._movePrevImageButton && (this._imageUrls.length <= 1 ? this._movePrevImageButton.isVisible = !1 : (this._movePrevImageButton.isVisible = !0, this._movePrevImageButton.alpha = this.canMovePrevImage() ? this._isOnMovePrevButton ? 1 : 0.3 : 0.1));
  }
  showImages(e) {
    this._canShowInfoPointsContent && (this._currentIdx = 0, this._imageUrls = e, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this.getOrCreateImagePanel(), this._imagePanel && (this.onBeforeShowImages && this.onBeforeShowImages(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this._imagePanel.isVisible = !0, this.showCurrentImage(), this.fireInfoPointContentShownEvent()), this.fireRenderingNeededEvent());
  }
  moveNextImage() {
    this.canMoveNextImage() && (this._currentIdx++, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  movePrevImage() {
    this.canMovePrevImage() && (this._currentIdx--, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  showCurrentImage() {
    this._currentIdx >= 0 && this._currentIdx < this._imageUrls.length && this.showImage(this._imageUrls[this._currentIdx]);
  }
  canMoveNextImage() {
    return this._imageUrls.length > 0 && this._currentIdx < this._imageUrls.length - 1;
  }
  canMovePrevImage() {
    return this._imageUrls.length > 0 && this._currentIdx > 0;
  }
  hideImages() {
    this._imagePanel && (this._imagePanel.isVisible = !1, this.onAfterShowImages && this.onAfterShowImages(), this.fireInfoPointContentHiddenEvent(), this.fireRenderingNeededEvent());
  }
  showImage(e) {
    if (this._imagePanel) {
      this._image && (this._imagePanel.removeControl(this._image), this._image.isVisible = !1, this._image.dispose(), this._image = null), this.showLoadingText();
      const t = new BABYLON.GUI.Image("but", e);
      t.width = 1, t.height = 1, t.isVisible = !0, t.zIndex = 10002, t.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, t.onImageLoadedObservable.add((n) => {
        this.hideLoadingText();
      }), this._imagePanel.addControl(t), this._image = t, this.fireRenderingNeededEvent();
    }
  }
  /**
   * Update info points visibility and return true if at least one info point has been updated.
   * 
   * @return {boolean} Return true if any info point has been updated.
   */
  updateInfoPointsVisibility() {
    let e = !1;
    if (this._scene.activeCamera && (!this._lastCameraPosition || !this._lastCameraPosition.equals(this._scene.activeCamera.position))) {
      this._lastCameraPosition = this._scene.activeCamera.position.clone();
      for (const t in this._meshesInfoPoints) {
        const n = this._scene.getMeshByID(t);
        n && (this.updateMeshInfoPointVisibility(n, this._meshesInfoPoints[t]), e = !0);
      }
    }
    return e;
  }
  drawRay(e, t) {
    let n = t.subtract(e);
    n = n.normalize();
    const s = t.subtract(e).length() * 2, o = new BABYLON.Ray(e, n, s);
    BABYLON.RayHelper.CreateAndShow(o, this._scene, new BABYLON.Color3(1, 1, 0.1));
  }
  updateMeshInfoPointVisibility(e, t) {
    if (this._scene.activeCamera) {
      const n = this._sceneHelper.getMeshHierarchyCenter(e), s = this._scene.activeCamera.position;
      let o = n.subtract(s);
      o = o.normalize();
      const h = n.subtract(s).length() * 2, c = new BABYLON.Ray(s, o, h), m = this._scene.pickWithRay(c);
      m && m.pickedMesh && (t.alpha = m.pickedMesh === e ? 1 : 0.2);
    }
  }
  getCloseSvg(e) {
    return this.getSvg(this.CLOSE_SVG, e);
  }
  getChevronLeftSvg(e) {
    return this.getSvg(this.CHEVRON_LEFT_SVG, e);
  }
  getChevronRightSvg(e) {
    return this.getSvg(this.CHEVRON_RIGHT_SVG, e);
  }
  getSvg(e, t) {
    return e.replace("§color§", encodeURIComponent(t));
  }
  // -------------------------------------------------------------
  // Events 
  // -------------------------------------------------------------
  // picked
  fireInfoPointPickedEvent(e) {
    for (let t = 0; t < this._infoPointPickedListeners.length; t++)
      this._infoPointPickedListeners[t](e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e);
  }
  addInfoPointPickedListenerRange(e) {
    this._infoPointPickedListeners.push(...e);
  }
  // Content shown
  fireInfoPointContentShownEvent() {
    for (let e = 0; e < this._infoPointContentShownListeners.length; e++)
      this._infoPointContentShownListeners[e]();
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e);
  }
  addInfoPointContentShownListenerRange(e) {
    this._infoPointContentShownListeners.push(...e);
  }
  // content hidden
  fireInfoPointContentHiddenEvent() {
    for (let e = 0; e < this._infoPointContentHiddenListeners.length; e++)
      this._infoPointContentHiddenListeners[e]();
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e);
  }
  addInfoPointContentHiddenListenerRange(e) {
    this._infoPointContentHiddenListeners.push(...e);
  }
  // Rendering Needed
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  showLoadingText() {
    var e;
    if (this._loadingText) {
      this._loadingText.isVisible = !0;
      return;
    }
    this._imagePanel && (this._loadingText = new BABYLON.GUI.TextBlock("loading"), this._loadingText.text = "Loading...", this._loadingText.left = 0.5, this._loadingText.top = 0.7, this._loadingText.zIndex = 10001, this._loadingText.color = ((e = this._style.imagePanelStyle) == null ? void 0 : e.loadingTextColor) || "white", this._imagePanel.addControl(this._loadingText), this.fireRenderingNeededEvent());
  }
  hideLoadingText() {
    this._loadingText && (this._loadingText.isVisible = !1), this.fireRenderingNeededEvent();
  }
  updateGuiElementsStyle() {
    this.updateMeshInfoPointsStyle(), this.updateImagePanelStyle(), this.fireRenderingNeededEvent();
  }
  updateMeshInfoPointsStyle() {
    this.getAllInfoPoints().forEach((e) => {
      var n, s, o;
      e.color = ((n = this._style.infoPointsStyle) == null ? void 0 : n.borderColor) || "#dddddd", e.background = ((s = this._style.infoPointsStyle) == null ? void 0 : s.color) || "#a01c20";
      const t = e.getChildByName("innerPoint");
      t && t instanceof BABYLON.GUI.Container && (t.background = ((o = this._style.infoPointsStyle) == null ? void 0 : o.innerPointColor) || "White");
    });
  }
  updateImagePanelStyle() {
    var e, t, n, s, o, h, c, m;
    if (this._imagePanel) {
      this._imagePanel.background = ((e = this._style.imagePanelStyle) == null ? void 0 : e.backgroundColor) || this._scene.clearColor.toHexString();
      const x = this._imagePanel.getChildByName("closePanel");
      if (x && x instanceof BABYLON.GUI.Container) {
        const F = x.getChildByName("closeRect");
        F && F instanceof BABYLON.GUI.Container && (F.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.buttonsColor) || "#a01c20", F.color = ((n = this._style.imagePanelStyle) == null ? void 0 : n.buttonsBorderColor) || "#a01c20");
      }
      const B = this._imagePanel.getChildByName("rightPanel");
      if (B && B instanceof BABYLON.GUI.Container) {
        const F = B.getChildByName("rightRect");
        F && F instanceof BABYLON.GUI.Container && (F.background = ((s = this._style.imagePanelStyle) == null ? void 0 : s.buttonsColor) || "#a01c20", F.color = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsBorderColor) || "#a01c20");
      }
      const I = this._imagePanel.getChildByName("leftPanel");
      if (I && I instanceof BABYLON.GUI.Container) {
        const F = I.getChildByName("leftRect");
        F && F instanceof BABYLON.GUI.Container && (F.background = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsColor) || "#a01c20", F.color = ((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsBorderColor) || "#a01c20");
      }
      this._loadingText && (this._loadingText.color = ((m = this._style.imagePanelStyle) == null ? void 0 : m.loadingTextColor) || "white");
    }
  }
}
var mg = /* @__PURE__ */ ((y) => (y[y.NotSelected = 0] = "NotSelected", y[y.Eyewear = 1] = "Eyewear", y[y.Scarves = 2] = "Scarves", y[y.Earrings = 3] = "Earrings", y[y.Headwear = 4] = "Headwear", y[y.Necklace = 5] = "Necklace", y[y.Shoes = 6] = "Shoes", y[y.Watches = 7] = "Watches", y[y.Bracelet = 8] = "Bracelet", y))(mg || {}), _g = /* @__PURE__ */ ((y) => (y[y.NotSelected = 0] = "NotSelected", y[y.Mazing = 1] = "Mazing", y[y.Banuba = 2] = "Banuba", y[y.DeepAR = 3] = "DeepAR", y))(_g || {}), Ds = /* @__PURE__ */ ((y) => (y.VirtualTryOn = "try_on", y.GlassPupillaryDistanceTool = "pd", y.StyleButton = "styleButton", y.MandatoryPupillaryDistance = "mandatoryPD", y))(Ds || {}), l1 = /* @__PURE__ */ ((y) => (y.Neutral = "neutral.hdr", y.Light = "light.hdr", y.Bright = "bright.hdr", y.Studio = "studio.hdr", y.Court = "court.hdr", y))(l1 || {}), h1 = /* @__PURE__ */ ((y) => (y.ViewProduct = "VIEW_PRODUCT", y.ViewArProdutc = "VIEW_AR_PRODUCT", y))(h1 || {}), u1 = (
  /** @class */
  function() {
    function y(e) {
      var t = this;
      if (this._axisRoot = null, this._axes = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var n = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(n), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._sceneEditor.addPreUpdateListener(function() {
        return t.onPreUpdate();
      }), this._sceneEditor.addPostUpdateListener(function() {
        return t.onPostUpdate();
      }), this.createAxes();
    }
    return y.prototype.dispose = function() {
      this._scene && (this._scene.dispose(), delete this._scene);
    }, y.prototype.onPreUpdate = function() {
      if (this._scene) {
        var e = this._editorScene.activeCamera;
        if (e && (this._scene.activeCamera = e, this._axisRoot)) {
          var t = BABYLON.Vector3.Distance(e.position, this._axisRoot.position) * 0.03;
          this._axisRoot.scaling = new BABYLON.Vector3(t, t, t), this._axisRoot.computeWorldMatrix(!0);
        }
      }
    }, y.prototype.onPostUpdate = function() {
    }, y.prototype.createAxes = function() {
      var e = this, t = 10, n = this._scene, s = new BABYLON.Mesh("axisRoot", n);
      s.isVisible = this._sceneEditor.canShowAxes();
      var o = function(F, M, Z) {
        var V = new BABYLON.DynamicTexture("DynamicTexture", 50, n, !0);
        V.hasAlpha = !0, V.drawText(F, 5, 40, "bold 36px Arial", M, "transparent", !0);
        var te = BABYLON.MeshBuilder.CreatePlane("TextPlane", { size: Z, updatable: !0 }, n), P = new BABYLON.StandardMaterial("TextPlaneMaterial", n);
        return P.metadata = { isRealMaterial: !1 }, P.backFaceCulling = !1, P.specularColor = new BABYLON.Color3(0, 0, 0), P.diffuseTexture = V, te.material = P, te.metadata = { isRealMesh: !1, isAxis: !0 }, te.parent = s, te.isVisible = e._sceneEditor.canShowAxes(), te;
      }, h = BABYLON.Mesh.CreateLines("axisX", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, 0.05 * t, 0),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, -0.05 * t, 0)
      ], n);
      h.metadata = { isRealMesh: !1, isAxis: !0 }, h.color = new BABYLON.Color3(1, 0, 0), h.parent = s, h.isVisible = this._sceneEditor.canShowAxes();
      var c = o("X", "red", t / 10);
      c.position = new BABYLON.Vector3(0.9 * t, -0.05 * t, 0);
      var m = BABYLON.Mesh.CreateLines("axisY", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(-0.05 * t, t * 0.95, 0),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(0.05 * t, t * 0.95, 0)
      ], n);
      m.metadata = { isRealMesh: !1, isAxis: !0 }, m.color = new BABYLON.Color3(0, 1, 0), m.parent = s, m.isVisible = this._sceneEditor.canShowAxes();
      var x = o("Y", "green", t / 10);
      x.position = new BABYLON.Vector3(0, 0.9 * t, -0.05 * t);
      var B = BABYLON.Mesh.CreateLines("axisZ", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, -0.05 * t, t * 0.95),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, 0.05 * t, t * 0.95)
      ], n);
      B.metadata = { isRealMesh: !1, isAxis: !0 }, B.color = new BABYLON.Color3(0, 0, 1), B.parent = s, B.isVisible = this._sceneEditor.canShowAxes();
      var I = o("Z", "blue", t / 10);
      I.position = new BABYLON.Vector3(0, 0.05 * t, 0.9 * t), this._axisRoot = s, this._axes.push(s, h, m, B, c, x, I);
    }, y.prototype.refresh = function() {
      for (var e = 0; e < this._axes.length; e++) {
        var t = this._axes[e];
        t.isVisible = this._sceneEditor.canShowAxes();
      }
    }, y.prototype.render = function() {
      this._scene && this._scene.activeCamera && this._scene.render();
    }, y.prototype.getScene = function() {
      return this._scene;
    }, y;
  }()
), c1 = (
  /** @class */
  function() {
    function y(e) {
      var t = this;
      if (this._lightMeshes = [], this._lightSelectedListeners = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var n = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(n), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._scene.onPointerDown = this.onPointerDown, this._sceneEditorPreUpdate = function() {
        return t.onPreUpdate();
      }, this._sceneEditorPostUpdate = function() {
        return t.onPostUpdate();
      }, this._sceneEditor.addPreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.addPostUpdateListener(this._sceneEditorPostUpdate);
    }
    return y.prototype.dispose = function() {
      this._sceneEditor && (this._sceneEditor.removePreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.removePostUpdateListener(this._sceneEditorPostUpdate)), this._scene && (this._scene.dispose(), delete this._scene);
    }, y.prototype.onPreUpdate = function() {
      this._scene.activeCamera = this._editorScene.activeCamera;
    }, y.prototype.onPostUpdate = function() {
      this._scene.getEngine();
      for (var e = 0; e < this._lightMeshes.length; e++) {
        var t = this._lightMeshes[e], n = this._editorScene.getLightByID(t.id);
        n && this.configureLightMesh(t, n);
      }
    }, y.prototype.onPointerDown = function(e, t, n) {
      if (t.hit && t.pickedMesh) {
        var s = { name: t.pickedMesh.name, id: t.pickedMesh.id };
        this.fireLightSelectedEvent(s);
      }
    }, y.prototype.refresh = function() {
      this.updateLightMeshes();
    }, y.prototype.updateLightMeshes = function() {
      if (this._scene && this._sceneEditor) {
        for (var e = 0; e < this._editorScene.lights.length; e++) {
          var t = this._editorScene.lights[e], n = this._scene.getMeshByID(t.id);
          n ? this.configureLightMesh(n, t) : this._lightMeshes.push(this.createLightMesh(t));
        }
        for (var e = 0; e < this._lightMeshes.length; e++) {
          var n = this._lightMeshes[e], t = this._editorScene.getLightByID(n.id);
          t || (n.dispose(), this._lightMeshes.splice(e--, 1));
        }
      }
    }, y.prototype.createLightMesh = function(e) {
      var t = new BABYLON.Texture(y._lightTexture, this._scene);
      t.hasAlpha = !0;
      var n = new BABYLON.StandardMaterial("LightMeshMaterial_" + e.id, this._scene);
      n.emissiveColor = BABYLON.Color3.White(), n.useAlphaFromDiffuseTexture = !0, n.disableDepthWrite = !1, n.diffuseTexture = t;
      var s = BABYLON.Mesh.CreatePlane(e.name, 1, this._scene);
      return s.id = e.id, s.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL, s.material = n, this.configureLightMesh(s, e), s;
    }, y.prototype.clearLightMeshes = function() {
      if (this._scene)
        for (; this._lightMeshes.length > 0; ) {
          var e = this._lightMeshes.pop();
          e && e.dispose();
        }
    }, y.prototype.configureLightMesh = function(e, t) {
      var n = this._editorScene.activeCamera;
      if (n && e && t) {
        e.position = t.getAbsolutePosition();
        var s = BABYLON.Vector3.Distance(n.position, e.position) * 0.03;
        e.scaling = new BABYLON.Vector3(s, s, s), e.computeWorldMatrix(!0), e.isVisible = this._sceneEditor.canShowLights();
      }
    }, y.prototype.render = function() {
      this._scene && this._scene.render();
    }, y.prototype.getScene = function() {
      return this._scene;
    }, y.prototype.fireLightSelectedEvent = function(e) {
      for (var t = 0; t < this._lightSelectedListeners.length; ++t)
        this._lightSelectedListeners[t](e);
    }, y.prototype.addLightSelectedListener = function(e) {
      this._lightSelectedListeners.push(e);
    }, y._lightTexture = "data:image/png;base64,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", y;
  }()
);
class f1 {
  /**
   * Create a new EventState
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   */
  constructor(e, t = !1, n, s) {
    this.skipNextObservers = !1, this.mask = 0, this.initalize(e, t, n, s);
  }
  /**
   * Initialize the current event state
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns the current event state
   */
  initalize(e, t = !1, n, s) {
    return this.mask = e, this.skipNextObservers = t, this.target = n, this.currentTarget = s, this;
  }
}
class d1 {
  /**
   * Creates a new observer
   * @param callback defines the callback to call when the observer is notified
   * @param mask defines the mask of the observer (used to filter notifications)
   * @param scope defines the current scope used to restore the JS context
   */
  constructor(e, t, n = null) {
    this.callback = e, this.mask = t, this.scope = n, this._willBeUnregistered = !1, this.unregisterOnNextCall = !1;
  }
}
class vg {
  constructor() {
    this._observers = null, this._observables = null;
  }
  /**
   * Release associated resources
   */
  dispose() {
    if (this._observers && this._observables)
      for (var e = 0; e < this._observers.length; e++)
        this._observables[e].remove(this._observers[e]);
    this._observers = null, this._observables = null;
  }
  /**
   * Raise a callback when one of the observable will notify
   * @param observables defines a list of observables to watch
   * @param callback defines the callback to call on notification
   * @param mask defines the mask used to filter notifications
   * @param scope defines the current scope used to restore the JS context
   * @returns the new MultiObserver
   */
  static Watch(e, t, n = 0, s = null) {
    let o = new vg();
    o._observers = new Array(), o._observables = e;
    for (var h of e) {
      let c = h.add(t, n, !1, s);
      c && o._observers.push(c);
    }
    return o;
  }
}
class yg {
  /**
   * Creates a new observable
   * @param onObserverAdded defines a callback to call when a new observer is added
   */
  constructor(e) {
    this._observers = new Array(), this._onObserverAdded = null, this._eventState = new f1(0), e && (this._onObserverAdded = e);
  }
  /**
   * Gets the list of observers
   */
  get observers() {
    return this._observers;
  }
  /**
   * Create a new Observer with the specified callback
   * @param callback the callback that will be executed for that Observer
   * @param mask the mask used to filter observers
   * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
   * @param scope optional scope for the callback to be called from
   * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
   * @returns the new observer created for the callback
   */
  add(e, t = 0, n = !1, s = null, o = !1) {
    if (!e)
      return null;
    var h = new d1(e, t, s);
    return h.unregisterOnNextCall = o, n ? this._observers.unshift(h) : this._observers.push(h), this._onObserverAdded && this._onObserverAdded(h), h;
  }
  /**
   * Create a new Observer with the specified callback and unregisters after the next notification
   * @param callback the callback that will be executed for that Observer
   * @returns the new observer created for the callback
   */
  addOnce(e) {
    return this.add(e, void 0, void 0, void 0, !0);
  }
  /**
   * Remove an Observer from the Observable object
   * @param observer the instance of the Observer to remove
   * @returns false if it doesn't belong to this Observable
   */
  remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._deferUnregister(e), !0) : !1;
  }
  /**
   * Remove a callback from the Observable object
   * @param callback the callback to remove
   * @param scope optional scope. If used only the callbacks with this scope will be removed
   * @returns false if it doesn't belong to this Observable
  */
  removeCallback(e, t) {
    for (var n = 0; n < this._observers.length; n++) {
      const s = this._observers[n];
      if (!s._willBeUnregistered && s.callback === e && (!t || t === s.scope))
        return this._deferUnregister(s), !0;
    }
    return !1;
  }
  _deferUnregister(e) {
    e.unregisterOnNextCall = !1, e._willBeUnregistered = !0, setTimeout(() => {
      this._remove(e);
    }, 0);
  }
  // This should only be called when not iterating over _observers to avoid callback skipping.
  // Removes an observer from the _observer Array.
  _remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._observers.splice(t, 1), !0) : !1;
  }
  /**
   * Moves the observable to the top of the observer list making it get called first when notified
   * @param observer the observer to move
   */
  makeObserverTopPriority(e) {
    this._remove(e), this._observers.unshift(e);
  }
  /**
   * Moves the observable to the bottom of the observer list making it get called last when notified
   * @param observer the observer to move
   */
  makeObserverBottomPriority(e) {
    this._remove(e), this._observers.push(e);
  }
  /**
   * Notify all Observers by calling their respective callback with the given data
   * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
   * @param eventData defines the data to send to all observers
   * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
   */
  notifyObservers(e, t = 0, n, s) {
    if (!this._observers.length)
      return !0;
    let o = this._eventState;
    o.mask = t, o.target = n, o.currentTarget = s, o.skipNextObservers = !1, o.lastReturnValue = e;
    for (var h of this._observers)
      if (!h._willBeUnregistered && (h.mask & t && (h.scope ? o.lastReturnValue = h.callback.apply(h.scope, [e, o]) : o.lastReturnValue = h.callback(e, o), h.unregisterOnNextCall && this._deferUnregister(h)), o.skipNextObservers))
        return !1;
    return !0;
  }
  /**
   * Calling this will execute each callback, expecting it to be a promise or return a value.
   * If at any point in the chain one function fails, the promise will fail and the execution will not continue.
   * This is useful when a chain of events (sometimes async events) is needed to initialize a certain object
   * and it is crucial that all callbacks will be executed.
   * The order of the callbacks is kept, callbacks are not executed parallel.
   *
   * @param eventData The data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   * @param target defines the callback target (see EventState)
   * @param currentTarget defines he current object in the bubbling phase
   * @returns {Promise<T>} will return a Promise than resolves when all callbacks executed successfully.
   */
  notifyObserversWithPromise(e, t = 0, n, s) {
    let o = Promise.resolve(e);
    if (!this._observers.length)
      return o;
    let h = this._eventState;
    return h.mask = t, h.target = n, h.currentTarget = s, h.skipNextObservers = !1, this._observers.forEach((c) => {
      h.skipNextObservers || c._willBeUnregistered || c.mask & t && (c.scope ? o = o.then((m) => (h.lastReturnValue = m, c.callback.apply(c.scope, [e, h]))) : o = o.then((m) => (h.lastReturnValue = m, c.callback(e, h))), c.unregisterOnNextCall && this._deferUnregister(c));
    }), o.then(() => e);
  }
  /**
   * Notify a specific observer
   * @param observer defines the observer to notify
   * @param eventData defines the data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   */
  notifyObserver(e, t, n = 0) {
    let s = this._eventState;
    s.mask = n, s.skipNextObservers = !1, e.callback(t, s);
  }
  /**
   * Gets a boolean indicating if the observable has at least one observer
   * @returns true is the Observable has at least one Observer registered
   */
  hasObservers() {
    return this._observers.length > 0;
  }
  /**
  * Clear the list of observers
  */
  clear() {
    this._observers = new Array(), this._onObserverAdded = null;
  }
  /**
   * Clone the current observable
   * @returns a new observable
   */
  clone() {
    var e = new yg();
    return e._observers = this._observers.slice(0), e;
  }
  /**
   * Does this observable handles observer registered with a given mask
   * @param mask defines the mask to be tested
   * @return whether or not one observer registered with the given mask is handeled
  **/
  hasSpecificMask(e = 0) {
    for (var t of this._observers)
      if (t.mask & e || t.mask === e)
        return !0;
    return !1;
  }
}
class ed {
  /**
   * Creates a new Database
  */
  constructor() {
    this._idbFactory = typeof window < "u" ? window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB : indexedDB, this._db = null, this._hasReachedQuota = !1, this._isSupported = !0;
  }
  openAsync() {
    return new Promise((e, t) => this.open(e, t));
  }
  /**
   * Open the database and make it available
   * @param successCallback defines the callback to call on success
   * @param errorCallback defines the callback to call on error
   */
  open(e, t) {
    const n = () => {
      this._isSupported = !1, t && t();
    };
    if (!this._idbFactory)
      this._isSupported = !1, t && t();
    else if (this._db)
      e && e();
    else {
      this._hasReachedQuota = !1, this._isSupported = !0;
      const s = this._idbFactory.open("zakeke", 1);
      s.onerror = () => {
        n();
      }, s.onblocked = () => {
        Logger.info("IDB request blocked. Please reload the page."), n();
      }, s.onsuccess = () => {
        this._db = s.result, e();
      }, s.onupgradeneeded = (o) => {
        if (this._db = o.target.result, this._db)
          try {
            this._db.createObjectStore("files", { keyPath: "fileId" });
          } catch (h) {
            Logger.info("Error while creating object stores. Exception: " + h.message), n();
          }
      };
    }
  }
  loadFileAsync(e) {
    return new Promise((t, n) => {
      if (this._isSupported && this._db) {
        const s = "files";
        let o;
        const h = this._db.transaction([s]);
        h.oncomplete = () => {
          t(o ? o.data : null);
        }, h.onabort = () => {
          t(null);
        };
        const c = h.objectStore(s).get(e);
        c.onsuccess = (m) => {
          o = m.target.result;
        }, c.onerror = () => {
          Logger.info("Error loading file " + e + " from DB."), t(null);
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), n("IndexedDB not supported or Db is not open");
    });
  }
  saveFileAsync(e, t) {
    return new Promise((n, s) => {
      if (this._isSupported) {
        const o = "files";
        if (!this._hasReachedQuota && this._db) {
          const h = this._db.transaction([o], "readwrite");
          h.onabort = (x) => {
            const B = x.srcElement.error;
            B && B.name === "QuotaExceededError" && (this._hasReachedQuota = !0, s("Quota Exceeded"));
          }, h.oncomplete = () => {
            Logger.info("File saved successfully"), n();
          };
          const c = { fileId: e, data: t }, m = h.objectStore(o).put(c);
          m.onsuccess = () => {
          }, m.onerror = () => {
            Logger.info("Error in DB add file request in Zakeke3D.Database."), s("Error in DB add file request");
          };
        } else {
          const h = this._hasReachedQuota ? "Quota has been reached" : "Database closed";
          s(h);
        }
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), s("IndexedDB not supported or Db is not open");
    });
  }
  deleteFileAsync(e) {
    return new Promise((t, n) => {
      if (this._isSupported && this._db) {
        const s = "files", o = this._db.transaction([s]);
        o.oncomplete = () => {
          t();
        }, o.onabort = () => {
          n("aborted cancellation");
        };
        const h = o.objectStore(s).get(e);
        h.onerror = () => {
          Logger.info("Error deleting file " + e + " from DB."), n("Error deleting file from DB");
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), n("IndexedDB not supported or Db is not open");
    });
  }
}
var Al = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Al.exports;
(function(y, e) {
  (function() {
    var t, n = "4.18.1", s = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", c = "Invalid `variable` option passed into `_.template`", m = "Invalid `imports` option passed into `_.template`", x = "__lodash_hash_undefined__", B = 500, I = "__lodash_placeholder__", F = 1, M = 2, Z = 4, V = 1, te = 2, P = 1, K = 2, J = 4, le = 8, fe = 16, X = 32, W = 64, je = 128, Ee = 256, He = 512, ft = 30, Le = "...", $e = 800, ce = 16, ut = 1, ze = 2, pt = 3, qt = 1 / 0, We = 9007199254740991, Et = 17976931348623157e292, rt = 0 / 0, it = 4294967295, Zt = it - 1, $t = it >>> 1, Lt = [
      ["ary", je],
      ["bind", P],
      ["bindKey", K],
      ["curry", le],
      ["curryRight", fe],
      ["flip", He],
      ["partial", X],
      ["partialRight", W],
      ["rearg", Ee]
    ], ii = "[object Arguments]", Ci = "[object Array]", ui = "[object AsyncFunction]", Gt = "[object Boolean]", Xt = "[object Date]", Qt = "[object DOMException]", Ni = "[object Error]", Di = "[object Function]", pe = "[object GeneratorFunction]", xt = "[object Map]", tt = "[object Number]", Pe = "[object Null]", ke = "[object Object]", Je = "[object Promise]", kt = "[object Proxy]", vt = "[object RegExp]", Qe = "[object Set]", wt = "[object String]", Yt = "[object Symbol]", Ye = "[object Undefined]", i = "[object WeakMap]", r = "[object WeakSet]", a = "[object ArrayBuffer]", l = "[object DataView]", u = "[object Float32Array]", d = "[object Float64Array]", v = "[object Int8Array]", p = "[object Int16Array]", b = "[object Int32Array]", S = "[object Uint8Array]", L = "[object Uint8ClampedArray]", E = "[object Uint16Array]", A = "[object Uint32Array]", T = /\b__p \+= '';/g, G = /\b(__p \+=) '' \+/g, D = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Y = /&(?:amp|lt|gt|quot|#39);/g, k = /[&<>"']/g, z = RegExp(Y.source), C = RegExp(k.source), O = /<%-([\s\S]+?)%>/g, j = /<%([\s\S]+?)%>/g, q = /<%=([\s\S]+?)%>/g, H = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ie = /^\w*$/, ae = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ue = /[\\^$.*+?()[\]{}|]/g, me = RegExp(ue.source), se = /^\s+/, de = /\s/, ve = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, we = /\{\n\/\* \[wrapped with (.+)\] \*/, Se = /,? & /, Ae = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ge = /[()=,{}\[\]\/\s]/, et = /\\(\\)?/g, st = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, _t = /\w*$/, Re = /^[-+]0x[0-9a-f]+$/i, Fe = /^0b[01]+$/i, at = /^\[object .+?Constructor\]$/, yt = /^0o[0-7]+$/i, bt = /^(?:0|[1-9]\d*)$/, Rt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, It = /($^)/, Ht = /['\n\r\u2028\u2029\\]/g, jt = "\\ud800-\\udfff", Vt = "\\u0300-\\u036f", Ti = "\\ufe20-\\ufe2f", ki = "\\u20d0-\\u20ff", Li = Vt + Ti + ki, bi = "\\u2700-\\u27bf", si = "a-z\\xdf-\\xf6\\xf8-\\xff", Nt = "\\xac\\xb1\\xd7\\xf7", Vi = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ci = "\\u2000-\\u206f", nn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Yi = "A-Z\\xc0-\\xd6\\xd8-\\xde", qi = "\\ufe0e\\ufe0f", Qi = Nt + Vi + ci + nn, Gi = "['’]", Xi = "[" + jt + "]", _n = "[" + Qi + "]", Ki = "[" + Li + "]", cn = "\\d+", Cn = "[" + bi + "]", $r = "[" + si + "]", Pr = "[^" + jt + Qi + cn + bi + si + Yi + "]", An = "\\ud83c[\\udffb-\\udfff]", Xr = "(?:" + Ki + "|" + An + ")", Vn = "[^" + jt + "]", gr = "(?:\\ud83c[\\udde6-\\uddff]){2}", Hn = "[\\ud800-\\udbff][\\udc00-\\udfff]", fn = "[" + Yi + "]", dn = "\\u200d", bn = "(?:" + $r + "|" + Pr + ")", sn = "(?:" + fn + "|" + Pr + ")", ri = "(?:" + Gi + "(?:d|ll|m|re|s|t|ve))?", gn = "(?:" + Gi + "(?:D|LL|M|RE|S|T|VE))?", rn = Xr + "?", On = "[" + qi + "]?", pr = "(?:" + dn + "(?:" + [Vn, gr, Hn].join("|") + ")" + On + rn + ")*", Nr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", wr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Sr = On + rn + pr, g = "(?:" + [Cn, gr, Hn].join("|") + ")" + Sr, U = "(?:" + [Vn + Ki + "?", Ki, gr, Hn, Xi].join("|") + ")", he = RegExp(Gi, "g"), ye = RegExp(Ki, "g"), Ie = RegExp(An + "(?=" + An + ")|" + U + Sr, "g"), ot = RegExp([
      fn + "?" + $r + "+" + ri + "(?=" + [_n, fn, "$"].join("|") + ")",
      sn + "+" + gn + "(?=" + [_n, fn + bn, "$"].join("|") + ")",
      fn + "?" + bn + "+" + ri,
      fn + "+" + gn,
      wr,
      Nr,
      cn,
      g
    ].join("|"), "g"), dt = RegExp("[" + dn + jt + Li + qi + "]"), zt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Kt = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], fi = -1, ti = {};
    ti[u] = ti[d] = ti[v] = ti[p] = ti[b] = ti[S] = ti[L] = ti[E] = ti[A] = !0, ti[ii] = ti[Ci] = ti[a] = ti[Gt] = ti[l] = ti[Xt] = ti[Ni] = ti[Di] = ti[xt] = ti[tt] = ti[ke] = ti[vt] = ti[Qe] = ti[wt] = ti[i] = !1;
    var hi = {};
    hi[ii] = hi[Ci] = hi[a] = hi[l] = hi[Gt] = hi[Xt] = hi[u] = hi[d] = hi[v] = hi[p] = hi[b] = hi[xt] = hi[tt] = hi[ke] = hi[vt] = hi[Qe] = hi[wt] = hi[Yt] = hi[S] = hi[L] = hi[E] = hi[A] = !0, hi[Ni] = hi[Di] = hi[i] = !1;
    var vn = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, ar = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Tn = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Mr = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Cr = parseFloat, or = parseInt, Ar = typeof as == "object" && as && as.Object === Object && as, ls = typeof self == "object" && self && self.Object === Object && self, Sn = Ar || ls || Function("return this")(), Rr = e && !e.nodeType && e, Dr = Rr && !0 && y && !y.nodeType && y, vs = Dr && Dr.exports === Rr, Ts = vs && Ar.process, w = function() {
      try {
        var Ne = Dr && Dr.require && Dr.require("util").types;
        return Ne || Ts && Ts.binding && Ts.binding("util");
      } catch {
      }
    }(), N = w && w.isArrayBuffer, ee = w && w.isDate, re = w && w.isMap, ge = w && w.isRegExp, _e = w && w.isSet, xe = w && w.isTypedArray;
    function Ue(Ne, Ze, Q) {
      switch (Q.length) {
        case 0:
          return Ne.call(Ze);
        case 1:
          return Ne.call(Ze, Q[0]);
        case 2:
          return Ne.call(Ze, Q[0], Q[1]);
        case 3:
          return Ne.call(Ze, Q[0], Q[1], Q[2]);
      }
      return Ne.apply(Ze, Q);
    }
    function De(Ne, Ze, Q, oe) {
      for (var Me = -1, Be = Ne == null ? 0 : Ne.length; ++Me < Be; ) {
        var ht = Ne[Me];
        Ze(oe, ht, Q(ht), Ne);
      }
      return oe;
    }
    function qe(Ne, Ze) {
      for (var Q = -1, oe = Ne == null ? 0 : Ne.length; ++Q < oe && Ze(Ne[Q], Q, Ne) !== !1; )
        ;
      return Ne;
    }
    function At(Ne, Ze) {
      for (var Q = Ne == null ? 0 : Ne.length; Q-- && Ze(Ne[Q], Q, Ne) !== !1; )
        ;
      return Ne;
    }
    function Bt(Ne, Ze) {
      for (var Q = -1, oe = Ne == null ? 0 : Ne.length; ++Q < oe; )
        if (!Ze(Ne[Q], Q, Ne))
          return !1;
      return !0;
    }
    function ct(Ne, Ze) {
      for (var Q = -1, oe = Ne == null ? 0 : Ne.length, Me = 0, Be = []; ++Q < oe; ) {
        var ht = Ne[Q];
        Ze(ht, Q, Ne) && (Be[Me++] = ht);
      }
      return Be;
    }
    function Ft(Ne, Ze) {
      var Q = Ne == null ? 0 : Ne.length;
      return !!Q && lr(Ne, Ze, 0) > -1;
    }
    function pi(Ne, Ze, Q) {
      for (var oe = -1, Me = Ne == null ? 0 : Ne.length; ++oe < Me; )
        if (Q(Ze, Ne[oe]))
          return !0;
      return !1;
    }
    function ai(Ne, Ze) {
      for (var Q = -1, oe = Ne == null ? 0 : Ne.length, Me = Array(oe); ++Q < oe; )
        Me[Q] = Ze(Ne[Q], Q, Ne);
      return Me;
    }
    function mi(Ne, Ze) {
      for (var Q = -1, oe = Ze.length, Me = Ne.length; ++Q < oe; )
        Ne[Me + Q] = Ze[Q];
      return Ne;
    }
    function xn(Ne, Ze, Q, oe) {
      var Me = -1, Be = Ne == null ? 0 : Ne.length;
      for (oe && Be && (Q = Ne[++Me]); ++Me < Be; )
        Q = Ze(Q, Ne[Me], Me, Ne);
      return Q;
    }
    function wn(Ne, Ze, Q, oe) {
      var Me = Ne == null ? 0 : Ne.length;
      for (oe && Me && (Q = Ne[--Me]); Me--; )
        Q = Ze(Q, Ne[Me], Me, Ne);
      return Q;
    }
    function an(Ne, Ze) {
      for (var Q = -1, oe = Ne == null ? 0 : Ne.length; ++Q < oe; )
        if (Ze(Ne[Q], Q, Ne))
          return !0;
      return !1;
    }
    var Si = Yn("length");
    function Ii(Ne) {
      return Ne.split("");
    }
    function Dn(Ne) {
      return Ne.match(Ae) || [];
    }
    function Fi(Ne, Ze, Q) {
      var oe;
      return Q(Ne, function(Me, Be, ht) {
        if (Ze(Me, Be, ht))
          return oe = Be, !1;
      }), oe;
    }
    function en(Ne, Ze, Q, oe) {
      for (var Me = Ne.length, Be = Q + (oe ? 1 : -1); oe ? Be-- : ++Be < Me; )
        if (Ze(Ne[Be], Be, Ne))
          return Be;
      return -1;
    }
    function lr(Ne, Ze, Q) {
      return Ze === Ze ? ys(Ne, Ze, Q) : en(Ne, pn, Q);
    }
    function mr(Ne, Ze, Q, oe) {
      for (var Me = Q - 1, Be = Ne.length; ++Me < Be; )
        if (oe(Ne[Me], Ze))
          return Me;
      return -1;
    }
    function pn(Ne) {
      return Ne !== Ne;
    }
    function Tr(Ne, Ze) {
      var Q = Ne == null ? 0 : Ne.length;
      return Q ? zr(Ne, Ze) / Q : rt;
    }
    function Yn(Ne) {
      return function(Ze) {
        return Ze == null ? t : Ze[Ne];
      };
    }
    function ei(Ne) {
      return function(Ze) {
        return Ne == null ? t : Ne[Ze];
      };
    }
    function Zn(Ne, Ze, Q, oe, Me) {
      return Me(Ne, function(Be, ht, gt) {
        Q = oe ? (oe = !1, Be) : Ze(Q, Be, ht, gt);
      }), Q;
    }
    function Gn(Ne, Ze) {
      var Q = Ne.length;
      for (Ne.sort(Ze); Q--; )
        Ne[Q] = Ne[Q].value;
      return Ne;
    }
    function zr(Ne, Ze) {
      for (var Q, oe = -1, Me = Ne.length; ++oe < Me; ) {
        var Be = Ze(Ne[oe]);
        Be !== t && (Q = Q === t ? Be : Q + Be);
      }
      return Q;
    }
    function Ai(Ne, Ze) {
      for (var Q = -1, oe = Array(Ne); ++Q < Ne; )
        oe[Q] = Ze(Q);
      return oe;
    }
    function hn(Ne, Ze) {
      return ai(Ze, function(Q) {
        return [Q, Ne[Q]];
      });
    }
    function Jt(Ne) {
      return Ne && Ne.slice(0, bs(Ne) + 1).replace(se, "");
    }
    function Ln(Ne) {
      return function(Ze) {
        return Ne(Ze);
      };
    }
    function _i(Ne, Ze) {
      return ai(Ze, function(Q) {
        return Ne[Q];
      });
    }
    function Ei(Ne, Ze) {
      return Ne.has(Ze);
    }
    function Bn(Ne, Ze) {
      for (var Q = -1, oe = Ne.length; ++Q < oe && lr(Ze, Ne[Q], 0) > -1; )
        ;
      return Q;
    }
    function di(Ne, Ze) {
      for (var Q = Ne.length; Q-- && lr(Ze, Ne[Q], 0) > -1; )
        ;
      return Q;
    }
    function un(Ne, Ze) {
      for (var Q = Ne.length, oe = 0; Q--; )
        Ne[Q] === Ze && ++oe;
      return oe;
    }
    var Fr = ei(vn), Js = ei(ar);
    function Kr(Ne) {
      return "\\" + Mr[Ne];
    }
    function Ur(Ne, Ze) {
      return Ne == null ? t : Ne[Ze];
    }
    function Ji(Ne) {
      return dt.test(Ne);
    }
    function Pn(Ne) {
      return zt.test(Ne);
    }
    function hr(Ne) {
      for (var Ze, Q = []; !(Ze = Ne.next()).done; )
        Q.push(Ze.value);
      return Q;
    }
    function tr(Ne) {
      var Ze = -1, Q = Array(Ne.size);
      return Ne.forEach(function(oe, Me) {
        Q[++Ze] = [Me, oe];
      }), Q;
    }
    function Vr(Ne, Ze) {
      return function(Q) {
        return Ne(Ze(Q));
      };
    }
    function $n(Ne, Ze) {
      for (var Q = -1, oe = Ne.length, Me = 0, Be = []; ++Q < oe; ) {
        var ht = Ne[Q];
        (ht === Ze || ht === I) && (Ne[Q] = I, Be[Me++] = Q);
      }
      return Be;
    }
    function Ri(Ne) {
      var Ze = -1, Q = Array(Ne.size);
      return Ne.forEach(function(oe) {
        Q[++Ze] = oe;
      }), Q;
    }
    function hs(Ne) {
      var Ze = -1, Q = Array(Ne.size);
      return Ne.forEach(function(oe) {
        Q[++Ze] = [oe, oe];
      }), Q;
    }
    function ys(Ne, Ze, Q) {
      for (var oe = Q - 1, Me = Ne.length; ++oe < Me; )
        if (Ne[oe] === Ze)
          return oe;
      return -1;
    }
    function Ls(Ne, Ze, Q) {
      for (var oe = Q + 1; oe--; )
        if (Ne[oe] === Ze)
          return oe;
      return oe;
    }
    function Jn(Ne) {
      return Ji(Ne) ? Oe(Ne) : Si(Ne);
    }
    function zn(Ne) {
      return Ji(Ne) ? Ke(Ne) : Ii(Ne);
    }
    function bs(Ne) {
      for (var Ze = Ne.length; Ze-- && de.test(Ne.charAt(Ze)); )
        ;
      return Ze;
    }
    var ur = ei(Tn);
    function Oe(Ne) {
      for (var Ze = Ie.lastIndex = 0; Ie.test(Ne); )
        ++Ze;
      return Ze;
    }
    function Ke(Ne) {
      return Ne.match(Ie) || [];
    }
    function mt(Ne) {
      return Ne.match(ot) || [];
    }
    var St = function Ne(Ze) {
      Ze = Ze == null ? Sn : Tt.defaults(Sn.Object(), Ze, Tt.pick(Sn, Kt));
      var Q = Ze.Array, oe = Ze.Date, Me = Ze.Error, Be = Ze.Function, ht = Ze.Math, gt = Ze.Object, Mt = Ze.RegExp, Wt = Ze.String, xi = Ze.TypeError, ji = Q.prototype, Nn = Be.prototype, mn = gt.prototype, _r = Ze["__core-js_shared__"], jn = Nn.toString, on = mn.hasOwnProperty, kg = 0, Eu = function() {
        var f = /[^.]+$/.exec(_r && _r.keys && _r.keys.IE_PROTO || "");
        return f ? "Symbol(src)_1." + f : "";
      }(), yo = mn.toString, Eg = jn.call(gt), Ig = Sn._, Og = Mt(
        "^" + jn.call(on).replace(ue, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), bo = vs ? Ze.Buffer : t, Fs = Ze.Symbol, xo = Ze.Uint8Array, Iu = bo ? bo.allocUnsafe : t, wo = Vr(gt.getPrototypeOf, gt), Ou = gt.create, Pu = mn.propertyIsEnumerable, So = ji.splice, Nu = Fs ? Fs.isConcatSpreadable : t, Na = Fs ? Fs.iterator : t, Qs = Fs ? Fs.toStringTag : t, Mo = function() {
        try {
          var f = ra(gt, "defineProperty");
          return f({}, "", {}), f;
        } catch {
        }
      }(), Pg = Ze.clearTimeout !== Sn.clearTimeout && Ze.clearTimeout, Ng = oe && oe.now !== Sn.Date.now && oe.now, Rg = Ze.setTimeout !== Sn.setTimeout && Ze.setTimeout, Co = ht.ceil, Ao = ht.floor, Rl = gt.getOwnPropertySymbols, Dg = bo ? bo.isBuffer : t, Ru = Ze.isFinite, zg = ji.join, Fg = Vr(gt.keys, gt), Xn = ht.max, cr = ht.min, Ug = oe.now, Vg = Ze.parseInt, Du = ht.random, Hg = ji.reverse, Dl = ra(Ze, "DataView"), Ra = ra(Ze, "Map"), zl = ra(Ze, "Promise"), pa = ra(Ze, "Set"), Da = ra(Ze, "WeakMap"), za = ra(gt, "create"), To = Da && new Da(), ma = {}, Yg = sa(Dl), Gg = sa(Ra), jg = sa(zl), Wg = sa(pa), qg = sa(Da), Lo = Fs ? Fs.prototype : t, Fa = Lo ? Lo.valueOf : t, zu = Lo ? Lo.toString : t;
      function Ce(f) {
        if (Rn(f) && !Oi(f) && !(f instanceof Zi)) {
          if (f instanceof Jr)
            return f;
          if (on.call(f, "__wrapped__"))
            return Fc(f);
        }
        return new Jr(f);
      }
      var _a = function() {
        function f() {
        }
        return function(_) {
          if (!kn(_))
            return {};
          if (Ou)
            return Ou(_);
          f.prototype = _;
          var R = new f();
          return f.prototype = t, R;
        };
      }();
      function Bo() {
      }
      function Jr(f, _) {
        this.__wrapped__ = f, this.__actions__ = [], this.__chain__ = !!_, this.__index__ = 0, this.__values__ = t;
      }
      Ce.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: O,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: j,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: q,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Ce
        }
      }, Ce.prototype = Bo.prototype, Ce.prototype.constructor = Ce, Jr.prototype = _a(Bo.prototype), Jr.prototype.constructor = Jr;
      function Zi(f) {
        this.__wrapped__ = f, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = it, this.__views__ = [];
      }
      function Zg() {
        var f = new Zi(this.__wrapped__);
        return f.__actions__ = Lr(this.__actions__), f.__dir__ = this.__dir__, f.__filtered__ = this.__filtered__, f.__iteratees__ = Lr(this.__iteratees__), f.__takeCount__ = this.__takeCount__, f.__views__ = Lr(this.__views__), f;
      }
      function $g() {
        if (this.__filtered__) {
          var f = new Zi(this);
          f.__dir__ = -1, f.__filtered__ = !0;
        } else
          f = this.clone(), f.__dir__ *= -1;
        return f;
      }
      function Xg() {
        var f = this.__wrapped__.value(), _ = this.__dir__, R = Oi(f), ne = _ < 0, be = R ? f.length : 0, Te = lm(0, be, this.__views__), Ve = Te.start, Xe = Te.end, lt = Xe - Ve, Ot = ne ? Xe : Ve - 1, Pt = this.__iteratees__, Ut = Pt.length, ni = 0, li = cr(lt, this.__takeCount__);
        if (!R || !ne && be == lt && li == lt)
          return lc(f, this.__actions__);
        var Mi = [];
        e:
          for (; lt-- && ni < li; ) {
            Ot += _;
            for (var Ui = -1, vi = f[Ot]; ++Ui < Ut; ) {
              var Wi = Pt[Ui], $i = Wi.iteratee, Gr = Wi.type, br = $i(vi);
              if (Gr == ze)
                vi = br;
              else if (!br) {
                if (Gr == ut)
                  continue e;
                break e;
              }
            }
            Mi[ni++] = vi;
          }
        return Mi;
      }
      Zi.prototype = _a(Bo.prototype), Zi.prototype.constructor = Zi;
      function ea(f) {
        var _ = -1, R = f == null ? 0 : f.length;
        for (this.clear(); ++_ < R; ) {
          var ne = f[_];
          this.set(ne[0], ne[1]);
        }
      }
      function Kg() {
        this.__data__ = za ? za(null) : {}, this.size = 0;
      }
      function Jg(f) {
        var _ = this.has(f) && delete this.__data__[f];
        return this.size -= _ ? 1 : 0, _;
      }
      function Qg(f) {
        var _ = this.__data__;
        if (za) {
          var R = _[f];
          return R === x ? t : R;
        }
        return on.call(_, f) ? _[f] : t;
      }
      function ep(f) {
        var _ = this.__data__;
        return za ? _[f] !== t : on.call(_, f);
      }
      function tp(f, _) {
        var R = this.__data__;
        return this.size += this.has(f) ? 0 : 1, R[f] = za && _ === t ? x : _, this;
      }
      ea.prototype.clear = Kg, ea.prototype.delete = Jg, ea.prototype.get = Qg, ea.prototype.has = ep, ea.prototype.set = tp;
      function Bs(f) {
        var _ = -1, R = f == null ? 0 : f.length;
        for (this.clear(); ++_ < R; ) {
          var ne = f[_];
          this.set(ne[0], ne[1]);
        }
      }
      function ip() {
        this.__data__ = [], this.size = 0;
      }
      function np(f) {
        var _ = this.__data__, R = ko(_, f);
        if (R < 0)
          return !1;
        var ne = _.length - 1;
        return R == ne ? _.pop() : So.call(_, R, 1), --this.size, !0;
      }
      function rp(f) {
        var _ = this.__data__, R = ko(_, f);
        return R < 0 ? t : _[R][1];
      }
      function sp(f) {
        return ko(this.__data__, f) > -1;
      }
      function ap(f, _) {
        var R = this.__data__, ne = ko(R, f);
        return ne < 0 ? (++this.size, R.push([f, _])) : R[ne][1] = _, this;
      }
      Bs.prototype.clear = ip, Bs.prototype.delete = np, Bs.prototype.get = rp, Bs.prototype.has = sp, Bs.prototype.set = ap;
      function ks(f) {
        var _ = -1, R = f == null ? 0 : f.length;
        for (this.clear(); ++_ < R; ) {
          var ne = f[_];
          this.set(ne[0], ne[1]);
        }
      }
      function op() {
        this.size = 0, this.__data__ = {
          hash: new ea(),
          map: new (Ra || Bs)(),
          string: new ea()
        };
      }
      function lp(f) {
        var _ = Ho(this, f).delete(f);
        return this.size -= _ ? 1 : 0, _;
      }
      function hp(f) {
        return Ho(this, f).get(f);
      }
      function up(f) {
        return Ho(this, f).has(f);
      }
      function cp(f, _) {
        var R = Ho(this, f), ne = R.size;
        return R.set(f, _), this.size += R.size == ne ? 0 : 1, this;
      }
      ks.prototype.clear = op, ks.prototype.delete = lp, ks.prototype.get = hp, ks.prototype.has = up, ks.prototype.set = cp;
      function ta(f) {
        var _ = -1, R = f == null ? 0 : f.length;
        for (this.__data__ = new ks(); ++_ < R; )
          this.add(f[_]);
      }
      function fp(f) {
        return this.__data__.set(f, x), this;
      }
      function dp(f) {
        return this.__data__.has(f);
      }
      ta.prototype.add = ta.prototype.push = fp, ta.prototype.has = dp;
      function us(f) {
        var _ = this.__data__ = new Bs(f);
        this.size = _.size;
      }
      function gp() {
        this.__data__ = new Bs(), this.size = 0;
      }
      function pp(f) {
        var _ = this.__data__, R = _.delete(f);
        return this.size = _.size, R;
      }
      function mp(f) {
        return this.__data__.get(f);
      }
      function _p(f) {
        return this.__data__.has(f);
      }
      function vp(f, _) {
        var R = this.__data__;
        if (R instanceof Bs) {
          var ne = R.__data__;
          if (!Ra || ne.length < s - 1)
            return ne.push([f, _]), this.size = ++R.size, this;
          R = this.__data__ = new ks(ne);
        }
        return R.set(f, _), this.size = R.size, this;
      }
      us.prototype.clear = gp, us.prototype.delete = pp, us.prototype.get = mp, us.prototype.has = _p, us.prototype.set = vp;
      function Fu(f, _) {
        var R = Oi(f), ne = !R && aa(f), be = !R && !ne && Gs(f), Te = !R && !ne && !be && xa(f), Ve = R || ne || be || Te, Xe = Ve ? Ai(f.length, Wt) : [], lt = Xe.length;
        for (var Ot in f)
          (_ || on.call(f, Ot)) && !(Ve && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Ot == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          be && (Ot == "offset" || Ot == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Te && (Ot == "buffer" || Ot == "byteLength" || Ot == "byteOffset") || // Skip index properties.
          Os(Ot, lt))) && Xe.push(Ot);
        return Xe;
      }
      function Uu(f) {
        var _ = f.length;
        return _ ? f[$l(0, _ - 1)] : t;
      }
      function yp(f, _) {
        return Yo(Lr(f), ia(_, 0, f.length));
      }
      function bp(f) {
        return Yo(Lr(f));
      }
      function Fl(f, _, R) {
        (R !== t && !fs(f[_], R) || R === t && !(_ in f)) && xs(f, _, R);
      }
      function Ua(f, _, R) {
        var ne = f[_];
        (!(on.call(f, _) && fs(ne, R)) || R === t && !(_ in f)) && xs(f, _, R);
      }
      function ko(f, _) {
        for (var R = f.length; R--; )
          if (fs(f[R][0], _))
            return R;
        return -1;
      }
      function xp(f, _, R, ne) {
        return Us(f, function(be, Te, Ve) {
          _(ne, be, R(be), Ve);
        }), ne;
      }
      function Vu(f, _) {
        return f && Ss(_, Qn(_), f);
      }
      function wp(f, _) {
        return f && Ss(_, kr(_), f);
      }
      function xs(f, _, R) {
        _ == "__proto__" && Mo ? Mo(f, _, {
          configurable: !0,
          enumerable: !0,
          value: R,
          writable: !0
        }) : f[_] = R;
      }
      function Ul(f, _) {
        for (var R = -1, ne = _.length, be = Q(ne), Te = f == null; ++R < ne; )
          be[R] = Te ? t : xh(f, _[R]);
        return be;
      }
      function ia(f, _, R) {
        return f === f && (R !== t && (f = f <= R ? f : R), _ !== t && (f = f >= _ ? f : _)), f;
      }
      function Qr(f, _, R, ne, be, Te) {
        var Ve, Xe = _ & F, lt = _ & M, Ot = _ & Z;
        if (R && (Ve = be ? R(f, ne, be, Te) : R(f)), Ve !== t)
          return Ve;
        if (!kn(f))
          return f;
        var Pt = Oi(f);
        if (Pt) {
          if (Ve = um(f), !Xe)
            return Lr(f, Ve);
        } else {
          var Ut = fr(f), ni = Ut == Di || Ut == pe;
          if (Gs(f))
            return cc(f, Xe);
          if (Ut == ke || Ut == ii || ni && !be) {
            if (Ve = lt || ni ? {} : kc(f), !Xe)
              return lt ? Qp(f, wp(Ve, f)) : Jp(f, Vu(Ve, f));
          } else {
            if (!hi[Ut])
              return be ? f : {};
            Ve = cm(f, Ut, Xe);
          }
        }
        Te || (Te = new us());
        var li = Te.get(f);
        if (li)
          return li;
        Te.set(f, Ve), af(f) ? f.forEach(function(vi) {
          Ve.add(Qr(vi, _, R, vi, f, Te));
        }) : rf(f) && f.forEach(function(vi, Wi) {
          Ve.set(Wi, Qr(vi, _, R, Wi, f, Te));
        });
        var Mi = Ot ? lt ? ah : sh : lt ? kr : Qn, Ui = Pt ? t : Mi(f);
        return qe(Ui || f, function(vi, Wi) {
          Ui && (Wi = vi, vi = f[Wi]), Ua(Ve, Wi, Qr(vi, _, R, Wi, f, Te));
        }), Ve;
      }
      function Sp(f) {
        var _ = Qn(f);
        return function(R) {
          return Hu(R, f, _);
        };
      }
      function Hu(f, _, R) {
        var ne = R.length;
        if (f == null)
          return !ne;
        for (f = gt(f); ne--; ) {
          var be = R[ne], Te = _[be], Ve = f[be];
          if (Ve === t && !(be in f) || !Te(Ve))
            return !1;
        }
        return !0;
      }
      function Yu(f, _, R) {
        if (typeof f != "function")
          throw new xi(h);
        return qa(function() {
          f.apply(t, R);
        }, _);
      }
      function Va(f, _, R, ne) {
        var be = -1, Te = Ft, Ve = !0, Xe = f.length, lt = [], Ot = _.length;
        if (!Xe)
          return lt;
        R && (_ = ai(_, Ln(R))), ne ? (Te = pi, Ve = !1) : _.length >= s && (Te = Ei, Ve = !1, _ = new ta(_));
        e:
          for (; ++be < Xe; ) {
            var Pt = f[be], Ut = R == null ? Pt : R(Pt);
            if (Pt = ne || Pt !== 0 ? Pt : 0, Ve && Ut === Ut) {
              for (var ni = Ot; ni--; )
                if (_[ni] === Ut)
                  continue e;
              lt.push(Pt);
            } else
              Te(_, Ut, ne) || lt.push(Pt);
          }
        return lt;
      }
      var Us = mc(ws), Gu = mc(Hl, !0);
      function Mp(f, _) {
        var R = !0;
        return Us(f, function(ne, be, Te) {
          return R = !!_(ne, be, Te), R;
        }), R;
      }
      function Eo(f, _, R) {
        for (var ne = -1, be = f.length; ++ne < be; ) {
          var Te = f[ne], Ve = _(Te);
          if (Ve != null && (Xe === t ? Ve === Ve && !Yr(Ve) : R(Ve, Xe)))
            var Xe = Ve, lt = Te;
        }
        return lt;
      }
      function Cp(f, _, R, ne) {
        var be = f.length;
        for (R = zi(R), R < 0 && (R = -R > be ? 0 : be + R), ne = ne === t || ne > be ? be : zi(ne), ne < 0 && (ne += be), ne = R > ne ? 0 : lf(ne); R < ne; )
          f[R++] = _;
        return f;
      }
      function ju(f, _) {
        var R = [];
        return Us(f, function(ne, be, Te) {
          _(ne, be, Te) && R.push(ne);
        }), R;
      }
      function ir(f, _, R, ne, be) {
        var Te = -1, Ve = f.length;
        for (R || (R = dm), be || (be = []); ++Te < Ve; ) {
          var Xe = f[Te];
          _ > 0 && R(Xe) ? _ > 1 ? ir(Xe, _ - 1, R, ne, be) : mi(be, Xe) : ne || (be[be.length] = Xe);
        }
        return be;
      }
      var Vl = _c(), Wu = _c(!0);
      function ws(f, _) {
        return f && Vl(f, _, Qn);
      }
      function Hl(f, _) {
        return f && Wu(f, _, Qn);
      }
      function Io(f, _) {
        return ct(_, function(R) {
          return Ps(f[R]);
        });
      }
      function na(f, _) {
        _ = Hs(_, f);
        for (var R = 0, ne = _.length; f != null && R < ne; )
          f = f[cs(_[R++])];
        return R && R == ne ? f : t;
      }
      function qu(f, _, R) {
        var ne = _(f);
        return Oi(f) ? ne : mi(ne, R(f));
      }
      function vr(f) {
        return f == null ? f === t ? Ye : Pe : Qs && Qs in gt(f) ? om(f) : bm(f);
      }
      function Yl(f, _) {
        return f > _;
      }
      function Ap(f, _) {
        return f != null && on.call(f, _);
      }
      function Tp(f, _) {
        return f != null && _ in gt(f);
      }
      function Lp(f, _, R) {
        return f >= cr(_, R) && f < Xn(_, R);
      }
      function Gl(f, _, R) {
        for (var ne = R ? pi : Ft, be = f[0].length, Te = f.length, Ve = Te, Xe = Q(Te), lt = 1 / 0, Ot = []; Ve--; ) {
          var Pt = f[Ve];
          Ve && _ && (Pt = ai(Pt, Ln(_))), lt = cr(Pt.length, lt), Xe[Ve] = !R && (_ || be >= 120 && Pt.length >= 120) ? new ta(Ve && Pt) : t;
        }
        Pt = f[0];
        var Ut = -1, ni = Xe[0];
        e:
          for (; ++Ut < be && Ot.length < lt; ) {
            var li = Pt[Ut], Mi = _ ? _(li) : li;
            if (li = R || li !== 0 ? li : 0, !(ni ? Ei(ni, Mi) : ne(Ot, Mi, R))) {
              for (Ve = Te; --Ve; ) {
                var Ui = Xe[Ve];
                if (!(Ui ? Ei(Ui, Mi) : ne(f[Ve], Mi, R)))
                  continue e;
              }
              ni && ni.push(Mi), Ot.push(li);
            }
          }
        return Ot;
      }
      function Bp(f, _, R, ne) {
        return ws(f, function(be, Te, Ve) {
          _(ne, R(be), Te, Ve);
        }), ne;
      }
      function Ha(f, _, R) {
        _ = Hs(_, f), f = Pc(f, _);
        var ne = f == null ? f : f[cs(ts(_))];
        return ne == null ? t : Ue(ne, f, R);
      }
      function Zu(f) {
        return Rn(f) && vr(f) == ii;
      }
      function kp(f) {
        return Rn(f) && vr(f) == a;
      }
      function Ep(f) {
        return Rn(f) && vr(f) == Xt;
      }
      function Ya(f, _, R, ne, be) {
        return f === _ ? !0 : f == null || _ == null || !Rn(f) && !Rn(_) ? f !== f && _ !== _ : Ip(f, _, R, ne, Ya, be);
      }
      function Ip(f, _, R, ne, be, Te) {
        var Ve = Oi(f), Xe = Oi(_), lt = Ve ? Ci : fr(f), Ot = Xe ? Ci : fr(_);
        lt = lt == ii ? ke : lt, Ot = Ot == ii ? ke : Ot;
        var Pt = lt == ke, Ut = Ot == ke, ni = lt == Ot;
        if (ni && Gs(f)) {
          if (!Gs(_))
            return !1;
          Ve = !0, Pt = !1;
        }
        if (ni && !Pt)
          return Te || (Te = new us()), Ve || xa(f) ? Tc(f, _, R, ne, be, Te) : sm(f, _, lt, R, ne, be, Te);
        if (!(R & V)) {
          var li = Pt && on.call(f, "__wrapped__"), Mi = Ut && on.call(_, "__wrapped__");
          if (li || Mi) {
            var Ui = li ? f.value() : f, vi = Mi ? _.value() : _;
            return Te || (Te = new us()), be(Ui, vi, R, ne, Te);
          }
        }
        return ni ? (Te || (Te = new us()), am(f, _, R, ne, be, Te)) : !1;
      }
      function Op(f) {
        return Rn(f) && fr(f) == xt;
      }
      function jl(f, _, R, ne) {
        var be = R.length, Te = be, Ve = !ne;
        if (f == null)
          return !Te;
        for (f = gt(f); be--; ) {
          var Xe = R[be];
          if (Ve && Xe[2] ? Xe[1] !== f[Xe[0]] : !(Xe[0] in f))
            return !1;
        }
        for (; ++be < Te; ) {
          Xe = R[be];
          var lt = Xe[0], Ot = f[lt], Pt = Xe[1];
          if (Ve && Xe[2]) {
            if (Ot === t && !(lt in f))
              return !1;
          } else {
            var Ut = new us();
            if (ne)
              var ni = ne(Ot, Pt, lt, f, _, Ut);
            if (!(ni === t ? Ya(Pt, Ot, V | te, ne, Ut) : ni))
              return !1;
          }
        }
        return !0;
      }
      function $u(f) {
        if (!kn(f) || pm(f))
          return !1;
        var _ = Ps(f) ? Og : at;
        return _.test(sa(f));
      }
      function Pp(f) {
        return Rn(f) && vr(f) == vt;
      }
      function Np(f) {
        return Rn(f) && fr(f) == Qe;
      }
      function Rp(f) {
        return Rn(f) && $o(f.length) && !!ti[vr(f)];
      }
      function Xu(f) {
        return typeof f == "function" ? f : f == null ? Er : typeof f == "object" ? Oi(f) ? Qu(f[0], f[1]) : Ju(f) : bf(f);
      }
      function Wl(f) {
        if (!Wa(f))
          return Fg(f);
        var _ = [];
        for (var R in gt(f))
          on.call(f, R) && R != "constructor" && _.push(R);
        return _;
      }
      function Dp(f) {
        if (!kn(f))
          return ym(f);
        var _ = Wa(f), R = [];
        for (var ne in f)
          ne == "constructor" && (_ || !on.call(f, ne)) || R.push(ne);
        return R;
      }
      function ql(f, _) {
        return f < _;
      }
      function Ku(f, _) {
        var R = -1, ne = Br(f) ? Q(f.length) : [];
        return Us(f, function(be, Te, Ve) {
          ne[++R] = _(be, Te, Ve);
        }), ne;
      }
      function Ju(f) {
        var _ = lh(f);
        return _.length == 1 && _[0][2] ? Ic(_[0][0], _[0][1]) : function(R) {
          return R === f || jl(R, f, _);
        };
      }
      function Qu(f, _) {
        return uh(f) && Ec(_) ? Ic(cs(f), _) : function(R) {
          var ne = xh(R, f);
          return ne === t && ne === _ ? wh(R, f) : Ya(_, ne, V | te);
        };
      }
      function Oo(f, _, R, ne, be) {
        f !== _ && Vl(_, function(Te, Ve) {
          if (be || (be = new us()), kn(Te))
            zp(f, _, Ve, R, Oo, ne, be);
          else {
            var Xe = ne ? ne(fh(f, Ve), Te, Ve + "", f, _, be) : t;
            Xe === t && (Xe = Te), Fl(f, Ve, Xe);
          }
        }, kr);
      }
      function zp(f, _, R, ne, be, Te, Ve) {
        var Xe = fh(f, R), lt = fh(_, R), Ot = Ve.get(lt);
        if (Ot) {
          Fl(f, R, Ot);
          return;
        }
        var Pt = Te ? Te(Xe, lt, R + "", f, _, Ve) : t, Ut = Pt === t;
        if (Ut) {
          var ni = Oi(lt), li = !ni && Gs(lt), Mi = !ni && !li && xa(lt);
          Pt = lt, ni || li || Mi ? Oi(Xe) ? Pt = Xe : Fn(Xe) ? Pt = Lr(Xe) : li ? (Ut = !1, Pt = cc(lt, !0)) : Mi ? (Ut = !1, Pt = fc(lt, !0)) : Pt = [] : Za(lt) || aa(lt) ? (Pt = Xe, aa(Xe) ? Pt = hf(Xe) : (!kn(Xe) || Ps(Xe)) && (Pt = kc(lt))) : Ut = !1;
        }
        Ut && (Ve.set(lt, Pt), be(Pt, lt, ne, Te, Ve), Ve.delete(lt)), Fl(f, R, Pt);
      }
      function ec(f, _) {
        var R = f.length;
        if (R)
          return _ += _ < 0 ? R : 0, Os(_, R) ? f[_] : t;
      }
      function tc(f, _, R) {
        _.length ? _ = ai(_, function(Te) {
          return Oi(Te) ? function(Ve) {
            return na(Ve, Te.length === 1 ? Te[0] : Te);
          } : Te;
        }) : _ = [Er];
        var ne = -1;
        _ = ai(_, Ln(wi()));
        var be = Ku(f, function(Te, Ve, Xe) {
          var lt = ai(_, function(Ot) {
            return Ot(Te);
          });
          return { criteria: lt, index: ++ne, value: Te };
        });
        return Gn(be, function(Te, Ve) {
          return Kp(Te, Ve, R);
        });
      }
      function Fp(f, _) {
        return ic(f, _, function(R, ne) {
          return wh(f, ne);
        });
      }
      function ic(f, _, R) {
        for (var ne = -1, be = _.length, Te = {}; ++ne < be; ) {
          var Ve = _[ne], Xe = na(f, Ve);
          R(Xe, Ve) && Ga(Te, Hs(Ve, f), Xe);
        }
        return Te;
      }
      function Up(f) {
        return function(_) {
          return na(_, f);
        };
      }
      function Zl(f, _, R, ne) {
        var be = ne ? mr : lr, Te = -1, Ve = _.length, Xe = f;
        for (f === _ && (_ = Lr(_)), R && (Xe = ai(f, Ln(R))); ++Te < Ve; )
          for (var lt = 0, Ot = _[Te], Pt = R ? R(Ot) : Ot; (lt = be(Xe, Pt, lt, ne)) > -1; )
            Xe !== f && So.call(Xe, lt, 1), So.call(f, lt, 1);
        return f;
      }
      function nc(f, _) {
        for (var R = f ? _.length : 0, ne = R - 1; R--; ) {
          var be = _[R];
          if (R == ne || be !== Te) {
            var Te = be;
            Os(be) ? So.call(f, be, 1) : Jl(f, be);
          }
        }
        return f;
      }
      function $l(f, _) {
        return f + Ao(Du() * (_ - f + 1));
      }
      function Vp(f, _, R, ne) {
        for (var be = -1, Te = Xn(Co((_ - f) / (R || 1)), 0), Ve = Q(Te); Te--; )
          Ve[ne ? Te : ++be] = f, f += R;
        return Ve;
      }
      function Xl(f, _) {
        var R = "";
        if (!f || _ < 1 || _ > We)
          return R;
        do
          _ % 2 && (R += f), _ = Ao(_ / 2), _ && (f += f);
        while (_);
        return R;
      }
      function Hi(f, _) {
        return dh(Oc(f, _, Er), f + "");
      }
      function Hp(f) {
        return Uu(wa(f));
      }
      function Yp(f, _) {
        var R = wa(f);
        return Yo(R, ia(_, 0, R.length));
      }
      function Ga(f, _, R, ne) {
        if (!kn(f))
          return f;
        _ = Hs(_, f);
        for (var be = -1, Te = _.length, Ve = Te - 1, Xe = f; Xe != null && ++be < Te; ) {
          var lt = cs(_[be]), Ot = R;
          if (lt === "__proto__" || lt === "constructor" || lt === "prototype")
            return f;
          if (be != Ve) {
            var Pt = Xe[lt];
            Ot = ne ? ne(Pt, lt, Xe) : t, Ot === t && (Ot = kn(Pt) ? Pt : Os(_[be + 1]) ? [] : {});
          }
          Ua(Xe, lt, Ot), Xe = Xe[lt];
        }
        return f;
      }
      var rc = To ? function(f, _) {
        return To.set(f, _), f;
      } : Er, Gp = Mo ? function(f, _) {
        return Mo(f, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Mh(_),
          writable: !0
        });
      } : Er;
      function jp(f) {
        return Yo(wa(f));
      }
      function es(f, _, R) {
        var ne = -1, be = f.length;
        _ < 0 && (_ = -_ > be ? 0 : be + _), R = R > be ? be : R, R < 0 && (R += be), be = _ > R ? 0 : R - _ >>> 0, _ >>>= 0;
        for (var Te = Q(be); ++ne < be; )
          Te[ne] = f[ne + _];
        return Te;
      }
      function Wp(f, _) {
        var R;
        return Us(f, function(ne, be, Te) {
          return R = _(ne, be, Te), !R;
        }), !!R;
      }
      function Po(f, _, R) {
        var ne = 0, be = f == null ? ne : f.length;
        if (typeof _ == "number" && _ === _ && be <= $t) {
          for (; ne < be; ) {
            var Te = ne + be >>> 1, Ve = f[Te];
            Ve !== null && !Yr(Ve) && (R ? Ve <= _ : Ve < _) ? ne = Te + 1 : be = Te;
          }
          return be;
        }
        return Kl(f, _, Er, R);
      }
      function Kl(f, _, R, ne) {
        var be = 0, Te = f == null ? 0 : f.length;
        if (Te === 0)
          return 0;
        _ = R(_);
        for (var Ve = _ !== _, Xe = _ === null, lt = Yr(_), Ot = _ === t; be < Te; ) {
          var Pt = Ao((be + Te) / 2), Ut = R(f[Pt]), ni = Ut !== t, li = Ut === null, Mi = Ut === Ut, Ui = Yr(Ut);
          if (Ve)
            var vi = ne || Mi;
          else
            Ot ? vi = Mi && (ne || ni) : Xe ? vi = Mi && ni && (ne || !li) : lt ? vi = Mi && ni && !li && (ne || !Ui) : li || Ui ? vi = !1 : vi = ne ? Ut <= _ : Ut < _;
          vi ? be = Pt + 1 : Te = Pt;
        }
        return cr(Te, Zt);
      }
      function sc(f, _) {
        for (var R = -1, ne = f.length, be = 0, Te = []; ++R < ne; ) {
          var Ve = f[R], Xe = _ ? _(Ve) : Ve;
          if (!R || !fs(Xe, lt)) {
            var lt = Xe;
            Te[be++] = Ve === 0 ? 0 : Ve;
          }
        }
        return Te;
      }
      function ac(f) {
        return typeof f == "number" ? f : Yr(f) ? rt : +f;
      }
      function Hr(f) {
        if (typeof f == "string")
          return f;
        if (Oi(f))
          return ai(f, Hr) + "";
        if (Yr(f))
          return zu ? zu.call(f) : "";
        var _ = f + "";
        return _ == "0" && 1 / f == -qt ? "-0" : _;
      }
      function Vs(f, _, R) {
        var ne = -1, be = Ft, Te = f.length, Ve = !0, Xe = [], lt = Xe;
        if (R)
          Ve = !1, be = pi;
        else if (Te >= s) {
          var Ot = _ ? null : nm(f);
          if (Ot)
            return Ri(Ot);
          Ve = !1, be = Ei, lt = new ta();
        } else
          lt = _ ? [] : Xe;
        e:
          for (; ++ne < Te; ) {
            var Pt = f[ne], Ut = _ ? _(Pt) : Pt;
            if (Pt = R || Pt !== 0 ? Pt : 0, Ve && Ut === Ut) {
              for (var ni = lt.length; ni--; )
                if (lt[ni] === Ut)
                  continue e;
              _ && lt.push(Ut), Xe.push(Pt);
            } else
              be(lt, Ut, R) || (lt !== Xe && lt.push(Ut), Xe.push(Pt));
          }
        return Xe;
      }
      function Jl(f, _) {
        _ = Hs(_, f);
        var R = -1, ne = _.length;
        if (!ne)
          return !0;
        for (; ++R < ne; ) {
          var be = cs(_[R]);
          if (be === "__proto__" && !on.call(f, "__proto__") || (be === "constructor" || be === "prototype") && R < ne - 1)
            return !1;
        }
        var Te = Pc(f, _);
        return Te == null || delete Te[cs(ts(_))];
      }
      function oc(f, _, R, ne) {
        return Ga(f, _, R(na(f, _)), ne);
      }
      function No(f, _, R, ne) {
        for (var be = f.length, Te = ne ? be : -1; (ne ? Te-- : ++Te < be) && _(f[Te], Te, f); )
          ;
        return R ? es(f, ne ? 0 : Te, ne ? Te + 1 : be) : es(f, ne ? Te + 1 : 0, ne ? be : Te);
      }
      function lc(f, _) {
        var R = f;
        return R instanceof Zi && (R = R.value()), xn(_, function(ne, be) {
          return be.func.apply(be.thisArg, mi([ne], be.args));
        }, R);
      }
      function Ql(f, _, R) {
        var ne = f.length;
        if (ne < 2)
          return ne ? Vs(f[0]) : [];
        for (var be = -1, Te = Q(ne); ++be < ne; )
          for (var Ve = f[be], Xe = -1; ++Xe < ne; )
            Xe != be && (Te[be] = Va(Te[be] || Ve, f[Xe], _, R));
        return Vs(ir(Te, 1), _, R);
      }
      function hc(f, _, R) {
        for (var ne = -1, be = f.length, Te = _.length, Ve = {}; ++ne < be; ) {
          var Xe = ne < Te ? _[ne] : t;
          R(Ve, f[ne], Xe);
        }
        return Ve;
      }
      function eh(f) {
        return Fn(f) ? f : [];
      }
      function th(f) {
        return typeof f == "function" ? f : Er;
      }
      function Hs(f, _) {
        return Oi(f) ? f : uh(f, _) ? [f] : zc(ln(f));
      }
      var qp = Hi;
      function Ys(f, _, R) {
        var ne = f.length;
        return R = R === t ? ne : R, !_ && R >= ne ? f : es(f, _, R);
      }
      var uc = Pg || function(f) {
        return Sn.clearTimeout(f);
      };
      function cc(f, _) {
        if (_)
          return f.slice();
        var R = f.length, ne = Iu ? Iu(R) : new f.constructor(R);
        return f.copy(ne), ne;
      }
      function ih(f) {
        var _ = new f.constructor(f.byteLength);
        return new xo(_).set(new xo(f)), _;
      }
      function Zp(f, _) {
        var R = _ ? ih(f.buffer) : f.buffer;
        return new f.constructor(R, f.byteOffset, f.byteLength);
      }
      function $p(f) {
        var _ = new f.constructor(f.source, _t.exec(f));
        return _.lastIndex = f.lastIndex, _;
      }
      function Xp(f) {
        return Fa ? gt(Fa.call(f)) : {};
      }
      function fc(f, _) {
        var R = _ ? ih(f.buffer) : f.buffer;
        return new f.constructor(R, f.byteOffset, f.length);
      }
      function dc(f, _) {
        if (f !== _) {
          var R = f !== t, ne = f === null, be = f === f, Te = Yr(f), Ve = _ !== t, Xe = _ === null, lt = _ === _, Ot = Yr(_);
          if (!Xe && !Ot && !Te && f > _ || Te && Ve && lt && !Xe && !Ot || ne && Ve && lt || !R && lt || !be)
            return 1;
          if (!ne && !Te && !Ot && f < _ || Ot && R && be && !ne && !Te || Xe && R && be || !Ve && be || !lt)
            return -1;
        }
        return 0;
      }
      function Kp(f, _, R) {
        for (var ne = -1, be = f.criteria, Te = _.criteria, Ve = be.length, Xe = R.length; ++ne < Ve; ) {
          var lt = dc(be[ne], Te[ne]);
          if (lt) {
            if (ne >= Xe)
              return lt;
            var Ot = R[ne];
            return lt * (Ot == "desc" ? -1 : 1);
          }
        }
        return f.index - _.index;
      }
      function gc(f, _, R, ne) {
        for (var be = -1, Te = f.length, Ve = R.length, Xe = -1, lt = _.length, Ot = Xn(Te - Ve, 0), Pt = Q(lt + Ot), Ut = !ne; ++Xe < lt; )
          Pt[Xe] = _[Xe];
        for (; ++be < Ve; )
          (Ut || be < Te) && (Pt[R[be]] = f[be]);
        for (; Ot--; )
          Pt[Xe++] = f[be++];
        return Pt;
      }
      function pc(f, _, R, ne) {
        for (var be = -1, Te = f.length, Ve = -1, Xe = R.length, lt = -1, Ot = _.length, Pt = Xn(Te - Xe, 0), Ut = Q(Pt + Ot), ni = !ne; ++be < Pt; )
          Ut[be] = f[be];
        for (var li = be; ++lt < Ot; )
          Ut[li + lt] = _[lt];
        for (; ++Ve < Xe; )
          (ni || be < Te) && (Ut[li + R[Ve]] = f[be++]);
        return Ut;
      }
      function Lr(f, _) {
        var R = -1, ne = f.length;
        for (_ || (_ = Q(ne)); ++R < ne; )
          _[R] = f[R];
        return _;
      }
      function Ss(f, _, R, ne) {
        var be = !R;
        R || (R = {});
        for (var Te = -1, Ve = _.length; ++Te < Ve; ) {
          var Xe = _[Te], lt = ne ? ne(R[Xe], f[Xe], Xe, R, f) : t;
          lt === t && (lt = f[Xe]), be ? xs(R, Xe, lt) : Ua(R, Xe, lt);
        }
        return R;
      }
      function Jp(f, _) {
        return Ss(f, hh(f), _);
      }
      function Qp(f, _) {
        return Ss(f, Lc(f), _);
      }
      function Ro(f, _) {
        return function(R, ne) {
          var be = Oi(R) ? De : xp, Te = _ ? _() : {};
          return be(R, f, wi(ne, 2), Te);
        };
      }
      function va(f) {
        return Hi(function(_, R) {
          var ne = -1, be = R.length, Te = be > 1 ? R[be - 1] : t, Ve = be > 2 ? R[2] : t;
          for (Te = f.length > 3 && typeof Te == "function" ? (be--, Te) : t, Ve && yr(R[0], R[1], Ve) && (Te = be < 3 ? t : Te, be = 1), _ = gt(_); ++ne < be; ) {
            var Xe = R[ne];
            Xe && f(_, Xe, ne, Te);
          }
          return _;
        });
      }
      function mc(f, _) {
        return function(R, ne) {
          if (R == null)
            return R;
          if (!Br(R))
            return f(R, ne);
          for (var be = R.length, Te = _ ? be : -1, Ve = gt(R); (_ ? Te-- : ++Te < be) && ne(Ve[Te], Te, Ve) !== !1; )
            ;
          return R;
        };
      }
      function _c(f) {
        return function(_, R, ne) {
          for (var be = -1, Te = gt(_), Ve = ne(_), Xe = Ve.length; Xe--; ) {
            var lt = Ve[f ? Xe : ++be];
            if (R(Te[lt], lt, Te) === !1)
              break;
          }
          return _;
        };
      }
      function em(f, _, R) {
        var ne = _ & P, be = ja(f);
        function Te() {
          var Ve = this && this !== Sn && this instanceof Te ? be : f;
          return Ve.apply(ne ? R : this, arguments);
        }
        return Te;
      }
      function vc(f) {
        return function(_) {
          _ = ln(_);
          var R = Ji(_) ? zn(_) : t, ne = R ? R[0] : _.charAt(0), be = R ? Ys(R, 1).join("") : _.slice(1);
          return ne[f]() + be;
        };
      }
      function ya(f) {
        return function(_) {
          return xn(vf(_f(_).replace(he, "")), f, "");
        };
      }
      function ja(f) {
        return function() {
          var _ = arguments;
          switch (_.length) {
            case 0:
              return new f();
            case 1:
              return new f(_[0]);
            case 2:
              return new f(_[0], _[1]);
            case 3:
              return new f(_[0], _[1], _[2]);
            case 4:
              return new f(_[0], _[1], _[2], _[3]);
            case 5:
              return new f(_[0], _[1], _[2], _[3], _[4]);
            case 6:
              return new f(_[0], _[1], _[2], _[3], _[4], _[5]);
            case 7:
              return new f(_[0], _[1], _[2], _[3], _[4], _[5], _[6]);
          }
          var R = _a(f.prototype), ne = f.apply(R, _);
          return kn(ne) ? ne : R;
        };
      }
      function tm(f, _, R) {
        var ne = ja(f);
        function be() {
          for (var Te = arguments.length, Ve = Q(Te), Xe = Te, lt = ba(be); Xe--; )
            Ve[Xe] = arguments[Xe];
          var Ot = Te < 3 && Ve[0] !== lt && Ve[Te - 1] !== lt ? [] : $n(Ve, lt);
          if (Te -= Ot.length, Te < R)
            return Sc(
              f,
              _,
              Do,
              be.placeholder,
              t,
              Ve,
              Ot,
              t,
              t,
              R - Te
            );
          var Pt = this && this !== Sn && this instanceof be ? ne : f;
          return Ue(Pt, this, Ve);
        }
        return be;
      }
      function yc(f) {
        return function(_, R, ne) {
          var be = gt(_);
          if (!Br(_)) {
            var Te = wi(R, 3);
            _ = Qn(_), R = function(Xe) {
              return Te(be[Xe], Xe, be);
            };
          }
          var Ve = f(_, R, ne);
          return Ve > -1 ? be[Te ? _[Ve] : Ve] : t;
        };
      }
      function bc(f) {
        return Is(function(_) {
          var R = _.length, ne = R, be = Jr.prototype.thru;
          for (f && _.reverse(); ne--; ) {
            var Te = _[ne];
            if (typeof Te != "function")
              throw new xi(h);
            if (be && !Ve && Vo(Te) == "wrapper")
              var Ve = new Jr([], !0);
          }
          for (ne = Ve ? ne : R; ++ne < R; ) {
            Te = _[ne];
            var Xe = Vo(Te), lt = Xe == "wrapper" ? oh(Te) : t;
            lt && ch(lt[0]) && lt[1] == (je | le | X | Ee) && !lt[4].length && lt[9] == 1 ? Ve = Ve[Vo(lt[0])].apply(Ve, lt[3]) : Ve = Te.length == 1 && ch(Te) ? Ve[Xe]() : Ve.thru(Te);
          }
          return function() {
            var Ot = arguments, Pt = Ot[0];
            if (Ve && Ot.length == 1 && Oi(Pt))
              return Ve.plant(Pt).value();
            for (var Ut = 0, ni = R ? _[Ut].apply(this, Ot) : Pt; ++Ut < R; )
              ni = _[Ut].call(this, ni);
            return ni;
          };
        });
      }
      function Do(f, _, R, ne, be, Te, Ve, Xe, lt, Ot) {
        var Pt = _ & je, Ut = _ & P, ni = _ & K, li = _ & (le | fe), Mi = _ & He, Ui = ni ? t : ja(f);
        function vi() {
          for (var Wi = arguments.length, $i = Q(Wi), Gr = Wi; Gr--; )
            $i[Gr] = arguments[Gr];
          if (li)
            var br = ba(vi), jr = un($i, br);
          if (ne && ($i = gc($i, ne, be, li)), Te && ($i = pc($i, Te, Ve, li)), Wi -= jr, li && Wi < Ot) {
            var Un = $n($i, br);
            return Sc(
              f,
              _,
              Do,
              vi.placeholder,
              R,
              $i,
              Un,
              Xe,
              lt,
              Ot - Wi
            );
          }
          var ds = Ut ? R : this, Rs = ni ? ds[f] : f;
          return Wi = $i.length, Xe ? $i = xm($i, Xe) : Mi && Wi > 1 && $i.reverse(), Pt && lt < Wi && ($i.length = lt), this && this !== Sn && this instanceof vi && (Rs = Ui || ja(Rs)), Rs.apply(ds, $i);
        }
        return vi;
      }
      function xc(f, _) {
        return function(R, ne) {
          return Bp(R, f, _(ne), {});
        };
      }
      function zo(f, _) {
        return function(R, ne) {
          var be;
          if (R === t && ne === t)
            return _;
          if (R !== t && (be = R), ne !== t) {
            if (be === t)
              return ne;
            typeof R == "string" || typeof ne == "string" ? (R = Hr(R), ne = Hr(ne)) : (R = ac(R), ne = ac(ne)), be = f(R, ne);
          }
          return be;
        };
      }
      function nh(f) {
        return Is(function(_) {
          return _ = ai(_, Ln(wi())), Hi(function(R) {
            var ne = this;
            return f(_, function(be) {
              return Ue(be, ne, R);
            });
          });
        });
      }
      function Fo(f, _) {
        _ = _ === t ? " " : Hr(_);
        var R = _.length;
        if (R < 2)
          return R ? Xl(_, f) : _;
        var ne = Xl(_, Co(f / Jn(_)));
        return Ji(_) ? Ys(zn(ne), 0, f).join("") : ne.slice(0, f);
      }
      function im(f, _, R, ne) {
        var be = _ & P, Te = ja(f);
        function Ve() {
          for (var Xe = -1, lt = arguments.length, Ot = -1, Pt = ne.length, Ut = Q(Pt + lt), ni = this && this !== Sn && this instanceof Ve ? Te : f; ++Ot < Pt; )
            Ut[Ot] = ne[Ot];
          for (; lt--; )
            Ut[Ot++] = arguments[++Xe];
          return Ue(ni, be ? R : this, Ut);
        }
        return Ve;
      }
      function wc(f) {
        return function(_, R, ne) {
          return ne && typeof ne != "number" && yr(_, R, ne) && (R = ne = t), _ = Ns(_), R === t ? (R = _, _ = 0) : R = Ns(R), ne = ne === t ? _ < R ? 1 : -1 : Ns(ne), Vp(_, R, ne, f);
        };
      }
      function Uo(f) {
        return function(_, R) {
          return typeof _ == "string" && typeof R == "string" || (_ = is(_), R = is(R)), f(_, R);
        };
      }
      function Sc(f, _, R, ne, be, Te, Ve, Xe, lt, Ot) {
        var Pt = _ & le, Ut = Pt ? Ve : t, ni = Pt ? t : Ve, li = Pt ? Te : t, Mi = Pt ? t : Te;
        _ |= Pt ? X : W, _ &= ~(Pt ? W : X), _ & J || (_ &= ~(P | K));
        var Ui = [
          f,
          _,
          be,
          li,
          Ut,
          Mi,
          ni,
          Xe,
          lt,
          Ot
        ], vi = R.apply(t, Ui);
        return ch(f) && Nc(vi, Ui), vi.placeholder = ne, Rc(vi, f, _);
      }
      function rh(f) {
        var _ = ht[f];
        return function(R, ne) {
          if (R = is(R), ne = ne == null ? 0 : cr(zi(ne), 292), ne && Ru(R)) {
            var be = (ln(R) + "e").split("e"), Te = _(be[0] + "e" + (+be[1] + ne));
            return be = (ln(Te) + "e").split("e"), +(be[0] + "e" + (+be[1] - ne));
          }
          return _(R);
        };
      }
      var nm = pa && 1 / Ri(new pa([, -0]))[1] == qt ? function(f) {
        return new pa(f);
      } : Th;
      function Mc(f) {
        return function(_) {
          var R = fr(_);
          return R == xt ? tr(_) : R == Qe ? hs(_) : hn(_, f(_));
        };
      }
      function Es(f, _, R, ne, be, Te, Ve, Xe) {
        var lt = _ & K;
        if (!lt && typeof f != "function")
          throw new xi(h);
        var Ot = ne ? ne.length : 0;
        if (Ot || (_ &= ~(X | W), ne = be = t), Ve = Ve === t ? Ve : Xn(zi(Ve), 0), Xe = Xe === t ? Xe : zi(Xe), Ot -= be ? be.length : 0, _ & W) {
          var Pt = ne, Ut = be;
          ne = be = t;
        }
        var ni = lt ? t : oh(f), li = [
          f,
          _,
          R,
          ne,
          be,
          Pt,
          Ut,
          Te,
          Ve,
          Xe
        ];
        if (ni && vm(li, ni), f = li[0], _ = li[1], R = li[2], ne = li[3], be = li[4], Xe = li[9] = li[9] === t ? lt ? 0 : f.length : Xn(li[9] - Ot, 0), !Xe && _ & (le | fe) && (_ &= ~(le | fe)), !_ || _ == P)
          var Mi = em(f, _, R);
        else
          _ == le || _ == fe ? Mi = tm(f, _, Xe) : (_ == X || _ == (P | X)) && !be.length ? Mi = im(f, _, R, ne) : Mi = Do.apply(t, li);
        var Ui = ni ? rc : Nc;
        return Rc(Ui(Mi, li), f, _);
      }
      function Cc(f, _, R, ne) {
        return f === t || fs(f, mn[R]) && !on.call(ne, R) ? _ : f;
      }
      function Ac(f, _, R, ne, be, Te) {
        return kn(f) && kn(_) && (Te.set(_, f), Oo(f, _, t, Ac, Te), Te.delete(_)), f;
      }
      function rm(f) {
        return Za(f) ? t : f;
      }
      function Tc(f, _, R, ne, be, Te) {
        var Ve = R & V, Xe = f.length, lt = _.length;
        if (Xe != lt && !(Ve && lt > Xe))
          return !1;
        var Ot = Te.get(f), Pt = Te.get(_);
        if (Ot && Pt)
          return Ot == _ && Pt == f;
        var Ut = -1, ni = !0, li = R & te ? new ta() : t;
        for (Te.set(f, _), Te.set(_, f); ++Ut < Xe; ) {
          var Mi = f[Ut], Ui = _[Ut];
          if (ne)
            var vi = Ve ? ne(Ui, Mi, Ut, _, f, Te) : ne(Mi, Ui, Ut, f, _, Te);
          if (vi !== t) {
            if (vi)
              continue;
            ni = !1;
            break;
          }
          if (li) {
            if (!an(_, function(Wi, $i) {
              if (!Ei(li, $i) && (Mi === Wi || be(Mi, Wi, R, ne, Te)))
                return li.push($i);
            })) {
              ni = !1;
              break;
            }
          } else if (!(Mi === Ui || be(Mi, Ui, R, ne, Te))) {
            ni = !1;
            break;
          }
        }
        return Te.delete(f), Te.delete(_), ni;
      }
      function sm(f, _, R, ne, be, Te, Ve) {
        switch (R) {
          case l:
            if (f.byteLength != _.byteLength || f.byteOffset != _.byteOffset)
              return !1;
            f = f.buffer, _ = _.buffer;
          case a:
            return !(f.byteLength != _.byteLength || !Te(new xo(f), new xo(_)));
          case Gt:
          case Xt:
          case tt:
            return fs(+f, +_);
          case Ni:
            return f.name == _.name && f.message == _.message;
          case vt:
          case wt:
            return f == _ + "";
          case xt:
            var Xe = tr;
          case Qe:
            var lt = ne & V;
            if (Xe || (Xe = Ri), f.size != _.size && !lt)
              return !1;
            var Ot = Ve.get(f);
            if (Ot)
              return Ot == _;
            ne |= te, Ve.set(f, _);
            var Pt = Tc(Xe(f), Xe(_), ne, be, Te, Ve);
            return Ve.delete(f), Pt;
          case Yt:
            if (Fa)
              return Fa.call(f) == Fa.call(_);
        }
        return !1;
      }
      function am(f, _, R, ne, be, Te) {
        var Ve = R & V, Xe = sh(f), lt = Xe.length, Ot = sh(_), Pt = Ot.length;
        if (lt != Pt && !Ve)
          return !1;
        for (var Ut = lt; Ut--; ) {
          var ni = Xe[Ut];
          if (!(Ve ? ni in _ : on.call(_, ni)))
            return !1;
        }
        var li = Te.get(f), Mi = Te.get(_);
        if (li && Mi)
          return li == _ && Mi == f;
        var Ui = !0;
        Te.set(f, _), Te.set(_, f);
        for (var vi = Ve; ++Ut < lt; ) {
          ni = Xe[Ut];
          var Wi = f[ni], $i = _[ni];
          if (ne)
            var Gr = Ve ? ne($i, Wi, ni, _, f, Te) : ne(Wi, $i, ni, f, _, Te);
          if (!(Gr === t ? Wi === $i || be(Wi, $i, R, ne, Te) : Gr)) {
            Ui = !1;
            break;
          }
          vi || (vi = ni == "constructor");
        }
        if (Ui && !vi) {
          var br = f.constructor, jr = _.constructor;
          br != jr && "constructor" in f && "constructor" in _ && !(typeof br == "function" && br instanceof br && typeof jr == "function" && jr instanceof jr) && (Ui = !1);
        }
        return Te.delete(f), Te.delete(_), Ui;
      }
      function Is(f) {
        return dh(Oc(f, t, Hc), f + "");
      }
      function sh(f) {
        return qu(f, Qn, hh);
      }
      function ah(f) {
        return qu(f, kr, Lc);
      }
      var oh = To ? function(f) {
        return To.get(f);
      } : Th;
      function Vo(f) {
        for (var _ = f.name + "", R = ma[_], ne = on.call(ma, _) ? R.length : 0; ne--; ) {
          var be = R[ne], Te = be.func;
          if (Te == null || Te == f)
            return be.name;
        }
        return _;
      }
      function ba(f) {
        var _ = on.call(Ce, "placeholder") ? Ce : f;
        return _.placeholder;
      }
      function wi() {
        var f = Ce.iteratee || Ch;
        return f = f === Ch ? Xu : f, arguments.length ? f(arguments[0], arguments[1]) : f;
      }
      function Ho(f, _) {
        var R = f.__data__;
        return gm(_) ? R[typeof _ == "string" ? "string" : "hash"] : R.map;
      }
      function lh(f) {
        for (var _ = Qn(f), R = _.length; R--; ) {
          var ne = _[R], be = f[ne];
          _[R] = [ne, be, Ec(be)];
        }
        return _;
      }
      function ra(f, _) {
        var R = Ur(f, _);
        return $u(R) ? R : t;
      }
      function om(f) {
        var _ = on.call(f, Qs), R = f[Qs];
        try {
          f[Qs] = t;
          var ne = !0;
        } catch {
        }
        var be = yo.call(f);
        return ne && (_ ? f[Qs] = R : delete f[Qs]), be;
      }
      var hh = Rl ? function(f) {
        return f == null ? [] : (f = gt(f), ct(Rl(f), function(_) {
          return Pu.call(f, _);
        }));
      } : Lh, Lc = Rl ? function(f) {
        for (var _ = []; f; )
          mi(_, hh(f)), f = wo(f);
        return _;
      } : Lh, fr = vr;
      (Dl && fr(new Dl(new ArrayBuffer(1))) != l || Ra && fr(new Ra()) != xt || zl && fr(zl.resolve()) != Je || pa && fr(new pa()) != Qe || Da && fr(new Da()) != i) && (fr = function(f) {
        var _ = vr(f), R = _ == ke ? f.constructor : t, ne = R ? sa(R) : "";
        if (ne)
          switch (ne) {
            case Yg:
              return l;
            case Gg:
              return xt;
            case jg:
              return Je;
            case Wg:
              return Qe;
            case qg:
              return i;
          }
        return _;
      });
      function lm(f, _, R) {
        for (var ne = -1, be = R.length; ++ne < be; ) {
          var Te = R[ne], Ve = Te.size;
          switch (Te.type) {
            case "drop":
              f += Ve;
              break;
            case "dropRight":
              _ -= Ve;
              break;
            case "take":
              _ = cr(_, f + Ve);
              break;
            case "takeRight":
              f = Xn(f, _ - Ve);
              break;
          }
        }
        return { start: f, end: _ };
      }
      function hm(f) {
        var _ = f.match(we);
        return _ ? _[1].split(Se) : [];
      }
      function Bc(f, _, R) {
        _ = Hs(_, f);
        for (var ne = -1, be = _.length, Te = !1; ++ne < be; ) {
          var Ve = cs(_[ne]);
          if (!(Te = f != null && R(f, Ve)))
            break;
          f = f[Ve];
        }
        return Te || ++ne != be ? Te : (be = f == null ? 0 : f.length, !!be && $o(be) && Os(Ve, be) && (Oi(f) || aa(f)));
      }
      function um(f) {
        var _ = f.length, R = new f.constructor(_);
        return _ && typeof f[0] == "string" && on.call(f, "index") && (R.index = f.index, R.input = f.input), R;
      }
      function kc(f) {
        return typeof f.constructor == "function" && !Wa(f) ? _a(wo(f)) : {};
      }
      function cm(f, _, R) {
        var ne = f.constructor;
        switch (_) {
          case a:
            return ih(f);
          case Gt:
          case Xt:
            return new ne(+f);
          case l:
            return Zp(f, R);
          case u:
          case d:
          case v:
          case p:
          case b:
          case S:
          case L:
          case E:
          case A:
            return fc(f, R);
          case xt:
            return new ne();
          case tt:
          case wt:
            return new ne(f);
          case vt:
            return $p(f);
          case Qe:
            return new ne();
          case Yt:
            return Xp(f);
        }
      }
      function fm(f, _) {
        var R = _.length;
        if (!R)
          return f;
        var ne = R - 1;
        return _[ne] = (R > 1 ? "& " : "") + _[ne], _ = _.join(R > 2 ? ", " : " "), f.replace(ve, `{
/* [wrapped with ` + _ + `] */
`);
      }
      function dm(f) {
        return Oi(f) || aa(f) || !!(Nu && f && f[Nu]);
      }
      function Os(f, _) {
        var R = typeof f;
        return _ = _ ?? We, !!_ && (R == "number" || R != "symbol" && bt.test(f)) && f > -1 && f % 1 == 0 && f < _;
      }
      function yr(f, _, R) {
        if (!kn(R))
          return !1;
        var ne = typeof _;
        return (ne == "number" ? Br(R) && Os(_, R.length) : ne == "string" && _ in R) ? fs(R[_], f) : !1;
      }
      function uh(f, _) {
        if (Oi(f))
          return !1;
        var R = typeof f;
        return R == "number" || R == "symbol" || R == "boolean" || f == null || Yr(f) ? !0 : ie.test(f) || !H.test(f) || _ != null && f in gt(_);
      }
      function gm(f) {
        var _ = typeof f;
        return _ == "string" || _ == "number" || _ == "symbol" || _ == "boolean" ? f !== "__proto__" : f === null;
      }
      function ch(f) {
        var _ = Vo(f), R = Ce[_];
        if (typeof R != "function" || !(_ in Zi.prototype))
          return !1;
        if (f === R)
          return !0;
        var ne = oh(R);
        return !!ne && f === ne[0];
      }
      function pm(f) {
        return !!Eu && Eu in f;
      }
      var mm = _r ? Ps : Bh;
      function Wa(f) {
        var _ = f && f.constructor, R = typeof _ == "function" && _.prototype || mn;
        return f === R;
      }
      function Ec(f) {
        return f === f && !kn(f);
      }
      function Ic(f, _) {
        return function(R) {
          return R == null ? !1 : R[f] === _ && (_ !== t || f in gt(R));
        };
      }
      function _m(f) {
        var _ = qo(f, function(ne) {
          return R.size === B && R.clear(), ne;
        }), R = _.cache;
        return _;
      }
      function vm(f, _) {
        var R = f[1], ne = _[1], be = R | ne, Te = be < (P | K | je), Ve = ne == je && R == le || ne == je && R == Ee && f[7].length <= _[8] || ne == (je | Ee) && _[7].length <= _[8] && R == le;
        if (!(Te || Ve))
          return f;
        ne & P && (f[2] = _[2], be |= R & P ? 0 : J);
        var Xe = _[3];
        if (Xe) {
          var lt = f[3];
          f[3] = lt ? gc(lt, Xe, _[4]) : Xe, f[4] = lt ? $n(f[3], I) : _[4];
        }
        return Xe = _[5], Xe && (lt = f[5], f[5] = lt ? pc(lt, Xe, _[6]) : Xe, f[6] = lt ? $n(f[5], I) : _[6]), Xe = _[7], Xe && (f[7] = Xe), ne & je && (f[8] = f[8] == null ? _[8] : cr(f[8], _[8])), f[9] == null && (f[9] = _[9]), f[0] = _[0], f[1] = be, f;
      }
      function ym(f) {
        var _ = [];
        if (f != null)
          for (var R in gt(f))
            _.push(R);
        return _;
      }
      function bm(f) {
        return yo.call(f);
      }
      function Oc(f, _, R) {
        return _ = Xn(_ === t ? f.length - 1 : _, 0), function() {
          for (var ne = arguments, be = -1, Te = Xn(ne.length - _, 0), Ve = Q(Te); ++be < Te; )
            Ve[be] = ne[_ + be];
          be = -1;
          for (var Xe = Q(_ + 1); ++be < _; )
            Xe[be] = ne[be];
          return Xe[_] = R(Ve), Ue(f, this, Xe);
        };
      }
      function Pc(f, _) {
        return _.length < 2 ? f : na(f, es(_, 0, -1));
      }
      function xm(f, _) {
        for (var R = f.length, ne = cr(_.length, R), be = Lr(f); ne--; ) {
          var Te = _[ne];
          f[ne] = Os(Te, R) ? be[Te] : t;
        }
        return f;
      }
      function fh(f, _) {
        if (!(_ === "constructor" && typeof f[_] == "function") && _ != "__proto__")
          return f[_];
      }
      var Nc = Dc(rc), qa = Rg || function(f, _) {
        return Sn.setTimeout(f, _);
      }, dh = Dc(Gp);
      function Rc(f, _, R) {
        var ne = _ + "";
        return dh(f, fm(ne, wm(hm(ne), R)));
      }
      function Dc(f) {
        var _ = 0, R = 0;
        return function() {
          var ne = Ug(), be = ce - (ne - R);
          if (R = ne, be > 0) {
            if (++_ >= $e)
              return arguments[0];
          } else
            _ = 0;
          return f.apply(t, arguments);
        };
      }
      function Yo(f, _) {
        var R = -1, ne = f.length, be = ne - 1;
        for (_ = _ === t ? ne : _; ++R < _; ) {
          var Te = $l(R, be), Ve = f[Te];
          f[Te] = f[R], f[R] = Ve;
        }
        return f.length = _, f;
      }
      var zc = _m(function(f) {
        var _ = [];
        return f.charCodeAt(0) === 46 && _.push(""), f.replace(ae, function(R, ne, be, Te) {
          _.push(be ? Te.replace(et, "$1") : ne || R);
        }), _;
      });
      function cs(f) {
        if (typeof f == "string" || Yr(f))
          return f;
        var _ = f + "";
        return _ == "0" && 1 / f == -qt ? "-0" : _;
      }
      function sa(f) {
        if (f != null) {
          try {
            return jn.call(f);
          } catch {
          }
          try {
            return f + "";
          } catch {
          }
        }
        return "";
      }
      function wm(f, _) {
        return qe(Lt, function(R) {
          var ne = "_." + R[0];
          _ & R[1] && !Ft(f, ne) && f.push(ne);
        }), f.sort();
      }
      function Fc(f) {
        if (f instanceof Zi)
          return f.clone();
        var _ = new Jr(f.__wrapped__, f.__chain__);
        return _.__actions__ = Lr(f.__actions__), _.__index__ = f.__index__, _.__values__ = f.__values__, _;
      }
      function Sm(f, _, R) {
        (R ? yr(f, _, R) : _ === t) ? _ = 1 : _ = Xn(zi(_), 0);
        var ne = f == null ? 0 : f.length;
        if (!ne || _ < 1)
          return [];
        for (var be = 0, Te = 0, Ve = Q(Co(ne / _)); be < ne; )
          Ve[Te++] = es(f, be, be += _);
        return Ve;
      }
      function Mm(f) {
        for (var _ = -1, R = f == null ? 0 : f.length, ne = 0, be = []; ++_ < R; ) {
          var Te = f[_];
          Te && (be[ne++] = Te);
        }
        return be;
      }
      function Cm() {
        var f = arguments.length;
        if (!f)
          return [];
        for (var _ = Q(f - 1), R = arguments[0], ne = f; ne--; )
          _[ne - 1] = arguments[ne];
        return mi(Oi(R) ? Lr(R) : [R], ir(_, 1));
      }
      var Am = Hi(function(f, _) {
        return Fn(f) ? Va(f, ir(_, 1, Fn, !0)) : [];
      }), Tm = Hi(function(f, _) {
        var R = ts(_);
        return Fn(R) && (R = t), Fn(f) ? Va(f, ir(_, 1, Fn, !0), wi(R, 2)) : [];
      }), Lm = Hi(function(f, _) {
        var R = ts(_);
        return Fn(R) && (R = t), Fn(f) ? Va(f, ir(_, 1, Fn, !0), t, R) : [];
      });
      function Bm(f, _, R) {
        var ne = f == null ? 0 : f.length;
        return ne ? (_ = R || _ === t ? 1 : zi(_), es(f, _ < 0 ? 0 : _, ne)) : [];
      }
      function km(f, _, R) {
        var ne = f == null ? 0 : f.length;
        return ne ? (_ = R || _ === t ? 1 : zi(_), _ = ne - _, es(f, 0, _ < 0 ? 0 : _)) : [];
      }
      function Em(f, _) {
        return f && f.length ? No(f, wi(_, 3), !0, !0) : [];
      }
      function Im(f, _) {
        return f && f.length ? No(f, wi(_, 3), !0) : [];
      }
      function Om(f, _, R, ne) {
        var be = f == null ? 0 : f.length;
        return be ? (R && typeof R != "number" && yr(f, _, R) && (R = 0, ne = be), Cp(f, _, R, ne)) : [];
      }
      function Uc(f, _, R) {
        var ne = f == null ? 0 : f.length;
        if (!ne)
          return -1;
        var be = R == null ? 0 : zi(R);
        return be < 0 && (be = Xn(ne + be, 0)), en(f, wi(_, 3), be);
      }
      function Vc(f, _, R) {
        var ne = f == null ? 0 : f.length;
        if (!ne)
          return -1;
        var be = ne - 1;
        return R !== t && (be = zi(R), be = R < 0 ? Xn(ne + be, 0) : cr(be, ne - 1)), en(f, wi(_, 3), be, !0);
      }
      function Hc(f) {
        var _ = f == null ? 0 : f.length;
        return _ ? ir(f, 1) : [];
      }
      function Pm(f) {
        var _ = f == null ? 0 : f.length;
        return _ ? ir(f, qt) : [];
      }
      function Nm(f, _) {
        var R = f == null ? 0 : f.length;
        return R ? (_ = _ === t ? 1 : zi(_), ir(f, _)) : [];
      }
      function Rm(f) {
        for (var _ = -1, R = f == null ? 0 : f.length, ne = {}; ++_ < R; ) {
          var be = f[_];
          xs(ne, be[0], be[1]);
        }
        return ne;
      }
      function Yc(f) {
        return f && f.length ? f[0] : t;
      }
      function Dm(f, _, R) {
        var ne = f == null ? 0 : f.length;
        if (!ne)
          return -1;
        var be = R == null ? 0 : zi(R);
        return be < 0 && (be = Xn(ne + be, 0)), lr(f, _, be);
      }
      function zm(f) {
        var _ = f == null ? 0 : f.length;
        return _ ? es(f, 0, -1) : [];
      }
      var Fm = Hi(function(f) {
        var _ = ai(f, eh);
        return _.length && _[0] === f[0] ? Gl(_) : [];
      }), Um = Hi(function(f) {
        var _ = ts(f), R = ai(f, eh);
        return _ === ts(R) ? _ = t : R.pop(), R.length && R[0] === f[0] ? Gl(R, wi(_, 2)) : [];
      }), Vm = Hi(function(f) {
        var _ = ts(f), R = ai(f, eh);
        return _ = typeof _ == "function" ? _ : t, _ && R.pop(), R.length && R[0] === f[0] ? Gl(R, t, _) : [];
      });
      function Hm(f, _) {
        return f == null ? "" : zg.call(f, _);
      }
      function ts(f) {
        var _ = f == null ? 0 : f.length;
        return _ ? f[_ - 1] : t;
      }
      function Ym(f, _, R) {
        var ne = f == null ? 0 : f.length;
        if (!ne)
          return -1;
        var be = ne;
        return R !== t && (be = zi(R), be = be < 0 ? Xn(ne + be, 0) : cr(be, ne - 1)), _ === _ ? Ls(f, _, be) : en(f, pn, be, !0);
      }
      function Gm(f, _) {
        return f && f.length ? ec(f, zi(_)) : t;
      }
      var jm = Hi(Gc);
      function Gc(f, _) {
        return f && f.length && _ && _.length ? Zl(f, _) : f;
      }
      function Wm(f, _, R) {
        return f && f.length && _ && _.length ? Zl(f, _, wi(R, 2)) : f;
      }
      function qm(f, _, R) {
        return f && f.length && _ && _.length ? Zl(f, _, t, R) : f;
      }
      var Zm = Is(function(f, _) {
        var R = f == null ? 0 : f.length, ne = Ul(f, _);
        return nc(f, ai(_, function(be) {
          return Os(be, R) ? +be : be;
        }).sort(dc)), ne;
      });
      function $m(f, _) {
        var R = [];
        if (!(f && f.length))
          return R;
        var ne = -1, be = [], Te = f.length;
        for (_ = wi(_, 3); ++ne < Te; ) {
          var Ve = f[ne];
          _(Ve, ne, f) && (R.push(Ve), be.push(ne));
        }
        return nc(f, be), R;
      }
      function gh(f) {
        return f == null ? f : Hg.call(f);
      }
      function Xm(f, _, R) {
        var ne = f == null ? 0 : f.length;
        return ne ? (R && typeof R != "number" && yr(f, _, R) ? (_ = 0, R = ne) : (_ = _ == null ? 0 : zi(_), R = R === t ? ne : zi(R)), es(f, _, R)) : [];
      }
      function Km(f, _) {
        return Po(f, _);
      }
      function Jm(f, _, R) {
        return Kl(f, _, wi(R, 2));
      }
      function Qm(f, _) {
        var R = f == null ? 0 : f.length;
        if (R) {
          var ne = Po(f, _);
          if (ne < R && fs(f[ne], _))
            return ne;
        }
        return -1;
      }
      function e_(f, _) {
        return Po(f, _, !0);
      }
      function t_(f, _, R) {
        return Kl(f, _, wi(R, 2), !0);
      }
      function i_(f, _) {
        var R = f == null ? 0 : f.length;
        if (R) {
          var ne = Po(f, _, !0) - 1;
          if (fs(f[ne], _))
            return ne;
        }
        return -1;
      }
      function n_(f) {
        return f && f.length ? sc(f) : [];
      }
      function r_(f, _) {
        return f && f.length ? sc(f, wi(_, 2)) : [];
      }
      function s_(f) {
        var _ = f == null ? 0 : f.length;
        return _ ? es(f, 1, _) : [];
      }
      function a_(f, _, R) {
        return f && f.length ? (_ = R || _ === t ? 1 : zi(_), es(f, 0, _ < 0 ? 0 : _)) : [];
      }
      function o_(f, _, R) {
        var ne = f == null ? 0 : f.length;
        return ne ? (_ = R || _ === t ? 1 : zi(_), _ = ne - _, es(f, _ < 0 ? 0 : _, ne)) : [];
      }
      function l_(f, _) {
        return f && f.length ? No(f, wi(_, 3), !1, !0) : [];
      }
      function h_(f, _) {
        return f && f.length ? No(f, wi(_, 3)) : [];
      }
      var u_ = Hi(function(f) {
        return Vs(ir(f, 1, Fn, !0));
      }), c_ = Hi(function(f) {
        var _ = ts(f);
        return Fn(_) && (_ = t), Vs(ir(f, 1, Fn, !0), wi(_, 2));
      }), f_ = Hi(function(f) {
        var _ = ts(f);
        return _ = typeof _ == "function" ? _ : t, Vs(ir(f, 1, Fn, !0), t, _);
      });
      function d_(f) {
        return f && f.length ? Vs(f) : [];
      }
      function g_(f, _) {
        return f && f.length ? Vs(f, wi(_, 2)) : [];
      }
      function p_(f, _) {
        return _ = typeof _ == "function" ? _ : t, f && f.length ? Vs(f, t, _) : [];
      }
      function ph(f) {
        if (!(f && f.length))
          return [];
        var _ = 0;
        return f = ct(f, function(R) {
          if (Fn(R))
            return _ = Xn(R.length, _), !0;
        }), Ai(_, function(R) {
          return ai(f, Yn(R));
        });
      }
      function jc(f, _) {
        if (!(f && f.length))
          return [];
        var R = ph(f);
        return _ == null ? R : ai(R, function(ne) {
          return Ue(_, t, ne);
        });
      }
      var m_ = Hi(function(f, _) {
        return Fn(f) ? Va(f, _) : [];
      }), __ = Hi(function(f) {
        return Ql(ct(f, Fn));
      }), v_ = Hi(function(f) {
        var _ = ts(f);
        return Fn(_) && (_ = t), Ql(ct(f, Fn), wi(_, 2));
      }), y_ = Hi(function(f) {
        var _ = ts(f);
        return _ = typeof _ == "function" ? _ : t, Ql(ct(f, Fn), t, _);
      }), b_ = Hi(ph);
      function x_(f, _) {
        return hc(f || [], _ || [], Ua);
      }
      function w_(f, _) {
        return hc(f || [], _ || [], Ga);
      }
      var S_ = Hi(function(f) {
        var _ = f.length, R = _ > 1 ? f[_ - 1] : t;
        return R = typeof R == "function" ? (f.pop(), R) : t, jc(f, R);
      });
      function Wc(f) {
        var _ = Ce(f);
        return _.__chain__ = !0, _;
      }
      function M_(f, _) {
        return _(f), f;
      }
      function Go(f, _) {
        return _(f);
      }
      var C_ = Is(function(f) {
        var _ = f.length, R = _ ? f[0] : 0, ne = this.__wrapped__, be = function(Te) {
          return Ul(Te, f);
        };
        return _ > 1 || this.__actions__.length || !(ne instanceof Zi) || !Os(R) ? this.thru(be) : (ne = ne.slice(R, +R + (_ ? 1 : 0)), ne.__actions__.push({
          func: Go,
          args: [be],
          thisArg: t
        }), new Jr(ne, this.__chain__).thru(function(Te) {
          return _ && !Te.length && Te.push(t), Te;
        }));
      });
      function A_() {
        return Wc(this);
      }
      function T_() {
        return new Jr(this.value(), this.__chain__);
      }
      function L_() {
        this.__values__ === t && (this.__values__ = of(this.value()));
        var f = this.__index__ >= this.__values__.length, _ = f ? t : this.__values__[this.__index__++];
        return { done: f, value: _ };
      }
      function B_() {
        return this;
      }
      function k_(f) {
        for (var _, R = this; R instanceof Bo; ) {
          var ne = Fc(R);
          ne.__index__ = 0, ne.__values__ = t, _ ? be.__wrapped__ = ne : _ = ne;
          var be = ne;
          R = R.__wrapped__;
        }
        return be.__wrapped__ = f, _;
      }
      function E_() {
        var f = this.__wrapped__;
        if (f instanceof Zi) {
          var _ = f;
          return this.__actions__.length && (_ = new Zi(this)), _ = _.reverse(), _.__actions__.push({
            func: Go,
            args: [gh],
            thisArg: t
          }), new Jr(_, this.__chain__);
        }
        return this.thru(gh);
      }
      function I_() {
        return lc(this.__wrapped__, this.__actions__);
      }
      var O_ = Ro(function(f, _, R) {
        on.call(f, R) ? ++f[R] : xs(f, R, 1);
      });
      function P_(f, _, R) {
        var ne = Oi(f) ? Bt : Mp;
        return R && yr(f, _, R) && (_ = t), ne(f, wi(_, 3));
      }
      function N_(f, _) {
        var R = Oi(f) ? ct : ju;
        return R(f, wi(_, 3));
      }
      var R_ = yc(Uc), D_ = yc(Vc);
      function z_(f, _) {
        return ir(jo(f, _), 1);
      }
      function F_(f, _) {
        return ir(jo(f, _), qt);
      }
      function U_(f, _, R) {
        return R = R === t ? 1 : zi(R), ir(jo(f, _), R);
      }
      function qc(f, _) {
        var R = Oi(f) ? qe : Us;
        return R(f, wi(_, 3));
      }
      function Zc(f, _) {
        var R = Oi(f) ? At : Gu;
        return R(f, wi(_, 3));
      }
      var V_ = Ro(function(f, _, R) {
        on.call(f, R) ? f[R].push(_) : xs(f, R, [_]);
      });
      function H_(f, _, R, ne) {
        f = Br(f) ? f : wa(f), R = R && !ne ? zi(R) : 0;
        var be = f.length;
        return R < 0 && (R = Xn(be + R, 0)), Xo(f) ? R <= be && f.indexOf(_, R) > -1 : !!be && lr(f, _, R) > -1;
      }
      var Y_ = Hi(function(f, _, R) {
        var ne = -1, be = typeof _ == "function", Te = Br(f) ? Q(f.length) : [];
        return Us(f, function(Ve) {
          Te[++ne] = be ? Ue(_, Ve, R) : Ha(Ve, _, R);
        }), Te;
      }), G_ = Ro(function(f, _, R) {
        xs(f, R, _);
      });
      function jo(f, _) {
        var R = Oi(f) ? ai : Ku;
        return R(f, wi(_, 3));
      }
      function j_(f, _, R, ne) {
        return f == null ? [] : (Oi(_) || (_ = _ == null ? [] : [_]), R = ne ? t : R, Oi(R) || (R = R == null ? [] : [R]), tc(f, _, R));
      }
      var W_ = Ro(function(f, _, R) {
        f[R ? 0 : 1].push(_);
      }, function() {
        return [[], []];
      });
      function q_(f, _, R) {
        var ne = Oi(f) ? xn : Zn, be = arguments.length < 3;
        return ne(f, wi(_, 4), R, be, Us);
      }
      function Z_(f, _, R) {
        var ne = Oi(f) ? wn : Zn, be = arguments.length < 3;
        return ne(f, wi(_, 4), R, be, Gu);
      }
      function $_(f, _) {
        var R = Oi(f) ? ct : ju;
        return R(f, Zo(wi(_, 3)));
      }
      function X_(f) {
        var _ = Oi(f) ? Uu : Hp;
        return _(f);
      }
      function K_(f, _, R) {
        (R ? yr(f, _, R) : _ === t) ? _ = 1 : _ = zi(_);
        var ne = Oi(f) ? yp : Yp;
        return ne(f, _);
      }
      function J_(f) {
        var _ = Oi(f) ? bp : jp;
        return _(f);
      }
      function Q_(f) {
        if (f == null)
          return 0;
        if (Br(f))
          return Xo(f) ? Jn(f) : f.length;
        var _ = fr(f);
        return _ == xt || _ == Qe ? f.size : Wl(f).length;
      }
      function e0(f, _, R) {
        var ne = Oi(f) ? an : Wp;
        return R && yr(f, _, R) && (_ = t), ne(f, wi(_, 3));
      }
      var t0 = Hi(function(f, _) {
        if (f == null)
          return [];
        var R = _.length;
        return R > 1 && yr(f, _[0], _[1]) ? _ = [] : R > 2 && yr(_[0], _[1], _[2]) && (_ = [_[0]]), tc(f, ir(_, 1), []);
      }), Wo = Ng || function() {
        return Sn.Date.now();
      };
      function i0(f, _) {
        if (typeof _ != "function")
          throw new xi(h);
        return f = zi(f), function() {
          if (--f < 1)
            return _.apply(this, arguments);
        };
      }
      function $c(f, _, R) {
        return _ = R ? t : _, _ = f && _ == null ? f.length : _, Es(f, je, t, t, t, t, _);
      }
      function Xc(f, _) {
        var R;
        if (typeof _ != "function")
          throw new xi(h);
        return f = zi(f), function() {
          return --f > 0 && (R = _.apply(this, arguments)), f <= 1 && (_ = t), R;
        };
      }
      var mh = Hi(function(f, _, R) {
        var ne = P;
        if (R.length) {
          var be = $n(R, ba(mh));
          ne |= X;
        }
        return Es(f, ne, _, R, be);
      }), Kc = Hi(function(f, _, R) {
        var ne = P | K;
        if (R.length) {
          var be = $n(R, ba(Kc));
          ne |= X;
        }
        return Es(_, ne, f, R, be);
      });
      function Jc(f, _, R) {
        _ = R ? t : _;
        var ne = Es(f, le, t, t, t, t, t, _);
        return ne.placeholder = Jc.placeholder, ne;
      }
      function Qc(f, _, R) {
        _ = R ? t : _;
        var ne = Es(f, fe, t, t, t, t, t, _);
        return ne.placeholder = Qc.placeholder, ne;
      }
      function ef(f, _, R) {
        var ne, be, Te, Ve, Xe, lt, Ot = 0, Pt = !1, Ut = !1, ni = !0;
        if (typeof f != "function")
          throw new xi(h);
        _ = is(_) || 0, kn(R) && (Pt = !!R.leading, Ut = "maxWait" in R, Te = Ut ? Xn(is(R.maxWait) || 0, _) : Te, ni = "trailing" in R ? !!R.trailing : ni);
        function li(Un) {
          var ds = ne, Rs = be;
          return ne = be = t, Ot = Un, Ve = f.apply(Rs, ds), Ve;
        }
        function Mi(Un) {
          return Ot = Un, Xe = qa(Wi, _), Pt ? li(Un) : Ve;
        }
        function Ui(Un) {
          var ds = Un - lt, Rs = Un - Ot, xf = _ - ds;
          return Ut ? cr(xf, Te - Rs) : xf;
        }
        function vi(Un) {
          var ds = Un - lt, Rs = Un - Ot;
          return lt === t || ds >= _ || ds < 0 || Ut && Rs >= Te;
        }
        function Wi() {
          var Un = Wo();
          if (vi(Un))
            return $i(Un);
          Xe = qa(Wi, Ui(Un));
        }
        function $i(Un) {
          return Xe = t, ni && ne ? li(Un) : (ne = be = t, Ve);
        }
        function Gr() {
          Xe !== t && uc(Xe), Ot = 0, ne = lt = be = Xe = t;
        }
        function br() {
          return Xe === t ? Ve : $i(Wo());
        }
        function jr() {
          var Un = Wo(), ds = vi(Un);
          if (ne = arguments, be = this, lt = Un, ds) {
            if (Xe === t)
              return Mi(lt);
            if (Ut)
              return uc(Xe), Xe = qa(Wi, _), li(lt);
          }
          return Xe === t && (Xe = qa(Wi, _)), Ve;
        }
        return jr.cancel = Gr, jr.flush = br, jr;
      }
      var n0 = Hi(function(f, _) {
        return Yu(f, 1, _);
      }), r0 = Hi(function(f, _, R) {
        return Yu(f, is(_) || 0, R);
      });
      function s0(f) {
        return Es(f, He);
      }
      function qo(f, _) {
        if (typeof f != "function" || _ != null && typeof _ != "function")
          throw new xi(h);
        var R = function() {
          var ne = arguments, be = _ ? _.apply(this, ne) : ne[0], Te = R.cache;
          if (Te.has(be))
            return Te.get(be);
          var Ve = f.apply(this, ne);
          return R.cache = Te.set(be, Ve) || Te, Ve;
        };
        return R.cache = new (qo.Cache || ks)(), R;
      }
      qo.Cache = ks;
      function Zo(f) {
        if (typeof f != "function")
          throw new xi(h);
        return function() {
          var _ = arguments;
          switch (_.length) {
            case 0:
              return !f.call(this);
            case 1:
              return !f.call(this, _[0]);
            case 2:
              return !f.call(this, _[0], _[1]);
            case 3:
              return !f.call(this, _[0], _[1], _[2]);
          }
          return !f.apply(this, _);
        };
      }
      function a0(f) {
        return Xc(2, f);
      }
      var o0 = qp(function(f, _) {
        _ = _.length == 1 && Oi(_[0]) ? ai(_[0], Ln(wi())) : ai(ir(_, 1), Ln(wi()));
        var R = _.length;
        return Hi(function(ne) {
          for (var be = -1, Te = cr(ne.length, R); ++be < Te; )
            ne[be] = _[be].call(this, ne[be]);
          return Ue(f, this, ne);
        });
      }), _h = Hi(function(f, _) {
        var R = $n(_, ba(_h));
        return Es(f, X, t, _, R);
      }), tf = Hi(function(f, _) {
        var R = $n(_, ba(tf));
        return Es(f, W, t, _, R);
      }), l0 = Is(function(f, _) {
        return Es(f, Ee, t, t, t, _);
      });
      function h0(f, _) {
        if (typeof f != "function")
          throw new xi(h);
        return _ = _ === t ? _ : zi(_), Hi(f, _);
      }
      function u0(f, _) {
        if (typeof f != "function")
          throw new xi(h);
        return _ = _ == null ? 0 : Xn(zi(_), 0), Hi(function(R) {
          var ne = R[_], be = Ys(R, 0, _);
          return ne && mi(be, ne), Ue(f, this, be);
        });
      }
      function c0(f, _, R) {
        var ne = !0, be = !0;
        if (typeof f != "function")
          throw new xi(h);
        return kn(R) && (ne = "leading" in R ? !!R.leading : ne, be = "trailing" in R ? !!R.trailing : be), ef(f, _, {
          leading: ne,
          maxWait: _,
          trailing: be
        });
      }
      function f0(f) {
        return $c(f, 1);
      }
      function d0(f, _) {
        return _h(th(_), f);
      }
      function g0() {
        if (!arguments.length)
          return [];
        var f = arguments[0];
        return Oi(f) ? f : [f];
      }
      function p0(f) {
        return Qr(f, Z);
      }
      function m0(f, _) {
        return _ = typeof _ == "function" ? _ : t, Qr(f, Z, _);
      }
      function _0(f) {
        return Qr(f, F | Z);
      }
      function v0(f, _) {
        return _ = typeof _ == "function" ? _ : t, Qr(f, F | Z, _);
      }
      function y0(f, _) {
        return _ == null || Hu(f, _, Qn(_));
      }
      function fs(f, _) {
        return f === _ || f !== f && _ !== _;
      }
      var b0 = Uo(Yl), x0 = Uo(function(f, _) {
        return f >= _;
      }), aa = Zu(function() {
        return arguments;
      }()) ? Zu : function(f) {
        return Rn(f) && on.call(f, "callee") && !Pu.call(f, "callee");
      }, Oi = Q.isArray, w0 = N ? Ln(N) : kp;
      function Br(f) {
        return f != null && $o(f.length) && !Ps(f);
      }
      function Fn(f) {
        return Rn(f) && Br(f);
      }
      function S0(f) {
        return f === !0 || f === !1 || Rn(f) && vr(f) == Gt;
      }
      var Gs = Dg || Bh, M0 = ee ? Ln(ee) : Ep;
      function C0(f) {
        return Rn(f) && f.nodeType === 1 && !Za(f);
      }
      function A0(f) {
        if (f == null)
          return !0;
        if (Br(f) && (Oi(f) || typeof f == "string" || typeof f.splice == "function" || Gs(f) || xa(f) || aa(f)))
          return !f.length;
        var _ = fr(f);
        if (_ == xt || _ == Qe)
          return !f.size;
        if (Wa(f))
          return !Wl(f).length;
        for (var R in f)
          if (on.call(f, R))
            return !1;
        return !0;
      }
      function T0(f, _) {
        return Ya(f, _);
      }
      function L0(f, _, R) {
        R = typeof R == "function" ? R : t;
        var ne = R ? R(f, _) : t;
        return ne === t ? Ya(f, _, t, R) : !!ne;
      }
      function vh(f) {
        if (!Rn(f))
          return !1;
        var _ = vr(f);
        return _ == Ni || _ == Qt || typeof f.message == "string" && typeof f.name == "string" && !Za(f);
      }
      function B0(f) {
        return typeof f == "number" && Ru(f);
      }
      function Ps(f) {
        if (!kn(f))
          return !1;
        var _ = vr(f);
        return _ == Di || _ == pe || _ == ui || _ == kt;
      }
      function nf(f) {
        return typeof f == "number" && f == zi(f);
      }
      function $o(f) {
        return typeof f == "number" && f > -1 && f % 1 == 0 && f <= We;
      }
      function kn(f) {
        var _ = typeof f;
        return f != null && (_ == "object" || _ == "function");
      }
      function Rn(f) {
        return f != null && typeof f == "object";
      }
      var rf = re ? Ln(re) : Op;
      function k0(f, _) {
        return f === _ || jl(f, _, lh(_));
      }
      function E0(f, _, R) {
        return R = typeof R == "function" ? R : t, jl(f, _, lh(_), R);
      }
      function I0(f) {
        return sf(f) && f != +f;
      }
      function O0(f) {
        if (mm(f))
          throw new Me(o);
        return $u(f);
      }
      function P0(f) {
        return f === null;
      }
      function N0(f) {
        return f == null;
      }
      function sf(f) {
        return typeof f == "number" || Rn(f) && vr(f) == tt;
      }
      function Za(f) {
        if (!Rn(f) || vr(f) != ke)
          return !1;
        var _ = wo(f);
        if (_ === null)
          return !0;
        var R = on.call(_, "constructor") && _.constructor;
        return typeof R == "function" && R instanceof R && jn.call(R) == Eg;
      }
      var yh = ge ? Ln(ge) : Pp;
      function R0(f) {
        return nf(f) && f >= -We && f <= We;
      }
      var af = _e ? Ln(_e) : Np;
      function Xo(f) {
        return typeof f == "string" || !Oi(f) && Rn(f) && vr(f) == wt;
      }
      function Yr(f) {
        return typeof f == "symbol" || Rn(f) && vr(f) == Yt;
      }
      var xa = xe ? Ln(xe) : Rp;
      function D0(f) {
        return f === t;
      }
      function z0(f) {
        return Rn(f) && fr(f) == i;
      }
      function F0(f) {
        return Rn(f) && vr(f) == r;
      }
      var U0 = Uo(ql), V0 = Uo(function(f, _) {
        return f <= _;
      });
      function of(f) {
        if (!f)
          return [];
        if (Br(f))
          return Xo(f) ? zn(f) : Lr(f);
        if (Na && f[Na])
          return hr(f[Na]());
        var _ = fr(f), R = _ == xt ? tr : _ == Qe ? Ri : wa;
        return R(f);
      }
      function Ns(f) {
        if (!f)
          return f === 0 ? f : 0;
        if (f = is(f), f === qt || f === -qt) {
          var _ = f < 0 ? -1 : 1;
          return _ * Et;
        }
        return f === f ? f : 0;
      }
      function zi(f) {
        var _ = Ns(f), R = _ % 1;
        return _ === _ ? R ? _ - R : _ : 0;
      }
      function lf(f) {
        return f ? ia(zi(f), 0, it) : 0;
      }
      function is(f) {
        if (typeof f == "number")
          return f;
        if (Yr(f))
          return rt;
        if (kn(f)) {
          var _ = typeof f.valueOf == "function" ? f.valueOf() : f;
          f = kn(_) ? _ + "" : _;
        }
        if (typeof f != "string")
          return f === 0 ? f : +f;
        f = Jt(f);
        var R = Fe.test(f);
        return R || yt.test(f) ? or(f.slice(2), R ? 2 : 8) : Re.test(f) ? rt : +f;
      }
      function hf(f) {
        return Ss(f, kr(f));
      }
      function H0(f) {
        return f ? ia(zi(f), -We, We) : f === 0 ? f : 0;
      }
      function ln(f) {
        return f == null ? "" : Hr(f);
      }
      var Y0 = va(function(f, _) {
        if (Wa(_) || Br(_)) {
          Ss(_, Qn(_), f);
          return;
        }
        for (var R in _)
          on.call(_, R) && Ua(f, R, _[R]);
      }), uf = va(function(f, _) {
        Ss(_, kr(_), f);
      }), cf = va(function(f, _, R, ne) {
        Ss(_, kr(_), f, ne);
      }), bh = va(function(f, _, R, ne) {
        Ss(_, Qn(_), f, ne);
      }), G0 = Is(Ul);
      function j0(f, _) {
        var R = _a(f);
        return _ == null ? R : Vu(R, _);
      }
      var W0 = Hi(function(f, _) {
        f = gt(f);
        var R = -1, ne = _.length, be = ne > 2 ? _[2] : t;
        for (be && yr(_[0], _[1], be) && (ne = 1); ++R < ne; )
          for (var Te = _[R], Ve = kr(Te), Xe = -1, lt = Ve.length; ++Xe < lt; ) {
            var Ot = Ve[Xe], Pt = f[Ot];
            (Pt === t || fs(Pt, mn[Ot]) && !on.call(f, Ot)) && (f[Ot] = Te[Ot]);
          }
        return f;
      }), q0 = Hi(function(f) {
        return f.push(t, Ac), Ue(ff, t, f);
      });
      function Z0(f, _) {
        return Fi(f, wi(_, 3), ws);
      }
      function $0(f, _) {
        return Fi(f, wi(_, 3), Hl);
      }
      function X0(f, _) {
        return f == null ? f : Vl(f, wi(_, 3), kr);
      }
      function K0(f, _) {
        return f == null ? f : Wu(f, wi(_, 3), kr);
      }
      function J0(f, _) {
        return f && ws(f, wi(_, 3));
      }
      function Q0(f, _) {
        return f && Hl(f, wi(_, 3));
      }
      function ev(f) {
        return f == null ? [] : Io(f, Qn(f));
      }
      function tv(f) {
        return f == null ? [] : Io(f, kr(f));
      }
      function xh(f, _, R) {
        var ne = f == null ? t : na(f, _);
        return ne === t ? R : ne;
      }
      function iv(f, _) {
        return f != null && Bc(f, _, Ap);
      }
      function wh(f, _) {
        return f != null && Bc(f, _, Tp);
      }
      var nv = xc(function(f, _, R) {
        _ != null && typeof _.toString != "function" && (_ = yo.call(_)), f[_] = R;
      }, Mh(Er)), rv = xc(function(f, _, R) {
        _ != null && typeof _.toString != "function" && (_ = yo.call(_)), on.call(f, _) ? f[_].push(R) : f[_] = [R];
      }, wi), sv = Hi(Ha);
      function Qn(f) {
        return Br(f) ? Fu(f) : Wl(f);
      }
      function kr(f) {
        return Br(f) ? Fu(f, !0) : Dp(f);
      }
      function av(f, _) {
        var R = {};
        return _ = wi(_, 3), ws(f, function(ne, be, Te) {
          xs(R, _(ne, be, Te), ne);
        }), R;
      }
      function ov(f, _) {
        var R = {};
        return _ = wi(_, 3), ws(f, function(ne, be, Te) {
          xs(R, be, _(ne, be, Te));
        }), R;
      }
      var lv = va(function(f, _, R) {
        Oo(f, _, R);
      }), ff = va(function(f, _, R, ne) {
        Oo(f, _, R, ne);
      }), hv = Is(function(f, _) {
        var R = {};
        if (f == null)
          return R;
        var ne = !1;
        _ = ai(_, function(Te) {
          return Te = Hs(Te, f), ne || (ne = Te.length > 1), Te;
        }), Ss(f, ah(f), R), ne && (R = Qr(R, F | M | Z, rm));
        for (var be = _.length; be--; )
          Jl(R, _[be]);
        return R;
      });
      function uv(f, _) {
        return df(f, Zo(wi(_)));
      }
      var cv = Is(function(f, _) {
        return f == null ? {} : Fp(f, _);
      });
      function df(f, _) {
        if (f == null)
          return {};
        var R = ai(ah(f), function(ne) {
          return [ne];
        });
        return _ = wi(_), ic(f, R, function(ne, be) {
          return _(ne, be[0]);
        });
      }
      function fv(f, _, R) {
        _ = Hs(_, f);
        var ne = -1, be = _.length;
        for (be || (be = 1, f = t); ++ne < be; ) {
          var Te = f == null ? t : f[cs(_[ne])];
          Te === t && (ne = be, Te = R), f = Ps(Te) ? Te.call(f) : Te;
        }
        return f;
      }
      function dv(f, _, R) {
        return f == null ? f : Ga(f, _, R);
      }
      function gv(f, _, R, ne) {
        return ne = typeof ne == "function" ? ne : t, f == null ? f : Ga(f, _, R, ne);
      }
      var gf = Mc(Qn), pf = Mc(kr);
      function pv(f, _, R) {
        var ne = Oi(f), be = ne || Gs(f) || xa(f);
        if (_ = wi(_, 4), R == null) {
          var Te = f && f.constructor;
          be ? R = ne ? new Te() : [] : kn(f) ? R = Ps(Te) ? _a(wo(f)) : {} : R = {};
        }
        return (be ? qe : ws)(f, function(Ve, Xe, lt) {
          return _(R, Ve, Xe, lt);
        }), R;
      }
      function mv(f, _) {
        return f == null ? !0 : Jl(f, _);
      }
      function _v(f, _, R) {
        return f == null ? f : oc(f, _, th(R));
      }
      function vv(f, _, R, ne) {
        return ne = typeof ne == "function" ? ne : t, f == null ? f : oc(f, _, th(R), ne);
      }
      function wa(f) {
        return f == null ? [] : _i(f, Qn(f));
      }
      function yv(f) {
        return f == null ? [] : _i(f, kr(f));
      }
      function bv(f, _, R) {
        return R === t && (R = _, _ = t), R !== t && (R = is(R), R = R === R ? R : 0), _ !== t && (_ = is(_), _ = _ === _ ? _ : 0), ia(is(f), _, R);
      }
      function xv(f, _, R) {
        return _ = Ns(_), R === t ? (R = _, _ = 0) : R = Ns(R), f = is(f), Lp(f, _, R);
      }
      function wv(f, _, R) {
        if (R && typeof R != "boolean" && yr(f, _, R) && (_ = R = t), R === t && (typeof _ == "boolean" ? (R = _, _ = t) : typeof f == "boolean" && (R = f, f = t)), f === t && _ === t ? (f = 0, _ = 1) : (f = Ns(f), _ === t ? (_ = f, f = 0) : _ = Ns(_)), f > _) {
          var ne = f;
          f = _, _ = ne;
        }
        if (R || f % 1 || _ % 1) {
          var be = Du();
          return cr(f + be * (_ - f + Cr("1e-" + ((be + "").length - 1))), _);
        }
        return $l(f, _);
      }
      var Sv = ya(function(f, _, R) {
        return _ = _.toLowerCase(), f + (R ? mf(_) : _);
      });
      function mf(f) {
        return Sh(ln(f).toLowerCase());
      }
      function _f(f) {
        return f = ln(f), f && f.replace(Rt, Fr).replace(ye, "");
      }
      function Mv(f, _, R) {
        f = ln(f), _ = Hr(_);
        var ne = f.length;
        R = R === t ? ne : ia(zi(R), 0, ne);
        var be = R;
        return R -= _.length, R >= 0 && f.slice(R, be) == _;
      }
      function Cv(f) {
        return f = ln(f), f && C.test(f) ? f.replace(k, Js) : f;
      }
      function Av(f) {
        return f = ln(f), f && me.test(f) ? f.replace(ue, "\\$&") : f;
      }
      var Tv = ya(function(f, _, R) {
        return f + (R ? "-" : "") + _.toLowerCase();
      }), Lv = ya(function(f, _, R) {
        return f + (R ? " " : "") + _.toLowerCase();
      }), Bv = vc("toLowerCase");
      function kv(f, _, R) {
        f = ln(f), _ = zi(_);
        var ne = _ ? Jn(f) : 0;
        if (!_ || ne >= _)
          return f;
        var be = (_ - ne) / 2;
        return Fo(Ao(be), R) + f + Fo(Co(be), R);
      }
      function Ev(f, _, R) {
        f = ln(f), _ = zi(_);
        var ne = _ ? Jn(f) : 0;
        return _ && ne < _ ? f + Fo(_ - ne, R) : f;
      }
      function Iv(f, _, R) {
        f = ln(f), _ = zi(_);
        var ne = _ ? Jn(f) : 0;
        return _ && ne < _ ? Fo(_ - ne, R) + f : f;
      }
      function Ov(f, _, R) {
        return R || _ == null ? _ = 0 : _ && (_ = +_), Vg(ln(f).replace(se, ""), _ || 0);
      }
      function Pv(f, _, R) {
        return (R ? yr(f, _, R) : _ === t) ? _ = 1 : _ = zi(_), Xl(ln(f), _);
      }
      function Nv() {
        var f = arguments, _ = ln(f[0]);
        return f.length < 3 ? _ : _.replace(f[1], f[2]);
      }
      var Rv = ya(function(f, _, R) {
        return f + (R ? "_" : "") + _.toLowerCase();
      });
      function Dv(f, _, R) {
        return R && typeof R != "number" && yr(f, _, R) && (_ = R = t), R = R === t ? it : R >>> 0, R ? (f = ln(f), f && (typeof _ == "string" || _ != null && !yh(_)) && (_ = Hr(_), !_ && Ji(f)) ? Ys(zn(f), 0, R) : f.split(_, R)) : [];
      }
      var zv = ya(function(f, _, R) {
        return f + (R ? " " : "") + Sh(_);
      });
      function Fv(f, _, R) {
        return f = ln(f), R = R == null ? 0 : ia(zi(R), 0, f.length), _ = Hr(_), f.slice(R, R + _.length) == _;
      }
      function Uv(f, _, R) {
        var ne = Ce.templateSettings;
        R && yr(f, _, R) && (_ = t), f = ln(f), _ = bh({}, _, ne, Cc);
        var be = bh({}, _.imports, ne.imports, Cc), Te = Qn(be), Ve = _i(be, Te);
        qe(Te, function(vi) {
          if (Ge.test(vi))
            throw new Me(m);
        });
        var Xe, lt, Ot = 0, Pt = _.interpolate || It, Ut = "__p += '", ni = Mt(
          (_.escape || It).source + "|" + Pt.source + "|" + (Pt === q ? st : It).source + "|" + (_.evaluate || It).source + "|$",
          "g"
        ), li = "//# sourceURL=" + (on.call(_, "sourceURL") ? (_.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++fi + "]") + `
`;
        f.replace(ni, function(vi, Wi, $i, Gr, br, jr) {
          return $i || ($i = Gr), Ut += f.slice(Ot, jr).replace(Ht, Kr), Wi && (Xe = !0, Ut += `' +
__e(` + Wi + `) +
'`), br && (lt = !0, Ut += `';
` + br + `;
__p += '`), $i && (Ut += `' +
((__t = (` + $i + `)) == null ? '' : __t) +
'`), Ot = jr + vi.length, vi;
        }), Ut += `';
`;
        var Mi = on.call(_, "variable") && _.variable;
        if (!Mi)
          Ut = `with (obj) {
` + Ut + `
}
`;
        else if (Ge.test(Mi))
          throw new Me(c);
        Ut = (lt ? Ut.replace(T, "") : Ut).replace(G, "$1").replace(D, "$1;"), Ut = "function(" + (Mi || "obj") + `) {
` + (Mi ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Xe ? ", __e = _.escape" : "") + (lt ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ut + `return __p
}`;
        var Ui = yf(function() {
          return Be(Te, li + "return " + Ut).apply(t, Ve);
        });
        if (Ui.source = Ut, vh(Ui))
          throw Ui;
        return Ui;
      }
      function Vv(f) {
        return ln(f).toLowerCase();
      }
      function Hv(f) {
        return ln(f).toUpperCase();
      }
      function Yv(f, _, R) {
        if (f = ln(f), f && (R || _ === t))
          return Jt(f);
        if (!f || !(_ = Hr(_)))
          return f;
        var ne = zn(f), be = zn(_), Te = Bn(ne, be), Ve = di(ne, be) + 1;
        return Ys(ne, Te, Ve).join("");
      }
      function Gv(f, _, R) {
        if (f = ln(f), f && (R || _ === t))
          return f.slice(0, bs(f) + 1);
        if (!f || !(_ = Hr(_)))
          return f;
        var ne = zn(f), be = di(ne, zn(_)) + 1;
        return Ys(ne, 0, be).join("");
      }
      function jv(f, _, R) {
        if (f = ln(f), f && (R || _ === t))
          return f.replace(se, "");
        if (!f || !(_ = Hr(_)))
          return f;
        var ne = zn(f), be = Bn(ne, zn(_));
        return Ys(ne, be).join("");
      }
      function Wv(f, _) {
        var R = ft, ne = Le;
        if (kn(_)) {
          var be = "separator" in _ ? _.separator : be;
          R = "length" in _ ? zi(_.length) : R, ne = "omission" in _ ? Hr(_.omission) : ne;
        }
        f = ln(f);
        var Te = f.length;
        if (Ji(f)) {
          var Ve = zn(f);
          Te = Ve.length;
        }
        if (R >= Te)
          return f;
        var Xe = R - Jn(ne);
        if (Xe < 1)
          return ne;
        var lt = Ve ? Ys(Ve, 0, Xe).join("") : f.slice(0, Xe);
        if (be === t)
          return lt + ne;
        if (Ve && (Xe += lt.length - Xe), yh(be)) {
          if (f.slice(Xe).search(be)) {
            var Ot, Pt = lt;
            for (be.global || (be = Mt(be.source, ln(_t.exec(be)) + "g")), be.lastIndex = 0; Ot = be.exec(Pt); )
              var Ut = Ot.index;
            lt = lt.slice(0, Ut === t ? Xe : Ut);
          }
        } else if (f.indexOf(Hr(be), Xe) != Xe) {
          var ni = lt.lastIndexOf(be);
          ni > -1 && (lt = lt.slice(0, ni));
        }
        return lt + ne;
      }
      function qv(f) {
        return f = ln(f), f && z.test(f) ? f.replace(Y, ur) : f;
      }
      var Zv = ya(function(f, _, R) {
        return f + (R ? " " : "") + _.toUpperCase();
      }), Sh = vc("toUpperCase");
      function vf(f, _, R) {
        return f = ln(f), _ = R ? t : _, _ === t ? Pn(f) ? mt(f) : Dn(f) : f.match(_) || [];
      }
      var yf = Hi(function(f, _) {
        try {
          return Ue(f, t, _);
        } catch (R) {
          return vh(R) ? R : new Me(R);
        }
      }), $v = Is(function(f, _) {
        return qe(_, function(R) {
          R = cs(R), xs(f, R, mh(f[R], f));
        }), f;
      });
      function Xv(f) {
        var _ = f == null ? 0 : f.length, R = wi();
        return f = _ ? ai(f, function(ne) {
          if (typeof ne[1] != "function")
            throw new xi(h);
          return [R(ne[0]), ne[1]];
        }) : [], Hi(function(ne) {
          for (var be = -1; ++be < _; ) {
            var Te = f[be];
            if (Ue(Te[0], this, ne))
              return Ue(Te[1], this, ne);
          }
        });
      }
      function Kv(f) {
        return Sp(Qr(f, F));
      }
      function Mh(f) {
        return function() {
          return f;
        };
      }
      function Jv(f, _) {
        return f == null || f !== f ? _ : f;
      }
      var Qv = bc(), ey = bc(!0);
      function Er(f) {
        return f;
      }
      function Ch(f) {
        return Xu(typeof f == "function" ? f : Qr(f, F));
      }
      function ty(f) {
        return Ju(Qr(f, F));
      }
      function iy(f, _) {
        return Qu(f, Qr(_, F));
      }
      var ny = Hi(function(f, _) {
        return function(R) {
          return Ha(R, f, _);
        };
      }), ry = Hi(function(f, _) {
        return function(R) {
          return Ha(f, R, _);
        };
      });
      function Ah(f, _, R) {
        var ne = Qn(_), be = Io(_, ne);
        R == null && !(kn(_) && (be.length || !ne.length)) && (R = _, _ = f, f = this, be = Io(_, Qn(_)));
        var Te = !(kn(R) && "chain" in R) || !!R.chain, Ve = Ps(f);
        return qe(be, function(Xe) {
          var lt = _[Xe];
          f[Xe] = lt, Ve && (f.prototype[Xe] = function() {
            var Ot = this.__chain__;
            if (Te || Ot) {
              var Pt = f(this.__wrapped__), Ut = Pt.__actions__ = Lr(this.__actions__);
              return Ut.push({ func: lt, args: arguments, thisArg: f }), Pt.__chain__ = Ot, Pt;
            }
            return lt.apply(f, mi([this.value()], arguments));
          });
        }), f;
      }
      function sy() {
        return Sn._ === this && (Sn._ = Ig), this;
      }
      function Th() {
      }
      function ay(f) {
        return f = zi(f), Hi(function(_) {
          return ec(_, f);
        });
      }
      var oy = nh(ai), ly = nh(Bt), hy = nh(an);
      function bf(f) {
        return uh(f) ? Yn(cs(f)) : Up(f);
      }
      function uy(f) {
        return function(_) {
          return f == null ? t : na(f, _);
        };
      }
      var cy = wc(), fy = wc(!0);
      function Lh() {
        return [];
      }
      function Bh() {
        return !1;
      }
      function dy() {
        return {};
      }
      function gy() {
        return "";
      }
      function py() {
        return !0;
      }
      function my(f, _) {
        if (f = zi(f), f < 1 || f > We)
          return [];
        var R = it, ne = cr(f, it);
        _ = wi(_), f -= it;
        for (var be = Ai(ne, _); ++R < f; )
          _(R);
        return be;
      }
      function _y(f) {
        return Oi(f) ? ai(f, cs) : Yr(f) ? [f] : Lr(zc(ln(f)));
      }
      function vy(f) {
        var _ = ++kg;
        return ln(f) + _;
      }
      var yy = zo(function(f, _) {
        return f + _;
      }, 0), by = rh("ceil"), xy = zo(function(f, _) {
        return f / _;
      }, 1), wy = rh("floor");
      function Sy(f) {
        return f && f.length ? Eo(f, Er, Yl) : t;
      }
      function My(f, _) {
        return f && f.length ? Eo(f, wi(_, 2), Yl) : t;
      }
      function Cy(f) {
        return Tr(f, Er);
      }
      function Ay(f, _) {
        return Tr(f, wi(_, 2));
      }
      function Ty(f) {
        return f && f.length ? Eo(f, Er, ql) : t;
      }
      function Ly(f, _) {
        return f && f.length ? Eo(f, wi(_, 2), ql) : t;
      }
      var By = zo(function(f, _) {
        return f * _;
      }, 1), ky = rh("round"), Ey = zo(function(f, _) {
        return f - _;
      }, 0);
      function Iy(f) {
        return f && f.length ? zr(f, Er) : 0;
      }
      function Oy(f, _) {
        return f && f.length ? zr(f, wi(_, 2)) : 0;
      }
      return Ce.after = i0, Ce.ary = $c, Ce.assign = Y0, Ce.assignIn = uf, Ce.assignInWith = cf, Ce.assignWith = bh, Ce.at = G0, Ce.before = Xc, Ce.bind = mh, Ce.bindAll = $v, Ce.bindKey = Kc, Ce.castArray = g0, Ce.chain = Wc, Ce.chunk = Sm, Ce.compact = Mm, Ce.concat = Cm, Ce.cond = Xv, Ce.conforms = Kv, Ce.constant = Mh, Ce.countBy = O_, Ce.create = j0, Ce.curry = Jc, Ce.curryRight = Qc, Ce.debounce = ef, Ce.defaults = W0, Ce.defaultsDeep = q0, Ce.defer = n0, Ce.delay = r0, Ce.difference = Am, Ce.differenceBy = Tm, Ce.differenceWith = Lm, Ce.drop = Bm, Ce.dropRight = km, Ce.dropRightWhile = Em, Ce.dropWhile = Im, Ce.fill = Om, Ce.filter = N_, Ce.flatMap = z_, Ce.flatMapDeep = F_, Ce.flatMapDepth = U_, Ce.flatten = Hc, Ce.flattenDeep = Pm, Ce.flattenDepth = Nm, Ce.flip = s0, Ce.flow = Qv, Ce.flowRight = ey, Ce.fromPairs = Rm, Ce.functions = ev, Ce.functionsIn = tv, Ce.groupBy = V_, Ce.initial = zm, Ce.intersection = Fm, Ce.intersectionBy = Um, Ce.intersectionWith = Vm, Ce.invert = nv, Ce.invertBy = rv, Ce.invokeMap = Y_, Ce.iteratee = Ch, Ce.keyBy = G_, Ce.keys = Qn, Ce.keysIn = kr, Ce.map = jo, Ce.mapKeys = av, Ce.mapValues = ov, Ce.matches = ty, Ce.matchesProperty = iy, Ce.memoize = qo, Ce.merge = lv, Ce.mergeWith = ff, Ce.method = ny, Ce.methodOf = ry, Ce.mixin = Ah, Ce.negate = Zo, Ce.nthArg = ay, Ce.omit = hv, Ce.omitBy = uv, Ce.once = a0, Ce.orderBy = j_, Ce.over = oy, Ce.overArgs = o0, Ce.overEvery = ly, Ce.overSome = hy, Ce.partial = _h, Ce.partialRight = tf, Ce.partition = W_, Ce.pick = cv, Ce.pickBy = df, Ce.property = bf, Ce.propertyOf = uy, Ce.pull = jm, Ce.pullAll = Gc, Ce.pullAllBy = Wm, Ce.pullAllWith = qm, Ce.pullAt = Zm, Ce.range = cy, Ce.rangeRight = fy, Ce.rearg = l0, Ce.reject = $_, Ce.remove = $m, Ce.rest = h0, Ce.reverse = gh, Ce.sampleSize = K_, Ce.set = dv, Ce.setWith = gv, Ce.shuffle = J_, Ce.slice = Xm, Ce.sortBy = t0, Ce.sortedUniq = n_, Ce.sortedUniqBy = r_, Ce.split = Dv, Ce.spread = u0, Ce.tail = s_, Ce.take = a_, Ce.takeRight = o_, Ce.takeRightWhile = l_, Ce.takeWhile = h_, Ce.tap = M_, Ce.throttle = c0, Ce.thru = Go, Ce.toArray = of, Ce.toPairs = gf, Ce.toPairsIn = pf, Ce.toPath = _y, Ce.toPlainObject = hf, Ce.transform = pv, Ce.unary = f0, Ce.union = u_, Ce.unionBy = c_, Ce.unionWith = f_, Ce.uniq = d_, Ce.uniqBy = g_, Ce.uniqWith = p_, Ce.unset = mv, Ce.unzip = ph, Ce.unzipWith = jc, Ce.update = _v, Ce.updateWith = vv, Ce.values = wa, Ce.valuesIn = yv, Ce.without = m_, Ce.words = vf, Ce.wrap = d0, Ce.xor = __, Ce.xorBy = v_, Ce.xorWith = y_, Ce.zip = b_, Ce.zipObject = x_, Ce.zipObjectDeep = w_, Ce.zipWith = S_, Ce.entries = gf, Ce.entriesIn = pf, Ce.extend = uf, Ce.extendWith = cf, Ah(Ce, Ce), Ce.add = yy, Ce.attempt = yf, Ce.camelCase = Sv, Ce.capitalize = mf, Ce.ceil = by, Ce.clamp = bv, Ce.clone = p0, Ce.cloneDeep = _0, Ce.cloneDeepWith = v0, Ce.cloneWith = m0, Ce.conformsTo = y0, Ce.deburr = _f, Ce.defaultTo = Jv, Ce.divide = xy, Ce.endsWith = Mv, Ce.eq = fs, Ce.escape = Cv, Ce.escapeRegExp = Av, Ce.every = P_, Ce.find = R_, Ce.findIndex = Uc, Ce.findKey = Z0, Ce.findLast = D_, Ce.findLastIndex = Vc, Ce.findLastKey = $0, Ce.floor = wy, Ce.forEach = qc, Ce.forEachRight = Zc, Ce.forIn = X0, Ce.forInRight = K0, Ce.forOwn = J0, Ce.forOwnRight = Q0, Ce.get = xh, Ce.gt = b0, Ce.gte = x0, Ce.has = iv, Ce.hasIn = wh, Ce.head = Yc, Ce.identity = Er, Ce.includes = H_, Ce.indexOf = Dm, Ce.inRange = xv, Ce.invoke = sv, Ce.isArguments = aa, Ce.isArray = Oi, Ce.isArrayBuffer = w0, Ce.isArrayLike = Br, Ce.isArrayLikeObject = Fn, Ce.isBoolean = S0, Ce.isBuffer = Gs, Ce.isDate = M0, Ce.isElement = C0, Ce.isEmpty = A0, Ce.isEqual = T0, Ce.isEqualWith = L0, Ce.isError = vh, Ce.isFinite = B0, Ce.isFunction = Ps, Ce.isInteger = nf, Ce.isLength = $o, Ce.isMap = rf, Ce.isMatch = k0, Ce.isMatchWith = E0, Ce.isNaN = I0, Ce.isNative = O0, Ce.isNil = N0, Ce.isNull = P0, Ce.isNumber = sf, Ce.isObject = kn, Ce.isObjectLike = Rn, Ce.isPlainObject = Za, Ce.isRegExp = yh, Ce.isSafeInteger = R0, Ce.isSet = af, Ce.isString = Xo, Ce.isSymbol = Yr, Ce.isTypedArray = xa, Ce.isUndefined = D0, Ce.isWeakMap = z0, Ce.isWeakSet = F0, Ce.join = Hm, Ce.kebabCase = Tv, Ce.last = ts, Ce.lastIndexOf = Ym, Ce.lowerCase = Lv, Ce.lowerFirst = Bv, Ce.lt = U0, Ce.lte = V0, Ce.max = Sy, Ce.maxBy = My, Ce.mean = Cy, Ce.meanBy = Ay, Ce.min = Ty, Ce.minBy = Ly, Ce.stubArray = Lh, Ce.stubFalse = Bh, Ce.stubObject = dy, Ce.stubString = gy, Ce.stubTrue = py, Ce.multiply = By, Ce.nth = Gm, Ce.noConflict = sy, Ce.noop = Th, Ce.now = Wo, Ce.pad = kv, Ce.padEnd = Ev, Ce.padStart = Iv, Ce.parseInt = Ov, Ce.random = wv, Ce.reduce = q_, Ce.reduceRight = Z_, Ce.repeat = Pv, Ce.replace = Nv, Ce.result = fv, Ce.round = ky, Ce.runInContext = Ne, Ce.sample = X_, Ce.size = Q_, Ce.snakeCase = Rv, Ce.some = e0, Ce.sortedIndex = Km, Ce.sortedIndexBy = Jm, Ce.sortedIndexOf = Qm, Ce.sortedLastIndex = e_, Ce.sortedLastIndexBy = t_, Ce.sortedLastIndexOf = i_, Ce.startCase = zv, Ce.startsWith = Fv, Ce.subtract = Ey, Ce.sum = Iy, Ce.sumBy = Oy, Ce.template = Uv, Ce.times = my, Ce.toFinite = Ns, Ce.toInteger = zi, Ce.toLength = lf, Ce.toLower = Vv, Ce.toNumber = is, Ce.toSafeInteger = H0, Ce.toString = ln, Ce.toUpper = Hv, Ce.trim = Yv, Ce.trimEnd = Gv, Ce.trimStart = jv, Ce.truncate = Wv, Ce.unescape = qv, Ce.uniqueId = vy, Ce.upperCase = Zv, Ce.upperFirst = Sh, Ce.each = qc, Ce.eachRight = Zc, Ce.first = Yc, Ah(Ce, function() {
        var f = {};
        return ws(Ce, function(_, R) {
          on.call(Ce.prototype, R) || (f[R] = _);
        }), f;
      }(), { chain: !1 }), Ce.VERSION = n, qe(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(f) {
        Ce[f].placeholder = Ce;
      }), qe(["drop", "take"], function(f, _) {
        Zi.prototype[f] = function(R) {
          R = R === t ? 1 : Xn(zi(R), 0);
          var ne = this.__filtered__ && !_ ? new Zi(this) : this.clone();
          return ne.__filtered__ ? ne.__takeCount__ = cr(R, ne.__takeCount__) : ne.__views__.push({
            size: cr(R, it),
            type: f + (ne.__dir__ < 0 ? "Right" : "")
          }), ne;
        }, Zi.prototype[f + "Right"] = function(R) {
          return this.reverse()[f](R).reverse();
        };
      }), qe(["filter", "map", "takeWhile"], function(f, _) {
        var R = _ + 1, ne = R == ut || R == pt;
        Zi.prototype[f] = function(be) {
          var Te = this.clone();
          return Te.__iteratees__.push({
            iteratee: wi(be, 3),
            type: R
          }), Te.__filtered__ = Te.__filtered__ || ne, Te;
        };
      }), qe(["head", "last"], function(f, _) {
        var R = "take" + (_ ? "Right" : "");
        Zi.prototype[f] = function() {
          return this[R](1).value()[0];
        };
      }), qe(["initial", "tail"], function(f, _) {
        var R = "drop" + (_ ? "" : "Right");
        Zi.prototype[f] = function() {
          return this.__filtered__ ? new Zi(this) : this[R](1);
        };
      }), Zi.prototype.compact = function() {
        return this.filter(Er);
      }, Zi.prototype.find = function(f) {
        return this.filter(f).head();
      }, Zi.prototype.findLast = function(f) {
        return this.reverse().find(f);
      }, Zi.prototype.invokeMap = Hi(function(f, _) {
        return typeof f == "function" ? new Zi(this) : this.map(function(R) {
          return Ha(R, f, _);
        });
      }), Zi.prototype.reject = function(f) {
        return this.filter(Zo(wi(f)));
      }, Zi.prototype.slice = function(f, _) {
        f = zi(f);
        var R = this;
        return R.__filtered__ && (f > 0 || _ < 0) ? new Zi(R) : (f < 0 ? R = R.takeRight(-f) : f && (R = R.drop(f)), _ !== t && (_ = zi(_), R = _ < 0 ? R.dropRight(-_) : R.take(_ - f)), R);
      }, Zi.prototype.takeRightWhile = function(f) {
        return this.reverse().takeWhile(f).reverse();
      }, Zi.prototype.toArray = function() {
        return this.take(it);
      }, ws(Zi.prototype, function(f, _) {
        var R = /^(?:filter|find|map|reject)|While$/.test(_), ne = /^(?:head|last)$/.test(_), be = Ce[ne ? "take" + (_ == "last" ? "Right" : "") : _], Te = ne || /^find/.test(_);
        be && (Ce.prototype[_] = function() {
          var Ve = this.__wrapped__, Xe = ne ? [1] : arguments, lt = Ve instanceof Zi, Ot = Xe[0], Pt = lt || Oi(Ve), Ut = function(Wi) {
            var $i = be.apply(Ce, mi([Wi], Xe));
            return ne && ni ? $i[0] : $i;
          };
          Pt && R && typeof Ot == "function" && Ot.length != 1 && (lt = Pt = !1);
          var ni = this.__chain__, li = !!this.__actions__.length, Mi = Te && !ni, Ui = lt && !li;
          if (!Te && Pt) {
            Ve = Ui ? Ve : new Zi(this);
            var vi = f.apply(Ve, Xe);
            return vi.__actions__.push({ func: Go, args: [Ut], thisArg: t }), new Jr(vi, ni);
          }
          return Mi && Ui ? f.apply(this, Xe) : (vi = this.thru(Ut), Mi ? ne ? vi.value()[0] : vi.value() : vi);
        });
      }), qe(["pop", "push", "shift", "sort", "splice", "unshift"], function(f) {
        var _ = ji[f], R = /^(?:push|sort|unshift)$/.test(f) ? "tap" : "thru", ne = /^(?:pop|shift)$/.test(f);
        Ce.prototype[f] = function() {
          var be = arguments;
          if (ne && !this.__chain__) {
            var Te = this.value();
            return _.apply(Oi(Te) ? Te : [], be);
          }
          return this[R](function(Ve) {
            return _.apply(Oi(Ve) ? Ve : [], be);
          });
        };
      }), ws(Zi.prototype, function(f, _) {
        var R = Ce[_];
        if (R) {
          var ne = R.name + "";
          on.call(ma, ne) || (ma[ne] = []), ma[ne].push({ name: _, func: R });
        }
      }), ma[Do(t, K).name] = [{
        name: "wrapper",
        func: t
      }], Zi.prototype.clone = Zg, Zi.prototype.reverse = $g, Zi.prototype.value = Xg, Ce.prototype.at = C_, Ce.prototype.chain = A_, Ce.prototype.commit = T_, Ce.prototype.next = L_, Ce.prototype.plant = k_, Ce.prototype.reverse = E_, Ce.prototype.toJSON = Ce.prototype.valueOf = Ce.prototype.value = I_, Ce.prototype.first = Ce.prototype.head, Na && (Ce.prototype[Na] = B_), Ce;
    }, Tt = St();
    Dr ? ((Dr.exports = Tt)._ = Tt, Rr._ = Tt) : Sn._ = Tt;
  }).call(as);
})(Al, Al.exports);
var g1 = Al.exports, bg = { exports: {} };
const p1 = {}, m1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: p1
}, Symbol.toStringTag, { value: "Module" })), td = /* @__PURE__ */ cw(m1);
var sl = { exports: {} }, id;
function _1() {
  return id || (id = 1, function(y, e) {
    (function(t, n) {
      n(e);
    })(as, function(t) {
      var n = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 78, 5, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 199, 7, 137, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 55, 9, 266, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 233, 0, 3, 0, 8, 1, 6, 0, 475, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], s = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 7, 25, 39, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 5, 57, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 24, 43, 261, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 33, 24, 3, 24, 45, 74, 6, 0, 67, 12, 65, 1, 2, 0, 15, 4, 10, 7381, 42, 31, 98, 114, 8702, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 208, 30, 2, 2, 2, 1, 2, 6, 3, 4, 10, 1, 225, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4381, 3, 5773, 3, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 8489], o = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-᫝᫠-᫫ᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", h = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-࢏ࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚ౜ౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ೜-ೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-Ƛ꟱-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", c = {
        3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
        5: "class enum extends super const export import",
        6: "enum",
        strict: "implements interface let package private protected public static yield",
        strictBind: "eval arguments"
      }, m = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", x = {
        5: m,
        "5module": m + " export import",
        6: m + " const class extends export import super"
      }, B = /^in(stanceof)?$/, I = new RegExp("[" + h + "]"), F = new RegExp("[" + h + o + "]");
      function M(g, U) {
        for (var he = 65536, ye = 0; ye < U.length; ye += 2) {
          if (he += U[ye], he > g)
            return !1;
          if (he += U[ye + 1], he >= g)
            return !0;
        }
        return !1;
      }
      function Z(g, U) {
        return g < 65 ? g === 36 : g < 91 ? !0 : g < 97 ? g === 95 : g < 123 ? !0 : g <= 65535 ? g >= 170 && I.test(String.fromCharCode(g)) : U === !1 ? !1 : M(g, s);
      }
      function V(g, U) {
        return g < 48 ? g === 36 : g < 58 ? !0 : g < 65 ? !1 : g < 91 ? !0 : g < 97 ? g === 95 : g < 123 ? !0 : g <= 65535 ? g >= 170 && F.test(String.fromCharCode(g)) : U === !1 ? !1 : M(g, s) || M(g, n);
      }
      var te = function(U, he) {
        he === void 0 && (he = {}), this.label = U, this.keyword = he.keyword, this.beforeExpr = !!he.beforeExpr, this.startsExpr = !!he.startsExpr, this.isLoop = !!he.isLoop, this.isAssign = !!he.isAssign, this.prefix = !!he.prefix, this.postfix = !!he.postfix, this.binop = he.binop || null, this.updateContext = null;
      };
      function P(g, U) {
        return new te(g, { beforeExpr: !0, binop: U });
      }
      var K = { beforeExpr: !0 }, J = { startsExpr: !0 }, le = {};
      function fe(g, U) {
        return U === void 0 && (U = {}), U.keyword = g, le[g] = new te(g, U);
      }
      var X = {
        num: new te("num", J),
        regexp: new te("regexp", J),
        string: new te("string", J),
        name: new te("name", J),
        privateId: new te("privateId", J),
        eof: new te("eof"),
        // Punctuation token types.
        bracketL: new te("[", { beforeExpr: !0, startsExpr: !0 }),
        bracketR: new te("]"),
        braceL: new te("{", { beforeExpr: !0, startsExpr: !0 }),
        braceR: new te("}"),
        parenL: new te("(", { beforeExpr: !0, startsExpr: !0 }),
        parenR: new te(")"),
        comma: new te(",", K),
        semi: new te(";", K),
        colon: new te(":", K),
        dot: new te("."),
        question: new te("?", K),
        questionDot: new te("?."),
        arrow: new te("=>", K),
        template: new te("template"),
        invalidTemplate: new te("invalidTemplate"),
        ellipsis: new te("...", K),
        backQuote: new te("`", J),
        dollarBraceL: new te("${", { beforeExpr: !0, startsExpr: !0 }),
        // Operators. These carry several kinds of properties to help the
        // parser use them properly (the presence of these properties is
        // what categorizes them as operators).
        //
        // `binop`, when present, specifies that this operator is a binary
        // operator, and will refer to its precedence.
        //
        // `prefix` and `postfix` mark the operator as a prefix or postfix
        // unary operator.
        //
        // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
        // binary operators with a very low precedence, that should result
        // in AssignmentExpression nodes.
        eq: new te("=", { beforeExpr: !0, isAssign: !0 }),
        assign: new te("_=", { beforeExpr: !0, isAssign: !0 }),
        incDec: new te("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
        prefix: new te("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        logicalOR: P("||", 1),
        logicalAND: P("&&", 2),
        bitwiseOR: P("|", 3),
        bitwiseXOR: P("^", 4),
        bitwiseAND: P("&", 5),
        equality: P("==/!=/===/!==", 6),
        relational: P("</>/<=/>=", 7),
        bitShift: P("<</>>/>>>", 8),
        plusMin: new te("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
        modulo: P("%", 10),
        star: P("*", 10),
        slash: P("/", 10),
        starstar: new te("**", { beforeExpr: !0 }),
        coalesce: P("??", 1),
        // Keyword token types.
        _break: fe("break"),
        _case: fe("case", K),
        _catch: fe("catch"),
        _continue: fe("continue"),
        _debugger: fe("debugger"),
        _default: fe("default", K),
        _do: fe("do", { isLoop: !0, beforeExpr: !0 }),
        _else: fe("else", K),
        _finally: fe("finally"),
        _for: fe("for", { isLoop: !0 }),
        _function: fe("function", J),
        _if: fe("if"),
        _return: fe("return", K),
        _switch: fe("switch"),
        _throw: fe("throw", K),
        _try: fe("try"),
        _var: fe("var"),
        _const: fe("const"),
        _while: fe("while", { isLoop: !0 }),
        _with: fe("with"),
        _new: fe("new", { beforeExpr: !0, startsExpr: !0 }),
        _this: fe("this", J),
        _super: fe("super", J),
        _class: fe("class", J),
        _extends: fe("extends", K),
        _export: fe("export"),
        _import: fe("import", J),
        _null: fe("null", J),
        _true: fe("true", J),
        _false: fe("false", J),
        _in: fe("in", { beforeExpr: !0, binop: 7 }),
        _instanceof: fe("instanceof", { beforeExpr: !0, binop: 7 }),
        _typeof: fe("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _void: fe("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _delete: fe("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
      }, W = /\r\n?|\n|\u2028|\u2029/, je = new RegExp(W.source, "g");
      function Ee(g) {
        return g === 10 || g === 13 || g === 8232 || g === 8233;
      }
      function He(g, U, he) {
        he === void 0 && (he = g.length);
        for (var ye = U; ye < he; ye++) {
          var Ie = g.charCodeAt(ye);
          if (Ee(Ie))
            return ye < he - 1 && Ie === 13 && g.charCodeAt(ye + 1) === 10 ? ye + 2 : ye + 1;
        }
        return -1;
      }
      var ft = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Le = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, $e = Object.prototype, ce = $e.hasOwnProperty, ut = $e.toString, ze = Object.hasOwn || function(g, U) {
        return ce.call(g, U);
      }, pt = Array.isArray || function(g) {
        return ut.call(g) === "[object Array]";
      }, qt = /* @__PURE__ */ Object.create(null);
      function We(g) {
        return qt[g] || (qt[g] = new RegExp("^(?:" + g.replace(/ /g, "|") + ")$"));
      }
      function Et(g) {
        return g <= 65535 ? String.fromCharCode(g) : (g -= 65536, String.fromCharCode((g >> 10) + 55296, (g & 1023) + 56320));
      }
      var rt = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, it = function(U, he) {
        this.line = U, this.column = he;
      };
      it.prototype.offset = function(U) {
        return new it(this.line, this.column + U);
      };
      var Zt = function(U, he, ye) {
        this.start = he, this.end = ye, U.sourceFile !== null && (this.source = U.sourceFile);
      };
      function $t(g, U) {
        for (var he = 1, ye = 0; ; ) {
          var Ie = He(g, ye, U);
          if (Ie < 0)
            return new it(he, U - ye);
          ++he, ye = Ie;
        }
      }
      var Lt = {
        // `ecmaVersion` indicates the ECMAScript version to parse. Must be
        // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
        // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
        // (the latest version the library supports). This influences
        // support for strict mode, the set of reserved words, and support
        // for new syntax features.
        ecmaVersion: null,
        // `sourceType` indicates the mode the code should be parsed in.
        // Can be either `"script"`, `"module"` or `"commonjs"`. This influences global
        // strict mode and parsing of `import` and `export` declarations.
        sourceType: "script",
        // When set to true, enable strict parsing mode even if `sourceType`
        // is `"script"`.
        strict: !1,
        // `onInsertedSemicolon` can be a callback that will be called when
        // a semicolon is automatically inserted. It will be passed the
        // position of the inserted semicolon as an offset, and if
        // `locations` is enabled, it is given the location as a `{line,
        // column}` object as second argument.
        onInsertedSemicolon: null,
        // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
        // trailing commas.
        onTrailingComma: null,
        // By default, reserved words are only enforced if ecmaVersion >= 5.
        // Set `allowReserved` to a boolean value to explicitly turn this on
        // an off. When this option has the value "never", reserved words
        // and keywords can also not be used as property names.
        allowReserved: null,
        // When enabled, a return at the top level is not considered an
        // error.
        allowReturnOutsideFunction: !1,
        // When enabled, import/export statements are not constrained to
        // appearing at the top of the program, and an import.meta expression
        // in a script isn't considered an error.
        allowImportExportEverywhere: !1,
        // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
        // When enabled, await identifiers are allowed to appear at the top-level scope,
        // but they are still not allowed in non-async functions.
        allowAwaitOutsideFunction: null,
        // When enabled, super identifiers are not constrained to
        // appearing in methods and do not raise an error when they appear elsewhere.
        allowSuperOutsideMethod: null,
        // When enabled, hashbang directive in the beginning of file is
        // allowed and treated as a line comment. Enabled by default when
        // `ecmaVersion` >= 2023.
        allowHashBang: !1,
        // By default, the parser will verify that private properties are
        // only used in places where they are valid and have been declared.
        // Set this to false to turn such checks off.
        checkPrivateFields: !0,
        // When `locations` is on, `loc` properties holding objects with
        // `start` and `end` properties in `{line, column}` form (with
        // line being 1-based and column 0-based) will be attached to the
        // nodes.
        locations: !1,
        // A function can be passed as `onToken` option, which will
        // cause Acorn to call that function with object in the same
        // format as tokens returned from `tokenizer().getToken()`. Note
        // that you are not allowed to call the parser from the
        // callback—that will corrupt its internal state.
        onToken: null,
        // A function can be passed as `onComment` option, which will
        // cause Acorn to call that function with `(block, text, start,
        // end)` parameters whenever a comment is skipped. `block` is a
        // boolean indicating whether this is a block (`/* */`) comment,
        // `text` is the content of the comment, and `start` and `end` are
        // character offsets that denote the start and end of the comment.
        // When the `locations` option is on, two more parameters are
        // passed, the full `{line, column}` locations of the start and
        // end of the comments. Note that you are not allowed to call the
        // parser from the callback—that will corrupt its internal state.
        // When this option has an array as value, objects representing the
        // comments are pushed to it.
        onComment: null,
        // Nodes have their start and end characters offsets recorded in
        // `start` and `end` properties (directly on the node, rather than
        // the `loc` object, which holds line/column data. To also add a
        // [semi-standardized][range] `range` property holding a `[start,
        // end]` array with the same numbers, set the `ranges` option to
        // `true`.
        //
        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
        ranges: !1,
        // It is possible to parse multiple files into a single AST by
        // passing the tree produced by parsing the first file as
        // `program` option in subsequent parses. This will add the
        // toplevel forms of the parsed file to the `Program` (top) node
        // of an existing parse tree.
        program: null,
        // When `locations` is on, you can pass this to record the source
        // file in every node's `loc` object.
        sourceFile: null,
        // This value, if given, is stored in every node, whether
        // `locations` is on or off.
        directSourceFile: null,
        // When enabled, parenthesized expressions are represented by
        // (non-standard) ParenthesizedExpression nodes
        preserveParens: !1
      }, ii = !1;
      function Ci(g) {
        var U = {};
        for (var he in Lt)
          U[he] = g && ze(g, he) ? g[he] : Lt[he];
        if (U.ecmaVersion === "latest" ? U.ecmaVersion = 1e8 : U.ecmaVersion == null ? (!ii && typeof console == "object" && console.warn && (ii = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), U.ecmaVersion = 11) : U.ecmaVersion >= 2015 && (U.ecmaVersion -= 2009), U.allowReserved == null && (U.allowReserved = U.ecmaVersion < 5), (!g || g.allowHashBang == null) && (U.allowHashBang = U.ecmaVersion >= 14), pt(U.onToken)) {
          var ye = U.onToken;
          U.onToken = function(Ie) {
            return ye.push(Ie);
          };
        }
        if (pt(U.onComment) && (U.onComment = ui(U, U.onComment)), U.sourceType === "commonjs" && U.allowAwaitOutsideFunction)
          throw new Error("Cannot use allowAwaitOutsideFunction with sourceType: commonjs");
        return U;
      }
      function ui(g, U) {
        return function(he, ye, Ie, ot, dt, zt) {
          var Kt = {
            type: he ? "Block" : "Line",
            value: ye,
            start: Ie,
            end: ot
          };
          g.locations && (Kt.loc = new Zt(this, dt, zt)), g.ranges && (Kt.range = [Ie, ot]), U.push(Kt);
        };
      }
      var Gt = 1, Xt = 2, Qt = 4, Ni = 8, Di = 16, pe = 32, xt = 64, tt = 128, Pe = 256, ke = 512, Je = 1024, kt = Gt | Xt | Pe;
      function vt(g, U) {
        return Xt | (g ? Qt : 0) | (U ? Ni : 0);
      }
      var Qe = 0, wt = 1, Yt = 2, Ye = 3, i = 4, r = 5, a = function(U, he, ye) {
        this.options = U = Ci(U), this.sourceFile = U.sourceFile, this.keywords = We(x[U.ecmaVersion >= 6 ? 6 : U.sourceType === "module" ? "5module" : 5]);
        var Ie = "";
        U.allowReserved !== !0 && (Ie = c[U.ecmaVersion >= 6 ? 6 : U.ecmaVersion === 5 ? 5 : 3], U.sourceType === "module" && (Ie += " await")), this.reservedWords = We(Ie);
        var ot = (Ie ? Ie + " " : "") + c.strict;
        this.reservedWordsStrict = We(ot), this.reservedWordsStrictBind = We(ot + " " + c.strictBind), this.input = String(he), this.containsEsc = !1, ye ? (this.pos = ye, this.lineStart = this.input.lastIndexOf(`
`, ye - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(W).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = X.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = U.sourceType === "module", this.strict = this.inModule || U.strict === !0 || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && U.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(
          this.options.sourceType === "commonjs" ? Xt : Gt
        ), this.regexpState = null, this.privateNameStack = [];
      }, l = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowReturn: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, allowUsing: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
      a.prototype.parse = function() {
        var U = this, he = this.options.program || this.startNode();
        return this.nextToken(), this.catchStackOverflow(function() {
          return U.parseTopLevel(he);
        });
      }, l.inFunction.get = function() {
        return (this.currentVarScope().flags & Xt) > 0;
      }, l.inGenerator.get = function() {
        return (this.currentVarScope().flags & Ni) > 0;
      }, l.inAsync.get = function() {
        return (this.currentVarScope().flags & Qt) > 0;
      }, l.canAwait.get = function() {
        for (var g = this.scopeStack.length - 1; g >= 0; g--) {
          var U = this.scopeStack[g], he = U.flags;
          if (he & (Pe | ke))
            return !1;
          if (he & Xt)
            return (he & Qt) > 0;
        }
        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
      }, l.allowReturn.get = function() {
        return !!(this.inFunction || this.options.allowReturnOutsideFunction && this.currentVarScope().flags & Gt);
      }, l.allowSuper.get = function() {
        var g = this.currentThisScope(), U = g.flags;
        return (U & xt) > 0 || this.options.allowSuperOutsideMethod;
      }, l.allowDirectSuper.get = function() {
        return (this.currentThisScope().flags & tt) > 0;
      }, l.treatFunctionsAsVar.get = function() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
      }, l.allowNewDotTarget.get = function() {
        for (var g = this.scopeStack.length - 1; g >= 0; g--) {
          var U = this.scopeStack[g], he = U.flags;
          if (he & (Pe | ke) || he & Xt && !(he & Di))
            return !0;
        }
        return !1;
      }, l.allowUsing.get = function() {
        var g = this.currentScope(), U = g.flags;
        return !(U & Je || !this.inModule && U & Gt);
      }, l.inClassStaticBlock.get = function() {
        return (this.currentVarScope().flags & Pe) > 0;
      }, a.extend = function() {
        for (var U = [], he = arguments.length; he--; )
          U[he] = arguments[he];
        for (var ye = this, Ie = 0; Ie < U.length; Ie++)
          ye = U[Ie](ye);
        return ye;
      }, a.parse = function(U, he) {
        return new this(he, U).parse();
      }, a.parseExpressionAt = function(U, he, ye) {
        var Ie = new this(ye, U, he);
        return Ie.nextToken(), Ie.parseExpression();
      }, a.tokenizer = function(U, he) {
        return new this(he, U);
      }, Object.defineProperties(a.prototype, l);
      var u = a.prototype, d = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
      u.strictDirective = function(g) {
        if (this.options.ecmaVersion < 5)
          return !1;
        for (; ; ) {
          Le.lastIndex = g, g += Le.exec(this.input)[0].length;
          var U = d.exec(this.input.slice(g));
          if (!U)
            return !1;
          if ((U[1] || U[2]) === "use strict") {
            Le.lastIndex = g + U[0].length;
            var he = Le.exec(this.input), ye = he.index + he[0].length, Ie = this.input.charAt(ye);
            return Ie === ";" || Ie === "}" || W.test(he[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(Ie) || Ie === "!" && this.input.charAt(ye + 1) === "=");
          }
          g += U[0].length, Le.lastIndex = g, g += Le.exec(this.input)[0].length, this.input[g] === ";" && g++;
        }
      }, u.eat = function(g) {
        return this.type === g ? (this.next(), !0) : !1;
      }, u.isContextual = function(g) {
        return this.type === X.name && this.value === g && !this.containsEsc;
      }, u.eatContextual = function(g) {
        return this.isContextual(g) ? (this.next(), !0) : !1;
      }, u.catchStackOverflow = function(g) {
        try {
          return g();
        } catch (U) {
          if (U instanceof Error && (/\bstack\b.*\b(exceeded|overflow)\b/i.test(U.message) || /\btoo much recursion\b/i.test(U.message)))
            this.raise(this.start, "Not enough stack space to parse input");
          else
            throw U;
        }
      }, u.expectContextual = function(g) {
        this.eatContextual(g) || this.unexpected();
      }, u.canInsertSemicolon = function() {
        return this.type === X.eof || this.type === X.braceR || W.test(this.input.slice(this.lastTokEnd, this.start));
      }, u.insertSemicolon = function() {
        if (this.canInsertSemicolon())
          return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
      }, u.semicolon = function() {
        !this.eat(X.semi) && !this.insertSemicolon() && this.unexpected();
      }, u.afterTrailingComma = function(g, U) {
        if (this.type === g)
          return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), U || this.next(), !0;
      }, u.expect = function(g) {
        this.eat(g) || this.unexpected();
      }, u.unexpected = function(g) {
        this.raise(g ?? this.start, "Unexpected token");
      };
      var v = function() {
        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
      };
      u.checkPatternErrors = function(g, U) {
        if (g) {
          g.trailingComma > -1 && this.raiseRecoverable(g.trailingComma, "Comma is not permitted after the rest element");
          var he = U ? g.parenthesizedAssign : g.parenthesizedBind;
          he > -1 && this.raiseRecoverable(he, U ? "Assigning to rvalue" : "Parenthesized pattern");
        }
      }, u.checkExpressionErrors = function(g, U) {
        if (!g)
          return !1;
        var he = g.shorthandAssign, ye = g.doubleProto;
        if (!U)
          return he >= 0 || ye >= 0;
        he >= 0 && this.raise(he, "Shorthand property assignments are valid only in destructuring patterns"), ye >= 0 && this.raiseRecoverable(ye, "Redefinition of __proto__ property");
      }, u.checkYieldAwaitInDefaultParams = function() {
        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
      }, u.isSimpleAssignTarget = function(g) {
        return g.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(g.expression) : g.type === "Identifier" || g.type === "MemberExpression";
      };
      var p = a.prototype;
      p.parseTopLevel = function(g) {
        var U = /* @__PURE__ */ Object.create(null);
        for (g.body || (g.body = []); this.type !== X.eof; ) {
          var he = this.parseStatement(null, !0, U);
          g.body.push(he);
        }
        if (this.inModule)
          for (var ye = 0, Ie = Object.keys(this.undefinedExports); ye < Ie.length; ye += 1) {
            var ot = Ie[ye];
            this.raiseRecoverable(this.undefinedExports[ot].start, "Export '" + ot + "' is not defined");
          }
        return this.adaptDirectivePrologue(g.body), this.next(), g.sourceType = this.options.sourceType === "commonjs" ? "script" : this.options.sourceType, this.finishNode(g, "Program");
      };
      var b = { kind: "loop" }, S = { kind: "switch" };
      p.isLet = function(g) {
        if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
          return !1;
        Le.lastIndex = this.pos;
        var U = Le.exec(this.input), he = this.pos + U[0].length, ye = this.fullCharCodeAt(he);
        if (ye === 91 || ye === 92)
          return !0;
        if (g)
          return !1;
        if (ye === 123)
          return !0;
        if (Z(ye)) {
          var Ie = he;
          do
            he += ye <= 65535 ? 1 : 2;
          while (V(ye = this.fullCharCodeAt(he)));
          if (ye === 92)
            return !0;
          var ot = this.input.slice(Ie, he);
          if (!B.test(ot))
            return !0;
        }
        return !1;
      }, p.isAsyncFunction = function() {
        if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
          return !1;
        Le.lastIndex = this.pos;
        var g = Le.exec(this.input), U = this.pos + g[0].length, he;
        return !W.test(this.input.slice(this.pos, U)) && this.input.slice(U, U + 8) === "function" && (U + 8 === this.input.length || !(V(he = this.fullCharCodeAt(U + 8)) || he === 92));
      }, p.isUsingKeyword = function(g, U) {
        if (this.options.ecmaVersion < 17 || !this.isContextual(g ? "await" : "using"))
          return !1;
        Le.lastIndex = this.pos;
        var he = Le.exec(this.input), ye = this.pos + he[0].length;
        if (W.test(this.input.slice(this.pos, ye)))
          return !1;
        if (g) {
          var Ie = ye + 5, ot;
          if (this.input.slice(ye, Ie) !== "using" || Ie === this.input.length || V(ot = this.fullCharCodeAt(Ie)) || ot === 92)
            return !1;
          Le.lastIndex = Ie;
          var dt = Le.exec(this.input);
          if (ye = Ie + dt[0].length, dt && W.test(this.input.slice(Ie, ye)))
            return !1;
        }
        var zt = this.fullCharCodeAt(ye);
        if (!Z(zt) && zt !== 92)
          return !1;
        var Kt = ye;
        do
          ye += zt <= 65535 ? 1 : 2;
        while (V(zt = this.fullCharCodeAt(ye)));
        if (zt === 92)
          return !0;
        var fi = this.input.slice(Kt, ye);
        if (B.test(fi))
          return !1;
        if (U && !g && fi === "of") {
          Le.lastIndex = ye;
          var ti = Le.exec(this.input);
          if (ye = ye + ti[0].length, this.input.charCodeAt(ye) !== 61 || // Check for ==, === and => operators
          (zt = this.input.charCodeAt(ye + 1)) === 61 || zt === 62)
            return !1;
        }
        return !0;
      }, p.isAwaitUsing = function(g) {
        return this.isUsingKeyword(!0, g);
      }, p.isUsing = function(g) {
        return this.isUsingKeyword(!1, g);
      }, p.parseStatement = function(g, U, he) {
        var ye = this.type, Ie = this.startNode(), ot;
        switch (this.isLet(g) && (ye = X._var, ot = "let"), ye) {
          case X._break:
          case X._continue:
            return this.parseBreakContinueStatement(Ie, ye.keyword);
          case X._debugger:
            return this.parseDebuggerStatement(Ie);
          case X._do:
            return this.parseDoStatement(Ie);
          case X._for:
            return this.parseForStatement(Ie);
          case X._function:
            return g && (this.strict || g !== "if" && g !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(Ie, !1, !g);
          case X._class:
            return g && this.unexpected(), this.parseClass(Ie, !0);
          case X._if:
            return this.parseIfStatement(Ie);
          case X._return:
            return this.parseReturnStatement(Ie);
          case X._switch:
            return this.parseSwitchStatement(Ie);
          case X._throw:
            return this.parseThrowStatement(Ie);
          case X._try:
            return this.parseTryStatement(Ie);
          case X._const:
          case X._var:
            return ot = ot || this.value, g && ot !== "var" && this.unexpected(), this.parseVarStatement(Ie, ot);
          case X._while:
            return this.parseWhileStatement(Ie);
          case X._with:
            return this.parseWithStatement(Ie);
          case X.braceL:
            return this.parseBlock(!0, Ie);
          case X.semi:
            return this.parseEmptyStatement(Ie);
          case X._export:
          case X._import:
            if (this.options.ecmaVersion > 10 && ye === X._import) {
              Le.lastIndex = this.pos;
              var dt = Le.exec(this.input), zt = this.pos + dt[0].length, Kt = this.input.charCodeAt(zt);
              if (Kt === 40 || Kt === 46)
                return this.parseExpressionStatement(Ie, this.parseExpression());
            }
            return this.options.allowImportExportEverywhere || (U || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), ye === X._import ? this.parseImport(Ie) : this.parseExport(Ie, he);
          default:
            if (this.isAsyncFunction())
              return g && this.unexpected(), this.next(), this.parseFunctionStatement(Ie, !0, !g);
            var fi = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
            if (fi)
              return this.allowUsing || this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script` or in the bare case statement"), g && this.raise(this.start, "Using declaration is not allowed in single-statement positions"), fi === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(Ie, !1, fi), this.semicolon(), this.finishNode(Ie, "VariableDeclaration");
            var ti = this.value, hi = this.parseExpression();
            return ye === X.name && hi.type === "Identifier" && this.eat(X.colon) ? this.parseLabeledStatement(Ie, ti, hi, g) : this.parseExpressionStatement(Ie, hi);
        }
      }, p.parseBreakContinueStatement = function(g, U) {
        var he = U === "break";
        this.next(), this.eat(X.semi) || this.insertSemicolon() ? g.label = null : this.type !== X.name ? this.unexpected() : (g.label = this.parseIdent(), this.semicolon());
        for (var ye = 0; ye < this.labels.length; ++ye) {
          var Ie = this.labels[ye];
          if ((g.label == null || Ie.name === g.label.name) && (Ie.kind != null && (he || Ie.kind === "loop") || g.label && he))
            break;
        }
        return ye === this.labels.length && this.raise(g.start, "Unsyntactic " + U), this.finishNode(g, he ? "BreakStatement" : "ContinueStatement");
      }, p.parseDebuggerStatement = function(g) {
        return this.next(), this.semicolon(), this.finishNode(g, "DebuggerStatement");
      }, p.parseDoStatement = function(g) {
        return this.next(), this.labels.push(b), g.body = this.parseStatement("do"), this.labels.pop(), this.expect(X._while), g.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(X.semi) : this.semicolon(), this.finishNode(g, "DoWhileStatement");
      }, p.parseForStatement = function(g) {
        this.next();
        var U = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
        if (this.labels.push(b), this.enterScope(0), this.expect(X.parenL), this.type === X.semi)
          return U > -1 && this.unexpected(U), this.parseFor(g, null);
        var he = this.isLet();
        if (this.type === X._var || this.type === X._const || he) {
          var ye = this.startNode(), Ie = he ? "let" : this.value;
          return this.next(), this.parseVar(ye, !0, Ie), this.finishNode(ye, "VariableDeclaration"), this.parseForAfterInit(g, ye, U);
        }
        var ot = this.isContextual("let"), dt = !1, zt = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
        if (zt) {
          var Kt = this.startNode();
          return this.next(), zt === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.parseVar(Kt, !0, zt), this.finishNode(Kt, "VariableDeclaration"), this.parseForAfterInit(g, Kt, U);
        }
        var fi = this.containsEsc, ti = new v(), hi = this.start, vn = U > -1 ? this.parseExprSubscripts(ti, "await") : this.parseExpression(!0, ti);
        return this.type === X._in || (dt = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (U > -1 ? (this.type === X._in && this.unexpected(U), g.await = !0) : dt && this.options.ecmaVersion >= 8 && (vn.start === hi && !fi && vn.type === "Identifier" && vn.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (g.await = !1)), ot && dt && this.raise(vn.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(vn, !1, ti), this.checkLValPattern(vn), this.parseForIn(g, vn)) : (this.checkExpressionErrors(ti, !0), U > -1 && this.unexpected(U), this.parseFor(g, vn));
      }, p.parseForAfterInit = function(g, U, he) {
        return (this.type === X._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && U.declarations.length === 1 ? (this.type === X._in ? ((U.kind === "using" || U.kind === "await using") && !U.declarations[0].init && this.raise(this.start, "Using declaration is not allowed in for-in loops"), this.options.ecmaVersion >= 9 && he > -1 && this.unexpected(he)) : this.options.ecmaVersion >= 9 && (g.await = he > -1), this.parseForIn(g, U)) : (he > -1 && this.unexpected(he), this.parseFor(g, U));
      }, p.parseFunctionStatement = function(g, U, he) {
        return this.next(), this.parseFunction(g, E | (he ? 0 : A), !1, U);
      }, p.parseIfStatement = function(g) {
        return this.next(), g.test = this.parseParenExpression(), g.consequent = this.parseStatement("if"), g.alternate = this.eat(X._else) ? this.parseStatement("if") : null, this.finishNode(g, "IfStatement");
      }, p.parseReturnStatement = function(g) {
        return this.allowReturn || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(X.semi) || this.insertSemicolon() ? g.argument = null : (g.argument = this.parseExpression(), this.semicolon()), this.finishNode(g, "ReturnStatement");
      }, p.parseSwitchStatement = function(g) {
        this.next(), g.discriminant = this.parseParenExpression(), g.cases = [], this.expect(X.braceL), this.labels.push(S), this.enterScope(Je);
        for (var U, he = !1; this.type !== X.braceR; )
          if (this.type === X._case || this.type === X._default) {
            var ye = this.type === X._case;
            U && this.finishNode(U, "SwitchCase"), g.cases.push(U = this.startNode()), U.consequent = [], this.next(), ye ? U.test = this.parseExpression() : (he && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), he = !0, U.test = null), this.expect(X.colon);
          } else
            U || this.unexpected(), U.consequent.push(this.parseStatement(null));
        return this.exitScope(), U && this.finishNode(U, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(g, "SwitchStatement");
      }, p.parseThrowStatement = function(g) {
        return this.next(), W.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), g.argument = this.parseExpression(), this.semicolon(), this.finishNode(g, "ThrowStatement");
      };
      var L = [];
      p.parseCatchClauseParam = function() {
        var g = this.parseBindingAtom(), U = g.type === "Identifier";
        return this.enterScope(U ? pe : 0), this.checkLValPattern(g, U ? i : Yt), this.expect(X.parenR), g;
      }, p.parseTryStatement = function(g) {
        if (this.next(), g.block = this.parseBlock(), g.handler = null, this.type === X._catch) {
          var U = this.startNode();
          this.next(), this.eat(X.parenL) ? U.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), U.param = null, this.enterScope(0)), U.body = this.parseBlock(!1), this.exitScope(), g.handler = this.finishNode(U, "CatchClause");
        }
        return g.finalizer = this.eat(X._finally) ? this.parseBlock() : null, !g.handler && !g.finalizer && this.raise(g.start, "Missing catch or finally clause"), this.finishNode(g, "TryStatement");
      }, p.parseVarStatement = function(g, U, he) {
        return this.next(), this.parseVar(g, !1, U, he), this.semicolon(), this.finishNode(g, "VariableDeclaration");
      }, p.parseWhileStatement = function(g) {
        return this.next(), g.test = this.parseParenExpression(), this.labels.push(b), g.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(g, "WhileStatement");
      }, p.parseWithStatement = function(g) {
        return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), g.object = this.parseParenExpression(), g.body = this.parseStatement("with"), this.finishNode(g, "WithStatement");
      }, p.parseEmptyStatement = function(g) {
        return this.next(), this.finishNode(g, "EmptyStatement");
      }, p.parseLabeledStatement = function(g, U, he, ye) {
        for (var Ie = 0, ot = this.labels; Ie < ot.length; Ie += 1) {
          var dt = ot[Ie];
          dt.name === U && this.raise(he.start, "Label '" + U + "' is already declared");
        }
        for (var zt = this.type.isLoop ? "loop" : this.type === X._switch ? "switch" : null, Kt = this.labels.length - 1; Kt >= 0; Kt--) {
          var fi = this.labels[Kt];
          if (fi.statementStart === g.start)
            fi.statementStart = this.start, fi.kind = zt;
          else
            break;
        }
        return this.labels.push({ name: U, kind: zt, statementStart: this.start }), g.body = this.parseStatement(ye ? ye.indexOf("label") === -1 ? ye + "label" : ye : "label"), this.labels.pop(), g.label = he, this.finishNode(g, "LabeledStatement");
      }, p.parseExpressionStatement = function(g, U) {
        return g.expression = U, this.semicolon(), this.finishNode(g, "ExpressionStatement");
      }, p.parseBlock = function(g, U, he) {
        for (g === void 0 && (g = !0), U === void 0 && (U = this.startNode()), U.body = [], this.expect(X.braceL), g && this.enterScope(0); this.type !== X.braceR; ) {
          var ye = this.parseStatement(null);
          U.body.push(ye);
        }
        return he && (this.strict = !1), this.next(), g && this.exitScope(), this.finishNode(U, "BlockStatement");
      }, p.parseFor = function(g, U) {
        return g.init = U, this.expect(X.semi), g.test = this.type === X.semi ? null : this.parseExpression(), this.expect(X.semi), g.update = this.type === X.parenR ? null : this.parseExpression(), this.expect(X.parenR), g.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(g, "ForStatement");
      }, p.parseForIn = function(g, U) {
        var he = this.type === X._in;
        return this.next(), U.type === "VariableDeclaration" && U.declarations[0].init != null && (!he || this.options.ecmaVersion < 8 || this.strict || U.kind !== "var" || U.declarations[0].id.type !== "Identifier") && this.raise(
          U.start,
          (he ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
        ), g.left = U, g.right = he ? this.parseExpression() : this.parseMaybeAssign(), this.expect(X.parenR), g.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(g, he ? "ForInStatement" : "ForOfStatement");
      }, p.parseVar = function(g, U, he, ye) {
        for (g.declarations = [], g.kind = he; ; ) {
          var Ie = this.startNode();
          if (this.parseVarId(Ie, he), this.eat(X.eq) ? Ie.init = this.parseMaybeAssign(U) : !ye && he === "const" && !(this.type === X._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !ye && (he === "using" || he === "await using") && this.options.ecmaVersion >= 17 && this.type !== X._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + he + " declaration") : !ye && Ie.id.type !== "Identifier" && !(U && (this.type === X._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : Ie.init = null, g.declarations.push(this.finishNode(Ie, "VariableDeclarator")), !this.eat(X.comma))
            break;
        }
        return g;
      }, p.parseVarId = function(g, U) {
        g.id = U === "using" || U === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(g.id, U === "var" ? wt : Yt, !1);
      };
      var E = 1, A = 2, T = 4;
      p.parseFunction = function(g, U, he, ye, Ie) {
        this.initFunction(g), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !ye) && (this.type === X.star && U & A && this.unexpected(), g.generator = this.eat(X.star)), this.options.ecmaVersion >= 8 && (g.async = !!ye), U & E && (g.id = U & T && this.type !== X.name ? null : this.parseIdent(), g.id && !(U & A) && this.checkLValSimple(g.id, this.strict || g.generator || g.async ? this.treatFunctionsAsVar ? wt : Yt : Ye));
        var ot = this.yieldPos, dt = this.awaitPos, zt = this.awaitIdentPos;
        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(vt(g.async, g.generator)), U & E || (g.id = this.type === X.name ? this.parseIdent() : null), this.parseFunctionParams(g), this.parseFunctionBody(g, he, !1, Ie), this.yieldPos = ot, this.awaitPos = dt, this.awaitIdentPos = zt, this.finishNode(g, U & E ? "FunctionDeclaration" : "FunctionExpression");
      }, p.parseFunctionParams = function(g) {
        this.expect(X.parenL), g.params = this.parseBindingList(X.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
      }, p.parseClass = function(g, U) {
        this.next();
        var he = this.strict;
        this.strict = !0, this.parseClassId(g, U), this.parseClassSuper(g);
        var ye = this.enterClassBody(), Ie = this.startNode(), ot = !1;
        for (Ie.body = [], this.expect(X.braceL); this.type !== X.braceR; ) {
          var dt = this.parseClassElement(g.superClass !== null);
          dt && (Ie.body.push(dt), dt.type === "MethodDefinition" && dt.kind === "constructor" ? (ot && this.raiseRecoverable(dt.start, "Duplicate constructor in the same class"), ot = !0) : dt.key && dt.key.type === "PrivateIdentifier" && G(ye, dt) && this.raiseRecoverable(dt.key.start, "Identifier '#" + dt.key.name + "' has already been declared"));
        }
        return this.strict = he, this.next(), g.body = this.finishNode(Ie, "ClassBody"), this.exitClassBody(), this.finishNode(g, U ? "ClassDeclaration" : "ClassExpression");
      }, p.parseClassElement = function(g) {
        if (this.eat(X.semi))
          return null;
        var U = this.options.ecmaVersion, he = this.startNode(), ye = "", Ie = !1, ot = !1, dt = "method", zt = !1;
        if (this.eatContextual("static")) {
          if (U >= 13 && this.eat(X.braceL))
            return this.parseClassStaticBlock(he), he;
          this.isClassElementNameStart() || this.type === X.star ? zt = !0 : ye = "static";
        }
        if (he.static = zt, !ye && U >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === X.star) && !this.canInsertSemicolon() ? ot = !0 : ye = "async"), !ye && (U >= 9 || !ot) && this.eat(X.star) && (Ie = !0), !ye && !ot && !Ie) {
          var Kt = this.value;
          (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? dt = Kt : ye = Kt);
        }
        if (ye ? (he.computed = !1, he.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), he.key.name = ye, this.finishNode(he.key, "Identifier")) : this.parseClassElementName(he), U < 13 || this.type === X.parenL || dt !== "method" || Ie || ot) {
          var fi = !he.static && D(he, "constructor"), ti = fi && g;
          fi && dt !== "method" && this.raise(he.key.start, "Constructor can't have get/set modifier"), he.kind = fi ? "constructor" : dt, this.parseClassMethod(he, Ie, ot, ti);
        } else
          this.parseClassField(he);
        return he;
      }, p.isClassElementNameStart = function() {
        return this.type === X.name || this.type === X.privateId || this.type === X.num || this.type === X.string || this.type === X.bracketL || this.type.keyword;
      }, p.parseClassElementName = function(g) {
        this.type === X.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), g.computed = !1, g.key = this.parsePrivateIdent()) : this.parsePropertyName(g);
      }, p.parseClassMethod = function(g, U, he, ye) {
        var Ie = g.key;
        g.kind === "constructor" ? (U && this.raise(Ie.start, "Constructor can't be a generator"), he && this.raise(Ie.start, "Constructor can't be an async method")) : g.static && D(g, "prototype") && this.raise(Ie.start, "Classes may not have a static property named prototype");
        var ot = g.value = this.parseMethod(U, he, ye);
        return g.kind === "get" && ot.params.length !== 0 && this.raiseRecoverable(ot.start, "getter should have no params"), g.kind === "set" && ot.params.length !== 1 && this.raiseRecoverable(ot.start, "setter should have exactly one param"), g.kind === "set" && ot.params[0].type === "RestElement" && this.raiseRecoverable(ot.params[0].start, "Setter cannot use rest params"), this.finishNode(g, "MethodDefinition");
      }, p.parseClassField = function(g) {
        return D(g, "constructor") ? this.raise(g.key.start, "Classes can't have a field named 'constructor'") : g.static && D(g, "prototype") && this.raise(g.key.start, "Classes can't have a static field named 'prototype'"), this.eat(X.eq) ? (this.enterScope(ke | xt), g.value = this.parseMaybeAssign(), this.exitScope()) : g.value = null, this.semicolon(), this.finishNode(g, "PropertyDefinition");
      }, p.parseClassStaticBlock = function(g) {
        g.body = [];
        var U = this.labels;
        for (this.labels = [], this.enterScope(Pe | xt); this.type !== X.braceR; ) {
          var he = this.parseStatement(null);
          g.body.push(he);
        }
        return this.next(), this.exitScope(), this.labels = U, this.finishNode(g, "StaticBlock");
      }, p.parseClassId = function(g, U) {
        this.type === X.name ? (g.id = this.parseIdent(), U && this.checkLValSimple(g.id, Yt, !1)) : (U === !0 && this.unexpected(), g.id = null);
      }, p.parseClassSuper = function(g) {
        g.superClass = this.eat(X._extends) ? this.parseExprSubscripts(null, !1) : null;
      }, p.enterClassBody = function() {
        var g = { declared: /* @__PURE__ */ Object.create(null), used: [] };
        return this.privateNameStack.push(g), g.declared;
      }, p.exitClassBody = function() {
        var g = this.privateNameStack.pop(), U = g.declared, he = g.used;
        if (this.options.checkPrivateFields)
          for (var ye = this.privateNameStack.length, Ie = ye === 0 ? null : this.privateNameStack[ye - 1], ot = 0; ot < he.length; ++ot) {
            var dt = he[ot];
            ze(U, dt.name) || (Ie ? Ie.used.push(dt) : this.raiseRecoverable(dt.start, "Private field '#" + dt.name + "' must be declared in an enclosing class"));
          }
      };
      function G(g, U) {
        var he = U.key.name, ye = g[he], Ie = "true";
        return U.type === "MethodDefinition" && (U.kind === "get" || U.kind === "set") && (Ie = (U.static ? "s" : "i") + U.kind), ye === "iget" && Ie === "iset" || ye === "iset" && Ie === "iget" || ye === "sget" && Ie === "sset" || ye === "sset" && Ie === "sget" ? (g[he] = "true", !1) : ye ? !0 : (g[he] = Ie, !1);
      }
      function D(g, U) {
        var he = g.computed, ye = g.key;
        return !he && (ye.type === "Identifier" && ye.name === U || ye.type === "Literal" && ye.value === U);
      }
      p.parseExportAllDeclaration = function(g, U) {
        return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (g.exported = this.parseModuleExportName(), this.checkExport(U, g.exported, this.lastTokStart)) : g.exported = null), this.expectContextual("from"), this.type !== X.string && this.unexpected(), g.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(g, "ExportAllDeclaration");
      }, p.parseExport = function(g, U) {
        if (this.next(), this.eat(X.star))
          return this.parseExportAllDeclaration(g, U);
        if (this.eat(X._default))
          return this.checkExport(U, "default", this.lastTokStart), g.declaration = this.parseExportDefaultDeclaration(), this.finishNode(g, "ExportDefaultDeclaration");
        if (this.shouldParseExportStatement())
          g.declaration = this.parseExportDeclaration(g), g.declaration.type === "VariableDeclaration" ? this.checkVariableExport(U, g.declaration.declarations) : this.checkExport(U, g.declaration.id, g.declaration.id.start), g.specifiers = [], g.source = null, this.options.ecmaVersion >= 16 && (g.attributes = []);
        else {
          if (g.declaration = null, g.specifiers = this.parseExportSpecifiers(U), this.eatContextual("from"))
            this.type !== X.string && this.unexpected(), g.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause());
          else {
            for (var he = 0, ye = g.specifiers; he < ye.length; he += 1) {
              var Ie = ye[he];
              this.checkUnreserved(Ie.local), this.checkLocalExport(Ie.local), Ie.local.type === "Literal" && this.raise(Ie.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            g.source = null, this.options.ecmaVersion >= 16 && (g.attributes = []);
          }
          this.semicolon();
        }
        return this.finishNode(g, "ExportNamedDeclaration");
      }, p.parseExportDeclaration = function(g) {
        return this.parseStatement(null);
      }, p.parseExportDefaultDeclaration = function() {
        var g;
        if (this.type === X._function || (g = this.isAsyncFunction())) {
          var U = this.startNode();
          return this.next(), g && this.next(), this.parseFunction(U, E | T, !1, g);
        } else if (this.type === X._class) {
          var he = this.startNode();
          return this.parseClass(he, "nullableID");
        } else {
          var ye = this.parseMaybeAssign();
          return this.semicolon(), ye;
        }
      }, p.checkExport = function(g, U, he) {
        g && (typeof U != "string" && (U = U.type === "Identifier" ? U.name : U.value), ze(g, U) && this.raiseRecoverable(he, "Duplicate export '" + U + "'"), g[U] = !0);
      }, p.checkPatternExport = function(g, U) {
        var he = U.type;
        if (he === "Identifier")
          this.checkExport(g, U, U.start);
        else if (he === "ObjectPattern")
          for (var ye = 0, Ie = U.properties; ye < Ie.length; ye += 1) {
            var ot = Ie[ye];
            this.checkPatternExport(g, ot);
          }
        else if (he === "ArrayPattern")
          for (var dt = 0, zt = U.elements; dt < zt.length; dt += 1) {
            var Kt = zt[dt];
            Kt && this.checkPatternExport(g, Kt);
          }
        else
          he === "Property" ? this.checkPatternExport(g, U.value) : he === "AssignmentPattern" ? this.checkPatternExport(g, U.left) : he === "RestElement" && this.checkPatternExport(g, U.argument);
      }, p.checkVariableExport = function(g, U) {
        if (g)
          for (var he = 0, ye = U; he < ye.length; he += 1) {
            var Ie = ye[he];
            this.checkPatternExport(g, Ie.id);
          }
      }, p.shouldParseExportStatement = function() {
        return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
      }, p.parseExportSpecifier = function(g) {
        var U = this.startNode();
        return U.local = this.parseModuleExportName(), U.exported = this.eatContextual("as") ? this.parseModuleExportName() : U.local, this.checkExport(
          g,
          U.exported,
          U.exported.start
        ), this.finishNode(U, "ExportSpecifier");
      }, p.parseExportSpecifiers = function(g) {
        var U = [], he = !0;
        for (this.expect(X.braceL); !this.eat(X.braceR); ) {
          if (he)
            he = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          U.push(this.parseExportSpecifier(g));
        }
        return U;
      }, p.parseImport = function(g) {
        return this.next(), this.type === X.string ? (g.specifiers = L, g.source = this.parseExprAtom()) : (g.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), g.source = this.type === X.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(g, "ImportDeclaration");
      }, p.parseImportSpecifier = function() {
        var g = this.startNode();
        return g.imported = this.parseModuleExportName(), this.eatContextual("as") ? g.local = this.parseIdent() : (this.checkUnreserved(g.imported), g.local = g.imported), this.checkLValSimple(g.local, Yt), this.finishNode(g, "ImportSpecifier");
      }, p.parseImportDefaultSpecifier = function() {
        var g = this.startNode();
        return g.local = this.parseIdent(), this.checkLValSimple(g.local, Yt), this.finishNode(g, "ImportDefaultSpecifier");
      }, p.parseImportNamespaceSpecifier = function() {
        var g = this.startNode();
        return this.next(), this.expectContextual("as"), g.local = this.parseIdent(), this.checkLValSimple(g.local, Yt), this.finishNode(g, "ImportNamespaceSpecifier");
      }, p.parseImportSpecifiers = function() {
        var g = [], U = !0;
        if (this.type === X.name && (g.push(this.parseImportDefaultSpecifier()), !this.eat(X.comma)))
          return g;
        if (this.type === X.star)
          return g.push(this.parseImportNamespaceSpecifier()), g;
        for (this.expect(X.braceL); !this.eat(X.braceR); ) {
          if (U)
            U = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          g.push(this.parseImportSpecifier());
        }
        return g;
      }, p.parseWithClause = function() {
        var g = [];
        if (!this.eat(X._with))
          return g;
        this.expect(X.braceL);
        for (var U = {}, he = !0; !this.eat(X.braceR); ) {
          if (he)
            he = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          var ye = this.parseImportAttribute(), Ie = ye.key.type === "Identifier" ? ye.key.name : ye.key.value;
          ze(U, Ie) && this.raiseRecoverable(ye.key.start, "Duplicate attribute key '" + Ie + "'"), U[Ie] = !0, g.push(ye);
        }
        return g;
      }, p.parseImportAttribute = function() {
        var g = this.startNode();
        return g.key = this.type === X.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(X.colon), this.type !== X.string && this.unexpected(), g.value = this.parseExprAtom(), this.finishNode(g, "ImportAttribute");
      }, p.parseModuleExportName = function() {
        if (this.options.ecmaVersion >= 13 && this.type === X.string) {
          var g = this.parseLiteral(this.value);
          return rt.test(g.value) && this.raise(g.start, "An export name cannot include a lone surrogate."), g;
        }
        return this.parseIdent(!0);
      }, p.adaptDirectivePrologue = function(g) {
        for (var U = 0; U < g.length && this.isDirectiveCandidate(g[U]); ++U)
          g[U].directive = g[U].expression.raw.slice(1, -1);
      }, p.isDirectiveCandidate = function(g) {
        return this.options.ecmaVersion >= 5 && g.type === "ExpressionStatement" && g.expression.type === "Literal" && typeof g.expression.value == "string" && // Reject parenthesized strings.
        (this.input[g.start] === '"' || this.input[g.start] === "'");
      };
      var Y = a.prototype;
      Y.toAssignable = function(g, U, he) {
        if (this.options.ecmaVersion >= 6 && g)
          switch (g.type) {
            case "Identifier":
              this.inAsync && g.name === "await" && this.raise(g.start, "Cannot use 'await' as identifier inside an async function");
              break;
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              g.type = "ObjectPattern", he && this.checkPatternErrors(he, !0);
              for (var ye = 0, Ie = g.properties; ye < Ie.length; ye += 1) {
                var ot = Ie[ye];
                this.toAssignable(ot, U), ot.type === "RestElement" && (ot.argument.type === "ArrayPattern" || ot.argument.type === "ObjectPattern") && this.raise(ot.argument.start, "Unexpected token");
              }
              break;
            case "Property":
              g.kind !== "init" && this.raise(g.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(g.value, U);
              break;
            case "ArrayExpression":
              g.type = "ArrayPattern", he && this.checkPatternErrors(he, !0), this.toAssignableList(g.elements, U);
              break;
            case "SpreadElement":
              g.type = "RestElement", this.toAssignable(g.argument, U), g.argument.type === "AssignmentPattern" && this.raise(g.argument.start, "Rest elements cannot have a default value");
              break;
            case "AssignmentExpression":
              g.operator !== "=" && this.raise(g.left.end, "Only '=' operator can be used for specifying default value."), g.type = "AssignmentPattern", delete g.operator, this.toAssignable(g.left, U);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(g.expression, U, he);
              break;
            case "ChainExpression":
              this.raiseRecoverable(g.start, "Optional chaining cannot appear in left-hand side");
              break;
            case "MemberExpression":
              if (!U)
                break;
            default:
              this.raise(g.start, "Assigning to rvalue");
          }
        else
          he && this.checkPatternErrors(he, !0);
        return g;
      }, Y.toAssignableList = function(g, U) {
        for (var he = g.length, ye = 0; ye < he; ye++) {
          var Ie = g[ye];
          Ie && this.toAssignable(Ie, U);
        }
        if (he) {
          var ot = g[he - 1];
          this.options.ecmaVersion === 6 && U && ot && ot.type === "RestElement" && ot.argument.type !== "Identifier" && this.unexpected(ot.argument.start);
        }
        return g;
      }, Y.parseSpread = function(g) {
        var U = this.startNode();
        return this.next(), U.argument = this.parseMaybeAssign(!1, g), this.finishNode(U, "SpreadElement");
      }, Y.parseRestBinding = function() {
        var g = this.startNode();
        return this.next(), this.options.ecmaVersion === 6 && this.type !== X.name && this.unexpected(), g.argument = this.parseBindingAtom(), this.finishNode(g, "RestElement");
      }, Y.parseBindingAtom = function() {
        if (this.options.ecmaVersion >= 6)
          switch (this.type) {
            case X.bracketL:
              var g = this.startNode();
              return this.next(), g.elements = this.parseBindingList(X.bracketR, !0, !0), this.finishNode(g, "ArrayPattern");
            case X.braceL:
              return this.parseObj(!0);
          }
        return this.parseIdent();
      }, Y.parseBindingList = function(g, U, he, ye) {
        for (var Ie = [], ot = !0; !this.eat(g); )
          if (ot ? ot = !1 : this.expect(X.comma), U && this.type === X.comma)
            Ie.push(null);
          else {
            if (he && this.afterTrailingComma(g))
              break;
            if (this.type === X.ellipsis) {
              var dt = this.parseRestBinding();
              this.parseBindingListItem(dt), Ie.push(dt), this.type === X.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(g);
              break;
            } else
              Ie.push(this.parseAssignableListItem(ye));
          }
        return Ie;
      }, Y.parseAssignableListItem = function(g) {
        var U = this.parseMaybeDefault(this.start, this.startLoc);
        return this.parseBindingListItem(U), U;
      }, Y.parseBindingListItem = function(g) {
        return g;
      }, Y.parseMaybeDefault = function(g, U, he) {
        if (he = he || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(X.eq))
          return he;
        var ye = this.startNodeAt(g, U);
        return ye.left = he, ye.right = this.parseMaybeAssign(), this.finishNode(ye, "AssignmentPattern");
      }, Y.checkLValSimple = function(g, U, he) {
        U === void 0 && (U = Qe);
        var ye = U !== Qe;
        switch (g.type) {
          case "Identifier":
            this.strict && this.reservedWordsStrictBind.test(g.name) && this.raiseRecoverable(g.start, (ye ? "Binding " : "Assigning to ") + g.name + " in strict mode"), ye && (U === Yt && g.name === "let" && this.raiseRecoverable(g.start, "let is disallowed as a lexically bound name"), he && (ze(he, g.name) && this.raiseRecoverable(g.start, "Argument name clash"), he[g.name] = !0), U !== r && this.declareName(g.name, U, g.start));
            break;
          case "ChainExpression":
            this.raiseRecoverable(g.start, "Optional chaining cannot appear in left-hand side");
            break;
          case "MemberExpression":
            ye && this.raiseRecoverable(g.start, "Binding member expression");
            break;
          case "ParenthesizedExpression":
            return ye && this.raiseRecoverable(g.start, "Binding parenthesized expression"), this.checkLValSimple(g.expression, U, he);
          default:
            this.raise(g.start, (ye ? "Binding" : "Assigning to") + " rvalue");
        }
      }, Y.checkLValPattern = function(g, U, he) {
        switch (U === void 0 && (U = Qe), g.type) {
          case "ObjectPattern":
            for (var ye = 0, Ie = g.properties; ye < Ie.length; ye += 1) {
              var ot = Ie[ye];
              this.checkLValInnerPattern(ot, U, he);
            }
            break;
          case "ArrayPattern":
            for (var dt = 0, zt = g.elements; dt < zt.length; dt += 1) {
              var Kt = zt[dt];
              Kt && this.checkLValInnerPattern(Kt, U, he);
            }
            break;
          default:
            this.checkLValSimple(g, U, he);
        }
      }, Y.checkLValInnerPattern = function(g, U, he) {
        switch (U === void 0 && (U = Qe), g.type) {
          case "Property":
            this.checkLValInnerPattern(g.value, U, he);
            break;
          case "AssignmentPattern":
            this.checkLValPattern(g.left, U, he);
            break;
          case "RestElement":
            this.checkLValPattern(g.argument, U, he);
            break;
          default:
            this.checkLValPattern(g, U, he);
        }
      };
      var k = function(U, he, ye, Ie, ot) {
        this.token = U, this.isExpr = !!he, this.preserveSpace = !!ye, this.override = Ie, this.generator = !!ot;
      }, z = {
        b_stat: new k("{", !1),
        b_expr: new k("{", !0),
        b_tmpl: new k("${", !1),
        p_stat: new k("(", !1),
        p_expr: new k("(", !0),
        q_tmpl: new k("`", !0, !0, function(g) {
          return g.tryReadTemplateToken();
        }),
        f_stat: new k("function", !1),
        f_expr: new k("function", !0),
        f_expr_gen: new k("function", !0, !1, null, !0),
        f_gen: new k("function", !1, !1, null, !0)
      }, C = a.prototype;
      C.initialContext = function() {
        return [z.b_stat];
      }, C.curContext = function() {
        return this.context[this.context.length - 1];
      }, C.braceIsBlock = function(g) {
        var U = this.curContext();
        return U === z.f_expr || U === z.f_stat ? !0 : g === X.colon && (U === z.b_stat || U === z.b_expr) ? !U.isExpr : g === X._return || g === X.name && this.exprAllowed ? W.test(this.input.slice(this.lastTokEnd, this.start)) : g === X._else || g === X.semi || g === X.eof || g === X.parenR || g === X.arrow ? !0 : g === X.braceL ? U === z.b_stat : g === X._var || g === X._const || g === X.name ? !1 : !this.exprAllowed;
      }, C.inGeneratorContext = function() {
        for (var g = this.context.length - 1; g >= 1; g--) {
          var U = this.context[g];
          if (U.token === "function")
            return U.generator;
        }
        return !1;
      }, C.updateContext = function(g) {
        var U, he = this.type;
        he.keyword && g === X.dot ? this.exprAllowed = !1 : (U = he.updateContext) ? U.call(this, g) : this.exprAllowed = he.beforeExpr;
      }, C.overrideContext = function(g) {
        this.curContext() !== g && (this.context[this.context.length - 1] = g);
      }, X.parenR.updateContext = X.braceR.updateContext = function() {
        if (this.context.length === 1) {
          this.exprAllowed = !0;
          return;
        }
        var g = this.context.pop();
        g === z.b_stat && this.curContext().token === "function" && (g = this.context.pop()), this.exprAllowed = !g.isExpr;
      }, X.braceL.updateContext = function(g) {
        this.context.push(this.braceIsBlock(g) ? z.b_stat : z.b_expr), this.exprAllowed = !0;
      }, X.dollarBraceL.updateContext = function() {
        this.context.push(z.b_tmpl), this.exprAllowed = !0;
      }, X.parenL.updateContext = function(g) {
        var U = g === X._if || g === X._for || g === X._with || g === X._while;
        this.context.push(U ? z.p_stat : z.p_expr), this.exprAllowed = !0;
      }, X.incDec.updateContext = function() {
      }, X._function.updateContext = X._class.updateContext = function(g) {
        g.beforeExpr && g !== X._else && !(g === X.semi && this.curContext() !== z.p_stat) && !(g === X._return && W.test(this.input.slice(this.lastTokEnd, this.start))) && !((g === X.colon || g === X.braceL) && this.curContext() === z.b_stat) ? this.context.push(z.f_expr) : this.context.push(z.f_stat), this.exprAllowed = !1;
      }, X.colon.updateContext = function() {
        this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
      }, X.backQuote.updateContext = function() {
        this.curContext() === z.q_tmpl ? this.context.pop() : this.context.push(z.q_tmpl), this.exprAllowed = !1;
      }, X.star.updateContext = function(g) {
        if (g === X._function) {
          var U = this.context.length - 1;
          this.context[U] === z.f_expr ? this.context[U] = z.f_expr_gen : this.context[U] = z.f_gen;
        }
        this.exprAllowed = !0;
      }, X.name.updateContext = function(g) {
        var U = !1;
        this.options.ecmaVersion >= 6 && g !== X.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (U = !0), this.exprAllowed = U;
      };
      var O = a.prototype;
      O.checkPropClash = function(g, U, he) {
        if (!(this.options.ecmaVersion >= 9 && g.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (g.computed || g.method || g.shorthand))) {
          var ye = g.key, Ie;
          switch (ye.type) {
            case "Identifier":
              Ie = ye.name;
              break;
            case "Literal":
              Ie = String(ye.value);
              break;
            default:
              return;
          }
          var ot = g.kind;
          if (this.options.ecmaVersion >= 6) {
            Ie === "__proto__" && ot === "init" && (U.proto && (he ? he.doubleProto < 0 && (he.doubleProto = ye.start) : this.raiseRecoverable(ye.start, "Redefinition of __proto__ property")), U.proto = !0);
            return;
          }
          Ie = "$" + Ie;
          var dt = U[Ie];
          if (dt) {
            var zt;
            ot === "init" ? zt = this.strict && dt.init || dt.get || dt.set : zt = dt.init || dt[ot], zt && this.raiseRecoverable(ye.start, "Redefinition of property");
          } else
            dt = U[Ie] = {
              init: !1,
              get: !1,
              set: !1
            };
          dt[ot] = !0;
        }
      }, O.parseExpression = function(g, U) {
        var he = this;
        return this.catchStackOverflow(function() {
          var ye = he.start, Ie = he.startLoc, ot = he.parseMaybeAssign(g, U);
          if (he.type === X.comma) {
            var dt = he.startNodeAt(ye, Ie);
            for (dt.expressions = [ot]; he.eat(X.comma); )
              dt.expressions.push(he.parseMaybeAssign(g, U));
            return he.finishNode(dt, "SequenceExpression");
          }
          return ot;
        });
      }, O.parseMaybeAssign = function(g, U, he) {
        if (this.isContextual("yield")) {
          if (this.inGenerator)
            return this.parseYield(g);
          this.exprAllowed = !1;
        }
        var ye = !1, Ie = -1, ot = -1, dt = -1;
        U ? (Ie = U.parenthesizedAssign, ot = U.trailingComma, dt = U.doubleProto, U.parenthesizedAssign = U.trailingComma = -1) : (U = new v(), ye = !0);
        var zt = this.start, Kt = this.startLoc;
        (this.type === X.parenL || this.type === X.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = g === "await");
        var fi = this.parseMaybeConditional(g, U);
        if (he && (fi = he.call(this, fi, zt, Kt)), this.type.isAssign) {
          var ti = this.startNodeAt(zt, Kt);
          return ti.operator = this.value, this.type === X.eq && (fi = this.toAssignable(fi, !1, U)), ye || (U.parenthesizedAssign = U.trailingComma = U.doubleProto = -1), U.shorthandAssign >= fi.start && (U.shorthandAssign = -1), this.type === X.eq ? this.checkLValPattern(fi) : this.checkLValSimple(fi), ti.left = fi, this.next(), ti.right = this.parseMaybeAssign(g), dt > -1 && (U.doubleProto = dt), this.finishNode(ti, "AssignmentExpression");
        } else
          ye && this.checkExpressionErrors(U, !0);
        return Ie > -1 && (U.parenthesizedAssign = Ie), ot > -1 && (U.trailingComma = ot), fi;
      }, O.parseMaybeConditional = function(g, U) {
        var he = this.start, ye = this.startLoc, Ie = this.parseExprOps(g, U);
        if (this.checkExpressionErrors(U))
          return Ie;
        if (!(Ie.type === "ArrowFunctionExpression" && Ie.start === he) && this.eat(X.question)) {
          var ot = this.startNodeAt(he, ye);
          return ot.test = Ie, ot.consequent = this.parseMaybeAssign(), this.expect(X.colon), ot.alternate = this.parseMaybeAssign(g), this.finishNode(ot, "ConditionalExpression");
        }
        return Ie;
      }, O.parseExprOps = function(g, U) {
        var he = this.start, ye = this.startLoc, Ie = this.parseMaybeUnary(U, !1, !1, g);
        return this.checkExpressionErrors(U) || Ie.start === he && Ie.type === "ArrowFunctionExpression" ? Ie : this.parseExprOp(Ie, he, ye, -1, g);
      }, O.parseExprOp = function(g, U, he, ye, Ie) {
        var ot = this.type.binop;
        if (ot != null && (!Ie || this.type !== X._in) && ot > ye) {
          var dt = this.type === X.logicalOR || this.type === X.logicalAND, zt = this.type === X.coalesce;
          zt && (ot = X.logicalAND.binop);
          var Kt = this.value;
          this.next();
          var fi = this.start, ti = this.startLoc, hi = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, Ie), fi, ti, ot, Ie), vn = this.buildBinary(U, he, g, hi, Kt, dt || zt);
          return (dt && this.type === X.coalesce || zt && (this.type === X.logicalOR || this.type === X.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(vn, U, he, ye, Ie);
        }
        return g;
      }, O.buildBinary = function(g, U, he, ye, Ie, ot) {
        ye.type === "PrivateIdentifier" && this.raise(ye.start, "Private identifier can only be left side of binary expression");
        var dt = this.startNodeAt(g, U);
        return dt.left = he, dt.operator = Ie, dt.right = ye, this.finishNode(dt, ot ? "LogicalExpression" : "BinaryExpression");
      }, O.parseMaybeUnary = function(g, U, he, ye) {
        var Ie = this.start, ot = this.startLoc, dt;
        if (this.isContextual("await") && this.canAwait)
          dt = this.parseAwait(ye), U = !0;
        else if (this.type.prefix) {
          var zt = this.startNode(), Kt = this.type === X.incDec;
          zt.operator = this.value, zt.prefix = !0, this.next(), zt.argument = this.parseMaybeUnary(null, !0, Kt, ye), this.checkExpressionErrors(g, !0), Kt ? this.checkLValSimple(zt.argument) : this.strict && zt.operator === "delete" && j(zt.argument) ? this.raiseRecoverable(zt.start, "Deleting local variable in strict mode") : zt.operator === "delete" && q(zt.argument) ? this.raiseRecoverable(zt.start, "Private fields can not be deleted") : U = !0, dt = this.finishNode(zt, Kt ? "UpdateExpression" : "UnaryExpression");
        } else if (!U && this.type === X.privateId)
          (ye || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), dt = this.parsePrivateIdent(), this.type !== X._in && this.unexpected();
        else {
          if (dt = this.parseExprSubscripts(g, ye), this.checkExpressionErrors(g))
            return dt;
          for (; this.type.postfix && !this.canInsertSemicolon(); ) {
            var fi = this.startNodeAt(Ie, ot);
            fi.operator = this.value, fi.prefix = !1, fi.argument = dt, this.checkLValSimple(dt), this.next(), dt = this.finishNode(fi, "UpdateExpression");
          }
        }
        if (!he && this.eat(X.starstar))
          if (U)
            this.unexpected(this.lastTokStart);
          else
            return this.buildBinary(Ie, ot, dt, this.parseMaybeUnary(null, !1, !1, ye), "**", !1);
        else
          return dt;
      };
      function j(g) {
        return g.type === "Identifier" || g.type === "ParenthesizedExpression" && j(g.expression);
      }
      function q(g) {
        return g.type === "MemberExpression" && g.property.type === "PrivateIdentifier" || g.type === "ChainExpression" && q(g.expression) || g.type === "ParenthesizedExpression" && q(g.expression);
      }
      O.parseExprSubscripts = function(g, U) {
        var he = this.start, ye = this.startLoc, Ie = this.parseExprAtom(g, U);
        if (Ie.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
          return Ie;
        var ot = this.parseSubscripts(Ie, he, ye, !1, U);
        return g && ot.type === "MemberExpression" && (g.parenthesizedAssign >= ot.start && (g.parenthesizedAssign = -1), g.parenthesizedBind >= ot.start && (g.parenthesizedBind = -1), g.trailingComma >= ot.start && (g.trailingComma = -1)), ot;
      }, O.parseSubscripts = function(g, U, he, ye, Ie) {
        for (var ot = this.options.ecmaVersion >= 8 && g.type === "Identifier" && g.name === "async" && this.lastTokEnd === g.end && !this.canInsertSemicolon() && g.end - g.start === 5 && this.potentialArrowAt === g.start, dt = !1; ; ) {
          var zt = this.parseSubscript(g, U, he, ye, ot, dt, Ie);
          if (zt.optional && (dt = !0), zt === g || zt.type === "ArrowFunctionExpression") {
            if (dt) {
              var Kt = this.startNodeAt(U, he);
              Kt.expression = zt, zt = this.finishNode(Kt, "ChainExpression");
            }
            return zt;
          }
          g = zt;
        }
      }, O.shouldParseAsyncArrow = function() {
        return !this.canInsertSemicolon() && this.eat(X.arrow);
      }, O.parseSubscriptAsyncArrow = function(g, U, he, ye) {
        return this.parseArrowExpression(this.startNodeAt(g, U), he, !0, ye);
      }, O.parseSubscript = function(g, U, he, ye, Ie, ot, dt) {
        var zt = this.options.ecmaVersion >= 11, Kt = zt && this.eat(X.questionDot);
        ye && Kt && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
        var fi = this.eat(X.bracketL);
        if (fi || Kt && this.type !== X.parenL && this.type !== X.backQuote || this.eat(X.dot)) {
          var ti = this.startNodeAt(U, he);
          ti.object = g, fi ? (ti.property = this.parseExpression(), this.expect(X.bracketR)) : this.type === X.privateId && g.type !== "Super" ? ti.property = this.parsePrivateIdent() : ti.property = this.parseIdent(this.options.allowReserved !== "never"), ti.computed = !!fi, zt && (ti.optional = Kt), g = this.finishNode(ti, "MemberExpression");
        } else if (!ye && this.eat(X.parenL)) {
          var hi = new v(), vn = this.yieldPos, ar = this.awaitPos, Tn = this.awaitIdentPos;
          this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
          var Mr = this.parseExprList(X.parenR, this.options.ecmaVersion >= 8, !1, hi);
          if (Ie && !Kt && this.shouldParseAsyncArrow())
            return this.checkPatternErrors(hi, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = vn, this.awaitPos = ar, this.awaitIdentPos = Tn, this.parseSubscriptAsyncArrow(U, he, Mr, dt);
          this.checkExpressionErrors(hi, !0), this.yieldPos = vn || this.yieldPos, this.awaitPos = ar || this.awaitPos, this.awaitIdentPos = Tn || this.awaitIdentPos;
          var Cr = this.startNodeAt(U, he);
          Cr.callee = g, Cr.arguments = Mr, zt && (Cr.optional = Kt), g = this.finishNode(Cr, "CallExpression");
        } else if (this.type === X.backQuote) {
          (Kt || ot) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
          var or = this.startNodeAt(U, he);
          or.tag = g, or.quasi = this.parseTemplate({ isTagged: !0 }), g = this.finishNode(or, "TaggedTemplateExpression");
        }
        return g;
      }, O.parseExprAtom = function(g, U, he) {
        this.type === X.slash && this.readRegexp();
        var ye, Ie = this.potentialArrowAt === this.start;
        switch (this.type) {
          case X._super:
            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), ye = this.startNode(), this.next(), this.type === X.parenL && !this.allowDirectSuper && this.raise(ye.start, "super() call outside constructor of a subclass"), this.type !== X.dot && this.type !== X.bracketL && this.type !== X.parenL && this.unexpected(), this.finishNode(ye, "Super");
          case X._this:
            return ye = this.startNode(), this.next(), this.finishNode(ye, "ThisExpression");
          case X.name:
            var ot = this.start, dt = this.startLoc, zt = this.containsEsc, Kt = this.parseIdent(!1);
            if (this.options.ecmaVersion >= 8 && !zt && Kt.name === "async" && !this.canInsertSemicolon() && this.eat(X._function))
              return this.overrideContext(z.f_expr), this.parseFunction(this.startNodeAt(ot, dt), 0, !1, !0, U);
            if (Ie && !this.canInsertSemicolon()) {
              if (this.eat(X.arrow))
                return this.parseArrowExpression(this.startNodeAt(ot, dt), [Kt], !1, U);
              if (this.options.ecmaVersion >= 8 && Kt.name === "async" && this.type === X.name && !zt && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
                return Kt = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(X.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(ot, dt), [Kt], !0, U);
            }
            return Kt;
          case X.regexp:
            var fi = this.value;
            return ye = this.parseLiteral(fi.value), ye.regex = { pattern: fi.pattern, flags: fi.flags }, ye;
          case X.num:
          case X.string:
            return this.parseLiteral(this.value);
          case X._null:
          case X._true:
          case X._false:
            return ye = this.startNode(), ye.value = this.type === X._null ? null : this.type === X._true, ye.raw = this.type.keyword, this.next(), this.finishNode(ye, "Literal");
          case X.parenL:
            var ti = this.start, hi = this.parseParenAndDistinguishExpression(Ie, U);
            return g && (g.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(hi) && (g.parenthesizedAssign = ti), g.parenthesizedBind < 0 && (g.parenthesizedBind = ti)), hi;
          case X.bracketL:
            return ye = this.startNode(), this.next(), ye.elements = this.parseExprList(X.bracketR, !0, !0, g), this.finishNode(ye, "ArrayExpression");
          case X.braceL:
            return this.overrideContext(z.b_expr), this.parseObj(!1, g);
          case X._function:
            return ye = this.startNode(), this.next(), this.parseFunction(ye, 0);
          case X._class:
            return this.parseClass(this.startNode(), !1);
          case X._new:
            return this.parseNew();
          case X.backQuote:
            return this.parseTemplate();
          case X._import:
            return this.options.ecmaVersion >= 11 ? this.parseExprImport(he) : this.unexpected();
          default:
            return this.parseExprAtomDefault();
        }
      }, O.parseExprAtomDefault = function() {
        this.unexpected();
      }, O.parseExprImport = function(g) {
        var U = this.startNode();
        if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === X.parenL && !g)
          return this.parseDynamicImport(U);
        if (this.type === X.dot) {
          var he = this.startNodeAt(U.start, U.loc && U.loc.start);
          return he.name = "import", U.meta = this.finishNode(he, "Identifier"), this.parseImportMeta(U);
        } else
          this.unexpected();
      }, O.parseDynamicImport = function(g) {
        if (this.next(), g.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
          this.eat(X.parenR) ? g.options = null : (this.expect(X.comma), this.afterTrailingComma(X.parenR) ? g.options = null : (g.options = this.parseMaybeAssign(), this.eat(X.parenR) || (this.expect(X.comma), this.afterTrailingComma(X.parenR) || this.unexpected())));
        else if (!this.eat(X.parenR)) {
          var U = this.start;
          this.eat(X.comma) && this.eat(X.parenR) ? this.raiseRecoverable(U, "Trailing comma is not allowed in import()") : this.unexpected(U);
        }
        return this.finishNode(g, "ImportExpression");
      }, O.parseImportMeta = function(g) {
        this.next();
        var U = this.containsEsc;
        return g.property = this.parseIdent(!0), g.property.name !== "meta" && this.raiseRecoverable(g.property.start, "The only valid meta property for import is 'import.meta'"), U && this.raiseRecoverable(g.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(g.start, "Cannot use 'import.meta' outside a module"), this.finishNode(g, "MetaProperty");
      }, O.parseLiteral = function(g) {
        var U = this.startNode();
        return U.value = g, U.raw = this.input.slice(this.start, this.end), U.raw.charCodeAt(U.raw.length - 1) === 110 && (U.bigint = U.value != null ? U.value.toString() : U.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(U, "Literal");
      }, O.parseParenExpression = function() {
        this.expect(X.parenL);
        var g = this.parseExpression();
        return this.expect(X.parenR), g;
      }, O.shouldParseArrow = function(g) {
        return !this.canInsertSemicolon();
      }, O.parseParenAndDistinguishExpression = function(g, U) {
        var he = this.start, ye = this.startLoc, Ie, ot = this.options.ecmaVersion >= 8;
        if (this.options.ecmaVersion >= 6) {
          this.next();
          var dt = this.start, zt = this.startLoc, Kt = [], fi = !0, ti = !1, hi = new v(), vn = this.yieldPos, ar = this.awaitPos, Tn;
          for (this.yieldPos = 0, this.awaitPos = 0; this.type !== X.parenR; )
            if (fi ? fi = !1 : this.expect(X.comma), ot && this.afterTrailingComma(X.parenR, !0)) {
              ti = !0;
              break;
            } else if (this.type === X.ellipsis) {
              Tn = this.start, Kt.push(this.parseParenItem(this.parseRestBinding())), this.type === X.comma && this.raiseRecoverable(
                this.start,
                "Comma is not permitted after the rest element"
              );
              break;
            } else
              Kt.push(this.parseMaybeAssign(!1, hi, this.parseParenItem));
          var Mr = this.lastTokEnd, Cr = this.lastTokEndLoc;
          if (this.expect(X.parenR), g && this.shouldParseArrow(Kt) && this.eat(X.arrow))
            return this.checkPatternErrors(hi, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = vn, this.awaitPos = ar, this.parseParenArrowList(he, ye, Kt, U);
          (!Kt.length || ti) && this.unexpected(this.lastTokStart), Tn && this.unexpected(Tn), this.checkExpressionErrors(hi, !0), this.yieldPos = vn || this.yieldPos, this.awaitPos = ar || this.awaitPos, Kt.length > 1 ? (Ie = this.startNodeAt(dt, zt), Ie.expressions = Kt, this.finishNodeAt(Ie, "SequenceExpression", Mr, Cr)) : Ie = Kt[0];
        } else
          Ie = this.parseParenExpression();
        if (this.options.preserveParens) {
          var or = this.startNodeAt(he, ye);
          return or.expression = Ie, this.finishNode(or, "ParenthesizedExpression");
        } else
          return Ie;
      }, O.parseParenItem = function(g) {
        return g;
      }, O.parseParenArrowList = function(g, U, he, ye) {
        return this.parseArrowExpression(this.startNodeAt(g, U), he, !1, ye);
      };
      var H = [];
      O.parseNew = function() {
        this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
        var g = this.startNode();
        if (this.next(), this.options.ecmaVersion >= 6 && this.type === X.dot) {
          var U = this.startNodeAt(g.start, g.loc && g.loc.start);
          U.name = "new", g.meta = this.finishNode(U, "Identifier"), this.next();
          var he = this.containsEsc;
          return g.property = this.parseIdent(!0), g.property.name !== "target" && this.raiseRecoverable(g.property.start, "The only valid meta property for new is 'new.target'"), he && this.raiseRecoverable(g.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(g.start, "'new.target' can only be used in functions and class static block"), this.finishNode(g, "MetaProperty");
        }
        var ye = this.start, Ie = this.startLoc;
        return g.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), ye, Ie, !0, !1), g.callee.type === "Super" && this.raiseRecoverable(ye, "Invalid use of 'super'"), this.eat(X.parenL) ? g.arguments = this.parseExprList(X.parenR, this.options.ecmaVersion >= 8, !1) : g.arguments = H, this.finishNode(g, "NewExpression");
      }, O.parseTemplateElement = function(g) {
        var U = g.isTagged, he = this.startNode();
        return this.type === X.invalidTemplate ? (U || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), he.value = {
          raw: this.value.replace(/\r\n?/g, `
`),
          cooked: null
        }) : he.value = {
          raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
          cooked: this.value
        }, this.next(), he.tail = this.type === X.backQuote, this.finishNode(he, "TemplateElement");
      }, O.parseTemplate = function(g) {
        g === void 0 && (g = {});
        var U = g.isTagged;
        U === void 0 && (U = !1);
        var he = this.startNode();
        this.next(), he.expressions = [];
        var ye = this.parseTemplateElement({ isTagged: U });
        for (he.quasis = [ye]; !ye.tail; )
          this.type === X.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(X.dollarBraceL), he.expressions.push(this.parseExpression()), this.expect(X.braceR), he.quasis.push(ye = this.parseTemplateElement({ isTagged: U }));
        return this.next(), this.finishNode(he, "TemplateLiteral");
      }, O.isAsyncProp = function(g) {
        return !g.computed && g.key.type === "Identifier" && g.key.name === "async" && (this.type === X.name || this.type === X.num || this.type === X.string || this.type === X.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === X.star) && !W.test(this.input.slice(this.lastTokEnd, this.start));
      }, O.parseObj = function(g, U) {
        var he = this.startNode(), ye = !0, Ie = {};
        for (he.properties = [], this.next(); !this.eat(X.braceR); ) {
          if (ye)
            ye = !1;
          else if (this.expect(X.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(X.braceR))
            break;
          var ot = this.parseProperty(g, U);
          g || this.checkPropClash(ot, Ie, U), he.properties.push(ot);
        }
        return this.finishNode(he, g ? "ObjectPattern" : "ObjectExpression");
      }, O.parseProperty = function(g, U) {
        var he = this.startNode(), ye, Ie, ot, dt;
        if (this.options.ecmaVersion >= 9 && this.eat(X.ellipsis))
          return g ? (he.argument = this.parseIdent(!1), this.type === X.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(he, "RestElement")) : (he.argument = this.parseMaybeAssign(!1, U), this.type === X.comma && U && U.trailingComma < 0 && (U.trailingComma = this.start), this.finishNode(he, "SpreadElement"));
        this.options.ecmaVersion >= 6 && (he.method = !1, he.shorthand = !1, (g || U) && (ot = this.start, dt = this.startLoc), g || (ye = this.eat(X.star)));
        var zt = this.containsEsc;
        return this.parsePropertyName(he), !g && !zt && this.options.ecmaVersion >= 8 && !ye && this.isAsyncProp(he) ? (Ie = !0, ye = this.options.ecmaVersion >= 9 && this.eat(X.star), this.parsePropertyName(he)) : Ie = !1, this.parsePropertyValue(he, g, ye, Ie, ot, dt, U, zt), this.finishNode(he, "Property");
      }, O.parseGetterSetter = function(g) {
        var U = g.key.name;
        this.parsePropertyName(g), g.value = this.parseMethod(!1), g.kind = U;
        var he = g.kind === "get" ? 0 : 1;
        if (g.value.params.length !== he) {
          var ye = g.value.start;
          g.kind === "get" ? this.raiseRecoverable(ye, "getter should have no params") : this.raiseRecoverable(ye, "setter should have exactly one param");
        } else
          g.kind === "set" && g.value.params[0].type === "RestElement" && this.raiseRecoverable(g.value.params[0].start, "Setter cannot use rest params");
      }, O.parsePropertyValue = function(g, U, he, ye, Ie, ot, dt, zt) {
        (he || ye) && this.type === X.colon && this.unexpected(), this.eat(X.colon) ? (g.value = U ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, dt), g.kind = "init") : this.options.ecmaVersion >= 6 && this.type === X.parenL ? (U && this.unexpected(), g.method = !0, g.value = this.parseMethod(he, ye), g.kind = "init") : !U && !zt && this.options.ecmaVersion >= 5 && !g.computed && g.key.type === "Identifier" && (g.key.name === "get" || g.key.name === "set") && this.type !== X.comma && this.type !== X.braceR && this.type !== X.eq ? ((he || ye) && this.unexpected(), this.parseGetterSetter(g)) : this.options.ecmaVersion >= 6 && !g.computed && g.key.type === "Identifier" ? ((he || ye) && this.unexpected(), this.checkUnreserved(g.key), g.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = Ie), U ? g.value = this.parseMaybeDefault(Ie, ot, this.copyNode(g.key)) : this.type === X.eq && dt ? (dt.shorthandAssign < 0 && (dt.shorthandAssign = this.start), g.value = this.parseMaybeDefault(Ie, ot, this.copyNode(g.key))) : g.value = this.copyNode(g.key), g.kind = "init", g.shorthand = !0) : this.unexpected();
      }, O.parsePropertyName = function(g) {
        if (this.options.ecmaVersion >= 6) {
          if (this.eat(X.bracketL))
            return g.computed = !0, g.key = this.parseMaybeAssign(), this.expect(X.bracketR), g.key;
          g.computed = !1;
        }
        return g.key = this.type === X.num || this.type === X.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
      }, O.initFunction = function(g) {
        g.id = null, this.options.ecmaVersion >= 6 && (g.generator = g.expression = !1), this.options.ecmaVersion >= 8 && (g.async = !1);
      }, O.parseMethod = function(g, U, he) {
        var ye = this.startNode(), Ie = this.yieldPos, ot = this.awaitPos, dt = this.awaitIdentPos;
        return this.initFunction(ye), this.options.ecmaVersion >= 6 && (ye.generator = g), this.options.ecmaVersion >= 8 && (ye.async = !!U), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(vt(U, ye.generator) | xt | (he ? tt : 0)), this.expect(X.parenL), ye.params = this.parseBindingList(X.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(ye, !1, !0, !1), this.yieldPos = Ie, this.awaitPos = ot, this.awaitIdentPos = dt, this.finishNode(ye, "FunctionExpression");
      }, O.parseArrowExpression = function(g, U, he, ye) {
        var Ie = this.yieldPos, ot = this.awaitPos, dt = this.awaitIdentPos;
        return this.enterScope(vt(he, !1) | Di), this.initFunction(g), this.options.ecmaVersion >= 8 && (g.async = !!he), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, g.params = this.toAssignableList(U, !0), this.parseFunctionBody(g, !0, !1, ye), this.yieldPos = Ie, this.awaitPos = ot, this.awaitIdentPos = dt, this.finishNode(g, "ArrowFunctionExpression");
      }, O.parseFunctionBody = function(g, U, he, ye) {
        var Ie = U && this.type !== X.braceL, ot = this.strict, dt = !1;
        if (Ie)
          g.body = this.parseMaybeAssign(ye), g.expression = !0, this.checkParams(g, !1);
        else {
          var zt = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(g.params);
          (!ot || zt) && (dt = this.strictDirective(this.end), dt && zt && this.raiseRecoverable(g.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
          var Kt = this.labels;
          this.labels = [], dt && (this.strict = !0), this.checkParams(g, !ot && !dt && !U && !he && this.isSimpleParamList(g.params)), this.strict && g.id && this.checkLValSimple(g.id, r), g.body = this.parseBlock(!1, void 0, dt && !ot), g.expression = !1, this.adaptDirectivePrologue(g.body.body), this.labels = Kt;
        }
        this.exitScope();
      }, O.isSimpleParamList = function(g) {
        for (var U = 0, he = g; U < he.length; U += 1) {
          var ye = he[U];
          if (ye.type !== "Identifier")
            return !1;
        }
        return !0;
      }, O.checkParams = function(g, U) {
        for (var he = /* @__PURE__ */ Object.create(null), ye = 0, Ie = g.params; ye < Ie.length; ye += 1) {
          var ot = Ie[ye];
          this.checkLValInnerPattern(ot, wt, U ? null : he);
        }
      }, O.parseExprList = function(g, U, he, ye) {
        for (var Ie = [], ot = !0; !this.eat(g); ) {
          if (ot)
            ot = !1;
          else if (this.expect(X.comma), U && this.afterTrailingComma(g))
            break;
          var dt = void 0;
          he && this.type === X.comma ? dt = null : this.type === X.ellipsis ? (dt = this.parseSpread(ye), ye && this.type === X.comma && ye.trailingComma < 0 && (ye.trailingComma = this.start)) : dt = this.parseMaybeAssign(!1, ye), Ie.push(dt);
        }
        return Ie;
      }, O.checkUnreserved = function(g) {
        var U = g.start, he = g.end, ye = g.name;
        if (this.inGenerator && ye === "yield" && this.raiseRecoverable(U, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && ye === "await" && this.raiseRecoverable(U, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & kt) && ye === "arguments" && this.raiseRecoverable(U, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (ye === "arguments" || ye === "await") && this.raise(U, "Cannot use " + ye + " in class static initialization block"), this.keywords.test(ye) && this.raise(U, "Unexpected keyword '" + ye + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(U, he).indexOf("\\") !== -1)) {
          var Ie = this.strict ? this.reservedWordsStrict : this.reservedWords;
          Ie.test(ye) && (!this.inAsync && ye === "await" && this.raiseRecoverable(U, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(U, "The keyword '" + ye + "' is reserved"));
        }
      }, O.parseIdent = function(g) {
        var U = this.parseIdentNode();
        return this.next(!!g), this.finishNode(U, "Identifier"), g || (this.checkUnreserved(U), U.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = U.start)), U;
      }, O.parseIdentNode = function() {
        var g = this.startNode();
        return this.type === X.name ? g.name = this.value : this.type.keyword ? (g.name = this.type.keyword, (g.name === "class" || g.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = X.name) : this.unexpected(), g;
      }, O.parsePrivateIdent = function() {
        var g = this.startNode();
        return this.type === X.privateId ? g.name = this.value : this.unexpected(), this.next(), this.finishNode(g, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(g.start, "Private field '#" + g.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(g)), g;
      }, O.parseYield = function(g) {
        this.yieldPos || (this.yieldPos = this.start);
        var U = this.startNode();
        return this.next(), this.type === X.semi || this.canInsertSemicolon() || this.type !== X.star && !this.type.startsExpr ? (U.delegate = !1, U.argument = null) : (U.delegate = this.eat(X.star), U.argument = this.parseMaybeAssign(g)), this.finishNode(U, "YieldExpression");
      }, O.parseAwait = function(g) {
        this.awaitPos || (this.awaitPos = this.start);
        var U = this.startNode();
        return this.next(), U.argument = this.parseMaybeUnary(null, !0, !1, g), this.finishNode(U, "AwaitExpression");
      };
      var ie = a.prototype;
      ie.raise = function(g, U) {
        var he = $t(this.input, g);
        U += " (" + he.line + ":" + he.column + ")", this.sourceFile && (U += " in " + this.sourceFile);
        var ye = new SyntaxError(U);
        throw ye.pos = g, ye.loc = he, ye.raisedAt = this.pos, ye;
      }, ie.raiseRecoverable = ie.raise, ie.curPosition = function() {
        if (this.options.locations)
          return new it(this.curLine, this.pos - this.lineStart);
      };
      var ae = a.prototype, ue = function(U) {
        this.flags = U, this.var = [], this.lexical = [], this.functions = [];
      };
      ae.enterScope = function(g) {
        this.scopeStack.push(new ue(g));
      }, ae.exitScope = function() {
        this.scopeStack.pop();
      }, ae.treatFunctionsAsVarInScope = function(g) {
        return g.flags & Xt || !this.inModule && g.flags & Gt;
      }, ae.declareName = function(g, U, he) {
        var ye = !1;
        if (U === Yt) {
          var Ie = this.currentScope();
          ye = Ie.lexical.indexOf(g) > -1 || Ie.functions.indexOf(g) > -1 || Ie.var.indexOf(g) > -1, Ie.lexical.push(g), this.inModule && Ie.flags & Gt && delete this.undefinedExports[g];
        } else if (U === i) {
          var ot = this.currentScope();
          ot.lexical.push(g);
        } else if (U === Ye) {
          var dt = this.currentScope();
          this.treatFunctionsAsVar ? ye = dt.lexical.indexOf(g) > -1 : ye = dt.lexical.indexOf(g) > -1 || dt.var.indexOf(g) > -1, dt.functions.push(g);
        } else
          for (var zt = this.scopeStack.length - 1; zt >= 0; --zt) {
            var Kt = this.scopeStack[zt];
            if (Kt.lexical.indexOf(g) > -1 && !(Kt.flags & pe && Kt.lexical[0] === g) || !this.treatFunctionsAsVarInScope(Kt) && Kt.functions.indexOf(g) > -1) {
              ye = !0;
              break;
            }
            if (Kt.var.push(g), this.inModule && Kt.flags & Gt && delete this.undefinedExports[g], Kt.flags & kt)
              break;
          }
        ye && this.raiseRecoverable(he, "Identifier '" + g + "' has already been declared");
      }, ae.checkLocalExport = function(g) {
        this.scopeStack[0].lexical.indexOf(g.name) === -1 && this.scopeStack[0].var.indexOf(g.name) === -1 && (this.undefinedExports[g.name] = g);
      }, ae.currentScope = function() {
        return this.scopeStack[this.scopeStack.length - 1];
      }, ae.currentVarScope = function() {
        for (var g = this.scopeStack.length - 1; ; g--) {
          var U = this.scopeStack[g];
          if (U.flags & (kt | ke | Pe))
            return U;
        }
      }, ae.currentThisScope = function() {
        for (var g = this.scopeStack.length - 1; ; g--) {
          var U = this.scopeStack[g];
          if (U.flags & (kt | ke | Pe) && !(U.flags & Di))
            return U;
        }
      };
      var me = function(U, he, ye) {
        this.type = "", this.start = he, this.end = 0, U.options.locations && (this.loc = new Zt(U, ye)), U.options.directSourceFile && (this.sourceFile = U.options.directSourceFile), U.options.ranges && (this.range = [he, 0]);
      }, se = a.prototype;
      se.startNode = function() {
        return new me(this, this.start, this.startLoc);
      }, se.startNodeAt = function(g, U) {
        return new me(this, g, U);
      };
      function de(g, U, he, ye) {
        return g.type = U, g.end = he, this.options.locations && (g.loc.end = ye), this.options.ranges && (g.range[1] = he), g;
      }
      se.finishNode = function(g, U) {
        return de.call(this, g, U, this.lastTokEnd, this.lastTokEndLoc);
      }, se.finishNodeAt = function(g, U, he, ye) {
        return de.call(this, g, U, he, ye);
      }, se.copyNode = function(g) {
        var U = new me(this, g.start, this.startLoc);
        for (var he in g)
          U[he] = g[he];
        return U;
      };
      var ve = "Berf Beria_Erfe Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sidetic Sidt Sunu Sunuwar Tai_Yo Tayo Todhri Todr Tolong_Siki Tols Tulu_Tigalari Tutg Unknown Zzzz", we = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Se = we + " Extended_Pictographic", Ae = Se, Ge = Ae + " EBase EComp EMod EPres ExtPict", et = Ge, st = et, _t = {
        9: we,
        10: Se,
        11: Ae,
        12: Ge,
        13: et,
        14: st
      }, Re = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", Fe = {
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: Re
      }, at = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", yt = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", bt = yt + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", Rt = bt + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", It = Rt + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", Ht = It + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", jt = Ht + " " + ve, Vt = {
        9: yt,
        10: bt,
        11: Rt,
        12: It,
        13: Ht,
        14: jt
      }, Ti = {};
      function ki(g) {
        var U = Ti[g] = {
          binary: We(_t[g] + " " + at),
          binaryOfStrings: We(Fe[g]),
          nonBinary: {
            General_Category: We(at),
            Script: We(Vt[g])
          }
        };
        U.nonBinary.Script_Extensions = U.nonBinary.Script, U.nonBinary.gc = U.nonBinary.General_Category, U.nonBinary.sc = U.nonBinary.Script, U.nonBinary.scx = U.nonBinary.Script_Extensions;
      }
      for (var Li = 0, bi = [9, 10, 11, 12, 13, 14]; Li < bi.length; Li += 1) {
        var si = bi[Li];
        ki(si);
      }
      var Nt = a.prototype, Vi = function(U, he) {
        this.parent = U, this.base = he || this;
      };
      Vi.prototype.separatedFrom = function(U) {
        for (var he = this; he; he = he.parent)
          for (var ye = U; ye; ye = ye.parent)
            if (he.base === ye.base && he !== ye)
              return !0;
        return !1;
      }, Vi.prototype.sibling = function() {
        return new Vi(this.parent, this.base);
      };
      var ci = function(U) {
        this.parser = U, this.validFlags = "gim" + (U.options.ecmaVersion >= 6 ? "uy" : "") + (U.options.ecmaVersion >= 9 ? "s" : "") + (U.options.ecmaVersion >= 13 ? "d" : "") + (U.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Ti[U.options.ecmaVersion >= 14 ? 14 : U.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
      };
      ci.prototype.reset = function(U, he, ye) {
        var Ie = ye.indexOf("v") !== -1, ot = ye.indexOf("u") !== -1;
        this.start = U | 0, this.source = he + "", this.flags = ye, Ie && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = ot && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = ot && this.parser.options.ecmaVersion >= 9);
      }, ci.prototype.raise = function(U) {
        this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + U);
      }, ci.prototype.at = function(U, he) {
        he === void 0 && (he = !1);
        var ye = this.source, Ie = ye.length;
        if (U >= Ie)
          return -1;
        var ot = ye.charCodeAt(U);
        if (!(he || this.switchU) || ot <= 55295 || ot >= 57344 || U + 1 >= Ie)
          return ot;
        var dt = ye.charCodeAt(U + 1);
        return dt >= 56320 && dt <= 57343 ? (ot << 10) + dt - 56613888 : ot;
      }, ci.prototype.nextIndex = function(U, he) {
        he === void 0 && (he = !1);
        var ye = this.source, Ie = ye.length;
        if (U >= Ie)
          return Ie;
        var ot = ye.charCodeAt(U), dt;
        return !(he || this.switchU) || ot <= 55295 || ot >= 57344 || U + 1 >= Ie || (dt = ye.charCodeAt(U + 1)) < 56320 || dt > 57343 ? U + 1 : U + 2;
      }, ci.prototype.current = function(U) {
        return U === void 0 && (U = !1), this.at(this.pos, U);
      }, ci.prototype.lookahead = function(U) {
        return U === void 0 && (U = !1), this.at(this.nextIndex(this.pos, U), U);
      }, ci.prototype.advance = function(U) {
        U === void 0 && (U = !1), this.pos = this.nextIndex(this.pos, U);
      }, ci.prototype.eat = function(U, he) {
        return he === void 0 && (he = !1), this.current(he) === U ? (this.advance(he), !0) : !1;
      }, ci.prototype.eatChars = function(U, he) {
        he === void 0 && (he = !1);
        for (var ye = this.pos, Ie = 0, ot = U; Ie < ot.length; Ie += 1) {
          var dt = ot[Ie], zt = this.at(ye, he);
          if (zt === -1 || zt !== dt)
            return !1;
          ye = this.nextIndex(ye, he);
        }
        return this.pos = ye, !0;
      }, Nt.validateRegExpFlags = function(g) {
        for (var U = g.validFlags, he = g.flags, ye = !1, Ie = !1, ot = 0; ot < he.length; ot++) {
          var dt = he.charAt(ot);
          U.indexOf(dt) === -1 && this.raise(g.start, "Invalid regular expression flag"), he.indexOf(dt, ot + 1) > -1 && this.raise(g.start, "Duplicate regular expression flag"), dt === "u" && (ye = !0), dt === "v" && (Ie = !0);
        }
        this.options.ecmaVersion >= 15 && ye && Ie && this.raise(g.start, "Invalid regular expression flag");
      };
      function nn(g) {
        for (var U in g)
          return !0;
        return !1;
      }
      Nt.validateRegExpPattern = function(g) {
        this.regexp_pattern(g), !g.switchN && this.options.ecmaVersion >= 9 && nn(g.groupNames) && (g.switchN = !0, this.regexp_pattern(g));
      }, Nt.regexp_pattern = function(g) {
        g.pos = 0, g.lastIntValue = 0, g.lastStringValue = "", g.lastAssertionIsQuantifiable = !1, g.numCapturingParens = 0, g.maxBackReference = 0, g.groupNames = /* @__PURE__ */ Object.create(null), g.backReferenceNames.length = 0, g.branchID = null, this.regexp_disjunction(g), g.pos !== g.source.length && (g.eat(
          41
          /* ) */
        ) && g.raise("Unmatched ')'"), (g.eat(
          93
          /* ] */
        ) || g.eat(
          125
          /* } */
        )) && g.raise("Lone quantifier brackets")), g.maxBackReference > g.numCapturingParens && g.raise("Invalid escape");
        for (var U = 0, he = g.backReferenceNames; U < he.length; U += 1) {
          var ye = he[U];
          g.groupNames[ye] || g.raise("Invalid named capture referenced");
        }
      }, Nt.regexp_disjunction = function(g) {
        var U = this.options.ecmaVersion >= 16;
        for (U && (g.branchID = new Vi(g.branchID, null)), this.regexp_alternative(g); g.eat(
          124
          /* | */
        ); )
          U && (g.branchID = g.branchID.sibling()), this.regexp_alternative(g);
        U && (g.branchID = g.branchID.parent), this.regexp_eatQuantifier(g, !0) && g.raise("Nothing to repeat"), g.eat(
          123
          /* { */
        ) && g.raise("Lone quantifier brackets");
      }, Nt.regexp_alternative = function(g) {
        for (; g.pos < g.source.length && this.regexp_eatTerm(g); )
          ;
      }, Nt.regexp_eatTerm = function(g) {
        return this.regexp_eatAssertion(g) ? (g.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(g) && g.switchU && g.raise("Invalid quantifier"), !0) : (g.switchU ? this.regexp_eatAtom(g) : this.regexp_eatExtendedAtom(g)) ? (this.regexp_eatQuantifier(g), !0) : !1;
      }, Nt.regexp_eatAssertion = function(g) {
        var U = g.pos;
        if (g.lastAssertionIsQuantifiable = !1, g.eat(
          94
          /* ^ */
        ) || g.eat(
          36
          /* $ */
        ))
          return !0;
        if (g.eat(
          92
          /* \ */
        )) {
          if (g.eat(
            66
            /* B */
          ) || g.eat(
            98
            /* b */
          ))
            return !0;
          g.pos = U;
        }
        if (g.eat(
          40
          /* ( */
        ) && g.eat(
          63
          /* ? */
        )) {
          var he = !1;
          if (this.options.ecmaVersion >= 9 && (he = g.eat(
            60
            /* < */
          )), g.eat(
            61
            /* = */
          ) || g.eat(
            33
            /* ! */
          ))
            return this.regexp_disjunction(g), g.eat(
              41
              /* ) */
            ) || g.raise("Unterminated group"), g.lastAssertionIsQuantifiable = !he, !0;
        }
        return g.pos = U, !1;
      }, Nt.regexp_eatQuantifier = function(g, U) {
        return U === void 0 && (U = !1), this.regexp_eatQuantifierPrefix(g, U) ? (g.eat(
          63
          /* ? */
        ), !0) : !1;
      }, Nt.regexp_eatQuantifierPrefix = function(g, U) {
        return g.eat(
          42
          /* * */
        ) || g.eat(
          43
          /* + */
        ) || g.eat(
          63
          /* ? */
        ) || this.regexp_eatBracedQuantifier(g, U);
      }, Nt.regexp_eatBracedQuantifier = function(g, U) {
        var he = g.pos;
        if (g.eat(
          123
          /* { */
        )) {
          var ye = 0, Ie = -1;
          if (this.regexp_eatDecimalDigits(g) && (ye = g.lastIntValue, g.eat(
            44
            /* , */
          ) && this.regexp_eatDecimalDigits(g) && (Ie = g.lastIntValue), g.eat(
            125
            /* } */
          )))
            return Ie !== -1 && Ie < ye && !U && g.raise("numbers out of order in {} quantifier"), !0;
          g.switchU && !U && g.raise("Incomplete quantifier"), g.pos = he;
        }
        return !1;
      }, Nt.regexp_eatAtom = function(g) {
        return this.regexp_eatPatternCharacters(g) || g.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(g) || this.regexp_eatCharacterClass(g) || this.regexp_eatUncapturingGroup(g) || this.regexp_eatCapturingGroup(g);
      }, Nt.regexp_eatReverseSolidusAtomEscape = function(g) {
        var U = g.pos;
        if (g.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatAtomEscape(g))
            return !0;
          g.pos = U;
        }
        return !1;
      }, Nt.regexp_eatUncapturingGroup = function(g) {
        var U = g.pos;
        if (g.eat(
          40
          /* ( */
        )) {
          if (g.eat(
            63
            /* ? */
          )) {
            if (this.options.ecmaVersion >= 16) {
              var he = this.regexp_eatModifiers(g), ye = g.eat(
                45
                /* - */
              );
              if (he || ye) {
                for (var Ie = 0; Ie < he.length; Ie++) {
                  var ot = he.charAt(Ie);
                  he.indexOf(ot, Ie + 1) > -1 && g.raise("Duplicate regular expression modifiers");
                }
                if (ye) {
                  var dt = this.regexp_eatModifiers(g);
                  !he && !dt && g.current() === 58 && g.raise("Invalid regular expression modifiers");
                  for (var zt = 0; zt < dt.length; zt++) {
                    var Kt = dt.charAt(zt);
                    (dt.indexOf(Kt, zt + 1) > -1 || he.indexOf(Kt) > -1) && g.raise("Duplicate regular expression modifiers");
                  }
                }
              }
            }
            if (g.eat(
              58
              /* : */
            )) {
              if (this.regexp_disjunction(g), g.eat(
                41
                /* ) */
              ))
                return !0;
              g.raise("Unterminated group");
            }
          }
          g.pos = U;
        }
        return !1;
      }, Nt.regexp_eatCapturingGroup = function(g) {
        if (g.eat(
          40
          /* ( */
        )) {
          if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(g) : g.current() === 63 && g.raise("Invalid group"), this.regexp_disjunction(g), g.eat(
            41
            /* ) */
          ))
            return g.numCapturingParens += 1, !0;
          g.raise("Unterminated group");
        }
        return !1;
      }, Nt.regexp_eatModifiers = function(g) {
        for (var U = "", he = 0; (he = g.current()) !== -1 && Yi(he); )
          U += Et(he), g.advance();
        return U;
      };
      function Yi(g) {
        return g === 105 || g === 109 || g === 115;
      }
      Nt.regexp_eatExtendedAtom = function(g) {
        return g.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(g) || this.regexp_eatCharacterClass(g) || this.regexp_eatUncapturingGroup(g) || this.regexp_eatCapturingGroup(g) || this.regexp_eatInvalidBracedQuantifier(g) || this.regexp_eatExtendedPatternCharacter(g);
      }, Nt.regexp_eatInvalidBracedQuantifier = function(g) {
        return this.regexp_eatBracedQuantifier(g, !0) && g.raise("Nothing to repeat"), !1;
      }, Nt.regexp_eatSyntaxCharacter = function(g) {
        var U = g.current();
        return qi(U) ? (g.lastIntValue = U, g.advance(), !0) : !1;
      };
      function qi(g) {
        return g === 36 || g >= 40 && g <= 43 || g === 46 || g === 63 || g >= 91 && g <= 94 || g >= 123 && g <= 125;
      }
      Nt.regexp_eatPatternCharacters = function(g) {
        for (var U = g.pos, he = 0; (he = g.current()) !== -1 && !qi(he); )
          g.advance();
        return g.pos !== U;
      }, Nt.regexp_eatExtendedPatternCharacter = function(g) {
        var U = g.current();
        return U !== -1 && U !== 36 && !(U >= 40 && U <= 43) && U !== 46 && U !== 63 && U !== 91 && U !== 94 && U !== 124 ? (g.advance(), !0) : !1;
      }, Nt.regexp_groupSpecifier = function(g) {
        if (g.eat(
          63
          /* ? */
        )) {
          this.regexp_eatGroupName(g) || g.raise("Invalid group");
          var U = this.options.ecmaVersion >= 16, he = g.groupNames[g.lastStringValue];
          if (he)
            if (U)
              for (var ye = 0, Ie = he; ye < Ie.length; ye += 1) {
                var ot = Ie[ye];
                ot.separatedFrom(g.branchID) || g.raise("Duplicate capture group name");
              }
            else
              g.raise("Duplicate capture group name");
          U ? (he || (g.groupNames[g.lastStringValue] = [])).push(g.branchID) : g.groupNames[g.lastStringValue] = !0;
        }
      }, Nt.regexp_eatGroupName = function(g) {
        if (g.lastStringValue = "", g.eat(
          60
          /* < */
        )) {
          if (this.regexp_eatRegExpIdentifierName(g) && g.eat(
            62
            /* > */
          ))
            return !0;
          g.raise("Invalid capture group name");
        }
        return !1;
      }, Nt.regexp_eatRegExpIdentifierName = function(g) {
        if (g.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(g)) {
          for (g.lastStringValue += Et(g.lastIntValue); this.regexp_eatRegExpIdentifierPart(g); )
            g.lastStringValue += Et(g.lastIntValue);
          return !0;
        }
        return !1;
      }, Nt.regexp_eatRegExpIdentifierStart = function(g) {
        var U = g.pos, he = this.options.ecmaVersion >= 11, ye = g.current(he);
        return g.advance(he), ye === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(g, he) && (ye = g.lastIntValue), Qi(ye) ? (g.lastIntValue = ye, !0) : (g.pos = U, !1);
      };
      function Qi(g) {
        return Z(g, !0) || g === 36 || g === 95;
      }
      Nt.regexp_eatRegExpIdentifierPart = function(g) {
        var U = g.pos, he = this.options.ecmaVersion >= 11, ye = g.current(he);
        return g.advance(he), ye === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(g, he) && (ye = g.lastIntValue), Gi(ye) ? (g.lastIntValue = ye, !0) : (g.pos = U, !1);
      };
      function Gi(g) {
        return V(g, !0) || g === 36 || g === 95 || g === 8204 || g === 8205;
      }
      Nt.regexp_eatAtomEscape = function(g) {
        return this.regexp_eatBackReference(g) || this.regexp_eatCharacterClassEscape(g) || this.regexp_eatCharacterEscape(g) || g.switchN && this.regexp_eatKGroupName(g) ? !0 : (g.switchU && (g.current() === 99 && g.raise("Invalid unicode escape"), g.raise("Invalid escape")), !1);
      }, Nt.regexp_eatBackReference = function(g) {
        var U = g.pos;
        if (this.regexp_eatDecimalEscape(g)) {
          var he = g.lastIntValue;
          if (g.switchU)
            return he > g.maxBackReference && (g.maxBackReference = he), !0;
          if (he <= g.numCapturingParens)
            return !0;
          g.pos = U;
        }
        return !1;
      }, Nt.regexp_eatKGroupName = function(g) {
        if (g.eat(
          107
          /* k */
        )) {
          if (this.regexp_eatGroupName(g))
            return g.backReferenceNames.push(g.lastStringValue), !0;
          g.raise("Invalid named reference");
        }
        return !1;
      }, Nt.regexp_eatCharacterEscape = function(g) {
        return this.regexp_eatControlEscape(g) || this.regexp_eatCControlLetter(g) || this.regexp_eatZero(g) || this.regexp_eatHexEscapeSequence(g) || this.regexp_eatRegExpUnicodeEscapeSequence(g, !1) || !g.switchU && this.regexp_eatLegacyOctalEscapeSequence(g) || this.regexp_eatIdentityEscape(g);
      }, Nt.regexp_eatCControlLetter = function(g) {
        var U = g.pos;
        if (g.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatControlLetter(g))
            return !0;
          g.pos = U;
        }
        return !1;
      }, Nt.regexp_eatZero = function(g) {
        return g.current() === 48 && !Hn(g.lookahead()) ? (g.lastIntValue = 0, g.advance(), !0) : !1;
      }, Nt.regexp_eatControlEscape = function(g) {
        var U = g.current();
        return U === 116 ? (g.lastIntValue = 9, g.advance(), !0) : U === 110 ? (g.lastIntValue = 10, g.advance(), !0) : U === 118 ? (g.lastIntValue = 11, g.advance(), !0) : U === 102 ? (g.lastIntValue = 12, g.advance(), !0) : U === 114 ? (g.lastIntValue = 13, g.advance(), !0) : !1;
      }, Nt.regexp_eatControlLetter = function(g) {
        var U = g.current();
        return Xi(U) ? (g.lastIntValue = U % 32, g.advance(), !0) : !1;
      };
      function Xi(g) {
        return g >= 65 && g <= 90 || g >= 97 && g <= 122;
      }
      Nt.regexp_eatRegExpUnicodeEscapeSequence = function(g, U) {
        U === void 0 && (U = !1);
        var he = g.pos, ye = U || g.switchU;
        if (g.eat(
          117
          /* u */
        )) {
          if (this.regexp_eatFixedHexDigits(g, 4)) {
            var Ie = g.lastIntValue;
            if (ye && Ie >= 55296 && Ie <= 56319) {
              var ot = g.pos;
              if (g.eat(
                92
                /* \ */
              ) && g.eat(
                117
                /* u */
              ) && this.regexp_eatFixedHexDigits(g, 4)) {
                var dt = g.lastIntValue;
                if (dt >= 56320 && dt <= 57343)
                  return g.lastIntValue = (Ie - 55296) * 1024 + (dt - 56320) + 65536, !0;
              }
              g.pos = ot, g.lastIntValue = Ie;
            }
            return !0;
          }
          if (ye && g.eat(
            123
            /* { */
          ) && this.regexp_eatHexDigits(g) && g.eat(
            125
            /* } */
          ) && _n(g.lastIntValue))
            return !0;
          ye && g.raise("Invalid unicode escape"), g.pos = he;
        }
        return !1;
      };
      function _n(g) {
        return g >= 0 && g <= 1114111;
      }
      Nt.regexp_eatIdentityEscape = function(g) {
        if (g.switchU)
          return this.regexp_eatSyntaxCharacter(g) ? !0 : g.eat(
            47
            /* / */
          ) ? (g.lastIntValue = 47, !0) : !1;
        var U = g.current();
        return U !== 99 && (!g.switchN || U !== 107) ? (g.lastIntValue = U, g.advance(), !0) : !1;
      }, Nt.regexp_eatDecimalEscape = function(g) {
        g.lastIntValue = 0;
        var U = g.current();
        if (U >= 49 && U <= 57) {
          do
            g.lastIntValue = 10 * g.lastIntValue + (U - 48), g.advance();
          while ((U = g.current()) >= 48 && U <= 57);
          return !0;
        }
        return !1;
      };
      var Ki = 0, cn = 1, Cn = 2;
      Nt.regexp_eatCharacterClassEscape = function(g) {
        var U = g.current();
        if ($r(U))
          return g.lastIntValue = -1, g.advance(), cn;
        var he = !1;
        if (g.switchU && this.options.ecmaVersion >= 9 && ((he = U === 80) || U === 112)) {
          g.lastIntValue = -1, g.advance();
          var ye;
          if (g.eat(
            123
            /* { */
          ) && (ye = this.regexp_eatUnicodePropertyValueExpression(g)) && g.eat(
            125
            /* } */
          ))
            return he && ye === Cn && g.raise("Invalid property name"), ye;
          g.raise("Invalid property name");
        }
        return Ki;
      };
      function $r(g) {
        return g === 100 || g === 68 || g === 115 || g === 83 || g === 119 || g === 87;
      }
      Nt.regexp_eatUnicodePropertyValueExpression = function(g) {
        var U = g.pos;
        if (this.regexp_eatUnicodePropertyName(g) && g.eat(
          61
          /* = */
        )) {
          var he = g.lastStringValue;
          if (this.regexp_eatUnicodePropertyValue(g)) {
            var ye = g.lastStringValue;
            return this.regexp_validateUnicodePropertyNameAndValue(g, he, ye), cn;
          }
        }
        if (g.pos = U, this.regexp_eatLoneUnicodePropertyNameOrValue(g)) {
          var Ie = g.lastStringValue;
          return this.regexp_validateUnicodePropertyNameOrValue(g, Ie);
        }
        return Ki;
      }, Nt.regexp_validateUnicodePropertyNameAndValue = function(g, U, he) {
        ze(g.unicodeProperties.nonBinary, U) || g.raise("Invalid property name"), g.unicodeProperties.nonBinary[U].test(he) || g.raise("Invalid property value");
      }, Nt.regexp_validateUnicodePropertyNameOrValue = function(g, U) {
        if (g.unicodeProperties.binary.test(U))
          return cn;
        if (g.switchV && g.unicodeProperties.binaryOfStrings.test(U))
          return Cn;
        g.raise("Invalid property name");
      }, Nt.regexp_eatUnicodePropertyName = function(g) {
        var U = 0;
        for (g.lastStringValue = ""; Pr(U = g.current()); )
          g.lastStringValue += Et(U), g.advance();
        return g.lastStringValue !== "";
      };
      function Pr(g) {
        return Xi(g) || g === 95;
      }
      Nt.regexp_eatUnicodePropertyValue = function(g) {
        var U = 0;
        for (g.lastStringValue = ""; An(U = g.current()); )
          g.lastStringValue += Et(U), g.advance();
        return g.lastStringValue !== "";
      };
      function An(g) {
        return Pr(g) || Hn(g);
      }
      Nt.regexp_eatLoneUnicodePropertyNameOrValue = function(g) {
        return this.regexp_eatUnicodePropertyValue(g);
      }, Nt.regexp_eatCharacterClass = function(g) {
        if (g.eat(
          91
          /* [ */
        )) {
          var U = g.eat(
            94
            /* ^ */
          ), he = this.regexp_classContents(g);
          return g.eat(
            93
            /* ] */
          ) || g.raise("Unterminated character class"), U && he === Cn && g.raise("Negated character class may contain strings"), !0;
        }
        return !1;
      }, Nt.regexp_classContents = function(g) {
        return g.current() === 93 ? cn : g.switchV ? this.regexp_classSetExpression(g) : (this.regexp_nonEmptyClassRanges(g), cn);
      }, Nt.regexp_nonEmptyClassRanges = function(g) {
        for (; this.regexp_eatClassAtom(g); ) {
          var U = g.lastIntValue;
          if (g.eat(
            45
            /* - */
          ) && this.regexp_eatClassAtom(g)) {
            var he = g.lastIntValue;
            g.switchU && (U === -1 || he === -1) && g.raise("Invalid character class"), U !== -1 && he !== -1 && U > he && g.raise("Range out of order in character class");
          }
        }
      }, Nt.regexp_eatClassAtom = function(g) {
        var U = g.pos;
        if (g.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatClassEscape(g))
            return !0;
          if (g.switchU) {
            var he = g.current();
            (he === 99 || bn(he)) && g.raise("Invalid class escape"), g.raise("Invalid escape");
          }
          g.pos = U;
        }
        var ye = g.current();
        return ye !== 93 ? (g.lastIntValue = ye, g.advance(), !0) : !1;
      }, Nt.regexp_eatClassEscape = function(g) {
        var U = g.pos;
        if (g.eat(
          98
          /* b */
        ))
          return g.lastIntValue = 8, !0;
        if (g.switchU && g.eat(
          45
          /* - */
        ))
          return g.lastIntValue = 45, !0;
        if (!g.switchU && g.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatClassControlLetter(g))
            return !0;
          g.pos = U;
        }
        return this.regexp_eatCharacterClassEscape(g) || this.regexp_eatCharacterEscape(g);
      }, Nt.regexp_classSetExpression = function(g) {
        var U = cn, he;
        if (!this.regexp_eatClassSetRange(g))
          if (he = this.regexp_eatClassSetOperand(g)) {
            he === Cn && (U = Cn);
            for (var ye = g.pos; g.eatChars(
              [38, 38]
              /* && */
            ); ) {
              if (g.current() !== 38 && (he = this.regexp_eatClassSetOperand(g))) {
                he !== Cn && (U = cn);
                continue;
              }
              g.raise("Invalid character in character class");
            }
            if (ye !== g.pos)
              return U;
            for (; g.eatChars(
              [45, 45]
              /* -- */
            ); )
              this.regexp_eatClassSetOperand(g) || g.raise("Invalid character in character class");
            if (ye !== g.pos)
              return U;
          } else
            g.raise("Invalid character in character class");
        for (; ; )
          if (!this.regexp_eatClassSetRange(g)) {
            if (he = this.regexp_eatClassSetOperand(g), !he)
              return U;
            he === Cn && (U = Cn);
          }
      }, Nt.regexp_eatClassSetRange = function(g) {
        var U = g.pos;
        if (this.regexp_eatClassSetCharacter(g)) {
          var he = g.lastIntValue;
          if (g.eat(
            45
            /* - */
          ) && this.regexp_eatClassSetCharacter(g)) {
            var ye = g.lastIntValue;
            return he !== -1 && ye !== -1 && he > ye && g.raise("Range out of order in character class"), !0;
          }
          g.pos = U;
        }
        return !1;
      }, Nt.regexp_eatClassSetOperand = function(g) {
        return this.regexp_eatClassSetCharacter(g) ? cn : this.regexp_eatClassStringDisjunction(g) || this.regexp_eatNestedClass(g);
      }, Nt.regexp_eatNestedClass = function(g) {
        var U = g.pos;
        if (g.eat(
          91
          /* [ */
        )) {
          var he = g.eat(
            94
            /* ^ */
          ), ye = this.regexp_classContents(g);
          if (g.eat(
            93
            /* ] */
          ))
            return he && ye === Cn && g.raise("Negated character class may contain strings"), ye;
          g.pos = U;
        }
        if (g.eat(
          92
          /* \ */
        )) {
          var Ie = this.regexp_eatCharacterClassEscape(g);
          if (Ie)
            return Ie;
          g.pos = U;
        }
        return null;
      }, Nt.regexp_eatClassStringDisjunction = function(g) {
        var U = g.pos;
        if (g.eatChars(
          [92, 113]
          /* \q */
        )) {
          if (g.eat(
            123
            /* { */
          )) {
            var he = this.regexp_classStringDisjunctionContents(g);
            if (g.eat(
              125
              /* } */
            ))
              return he;
          } else
            g.raise("Invalid escape");
          g.pos = U;
        }
        return null;
      }, Nt.regexp_classStringDisjunctionContents = function(g) {
        for (var U = this.regexp_classString(g); g.eat(
          124
          /* | */
        ); )
          this.regexp_classString(g) === Cn && (U = Cn);
        return U;
      }, Nt.regexp_classString = function(g) {
        for (var U = 0; this.regexp_eatClassSetCharacter(g); )
          U++;
        return U === 1 ? cn : Cn;
      }, Nt.regexp_eatClassSetCharacter = function(g) {
        var U = g.pos;
        if (g.eat(
          92
          /* \ */
        ))
          return this.regexp_eatCharacterEscape(g) || this.regexp_eatClassSetReservedPunctuator(g) ? !0 : g.eat(
            98
            /* b */
          ) ? (g.lastIntValue = 8, !0) : (g.pos = U, !1);
        var he = g.current();
        return he < 0 || he === g.lookahead() && Xr(he) || Vn(he) ? !1 : (g.advance(), g.lastIntValue = he, !0);
      };
      function Xr(g) {
        return g === 33 || g >= 35 && g <= 38 || g >= 42 && g <= 44 || g === 46 || g >= 58 && g <= 64 || g === 94 || g === 96 || g === 126;
      }
      function Vn(g) {
        return g === 40 || g === 41 || g === 45 || g === 47 || g >= 91 && g <= 93 || g >= 123 && g <= 125;
      }
      Nt.regexp_eatClassSetReservedPunctuator = function(g) {
        var U = g.current();
        return gr(U) ? (g.lastIntValue = U, g.advance(), !0) : !1;
      };
      function gr(g) {
        return g === 33 || g === 35 || g === 37 || g === 38 || g === 44 || g === 45 || g >= 58 && g <= 62 || g === 64 || g === 96 || g === 126;
      }
      Nt.regexp_eatClassControlLetter = function(g) {
        var U = g.current();
        return Hn(U) || U === 95 ? (g.lastIntValue = U % 32, g.advance(), !0) : !1;
      }, Nt.regexp_eatHexEscapeSequence = function(g) {
        var U = g.pos;
        if (g.eat(
          120
          /* x */
        )) {
          if (this.regexp_eatFixedHexDigits(g, 2))
            return !0;
          g.switchU && g.raise("Invalid escape"), g.pos = U;
        }
        return !1;
      }, Nt.regexp_eatDecimalDigits = function(g) {
        var U = g.pos, he = 0;
        for (g.lastIntValue = 0; Hn(he = g.current()); )
          g.lastIntValue = 10 * g.lastIntValue + (he - 48), g.advance();
        return g.pos !== U;
      };
      function Hn(g) {
        return g >= 48 && g <= 57;
      }
      Nt.regexp_eatHexDigits = function(g) {
        var U = g.pos, he = 0;
        for (g.lastIntValue = 0; fn(he = g.current()); )
          g.lastIntValue = 16 * g.lastIntValue + dn(he), g.advance();
        return g.pos !== U;
      };
      function fn(g) {
        return g >= 48 && g <= 57 || g >= 65 && g <= 70 || g >= 97 && g <= 102;
      }
      function dn(g) {
        return g >= 65 && g <= 70 ? 10 + (g - 65) : g >= 97 && g <= 102 ? 10 + (g - 97) : g - 48;
      }
      Nt.regexp_eatLegacyOctalEscapeSequence = function(g) {
        if (this.regexp_eatOctalDigit(g)) {
          var U = g.lastIntValue;
          if (this.regexp_eatOctalDigit(g)) {
            var he = g.lastIntValue;
            U <= 3 && this.regexp_eatOctalDigit(g) ? g.lastIntValue = U * 64 + he * 8 + g.lastIntValue : g.lastIntValue = U * 8 + he;
          } else
            g.lastIntValue = U;
          return !0;
        }
        return !1;
      }, Nt.regexp_eatOctalDigit = function(g) {
        var U = g.current();
        return bn(U) ? (g.lastIntValue = U - 48, g.advance(), !0) : (g.lastIntValue = 0, !1);
      };
      function bn(g) {
        return g >= 48 && g <= 55;
      }
      Nt.regexp_eatFixedHexDigits = function(g, U) {
        var he = g.pos;
        g.lastIntValue = 0;
        for (var ye = 0; ye < U; ++ye) {
          var Ie = g.current();
          if (!fn(Ie))
            return g.pos = he, !1;
          g.lastIntValue = 16 * g.lastIntValue + dn(Ie), g.advance();
        }
        return !0;
      };
      var sn = function(U) {
        this.type = U.type, this.value = U.value, this.start = U.start, this.end = U.end, U.options.locations && (this.loc = new Zt(U, U.startLoc, U.endLoc)), U.options.ranges && (this.range = [U.start, U.end]);
      }, ri = a.prototype;
      ri.next = function(g) {
        !g && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new sn(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
      }, ri.getToken = function() {
        return this.next(), new sn(this);
      }, typeof Symbol < "u" && (ri[Symbol.iterator] = function() {
        var g = this;
        return {
          next: function() {
            var U = g.getToken();
            return {
              done: U.type === X.eof,
              value: U
            };
          }
        };
      }), ri.nextToken = function() {
        var g = this.curContext();
        if ((!g || !g.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
          return this.finishToken(X.eof);
        if (g.override)
          return g.override(this);
        this.readToken(this.fullCharCodeAtPos());
      }, ri.readToken = function(g) {
        return Z(g, this.options.ecmaVersion >= 6) || g === 92 ? this.readWord() : this.getTokenFromCode(g);
      }, ri.fullCharCodeAt = function(g) {
        var U = this.input.charCodeAt(g);
        if (U <= 55295 || U >= 56320)
          return U;
        var he = this.input.charCodeAt(g + 1);
        return he <= 56319 || he >= 57344 ? U : (U << 10) + he - 56613888;
      }, ri.fullCharCodeAtPos = function() {
        return this.fullCharCodeAt(this.pos);
      }, ri.skipBlockComment = function() {
        var g = this.options.onComment && this.curPosition(), U = this.pos, he = this.input.indexOf("*/", this.pos += 2);
        if (he === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = he + 2, this.options.locations)
          for (var ye = void 0, Ie = U; (ye = He(this.input, Ie, this.pos)) > -1; )
            ++this.curLine, Ie = this.lineStart = ye;
        this.options.onComment && this.options.onComment(
          !0,
          this.input.slice(U + 2, he),
          U,
          this.pos,
          g,
          this.curPosition()
        );
      }, ri.skipLineComment = function(g) {
        for (var U = this.pos, he = this.options.onComment && this.curPosition(), ye = this.input.charCodeAt(this.pos += g); this.pos < this.input.length && !Ee(ye); )
          ye = this.input.charCodeAt(++this.pos);
        this.options.onComment && this.options.onComment(
          !1,
          this.input.slice(U + g, this.pos),
          U,
          this.pos,
          he,
          this.curPosition()
        );
      }, ri.skipSpace = function() {
        e:
          for (; this.pos < this.input.length; ) {
            var g = this.input.charCodeAt(this.pos);
            switch (g) {
              case 32:
              case 160:
                ++this.pos;
                break;
              case 13:
                this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
              case 10:
              case 8232:
              case 8233:
                ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                break;
              case 47:
                switch (this.input.charCodeAt(this.pos + 1)) {
                  case 42:
                    this.skipBlockComment();
                    break;
                  case 47:
                    this.skipLineComment(2);
                    break;
                  default:
                    break e;
                }
                break;
              default:
                if (g > 8 && g < 14 || g >= 5760 && ft.test(String.fromCharCode(g)))
                  ++this.pos;
                else
                  break e;
            }
          }
      }, ri.finishToken = function(g, U) {
        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
        var he = this.type;
        this.type = g, this.value = U, this.updateContext(he);
      }, ri.readToken_dot = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        if (g >= 48 && g <= 57)
          return this.readNumber(!0);
        var U = this.input.charCodeAt(this.pos + 2);
        return this.options.ecmaVersion >= 6 && g === 46 && U === 46 ? (this.pos += 3, this.finishToken(X.ellipsis)) : (++this.pos, this.finishToken(X.dot));
      }, ri.readToken_slash = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        return this.exprAllowed ? (++this.pos, this.readRegexp()) : g === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.slash, 1);
      }, ri.readToken_mult_modulo_exp = function(g) {
        var U = this.input.charCodeAt(this.pos + 1), he = 1, ye = g === 42 ? X.star : X.modulo;
        return this.options.ecmaVersion >= 7 && g === 42 && U === 42 && (++he, ye = X.starstar, U = this.input.charCodeAt(this.pos + 2)), U === 61 ? this.finishOp(X.assign, he + 1) : this.finishOp(ye, he);
      }, ri.readToken_pipe_amp = function(g) {
        var U = this.input.charCodeAt(this.pos + 1);
        if (U === g) {
          if (this.options.ecmaVersion >= 12) {
            var he = this.input.charCodeAt(this.pos + 2);
            if (he === 61)
              return this.finishOp(X.assign, 3);
          }
          return this.finishOp(g === 124 ? X.logicalOR : X.logicalAND, 2);
        }
        return U === 61 ? this.finishOp(X.assign, 2) : this.finishOp(g === 124 ? X.bitwiseOR : X.bitwiseAND, 1);
      }, ri.readToken_caret = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        return g === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.bitwiseXOR, 1);
      }, ri.readToken_plus_min = function(g) {
        var U = this.input.charCodeAt(this.pos + 1);
        return U === g ? U === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || W.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(X.incDec, 2) : U === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.plusMin, 1);
      }, ri.readToken_lt_gt = function(g) {
        var U = this.input.charCodeAt(this.pos + 1), he = 1;
        return U === g ? (he = g === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + he) === 61 ? this.finishOp(X.assign, he + 1) : this.finishOp(X.bitShift, he)) : U === 33 && g === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (U === 61 && (he = 2), this.finishOp(X.relational, he));
      }, ri.readToken_eq_excl = function(g) {
        var U = this.input.charCodeAt(this.pos + 1);
        return U === 61 ? this.finishOp(X.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : g === 61 && U === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(X.arrow)) : this.finishOp(g === 61 ? X.eq : X.prefix, 1);
      }, ri.readToken_question = function() {
        var g = this.options.ecmaVersion;
        if (g >= 11) {
          var U = this.input.charCodeAt(this.pos + 1);
          if (U === 46) {
            var he = this.input.charCodeAt(this.pos + 2);
            if (he < 48 || he > 57)
              return this.finishOp(X.questionDot, 2);
          }
          if (U === 63) {
            if (g >= 12) {
              var ye = this.input.charCodeAt(this.pos + 2);
              if (ye === 61)
                return this.finishOp(X.assign, 3);
            }
            return this.finishOp(X.coalesce, 2);
          }
        }
        return this.finishOp(X.question, 1);
      }, ri.readToken_numberSign = function() {
        var g = this.options.ecmaVersion, U = 35;
        if (g >= 13 && (++this.pos, U = this.fullCharCodeAtPos(), Z(U, !0) || U === 92))
          return this.finishToken(X.privateId, this.readWord1());
        this.raise(this.pos, "Unexpected character '" + Et(U) + "'");
      }, ri.getTokenFromCode = function(g) {
        switch (g) {
          case 46:
            return this.readToken_dot();
          case 40:
            return ++this.pos, this.finishToken(X.parenL);
          case 41:
            return ++this.pos, this.finishToken(X.parenR);
          case 59:
            return ++this.pos, this.finishToken(X.semi);
          case 44:
            return ++this.pos, this.finishToken(X.comma);
          case 91:
            return ++this.pos, this.finishToken(X.bracketL);
          case 93:
            return ++this.pos, this.finishToken(X.bracketR);
          case 123:
            return ++this.pos, this.finishToken(X.braceL);
          case 125:
            return ++this.pos, this.finishToken(X.braceR);
          case 58:
            return ++this.pos, this.finishToken(X.colon);
          case 96:
            if (this.options.ecmaVersion < 6)
              break;
            return ++this.pos, this.finishToken(X.backQuote);
          case 48:
            var U = this.input.charCodeAt(this.pos + 1);
            if (U === 120 || U === 88)
              return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
              if (U === 111 || U === 79)
                return this.readRadixNumber(8);
              if (U === 98 || U === 66)
                return this.readRadixNumber(2);
            }
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return this.readNumber(!1);
          case 34:
          case 39:
            return this.readString(g);
          case 47:
            return this.readToken_slash();
          case 37:
          case 42:
            return this.readToken_mult_modulo_exp(g);
          case 124:
          case 38:
            return this.readToken_pipe_amp(g);
          case 94:
            return this.readToken_caret();
          case 43:
          case 45:
            return this.readToken_plus_min(g);
          case 60:
          case 62:
            return this.readToken_lt_gt(g);
          case 61:
          case 33:
            return this.readToken_eq_excl(g);
          case 63:
            return this.readToken_question();
          case 126:
            return this.finishOp(X.prefix, 1);
          case 35:
            return this.readToken_numberSign();
        }
        this.raise(this.pos, "Unexpected character '" + Et(g) + "'");
      }, ri.finishOp = function(g, U) {
        var he = this.input.slice(this.pos, this.pos + U);
        return this.pos += U, this.finishToken(g, he);
      }, ri.readRegexp = function() {
        for (var g, U, he = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(he, "Unterminated regular expression");
          var ye = this.input.charAt(this.pos);
          if (W.test(ye) && this.raise(he, "Unterminated regular expression"), g)
            g = !1;
          else {
            if (ye === "[")
              U = !0;
            else if (ye === "]" && U)
              U = !1;
            else if (ye === "/" && !U)
              break;
            g = ye === "\\";
          }
          ++this.pos;
        }
        var Ie = this.input.slice(he, this.pos);
        ++this.pos;
        var ot = this.pos, dt = this.readWord1();
        this.containsEsc && this.unexpected(ot);
        var zt = this.regexpState || (this.regexpState = new ci(this));
        zt.reset(he, Ie, dt), this.validateRegExpFlags(zt), this.validateRegExpPattern(zt);
        var Kt = null;
        try {
          Kt = new RegExp(Ie, dt);
        } catch {
        }
        return this.finishToken(X.regexp, { pattern: Ie, flags: dt, value: Kt });
      }, ri.readInt = function(g, U, he) {
        for (var ye = this.options.ecmaVersion >= 12 && U === void 0, Ie = he && this.input.charCodeAt(this.pos) === 48, ot = this.pos, dt = 0, zt = 0, Kt = 0, fi = U ?? 1 / 0; Kt < fi; ++Kt, ++this.pos) {
          var ti = this.input.charCodeAt(this.pos), hi = void 0;
          if (ye && ti === 95) {
            Ie && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), zt === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), Kt === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), zt = ti;
            continue;
          }
          if (ti >= 97 ? hi = ti - 97 + 10 : ti >= 65 ? hi = ti - 65 + 10 : ti >= 48 && ti <= 57 ? hi = ti - 48 : hi = 1 / 0, hi >= g)
            break;
          zt = ti, dt = dt * g + hi;
        }
        return ye && zt === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === ot || U != null && this.pos - ot !== U ? null : dt;
      };
      function gn(g, U) {
        return U ? parseInt(g, 8) : parseFloat(g.replace(/_/g, ""));
      }
      function rn(g) {
        return typeof BigInt != "function" ? null : BigInt(g.replace(/_/g, ""));
      }
      ri.readRadixNumber = function(g) {
        var U = this.pos;
        this.pos += 2;
        var he = this.readInt(g);
        return he == null && this.raise(this.start + 2, "Expected number in radix " + g), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (he = rn(this.input.slice(U, this.pos)), ++this.pos) : Z(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(X.num, he);
      }, ri.readNumber = function(g) {
        var U = this.pos;
        !g && this.readInt(10, void 0, !0) === null && this.raise(U, "Invalid number");
        var he = this.pos - U >= 2 && this.input.charCodeAt(U) === 48;
        he && this.strict && this.raise(U, "Invalid number");
        var ye = this.input.charCodeAt(this.pos);
        if (!he && !g && this.options.ecmaVersion >= 11 && ye === 110) {
          var Ie = rn(this.input.slice(U, this.pos));
          return ++this.pos, Z(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(X.num, Ie);
        }
        he && /[89]/.test(this.input.slice(U, this.pos)) && (he = !1), ye === 46 && !he && (++this.pos, this.readInt(10), ye = this.input.charCodeAt(this.pos)), (ye === 69 || ye === 101) && !he && (ye = this.input.charCodeAt(++this.pos), (ye === 43 || ye === 45) && ++this.pos, this.readInt(10) === null && this.raise(U, "Invalid number")), Z(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
        var ot = gn(this.input.slice(U, this.pos), he);
        return this.finishToken(X.num, ot);
      }, ri.readCodePoint = function() {
        var g = this.input.charCodeAt(this.pos), U;
        if (g === 123) {
          this.options.ecmaVersion < 6 && this.unexpected();
          var he = ++this.pos;
          U = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, U > 1114111 && this.invalidStringToken(he, "Code point out of bounds");
        } else
          U = this.readHexChar(4);
        return U;
      }, ri.readString = function(g) {
        for (var U = "", he = ++this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
          var ye = this.input.charCodeAt(this.pos);
          if (ye === g)
            break;
          ye === 92 ? (U += this.input.slice(he, this.pos), U += this.readEscapedChar(!1), he = this.pos) : ye === 8232 || ye === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (Ee(ye) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
        }
        return U += this.input.slice(he, this.pos++), this.finishToken(X.string, U);
      };
      var On = {};
      ri.tryReadTemplateToken = function() {
        this.inTemplateElement = !0;
        try {
          this.readTmplToken();
        } catch (g) {
          if (g === On)
            this.readInvalidTemplateToken();
          else
            throw g;
        }
        this.inTemplateElement = !1;
      }, ri.invalidStringToken = function(g, U) {
        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
          throw On;
        this.raise(g, U);
      }, ri.readTmplToken = function() {
        for (var g = "", U = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
          var he = this.input.charCodeAt(this.pos);
          if (he === 96 || he === 36 && this.input.charCodeAt(this.pos + 1) === 123)
            return this.pos === this.start && (this.type === X.template || this.type === X.invalidTemplate) ? he === 36 ? (this.pos += 2, this.finishToken(X.dollarBraceL)) : (++this.pos, this.finishToken(X.backQuote)) : (g += this.input.slice(U, this.pos), this.finishToken(X.template, g));
          if (he === 92)
            g += this.input.slice(U, this.pos), g += this.readEscapedChar(!0), U = this.pos;
          else if (Ee(he)) {
            switch (g += this.input.slice(U, this.pos), ++this.pos, he) {
              case 13:
                this.input.charCodeAt(this.pos) === 10 && ++this.pos;
              case 10:
                g += `
`;
                break;
              default:
                g += String.fromCharCode(he);
                break;
            }
            this.options.locations && (++this.curLine, this.lineStart = this.pos), U = this.pos;
          } else
            ++this.pos;
        }
      }, ri.readInvalidTemplateToken = function() {
        for (; this.pos < this.input.length; this.pos++)
          switch (this.input[this.pos]) {
            case "\\":
              ++this.pos;
              break;
            case "$":
              if (this.input[this.pos + 1] !== "{")
                break;
            case "`":
              return this.finishToken(X.invalidTemplate, this.input.slice(this.start, this.pos));
            case "\r":
              this.input[this.pos + 1] === `
` && ++this.pos;
            case `
`:
            case "\u2028":
            case "\u2029":
              ++this.curLine, this.lineStart = this.pos + 1;
              break;
          }
        this.raise(this.start, "Unterminated template");
      }, ri.readEscapedChar = function(g) {
        var U = this.input.charCodeAt(++this.pos);
        switch (++this.pos, U) {
          case 110:
            return `
`;
          case 114:
            return "\r";
          case 120:
            return String.fromCharCode(this.readHexChar(2));
          case 117:
            return Et(this.readCodePoint());
          case 116:
            return "	";
          case 98:
            return "\b";
          case 118:
            return "\v";
          case 102:
            return "\f";
          case 13:
            this.input.charCodeAt(this.pos) === 10 && ++this.pos;
          case 10:
            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
          case 56:
          case 57:
            if (this.strict && this.invalidStringToken(
              this.pos - 1,
              "Invalid escape sequence"
            ), g) {
              var he = this.pos - 1;
              this.invalidStringToken(
                he,
                "Invalid escape sequence in template string"
              );
            }
          default:
            if (U >= 48 && U <= 55) {
              var ye = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], Ie = parseInt(ye, 8);
              return Ie > 255 && (ye = ye.slice(0, -1), Ie = parseInt(ye, 8)), this.pos += ye.length - 1, U = this.input.charCodeAt(this.pos), (ye !== "0" || U === 56 || U === 57) && (this.strict || g) && this.invalidStringToken(
                this.pos - 1 - ye.length,
                g ? "Octal literal in template string" : "Octal literal in strict mode"
              ), String.fromCharCode(Ie);
            }
            return Ee(U) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(U);
        }
      }, ri.readHexChar = function(g) {
        var U = this.pos, he = this.readInt(16, g);
        return he === null && this.invalidStringToken(U, "Bad character escape sequence"), he;
      }, ri.readWord1 = function() {
        this.containsEsc = !1;
        for (var g = "", U = !0, he = this.pos, ye = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
          var Ie = this.fullCharCodeAtPos();
          if (V(Ie, ye))
            this.pos += Ie <= 65535 ? 1 : 2;
          else if (Ie === 92) {
            this.containsEsc = !0, g += this.input.slice(he, this.pos);
            var ot = this.pos;
            this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
            var dt = this.readCodePoint();
            (U ? Z : V)(dt, ye) || this.invalidStringToken(ot, "Invalid Unicode escape"), g += Et(dt), he = this.pos;
          } else
            break;
          U = !1;
        }
        return g + this.input.slice(he, this.pos);
      }, ri.readWord = function() {
        var g = this.readWord1(), U = X.name;
        return this.keywords.test(g) && (U = le[g]), this.finishToken(U, g);
      };
      var pr = "8.17.0";
      a.acorn = {
        Parser: a,
        version: pr,
        defaultOptions: Lt,
        Position: it,
        SourceLocation: Zt,
        getLineInfo: $t,
        Node: me,
        TokenType: te,
        tokTypes: X,
        keywordTypes: le,
        TokContext: k,
        tokContexts: z,
        isIdentifierChar: V,
        isIdentifierStart: Z,
        Token: sn,
        isNewLine: Ee,
        lineBreak: W,
        lineBreakG: je,
        nonASCIIwhitespace: ft
      };
      function Nr(g, U) {
        return a.parse(g, U);
      }
      function wr(g, U, he) {
        return a.parseExpressionAt(g, U, he);
      }
      function Sr(g, U) {
        return a.tokenizer(g, U);
      }
      t.Node = me, t.Parser = a, t.Position = it, t.SourceLocation = Zt, t.TokContext = k, t.Token = sn, t.TokenType = te, t.defaultOptions = Lt, t.getLineInfo = $t, t.isIdentifierChar = V, t.isIdentifierStart = Z, t.isNewLine = Ee, t.keywordTypes = le, t.lineBreak = W, t.lineBreakG = je, t.nonASCIIwhitespace = ft, t.parse = Nr, t.parseExpressionAt = wr, t.tokContexts = z, t.tokTypes = X, t.tokenizer = Sr, t.version = pr;
    });
  }(sl, sl.exports)), sl.exports;
}
/*!
 * Paper.js v0.12.18 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Wed Jul 17 14:57:24 2024 +0200
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(y) {
  (function(e, t) {
    e = e || td;
    var n = e.window, s = e.document, o = new function() {
      var i = /^(statics|enumerable|beans|preserve)$/, r = [], a = r.slice, l = Object.create, u = Object.getOwnPropertyDescriptor, d = Object.defineProperty, v = r.forEach || function(A, T) {
        for (var G = 0, D = this.length; G < D; G++)
          A.call(T, this[G], G, this);
      }, p = function(A, T) {
        for (var G in this)
          this.hasOwnProperty(G) && A.call(T, this[G], G, this);
      }, b = Object.assign || function(A) {
        for (var T = 1, G = arguments.length; T < G; T++) {
          var D = arguments[T];
          for (var Y in D)
            D.hasOwnProperty(Y) && (A[Y] = D[Y]);
        }
        return A;
      }, S = function(A, T, G) {
        if (A) {
          var D = u(A, "length");
          (D && typeof D.value == "number" ? v : p).call(A, T, G = G || A);
        }
        return G;
      };
      function L(A, T, G, D, Y) {
        var k = {};
        function z(H, ie) {
          ie = ie || (ie = u(T, H)) && (ie.get ? ie : ie.value), typeof ie == "string" && ie[0] === "#" && (ie = A[ie.substring(1)] || ie);
          var ae = typeof ie == "function", ue = ie, me = Y || ae && !ie.base ? ie && ie.get ? H in A : A[H] : null, se;
          (!Y || !me) && (ae && me && (ie.base = me), ae && D !== !1 && (se = H.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (k[se[3].toLowerCase() + se[4]] = se[2]), (!ue || ae || !ue.get || typeof ue.get != "function" || !E.isPlainObject(ue)) && (ue = { value: ue, writable: !0 }), (u(A, H) || { configurable: !0 }).configurable && (ue.configurable = !0, ue.enumerable = G ?? !se), d(A, H, ue));
        }
        if (T) {
          for (var C in T)
            T.hasOwnProperty(C) && !i.test(C) && z(C);
          for (var C in k) {
            var O = k[C], j = A["set" + O], q = A["get" + O] || j && A["is" + O];
            q && (D === !0 || q.length === 0) && z(C, { get: q, set: j });
          }
        }
        return A;
      }
      function E() {
        for (var A = 0, T = arguments.length; A < T; A++) {
          var G = arguments[A];
          G && b(this, G);
        }
        return this;
      }
      return L(E, {
        inject: function(A) {
          if (A) {
            var T = A.statics === !0 ? A : A.statics, G = A.beans, D = A.preserve;
            T !== A && L(this.prototype, A, A.enumerable, G, D), L(this, T, null, G, D);
          }
          for (var Y = 1, k = arguments.length; Y < k; Y++)
            this.inject(arguments[Y]);
          return this;
        },
        extend: function() {
          for (var A = this, T, G, D = 0, Y, k = arguments.length; D < k && !(T && G); D++)
            Y = arguments[D], T = T || Y.initialize, G = G || Y.prototype;
          return T = T || function() {
            A.apply(this, arguments);
          }, G = T.prototype = G || l(this.prototype), d(
            G,
            "constructor",
            { value: T, writable: !0, configurable: !0 }
          ), L(T, this), arguments.length && this.inject.apply(T, arguments), T.base = A, T;
        }
      }).inject({
        enumerable: !1,
        initialize: E,
        set: E,
        inject: function() {
          for (var A = 0, T = arguments.length; A < T; A++) {
            var G = arguments[A];
            G && L(this, G, G.enumerable, G.beans, G.preserve);
          }
          return this;
        },
        extend: function() {
          var A = l(this);
          return A.inject.apply(A, arguments);
        },
        each: function(A, T) {
          return S(this, A, T);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: b,
          each: S,
          create: l,
          define: d,
          describe: u,
          clone: function(A) {
            return b(new A.constructor(), A);
          },
          isPlainObject: function(A) {
            var T = A != null && A.constructor;
            return T && (T === Object || T === E || T.name === "Object");
          },
          pick: function(A, T) {
            return A !== t ? A : T;
          },
          slice: function(A, T, G) {
            return a.call(A, T, G);
          }
        }
      });
    }();
    y.exports = o, o.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + o.each(this, function(i, r) {
          if (!/^_/.test(r)) {
            var a = typeof i;
            this.push(r + ": " + (a === "number" ? B.instance.number(i) : a === "string" ? "'" + i + "'" : i));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(i) {
        return o.importJSON(i, this);
      },
      exportJSON: function(i) {
        return o.exportJSON(this, i);
      },
      toJSON: function() {
        return o.serialize(this);
      },
      set: function(i, r) {
        return i && o.filter(this, i, r, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function i() {
          var r = i.base.apply(this, arguments), a = r.prototype._class;
          return a && !o.exports[a] && (o.exports[a] = r), r;
        },
        equals: function(i, r) {
          if (i === r)
            return !0;
          if (i && i.equals)
            return i.equals(r);
          if (r && r.equals)
            return r.equals(i);
          if (i && r && typeof i == "object" && typeof r == "object") {
            if (Array.isArray(i) && Array.isArray(r)) {
              var a = i.length;
              if (a !== r.length)
                return !1;
              for (; a--; )
                if (!o.equals(i[a], r[a]))
                  return !1;
            } else {
              var l = Object.keys(i), a = l.length;
              if (a !== Object.keys(r).length)
                return !1;
              for (; a--; ) {
                var u = l[a];
                if (!(r.hasOwnProperty(u) && o.equals(i[u], r[u])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(i, r, a, l) {
          if (this === o) {
            var u = this.peek(i, r);
            return i.__index++, u;
          }
          var d = this.prototype, v = d._readIndex, p = r || v && i.__index || 0, b = i.length, S = i[p];
          if (l = l || b - p, S instanceof this || a && a.readNull && S == null && l <= 1)
            return v && (i.__index = p + 1), S && a && a.clone ? S.clone() : S;
          if (S = o.create(d), v && (S.__read = !0), S = S.initialize.apply(S, p > 0 || p + l < b ? o.slice(i, p, p + l) : i) || S, v) {
            i.__index = p + S.__read;
            var L = S.__filtered;
            L && (i.__filtered = L, S.__filtered = t), S.__read = t;
          }
          return S;
        },
        peek: function(i, r) {
          return i[i.__index = r || i.__index || 0];
        },
        remain: function(i) {
          return i.length - (i.__index || 0);
        },
        readList: function(i, r, a, l) {
          for (var u = [], d, v = r || 0, p = l ? v + l : i.length, b = v; b < p; b++)
            u.push(Array.isArray(d = i[b]) ? this.read(d, 0, a) : this.read(i, b, a, 1));
          return u;
        },
        readNamed: function(i, r, a, l, u) {
          var d = this.getNamed(i, r), v = d !== t;
          if (v) {
            var p = i.__filtered;
            if (!p) {
              var b = this.getSource(i);
              p = i.__filtered = o.create(b), p.__unfiltered = b;
            }
            p[r] = t;
          }
          return this.read(v ? [d] : i, a, l, u);
        },
        readSupported: function(i, r) {
          var a = this.getSource(i), l = this, u = !1;
          return a && Object.keys(a).forEach(function(d) {
            if (d in r) {
              var v = l.readNamed(i, d);
              v !== t && (r[d] = v), u = !0;
            }
          }), u;
        },
        getSource: function(i) {
          var r = i.__source;
          if (r === t) {
            var a = i.length === 1 && i[0];
            r = i.__source = a && o.isPlainObject(a) ? a : null;
          }
          return r;
        },
        getNamed: function(i, r) {
          var a = this.getSource(i);
          if (a)
            return r ? a[r] : i.__filtered || a;
        },
        hasNamed: function(i, r) {
          return !!this.getNamed(i, r);
        },
        filter: function(i, r, a, l) {
          var u;
          function d(L) {
            if (!(a && L in a) && !(u && L in u)) {
              var E = r[L];
              E !== t && (i[L] = E);
            }
          }
          if (l) {
            for (var v = {}, p = 0, b, S = l.length; p < S; p++)
              (b = l[p]) in r && (d(b), v[b] = !0);
            u = v;
          }
          return Object.keys(r.__unfiltered || r).forEach(d), i;
        },
        isPlainValue: function(i, r) {
          return o.isPlainObject(i) || Array.isArray(i) || r && typeof i == "string";
        },
        serialize: function(i, r, a, l) {
          r = r || {};
          var u = !l, d;
          if (u && (r.formatter = new B(r.precision), l = {
            length: 0,
            definitions: {},
            references: {},
            add: function(E, A) {
              var T = "#" + E._id, G = this.references[T];
              if (!G) {
                this.length++;
                var D = A.call(E), Y = E._class;
                Y && D[0] !== Y && D.unshift(Y), this.definitions[T] = D, G = this.references[T] = [T];
              }
              return G;
            }
          }), i && i._serialize) {
            d = i._serialize(r, l);
            var v = i._class;
            v && !i._compactSerialize && (u || !a) && d[0] !== v && d.unshift(v);
          } else if (Array.isArray(i)) {
            d = [];
            for (var p = 0, b = i.length; p < b; p++)
              d[p] = o.serialize(i[p], r, a, l);
          } else if (o.isPlainObject(i)) {
            d = {};
            for (var S = Object.keys(i), p = 0, b = S.length; p < b; p++) {
              var L = S[p];
              d[L] = o.serialize(
                i[L],
                r,
                a,
                l
              );
            }
          } else
            typeof i == "number" ? d = r.formatter.number(i, r.precision) : d = i;
          return u && l.length > 0 ? [["dictionary", l.definitions], d] : d;
        },
        deserialize: function(i, r, a, l, u) {
          var d = i, v = !a, p = v && i && i.length && i[0][0] === "dictionary";
          if (a = a || {}, Array.isArray(i)) {
            var b = i[0], S = b === "dictionary";
            if (i.length == 1 && /^#/.test(b))
              return a.dictionary[b];
            b = o.exports[b], d = [];
            for (var L = b ? 1 : 0, E = i.length; L < E; L++)
              d.push(o.deserialize(
                i[L],
                r,
                a,
                S,
                p
              ));
            if (b) {
              var A = d;
              r ? d = r(b, A, v || u) : d = new b(A);
            }
          } else if (o.isPlainObject(i)) {
            d = {}, l && (a.dictionary = d);
            for (var T in i)
              d[T] = o.deserialize(i[T], r, a);
          }
          return p ? d[1] : d;
        },
        exportJSON: function(i, r) {
          var a = o.serialize(i, r);
          return r && r.asString == !1 ? a : JSON.stringify(a);
        },
        importJSON: function(i, r) {
          return o.deserialize(
            typeof i == "string" ? JSON.parse(i) : i,
            function(a, l, u) {
              var d = u && r && r.constructor === a, v = d ? r : o.create(a.prototype);
              if (l.length === 1 && v instanceof X && (d || !(v instanceof je))) {
                var p = l[0];
                o.isPlainObject(p) && (p.insert = !1, d && (l = l.concat([X.INSERT])));
              }
              return (d ? v.set : a).apply(v, l), d && (r = null), v;
            }
          );
        },
        push: function(i, r) {
          var a = r.length;
          if (a < 4096)
            i.push.apply(i, r);
          else {
            var l = i.length;
            i.length += a;
            for (var u = 0; u < a; u++)
              i[l + u] = r[u];
          }
          return i;
        },
        splice: function(i, r, a, l) {
          var u = r && r.length, d = a === t;
          a = d ? i.length : a, a > i.length && (a = i.length);
          for (var v = 0; v < u; v++)
            r[v]._index = a + v;
          if (d)
            return o.push(i, r), [];
          var p = [a, l];
          r && o.push(p, r);
          for (var b = i.splice.apply(i, p), v = 0, S = b.length; v < S; v++)
            b[v]._index = t;
          for (var v = a + u, S = i.length; v < S; v++)
            i[v]._index = v;
          return b;
        },
        capitalize: function(i) {
          return i.replace(/\b[a-z]/g, function(r) {
            return r.toUpperCase();
          });
        },
        camelize: function(i) {
          return i.replace(/-(.)/g, function(r, a) {
            return a.toUpperCase();
          });
        },
        hyphenate: function(i) {
          return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var h = {
      on: function(i, r) {
        if (typeof i != "string")
          o.each(i, function(d, v) {
            this.on(v, d);
          }, this);
        else {
          var a = this._eventTypes, l = a && a[i], u = this._callbacks = this._callbacks || {};
          u = u[i] = u[i] || [], u.indexOf(r) === -1 && (u.push(r), l && l.install && u.length === 1 && l.install.call(this, i));
        }
        return this;
      },
      off: function(i, r) {
        if (typeof i != "string") {
          o.each(i, function(v, p) {
            this.off(p, v);
          }, this);
          return;
        }
        var a = this._eventTypes, l = a && a[i], u = this._callbacks && this._callbacks[i], d;
        return u && (!r || (d = u.indexOf(r)) !== -1 && u.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : d !== -1 && u.splice(d, 1)), this;
      },
      once: function(i, r) {
        return this.on(i, function a() {
          r.apply(this, arguments), this.off(i, a);
        });
      },
      emit: function(i, r) {
        var a = this._callbacks && this._callbacks[i];
        if (!a)
          return !1;
        var l = o.slice(arguments, 1), u = r && r.target && !r.currentTarget;
        a = a.slice(), u && (r.currentTarget = this);
        for (var d = 0, v = a.length; d < v; d++)
          if (a[d].apply(this, l) == !1) {
            r && r.stop && r.stop();
            break;
          }
        return u && delete r.currentTarget, !0;
      },
      responds: function(i) {
        return !!(this._callbacks && this._callbacks[i]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(i) {
        var r = this._eventTypes, a = this._callbacks, l = i ? "install" : "uninstall";
        if (r) {
          for (var u in a)
            if (a[u].length > 0) {
              var d = r[u], v = d && d[l];
              v && v.call(this, u);
            }
        }
      },
      statics: {
        inject: function i(r) {
          var a = r._events;
          if (a) {
            var l = {};
            o.each(a, function(u, d) {
              var v = typeof u == "string", p = v ? u : d, b = o.capitalize(p), S = p.substring(2).toLowerCase();
              l[S] = v ? {} : u, p = "_" + p, r["get" + b] = function() {
                return this[p];
              }, r["set" + b] = function(L) {
                var E = this[p];
                E && this.off(S, E), L && this.on(S, L), this[p] = L;
              };
            }), r._eventTypes = l;
          }
          return i.base.apply(this, arguments);
        }
      }
    }, c = o.extend({
      _class: "PaperScope",
      initialize: function i() {
        Ye = this, this.settings = new o({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
        var r = i.prototype;
        if (!this.support) {
          var a = vt.getContext(1, 1) || {};
          r.support = {
            nativeDash: "setLineDash" in a || "mozDash" in a,
            nativeBlendModes: Qe.nativeModes
          }, vt.release(a);
        }
        if (!this.agent) {
          var l = e.navigator.userAgent.toLowerCase(), u = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], d = u === "darwin" ? "mac" : u, v = r.agent = r.browser = { platform: d };
          d && (v[d] = !0), l.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(p, b, S, L, E) {
              if (!v.chrome) {
                var A = b === "opera" ? L : /^(node|trident)$/.test(b) ? E : S;
                v.version = A, v.versionNumber = parseFloat(A), b = { trident: "msie", jsdom: "node" }[b] || b, v.name = b, v[b] = !0;
              }
            }
          ), v.chrome && delete v.webkit, v.atom && delete v.chrome;
        }
      },
      version: "0.12.18",
      getView: function() {
        var i = this.project;
        return i && i._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(i, r) {
        var a = Ye.PaperScript.execute(i, this, r);
        return Qt.updateFocus(), a;
      },
      install: function(i) {
        var r = this;
        o.each(["project", "view", "tool"], function(l) {
          o.define(i, l, {
            configurable: !0,
            get: function() {
              return r[l];
            }
          });
        });
        for (var a in this)
          !/^_/.test(a) && this[a] && (i[a] = this[a]);
      },
      setup: function(i) {
        return Ye = this, this.project = new fe(i), this;
      },
      createCanvas: function(i, r) {
        return vt.getCanvas(i, r);
      },
      activate: function() {
        Ye = this;
      },
      clear: function() {
        for (var i = this.projects, r = this.tools, a = i.length - 1; a >= 0; a--)
          i[a].remove();
        for (var a = r.length - 1; a >= 0; a--)
          r[a].remove();
      },
      remove: function() {
        this.clear(), delete c._scopes[this._id];
      },
      statics: new function() {
        function i(r) {
          return r += "Attribute", function(a, l) {
            return a[r](l) || a[r]("data-paper-" + l);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(r) {
            return this._scopes[r] || null;
          },
          getAttribute: i("get"),
          hasAttribute: i("has")
        };
      }()
    }), m = o.extend(h, {
      initialize: function(i) {
        this._scope = Ye, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var i = this._scope[this._reference];
        return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (o.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), x = {
      findItemBoundsCollisions: function(i, r, a) {
        function l(v) {
          for (var p = new Array(v.length), b = 0; b < v.length; b++) {
            var S = v[b].getBounds();
            p[b] = [S.left, S.top, S.right, S.bottom];
          }
          return p;
        }
        var u = l(i), d = !r || r === i ? u : l(r);
        return this.findBoundsCollisions(u, d, a || 0);
      },
      findCurveBoundsCollisions: function(i, r, a, l) {
        function u(A) {
          for (var T = Math.min, G = Math.max, D = new Array(A.length), Y = 0; Y < A.length; Y++) {
            var k = A[Y];
            D[Y] = [
              T(k[0], k[2], k[4], k[6]),
              T(k[1], k[3], k[5], k[7]),
              G(k[0], k[2], k[4], k[6]),
              G(k[1], k[3], k[5], k[7])
            ];
          }
          return D;
        }
        var d = u(i), v = !r || r === i ? d : u(r);
        if (l) {
          for (var p = this.findBoundsCollisions(
            d,
            v,
            a || 0,
            !1,
            !0
          ), b = this.findBoundsCollisions(
            d,
            v,
            a || 0,
            !0,
            !0
          ), S = [], L = 0, E = p.length; L < E; L++)
            S[L] = { hor: p[L], ver: b[L] };
          return S;
        }
        return this.findBoundsCollisions(d, v, a || 0);
      },
      findBoundsCollisions: function(i, r, a, l, u) {
        var d = !r || i === r, v = d ? i : i.concat(r), p = i.length, b = v.length;
        function S(et, st, _t) {
          for (var Re = 0, Fe = et.length; Re < Fe; ) {
            var at = Fe + Re >>> 1;
            v[et[at]][st] < _t ? Re = at + 1 : Fe = at;
          }
          return Re - 1;
        }
        for (var L = l ? 1 : 0, E = L + 2, A = l ? 0 : 1, T = A + 2, G = new Array(b), D = 0; D < b; D++)
          G[D] = D;
        G.sort(function(et, st) {
          return v[et][L] - v[st][L];
        });
        for (var Y = [], k = new Array(p), D = 0; D < b; D++) {
          var z = G[D], C = v[z], O = d ? z : z - p, j = z < p, q = d || !j, H = j ? [] : null;
          if (Y.length) {
            var ie = S(
              Y,
              E,
              C[L] - a
            ) + 1;
            if (Y.splice(0, ie), d && u) {
              H = H.concat(Y);
              for (var ae = 0; ae < Y.length; ae++) {
                var ue = Y[ae];
                k[ue].push(O);
              }
            } else
              for (var me = C[T], se = C[A], ae = 0; ae < Y.length; ae++) {
                var ue = Y[ae], de = v[ue], ve = ue < p, we = d || ue >= p;
                (u || (j && we || q && ve) && me >= de[A] - a && se <= de[T] + a) && (j && we && H.push(
                  d ? ue : ue - p
                ), q && ve && k[ue].push(O));
              }
          }
          if (j && (i === r && H.push(z), k[z] = H), Y.length) {
            var Se = C[E], Ae = S(Y, E, Se);
            Y.splice(Ae + 1, 0, z);
          } else
            Y.push(z);
        }
        for (var D = 0; D < k.length; D++) {
          var Ge = k[D];
          Ge && Ge.sort(function(st, _t) {
            return st - _t;
          });
        }
        return k;
      }
    }, B = o.extend({
      initialize: function(i) {
        this.precision = o.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(i) {
        return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
      },
      pair: function(i, r, a) {
        return this.number(i) + (a || ",") + this.number(r);
      },
      point: function(i, r) {
        return this.number(i.x) + (r || ",") + this.number(i.y);
      },
      size: function(i, r) {
        return this.number(i.width) + (r || ",") + this.number(i.height);
      },
      rectangle: function(i, r) {
        return this.point(i, r) + (r || ",") + this.size(i, r);
      }
    });
    B.instance = new B();
    var I = new function() {
      var i = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], r = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], a = Math.abs, l = Math.sqrt, u = Math.pow, d = Math.log2 || function(E) {
        return Math.log(E) * Math.LOG2E;
      }, v = 1e-12, p = 112e-18;
      function b(E, A, T) {
        return E < A ? A : E > T ? T : E;
      }
      function S(E, A, T) {
        function G(ie) {
          var ae = ie * 134217729, ue = ie - ae, me = ue + ae, se = ie - me;
          return [me, se];
        }
        var D = A * A - E * T, Y = A * A + E * T;
        if (a(D) * 3 < Y) {
          var k = G(E), z = G(A), C = G(T), O = A * A, j = z[0] * z[0] - O + 2 * z[0] * z[1] + z[1] * z[1], q = E * T, H = k[0] * C[0] - q + k[0] * C[1] + k[1] * C[0] + k[1] * C[1];
          D = O - q + (j - H);
        }
        return D;
      }
      function L() {
        var E = Math.max.apply(Math, arguments);
        return E && (E < 1e-8 || E > 1e8) ? u(2, -Math.round(d(E))) : 0;
      }
      return {
        EPSILON: v,
        MACHINE_EPSILON: p,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (l(2) - 1) / 3,
        isZero: function(E) {
          return E >= -v && E <= v;
        },
        isMachineZero: function(E) {
          return E >= -p && E <= p;
        },
        clamp: b,
        integrate: function(E, A, T, G) {
          for (var D = i[G - 2], Y = r[G - 2], k = (T - A) * 0.5, z = k + A, C = 0, O = G + 1 >> 1, j = G & 1 ? Y[C++] * E(z) : 0; C < O; ) {
            var q = k * D[C];
            j += Y[C++] * (E(z + q) + E(z - q));
          }
          return k * j;
        },
        findRoot: function(E, A, T, G, D, Y, k) {
          for (var z = 0; z < Y; z++) {
            var C = E(T), O = C / A(T), j = T - O;
            if (a(O) < k) {
              T = j;
              break;
            }
            C > 0 ? (D = T, T = j <= G ? (G + D) * 0.5 : j) : (G = T, T = j >= D ? (G + D) * 0.5 : j);
          }
          return b(T, G, D);
        },
        solveQuadratic: function(E, A, T, G, D, Y) {
          var k, z = 1 / 0;
          if (a(E) < v) {
            if (a(A) < v)
              return a(T) < v ? -1 : 0;
            k = -T / A;
          } else {
            A *= -0.5;
            var C = S(E, A, T);
            if (C && a(C) < p) {
              var O = L(a(E), a(A), a(T));
              O && (E *= O, A *= O, T *= O, C = S(E, A, T));
            }
            if (C >= -p) {
              var j = C < 0 ? 0 : l(C), q = A + (A < 0 ? -j : j);
              q === 0 ? (k = T / E, z = -k) : (k = q / E, z = T / q);
            }
          }
          var H = 0, ie = D == null, ae = D - v, ue = Y + v;
          return isFinite(k) && (ie || k > ae && k < ue) && (G[H++] = ie ? k : b(k, D, Y)), z !== k && isFinite(z) && (ie || z > ae && z < ue) && (G[H++] = ie ? z : b(z, D, Y)), H;
        },
        solveCubic: function(E, A, T, G, D, Y, k) {
          var z = L(a(E), a(A), a(T), a(G)), C, O, j, q, H;
          z && (E *= z, A *= z, T *= z, G *= z);
          function ie(Ae) {
            C = Ae;
            var Ge = E * C;
            O = Ge + A, j = O * C + T, q = (Ge + O) * C + j, H = j * C + G;
          }
          if (a(E) < v)
            E = A, O = T, j = G, C = 1 / 0;
          else if (a(G) < v)
            O = A, j = T, C = 0;
          else {
            ie(-(A / E) / 3);
            var ae = H / E, ue = u(a(ae), 1 / 3), me = ae < 0 ? -1 : 1, se = -q / E, de = se > 0 ? 1.324717957244746 * Math.max(ue, l(se)) : ue, ve = C - me * de;
            if (ve !== C) {
              do
                ie(ve), ve = q === 0 ? C : C - H / q / (1 + p);
              while (me * ve > me * C);
              a(E) * C * C > a(G / C) && (j = -G / C, O = (j - T) / C);
            }
          }
          var we = I.solveQuadratic(E, O, j, D, Y, k), Se = Y == null;
          return isFinite(C) && (we === 0 || we > 0 && C !== D[0] && C !== D[1]) && (Se || C > Y - v && C < k + v) && (D[we++] = Se ? C : b(C, Y, k)), we;
        }
      };
    }(), F = {
      _id: 1,
      _pools: {},
      get: function(i) {
        if (i) {
          var r = this._pools[i];
          return r || (r = this._pools[i] = { _id: 1 }), r._id++;
        } else
          return this._id++;
      }
    }, M = o.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(r, a) {
        var l = typeof r, u = this.__read, d = 0;
        if (l === "number") {
          var v = typeof a == "number";
          this._set(r, v ? a : r), u && (d = v ? 2 : 1);
        } else if (l === "undefined" || r === null)
          this._set(0, 0), u && (d = r === null ? 1 : 0);
        else {
          var p = l === "string" ? r.split(/[\s,]+/) || [] : r;
          d = 1, Array.isArray(p) ? this._set(+p[0], +(p.length > 1 ? p[1] : p[0])) : "x" in p ? this._set(p.x || 0, p.y || 0) : "width" in p ? this._set(p.width || 0, p.height || 0) : "angle" in p ? (this._set(p.length || 0, 0), this.setAngle(p.angle || 0)) : (this._set(0, 0), d = 0);
        }
        return u && (this.__read = d), this;
      },
      set: "#initialize",
      _set: function(i, r) {
        return this.x = i, this.y = r, this;
      },
      equals: function(i) {
        return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
      },
      clone: function() {
        return new M(this.x, this.y);
      },
      toString: function() {
        var i = B.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [r.number(this.x), r.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(i) {
        if (this.isZero()) {
          var r = this._angle || 0;
          this._set(
            Math.cos(r) * i,
            Math.sin(r) * i
          );
        } else {
          var a = i / this.getLength();
          I.isZero(a) && this.getAngle(), this._set(
            this.x * a,
            this.y * a
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(i) {
        this.setAngleInRadians.call(this, i * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var i = M.read(arguments), r = this.getLength() * i.getLength();
          if (I.isZero(r))
            return NaN;
          var a = this.dot(i) / r;
          return Math.acos(a < -1 ? -1 : a > 1 ? 1 : a);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(i) {
        if (this._angle = i, !this.isZero()) {
          var r = this.getLength();
          this._set(
            Math.cos(i) * r,
            Math.sin(i) * r
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var i = M.read(arguments);
        return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
      },
      getDistance: function() {
        var i = arguments, r = M.read(i), a = r.x - this.x, l = r.y - this.y, u = a * a + l * l, d = o.read(i);
        return d ? u : Math.sqrt(u);
      },
      normalize: function(i) {
        i === t && (i = 1);
        var r = this.getLength(), a = r !== 0 ? i / r : 0, l = new M(this.x * a, this.y * a);
        return a >= 0 && (l._angle = this._angle), l;
      },
      rotate: function(i, r) {
        if (i === 0)
          return this.clone();
        i = i * Math.PI / 180;
        var a = r ? this.subtract(r) : this, l = Math.sin(i), u = Math.cos(i);
        return a = new M(
          a.x * u - a.y * l,
          a.x * l + a.y * u
        ), r ? a.add(r) : a;
      },
      transform: function(i) {
        return i ? i._transformPoint(this) : this;
      },
      add: function() {
        var i = M.read(arguments);
        return new M(this.x + i.x, this.y + i.y);
      },
      subtract: function() {
        var i = M.read(arguments);
        return new M(this.x - i.x, this.y - i.y);
      },
      multiply: function() {
        var i = M.read(arguments);
        return new M(this.x * i.x, this.y * i.y);
      },
      divide: function() {
        var i = M.read(arguments);
        return new M(this.x / i.x, this.y / i.y);
      },
      modulo: function() {
        var i = M.read(arguments);
        return new M(this.x % i.x, this.y % i.y);
      },
      negate: function() {
        return new M(-this.x, -this.y);
      },
      isInside: function() {
        return P.read(arguments).contains(this);
      },
      isClose: function() {
        var i = arguments, r = M.read(i), a = o.read(i);
        return this.getDistance(r) <= a;
      },
      isCollinear: function() {
        var i = M.read(arguments);
        return M.isCollinear(this.x, this.y, i.x, i.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var i = M.read(arguments);
        return M.isOrthogonal(this.x, this.y, i.x, i.y);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this.x) && i(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(i) {
        return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var i = M.read(arguments);
        return this.x * i.x + this.y * i.y;
      },
      cross: function() {
        var i = M.read(arguments);
        return this.x * i.y - this.y * i.x;
      },
      project: function() {
        var i = M.read(arguments), r = i.isZero() ? 0 : this.dot(i) / i.dot(i);
        return new M(
          i.x * r,
          i.y * r
        );
      },
      statics: {
        min: function() {
          var i = arguments, r = M.read(i), a = M.read(i);
          return new M(
            Math.min(r.x, a.x),
            Math.min(r.y, a.y)
          );
        },
        max: function() {
          var i = arguments, r = M.read(i), a = M.read(i);
          return new M(
            Math.max(r.x, a.x),
            Math.max(r.y, a.y)
          );
        },
        random: function() {
          return new M(Math.random(), Math.random());
        },
        isCollinear: function(i, r, a, l) {
          return Math.abs(i * l - r * a) <= Math.sqrt((i * i + r * r) * (a * a + l * l)) * 1e-8;
        },
        isOrthogonal: function(i, r, a, l) {
          return Math.abs(i * a + r * l) <= Math.sqrt((i * i + r * r) * (a * a + l * l)) * 1e-8;
        }
      }
    }, o.each(["round", "ceil", "floor", "abs"], function(i) {
      var r = Math[i];
      this[i] = function() {
        return new M(r(this.x), r(this.y));
      };
    }, {})), Z = M.extend({
      initialize: function(r, a, l, u) {
        this._x = r, this._y = a, this._owner = l, this._setter = u;
      },
      _set: function(i, r, a) {
        return this._x = i, this._y = r, a || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), V = o.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(r, a) {
        var l = typeof r, u = this.__read, d = 0;
        if (l === "number") {
          var v = typeof a == "number";
          this._set(r, v ? a : r), u && (d = v ? 2 : 1);
        } else if (l === "undefined" || r === null)
          this._set(0, 0), u && (d = r === null ? 1 : 0);
        else {
          var p = l === "string" ? r.split(/[\s,]+/) || [] : r;
          d = 1, Array.isArray(p) ? this._set(+p[0], +(p.length > 1 ? p[1] : p[0])) : "width" in p ? this._set(p.width || 0, p.height || 0) : "x" in p ? this._set(p.x || 0, p.y || 0) : (this._set(0, 0), d = 0);
        }
        return u && (this.__read = d), this;
      },
      set: "#initialize",
      _set: function(i, r) {
        return this.width = i, this.height = r, this;
      },
      equals: function(i) {
        return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
      },
      clone: function() {
        return new V(this.width, this.height);
      },
      toString: function() {
        var i = B.instance;
        return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [
          r.number(this.width),
          r.number(this.height)
        ];
      },
      add: function() {
        var i = V.read(arguments);
        return new V(this.width + i.width, this.height + i.height);
      },
      subtract: function() {
        var i = V.read(arguments);
        return new V(this.width - i.width, this.height - i.height);
      },
      multiply: function() {
        var i = V.read(arguments);
        return new V(this.width * i.width, this.height * i.height);
      },
      divide: function() {
        var i = V.read(arguments);
        return new V(this.width / i.width, this.height / i.height);
      },
      modulo: function() {
        var i = V.read(arguments);
        return new V(this.width % i.width, this.height % i.height);
      },
      negate: function() {
        return new V(-this.width, -this.height);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this.width) && i(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(i, r) {
          return new V(
            Math.min(i.width, r.width),
            Math.min(i.height, r.height)
          );
        },
        max: function(i, r) {
          return new V(
            Math.max(i.width, r.width),
            Math.max(i.height, r.height)
          );
        },
        random: function() {
          return new V(Math.random(), Math.random());
        }
      }
    }, o.each(["round", "ceil", "floor", "abs"], function(i) {
      var r = Math[i];
      this[i] = function() {
        return new V(r(this.width), r(this.height));
      };
    }, {})), te = V.extend({
      initialize: function(r, a, l, u) {
        this._width = r, this._height = a, this._owner = l, this._setter = u;
      },
      _set: function(i, r, a) {
        return this._width = i, this._height = r, a || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(i) {
        this._width = i, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(i) {
        this._height = i, this._owner[this._setter](this);
      }
    }), P = o.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(r, a, l, u) {
        var d = arguments, v = typeof r, p;
        if (v === "number" ? (this._set(r, a, l, u), p = 4) : v === "undefined" || r === null ? (this._set(0, 0, 0, 0), p = r === null ? 1 : 0) : d.length === 1 && (Array.isArray(r) ? (this._set.apply(this, r), p = 1) : r.x !== t || r.width !== t ? (this._set(
          r.x || 0,
          r.y || 0,
          r.width || 0,
          r.height || 0
        ), p = 1) : r.from === t && r.to === t && (this._set(0, 0, 0, 0), o.readSupported(d, this) && (p = 1))), p === t) {
          var b = M.readNamed(d, "from"), S = o.peek(d), L = b.x, E = b.y, A, T;
          if (S && S.x !== t || o.hasNamed(d, "to")) {
            var G = M.readNamed(d, "to");
            A = G.x - L, T = G.y - E, A < 0 && (L = G.x, A = -A), T < 0 && (E = G.y, T = -T);
          } else {
            var D = V.read(d);
            A = D.width, T = D.height;
          }
          this._set(L, E, A, T), p = d.__index;
        }
        var Y = d.__filtered;
        return Y && (this.__filtered = Y), this.__read && (this.__read = p), this;
      },
      set: "#initialize",
      _set: function(i, r, a, l) {
        return this.x = i, this.y = r, this.width = a, this.height = l, this;
      },
      clone: function() {
        return new P(this.x, this.y, this.width, this.height);
      },
      equals: function(i) {
        var r = o.isPlainValue(i) ? P.read(arguments) : i;
        return r === this || r && this.x === r.x && this.y === r.y && this.width === r.width && this.height === r.height || !1;
      },
      toString: function() {
        var i = B.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [
          r.number(this.x),
          r.number(this.y),
          r.number(this.width),
          r.number(this.height)
        ];
      },
      getPoint: function(i) {
        var r = i ? M : Z;
        return new r(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.x = i.x, this.y = i.y;
      },
      getSize: function(i) {
        var r = i ? V : te;
        return new r(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var i = V.read(arguments), r = this._sx, a = this._sy, l = i.width, u = i.height;
        r && (this.x += (this.width - l) * r), a && (this.y += (this.height - u) * a), this.width = l, this.height = u, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(i) {
        if (!this._fw) {
          var r = i - this.x;
          this.width -= this._sx === 0.5 ? r * 2 : r;
        }
        this.x = i, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(i) {
        if (!this._fh) {
          var r = i - this.y;
          this.height -= this._sy === 0.5 ? r * 2 : r;
        }
        this.y = i, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(i) {
        if (!this._fw) {
          var r = i - this.x;
          this.width = this._sx === 0.5 ? r * 2 : r;
        }
        this.x = i - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(i) {
        if (!this._fh) {
          var r = i - this.y;
          this.height = this._sy === 0.5 ? r * 2 : r;
        }
        this.y = i - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(i) {
        this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(i) {
        this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(i) {
        var r = i ? M : Z;
        return new r(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var i = M.read(arguments);
        return this.setCenterX(i.x), this.setCenterY(i.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(i) {
        return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(P.read(arguments)) : this._containsPoint(M.read(arguments));
      },
      _containsPoint: function(i) {
        var r = i.x, a = i.y;
        return r >= this.x && a >= this.y && r <= this.x + this.width && a <= this.y + this.height;
      },
      _containsRectangle: function(i) {
        var r = i.x, a = i.y;
        return r >= this.x && a >= this.y && r + i.width <= this.x + this.width && a + i.height <= this.y + this.height;
      },
      intersects: function() {
        var i = P.read(arguments), r = o.read(arguments) || 0;
        return i.x + i.width > this.x - r && i.y + i.height > this.y - r && i.x < this.x + this.width + r && i.y < this.y + this.height + r;
      },
      intersect: function() {
        var i = P.read(arguments), r = Math.max(this.x, i.x), a = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), u = Math.min(this.y + this.height, i.y + i.height);
        return new P(r, a, l - r, u - a);
      },
      unite: function() {
        var i = P.read(arguments), r = Math.min(this.x, i.x), a = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), u = Math.max(this.y + this.height, i.y + i.height);
        return new P(r, a, l - r, u - a);
      },
      include: function() {
        var i = M.read(arguments), r = Math.min(this.x, i.x), a = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), u = Math.max(this.y + this.height, i.y);
        return new P(r, a, l - r, u - a);
      },
      expand: function() {
        var i = V.read(arguments), r = i.width, a = i.height;
        return new P(
          this.x - r / 2,
          this.y - a / 2,
          this.width + r,
          this.height + a
        );
      },
      scale: function(i, r) {
        return this.expand(
          this.width * i - this.width,
          this.height * (r === t ? i : r) - this.height
        );
      }
    }, o.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(i, r) {
        var a = i.join(""), l = /^[RL]/.test(a);
        r >= 4 && (i[1] += l ? "Y" : "X");
        var u = i[l ? 0 : 1], d = i[l ? 1 : 0], v = "get" + u, p = "get" + d, b = "set" + u, S = "set" + d, L = "get" + a, E = "set" + a;
        this[L] = function(A) {
          var T = A ? M : Z;
          return new T(this[v](), this[p](), this, E);
        }, this[E] = function() {
          var A = M.read(arguments);
          this[b](A.x), this[S](A.y);
        };
      },
      {
        beans: !0
      }
    )), K = P.extend(
      {
        initialize: function(r, a, l, u, d, v) {
          this._set(r, a, l, u, !0), this._owner = d, this._setter = v;
        },
        _set: function(i, r, a, l, u) {
          return this._x = i, this._y = r, this._width = a, this._height = l, u || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var i = P.prototype;
        return o.each(
          ["x", "y", "width", "height"],
          function(r) {
            var a = o.capitalize(r), l = "_" + r;
            this["get" + a] = function() {
              return this[l];
            }, this["set" + a] = function(u) {
              this[l] = u, this._dontNotify || this._owner[this._setter](this);
            };
          },
          o.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(r) {
              var a = "set" + r;
              this[a] = function() {
                this._dontNotify = !0, i[a].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(r) {
                var a = this._owner;
                a._changeSelection && a._changeSelection(2, r);
              }
            }
          )
        );
      }()
    ), J = o.extend({
      _class: "Matrix",
      initialize: function i(r, a) {
        var l = arguments, u = l.length, d = !0;
        if (u >= 6 ? this._set.apply(this, l) : u === 1 || u === 2 ? r instanceof i ? this._set(
          r._a,
          r._b,
          r._c,
          r._d,
          r._tx,
          r._ty,
          a
        ) : Array.isArray(r) ? this._set.apply(
          this,
          a ? r.concat([a]) : r
        ) : d = !1 : u ? d = !1 : this.reset(), !d)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(i, r, a, l, u, d, v) {
        return this._a = i, this._b = r, this._c = a, this._d = l, this._tx = u, this._ty = d, v || this._changed(), this;
      },
      _serialize: function(i, r) {
        return o.serialize(this.getValues(), i, !0, r);
      },
      _changed: function() {
        var i = this._owner;
        i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
      },
      clone: function() {
        return new J(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(i) {
        return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
      },
      toString: function() {
        var i = B.instance;
        return "[[" + [
          i.number(this._a),
          i.number(this._c),
          i.number(this._tx)
        ].join(", ") + "], [" + [
          i.number(this._b),
          i.number(this._d),
          i.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(i) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
      },
      apply: function(i, r) {
        var a = this._owner;
        return a ? (a.transform(null, o.pick(i, !0), r), this.isIdentity()) : !1;
      },
      translate: function() {
        var i = M.read(arguments), r = i.x, a = i.y;
        return this._tx += r * this._a + a * this._c, this._ty += r * this._b + a * this._d, this._changed(), this;
      },
      scale: function() {
        var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 });
        return a && this.translate(a), this._a *= r.x, this._b *= r.x, this._c *= r.y, this._d *= r.y, a && this.translate(a.negate()), this._changed(), this;
      },
      rotate: function(i) {
        i *= Math.PI / 180;
        var r = M.read(arguments, 1), a = r.x, l = r.y, u = Math.cos(i), d = Math.sin(i), v = a - a * u + l * d, p = l - a * d - l * u, b = this._a, S = this._b, L = this._c, E = this._d;
        return this._a = u * b + d * L, this._b = u * S + d * E, this._c = -d * b + u * L, this._d = -d * S + u * E, this._tx += v * b + p * L, this._ty += v * S + p * E, this._changed(), this;
      },
      shear: function() {
        var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 });
        a && this.translate(a);
        var l = this._a, u = this._b;
        return this._a += r.y * this._c, this._b += r.y * this._d, this._c += r.x * l, this._d += r.x * u, a && this.translate(a.negate()), this._changed(), this;
      },
      skew: function() {
        var i = arguments, r = M.read(i), a = M.read(i, 0, { readNull: !0 }), l = Math.PI / 180, u = new M(
          Math.tan(r.x * l),
          Math.tan(r.y * l)
        );
        return this.shear(u, a);
      },
      append: function(i, r) {
        if (i) {
          var a = this._a, l = this._b, u = this._c, d = this._d, v = i._a, p = i._c, b = i._b, S = i._d, L = i._tx, E = i._ty;
          this._a = v * a + b * u, this._c = p * a + S * u, this._b = v * l + b * d, this._d = p * l + S * d, this._tx += L * a + E * u, this._ty += L * l + E * d, r || this._changed();
        }
        return this;
      },
      prepend: function(i, r) {
        if (i) {
          var a = this._a, l = this._b, u = this._c, d = this._d, v = this._tx, p = this._ty, b = i._a, S = i._c, L = i._b, E = i._d, A = i._tx, T = i._ty;
          this._a = b * a + S * l, this._c = b * u + S * d, this._b = L * a + E * l, this._d = L * u + E * d, this._tx = b * v + S * p + A, this._ty = L * v + E * p + T, r || this._changed();
        }
        return this;
      },
      appended: function(i) {
        return this.clone().append(i);
      },
      prepended: function(i) {
        return this.clone().prepend(i);
      },
      invert: function() {
        var i = this._a, r = this._b, a = this._c, l = this._d, u = this._tx, d = this._ty, v = i * l - r * a, p = null;
        return v && !isNaN(v) && isFinite(u) && isFinite(d) && (this._a = l / v, this._b = -r / v, this._c = -a / v, this._d = i / v, this._tx = (a * d - l * u) / v, this._ty = (r * u - i * d) / v, p = this), p;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new J(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var i = this._a * this._d - this._c * this._b;
        return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(i, r, a) {
        return arguments.length < 3 ? this._transformPoint(M.read(arguments)) : this._transformCoordinates(i, r, a);
      },
      _transformPoint: function(i, r, a) {
        var l = i.x, u = i.y;
        return r || (r = new M()), r._set(
          l * this._a + u * this._c + this._tx,
          l * this._b + u * this._d + this._ty,
          a
        );
      },
      _transformCoordinates: function(i, r, a) {
        for (var l = 0, u = 2 * a; l < u; l += 2) {
          var d = i[l], v = i[l + 1];
          r[l] = d * this._a + v * this._c + this._tx, r[l + 1] = d * this._b + v * this._d + this._ty;
        }
        return r;
      },
      _transformCorners: function(i) {
        var r = i.x, a = i.y, l = r + i.width, u = a + i.height, d = [r, a, l, a, l, u, r, u];
        return this._transformCoordinates(d, d, 4);
      },
      _transformBounds: function(i, r, a) {
        for (var l = this._transformCorners(i), u = l.slice(0, 2), d = u.slice(), v = 2; v < 8; v++) {
          var p = l[v], b = v & 1;
          p < u[b] ? u[b] = p : p > d[b] && (d[b] = p);
        }
        return r || (r = new P()), r._set(
          u[0],
          u[1],
          d[0] - u[0],
          d[1] - u[1],
          a
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(M.read(arguments));
      },
      _inverseTransform: function(i, r, a) {
        var l = this._a, u = this._b, d = this._c, v = this._d, p = this._tx, b = this._ty, S = l * v - u * d, L = null;
        if (S && !isNaN(S) && isFinite(p) && isFinite(b)) {
          var E = i.x - this._tx, A = i.y - this._ty;
          r || (r = new M()), L = r._set(
            (E * v - A * d) / S,
            (A * l - E * u) / S,
            a
          );
        }
        return L;
      },
      decompose: function() {
        var i = this._a, r = this._b, a = this._c, l = this._d, u = i * l - r * a, d = Math.sqrt, v = Math.atan2, p = 180 / Math.PI, b, S, L;
        if (i !== 0 || r !== 0) {
          var E = d(i * i + r * r);
          b = Math.acos(i / E) * (r > 0 ? 1 : -1), S = [E, u / E], L = [v(i * a + r * l, E * E), 0];
        } else if (a !== 0 || l !== 0) {
          var A = d(a * a + l * l);
          b = Math.asin(a / A) * (l > 0 ? 1 : -1), S = [u / A, A], L = [0, v(i * a + r * l, A * A)];
        } else
          b = 0, L = S = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: b * p,
          scaling: new M(S),
          skewing: new M(L[0] * p, L[1] * p)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new M(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(i) {
        this.isIdentity() || i.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, o.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
      var r = o.capitalize(i), a = "_" + i;
      this["get" + r] = function() {
        return this[a];
      }, this["set" + r] = function(l) {
        this[a] = l, this._changed();
      };
    }, {})), le = o.extend({
      _class: "Line",
      initialize: function(r, a, l, u, d) {
        var v = !1;
        arguments.length >= 4 ? (this._px = r, this._py = a, this._vx = l, this._vy = u, v = d) : (this._px = r.x, this._py = r.y, this._vx = a.x, this._vy = a.y, v = l), v || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new M(this._px, this._py);
      },
      getVector: function() {
        return new M(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(i, r) {
        return le.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i._px,
          i._py,
          i._vx,
          i._vy,
          !0,
          r
        );
      },
      getSide: function(i, r) {
        return le.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0,
          r
        );
      },
      getDistance: function(i) {
        return Math.abs(this.getSignedDistance(i));
      },
      getSignedDistance: function(i) {
        return le.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0
        );
      },
      isCollinear: function(i) {
        return M.isCollinear(this._vx, this._vy, i._vx, i._vy);
      },
      isOrthogonal: function(i) {
        return M.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
      },
      statics: {
        intersect: function(i, r, a, l, u, d, v, p, b, S) {
          b || (a -= i, l -= r, v -= u, p -= d);
          var L = a * p - l * v;
          if (!I.isMachineZero(L)) {
            var E = i - u, A = r - d, T = (v * A - p * E) / L, G = (a * A - l * E) / L, D = 1e-12, Y = -D, k = 1 + D;
            if (S || Y < T && T < k && Y < G && G < k)
              return S || (T = T <= 0 ? 0 : T >= 1 ? 1 : T), new M(
                i + T * a,
                r + T * l
              );
          }
        },
        getSide: function(i, r, a, l, u, d, v, p) {
          v || (a -= i, l -= r);
          var b = u - i, S = d - r, L = b * l - S * a;
          return !p && I.isMachineZero(L) && (L = (b * a + b * a) / (a * a + l * l), L >= 0 && L <= 1 && (L = 0)), L < 0 ? -1 : L > 0 ? 1 : 0;
        },
        getSignedDistance: function(i, r, a, l, u, d, v) {
          return v || (a -= i, l -= r), a === 0 ? l > 0 ? u - i : i - u : l === 0 ? a < 0 ? d - r : r - d : ((u - i) * l - (d - r) * a) / (l > a ? l * Math.sqrt(1 + a * a / (l * l)) : a * Math.sqrt(1 + l * l / (a * a)));
        },
        getDistance: function(i, r, a, l, u, d, v) {
          return Math.abs(
            le.getSignedDistance(i, r, a, l, u, d, v)
          );
        }
      }
    }), fe = m.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(r) {
        m.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new ui(null, null, this), this._view = Qt.create(
          this,
          r || vt.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(i, r) {
        return o.serialize(this._children, i, !0, r);
      },
      _changed: function(i, r) {
        if (i & 1) {
          var a = this._view;
          a && (a._needsUpdate = !0, !a._requested && a._autoUpdate && a.requestUpdate());
        }
        var l = this._changes;
        if (l && r) {
          var u = this._changesById, d = r._id, v = u[d];
          v ? v.flags |= i : l.push(u[d] = { item: r, flags: i });
        }
      },
      clear: function() {
        for (var i = this._children, r = i.length - 1; r >= 0; r--)
          i[r].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function i() {
        return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(i) {
        this._currentStyle.set(i);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new je({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var i = [], r = {};
        return this.getItems({
          class: ft,
          match: function(a) {
            var l = a._definition, u = l._id;
            return r[u] || (r[u] = !0, i.push(l)), !1;
          }
        }), i;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var i = this._selectionItems, r = [];
        for (var a in i) {
          var l = i[a], u = l._selection;
          u & 1 && l.isInserted() ? r.push(l) : u || this._updateSelection(l);
        }
        return r;
      },
      _updateSelection: function(i) {
        var r = i._id, a = this._selectionItems;
        i._selection ? a[r] !== i && (this._selectionCount++, a[r] = i) : a[r] === i && (this._selectionCount--, delete a[r]);
      },
      selectAll: function() {
        for (var i = this._children, r = 0, a = i.length; r < a; r++)
          i[r].setFullySelected(!0);
      },
      deselectAll: function() {
        var i = this._selectionItems;
        for (var r in i)
          i[r].setFullySelected(!1);
      },
      addLayer: function(i) {
        return this.insertLayer(t, i);
      },
      insertLayer: function(i, r) {
        if (r instanceof je) {
          r._remove(!1, !0), o.splice(this._children, [r], i, 0), r._setProject(this, !0);
          var a = r._name;
          a && r.setName(a), this._changes && r._changed(5), this._activeLayer || (this._activeLayer = r);
        } else
          r = null;
        return r;
      },
      _insertItem: function(i, r, a) {
        return r = this.insertLayer(i, r) || (this._activeLayer || this._insertItem(
          t,
          new je(X.NO_INSERT),
          !0
        )).insertChild(i, r), a && r.activate && r.activate(), r;
      },
      getItems: function(i) {
        return X._getItems(this, i);
      },
      getItem: function(i) {
        return X._getItems(this, i, null, null, !0)[0] || null;
      },
      importJSON: function(i) {
        this.activate();
        var r = this._activeLayer;
        return o.importJSON(i, r && r.isEmpty() && r);
      },
      removeOn: function(i) {
        var r = this._removeSets;
        if (r) {
          i === "mouseup" && (r.mousedrag = null);
          var a = r[i];
          if (a) {
            for (var l in a) {
              var u = a[l];
              for (var d in r) {
                var v = r[d];
                v && v != a && delete v[u._id];
              }
              u.remove();
            }
            r[i] = null;
          }
        }
      },
      draw: function(i, r, a) {
        this._updateVersion++, i.save(), r.applyToContext(i);
        for (var l = this._children, u = new o({
          offset: new M(0, 0),
          pixelRatio: a,
          viewMatrix: r.isIdentity() ? null : r,
          matrices: [new J()],
          updateMatrix: !0
        }), d = 0, v = l.length; d < v; d++)
          l[d].draw(i, u);
        if (i.restore(), this._selectionCount > 0) {
          i.save(), i.strokeWidth = 1;
          var p = this._selectionItems, b = this._scope.settings.handleSize, S = this._updateVersion;
          for (var L in p)
            p[L]._drawSelection(i, r, b, p, S);
          i.restore();
        }
      }
    }), X = o.extend(
      h,
      {
        statics: {
          extend: function i(r) {
            return r._serializeFields && (r._serializeFields = o.set(
              {},
              this.prototype._serializeFields,
              r._serializeFields
            )), i.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new J(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var i = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return o.each(
          i,
          function(r) {
            this._events[r] = {
              install: function(a) {
                this.getView()._countItemEvent(a, 1);
              },
              uninstall: function(a) {
                this.getView()._countItemEvent(a, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: i
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(i, r) {
          var a = i && o.isPlainObject(i), l = a && i.internal === !0, u = this._matrix = new J(), d = a && i.project || Ye.project, v = Ye.settings;
          return this._id = l ? null : F.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && v.applyMatrix, r && u.translate(r), u._owner = this, this._style = new ui(d._currentStyle, this, d), l || a && i.insert == !1 || !v.insertItems && !(a && i.insert == !0) ? this._setProject(d) : (a && i.parent || d)._insertItem(t, this, !0), a && i !== X.NO_INSERT && i !== X.INSERT && this.set(i, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), a;
        },
        _serialize: function(i, r) {
          var a = {}, l = this;
          function u(d) {
            for (var v in d) {
              var p = l[v];
              o.equals(p, v === "leading" ? d.fontSize * 1.2 : d[v]) || (a[v] = o.serialize(
                p,
                i,
                v !== "data",
                r
              ));
            }
          }
          return u(this._serializeFields), this instanceof W || u(this._style._defaults), [this._class, a];
        },
        _changed: function(i) {
          var r = this._symbol, a = this._parent || r, l = this._project;
          i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), a && i & 72 && X._clearBoundsCache(a), i & 2 && X._clearBoundsCache(this), l && l._changed(i, this), r && r._changed(i);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(i) {
          if (this._name && this._removeNamed(), i === +i + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var r = this._getOwner();
          if (i && r) {
            var a = r._children, l = r._namedChildren;
            (l[i] = l[i] || []).push(this), i in a || (a[i] = this);
          }
          this._name = i || t, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(i) {
          this.getStyle().set(i);
        }
      },
      o.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(i) {
          var r = o.capitalize(i), a = "_" + i, l = {
            locked: 256,
            visible: 265
          };
          this["get" + r] = function() {
            return this[a];
          }, this["set" + r] = function(u) {
            u != this[a] && (this[a] = u, this._changed(l[i] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          if (i !== this._selection) {
            this._selection = i;
            var r = this._project;
            r && (r._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(i, r) {
          var a = this._selection;
          this.setSelection(r ? a | i : a & ~i);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var i = this._children, r = 0, a = i.length; r < a; r++)
              if (i[r].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(i) {
          if (this._selectChildren)
            for (var r = this._children, a = 0, l = r.length; a < l; a++)
              r[a].setSelected(i);
          this._changeSelection(1, i);
        },
        isFullySelected: function() {
          var i = this._children, r = !!(this._selection & 1);
          if (i && r) {
            for (var a = 0, l = i.length; a < l; a++)
              if (!i[a].isFullySelected())
                return !1;
            return !0;
          }
          return r;
        },
        setFullySelected: function(i) {
          var r = this._children;
          if (r)
            for (var a = 0, l = r.length; a < l; a++)
              r[a].setFullySelected(i);
          this._changeSelection(1, i);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(i) {
          this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(i) {
          this._data = i;
        },
        getPosition: function(i) {
          var r = i ? M : Z, a = this._position || (this._position = this._getPositionFromBounds());
          return new r(a.x, a.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(M.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(i) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var i = this._pivot;
          return i ? new Z(i.x, i.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = M.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
        }
      },
      o.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(i, r) {
          this[r] = function(a) {
            return this.getBounds(a, i);
          };
        },
        {
          beans: !0,
          getBounds: function(i, r) {
            var a = r || i instanceof J, l = o.set(
              {},
              a ? r : i,
              this._boundsOptions
            );
            (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
            var u = this._getCachedBounds(a && i, l).rect;
            return arguments.length ? u : new K(
              u.x,
              u.y,
              u.width,
              u.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var i = P.read(arguments), r = this.getBounds(), a = this._matrix, l = new J(), u = i.getCenter();
            l.translate(u), (i.width != r.width || i.height != r.height) && (a.isInvertible() || (a.set(a._backup || new J().translate(a.getTranslation())), r = this.getBounds()), l.scale(
              r.width !== 0 ? i.width / r.width : 0,
              r.height !== 0 ? i.height / r.height : 0
            )), u = r.getCenter(), l.translate(-u.x, -u.y), this.transform(l);
          },
          _getBounds: function(i, r) {
            var a = this._children;
            return !a || !a.length ? new P() : (X._updateBoundsCache(this, r.cacheItem), X._getBounds(a, i, r));
          },
          _getBoundsCacheKey: function(i, r) {
            return [
              i.stroke ? 1 : 0,
              i.handle ? 1 : 0,
              r ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(i, r, a) {
            i = i && i._orNullIfIdentity();
            var l = r.internal && !a, u = r.cacheItem, d = l ? null : this._matrix._orNullIfIdentity(), v = u && (!i || i.equals(d)) && this._getBoundsCacheKey(r, l), p = this._bounds;
            if (X._updateBoundsCache(this._parent || this._symbol, u), v && p && v in p) {
              var b = p[v];
              return {
                rect: b.rect.clone(),
                nonscaling: b.nonscaling
              };
            }
            var S = this._getBounds(i || d, r), L = S.rect || S, E = this._style, A = S.nonscaling || E.hasStroke() && !E.getStrokeScaling();
            if (v) {
              p || (this._bounds = p = {});
              var b = p[v] = {
                rect: L.clone(),
                nonscaling: A,
                internal: l
              };
            }
            return {
              rect: L,
              nonscaling: A
            };
          },
          _getStrokeMatrix: function(i, r) {
            var a = this.getStrokeScaling() ? null : r && r.internal ? this : this._parent || this._symbol && this._symbol._item, l = a ? a.getViewMatrix().invert() : i;
            return l && l._shiftless();
          },
          statics: {
            _updateBoundsCache: function(i, r) {
              if (i && r) {
                var a = r._id, l = i._boundsCache = i._boundsCache || {
                  ids: {},
                  list: []
                };
                l.ids[a] || (l.list.push(r), l.ids[a] = r);
              }
            },
            _clearBoundsCache: function(i) {
              var r = i._boundsCache;
              if (r) {
                i._bounds = i._position = i._boundsCache = t;
                for (var a = 0, l = r.list, u = l.length; a < u; a++) {
                  var d = l[a];
                  d !== i && (d._bounds = d._position = t, d._boundsCache && X._clearBoundsCache(d));
                }
              }
            },
            _getBounds: function(i, r, a) {
              var l = 1 / 0, u = -l, d = l, v = u, p = !1;
              a = a || {};
              for (var b = 0, S = i.length; b < S; b++) {
                var L = i[b];
                if (L._visible && !L.isEmpty(!0)) {
                  var E = L._getCachedBounds(
                    r && r.appended(L._matrix),
                    a,
                    !0
                  ), A = E.rect;
                  l = Math.min(A.x, l), d = Math.min(A.y, d), u = Math.max(A.x + A.width, u), v = Math.max(A.y + A.height, v), E.nonscaling && (p = !0);
                }
              }
              return {
                rect: isFinite(l) ? new P(l, d, u - l, v - d) : new P(),
                nonscaling: p
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var i = this._decompose();
          return i ? i.rotation : 0;
        },
        setRotation: function(i) {
          var r = this.getRotation();
          if (r != null && i != null) {
            var a = this._decomposed;
            this.rotate(i - r), a && (a.rotation = i, this._decomposed = a);
          }
        },
        getScaling: function() {
          var i = this._decompose(), r = i && i.scaling;
          return new Z(r ? r.x : 1, r ? r.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
          if (i && r && !i.equals(r)) {
            var a = this.getRotation(), l = this._decomposed, u = new J(), d = I.isZero;
            if (d(i.x) || d(i.y))
              u.translate(l.translation), a && u.rotate(a), u.scale(r.x, r.y), this._matrix.set(u);
            else {
              var v = this.getPosition(!0);
              u.translate(v), a && u.rotate(a), u.scale(r.x / i.x, r.y / i.y), a && u.rotate(-a), u.translate(v.negate()), this.transform(u);
            }
            l && (l.scaling = r, this._decomposed = l);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        getGlobalMatrix: function(i) {
          var r = this._globalMatrix;
          if (r)
            for (var a = this._parent, l = []; a; ) {
              if (!a._globalMatrix) {
                r = null;
                for (var u = 0, d = l.length; u < d; u++)
                  l[u]._globalMatrix = null;
                break;
              }
              l.push(a), a = a._parent;
            }
          if (!r) {
            r = this._globalMatrix = this._matrix.clone();
            var a = this._parent;
            a && r.prepend(a.getGlobalMatrix(!0));
          }
          return i ? r : r.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(i) {
          (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(i, r) {
          if (this._project !== i) {
            this._project && this._installEvents(!1), this._project = i;
            for (var a = this._children, l = 0, u = a && a.length; l < u; l++)
              a[l]._setProject(i);
            r = !0;
          }
          r && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function i(r) {
          i.base.call(this, r);
          for (var a = this._children, l = 0, u = a && a.length; l < u; l++)
            a[l]._installEvents(r);
        },
        getLayer: function() {
          for (var i = this; i = i._parent; )
            if (i instanceof je)
              return i;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(i) {
          return i.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(i) {
          this.removeChildren(), this.addChildren(i);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        setIndex: function(i) {
          var r = this._parent, a = r && r._children;
          a && r.insertChildren(
            i in a ? i : t,
            [this]
          );
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
        },
        _equals: function(i) {
          return o.equals(this._children, i._children);
        },
        clone: function(i) {
          var r = new this.constructor(X.NO_INSERT), a = this._children, l = o.pick(
            i ? i.insert : t,
            i === t || i === !0
          ), u = o.pick(i ? i.deep : t, !0);
          a && r.copyAttributes(this), (!a || u) && r.copyContent(this), a || r.copyAttributes(this), l && r.insertAbove(this);
          var d = this._name, v = this._parent;
          if (d && v) {
            for (var a = v._children, p = d, b = 1; a[d]; )
              d = p + " " + b++;
            d !== p && r.setName(d);
          }
          return r;
        },
        copyContent: function(i) {
          for (var r = i._children, a = 0, l = r && r.length; a < l; a++)
            this.addChild(r[a].clone(!1), !0);
        },
        copyAttributes: function(i, r) {
          this.setStyle(i._style);
          for (var a = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], l = 0, u = a.length; l < u; l++) {
            var d = a[l];
            i.hasOwnProperty(d) && (this[d] = i[d]);
          }
          r || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
          var v = i._data, p = i._name;
          this._data = v ? o.clone(v) : null, p && this.setName(p);
        },
        rasterize: function(i, r) {
          var a, l, u;
          o.isPlainObject(i) ? (a = i.resolution, l = i.insert, u = i.raster) : (a = i, l = r), u || (u = new He(X.NO_INSERT));
          var d = this.getStrokeBounds(), v = (a || this.getView().getResolution()) / 72, p = d.getTopLeft().floor(), b = d.getBottomRight().ceil(), S = new V(b.subtract(p)), L = S.multiply(v);
          if (u.setSize(L, !0), !L.isZero()) {
            var E = u.getContext(!0), A = new J().scale(v).translate(p.negate());
            E.save(), A.applyToContext(E), this.draw(E, new o({ matrices: [A] })), E.restore();
          }
          return u._matrix.set(
            new J().translate(p.add(S.divide(2))).scale(1 / v)
          ), (l === t || l) && u.insertAbove(this), u;
        },
        contains: function() {
          var i = this._matrix;
          return i.isInvertible() && !!this._contains(i._inverseTransform(M.read(arguments)));
        },
        _contains: function(i) {
          var r = this._children;
          if (r) {
            for (var a = r.length - 1; a >= 0; a--)
              if (r[a].contains(i))
                return !0;
            return !1;
          }
          return i.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return P.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new We.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(i, r) {
          return i instanceof X ? this._asPathItem().getIntersections(
            i._asPathItem(),
            null,
            r,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function i() {
          var l = arguments;
          return this._hitTest(
            M.read(l),
            $e.getOptions(l)
          );
        }
        function r() {
          var l = arguments, u = M.read(l), d = $e.getOptions(l), v = [];
          return this._hitTest(u, new o({ all: v }, d)), v;
        }
        function a(l, u, d, v) {
          var p = this._children;
          if (p)
            for (var b = p.length - 1; b >= 0; b--) {
              var S = p[b], L = S !== v && S._hitTest(
                l,
                u,
                d
              );
              if (L && !u.all)
                return L;
            }
          return null;
        }
        return fe.inject({
          hitTest: i,
          hitTestAll: r,
          _hitTest: a
        }), {
          hitTest: i,
          hitTestAll: r,
          _hitTestChildren: a
        };
      }(),
      {
        _hitTest: function(i, r, a) {
          if (this._locked || !this._visible || this._guide && !r.guides || this.isEmpty())
            return null;
          var l = this._matrix, u = a ? a.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), d = Math.max(r.tolerance, 1e-12), v = r._tolerancePadding = new V(
            We._getStrokePadding(
              d,
              l._shiftless().invert()
            )
          );
          if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(v.multiply(2))._containsPoint(i))
            return null;
          var p = !(r.guides && !this._guide || r.selected && !this.isSelected() || r.type && r.type !== o.hyphenate(this._class) || r.class && !(this instanceof r.class)), b = r.match, S = this, L, E;
          function A(C) {
            return C && b && !b(C) && (C = null), C && r.all && r.all.push(C), C;
          }
          function T(C, O) {
            var j = O ? L["get" + O]() : S.getPosition();
            if (i.subtract(j).divide(v).length <= 1)
              return new $e(C, S, {
                name: O ? o.hyphenate(O) : C,
                point: j
              });
          }
          var G = r.position, D = r.center, Y = r.bounds;
          if (p && this._parent && (G || D || Y)) {
            if ((D || Y) && (L = this.getInternalBounds()), E = G && T("position") || D && T("center", "Center"), !E && Y)
              for (var k = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], z = 0; z < 8 && !E; z++)
                E = T("bounds", k[z]);
            E = A(E);
          }
          return E || (E = this._hitTestChildren(i, r, u) || p && A(this._hitTestSelf(
            i,
            r,
            u,
            this.getStrokeScaling() ? null : u._shiftless().invert()
          )) || null), E && E.point && (E.point = l.transform(E.point)), E;
        },
        _hitTestSelf: function(i, r) {
          if (r.fill && this.hasFill() && this._contains(i))
            return new $e("fill", this);
        },
        matches: function(i, r) {
          function a(v, p) {
            for (var b in v)
              if (v.hasOwnProperty(b)) {
                var S = v[b], L = p[b];
                if (o.isPlainObject(S) && o.isPlainObject(L)) {
                  if (!a(S, L))
                    return !1;
                } else if (!o.equals(S, L))
                  return !1;
              }
            return !0;
          }
          var l = typeof i;
          if (l === "object") {
            for (var u in i)
              if (i.hasOwnProperty(u) && !this.matches(u, i[u]))
                return !1;
            return !0;
          } else {
            if (l === "function")
              return i(this);
            if (i === "match")
              return r(this);
            var d = /^(empty|editable)$/.test(i) ? this["is" + o.capitalize(i)]() : i === "type" ? o.hyphenate(this._class) : this[i];
            if (i === "class") {
              if (typeof r == "function")
                return this instanceof r;
              d = this._class;
            }
            if (typeof r == "function")
              return !!r(d);
            if (r) {
              if (r.test)
                return r.test(d);
              if (o.isPlainObject(r))
                return a(r, d);
            }
            return o.equals(d, r);
          }
        },
        getItems: function(i) {
          return X._getItems(this, i, this._matrix);
        },
        getItem: function(i) {
          return X._getItems(this, i, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function i(r, a, l, u, d) {
            if (!u) {
              var v = typeof a == "object" && a, p = v && v.overlapping, b = v && v.inside, S = p || b, A = S && P.read([S]);
              u = {
                items: [],
                recursive: v && v.recursive !== !1,
                inside: !!b,
                overlapping: !!p,
                rect: A,
                path: p && new We.Rectangle({
                  rectangle: A,
                  insert: !1
                })
              }, v && (a = o.filter({}, a, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var L = r._children, E = u.items, A = u.rect;
            l = A && (l || new J());
            for (var T = 0, G = L && L.length; T < G; T++) {
              var D = L[T], Y = l && l.appended(D._matrix), k = !0;
              if (A) {
                var S = D.getBounds(Y);
                if (!A.intersects(S))
                  continue;
                A.contains(S) || u.overlapping && (S.contains(A) || u.path.intersects(D, Y)) || (k = !1);
              }
              if (k && D.matches(a) && (E.push(D), d) || (u.recursive !== !1 && i(D, a, Y, u, d), d && E.length > 0))
                break;
            }
            return E;
          }
        }
      },
      {
        importJSON: function(i) {
          var r = o.importJSON(i, this);
          return r !== this ? this.addChild(r) : r;
        },
        addChild: function(i) {
          return this.insertChild(t, i);
        },
        insertChild: function(i, r) {
          var a = r ? this.insertChildren(i, [r]) : null;
          return a && a[0];
        },
        addChildren: function(i) {
          return this.insertChildren(this._children.length, i);
        },
        insertChildren: function(i, r) {
          var a = this._children;
          if (a && r && r.length > 0) {
            r = o.slice(r);
            for (var l = {}, u = r.length - 1; u >= 0; u--) {
              var d = r[u], v = d && d._id;
              !d || l[v] ? r.splice(u, 1) : (d._remove(!1, !0), l[v] = !0);
            }
            o.splice(a, r, i, 0);
            for (var p = this._project, b = p._changes, u = 0, S = r.length; u < S; u++) {
              var d = r[u], L = d._name;
              d._parent = this, d._setProject(p, !0), L && d.setName(L), b && d._changed(5);
            }
            this._changed(11);
          } else
            r = null;
          return r;
        },
        _insertItem: "#insertChild",
        _insertAt: function(i, r) {
          var a = i && i._getOwner(), l = i !== this && a ? this : null;
          return l && (l._remove(!1, !0), a._insertItem(i._index + r, l)), l;
        },
        insertAbove: function(i) {
          return this._insertAt(i, 1);
        },
        insertBelow: function(i) {
          return this._insertAt(i, 0);
        },
        sendToBack: function() {
          var i = this._getOwner();
          return i ? i._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var i = this._getOwner();
          return i ? i._insertItem(t, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(i) {
          return this.insertChild(0, i);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(i) {
          return i._insertItem(t, this);
        },
        copyTo: function(i) {
          return this.clone(!1).addTo(i);
        },
        reduce: function(i) {
          var r = this._children;
          if (r && r.length === 1) {
            var a = r[0].reduce(i);
            return this._parent ? (a.insertAbove(this), this.remove()) : a.remove(), a;
          }
          return this;
        },
        _removeNamed: function() {
          var i = this._getOwner();
          if (i) {
            var r = i._children, a = i._namedChildren, l = this._name, u = a[l], d = u ? u.indexOf(this) : -1;
            d !== -1 && (r[l] == this && delete r[l], u.splice(d, 1), u.length ? r[l] = u[0] : delete a[l]);
          }
        },
        _remove: function(i, r) {
          var a = this._getOwner(), l = this._project, u = this._index;
          return this._style && this._style._dispose(), a ? (this._name && this._removeNamed(), u != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), o.splice(a._children, null, u, 1)), this._installEvents(!1), i && l._changes && this._changed(5), r && a._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(i) {
          var r = i && i.insertBelow(this);
          return r && this.remove(), r;
        },
        removeChildren: function(i, r) {
          if (!this._children)
            return null;
          i = i || 0, r = o.pick(r, this._children.length);
          for (var a = o.splice(this._children, null, i, r - i), l = a.length - 1; l >= 0; l--)
            a[l]._remove(!0, !1);
          return a.length > 0 && this._changed(11), a;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var i = 0, r = this._children.length; i < r; i++)
              this._children[i]._index = i;
            this._changed(11);
          }
        },
        isEmpty: function(i) {
          var r = this._children, a = r ? r.length : 0;
          if (i) {
            for (var l = 0; l < a; l++)
              if (!r[l].isEmpty(i))
                return !1;
            return !0;
          }
          return !a;
        },
        isEditable: function() {
          for (var i = this; i; ) {
            if (!i._visible || i._locked)
              return !1;
            i = i._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(i) {
          function r(v) {
            var p = [];
            do
              p.unshift(v);
            while (v = v._parent);
            return p;
          }
          for (var a = r(this), l = r(i), u = 0, d = Math.min(a.length, l.length); u < d; u++)
            if (a[u] != l[u])
              return a[u]._index < l[u]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(i) {
          return this._getOrder(i) === -1;
        },
        isBelow: function(i) {
          return this._getOrder(i) === 1;
        },
        isParent: function(i) {
          return this._parent === i;
        },
        isChild: function(i) {
          return i && i._parent === this;
        },
        isDescendant: function(i) {
          for (var r = this; r = r._parent; )
            if (r === i)
              return !0;
          return !1;
        },
        isAncestor: function(i) {
          return i ? i.isDescendant(this) : !1;
        },
        isSibling: function(i) {
          return this._parent === i._parent;
        },
        isGroupedWith: function(i) {
          for (var r = this._parent; r; ) {
            if (r._parent && /^(Group|Layer|CompoundPath)$/.test(r._class) && i.isDescendant(r))
              return !0;
            r = r._parent;
          }
          return !1;
        }
      },
      o.each(["rotate", "scale", "shear", "skew"], function(i) {
        var r = i === "rotate";
        this[i] = function() {
          var a = arguments, l = (r ? o : M).read(a), u = M.read(a, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            u || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        transform: function(i, r, a) {
          var l = this._matrix, u = i && !i.isIdentity(), d = a && this._canApplyMatrix || this._applyMatrix && (u || !l.isIdentity() || r && this._children);
          if (!u && !d)
            return this;
          if (u) {
            !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
            var v = this._style, p = v.getFillColor(!0), b = v.getStrokeColor(!0);
            p && p.transform(i), b && b.transform(i);
          }
          if (d && (d = this._transformContent(
            l,
            r,
            a
          ))) {
            var S = this._pivot;
            S && l._transformPoint(S, S, !0), l.reset(!0), a && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var L = this._bounds, E = this._position;
          (u || d) && this._changed(25);
          var A = u && L && i.decompose();
          if (A && A.skewing.isZero() && A.rotation % 90 === 0) {
            for (var T in L) {
              var G = L[T];
              if (G.nonscaling)
                delete L[T];
              else if (d || !G.internal) {
                var D = G.rect;
                i._transformBounds(D, D);
              }
            }
            this._bounds = L;
            var Y = L[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            Y && (this._position = this._getPositionFromBounds(Y.rect));
          } else
            u && E && this._pivot && (this._position = i._transformPoint(E, E));
          return this;
        },
        _transformContent: function(i, r, a) {
          var l = this._children;
          if (l) {
            for (var u = 0, d = l.length; u < d; u++)
              l[u].transform(i, r, a);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            M.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            M.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        fitBounds: function(i, r) {
          i = P.read(arguments);
          var a = this.getBounds(), l = a.height / a.width, u = i.height / i.width, d = (r ? l > u : l < u) ? i.width / a.width : i.height / a.height, v = new P(
            new M(),
            new V(a.width * d, a.height * d)
          );
          v.setCenter(i.getCenter()), this.setBounds(v);
        }
      }),
      {
        _setStyles: function(i, r, a) {
          var l = this._style, u = this._matrix;
          if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, u)), l.hasStroke()) {
            i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, u), i.lineWidth = l.getStrokeWidth();
            var d = l.getStrokeJoin(), v = l.getStrokeCap(), p = l.getMiterLimit();
            if (d && (i.lineJoin = d), v && (i.lineCap = v), p && (i.miterLimit = p), Ye.support.nativeDash) {
              var b = l.getDashArray(), S = l.getDashOffset();
              b && b.length && ("setLineDash" in i ? (i.setLineDash(b), i.lineDashOffset = S) : (i.mozDash = b, i.mozDashOffset = S));
            }
          }
          if (l.hasShadow()) {
            var L = r.pixelRatio || 1, E = a._shiftless().prepend(
              new J().scale(L, L)
            ), A = E.transform(new M(l.getShadowBlur(), 0)), T = E.transform(this.getShadowOffset());
            i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = A.getLength(), i.shadowOffsetX = T.x, i.shadowOffsetY = T.y;
          }
        },
        draw: function(i, r, a) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var l = r.matrices, u = r.viewMatrix, d = this._matrix, v = l[l.length - 1].appended(d);
            if (v.isInvertible()) {
              u = u ? u.appended(v) : v, l.push(v), r.updateMatrix && (this._globalMatrix = v);
              var p = this._blendMode, b = I.clamp(this._opacity, 0, 1), S = p === "normal", L = Qe.nativeModes[p], E = S && b === 1 || r.dontStart || r.clip || (L || S && b < 1) && this._canComposite(), A = r.pixelRatio || 1, T, G, D;
              if (!E) {
                var Y = this.getStrokeBounds(u);
                if (!Y.width || !Y.height) {
                  l.pop();
                  return;
                }
                D = r.offset, G = r.offset = Y.getTopLeft().floor(), T = i, i = vt.getContext(Y.getSize().ceil().add(1).multiply(A)), A !== 1 && i.scale(A, A);
              }
              i.save();
              var k = a ? a.appended(d) : this._canScaleStroke && !this.getStrokeScaling(!0) && u, z = !E && r.clipItem, C = !k || z;
              if (E ? (i.globalAlpha = b, L && (i.globalCompositeOperation = p)) : C && i.translate(-G.x, -G.y), C && (E ? d : u).applyToContext(i), z && r.clipItem.draw(i, r.extend({ clip: !0 })), k) {
                i.setTransform(A, 0, 0, A, 0, 0);
                var O = r.offset;
                O && i.translate(-O.x, -O.y);
              }
              this._draw(i, r, u, k), i.restore(), l.pop(), r.clip && !r.dontFinish && i.clip(this.getFillRule()), E || (Qe.process(
                p,
                i,
                T,
                b,
                G.subtract(D).multiply(A)
              ), vt.release(i), r.offset = D);
            }
          }
        },
        _isUpdated: function(i) {
          var r = this._parent;
          if (r instanceof Et)
            return r._isUpdated(i);
          var a = this._updateVersion === i;
          return !a && r && r._visible && r._isUpdated(i) && (this._updateVersion = i, a = !0), a;
        },
        _drawSelection: function(i, r, a, l, u) {
          var d = this._selection, v = d & 1, p = d & 2 || v && this._selectBounds, b = d & 4;
          if (this._drawSelected || (v = !1), (v || p || b) && this._isUpdated(u)) {
            var S, L = this.getSelectedColor(!0) || (S = this.getLayer()) && S.getSelectedColor(!0), E = r.appended(this.getGlobalMatrix(!0)), A = a / 2;
            if (i.strokeStyle = i.fillStyle = L ? L.toCanvasStyle(i) : "#009dec", v && this._drawSelected(i, E, l), b) {
              var T = this.getPosition(!0), G = this._parent, D = G ? G.localToGlobal(T) : T, Y = D.x, k = D.y;
              i.beginPath(), i.arc(Y, k, A, 0, Math.PI * 2, !0), i.stroke();
              for (var z = [[0, -1], [1, 0], [0, 1], [-1, 0]], C = A, O = a + 1, j = 0; j < 4; j++) {
                var q = z[j], H = q[0], ie = q[1];
                i.moveTo(Y + H * C, k + ie * C), i.lineTo(Y + H * O, k + ie * O), i.stroke();
              }
            }
            if (p) {
              var ae = E._transformCorners(this.getInternalBounds());
              i.beginPath();
              for (var j = 0; j < 8; j++)
                i[j ? "lineTo" : "moveTo"](ae[j], ae[++j]);
              i.closePath(), i.stroke();
              for (var j = 0; j < 8; j++)
                i.fillRect(
                  ae[j] - A,
                  ae[++j] - A,
                  a,
                  a
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      o.each(["down", "drag", "up", "move"], function(i) {
        this["removeOn" + o.capitalize(i)] = function() {
          var r = {};
          return r[i] = !0, this.removeOn(r);
        };
      }, {
        removeOn: function(i) {
          for (var r in i)
            if (i[r]) {
              var a = "mouse" + r, l = this._project, u = l._removeSets = l._removeSets || {};
              u[a] = u[a] || {}, u[a][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(i, r, a) {
          a || (a = r, r = i, i = null, a || (a = r, r = null));
          var l = a && a.easing, u = a && a.start, d = a != null && (typeof a == "number" ? a : a.duration), v = new Je(this, i, r, d, l, u);
          function p(b) {
            v._handleFrame(b.time * 1e3), v.running || this.off("frame", p);
          }
          return d && this.on("frame", p), v;
        },
        tweenTo: function(i, r) {
          return this.tween(null, i, r);
        },
        tweenFrom: function(i, r) {
          return this.tween(i, null, r);
        }
      }
    ), W = X.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(r) {
        this._children = [], this._namedChildren = {}, this._initialize(r) || this.addChildren(Array.isArray(r) ? r : arguments);
      },
      _changed: function i(r) {
        i.base.call(this, r), r & 2050 && (this._clipItem = t);
      },
      _getClipItem: function() {
        var i = this._clipItem;
        if (i === t) {
          i = null;
          for (var r = this._children, a = 0, l = r.length; a < l; a++)
            if (r[a]._clipMask) {
              i = r[a];
              break;
            }
          this._clipItem = i;
        }
        return i;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(i) {
        var r = this.getFirstChild();
        r && r.setClipMask(i);
      },
      _getBounds: function i(r, a) {
        var l = this._getClipItem();
        return l ? l._getCachedBounds(
          l._matrix.prepended(r),
          o.set({}, a, { stroke: !1 })
        ) : i.base.call(this, r, a);
      },
      _hitTestChildren: function i(r, a, l) {
        var u = this._getClipItem();
        return (!u || u.contains(r)) && i.base.call(
          this,
          r,
          a,
          l,
          u
        );
      },
      _draw: function(i, r) {
        var a = r.clip, l = !a && this._getClipItem();
        r = r.extend({ clipItem: l, clip: !1 }), a ? (i.beginPath(), r.dontStart = r.dontFinish = !0) : l && l.draw(i, r.extend({ clip: !0 }));
        for (var u = this._children, d = 0, v = u.length; d < v; d++) {
          var p = u[d];
          p !== l && p.draw(i, r);
        }
      }
    }), je = W.extend({
      _class: "Layer",
      initialize: function() {
        W.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function i() {
        return this._parent ? i.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), Ee = X.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(r, a) {
          this._initialize(r, a);
        },
        _equals: function(i) {
          return this._type === i._type && this._size.equals(i._size) && o.equals(this._radius, i._radius);
        },
        copyContent: function(i) {
          this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(i) {
          this._type = i;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var i = this._size;
          return new te(i.width, i.height, this, "setSize");
        },
        setSize: function() {
          var i = V.read(arguments);
          if (!this._size)
            this._size = i.clone();
          else if (!this._size.equals(i)) {
            var r = this._type, a = i.width, l = i.height;
            r === "rectangle" ? this._radius.set(V.min(this._radius, i.divide(2).abs())) : r === "circle" ? (a = l = (a + l) / 2, this._radius = a / 2) : r === "ellipse" && this._radius._set(a / 2, l / 2), this._size._set(a, l), this._changed(9);
          }
        },
        getRadius: function() {
          var i = this._radius;
          return this._type === "circle" ? i : new te(i.width, i.height, this, "setRadius");
        },
        setRadius: function(i) {
          var r = this._type;
          if (r === "circle") {
            if (i === this._radius)
              return;
            var a = i * 2;
            this._radius = i, this._size._set(a, a);
          } else if (i = V.read(arguments), !this._radius)
            this._radius = i.clone();
          else {
            if (this._radius.equals(i))
              return;
            if (this._radius.set(i), r === "rectangle") {
              var a = V.max(this._size, i.multiply(2));
              this._size.set(a);
            } else
              r === "ellipse" && this._size._set(i.width * 2, i.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(i) {
          var r = new We[o.capitalize(this._type)]({
            center: new M(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return r.copyAttributes(this), Ye.settings.applyMatrix && r.setApplyMatrix(!0), (i === t || i) && r.insertAbove(this), r;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(i, r, a, l) {
          var u = this._style, d = u.hasFill(), v = u.hasStroke(), p = r.dontFinish || r.clip, b = !l;
          if (d || v || p) {
            var S = this._type, L = this._radius, E = S === "circle";
            if (r.dontStart || i.beginPath(), b && E)
              i.arc(0, 0, L, 0, Math.PI * 2, !0);
            else {
              var A = E ? L : L.width, T = E ? L : L.height, G = this._size, D = G.width, Y = G.height;
              if (b && S === "rectangle" && A === 0 && T === 0)
                i.rect(-D / 2, -Y / 2, D, Y);
              else {
                var k = D / 2, z = Y / 2, C = 1 - 0.5522847498307936, O = A * C, j = T * C, q = [
                  -k,
                  -z + T,
                  -k,
                  -z + j,
                  -k + O,
                  -z,
                  -k + A,
                  -z,
                  k - A,
                  -z,
                  k - O,
                  -z,
                  k,
                  -z + j,
                  k,
                  -z + T,
                  k,
                  z - T,
                  k,
                  z - j,
                  k - O,
                  z,
                  k - A,
                  z,
                  -k + A,
                  z,
                  -k + O,
                  z,
                  -k,
                  z - j,
                  -k,
                  z - T
                ];
                l && l.transform(q, q, 32), i.moveTo(q[0], q[1]), i.bezierCurveTo(q[2], q[3], q[4], q[5], q[6], q[7]), k !== A && i.lineTo(q[8], q[9]), i.bezierCurveTo(q[10], q[11], q[12], q[13], q[14], q[15]), z !== T && i.lineTo(q[16], q[17]), i.bezierCurveTo(q[18], q[19], q[20], q[21], q[22], q[23]), k !== A && i.lineTo(q[24], q[25]), i.bezierCurveTo(q[26], q[27], q[28], q[29], q[30], q[31]);
              }
            }
            i.closePath();
          }
          !p && (d || v) && (this._setStyles(i, r, a), d && (i.fill(u.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), v && i.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(i, r) {
          var a = new P(this._size).setCenter(0, 0), l = this._style, u = r.stroke && l.hasStroke() && l.getStrokeWidth();
          return i && (a = i._transformBounds(a)), u ? a.expand(We._getStrokePadding(
            u,
            this._getStrokeMatrix(i, r)
          )) : a;
        }
      },
      new function() {
        function i(a, l, u) {
          var d = a._radius;
          if (!d.isZero())
            for (var v = a._size.divide(2), p = 1; p <= 4; p++) {
              var b = new M(p > 1 && p < 4 ? -1 : 1, p > 2 ? -1 : 1), S = b.multiply(v), L = S.subtract(b.multiply(d)), E = new P(
                u ? S.add(b.multiply(u)) : S,
                L
              );
              if (E.contains(l))
                return { point: L, quadrant: p };
            }
        }
        function r(a, l, u, d) {
          var v = a.divide(l);
          return (!d || v.isInQuadrant(d)) && v.subtract(v.normalize()).multiply(l).divide(u).length <= 1;
        }
        return {
          _contains: function a(l) {
            if (this._type === "rectangle") {
              var u = i(this, l);
              return u ? l.subtract(u.point).divide(this._radius).getLength() <= 1 : a.base.call(this, l);
            } else
              return l.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function a(l, u, d, v) {
            var p = !1, b = this._style, S = u.stroke && b.hasStroke(), L = u.fill && b.hasFill();
            if (S || L) {
              var E = this._type, A = this._radius, T = S ? b.getStrokeWidth() / 2 : 0, G = u._tolerancePadding.add(
                We._getStrokePadding(
                  T,
                  !b.getStrokeScaling() && v
                )
              );
              if (E === "rectangle") {
                var D = G.multiply(2), Y = i(this, l, D);
                if (Y)
                  p = r(
                    l.subtract(Y.point),
                    A,
                    G,
                    Y.quadrant
                  );
                else {
                  var k = new P(this._size).setCenter(0, 0), z = k.expand(D), C = k.expand(D.negate());
                  p = z._containsPoint(l) && !C._containsPoint(l);
                }
              } else
                p = r(l, A, G);
            }
            return p ? new $e(S ? "stroke" : "fill", this) : a.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function i(r, a, l, u, d) {
            var v = o.create(Ee.prototype);
            return v._type = r, v._size = l, v._radius = u, v._initialize(o.getNamed(d), a), v;
          }
          return {
            Circle: function() {
              var r = arguments, a = M.readNamed(r, "center"), l = o.readNamed(r, "radius");
              return i(
                "circle",
                a,
                new V(l * 2),
                l,
                r
              );
            },
            Rectangle: function() {
              var r = arguments, a = P.readNamed(r, "rectangle"), l = V.min(
                V.readNamed(r, "radius"),
                a.getSize(!0).divide(2)
              );
              return i(
                "rectangle",
                a.getCenter(!0),
                a.getSize(!0),
                l,
                r
              );
            },
            Ellipse: function() {
              var r = arguments, a = Ee._readEllipse(r), l = a.radius;
              return i(
                "ellipse",
                a.center,
                l.multiply(2),
                l,
                r
              );
            },
            _readEllipse: function(r) {
              var a, l;
              if (o.hasNamed(r, "radius"))
                a = M.readNamed(r, "center"), l = V.readNamed(r, "radius");
              else {
                var u = P.readNamed(r, "rectangle");
                a = u.getCenter(!0), l = u.getSize(!0).divide(2);
              }
              return { center: a, radius: l };
            }
          };
        }()
      }
    ), He = X.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(r, a) {
        if (!this._initialize(
          r,
          a !== t && M.read(arguments)
        )) {
          var l, u = typeof r, d = u === "string" ? s.getElementById(r) : u === "object" ? r : null;
          if (d && d !== X.NO_INSERT) {
            if (d.getContext || d.naturalHeight != null)
              l = d;
            else if (d) {
              var v = V.read(arguments);
              v.isZero() || (l = vt.getCanvas(v));
            }
          }
          l ? this.setImage(l) : this.setSource(r);
        }
        this._size || (this._size = new V(), this._loaded = !1);
      },
      _equals: function(i) {
        return this.getSource() === i.getSource();
      },
      copyContent: function(i) {
        var r = i._image, a = i._canvas;
        if (r)
          this._setImage(r);
        else if (a) {
          var l = vt.getCanvas(i._size);
          l.getContext("2d").drawImage(a, 0, 0), this._setImage(l);
        }
        this._crossOrigin = i._crossOrigin;
      },
      getSize: function() {
        var i = this._size;
        return new te(
          i ? i.width : 0,
          i ? i.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(i, r) {
        var a = V.read(arguments);
        if (a.equals(this._size))
          r && this.clear();
        else if (a.width > 0 && a.height > 0) {
          var l = !r && this.getElement();
          this._setImage(vt.getCanvas(a)), l && this.getContext(!0).drawImage(
            l,
            0,
            0,
            a.width,
            a.height
          );
        } else
          this._canvas && vt.release(this._canvas), this._size = a.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(i) {
        this.setSize(i, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(i) {
        this.setSize(this.getWidth(), i);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var i = this._size;
        return !i || i.width === 0 && i.height === 0;
      },
      getResolution: function() {
        var i = this._matrix, r = new M(0, 0).transform(i), a = new M(1, 0).transform(i).subtract(r), l = new M(0, 1).transform(i).subtract(r);
        return new V(
          72 / a.getLength(),
          72 / l.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(i) {
        var r = this;
        function a(l) {
          var u = r.getView(), d = l && l.type || "load";
          u && r.responds(d) && (Ye = u._scope, r.emit(d, new Di(l)));
        }
        this._setImage(i), this._loaded ? setTimeout(a, 0) : i && Xt.add(i, {
          load: function(l) {
            r._setImage(i), a(l);
          },
          error: a
        });
      },
      _setImage: function(i) {
        this._canvas && vt.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new V(
          i ? i.naturalWidth || i.width : 0,
          i ? i.naturalHeight || i.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var i = vt.getContext(this._size);
          try {
            this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
          } catch {
            vt.release(i);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(i) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(i) {
        this._context = i;
      },
      getSource: function() {
        var i = this._image;
        return i && i.src || this.toDataURL();
      },
      setSource: function(i) {
        var r = new e.Image(), a = this._crossOrigin;
        a && (r.crossOrigin = a), i && (r.src = i), this.setImage(r);
      },
      getCrossOrigin: function() {
        var i = this._image;
        return i && i.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(i) {
        this._crossOrigin = i;
        var r = this._image;
        r && (r.crossOrigin = i);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(i) {
        this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var i = P.read(arguments), r = vt.getContext(i.getSize());
        return r.drawImage(
          this.getCanvas(),
          i.x,
          i.y,
          i.width,
          i.height,
          0,
          0,
          i.width,
          i.height
        ), r.canvas;
      },
      getSubRaster: function() {
        var i = P.read(arguments), r = new He(X.NO_INSERT);
        return r._setImage(this.getSubCanvas(i)), r.translate(i.getCenter().subtract(this.getSize().divide(2))), r._matrix.prepend(this._matrix), r.insertAbove(this), r;
      },
      toDataURL: function() {
        var i = this._image, r = i && i.src;
        if (/^data:/.test(r))
          return r;
        var a = this.getCanvas();
        return a ? a.toDataURL.apply(a, arguments) : null;
      },
      drawImage: function(i) {
        var r = M.read(arguments, 1);
        this.getContext(!0).drawImage(i, r.x, r.y);
      },
      getAverageColor: function(i) {
        var r, a;
        if (i ? i instanceof qt ? (a = i, r = i.getBounds()) : typeof i == "object" && ("width" in i ? r = new P(i) : "x" in i && (r = new P(i.x - 0.5, i.y - 0.5, 1, 1))) : r = this.getBounds(), !r)
          return null;
        var l = 32, u = Math.min(r.width, l), d = Math.min(r.height, l), v = He._sampleContext;
        v ? v.clearRect(0, 0, l + 1, l + 1) : v = He._sampleContext = vt.getContext(
          new V(l)
        ), v.save();
        var p = new J().scale(u / r.width, d / r.height).translate(-r.x, -r.y);
        p.applyToContext(v), a && a.draw(v, new o({ clip: !0, matrices: [p] })), this._matrix.applyToContext(v);
        var b = this.getElement(), S = this._size;
        b && v.drawImage(b, -S.width / 2, -S.height / 2), v.restore();
        for (var L = v.getImageData(
          0.5,
          0.5,
          Math.ceil(u),
          Math.ceil(d)
        ).data, E = [0, 0, 0], A = 0, T = 0, G = L.length; T < G; T += 4) {
          var D = L[T + 3];
          A += D, D /= 255, E[0] += L[T] * D, E[1] += L[T + 1] * D, E[2] += L[T + 2] * D;
        }
        for (var T = 0; T < 3; T++)
          E[T] /= A;
        return A ? Lt.read(E) : null;
      },
      getPixel: function() {
        var i = M.read(arguments), r = this.getContext().getImageData(i.x, i.y, 1, 1).data;
        return new Lt(
          "rgb",
          [r[0] / 255, r[1] / 255, r[2] / 255],
          r[3] / 255
        );
      },
      setPixel: function() {
        var i = arguments, r = M.read(i), a = Lt.read(i), l = a._convert("rgb"), u = a._alpha, d = this.getContext(!0), v = d.createImageData(1, 1), p = v.data;
        p[0] = l[0] * 255, p[1] = l[1] * 255, p[2] = l[2] * 255, p[3] = u != null ? u * 255 : 255, d.putImageData(v, r.x, r.y);
      },
      clear: function() {
        var i = this._size;
        this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
      },
      createImageData: function() {
        var i = V.read(arguments);
        return this.getContext().createImageData(i.width, i.height);
      },
      getImageData: function() {
        var i = P.read(arguments);
        return i.isEmpty() && (i = new P(this._size)), this.getContext().getImageData(
          i.x,
          i.y,
          i.width,
          i.height
        );
      },
      putImageData: function(i) {
        var r = M.read(arguments, 1);
        this.getContext(!0).putImageData(i, r.x, r.y);
      },
      setImageData: function(i) {
        this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
      },
      _getBounds: function(i, r) {
        var a = new P(this._size).setCenter(0, 0);
        return i ? i._transformBounds(a) : a;
      },
      _hitTestSelf: function(i) {
        if (this._contains(i)) {
          var r = this;
          return new $e("pixel", r, {
            offset: i.add(r._size.divide(2)).round(),
            color: {
              get: function() {
                return r.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(i, r, a) {
        var l = this.getElement();
        if (l && l.width > 0 && l.height > 0) {
          i.globalAlpha = I.clamp(this._opacity, 0, 1), this._setStyles(i, r, a);
          var u = this._smoothing, d = u === "off";
          Gt.setPrefixed(
            i,
            d ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            d ? !1 : u
          ), i.drawImage(
            l,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), ft = X.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(r, a) {
        this._initialize(
          r,
          a !== t && M.read(arguments, 1)
        ) || this.setDefinition(r instanceof Le ? r : new Le(r));
      },
      _equals: function(i) {
        return this._definition === i._definition;
      },
      copyContent: function(i) {
        this.setDefinition(i._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(i) {
        this._definition = i, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(i, r) {
        var a = this._definition._item;
        return a._getCachedBounds(a._matrix.prepended(i), r);
      },
      _hitTestSelf: function(i, r, a) {
        var l = r.extend({ all: !1 }), u = this._definition._item._hitTest(i, l, a);
        return u && (u.item = this), u;
      },
      _draw: function(i, r) {
        this._definition._item.draw(i, r);
      }
    }), Le = o.extend({
      _class: "SymbolDefinition",
      initialize: function(r, a) {
        this._id = F.get(), this.project = Ye.project, r && this.setItem(r, a);
      },
      _serialize: function(i, r) {
        return r.add(this, function() {
          return o.serialize(
            [this._class, this._item],
            i,
            !1,
            r
          );
        });
      },
      _changed: function(i) {
        i & 8 && X._clearBoundsCache(this), i & 1 && this.project._changed(i);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(i, r) {
        i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), r || i.setPosition(new M()), i._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(i) {
        return new ft(this, i);
      },
      clone: function() {
        return new Le(this._item.clone(!1));
      },
      equals: function(i) {
        return i === this || i && this._item.equals(i._item) || !1;
      }
    }), $e = o.extend({
      _class: "HitResult",
      initialize: function(r, a, l) {
        this.type = r, this.item = a, l && this.inject(l);
      },
      statics: {
        getOptions: function(i) {
          var r = i && o.read(i);
          return new o({
            type: null,
            tolerance: Ye.settings.hitTolerance,
            fill: !r,
            stroke: !r,
            segments: !r,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, r);
        }
      }
    }), ce = o.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(r, a, l, u, d, v) {
        var p = arguments.length, b, S, L, E;
        p > 0 && (r == null || typeof r == "object" ? p === 1 && r && "point" in r ? (b = r.point, S = r.handleIn, L = r.handleOut, E = r.selection) : (b = r, S = a, L = l, E = u) : (b = [r, a], S = l !== t ? [l, u] : null, L = d !== t ? [d, v] : null)), new ut(b, this, "_point"), new ut(S, this, "_handleIn"), new ut(L, this, "_handleOut"), E && this.setSelection(E);
      },
      _serialize: function(i, r) {
        var a = this._point, l = this._selection, u = l || this.hasHandles() ? [a, this._handleIn, this._handleOut] : a;
        return l && u.push(l), o.serialize(u, i, !0, r);
      },
      _changed: function(i) {
        var r = this._path;
        if (r) {
          var a = r._curves, l = this._index, u;
          a && ((!i || i === this._point || i === this._handleIn) && (u = l > 0 ? a[l - 1] : r._closed ? a[a.length - 1] : null) && u._changed(), (!i || i === this._point || i === this._handleOut) && (u = a[l]) && u._changed()), r._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(M.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(M.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(M.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var i = this._handleIn, r = this._handleOut;
        return !i.isZero() && !r.isZero() && i.isCollinear(r);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(i) {
        var r = this._selection, a = this._path;
        this._selection = i = i || 0, a && i !== r && (a._updateSelection(this, r, i), a._changed(257));
      },
      _changeSelection: function(i, r) {
        var a = this._selection;
        this.setSelection(r ? a | i : a & ~i);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(i) {
        this._changeSelection(7, i);
      },
      getIndex: function() {
        return this._index !== t ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var i = this._path, r = this._index;
        return i ? (r > 0 && !i._closed && r === i._segments.length - 1 && r--, i.getCurves()[r] || null) : null;
      },
      getLocation: function() {
        var i = this.getCurve();
        return i ? new pt(i, this === i._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
      },
      smooth: function(i, r, a) {
        var l = i || {}, u = l.type, d = l.factor, v = this.getPrevious(), p = this.getNext(), b = (v || this)._point, S = this._point, L = (p || this)._point, E = b.getDistance(S), A = S.getDistance(L);
        if (!u || u === "catmull-rom") {
          var T = d === t ? 0.5 : d, G = Math.pow(E, T), D = G * G, Y = Math.pow(A, T), k = Y * Y;
          if (!r && v) {
            var z = 2 * k + 3 * Y * G + D, C = 3 * Y * (Y + G);
            this.setHandleIn(C !== 0 ? new M(
              (k * b._x + z * S._x - D * L._x) / C - S._x,
              (k * b._y + z * S._y - D * L._y) / C - S._y
            ) : new M());
          }
          if (!a && p) {
            var z = 2 * D + 3 * G * Y + k, C = 3 * G * (G + Y);
            this.setHandleOut(C !== 0 ? new M(
              (D * L._x + z * S._x - k * b._x) / C - S._x,
              (D * L._y + z * S._y - k * b._y) / C - S._y
            ) : new M());
          }
        } else if (u === "geometric") {
          if (v && p) {
            var O = b.subtract(L), j = d === t ? 0.4 : d, q = j * E / (E + A);
            r || this.setHandleIn(O.multiply(q)), a || this.setHandleOut(O.multiply(q - j));
          }
        } else
          throw new Error("Smoothing method '" + u + "' not supported.");
      },
      getPrevious: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var i = this._path;
        return i && this._index === i._segments.length - 1 || !1;
      },
      reverse: function() {
        var i = this._handleIn, r = this._handleOut, a = i.clone();
        i.set(r), r.set(a);
      },
      reversed: function() {
        return new ce(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new ce(this._point, this._handleIn, this._handleOut);
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
      },
      toString: function() {
        var i = ["point: " + this._point];
        return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
      },
      transform: function(i) {
        this._transformCoordinates(i, new Array(6), !0), this._changed();
      },
      interpolate: function(i, r, a) {
        var l = 1 - a, u = a, d = i._point, v = r._point, p = i._handleIn, b = r._handleIn, S = r._handleOut, L = i._handleOut;
        this._point._set(
          l * d._x + u * v._x,
          l * d._y + u * v._y,
          !0
        ), this._handleIn._set(
          l * p._x + u * b._x,
          l * p._y + u * b._y,
          !0
        ), this._handleOut._set(
          l * L._x + u * S._x,
          l * L._y + u * S._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(i, r, a) {
        var l = this._point, u = !a || !this._handleIn.isZero() ? this._handleIn : null, d = !a || !this._handleOut.isZero() ? this._handleOut : null, v = l._x, p = l._y, b = 2;
        return r[0] = v, r[1] = p, u && (r[b++] = u._x + v, r[b++] = u._y + p), d && (r[b++] = d._x + v, r[b++] = d._y + p), i && (i._transformCoordinates(r, r, b / 2), v = r[0], p = r[1], a ? (l._x = v, l._y = p, b = 2, u && (u._x = r[b++] - v, u._y = r[b++] - p), d && (d._x = r[b++] - v, d._y = r[b++] - p)) : (u || (r[b++] = v, r[b++] = p), d || (r[b++] = v, r[b++] = p))), r;
      }
    }), ut = M.extend({
      initialize: function(r, a, l) {
        var u, d, v;
        if (!r)
          u = d = 0;
        else if ((u = r[0]) !== t)
          d = r[1];
        else {
          var p = r;
          (u = p.x) === t && (p = M.read(arguments), u = p.x), d = p.y, v = p.selected;
        }
        this._x = u, this._y = d, this._owner = a, a[l] = this, v && this.setSelected(!0);
      },
      _set: function(i, r) {
        return this._x = i, this._y = r, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner._changed(this);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this._x) && i(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        var i = this._owner;
        return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
      }
    }), ze = o.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(r, a, l, u, d, v, p, b) {
          var S = arguments.length, L, E, A, T, G, D;
          S === 3 ? (this._path = r, L = a, E = l) : S ? S === 1 ? "segment1" in r ? (L = new ce(r.segment1), E = new ce(r.segment2)) : "point1" in r ? (A = r.point1, G = r.handle1, D = r.handle2, T = r.point2) : Array.isArray(r) && (A = [r[0], r[1]], T = [r[6], r[7]], G = [r[2] - r[0], r[3] - r[1]], D = [r[4] - r[6], r[5] - r[7]]) : S === 2 ? (L = new ce(r), E = new ce(a)) : S === 4 ? (A = r, G = a, D = l, T = u) : S === 8 && (A = [r, a], T = [p, b], G = [l - r, u - a], D = [d - p, v - b]) : (L = new ce(), E = new ce()), this._segment1 = L || new ce(A, null, G), this._segment2 = E || new ce(T, D, null);
        },
        _serialize: function(i, r) {
          return o.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            i,
            !0,
            r
          );
        },
        _changed: function() {
          this._length = this._bounds = t;
        },
        clone: function() {
          return new ze(this._segment1, this._segment2);
        },
        toString: function() {
          var i = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
        },
        classify: function() {
          return ze.classify(this.getValues());
        },
        remove: function() {
          var i = !1;
          if (this._path) {
            var r = this._segment2, a = r._handleOut;
            i = r.remove(), i && this._segment1._handleOut.set(a);
          }
          return i;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(M.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(M.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(M.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(M.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
        },
        getPrevious: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._segment1._index === i._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(i) {
          this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
        },
        getValues: function(i) {
          return ze.getValues(this._segment1, this._segment2, i);
        },
        getPoints: function() {
          for (var i = this.getValues(), r = [], a = 0; a < 8; a += 2)
            r.push(new M(i[a], i[a + 1]));
          return r;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = ze.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return ze.getArea(this.getValues());
        },
        getLine: function() {
          return new le(this._segment1._point, this._segment2._point);
        },
        getPart: function(i, r) {
          return new ze(ze.getPart(this.getValues(), i, r));
        },
        getPartLength: function(i, r) {
          return ze.getLength(this.getValues(), i, r);
        },
        divideAt: function(i) {
          return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
        },
        divideAtTime: function(i, r) {
          var a = 1e-8, l = 1 - a, u = null;
          if (i >= a && i <= l) {
            var d = ze.subdivide(this.getValues(), i), v = d[0], p = d[1], b = r || this.hasHandles(), S = this._segment1, L = this._segment2, E = this._path;
            b && (S._handleOut._set(v[2] - v[0], v[3] - v[1]), L._handleIn._set(p[4] - p[6], p[5] - p[7]));
            var A = v[6], T = v[7], G = new ce(
              new M(A, T),
              b && new M(v[4] - A, v[5] - T),
              b && new M(p[2] - A, p[3] - T)
            );
            E ? (E.insert(S._index + 1, G), u = this.getNext()) : (this._segment2 = G, this._changed(), u = new ze(G, L));
          }
          return u;
        },
        splitAt: function(i) {
          var r = this._path;
          return r ? r.splitAt(i) : null;
        },
        splitAtTime: function(i) {
          return this.splitAt(this.getLocationAtTime(i));
        },
        divide: function(i, r) {
          return this.divideAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
        },
        split: function(i, r) {
          return this.splitAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
        },
        reversed: function() {
          return new ze(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(i, r, a, l) {
            var u = i._point, d = i._handleOut, v = r._handleIn, p = r._point, b = u.x, S = u.y, L = p.x, E = p.y, A = l ? [b, S, b, S, L, E, L, E] : [
              b,
              S,
              b + d._x,
              S + d._y,
              L + v._x,
              E + v._y,
              L,
              E
            ];
            return a && a._transformCoordinates(A, A, 4), A;
          },
          subdivide: function(i, r) {
            var a = i[0], l = i[1], u = i[2], d = i[3], v = i[4], p = i[5], b = i[6], S = i[7];
            r === t && (r = 0.5);
            var L = 1 - r, E = L * a + r * u, A = L * l + r * d, T = L * u + r * v, G = L * d + r * p, D = L * v + r * b, Y = L * p + r * S, k = L * E + r * T, z = L * A + r * G, C = L * T + r * D, O = L * G + r * Y, j = L * k + r * C, q = L * z + r * O;
            return [
              [a, l, E, A, k, z, j, q],
              [j, q, C, O, D, Y, b, S]
            ];
          },
          getMonoCurves: function(i, r) {
            var a = [], l = r ? 0 : 1, u = i[l + 0], d = i[l + 2], v = i[l + 4], p = i[l + 6];
            if (u >= d == d >= v && d >= v == v >= p || ze.isStraight(i))
              a.push(i);
            else {
              var b = 3 * (d - v) - u + p, S = 2 * (u + v) - 4 * d, L = d - u, E = 1e-8, A = 1 - E, T = [], G = I.solveQuadratic(b, S, L, T, E, A);
              if (!G)
                a.push(i);
              else {
                T.sort();
                var D = T[0], Y = ze.subdivide(i, D);
                a.push(Y[0]), G > 1 && (D = (T[1] - D) / (1 - D), Y = ze.subdivide(Y[1], D), a.push(Y[0])), a.push(Y[1]);
              }
            }
            return a;
          },
          solveCubic: function(i, r, a, l, u, d) {
            var v = i[r], p = i[r + 2], b = i[r + 4], S = i[r + 6], L = 0;
            if (!(v < a && S < a && p < a && b < a || v > a && S > a && p > a && b > a)) {
              var E = 3 * (p - v), A = 3 * (b - p) - E, T = S - v - E - A;
              L = I.solveCubic(T, A, E, v - a, l, u, d);
            }
            return L;
          },
          getTimeOf: function(i, r) {
            var a = new M(i[0], i[1]), l = new M(i[6], i[7]), u = 1e-12, d = 1e-7, v = r.isClose(a, u) ? 0 : r.isClose(l, u) ? 1 : null;
            if (v === null)
              for (var p = [r.x, r.y], b = [], S = 0; S < 2; S++)
                for (var L = ze.solveCubic(i, S, p[S], b, 0, 1), E = 0; E < L; E++) {
                  var A = b[E];
                  if (r.isClose(ze.getPoint(i, A), d))
                    return A;
                }
            return r.isClose(a, d) ? 0 : r.isClose(l, d) ? 1 : null;
          },
          getNearestTime: function(i, r) {
            if (ze.isStraight(i)) {
              var a = i[0], l = i[1], u = i[6], d = i[7], v = u - a, p = d - l, b = v * v + p * p;
              if (b === 0)
                return 0;
              var S = ((r.x - a) * v + (r.y - l) * p) / b;
              return S < 1e-12 ? 0 : S > 0.999999999999 ? 1 : ze.getTimeOf(
                i,
                new M(a + S * v, l + S * p)
              );
            }
            var L = 100, E = 1 / 0, A = 0;
            function T(Y) {
              if (Y >= 0 && Y <= 1) {
                var k = r.getDistance(ze.getPoint(i, Y), !0);
                if (k < E)
                  return E = k, A = Y, !0;
              }
            }
            for (var G = 0; G <= L; G++)
              T(G / L);
            for (var D = 1 / (L * 2); D > 1e-8; )
              !T(A - D) && !T(A + D) && (D /= 2);
            return A;
          },
          getPart: function(i, r, a) {
            var l = r > a;
            if (l) {
              var u = r;
              r = a, a = u;
            }
            return r > 0 && (i = ze.subdivide(i, r)[1]), a < 1 && (i = ze.subdivide(i, (a - r) / (1 - r))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
          },
          isFlatEnough: function(i, r) {
            var a = i[0], l = i[1], u = i[2], d = i[3], v = i[4], p = i[5], b = i[6], S = i[7], L = 3 * u - 2 * a - b, E = 3 * d - 2 * l - S, A = 3 * v - 2 * b - a, T = 3 * p - 2 * S - l;
            return Math.max(L * L, A * A) + Math.max(E * E, T * T) <= 16 * r * r;
          },
          getArea: function(i) {
            var r = i[0], a = i[1], l = i[2], u = i[3], d = i[4], v = i[5], p = i[6], b = i[7];
            return 3 * ((b - a) * (l + d) - (p - r) * (u + v) + u * (r - d) - l * (a - v) + b * (d + r / 3) - p * (v + a / 3)) / 20;
          },
          getBounds: function(i) {
            for (var r = i.slice(0, 2), a = r.slice(), l = [0, 0], u = 0; u < 2; u++)
              ze._addBounds(
                i[u],
                i[u + 2],
                i[u + 4],
                i[u + 6],
                u,
                0,
                r,
                a,
                l
              );
            return new P(r[0], r[1], a[0] - r[0], a[1] - r[1]);
          },
          _addBounds: function(i, r, a, l, u, d, v, p, b) {
            function S(j, q) {
              var H = j - q, ie = j + q;
              H < v[u] && (v[u] = H), ie > p[u] && (p[u] = ie);
            }
            d /= 2;
            var L = v[u] + d, E = p[u] - d;
            if (i < L || r < L || a < L || l < L || i > E || r > E || a > E || l > E)
              if (r < i != r < l && a < i != a < l)
                S(i, 0), S(l, 0);
              else {
                var A = 3 * (r - a) - i + l, T = 2 * (i + a) - 4 * r, G = r - i, D = I.solveQuadratic(A, T, G, b), Y = 1e-8, k = 1 - Y;
                S(l, 0);
                for (var z = 0; z < D; z++) {
                  var C = b[z], O = 1 - C;
                  Y <= C && C <= k && S(
                    O * O * O * i + 3 * O * O * C * r + 3 * O * C * C * a + C * C * C * l,
                    d
                  );
                }
              }
          }
        }
      },
      o.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(i) {
          this[i] = function() {
            this._bounds || (this._bounds = {});
            var r = this._bounds[i];
            return r || (r = this._bounds[i] = We[i](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), r.clone();
          };
        },
        {}
      ),
      o.each({
        isStraight: function(i, r, a, l) {
          if (r.isZero() && a.isZero())
            return !0;
          var u = l.subtract(i);
          if (u.isZero())
            return !1;
          if (u.isCollinear(r) && u.isCollinear(a)) {
            var d = new le(i, l), v = 1e-7;
            if (d.getDistance(i.add(r)) < v && d.getDistance(l.add(a)) < v) {
              var p = u.dot(u), b = u.dot(r) / p, S = u.dot(a) / p;
              return b >= 0 && b <= 1 && S <= 0 && S >= -1;
            }
          }
          return !1;
        },
        isLinear: function(i, r, a, l) {
          var u = l.subtract(i).divide(3);
          return r.equals(u) && a.negate().equals(u);
        }
      }, function(i, r) {
        this[r] = function(a) {
          var l = this._segment1, u = this._segment2;
          return i(
            l._point,
            l._handleOut,
            u._handleIn,
            u._point,
            a
          );
        }, this.statics[r] = function(a, l) {
          var u = a[0], d = a[1], v = a[6], p = a[7];
          return i(
            new M(u, d),
            new M(a[2] - u, a[3] - d),
            new M(a[4] - v, a[5] - p),
            new M(v, p),
            l
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(i) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
        },
        isCollinear: function(i) {
          return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(i, r) {
          return this.getLocationAtTime(
            r ? i : this.getTimeAt(i)
          );
        },
        getLocationAtTime: function(i) {
          return i != null && i >= 0 && i <= 1 ? new pt(this, i) : null;
        },
        getTimeAt: function(i, r) {
          return ze.getTimeAt(this.getValues(), i, r);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var i = M.read(arguments);
          return i.isZero() ? [] : ze.getTimesWithTangent(this.getValues(), i);
        },
        getOffsetAtTime: function(i) {
          return this.getPartLength(0, i);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(M.read(arguments)));
        },
        getOffsetOf: function() {
          var i = this.getLocationOf.apply(this, arguments);
          return i ? i.getOffset() : null;
        },
        getTimeOf: function() {
          return ze.getTimeOf(this.getValues(), M.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var i = M.read(arguments), r = this.getValues(), a = ze.getNearestTime(r, i), l = ze.getPoint(r, a);
          return new pt(this, a, l, null, i.getDistance(l));
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        }
      },
      new function() {
        var i = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return o.each(
          i,
          function(r) {
            this[r + "At"] = function(a, l) {
              var u = this.getValues();
              return ze[r](u, l ? a : ze.getTimeAt(u, a));
            }, this[r + "AtTime"] = function(a) {
              return ze[r](this.getValues(), a);
            };
          },
          {
            statics: {
              _evaluateMethods: i
            }
          }
        );
      }(),
      new function() {
        function i(l) {
          var u = l[0], d = l[1], v = l[2], p = l[3], b = l[4], S = l[5], L = l[6], E = l[7], A = 9 * (v - b) + 3 * (L - u), T = 6 * (u + b) - 12 * v, G = 3 * (v - u), D = 9 * (p - S) + 3 * (E - d), Y = 6 * (d + S) - 12 * p, k = 3 * (p - d);
          return function(z) {
            var C = (A * z + T) * z + G, O = (D * z + Y) * z + k;
            return Math.sqrt(C * C + O * O);
          };
        }
        function r(l, u) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(u - l) * 32)));
        }
        function a(l, u, d, v) {
          if (u == null || u < 0 || u > 1)
            return null;
          var p = l[0], b = l[1], S = l[2], L = l[3], E = l[4], A = l[5], T = l[6], G = l[7], D = I.isZero;
          D(S - p) && D(L - b) && (S = p, L = b), D(E - T) && D(A - G) && (E = T, A = G);
          var Y = 3 * (S - p), k = 3 * (E - S) - Y, z = T - p - Y - k, C = 3 * (L - b), O = 3 * (A - L) - C, j = G - b - C - O, q, H;
          if (d === 0)
            q = u === 0 ? p : u === 1 ? T : ((z * u + k) * u + Y) * u + p, H = u === 0 ? b : u === 1 ? G : ((j * u + O) * u + C) * u + b;
          else {
            var ie = 1e-8, ae = 1 - ie;
            if (u < ie ? (q = Y, H = C) : u > ae ? (q = 3 * (T - E), H = 3 * (G - A)) : (q = (3 * z * u + 2 * k) * u + Y, H = (3 * j * u + 2 * O) * u + C), v) {
              q === 0 && H === 0 && (u < ie || u > ae) && (q = E - S, H = A - L);
              var ue = Math.sqrt(q * q + H * H);
              ue && (q /= ue, H /= ue);
            }
            if (d === 3) {
              var E = 6 * z * u + 2 * k, A = 6 * j * u + 2 * O, me = Math.pow(q * q + H * H, 3 / 2);
              q = me !== 0 ? (q * A - H * E) / me : 0, H = 0;
            }
          }
          return d === 2 ? new M(H, -q) : new M(q, H);
        }
        return { statics: {
          classify: function(l) {
            var u = l[0], d = l[1], v = l[2], p = l[3], b = l[4], S = l[5], L = l[6], E = l[7], A = u * (E - S) + d * (b - L) + L * S - E * b, T = v * (d - E) + p * (L - u) + u * E - d * L, G = b * (p - d) + S * (u - v) + v * d - p * u, D = 3 * G, Y = D - T, k = Y - T + A, z = Math.sqrt(k * k + Y * Y + D * D), C = z !== 0 ? 1 / z : 0, O = I.isZero, j = "serpentine";
            k *= C, Y *= C, D *= C;
            function q(ue, me, se) {
              var de = me !== t, ve = de && me > 0 && me < 1, we = de && se > 0 && se < 1;
              return de && (!(ve || we) || ue === "loop" && !(ve && we)) && (ue = "arch", ve = we = !1), {
                type: ue,
                roots: ve || we ? ve && we ? me < se ? [me, se] : [se, me] : [ve ? me : se] : null
              };
            }
            if (O(k))
              return O(Y) ? q(O(D) ? "line" : "quadratic") : q(j, D / (3 * Y));
            var H = 3 * Y * Y - 4 * k * D;
            if (O(H))
              return q("cusp", Y / (2 * k));
            var ie = H > 0 ? Math.sqrt(H / 3) : Math.sqrt(-H), ae = 2 * k;
            return q(
              H > 0 ? j : "loop",
              (Y + ie) / ae,
              (Y - ie) / ae
            );
          },
          getLength: function(l, u, d, v) {
            if (u === t && (u = 0), d === t && (d = 1), ze.isStraight(l)) {
              var p = l;
              d < 1 && (p = ze.subdivide(p, d)[0], u /= d), u > 0 && (p = ze.subdivide(p, u)[1]);
              var b = p[6] - p[0], S = p[7] - p[1];
              return Math.sqrt(b * b + S * S);
            }
            return I.integrate(
              v || i(l),
              u,
              d,
              r(u, d)
            );
          },
          getTimeAt: function(l, u, d) {
            if (d === t && (d = u < 0 ? 1 : 0), u === 0)
              return d;
            var v = Math.abs, p = 1e-12, b = u > 0, S = b ? d : 0, L = b ? 1 : d, E = i(l), A = ze.getLength(l, S, L, E), T = v(u) - A;
            if (v(T) < p)
              return b ? L : S;
            if (T > p)
              return null;
            var G = u / A, D = 0;
            function Y(k) {
              return D += I.integrate(
                E,
                d,
                k,
                r(d, k)
              ), d = k, D - u;
            }
            return I.findRoot(
              Y,
              E,
              d + G,
              S,
              L,
              32,
              1e-12
            );
          },
          getPoint: function(l, u) {
            return a(l, u, 0, !1);
          },
          getTangent: function(l, u) {
            return a(l, u, 1, !0);
          },
          getWeightedTangent: function(l, u) {
            return a(l, u, 1, !1);
          },
          getNormal: function(l, u) {
            return a(l, u, 2, !0);
          },
          getWeightedNormal: function(l, u) {
            return a(l, u, 2, !1);
          },
          getCurvature: function(l, u) {
            return a(l, u, 3, !1).x;
          },
          getPeaks: function(l) {
            var u = l[0], d = l[1], v = l[2], p = l[3], b = l[4], S = l[5], L = l[6], E = l[7], A = -u + 3 * v - 3 * b + L, T = 3 * u - 6 * v + 3 * b, G = -3 * u + 3 * v, D = -d + 3 * p - 3 * S + E, Y = 3 * d - 6 * p + 3 * S, k = -3 * d + 3 * p, z = 1e-8, C = 1 - z, O = [];
            return I.solveCubic(
              9 * (A * A + D * D),
              9 * (A * T + Y * D),
              2 * (T * T + Y * Y) + 3 * (G * A + k * D),
              G * T + Y * k,
              O,
              z,
              C
            ), O.sort();
          }
        } };
      }(),
      new function() {
        function i(T, G, D, Y, k, z, C) {
          var O = !C && D.getPrevious() === k, j = !C && D !== k && D.getNext() === k, q = 1e-8, H = 1 - q;
          if (Y !== null && Y >= (O ? q : 0) && Y <= (j ? H : 1) && z !== null && z >= (j ? q : 0) && z <= (O ? H : 1)) {
            var ie = new pt(D, Y, null, C), ae = new pt(k, z, null, C);
            ie._intersection = ae, ae._intersection = ie, (!G || G(ie)) && pt.insert(T, ie, !0);
          }
        }
        function r(T, G, D, Y, k, z, C, O, j, q, H, ie, ae) {
          if (++j >= 4096 || ++O >= 40)
            return j;
          var ue = 1e-9, me = G[0], se = G[1], de = G[6], ve = G[7], we = le.getSignedDistance, Se = we(me, se, de, ve, G[2], G[3]), Ae = we(me, se, de, ve, G[4], G[5]), Ge = Se * Ae > 0 ? 3 / 4 : 4 / 9, et = Ge * Math.min(0, Se, Ae), st = Ge * Math.max(0, Se, Ae), _t = we(me, se, de, ve, T[0], T[1]), Re = we(me, se, de, ve, T[2], T[3]), Fe = we(me, se, de, ve, T[4], T[5]), at = we(me, se, de, ve, T[6], T[7]), yt = a(_t, Re, Fe, at), bt = yt[0], Rt = yt[1], It, Ht;
          if (Se === 0 && Ae === 0 && _t === 0 && Re === 0 && Fe === 0 && at === 0 || (It = l(bt, Rt, et, st)) == null || (Ht = l(
            bt.reverse(),
            Rt.reverse(),
            et,
            st
          )) == null)
            return j;
          var jt = q + (H - q) * It, Vt = q + (H - q) * Ht;
          if (Math.max(ae - ie, Vt - jt) < ue) {
            var Ti = (jt + Vt) / 2, ki = (ie + ae) / 2;
            i(
              k,
              z,
              C ? Y : D,
              C ? ki : Ti,
              C ? D : Y,
              C ? Ti : ki
            );
          } else {
            T = ze.getPart(T, It, Ht);
            var Li = ae - ie;
            if (Ht - It > 0.8)
              if (Vt - jt > Li) {
                var bi = ze.subdivide(T, 0.5), Ti = (jt + Vt) / 2;
                j = r(
                  G,
                  bi[0],
                  Y,
                  D,
                  k,
                  z,
                  !C,
                  O,
                  j,
                  ie,
                  ae,
                  jt,
                  Ti
                ), j = r(
                  G,
                  bi[1],
                  Y,
                  D,
                  k,
                  z,
                  !C,
                  O,
                  j,
                  ie,
                  ae,
                  Ti,
                  Vt
                );
              } else {
                var bi = ze.subdivide(G, 0.5), ki = (ie + ae) / 2;
                j = r(
                  bi[0],
                  T,
                  Y,
                  D,
                  k,
                  z,
                  !C,
                  O,
                  j,
                  ie,
                  ki,
                  jt,
                  Vt
                ), j = r(
                  bi[1],
                  T,
                  Y,
                  D,
                  k,
                  z,
                  !C,
                  O,
                  j,
                  ki,
                  ae,
                  jt,
                  Vt
                );
              }
            else
              Li === 0 || Li >= ue ? j = r(
                G,
                T,
                Y,
                D,
                k,
                z,
                !C,
                O,
                j,
                ie,
                ae,
                jt,
                Vt
              ) : j = r(
                T,
                G,
                D,
                Y,
                k,
                z,
                C,
                O,
                j,
                jt,
                Vt,
                ie,
                ae
              );
          }
          return j;
        }
        function a(T, G, D, Y) {
          var k = [0, T], z = [1 / 3, G], C = [2 / 3, D], O = [1, Y], j = G - (2 * T + Y) / 3, q = D - (T + 2 * Y) / 3, H;
          if (j * q < 0)
            H = [[k, z, O], [k, C, O]];
          else {
            var ie = j / q;
            H = [
              ie >= 2 ? [k, z, O] : ie <= 0.5 ? [k, C, O] : [k, z, C, O],
              [k, O]
            ];
          }
          return (j || q) < 0 ? H.reverse() : H;
        }
        function l(T, G, D, Y) {
          return T[0][1] < D ? u(T, !0, D) : G[0][1] > Y ? u(G, !1, Y) : T[0][0];
        }
        function u(T, G, D) {
          for (var Y = T[0][0], k = T[0][1], z = 1, C = T.length; z < C; z++) {
            var O = T[z][0], j = T[z][1];
            if (G ? j >= D : j <= D)
              return j === D ? O : Y + (D - k) * (O - Y) / (j - k);
            Y = O, k = j;
          }
          return null;
        }
        function d(T, G, D, Y, k) {
          var z = I.isZero;
          if (z(Y) && z(k)) {
            var C = ze.getTimeOf(T, new M(G, D));
            return C === null ? [] : [C];
          }
          for (var O = Math.atan2(-k, Y), j = Math.sin(O), q = Math.cos(O), H = [], ie = [], ae = 0; ae < 8; ae += 2) {
            var ue = T[ae] - G, me = T[ae + 1] - D;
            H.push(
              ue * q - me * j,
              ue * j + me * q
            );
          }
          return ze.solveCubic(H, 1, 0, ie, 0, 1), ie;
        }
        function v(T, G, D, Y, k, z, C) {
          for (var O = G[0], j = G[1], q = G[6], H = G[7], ie = d(T, O, j, q - O, H - j), ae = 0, ue = ie.length; ae < ue; ae++) {
            var me = ie[ae], se = ze.getPoint(T, me), de = ze.getTimeOf(G, se);
            de !== null && i(
              k,
              z,
              C ? Y : D,
              C ? de : me,
              C ? D : Y,
              C ? me : de
            );
          }
        }
        function p(T, G, D, Y, k, z) {
          var C = le.intersect(
            T[0],
            T[1],
            T[6],
            T[7],
            G[0],
            G[1],
            G[6],
            G[7]
          );
          C && i(
            k,
            z,
            D,
            ze.getTimeOf(T, C),
            Y,
            ze.getTimeOf(G, C)
          );
        }
        function b(T, G, D, Y, k, z) {
          var C = 1e-12, O = Math.min, j = Math.max;
          if (j(T[0], T[2], T[4], T[6]) + C > O(G[0], G[2], G[4], G[6]) && O(T[0], T[2], T[4], T[6]) - C < j(G[0], G[2], G[4], G[6]) && j(T[1], T[3], T[5], T[7]) + C > O(G[1], G[3], G[5], G[7]) && O(T[1], T[3], T[5], T[7]) - C < j(G[1], G[3], G[5], G[7])) {
            var q = E(T, G);
            if (q)
              for (var H = 0; H < 2; H++) {
                var ie = q[H];
                i(
                  k,
                  z,
                  D,
                  ie[0],
                  Y,
                  ie[1],
                  !0
                );
              }
            else {
              var ae = ze.isStraight(T), ue = ze.isStraight(G), me = ae && ue, se = ae && !ue, de = k.length;
              if ((me ? p : ae || ue ? v : r)(
                se ? G : T,
                se ? T : G,
                se ? Y : D,
                se ? D : Y,
                k,
                z,
                se,
                0,
                0,
                0,
                1,
                0,
                1
              ), !me || k.length === de)
                for (var H = 0; H < 4; H++) {
                  var ve = H >> 1, we = H & 1, Se = ve * 6, Ae = we * 6, Ge = new M(T[Se], T[Se + 1]), et = new M(G[Ae], G[Ae + 1]);
                  Ge.isClose(et, C) && i(
                    k,
                    z,
                    D,
                    ve,
                    Y,
                    we
                  );
                }
            }
          }
          return k;
        }
        function S(T, G, D, Y) {
          var k = ze.classify(T);
          if (k.type === "loop") {
            var z = k.roots;
            i(
              D,
              Y,
              G,
              z[0],
              G,
              z[1]
            );
          }
          return D;
        }
        function L(T, G, D, Y, k, z) {
          var C = 1e-7, O = !G;
          O && (G = T);
          for (var j = T.length, q = G.length, H = new Array(j), ie = O ? H : new Array(q), ae = [], ue = 0; ue < j; ue++)
            H[ue] = T[ue].getValues(Y);
          if (!O)
            for (var ue = 0; ue < q; ue++)
              ie[ue] = G[ue].getValues(k);
          for (var me = x.findCurveBoundsCollisions(
            H,
            ie,
            C
          ), se = 0; se < j; se++) {
            var de = T[se], ve = H[se];
            O && S(ve, de, ae, D);
            var we = me[se];
            if (we)
              for (var Se = 0; Se < we.length; Se++) {
                if (z && ae.length)
                  return ae;
                var Ae = we[Se];
                if (!O || Ae > se) {
                  var Ge = G[Ae], et = ie[Ae];
                  b(
                    ve,
                    et,
                    de,
                    Ge,
                    ae,
                    D
                  );
                }
              }
          }
          return ae;
        }
        function E(T, G) {
          function D(at) {
            var yt = at[6] - at[0], bt = at[7] - at[1];
            return yt * yt + bt * bt;
          }
          var Y = Math.abs, k = le.getDistance, z = 1e-8, C = 1e-7, O = ze.isStraight(T), j = ze.isStraight(G), q = O && j, H = D(T) < D(G), ie = H ? G : T, ae = H ? T : G, ue = ie[0], me = ie[1], se = ie[6] - ue, de = ie[7] - me;
          if (k(ue, me, se, de, ae[0], ae[1], !0) < C && k(ue, me, se, de, ae[6], ae[7], !0) < C)
            !q && k(ue, me, se, de, ie[2], ie[3], !0) < C && k(ue, me, se, de, ie[4], ie[5], !0) < C && k(ue, me, se, de, ae[2], ae[3], !0) < C && k(ue, me, se, de, ae[4], ae[5], !0) < C && (O = j = q = !0);
          else if (q)
            return null;
          if (O ^ j)
            return null;
          for (var ve = [T, G], we = [], Se = 0; Se < 4 && we.length < 2; Se++) {
            var Ae = Se & 1, Ge = Ae ^ 1, et = Se >> 1, st = ze.getTimeOf(ve[Ae], new M(
              ve[Ge][et ? 6 : 0],
              ve[Ge][et ? 7 : 1]
            ));
            if (st != null) {
              var _t = Ae ? [et, st] : [st, et];
              (!we.length || Y(_t[0] - we[0][0]) > z && Y(_t[1] - we[0][1]) > z) && we.push(_t);
            }
            if (Se > 2 && !we.length)
              break;
          }
          if (we.length !== 2)
            we = null;
          else if (!q) {
            var Re = ze.getPart(T, we[0][0], we[1][0]), Fe = ze.getPart(G, we[0][1], we[1][1]);
            (Y(Fe[2] - Re[2]) > C || Y(Fe[3] - Re[3]) > C || Y(Fe[4] - Re[4]) > C || Y(Fe[5] - Re[5]) > C) && (we = null);
          }
          return we;
        }
        function A(T, G) {
          var D = T[0], Y = T[1], k = T[2], z = T[3], C = T[4], O = T[5], j = T[6], q = T[7], H = G.normalize(), ie = H.x, ae = H.y, ue = 3 * j - 9 * C + 9 * k - 3 * D, me = 3 * q - 9 * O + 9 * z - 3 * Y, se = 6 * C - 12 * k + 6 * D, de = 6 * O - 12 * z + 6 * Y, ve = 3 * k - 3 * D, we = 3 * z - 3 * Y, Se = 2 * ue * ae - 2 * me * ie, Ae = [];
          if (Math.abs(Se) < I.CURVETIME_EPSILON) {
            var Ge = ue * we - me * ve, Se = ue * de - me * se;
            if (Se != 0) {
              var et = -Ge / Se;
              et >= 0 && et <= 1 && Ae.push(et);
            }
          } else {
            var st = (se * se - 4 * ue * ve) * ae * ae + (-2 * se * de + 4 * me * ve + 4 * ue * we) * ie * ae + (de * de - 4 * me * we) * ie * ie, _t = se * ae - de * ie;
            if (st >= 0 && Se != 0) {
              var Re = Math.sqrt(st), Fe = -(_t + Re) / Se, at = (-_t + Re) / Se;
              Fe >= 0 && Fe <= 1 && Ae.push(Fe), at >= 0 && at <= 1 && Ae.push(at);
            }
          }
          return Ae;
        }
        return {
          getIntersections: function(T) {
            var G = this.getValues(), D = T && T !== this && T.getValues();
            return D ? b(G, D, this, T, []) : S(G, this, []);
          },
          statics: {
            getOverlaps: E,
            getIntersections: L,
            getCurveLineIntersections: d,
            getTimesWithTangent: A
          }
        };
      }()
    ), pt = o.extend(
      {
        _class: "CurveLocation",
        initialize: function(r, a, l, u, d) {
          if (a >= 0.99999999) {
            var v = r.getNext();
            v && (a = 0, r = v);
          }
          this._setCurve(r), this._time = a, this._point = l || r.getPointAtTime(a), this._overlap = u, this._distance = d, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(i) {
          this._path = i, this._version = i ? i._version : 0;
        },
        _setCurve: function(i) {
          this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
        },
        _setSegment: function(i) {
          var r = i.getCurve();
          r ? this._setCurve(r) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
        },
        getSegment: function() {
          var i = this._segment;
          if (!i) {
            var r = this.getCurve(), a = this.getTime();
            a === 0 ? i = r._segment1 : a === 1 ? i = r._segment2 : a != null && (i = r.getPartLength(0, a) < r.getPartLength(a, 1) ? r._segment1 : r._segment2), this._segment = i;
          }
          return i;
        },
        getCurve: function() {
          var i = this._path, r = this;
          i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function a(l) {
            var u = l && l.getCurve();
            if (u && (r._time = u.getTimeOf(r._point)) != null)
              return r._setCurve(u), u;
          }
          return this._curve || a(this._segment) || a(this._segment1) || a(this._segment2.getPrevious());
        },
        getPath: function() {
          var i = this.getCurve();
          return i && i._path;
        },
        getIndex: function() {
          var i = this.getCurve();
          return i && i.getIndex();
        },
        getTime: function() {
          var i = this.getCurve(), r = this._time;
          return i && r == null ? this._time = i.getTimeOf(this._point) : r;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var i = this._offset;
          if (i == null) {
            i = 0;
            var r = this.getPath(), a = this.getIndex();
            if (r && a != null)
              for (var l = r.getCurves(), u = 0; u < a; u++)
                i += l[u].getLength();
            this._offset = i += this.getCurveOffset();
          }
          return i;
        },
        getCurveOffset: function() {
          var i = this._curveOffset;
          if (i == null) {
            var r = this.getCurve(), a = this.getTime();
            this._curveOffset = i = a != null && r && r.getPartLength(0, a);
          }
          return i;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var i = this.getCurve(), r = i && i.divideAtTime(this.getTime());
          return r && this._setSegment(r._segment1), r;
        },
        split: function() {
          var i = this.getCurve(), r = i._path, a = i && i.splitAtTime(this.getTime());
          return a && this._setSegment(r.getLastSegment()), a;
        },
        equals: function(i, r) {
          var a = this === i;
          if (!a && i instanceof pt) {
            var l = this.getCurve(), u = i.getCurve(), d = l._path, v = u._path;
            if (d === v) {
              var p = Math.abs, b = 1e-7, S = p(this.getOffset() - i.getOffset()), L = !r && this._intersection, E = !r && i._intersection;
              a = (S < b || d && p(d.getLength() - S) < b) && (!L && !E || L && E && L.equals(E, !0));
            }
          }
          return a;
        },
        toString: function() {
          var i = [], r = this.getPoint(), a = B.instance;
          r && i.push("point: " + r);
          var l = this.getIndex();
          l != null && i.push("index: " + l);
          var u = this.getTime();
          return u != null && i.push("time: " + a.number(u)), this._distance != null && i.push("distance: " + a.number(this._distance)), "{ " + i.join(", ") + " }";
        },
        isTouching: function() {
          var i = this._intersection;
          if (i && this.getTangent().isCollinear(i.getTangent())) {
            var r = this.getCurve(), a = i.getCurve();
            return !(r.isStraight() && a.isStraight() && r.getLine().intersect(a.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var i = this._intersection;
          if (!i)
            return !1;
          var r = this.getTime(), a = i.getTime(), l = 1e-8, u = 1 - l, d = r >= l && r <= u, v = a >= l && a <= u;
          if (d && v)
            return !this.isTouching();
          var p = this.getCurve(), b = p && r < l ? p.getPrevious() : p, S = i.getCurve(), L = S && a < l ? S.getPrevious() : S;
          if (r > u && (p = p.getNext()), a > u && (S = S.getNext()), !b || !p || !L || !S)
            return !1;
          var E = [];
          function A(ie, ae) {
            var ue = ie.getValues(), me = ze.classify(ue).roots || ze.getPeaks(ue), se = me.length, de = ze.getLength(
              ue,
              ae && se ? me[se - 1] : 0,
              !ae && se ? me[0] : 1
            );
            E.push(se ? de : de / 32);
          }
          function T(ie, ae, ue) {
            return ae < ue ? ie > ae && ie < ue : ie > ae || ie < ue;
          }
          d || (A(b, !0), A(p, !1)), v || (A(L, !0), A(S, !1));
          var G = this.getPoint(), D = Math.min.apply(Math, E), Y = d ? p.getTangentAtTime(r) : p.getPointAt(D).subtract(G), k = d ? Y.negate() : b.getPointAt(-D).subtract(G), z = v ? S.getTangentAtTime(a) : S.getPointAt(D).subtract(G), C = v ? z.negate() : L.getPointAt(-D).subtract(G), O = k.getAngle(), j = Y.getAngle(), q = C.getAngle(), H = z.getAngle();
          return !!(d ? T(O, q, H) ^ T(j, q, H) && T(O, H, q) ^ T(j, H, q) : T(q, O, j) ^ T(H, O, j) && T(q, j, O) ^ T(H, j, O));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      o.each(ze._evaluateMethods, function(i) {
        var r = i + "At";
        this[i] = function() {
          var a = this.getCurve(), l = this.getTime();
          return l != null && a && a[r](l, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function i(r, a, l) {
          var u = r.length, d = 0, v = u - 1;
          function p(G, D) {
            for (var Y = G + D; Y >= -1 && Y <= u; Y += D) {
              var k = r[(Y % u + u) % u];
              if (!a.getPoint().isClose(
                k.getPoint(),
                1e-7
              ))
                break;
              if (a.equals(k))
                return k;
            }
            return null;
          }
          for (; d <= v; ) {
            var b = d + v >>> 1, S = r[b], L;
            if (l && (L = a.equals(S) ? S : p(b, -1) || p(b, 1)))
              return a._overlap && (L._overlap = L._intersection._overlap = !0), L;
            var E = a.getPath(), A = S.getPath(), T = E !== A ? E._id - A._id : a.getIndex() + a.getTime() - (S.getIndex() + S.getTime());
            T < 0 ? v = b - 1 : d = b + 1;
          }
          return r.splice(d, 0, a), a;
        }
        return { statics: {
          insert: i,
          expand: function(r) {
            for (var a = r.slice(), l = r.length - 1; l >= 0; l--)
              i(a, r[l]._intersection, !1);
            return a;
          }
        } };
      }()
    ), qt = X.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(i) {
          var r, a, l;
          if (o.isPlainObject(i) ? (a = i.segments, r = i.pathData) : Array.isArray(i) ? a = i : typeof i == "string" && (r = i), a) {
            var u = a[0];
            l = u && Array.isArray(u[0]);
          } else
            r && (l = (r.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(r));
          var d = l ? Et : We;
          return new d(i);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(i) {
        this.isClockwise() != (i = !!i) && this.reverse();
      },
      setPathData: function(i) {
        var r = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), a, l = !1, u, d, v = new M(), p = new M();
        function b(C, O) {
          var j = +a[C];
          return l && (j += v[O]), j;
        }
        function S(C) {
          return new M(
            b(C, "x"),
            b(C + 1, "y")
          );
        }
        this.clear();
        for (var L = 0, E = r && r.length; L < E; L++) {
          var A = r[L], T = A[0], G = T.toLowerCase();
          a = A.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var D = a && a.length;
          switch (l = T === G, u === "z" && !/[mz]/.test(G) && this.moveTo(v), G) {
            case "m":
            case "l":
              for (var Y = G === "m", k = 0; k < D; k += 2)
                this[Y ? "moveTo" : "lineTo"](v = S(k)), Y && (p = v, Y = !1);
              d = v;
              break;
            case "h":
            case "v":
              var z = G === "h" ? "x" : "y";
              v = v.clone();
              for (var k = 0; k < D; k++)
                v[z] = b(k, z), this.lineTo(v);
              d = v;
              break;
            case "c":
              for (var k = 0; k < D; k += 6)
                this.cubicCurveTo(
                  S(k),
                  d = S(k + 2),
                  v = S(k + 4)
                );
              break;
            case "s":
              for (var k = 0; k < D; k += 4)
                this.cubicCurveTo(
                  /[cs]/.test(u) ? v.multiply(2).subtract(d) : v,
                  d = S(k),
                  v = S(k + 2)
                ), u = G;
              break;
            case "q":
              for (var k = 0; k < D; k += 4)
                this.quadraticCurveTo(
                  d = S(k),
                  v = S(k + 2)
                );
              break;
            case "t":
              for (var k = 0; k < D; k += 2)
                this.quadraticCurveTo(
                  d = /[qt]/.test(u) ? v.multiply(2).subtract(d) : v,
                  v = S(k)
                ), u = G;
              break;
            case "a":
              for (var k = 0; k < D; k += 7)
                this.arcTo(
                  v = S(k + 5),
                  new V(+a[k], +a[k + 1]),
                  +a[k + 2],
                  +a[k + 4],
                  +a[k + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), v = p;
              break;
          }
          u = G;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(i) {
        var r = i.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(i) : {};
        return r.onPath || !!(this.getFillRule() === "evenodd" ? r.windingL & 1 || r.windingR & 1 : r.winding);
      },
      getIntersections: function(i, r, a, l) {
        var u = this === i || !i, d = this._matrix._orNullIfIdentity(), v = u ? d : (a || i._matrix)._orNullIfIdentity();
        return u || this.getBounds(d).intersects(
          i.getBounds(v),
          1e-12
        ) ? ze.getIntersections(
          this.getCurves(),
          !u && i.getCurves(),
          r,
          d,
          v,
          l
        ) : [];
      },
      getCrossings: function(i) {
        return this.getIntersections(i, function(r) {
          return r.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var i = M.read(arguments), r = this.getCurves(), a = 1 / 0, l = null, u = 0, d = r.length; u < d; u++) {
          var v = r[u].getNearestLocation(i);
          v._distance < a && (a = v._distance, l = v);
        }
        return l;
      },
      getNearestPoint: function() {
        var i = this.getNearestLocation.apply(this, arguments);
        return i && i.getPoint();
      },
      interpolate: function(i, r, a) {
        var l = !this._children, u = l ? "_segments" : "_children", d = i[u], v = r[u], p = this[u];
        if (!d || !v || d.length !== v.length)
          throw new Error("Invalid operands in interpolate() call: " + i + ", " + r);
        var b = p.length, S = v.length;
        if (b < S)
          for (var L = l ? ce : We, E = b; E < S; E++)
            this.add(new L());
        else
          b > S && this[l ? "removeSegments" : "removeChildren"](S, b);
        for (var E = 0; E < S; E++)
          p[E].interpolate(d[E], v[E], a);
        l && (this.setClosed(i._closed), this._changed(9));
      },
      compare: function(i) {
        var r = !1;
        if (i) {
          var a = this._children || [this], l = i._children ? i._children.slice() : [i], u = a.length, d = l.length, v = [], p = 0;
          r = !0;
          for (var b = x.findItemBoundsCollisions(a, l, I.GEOMETRIC_EPSILON), S = u - 1; S >= 0 && r; S--) {
            var L = a[S];
            r = !1;
            var E = b[S];
            if (E)
              for (var A = E.length - 1; A >= 0 && !r; A--)
                L.compare(l[E[A]]) && (v[E[A]] || (v[E[A]] = !0, p++), r = !0);
          }
          r = r && p === d;
        }
        return r;
      }
    }), We = qt.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(r) {
          this._closed = !1, this._segments = [], this._version = 0;
          var a = arguments, l = Array.isArray(r) ? typeof r[0] == "object" ? r : a : r && r.size === t && (r.x !== t || r.point !== t) ? a : null;
          l && l.length > 0 ? this.setSegments(l) : (this._curves = t, this._segmentSelection = 0, !l && typeof r == "string" && (this.setPathData(r), r = null)), this._initialize(!l && r);
        },
        _equals: function(i) {
          return this._closed === i._closed && o.equals(this._segments, i._segments);
        },
        copyContent: function(i) {
          this.setSegments(i._segments), this._closed = i._closed;
        },
        _changed: function i(r) {
          if (i.base.call(this, r), r & 8) {
            if (this._length = this._area = t, r & 32)
              this._version++;
            else if (this._curves)
              for (var a = 0, l = this._curves.length; a < l; a++)
                this._curves[a]._changed();
          } else
            r & 64 && (this._bounds = t);
        },
        getStyle: function() {
          var i = this._parent;
          return (i instanceof Et ? i : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(i) {
          var r = this.isFullySelected(), a = i && i.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, a) {
            var l = i[a - 1];
            typeof l == "boolean" && (this.setClosed(l), a--), this._add(ce.readList(i, 0, {}, a));
          }
          r && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var i = this._curves, r = this._segments;
          if (!i) {
            var a = this._countCurves();
            i = this._curves = new Array(a);
            for (var l = 0; l < a; l++)
              i[l] = new ze(
                this,
                r[l],
                r[l + 1] || r[0]
              );
          }
          return i;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var i = this.getCurves();
          return i[i.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(i) {
          if (this._closed != (i = !!i)) {
            if (this._closed = i, this._curves) {
              var r = this._curves.length = this._countCurves();
              i && (this._curves[r - 1] = new ze(
                this,
                this._segments[r - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(i, r) {
          var a = this._segments, l = a.length, u = new B(r), d = new Array(6), v = !0, p, b, S, L, E, A, T, G, D = [];
          function Y(z, C) {
            if (z._transformCoordinates(i, d), p = d[0], b = d[1], v)
              D.push("M" + u.pair(p, b)), v = !1;
            else if (E = d[2], A = d[3], E === p && A === b && T === S && G === L) {
              if (!C) {
                var O = p - S, j = b - L;
                D.push(
                  O === 0 ? "v" + u.number(j) : j === 0 ? "h" + u.number(O) : "l" + u.pair(O, j)
                );
              }
            } else
              D.push("c" + u.pair(T - S, G - L) + " " + u.pair(E - S, A - L) + " " + u.pair(p - S, b - L));
            S = p, L = b, T = d[4], G = d[5];
          }
          if (!l)
            return "";
          for (var k = 0; k < l; k++)
            Y(a[k]);
          return this._closed && l > 0 && (Y(a[0], !0), D.push("z")), D.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(i) {
          for (var r = this._segments, a = new Array(6), l = 0, u = r.length; l < u; l++)
            r[l]._transformCoordinates(i, a, !0);
          return !0;
        },
        _add: function(i, v) {
          for (var a = this._segments, l = this._curves, u = i.length, d = v == null, v = d ? a.length : v, p = 0; p < u; p++) {
            var b = i[p];
            b._path && (b = i[p] = b.clone()), b._path = this, b._index = v + p, b._selection && this._updateSelection(b, 0, b._selection);
          }
          if (d)
            o.push(a, i);
          else {
            a.splice.apply(a, [v, 0].concat(i));
            for (var p = v + u, S = a.length; p < S; p++)
              a[p]._index = p;
          }
          if (l) {
            var L = this._countCurves(), E = v > 0 && v + u - 1 === L ? v - 1 : v, A = E, T = Math.min(E + u, L);
            i._curves && (l.splice.apply(l, [E, 0].concat(i._curves)), A += i._curves.length);
            for (var p = A; p < T; p++)
              l.splice(p, 0, new ze(this, null, null));
            this._adjustCurves(E, T);
          }
          return this._changed(41), i;
        },
        _adjustCurves: function(i, r) {
          for (var a = this._segments, l = this._curves, u, d = i; d < r; d++)
            u = l[d], u._path = this, u._segment1 = a[d], u._segment2 = a[d + 1] || a[0], u._changed();
          (u = l[this._closed && !i ? a.length - 1 : i - 1]) && (u._segment2 = a[i] || a[0], u._changed()), (u = l[r]) && (u._segment1 = a[r], u._changed());
        },
        _countCurves: function() {
          var i = this._segments.length;
          return !this._closed && i > 0 ? i - 1 : i;
        },
        add: function(i) {
          var r = arguments;
          return r.length > 1 && typeof i != "number" ? this._add(ce.readList(r)) : this._add([ce.read(r)])[0];
        },
        insert: function(i, r) {
          var a = arguments;
          return a.length > 2 && typeof r != "number" ? this._add(ce.readList(a, 1), i) : this._add([ce.read(a, 1)], i)[0];
        },
        addSegment: function() {
          return this._add([ce.read(arguments)])[0];
        },
        insertSegment: function(i) {
          return this._add([ce.read(arguments, 1)], i)[0];
        },
        addSegments: function(i) {
          return this._add(ce.readList(i));
        },
        insertSegments: function(i, r) {
          return this._add(ce.readList(r), i);
        },
        removeSegment: function(i) {
          return this.removeSegments(i, i + 1)[0] || null;
        },
        removeSegments: function(i, r, a) {
          i = i || 0, r = o.pick(r, this._segments.length);
          var l = this._segments, u = this._curves, d = l.length, v = l.splice(i, r - i), p = v.length;
          if (!p)
            return v;
          for (var b = 0; b < p; b++) {
            var S = v[b];
            S._selection && this._updateSelection(S, S._selection, 0), S._index = S._path = null;
          }
          for (var b = i, L = l.length; b < L; b++)
            l[b]._index = b;
          if (u) {
            for (var E = i > 0 && r === d + (this._closed ? 1 : 0) ? i - 1 : i, u = u.splice(E, p), b = u.length - 1; b >= 0; b--)
              u[b]._path = null;
            a && (v._curves = u.slice(1)), this._adjustCurves(E, E);
          }
          return this._changed(41), v;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var i = this._segments, r = 0, a = i.length; r < a; r++)
            if (i[r].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var i = this._segments, r = 0, a = i.length; r < a; r++)
            i[r].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var i = this.getCurves(), r = 0, a = 0, l = i.length; a < l; a++)
              r += i[a].getLength();
            this._length = r;
          }
          return this._length;
        },
        getArea: function() {
          var i = this._area;
          if (i == null) {
            var r = this._segments, a = this._closed;
            i = 0;
            for (var l = 0, u = r.length; l < u; l++) {
              var d = l + 1 === u;
              i += ze.getArea(ze.getValues(
                r[l],
                r[d ? 0 : l + 1],
                null,
                d && !a
              ));
            }
            this._area = i;
          }
          return i;
        },
        isFullySelected: function() {
          var i = this._segments.length;
          return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
        },
        setFullySelected: function(i) {
          i && this._selectSegments(!0), this.setSelected(i);
        },
        setSelection: function i(r) {
          r & 1 || this._selectSegments(!1), i.base.call(this, r);
        },
        _selectSegments: function(i) {
          var r = this._segments, a = r.length, l = i ? 7 : 0;
          this._segmentSelection = l * a;
          for (var u = 0; u < a; u++)
            r[u]._selection = l;
        },
        _updateSelection: function(i, r, a) {
          i._selection = a;
          var l = this._segmentSelection += a - r;
          l > 0 && this.setSelected(!0);
        },
        divideAt: function(i) {
          var r = this.getLocationAt(i), a;
          return r && (a = r.getCurve().divideAt(r.getCurveOffset())) ? a._segment1 : null;
        },
        splitAt: function(i) {
          var r = this.getLocationAt(i), a = r && r.index, l = r && r.time, u = 1e-8, d = 1 - u;
          l > d && (a++, l = 0);
          var v = this.getCurves();
          if (a >= 0 && a < v.length) {
            l >= u && v[a++].divideAtTime(l);
            var p = this.removeSegments(a, this._segments.length, !0), b;
            return this._closed ? (this.setClosed(!1), b = this) : (b = new We(X.NO_INSERT), b.insertAbove(this), b.copyAttributes(this)), b._add(p, 0), this.addSegment(p[0]), b;
          }
          return null;
        },
        split: function(i, r) {
          var a, l = r === t ? i : (a = this.getCurves()[i]) && a.getLocationAtTime(r);
          return l != null ? this.splitAt(l) : null;
        },
        join: function(i, r) {
          var a = r || 0;
          if (i && i !== this) {
            var l = i._segments, u = this.getLastSegment(), d = i.getLastSegment();
            if (!d)
              return this;
            u && u._point.isClose(d._point, a) && i.reverse();
            var v = i.getFirstSegment();
            if (u && u._point.isClose(v._point, a))
              u.setHandleOut(v._handleOut), this._add(l.slice(1));
            else {
              var p = this.getFirstSegment();
              p && p._point.isClose(v._point, a) && i.reverse(), d = i.getLastSegment(), p && p._point.isClose(d._point, a) ? (p.setHandleIn(d._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
            }
            i._closed && this._add([l[0]]), i.remove();
          }
          var b = this.getFirstSegment(), S = this.getLastSegment();
          return b !== S && b._point.isClose(S._point, a) && (b.setHandleIn(S._handleIn), S.remove(), this.setClosed(!0)), this;
        },
        reduce: function(i) {
          for (var r = this.getCurves(), a = i && i.simplify, l = a ? 1e-7 : 0, u = r.length - 1; u >= 0; u--) {
            var d = r[u];
            !d.hasHandles() && (!d.hasLength(l) || a && d.isCollinear(d.getNext())) && d.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var i = 0, r = this._segments.length; i < r; i++) {
            var a = this._segments[i], l = a._handleIn;
            a._handleIn = a._handleOut, a._handleOut = l, a._index = i;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(i) {
          for (var r = new rt(this, i || 0.25, 256, !0), a = r.parts, l = a.length, u = [], d = 0; d < l; d++)
            u.push(new ce(a[d].curve.slice(0, 2)));
          !this._closed && l > 0 && u.push(new ce(a[l - 1].curve.slice(6))), this.setSegments(u);
        },
        simplify: function(i) {
          var r = new it(this).fit(i || 2.5);
          return r && this.setSegments(r), !!r;
        },
        smooth: function(i) {
          var r = this, a = i || {}, l = a.type || "asymmetric", u = this._segments, d = u.length, v = this._closed;
          function p(bt, Rt) {
            var It = bt && bt.index;
            if (It != null) {
              var Ht = bt.path;
              if (Ht && Ht !== r)
                throw new Error(bt._class + " " + It + " of " + Ht + " is not part of " + r);
              Rt && bt instanceof ze && It++;
            } else
              It = typeof bt == "number" ? bt : Rt;
            return Math.min(It < 0 && v ? It % d : It < 0 ? It + d : It, d - 1);
          }
          var b = v && a.from === t && a.to === t, S = p(a.from, 0), L = p(a.to, d - 1);
          if (S > L)
            if (v)
              S -= d;
            else {
              var E = S;
              S = L, L = E;
            }
          if (/^(?:asymmetric|continuous)$/.test(l)) {
            var A = l === "asymmetric", T = Math.min, G = L - S + 1, D = G - 1, Y = b ? T(G, 4) : 1, k = Y, z = Y, C = [];
            if (v || (k = T(1, S), z = T(1, d - L - 1)), D += k + z, D <= 1)
              return;
            for (var O = 0, j = S - k; O <= D; O++, j++)
              C[O] = u[(j < 0 ? j + d : j) % d]._point;
            for (var q = C[0]._x + 2 * C[1]._x, H = C[0]._y + 2 * C[1]._y, ie = 2, ae = D - 1, ue = [q], me = [H], se = [ie], de = [], ve = [], O = 1; O < D; O++) {
              var we = O < ae, Se = we || A ? 1 : 2, Ae = we ? 4 : A ? 2 : 7, Ge = we ? 4 : A ? 3 : 8, et = we ? 2 : A ? 0 : 1, st = Se / ie;
              ie = se[O] = Ae - st, q = ue[O] = Ge * C[O]._x + et * C[O + 1]._x - st * q, H = me[O] = Ge * C[O]._y + et * C[O + 1]._y - st * H;
            }
            de[ae] = ue[ae] / se[ae], ve[ae] = me[ae] / se[ae];
            for (var O = D - 2; O >= 0; O--)
              de[O] = (ue[O] - de[O + 1]) / se[O], ve[O] = (me[O] - ve[O + 1]) / se[O];
            de[D] = (3 * C[D]._x - de[ae]) / 2, ve[D] = (3 * C[D]._y - ve[ae]) / 2;
            for (var O = k, _t = D - z, j = S; O <= _t; O++, j++) {
              var Re = u[j < 0 ? j + d : j], Fe = Re._point, at = de[O] - Fe._x, yt = ve[O] - Fe._y;
              (b || O < _t) && Re.setHandleOut(at, yt), (b || O > k) && Re.setHandleIn(-at, -yt);
            }
          } else
            for (var O = S; O <= L; O++)
              u[O < 0 ? O + d : O].smooth(
                a,
                !b && O === S,
                !b && O === L
              );
        },
        toShape: function(i) {
          if (!this._closed)
            return null;
          var r = this._segments, a, l, u, d;
          function v(A, T) {
            var G = r[A], D = G.getNext(), Y = r[T], k = Y.getNext();
            return G._handleOut.isZero() && D._handleIn.isZero() && Y._handleOut.isZero() && k._handleIn.isZero() && D._point.subtract(G._point).isCollinear(
              k._point.subtract(Y._point)
            );
          }
          function p(A) {
            var T = r[A], G = T.getPrevious(), D = T.getNext();
            return G._handleOut.isZero() && T._handleIn.isZero() && T._handleOut.isZero() && D._handleIn.isZero() && T._point.subtract(G._point).isOrthogonal(
              D._point.subtract(T._point)
            );
          }
          function b(A) {
            var T = r[A], G = T.getNext(), D = T._handleOut, Y = G._handleIn, k = 0.5522847498307936;
            if (D.isOrthogonal(Y)) {
              var z = T._point, C = G._point, O = new le(z, D, !0).intersect(
                new le(C, Y, !0),
                !0
              );
              return O && I.isZero(D.getLength() / O.subtract(z).getLength() - k) && I.isZero(Y.getLength() / O.subtract(C).getLength() - k);
            }
            return !1;
          }
          function S(A, T) {
            return r[A]._point.getDistance(r[T]._point);
          }
          if (!this.hasHandles() && r.length === 4 && v(0, 2) && v(1, 3) && p(1) ? (a = Ee.Rectangle, l = new V(S(0, 3), S(0, 1)), d = r[1]._point.add(r[2]._point).divide(2)) : r.length === 8 && b(0) && b(2) && b(4) && b(6) && v(1, 5) && v(3, 7) ? (a = Ee.Rectangle, l = new V(S(1, 6), S(0, 3)), u = l.subtract(new V(
            S(0, 7),
            S(1, 2)
          )).divide(2), d = r[3]._point.add(r[4]._point).divide(2)) : r.length === 4 && b(0) && b(1) && b(2) && b(3) && (I.isZero(S(0, 2) - S(1, 3)) ? (a = Ee.Circle, u = S(0, 2) / 2) : (a = Ee.Ellipse, u = new V(S(2, 0) / 2, S(3, 1) / 2)), d = r[1]._point), a) {
            var L = this.getPosition(!0), E = new a({
              center: L,
              size: l,
              radius: u,
              insert: !1
            });
            return E.copyAttributes(this, !0), E._matrix.prepend(this._matrix), E.rotate(d.subtract(L).getAngle() + 90), (i === t || i) && E.insertAbove(this), E;
          }
          return null;
        },
        toPath: "#clone",
        compare: function i(r) {
          if (!r || r instanceof Et)
            return i.base.call(this, r);
          var a = this.getCurves(), l = r.getCurves(), u = a.length, d = l.length;
          if (!u || !d)
            return u == d;
          for (var v = a[0].getValues(), p = [], b = 0, S, L = 0, E, A = 0; A < d; A++) {
            var Y = l[A].getValues();
            p.push(Y);
            var T = ze.getOverlaps(v, Y);
            if (T) {
              S = !A && T[0][0] > 0 ? d - 1 : A, E = T[0][1];
              break;
            }
          }
          for (var G = Math.abs, D = 1e-8, Y = p[S], k; v && Y; ) {
            var T = ze.getOverlaps(v, Y);
            if (T) {
              var z = T[0][0];
              if (G(z - L) < D) {
                L = T[1][0], L === 1 && (v = ++b < u ? a[b].getValues() : null, L = 0);
                var C = T[0][1];
                if (G(C - E) < D) {
                  if (k || (k = [S, C]), E = T[1][1], E === 1 && (++S >= d && (S = 0), Y = p[S] || l[S].getValues(), E = 0), !v)
                    return k[0] === S && k[1] === E;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(i, r, a, l) {
          var u = this, d = this.getStyle(), v = this._segments, p = v.length, b = this._closed, S = r._tolerancePadding, L = S, E, A, T, G, D, Y, k = r.stroke && d.hasStroke(), z = r.fill && d.hasFill(), C = r.curves, O = k ? d.getStrokeWidth() / 2 : z && r.tolerance > 0 || C ? 0 : null;
          O !== null && (O > 0 ? (E = d.getStrokeJoin(), A = d.getStrokeCap(), T = d.getMiterLimit(), L = L.add(
            We._getStrokePadding(O, l)
          )) : E = A = "round");
          function j(de, ve) {
            return i.subtract(de).divide(ve).length <= 1;
          }
          function q(de, ve, we) {
            if (!r.selected || ve.isSelected()) {
              var Se = de._point;
              if (ve !== Se && (ve = ve.add(Se)), j(ve, L))
                return new $e(we, u, {
                  segment: de,
                  point: ve
                });
            }
          }
          function H(de, ve) {
            return (ve || r.segments) && q(de, de._point, "segment") || !ve && r.handles && (q(de, de._handleIn, "handle-in") || q(de, de._handleOut, "handle-out"));
          }
          function ie(de) {
            G.add(de);
          }
          function ae(de) {
            var ve = b || de._index > 0 && de._index < p - 1;
            if ((ve ? E : A) === "round")
              return j(de._point, L);
            if (G = new We({ internal: !0, closed: !0 }), ve ? de.isSmooth() || We._addBevelJoin(
              de,
              E,
              O,
              T,
              null,
              l,
              ie,
              !0
            ) : A === "square" && We._addSquareCap(
              de,
              A,
              O,
              null,
              l,
              ie,
              !0
            ), !G.isEmpty()) {
              var we;
              return G.contains(i) || (we = G.getNearestLocation(i)) && j(we.getPoint(), S);
            }
          }
          if (r.ends && !r.segments && !b) {
            if (Y = H(v[0], !0) || H(v[p - 1], !0))
              return Y;
          } else if (r.segments || r.handles) {
            for (var ue = 0; ue < p; ue++)
              if (Y = H(v[ue]))
                return Y;
          }
          if (O !== null) {
            if (D = this.getNearestLocation(i), D) {
              var me = D.getTime();
              me === 0 || me === 1 && p > 1 ? ae(D.getSegment()) || (D = null) : j(D.getPoint(), L) || (D = null);
            }
            if (!D && E === "miter" && p > 1)
              for (var ue = 0; ue < p; ue++) {
                var se = v[ue];
                if (i.getDistance(se._point) <= T * O && ae(se)) {
                  D = se.getLocation();
                  break;
                }
              }
          }
          return !D && z && this._contains(i) || D && !k && !C ? new $e("fill", this) : D ? new $e(k ? "stroke" : "curve", this, {
            location: D,
            point: D.getPoint()
          }) : null;
        }
      },
      o.each(
        ze._evaluateMethods,
        function(i) {
          this[i + "At"] = function(r) {
            var a = this.getLocationAt(r);
            return a && a[i]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var i = M.read(arguments), r = this.getCurves(), a = 0, l = r.length; a < l; a++) {
              var u = r[a].getLocationOf(i);
              if (u)
                return u;
            }
            return null;
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getLocationAt: function(i) {
            if (typeof i == "number") {
              for (var r = this.getCurves(), a = 0, l = 0, u = r.length; l < u; l++) {
                var d = a, v = r[l];
                if (a += v.getLength(), a > i)
                  return v.getLocationAt(i - d);
              }
              if (r.length > 0 && i <= this.getLength())
                return new pt(r[r.length - 1], 1);
            } else if (i && i.getPath && i.getPath() === this)
              return i;
            return null;
          },
          getOffsetsWithTangent: function() {
            var i = M.read(arguments);
            if (i.isZero())
              return [];
            for (var r = [], a = 0, l = this.getCurves(), u = 0, d = l.length; u < d; u++) {
              for (var v = l[u], p = v.getTimesWithTangent(i), b = 0, S = p.length; b < S; b++) {
                var L = a + v.getOffsetAtTime(p[b]);
                r.indexOf(L) < 0 && r.push(L);
              }
              a += v.length;
            }
            return r;
          }
        }
      ),
      new function() {
        function i(a, l, u, d) {
          if (d <= 0)
            return;
          var v = d / 2, p = d - 2, b = v - 1, S = new Array(6), L, E;
          function A(z) {
            var C = S[z], O = S[z + 1];
            (L != C || E != O) && (a.beginPath(), a.moveTo(L, E), a.lineTo(C, O), a.stroke(), a.beginPath(), a.arc(C, O, v, 0, Math.PI * 2, !0), a.fill());
          }
          for (var T = 0, G = l.length; T < G; T++) {
            var D = l[T], Y = D._selection;
            if (D._transformCoordinates(u, S), L = S[0], E = S[1], Y & 2 && A(2), Y & 4 && A(4), a.fillRect(L - v, E - v, d, d), p > 0 && !(Y & 1)) {
              var k = a.fillStyle;
              a.fillStyle = "#ffffff", a.fillRect(L - b, E - b, p, p), a.fillStyle = k;
            }
          }
        }
        function r(a, l, u) {
          var d = l._segments, v = d.length, p = new Array(6), b = !0, S, L, E, A, T, G, D, Y;
          function k(C) {
            if (u)
              C._transformCoordinates(u, p), S = p[0], L = p[1];
            else {
              var O = C._point;
              S = O._x, L = O._y;
            }
            if (b)
              a.moveTo(S, L), b = !1;
            else {
              if (u)
                T = p[2], G = p[3];
              else {
                var j = C._handleIn;
                T = S + j._x, G = L + j._y;
              }
              T === S && G === L && D === E && Y === A ? a.lineTo(S, L) : a.bezierCurveTo(D, Y, T, G, S, L);
            }
            if (E = S, A = L, u)
              D = p[4], Y = p[5];
            else {
              var j = C._handleOut;
              D = E + j._x, Y = A + j._y;
            }
          }
          for (var z = 0; z < v; z++)
            k(d[z]);
          l._closed && v > 0 && k(d[0]);
        }
        return {
          _draw: function(a, l, u, d) {
            var v = l.dontStart, p = l.dontFinish || l.clip, b = this.getStyle(), S = b.hasFill(), L = b.hasStroke(), E = b.getDashArray(), A = !Ye.support.nativeDash && L && E && E.length;
            v || a.beginPath(), (S || L && !A || p) && (r(a, this, d), this._closed && a.closePath());
            function T(C) {
              return E[(C % A + A) % A];
            }
            if (!p && (S || L) && (this._setStyles(a, l, u), S && (a.fill(b.getFillRule()), a.shadowColor = "rgba(0,0,0,0)"), L)) {
              if (A) {
                v || a.beginPath();
                for (var G = new rt(
                  this,
                  0.25,
                  32,
                  !1,
                  d
                ), D = G.length, Y = -b.getDashOffset(), k, z = 0; Y > 0; )
                  Y -= T(z--) + T(z--);
                for (; Y < D; )
                  k = Y + T(z++), (Y > 0 || k > 0) && G.drawPart(
                    a,
                    Math.max(Y, 0),
                    Math.max(k, 0)
                  ), Y = k + T(z++);
              }
              a.stroke();
            }
          },
          _drawSelected: function(a, l) {
            a.beginPath(), r(a, this, l), a.stroke(), i(a, this._segments, l, Ye.settings.handleSize);
          }
        };
      }(),
      new function() {
        function i(r) {
          var a = r._segments;
          if (!a.length)
            throw new Error("Use a moveTo() command first");
          return a[a.length - 1];
        }
        return {
          moveTo: function() {
            var r = this._segments;
            r.length === 1 && this.removeSegment(0), r.length || this._add([new ce(M.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new ce(M.read(arguments))]);
          },
          cubicCurveTo: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = M.read(r), d = i(this);
            d.setHandleOut(a.subtract(d._point)), this._add([new ce(u, l.subtract(u))]);
          },
          quadraticCurveTo: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = i(this)._point;
            this.cubicCurveTo(
              a.add(u.subtract(a).multiply(1 / 3)),
              a.add(l.subtract(a).multiply(1 / 3)),
              l
            );
          },
          curveTo: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = o.pick(o.read(r), 0.5), d = 1 - u, v = i(this)._point, p = a.subtract(v.multiply(d * d)).subtract(l.multiply(u * u)).divide(2 * u * d);
            if (p.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + u
              );
            this.quadraticCurveTo(p, l);
          },
          arcTo: function() {
            var r = arguments, a = Math.abs, l = Math.sqrt, u = i(this), d = u._point, v = M.read(r), p, b = o.peek(r), S = o.pick(b, !0), L, E, A, T;
            if (typeof S == "boolean")
              var G = d.add(v).divide(2), p = G.add(G.subtract(d).rotate(
                S ? -90 : 90
              ));
            else if (o.remain(r) <= 2)
              p = v, v = M.read(r);
            else if (!d.equals(v)) {
              var D = V.read(r), Y = I.isZero;
              if (Y(D.width) || Y(D.height))
                return this.lineTo(v);
              var k = o.read(r), S = !!o.read(r), z = !!o.read(r), G = d.add(v).divide(2), C = d.subtract(G).rotate(-k), O = C.x, j = C.y, q = a(D.width), H = a(D.height), ie = q * q, ae = H * H, ue = O * O, me = j * j, se = l(ue / ie + me / ae);
              if (se > 1 && (q *= se, H *= se, ie = q * q, ae = H * H), se = (ie * ae - ie * me - ae * ue) / (ie * me + ae * ue), a(se) < 1e-12 && (se = 0), se < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              L = new M(q * j / H, -H * O / q).multiply((z === S ? -1 : 1) * l(se)).rotate(k).add(G), T = new J().translate(L).rotate(k).scale(q, H), A = T._inverseTransform(d), E = A.getDirectedAngle(T._inverseTransform(v)), !S && E > 0 ? E -= 360 : S && E < 0 && (E += 360);
            }
            if (p) {
              var de = new le(
                d.add(p).divide(2),
                p.subtract(d).rotate(90),
                !0
              ), ve = new le(
                p.add(v).divide(2),
                v.subtract(p).rotate(90),
                !0
              ), we = new le(d, v), Se = we.getSide(p);
              if (L = de.intersect(ve, !0), !L) {
                if (!Se)
                  return this.lineTo(v);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              A = d.subtract(L), E = A.getDirectedAngle(v.subtract(L));
              var Ae = we.getSide(L, !0);
              Ae === 0 ? E = Se * a(E) : Se === Ae && (E += E < 0 ? 360 : -360);
            }
            if (E) {
              for (var Ge = 1e-5, et = a(E), st = et >= 360 ? 4 : Math.ceil((et - Ge) / 90), _t = E / st, Re = _t * Math.PI / 360, Fe = 4 / 3 * Math.sin(Re) / (1 + Math.cos(Re)), at = [], yt = 0; yt <= st; yt++) {
                var C = v, bt = null;
                if (yt < st && (bt = A.rotate(90).multiply(Fe), T ? (C = T._transformPoint(A), bt = T._transformPoint(A.add(bt)).subtract(C)) : C = L.add(A)), !yt)
                  u.setHandleOut(bt);
                else {
                  var Rt = A.rotate(-90).multiply(Fe);
                  T && (Rt = T._transformPoint(A.add(Rt)).subtract(C)), at.push(new ce(C, Rt, bt));
                }
                A = A.rotate(_t);
              }
              this._add(at);
            }
          },
          lineBy: function() {
            var r = M.read(arguments), a = i(this)._point;
            this.lineTo(a.add(r));
          },
          curveBy: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = o.read(r), d = i(this)._point;
            this.curveTo(d.add(a), d.add(l), u);
          },
          cubicCurveBy: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = M.read(r), d = i(this)._point;
            this.cubicCurveTo(
              d.add(a),
              d.add(l),
              d.add(u)
            );
          },
          quadraticCurveBy: function() {
            var r = arguments, a = M.read(r), l = M.read(r), u = i(this)._point;
            this.quadraticCurveTo(u.add(a), u.add(l));
          },
          arcBy: function() {
            var r = arguments, a = i(this)._point, l = a.add(M.read(r)), u = o.pick(o.peek(r), !0);
            typeof u == "boolean" ? this.arcTo(l, u) : this.arcTo(l, a.add(M.read(r)));
          },
          closePath: function(r) {
            this.setClosed(!0), this.join(this, r);
          }
        };
      }(),
      {
        _getBounds: function(i, r) {
          var a = r.handle ? "getHandleBounds" : r.stroke ? "getStrokeBounds" : "getBounds";
          return We[a](this._segments, this._closed, this, i, r);
        },
        statics: {
          getBounds: function(i, r, a, l, u, d) {
            var v = i[0];
            if (!v)
              return new P();
            var p = new Array(6), b = v._transformCoordinates(l, new Array(6)), S = b.slice(0, 2), L = S.slice(), E = new Array(2);
            function A(D) {
              D._transformCoordinates(l, p);
              for (var Y = 0; Y < 2; Y++)
                ze._addBounds(
                  b[Y],
                  b[Y + 4],
                  p[Y + 2],
                  p[Y],
                  Y,
                  d ? d[Y] : 0,
                  S,
                  L,
                  E
                );
              var k = b;
              b = p, p = k;
            }
            for (var T = 1, G = i.length; T < G; T++)
              A(i[T]);
            return r && A(v), new P(S[0], S[1], L[0] - S[0], L[1] - S[1]);
          },
          getStrokeBounds: function(i, r, a, l, u) {
            var d = a.getStyle(), v = d.hasStroke(), p = d.getStrokeWidth(), b = v && a._getStrokeMatrix(l, u), S = v && We._getStrokePadding(
              p,
              b
            ), L = We.getBounds(
              i,
              r,
              a,
              l,
              u,
              S
            );
            if (!v)
              return L;
            var E = p / 2, A = d.getStrokeJoin(), T = d.getStrokeCap(), G = d.getMiterLimit(), D = new P(new V(S));
            function Y(q) {
              L = L.include(q);
            }
            function k(q) {
              L = L.unite(
                D.setCenter(q._point.transform(l))
              );
            }
            function z(q, H) {
              H === "round" || q.isSmooth() ? k(q) : We._addBevelJoin(
                q,
                H,
                E,
                G,
                l,
                b,
                Y
              );
            }
            function C(q, H) {
              H === "round" ? k(q) : We._addSquareCap(
                q,
                H,
                E,
                l,
                b,
                Y
              );
            }
            var O = i.length - (r ? 0 : 1);
            if (O > 0) {
              for (var j = 1; j < O; j++)
                z(i[j], A);
              r ? z(i[0], A) : (C(i[0], T), C(i[i.length - 1], T));
            }
            return L;
          },
          _getStrokePadding: function(i, r) {
            if (!r)
              return [i, i];
            var a = new M(i, 0).transform(r), l = new M(0, i).transform(r), u = a.getAngleInRadians(), d = a.getLength(), v = l.getLength(), p = Math.sin(u), b = Math.cos(u), S = Math.tan(u), L = Math.atan2(v * S, d), E = Math.atan2(v, S * d);
            return [
              Math.abs(d * Math.cos(L) * b + v * Math.sin(L) * p),
              Math.abs(v * Math.sin(E) * b + d * Math.cos(E) * p)
            ];
          },
          _addBevelJoin: function(i, r, a, l, u, d, v, p) {
            var b = i.getCurve(), S = b.getPrevious(), L = b.getPoint1().transform(u), E = S.getNormalAtTime(1).multiply(a).transform(d), A = b.getNormalAtTime(0).multiply(a).transform(d), T = E.getDirectedAngle(A);
            if ((T < 0 || T >= 180) && (E = E.negate(), A = A.negate()), p && v(L), v(L.add(E)), r === "miter") {
              var G = new le(
                L.add(E),
                new M(-E.y, E.x),
                !0
              ).intersect(new le(
                L.add(A),
                new M(-A.y, A.x),
                !0
              ), !0);
              G && L.getDistance(G) <= l * a && v(G);
            }
            v(L.add(A));
          },
          _addSquareCap: function(i, r, a, l, u, d, v) {
            var p = i._point.transform(l), b = i.getLocation(), S = b.getNormal().multiply(b.getTime() === 0 ? a : -a).transform(u);
            r === "square" && (v && (d(p.subtract(S)), d(p.add(S))), p = p.add(S.rotate(-90))), d(p.add(S)), d(p.subtract(S));
          },
          getHandleBounds: function(i, r, a, l, u) {
            var d = a.getStyle(), v = u.stroke && d.hasStroke(), p, b;
            if (v) {
              var S = a._getStrokeMatrix(l, u), L = d.getStrokeWidth() / 2, E = L;
              d.getStrokeJoin() === "miter" && (E = L * d.getMiterLimit()), d.getStrokeCap() === "square" && (E = Math.max(E, L * Math.SQRT2)), p = We._getStrokePadding(L, S), b = We._getStrokePadding(E, S);
            }
            for (var A = new Array(6), T = 1 / 0, G = -T, D = T, Y = G, k = 0, z = i.length; k < z; k++) {
              var C = i[k];
              C._transformCoordinates(l, A);
              for (var O = 0; O < 6; O += 2) {
                var j = O ? p : b, q = j ? j[0] : 0, H = j ? j[1] : 0, ie = A[O], ae = A[O + 1], ue = ie - q, me = ie + q, se = ae - H, de = ae + H;
                ue < T && (T = ue), me > G && (G = me), se < D && (D = se), de > Y && (Y = de);
              }
            }
            return new P(T, D, G - T, Y - D);
          }
        }
      }
    );
    We.inject({ statics: new function() {
      var i = 0.5522847498307936, r = [
        new ce([-1, 0], [0, i], [0, -i]),
        new ce([0, -1], [-i, 0], [i, 0]),
        new ce([1, 0], [0, -i], [0, i]),
        new ce([0, 1], [i, 0], [-i, 0])
      ];
      function a(u, d, v) {
        var p = o.getNamed(v), b = new We(p && (p.insert == !0 ? X.INSERT : p.insert == !1 ? X.NO_INSERT : null));
        return b._add(u), b._closed = d, b.set(p, X.INSERT);
      }
      function l(u, d, v) {
        for (var p = new Array(4), b = 0; b < 4; b++) {
          var S = r[b];
          p[b] = new ce(
            S._point.multiply(d).add(u),
            S._handleIn.multiply(d),
            S._handleOut.multiply(d)
          );
        }
        return a(p, !0, v);
      }
      return {
        Line: function() {
          var u = arguments;
          return a([
            new ce(M.readNamed(u, "from")),
            new ce(M.readNamed(u, "to"))
          ], !1, u);
        },
        Circle: function() {
          var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "radius");
          return l(d, new V(v), u);
        },
        Rectangle: function() {
          var u = arguments, d = P.readNamed(u, "rectangle"), v = V.readNamed(
            u,
            "radius",
            0,
            { readNull: !0 }
          ), p = d.getBottomLeft(!0), b = d.getTopLeft(!0), S = d.getTopRight(!0), L = d.getBottomRight(!0), E;
          if (!v || v.isZero())
            E = [
              new ce(p),
              new ce(b),
              new ce(S),
              new ce(L)
            ];
          else {
            v = V.min(v, d.getSize(!0).divide(2));
            var A = v.width, T = v.height, G = A * i, D = T * i;
            E = [
              new ce(p.add(A, 0), null, [-G, 0]),
              new ce(p.subtract(0, T), [0, D]),
              new ce(b.add(0, T), null, [0, -D]),
              new ce(b.add(A, 0), [-G, 0], null),
              new ce(S.subtract(A, 0), null, [G, 0]),
              new ce(S.add(0, T), [0, -D], null),
              new ce(L.subtract(0, T), null, [0, D]),
              new ce(L.subtract(A, 0), [G, 0])
            ];
          }
          return a(E, !0, u);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var u = arguments, d = Ee._readEllipse(u);
          return l(d.center, d.radius, u);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var u = arguments, d = M.readNamed(u, "from"), v = M.readNamed(u, "through"), p = M.readNamed(u, "to"), b = o.getNamed(u), S = new We(b && b.insert == !1 && X.NO_INSERT);
          return S.moveTo(d), S.arcTo(v, p), S.set(b);
        },
        RegularPolygon: function() {
          for (var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "sides"), p = o.readNamed(u, "radius"), b = 360 / v, S = v % 3 === 0, L = new M(0, S ? -p : p), E = S ? -1 : 0.5, A = new Array(v), T = 0; T < v; T++)
            A[T] = new ce(d.add(
              L.rotate((T + E) * b)
            ));
          return a(A, !0, u);
        },
        Star: function() {
          for (var u = arguments, d = M.readNamed(u, "center"), v = o.readNamed(u, "points") * 2, p = o.readNamed(u, "radius1"), b = o.readNamed(u, "radius2"), S = 360 / v, L = new M(0, -1), E = new Array(v), A = 0; A < v; A++)
            E[A] = new ce(d.add(L.rotate(S * A).multiply(A % 2 ? b : p)));
          return a(E, !0, u);
        }
      };
    }() });
    var Et = qt.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(r) {
          this._children = [], this._namedChildren = {}, this._initialize(r) || (typeof r == "string" ? this.setPathData(r) : this.addChildren(Array.isArray(r) ? r : arguments));
        },
        insertChildren: function i(r, a) {
          var l = a, u = l[0];
          u && typeof u[0] == "number" && (l = [l]);
          for (var d = a.length - 1; d >= 0; d--) {
            var v = l[d];
            l === a && !(v instanceof We) && (l = o.slice(l)), Array.isArray(v) ? l[d] = new We({ segments: v, insert: !1 }) : v instanceof Et && (l.splice.apply(l, [d, 1].concat(v.removeChildren())), v.remove());
          }
          return i.base.call(this, r, l);
        },
        reduce: function i(r) {
          for (var a = this._children, l = a.length - 1; l >= 0; l--) {
            var u = a[l].reduce(r);
            u.isEmpty() && u.remove();
          }
          if (!a.length) {
            var u = new We(X.NO_INSERT);
            return u.copyAttributes(this), u.insertAbove(this), this.remove(), u;
          }
          return i.base.call(this);
        },
        isClosed: function() {
          for (var i = this._children, r = 0, a = i.length; r < a; r++)
            if (!i[r]._closed)
              return !1;
          return !0;
        },
        setClosed: function(i) {
          for (var r = this._children, a = 0, l = r.length; a < l; a++)
            r[a].setClosed(i);
        },
        getFirstSegment: function() {
          var i = this.getFirstChild();
          return i && i.getFirstSegment();
        },
        getLastSegment: function() {
          var i = this.getLastChild();
          return i && i.getLastSegment();
        },
        getCurves: function() {
          for (var i = this._children, r = [], a = 0, l = i.length; a < l; a++)
            o.push(r, i[a].getCurves());
          return r;
        },
        getFirstCurve: function() {
          var i = this.getFirstChild();
          return i && i.getFirstCurve();
        },
        getLastCurve: function() {
          var i = this.getLastChild();
          return i && i.getLastCurve();
        },
        getArea: function() {
          for (var i = this._children, r = 0, a = 0, l = i.length; a < l; a++)
            r += i[a].getArea();
          return r;
        },
        getLength: function() {
          for (var i = this._children, r = 0, a = 0, l = i.length; a < l; a++)
            r += i[a].getLength();
          return r;
        },
        getPathData: function(i, r) {
          for (var a = this._children, l = [], u = 0, d = a.length; u < d; u++) {
            var v = a[u], p = v._matrix;
            l.push(v.getPathData(i && !p.isIdentity() ? i.appended(p) : i, r));
          }
          return l.join("");
        },
        _hitTestChildren: function i(r, a, l) {
          return i.base.call(
            this,
            r,
            a.class === We || a.type === "path" ? a : o.set({}, a, { fill: !1 }),
            l
          );
        },
        _draw: function(i, r, a, l) {
          var u = this._children;
          if (u.length) {
            r = r.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
            for (var d = 0, v = u.length; d < v; d++)
              u[d].draw(i, r, l);
            if (!r.clip) {
              this._setStyles(i, r, a);
              var p = this._style;
              p.hasFill() && (i.fill(p.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), p.hasStroke() && i.stroke();
            }
          }
        },
        _drawSelected: function(i, r, a) {
          for (var l = this._children, u = 0, d = l.length; u < d; u++) {
            var v = l[u], p = v._matrix;
            a[v._id] || v._drawSelected(i, p.isIdentity() ? r : r.appended(p));
          }
        }
      },
      new function() {
        function i(r, a) {
          var l = r._children;
          if (a && !l.length)
            throw new Error("Use a moveTo() command first");
          return l[l.length - 1];
        }
        return o.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(r) {
            this[r] = function() {
              var a = i(this, !0);
              a[r].apply(a, arguments);
            };
          },
          {
            moveTo: function() {
              var r = i(this), a = r && r.isEmpty() ? r : new We(X.NO_INSERT);
              a !== r && this.addChild(a), a.moveTo.apply(a, arguments);
            },
            moveBy: function() {
              var r = i(this, !0), a = r && r.getLastSegment(), l = M.read(arguments);
              this.moveTo(a ? l.add(a._point) : l);
            },
            closePath: function(r) {
              i(this, !0).closePath(r);
            }
          }
        );
      }(),
      o.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
        this[i] = function(r) {
          for (var a = this._children, l, u = 0, d = a.length; u < d; u++)
            l = a[u][i](r) || l;
          return l;
        };
      }, {})
    );
    qt.inject(new function() {
      var i = Math.min, r = Math.max, a = Math.abs, l = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function u(k) {
        return k._children || [k];
      }
      function d(k, z) {
        var C = k.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (z) {
          for (var O = u(C), j = 0, q = O.length; j < q; j++) {
            var k = O[j];
            !k._closed && !k.isEmpty() && (k.closePath(1e-12), k.getFirstSegment().setHandleIn(0, 0), k.getLastSegment().setHandleOut(0, 0));
          }
          C = C.resolveCrossings().reorient(C.getFillRule() === "nonzero", !0);
        }
        return C;
      }
      function v(k, z, C, O, j) {
        var q = new Et(X.NO_INSERT);
        return q.addChildren(k, !0), q = q.reduce({ simplify: z }), j && j.insert == !1 || q.insertAbove(O && C.isSibling(O) && C.getIndex() < O.getIndex() ? O : C), q.copyAttributes(C, !0), q;
      }
      function p(k) {
        return k.hasOverlap() || k.isCrossing();
      }
      function b(k, z, C, O) {
        if (O && (O.trace == !1 || O.stroke) && /^(subtract|intersect)$/.test(C))
          return S(k, z, C);
        var j = d(k, !0), q = z && k !== z && d(z, !0), H = l[C];
        H[C] = !0, q && (H.subtract || H.exclude) ^ (q.isClockwise() ^ j.isClockwise()) && q.reverse();
        var ie = T(pt.expand(
          j.getIntersections(q, p)
        )), ae = u(j), ue = q && u(q), me = [], se = [], de;
        function ve(bt) {
          for (var Rt = 0, It = bt.length; Rt < It; Rt++) {
            var Ht = bt[Rt];
            o.push(me, Ht._segments), o.push(se, Ht.getCurves()), Ht._overlapsOnly = !0;
          }
        }
        function we(bt) {
          for (var Rt = [], It = 0, Ht = bt && bt.length; It < Ht; It++)
            Rt.push(se[bt[It]]);
          return Rt;
        }
        if (ie.length) {
          ve(ae), ue && ve(ue);
          for (var Se = new Array(se.length), Ae = 0, Ge = se.length; Ae < Ge; Ae++)
            Se[Ae] = se[Ae].getValues();
          for (var et = x.findCurveBoundsCollisions(
            Se,
            Se,
            0,
            !0
          ), st = {}, Ae = 0; Ae < se.length; Ae++) {
            var _t = se[Ae], Re = _t._path._id, Fe = st[Re] = st[Re] || {};
            Fe[_t.getIndex()] = {
              hor: we(et[Ae].hor),
              ver: we(et[Ae].ver)
            };
          }
          for (var Ae = 0, Ge = ie.length; Ae < Ge; Ae++)
            D(
              ie[Ae]._segment,
              j,
              q,
              st,
              H
            );
          for (var Ae = 0, Ge = me.length; Ae < Ge; Ae++) {
            var at = me[Ae], yt = at._intersection;
            at._winding || D(
              at,
              j,
              q,
              st,
              H
            ), yt && yt._overlap || (at._path._overlapsOnly = !1);
          }
          de = Y(me, H);
        } else
          de = A(
            ue ? ae.concat(ue) : ae.slice(),
            function(bt) {
              return !!H[bt];
            }
          );
        return v(de, !0, k, z, O);
      }
      function S(k, z, C) {
        var O = d(k), j = d(z), q = O.getIntersections(j, p), H = C === "subtract", ie = C === "divide", ae = {}, ue = [];
        function me(ve) {
          if (!ae[ve._id] && (ie || j.contains(ve.getPointAt(ve.getLength() / 2)) ^ H))
            return ue.unshift(ve), ae[ve._id] = !0;
        }
        for (var se = q.length - 1; se >= 0; se--) {
          var de = q[se].split();
          de && (me(de) && de.getFirstSegment().setHandleIn(0, 0), O.getLastSegment().setHandleOut(0, 0));
        }
        return me(O), v(ue, !1, k, z);
      }
      function L(k, z) {
        for (var C = k; C; ) {
          if (C === z)
            return;
          C = C._previous;
        }
        for (; k._next && k._next !== z; )
          k = k._next;
        if (!k._next) {
          for (; z._previous; )
            z = z._previous;
          k._next = z, z._previous = k;
        }
      }
      function E(k) {
        for (var z = k.length - 1; z >= 0; z--)
          k[z].clearHandles();
      }
      function A(k, z, C) {
        var O = k && k.length;
        if (O) {
          var j = o.each(k, function(et, st) {
            this[et._id] = {
              container: null,
              winding: et.isClockwise() ? 1 : -1,
              index: st
            };
          }, {}), q = k.slice().sort(function(et, st) {
            return a(st.getArea()) - a(et.getArea());
          }), H = q[0], ie = x.findItemBoundsCollisions(
            q,
            null,
            I.GEOMETRIC_EPSILON
          );
          C == null && (C = H.isClockwise());
          for (var ae = 0; ae < O; ae++) {
            var ue = q[ae], me = j[ue._id], se = 0, de = ie[ae];
            if (de) {
              for (var ve = null, we = de.length - 1; we >= 0; we--)
                if (de[we] < ae) {
                  ve = ve || ue.getInteriorPoint();
                  var Se = q[de[we]];
                  if (Se.contains(ve)) {
                    var Ae = j[Se._id];
                    se = Ae.winding, me.winding += se, me.container = Ae.exclude ? Ae.container : Se;
                    break;
                  }
                }
            }
            if (z(me.winding) === z(se))
              me.exclude = !0, k[me.index] = null;
            else {
              var Ge = me.container;
              ue.setClockwise(
                Ge ? !Ge.isClockwise() : C
              );
            }
          }
        }
        return k;
      }
      function T(k, z, C) {
        var O = z && [], j = 1e-8, q = 1 - j, H = !1, ie = C || [], ae = C && {}, ue, me, se;
        function de(Rt) {
          return Rt._path._id + "." + Rt._segment1._index;
        }
        for (var ve = (C && C.length) - 1; ve >= 0; ve--) {
          var we = C[ve];
          we._path && (ae[de(we)] = !0);
        }
        for (var ve = k.length - 1; ve >= 0; ve--) {
          var Se = k[ve], Ae = Se._time, Ge = Ae, et = z && !z(Se), we = Se._curve, st;
          if (we && (we !== me ? (H = !we.hasHandles() || ae && ae[de(we)], ue = [], se = null, me = we) : se >= j && (Ae /= se)), et) {
            ue && ue.push(Se);
            continue;
          } else
            z && O.unshift(Se);
          if (se = Ge, Ae < j)
            st = we._segment1;
          else if (Ae > q)
            st = we._segment2;
          else {
            var _t = we.divideAtTime(Ae, !0);
            H && ie.push(we, _t), st = _t._segment1;
            for (var Re = ue.length - 1; Re >= 0; Re--) {
              var Fe = ue[Re];
              Fe._time = (Fe._time - Ae) / (1 - Ae);
            }
          }
          Se._setSegment(st);
          var at = st._intersection, yt = Se._intersection;
          if (at) {
            L(at, yt);
            for (var bt = at; bt; )
              L(bt._intersection, at), bt = bt._next;
          } else
            st._intersection = yt;
        }
        return C || E(ie), O || k;
      }
      function G(k, z, C, O, j) {
        var q = Array.isArray(z) ? z : z[C ? "hor" : "ver"], H = C ? 1 : 0, ie = H ^ 1, ae = [k.x, k.y], ue = ae[H], me = ae[ie], se = 1e-9, de = 1e-6, ve = ue - se, we = ue + se, Se = 0, Ae = 0, Ge = 0, et = 0, st = !1, _t = !1, Re = 1, Fe = [], at, yt;
        function bt(si) {
          var Nt = si[ie + 0], Vi = si[ie + 6];
          if (!(me < i(Nt, Vi) || me > r(Nt, Vi))) {
            var ci = si[H + 0], nn = si[H + 2], Yi = si[H + 4], qi = si[H + 6];
            if (Nt === Vi) {
              (ci < we && qi > ve || qi < we && ci > ve) && (st = !0);
              return;
            }
            var Qi = me === Nt ? 0 : me === Vi || ve > r(ci, nn, Yi, qi) || we < i(ci, nn, Yi, qi) ? 1 : ze.solveCubic(si, ie, me, Fe, 0, 1) > 0 ? Fe[0] : 1, Gi = Qi === 0 ? ci : Qi === 1 ? qi : ze.getPoint(si, Qi)[C ? "y" : "x"], Xi = Nt > Vi ? 1 : -1, _n = at[ie] > at[ie + 6] ? 1 : -1, Ki = at[H + 6];
            return me !== Nt ? (Gi < ve ? Ge += Xi : Gi > we ? et += Xi : st = !0, Gi > ue - de && Gi < ue + de && (Re /= 2)) : (Xi !== _n ? ci < ve ? Ge += Xi : ci > we && (et += Xi) : ci != Ki && (Ki < we && Gi > we ? (et += Xi, st = !0) : Ki > ve && Gi < ve && (Ge += Xi, st = !0)), Re /= 4), at = si, !j && Gi > ve && Gi < we && ze.getTangent(si, Qi)[C ? "x" : "y"] === 0 && G(k, z, !C, O, !0);
          }
        }
        function Rt(si) {
          var Nt = si[ie + 0], Vi = si[ie + 2], ci = si[ie + 4], nn = si[ie + 6];
          if (me <= r(Nt, Vi, ci, nn) && me >= i(Nt, Vi, ci, nn)) {
            for (var Yi = si[H + 0], qi = si[H + 2], Qi = si[H + 4], Gi = si[H + 6], Xi = ve > r(Yi, qi, Qi, Gi) || we < i(Yi, qi, Qi, Gi) ? [si] : ze.getMonoCurves(si, C), _n, Ki = 0, cn = Xi.length; Ki < cn; Ki++)
              if (_n = bt(Xi[Ki]))
                return _n;
          }
        }
        for (var It = 0, Ht = q.length; It < Ht; It++) {
          var jt = q[It], Vt = jt._path, Ti = jt.getValues(), ki;
          if ((!It || q[It - 1]._path !== Vt) && (at = null, Vt._closed || (yt = ze.getValues(
            Vt.getLastCurve().getSegment2(),
            jt.getSegment1(),
            null,
            !O
          ), yt[ie] !== yt[ie + 6] && (at = yt)), !at)) {
            at = Ti;
            for (var Li = Vt.getLastCurve(); Li && Li !== jt; ) {
              var bi = Li.getValues();
              if (bi[ie] !== bi[ie + 6]) {
                at = bi;
                break;
              }
              Li = Li.getPrevious();
            }
          }
          if (ki = Rt(Ti))
            return ki;
          if (It + 1 === Ht || q[It + 1]._path !== Vt) {
            if (yt && (ki = Rt(yt)))
              return ki;
            st && !Ge && !et && (Ge = et = Vt.isClockwise(O) ^ C ? 1 : -1), Se += Ge, Ae += et, Ge = et = 0, st && (_t = !0, st = !1), yt = null;
          }
        }
        return Se = a(Se), Ae = a(Ae), {
          winding: r(Se, Ae),
          windingL: Se,
          windingR: Ae,
          quality: Re,
          onPath: _t
        };
      }
      function D(k, z, C, O, j) {
        var q = [], H = k, ie = 0, se;
        do {
          var ae = k.getCurve();
          if (ae) {
            var ue = ae.getLength();
            q.push({ segment: k, curve: ae, length: ue }), ie += ue;
          }
          k = k.getNext();
        } while (k && !k._intersection && k !== H);
        for (var me = [0.5, 0.25, 0.75], se = { winding: 0, quality: -1 }, de = 1e-3, ve = 1 - de, we = 0; we < me.length && se.quality < 0.5; we++)
          for (var ue = ie * me[we], Se = 0, Ae = q.length; Se < Ae; Se++) {
            var Ge = q[Se], et = Ge.length;
            if (ue <= et) {
              var ae = Ge.curve, st = ae._path, _t = st._parent, Re = _t instanceof Et ? _t : st, Fe = I.clamp(ae.getTimeAt(ue), de, ve), at = ae.getPointAtTime(Fe), yt = a(ae.getTangentAtTime(Fe).y) < Math.SQRT1_2, bt = null;
              if (j.subtract && C) {
                var Rt = Re === z ? C : z, It = Rt._getWinding(at, yt, !0);
                if (Re === z && It.winding || Re === C && !It.winding) {
                  if (It.quality < 1)
                    continue;
                  bt = { winding: 0, quality: 1 };
                }
              }
              bt = bt || G(
                at,
                O[st._id][ae.getIndex()],
                yt,
                !0
              ), bt.quality > se.quality && (se = bt);
              break;
            }
            ue -= et;
          }
        for (var Se = q.length - 1; Se >= 0; Se--)
          q[Se].segment._winding = se;
      }
      function Y(k, z) {
        var C = [], O;
        function j(Ht) {
          var jt;
          return !!(Ht && !Ht._visited && (!z || z[(jt = Ht._winding || {}).winding] && !(z.unite && jt.winding === 2 && jt.windingL && jt.windingR)));
        }
        function q(Ht) {
          if (Ht) {
            for (var jt = 0, Vt = O.length; jt < Vt; jt++)
              if (Ht === O[jt])
                return !0;
          }
          return !1;
        }
        function H(Ht) {
          for (var jt = Ht._segments, Vt = 0, Ti = jt.length; Vt < Ti; Vt++)
            jt[Vt]._visited = !0;
        }
        function ie(Ht, jt) {
          var Vt = Ht._intersection, Ti = Vt, ki = [];
          jt && (O = [Ht]);
          function Li(bi, si) {
            for (; bi && bi !== si; ) {
              var Nt = bi._segment, Vi = Nt && Nt._path;
              if (Vi) {
                var ci = Nt.getNext() || Vi.getFirstSegment(), nn = ci._intersection;
                Nt !== Ht && (q(Nt) || q(ci) || ci && j(Nt) && (j(ci) || nn && j(nn._segment))) && ki.push(Nt), jt && O.push(Nt);
              }
              bi = bi._next;
            }
          }
          if (Vt) {
            for (Li(Vt); Vt && Vt._previous; )
              Vt = Vt._previous;
            Li(Vt, Ti);
          }
          return ki;
        }
        k.sort(function(Ht, jt) {
          var Vt = Ht._intersection, Ti = jt._intersection, ki = !!(Vt && Vt._overlap), Li = !!(Ti && Ti._overlap), bi = Ht._path, si = jt._path;
          return ki ^ Li ? ki ? 1 : -1 : !Vt ^ !Ti ? Vt ? 1 : -1 : bi !== si ? bi._id - si._id : Ht._index - jt._index;
        });
        for (var ae = 0, ue = k.length; ae < ue; ae++) {
          var me = k[ae], se = j(me), de = null, ve = !1, we = !0, Se = [], Ae, Ge, et;
          if (se && me._path._overlapsOnly) {
            var st = me._path, _t = me._intersection._segment._path;
            st.compare(_t) && (st.getArea() && C.push(st.clone(!1)), H(st), H(_t), se = !1);
          }
          for (; se; ) {
            var Re = !de, Fe = ie(me, Re), at = Fe.shift(), ve = !Re && (q(me) || q(at)), yt = !ve && at;
            if (Re && (de = new We(X.NO_INSERT), Ae = null), ve) {
              (me.isFirst() || me.isLast()) && (we = me._path._closed), me._visited = !0;
              break;
            }
            if (yt && Ae && (Se.push(Ae), Ae = null), Ae || (yt && Fe.push(me), Ae = {
              start: de._segments.length,
              crossings: Fe,
              visited: Ge = [],
              handleIn: et
            }), yt && (me = at), !j(me)) {
              de.removeSegments(Ae.start);
              for (var bt = 0, Rt = Ge.length; bt < Rt; bt++)
                Ge[bt]._visited = !1;
              Ge.length = 0;
              do
                me = Ae && Ae.crossings.shift(), (!me || !me._path) && (me = null, Ae = Se.pop(), Ae && (Ge = Ae.visited, et = Ae.handleIn));
              while (Ae && !j(me));
              if (!me)
                break;
            }
            var It = me.getNext();
            de.add(new ce(
              me._point,
              et,
              It && me._handleOut
            )), me._visited = !0, Ge.push(me), me = It || me._path.getFirstSegment(), et = It && It._handleIn;
          }
          ve && (we && (de.getFirstSegment().setHandleIn(et), de.setClosed(we)), de.getArea() !== 0 && C.push(de));
        }
        return C;
      }
      return {
        _getWinding: function(k, z, C) {
          return G(k, this.getCurves(), z, C);
        },
        unite: function(k, z) {
          return b(this, k, "unite", z);
        },
        intersect: function(k, z) {
          return b(this, k, "intersect", z);
        },
        subtract: function(k, z) {
          return b(this, k, "subtract", z);
        },
        exclude: function(k, z) {
          return b(this, k, "exclude", z);
        },
        divide: function(k, z) {
          return z && (z.trace == !1 || z.stroke) ? S(this, k, "divide") : v([
            this.subtract(k, z),
            this.intersect(k, z)
          ], !0, this, k, z);
        },
        resolveCrossings: function() {
          var k = this._children, z = k || [this];
          function C(Ae, Ge) {
            var et = Ae && Ae._intersection;
            return et && et._overlap && et._path === Ge;
          }
          var O = !1, j = !1, q = this.getIntersections(null, function(Ae) {
            return Ae.hasOverlap() && (O = !0) || Ae.isCrossing() && (j = !0);
          }), H = O && j && [];
          if (q = pt.expand(q), O)
            for (var ie = T(q, function(Ae) {
              return Ae.hasOverlap();
            }, H), ae = ie.length - 1; ae >= 0; ae--) {
              var ue = ie[ae], me = ue._path, se = ue._segment, de = se.getPrevious(), ve = se.getNext();
              C(de, me) && C(ve, me) && (se.remove(), de._handleOut._set(0, 0), ve._handleIn._set(0, 0), de !== se && !de.getCurve().hasLength() && (ve._handleIn.set(de._handleIn), de.remove()));
            }
          j && (T(q, O && function(Ae) {
            var Ge = Ae.getCurve(), et = Ae.getSegment(), st = Ae._intersection, _t = st._curve, Re = st._segment;
            if (Ge && _t && Ge._path && _t._path)
              return !0;
            et && (et._intersection = null), Re && (Re._intersection = null);
          }, H), H && E(H), z = Y(o.each(z, function(Ae) {
            o.push(this, Ae._segments);
          }, [])));
          var we = z.length, Se;
          return we > 1 && k ? (z !== k && this.setChildren(z), Se = this) : we === 1 && !k && (z[0] !== this && this.setSegments(z[0].removeSegments()), Se = this), Se || (Se = new Et(X.NO_INSERT), Se.addChildren(z), Se = Se.reduce(), Se.copyAttributes(this), this.replaceWith(Se)), Se;
        },
        reorient: function(k, z) {
          var C = this._children;
          return C && C.length ? this.setChildren(A(
            this.removeChildren(),
            function(O) {
              return !!(k ? O : O & 1);
            },
            z
          )) : z !== t && this.setClockwise(z), this;
        },
        getInteriorPoint: function() {
          var k = this.getBounds(), z = k.getCenter(!0);
          if (!this.contains(z)) {
            for (var C = this.getCurves(), O = z.y, j = [], q = [], H = 0, ie = C.length; H < ie; H++) {
              var ae = C[H].getValues(), ue = ae[1], me = ae[3], se = ae[5], de = ae[7];
              if (O >= i(ue, me, se, de) && O <= r(ue, me, se, de))
                for (var ve = ze.getMonoCurves(ae), we = 0, Se = ve.length; we < Se; we++) {
                  var Ae = ve[we], Ge = Ae[1], et = Ae[7];
                  if (Ge !== et && (O >= Ge && O <= et || O >= et && O <= Ge)) {
                    var st = O === Ge ? Ae[0] : O === et ? Ae[6] : ze.solveCubic(Ae, 1, O, q, 0, 1) === 1 ? ze.getPoint(Ae, q[0]).x : (Ae[0] + Ae[6]) / 2;
                    j.push(st);
                  }
                }
            }
            j.length > 1 && (j.sort(function(_t, Re) {
              return _t - Re;
            }), z.x = (j[0] + j[1]) / 2);
          }
          return z;
        }
      };
    }());
    var rt = o.extend(
      {
        _class: "PathFlattener",
        initialize: function(i, r, a, l, u) {
          var d = [], v = [], p = 0, b = 1 / (a || 32), S = i._segments, L = S[0], E;
          function A(Y, k) {
            var z = ze.getValues(Y, k, u);
            d.push(z), T(z, Y._index, 0, 1);
          }
          function T(Y, k, z, C) {
            if (C - z > b && !(l && ze.isStraight(Y)) && !ze.isFlatEnough(Y, r || 0.25)) {
              var O = ze.subdivide(Y, 0.5), j = (z + C) / 2;
              T(O[0], k, z, j), T(O[1], k, j, C);
            } else {
              var q = Y[6] - Y[0], H = Y[7] - Y[1], ie = Math.sqrt(q * q + H * H);
              ie > 0 && (p += ie, v.push({
                offset: p,
                curve: Y,
                index: k,
                time: C
              }));
            }
          }
          for (var G = 1, D = S.length; G < D; G++)
            E = S[G], A(L, E), L = E;
          i._closed && A(E || L, S[0]), this.curves = d, this.parts = v, this.length = p, this.index = 0;
        },
        _get: function(i) {
          for (var r = this.parts, a = r.length, l, u = this.index; l = u, !(!u || r[--u].offset < i); )
            ;
          for (; l < a; l++) {
            var d = r[l];
            if (d.offset >= i) {
              this.index = l;
              var v = r[l - 1], p = v && v.index === d.index ? v.time : 0, b = v ? v.offset : 0;
              return {
                index: d.index,
                time: p + (d.time - p) * (i - b) / (d.offset - b)
              };
            }
          }
          return {
            index: r[a - 1].index,
            time: 1
          };
        },
        drawPart: function(i, r, a) {
          for (var l = this._get(r), u = this._get(a), d = l.index, v = u.index; d <= v; d++) {
            var p = ze.getPart(
              this.curves[d],
              d === l.index ? l.time : 0,
              d === u.index ? u.time : 1
            );
            d === l.index && i.moveTo(p[0], p[1]), i.bezierCurveTo.apply(i, p.slice(2));
          }
        }
      },
      o.each(
        ze._evaluateMethods,
        function(i) {
          this[i + "At"] = function(r) {
            var a = this._get(r);
            return ze[i](this.curves[a.index], a.time);
          };
        },
        {}
      )
    ), it = o.extend({
      initialize: function(i) {
        for (var r = this.points = [], a = i._segments, l = i._closed, u = 0, d, v = a.length; u < v; u++) {
          var p = a[u].point;
          (!d || !d.equals(p)) && r.push(d = p.clone());
        }
        l && (r.unshift(r[r.length - 1]), r.push(r[1])), this.closed = l;
      },
      fit: function(i) {
        var r = this.points, a = r.length, l = null;
        return a > 0 && (l = [new ce(r[0])], a > 1 && (this.fitCubic(
          l,
          i,
          0,
          a - 1,
          r[1].subtract(r[0]),
          r[a - 2].subtract(r[a - 1])
        ), this.closed && (l.shift(), l.pop()))), l;
      },
      fitCubic: function(i, r, a, l, u, d) {
        var v = this.points;
        if (l - a === 1) {
          var p = v[a], b = v[l], S = p.getDistance(b) / 3;
          this.addCurve(i, [
            p,
            p.add(u.normalize(S)),
            b.add(d.normalize(S)),
            b
          ]);
          return;
        }
        for (var L = this.chordLengthParameterize(a, l), E = Math.max(r, r * r), A, T = !0, G = 0; G <= 4; G++) {
          var D = this.generateBezier(a, l, L, u, d), Y = this.findMaxError(a, l, D, L);
          if (Y.error < r && T) {
            this.addCurve(i, D);
            return;
          }
          if (A = Y.index, Y.error >= E)
            break;
          T = this.reparameterize(a, l, L, D), E = Y.error;
        }
        var k = v[A - 1].subtract(v[A + 1]);
        this.fitCubic(i, r, a, A, u, k), this.fitCubic(i, r, A, l, k.negate(), d);
      },
      addCurve: function(i, r) {
        var a = i[i.length - 1];
        a.setHandleOut(r[1].subtract(r[0])), i.push(new ce(r[3], r[2].subtract(r[3])));
      },
      generateBezier: function(i, r, a, l, u) {
        for (var d = 1e-12, v = Math.abs, p = this.points, b = p[i], S = p[r], L = [[0, 0], [0, 0]], E = [0, 0], A = 0, T = r - i + 1; A < T; A++) {
          var G = a[A], D = 1 - G, Y = 3 * G * D, k = D * D * D, z = Y * D, C = Y * G, O = G * G * G, j = l.normalize(z), q = u.normalize(C), H = p[i + A].subtract(b.multiply(k + z)).subtract(S.multiply(C + O));
          L[0][0] += j.dot(j), L[0][1] += j.dot(q), L[1][0] = L[0][1], L[1][1] += q.dot(q), E[0] += j.dot(H), E[1] += q.dot(H);
        }
        var ie = L[0][0] * L[1][1] - L[1][0] * L[0][1], ae, ue;
        if (v(ie) > d) {
          var me = L[0][0] * E[1] - L[1][0] * E[0], se = E[0] * L[1][1] - E[1] * L[0][1];
          ae = se / ie, ue = me / ie;
        } else {
          var de = L[0][0] + L[0][1], ve = L[1][0] + L[1][1];
          ae = ue = v(de) > d ? E[0] / de : v(ve) > d ? E[1] / ve : 0;
        }
        var we = S.getDistance(b), Se = d * we, Ae, Ge;
        if (ae < Se || ue < Se)
          ae = ue = we / 3;
        else {
          var et = S.subtract(b);
          Ae = l.normalize(ae), Ge = u.normalize(ue), Ae.dot(et) - Ge.dot(et) > we * we && (ae = ue = we / 3, Ae = Ge = null);
        }
        return [
          b,
          b.add(Ae || l.normalize(ae)),
          S.add(Ge || u.normalize(ue)),
          S
        ];
      },
      reparameterize: function(i, r, a, l) {
        for (var u = i; u <= r; u++)
          a[u - i] = this.findRoot(l, this.points[u], a[u - i]);
        for (var u = 1, d = a.length; u < d; u++)
          if (a[u] <= a[u - 1])
            return !1;
        return !0;
      },
      findRoot: function(i, r, a) {
        for (var l = [], u = [], d = 0; d <= 2; d++)
          l[d] = i[d + 1].subtract(i[d]).multiply(3);
        for (var d = 0; d <= 1; d++)
          u[d] = l[d + 1].subtract(l[d]).multiply(2);
        var v = this.evaluate(3, i, a), p = this.evaluate(2, l, a), b = this.evaluate(1, u, a), S = v.subtract(r), L = p.dot(p) + S.dot(b);
        return I.isMachineZero(L) ? a : a - S.dot(p) / L;
      },
      evaluate: function(i, r, a) {
        for (var l = r.slice(), u = 1; u <= i; u++)
          for (var d = 0; d <= i - u; d++)
            l[d] = l[d].multiply(1 - a).add(l[d + 1].multiply(a));
        return l[0];
      },
      chordLengthParameterize: function(i, r) {
        for (var a = [0], l = i + 1; l <= r; l++)
          a[l - i] = a[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
        for (var l = 1, u = r - i; l <= u; l++)
          a[l] /= a[u];
        return a;
      },
      findMaxError: function(i, r, a, l) {
        for (var u = Math.floor((r - i + 1) / 2), d = 0, v = i + 1; v < r; v++) {
          var p = this.evaluate(3, a, l[v - i]), b = p.subtract(this.points[v]), S = b.x * b.x + b.y * b.y;
          S >= d && (d = S, u = v);
        }
        return {
          error: d,
          index: u
        };
      }
    }), Zt = X.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(r) {
        this._content = "", this._lines = [];
        var a = r && o.isPlainObject(r) && r.x === t && r.y === t;
        this._initialize(a && r, !a && M.read(arguments));
      },
      _equals: function(i) {
        return this._content === i._content;
      },
      copyContent: function(i) {
        this.setContent(i._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(i) {
        this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), $t = Zt.extend({
      _class: "PointText",
      initialize: function() {
        Zt.apply(this, arguments);
      },
      getPoint: function() {
        var i = this._matrix.getTranslation();
        return new Z(i.x, i.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.translate(i.subtract(this._matrix.getTranslation()));
      },
      _draw: function(i, r, a) {
        if (this._content) {
          this._setStyles(i, r, a);
          var l = this._lines, u = this._style, d = u.hasFill(), v = u.hasStroke(), p = u.getLeading(), b = i.shadowColor;
          i.font = u.getFontStyle(), i.textAlign = u.getJustification();
          for (var S = 0, L = l.length; S < L; S++) {
            i.shadowColor = b;
            var E = l[S];
            d && (i.fillText(E, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), v && i.strokeText(E, 0, 0), i.translate(0, p);
          }
        }
      },
      _getBounds: function(i, r) {
        var a = this._style, l = this._lines, u = l.length, d = a.getJustification(), v = a.getLeading(), p = this.getView().getTextWidth(a.getFontStyle(), l), b = 0;
        d !== "left" && (b -= p / (d === "center" ? 2 : 1));
        var S = new P(
          b,
          u ? -0.75 * v : 0,
          p,
          u * v
        );
        return i ? i._transformBounds(S, S) : S;
      }
    }), Lt = o.extend(
      new function() {
        var i = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, r = {}, a = {
          transparent: [0, 0, 0, 0]
        }, l;
        function u(p) {
          var b = p.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || p.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), S = "rgb", L;
          if (b) {
            var E = b[4] ? 4 : 3;
            L = new Array(E);
            for (var A = 0; A < E; A++) {
              var T = b[A + 1];
              L[A] = parseInt(T.length == 1 ? T + T : T, 16) / 255;
            }
          } else if (b = p.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            S = b[1], L = b[2].trim().split(/[,\s]+/g);
            for (var G = S === "hsl", A = 0, D = Math.min(L.length, 4); A < D; A++) {
              var Y = L[A], T = parseFloat(Y);
              if (G)
                if (A === 0) {
                  var k = Y.match(/([a-z]*)$/)[1];
                  T *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[k] || 1;
                } else
                  A < 3 && (T /= 100);
              else
                A < 3 && (T /= /%$/.test(Y) ? 100 : 255);
              L[A] = T;
            }
          } else {
            var z = a[p];
            if (!z)
              if (n) {
                l || (l = vt.getContext(1, 1, {
                  willReadFrequently: !0
                }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = p, l.fillRect(0, 0, 1, 1);
                var C = l.getImageData(0, 0, 1, 1).data;
                z = a[p] = [
                  C[0] / 255,
                  C[1] / 255,
                  C[2] / 255
                ];
              } else
                z = [0, 0, 0];
            L = z.slice();
          }
          return [S, L];
        }
        var d = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], v = {
          "rgb-hsb": function(p, b, S) {
            var L = Math.max(p, b, S), E = Math.min(p, b, S), A = L - E, T = A === 0 ? 0 : (L == p ? (b - S) / A + (b < S ? 6 : 0) : L == b ? (S - p) / A + 2 : (p - b) / A + 4) * 60;
            return [T, L === 0 ? 0 : A / L, L];
          },
          "hsb-rgb": function(p, b, S) {
            p = (p / 60 % 6 + 6) % 6;
            var E = Math.floor(p), L = p - E, E = d[E], A = [
              S,
              S * (1 - b),
              S * (1 - b * L),
              S * (1 - b * (1 - L))
            ];
            return [A[E[0]], A[E[1]], A[E[2]]];
          },
          "rgb-hsl": function(p, b, S) {
            var L = Math.max(p, b, S), E = Math.min(p, b, S), A = L - E, T = A === 0, G = T ? 0 : (L == p ? (b - S) / A + (b < S ? 6 : 0) : L == b ? (S - p) / A + 2 : (p - b) / A + 4) * 60, D = (L + E) / 2, Y = T ? 0 : D < 0.5 ? A / (L + E) : A / (2 - L - E);
            return [G, Y, D];
          },
          "hsl-rgb": function(p, b, S) {
            if (p = (p / 360 % 1 + 1) % 1, b === 0)
              return [S, S, S];
            for (var L = [p + 1 / 3, p, p - 1 / 3], E = S < 0.5 ? S * (1 + b) : S + b - S * b, A = 2 * S - E, T = [], G = 0; G < 3; G++) {
              var D = L[G];
              D < 0 && (D += 1), D > 1 && (D -= 1), T[G] = 6 * D < 1 ? A + (E - A) * 6 * D : 2 * D < 1 ? E : 3 * D < 2 ? A + (E - A) * (2 / 3 - D) * 6 : A;
            }
            return T;
          },
          "rgb-gray": function(p, b, S) {
            return [p * 0.2989 + b * 0.587 + S * 0.114];
          },
          "gray-rgb": function(p) {
            return [p, p, p];
          },
          "gray-hsb": function(p) {
            return [0, 0, p];
          },
          "gray-hsl": function(p) {
            return [0, 0, p];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return o.each(i, function(p, b) {
          r[b] = [], o.each(p, function(S, L) {
            var E = o.capitalize(S), A = /^(hue|saturation)$/.test(S), T = r[b][L] = b === "gradient" ? S === "gradient" ? function(G) {
              var D = this._components[0];
              return G = ii.read(
                Array.isArray(G) ? G : arguments,
                0,
                { readNull: !0 }
              ), D !== G && (D && D._removeOwner(this), G && G._addOwner(this)), G;
            } : function() {
              return M.read(arguments, 0, {
                readNull: S === "highlight",
                clone: !0
              });
            } : function(G) {
              return G == null || isNaN(G) ? 0 : +G;
            };
            this["get" + E] = function() {
              return this._type === b || A && /^hs[bl]$/.test(this._type) ? this._components[L] : this._convert(b)[L];
            }, this["set" + E] = function(G) {
              this._type !== b && !(A && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(b), this._properties = i[b], this._type = b), this._components[L] = T.call(this, G), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function p(b) {
            var S = arguments, L = this.__read, E = 0, A, T, G, D;
            Array.isArray(b) && (S = b, b = S[0]);
            var Y = b != null && typeof b;
            if (Y === "string" && b in i && (A = b, b = S[1], Array.isArray(b) ? (T = b, G = S[2]) : (L && (E = 1), S = o.slice(S, 1), Y = typeof b)), !T) {
              if (D = Y === "number" ? S : Y === "object" && b.length != null ? b : null, D) {
                A || (A = D.length >= 3 ? "rgb" : "gray");
                var k = i[A].length;
                G = D[k], L && (E += D === arguments ? k + (G != null ? 1 : 0) : 1), D.length > k && (D = o.slice(D, 0, k));
              } else if (Y === "string") {
                var z = u(b);
                A = z[0], T = z[1], T.length === 4 && (G = T[3], T.length--);
              } else if (Y === "object")
                if (b.constructor === p) {
                  if (A = b._type, T = b._components.slice(), G = b._alpha, A === "gradient")
                    for (var C = 1, O = T.length; C < O; C++) {
                      var j = T[C];
                      j && (T[C] = j.clone());
                    }
                } else if (b.constructor === ii)
                  A = "gradient", D = S;
                else {
                  A = "hue" in b ? "lightness" in b ? "hsl" : "hsb" : "gradient" in b || "stops" in b || "radial" in b ? "gradient" : "gray" in b ? "gray" : "rgb";
                  var q = i[A], H = r[A];
                  this._components = T = [];
                  for (var C = 0, O = q.length; C < O; C++) {
                    var ie = b[q[C]];
                    ie == null && !C && A === "gradient" && "stops" in b && (ie = {
                      stops: b.stops,
                      radial: b.radial
                    }), ie = H[C].call(this, ie), ie != null && (T[C] = ie);
                  }
                  G = b.alpha;
                }
              L && A && (E = 1);
            }
            if (this._type = A || "rgb", !T) {
              this._components = T = [];
              for (var H = r[this._type], C = 0, O = H.length; C < O; C++) {
                var ie = H[C].call(this, D && D[C]);
                ie != null && (T[C] = ie);
              }
            }
            return this._components = T, this._properties = i[this._type], this._alpha = G, L && (this.__read = E), this;
          },
          set: "#initialize",
          _serialize: function(p, b) {
            var S = this.getComponents();
            return o.serialize(
              /^(gray|rgb)$/.test(this._type) ? S : [this._type].concat(S),
              p,
              !0,
              b
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(p) {
            var b;
            return this._type === p ? this._components.slice() : (b = v[this._type + "-" + p]) ? b.apply(this, this._components) : v["rgb-" + p].apply(
              this,
              v[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(p) {
            return new Lt(p, this._convert(p), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(p) {
            this._components = this._convert(p), this._properties = i[p], this._type = p;
          },
          getComponents: function() {
            var p = this._components.slice();
            return this._alpha != null && p.push(this._alpha), p;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(p) {
            this._alpha = p == null ? null : Math.min(Math.max(p, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(p) {
            var b = o.isPlainValue(p, !0) ? Lt.read(arguments) : p;
            return b === this || b && this._class === b._class && this._type === b._type && this.getAlpha() === b.getAlpha() && o.equals(this._components, b._components) || !1;
          },
          toString: function() {
            for (var p = this._properties, b = [], S = this._type === "gradient", L = B.instance, E = 0, A = p.length; E < A; E++) {
              var T = this._components[E];
              T != null && b.push(p[E] + ": " + (S ? T : L.number(T)));
            }
            return this._alpha != null && b.push("alpha: " + L.number(this._alpha)), "{ " + b.join(", ") + " }";
          },
          toCSS: function(p) {
            var b = this._convert("rgb"), S = p || this._alpha == null ? 1 : this._alpha;
            function L(E) {
              return Math.round((E < 0 ? 0 : E > 1 ? 1 : E) * 255);
            }
            return b = [
              L(b[0]),
              L(b[1]),
              L(b[2])
            ], S < 1 && b.push(S < 0 ? 0 : S), p ? "#" + ((1 << 24) + (b[0] << 16) + (b[1] << 8) + b[2]).toString(16).slice(1) : (b.length == 4 ? "rgba(" : "rgb(") + b.join(",") + ")";
          },
          toCanvasStyle: function(p, b) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var S = this._components, L = S[0], E = L._stops, A = S[1], T = S[2], G = S[3], D = b && b.inverted(), Y;
            if (D && (A = D._transformPoint(A), T = D._transformPoint(T), G && (G = D._transformPoint(G))), L._radial) {
              var k = T.getDistance(A);
              if (G) {
                var z = G.subtract(A);
                z.getLength() > k && (G = A.add(z.normalize(k - 0.1)));
              }
              var C = G || A;
              Y = p.createRadialGradient(
                C.x,
                C.y,
                0,
                A.x,
                A.y,
                k
              );
            } else
              Y = p.createLinearGradient(
                A.x,
                A.y,
                T.x,
                T.y
              );
            for (var O = 0, j = E.length; O < j; O++) {
              var q = E[O], H = q._offset;
              Y.addColorStop(
                H ?? O / (j - 1),
                q._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = Y;
          },
          transform: function(p) {
            if (this._type === "gradient") {
              for (var b = this._components, S = 1, L = b.length; S < L; S++) {
                var E = b[S];
                p._transformPoint(E, E, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: i,
            random: function() {
              var p = Math.random;
              return new Lt(p(), p(), p());
            },
            _setOwner: function(p, b, S) {
              return p && (p._owner && b && p._owner !== b && (p = p.clone()), !p._owner ^ !b && (p._owner = b || null, p._setter = S || null)), p;
            }
          }
        });
      }(),
      new function() {
        var i = {
          add: function(r, a) {
            return r + a;
          },
          subtract: function(r, a) {
            return r - a;
          },
          multiply: function(r, a) {
            return r * a;
          },
          divide: function(r, a) {
            return r / a;
          }
        };
        return o.each(i, function(r, a) {
          this[a] = function(l) {
            l = Lt.read(arguments);
            for (var u = this._type, d = this._components, v = l._convert(u), p = 0, b = d.length; p < b; p++)
              v[p] = r(d[p], v[p]);
            return new Lt(
              u,
              v,
              this._alpha != null ? r(this._alpha, l.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), ii = o.extend({
      _class: "Gradient",
      initialize: function(r, a) {
        this._id = F.get(), r && o.isPlainObject(r) && (this.set(r), r = a = null), this._stops == null && this.setStops(r || ["white", "black"]), this._radial == null && this.setRadial(typeof a == "string" && a === "radial" || a || !1);
      },
      _serialize: function(i, r) {
        return r.add(this, function() {
          return o.serialize(
            [this._stops, this._radial],
            i,
            !0,
            r
          );
        });
      },
      _changed: function() {
        for (var i = 0, r = this._owners && this._owners.length; i < r; i++)
          this._owners[i]._changed();
      },
      _addOwner: function(i) {
        this._owners || (this._owners = []), this._owners.push(i);
      },
      _removeOwner: function(i) {
        var r = this._owners ? this._owners.indexOf(i) : -1;
        r != -1 && (this._owners.splice(r, 1), this._owners.length || (this._owners = t));
      },
      clone: function() {
        for (var i = [], r = 0, a = this._stops.length; r < a; r++)
          i[r] = this._stops[r].clone();
        return new ii(i, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(i) {
        if (i.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var r = this._stops;
        if (r)
          for (var a = 0, l = r.length; a < l; a++)
            r[a]._owner = t;
        r = this._stops = Ci.readList(i, 0, { clone: !0 });
        for (var a = 0, l = r.length; a < l; a++)
          r[a]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(i) {
        this._radial = i, this._changed();
      },
      equals: function(i) {
        if (i === this)
          return !0;
        if (i && this._class === i._class) {
          var r = this._stops, a = i._stops, l = r.length;
          if (l === a.length) {
            for (var u = 0; u < l; u++)
              if (!r[u].equals(a[u]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), Ci = o.extend({
      _class: "GradientStop",
      initialize: function(r, a) {
        var l = r, u = a;
        typeof r == "object" && a === t && (Array.isArray(r) && typeof r[0] != "number" ? (l = r[0], u = r[1]) : ("color" in r || "offset" in r || "rampPoint" in r) && (l = r.color, u = r.offset || r.rampPoint || 0)), this.setColor(l), this.setOffset(u);
      },
      clone: function() {
        return new Ci(this._color.clone(), this._offset);
      },
      _serialize: function(i, r) {
        var a = this._color, l = this._offset;
        return o.serialize(
          l == null ? [a] : [a, l],
          i,
          !0,
          r
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(i) {
        this._offset = i, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        Lt._setOwner(this._color, null), this._color = Lt._setOwner(
          Lt.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
      }
    }), ui = o.extend(new function() {
      var i = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new M(),
        selectedColor: null
      }, r = o.set({}, i, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), a = o.set({}, r, {
        fillColor: new Lt()
      }), l = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, u = {
        beans: !0
      }, d = {
        _class: "Style",
        beans: !0,
        initialize: function(p, b, S) {
          this._values = {}, this._owner = b, this._project = b && b._project || S || Ye.project, this._defaults = !b || b instanceof W ? r : b instanceof Zt ? a : i, p && this.set(p);
        }
      };
      return o.each(r, function(v, p) {
        var b = /Color$/.test(p), S = p === "shadowOffset", L = o.capitalize(p), E = l[p], A = "set" + L, T = "get" + L;
        d[A] = function(G) {
          var D = this._owner, Y = D && D._children, k = Y && Y.length > 0 && !(D instanceof Et);
          if (k)
            for (var z = 0, C = Y.length; z < C; z++)
              Y[z]._style[A](G);
          if ((p === "selectedColor" || !k) && p in this._defaults) {
            var O = this._values[p];
            O !== G && (b && (O && (Lt._setOwner(O, null), O._canvasStyle = null), G && G.constructor === Lt && (G = Lt._setOwner(
              G,
              D,
              k && A
            ))), this._values[p] = G, D && D._changed(E || 129));
          }
        }, d[T] = function(G) {
          var D = this._owner, Y = D && D._children, k = Y && Y.length > 0 && !(D instanceof Et), z;
          if (k && !G)
            for (var C = 0, O = Y.length; C < O; C++) {
              var j = Y[C]._style[T]();
              if (!C)
                z = j;
              else if (!o.equals(z, j))
                return t;
            }
          else if (p in this._defaults) {
            var z = this._values[p];
            if (z === t)
              z = this._defaults[p], z && z.clone && (z = z.clone());
            else {
              var q = b ? Lt : S ? M : null;
              q && !(z && z.constructor === q) && (this._values[p] = z = q.read(
                [z],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return z && b && (z = Lt._setOwner(z, D, k && A)), z;
        }, u[T] = function(G) {
          return this._style[T](G);
        }, u[A] = function(G) {
          this._style[A](G);
        };
      }), o.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(v, p) {
        var b = "get" + p, S = "set" + p;
        d[b] = u[b] = "#get" + v, d[S] = u[S] = "#set" + v;
      }), X.inject(u), d;
    }(), {
      set: function(i) {
        var r = i instanceof ui, a = r ? i._values : i;
        if (a) {
          for (var l in a)
            if (l in this._defaults) {
              var u = a[l];
              this[l] = u && r && u.clone ? u.clone() : u;
            }
        }
      },
      equals: function(i) {
        function r(a, l, u) {
          var d = a._values, v = l._values, p = l._defaults;
          for (var b in d) {
            var S = d[b], L = v[b];
            if (!(u && b in v) && !o.equals(
              S,
              L === t ? p[b] : L
            ))
              return !1;
          }
          return !0;
        }
        return i === this || i && this._class === i._class && r(this, i) && r(i, this, !0) || !1;
      },
      _dispose: function() {
        var i;
        i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
      },
      hasFill: function() {
        var i = this.getFillColor();
        return !!i && i.alpha > 0;
      },
      hasStroke: function() {
        var i = this.getStrokeColor();
        return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var i = this.getShadowColor();
        return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var i = this.getFontSize();
        return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function i() {
        var r = i.base.call(this), a = this.getFontSize();
        return /pt|em|%|px/.test(a) && (a = this.getView().getPixelSize(a)), r ?? a * 1.2;
      }
    }), Gt = new function() {
      function i(r, a, l, u) {
        for (var d = ["", "webkit", "moz", "Moz", "ms", "o"], v = a[0].toUpperCase() + a.substring(1), p = 0; p < 6; p++) {
          var b = d[p], S = b ? b + v : a;
          if (S in r) {
            if (l)
              r[S] = u;
            else
              return r[S];
            break;
          }
        }
      }
      return {
        getStyles: function(r) {
          var a = r && r.nodeType !== 9 ? r.ownerDocument : r, l = a && a.defaultView;
          return l && l.getComputedStyle(r, "");
        },
        getBounds: function(r, a) {
          var l = r.ownerDocument, u = l.body, d = l.documentElement, v;
          try {
            v = r.getBoundingClientRect();
          } catch {
            v = { left: 0, top: 0, width: 0, height: 0 };
          }
          var p = v.left - (d.clientLeft || u.clientLeft || 0), b = v.top - (d.clientTop || u.clientTop || 0);
          if (!a) {
            var S = l.defaultView;
            p += S.pageXOffset || d.scrollLeft || u.scrollLeft, b += S.pageYOffset || d.scrollTop || u.scrollTop;
          }
          return new P(p, b, v.width, v.height);
        },
        getViewportBounds: function(r) {
          var a = r.ownerDocument, l = a.defaultView, u = a.documentElement;
          return new P(
            0,
            0,
            l.innerWidth || u.clientWidth,
            l.innerHeight || u.clientHeight
          );
        },
        getOffset: function(r, a) {
          return Gt.getBounds(r, a).getPoint();
        },
        getSize: function(r) {
          return Gt.getBounds(r, !0).getSize();
        },
        isInvisible: function(r) {
          return Gt.getSize(r).equals(new V(0, 0));
        },
        isInView: function(r) {
          return !Gt.isInvisible(r) && Gt.getViewportBounds(r).intersects(
            Gt.getBounds(r, !0)
          );
        },
        isInserted: function(r) {
          return s.body.contains(r);
        },
        getPrefixed: function(r, a) {
          return r && i(r, a);
        },
        setPrefixed: function(r, a, l) {
          if (typeof a == "object")
            for (var u in a)
              i(r, u, !0, a[u]);
          else
            i(r, a, !0, l);
        }
      };
    }(), Xt = {
      add: function(i, r) {
        if (i)
          for (var a in r)
            for (var l = r[a], u = a.split(/[\s,]+/g), d = 0, v = u.length; d < v; d++) {
              var p = u[d], b = i === s && (p === "touchstart" || p === "touchmove") ? { passive: !1 } : !1;
              i.addEventListener(p, l, b);
            }
      },
      remove: function(i, r) {
        if (i)
          for (var a in r)
            for (var l = r[a], u = a.split(/[\s,]+/g), d = 0, v = u.length; d < v; d++)
              i.removeEventListener(u[d], l, !1);
      },
      getPoint: function(i) {
        var r = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
        return new M(
          r.pageX || r.clientX + s.documentElement.scrollLeft,
          r.pageY || r.clientY + s.documentElement.scrollTop
        );
      },
      getTarget: function(i) {
        return i.target || i.srcElement;
      },
      getRelatedTarget: function(i) {
        return i.relatedTarget || i.toElement;
      },
      getOffset: function(i, r) {
        return Xt.getPoint(i).subtract(Gt.getOffset(
          r || Xt.getTarget(i)
        ));
      }
    };
    Xt.requestAnimationFrame = new function() {
      var i = Gt.getPrefixed(n, "requestAnimationFrame"), r = !1, a = [], l;
      function u() {
        var d = a;
        a = [];
        for (var v = 0, p = d.length; v < p; v++)
          d[v]();
        r = i && a.length, r && i(u);
      }
      return function(d) {
        a.push(d), i ? r || (i(u), r = !0) : l || (l = setInterval(u, 1e3 / 60));
      };
    }();
    var Qt = o.extend(
      h,
      {
        _class: "View",
        initialize: function i(r, a) {
          function l(E) {
            return a[E] || parseInt(a.getAttribute(E), 10);
          }
          function u() {
            var E = Gt.getSize(a);
            return E.isNaN() || E.isZero() ? new V(l("width"), l("height")) : E;
          }
          var d;
          if (n && a) {
            this._id = a.getAttribute("id"), this._id == null && a.setAttribute("id", this._id = "paper-view-" + i._id++), Xt.add(a, this._viewEvents);
            var v = "none";
            if (Gt.setPrefixed(a.style, {
              userDrag: v,
              userSelect: v,
              touchCallout: v,
              contentZooming: v,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), c.hasAttribute(a, "resize")) {
              var p = this;
              Xt.add(n, this._windowEvents = {
                resize: function() {
                  p.setViewSize(u());
                }
              });
            }
            if (d = u(), c.hasAttribute(a, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var b = this._stats.domElement, S = b.style, L = Gt.getOffset(a);
              S.position = "absolute", S.left = L.x + "px", S.top = L.y + "px", s.body.appendChild(b);
            }
          } else
            d = new V(a), a = null;
          this._project = r, this._scope = r._scope, this._element = a, this._pixelRatio || (this._pixelRatio = n && n.devicePixelRatio || 1), this._setElementSize(d.width, d.height), this._viewSize = d, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new J())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !Ye.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          Qt._focused === this && (Qt._focused = null), Qt._views.splice(Qt._views.indexOf(this), 1), delete Qt._viewsById[this._id];
          var i = this._project;
          return i._view === this && (i._view = null), Xt.remove(this._element, this._viewEvents), Xt.remove(n, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: o.each(
          X._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(i) {
            this[i] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(i) {
          this._autoUpdate = i, i && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var i = this;
            Xt.requestAnimationFrame(function() {
              if (i._requested = !1, i._animate) {
                i.requestUpdate();
                var r = i._element;
                (!Gt.getPrefixed(s, "hidden") || c.getAttribute(r, "keepalive") === "true") && Gt.isInView(r) && i._handleFrame();
              }
              i._autoUpdate && i.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          Ye = this._scope;
          var i = Date.now() / 1e3, r = this._last ? i - this._last : 0;
          this._last = i, this.emit("frame", new o({
            delta: r,
            time: this._time += r,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(i, r) {
          var a = this._frameItems;
          r ? (a[i._id] = {
            item: i,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete a[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(i) {
          for (var r in this._frameItems) {
            var a = this._frameItems[r];
            a.item.emit("frame", new o(i, {
              time: a.time += i.delta,
              count: a.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = t;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var i = this._viewSize;
          return new te(i.width, i.height, this, "setViewSize");
        },
        setViewSize: function() {
          var i = V.read(arguments), r = i.subtract(this._viewSize);
          r.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: r }), this._autoUpdate && this.update());
        },
        _setElementSize: function(i, r) {
          var a = this._element;
          a && (a.width !== i && (a.width = i), a.height !== r && (a.height = r));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new P(new M(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return Gt.isInView(this._element);
        },
        isInserted: function() {
          return Gt.isInserted(this._element);
        },
        getPixelSize: function(i) {
          var r = this._element, a;
          if (r) {
            var l = r.parentNode, u = s.createElement("div");
            u.style.fontSize = i, l.appendChild(u), a = parseFloat(Gt.getStyles(u).fontSize), l.removeChild(u);
          } else
            a = parseFloat(a);
          return a;
        },
        getTextWidth: function(i, r) {
          return 0;
        }
      },
      o.each(["rotate", "scale", "shear", "skew"], function(i) {
        var r = i === "rotate";
        this[i] = function() {
          var a = arguments, l = (r ? o : M).read(a), u = M.read(a, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            u || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var i = M.read(arguments);
          this.translate(this.getCenter().subtract(i));
        },
        getZoom: function() {
          var i = this._decompose().scaling;
          return (i.x + i.y) / 2;
        },
        setZoom: function(i) {
          this.transform(new J().scale(
            i / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(i) {
          var r = this.getRotation();
          r != null && i != null && this.rotate(i - r);
        },
        getScaling: function() {
          var i = this._decompose().scaling;
          return new Z(i.x, i.y, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
          i && r && this.scale(r.x / i.x, r.y / i.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        transform: function(i) {
          this._matrix.append(i);
        },
        scrollBy: function() {
          this.translate(M.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        getEventPoint: function(i) {
          return this.viewToProject(Xt.getOffset(i, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(i, r) {
            s && typeof r == "string" && (r = s.getElementById(r));
            var a = n ? Ni : Qt;
            return new a(i, r);
          }
        }
      },
      new function() {
        if (!n)
          return;
        var i, r, a = !1, l = !1;
        function u(se) {
          var de = Xt.getTarget(se);
          return de.getAttribute && Qt._viewsById[de.getAttribute("id")];
        }
        function d() {
          var se = Qt._focused;
          if (!se || !se.isVisible()) {
            for (var de = 0, ve = Qt._views.length; de < ve; de++)
              if ((se = Qt._views[de]).isVisible()) {
                Qt._focused = r = se;
                break;
              }
          }
        }
        function v(se, de, ve) {
          se._handleMouseEvent("mousemove", de, ve);
        }
        var p = n.navigator, b, S, L;
        p.pointerEnabled || p.msPointerEnabled ? (b = "pointerdown MSPointerDown", S = "pointermove MSPointerMove", L = "pointerup pointercancel MSPointerUp MSPointerCancel") : (b = "touchstart", S = "touchmove", L = "touchend touchcancel", "ontouchstart" in n && p.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (b += " mousedown", S += " mousemove", L += " mouseup"));
        var E = {}, A = {
          mouseout: function(se) {
            var de = Qt._focused, ve = Xt.getRelatedTarget(se);
            if (de && (!ve || ve.nodeName === "HTML")) {
              var we = Xt.getOffset(se, de._element), Se = we.x, Ae = Math.abs, Ge = Ae(Se), et = 1 << 25, st = Ge - et;
              we.x = Ae(st) < Ge ? st * (Se < 0 ? -1 : 1) : Se, v(de, se, de.viewToProject(we));
            }
          },
          scroll: d
        };
        E[b] = function(se) {
          var de = Qt._focused = u(se);
          a || (a = !0, de._handleMouseEvent("mousedown", se));
        }, A[S] = function(se) {
          var de = Qt._focused;
          if (!l) {
            var ve = u(se);
            ve ? de !== ve && (de && v(de, se), i || (i = de), de = Qt._focused = r = ve) : r && r === de && (i && !i.isInserted() && (i = null), de = Qt._focused = i, i = null, d());
          }
          de && v(de, se);
        }, A[b] = function() {
          l = !0;
        }, A[L] = function(se) {
          var de = Qt._focused;
          de && a && de._handleMouseEvent("mouseup", se), l = a = !1;
        }, Xt.add(s, A), Xt.add(n, {
          load: d
        });
        var T = !1, G = !1, D = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, Y = !1, k, z, C, O, j, q, H, ie;
        function ae(se, de, ve, we, Se, Ae, Ge) {
          var et = !1, st;
          function _t(Re, Fe) {
            if (Re.responds(Fe)) {
              if (st || (st = new tt(
                Fe,
                we,
                Se,
                de || Re,
                Ae ? Se.subtract(Ae) : null
              )), Re.emit(Fe, st) && (T = !0, st.prevented && (G = !0), st.stopped))
                return et = !0;
            } else {
              var at = D[Fe];
              if (at)
                return _t(Re, at);
            }
          }
          for (; se && se !== Ge && !_t(se, ve); )
            se = se._parent;
          return et;
        }
        function ue(se, de, ve, we, Se, Ae) {
          return se._project.removeOn(ve), G = T = !1, j && ae(
            j,
            null,
            ve,
            we,
            Se,
            Ae
          ) || de && de !== j && !de.isDescendant(j) && ae(de, null, ve === "mousedrag" ? "mousemove" : ve, we, Se, Ae, j) || ae(
            se,
            j || de || se,
            ve,
            we,
            Se,
            Ae
          );
        }
        var me = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: E,
          _handleMouseEvent: function(se, de, ve) {
            var we = this._itemEvents, Se = we.native[se], Ae = se === "mousemove", Ge = this._scope.tool, et = this;
            function st(Rt) {
              return we.virtual[Rt] || et.responds(Rt) || Ge && Ge.responds(Rt);
            }
            Ae && a && st("mousedrag") && (se = "mousedrag"), ve || (ve = this.getEventPoint(de));
            var _t = this.getBounds().contains(ve), Re = Se && _t && et._project.hitTest(ve, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), Fe = Re && Re.item || null, at = !1, yt = {};
            if (yt[se.substr(5)] = !0, Se && Fe !== O && (O && ae(O, null, "mouseleave", de, ve), Fe && ae(Fe, null, "mouseenter", de, ve), O = Fe), Y ^ _t && (ae(
              this,
              null,
              _t ? "mouseenter" : "mouseleave",
              de,
              ve
            ), at = !0), (_t || yt.drag) && !ve.equals(z) && (ue(
              this,
              Fe,
              Ae ? se : "mousemove",
              de,
              ve,
              z
            ), at = !0), Y = _t, yt.down && _t || yt.up && k) {
              if (ue(this, Fe, se, de, ve, k), yt.down) {
                if (ie = Fe === q && Date.now() - H < 300, C = q = Fe, !G && Fe) {
                  for (var bt = Fe; bt && !bt.responds("mousedrag"); )
                    bt = bt._parent;
                  bt && (j = Fe);
                }
                k = ve;
              } else
                yt.up && (!G && Fe === C && (H = Date.now(), ue(this, Fe, ie ? "doubleclick" : "click", de, ve, k), ie = !1), C = j = null);
              Y = !1, at = !0;
            }
            z = ve, at && Ge && (T = Ge._handleMouseEvent(se, de, ve, yt) || T), de.cancelable !== !1 && (T && !yt.move || yt.down && st("mouseup")) && de.preventDefault();
          },
          _handleKeyEvent: function(se, de, ve, we) {
            var Se = this._scope, Ae = Se.tool, Ge;
            function et(st) {
              st.responds(se) && (Ye = Se, st.emit(se, Ge = Ge || new pe(se, de, ve, we)));
            }
            this.isVisible() && (et(this), Ae && Ae.responds(se) && et(Ae));
          },
          _countItemEvent: function(se, de) {
            var ve = this._itemEvents, we = ve.native, Se = ve.virtual;
            for (var Ae in me)
              we[Ae] = (we[Ae] || 0) + (me[Ae][se] || 0) * de;
            Se[se] = (Se[se] || 0) + de;
          },
          statics: {
            updateFocus: d,
            _resetState: function() {
              a = l = T = Y = !1, i = r = k = z = C = O = j = q = H = ie = null;
            }
          }
        };
      }()
    ), Ni = Qt.extend({
      _class: "CanvasView",
      initialize: function(r, a) {
        if (!(a instanceof n.HTMLCanvasElement)) {
          var l = V.read(arguments, 1);
          if (l.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + o.slice(arguments, 1)
            );
          a = vt.getCanvas(l);
        }
        var u = this._context = a.getContext("2d");
        if (u.save(), this._pixelRatio = 1, !/^off|false$/.test(c.getAttribute(a, "hidpi"))) {
          var d = n.devicePixelRatio || 1, v = Gt.getPrefixed(
            u,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = d / v;
        }
        Qt.call(this, r, a), this._needsUpdate = !0;
      },
      remove: function i() {
        return this._context.restore(), i.base.call(this);
      },
      _setElementSize: function i(r, a) {
        var l = this._pixelRatio;
        if (i.base.call(this, r * l, a * l), l !== 1) {
          var u = this._element, d = this._context;
          if (!c.hasAttribute(u, "resize")) {
            var v = u.style;
            v.width = r + "px", v.height = a + "px";
          }
          d.restore(), d.save(), d.scale(l, l);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function i(r) {
        var a = Ye.agent, l;
        if (a && a.firefox)
          l = i.base.call(this, r);
        else {
          var u = this._context, d = u.font;
          u.font = r + " serif", l = parseFloat(u.font), u.font = d;
        }
        return l;
      },
      getTextWidth: function(i, r) {
        var a = this._context, l = a.font, u = 0;
        a.font = i;
        for (var d = 0, v = r.length; d < v; d++)
          u = Math.max(u, a.measureText(r[d]).width);
        return a.font = l, u;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var i = this._project, r = this._context, a = this._viewSize;
        return r.clearRect(0, 0, a.width + 1, a.height + 1), i && i.draw(r, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), Di = o.extend({
      _class: "Event",
      initialize: function(r) {
        this.event = r, this.type = r && r.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return xt.modifiers;
      }
    }), pe = Di.extend({
      _class: "KeyEvent",
      initialize: function(r, a, l, u) {
        this.type = r, this.event = a, this.key = l, this.character = u;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), xt = new function() {
      var i = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, r = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, a = {}, l = {}, u, d, v = new o({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var S = Ye && Ye.agent;
            return S && S.mac ? this.meta : this.control;
          }
        }
      });
      function p(S) {
        var L = S.key || S.keyIdentifier;
        return L = /^U\+/.test(L) ? String.fromCharCode(parseInt(L.substr(2), 16)) : /^Arrow[A-Z]/.test(L) ? L.substr(5) : L === "Unidentified" || L === t ? String.fromCharCode(S.keyCode) : L, i[L] || (L.length > 1 ? o.hyphenate(L) : L.toLowerCase());
      }
      function b(S, L, E, A) {
        var T = Qt._focused, G;
        if (a[L] = S, S ? l[L] = E : delete l[L], L.length > 1 && (G = o.camelize(L)) in v) {
          v[G] = S;
          var D = Ye && Ye.agent;
          if (G === "meta" && D && D.mac)
            if (S)
              u = {};
            else {
              for (var Y in u)
                Y in l && b(!1, Y, u[Y], A);
              u = null;
            }
        } else
          S && u && (u[L] = E);
        T && T._handleKeyEvent(
          S ? "keydown" : "keyup",
          A,
          L,
          E
        );
      }
      return Xt.add(s, {
        keydown: function(S) {
          var L = p(S), E = Ye && Ye.agent;
          L.length > 1 || E && E.chrome && (S.altKey || E.mac && S.metaKey || !E.mac && S.ctrlKey) ? b(
            !0,
            L,
            r[L] || (L.length > 1 ? "" : L),
            S
          ) : d = L;
        },
        keypress: function(S) {
          if (d) {
            var L = p(S), E = S.charCode, A = E >= 32 ? String.fromCharCode(E) : L.length > 1 ? "" : L;
            L !== d && (L = A.toLowerCase()), b(!0, L, A, S), d = null;
          }
        },
        keyup: function(S) {
          var L = p(S);
          L in l && b(!1, L, l[L], S);
        }
      }), Xt.add(n, {
        blur: function(S) {
          for (var L in l)
            b(!1, L, l[L], S);
        }
      }), {
        modifiers: v,
        isDown: function(S) {
          return !!a[S];
        }
      };
    }(), tt = Di.extend({
      _class: "MouseEvent",
      initialize: function(r, a, l, u, d) {
        this.type = r, this.event = a, this.point = l, this.target = u, this.delta = d;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Pe = Di.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(r, a, l) {
        this.tool = r, this.type = a, this.event = l;
      },
      _choosePoint: function(i, r) {
        return i || (r ? r.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(i) {
        this._point = i;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(i) {
        this._lastPoint = i;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(i) {
        this._downPoint = i;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(i) {
        this._middlePoint = i;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(i) {
        this._delta = i;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(i) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
      },
      getItem: function() {
        if (!this._item) {
          var i = this.tool._scope.project.hitTest(this.getPoint());
          if (i) {
            for (var r = i.item, a = r._parent; /^(Group|CompoundPath)$/.test(a._class); )
              r = a, a = a._parent;
            this._item = r;
          }
        }
        return this._item;
      },
      setItem: function(i) {
        this._item = i;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), ke = m.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(r) {
        m.call(this), this._moveCount = -1, this._downCount = -1, this.set(r);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(i) {
        this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(i) {
        this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(i) {
        this._minDistance = this._maxDistance = i;
      },
      _handleMouseEvent: function(i, r, a, l) {
        Ye = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
        var u = l.move || l.drag, d = this.responds(i), v = !1, p = this;
        function b(L, E) {
          var A = a, T = u ? p._point : p._downPoint || A;
          if (u) {
            if (p._moveCount >= 0 && A.equals(T))
              return !1;
            if (T && (L != null || E != null)) {
              var G = A.subtract(T), D = G.getLength();
              if (D < (L || 0))
                return !1;
              E && (A = T.add(G.normalize(
                Math.min(D, E)
              )));
            }
            p._moveCount++;
          }
          return p._point = A, p._lastPoint = T || A, l.down && (p._moveCount = -1, p._downPoint = A, p._downCount++), !0;
        }
        function S() {
          d && (v = p.emit(i, new Pe(p, i, r)) || v);
        }
        if (l.down)
          b(), S();
        else if (l.up)
          b(null, this._maxDistance), S();
        else if (d)
          for (; b(this._minDistance, this._maxDistance); )
            S();
        return v;
      }
    }), Je = o.extend(h, {
      _class: "Tween",
      statics: {
        easings: new o({
          linear: function(i) {
            return i;
          },
          easeInQuad: function(i) {
            return i * i;
          },
          easeOutQuad: function(i) {
            return i * (2 - i);
          },
          easeInOutQuad: function(i) {
            return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
          },
          easeInCubic: function(i) {
            return i * i * i;
          },
          easeOutCubic: function(i) {
            return --i * i * i + 1;
          },
          easeInOutCubic: function(i) {
            return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
          },
          easeInQuart: function(i) {
            return i * i * i * i;
          },
          easeOutQuart: function(i) {
            return 1 - --i * i * i * i;
          },
          easeInOutQuart: function(i) {
            return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
          },
          easeInQuint: function(i) {
            return i * i * i * i * i;
          },
          easeOutQuint: function(i) {
            return 1 + --i * i * i * i * i;
          },
          easeInOutQuint: function(i) {
            return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
          }
        })
      },
      initialize: function i(r, a, l, u, d, v) {
        this.object = r;
        var p = typeof d, b = p === "function";
        this.type = b ? p : p === "string" ? d : "linear", this.easing = b ? d : i.easings[this.type], this.duration = u, this.running = !1, this._then = null, this._startTime = null;
        var S = a || l;
        this._keys = S ? Object.keys(S) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = S && this._getState(a), this._to = S && this._getState(l), v !== !1 && this.start();
      },
      then: function(i) {
        return this._then = i, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(i) {
        if (this.running) {
          i >= 1 && (i = 1, this.running = !1);
          for (var r = this.easing(i), a = this._keys, l = function(L) {
            return typeof L == "function" ? L(r, i) : L;
          }, u = 0, d = a && a.length; u < d; u++) {
            var v = a[u], p = l(this._from[v]), b = l(this._to[v]), S = p && b && p.__add && b.__add ? b.__subtract(p).__multiply(r).__add(p) : (b - p) * r + p;
            this._setProperty(this._parsedKeys[v], S);
          }
          this.responds("update") && this.emit("update", new o({
            progress: i,
            factor: r
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(i) {
        var r = this._startTime, a = r ? (i - r) / this.duration : 0;
        r || (this._startTime = i), this.update(a);
      },
      _getState: function(i) {
        for (var r = this._keys, a = {}, l = 0, u = r.length; l < u; l++) {
          var d = r[l], v = this._parsedKeys[d], p = this._getProperty(v), b;
          if (i) {
            var S = this._resolveValue(p, i[d]);
            this._setProperty(v, S), b = this._getProperty(v), b = b && b.clone ? b.clone() : b, this._setProperty(v, p);
          } else
            b = p && p.clone ? p.clone() : p;
          a[d] = b;
        }
        return a;
      },
      _resolveValue: function(i, r) {
        if (r) {
          if (Array.isArray(r) && r.length === 2) {
            var a = r[0];
            return a && a.match && a.match(/^[+\-\*\/]=/) ? this._calculate(i, a[0], r[1]) : r;
          } else if (typeof r == "string") {
            var l = r.match(/^[+\-*/]=(.*)/);
            if (l) {
              var u = JSON.parse(l[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(i, r[0], u);
            }
          }
        }
        return r;
      },
      _calculate: function(i, r, a) {
        return Ye.PaperScript.calculateBinary(i, r, a);
      },
      _parseKeys: function(i) {
        for (var r = {}, a = 0, l = i.length; a < l; a++) {
          var u = i[a], d = u.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          r[u] = d.split("/");
        }
        return r;
      },
      _getProperty: function(i, r) {
        for (var a = this.object, l = 0, u = i.length - (r || 0); l < u && a; l++)
          a = a[i[l]];
        return a;
      },
      _setProperty: function(i, r) {
        var a = this._getProperty(i, 1);
        a && (a[i[i.length - 1]] = r);
      }
    }), kt = {
      request: function(i) {
        var r = new e.XMLHttpRequest();
        return r.open(
          (i.method || "get").toUpperCase(),
          i.url,
          o.pick(i.async, !0)
        ), i.mimeType && r.overrideMimeType(i.mimeType), r.onload = function() {
          var a = r.status;
          a === 0 || a === 200 ? i.onLoad && i.onLoad.call(r, r.responseText) : r.onerror();
        }, r.onerror = function() {
          var a = r.status, l = 'Could not load "' + i.url + '" (Status: ' + a + ")";
          if (i.onError)
            i.onError(l, a);
          else
            throw new Error(l);
        }, r.send(null);
      }
    }, vt = o.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(i, r, a) {
        if (!n)
          return null;
        var l, u = !0;
        typeof i == "object" && (r = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = s.createElement("canvas"), u = !1);
        var d = l.getContext("2d", a || {});
        if (!d)
          throw new Error("Canvas " + l + " is unable to provide a 2D context.");
        return l.width === i && l.height === r ? u && d.clearRect(0, 0, i + 1, r + 1) : (l.width = i, l.height = r), d.save(), l;
      },
      getContext: function(i, r, a) {
        var l = this.getCanvas(i, r, a);
        return l ? l.getContext("2d", a || {}) : null;
      },
      release: function(i) {
        var r = i && i.canvas ? i.canvas : i;
        r && r.getContext && (r.getContext("2d").restore(), this.canvases.push(r));
      }
    }, Qe = new function() {
      var i = Math.min, r = Math.max, a = Math.abs, l, u, d, v, p, b, S, L, E, A, T;
      function G(j, q, H) {
        return 0.2989 * j + 0.587 * q + 0.114 * H;
      }
      function D(j, q, H, ue) {
        var ae = ue - G(j, q, H);
        E = j + ae, A = q + ae, T = H + ae;
        var ue = G(E, A, T), me = i(E, A, T), se = r(E, A, T);
        if (me < 0) {
          var de = ue - me;
          E = ue + (E - ue) * ue / de, A = ue + (A - ue) * ue / de, T = ue + (T - ue) * ue / de;
        }
        if (se > 255) {
          var ve = 255 - ue, we = se - ue;
          E = ue + (E - ue) * ve / we, A = ue + (A - ue) * ve / we, T = ue + (T - ue) * ve / we;
        }
      }
      function Y(j, q, H) {
        return r(j, q, H) - i(j, q, H);
      }
      function k(j, q, H, ie) {
        var ae = [j, q, H], ue = r(j, q, H), me = i(j, q, H), se;
        me = me === j ? 0 : me === q ? 1 : 2, ue = ue === j ? 0 : ue === q ? 1 : 2, se = i(me, ue) === 0 ? r(me, ue) === 1 ? 2 : 1 : 0, ae[ue] > ae[me] ? (ae[se] = (ae[se] - ae[me]) * ie / (ae[ue] - ae[me]), ae[ue] = ie) : ae[se] = ae[ue] = 0, ae[me] = 0, E = ae[0], A = ae[1], T = ae[2];
      }
      var z = {
        multiply: function() {
          E = p * l / 255, A = b * u / 255, T = S * d / 255;
        },
        screen: function() {
          E = p + l - p * l / 255, A = b + u - b * u / 255, T = S + d - S * d / 255;
        },
        overlay: function() {
          E = p < 128 ? 2 * p * l / 255 : 255 - 2 * (255 - p) * (255 - l) / 255, A = b < 128 ? 2 * b * u / 255 : 255 - 2 * (255 - b) * (255 - u) / 255, T = S < 128 ? 2 * S * d / 255 : 255 - 2 * (255 - S) * (255 - d) / 255;
        },
        "soft-light": function() {
          var j = l * p / 255;
          E = j + p * (255 - (255 - p) * (255 - l) / 255 - j) / 255, j = u * b / 255, A = j + b * (255 - (255 - b) * (255 - u) / 255 - j) / 255, j = d * S / 255, T = j + S * (255 - (255 - S) * (255 - d) / 255 - j) / 255;
        },
        "hard-light": function() {
          E = l < 128 ? 2 * l * p / 255 : 255 - 2 * (255 - l) * (255 - p) / 255, A = u < 128 ? 2 * u * b / 255 : 255 - 2 * (255 - u) * (255 - b) / 255, T = d < 128 ? 2 * d * S / 255 : 255 - 2 * (255 - d) * (255 - S) / 255;
        },
        "color-dodge": function() {
          E = p === 0 ? 0 : l === 255 ? 255 : i(255, 255 * p / (255 - l)), A = b === 0 ? 0 : u === 255 ? 255 : i(255, 255 * b / (255 - u)), T = S === 0 ? 0 : d === 255 ? 255 : i(255, 255 * S / (255 - d));
        },
        "color-burn": function() {
          E = p === 255 ? 255 : l === 0 ? 0 : r(0, 255 - (255 - p) * 255 / l), A = b === 255 ? 255 : u === 0 ? 0 : r(0, 255 - (255 - b) * 255 / u), T = S === 255 ? 255 : d === 0 ? 0 : r(0, 255 - (255 - S) * 255 / d);
        },
        darken: function() {
          E = p < l ? p : l, A = b < u ? b : u, T = S < d ? S : d;
        },
        lighten: function() {
          E = p > l ? p : l, A = b > u ? b : u, T = S > d ? S : d;
        },
        difference: function() {
          E = p - l, E < 0 && (E = -E), A = b - u, A < 0 && (A = -A), T = S - d, T < 0 && (T = -T);
        },
        exclusion: function() {
          E = p + l * (255 - p - p) / 255, A = b + u * (255 - b - b) / 255, T = S + d * (255 - S - S) / 255;
        },
        hue: function() {
          k(l, u, d, Y(p, b, S)), D(E, A, T, G(p, b, S));
        },
        saturation: function() {
          k(p, b, S, Y(l, u, d)), D(E, A, T, G(p, b, S));
        },
        luminosity: function() {
          D(p, b, S, G(l, u, d));
        },
        color: function() {
          D(l, u, d, G(p, b, S));
        },
        add: function() {
          E = i(p + l, 255), A = i(b + u, 255), T = i(S + d, 255);
        },
        subtract: function() {
          E = r(p - l, 0), A = r(b - u, 0), T = r(S - d, 0);
        },
        average: function() {
          E = (p + l) / 2, A = (b + u) / 2, T = (S + d) / 2;
        },
        negation: function() {
          E = 255 - a(255 - l - p), A = 255 - a(255 - u - b), T = 255 - a(255 - d - S);
        }
      }, C = this.nativeModes = o.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(j) {
        this[j] = !0;
      }, {}), O = vt.getContext(1, 1, { willReadFrequently: !0 });
      O && (o.each(z, function(j, q) {
        var H = q === "darken", ie = !1;
        O.save();
        try {
          O.fillStyle = H ? "#300" : "#a00", O.fillRect(0, 0, 1, 1), O.globalCompositeOperation = q, O.globalCompositeOperation === q && (O.fillStyle = H ? "#a00" : "#300", O.fillRect(0, 0, 1, 1), ie = O.getImageData(0, 0, 1, 1).data[0] !== H ? 170 : 51);
        } catch {
        }
        O.restore(), C[q] = ie;
      }), vt.release(O)), this.process = function(j, q, H, ie, ae) {
        var ue = q.canvas, me = j === "normal";
        if (me || C[j])
          H.save(), H.setTransform(1, 0, 0, 1, 0, 0), H.globalAlpha = ie, me || (H.globalCompositeOperation = j), H.drawImage(ue, ae.x, ae.y), H.restore();
        else {
          var se = z[j];
          if (!se)
            return;
          for (var de = H.getImageData(
            ae.x,
            ae.y,
            ue.width,
            ue.height
          ), ve = de.data, we = q.getImageData(
            0,
            0,
            ue.width,
            ue.height
          ).data, Se = 0, Ae = ve.length; Se < Ae; Se += 4) {
            l = we[Se], p = ve[Se], u = we[Se + 1], b = ve[Se + 1], d = we[Se + 2], S = ve[Se + 2], v = we[Se + 3], L = ve[Se + 3], se();
            var Ge = v * ie / 255, et = 1 - Ge;
            ve[Se] = Ge * E + et * p, ve[Se + 1] = Ge * A + et * b, ve[Se + 2] = Ge * T + et * S, ve[Se + 3] = v * ie + et * L;
          }
          H.putImageData(de, ae.x, ae.y);
        }
      };
    }(), wt = new function() {
      var i = "http://www.w3.org/2000/svg", r = "http://www.w3.org/2000/xmlns", a = "http://www.w3.org/1999/xlink", l = {
        href: a,
        xlink: r,
        xmlns: r + "/",
        "xmlns:xlink": r + "/"
      };
      function u(p, b, S) {
        return v(s.createElementNS(i, p), b, S);
      }
      function d(p, b) {
        var S = l[b], L = S ? p.getAttributeNS(S, b) : p.getAttribute(b);
        return L === "null" ? null : L;
      }
      function v(p, b, S) {
        for (var L in b) {
          var E = b[L], A = l[L];
          typeof E == "number" && S && (E = S.number(E)), A ? p.setAttributeNS(A, L, E) : p.setAttribute(L, E);
        }
        return p;
      }
      return {
        svg: i,
        xmlns: r,
        xlink: a,
        create: u,
        get: d,
        set: v
      };
    }(), Yt = o.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(i, r) {
        return !r && (i instanceof qt || i instanceof Ee || i instanceof Zt);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(i, r) {
      var a = o.capitalize(r), l = i[2];
      this[r] = {
        type: i[1],
        property: r,
        attribute: i[0],
        toSVG: l,
        fromSVG: l && o.each(l, function(u, d) {
          this[u] = d;
        }, {}),
        exportFilter: i[3],
        get: "get" + a,
        set: "set" + a
      };
    }, {});
    new function() {
      var i;
      function r(z, C, O) {
        var j = new o(), q = z.getTranslation();
        if (C) {
          var H;
          z.isInvertible() ? (z = z._shiftless(), H = z._inverseTransform(q), q = null) : H = new M(), j[O ? "cx" : "x"] = H.x, j[O ? "cy" : "y"] = H.y;
        }
        if (!z.isIdentity()) {
          var ie = z.decompose();
          if (ie) {
            var ae = [], ue = ie.rotation, me = ie.scaling, se = ie.skewing;
            q && !q.isZero() && ae.push("translate(" + i.point(q) + ")"), ue && ae.push("rotate(" + i.number(ue) + ")"), (!I.isZero(me.x - 1) || !I.isZero(me.y - 1)) && ae.push("scale(" + i.point(me) + ")"), se.x && ae.push("skewX(" + i.number(se.x) + ")"), se.y && ae.push("skewY(" + i.number(se.y) + ")"), j.transform = ae.join(" ");
          } else
            j.transform = "matrix(" + z.getValues().join(",") + ")";
        }
        return j;
      }
      function a(z, C) {
        for (var O = r(z._matrix), j = z._children, q = wt.create("g", O, i), H = 0, ie = j.length; H < ie; H++) {
          var ae = j[H], ue = Y(ae, C);
          if (ue)
            if (ae.isClipMask()) {
              var me = wt.create("clipPath");
              me.appendChild(ue), G(ae, me, "clip"), wt.set(q, {
                "clip-path": "url(#" + me.id + ")"
              });
            } else
              q.appendChild(ue);
        }
        return q;
      }
      function l(z, C) {
        var O = r(z._matrix, !0), j = z.getSize(), q = z.getImage();
        return O.x -= j.width / 2, O.y -= j.height / 2, O.width = j.width, O.height = j.height, O.href = C.embedImages == !1 && q && q.src || z.toDataURL(), wt.create("image", O, i);
      }
      function u(z, C) {
        var O = C.matchShapes;
        if (O) {
          var j = z.toShape(!1);
          if (j)
            return d(j);
        }
        var q = z._segments, H = q.length, ie, ae = r(z._matrix);
        if (O && H >= 2 && !z.hasHandles())
          if (H > 2) {
            ie = z._closed ? "polygon" : "polyline";
            for (var ue = [], me = 0; me < H; me++)
              ue.push(i.point(q[me]._point));
            ae.points = ue.join(" ");
          } else {
            ie = "line";
            var se = q[0]._point, de = q[1]._point;
            ae.set({
              x1: se.x,
              y1: se.y,
              x2: de.x,
              y2: de.y
            });
          }
        else
          ie = "path", ae.d = z.getPathData(null, C.precision);
        return wt.create(ie, ae, i);
      }
      function d(z) {
        var C = z._type, O = z._radius, j = r(z._matrix, !0, C !== "rectangle");
        if (C === "rectangle") {
          C = "rect";
          var q = z._size, H = q.width, ie = q.height;
          j.x -= H / 2, j.y -= ie / 2, j.width = H, j.height = ie, O.isZero() && (O = null);
        }
        return O && (C === "circle" ? j.r = O : (j.rx = O.width, j.ry = O.height)), wt.create(C, j, i);
      }
      function v(z, C) {
        var O = r(z._matrix), j = z.getPathData(null, C.precision);
        return j && (O.d = j), wt.create("path", O, i);
      }
      function p(z, C) {
        var O = r(z._matrix, !0), j = z._definition, q = T(j, "symbol"), H = j._item, ie = H.getStrokeBounds();
        return q || (q = wt.create("symbol", {
          viewBox: i.rectangle(ie)
        }), q.appendChild(Y(H, C)), G(j, q, "symbol")), O.href = "#" + q.id, O.x += ie.x, O.y += ie.y, O.width = ie.width, O.height = ie.height, O.overflow = "visible", wt.create("use", O, i);
      }
      function b(z) {
        var C = T(z, "color");
        if (!C) {
          var O = z.getGradient(), j = O._radial, q = z.getOrigin(), H = z.getDestination(), ie;
          if (j) {
            ie = {
              cx: q.x,
              cy: q.y,
              r: q.getDistance(H)
            };
            var ae = z.getHighlight();
            ae && (ie.fx = ae.x, ie.fy = ae.y);
          } else
            ie = {
              x1: q.x,
              y1: q.y,
              x2: H.x,
              y2: H.y
            };
          ie.gradientUnits = "userSpaceOnUse", C = wt.create((j ? "radial" : "linear") + "Gradient", ie, i);
          for (var ue = O._stops, me = 0, se = ue.length; me < se; me++) {
            var de = ue[me], ve = de._color, we = ve.getAlpha(), Se = de._offset;
            ie = {
              offset: Se ?? me / (se - 1)
            }, ve && (ie["stop-color"] = ve.toCSS(!0)), we < 1 && (ie["stop-opacity"] = we), C.appendChild(
              wt.create("stop", ie, i)
            );
          }
          G(z, C, "color");
        }
        return "url(#" + C.id + ")";
      }
      function S(z) {
        var C = wt.create(
          "text",
          r(z._matrix, !0),
          i
        );
        return C.textContent = z._content, C;
      }
      var L = {
        Group: a,
        Layer: a,
        Raster: l,
        Path: u,
        Shape: d,
        CompoundPath: v,
        SymbolItem: p,
        PointText: S
      };
      function E(z, C, O, j) {
        var q = {}, H = !j && z.getParent(), ie = [];
        return z._name != null && (q.id = z._name), o.each(Yt, function(ae) {
          var ue = ae.get, me = ae.type, se = z[ue]();
          if (ae.exportFilter ? ae.exportFilter(z, se) : O.reduceAttributes == !1 || !H || !o.equals(H[ue](), se)) {
            if (me === "color" && se != null) {
              var de = se.getAlpha();
              de < 1 && (q[ae.attribute + "-opacity"] = de);
            }
            me === "style" ? ie.push(ae.attribute + ": " + se) : q[ae.attribute] = se == null ? "none" : me === "color" ? se.gradient ? b(se) : se.toCSS(!0) : me === "array" ? se.join(",") : me === "lookup" ? ae.toSVG[se] : se;
          }
        }), ie.length && (q.style = ie.join(";")), q.opacity === 1 && delete q.opacity, z._visible || (q.visibility = "hidden"), wt.set(C, q, i);
      }
      var A;
      function T(z, C) {
        return A || (A = { ids: {}, svgs: {} }), z && A.svgs[C + "-" + (z._id || z.__id || (z.__id = F.get("svg")))];
      }
      function G(z, C, O) {
        A || T();
        var j = A.ids[O] = (A.ids[O] || 0) + 1;
        C.id = O + "-" + j, A.svgs[O + "-" + (z._id || z.__id)] = C;
      }
      function D(z, C) {
        var O = z, j = null;
        if (A) {
          O = z.nodeName.toLowerCase() === "svg" && z;
          for (var q in A.svgs)
            j || (O || (O = wt.create("svg"), O.appendChild(z)), j = O.insertBefore(
              wt.create("defs"),
              O.firstChild
            )), j.appendChild(A.svgs[q]);
          A = null;
        }
        return C.asString ? new e.XMLSerializer().serializeToString(O) : O;
      }
      function Y(z, C, O) {
        var j = L[z._class], q = j && j(z, C);
        if (q) {
          var H = C.onExport;
          H && (q = H(z, q, C) || q);
          var ie = JSON.stringify(z._data);
          ie && ie !== "{}" && ie !== "null" && q.setAttribute("data-paper-data", ie);
        }
        return q && E(z, q, C, O);
      }
      function k(z) {
        return z || (z = {}), i = new B(z.precision), z;
      }
      X.inject({
        exportSVG: function(z) {
          return z = k(z), D(Y(this, z, !0), z);
        }
      }), fe.inject({
        exportSVG: function(z) {
          z = k(z);
          var C = this._children, O = this.getView(), j = o.pick(z.bounds, "view"), q = z.matrix || j === "view" && O._matrix, H = q && J.read([q]), ie = j === "view" ? new P([0, 0], O.getViewSize()) : j === "content" ? X._getBounds(C, H, { stroke: !0 }).rect : P.read([j], 0, { readNull: !0 }), ae = {
            version: "1.1",
            xmlns: wt.svg,
            "xmlns:xlink": wt.xlink
          };
          ie && (ae.width = ie.width, ae.height = ie.height, (ie.x || ie.x === 0 || ie.y || ie.y === 0) && (ae.viewBox = i.rectangle(ie)));
          var ue = wt.create("svg", ae, i), me = ue;
          H && !H.isIdentity() && (me = ue.appendChild(wt.create(
            "g",
            r(H),
            i
          )));
          for (var se = 0, de = C.length; se < de; se++)
            me.appendChild(Y(C[se], z, !0));
          return D(ue, z);
        }
      });
    }(), new function() {
      var i = {}, r;
      function a(C, O, j, q, H, ie) {
        var ae = wt.get(C, O) || ie, ue = ae == null ? q ? null : j ? "" : 0 : j ? ae : parseFloat(ae);
        return /%\s*$/.test(ae) ? ue / 100 * (H ? 1 : r[/x|^width/.test(O) ? "width" : "height"]) : ue;
      }
      function l(C, O, j, q, H, ie, ae) {
        return O = a(C, O || "x", !1, q, H, ie), j = a(C, j || "y", !1, q, H, ae), q && (O == null || j == null) ? null : new M(O, j);
      }
      function u(C, O, j, q, H) {
        return O = a(C, O || "width", !1, q, H), j = a(C, j || "height", !1, q, H), q && (O == null || j == null) ? null : new V(O, j);
      }
      function d(C, O, j) {
        return C === "none" ? null : O === "number" ? parseFloat(C) : O === "array" ? C ? C.split(/[\s,]+/g).map(parseFloat) : [] : O === "color" ? Y(C) || C : O === "lookup" ? j[C] : C;
      }
      function v(C, O, j, q) {
        var H = C.childNodes, ie = O === "clippath", ae = O === "defs", ue = new W(), me = ue._project, se = me._currentStyle, de = [];
        if (!ie && !ae && (ue = D(ue, C, q), me._currentStyle = ue._style.clone()), q)
          for (var ve = C.querySelectorAll("defs"), we = 0, Se = ve.length; we < Se; we++)
            k(ve[we], j, !1);
        for (var we = 0, Se = H.length; we < Se; we++) {
          var Ae = H[we], Ge;
          Ae.nodeType === 1 && !/^defs$/i.test(Ae.nodeName) && (Ge = k(Ae, j, !1)) && !(Ge instanceof Le) && de.push(Ge);
        }
        return ue.addChildren(de), ie && (ue = D(ue.reduce(), C, q)), me._currentStyle = se, (ie || ae) && (ue.remove(), ue = null), ue;
      }
      function p(C, O) {
        for (var j = C.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), q = [], H = 0, ie = j.length; H < ie; H += 2)
          q.push(new M(
            parseFloat(j[H]),
            parseFloat(j[H + 1])
          ));
        var ae = new We(q);
        return O === "polygon" && ae.closePath(), ae;
      }
      function b(C) {
        return qt.create(C.getAttribute("d"));
      }
      function S(C, O) {
        var j = (a(C, "href", !0) || "").substring(1), q = O === "radialgradient", H;
        if (j)
          H = i[j].getGradient(), H._radial ^ q && (H = H.clone(), H._radial = q);
        else {
          for (var ie = C.childNodes, ae = [], ue = 0, me = ie.length; ue < me; ue++) {
            var se = ie[ue];
            se.nodeType === 1 && ae.push(D(new Ci(), se));
          }
          H = new ii(ae, q);
        }
        var de, ve, we, Se = a(C, "gradientUnits", !0) !== "userSpaceOnUse";
        q ? (de = l(
          C,
          "cx",
          "cy",
          !1,
          Se,
          "50%",
          "50%"
        ), ve = de.add(
          a(C, "r", !1, !1, Se, "50%"),
          0
        ), we = l(C, "fx", "fy", !0, Se)) : (de = l(
          C,
          "x1",
          "y1",
          !1,
          Se,
          "0%",
          "0%"
        ), ve = l(
          C,
          "x2",
          "y2",
          !1,
          Se,
          "100%",
          "0%"
        ));
        var Ae = D(
          new Lt(H, de, ve, we),
          C
        );
        return Ae._scaleToBounds = Se, null;
      }
      var L = {
        "#document": function(C, O, j, q) {
          for (var H = C.childNodes, ie = 0, ae = H.length; ie < ae; ie++) {
            var ue = H[ie];
            if (ue.nodeType === 1)
              return k(ue, j, q);
          }
        },
        g: v,
        svg: v,
        clippath: v,
        polygon: p,
        polyline: p,
        path: b,
        lineargradient: S,
        radialgradient: S,
        image: function(C) {
          var O = new He(a(C, "href", !0));
          return O.on("load", function() {
            var j = u(C);
            this.setSize(j);
            var q = l(C).add(j.divide(2));
            this._matrix.append(new J().translate(q));
          }), O;
        },
        symbol: function(C, O, j, q) {
          return new Le(
            v(C, O, j, q),
            !0
          );
        },
        defs: v,
        use: function(C) {
          var O = (a(C, "href", !0) || "").substring(1), j = i[O], q = l(C);
          return j ? j instanceof Le ? j.place(q) : j.clone().translate(q) : null;
        },
        circle: function(C) {
          return new Ee.Circle(
            l(C, "cx", "cy"),
            a(C, "r")
          );
        },
        ellipse: function(C) {
          return new Ee.Ellipse({
            center: l(C, "cx", "cy"),
            radius: u(C, "rx", "ry")
          });
        },
        rect: function(C) {
          return new Ee.Rectangle(new P(
            l(C),
            u(C)
          ), u(C, "rx", "ry"));
        },
        line: function(C) {
          return new We.Line(
            l(C, "x1", "y1"),
            l(C, "x2", "y2")
          );
        },
        text: function(C) {
          var O = new $t(l(C).add(
            l(C, "dx", "dy")
          ));
          return O.setContent(C.textContent.trim() || ""), O;
        },
        switch: v
      };
      function E(C, O, j, q) {
        if (C.transform) {
          for (var H = (q.getAttribute(j) || "").split(/\)\s*/g), ie = new J(), ae = 0, ue = H.length; ae < ue; ae++) {
            var me = H[ae];
            if (!me)
              break;
            for (var se = me.split(/\(\s*/), de = se[0].trim(), ve = se[1].split(/[\s,]+/g), we = 0, Se = ve.length; we < Se; we++)
              ve[we] = parseFloat(ve[we]);
            switch (de) {
              case "matrix":
                ie.append(
                  new J(ve[0], ve[1], ve[2], ve[3], ve[4], ve[5])
                );
                break;
              case "rotate":
                ie.rotate(ve[0], ve[1] || 0, ve[2] || 0);
                break;
              case "translate":
                ie.translate(ve[0], ve[1] || 0);
                break;
              case "scale":
                ie.scale(ve);
                break;
              case "skewX":
                ie.skew(ve[0], 0);
                break;
              case "skewY":
                ie.skew(0, ve[0]);
                break;
            }
          }
          C.transform(ie);
        }
      }
      function A(C, O, j) {
        var q = j === "fill-opacity" ? "getFillColor" : "getStrokeColor", H = C[q] && C[q]();
        H && H.setAlpha(parseFloat(O));
      }
      var T = o.set(o.each(Yt, function(C) {
        this[C.attribute] = function(O, j) {
          if (O[C.set] && (O[C.set](d(j, C.type, C.fromSVG)), C.type === "color")) {
            var q = O[C.get]();
            if (q && q._scaleToBounds) {
              var H = O.getBounds();
              q.transform(new J().translate(H.getPoint()).scale(H.getSize()));
            }
          }
        };
      }, {}), {
        id: function(C, O) {
          i[O] = C, C.setName && C.setName(O);
        },
        "clip-path": function(C, O) {
          var j = Y(O);
          if (j)
            if (j = j.clone(), j.setClipMask(!0), C instanceof W)
              C.insertChild(0, j);
            else
              return new W(j, C);
        },
        gradientTransform: E,
        transform: E,
        "fill-opacity": A,
        "stroke-opacity": A,
        visibility: function(C, O) {
          C.setVisible && C.setVisible(O === "visible");
        },
        display: function(C, O) {
          C.setVisible && C.setVisible(O !== null);
        },
        "stop-color": function(C, O) {
          C.setColor && C.setColor(O);
        },
        "stop-opacity": function(C, O) {
          C._color && C._color.setAlpha(parseFloat(O));
        },
        offset: function(C, O) {
          if (C.setOffset) {
            var j = O.match(/(.*)%$/);
            C.setOffset(j ? j[1] / 100 : parseFloat(O));
          }
        },
        viewBox: function(C, O, j, q, H) {
          var ie = new P(d(O, "array")), ae = u(q, null, null, !0), ue, me;
          if (C instanceof W) {
            var se = ae ? ae.divide(ie.getSize()) : 1, me = new J().scale(se).translate(ie.getPoint().negate());
            ue = C;
          } else
            C instanceof Le && (ae && ie.setSize(ae), ue = C._item);
          if (ue) {
            if (G(q, "overflow", H) !== "visible") {
              var de = new Ee.Rectangle(ie);
              de.setClipMask(!0), ue.addChild(de);
            }
            me && ue.transform(me);
          }
        }
      });
      function G(C, O, j) {
        var q = C.attributes[O], H = q && q.value;
        if (!H && C.style) {
          var ie = o.camelize(O);
          H = C.style[ie], !H && j.node[ie] !== j.parent[ie] && (H = j.node[ie]);
        }
        return H ? H === "none" ? null : H : t;
      }
      function D(C, O, j) {
        var q = O.parentNode, H = {
          node: Gt.getStyles(O) || {},
          parent: !j && !/^defs$/i.test(q.tagName) && Gt.getStyles(q) || {}
        };
        return o.each(T, function(ie, ae) {
          var ue = G(O, ae, H);
          C = ue !== t && ie(C, ue, ae, O, H) || C;
        }), C;
      }
      function Y(C) {
        var O = C && C.match(/\((?:["'#]*)([^"')]+)/), j = O && O[1], q = j && i[n ? j.replace(n.location.href.split("#")[0] + "#", "") : j];
        return q && q._scaleToBounds && (q = q.clone(), q._scaleToBounds = !0), q;
      }
      function k(C, O, j) {
        var q = C.nodeName.toLowerCase(), H = q !== "#document", ie = s.body, ae, ue, me;
        j && H && (r = Ye.getView().getSize(), r = u(C, null, null, !0) || r, ae = wt.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), ue = C.parentNode, me = C.nextSibling, ae.appendChild(C), ie.appendChild(ae));
        var se = Ye.settings, de = se.applyMatrix, ve = se.insertItems;
        se.applyMatrix = !1, se.insertItems = !1;
        var we = L[q], Se = we && we(C, q, O, j) || null;
        if (se.insertItems = ve, se.applyMatrix = de, Se) {
          H && !(Se instanceof W) && (Se = D(Se, C, j));
          var Ae = O.onImport, Ge = H && C.getAttribute("data-paper-data");
          Ae && (Se = Ae(C, Se, O) || Se), O.expandShapes && Se instanceof Ee && (Se.remove(), Se = Se.toPath()), Ge && (Se._data = JSON.parse(Ge));
        }
        return ae && (ie.removeChild(ae), ue && (me ? ue.insertBefore(C, me) : ue.appendChild(C))), j && (i = {}, Se && o.pick(O.applyMatrix, de) && Se.matrix.apply(!0, !0)), Se;
      }
      function z(C, O, j) {
        if (!C)
          return null;
        O = typeof O == "function" ? { onLoad: O } : O || {};
        var q = Ye, H = null;
        function ie(se) {
          try {
            var de = typeof se == "object" ? se : new e.DOMParser().parseFromString(
              se.trim(),
              "image/svg+xml"
            );
            if (!de.nodeName)
              throw de = null, new Error("Unsupported SVG source: " + C);
            Ye = q, H = k(de, O, !0), (!O || O.insert !== !1) && j._insertItem(t, H);
            var ve = O.onLoad;
            ve && ve(H, se);
          } catch (we) {
            ae(we);
          }
        }
        function ae(se, de) {
          var ve = O.onError;
          if (ve)
            ve(se, de);
          else
            throw new Error(se);
        }
        if (typeof C == "string" && !/^[\s\S]*</.test(C)) {
          var ue = s.getElementById(C);
          ue ? ie(ue) : kt.request({
            url: C,
            async: !0,
            onLoad: ie,
            onError: ae
          });
        } else if (typeof File < "u" && C instanceof File) {
          var me = new FileReader();
          return me.onload = function() {
            ie(me.result);
          }, me.onerror = function() {
            ae(me.error);
          }, me.readAsText(C);
        } else
          ie(C);
        return H;
      }
      X.inject({
        importSVG: function(C, O) {
          return z(C, O, this);
        }
      }), fe.inject({
        importSVG: function(C, O) {
          return this.activate(), z(C, O, this);
        }
      });
    }(), o.exports.PaperScript = (function() {
      var i = this, r = i.acorn;
      if (!r && typeof Qa < "u")
        try {
          r = _1();
        } catch {
        }
      if (!r) {
        var a, l;
        r = a = l = {}, function(D, Y) {
          if (typeof a == "object" && typeof l == "object")
            return Y(a);
          if (typeof t == "function" && t.amd)
            return t(["exports"], Y);
          Y(D.acorn || (D.acorn = {}));
        }(this, function(D) {
          D.version = "0.5.0";
          var Y, k, z, C;
          D.parse = function(Q, oe) {
            return k = String(Q), z = k.length, j(oe), _e(), Js(Y.program);
          };
          var O = D.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function j(Q) {
            Y = Q || {};
            for (var oe in O)
              Object.prototype.hasOwnProperty.call(Y, oe) || (Y[oe] = O[oe]);
            C = Y.sourceFile || null;
          }
          var q = D.getLineInfo = function(Q, oe) {
            for (var Me = 1, Be = 0; ; ) {
              N.lastIndex = Be;
              var ht = N.exec(Q);
              if (ht && ht.index < oe)
                ++Me, Be = ht.index + ht[0].length;
              else
                break;
            }
            return { line: Me, column: oe - Be };
          };
          D.tokenize = function(Q, oe) {
            k = String(Q), z = k.length, j(oe), _e();
            var Me = {};
            function Be(ht) {
              return Ge = ae, an(ht), Me.start = ie, Me.end = ae, Me.startLoc = ue, Me.endLoc = me, Me.type = se, Me.value = de, Me;
            }
            return Be.jumpTo = function(ht, gt) {
              if (H = ht, Y.locations) {
                we = 1, Se = N.lastIndex = 0;
                for (var Mt; (Mt = N.exec(k)) && Mt.index < ht; )
                  ++we, Se = Mt.index + Mt[0].length;
              }
              ve = gt, qe();
            }, Be;
          };
          var H, ie, ae, ue, me, se, de, ve, we, Se, Ae, Ge, et, st, _t, Re;
          function Fe(Q, oe) {
            var Me = q(k, Q);
            oe += " (" + Me.line + ":" + Me.column + ")";
            var Be = new SyntaxError(oe);
            throw Be.pos = Q, Be.loc = Me, Be.raisedAt = H, Be;
          }
          var at = [], yt = { type: "num" }, bt = { type: "regexp" }, Rt = { type: "string" }, It = { type: "name" }, Ht = { type: "eof" }, jt = { keyword: "break" }, Vt = { keyword: "case", beforeExpr: !0 }, Ti = { keyword: "catch" }, ki = { keyword: "continue" }, Li = { keyword: "debugger" }, bi = { keyword: "default" }, si = { keyword: "do", isLoop: !0 }, Nt = { keyword: "else", beforeExpr: !0 }, Vi = { keyword: "finally" }, ci = { keyword: "for", isLoop: !0 }, nn = { keyword: "function" }, Yi = { keyword: "if" }, qi = { keyword: "return", beforeExpr: !0 }, Qi = { keyword: "switch" }, Gi = { keyword: "throw", beforeExpr: !0 }, Xi = { keyword: "try" }, _n = { keyword: "var" }, Ki = { keyword: "while", isLoop: !0 }, cn = { keyword: "with" }, Cn = { keyword: "new", beforeExpr: !0 }, $r = { keyword: "this" }, Pr = { keyword: "null", atomValue: null }, An = { keyword: "true", atomValue: !0 }, Xr = { keyword: "false", atomValue: !1 }, Vn = { keyword: "in", binop: 7, beforeExpr: !0 }, gr = {
            break: jt,
            case: Vt,
            catch: Ti,
            continue: ki,
            debugger: Li,
            default: bi,
            do: si,
            else: Nt,
            finally: Vi,
            for: ci,
            function: nn,
            if: Yi,
            return: qi,
            switch: Qi,
            throw: Gi,
            try: Xi,
            var: _n,
            while: Ki,
            with: cn,
            null: Pr,
            true: An,
            false: Xr,
            new: Cn,
            in: Vn,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: $r,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, Hn = { type: "[", beforeExpr: !0 }, fn = { type: "]" }, dn = { type: "{", beforeExpr: !0 }, bn = { type: "}" }, sn = { type: "(", beforeExpr: !0 }, ri = { type: ")" }, gn = { type: ",", beforeExpr: !0 }, rn = { type: ";", beforeExpr: !0 }, On = { type: ":", beforeExpr: !0 }, pr = { type: "." }, Nr = { type: "?", beforeExpr: !0 }, wr = { binop: 10, beforeExpr: !0 }, Sr = { isAssign: !0, beforeExpr: !0 }, g = { isAssign: !0, beforeExpr: !0 }, U = { postfix: !0, prefix: !0, isUpdate: !0 }, he = { prefix: !0, beforeExpr: !0 }, ye = { binop: 1, beforeExpr: !0 }, Ie = { binop: 2, beforeExpr: !0 }, ot = { binop: 3, beforeExpr: !0 }, dt = { binop: 4, beforeExpr: !0 }, zt = { binop: 5, beforeExpr: !0 }, Kt = { binop: 6, beforeExpr: !0 }, fi = { binop: 7, beforeExpr: !0 }, ti = { binop: 8, beforeExpr: !0 }, hi = { binop: 9, prefix: !0, beforeExpr: !0 }, vn = { binop: 10, beforeExpr: !0 };
          D.tokTypes = {
            bracketL: Hn,
            bracketR: fn,
            braceL: dn,
            braceR: bn,
            parenL: sn,
            parenR: ri,
            comma: gn,
            semi: rn,
            colon: On,
            dot: pr,
            question: Nr,
            slash: wr,
            eq: Sr,
            name: It,
            eof: Ht,
            num: yt,
            regexp: bt,
            string: Rt
          };
          for (var ar in gr)
            D.tokTypes["_" + ar] = gr[ar];
          function Tn(Q) {
            Q = Q.split(" ");
            var oe = "", Me = [];
            e:
              for (var Be = 0; Be < Q.length; ++Be) {
                for (var ht = 0; ht < Me.length; ++ht)
                  if (Me[ht][0].length == Q[Be].length) {
                    Me[ht].push(Q[Be]);
                    continue e;
                  }
                Me.push([Q[Be]]);
              }
            function gt(Wt) {
              if (Wt.length == 1)
                return oe += "return str === " + JSON.stringify(Wt[0]) + ";";
              oe += "switch(str){";
              for (var xi = 0; xi < Wt.length; ++xi)
                oe += "case " + JSON.stringify(Wt[xi]) + ":";
              oe += "return true}return false;";
            }
            if (Me.length > 3) {
              Me.sort(function(Wt, xi) {
                return xi.length - Wt.length;
              }), oe += "switch(str.length){";
              for (var Be = 0; Be < Me.length; ++Be) {
                var Mt = Me[Be];
                oe += "case " + Mt[0].length + ":", gt(Mt);
              }
              oe += "}";
            } else
              gt(Q);
            return new Function("str", oe);
          }
          var Mr = Tn("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), Cr = Tn("class enum extends super const export import"), or = Tn("implements interface let package private protected public static yield"), Ar = Tn("eval arguments"), ls = Tn("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), Sn = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Rr = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Dr = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", vs = new RegExp("[" + Rr + "]"), Ts = new RegExp("[" + Rr + Dr + "]"), w = /[\n\r\u2028\u2029]/, N = /\r\n|[\n\r\u2028\u2029]/g, ee = D.isIdentifierStart = function(Q) {
            return Q < 65 ? Q === 36 : Q < 91 ? !0 : Q < 97 ? Q === 95 : Q < 123 ? !0 : Q >= 170 && vs.test(String.fromCharCode(Q));
          }, re = D.isIdentifierChar = function(Q) {
            return Q < 48 ? Q === 36 : Q < 58 ? !0 : Q < 65 ? !1 : Q < 91 ? !0 : Q < 97 ? Q === 95 : Q < 123 ? !0 : Q >= 170 && Ts.test(String.fromCharCode(Q));
          };
          function ge() {
            this.line = we, this.column = H - Se;
          }
          function _e() {
            we = 1, H = Se = 0, ve = !0, qe();
          }
          function xe(Q, oe) {
            ae = H, Y.locations && (me = new ge()), se = Q, qe(), de = oe, ve = Q.beforeExpr;
          }
          function Ue() {
            var Q = Y.onComment && Y.locations && new ge(), oe = H, Me = k.indexOf("*/", H += 2);
            if (Me === -1 && Fe(H - 2, "Unterminated comment"), H = Me + 2, Y.locations) {
              N.lastIndex = oe;
              for (var Be; (Be = N.exec(k)) && Be.index < H; )
                ++we, Se = Be.index + Be[0].length;
            }
            Y.onComment && Y.onComment(
              !0,
              k.slice(oe + 2, Me),
              oe,
              H,
              Q,
              Y.locations && new ge()
            );
          }
          function De() {
            for (var Q = H, oe = Y.onComment && Y.locations && new ge(), Me = k.charCodeAt(H += 2); H < z && Me !== 10 && Me !== 13 && Me !== 8232 && Me !== 8233; )
              ++H, Me = k.charCodeAt(H);
            Y.onComment && Y.onComment(
              !1,
              k.slice(Q + 2, H),
              Q,
              H,
              oe,
              Y.locations && new ge()
            );
          }
          function qe() {
            for (; H < z; ) {
              var Q = k.charCodeAt(H);
              if (Q === 32)
                ++H;
              else if (Q === 13) {
                ++H;
                var oe = k.charCodeAt(H);
                oe === 10 && ++H, Y.locations && (++we, Se = H);
              } else if (Q === 10 || Q === 8232 || Q === 8233)
                ++H, Y.locations && (++we, Se = H);
              else if (Q > 8 && Q < 14)
                ++H;
              else if (Q === 47) {
                var oe = k.charCodeAt(H + 1);
                if (oe === 42)
                  Ue();
                else if (oe === 47)
                  De();
                else
                  break;
              } else if (Q === 160)
                ++H;
              else if (Q >= 5760 && Sn.test(String.fromCharCode(Q)))
                ++H;
              else
                break;
            }
          }
          function At() {
            var Q = k.charCodeAt(H + 1);
            return Q >= 48 && Q <= 57 ? en(!0) : (++H, xe(pr));
          }
          function Bt() {
            var Q = k.charCodeAt(H + 1);
            return ve ? (++H, Ii()) : Q === 61 ? Si(g, 2) : Si(wr, 1);
          }
          function ct() {
            var Q = k.charCodeAt(H + 1);
            return Q === 61 ? Si(g, 2) : Si(vn, 1);
          }
          function Ft(Q) {
            var oe = k.charCodeAt(H + 1);
            return oe === Q ? Si(Q === 124 ? ye : Ie, 2) : oe === 61 ? Si(g, 2) : Si(Q === 124 ? ot : zt, 1);
          }
          function pi() {
            var Q = k.charCodeAt(H + 1);
            return Q === 61 ? Si(g, 2) : Si(dt, 1);
          }
          function ai(Q) {
            var oe = k.charCodeAt(H + 1);
            return oe === Q ? oe == 45 && k.charCodeAt(H + 2) == 62 && w.test(k.slice(Ge, H)) ? (H += 3, De(), qe(), an()) : Si(U, 2) : oe === 61 ? Si(g, 2) : Si(hi, 1);
          }
          function mi(Q) {
            var oe = k.charCodeAt(H + 1), Me = 1;
            return oe === Q ? (Me = Q === 62 && k.charCodeAt(H + 2) === 62 ? 3 : 2, k.charCodeAt(H + Me) === 61 ? Si(g, Me + 1) : Si(ti, Me)) : oe == 33 && Q == 60 && k.charCodeAt(H + 2) == 45 && k.charCodeAt(H + 3) == 45 ? (H += 4, De(), qe(), an()) : (oe === 61 && (Me = k.charCodeAt(H + 2) === 61 ? 3 : 2), Si(fi, Me));
          }
          function xn(Q) {
            var oe = k.charCodeAt(H + 1);
            return oe === 61 ? Si(Kt, k.charCodeAt(H + 2) === 61 ? 3 : 2) : Si(Q === 61 ? Sr : he, 1);
          }
          function wn(Q) {
            switch (Q) {
              case 46:
                return At();
              case 40:
                return ++H, xe(sn);
              case 41:
                return ++H, xe(ri);
              case 59:
                return ++H, xe(rn);
              case 44:
                return ++H, xe(gn);
              case 91:
                return ++H, xe(Hn);
              case 93:
                return ++H, xe(fn);
              case 123:
                return ++H, xe(dn);
              case 125:
                return ++H, xe(bn);
              case 58:
                return ++H, xe(On);
              case 63:
                return ++H, xe(Nr);
              case 48:
                var oe = k.charCodeAt(H + 1);
                if (oe === 120 || oe === 88)
                  return Fi();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return en(!1);
              case 34:
              case 39:
                return lr(Q);
              case 47:
                return Bt();
              case 37:
              case 42:
                return ct();
              case 124:
              case 38:
                return Ft(Q);
              case 94:
                return pi();
              case 43:
              case 45:
                return ai(Q);
              case 60:
              case 62:
                return mi(Q);
              case 61:
              case 33:
                return xn(Q);
              case 126:
                return Si(he, 1);
            }
            return !1;
          }
          function an(Q) {
            if (Q ? H = ie + 1 : ie = H, Y.locations && (ue = new ge()), Q)
              return Ii();
            if (H >= z)
              return xe(Ht);
            var oe = k.charCodeAt(H);
            if (ee(oe) || oe === 92)
              return Yn();
            var Me = wn(oe);
            if (Me === !1) {
              var Be = String.fromCharCode(oe);
              if (Be === "\\" || vs.test(Be))
                return Yn();
              Fe(H, "Unexpected character '" + Be + "'");
            }
            return Me;
          }
          function Si(Q, oe) {
            var Me = k.slice(H, H + oe);
            H += oe, xe(Q, Me);
          }
          function Ii() {
            for (var ht = "", Q, oe, Me = H; ; ) {
              H >= z && Fe(Me, "Unterminated regular expression");
              var Be = k.charAt(H);
              if (w.test(Be) && Fe(Me, "Unterminated regular expression"), Q)
                Q = !1;
              else {
                if (Be === "[")
                  oe = !0;
                else if (Be === "]" && oe)
                  oe = !1;
                else if (Be === "/" && !oe)
                  break;
                Q = Be === "\\";
              }
              ++H;
            }
            var ht = k.slice(Me, H);
            ++H;
            var gt = Tr();
            gt && !/^[gmsiy]*$/.test(gt) && Fe(Me, "Invalid regexp flag");
            try {
              var Mt = new RegExp(ht, gt);
            } catch (Wt) {
              Wt instanceof SyntaxError && Fe(Me, Wt.message), Fe(Wt);
            }
            return xe(bt, Mt);
          }
          function Dn(Q, oe) {
            for (var Me = H, Be = 0, ht = 0, gt = oe ?? 1 / 0; ht < gt; ++ht) {
              var Mt = k.charCodeAt(H), Wt;
              if (Mt >= 97 ? Wt = Mt - 97 + 10 : Mt >= 65 ? Wt = Mt - 65 + 10 : Mt >= 48 && Mt <= 57 ? Wt = Mt - 48 : Wt = 1 / 0, Wt >= Q)
                break;
              ++H, Be = Be * Q + Wt;
            }
            return H === Me || oe != null && H - Me !== oe ? null : Be;
          }
          function Fi() {
            H += 2;
            var Q = Dn(16);
            return Q == null && Fe(ie + 2, "Expected hexadecimal number"), ee(k.charCodeAt(H)) && Fe(H, "Identifier directly after number"), xe(yt, Q);
          }
          function en(Q) {
            var oe = H, Me = !1, Be = k.charCodeAt(H) === 48;
            !Q && Dn(10) === null && Fe(oe, "Invalid number"), k.charCodeAt(H) === 46 && (++H, Dn(10), Me = !0);
            var ht = k.charCodeAt(H);
            (ht === 69 || ht === 101) && (ht = k.charCodeAt(++H), (ht === 43 || ht === 45) && ++H, Dn(10) === null && Fe(oe, "Invalid number"), Me = !0), ee(k.charCodeAt(H)) && Fe(H, "Identifier directly after number");
            var gt = k.slice(oe, H), Mt;
            return Me ? Mt = parseFloat(gt) : !Be || gt.length === 1 ? Mt = parseInt(gt, 10) : /[89]/.test(gt) || Re ? Fe(oe, "Invalid number") : Mt = parseInt(gt, 8), xe(yt, Mt);
          }
          function lr(Q) {
            H++;
            for (var oe = ""; ; ) {
              H >= z && Fe(ie, "Unterminated string constant");
              var Me = k.charCodeAt(H);
              if (Me === Q)
                return ++H, xe(Rt, oe);
              if (Me === 92) {
                Me = k.charCodeAt(++H);
                var Be = /^[0-7]+/.exec(k.slice(H, H + 3));
                for (Be && (Be = Be[0]); Be && parseInt(Be, 8) > 255; )
                  Be = Be.slice(0, -1);
                if (Be === "0" && (Be = null), ++H, Be)
                  Re && Fe(H - 2, "Octal literal in strict mode"), oe += String.fromCharCode(parseInt(Be, 8)), H += Be.length - 1;
                else
                  switch (Me) {
                    case 110:
                      oe += `
`;
                      break;
                    case 114:
                      oe += "\r";
                      break;
                    case 120:
                      oe += String.fromCharCode(mr(2));
                      break;
                    case 117:
                      oe += String.fromCharCode(mr(4));
                      break;
                    case 85:
                      oe += String.fromCharCode(mr(8));
                      break;
                    case 116:
                      oe += "	";
                      break;
                    case 98:
                      oe += "\b";
                      break;
                    case 118:
                      oe += "\v";
                      break;
                    case 102:
                      oe += "\f";
                      break;
                    case 48:
                      oe += "\0";
                      break;
                    case 13:
                      k.charCodeAt(H) === 10 && ++H;
                    case 10:
                      Y.locations && (Se = H, ++we);
                      break;
                    default:
                      oe += String.fromCharCode(Me);
                      break;
                  }
              } else
                (Me === 13 || Me === 10 || Me === 8232 || Me === 8233) && Fe(ie, "Unterminated string constant"), oe += String.fromCharCode(Me), ++H;
            }
          }
          function mr(Q) {
            var oe = Dn(16, Q);
            return oe === null && Fe(ie, "Bad character escape sequence"), oe;
          }
          var pn;
          function Tr() {
            pn = !1;
            for (var Q, oe = !0, Me = H; ; ) {
              var Be = k.charCodeAt(H);
              if (re(Be))
                pn && (Q += k.charAt(H)), ++H;
              else if (Be === 92) {
                pn || (Q = k.slice(Me, H)), pn = !0, k.charCodeAt(++H) != 117 && Fe(H, "Expecting Unicode escape sequence \\uXXXX"), ++H;
                var ht = mr(4), gt = String.fromCharCode(ht);
                gt || Fe(H - 1, "Invalid Unicode escape"), (oe ? ee(ht) : re(ht)) || Fe(H - 4, "Invalid Unicode escape"), Q += gt;
              } else
                break;
              oe = !1;
            }
            return pn ? Q : k.slice(Me, H);
          }
          function Yn() {
            var Q = Tr(), oe = It;
            return !pn && ls(Q) && (oe = gr[Q]), xe(oe, Q);
          }
          function ei() {
            Ae = ie, Ge = ae, et = me, an();
          }
          function Zn(Q) {
            if (Re = Q, H = ie, Y.locations)
              for (; H < Se; )
                Se = k.lastIndexOf(`
`, Se - 2) + 1, --we;
            qe(), an();
          }
          function Gn() {
            this.type = null, this.start = ie, this.end = null;
          }
          function zr() {
            this.start = ue, this.end = null, C !== null && (this.source = C);
          }
          function Ai() {
            var Q = new Gn();
            return Y.locations && (Q.loc = new zr()), Y.directSourceFile && (Q.sourceFile = Y.directSourceFile), Y.ranges && (Q.range = [ie, 0]), Q;
          }
          function hn(Q) {
            var oe = new Gn();
            return oe.start = Q.start, Y.locations && (oe.loc = new zr(), oe.loc.start = Q.loc.start), Y.ranges && (oe.range = [Q.range[0], 0]), oe;
          }
          function Jt(Q, oe) {
            return Q.type = oe, Q.end = Ge, Y.locations && (Q.loc.end = et), Y.ranges && (Q.range[1] = Ge), Q;
          }
          function Ln(Q) {
            return Y.ecmaVersion >= 5 && Q.type === "ExpressionStatement" && Q.expression.type === "Literal" && Q.expression.value === "use strict";
          }
          function _i(Q) {
            if (se === Q)
              return ei(), !0;
          }
          function Ei() {
            return !Y.strictSemicolons && (se === Ht || se === bn || w.test(k.slice(Ge, ie)));
          }
          function Bn() {
            !_i(rn) && !Ei() && un();
          }
          function di(Q) {
            se === Q ? ei() : un();
          }
          function un() {
            Fe(ie, "Unexpected token");
          }
          function Fr(Q) {
            Q.type !== "Identifier" && Q.type !== "MemberExpression" && Fe(Q.start, "Assigning to rvalue"), Re && Q.type === "Identifier" && Ar(Q.name) && Fe(Q.start, "Assigning to " + Q.name + " in strict mode");
          }
          function Js(Q) {
            Ae = Ge = H, Y.locations && (et = new ge()), st = Re = null, _t = [], an();
            var oe = Q || Ai(), Me = !0;
            for (Q || (oe.body = []); se !== Ht; ) {
              var Be = Ji();
              oe.body.push(Be), Me && Ln(Be) && Zn(!0), Me = !1;
            }
            return Jt(oe, "Program");
          }
          var Kr = { kind: "loop" }, Ur = { kind: "switch" };
          function Ji() {
            (se === wr || se === g && de == "/=") && an(!0);
            var Q = se, oe = Ai();
            switch (Q) {
              case jt:
              case ki:
                ei();
                var Me = Q === jt;
                _i(rn) || Ei() ? oe.label = null : se !== It ? un() : (oe.label = Ze(), Bn());
                for (var Be = 0; Be < _t.length; ++Be) {
                  var ht = _t[Be];
                  if ((oe.label == null || ht.name === oe.label.name) && (ht.kind != null && (Me || ht.kind === "loop") || oe.label && Me))
                    break;
                }
                return Be === _t.length && Fe(oe.start, "Unsyntactic " + Q.keyword), Jt(oe, Me ? "BreakStatement" : "ContinueStatement");
              case Li:
                return ei(), Bn(), Jt(oe, "DebuggerStatement");
              case si:
                return ei(), _t.push(Kr), oe.body = Ji(), _t.pop(), di(Ki), oe.test = Pn(), Bn(), Jt(oe, "DoWhileStatement");
              case ci:
                if (ei(), _t.push(Kr), di(sn), se === rn)
                  return tr(oe, null);
                if (se === _n) {
                  var gt = Ai();
                  return ei(), $n(gt, !0), Jt(gt, "VariableDeclaration"), gt.declarations.length === 1 && _i(Vn) ? Vr(oe, gt) : tr(oe, gt);
                }
                var gt = Ri(!1, !0);
                return _i(Vn) ? (Fr(gt), Vr(oe, gt)) : tr(oe, gt);
              case nn:
                return ei(), Tt(oe, !0);
              case Yi:
                return ei(), oe.test = Pn(), oe.consequent = Ji(), oe.alternate = _i(Nt) ? Ji() : null, Jt(oe, "IfStatement");
              case qi:
                return !st && !Y.allowReturnOutsideFunction && Fe(ie, "'return' outside of function"), ei(), _i(rn) || Ei() ? oe.argument = null : (oe.argument = Ri(), Bn()), Jt(oe, "ReturnStatement");
              case Qi:
                ei(), oe.discriminant = Pn(), oe.cases = [], di(dn), _t.push(Ur);
                for (var Mt, Wt; se != bn; )
                  if (se === Vt || se === bi) {
                    var xi = se === Vt;
                    Mt && Jt(Mt, "SwitchCase"), oe.cases.push(Mt = Ai()), Mt.consequent = [], ei(), xi ? Mt.test = Ri() : (Wt && Fe(Ae, "Multiple default clauses"), Wt = !0, Mt.test = null), di(On);
                  } else
                    Mt || un(), Mt.consequent.push(Ji());
                return Mt && Jt(Mt, "SwitchCase"), ei(), _t.pop(), Jt(oe, "SwitchStatement");
              case Gi:
                return ei(), w.test(k.slice(Ge, ie)) && Fe(Ge, "Illegal newline after throw"), oe.argument = Ri(), Bn(), Jt(oe, "ThrowStatement");
              case Xi:
                if (ei(), oe.block = hr(), oe.handler = null, se === Ti) {
                  var ji = Ai();
                  ei(), di(sn), ji.param = Ze(), Re && Ar(ji.param.name) && Fe(ji.param.start, "Binding " + ji.param.name + " in strict mode"), di(ri), ji.guard = null, ji.body = hr(), oe.handler = Jt(ji, "CatchClause");
                }
                return oe.guardedHandlers = at, oe.finalizer = _i(Vi) ? hr() : null, !oe.handler && !oe.finalizer && Fe(oe.start, "Missing catch or finally clause"), Jt(oe, "TryStatement");
              case _n:
                return ei(), $n(oe), Bn(), Jt(oe, "VariableDeclaration");
              case Ki:
                return ei(), oe.test = Pn(), _t.push(Kr), oe.body = Ji(), _t.pop(), Jt(oe, "WhileStatement");
              case cn:
                return Re && Fe(ie, "'with' in strict mode"), ei(), oe.object = Pn(), oe.body = Ji(), Jt(oe, "WithStatement");
              case dn:
                return hr();
              case rn:
                return ei(), Jt(oe, "EmptyStatement");
              default:
                var Nn = de, mn = Ri();
                if (Q === It && mn.type === "Identifier" && _i(On)) {
                  for (var Be = 0; Be < _t.length; ++Be)
                    _t[Be].name === Nn && Fe(mn.start, "Label '" + Nn + "' is already declared");
                  var _r = se.isLoop ? "loop" : se === Qi ? "switch" : null;
                  return _t.push({ name: Nn, kind: _r }), oe.body = Ji(), _t.pop(), oe.label = mn, Jt(oe, "LabeledStatement");
                } else
                  return oe.expression = mn, Bn(), Jt(oe, "ExpressionStatement");
            }
          }
          function Pn() {
            di(sn);
            var Q = Ri();
            return di(ri), Q;
          }
          function hr(Q) {
            var oe = Ai(), Me = !0, Be = !1, ht;
            for (oe.body = [], di(dn); !_i(bn); ) {
              var gt = Ji();
              oe.body.push(gt), Me && Q && Ln(gt) && (ht = Be, Zn(Be = !0)), Me = !1;
            }
            return Be && !ht && Zn(!1), Jt(oe, "BlockStatement");
          }
          function tr(Q, oe) {
            return Q.init = oe, di(rn), Q.test = se === rn ? null : Ri(), di(rn), Q.update = se === ri ? null : Ri(), di(ri), Q.body = Ji(), _t.pop(), Jt(Q, "ForStatement");
          }
          function Vr(Q, oe) {
            return Q.left = oe, Q.right = Ri(), di(ri), Q.body = Ji(), _t.pop(), Jt(Q, "ForInStatement");
          }
          function $n(Q, oe) {
            for (Q.declarations = [], Q.kind = "var"; ; ) {
              var Me = Ai();
              if (Me.id = Ze(), Re && Ar(Me.id.name) && Fe(Me.id.start, "Binding " + Me.id.name + " in strict mode"), Me.init = _i(Sr) ? Ri(!0, oe) : null, Q.declarations.push(Jt(Me, "VariableDeclarator")), !_i(gn))
                break;
            }
            return Q;
          }
          function Ri(Q, oe) {
            var Me = hs(oe);
            if (!Q && se === gn) {
              var Be = hn(Me);
              for (Be.expressions = [Me]; _i(gn); )
                Be.expressions.push(hs(oe));
              return Jt(Be, "SequenceExpression");
            }
            return Me;
          }
          function hs(Q) {
            var oe = ys(Q);
            if (se.isAssign) {
              var Me = hn(oe);
              return Me.operator = de, Me.left = oe, ei(), Me.right = hs(Q), Fr(oe), Jt(Me, "AssignmentExpression");
            }
            return oe;
          }
          function ys(Q) {
            var oe = Ls(Q);
            if (_i(Nr)) {
              var Me = hn(oe);
              return Me.test = oe, Me.consequent = Ri(!0), di(On), Me.alternate = Ri(!0, Q), Jt(Me, "ConditionalExpression");
            }
            return oe;
          }
          function Ls(Q) {
            return Jn(zn(), -1, Q);
          }
          function Jn(Q, oe, Me) {
            var Be = se.binop;
            if (Be != null && (!Me || se !== Vn) && Be > oe) {
              var ht = hn(Q);
              ht.left = Q, ht.operator = de;
              var gt = se;
              ei(), ht.right = Jn(zn(), Be, Me);
              var Mt = Jt(ht, gt === ye || gt === Ie ? "LogicalExpression" : "BinaryExpression");
              return Jn(Mt, oe, Me);
            }
            return Q;
          }
          function zn() {
            if (se.prefix) {
              var Q = Ai(), oe = se.isUpdate;
              return Q.operator = de, Q.prefix = !0, ve = !0, ei(), Q.argument = zn(), oe ? Fr(Q.argument) : Re && Q.operator === "delete" && Q.argument.type === "Identifier" && Fe(Q.start, "Deleting local variable in strict mode"), Jt(Q, oe ? "UpdateExpression" : "UnaryExpression");
            }
            for (var Me = bs(); se.postfix && !Ei(); ) {
              var Q = hn(Me);
              Q.operator = de, Q.prefix = !1, Q.argument = Me, Fr(Me), ei(), Me = Jt(Q, "UpdateExpression");
            }
            return Me;
          }
          function bs() {
            return ur(Oe());
          }
          function ur(Q, oe) {
            if (_i(pr)) {
              var Me = hn(Q);
              return Me.object = Q, Me.property = Ze(!0), Me.computed = !1, ur(Jt(Me, "MemberExpression"), oe);
            } else if (_i(Hn)) {
              var Me = hn(Q);
              return Me.object = Q, Me.property = Ri(), Me.computed = !0, di(fn), ur(Jt(Me, "MemberExpression"), oe);
            } else if (!oe && _i(sn)) {
              var Me = hn(Q);
              return Me.callee = Q, Me.arguments = Ne(ri, !1), ur(Jt(Me, "CallExpression"), oe);
            } else
              return Q;
          }
          function Oe() {
            switch (se) {
              case $r:
                var Be = Ai();
                return ei(), Jt(Be, "ThisExpression");
              case It:
                return Ze();
              case yt:
              case Rt:
              case bt:
                var Be = Ai();
                return Be.value = de, Be.raw = k.slice(ie, ae), ei(), Jt(Be, "Literal");
              case Pr:
              case An:
              case Xr:
                var Be = Ai();
                return Be.value = se.atomValue, Be.raw = se.keyword, ei(), Jt(Be, "Literal");
              case sn:
                var Q = ue, oe = ie;
                ei();
                var Me = Ri();
                return Me.start = oe, Me.end = ae, Y.locations && (Me.loc.start = Q, Me.loc.end = me), Y.ranges && (Me.range = [oe, ae]), di(ri), Me;
              case Hn:
                var Be = Ai();
                return ei(), Be.elements = Ne(fn, !0, !0), Jt(Be, "ArrayExpression");
              case dn:
                return mt();
              case nn:
                var Be = Ai();
                return ei(), Tt(Be, !1);
              case Cn:
                return Ke();
              default:
                un();
            }
          }
          function Ke() {
            var Q = Ai();
            return ei(), Q.callee = ur(Oe(), !0), _i(sn) ? Q.arguments = Ne(ri, !1) : Q.arguments = at, Jt(Q, "NewExpression");
          }
          function mt() {
            var Q = Ai(), oe = !0, Me = !1;
            for (Q.properties = [], ei(); !_i(bn); ) {
              if (oe)
                oe = !1;
              else if (di(gn), Y.allowTrailingCommas && _i(bn))
                break;
              var Be = { key: St() }, ht = !1, gt;
              if (_i(On) ? (Be.value = Ri(!0), gt = Be.kind = "init") : Y.ecmaVersion >= 5 && Be.key.type === "Identifier" && (Be.key.name === "get" || Be.key.name === "set") ? (ht = Me = !0, gt = Be.kind = Be.key.name, Be.key = St(), se !== sn && un(), Be.value = Tt(Ai(), !1)) : un(), Be.key.type === "Identifier" && (Re || Me))
                for (var Mt = 0; Mt < Q.properties.length; ++Mt) {
                  var Wt = Q.properties[Mt];
                  if (Wt.key.name === Be.key.name) {
                    var xi = gt == Wt.kind || ht && Wt.kind === "init" || gt === "init" && (Wt.kind === "get" || Wt.kind === "set");
                    xi && !Re && gt === "init" && Wt.kind === "init" && (xi = !1), xi && Fe(Be.key.start, "Redefinition of property");
                  }
                }
              Q.properties.push(Be);
            }
            return Jt(Q, "ObjectExpression");
          }
          function St() {
            return se === yt || se === Rt ? Oe() : Ze(!0);
          }
          function Tt(Q, oe) {
            se === It ? Q.id = Ze() : oe ? un() : Q.id = null, Q.params = [];
            var Me = !0;
            for (di(sn); !_i(ri); )
              Me ? Me = !1 : di(gn), Q.params.push(Ze());
            var Be = st, ht = _t;
            if (st = !0, _t = [], Q.body = hr(!0), st = Be, _t = ht, Re || Q.body.body.length && Ln(Q.body.body[0]))
              for (var gt = Q.id ? -1 : 0; gt < Q.params.length; ++gt) {
                var Mt = gt < 0 ? Q.id : Q.params[gt];
                if ((or(Mt.name) || Ar(Mt.name)) && Fe(Mt.start, "Defining '" + Mt.name + "' in strict mode"), gt >= 0)
                  for (var Wt = 0; Wt < gt; ++Wt)
                    Mt.name === Q.params[Wt].name && Fe(Mt.start, "Argument name clash in strict mode");
              }
            return Jt(Q, oe ? "FunctionDeclaration" : "FunctionExpression");
          }
          function Ne(Q, oe, Me) {
            for (var Be = [], ht = !0; !_i(Q); ) {
              if (ht)
                ht = !1;
              else if (di(gn), oe && Y.allowTrailingCommas && _i(Q))
                break;
              Me && se === gn ? Be.push(null) : Be.push(Ri(!0));
            }
            return Be;
          }
          function Ze(Q) {
            var oe = Ai();
            return Q && Y.forbidReserved == "everywhere" && (Q = !1), se === It ? (!Q && (Y.forbidReserved && (Y.ecmaVersion === 3 ? Mr : Cr)(de) || Re && or(de)) && k.slice(ie, ae).indexOf("\\") == -1 && Fe(ie, "The keyword '" + de + "' is reserved"), oe.name = de) : Q && se.keyword ? oe.name = se.keyword : un(), ve = !1, ei(), Jt(oe, "Identifier");
          }
        }), r.version || (r = null);
      }
      function u(D, Y) {
        return (i.acorn || r).parse(D, Y);
      }
      var d = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, v = {
        "-": "__negate",
        "+": "__self"
      }, p = o.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(D) {
          this["__" + D] = "#" + D;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      M.inject(p), V.inject(p), Lt.inject(p);
      function b(D, Y, k) {
        var z = d[Y];
        if (D && D[z]) {
          var C = D[z](k);
          return Y === "!=" ? !C : C;
        }
        switch (Y) {
          case "+":
            return D + k;
          case "-":
            return D - k;
          case "*":
            return D * k;
          case "/":
            return D / k;
          case "%":
            return D % k;
          case "==":
            return D == k;
          case "!=":
            return D != k;
        }
      }
      function S(D, Y) {
        var k = v[D];
        if (Y && Y[k])
          return Y[k]();
        switch (D) {
          case "+":
            return +Y;
          case "-":
            return -Y;
        }
      }
      function L(D, Y) {
        if (!D)
          return "";
        Y = Y || {};
        var k = [];
        function z(Re) {
          for (var Fe = 0, at = k.length; Fe < at; Fe++) {
            var yt = k[Fe];
            if (yt[0] >= Re)
              break;
            Re += yt[1];
          }
          return Re;
        }
        function C(Re) {
          return D.substring(
            z(Re.range[0]),
            z(Re.range[1])
          );
        }
        function O(Re, Fe) {
          return D.substring(
            z(Re.range[1]),
            z(Fe.range[0])
          );
        }
        function j(Re, Fe) {
          for (var at = z(Re.range[0]), yt = z(Re.range[1]), bt = 0, Rt = k.length - 1; Rt >= 0; Rt--)
            if (at > k[Rt][0]) {
              bt = Rt + 1;
              break;
            }
          k.splice(bt, 0, [at, Fe.length - yt + at]), D = D.substring(0, at) + Fe + D.substring(yt);
        }
        function q(Re, Fe) {
          switch (Re.type) {
            case "UnaryExpression":
              if (Re.operator in v && Re.argument.type !== "Literal") {
                var at = C(Re.argument);
                j(Re, '$__("' + Re.operator + '", ' + at + ")");
              }
              break;
            case "BinaryExpression":
              if (Re.operator in d && Re.left.type !== "Literal") {
                var yt = C(Re.left), bt = C(Re.right), Rt = O(Re.left, Re.right), It = Re.operator;
                j(Re, "__$__(" + yt + "," + Rt.replace(
                  new RegExp("\\" + It),
                  '"' + It + '"'
                ) + ", " + bt + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var Ht = Fe && Fe.type;
              if (!(Ht === "ForStatement" || Ht === "BinaryExpression" && /^[=!<>]/.test(Fe.operator) || Ht === "MemberExpression" && Fe.computed)) {
                if (Re.type === "UpdateExpression") {
                  var at = C(Re.argument), jt = "__$__(" + at + ', "' + Re.operator[0] + '", 1)', Vt = at + " = " + jt;
                  Re.prefix ? Vt = "(" + Vt + ")" : (Ht === "AssignmentExpression" || Ht === "VariableDeclarator" || Ht === "BinaryExpression") && (C(Fe.left || Fe.id) === at && (Vt = jt), Vt = at + "; " + Vt), j(Re, Vt);
                } else if (/^.=$/.test(Re.operator) && Re.left.type !== "Literal") {
                  var yt = C(Re.left), bt = C(Re.right), jt = yt + " = __$__(" + yt + ', "' + Re.operator[0] + '", ' + bt + ")";
                  j(Re, /^\(.*\)$/.test(C(Re)) ? "(" + jt + ")" : jt);
                }
              }
              break;
          }
        }
        function H(Re) {
          switch (Re.type) {
            case "ExportDefaultDeclaration":
              j({
                range: [Re.start, Re.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var Fe = Re.declaration, at = Re.specifiers;
              if (Fe) {
                var yt = Fe.declarations;
                yt && (yt.forEach(function(Rt) {
                  j(Rt, "module.exports." + C(Rt));
                }), j({
                  range: [
                    Re.start,
                    Fe.start + Fe.kind.length
                  ]
                }, ""));
              } else if (at) {
                var bt = at.map(function(Rt) {
                  var It = C(Rt);
                  return "module.exports." + It + " = " + It + "; ";
                }).join("");
                bt && j(Re, bt);
              }
              break;
          }
        }
        function ie(Re, Fe, at) {
          if (Re) {
            for (var yt in Re)
              if (yt !== "range" && yt !== "loc") {
                var bt = Re[yt];
                if (Array.isArray(bt))
                  for (var Rt = 0, It = bt.length; Rt < It; Rt++)
                    ie(bt[Rt], Re, at);
                else
                  bt && typeof bt == "object" && ie(bt, Re, at);
              }
            at.operatorOverloading !== !1 && q(Re, Fe), at.moduleExports !== !1 && H(Re);
          }
        }
        function ae(Re) {
          var Fe = "", at = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (Re = (Math.abs(Re) << 1) + (Re < 0 ? 1 : 0); Re || !Fe; ) {
            var yt = Re & 31;
            Re >>= 5, Re && (yt |= 32), Fe += at[yt];
          }
          return Fe;
        }
        var ue = Y.url || "", me = Y.sourceMaps, se = Y.paperFeatures || {}, de = Y.source || D, ve = Y.offset || 0, we = Ye.agent, Se = we.versionNumber, Ae = !1, Ge = /\r\n|\n|\r/mg, et;
        if (me && (we.chrome && Se >= 30 || we.webkit && Se >= 537.76 || we.firefox && Se >= 23 || we.node)) {
          if (we.node)
            ve -= 2;
          else if (n && ue && !n.location.href.indexOf(ue)) {
            var st = s.getElementsByTagName("html")[0].innerHTML;
            ve = st.substr(0, st.indexOf(D) + 1).match(
              Ge
            ).length + 1;
          }
          Ae = ve > 0 && !(we.chrome && Se >= 36 || we.safari && Se >= 600 || we.firefox && Se >= 40 || we.node);
          var _t = ["AA" + ae(Ae ? 0 : ve) + "A"];
          _t.length = (D.match(Ge) || []).length + 1 + (Ae ? ve : 0), et = {
            version: 3,
            file: ue,
            names: [],
            mappings: _t.join(";AACA"),
            sourceRoot: "",
            sources: [ue],
            sourcesContent: [de]
          };
        }
        return (se.operatorOverloading !== !1 || se.moduleExports !== !1) && ie(u(D, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, se), et && (Ae && (D = new Array(ve + 1).join(`
`) + D), /^(inline|both)$/.test(me) && (D += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
          JSON.stringify(et)
        )))), D += `
//# sourceURL=` + (ue || "paperscript")), {
          url: ue,
          source: de,
          code: D,
          map: et
        };
      }
      function E(D, Y, k) {
        Ye = Y;
        var z = Y.getView(), C = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(D) && !/\bnew\s+Tool\b/.test(D) ? new ke() : null, O = C ? C._events : [], j = ["onFrame", "onResize"].concat(O), q = [], H = [], ie, ae = typeof D == "object" ? D : L(D, k);
        D = ae.code;
        function ue(Se, Ae) {
          for (var Ge in Se)
            (Ae || !/^_/.test(Ge)) && new RegExp("([\\b\\s\\W]|^)" + Ge.replace(/\$/g, "\\$") + "\\b").test(D) && (q.push(Ge), H.push(Se[Ge]));
        }
        ue(
          { __$__: b, $__: S, paper: Y, tool: C },
          !0
        ), ue(Y), D = "var module = { exports: {} }; " + D;
        var ve = o.each(j, function(Se) {
          new RegExp("\\s+" + Se + "\\b").test(D) && (q.push(Se), this.push("module.exports." + Se + " = " + Se + ";"));
        }, []).join(`
`);
        ve && (D += `
` + ve), D += `
return module.exports;`;
        var me = Ye.agent;
        if (s && (me.chrome || me.firefox && me.versionNumber < 40)) {
          var se = s.createElement("script"), de = s.head || s.getElementsByTagName("head")[0];
          me.firefox && (D = `
` + D), se.appendChild(s.createTextNode(
            "document.__paperscript__ = function(" + q + ") {" + D + `
}`
          )), de.appendChild(se), ie = s.__paperscript__, delete s.__paperscript__, de.removeChild(se);
        } else
          ie = Function(q, D);
        var ve = ie && ie.apply(Y, H), we = ve || {};
        return o.each(O, function(Se) {
          var Ae = we[Se];
          Ae && (C[Se] = Ae);
        }), z && (we.onResize && z.setOnResize(we.onResize), z.emit("resize", {
          size: z.size,
          delta: new M()
        }), we.onFrame && z.setOnFrame(we.onFrame), z.requestUpdate()), ve;
      }
      function A(D) {
        if (/^text\/(?:x-|)paperscript$/.test(D.type) && c.getAttribute(D, "ignore") !== "true") {
          var Y = c.getAttribute(D, "canvas"), k = s.getElementById(Y), z = D.src || D.getAttribute("data-src"), C = c.hasAttribute(D, "async"), O = "data-paper-scope";
          if (!k)
            throw new Error('Unable to find canvas with id "' + Y + '"');
          var j = c.get(k.getAttribute(O)) || new c().setup(k);
          return k.setAttribute(O, j._id), z ? kt.request({
            url: z,
            async: C,
            mimeType: "text/plain",
            onLoad: function(q) {
              E(q, j, z);
            }
          }) : E(D.innerHTML, j, D.baseURI), D.setAttribute("data-paper-ignore", "true"), j;
        }
      }
      function T() {
        o.each(
          s && s.getElementsByTagName("script"),
          A
        );
      }
      function G(D) {
        return D ? A(D) : T();
      }
      return n && (s.readyState === "complete" ? setTimeout(T) : Xt.add(n, { load: T })), {
        compile: L,
        execute: E,
        load: G,
        parse: u,
        calculateBinary: b,
        calculateUnary: S
      };
    }).call(this);
    var Ye = new (c.inject(o.exports, {
      Base: o,
      Numerical: I,
      Key: xt,
      DomEvent: Xt,
      DomElement: Gt,
      document: s,
      window: n,
      Symbol: Le,
      PlacedSymbol: ft
    }))();
    return Ye.agent.node && td(Ye), typeof t == "function" && t.amd ? t("paper", Ye) : y && (y.exports = Ye), Ye;
  }).call(as, typeof self == "object" ? self : null);
})(bg);
var v1 = bg.exports;
const y1 = /* @__PURE__ */ pu(v1);
function b1(y) {
  if (y && !(typeof window > "u")) {
    var e = document.createElement("style");
    return e.setAttribute("type", "text/css"), e.innerHTML = y, document.head.appendChild(e), y;
  }
}
function La(y, e) {
  var t = y.__state.conversionName.toString(), n = Math.round(y.r), s = Math.round(y.g), o = Math.round(y.b), h = y.a, c = Math.round(y.h), m = y.s.toFixed(1), x = y.v.toFixed(1);
  if (e || t === "THREE_CHAR_HEX" || t === "SIX_CHAR_HEX") {
    for (var B = y.hex.toString(16); B.length < 6; )
      B = "0" + B;
    return "#" + B;
  } else {
    if (t === "CSS_RGB")
      return "rgb(" + n + "," + s + "," + o + ")";
    if (t === "CSS_RGBA")
      return "rgba(" + n + "," + s + "," + o + "," + h + ")";
    if (t === "HEX")
      return "0x" + y.hex.toString(16);
    if (t === "RGB_ARRAY")
      return "[" + n + "," + s + "," + o + "]";
    if (t === "RGBA_ARRAY")
      return "[" + n + "," + s + "," + o + "," + h + "]";
    if (t === "RGB_OBJ")
      return "{r:" + n + ",g:" + s + ",b:" + o + "}";
    if (t === "RGBA_OBJ")
      return "{r:" + n + ",g:" + s + ",b:" + o + ",a:" + h + "}";
    if (t === "HSV_OBJ")
      return "{h:" + c + ",s:" + m + ",v:" + x + "}";
    if (t === "HSVA_OBJ")
      return "{h:" + c + ",s:" + m + ",v:" + x + ",a:" + h + "}";
  }
  return "unknown format";
}
var nd = Array.prototype.forEach, Xa = Array.prototype.slice, Dt = {
  BREAK: {},
  extend: function(e) {
    return this.each(Xa.call(arguments, 1), function(t) {
      var n = this.isObject(t) ? Object.keys(t) : [];
      n.forEach((function(s) {
        this.isUndefined(t[s]) || (e[s] = t[s]);
      }).bind(this));
    }, this), e;
  },
  defaults: function(e) {
    return this.each(Xa.call(arguments, 1), function(t) {
      var n = this.isObject(t) ? Object.keys(t) : [];
      n.forEach((function(s) {
        this.isUndefined(e[s]) && (e[s] = t[s]);
      }).bind(this));
    }, this), e;
  },
  compose: function() {
    var e = Xa.call(arguments);
    return function() {
      for (var t = Xa.call(arguments), n = e.length - 1; n >= 0; n--)
        t = [e[n].apply(this, t)];
      return t[0];
    };
  },
  each: function(e, t, n) {
    if (e) {
      if (nd && e.forEach && e.forEach === nd)
        e.forEach(t, n);
      else if (e.length === e.length + 0) {
        var s = void 0, o = void 0;
        for (s = 0, o = e.length; s < o; s++)
          if (s in e && t.call(n, e[s], s) === this.BREAK)
            return;
      } else
        for (var h in e)
          if (t.call(n, e[h], h) === this.BREAK)
            return;
    }
  },
  defer: function(e) {
    setTimeout(e, 0);
  },
  debounce: function(e, t, n) {
    var s = void 0;
    return function() {
      var o = this, h = arguments;
      function c() {
        s = null, n || e.apply(o, h);
      }
      var m = n || !s;
      clearTimeout(s), s = setTimeout(c, t), m && e.apply(o, h);
    };
  },
  toArray: function(e) {
    return e.toArray ? e.toArray() : Xa.call(e);
  },
  isUndefined: function(e) {
    return e === void 0;
  },
  isNull: function(e) {
    return e === null;
  },
  isNaN: function(y) {
    function e(t) {
      return y.apply(this, arguments);
    }
    return e.toString = function() {
      return y.toString();
    }, e;
  }(function(y) {
    return isNaN(y);
  }),
  isArray: Array.isArray || function(y) {
    return y.constructor === Array;
  },
  isObject: function(e) {
    return e === Object(e);
  },
  isNumber: function(e) {
    return e === e + 0;
  },
  isString: function(e) {
    return e === e + "";
  },
  isBoolean: function(e) {
    return e === !1 || e === !0;
  },
  isFunction: function(e) {
    return e instanceof Function;
  }
}, x1 = [
  {
    litmus: Dt.isString,
    conversions: {
      THREE_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString() + t[1].toString() + t[2].toString() + t[2].toString() + t[3].toString() + t[3].toString(), 0)
          };
        },
        write: La
      },
      SIX_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9]{6})$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString(), 0)
          };
        },
        write: La
      },
      CSS_RGB: {
        read: function(e) {
          var t = e.match(/^rgb\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3])
          };
        },
        write: La
      },
      CSS_RGBA: {
        read: function(e) {
          var t = e.match(/^rgba\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3]),
            a: parseFloat(t[4])
          };
        },
        write: La
      }
    }
  },
  {
    litmus: Dt.isNumber,
    conversions: {
      HEX: {
        read: function(e) {
          return {
            space: "HEX",
            hex: e,
            conversionName: "HEX"
          };
        },
        write: function(e) {
          return e.hex;
        }
      }
    }
  },
  {
    litmus: Dt.isArray,
    conversions: {
      RGB_ARRAY: {
        read: function(e) {
          return e.length !== 3 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b];
        }
      },
      RGBA_ARRAY: {
        read: function(e) {
          return e.length !== 4 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2],
            a: e[3]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b, e.a];
        }
      }
    }
  },
  {
    litmus: Dt.isObject,
    conversions: {
      RGBA_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.r) && Dt.isNumber(e.g) && Dt.isNumber(e.b) && Dt.isNumber(e.a) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          };
        }
      },
      RGB_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.r) && Dt.isNumber(e.g) && Dt.isNumber(e.b) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b
          };
        }
      },
      HSVA_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.h) && Dt.isNumber(e.s) && Dt.isNumber(e.v) && Dt.isNumber(e.a) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          };
        }
      },
      HSV_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.h) && Dt.isNumber(e.s) && Dt.isNumber(e.v) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v
          };
        }
      }
    }
  }
], Ka = void 0, al = void 0, Kh = function() {
  al = !1;
  var e = arguments.length > 1 ? Dt.toArray(arguments) : arguments[0];
  return Dt.each(x1, function(t) {
    if (t.litmus(e))
      return Dt.each(t.conversions, function(n, s) {
        if (Ka = n.read(e), al === !1 && Ka !== !1)
          return al = Ka, Ka.conversionName = s, Ka.conversion = n, Dt.BREAK;
      }), Dt.BREAK;
  }), al;
}, rd = void 0, Tl = {
  hsv_to_rgb: function(e, t, n) {
    var s = Math.floor(e / 60) % 6, o = e / 60 - Math.floor(e / 60), h = n * (1 - t), c = n * (1 - o * t), m = n * (1 - (1 - o) * t), x = [[n, m, h], [c, n, h], [h, n, m], [h, c, n], [m, h, n], [n, h, c]][s];
    return {
      r: x[0] * 255,
      g: x[1] * 255,
      b: x[2] * 255
    };
  },
  rgb_to_hsv: function(e, t, n) {
    var s = Math.min(e, t, n), o = Math.max(e, t, n), h = o - s, c = void 0, m = void 0;
    if (o !== 0)
      m = h / o;
    else
      return {
        h: NaN,
        s: 0,
        v: 0
      };
    return e === o ? c = (t - n) / h : t === o ? c = 2 + (n - e) / h : c = 4 + (e - t) / h, c /= 6, c < 0 && (c += 1), {
      h: c * 360,
      s: m,
      v: o / 255
    };
  },
  rgb_to_hex: function(e, t, n) {
    var s = this.hex_with_component(0, 2, e);
    return s = this.hex_with_component(s, 1, t), s = this.hex_with_component(s, 0, n), s;
  },
  component_from_hex: function(e, t) {
    return e >> t * 8 & 255;
  },
  hex_with_component: function(e, t, n) {
    return n << (rd = t * 8) | e & ~(255 << rd);
  }
}, w1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
  return typeof y;
} : function(y) {
  return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
}, ms = function(y, e) {
  if (!(y instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, _s = function() {
  function y(e, t) {
    for (var n = 0; n < t.length; n++) {
      var s = t[n];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
    }
  }
  return function(e, t, n) {
    return t && y(e.prototype, t), n && y(e, n), e;
  };
}(), Zs = function y(e, t, n) {
  e === null && (e = Function.prototype);
  var s = Object.getOwnPropertyDescriptor(e, t);
  if (s === void 0) {
    var o = Object.getPrototypeOf(e);
    return o === null ? void 0 : y(o, t, n);
  } else {
    if ("value" in s)
      return s.value;
    var h = s.get;
    return h === void 0 ? void 0 : h.call(n);
  }
}, Xs = function(y, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  y.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: y,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(y, e) : y.__proto__ = e);
}, Ks = function(y, e) {
  if (!y)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : y;
}, er = function() {
  function y() {
    if (ms(this, y), this.__state = Kh.apply(this, arguments), this.__state === !1)
      throw new Error("Failed to interpret color arguments");
    this.__state.a = this.__state.a || 1;
  }
  return _s(y, [{
    key: "toString",
    value: function() {
      return La(this);
    }
  }, {
    key: "toHexString",
    value: function() {
      return La(this, !0);
    }
  }, {
    key: "toOriginal",
    value: function() {
      return this.__state.conversion.write(this);
    }
  }]), y;
}();
function Tu(y, e, t) {
  Object.defineProperty(y, e, {
    get: function() {
      return this.__state.space === "RGB" ? this.__state[e] : (er.recalculateRGB(this, e, t), this.__state[e]);
    },
    set: function(s) {
      this.__state.space !== "RGB" && (er.recalculateRGB(this, e, t), this.__state.space = "RGB"), this.__state[e] = s;
    }
  });
}
function Lu(y, e) {
  Object.defineProperty(y, e, {
    get: function() {
      return this.__state.space === "HSV" ? this.__state[e] : (er.recalculateHSV(this), this.__state[e]);
    },
    set: function(n) {
      this.__state.space !== "HSV" && (er.recalculateHSV(this), this.__state.space = "HSV"), this.__state[e] = n;
    }
  });
}
er.recalculateRGB = function(y, e, t) {
  if (y.__state.space === "HEX")
    y.__state[e] = Tl.component_from_hex(y.__state.hex, t);
  else if (y.__state.space === "HSV")
    Dt.extend(y.__state, Tl.hsv_to_rgb(y.__state.h, y.__state.s, y.__state.v));
  else
    throw new Error("Corrupted color state");
};
er.recalculateHSV = function(y) {
  var e = Tl.rgb_to_hsv(y.r, y.g, y.b);
  Dt.extend(y.__state, {
    s: e.s,
    v: e.v
  }), Dt.isNaN(e.h) ? Dt.isUndefined(y.__state.h) && (y.__state.h = 0) : y.__state.h = e.h;
};
er.COMPONENTS = ["r", "g", "b", "h", "s", "v", "hex", "a"];
Tu(er.prototype, "r", 2);
Tu(er.prototype, "g", 1);
Tu(er.prototype, "b", 0);
Lu(er.prototype, "h");
Lu(er.prototype, "s");
Lu(er.prototype, "v");
Object.defineProperty(er.prototype, "a", {
  get: function() {
    return this.__state.a;
  },
  set: function(e) {
    this.__state.a = e;
  }
});
Object.defineProperty(er.prototype, "hex", {
  get: function() {
    return this.__state.space !== "HEX" && (this.__state.hex = Tl.rgb_to_hex(this.r, this.g, this.b), this.__state.space = "HEX"), this.__state.hex;
  },
  set: function(e) {
    this.__state.space = "HEX", this.__state.hex = e;
  }
});
var ga = function() {
  function y(e, t) {
    ms(this, y), this.initialValue = e[t], this.domElement = document.createElement("div"), this.object = e, this.property = t, this.__onChange = void 0, this.__onFinishChange = void 0;
  }
  return _s(y, [{
    key: "onChange",
    value: function(t) {
      return this.__onChange = t, this;
    }
  }, {
    key: "onFinishChange",
    value: function(t) {
      return this.__onFinishChange = t, this;
    }
  }, {
    key: "setValue",
    value: function(t) {
      return this.object[this.property] = t, this.__onChange && this.__onChange.call(this, t), this.updateDisplay(), this;
    }
  }, {
    key: "getValue",
    value: function() {
      return this.object[this.property];
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this;
    }
  }, {
    key: "isModified",
    value: function() {
      return this.initialValue !== this.getValue();
    }
  }]), y;
}(), S1 = {
  HTMLEvents: ["change"],
  MouseEvents: ["click", "mousemove", "mousedown", "mouseup", "mouseover"],
  KeyboardEvents: ["keydown"]
}, xg = {};
Dt.each(S1, function(y, e) {
  Dt.each(y, function(t) {
    xg[t] = e;
  });
});
var M1 = /(\d+(\.\d+)?)px/;
function Cs(y) {
  if (y === "0" || Dt.isUndefined(y))
    return 0;
  var e = y.match(M1);
  return Dt.isNull(e) ? 0 : parseFloat(e[1]);
}
var Ct = {
  makeSelectable: function(e, t) {
    e === void 0 || e.style === void 0 || (e.onselectstart = t ? function() {
      return !1;
    } : function() {
    }, e.style.MozUserSelect = t ? "auto" : "none", e.style.KhtmlUserSelect = t ? "auto" : "none", e.unselectable = t ? "on" : "off");
  },
  makeFullscreen: function(e, t, n) {
    var s = n, o = t;
    Dt.isUndefined(o) && (o = !0), Dt.isUndefined(s) && (s = !0), e.style.position = "absolute", o && (e.style.left = 0, e.style.right = 0), s && (e.style.top = 0, e.style.bottom = 0);
  },
  fakeEvent: function(e, t, n, s) {
    var o = n || {}, h = xg[t];
    if (!h)
      throw new Error("Event type " + t + " not supported.");
    var c = document.createEvent(h);
    switch (h) {
      case "MouseEvents": {
        var m = o.x || o.clientX || 0, x = o.y || o.clientY || 0;
        c.initMouseEvent(
          t,
          o.bubbles || !1,
          o.cancelable || !0,
          window,
          o.clickCount || 1,
          0,
          0,
          m,
          x,
          !1,
          !1,
          !1,
          !1,
          0,
          null
        );
        break;
      }
      case "KeyboardEvents": {
        var B = c.initKeyboardEvent || c.initKeyEvent;
        Dt.defaults(o, {
          cancelable: !0,
          ctrlKey: !1,
          altKey: !1,
          shiftKey: !1,
          metaKey: !1,
          keyCode: void 0,
          charCode: void 0
        }), B(t, o.bubbles || !1, o.cancelable, window, o.ctrlKey, o.altKey, o.shiftKey, o.metaKey, o.keyCode, o.charCode);
        break;
      }
      default: {
        c.initEvent(t, o.bubbles || !1, o.cancelable || !0);
        break;
      }
    }
    Dt.defaults(c, s), e.dispatchEvent(c);
  },
  bind: function(e, t, n, s) {
    var o = s || !1;
    return e.addEventListener ? e.addEventListener(t, n, o) : e.attachEvent && e.attachEvent("on" + t, n), Ct;
  },
  unbind: function(e, t, n, s) {
    var o = s || !1;
    return e.removeEventListener ? e.removeEventListener(t, n, o) : e.detachEvent && e.detachEvent("on" + t, n), Ct;
  },
  addClass: function(e, t) {
    if (e.className === void 0)
      e.className = t;
    else if (e.className !== t) {
      var n = e.className.split(/ +/);
      n.indexOf(t) === -1 && (n.push(t), e.className = n.join(" ").replace(/^\s+/, "").replace(/\s+$/, ""));
    }
    return Ct;
  },
  removeClass: function(e, t) {
    if (t)
      if (e.className === t)
        e.removeAttribute("class");
      else {
        var n = e.className.split(/ +/), s = n.indexOf(t);
        s !== -1 && (n.splice(s, 1), e.className = n.join(" "));
      }
    else
      e.className = void 0;
    return Ct;
  },
  hasClass: function(e, t) {
    return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(e.className) || !1;
  },
  getWidth: function(e) {
    var t = getComputedStyle(e);
    return Cs(t["border-left-width"]) + Cs(t["border-right-width"]) + Cs(t["padding-left"]) + Cs(t["padding-right"]) + Cs(t.width);
  },
  getHeight: function(e) {
    var t = getComputedStyle(e);
    return Cs(t["border-top-width"]) + Cs(t["border-bottom-width"]) + Cs(t["padding-top"]) + Cs(t["padding-bottom"]) + Cs(t.height);
  },
  getOffset: function(e) {
    var t = e, n = { left: 0, top: 0 };
    if (t.offsetParent)
      do
        n.left += t.offsetLeft, n.top += t.offsetTop, t = t.offsetParent;
      while (t);
    return n;
  },
  isActive: function(e) {
    return e === document.activeElement && (e.type || e.href);
  }
}, wg = function(y) {
  Xs(e, y);
  function e(t, n) {
    ms(this, e);
    var s = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), o = s;
    s.__prev = s.getValue(), s.__checkbox = document.createElement("input"), s.__checkbox.setAttribute("type", "checkbox");
    function h() {
      o.setValue(!o.__prev);
    }
    return Ct.bind(s.__checkbox, "change", h, !1), s.domElement.appendChild(s.__checkbox), s.updateDisplay(), s;
  }
  return _s(e, [{
    key: "setValue",
    value: function(n) {
      var s = Zs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, n);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), this.__prev = this.getValue(), s;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this.getValue() === !0 ? (this.__checkbox.setAttribute("checked", "checked"), this.__checkbox.checked = !0, this.__prev = !0) : (this.__checkbox.checked = !1, this.__prev = !1), Zs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ga), C1 = function(y) {
  Xs(e, y);
  function e(t, n, s) {
    ms(this, e);
    var o = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = s, c = o;
    if (o.__select = document.createElement("select"), Dt.isArray(h)) {
      var m = {};
      Dt.each(h, function(x) {
        m[x] = x;
      }), h = m;
    }
    return Dt.each(h, function(x, B) {
      var I = document.createElement("option");
      I.innerHTML = B, I.setAttribute("value", x), c.__select.appendChild(I);
    }), o.updateDisplay(), Ct.bind(o.__select, "change", function() {
      var x = this.options[this.selectedIndex].value;
      c.setValue(x);
    }), o.domElement.appendChild(o.__select), o;
  }
  return _s(e, [{
    key: "setValue",
    value: function(n) {
      var s = Zs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, n);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), s;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return Ct.isActive(this.__select) ? this : (this.__select.value = this.getValue(), Zs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this));
    }
  }]), e;
}(ga), A1 = function(y) {
  Xs(e, y);
  function e(t, n) {
    ms(this, e);
    var s = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), o = s;
    function h() {
      o.setValue(o.__input.value);
    }
    function c() {
      o.__onFinishChange && o.__onFinishChange.call(o, o.getValue());
    }
    return s.__input = document.createElement("input"), s.__input.setAttribute("type", "text"), Ct.bind(s.__input, "keyup", h), Ct.bind(s.__input, "change", h), Ct.bind(s.__input, "blur", c), Ct.bind(s.__input, "keydown", function(m) {
      m.keyCode === 13 && this.blur();
    }), s.updateDisplay(), s.domElement.appendChild(s.__input), s;
  }
  return _s(e, [{
    key: "updateDisplay",
    value: function() {
      return Ct.isActive(this.__input) || (this.__input.value = this.getValue()), Zs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ga);
function sd(y) {
  var e = y.toString();
  return e.indexOf(".") > -1 ? e.length - e.indexOf(".") - 1 : 0;
}
var Sg = function(y) {
  Xs(e, y);
  function e(t, n, s) {
    ms(this, e);
    var o = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = s || {};
    return o.__min = h.min, o.__max = h.max, o.__step = h.step, Dt.isUndefined(o.__step) ? o.initialValue === 0 ? o.__impliedStep = 1 : o.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(o.initialValue)) / Math.LN10)) / 10 : o.__impliedStep = o.__step, o.__precision = sd(o.__impliedStep), o;
  }
  return _s(e, [{
    key: "setValue",
    value: function(n) {
      var s = n;
      return this.__min !== void 0 && s < this.__min ? s = this.__min : this.__max !== void 0 && s > this.__max && (s = this.__max), this.__step !== void 0 && s % this.__step !== 0 && (s = Math.round(s / this.__step) * this.__step), Zs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, s);
    }
  }, {
    key: "min",
    value: function(n) {
      return this.__min = n, this;
    }
  }, {
    key: "max",
    value: function(n) {
      return this.__max = n, this;
    }
  }, {
    key: "step",
    value: function(n) {
      return this.__step = n, this.__impliedStep = n, this.__precision = sd(n), this;
    }
  }]), e;
}(ga);
function T1(y, e) {
  var t = Math.pow(10, e);
  return Math.round(y * t) / t;
}
var Ll = function(y) {
  Xs(e, y);
  function e(t, n, s) {
    ms(this, e);
    var o = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n, s));
    o.__truncationSuspended = !1;
    var h = o, c = void 0;
    function m() {
      var Z = parseFloat(h.__input.value);
      Dt.isNaN(Z) || h.setValue(Z);
    }
    function x() {
      h.__onFinishChange && h.__onFinishChange.call(h, h.getValue());
    }
    function B() {
      x();
    }
    function I(Z) {
      var V = c - Z.clientY;
      h.setValue(h.getValue() + V * h.__impliedStep), c = Z.clientY;
    }
    function F() {
      Ct.unbind(window, "mousemove", I), Ct.unbind(window, "mouseup", F), x();
    }
    function M(Z) {
      Ct.bind(window, "mousemove", I), Ct.bind(window, "mouseup", F), c = Z.clientY;
    }
    return o.__input = document.createElement("input"), o.__input.setAttribute("type", "text"), Ct.bind(o.__input, "change", m), Ct.bind(o.__input, "blur", B), Ct.bind(o.__input, "mousedown", M), Ct.bind(o.__input, "keydown", function(Z) {
      Z.keyCode === 13 && (h.__truncationSuspended = !0, this.blur(), h.__truncationSuspended = !1, x());
    }), o.updateDisplay(), o.domElement.appendChild(o.__input), o;
  }
  return _s(e, [{
    key: "updateDisplay",
    value: function() {
      return this.__input.value = this.__truncationSuspended ? this.getValue() : T1(this.getValue(), this.__precision), Zs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(Sg);
function ad(y, e, t, n, s) {
  return n + (s - n) * ((y - e) / (t - e));
}
var Jh = function(y) {
  Xs(e, y);
  function e(t, n, s, o, h) {
    ms(this, e);
    var c = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n, { min: s, max: o, step: h })), m = c;
    c.__background = document.createElement("div"), c.__foreground = document.createElement("div"), Ct.bind(c.__background, "mousedown", x), Ct.bind(c.__background, "touchstart", F), Ct.addClass(c.__background, "slider"), Ct.addClass(c.__foreground, "slider-fg");
    function x(V) {
      document.activeElement.blur(), Ct.bind(window, "mousemove", B), Ct.bind(window, "mouseup", I), B(V);
    }
    function B(V) {
      V.preventDefault();
      var te = m.__background.getBoundingClientRect();
      return m.setValue(ad(V.clientX, te.left, te.right, m.__min, m.__max)), !1;
    }
    function I() {
      Ct.unbind(window, "mousemove", B), Ct.unbind(window, "mouseup", I), m.__onFinishChange && m.__onFinishChange.call(m, m.getValue());
    }
    function F(V) {
      V.touches.length === 1 && (Ct.bind(window, "touchmove", M), Ct.bind(window, "touchend", Z), M(V));
    }
    function M(V) {
      var te = V.touches[0].clientX, P = m.__background.getBoundingClientRect();
      m.setValue(ad(te, P.left, P.right, m.__min, m.__max));
    }
    function Z() {
      Ct.unbind(window, "touchmove", M), Ct.unbind(window, "touchend", Z), m.__onFinishChange && m.__onFinishChange.call(m, m.getValue());
    }
    return c.updateDisplay(), c.__background.appendChild(c.__foreground), c.domElement.appendChild(c.__background), c;
  }
  return _s(e, [{
    key: "updateDisplay",
    value: function() {
      var n = (this.getValue() - this.__min) / (this.__max - this.__min);
      return this.__foreground.style.width = n * 100 + "%", Zs(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(Sg), Mg = function(y) {
  Xs(e, y);
  function e(t, n, s) {
    ms(this, e);
    var o = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = o;
    return o.__button = document.createElement("div"), o.__button.innerHTML = s === void 0 ? "Fire" : s, Ct.bind(o.__button, "click", function(c) {
      return c.preventDefault(), h.fire(), !1;
    }), Ct.addClass(o.__button, "button"), o.domElement.appendChild(o.__button), o;
  }
  return _s(e, [{
    key: "fire",
    value: function() {
      this.__onChange && this.__onChange.call(this), this.getValue().call(this.object), this.__onFinishChange && this.__onFinishChange.call(this, this.getValue());
    }
  }]), e;
}(ga), Qh = function(y) {
  Xs(e, y);
  function e(t, n) {
    ms(this, e);
    var s = Ks(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n));
    s.__color = new er(s.getValue()), s.__temp = new er(0);
    var o = s;
    s.domElement = document.createElement("div"), Ct.makeSelectable(s.domElement, !1), s.__selector = document.createElement("div"), s.__selector.className = "selector", s.__saturation_field = document.createElement("div"), s.__saturation_field.className = "saturation-field", s.__field_knob = document.createElement("div"), s.__field_knob.className = "field-knob", s.__field_knob_border = "2px solid ", s.__hue_knob = document.createElement("div"), s.__hue_knob.className = "hue-knob", s.__hue_field = document.createElement("div"), s.__hue_field.className = "hue-field", s.__input = document.createElement("input"), s.__input.type = "text", s.__input_textShadow = "0 1px 1px ", Ct.bind(s.__input, "keydown", function(V) {
      V.keyCode === 13 && I.call(this);
    }), Ct.bind(s.__input, "blur", I), Ct.bind(s.__selector, "mousedown", function() {
      Ct.addClass(this, "drag").bind(window, "mouseup", function() {
        Ct.removeClass(o.__selector, "drag");
      });
    }), Ct.bind(s.__selector, "touchstart", function() {
      Ct.addClass(this, "drag").bind(window, "touchend", function() {
        Ct.removeClass(o.__selector, "drag");
      });
    });
    var h = document.createElement("div");
    Dt.extend(s.__selector.style, {
      width: "122px",
      height: "102px",
      padding: "3px",
      backgroundColor: "#222",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
    }), Dt.extend(s.__field_knob.style, {
      position: "absolute",
      width: "12px",
      height: "12px",
      border: s.__field_knob_border + (s.__color.v < 0.5 ? "#fff" : "#000"),
      boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
      borderRadius: "12px",
      zIndex: 1
    }), Dt.extend(s.__hue_knob.style, {
      position: "absolute",
      width: "15px",
      height: "2px",
      borderRight: "4px solid #fff",
      zIndex: 1
    }), Dt.extend(s.__saturation_field.style, {
      width: "100px",
      height: "100px",
      border: "1px solid #555",
      marginRight: "3px",
      display: "inline-block",
      cursor: "pointer"
    }), Dt.extend(h.style, {
      width: "100%",
      height: "100%",
      background: "none"
    }), od(h, "top", "rgba(0,0,0,0)", "#000"), Dt.extend(s.__hue_field.style, {
      width: "15px",
      height: "100px",
      border: "1px solid #555",
      cursor: "ns-resize",
      position: "absolute",
      top: "3px",
      right: "3px"
    }), B1(s.__hue_field), Dt.extend(s.__input.style, {
      outline: "none",
      textAlign: "center",
      color: "#fff",
      border: 0,
      fontWeight: "bold",
      textShadow: s.__input_textShadow + "rgba(0,0,0,0.7)"
    }), Ct.bind(s.__saturation_field, "mousedown", c), Ct.bind(s.__saturation_field, "touchstart", c), Ct.bind(s.__field_knob, "mousedown", c), Ct.bind(s.__field_knob, "touchstart", c), Ct.bind(s.__hue_field, "mousedown", m), Ct.bind(s.__hue_field, "touchstart", m);
    function c(V) {
      M(V), Ct.bind(window, "mousemove", M), Ct.bind(window, "touchmove", M), Ct.bind(window, "mouseup", x), Ct.bind(window, "touchend", x);
    }
    function m(V) {
      Z(V), Ct.bind(window, "mousemove", Z), Ct.bind(window, "touchmove", Z), Ct.bind(window, "mouseup", B), Ct.bind(window, "touchend", B);
    }
    function x() {
      Ct.unbind(window, "mousemove", M), Ct.unbind(window, "touchmove", M), Ct.unbind(window, "mouseup", x), Ct.unbind(window, "touchend", x), F();
    }
    function B() {
      Ct.unbind(window, "mousemove", Z), Ct.unbind(window, "touchmove", Z), Ct.unbind(window, "mouseup", B), Ct.unbind(window, "touchend", B), F();
    }
    function I() {
      var V = Kh(this.value);
      V !== !1 ? (o.__color.__state = V, o.setValue(o.__color.toOriginal())) : this.value = o.__color.toString();
    }
    function F() {
      o.__onFinishChange && o.__onFinishChange.call(o, o.__color.toOriginal());
    }
    s.__saturation_field.appendChild(h), s.__selector.appendChild(s.__field_knob), s.__selector.appendChild(s.__saturation_field), s.__selector.appendChild(s.__hue_field), s.__hue_field.appendChild(s.__hue_knob), s.domElement.appendChild(s.__input), s.domElement.appendChild(s.__selector), s.updateDisplay();
    function M(V) {
      V.type.indexOf("touch") === -1 && V.preventDefault();
      var te = o.__saturation_field.getBoundingClientRect(), P = V.touches && V.touches[0] || V, K = P.clientX, J = P.clientY, le = (K - te.left) / (te.right - te.left), fe = 1 - (J - te.top) / (te.bottom - te.top);
      return fe > 1 ? fe = 1 : fe < 0 && (fe = 0), le > 1 ? le = 1 : le < 0 && (le = 0), o.__color.v = fe, o.__color.s = le, o.setValue(o.__color.toOriginal()), !1;
    }
    function Z(V) {
      V.type.indexOf("touch") === -1 && V.preventDefault();
      var te = o.__hue_field.getBoundingClientRect(), P = V.touches && V.touches[0] || V, K = P.clientY, J = 1 - (K - te.top) / (te.bottom - te.top);
      return J > 1 ? J = 1 : J < 0 && (J = 0), o.__color.h = J * 360, o.setValue(o.__color.toOriginal()), !1;
    }
    return s;
  }
  return _s(e, [{
    key: "updateDisplay",
    value: function() {
      var n = Kh(this.getValue());
      if (n !== !1) {
        var s = !1;
        Dt.each(er.COMPONENTS, function(c) {
          if (!Dt.isUndefined(n[c]) && !Dt.isUndefined(this.__color.__state[c]) && n[c] !== this.__color.__state[c])
            return s = !0, {};
        }, this), s && Dt.extend(this.__color.__state, n);
      }
      Dt.extend(this.__temp.__state, this.__color.__state), this.__temp.a = 1;
      var o = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0, h = 255 - o;
      Dt.extend(this.__field_knob.style, {
        marginLeft: 100 * this.__color.s - 7 + "px",
        marginTop: 100 * (1 - this.__color.v) - 7 + "px",
        backgroundColor: this.__temp.toHexString(),
        border: this.__field_knob_border + "rgb(" + o + "," + o + "," + o + ")"
      }), this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + "px", this.__temp.s = 1, this.__temp.v = 1, od(this.__saturation_field, "left", "#fff", this.__temp.toHexString()), this.__input.value = this.__color.toString(), Dt.extend(this.__input.style, {
        backgroundColor: this.__color.toHexString(),
        color: "rgb(" + o + "," + o + "," + o + ")",
        textShadow: this.__input_textShadow + "rgba(" + h + "," + h + "," + h + ",.7)"
      });
    }
  }]), e;
}(ga), L1 = ["-moz-", "-o-", "-webkit-", "-ms-", ""];
function od(y, e, t, n) {
  y.style.background = "", Dt.each(L1, function(s) {
    y.style.cssText += "background: " + s + "linear-gradient(" + e + ", " + t + " 0%, " + n + " 100%); ";
  });
}
function B1(y) {
  y.style.background = "", y.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);", y.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", y.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", y.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", y.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
}
var k1 = {
  load: function(e, t) {
    var n = t || document, s = n.createElement("link");
    s.type = "text/css", s.rel = "stylesheet", s.href = e, n.getElementsByTagName("head")[0].appendChild(s);
  },
  inject: function(e, t) {
    var n = t || document, s = document.createElement("style");
    s.type = "text/css", s.innerHTML = e;
    var o = n.getElementsByTagName("head")[0];
    try {
      o.appendChild(s);
    } catch {
    }
  }
}, E1 = `<div id="dg-save" class="dg dialogue">

  Here's the new load parameter for your <code>GUI</code>'s constructor:

  <textarea id="dg-new-constructor"></textarea>

  <div id="dg-save-locally">

    <input id="dg-local-storage" type="checkbox"/> Automatically save
    values to <code>localStorage</code> on exit.

    <div id="dg-local-explain">The values saved to <code>localStorage</code> will
      override those passed to <code>dat.GUI</code>'s constructor. This makes it
      easier to work incrementally, but <code>localStorage</code> is fragile,
      and your friends may not see the same values you do.

    </div>

  </div>

</div>`, I1 = function(e, t) {
  var n = e[t];
  return Dt.isArray(arguments[2]) || Dt.isObject(arguments[2]) ? new C1(e, t, arguments[2]) : Dt.isNumber(n) ? Dt.isNumber(arguments[2]) && Dt.isNumber(arguments[3]) ? Dt.isNumber(arguments[4]) ? new Jh(e, t, arguments[2], arguments[3], arguments[4]) : new Jh(e, t, arguments[2], arguments[3]) : Dt.isNumber(arguments[4]) ? new Ll(e, t, { min: arguments[2], max: arguments[3], step: arguments[4] }) : new Ll(e, t, { min: arguments[2], max: arguments[3] }) : Dt.isString(n) ? new A1(e, t) : Dt.isFunction(n) ? new Mg(e, t, "") : Dt.isBoolean(n) ? new wg(e, t) : null;
};
function O1(y) {
  setTimeout(y, 1e3 / 60);
}
var P1 = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || O1, N1 = function() {
  function y() {
    ms(this, y), this.backgroundElement = document.createElement("div"), Dt.extend(this.backgroundElement.style, {
      backgroundColor: "rgba(0,0,0,0.8)",
      top: 0,
      left: 0,
      display: "none",
      zIndex: "1000",
      opacity: 0,
      WebkitTransition: "opacity 0.2s linear",
      transition: "opacity 0.2s linear"
    }), Ct.makeFullscreen(this.backgroundElement), this.backgroundElement.style.position = "fixed", this.domElement = document.createElement("div"), Dt.extend(this.domElement.style, {
      position: "fixed",
      display: "none",
      zIndex: "1001",
      opacity: 0,
      WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
      transition: "transform 0.2s ease-out, opacity 0.2s linear"
    }), document.body.appendChild(this.backgroundElement), document.body.appendChild(this.domElement);
    var e = this;
    Ct.bind(this.backgroundElement, "click", function() {
      e.hide();
    });
  }
  return _s(y, [{
    key: "show",
    value: function() {
      var t = this;
      this.backgroundElement.style.display = "block", this.domElement.style.display = "block", this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)", this.layout(), Dt.defer(function() {
        t.backgroundElement.style.opacity = 1, t.domElement.style.opacity = 1, t.domElement.style.webkitTransform = "scale(1)";
      });
    }
  }, {
    key: "hide",
    value: function() {
      var t = this, n = function s() {
        t.domElement.style.display = "none", t.backgroundElement.style.display = "none", Ct.unbind(t.domElement, "webkitTransitionEnd", s), Ct.unbind(t.domElement, "transitionend", s), Ct.unbind(t.domElement, "oTransitionEnd", s);
      };
      Ct.bind(this.domElement, "webkitTransitionEnd", n), Ct.bind(this.domElement, "transitionend", n), Ct.bind(this.domElement, "oTransitionEnd", n), this.backgroundElement.style.opacity = 0, this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)";
    }
  }, {
    key: "layout",
    value: function() {
      this.domElement.style.left = window.innerWidth / 2 - Ct.getWidth(this.domElement) / 2 + "px", this.domElement.style.top = window.innerHeight / 2 - Ct.getHeight(this.domElement) / 2 + "px";
    }
  }]), y;
}(), R1 = b1(`.dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .cr.function .property-name{width:100%}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}
`);
k1.inject(R1);
var ld = "dg", hd = 72, ud = 20, po = "Default", eo = function() {
  try {
    return !!window.localStorage;
  } catch {
    return !1;
  }
}(), so = void 0, cd = !0, Aa = void 0, zh = !1, Cg = [], yn = function y(e) {
  var t = this, n = e || {};
  this.domElement = document.createElement("div"), this.__ul = document.createElement("ul"), this.domElement.appendChild(this.__ul), Ct.addClass(this.domElement, ld), this.__folders = {}, this.__controllers = [], this.__rememberedObjects = [], this.__rememberedObjectIndecesToControllers = [], this.__listening = [], n = Dt.defaults(n, {
    closeOnTop: !1,
    autoPlace: !0,
    width: y.DEFAULT_WIDTH
  }), n = Dt.defaults(n, {
    resizable: n.autoPlace,
    hideable: n.autoPlace
  }), Dt.isUndefined(n.load) ? n.load = { preset: po } : n.preset && (n.load.preset = n.preset), Dt.isUndefined(n.parent) && n.hideable && Cg.push(this), n.resizable = Dt.isUndefined(n.parent) && n.resizable, n.autoPlace && Dt.isUndefined(n.scrollable) && (n.scrollable = !0);
  var s = eo && localStorage.getItem(Ta(this, "isLocal")) === "true", o = void 0, h = void 0;
  if (Object.defineProperties(
    this,
    {
      parent: {
        get: function() {
          return n.parent;
        }
      },
      scrollable: {
        get: function() {
          return n.scrollable;
        }
      },
      autoPlace: {
        get: function() {
          return n.autoPlace;
        }
      },
      closeOnTop: {
        get: function() {
          return n.closeOnTop;
        }
      },
      preset: {
        get: function() {
          return t.parent ? t.getRoot().preset : n.load.preset;
        },
        set: function(F) {
          t.parent ? t.getRoot().preset = F : n.load.preset = F, U1(this), t.revert();
        }
      },
      width: {
        get: function() {
          return n.width;
        },
        set: function(F) {
          n.width = F, iu(t, F);
        }
      },
      name: {
        get: function() {
          return n.name;
        },
        set: function(F) {
          n.name = F, h && (h.innerHTML = n.name);
        }
      },
      closed: {
        get: function() {
          return n.closed;
        },
        set: function(F) {
          n.closed = F, n.closed ? Ct.addClass(t.__ul, y.CLASS_CLOSED) : Ct.removeClass(t.__ul, y.CLASS_CLOSED), this.onResize(), t.__closeButton && (t.__closeButton.innerHTML = F ? y.TEXT_OPEN : y.TEXT_CLOSED);
        }
      },
      load: {
        get: function() {
          return n.load;
        }
      },
      useLocalStorage: {
        get: function() {
          return s;
        },
        set: function(F) {
          eo && (s = F, F ? Ct.bind(window, "unload", o) : Ct.unbind(window, "unload", o), localStorage.setItem(Ta(t, "isLocal"), F));
        }
      }
    }
  ), Dt.isUndefined(n.parent)) {
    if (this.closed = n.closed || !1, Ct.addClass(this.domElement, y.CLASS_MAIN), Ct.makeSelectable(this.domElement, !1), eo && s) {
      t.useLocalStorage = !0;
      var c = localStorage.getItem(Ta(this, "gui"));
      c && (n.load = JSON.parse(c));
    }
    this.__closeButton = document.createElement("div"), this.__closeButton.innerHTML = y.TEXT_CLOSED, Ct.addClass(this.__closeButton, y.CLASS_CLOSE_BUTTON), n.closeOnTop ? (Ct.addClass(this.__closeButton, y.CLASS_CLOSE_TOP), this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0])) : (Ct.addClass(this.__closeButton, y.CLASS_CLOSE_BOTTOM), this.domElement.appendChild(this.__closeButton)), Ct.bind(this.__closeButton, "click", function() {
      t.closed = !t.closed;
    });
  } else {
    n.closed === void 0 && (n.closed = !0);
    var m = document.createTextNode(n.name);
    Ct.addClass(m, "controller-name"), h = Bu(t, m);
    var x = function(F) {
      return F.preventDefault(), t.closed = !t.closed, !1;
    };
    Ct.addClass(this.__ul, y.CLASS_CLOSED), Ct.addClass(h, "title"), Ct.bind(h, "click", x), n.closed || (this.closed = !1);
  }
  n.autoPlace && (Dt.isUndefined(n.parent) && (cd && (Aa = document.createElement("div"), Ct.addClass(Aa, ld), Ct.addClass(Aa, y.CLASS_AUTO_PLACE_CONTAINER), document.body.appendChild(Aa), cd = !1), Aa.appendChild(this.domElement), Ct.addClass(this.domElement, y.CLASS_AUTO_PLACE)), this.parent || iu(t, n.width)), this.__resizeHandler = function() {
    t.onResizeDebounced();
  }, Ct.bind(window, "resize", this.__resizeHandler), Ct.bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler), Ct.bind(this.__ul, "transitionend", this.__resizeHandler), Ct.bind(this.__ul, "oTransitionEnd", this.__resizeHandler), this.onResize(), n.resizable && F1(this), o = function() {
    eo && localStorage.getItem(Ta(t, "isLocal")) === "true" && localStorage.setItem(Ta(t, "gui"), JSON.stringify(t.getSaveObject()));
  }, this.saveToLocalStorageIfPossible = o;
  function B() {
    var I = t.getRoot();
    I.width += 1, Dt.defer(function() {
      I.width -= 1;
    });
  }
  n.parent || B();
};
yn.toggleHide = function() {
  zh = !zh, Dt.each(Cg, function(y) {
    y.domElement.style.display = zh ? "none" : "";
  });
};
yn.CLASS_AUTO_PLACE = "a";
yn.CLASS_AUTO_PLACE_CONTAINER = "ac";
yn.CLASS_MAIN = "main";
yn.CLASS_CONTROLLER_ROW = "cr";
yn.CLASS_TOO_TALL = "taller-than-window";
yn.CLASS_CLOSED = "closed";
yn.CLASS_CLOSE_BUTTON = "close-button";
yn.CLASS_CLOSE_TOP = "close-top";
yn.CLASS_CLOSE_BOTTOM = "close-bottom";
yn.CLASS_DRAG = "drag";
yn.DEFAULT_WIDTH = 245;
yn.TEXT_CLOSED = "Close Controls";
yn.TEXT_OPEN = "Open Controls";
yn._keydownHandler = function(y) {
  document.activeElement.type !== "text" && (y.which === hd || y.keyCode === hd) && yn.toggleHide();
};
Ct.bind(window, "keydown", yn._keydownHandler, !1);
Dt.extend(
  yn.prototype,
  {
    add: function(e, t) {
      return ao(this, e, t, {
        factoryArgs: Array.prototype.slice.call(arguments, 2)
      });
    },
    addColor: function(e, t) {
      return ao(this, e, t, {
        color: !0
      });
    },
    remove: function(e) {
      this.__ul.removeChild(e.__li), this.__controllers.splice(this.__controllers.indexOf(e), 1);
      var t = this;
      Dt.defer(function() {
        t.onResize();
      });
    },
    destroy: function() {
      if (this.parent)
        throw new Error("Only the root GUI should be removed with .destroy(). For subfolders, use gui.removeFolder(folder) instead.");
      this.autoPlace && Aa.removeChild(this.domElement);
      var e = this;
      Dt.each(this.__folders, function(t) {
        e.removeFolder(t);
      }), Ct.unbind(window, "keydown", yn._keydownHandler, !1), fd(this);
    },
    addFolder: function(e) {
      if (this.__folders[e] !== void 0)
        throw new Error('You already have a folder in this GUI by the name "' + e + '"');
      var t = { name: e, parent: this };
      t.autoPlace = this.autoPlace, this.load && this.load.folders && this.load.folders[e] && (t.closed = this.load.folders[e].closed, t.load = this.load.folders[e]);
      var n = new yn(t);
      this.__folders[e] = n;
      var s = Bu(this, n.domElement);
      return Ct.addClass(s, "folder"), n;
    },
    removeFolder: function(e) {
      this.__ul.removeChild(e.domElement.parentElement), delete this.__folders[e.name], this.load && this.load.folders && this.load.folders[e.name] && delete this.load.folders[e.name], fd(e);
      var t = this;
      Dt.each(e.__folders, function(n) {
        e.removeFolder(n);
      }), Dt.defer(function() {
        t.onResize();
      });
    },
    open: function() {
      this.closed = !1;
    },
    close: function() {
      this.closed = !0;
    },
    hide: function() {
      this.domElement.style.display = "none";
    },
    show: function() {
      this.domElement.style.display = "";
    },
    onResize: function() {
      var e = this.getRoot();
      if (e.scrollable) {
        var t = Ct.getOffset(e.__ul).top, n = 0;
        Dt.each(e.__ul.childNodes, function(s) {
          e.autoPlace && s === e.__save_row || (n += Ct.getHeight(s));
        }), window.innerHeight - t - ud < n ? (Ct.addClass(e.domElement, yn.CLASS_TOO_TALL), e.__ul.style.height = window.innerHeight - t - ud + "px") : (Ct.removeClass(e.domElement, yn.CLASS_TOO_TALL), e.__ul.style.height = "auto");
      }
      e.__resize_handle && Dt.defer(function() {
        e.__resize_handle.style.height = e.__ul.offsetHeight + "px";
      }), e.__closeButton && (e.__closeButton.style.width = e.width + "px");
    },
    onResizeDebounced: Dt.debounce(function() {
      this.onResize();
    }, 50),
    remember: function() {
      if (Dt.isUndefined(so) && (so = new N1(), so.domElement.innerHTML = E1), this.parent)
        throw new Error("You can only call remember on a top level GUI.");
      var e = this;
      Dt.each(Array.prototype.slice.call(arguments), function(t) {
        e.__rememberedObjects.length === 0 && z1(e), e.__rememberedObjects.indexOf(t) === -1 && e.__rememberedObjects.push(t);
      }), this.autoPlace && iu(this, this.width);
    },
    getRoot: function() {
      for (var e = this; e.parent; )
        e = e.parent;
      return e;
    },
    getSaveObject: function() {
      var e = this.load;
      return e.closed = this.closed, this.__rememberedObjects.length > 0 && (e.preset = this.preset, e.remembered || (e.remembered = {}), e.remembered[this.preset] = ol(this)), e.folders = {}, Dt.each(this.__folders, function(t, n) {
        e.folders[n] = t.getSaveObject();
      }), e;
    },
    save: function() {
      this.load.remembered || (this.load.remembered = {}), this.load.remembered[this.preset] = ol(this), eu(this, !1), this.saveToLocalStorageIfPossible();
    },
    saveAs: function(e) {
      this.load.remembered || (this.load.remembered = {}, this.load.remembered[po] = ol(this, !0)), this.load.remembered[e] = ol(this), this.preset = e, tu(this, e, !0), this.saveToLocalStorageIfPossible();
    },
    revert: function(e) {
      Dt.each(this.__controllers, function(t) {
        this.getRoot().load.remembered ? Ag(e || this.getRoot(), t) : t.setValue(t.initialValue), t.__onFinishChange && t.__onFinishChange.call(t, t.getValue());
      }, this), Dt.each(this.__folders, function(t) {
        t.revert(t);
      }), e || eu(this.getRoot(), !1);
    },
    listen: function(e) {
      var t = this.__listening.length === 0;
      this.__listening.push(e), t && Tg(this.__listening);
    },
    updateDisplay: function() {
      Dt.each(this.__controllers, function(e) {
        e.updateDisplay();
      }), Dt.each(this.__folders, function(e) {
        e.updateDisplay();
      });
    }
  }
);
function Bu(y, e, t) {
  var n = document.createElement("li");
  return e && n.appendChild(e), t ? y.__ul.insertBefore(n, t) : y.__ul.appendChild(n), y.onResize(), n;
}
function fd(y) {
  Ct.unbind(window, "resize", y.__resizeHandler), y.saveToLocalStorageIfPossible && Ct.unbind(window, "unload", y.saveToLocalStorageIfPossible);
}
function eu(y, e) {
  var t = y.__preset_select[y.__preset_select.selectedIndex];
  e ? t.innerHTML = t.value + "*" : t.innerHTML = t.value;
}
function D1(y, e, t) {
  if (t.__li = e, t.__gui = y, Dt.extend(t, {
    options: function(h) {
      if (arguments.length > 1) {
        var c = t.__li.nextElementSibling;
        return t.remove(), ao(y, t.object, t.property, {
          before: c,
          factoryArgs: [Dt.toArray(arguments)]
        });
      }
      if (Dt.isArray(h) || Dt.isObject(h)) {
        var m = t.__li.nextElementSibling;
        return t.remove(), ao(y, t.object, t.property, {
          before: m,
          factoryArgs: [h]
        });
      }
    },
    name: function(h) {
      return t.__li.firstElementChild.firstElementChild.innerHTML = h, t;
    },
    listen: function() {
      return t.__gui.listen(t), t;
    },
    remove: function() {
      return t.__gui.remove(t), t;
    }
  }), t instanceof Jh) {
    var n = new Ll(t.object, t.property, { min: t.__min, max: t.__max, step: t.__step });
    Dt.each(["updateDisplay", "onChange", "onFinishChange", "step", "min", "max"], function(o) {
      var h = t[o], c = n[o];
      t[o] = n[o] = function() {
        var m = Array.prototype.slice.call(arguments);
        return c.apply(n, m), h.apply(t, m);
      };
    }), Ct.addClass(e, "has-slider"), t.domElement.insertBefore(n.domElement, t.domElement.firstElementChild);
  } else if (t instanceof Ll) {
    var s = function(h) {
      if (Dt.isNumber(t.__min) && Dt.isNumber(t.__max)) {
        var c = t.__li.firstElementChild.firstElementChild.innerHTML, m = t.__gui.__listening.indexOf(t) > -1;
        t.remove();
        var x = ao(y, t.object, t.property, {
          before: t.__li.nextElementSibling,
          factoryArgs: [t.__min, t.__max, t.__step]
        });
        return x.name(c), m && x.listen(), x;
      }
      return h;
    };
    t.min = Dt.compose(s, t.min), t.max = Dt.compose(s, t.max);
  } else
    t instanceof wg ? (Ct.bind(e, "click", function() {
      Ct.fakeEvent(t.__checkbox, "click");
    }), Ct.bind(t.__checkbox, "click", function(o) {
      o.stopPropagation();
    })) : t instanceof Mg ? (Ct.bind(e, "click", function() {
      Ct.fakeEvent(t.__button, "click");
    }), Ct.bind(e, "mouseover", function() {
      Ct.addClass(t.__button, "hover");
    }), Ct.bind(e, "mouseout", function() {
      Ct.removeClass(t.__button, "hover");
    })) : t instanceof Qh && (Ct.addClass(e, "color"), t.updateDisplay = Dt.compose(function(o) {
      return e.style.borderLeftColor = t.__color.toString(), o;
    }, t.updateDisplay), t.updateDisplay());
  t.setValue = Dt.compose(function(o) {
    return y.getRoot().__preset_select && t.isModified() && eu(y.getRoot(), !0), o;
  }, t.setValue);
}
function Ag(y, e) {
  var t = y.getRoot(), n = t.__rememberedObjects.indexOf(e.object);
  if (n !== -1) {
    var s = t.__rememberedObjectIndecesToControllers[n];
    if (s === void 0 && (s = {}, t.__rememberedObjectIndecesToControllers[n] = s), s[e.property] = e, t.load && t.load.remembered) {
      var o = t.load.remembered, h = void 0;
      if (o[y.preset])
        h = o[y.preset];
      else if (o[po])
        h = o[po];
      else
        return;
      if (h[n] && h[n][e.property] !== void 0) {
        var c = h[n][e.property];
        e.initialValue = c, e.setValue(c);
      }
    }
  }
}
function ao(y, e, t, n) {
  if (e[t] === void 0)
    throw new Error('Object "' + e + '" has no property "' + t + '"');
  var s = void 0;
  if (n.color)
    s = new Qh(e, t);
  else {
    var o = [e, t].concat(n.factoryArgs);
    s = I1.apply(y, o);
  }
  n.before instanceof ga && (n.before = n.before.__li), Ag(y, s), Ct.addClass(s.domElement, "c");
  var h = document.createElement("span");
  Ct.addClass(h, "property-name"), h.innerHTML = s.property;
  var c = document.createElement("div");
  c.appendChild(h), c.appendChild(s.domElement);
  var m = Bu(y, c, n.before);
  return Ct.addClass(m, yn.CLASS_CONTROLLER_ROW), s instanceof Qh ? Ct.addClass(m, "color") : Ct.addClass(m, w1(s.getValue())), D1(y, m, s), y.__controllers.push(s), s;
}
function Ta(y, e) {
  return document.location.href + "." + e;
}
function tu(y, e, t) {
  var n = document.createElement("option");
  n.innerHTML = e, n.value = e, y.__preset_select.appendChild(n), t && (y.__preset_select.selectedIndex = y.__preset_select.length - 1);
}
function dd(y, e) {
  e.style.display = y.useLocalStorage ? "block" : "none";
}
function z1(y) {
  var e = y.__save_row = document.createElement("li");
  Ct.addClass(y.domElement, "has-save"), y.__ul.insertBefore(e, y.__ul.firstChild), Ct.addClass(e, "save-row");
  var t = document.createElement("span");
  t.innerHTML = "&nbsp;", Ct.addClass(t, "button gears");
  var n = document.createElement("span");
  n.innerHTML = "Save", Ct.addClass(n, "button"), Ct.addClass(n, "save");
  var s = document.createElement("span");
  s.innerHTML = "New", Ct.addClass(s, "button"), Ct.addClass(s, "save-as");
  var o = document.createElement("span");
  o.innerHTML = "Revert", Ct.addClass(o, "button"), Ct.addClass(o, "revert");
  var h = y.__preset_select = document.createElement("select");
  if (y.load && y.load.remembered ? Dt.each(y.load.remembered, function(I, F) {
    tu(y, F, F === y.preset);
  }) : tu(y, po, !1), Ct.bind(h, "change", function() {
    for (var I = 0; I < y.__preset_select.length; I++)
      y.__preset_select[I].innerHTML = y.__preset_select[I].value;
    y.preset = this.value;
  }), e.appendChild(h), e.appendChild(t), e.appendChild(n), e.appendChild(s), e.appendChild(o), eo) {
    var c = document.getElementById("dg-local-explain"), m = document.getElementById("dg-local-storage"), x = document.getElementById("dg-save-locally");
    x.style.display = "block", localStorage.getItem(Ta(y, "isLocal")) === "true" && m.setAttribute("checked", "checked"), dd(y, c), Ct.bind(m, "change", function() {
      y.useLocalStorage = !y.useLocalStorage, dd(y, c);
    });
  }
  var B = document.getElementById("dg-new-constructor");
  Ct.bind(B, "keydown", function(I) {
    I.metaKey && (I.which === 67 || I.keyCode === 67) && so.hide();
  }), Ct.bind(t, "click", function() {
    B.innerHTML = JSON.stringify(y.getSaveObject(), void 0, 2), so.show(), B.focus(), B.select();
  }), Ct.bind(n, "click", function() {
    y.save();
  }), Ct.bind(s, "click", function() {
    var I = prompt("Enter a new preset name.");
    I && y.saveAs(I);
  }), Ct.bind(o, "click", function() {
    y.revert();
  });
}
function F1(y) {
  var e = void 0;
  y.__resize_handle = document.createElement("div"), Dt.extend(y.__resize_handle.style, {
    width: "6px",
    marginLeft: "-3px",
    height: "200px",
    cursor: "ew-resize",
    position: "absolute"
  });
  function t(o) {
    return o.preventDefault(), y.width += e - o.clientX, y.onResize(), e = o.clientX, !1;
  }
  function n() {
    Ct.removeClass(y.__closeButton, yn.CLASS_DRAG), Ct.unbind(window, "mousemove", t), Ct.unbind(window, "mouseup", n);
  }
  function s(o) {
    return o.preventDefault(), e = o.clientX, Ct.addClass(y.__closeButton, yn.CLASS_DRAG), Ct.bind(window, "mousemove", t), Ct.bind(window, "mouseup", n), !1;
  }
  Ct.bind(y.__resize_handle, "mousedown", s), Ct.bind(y.__closeButton, "mousedown", s), y.domElement.insertBefore(y.__resize_handle, y.domElement.firstElementChild);
}
function iu(y, e) {
  y.domElement.style.width = e + "px", y.__save_row && y.autoPlace && (y.__save_row.style.width = e + "px"), y.__closeButton && (y.__closeButton.style.width = e + "px");
}
function ol(y, e) {
  var t = {};
  return Dt.each(y.__rememberedObjects, function(n, s) {
    var o = {}, h = y.__rememberedObjectIndecesToControllers[s];
    Dt.each(h, function(c, m) {
      o[m] = e ? c.initialValue : c.getValue();
    }), t[s] = o;
  }), t;
}
function U1(y) {
  for (var e = 0; e < y.__preset_select.length; e++)
    y.__preset_select[e].value === y.preset && (y.__preset_select.selectedIndex = e);
}
function Tg(y) {
  y.length !== 0 && P1.call(window, function() {
    Tg(y);
  }), Dt.each(y, function(e) {
    e.updateDisplay();
  });
}
var V1 = yn;
let Fh = null;
class H1 {
  constructor(e) {
    if (this.debug = null, this.config = null, this.updateConfig = (t) => {
      this.config = t;
    }, Fh)
      return Fh;
    Fh = this, this.config = e, this.init();
  }
  init() {
    if (this.debug)
      return;
    const e = new V1({ width: 300 });
    let t;
    window.parent !== window ? (t = this.getExportIntegration(), e.add(t, "export").name("Save")) : (t = this.getExportStandalone(), e.add(t, "export").name("Export")), this.debug = e, this.debug.domElement.style.display = "none", new URLSearchParams(window.location.search).get("config") === "true" && (this.debug.open(), this.debug.domElement.style.display = "block");
  }
  getExportIntegration() {
    return {
      export: () => {
        const t = "babylon-customization.json", n = this.exportConfigCustmizations(this.config);
        window.parent.postMessage(
          {
            type: "exportConfig",
            data: {
              filename: t,
              config: n
            }
          },
          "*"
        );
      }
    };
  }
  getExportStandalone() {
    return {
      export: () => {
        const t = "babylon-customization.json", n = JSON.stringify(this.exportConfigCustmizations(this.config));
        let s = document.createElement("a");
        s.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(n)), s.setAttribute("download", t), s.style.display = "none", document.body.appendChild(s), s.click(), document.body.removeChild(s);
      }
    };
  }
  updateDisplay(e) {
    if (e) {
      for (var t in e.__controllers)
        e.__controllers[t].updateDisplay();
      for (var n in e.__folders)
        this.updateDisplay(e.__folders[n]);
    }
  }
  exportConfigCustmizations(e) {
    if (!(!e || !this.debug))
      return e;
  }
  exportCustomProperties(e) {
    return Object.entries(e.__folders).map(([t, n]) => ({
      [t]: this.exportCustomPropertiesProps(n)
    })).reduce((t, n) => ({ ...n, ...t }), {});
  }
  exportCustomPropertiesProps(e) {
    const t = e.__controllers.reduce(
      (s, o) => ({
        ...s,
        [o.property]: o.getValue()
      }),
      {}
    ), n = Object.entries(e.__folders).map(([s, o]) => ({
      [s]: this.exportCustomPropertiesProps(o)
    })).reduce((s, o) => ({ ...o, ...s }), {});
    return {
      ...t,
      ...n
    };
  }
}
class Y1 {
  constructor(e, t, n) {
    this.gui = null, this.config = null, this.sceneHelper = null, this.shadowMinZController = null, this.shadowMaxZController = null;
    const s = new H1(e);
    s.init(), this.gui = s, this.onUpdate = t, this.config = e, this.sceneHelper = n;
  }
  /**
   * The function "setupGui" configures the general, environment, lights, and camera settings based on
   * the provided configuration object, and calls the onUpdate function with the updated configuration.
   * @param {SceneConfig} config - The `config` parameter is an object that contains the initial configuration
   * for the GUI. It may include properties such as general settings, environment settings, lights
   * settings, and camera settings.
   * @param onUpdate - The `onUpdate` parameter is a callback function that will be called whenever
   * there is an update to the configuration. It takes a new configuration object as a parameter
   * (`newConfig: SceneConfig`).
   */
  setupGui(e) {
    if (!this.config)
      return;
    const t = (n) => {
      var s;
      this.onUpdate(n), (s = this.gui) == null || s.updateConfig(n);
    };
    this.configureGeneral(this.config, t), this.configureEnvironment(this.config, t), this.configureLights(this.config, t), this.configureCamera(this.config, t, e), this.configureShadows(this.config, t), this.configureAr(this.config, t), this.configureModel(this.config, t), this.configureAnimations(this.config, t, e);
  }
  configureModel(e, t) {
    var s, o;
    if (!e.model)
      return;
    const n = (o = (s = this.gui) == null ? void 0 : s.debug) == null ? void 0 : o.addFolder("Model");
    e.model.config || (e.model.config = { doubleSided: !0 }), n == null || n.add(e.model.config, "doubleSided").name("Double Sided").onFinishChange(() => {
      t(e);
    });
  }
  configureShadows(e, t) {
    var o, h, c, m, x, B;
    if (!e.environment || !e.environment.shadows)
      return;
    const n = (h = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : h.addFolder("Shadows");
    n == null || n.add(e.environment.shadows, "enableShadows").name("Enable Shadows").onChange(() => {
      t(e);
    }), n == null || n.addColor(e.environment.shadows, "shadowHexColor").name("Hex Color").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "shadowDarkness", 0, 1, 0.1).name("Transparency").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "groundSizeMultiplierWidth", 0, 5, 0.1).name("Ground Width").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "groundSizeMultiplierLength", 0, 5, 0.1).name("Ground Length").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "shadowMapSize", 0, 128, 4).name("Map Size").onChange(() => {
      t(e);
    });
    const s = {
      enableShadowMinZ: !!((m = (c = e == null ? void 0 : e.environment) == null ? void 0 : c.shadows) != null && m.shadowMinZ),
      enableShadowMaxZ: !!((B = (x = e == null ? void 0 : e.environment) == null ? void 0 : x.shadows) != null && B.shadowMaxZ)
    };
    n == null || n.add(s, "enableShadowMinZ").name("Enable starting shadow clipping").onChange(() => {
      s.enableShadowMinZ ? e.environment.shadows.shadowMinZ = 0 : (e.environment.shadows.shadowMinZ = null, t(e)), this.buildShadowZConfig(e, n, t);
    }), n == null || n.add(s, "enableShadowMaxZ").name("Enable ending shadow clipping").onChange(() => {
      s.enableShadowMaxZ ? e.environment.shadows.shadowMaxZ = 0 : (e.environment.shadows.shadowMaxZ = null, t(e)), this.buildShadowZConfig(e, n, t);
    }), n && this.buildShadowZConfig(e, n, t);
  }
  buildShadowZConfig(e, t, n) {
    var s, o, h, c, m, x, B, I, F, M;
    ((o = (s = e == null ? void 0 : e.environment) == null ? void 0 : s.shadows) == null ? void 0 : o.shadowMinZ) !== void 0 && ((c = (h = e == null ? void 0 : e.environment) == null ? void 0 : h.shadows) == null ? void 0 : c.shadowMinZ) !== null ? this.shadowMinZController || (this.shadowMinZController = t == null ? void 0 : t.add((m = e == null ? void 0 : e.environment) == null ? void 0 : m.shadows, "shadowMinZ", -50, 0, 1).name("Clipping Start").onChange(() => {
      n(e);
    })) : this.shadowMinZController && (t == null || t.remove(this.shadowMinZController), this.shadowMinZController = null), ((B = (x = e == null ? void 0 : e.environment) == null ? void 0 : x.shadows) == null ? void 0 : B.shadowMaxZ) !== void 0 && ((F = (I = e == null ? void 0 : e.environment) == null ? void 0 : I.shadows) == null ? void 0 : F.shadowMaxZ) !== null ? this.shadowMaxZController || (this.shadowMaxZController = t == null ? void 0 : t.add((M = e == null ? void 0 : e.environment) == null ? void 0 : M.shadows, "shadowMaxZ", 0, 50, 1).name("Clipping End").onChange(() => {
      n(e);
    })) : this.shadowMaxZController && (t == null || t.remove(this.shadowMaxZController), this.shadowMaxZController = null);
  }
  configureGeneral(e, t) {
    var s, o;
    if (!e.general)
      return;
    const n = (o = (s = this.gui) == null ? void 0 : s.debug) == null ? void 0 : o.addFolder("General");
    n == null || n.addColor(e.general, "backgroundColor").name("Background Color").onChange(() => {
      t(e);
    }), n == null || n.add(e.general, "removeDefaultBackground").name("Remove Background").onChange(() => {
      t(e);
    }), e.camera && (n == null || n.add(e.camera, "toneMappingEnabled").name("Tone Mapping Enabled").onFinishChange(() => {
      t(e);
    }), n == null || n.add(e.camera, "toneMappingType", {
      Standard: 0,
      AcesToneMapping: 1
    }).name("Tone Mapping Type").onFinishChange(() => {
      var h;
      (h = e == null ? void 0 : e.camera) != null && h.toneMappingType && (e.camera.toneMappingType = Number(e.camera.toneMappingType)), t(e);
    }), this.configureAntialias(n, e, t));
  }
  configureAntialias(e, t, n) {
    if (!e || !t.general)
      return;
    const s = e == null ? void 0 : e.addFolder("Antialias"), o = s == null ? void 0 : s.addFolder("Desktop"), h = s == null ? void 0 : s.addFolder("Mobile"), c = {
      desktop: null,
      mobile: null
    };
    t.general.antialias ? t.general.antialias && t.general.antialias.desktop && !t.general.antialias.mobile && (t.general.antialias.mobile = {
      enabled: t.general.antialias.desktop.enabled,
      inRotationEnabled: t.general.antialias.desktop.inRotationEnabled
    }) : t.general.antialias = {
      desktop: {
        enabled: !0,
        inRotationEnabled: !1
      },
      mobile: {
        enabled: !0,
        inRotationEnabled: !1
      }
    };
    function m(F, M, Z = !0) {
      var K, J, le;
      const V = (J = (K = t.general) == null ? void 0 : K.antialias) == null ? void 0 : J[F];
      if (!V)
        return;
      const { enabled: te, inRotationEnabled: P } = V;
      if (V.inRotationEnabled = te ? P : !1, M) {
        const fe = (le = M.domElement.parentElement) == null ? void 0 : le.parentElement;
        fe && (fe.style.display = te ? "" : "none");
      }
      Z && n(t);
    }
    function x(F, M) {
      var te, P;
      const Z = (P = (te = t.general) == null ? void 0 : te.antialias) == null ? void 0 : P[M];
      if (!Z)
        return null;
      F == null || F.add(Z, "enabled").name("Enabled").onChange(() => {
        m(M, c[M] ?? void 0);
      });
      const V = F == null ? void 0 : F.add(Z, "inRotationEnabled").name("In Rotation Enabled").listen().onChange(() => n(t));
      return c[M] = V, V;
    }
    const B = x(o, "desktop"), I = x(h, "mobile");
    m("desktop", B ?? void 0, !1), m("mobile", I ?? void 0, !1);
  }
  configureAr(e, t) {
    var B, I, F, M, Z;
    if (!e.general || !e.general.meshSize)
      return;
    const n = (I = (B = this.gui) == null ? void 0 : B.debug) == null ? void 0 : I.addFolder("Augmented Reality");
    n == null || n.add(e.general, "arEnabled").name("Enabled").onChange(() => {
      t(e);
    }), n == null || n.add({ enabled: e.general.arAnchor === "wall" }, "enabled").name("Enable wall placement").onChange((V) => {
      e.general && (e.general.arAnchor = V ? "wall" : null), t(e);
    }), n == null || n.add({ enabled: e.general.arScale ?? !1 }, "enabled").name("Resizable in AR").onChange((V) => {
      e.general && (e.general.arScale = V), t(e);
    }), n == null || n.add({ enabled: e.general.arOnTheFly }, "enabled").name("Faster AR Conversion").onChange((V) => {
      e.general && (e.general.arOnTheFly = V), t(e);
    });
    const s = n == null ? void 0 : n.addFolder("Measure Scene Ar"), o = {
      options: {
        width: ((F = e.general.meshSize) == null ? void 0 : F.width) ?? !1,
        height: ((M = e.general.meshSize) == null ? void 0 : M.height) ?? !1,
        depth: ((Z = e.general.meshSize) == null ? void 0 : Z.depth) ?? !1
      }
    };
    let c = (() => {
      const { width: V, height: te, depth: P } = o.options;
      return V ? "width" : te ? "height" : P ? "depth" : null;
    })();
    const m = (V) => {
      if (V === "none" || !V)
        return 0;
      if (e.general && e.general.meshSize)
        return e.general.meshSize[V];
    };
    s == null || s.add(o, "options", {
      None: "none",
      Width: "width",
      Height: "height",
      Depth: "depth"
    }).name("Know Dimension").setValue(c).onFinishChange((V) => {
      c = V, V === "none" && e.general && e.general.meshSize && (e.general.meshSize = {
        width: null,
        height: null,
        depth: null
      }, t(e)), x == null || x.setValue(m(c));
    });
    const x = s == null ? void 0 : s.add({ size: 0 }, "size", -500, 500, 1).name("Measure (cm)").setValue(m(c)).onFinishChange((V) => {
      e.general && e.general.meshSize && (Object.keys(e.general.meshSize).forEach((te) => {
        e.general && e.general.meshSize && (e.general.meshSize[te] = te !== c ? null : V);
      }), t(e));
    });
  }
  configureEnvironment(e, t) {
    var s, o;
    if (!e.general || !e.general.environmentOptions)
      return;
    const n = (o = (s = this.gui) == null ? void 0 : s.debug) == null ? void 0 : o.addFolder("Environment");
    n == null || n.add(e.general, "exposure", 0, 5, 0.1).name("Exposure").onChange(() => {
      t(e);
    }), n == null || n.add(e.general, "contrast", 0, 5, 0.1).name("Contrast").onChange(() => {
      t(e);
    }).isModified, n == null || n.add(e.general.environmentOptions, "rotationY", 0, 10, 1e-3).name("Rotation Y").onChange(() => {
      t(e);
    }), n == null || n.add(e.general.environmentOptions, "intensity", 0, 20, 0.1).name("Intensity").onChange(() => {
      t(e);
    }), n == null || n.add(e.general.environmentOptions, "pbrIntensity", 0, 20, 0.1).name("PBR Intensity").onChange(() => {
      t(e);
    });
  }
  configureCamera(e, t, n) {
    var B, I;
    const s = n == null ? void 0 : n.cameras.find((F) => F instanceof BABYLON.ArcRotateCamera);
    if (!e.camera || !e.camera.position || !s)
      return;
    const o = (I = (B = this.gui) == null ? void 0 : B.debug) == null ? void 0 : I.addFolder("Camera");
    o == null || o.add(e.camera, "autoRotate").name("Auto Rotate").onChange(() => {
      t(e);
    }), e.camera.zoom === void 0 && (e.camera.zoom = 0), o == null || o.add(e.camera, "zoom", -50, 10, 0.1).name("Initial Zoom").onChange(() => {
      t(e);
    }), o == null || o.add(e.camera.position, "fov", 0, 1.6, 1e-3).name("Fov").onChange((F) => {
      s.fov = F, n == null || n.render();
    });
    const h = o == null ? void 0 : o.addFolder("Rotation");
    h == null || h.add(e.camera.position, "alpha", -10, 10, 0.01).name("X").onChange((F) => {
      s.alpha = F, n == null || n.render();
    }), h == null || h.add(e.camera.position, "beta", -3, 3, 0.01).name("Y").onChange((F) => {
      s.beta = F, n == null || n.render();
    });
    const c = o == null ? void 0 : o.addFolder("Zoom Settings");
    e.camera.useMinZoomPerc = e.camera.useMinZoomPerc === null ? !1 : e.camera.useMinZoomPerc, e.camera.useMaxZoomPerc = e.camera.useMaxZoomPerc === null ? !1 : e.camera.useMaxZoomPerc, c == null || c.add(e.camera, "useMinZoomPerc", 0, 1, 0.01).name("Enable Max Zoom").onChange(() => {
      t(e);
    });
    const m = c == null ? void 0 : c.add(e.camera, "minZoomPerc", 0, 10, 0.01).name("Max Zoom");
    m == null || m.onChange((F) => {
      var Z;
      const M = (Z = e.camera) == null ? void 0 : Z.maxZoomPerc;
      M && F > M && m.setValue(M), t(e);
    }), c == null || c.add(e.camera, "useMaxZoomPerc", 0, 1, 0.01).name("Enable Min Zoom").onChange(() => {
      t(e);
    });
    const x = c == null ? void 0 : c.add(e.camera, "maxZoomPerc", 0, 10, 0.01).name("Min Zoom");
    x == null || x.onChange((F) => {
      var Z;
      const M = (Z = e.camera) == null ? void 0 : Z.minZoomPerc;
      F === 0 ? x.setValue(0.01) : M && F < M && x.setValue(M), t(e);
    });
  }
  configureLights(e, t) {
    var s, o;
    if (!e.lights)
      return;
    const n = (o = (s = this.gui) == null ? void 0 : s.debug) == null ? void 0 : o.addFolder("Lights");
    this.configureLight(
      n,
      "Directional Light Back",
      e.lights.directionalLightBack,
      e,
      t
    ), this.configureLight(
      n,
      "Directional Light Left",
      e.lights.directionalLightLeft,
      e,
      t
    ), this.configureLight(n, "Point Light Back", e.lights.pointLightBack, e, t), this.configureLight(n, "Point Light Front", e.lights.pointLightFront, e, t), this.configureLight(n, "Hemisphere Light", e.lights.hemisphereLight, e, t);
  }
  configureLight(e, t, n, s, o) {
    const h = e == null ? void 0 : e.addFolder(t), c = h == null ? void 0 : h.addFolder("position"), m = h == null ? void 0 : h.addFolder("general");
    c == null || c.add(n.position, "x", -100, 100, 0.1).name("Position X").onChange(() => {
      o(s);
    }), c == null || c.add(n.position, "y", -100, 100, 0.1).name("Position Y").onChange(() => {
      o(s);
    }), c == null || c.add(n.position, "z", -100, 100, 0.1).name("Position Z").onChange(() => {
      o(s);
    }), m == null || m.add(n.general, "intensity", 0, 50, 0.1).name("Intensity").onChange(() => {
      o(s);
    }), m == null || m.add(n.general, "visible").name("Visible").onChange(() => {
      o(s);
    });
  }
  configureAnimations(e, t, n) {
    var h, c;
    const s = (n == null ? void 0 : n.animationGroups) && n.animationGroups.length > 0;
    if (!e.animations || !s)
      return;
    const o = (c = (h = this.gui) == null ? void 0 : h.debug) == null ? void 0 : c.addFolder("animations");
    o == null || o.add(e.animations, "runAtStart").name("Run At Start").onChange(() => t(e)), o == null || o.add(e.animations, "loop").name("Loop").onChange(() => t(e)), o == null || o.add(e.animations, "speed", 0.1, 5, 0.1).name("Speed").onChange(() => t(e));
  }
}
var G1 = /* @__PURE__ */ ((y) => (y.CameraMovement = "camera-movement", y.ScriptExecution = "script-execution", y.DesignChanged = "design-changed", y))(G1 || {});
class ku {
  constructor(e) {
    this._zkScene = null, this._zkModel = null, this._canvasID = "zakeke-canvas-viewer3D-" + Zakeke.makeID(5), this._canvas = null, this._domElement = null, this._lastWidth = Number.MIN_VALUE, this._lastHeight = Number.MIN_VALUE, this._resizeObserver = null, this._engine = null, this._scene = null, this._bindedResize = null, this._sceneHelper = null, this._environmentManager = null, this._glowManager = null, this._sceneActionsExecutor = null, this._renderingNeeded = !1, this._renderingPaused = !1, this._autoRender = !1, this._antiAliasConfig = {
      enabled: !0,
      inRotationEnabled: !1
    }, this._postProcesses = [], this._camera = null, this._hemiLight = null, this._pointLight = null, this._highlightColor = "#00ff00", this._highlightSize = 2, this._highlightLayer = null, this._highlightBlurHorizontalSize = 1, this._highlightBlurVerticalSize = 1, this._highlightAnimationID = null, this._highlightCurrentMeshes = [], this._highlightNextMeshes = [], this._deviceType = MPlaza.DeviceType.All, this._destroyed = !1, this._sceneDesignManager = null, this._meshLocationsManager = null, this._renderDesignQueue = Promise.resolve(), this._groupPickedListeners = [], this._focusAttributesListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._onDelayLoadingStart = null, this._onDelayLoadingProgress = null, this._onDelayLoadingSuccess = null, this._onDelayLoadingError = null, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._nextSceneMeshesLoadedListeners = [], this._nextSceneTexturesLoadedListeners = [], this._beginSceneLoadingListeners = [], this._endSceneLoadingListeners = [], this._scriptExecutionListeners = [], this._arFileUrls = {}, this._designTextureResolution = 1024, this._configPreview = !1, this._defaultBackgroundColor = null, this._grids = [], this._dracoCompression = null, this._infoPointsManager = null, this._infoPointsManagerStyle = null, this._canShowInfoPoints = !0, this._canShowInfoPointsContent = !0, this._broadcastChannel = null, this._isHologramSource = !1, this._isHologram = !1, this._lastResizableMeshID = "", this._brandLogoButton = null, this._advancedTexture = null, this._createGui = null, this._performanceInfo = null, this._currentRotation = 0, this._isRotating = !1, this._isViewer = !1, this._isSelectionMode = !0, this._mouseWheelInput = null, this._modelParentNode = null, this.setCameraLocked = (t) => {
      this._zkScene && this._sceneHelper && this._scene && (this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._camera && (t ? (this._sceneHelper.setCameraLimitLowerRadius(!0), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1)) : (this._sceneHelper.setCameraLimitLowerRadius(!1), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1.5))));
    }, e != null && (typeof e == "boolean" ? this._configPreview = e : (this._configPreview = e.configPreview, e.defaultBackgroundColor && (this._defaultBackgroundColor = BABYLON.Color4.FromHexString(e.defaultBackgroundColor)), this._isViewer = (e == null ? void 0 : e.isViewer) ?? !1)), this._elementSelector = new tg();
  }
  get zkScene() {
    return this._zkScene;
  }
  get zkModel() {
    return this._zkModel;
  }
  get canvas() {
    return this._canvas;
  }
  get engine() {
    return this._engine;
  }
  get scene() {
    return this._scene;
  }
  get autoRender() {
    return this._autoRender;
  }
  set autoRender(e) {
    this._autoRender = e;
  }
  get antiAliasConfig() {
    return this._antiAliasConfig;
  }
  set antiAliasConfig(e) {
    this._antiAliasConfig = e;
  }
  get isLowEndDevice() {
    return this._performanceInfo && this._performanceInfo.isLowEndDevice;
  }
  get isHologramSource() {
    return this.isHologramSource;
  }
  get createGui() {
    return this._createGui;
  }
  set createGui(e) {
    this._createGui = e;
  }
  set isHologramSource(e) {
    this._isHologramSource = e, e && (this._isHologram = !1, this.detachBroadcastChannelEventHandlers());
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, e ? (this._isHologramSource = !1, this.attachBroadcastChannelEventHandlers()) : this.detachBroadcastChannelEventHandlers(), this.refreshEnvironment();
  }
  get isSelectionMode() {
    return this._isSelectionMode;
  }
  set isSelectionMode(e) {
    this._isSelectionMode = e;
  }
  setupAntiAliasing() {
    if (this._zkScene) {
      let e = this.getAntiAliasingConfig();
      this._antiAliasConfig = e, e.enabled === !0 ? this.enableAntialiasing() : e.enabled === !1 && this.disableAntialiasing();
    }
  }
  getAntiAliasingConfig() {
    var t, n, s, o, h;
    if (!this._zkScene)
      return this._antiAliasConfig;
    const e = (o = (s = (n = (t = this._zkScene).get) == null ? void 0 : n.call(t, "config")) == null ? void 0 : s.toJSON) == null ? void 0 : o.call(s);
    return (h = e == null ? void 0 : e.general) != null && h.antialias ? Fw() ? e.general.antialias.mobile ?? this._antiAliasConfig : e.general.antialias.desktop ?? this._antiAliasConfig : this._antiAliasConfig;
  }
  enableAntialiasing() {
    this._scene && this._antiAliasConfig.enabled && (this.createAntialiasPostProcesses(), this._scene.postProcessesEnabled = !0);
  }
  disableAntialiasing(e = !1) {
    this._scene && (this._scene.postProcessesEnabled = !1), e && this.disposePostProcesses();
  }
  // Per coerenza con tutto il resto inserisco questi metodi set & get,
  // andrebbero usate solo le proprietà, ma questo anche in SceneEditor
  getARScale() {
    let e = !0;
    if (this._zkScene) {
      let t = this._zkScene.getARScale();
      return t ?? e;
    }
    return e;
  }
  setARScale(e) {
    this._zkScene && this._zkScene.setARScale(e);
  }
  getUseMaterialOffloading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseMaterialOffloading();
      return t ?? e;
    }
    return e;
  }
  setUseMaterialOffloading(e) {
    this._zkScene && this._zkScene.setUseMaterialOffloading(e);
  }
  getPrefetchMeshes() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMeshes();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMeshes(e) {
    this._zkScene && this._zkScene.setPrefetchMeshes(e);
  }
  getPrefetchMaterials() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMaterials();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMaterials(e) {
    this._zkScene && this._zkScene.setPrefetchMaterials(e);
  }
  getShowHideInfoPoints() {
    return this.canShowInfoPoints;
  }
  setShowHideInfoPoints(e) {
    this.canShowInfoPoints = e;
  }
  get camera() {
    return this._camera;
  }
  get deviceType() {
    return this._deviceType;
  }
  set deviceType(e) {
    this._deviceType = e;
  }
  getDeviceType() {
    return this.deviceType;
  }
  get highlightColor() {
    return this._highlightColor;
  }
  set highlightColor(e) {
    this._highlightColor = e;
  }
  get highlightSize() {
    return this._highlightSize;
  }
  set highlightSize(e) {
    this._highlightSize = e;
  }
  get destroyed() {
    return this._destroyed;
  }
  /**
   * Recupera il token di autorizzazione disponibile
   * @returns Il token se disponibile, altrimenti null
   */
  getAvailableAuthToken() {
    return this._authorizationToken && typeof this._authorizationToken == "string" ? this._authorizationToken : window.token && typeof window.token == "string" && window.token.trim() !== "" ? window.token : null;
  }
  get onDelayLoadingStart() {
    return this._onDelayLoadingStart;
  }
  set onDelayLoadingStart(e) {
    this._onDelayLoadingStart = e;
  }
  get onDelayLoadingProgress() {
    return this._onDelayLoadingProgress;
  }
  set onDelayLoadingProgress(e) {
    this._onDelayLoadingProgress = e;
  }
  get onDelayLoadingSuccess() {
    return this._onDelayLoadingSuccess;
  }
  set onDelayLoadingSuccess(e) {
    this._onDelayLoadingSuccess = e;
  }
  get onDelayLoadingError() {
    return this._onDelayLoadingError;
  }
  set onDelayLoadingError(e) {
    this._onDelayLoadingError = e;
  }
  get dracoCompression() {
    return this._dracoCompression || (this._dracoCompression = n1.Default), this._dracoCompression;
  }
  get infoPointsShown() {
    return this._infoPointsManager ? this._infoPointsManager.infoPointsShown : !1;
  }
  get infoPointsManagerStyle() {
    return this._infoPointsManagerStyle;
  }
  set infoPointsManagerStyle(e) {
    this._infoPointsManagerStyle = e, this.updateInfoPointsManagerStyle();
  }
  get canShowInfoPoints() {
    return this._canShowInfoPoints;
  }
  set canShowInfoPoints(e) {
    this._canShowInfoPoints = e, this.refreshInfoPoints();
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this._infoPointsManager && (this._infoPointsManager.canShowInfoPointsContent = e);
  }
  static async createSceneViewerAsync(e) {
    const t = new ku(e);
    return await t.initAsync(), t;
  }
  dispose() {
    this.closeBroadcastChannel(), this.removeCanvas(), this.removeDomElement(), this.deleteScene(), this.deleteEngine();
  }
  async initAsync() {
    this._bindedResize = this.resize.bind(this), Zakeke.Tools.Init(), BABYLON.Geometry.onDelayLoadingStart = (e) => {
      this._onDelayLoadingStart && this._onDelayLoadingStart(e);
    }, BABYLON.Geometry.onDelayLoadingProgress = (e) => {
      this._onDelayLoadingProgress && this._onDelayLoadingProgress(e);
    }, BABYLON.Geometry.onDelayLoadingSuccess = (e) => {
      this._onDelayLoadingSuccess && this._onDelayLoadingSuccess(e);
    }, BABYLON.Geometry.onDelayLoadingError = (e) => {
      this._onDelayLoadingError && this._onDelayLoadingError(e);
    }, BABYLON.Geometry.dracoDecodingFunction = (e, t, n) => {
      this.dracoDecodingFunction(e, t, n);
    }, this.createCanvas(), this.createDOMElement(), await this.init3DEngineAsync();
  }
  async init3DEngineAsync() {
    this.createEngine(), await this.createEmptySceneAsync(), this._destroyed = !1;
  }
  createCanvas() {
    return this._canvas = document.createElement("canvas"), this._canvas.setAttribute("id", this._canvasID), this._canvas.setAttribute("touch-action", "none"), this._canvas.addEventListener("dblclick", (e) => this.setRenderingNeeded()), this._canvas;
  }
  removeCanvas() {
    this._canvas && (this._canvas.remove(), this._canvas = null);
  }
  deleteEngine() {
    this._engine && (this._engine.dispose(), this._engine = null), this._destroyed = !0, $(window).off("resize", this._bindedResize), this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null);
  }
  deleteScene() {
    this.deleteComponents(), this._scene && (this._scene.dispose(), this._scene = null);
  }
  deleteComponents() {
    this.resetPerformanceInfo(), this.emptyArFileCache(), this.disposeInfoPointsManager(), this._meshLocationsManager && (this._meshLocationsManager.dispose(), this._meshLocationsManager = null), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._sceneActionsExecutor && (this._sceneActionsExecutor.dispose(), this._sceneActionsExecutor = null), this.disposePostProcesses();
  }
  disposeInfoPointsManager() {
    this._infoPointsManager && (this._infoPointsManager.dispose(), this._infoPointsManager = null);
  }
  disposePostProcesses() {
    for (; this._postProcesses.length > 0; ) {
      var e = this._postProcesses.pop();
      e && e.dispose();
    }
  }
  emptyArFileCache() {
    this._arFileUrls = {};
  }
  async resetSceneAsync() {
    await this.init3DEngineAsync();
  }
  /**
   * In some case, we need to replace the model with a new one for example when reverting some changes in the preview 3D.
   * Backbone don't allow to replace all the model, so we need to replace the model with a old clone.
   * @param zkModel The new model to replace the old one.
   */
  replaceModel(e) {
    this._zkModel = e, this.render();
  }
  setZkScene(e) {
    this._zkScene = e;
  }
  closeBroadcastChannel() {
    this._broadcastChannel && (this._broadcastChannel.close(), this._broadcastChannel = null);
  }
  openBroadcastChannel() {
    if (!this._broadcastChannel && window.BroadcastChannel)
      try {
        this._broadcastChannel = new BroadcastChannel("zakeke-broadcast-channel");
      } catch (e) {
        console.error("Failed opening broadcast channel"), console.error(e);
      }
  }
  getOrCreateBroadcastChannel() {
    return this.openBroadcastChannel(), this._broadcastChannel;
  }
  createEngine() {
    this.deleteScene(), this.deleteEngine(), this._engine = new BABYLON.Engine(this._canvas, !0, { stencil: !0, preserveDrawingBuffer: !0 }), this._engine.enableOfflineSupport = !1, this._engine.disableUniformBuffers = !0, Logger.info("WebGL version: " + this._engine.webGLVersion), $(window).resize(this._bindedResize), $(window).on("orientationchange", () => {
      setTimeout(() => this._bindedResize(), 100);
    });
  }
  createBrandLogoButton() {
    var e = BABYLON.GUI.Button.CreateImageOnlyButton(
      "zakeke-logo",
      "https://zakeke.blob.core.windows.net/files/images/logo_hq.png"
    );
    return e.image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, e.width = "120px", e.height = "70px", e.color = "transparent", e.hoverCursor = "pointer", e.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, e.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP, e.left = "40px", e.top = "15px", e.onPointerClickObservable.add(function() {
      window.open("https://www.zakeke.com/");
    }), this._brandLogoButton = e, this._advancedTexture = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene), this._advancedTexture.updateSamplingMode(BABYLON.Texture.NEAREST_NEAREST), this._advancedTexture.renderScale = 2, this._advancedTexture.addControl(this._brandLogoButton), this._brandLogoButton;
  }
  async createEmptySceneAsync() {
    this.deleteScene(), this._engine && (this._scene = new BABYLON.Scene(this._engine), this._defaultBackgroundColor ? this._scene.clearColor.copyFrom(this._defaultBackgroundColor) : this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0), await this.setupSceneAsync());
  }
  refreshLights() {
    var n, s, o, h, c, m;
    if (!this._zkScene)
      return;
    ((s = (n = this._zkScene) == null ? void 0 : n.getGeneralConfig()) == null ? void 0 : s.get("preventDefaultLights")) !== !0 && ((o = this._sceneHelper) == null || o.setupLights());
    const t = (c = (h = this._zkScene) == null ? void 0 : h.getSceneConfig()) == null ? void 0 : c.get("lights");
    t != null && t.attributes && ((m = this._sceneHelper) == null || m.setUpCustomLights(t.attributes));
  }
  async setupSceneAsync(e = !0) {
    var t, n, s, o, h, c, m, x, B, I, F, M, Z, V, te;
    if (this._zkScene && this._zkScene.get("config") && ((n = (t = this._zkScene.get("config")) == null ? void 0 : t.get("general")) != null && n.get("meshSize"))) {
      const P = (o = (s = this._zkScene.get("config")) == null ? void 0 : s.get("general")) == null ? void 0 : o.get("meshSize"), K = (h = this._scene) == null ? void 0 : h.meshes.find((J) => !J.parent);
      K && P && (P.width || P.height || P.depth) && (K.metadata ? K.metadata.sizecm = P : K.metadata = { sizecm: P });
    }
    if (this.refreshModel(), this._engine && this._scene) {
      this._sceneHelper = new yi(this._scene);
      const P = this.getAvailableAuthToken();
      P && this._sceneHelper.setAuthorizationToken(P);
      const K = this._zkScene ? this._zkScene.getCameraPositionScale() : void 0, J = this._zkScene ? this._zkScene.getCameraPositionFOV() : void 0, le = this._zkScene ? this._zkScene.getCameraLimitLowerRadius() : void 0, fe = this._zkScene ? this._zkScene.getCameraZoomEnabled() : void 0, X = this._zkScene ? this._zkScene.getCameraUseMinZoomPerc() : !1, W = this._zkScene ? this._zkScene.getCameraMinZoomPerc() : 1, je = this._zkScene ? this._zkScene.getCameraUseMaxZoomPerc() : !1, Ee = this._zkScene ? this._zkScene.getCameraMaxZoomPerc() : 1.5, He = this._zkScene ? this._zkScene.getCameraLowerAlphaLimit() : null, ft = this._zkScene ? this._zkScene.getCameraUpperAlphaLimit() : null, Le = this._zkScene ? this._zkScene.getCameraLowerBetaLimit() : null, $e = this._zkScene ? this._zkScene.getCameraUpperBetaLimit() : null, ce = this._zkScene ? (c = this._zkScene.getCameraConfig()) == null ? void 0 : c.get("zoom") : null;
      if (K != null && K != null && this._sceneHelper.setCameraPositionScale(K, !1), J != null && J != null && this._sceneHelper.setCameraPositionFOV(J), le != null && le != null && this._sceneHelper.setCameraLimitLowerRadius(le, !1), fe != null && fe != null && this._sceneHelper.setZoomEnabled(fe), this._sceneHelper.setCameraZoom(ce), this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._mouseWheelInput = ((m = this._camera) == null ? void 0 : m.inputs.attached.mousewheel) ?? null, this._camera && (X ? this._sceneHelper.setMinZoomPerc(W) : this._sceneHelper.setMinZoomPerc(null), je ? this._sceneHelper.setMaxZoomPerc(Ee) : this._sceneHelper.setMaxZoomPerc(null), this._sceneHelper.setCameraAlphaLimits(He, ft), this._sceneHelper.setCameraBetaLimits(Le, $e)), this._camera && e && (this._camera.onViewMatrixChangedObservable.add(() => {
        this.notifyCameraMovement();
      }), this._camera.onRestoreStateObservable.add(() => {
        this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded();
      }), this.refreshCameraPosition()), (x = this._sceneHelper) == null || x.setupAnimations(this._zkScene), this._modelParentNode || (this._modelParentNode = new BABYLON.TransformNode("modelParent")), (B = this._sceneHelper) == null || B.setupShadows(this._zkScene), this.refreshLights(), this.createHighlightLayer(), await this.refreshEnvironment(), await this.fixEnvironmentTexture(), this.setupGlowManager(), this._zkScene && (this._meshLocationsManager = new Ow(), this._meshLocationsManager.setModelAndScene(this._zkScene, this._scene), this._meshLocationsManager.addMeshAnimationCompletedListener(() => this.setRenderingNeeded())), await this.setupSceneActionsExecutorAsync(), this.setRenderingOnDelayLoaded(), this.setupAntiAliasing(), this._scene.onPointerDown = (ut, ze) => this.onPointerDown(ut, ze), this._scene.registerBeforeRender(() => {
        this.onBeforeRender();
      }), this.refreshInfoPoints(), this.refreshModel(), (Z = (M = (F = (I = this._zkScene) == null ? void 0 : I.get("config")) == null ? void 0 : F.get("general")) == null ? void 0 : M.get("environmentOptions")) != null && Z.get("pbrIntensity") && this.updatePBRMaterialsIntensity(), this._zkScene) {
        const ut = (te = (V = this._zkScene) == null ? void 0 : V.getGeneralConfig()) == null ? void 0 : te.get("removeDefaultBackground");
        this._sceneHelper.removeDefaultBackground(ut), this._sceneHelper.setUpSceneToneMapping(this._zkScene);
      }
      this._engine.stopRenderLoop(), this.render(), this._engine.runRenderLoop(() => {
        this.checkRendering();
      });
    }
  }
  onBeforeRender() {
    if (this._scene && this._sceneHelper) {
      if (this._camera) {
        const e = this._sceneHelper.getDefaultPointLight();
        e && (e.position = this._camera.position);
      }
      this._scene.meshes.forEach((e) => {
        e.mustDepthSortFacets && e.isFacetDataEnabled && e.updateFacetData();
      });
    }
  }
  render() {
    this._scene && !this._scene.isDisposed && !this._renderingPaused && this._scene.render();
  }
  // Disabilito il post-processing quando la camera è in movimento
  checkRendering() {
    this._scene && (this._autoRender || this._renderingNeeded || this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving() ? (this.checkPerformance(), (this.isLowEndDevice || this._autoRender && !this._camera.autoRotationBehavior || // fix: in autorotate the antialiasing will be disabled without autoRotationBehavior check
    this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving()) && !this._antiAliasConfig.inRotationEnabled ? this.disableAntialiasing() : this.enableAntialiasing(), this.render(), this._renderingNeeded && (this._renderingNeeded = !1)) : !this._scene.postProcessesEnabled && !this._antiAliasConfig.inRotationEnabled && (this.enableAntialiasing(), this.render()), this._infoPointsManager && this._infoPointsManager.updateInfoPointsVisibility() && this.render());
  }
  resetPerformanceInfo() {
    this._performanceInfo = null;
  }
  checkPerformance() {
    if (this._performanceInfo || (this._performanceInfo = { totalFPS: 0, countFPS: 0, isLowEndDevice: !1, chekDone: !1 }), this._engine && !this._performanceInfo.chekDone) {
      this._performanceInfo.totalFPS += this._engine.getFps(), this._performanceInfo.countFPS++;
      const e = this._performanceInfo.totalFPS / this._performanceInfo.countFPS;
      this._performanceInfo.countFPS > 30 && (this._performanceInfo.isLowEndDevice = e <= 30, this._performanceInfo.chekDone = !0);
    }
  }
  createAntialiasPostProcesses() {
    if (this._camera && this._postProcesses.length === 0) {
      var e = /firefox/i.test(navigator.userAgent);
      e || this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 4, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 2, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 1, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      );
    }
  }
  getDAMMainMesh() {
    var e, t;
    return (t = (e = this._sceneHelper) == null ? void 0 : e.getVTOMeshes().userMeshes.filter((n) => !n.parent)) == null ? void 0 : t[0];
  }
  setRenderingNeeded() {
    this._renderingNeeded = !0;
  }
  setLongRenderingNeeded() {
    this.setRenderingNeeded();
    for (let e = 50; e <= 1e3; e += 200)
      setTimeout(() => this.setRenderingNeeded(), e);
  }
  refreshRendering() {
    this.setLongRenderingNeeded();
  }
  pauseRendering() {
    this._renderingPaused = !0;
  }
  resumeRendering() {
    this._renderingPaused = !1, this.setRenderingNeeded();
  }
  setLoadingScreen(e) {
    this._engine && (this._engine.loadingScreen = e);
  }
  setRenderingOnDelayLoaded() {
    if (this._scene) {
      var e = this;
      this._scene.getGeometries().forEach(function(t) {
        var n = t.onGeometryUpdated;
        t.onGeometryUpdated = function(s, o) {
          e.setLongRenderingNeeded(), n && n.apply(this, [s, o]);
        };
      });
    }
  }
  createHighlightLayer() {
    this._scene && (this._highlightLayer = new BABYLON.HighlightLayer("hl1", this._scene), this.updateHighlightLayerExcludedDesignMeshes(), this.setupHighlightLayerIntensity());
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightSize, this._highlightLayer.blurVerticalSize = this._highlightSize, this._highlightBlurHorizontalSize = this._highlightSize, this._highlightBlurVerticalSize = this._highlightSize);
  }
  updateHighlightLayerExcludedDesignMeshes() {
    this.scene && this._sceneHelper && this._highlightLayer && (this._highlightLayer.removeAllMeshes(), this.scene.meshes.filter(this._sceneHelper.isCanvasMesh).forEach((e) => this._highlightLayer.addExcludedMesh(e)));
  }
  createDOMElement() {
    this._canvas && (this._domElement = document.createElement("div"), this._domElement.setAttribute("id", "zakeke-canvas-viewer3D-div-" + Zakeke.makeID(5)), this._domElement.appendChild(this._canvas), this._domElement.style.position = "absolute", this._domElement.style.width = "100%", this._domElement.style.height = "100%", this._domElement.style.left = "0", this._domElement.style.top = "0");
  }
  removeDomElement() {
    this._domElement && (this.detach(), this._domElement.remove(), this._domElement = null);
  }
  appendTo(e) {
    this._domElement && (e.firstChild ? e.insertBefore(this._domElement, e.firstChild) : e.appendChild(this._domElement), e.appendChild(this._domElement), this.resize(), this.resize(), this.setupResizeObserver(e));
  }
  setupResizeObserver(e) {
    this._resizeObserver && this._resizeObserver.disconnect(), this._resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        this.resize();
      });
    }), this._resizeObserver.observe(e);
  }
  detach() {
    this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null), this._domElement && this._domElement.parentNode && this._domElement.parentNode.removeChild(this._domElement);
  }
  updateView(e = !0, t = !1) {
    this.resize(t), e && this._scene && this.adjustCamera(!1);
  }
  resize(e = !1) {
    if (this._canvas) {
      this.disableAntialiasing(!0);
      var t = this._canvas.parentNode;
      if (!(!t || !(t instanceof HTMLElement))) {
        var n = t.offsetWidth, s = t.offsetHeight, o = this._canvas.width !== this._canvas.clientWidth || this._canvas.height !== this._canvas.clientHeight;
        (n != this._lastWidth || s != this._lastHeight || e || o) && (this._canvas.style.width = "100%", this._canvas.style.height = "100%", this._engine && (this._engine.resize(), this.setRenderingNeeded())), this._lastWidth = n, this._lastHeight = s, this.enableAntialiasing();
      }
    }
  }
  switchFullScreen(e) {
    this._sceneHelper && this._sceneHelper.switchFullScreen(e);
  }
  setupGlowManager() {
    this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._zkScene && this._scene && (this._glowManager = new Pw(this._zkScene, this._scene), this._glowManager.update(), this.setRenderingNeeded());
  }
  async setupSceneActionsExecutorAsync() {
    this._zkScene && this._scene && (this._sceneActionsExecutor = new Iw(this._zkScene, this._scene), this._sceneActionsExecutor.deviceType = this.deviceType, this._sceneActionsExecutor.useMaterialOffloading = !this._configPreview && this.getUseMaterialOffloading(), this._sceneActionsExecutor.prefetchMeshes = this.getPrefetchMeshes(), this._sceneActionsExecutor.prefetchMaterials = this.getPrefetchMaterials(), this._sceneActionsExecutor.addMeshDesignRefreshRequiredListeners(async (e) => {
      await this.refreshMeshesDesignAsync(e.meshes, e.effect);
    }), this._sceneActionsExecutor.addBeginAssetsLoadingListener(() => this.fireBeginAssetsLoadingEvent()), this._sceneActionsExecutor.addEndAssetsLoadingListener(() => this.fireEndAssetsLoadingEvent()));
  }
  restoreCameraState() {
    this._sceneHelper && (this._sceneHelper.restoreCameraState(), this._sceneHelper.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  async fixEnvironmentTexture() {
    if (this._scene && this._scene.environmentTexture && this._scene.environmentTexture.url && typeof this._scene.environmentTexture.url == "string") {
      const e = this._scene.environmentTexture.url, t = (e.match(/http/g) || []).length;
      let n = e;
      if (t > 1) {
        let c = e.lastIndexOf("http");
        c >= 0 && (n = e.substring(c));
      } else if (t == 0 && this._zkScene && this._zkScene.get("rootUrl")) {
        let c = this._zkScene.get("rootUrl");
        if (c) {
          const m = c.endsWith("/") ? "" : "/";
          n = c + m + e;
        }
      } else if (t === 0)
        return;
      let s, o, h;
      this._scene && this._scene.metadata && (this._scene.metadata.environmentTextureRotationY !== void 0 && typeof this._scene.metadata.environmentTextureRotationY == "number" && (s = this._scene.metadata.environmentTextureRotationY), this._scene.metadata.environmentTextureExtensions && (o = this._scene.metadata.environmentTextureExtensions), this._scene.metadata.environmentTextureFiles && (h = this._scene.metadata.environmentTextureFiles)), await this.setSceneEnvironmentTexture(n, s, o, h);
    } else
      await this.checkSceneEmptyEnvironmentTexture();
  }
  async checkSceneEmptyEnvironmentTexture() {
    this._scene && this._sceneHelper && this._sceneHelper.containsPBRMaterials() && !this._scene.environmentTexture && await this.setDefaultSceneEnvironmentTexture();
  }
  async setDefaultSceneEnvironmentTexture() {
    const e = gi.Environment.EnvironmentTextureCDNUrl;
    await this.setSceneEnvironmentTexture(e);
  }
  async setSceneEnvironmentTexture(e, t, n, s, o) {
    return new Promise((h) => {
      if (this._scene && this._sceneHelper) {
        this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != e && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null);
        const c = () => {
          this.setLongRenderingNeeded();
        };
        this._scene.metadata || (this._scene.metadata = {}), delete this._scene.metadata.environmentTextureType, delete this._scene.metadata.environmentTextureSize, delete this._scene.metadata.environmentTextureExtensions, delete this._scene.metadata.environmentTextureFiles;
        let m = null;
        e.endsWith(".dds") ? m = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : e.endsWith(".hdr") ? (m = new BABYLON.HDRCubeTexture(
          e,
          this._scene,
          128,
          (o == null ? void 0 : o.get("mipMaps")) || void 0,
          (o == null ? void 0 : o.get("generateHarmonics")) || void 0,
          (o == null ? void 0 : o.get("gammaSpace")) || void 0,
          (o == null ? void 0 : o.get("prefilterOnLoad")) || void 0,
          c
        ), this._scene.metadata.environmentTextureType = "BABYLON.HDRCubeTexture", this._scene.metadata.environmentTextureSize = 128) : e.endsWith(".env") ? m = new BABYLON.CubeTexture(
          e,
          this._scene,
          null,
          !1,
          null,
          c,
          null,
          void 0,
          !0,
          void 0,
          !0
        ) : e.endsWith(".basis") ? m = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : n && n.length === 6 && s && s.length === 6 && (m = new BABYLON.CubeTexture(
          e,
          this._scene,
          n,
          !1,
          s,
          c
        ), this._scene.metadata.environmentTextureExtensions = n, this._scene.metadata.environmentTextureFiles = s), m && yi.whenTextureIsReadyAsync(m).then(() => {
          var x, B, I, F, M, Z, V, te;
          if (m && this._scene) {
            const P = (F = (I = (B = (x = this._zkScene) == null ? void 0 : x.get("config")) == null ? void 0 : B.get("general")) == null ? void 0 : I.get("environmentOptions")) == null ? void 0 : F.get("intensity"), K = (te = (V = (Z = (M = this._zkScene) == null ? void 0 : M.get("config")) == null ? void 0 : Z.get("general")) == null ? void 0 : V.get("environmentOptions")) == null ? void 0 : te.get("rotationY");
            P && (m.level = P), K ? m.rotationY = K : this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY, this._scene.environmentTexture = m, console.log("Environment texture loaded: " + e), this.setRenderingNeeded(), h();
          }
        });
      } else
        h();
    });
  }
  async loadSceneFromModelAsync(e, t, n) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      const s = t.get("rootUrl"), o = t.get("sceneFileName");
      s && o && await this.loadSceneFromRemoteFilesAsync(s, o, n);
    }
  }
  async loadSceneFromModelDataAsync(e, t, n, s) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      var o = "data:" + n;
      const h = t.get("rootUrl");
      h && await this.loadSceneFromRemoteFilesAsync(h, o, s);
    }
  }
  preSceneFileLoading() {
  }
  postSceneFileLoading() {
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync(e, t, n) {
    if (!this._engine)
      throw new Error("Unable to load scene when the 3D engine is null");
    try {
      this.fireBeginSceneLoadingEvent(), this.preSceneFileLoading(), this.pauseRendering(), this._engine.sceneFileRootUrl = e;
      let s = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, n);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), s.dispose();
        return;
      }
      if (await new Promise((x) => s.executeWhenReady(() => x())), this._destroyed)
        throw Logger.info("Loading scene engine destroyed"), s.dispose(), new Error("Engine destroyed while loading scene");
      const o = yi.visibleMeshesRequireDelayedLoading(s);
      o && this.fireBeginAssetsLoadingEvent();
      let h = 0;
      const c = s.meshes.filter((x) => x.isVisible);
      for (let x = 0; x < c.length; x++)
        await this.fireNextSceneMeshesLoadedEvent(x + 1, c.length), await new Promise((B) => {
          setTimeout(() => {
            B();
          }, 10);
        });
      await yi.whenAllVisibleMeshesAreReadyAsync(c), o && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = s, this._defaultBackgroundColor ? this._scene.clearColor.copyFrom(this._defaultBackgroundColor) : this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
      let m = [];
      for (let x = 0; x < this._scene.textures.length; x++) {
        const B = this._scene.textures[x];
        m.push(B.name), B instanceof BABYLON.Texture && B.onLoadObservable && B.onLoadObservable.add((I) => {
          this.setLongRenderingNeeded();
        });
      }
      if (this._scene && this._scene.metadata && !this._scene.metadata.delayedMaterials)
        for (let x = 0; x < this._scene.textures.length; x++)
          await this.fireNextSceneTextureLoadedEvent(x + 1, this._scene.textures.length), await new Promise((B) => {
            setTimeout(() => {
              B();
            }, 10);
          });
      if (await this.setupSceneAsync(), this._sceneHelper) {
        if (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials) {
          this._scene.useDelayedTextureLoading = !0;
          try {
            console.log("Trying loading delayed materials using Zip file"), await this._sceneHelper.loadAllDelayedMaterialFromZip(
              e,
              this.zkScene.get("version"),
              this.fireNextSceneTextureLoadedEvent.bind(this)
            ), console.log("Delayed materials loaded using zip file");
          } catch (x) {
            console.warn(
              "Delayed materials not loaded using zip file error:",
              x,
              ", trying to load delayed materials the stanrdad way"
            ), await this._sceneHelper.cleanupAllTemporaryMaterialsAsync(), await this._sceneHelper.loadAllDelayedMaterialsAsync(
              e,
              this.fireNextSceneTextureLoadedEvent.bind(this)
            );
          }
        }
        this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition();
        try {
          await this.reloadAllLoadingErrorTexturesAsync();
        } catch (x) {
          console.error(x);
        }
      }
      if (this._environmentManager) {
        const x = this._environmentManager.getSkyboxTexture();
        x && await yi.whenTextureIsReadyAsync(x);
      }
    } finally {
      this.resumeRendering(), this.postSceneFileLoading(), this.fireEndSceneLoadingEvent();
    }
  }
  getSkyboxTexture() {
    var e;
    return (e = this._environmentManager) == null ? void 0 : e.getSkyboxTexture();
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync_OLD(e, t, n) {
    return new Promise(async (s, o) => {
      this._engine || o(), this.preSceneFileLoading(), this._engine.sceneFileRootUrl = e;
      let h = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, n);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), h.dispose();
        return;
      }
      h.executeWhenReady(async () => {
        this._destroyed && (Logger.info("Loading scene engine destroyed"), h.dispose(), o());
        const c = h.meshes.filter((x) => x.isVisible), m = yi.visibleMeshesRequireDelayedLoading(h);
        m && this.fireBeginAssetsLoadingEvent(), await yi.whenAllVisibleMeshesAreReadyAsync(c), m && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = h;
        for (let x = 0; x < this._scene.textures.length; x++) {
          const B = this._scene.textures[x];
          B instanceof BABYLON.Texture && B.onLoadObservable && B.onLoadObservable.add((I) => {
            this.setLongRenderingNeeded();
          });
        }
        await this.setupSceneAsync(), this._sceneHelper && (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials && await this._sceneHelper.loadAllDelayedMaterialsAsync(e), this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition()), this.postSceneFileLoading(), s();
      });
    });
  }
  checkSceneShaderMaterials(e) {
    if (e instanceof Zakeke.Scene && e.get("shaderMaterials"))
      for (let t = 0; t < e.get("shaderMaterials").length; t++) {
        const n = e.get("shaderMaterials").at(t), s = n.get("name"), o = n.get("vertex"), h = n.get("fragment");
        if (s && o && h) {
          const c = { name: s, vertex: o, fragment: h };
          this.setupShadersStore(c);
        }
      }
  }
  checkShaderMaterial(e) {
    if (e && e instanceof Zakeke.Material && e.get("shaders")) {
      const n = e.get("shaders").get("name"), s = e.get("shaders").get("vertex"), o = e.get("shaders").get("fragment");
      if (n && s && o) {
        const h = { name: n, vertex: s, fragment: o };
        this.setupShadersStore(h);
      }
    }
  }
  setupShadersStore(e) {
    if (e && e.hasOwnProperty("name") && e.hasOwnProperty("vertex") && e.hasOwnProperty("fragment")) {
      var t = e.name + "VertexShader", n = e.name + "FragmentShader";
      BABYLON.Effect.ShadersStore[t] = e.vertex, BABYLON.Effect.ShadersStore[n] = e.fragment;
    }
  }
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  countSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.countSceneMeshes() : 0;
  }
  getVisibleMeshes() {
    return this._sceneHelper ? this._sceneHelper.getVisibleMeshes() : [];
  }
  getSceneBoundingInfo() {
    return this._sceneHelper ? this._sceneHelper.getSceneBoundingInfo() : null;
  }
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && (this._scene.meshes.forEach((e) => this.unselectSingleMesh(e)), this.fireFocusAttributesEvent({ groups: [] }));
  }
  selectUnselectMesh(e, t) {
    if (this._scene && (this._scene.meshes.forEach((s) => this.unselectSingleMesh(s)), t)) {
      let s = (h) => {
        this.selectSingleMesh(h);
        const c = h.getChildMeshes();
        c && c.forEach((m) => s(m));
      };
      const o = this._scene.getMeshByID(e);
      if (o) {
        s(o);
        const h = this.getGroupForMesh(o);
        h && (this.highlightGroupForMesh(o), this.fireGroupPickedEvent({ groupID: h.get("groupID") }));
        var n = this.getVisibleHiddenAttributesForMesh(o);
        this.fireFocusAttributesEvent({ groups: n }), n.length > 0 && this.highlightMeshes([o]);
      }
    }
  }
  selectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !0;
  }
  unselectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !1;
  }
  selectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !0);
  }
  unselectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !1);
  }
  selectUnselectMeshesWithMaterial(e, t) {
    if (this._scene && (this._scene.meshes.forEach((n) => this.unselectSingleMesh(n)), t)) {
      let n = (s) => {
        s.material && s.material.id === e && this.selectSingleMesh(s);
        const o = s.getChildMeshes();
        o && o.forEach((h) => {
          n(h);
        });
      };
      this._scene.meshes.forEach((s) => {
        n(s);
      });
    }
  }
  onPointerDown(e, t) {
    t.hit && t.pickedMesh ? this.selectMesh(t.pickedMesh.id) : this.unselectAllMeshes();
  }
  getSelectedRootMesh() {
    if (this._scene)
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        if (t.selected) {
          const n = t.parent;
          if (!n || !n.selected)
            return t;
        }
      }
    return null;
  }
  getMeshByID(e) {
    return this._scene ? this._scene.getMeshByID(e) : null;
  }
  getMeshByName(e) {
    return this._scene ? this._scene.getMeshByName(e) : null;
  }
  getMaterialByID(e) {
    return this._scene ? this._scene.getMaterialByID(e) : null;
  }
  setCameraLocation(e, t = !1, n = !0) {
    if (this._zkScene && this._sceneHelper) {
      const s = this._zkScene.getCameraLocation(e);
      if (s) {
        const o = new BABYLON.Vector3(
          s.get("px"),
          s.get("py"),
          s.get("pz")
        ), h = new BABYLON.Vector3(
          s.get("tx"),
          s.get("ty"),
          s.get("tz")
        );
        if (n) {
          if (!t)
            this._sceneHelper.animateCamera(h, o, 0.5);
          else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const c = this._sceneHelper.computeCameraAngleOfView(h, o);
            this._sceneHelper.animateCameraToFinalParamters(
              c.alpha,
              c.beta,
              this._camera.radius,
              this._camera.target,
              0.5
            );
          }
        } else if (!t)
          this._sceneHelper.moveCamera(h, o);
        else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
          const c = this._sceneHelper.computeCameraAngleOfView(h, o);
          this._sceneHelper.moveCameraToFinalParameters(
            c.alpha,
            c.beta,
            this._camera.radius,
            this._camera.target
          );
        }
      }
    }
    this.setRenderingNeeded();
  }
  updateCameraLocation(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.position, n = this._camera.target;
      e.set("px", t.x), e.set("py", t.y), e.set("pz", t.z), e.set("tx", n.x), e.set("ty", n.y), e.set("tz", n.z);
    }
  }
  adjustCamera(e) {
    this._sceneHelper && (e != null && e != null && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera(), this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  zoomIn() {
    this._sceneHelper && this._sceneHelper.zoomIn();
  }
  zoomOut() {
    this._sceneHelper && this._sceneHelper.zoomOut();
  }
  zoom(e) {
    this._sceneHelper && this._sceneHelper.zoom(e);
  }
  rotateCameraLeft(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraLeft(e, t);
  }
  rotateCameraRight(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraRight(e, t);
  }
  rotateCameraUp(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraUp(e, t);
  }
  rotateCameraDown(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraDown(e, t);
  }
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      const t = e ? this._scene.getMeshByID(e) : null;
      this._sceneHelper.setCameraPivot(t);
    }
  }
  setCameraZoomEnabled(e) {
    this._scene && this._sceneHelper && (this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  async executeScriptAsync(e) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeScriptAsync(e), this.notifyScriptExecution(e), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async executeActionsAsync(e, t, n) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeActionsAsync(e, t, n), this.notifyActionExecution(e, t, n), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async prefetchMeshesForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchMeshesForUnselectedOptionsAsync(e);
  }
  async prefetchDataForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchDataForUnselectedOptionsAsync(e);
  }
  async updatePBRMaterialsIntensity() {
    var s, o, h, c, m;
    const e = (s = this._scene) == null ? void 0 : s.materials, t = (h = (o = this._zkScene) == null ? void 0 : o.get("config")) == null ? void 0 : h.toJSON();
    if (!t || !e)
      return;
    const n = (m = (c = t == null ? void 0 : t.general) == null ? void 0 : c.environmentOptions) == null ? void 0 : m.pbrIntensity;
    n && (e == null || e.forEach((x) => {
      x instanceof BABYLON.PBRMaterial && (x.environmentIntensity = n);
    }));
  }
  async refreshModel() {
    var n, s, o, h, c, m, x, B;
    const e = (n = this._scene) == null ? void 0 : n.meshes, t = (o = (s = this._zkScene) == null ? void 0 : s.get("config")) == null ? void 0 : o.toJSON();
    if (!(!t || !e) && ((x = this._sceneHelper) == null || x.transformEntireScene(
      (h = t.model) == null ? void 0 : h.position,
      (c = t.model) == null ? void 0 : c.rotation,
      (m = t.model) == null ? void 0 : m.scale,
      this._modelParentNode
    ), (B = t.model) != null && B.config)) {
      const I = t.model.config.doubleSided;
      I !== void 0 && (e == null || e.forEach((F) => {
        F.material instanceof BABYLON.PBRMaterial && F.material && !(F instanceof BABYLON.GroundMesh) && (F.material.backFaceCulling = !I);
      }));
    }
  }
  async refreshEnvironment() {
    if (this._zkScene && this._scene) {
      const e = this._zkScene.getOrCreateGeneralConfig().get("environmentTexture"), t = this._zkScene.getOrCreateGeneralConfig().get("environmentOptions");
      e && t && !this._scene.textures.some((n) => n.url === e) && await this.setSceneEnvironmentTexture(e, void 0, void 0, void 0, t), (!this._environmentManager || this._environmentManager.zkScene != this._zkScene || this._environmentManager.scene != this._scene || this._environmentManager.isHologram != this._isHologram) && (this._environmentManager = new cg(this._zkScene, this._scene, this._isHologram)), this._environmentManager.update(), this.setLongRenderingNeeded(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded();
    }
  }
  highlightMeshes(e) {
    if (!e || Object.prototype.toString.call(e) !== "[object Array]" || this._highlightSize == 0)
      return;
    const t = this._highlightBlurHorizontalSize, n = this._highlightBlurVerticalSize, s = (c) => {
      c.isVisible && this._highlightLayer && this._highlightLayer.addMesh(c, BABYLON.Color3.FromHexString(this._highlightColor)), c.getChildMeshes().forEach((x) => {
        x instanceof BABYLON.Mesh && s(x);
      });
    }, o = (c) => {
      this._highlightLayer && this._highlightLayer.removeMesh(c), c.getChildMeshes().forEach((x) => {
        x instanceof BABYLON.Mesh && o(x);
      });
    }, h = () => {
      if (this._highlightAnimationID && (clearInterval(this._highlightAnimationID), this._highlightAnimationID = null), this._highlightCurrentMeshes && this._highlightCurrentMeshes.forEach((c) => {
        c instanceof BABYLON.Mesh && o(c);
      }), this._highlightLayer && (this._highlightLayer.blurHorizontalSize = t, this._highlightLayer.blurVerticalSize = n), this._highlightNextMeshes) {
        const c = this._highlightNextMeshes;
        this._highlightNextMeshes = [], this.highlightMeshes(c);
      }
    };
    if (this._highlightAnimationID) {
      this._highlightNextMeshes = e, h();
      return;
    }
    if (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer) {
      this._highlightCurrentMeshes = e, e.forEach((F) => {
        F instanceof BABYLON.Mesh && s(F);
      });
      const c = 800, m = 20, x = m / c;
      let B = t, I = n;
      this._highlightAnimationID = window.setInterval(() => {
        this._highlightLayer && (B -= t * x, I -= n * x, B = Math.max(0, B), I = Math.max(0, I), B >= 0 && (this._highlightLayer.blurHorizontalSize = B), I >= 0 && (this._highlightLayer.blurVerticalSize = I), (B == 0 || I == 0) && h(), this.setRenderingNeeded());
      }, m), this.setRenderingNeeded();
    }
  }
  highlightGroupForMesh(e) {
    const t = this.getGroupForMesh(e);
    this.highlightGroup(t);
  }
  highlightGroupByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributeGroups").findWhere({ groupID: e });
      t ? this.highlightGroup(t) : this.highlightGroup(null);
    }
  }
  highlightGroup(e) {
    if (this._zkScene && this._scene && e) {
      const n = e.get("meshSelector");
      if (n) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          n,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getGroupForMesh(e) {
    if (this._zkModel && this._zkScene && this._scene && e && this._sceneHelper) {
      const t = this._zkModel.get("attributeGroups");
      for (let n = 0; n < t.length; n++) {
        const s = t.at(n), o = s.get("meshSelector");
        if (o) {
          const h = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            o,
            MPlaza.SceneElementType.Mesh
          );
          for (let c = 0; c < h.length; c++) {
            let m = h[c];
            if (e.id == m.id || this._sceneHelper.meshHasParent(e.id, m.id))
              return s;
          }
        }
      }
    }
    return null;
  }
  highlightAttributeByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributes").findWhere({ attributeID: e });
      t ? this.highlightAttribute(t) : this.highlightAttribute(null);
    }
  }
  highlightAttribute(e) {
    if (this._zkScene && this._scene && e) {
      const n = e.get("meshSelector");
      if (n) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          n,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getVisibleHiddenAttributesForMesh(e) {
    const t = [], n = (o) => {
      let h = t.find((c) => c.groupId == o);
      return h || (h = { groupId: o, visibleAttributes: [], hiddenAttributes: [] }, t.push(h)), h;
    };
    if (this._zkModel && this._zkScene && this._scene && e) {
      const o = this._zkModel.get("attributes");
      for (let h = 0; h < o.length; h++) {
        const c = o.at(h), m = c.get("attributeID"), x = c.get("meshSelector");
        if (x) {
          const B = n(c.get("groupID"));
          var s = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            x,
            MPlaza.SceneElementType.Mesh
          );
          s.find((F) => this._sceneHelper ? e.id == F.id || this._sceneHelper.meshHasParent(e.id, F.id) : !1) ? B.visibleAttributes.push(m) : B.hiddenAttributes.push(m);
        }
      }
    }
    return t.filter((o) => o.visibleAttributes.length > 0);
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireGroupPickedEvent(e) {
    for (let t = 0; t < this._groupPickedListeners.length; t++)
      this._groupPickedListeners[t](e);
  }
  addGroupPickedListener(e) {
    this._groupPickedListeners.push(e);
  }
  fireFocusAttributesEvent(e) {
    for (let t = 0; t < this._focusAttributesListeners.length; t++)
      this._focusAttributesListeners[t](e);
  }
  addFocusAttributesListener(e) {
    this._focusAttributesListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addRemoveMessageListener(e);
  }
  addScriptExecutionListener(e) {
    this._scriptExecutionListeners.push(e);
  }
  removeScriptExecutionListener(e) {
    const t = this._scriptExecutionListeners.indexOf(e);
    t !== -1 && this._scriptExecutionListeners.splice(t, 1);
  }
  setEventMessages(e) {
    this._designEventMessages = e, this._sceneDesignManager && this._sceneDesignManager.setEventMessages(e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointPickedListener(e);
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentShownListener(e);
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentHiddenListener(e);
  }
  // begin assets loading
  addBeginAssetsLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginAssetsLoadingEvent() {
    Logger.info("Begin Assets Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndAssetsLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndAssetsLoadingEvent() {
    Logger.info("End Assets Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  addNextSceneMeshesLoadedListeners(e) {
    this._nextSceneMeshesLoadedListeners.push(e);
  }
  async fireNextSceneMeshesLoadedEvent(e, t) {
    let n = [];
    for (let s = 0; s < this._nextSceneMeshesLoadedListeners.length; ++s)
      n.push(this._nextSceneMeshesLoadedListeners[s](e, t));
    await Promise.all(n);
  }
  addNextSceneTextureLoadedListeners(e) {
    this._nextSceneTexturesLoadedListeners.push(e);
  }
  async fireNextSceneTextureLoadedEvent(e, t) {
    let n = [];
    for (let s = 0; s < this._nextSceneTexturesLoadedListeners.length; ++s)
      n.push(this._nextSceneTexturesLoadedListeners[s](e, t));
    await Promise.all(n);
  }
  addBeginSceneLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginSceneLoadingEvent() {
    Logger.info("Begin Scene Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndSceneLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndSceneLoadingEvent() {
    Logger.info("End Scene Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  // --------------------------------------------------------------
  async getSceneScreenshotAsync(e, t) {
    return this._sceneHelper ? (this.setRenderingNeeded(), await this._sceneHelper.takeScreenshotAsync(e, t)) : null;
  }
  async getSceneContentScreenshotAsync(e, t, n = 0, s, o, h, c, m) {
    if (!this._sceneHelper || !this.scene || !this.zkModel || !this.zkScene)
      return null;
    this.preSceneContentScreenshot(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this.setRenderingNeeded();
    let x = "";
    const B = c ? typeof c == "string" ? BABYLON.Color4.FromHexString(c) : c : void 0;
    if (o)
      x = await this._sceneHelper.takeContentScreenshotAsync(e, t, B);
    else {
      const F = this._canvas;
      if (F) {
        const M = F.width, Z = F.height;
        F.width = e, F.height = t;
        const V = this.scene.activeCamera.position.clone(), te = this.scene.activeCamera.target.clone(), P = h ? {
          position: new BABYLON.Vector3(h.get("px"), h.get("py"), h.get("pz")),
          target: new BABYLON.Vector3(h.get("tx"), h.get("ty"), h.get("tz"))
        } : {
          position: this._scene.activeCamera.position,
          target: this._scene.activeCamera.target
        };
        this._scene.activeCamera.position = P.position, this._scene.activeCamera.target = P.target, this._scene.render(), x = await this._sceneHelper.takeContentScreenshotAsync(e, t, B), this._scene.activeCamera.position = V, this._scene.activeCamera.target = te, F.width = M, F.height = Z;
      }
    }
    console.log("senza Utils");
    let I;
    if (m != null ? I = await jw(x, m) : I = await Zh(x), I || (console.error("Failed trimming image.", x), I = x), I = await Zw(I, e, t, n), !I)
      throw new Error("Failed resizing image.");
    return this.refreshEnvironment(), this.postSceneContentScreenshot(), I;
  }
  preSceneContentScreenshot() {
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
  }
  postSceneMaterialScreenshot() {
    this.refreshEnvironment();
  }
  async getMaterialScreenshotAsync(e, t, n) {
    if (!this._scene || !this._sceneHelper)
      return null;
    this.preSceneMaterialScreenshot();
    let s = null;
    const o = await this.getSceneRootUrl();
    if (o) {
      const h = await fo.getPreviewsAsync(
        this._scene,
        o,
        [e],
        {
          width: t,
          height: n,
          crop: !0
        },
        !1
      ), c = Object.keys(h.previewFiles);
      c.length == 1 && (s = h.previewFiles[c[0]]);
    } else {
      const h = await this._sceneHelper.takeMaterialScreenshotAsync(e, t, n), c = await Zh(h);
      c && (s = c);
    }
    return this.postSceneMaterialScreenshot(), s;
  }
  // Used to avoid multiple listeners when using react redraw
  clearListeners() {
    this._groupPickedListeners = [], this._focusAttributesListeners = [], this._scriptExecutionListeners = [];
  }
  // Il parametro showDesign è stato aggiunto per impedire la visualizzazione dei design sugli oggetti.
  // Un utilizzo di questo parametro viene fatto quando si vogliono ottenere le informazioni sugli item
  // del design senza volerli visualizzare perché ad esempio potrebbero essere elementi di testo con
  // dei font ancora non caricati. In tal caso andrebbero prima caricati i font e poi visualizzato il design
  async renderDesignAsync(e, t = !0) {
    const n = this._renderDesignQueue;
    return this._renderDesignQueue = n.catch(() => {
    }).then(() => this._renderDesignInternalAsync(e, t)), this._renderDesignQueue;
  }
  async _renderDesignInternalAsync(e, t) {
    if (this._scene && this._zkScene && this._zkModel && e) {
      if (this._sceneDesignManager && this._sceneDesignManager.isForModels(this._scene, this._zkModel, e))
        this._sceneDesignManager.showDesign = t, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync();
      else {
        this.emptyArFileCache(), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneDesignManager = new e1(
          this._scene,
          this._zkScene,
          this._zkModel,
          e,
          t
        ), this._sceneDesignManager.addRenderingNeededListener(() => {
          this.setLongRenderingNeeded(), this.notifyDesignChanged(e);
        }), this._sceneDesignManager.setCustomizerGrids(this._grids), this._sceneDesignManager.setEventMessages(this._designEventMessages);
        for (const n of this._designNotifyMessageListeners)
          this._sceneDesignManager.addNotifyMessageListener(n);
        for (const n of this._designRemoveMessageListeners)
          this._sceneDesignManager.addRemoveMessageListener(n);
        await this._sceneDesignManager.refreshAsync();
      }
      this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded();
    }
  }
  resetDesign() {
    this._scene && this._zkScene && this._zkModel && (this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded());
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  async refreshMeshesDesignAsync(e, t) {
    e && Object.prototype.toString.call(e) === "[object Array]" && e.forEach(async (n) => await this.refreshMeshDesignAsync(n.id, void 0, t || void 0));
  }
  async refreshMeshDesignAsync(e, t = 0, n) {
    var s;
    (s = this._sceneDesignManager) == null || s.refreshMeshDesignAsync(e, t, n);
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._sceneDesignManager) == null || t.setCustomizerGrids(e);
  }
  removeDesignItem(e, t) {
    var n;
    t == null || t.deselectAll(), t == null || t.removeItemByGuid(e), t == null || t.updateSelectionState(), (n = this._sceneDesignManager) == null || n.removeItem(e);
  }
  addDesignItemText(e, t, n) {
    var s;
    return n ? n.addTextElement(null, e, !1) : (s = this._sceneDesignManager) == null ? void 0 : s.addItemText(e, t);
  }
  async addDesignItemImage(e, t, n) {
    var o;
    return n ? await n.insertImageById(e) : await ((o = this._sceneDesignManager) == null ? void 0 : o.addItemImage(e, t));
  }
  getDesignItemsInfo(e) {
    var t;
    return ((t = this._sceneDesignManager) == null ? void 0 : t.getItemsInfo(e)) || [];
  }
  setDesignItemText(e, t, n) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemText(e, t), n == null || n.modifyTextElementContentByGuid(e, t);
  }
  async refreshDesignTextureForItem(e) {
    var t;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.refreshTextureForItem(e));
  }
  /**
   * Get font weights from font variations - same logic as MeshDesignManager
   */
  getFontWeights(e) {
    let t = e.faces.map((F) => F.variation), n = t.filter((F) => F.startsWith("i")).map((F) => parseInt(F.charAt(F.length - 1)) * 100), s = t.filter((F) => F.startsWith("n")).map((F) => parseInt(F.charAt(F.length - 1)) * 100), o = s.filter((F) => F <= 500).sort((F, M) => M - F)[0], h = n.filter((F) => F <= 500).sort((F, M) => M - F)[0], c = s.filter((F) => F == 700), m = (c.length ? c : s.filter((F) => F > 500)).sort((F, M) => F - M)[0], x = n.filter((F) => F == m);
    x = x.length ? x : n.filter((F) => F == 700);
    let B = (x.length ? x : n.filter((F) => F > 500)).sort((F, M) => F - M)[0];
    const I = [];
    return o && I.push({ style: "normal", weight: o }), m && I.push({ style: "normal", weight: m }), h && I.push({ style: "italic", weight: h }), B && I.push({ style: "italic", weight: B }), I;
  }
  setDesignItemBold(e, t, n, s) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemBold(e, t, n);
  }
  setDesignItemItalic(e, t, n, s) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemItalic(e, t, n);
  }
  setDesignItemColor(e, t, n) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemColor(e, t), n == null || n.modifyTextElementFillColorByGuid(e, t);
  }
  setDesignItemFontFamily(e, t, n) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemFontFamily(e, t), n == null || n.modifyTextElementFontFamilyByGuid(e, t);
  }
  setDesignItemFontWeight(e, t, n, s) {
    let o = s == null ? void 0 : s.findItemByGuid(e);
    if (!o || !s || !n)
      return;
    let c = s.getTextItemInfo(o).fontWeight.split(" "), m = c.includes("italic"), x = !1;
    for (let F of c) {
      let M = parseInt(F);
      if (!isNaN(M)) {
        x = M > 500;
        break;
      }
    }
    const B = this.getFontWeights(n);
    let I;
    if (m) {
      const F = B.filter((M) => M.style === "italic");
      if (F.length === 0) {
        m = !1;
        const M = B.filter((Z) => Z.style === "normal");
        if (x) {
          const Z = M.filter((V) => V.weight > 500).sort((V, te) => V.weight - te.weight)[0];
          I = Z == null ? void 0 : Z.weight;
        } else {
          const Z = M.filter((V) => V.weight <= 500).sort((V, te) => te.weight - V.weight)[0];
          I = Z == null ? void 0 : Z.weight;
        }
      } else if (x) {
        const M = F.filter((Z) => Z.weight > 500).sort((Z, V) => Z.weight - V.weight)[0];
        I = M == null ? void 0 : M.weight;
      } else {
        const M = F.filter((Z) => Z.weight <= 500).sort((Z, V) => V.weight - Z.weight)[0];
        I = M == null ? void 0 : M.weight;
      }
    } else {
      const F = B.filter((M) => M.style === "normal");
      if (x) {
        const M = F.filter((Z) => Z.weight > 500).sort((Z, V) => Z.weight - V.weight)[0];
        I = M == null ? void 0 : M.weight;
      } else {
        const M = F.filter((Z) => Z.weight <= 500).sort((Z, V) => V.weight - Z.weight)[0];
        I = M == null ? void 0 : M.weight;
      }
    }
    if (I !== void 0) {
      let F = m ? `italic ${I}` : I.toString();
      s.modifyTextElementFontWeight(o, F);
    }
  }
  async setDesignItemImage(e, t, n) {
    var s;
    await ((s = this._sceneDesignManager) == null ? void 0 : s.setItemImage(e, t)), n == null || n.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t, n, s) {
    var h;
    (h = this._sceneDesignManager) == null || h.setItemTextOnPath(e, t, n);
    let o = s == null ? void 0 : s.findItemByGuid(e);
    n ? s == null || s.convertToTextOnPath(o) : s == null || s.convertToTextArea(o);
  }
  removeDesignItemImage(e, t) {
    var n;
    t == null || t.deselectAll(), t == null || t.removeImageByGuid(e), t == null || t.updateSelectionState(), (n = this._sceneDesignManager) == null || n.removeItemImage(e);
  }
  async setDesignItemSize(e, t, n, s) {
    var o;
    s && await s.setItemSize(e, t, n), await ((o = this._sceneDesignManager) == null ? void 0 : o.setItemSize(e, t, n));
  }
  setDesignItemConstraints(e, t, n) {
    var s;
    (n == null ? void 0 : n.setItemConstraints(e, t)) ?? ((s = this._sceneDesignManager) == null || s.setItemConstraints(e, t));
  }
  setDesignPrintingMethod(e, t, n) {
    var s;
    (n == null ? void 0 : n.setDesignPrintingMethod(e, t)) ?? ((s = this._sceneDesignManager) == null || s.setDesignPrintingMethod(e, t));
  }
  setDesignVisibility(e, t) {
    var n;
    (n = this._sceneDesignManager) == null || n.setDesignVisibility(e, t);
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let e = 0; e < this._scene.materials.length; e++) {
        const t = this._scene.materials[e];
        this.setupShaderMaterialCameraPosition(t);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    this._scene && this._scene.activeCamera && e && e instanceof BABYLON.ShaderMaterial && e.setVector3("cameraPosition", this._scene.activeCamera.position);
  }
  setMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.setMeshLocationByID(e);
  }
  async explodeMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.explodeMeshes();
  }
  async collapseMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.collapseMeshes();
  }
  dracoDecodingFunction(e, t, n) {
    this.decodeDracoFile(e, t, n);
  }
  decodeDracoFile(e, t, n) {
    var s = (/* @__PURE__ */ new Date()).getTime(), o = new Uint8Array(t), h = msgpack.decode(o);
    this.dracoCompression.decodeMeshAsync(h.data, h.attributes).then(function(c) {
      let m = {};
      c && (c.indices && (m.indices = c.indices), c.positions && (m.positions = c.positions), c.normals && (m.normals = c.normals), c.tangents && (m.tangents = c.tangents), c.uvs && (m.uvs = c.uvs), c.uvs2 && (m.uv2s = c.uvs2), c.uvs3 && (m.uv3s = c.uvs3), c.uvs4 && (m.uv4s = c.uvs4), c.uvs5 && (m.uv5s = c.uvs5), c.uvs6 && (m.uv6s = c.uvs6));
      var x = /* @__PURE__ */ new Date(), B = x.getTime(), I = B - s, F = x.getHours() + ":" + x.getMinutes() + ":" + x.getSeconds() + "." + x.getMilliseconds();
      console.log(
        "Draco Decoding [" + F + "] - " + e + "	" + t.byteLength + "	" + I + " ms"
      ), n && n(m);
    });
  }
  exportSceneToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportSceneToBabylon();
  }
  exportVisibleMeshesToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportVisibleMeshesToBabylon();
  }
  async exportMeshesForTyOnToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : await this._sceneHelper.exportMeshesForTyOnToBabylon();
  }
  async exportMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    const t = this._scene.getMeshById(e);
    return t ? await this._sceneHelper.exportMeshToBabylon(t) : null;
  }
  async downloadMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return;
    const t = this._scene.getMeshById(e);
    t && await this._sceneHelper.downloadMeshBabylonAsync(t);
  }
  async saveSceneOnDatabaseAsync(e) {
    const t = this.exportSceneToBabylon();
    if (t) {
      const n = new ed();
      await n.openAsync(), await n.saveFileAsync(e, t);
    }
  }
  async saveVisibleMeshesOnDatabaseAsync(e) {
    const t = await this.exportMeshesForTyOnToBabylon();
    if (t) {
      const n = new ed();
      await n.openAsync(), await n.saveFileAsync(e, t);
    }
  }
  async saveGlbOnDatabaseAsync(e) {
    let t = null, n = "";
    if (t = await this.exportSceneToLocalGLBAsync(), t) {
      const s = await t.arrayBuffer(), o = Math.random().toString(36).substring(7), h = new FormData();
      h.append("blob", new Blob([s]), `model_${o}.glb`);
      try {
        const c = await fetch(Zakeke.config.baseApiUrl + "tryonassetupload/asset-upload", {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + window.token
          },
          body: h
        });
        if (c.status === 200)
          return n = await c.text(), n = n.replace(/^"|"$/g, "").substring(n.indexOf("fileUrl=") + 8 - 1), console.log("solo parametro restituito da asset-upload", n), n;
        console.error("Error uploading model", c);
      } catch (c) {
        console.error("Error uploading model", c);
      }
    }
    return n;
  }
  getArFileUrlCacheKey(e, t, n = "usdz") {
    let s = "scene_" + e;
    if (t && (s += "_code_" + t), this._sceneDesignManager) {
      var o = this._sceneDesignManager.getDesignItemsJson();
      if (o) {
        var h = CryptoJS.SHA1(o).toString();
        s += "_design_" + this._sceneDesignManager.getDesignID() + "_" + h;
      }
    }
    return s += "_" + n, s;
  }
  getCachedArFileUrl(e, t, n = "usdz") {
    var s = this.getArFileUrlCacheKey(e, t, n);
    return this._arFileUrls.hasOwnProperty(s) ? this._arFileUrls[s] : null;
  }
  cacheArFileUrl(e, t, n, s) {
    if (s) {
      var o = this.getArFileUrlCacheKey(e, t || void 0, n);
      this._arFileUrls[o] = s;
    }
  }
  async exportMeshToGLBBlob(e) {
    var o, h, c, m;
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    let t = null;
    const n = this._zkScene.get("rootUrl");
    n && (t = n), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToRasterizedTextures()), (h = this._sceneDesignManager) == null || h.expandCanvasMeshes(0.05);
    let s = await this._sceneHelper.exportMeshToGLBBlob(t, e);
    return console.log("dopo l'export faccio rientrare l'expand", s), (c = this._sceneDesignManager) == null || c.expandCanvasMeshes(-0.05), await ((m = this._sceneDesignManager) == null ? void 0 : m.changeToDynamicTextures()), s;
  }
  async exportSceneToUsdzAsync(e, t, n) {
    var B, I, F, M;
    if (!this._zkScene || !this._sceneHelper)
      return null;
    const s = "usdz";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, s)), o)
      return o;
    let h = null, c = null;
    const m = this._zkScene.get("name");
    m && (h = m);
    const x = this._zkScene.get("rootUrl");
    return x && (c = x), await ((B = this._sceneDesignManager) == null ? void 0 : B.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToUsdzAsync(
      h,
      c,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((I = this.zkScene) == null ? void 0 : I.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (F = this._zkScene) == null ? void 0 : F.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((M = this._sceneDesignManager) == null ? void 0 : M.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, s, o), o;
  }
  async exportMeshToUsdzAsync(e) {
    var n, s, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const c = this._zkScene.get("rootUrl");
      c && (h = c), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const m = await this._sceneHelper.exportMeshToUsdzAsync(
        h,
        t,
        ((s = this.zkScene) == null ? void 0 : s.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), Logger.info("USDZ: " + m), m;
    }
    return null;
  }
  async exportSceneToRemoteGlTFAsync(e, t, n) {
    var m, x, B, I;
    if (!this._sceneHelper)
      return null;
    const s = "glTF";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, s)), o)
      return o;
    let h = null, c = null;
    if (this._zkScene) {
      const F = this._zkScene.get("name");
      F && (h = F);
      const M = this._zkScene.get("rootUrl");
      M && (c = M);
    }
    return await ((m = this._sceneDesignManager) == null ? void 0 : m.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToRemoteGlTFAsync(
      h,
      c,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((x = this.zkScene) == null ? void 0 : x.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (B = this._zkScene) == null ? void 0 : B.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((I = this._sceneDesignManager) == null ? void 0 : I.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, s, o), Logger.info("GlTF: " + o), o;
  }
  async exportMeshToRemoteGlTFAsync(e) {
    var n, s, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const c = this._zkScene.get("rootUrl");
      c && (h = c), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const m = await this._sceneHelper.exportMeshToRemoteGlTFAsync(
        h,
        t,
        ((s = this.zkScene) == null ? void 0 : s.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + m), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), m;
    }
    return null;
  }
  async exportSceneToRemoteGLBAsync(e, t, n) {
    var m, x, B, I;
    if (!this._sceneHelper)
      return null;
    const s = "glb";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, s)), o)
      return o;
    let h = null, c = null;
    if (this._zkScene) {
      const F = this._zkScene.get("name");
      F && (h = F);
      const M = this._zkScene.get("rootUrl");
      M && (c = M);
    }
    return await ((m = this._sceneDesignManager) == null ? void 0 : m.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToRemoteGLBAsync(
      h,
      c,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((x = this.zkScene) == null ? void 0 : x.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (B = this._zkScene) == null ? void 0 : B.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((I = this._sceneDesignManager) == null ? void 0 : I.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, s, o), Logger.info("GLB: " + o), o;
  }
  async exportMeshToRemoteGLBAsync(e) {
    var n, s, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const c = this._zkScene.get("rootUrl");
      c && (h = c), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const m = await this._sceneHelper.exportMeshToRemoteGLBAsync(
        h,
        t,
        ((s = this.zkScene) == null ? void 0 : s.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + m), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), m;
    }
    return null;
  }
  // Esporta la scena nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportSceneToARAsync(e, t) {
    var h, c;
    let n = [];
    if (!this._sceneHelper)
      return n;
    let s = null, o = null;
    if (this._zkScene) {
      const m = this._zkScene.get("name");
      m && (s = m);
      const x = this._zkScene.get("rootUrl");
      x && (o = x);
    }
    return await ((h = this._sceneDesignManager) == null ? void 0 : h.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), n = await this._sceneHelper.exportSceneToARMultiformatAsync(
      s,
      o,
      ["usdz", "glb"],
      e,
      t
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((c = this._sceneDesignManager) == null ? void 0 : c.changeToDynamicTextures()), n;
  }
  // Esporta la mesh nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportMeshToARAsync(e) {
    var s, o, h;
    let t = [];
    const n = this.getMeshByID(e);
    if (n && this._zkScene && this._sceneHelper) {
      let c = null;
      const m = this._zkScene.get("rootUrl");
      m && (c = m), await ((s = this._sceneDesignManager) == null ? void 0 : s.changeToRasterizedTextures()), t = await this._sceneHelper.exportMeshToARMultiformatAsync(
        c,
        n,
        ["usdz", "glb"],
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      ), await ((h = this._sceneDesignManager) == null ? void 0 : h.changeToDynamicTextures());
    }
    return t;
  }
  isAREnabled() {
    if (!this._zkScene)
      return !1;
    let e = this._zkScene.getAREnabled();
    return e != null && e && this._sceneHelper != null && // this._sceneHelper.getMeshesForAR().length > 0 &&
    this._sceneHelper.checkMaterialsForAR();
  }
  async exportSceneToLocalGLBAsync() {
    var t, n;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalGLBBlobAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalGLBAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalGLBAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  async exportSceneToLocalUSDZAsync() {
    var t, n;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalUSDZUrlAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalUSDZAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalUSDZAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  getSceneRootUrl() {
    return new Promise((e, t) => {
      let n = null;
      this._zkScene ? (n = this._zkScene.get("rootUrl") || null, n ? e(n) : jQuery.ajax({
        url: this._zkScene.getSceneRootUrlApiUrl(),
        type: "GET",
        success: function(s) {
          n = s, e(n);
        },
        error: function(s, o, h) {
          t(h);
        }
      })) : e(n);
    });
  }
  isTryOnMeshVisibleEnabledToShow() {
    const e = this.getVisibleMeshes();
    for (const t of e) {
      const n = t.getChildren();
      if (n.length > 0 && n.find(
        (o) => this._sceneHelper.isTryOnEnabledForMesh(o)
      ) && this._sceneHelper.isTryOnEnabledForMesh(t))
        return !0;
    }
    return !1;
  }
  getTryOnMeshVisible() {
    const e = this.getVisibleMeshes();
    for (let t of e) {
      const n = t.getChildren();
      if (n.length > 0 && !t.parent && n.find(
        (o) => {
          var h;
          return (h = this._sceneHelper) == null ? void 0 : h.isTryOnEnabledForMesh(o);
        }
      ))
        return t;
    }
    return null;
  }
  getFrameDAMSettings() {
    if (this._zkScene) {
      const e = this._zkScene.getFrameDAMSettings() ?? null;
      if (e)
        return JSON.parse(e);
    }
    return null;
  }
  getMeshFineTuningData(e) {
    const t = typeof e == "string" ? this.getMeshByID(e) : e;
    return t && t.metadata && t.metadata.tryOnFineTuningSettings ? t.metadata.tryOnFineTuningSettings : null;
  }
  getDAMFineTuningData() {
    var e, t;
    return (e = this.zkScene) != null && e.getFrameDAMSettings() && ((t = this.getFrameDAMSettings()) == null ? void 0 : t.finetuning) || null;
  }
  getTryOnFineTuningMeshVisible() {
    var t;
    const e = this.getVisibleMeshes();
    for (const n of e) {
      const s = n.getChildren();
      if (s.length > 0 && s.find(
        (h) => {
          var c;
          return (c = this._sceneHelper) == null ? void 0 : c.isTryOnEnabledForMesh(h);
        }
      ) && (t = n == null ? void 0 : n.metadata) != null && t.tryOnFineTuningSettings)
        return n;
    }
    return null;
  }
  refreshInfoPoints() {
    if (!(this._zkScene && this._zkScene.getInfoPointsEnabled() && this.canShowInfoPoints)) {
      this.disposeInfoPointsManager(), this.setLongRenderingNeeded();
      return;
    }
    const t = this.getInfoPointsManagerStyle();
    let n = null;
    this._infoPointsManager || this._scene && this._zkScene && (this._infoPointsManager = new o1(this._zkScene, this._scene, t), this._infoPointPickedListeners && this._infoPointPickedListeners.length > 0 && this._infoPointsManager.addInfoPointPickedListenerRange(this._infoPointPickedListeners), this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0 && this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners), this._infoPointContentHiddenListeners && this._infoPointContentHiddenListeners.length > 0 && this._infoPointsManager.addInfoPointContentHiddenListenerRange(
      this._infoPointContentHiddenListeners
    ), this._infoPointsManager.onBeforeShowImages = () => {
      n === null && (n = this.antiAliasConfig.enabled), this.antiAliasConfig.enabled = !1, this.disableAntialiasing();
    }, this._infoPointsManager.onAfterShowImages = () => {
      this.antiAliasConfig.enabled = n, n = null, this.enableAntialiasing(), this.setLongRenderingNeeded();
    }, this._infoPointsManager.addRenderingNeededListener(() => this.setRenderingNeeded())), this._infoPointsManager && (this.updateInfoPointsManagerStyle(), this._infoPointsManager.canShowInfoPointsContent = this.canShowInfoPointsContent, this._infoPointsManager.refresh()), this.setLongRenderingNeeded();
  }
  getInfoPointsManagerStyle() {
    const e = this._infoPointsManagerStyle ? this._infoPointsManagerStyle : {};
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsStyleConfig();
      t && (e.infoPointsStyle || (e.infoPointsStyle = {}), t.get("borderColor") && (e.infoPointsStyle.borderColor = t.get("borderColor")), t.get("innerPointColor") && (e.infoPointsStyle.innerPointColor = t.get("innerPointColor")), t.get("color") && (e.infoPointsStyle.color = t.get("color")), t.get("highlightColor") && (e.infoPointsStyle.highlightColor = t.get("highlightColor")));
    }
    return e;
  }
  updateInfoPointsManagerStyle() {
    if (this._infoPointsManager) {
      const e = this.getInfoPointsManagerStyle();
      this._infoPointsManager.applyStyle(e);
    }
  }
  showInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.showInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  hideInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.hideInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  // try to reload all textures with loading errors
  async reloadAllLoadingErrorTexturesAsync() {
    if (this._zkScene && this._sceneHelper) {
      const e = this._zkScene.get("rootUrl");
      e && await this._sceneHelper.reloadAllLoadingErrorTexturesAsync(e);
    }
  }
  // try to reload the material textures with loading errors
  async reloadMaterialLoadingErrorTexturesAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadMaterialLoadingErrorTexturesAsync(t, e);
    }
  }
  // try to reload the texture having loading errors
  async reloadLoadingErrorTextureAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadLoadingErrorTextureAsync(t, e);
    }
  }
  // were there any loading errors for the texture?
  isTextureLoadingError(e) {
    return this._sceneHelper ? this._sceneHelper.isTextureLoadingError(e) : !1;
  }
  // the material has some texture with loading errors
  materialHasLoadingErrorTextues(e) {
    return this._sceneHelper ? this._sceneHelper.materialHasLoadingErrorTextues(e) : !1;
  }
  // Check if any texture in the scene has loading errors
  hasAnyTextureLoadingErrors() {
    return !this._scene || !this._sceneHelper ? !1 : this._scene.textures.some((e) => this._sceneHelper.isTextureLoadingError(e));
  }
  // Get all textures with loading errors
  getTexturesWithLoadingErrors() {
    return !this._scene || !this._sceneHelper ? [] : this._scene.textures.filter((e) => this._sceneHelper.isTextureLoadingError(e));
  }
  // Get all materials that have at least one texture with loading errors
  getMaterialsWithLoadingErrors() {
    return this._sceneHelper ? this._sceneHelper.getAllMaterials().filter((e) => this._sceneHelper.materialHasLoadingErrorTextues(e)) : [];
  }
  notifyCameraMovement() {
    if (this._isHologramSource && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.postMessage({
        type: "camera-movement",
        target: { x: this._camera.target.x, y: this._camera.target.y, z: this._camera.target.z },
        alpha: this._camera.alpha,
        beta: this._camera.beta,
        radius: this._camera.radius
      });
    }
  }
  notifyScriptExecution(e) {
    if (this._isHologramSource) {
      const t = e.map((s) => ({
        attributeID: s.attributeID,
        selectedValue: s.selectedValue,
        actions: s.actions.map((o) => ({
          attributeGuid: o.get("actionGuid"),
          name: o.get("name"),
          actionTypeID: o.get("actionTypeID"),
          sceneElementTypeID: o.get("sceneElementTypeID"),
          selector: o.get("selector"),
          propertyName: o.get("propertyName"),
          value: o.get("value"),
          execOrder: o.get("execOrder"),
          deviceTypes: o.get("deviceTypes")
        }))
      }));
      let n = this.getOrCreateBroadcastChannel();
      if (!n)
        return;
      n.postMessage({
        type: "script-execution",
        script: t
      });
    }
    for (const t of this._scriptExecutionListeners)
      t(e);
  }
  notifyDesignChanged(e) {
    if (this._isHologramSource) {
      let t = this.getOrCreateBroadcastChannel();
      if (!t)
        return;
      t.postMessage({
        type: "design-changed",
        design: e.toJSON()
      });
    }
  }
  notifyActionExecution(e, t, n) {
    this.notifyScriptExecution([
      {
        attributeID: e,
        selectedValue: t,
        actions: n
      }
    ]);
  }
  attachBroadcastChannelEventHandlers() {
    if (this._isHologram && !this._isHologramSource) {
      var e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.onmessage = (t) => this.onBroadcastMessageReceived(t);
    }
  }
  detachBroadcastChannelEventHandlers() {
    this._broadcastChannel && (this._broadcastChannel.onmessage = null);
  }
  onBroadcastMessageReceived(e) {
    this._isHologram && e && e.data && e.data.type && (e.data.type === "camera-movement" ? this.processCameraMovementEvent(e) : e.data.type === "script-execution" ? this.processScriptExecution(e) : e.data.type === "design-changed" && this.processDesignChanged(e));
  }
  processCameraMovementEvent(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && e && e.data && (this._camera.target = new BABYLON.Vector3(e.data.target.x, e.data.target.y, e.data.target.z), this._camera.alpha = e.data.alpha, this._camera.beta = e.data.beta, this._camera.radius = e.data.radius, this.setRenderingNeeded());
  }
  processScriptExecution(e) {
    if (e && e.data && e.data.script && Object.prototype.toString.call(e.data.script) === "[object Array]") {
      var t = e.data.script.map(
        (n) => ({
          attributeID: n.attributeID,
          selectedValue: n.selectedValue,
          actions: n.actions.map((s) => new MPlaza.AttributeSceneAction(s))
        })
      );
      this.executeScriptAsync(t);
    }
  }
  processDesignChanged(e) {
    if (e && e.data && e.data.design) {
      let t = new MPlaza.Design(e.data.design);
      this.renderDesignAsync(t);
    }
  }
  loadSceneConfig(e) {
    const t = new Zakeke.SceneConfig(e);
    if (this._zkScene && !this._zkScene.get("config"))
      this._zkScene.set("config", t);
    else {
      const n = new Zakeke.Scene();
      n.set("config", t), this._zkScene = n;
    }
    this.checkSceneShaderMaterials(this._zkScene);
  }
  updateFromConfig(e, t) {
    var n, s;
    if (this._zkScene) {
      let o = (s = (n = this._zkScene) == null ? void 0 : n.get("config")) == null ? void 0 : s.toJSON();
      const h = g1.merge(o, e), c = new Zakeke.SceneConfig(h);
      if (this._zkScene.set("config", c), (t == null ? void 0 : t.preventRefresh) === !0)
        return;
      this.setupSceneAsync((t == null ? void 0 : t.updateCamera) === !0);
    }
  }
  /**
   * Set up new camera position if parameter is present in config
   */
  refreshCameraPosition() {
    var n, s, o;
    const e = (s = (n = this._zkScene) == null ? void 0 : n.get("config")) == null ? void 0 : s.toJSON(), t = e == null ? void 0 : e.camera;
    t && (t != null && t.position) && ((o = this._sceneHelper) == null || o.setUpCameraByOptions(t.position));
  }
  setupDebugGUI() {
    var n;
    const e = (n = this._zkScene) == null ? void 0 : n.get("config"), t = (s) => {
      this.updateFromConfig(s, { updateCamera: !1 });
    };
    this._createGui = new Y1(
      e.toJSON(),
      (s) => t(s),
      this._sceneHelper
    ), this._createGui.setupGui(this._scene);
  }
  async setUpEmptyScene(e) {
    this._scene && (e && this.loadSceneConfig(e), await this.setupSceneAsync(), this.setRenderingNeeded());
  }
  /**
   * Loads a babylon scene from a remote URL.
   * @param rootUrl The root URL of the scene.
   * @param sceneFileName The name of the scene file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromSceneUrl(e, t, n) {
    await this.loadSceneFromRemoteFilesAsync(e, t), n && this.loadSceneConfig(n), await this.setupSceneAsync(), this.setRenderingNeeded();
  }
  stopAllAnimations() {
    this._scene && this._sceneHelper && this._sceneHelper.stopAllAnimations();
  }
  hasAnimations() {
    return this._scene && this._sceneHelper ? this._sceneHelper.hasAnimations() : !1;
  }
  playAnimations() {
    this._scene && this._sceneHelper && this._sceneHelper.playAnimations();
  }
  // al momento Marco FF ha detto che non serve esposto
  // public setupAnimations () {
  // 	if (this._scene && this._sceneHelper) {
  // 		this._sceneHelper.setupAnimations(this._zkScene);
  // 	}
  // }
  /**
   * Loads a scene from a GLB file URL.
   * @param url The URL of the GLB file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromGlbUrl(e, t) {
    var s, o, h;
    const n = ((s = t == null ? void 0 : t.camera) == null ? void 0 : s.animateIntro) !== void 0 ? (o = t == null ? void 0 : t.camera) == null ? void 0 : o.animateIntro : !0;
    await ((h = this._sceneHelper) == null ? void 0 : h.importMeshesFromUrlAsync(e, null, void 0, n, ".glb", this._isViewer)), t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!1, !0);
  }
  /**
   * Loads a scene from a file.
   * @param file The file to load the scene from.
   */
  async loadFromFile(e, t) {
    var n, s;
    ((n = t == null ? void 0 : t.camera) == null ? void 0 : n.animateIntro) !== void 0 && ((s = t == null ? void 0 : t.camera) == null || s.animateIntro);
    try {
      await BABYLON.SceneLoader.AppendAsync(e.name, e, this._scene);
    } catch (o) {
      console.log("dropObjectIntoScene: ", o);
    }
    t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!0, !0), this.setRenderingNeeded();
  }
  async showResizableCanvasModel(e) {
    if (this._scene && this._zkScene && this._zkModel && this._sceneHelper) {
      const t = await this._sceneHelper.showResizableCanvas(
        e.width,
        e.height,
        e.depth,
        e.borderRadius,
        e.type,
        e.borderColor,
        e.columns,
        e.rows,
        e.ppcm,
        e.backgroundColor,
        e.backgroundUrl,
        e.shape
      );
      if (!t)
        return { meshes: [], matrixJson: "" };
      const n = new y1.PaperScope();
      n.setup(new n.Size(1, 1));
      const s = new n.Matrix(), o = hg.DEFAULT_SIZE;
      s.translate(o / 2, o / 2), s.scale(o / e.width, o / e.height);
      const h = JSON.stringify(s.values);
      return { meshes: t, matrixJson: h };
    }
    return { meshes: [], matrixJson: "" };
  }
  async showResizableCanvasPerCurrentSide(e) {
    console.log("showResizableCanvasPerCurrentSide", e);
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-${e.currentSideId}-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const n = await this.showResizableCanvasModel(e);
    if (n.meshes.length === 0)
      return;
    const s = this._zkModel.get("scenes").at(0).get("meshSides");
    s.filter((m) => m.get("isResizable")).forEach((m) => s.remove(m));
    const h = e.type === "mirrored" ? ["front", "borders"] : ["front"];
    let c = 0;
    for (const m of n.meshes)
      if (m && h.includes(m.name)) {
        m.id = t.replace("sideIdPlaceholder", e.currentSideId.toString()) + c++;
        const x = new MPlaza.ModelSceneMeshSide({
          sideID: e.currentSideId,
          meshID: m.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: n.matrixJson,
          isResizable: !0
        });
        s.push(x);
      }
    console.log({ meshSides: s }), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async showResizableCanvasPerVariant(e) {
    if (console.log("showResizableCanvasPerVariant", e), !this.zkModel)
      return;
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-sideIdPlaceholder-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const n = await this.showResizableCanvasModel(e);
    if (n.meshes.length === 0)
      return;
    let s = 0;
    const o = e.sidesIds.length > 1;
    let h = ["front", "back", "borders"];
    e.type === "none" || e.type === "colored" ? o ? h = ["front", "back"] : h = ["front"] : e.type === "mirrored" && (o ? h = ["front", "back", "borders"] : h = ["front", "borders"]);
    const c = this._zkModel.get("scenes").at(0).get("meshSides");
    c.filter((x) => x.get("isResizable")).forEach((x) => c.remove(x));
    for (const x of n.meshes)
      if (x && h.includes(x.name)) {
        const B = !o || x.name === "front" ? e.sidesIds[0] : e.sidesIds[1];
        x.id = t.replace("sideIdPlaceholder", B.toString()) + s++;
        const I = new MPlaza.ModelSceneMeshSide({
          sideID: B,
          meshID: x.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: n.matrixJson,
          isResizable: !0
        });
        c.push(I);
      }
    setTimeout(() => this.adjustCamera(!1), 100);
  }
  clearResizableProduct() {
    var e;
    (e = this._sceneHelper) == null || e.clearResizableMeshes();
  }
  setMouseWheelInputEnabled(e) {
    this._camera && this._mouseWheelInput && (e ? this._camera.inputs.add(this._mouseWheelInput) : this._camera.inputs.remove(this._mouseWheelInput));
  }
  setCameraPinchingZoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.inputs.attached.pointers;
      t.pinchZoom = e, t.multiTouchPanAndZoom = e;
    }
  }
  switchMode(e) {
    var t;
    e === "upload" && (this._lastResizableMeshID = ""), (t = this._sceneHelper) == null || t.switchMode(e), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async setCanvasRotation(e, t) {
    var m;
    if (e = e % 360, this._isRotating || !this._zkModel || !this._sceneHelper || !this._sceneDesignManager || this._currentRotation === e)
      return;
    const n = this._zkModel.get("scenes").at(0).get("meshSides");
    if (n.length === 0)
      return;
    const o = n.at(0).get("meshID"), h = this.getMeshByID(o);
    if (!h)
      return;
    const c = h.getFacetNormal(0);
    this._isRotating = !0, await ((m = this._sceneHelper) == null ? void 0 : m.rotate(this._currentRotation - e, c, t)), this._currentRotation = e, this._isRotating = !1, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync(), this.setRenderingNeeded();
  }
  getFitToScreenMargin() {
    return this._zkScene ? this._zkScene.getFitToScreenMargin() : 1;
  }
  setFitToScreenMargin(e) {
    this._zkScene && this._zkScene.setFitToScreenMargin(e);
  }
  moveDesignItemUp(e, t) {
    var n;
    console.log("sceneViewer moveDesignItemUp", e), t ? t.moveItemUp(e) : (n = this._sceneDesignManager) == null || n.moveItemUp(e);
  }
  moveDesignItemDown(e, t) {
    var n;
    console.log("sceneViewer moveDesignItemDown", e), t ? t.moveItemDown(e) : (n = this._sceneDesignManager) == null || n.moveItemDown(e);
  }
  saveVisibleMeshesToMetadata() {
    if (!this._scene || !this._sceneHelper)
      return [];
    const t = this._sceneHelper.getVisibleMeshes().map((n) => n.id);
    this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.visibleMeshesID = t;
    for (const n of this._scene.meshes)
      this._sceneHelper.isRealMesh(n) && (n.isVisible = !1);
    return t;
  }
  getVisibleMeshesFromMetadata() {
    var t, n;
    const e = (n = (t = this._scene) == null ? void 0 : t.metadata) == null ? void 0 : n.visibleMeshesID;
    return Array.isArray(e) ? e : null;
  }
  applyVisibleMeshesFromMetadata() {
    if (!this._scene || !this._sceneHelper)
      return [];
    const e = this.getVisibleMeshesFromMetadata();
    if (!e)
      return [];
    for (const t of e)
      this._sceneHelper.showMesh(t);
    return e;
  }
}
class j1 {
  constructor(e) {
    this.materials = [], this.guid = Zakeke.generateUUID(), this.groupName = e;
  }
}
var W1 = /* @__PURE__ */ ((y) => (y[y.uploading = 0] = "uploading", y[y.progress = 1] = "progress", y[y.checking = 2] = "checking", y[y.success = 3] = "success", y[y.completed_success = 4] = "completed_success", y[y.completed_error = 5] = "completed_error", y))(W1 || {});
const Lg = class pl extends ku {
  constructor(e) {
    super({ configPreview: !0 }), this._dracoEnabled = !0, this._dracoEncodingSpeed = 5, this._dracoDecodingSpeed = 5, this._envMode = Ir.Editor, this._selectOnPick = !0, this._showBoundingBox = !1, this._editorBackgroundColor = "#444444", this._showGround = !0, this._ground = null, this._showLights = !1, this._lightsLayer = null, this._showAxes = !1, this._axesLayer = null, this._showFineTuning = !1, this._fineTuningModelLoaded = !1, this._showHighlight = !0, this._highlightOver = !0, this._highlightOverColor = "#0082ff", this._editingMode = Ja.None, this._manipulatedNode = null, this._oldManipulatedNode = null, this._EditControl = org.ssatguru.babylonjs.component.EditControl, this._editControl = null, this._editControlVisible = !1, this._shiftPressed = !1, this._ctrlPressed = !1, this._realMeshVisibility = {}, this._sceneSourceTasks = [], this._sceneSourceTaskXhrs = /* @__PURE__ */ new Map(), this._sceneSourceTaskAbortControllers = /* @__PURE__ */ new Map(), this._isLoadingSourceFiles = !1, this._authorizationToken = "", this._incrementalWorkersScriptsUrls = [], this._preUpdateListeners = [], this._postUpdateListeners = [], this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [], this._pickedProvider = _g.NotSelected, this._providerData = { mesh: new Blob() }, this._sessionTryOnEnabled = !1, this._tryOnInfoLoading = !0, this._initialMeshMaterials = {}, this._initialSubMeshMaterials = {}, this._lastMeshMaterials = {}, this._lastSubMeshMaterials = {}, this._meshOver = null, this._incrementalFilesMaker = null, this._sceneToBlobs = null, this._showMeasurements = !1, this._modelMeasurements = BABYLON.Vector3.Zero(), e && (this._incrementalWorkersScriptsUrls = e.incrementalWorkersScriptsUrls, this._authorizationToken = e.authorizationToken, e.showGround != null && e.showGround != null && (this._showGround = e.showGround), e.editorBackgroundColor !== void 0 && e.editorBackgroundColor !== null && (this._editorBackgroundColor = e.editorBackgroundColor), e.showHighlight !== void 0 && e.showHighlight !== null && (this._showHighlight = e.showHighlight), e.highlightColor !== void 0 && e.highlightColor !== null && (this._highlightColor = e.highlightColor), e.highlightOver !== void 0 && e.highlightOver != null && (this._highlightOver = e.highlightOver), e.highlightOverColor !== void 0 && e.highlightOverColor != null && (this._highlightOverColor = e.highlightOverColor));
  }
  // Real mesh visibility
  get realMeshVisibility() {
    return this._realMeshVisibility;
  }
  // Environemnt manager
  get environmentManager() {
    return this._environmentManager;
  }
  // EnvMode
  get envMode() {
    return this._envMode;
  }
  // Source tasks
  get sceneSourceTasks() {
    return this._sceneSourceTasks;
  }
  set envMode(e) {
    this._envMode != e && (this._envMode = e, this.refreshEnvironment());
  }
  // SelectOnPick
  get selectOnPick() {
    return this._selectOnPick;
  }
  set seletOnPick(e) {
    this._selectOnPick != e && (this._selectOnPick = e);
  }
  // ShowBoundingBox
  get showBoundingBox() {
    return this._showBoundingBox;
  }
  set showBoundingBox(e) {
    this._showBoundingBox != e && (this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded());
  }
  // EditorBackgroundColor
  get editorBackgroundColor() {
    return this._editorBackgroundColor;
  }
  set editorBackgroundColor(e) {
    this._editorBackgroundColor != e && this.setEditorBackgroundColor(e);
  }
  // ShowGround
  get showGround() {
    return this._showGround;
  }
  set showGround(e) {
    this._showGround != e && (this._showGround = e, this.refreshGround());
  }
  // ShowLights
  get showLights() {
    return this._showLights;
  }
  set showLights(e) {
    this._showLights != e && (this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded());
  }
  // ShowAxes
  get showAxes() {
    return this._showAxes;
  }
  set showAxes(e) {
    this._showAxes != e && (this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded());
  }
  get showFineTuning() {
    return this._showFineTuning;
  }
  set showFineTuning(e) {
    this._showFineTuning = e, this._fineTuningModelLoaded = !1;
  }
  set fineTuningModelLoaded(e) {
    this._fineTuningModelLoaded = e;
  }
  get fineTuningModelLoaded() {
    return this._fineTuningModelLoaded;
  }
  get sessionTryOnEnabled() {
    return this._sessionTryOnEnabled;
  }
  set sessionTryOnEnabled(e) {
    this._sessionTryOnEnabled = e;
  }
  get tryOnInfoLoading() {
    return this._tryOnInfoLoading;
  }
  set tryOnInfoLoading(e) {
    this._tryOnInfoLoading = e;
  }
  // ShowHighlight
  get showHighlight() {
    return this._showHighlight;
  }
  set showHighlight(e) {
    this._showHighlight != e && (this._showHighlight = e);
  }
  // HighlightOver
  get highlightOver() {
    return this._highlightOver;
  }
  set highlightOver(e) {
    this._highlightOver != e && (this._highlightOver = e);
  }
  // HighlightOverColor
  get highlightOverColor() {
    return this._highlightOverColor;
  }
  set highlightOverColor(e) {
    this._highlightOverColor != e && (this._highlightOverColor = e);
  }
  // EditingMode
  get editingMode() {
    return this._editingMode;
  }
  set editingMode(e) {
    this._editingMode != e && this.setEditingMode(e);
  }
  // EditingControlVisible
  get editControlVisible() {
    return this._editControlVisible;
  }
  set editControlVisible(e) {
    this._editControlVisible != e && this.showHideEditControl(e);
  }
  get selectedProvider() {
    return this._pickedProvider;
  }
  get selectedProviderFineTuningData() {
    return this._providerData;
  }
  get modelMeasurements() {
    return this._modelMeasurements;
  }
  set modelMeasurements(e) {
    this._modelMeasurements = e;
  }
  get showMeasurements() {
    return this._showMeasurements;
  }
  fireHideMeasurementsEvent() {
    this._showMeasurements = !1;
  }
  fireShowMeasurementsEvent() {
    this._showMeasurements = !0;
  }
  static async createSceneEditorAsync(e) {
    const t = new pl(e);
    return await t.initAsync(), t.checkSceneSourceTasks(), t;
  }
  createCanvas() {
    const e = super.createCanvas();
    return e.addEventListener(
      "keydown",
      (t) => {
        this._shiftPressed = t.key == "Shift", this._ctrlPressed = t.key == "Control";
      },
      !1
    ), e.addEventListener(
      "keyup",
      (t) => {
        this._shiftPressed = t.key != "Shift", this._ctrlPressed = t.key != "Control";
      },
      !1
    ), e.addEventListener("dblclick", (t) => {
      this.setRenderingNeeded();
    }), e;
  }
  deleteComponents() {
    super.deleteComponents(), this._editControl && (this._editControl.detach(), this._editControl = null), this._lightsLayer && (this._lightsLayer.dispose(), this._lightsLayer = null), this._axesLayer && (this._axesLayer.dispose(), this._axesLayer = null);
  }
  dispose() {
    super.dispose(), this._incrementalFilesMaker && (this._incrementalFilesMaker.dispose(), delete this._incrementalFilesMaker), this._sceneToBlobs && (this._sceneToBlobs.dispose(), delete this._sceneToBlobs);
  }
  createEngine() {
    super.createEngine(), BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = !0;
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this._engine && this.fireSceneCreatedEvent();
  }
  async setupSceneAsync() {
    var e;
    await super.setupSceneAsync(), this._engine && this._scene && (this._scene.setRenderingAutoClearDepthStencil(1, !0, !0, !1), this._scene.setRenderingAutoClearDepthStencil(2, !0, !0, !1), this._lightsLayer = new c1(this), this._lightsLayer.addLightSelectedListener((t) => {
      this.lightsLayer_onLightSelected(t);
    }), (e = this._sceneHelper) == null || e.cleanUnusedMaterialsMappings(this._zkScene), this.addMaterialsUpdateListener(() => {
      var t;
      return (t = this._sceneHelper) == null ? void 0 : t.cleanUnusedMaterialsMappings(this._zkScene);
    }), this.setupAxes(), this._zkModel && this._meshLocationsManager && (this._meshLocationsManager.addBeforeSaveMeshLocationListener(() => this.onBeforeSaveMeshLocation()), this._meshLocationsManager.addAfterSaveMeshLocationListener(() => this.onAfterSaveMeshLocation())), this._scene.onPointerMove = (t, n) => this.onPointerMove(t, n));
  }
  render() {
    this.firePreUpdateEvent(), super.render(), this._lightsLayer && this._lightsLayer.render(), this._axesLayer && this._axesLayer.render(), this.firePostUpdateEvent();
  }
  deleteHighlightLayer() {
    this._highlightLayer && (this._highlightLayer.dispose(), this._highlightLayer = null), this.setRenderingNeeded();
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightBlurHorizontalSize, this._highlightLayer.blurVerticalSize = this._highlightBlurVerticalSize);
  }
  setupAxes() {
    this._axesLayer = new u1(this);
  }
  getMatchSameNameTextures() {
    if (this._zkScene) {
      let e = this._zkScene.getMatchSameNameTextures();
      return e ?? !1;
    }
    return !1;
  }
  setMatchSameNameTextures(e) {
    this._zkScene && this._zkScene.setMatchSameNameTextures(e);
  }
  getAREnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAREnabled();
      return t ?? e;
    }
    return e;
  }
  setAREnabled(e) {
    this._zkScene && this._zkScene.setAREnabled(e);
  }
  getAROnTheFly() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAROnTheFly();
      return t ?? e;
    }
    return e;
  }
  setAROnTheFly(e) {
    this._zkScene && this._zkScene.setAROnTheFly(e);
  }
  setARAnchor(e) {
    this._zkScene && this._zkScene.setARAnchor(e);
  }
  getTryOnEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getTryOnEnabled();
      return t ?? e;
    }
    return e;
  }
  setTryOnEnabled(e) {
    this._zkScene && this._zkScene.setTryOnEnabled(e);
  }
  setTryOnSelectedType(e) {
    if (this._zkScene) {
      const t = this.getTryOnDefaultTypeSettings(), n = this._zkScene.getTryOnSettings() || t;
      n.type = e, this.setTryOnTypeSettings(n);
    }
  }
  setFrameDAMSettings(e) {
    this._zkScene && this._zkScene.setFrameDAMSettings(typeof e == "string" ? e : JSON.stringify(e));
  }
  getForceDracoCompression() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getForceDracoCompression();
      return t ?? e;
    }
    return e;
  }
  setForceDracoCompression(e) {
    this._zkScene && this._zkScene.setForceDracoCompression(e);
  }
  getWebPEnabled() {
    return this._zkScene ? this._zkScene.getWebPEnabled() : !1;
  }
  setWebPEnabled(e) {
    this._zkScene && this._zkScene.setWebPEnabled(e);
  }
  getWebPType() {
    return this._zkScene ? this._zkScene.getWebPType() : "Lossless";
  }
  setWebPType(e) {
    this._zkScene && this._zkScene.setWebPType(e);
  }
  getWebPQuality() {
    return this._zkScene ? this._zkScene.getWebPQuality() : 80;
  }
  setWebPQuality(e) {
    this._zkScene && this._zkScene.setWebPQuality(e);
  }
  setProvider(e) {
    this._pickedProvider = e;
  }
  setProviderFineTuningData(e) {
    this._providerData = {
      mesh: e.mesh ? e.mesh : this._providerData.mesh,
      settings: e.settings ? e.settings : this._providerData.settings
    };
  }
  resetProviderFineTuningData() {
    var e;
    (e = this._scene) == null || e.meshes.forEach((t) => {
      t.metadata && t.metadata.tryOnFineTuningSettings && (t.metadata.tryOnFineTuningSettings = null);
    }), this._providerData = {};
  }
  setMeshFineTuningData(e, t) {
    const n = typeof e == "string" ? this.getMeshByID(e) : e;
    n && (n.metadata || (n.metadata = {}), n.metadata.tryOnFineTuningSettings = t);
  }
  setDAMFineTuningData(e) {
    const t = {
      finetuning: e
    };
    this.setFrameDAMSettings(t);
  }
  getTryOnSelectedType() {
    if (this._zkScene) {
      let e = this._zkScene.getTryOnSettings();
      if (e && e.type)
        return e.type;
    }
    return null;
  }
  getTryOnSettings() {
    const e = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t)
        return t;
    }
    return e;
  }
  getTryOnSetting(e) {
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t && e in t.typeSettings && t.typeSettings[e] && typeof t.typeSettings[e] == "boolean")
        return t.typeSettings[e];
    }
    return !1;
  }
  setTryOnSetting(e, t) {
    let n = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let s = this._zkScene.getTryOnSettings();
      if (!s) {
        switch (e) {
          case Ds.GlassPupillaryDistanceTool:
          case Ds.VirtualTryOn:
          case Ds.MandatoryPupillaryDistance:
            n.typeSettings[e] = t;
            break;
          case Ds.StyleButton:
            n.styleButton = t;
        }
        this.setTryOnTypeSettings(n);
        return;
      }
      switch (e) {
        case Ds.GlassPupillaryDistanceTool:
          s.typeSettings.pd = t;
          break;
        case Ds.VirtualTryOn:
          s.typeSettings.try_on = t;
          break;
        case Ds.MandatoryPupillaryDistance:
          s.typeSettings.mandatoryPD = t;
          break;
        case Ds.StyleButton:
          s.styleButton = t;
          break;
      }
      s.typeSettings.pd && s.typeSettings.try_on || (s.styleButton = "single"), this._zkScene.setTryOnSettings(s);
    }
  }
  setTryOnTypeSettings(e) {
    this._zkScene && this._zkScene.setTryOnSettings(e);
  }
  getTryOnDefaultTypeSettings() {
    return {
      type: mg.NotSelected,
      styleButton: "single",
      buttonCustomizations: [
        {
          image: "base",
          textLabel: "Virtual Try-on",
          textColor: null,
          backgroundColor: null,
          borderColor: null,
          borderWidth: 0,
          borderRadius: 0
        }
      ],
      typeSettings: {
        try_on: !0,
        pd: !1,
        active: this.getTryOnEnabled() ?? !1
      }
    };
  }
  setTryOnDefaultTypeSettings() {
    let e = this.getTryOnDefaultTypeSettings();
    this.setTryOnTypeSettings(e);
  }
  getUseDelayedMaterialLoading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseDelayedMaterialLoading();
      return t ?? e;
    }
    return e;
  }
  setUseDelayedMaterialLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedMaterialLoading(e);
  }
  getUseDelayedTextureLoading() {
    if (this._zkScene) {
      let t = this._zkScene.getUseDelayedTextureLoading();
      return t ?? !1;
    }
    return !1;
  }
  setUseDelayedTextureLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedTextureLoading(e);
  }
  getGlowEnabled() {
    return this._glowManager ? this._glowManager.enabled : !1;
  }
  setGlowEnabled(e) {
    this._glowManager && (this._glowManager.enabled = e, this.setRenderingNeeded());
  }
  getGlowIntensity() {
    return this._glowManager ? this._glowManager.intensity : 1;
  }
  setGlowIntensity(e) {
    this._glowManager && (this._glowManager.intensity = e, this.setRenderingNeeded());
  }
  getGlowBlurSize() {
    return this._glowManager ? this._glowManager.blurSize : 16;
  }
  setGlowBlurSize(e) {
    this._glowManager && (this._glowManager.blurSize = e, this.setRenderingNeeded());
  }
  getInfoPointsEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getInfoPointsEnabled();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsEnabled(e) {
    this._zkScene && this._zkScene.setInfoPointsEnabled(e), this.refreshInfoPoints();
  }
  getInfoPointsBorderColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsBorderColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsBorderColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsBorderColor(e), this.refreshInfoPoints());
  }
  getInfoPointsInnerPointColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsInnerPointColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsInnerPointColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsInnerPointColor(e), this.refreshInfoPoints());
  }
  getInfoPointsColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsColor(e), this.refreshInfoPoints());
  }
  getInfoPointsHighlightColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsHighlightColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsHighlightColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsHighlightColor(e), this.refreshInfoPoints());
  }
  enableGlowForMesh(e) {
    this._glowManager && this._glowManager.enableGlowForMesh(e);
  }
  disableGlowForMesh(e) {
    this._glowManager && (this._glowManager.disableGlowForMesh(e), this.setRenderingNeeded());
  }
  enableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !0);
  }
  disableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !1);
  }
  disableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !1, e.getChildMeshes().forEach((t) => this.disableTryOnForMesh(t)));
  }
  enableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !0, e.getChildMeshes().forEach((t) => this.enableTryOnForMesh(t)));
  }
  enableInfoPointsForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.showInfoPoints = !0, this.refreshInfoPoints());
  }
  disableInfoPointsForMesh(e) {
    e && e.metadata && e.metadata.showInfoPoints !== void 0 && e.metadata.showInfoPoints !== null && (delete e.metadata.showInfoPoints, this.refreshInfoPoints());
  }
  enableForcedInfoPointsVisibilityOnMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.forceShowInfoPoints = !0, this.refreshInfoPoints());
  }
  disableForcedInfoPointsVisibilityOnMesh(e) {
    e && e.metadata && e.metadata.forceShowInfoPoints !== void 0 && e.metadata.forceShowInfoPoints !== null && (delete e.metadata.forceShowInfoPoints, this.refreshInfoPoints());
  }
  setEditorBackgroundColor(e) {
    this._editorBackgroundColor = e, this.refreshEnvironment();
  }
  setViewerBackgroundAlpha(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundAlpha", e), this.refreshEnvironment());
  }
  setViewerBackgroundColor(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundColor", e), this.refreshEnvironment());
  }
  setViewerEnvironmentSizeAuto(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("sizeAuto", e), this.refreshEnvironment());
  }
  setViewerEnvironmentMainColor(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("mainColor", e), this.refreshEnvironment());
  }
  setViewerSkyboxCreateSkybox(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("createSkybox", e), this.refreshEnvironment());
  }
  setViewerSkyboxSize(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerSkyboxBlur(e) {
    if (this._zkScene) {
      let t = e >= 0 ? e : 0;
      this._zkScene.getOrCreateSkyboxConfig().set("blur", t), this.refreshEnvironment();
    }
  }
  setViewerSkyboxTexture(e, t, n) {
    if (this._zkScene && e != null && typeof e == "string") {
      const s = this._zkScene.getOrCreateSkyboxConfig();
      s.set("texture", e), s.set("extensions", t), s.set("files", n), this.refreshEnvironment();
    }
  }
  removeViewerSkyboxTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getSkyboxConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerSkyboxColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateSkyboxConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundCreateGround(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("createGround", e), this.refreshEnvironment());
  }
  setViewerGroundSize(e) {
    this._zkScene && (this._zkScene.getOrCreateGroundConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerGroundTexture(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("texture", e), this.refreshEnvironment());
  }
  removeViewerGroundTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getGroundConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerGroundColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundOpacity(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("opacity", e), this.refreshEnvironment());
  }
  setViewerGroundEnableShadow(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableShadow", e), this.refreshEnvironment());
  }
  setViewerGroundShadowLevel(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("shadowLevel", e), this.refreshEnvironment());
  }
  setViewerGroundEnableMirror(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableMirror", e), this.refreshEnvironment());
  }
  setViewerGroundMirrorBlur(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("mirrorBlurKernel", e), this.refreshEnvironment());
  }
  setViewerCameraAutoRotate(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("autoRotate", e), this.autoRender = e, this.refreshEnvironment());
  }
  setViewerCameraContrast(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("contrast", e), this.refreshEnvironment());
  }
  setViewerCameraExposure(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("exposure", e), this.refreshEnvironment());
  }
  setViewerCameraUpperAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const s = this._zkScene.getOrCreateCameraConfig().get("lowerAlphaLimit");
      this._zkScene.setCameraUpperAlphaLimit(Math.max(e, s ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperAlphaLimit(Math.max(e, s ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const s = this._zkScene.getOrCreateCameraConfig().get("upperAlphaLimit");
      this._zkScene.setCameraLowerAlphaLimit(Math.min(e, s ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerAlphaLimit(Math.min(e, s ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const s = this._zkScene.getOrCreateCameraConfig().get("upperBetaLimit");
      this._zkScene.setCameraLowerBetaLimit(Math.min(e, s ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerBetaLimit(Math.min(e, s ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraUpperBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const s = this._zkScene.getOrCreateCameraConfig().get("lowerBetaLimit");
      this._zkScene.setCameraUpperBetaLimit(Math.max(e, s ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperBetaLimit(Math.max(e, s ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraToneMappingEnabled(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("toneMappingEnabled", e), this.refreshEnvironment());
  }
  serializeFromVector(e) {
    return e ? { x: e.x, y: e.y, z: e.z } : null;
  }
  setModelTransformsFromDAMMesh() {
    var t;
    const e = this.getDAMMainMesh();
    if (e) {
      const n = e.position, s = e.rotation, o = e.scaling, h = new BABYLON.Vector3(
        Math.abs(o.x),
        Math.abs(o.y),
        Math.abs(o.z)
      );
      console.log("🔧 [DAM-SAVE] Reading transforms from mesh:", {
        nodeName: e.name,
        originalScale: { x: o.x, y: o.y, z: o.z }
      }), console.log("🔵 [DAM-SAVE] Normalized scale:", { x: h.x, y: h.y, z: h.z });
      const c = (t = this._zkScene) == null ? void 0 : t.getOrCreateModelConfig();
      c.set("position", this.serializeFromVector(n)), c.set("rotation", this.serializeFromVector(s)), c.set("scale", this.serializeFromVector(h));
    }
  }
  resetEditorEnvironment() {
    this.resetEditorBackground(), this.resetEditorCamera(), this.setRenderingNeeded();
  }
  resetEditorBackground() {
    this._scene && (this._scene.clearColor = BABYLON.Color3.FromHexString(this._editorBackgroundColor).toColor4(), this.refreshGround(), this.setRenderingNeeded());
  }
  resetEditorCamera() {
    if (this._scene) {
      const e = this._scene.activeCamera;
      e instanceof BABYLON.ArcRotateCamera && (e.useAutoRotationBehavior = !1), this._autoRender = !1, this.setRenderingNeeded();
    }
  }
  preSceneContentScreenshot() {
    this.resetEditorEnvironment(), this.removeGround();
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    super.preSceneMaterialScreenshot(), this.adjustSceneForSerialization();
  }
  postSceneMaterialScreenshot() {
    super.postSceneMaterialScreenshot();
  }
  sceneReadyForSave() {
    if (this._scene) {
      for (let e = 0; e < this._scene.meshes.length; e++)
        if (!this._scene.meshes[e].isReady())
          return !1;
    }
    return !0;
  }
  isCurrentCameraPivot(e) {
    if (this._sceneHelper) {
      const t = this._sceneHelper.getCameraPivot();
      return t && t.id === e;
    }
    return !1;
  }
  getCurrentCameraPivotID() {
    if (this._scene && this._sceneHelper) {
      const e = this._sceneHelper.getCameraPivot();
      if (e) {
        const t = this._scene.getMeshByID(e.id);
        if (t)
          return t.id;
      }
    }
    return null;
  }
  // Riscritta quella di SceneViewer perché viene salvata l'informazione
  // sul nuovo pivot, non solo modifcato il punto di vista
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      for (let n = 0; n < this._scene.meshes.length; n++) {
        var t = this._scene.meshes[n];
        t.metadata && t.metadata.isCameraPivot != null && delete t.metadata.isCameraPivot;
      }
      if (e) {
        const n = this._scene.getMeshByID(e);
        n && (n.metadata = n.metadata || {}, n.metadata.isCameraPivot = !0), this._sceneHelper.setCameraPivot(n || null);
      } else
        this._sceneHelper.setCameraPivot(null);
    }
  }
  // --------------------------------------------------------
  // Funzioni per il salvataggio della scena
  // --------------------------------------------------------
  async getBlobFromEmbeddedTextureAsync(e) {
    let t = null;
    if (e.url) {
      const h = e.url;
      var n = h.substring(0, 5) === "data:", s = h.substring(0, 5) === "blob:", o = n && h.indexOf(";base64,") !== -1;
      if (n && e._buffer && (e._buffer instanceof ArrayBuffer || e._buffer instanceof Uint8Array || e._buffer instanceof Blob))
        e._buffer instanceof Blob ? t = e._buffer : e._buffer instanceof Uint8Array ? t = new Blob([e._buffer], { type: e.mimeType }) : e._buffer instanceof ArrayBuffer && (t = new Blob([new Uint8Array(e._buffer)], { type: e.mimeType }));
      else if (s)
        await new Promise((c) => {
          var m = new XMLHttpRequest();
          m.open("GET", h, !0), m.responseType = "blob", m.onload = function(x) {
            this.status == 200 && c(this.response);
          }, m.send();
        });
      else if (o) {
        const c = new Uint8Array(BABYLON.Tools.DecodeBase64(h));
        t = new Blob([c], { type: e.mimeType });
      }
    }
    return t;
  }
  async uploadEmbeddedTexturesAsync(e) {
    const t = [];
    if (this._zkScene && this._scene && this._sceneHelper) {
      this._scene, this._zkScene;
      const n = this._sceneHelper;
      this.getAllMaterials().forEach((o) => {
        o.getActiveTextures().filter((c) => c instanceof BABYLON.Texture).forEach((c) => {
          if (c.url) {
            var m = c.url.substring(0, 5) === "data:", x = c.url.substring(0, 5) === "blob:", B = m && c.url.indexOf(";base64,") !== -1;
            if (m || x || B) {
              const I = n.getMaterialTextureType(o, c);
              I && t.push({
                texture: c,
                material: o,
                type: I
              });
            }
          }
        });
      });
    }
    for (let n = 0; n < t.length; n++) {
      const s = t[n], o = s.texture, h = await this.getBlobFromEmbeddedTextureAsync(o);
      if (h) {
        let c = ".png";
        o.mimeType === "image/jpeg" && (c = ".jpg");
        const x = `${s.type.replace(" ", "_")}${c}`;
        let B = new File([h], x);
        const I = await this.uploadTextureFileAsync(B, s.material);
        if (I) {
          const F = I.get("url");
          F && await new Promise((M, Z) => {
            o.updateURL(
              F,
              void 0,
              () => M(),
              void 0,
              () => Z()
            );
          });
        }
        e && e(n / t.length * 100, "textures");
      }
    }
  }
  useIncrementalLoading() {
    if (this._sceneHelper) {
      const e = this._sceneHelper.getTotalVertices(), t = this._sceneHelper.getTotalIndices();
      if (e + t >= 1e3)
        return !0;
    }
    return !1;
  }
  // Prepara il modello backbone zkScene per il salvataggio. Nel dettaglio:
  // 1. Esegue lo screenshot della scena e imposta i byte nel modello zkScene
  // 2. Recupera il JSON della scena da Babylon JS.
  // 3. Esegue l'upload del file in modo che possa essere salvato nel percorso previsto per la scena corrente.
  // 4. Aggiorna il modello impostando i dati relativi al file "uploadato" (essenzialmente il fileObject)
  updateSceneModel(e, t, n, s) {
    if (this._zkScene && this._scene) {
      this._scene;
      const o = this._zkScene;
      this.resetRealVisibility();
      const h = this.infoPointsShown;
      h && this.hideInfoPoints(), this.uploadEmbeddedTexturesAsync((c, m) => {
        n && n(c, m);
      }).then(() => {
        this.getSceneScreenshotAsync(500, 450).then((c) => {
          h && this.showInfoPoints(), o.set("imageData", c), o.set("version", o.get("version") + 1);
          var m = this.useIncrementalLoading();
          m ? this.uploadSceneIncrementalFiles(
            (x) => {
              this.onUploadScenFileSuccess(x), e && e();
            },
            (x) => {
              t && t(x);
            },
            (x) => {
              n && n(x);
            },
            s
          ) : this.uploadSceneFile(
            (x) => {
              this.onUploadScenFileSuccess(x), e && e();
            },
            (x) => {
              t && t(x);
            },
            (x, B) => {
              n && n(x, B);
            }
          );
        });
      }).catch((c) => {
        t && t(c);
      });
    }
  }
  // Aggiorna il modello con i dati sul file di scena salvato
  onUploadScenFileSuccess(e) {
    this._zkScene && e && (e.hasOwnProperty("fileObjectID") || e.hasOwnProperty("fileLength")) && e.hasOwnProperty("rootUrl") && e.hasOwnProperty("sceneFileName") && (e.hasOwnProperty("manifestFileObjectID") || e.hasOwnProperty("manifestFileLength")) && (e.hasOwnProperty("incrementalsFileObjectID") || e.hasOwnProperty("incrementalsFileLength")) ? (this._zkScene.set("fileObjectID", e.fileObjectID), this._zkScene.set("fileLength", e.fileLength), this._zkScene.set("url", e.url), this._zkScene.set("rootUrl", e.rootUrl), this._zkScene.set("sceneFileName", e.sceneFileName), this._zkScene.set("manifestFileObjectID", e.manifestFileObjectID), this._zkScene.set("manifestFileLength", e.manifestFileLength), this._zkScene.set("manifestFileUrl", e.manifestFileUrl), this._zkScene.set("incrementalsFileObjectID", e.incrementalsFileObjectID), this._zkScene.set("incrementalsFileLength", e.incrementalsFileLength), this._zkScene.set("incrementalsFileUrl", e.incrementalsFileUrl)) : Logger.info("le informazioni sul file di scena salvato sono vuote o incorrette");
  }
  uploadSceneFile(e, t, n) {
    if (!this._scene || !this._zkScene) {
      t && t("No scene to upload");
      return;
    }
    this._scene;
    const s = this._zkScene, o = s.get("version"), h = this.getSceneJson();
    this.getSceneFileBlobsAsync(h, o, (c) => {
      n && n(c, "optimize");
    }).then((c) => {
      const m = new FormData();
      for (let x = 0; x < c.length; x++) {
        const B = c[x];
        m.append("file_" + x, B.blob, B.name);
      }
      fetch(s.getSceneIncrementalFileUploadUrl(), {
        method: "POST",
        body: m,
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        }
      }).then((x) => {
        if (!x.ok)
          throw new Error("HTTP error " + x.status);
        return x.json();
      }).then((x) => {
        e && e(x);
      }).catch((x) => {
        t && t(x.message);
      });
    });
  }
  async getSceneFileBlobsAsync(e, t, n) {
    let s = [];
    return this._sceneToBlobs || (this._sceneToBlobs = new a1(this._incrementalWorkersScriptsUrls)), this._sceneToBlobs && (await this._sceneToBlobs.whenReadyAsync(), s = await this._sceneToBlobs.getSceneBlobsAsync(e, t, n)), s;
  }
  // Serializza in JSON la scena Babylon JS
  getSceneJson() {
    var t;
    let e = "";
    if (this._scene && this._sceneHelper) {
      const n = this._envMode;
      this.setEnvironmentMode(Ir.Editor), this.disableAntialiasing(!0);
      const s = this.resetCameraRotationLimits();
      this.deleteHighlightLayer();
      const o = this._manipulatedNode;
      this.setManipulatedNode(null), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading() && this._sceneHelper.offloadAllUnusedMaterials(), this._sceneHelper.setDummyMaterialToInvisibleMeshes(), this.adjustSceneForSerialization();
      const h = BABYLON.SceneSerializer.Serialize(this._scene);
      if (h.postProcesses = [], e = JSON.stringify(h), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
        const c = (t = this._zkScene) == null ? void 0 : t.get("rootUrl");
        c && this._sceneHelper.loadAllOffloadedMaterials(c);
      }
      this._sceneHelper.unsetAllDummyMaterials(), n != Ir.Editor && this.setEnvironmentMode(n), this.enableAntialiasing(), this.createHighlightLayer(), this.setManipulatedNode(o), this.setCameraRotationLimits(s);
    }
    return e;
  }
  resetCameraRotationLimits() {
    const e = {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: null,
      upperBetaLimit: null
    };
    return this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (e.lowerAlphaLimit = this._camera.lowerAlphaLimit, e.upperAlphaLimit = this._camera.upperAlphaLimit, e.lowerBetaLimit = this._camera.lowerBetaLimit, e.upperBetaLimit = this._camera.upperBetaLimit, this._camera.lowerAlphaLimit = null, this._camera.upperAlphaLimit = null, this._camera.lowerBetaLimit = 0.01, this._camera.upperBetaLimit = Math.PI - 0.01), e;
  }
  setCameraRotationLimits(e) {
    e = e || {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: 0.01,
      upperBetaLimit: Math.PI - 0.01
    }, this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerAlphaLimit = e.lowerAlphaLimit, this._camera.upperAlphaLimit = e.upperAlphaLimit, this._camera.lowerBetaLimit = e.lowerBetaLimit || 0.01, this._camera.upperBetaLimit = e.upperBetaLimit || Math.PI - 0.01);
  }
  // Metodo fondamentale per modificare gli url delle texture ed eliminare le
  // le texture non più utilizzate. In fase di caricamento della scena, Babylon JS
  // risolve il nome delle texture in base al path della scena. Quindi gli url delle
  // texture vanno, se necessario, trasformanti in path relativi.
  adjustSceneForSerialization() {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const e = this._sceneHelper;
      this.removeDisabledFresnelParameters();
      let t = !1;
      this._zkScene.getUseDelayedTextureLoading() != null && (t = this._zkScene.getUseDelayedTextureLoading()), this._scene.useDelayedTextureLoading = t;
      const n = this.getMatchSameNameTextures(), s = this._zkScene.getSourcesIDs();
      this._zkScene.getLibraryMaterialIDs();
      const o = {}, h = [], c = [], m = [], x = e.getTextureUrl(this._scene.environmentTexture), B = x !== null && x.endsWith(gi.Environment.EnvironmentTextureName);
      if (this._zkScene.set("useDefaultEnvironmentTexture", B), this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
        const P = this._scene.environmentTexture.rotationY;
        this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.environmentTextureRotationY = P;
      }
      this._scene.textures.forEach((P) => {
        var J, le;
        if (!e.isTextureWithUrl(P))
          return;
        let K = P.url;
        if (P.getInternalTexture) {
          const fe = P.getInternalTexture();
          fe && fe.url && (K = fe.url);
        }
        if (K) {
          let fe = K;
          if (fe === gi.Environment.EnvironmentTextureCDNUrl) {
            P.url = "textures/" + Zakeke.getEmptyUUID().replace(/-/g, "") + "/" + gi.Environment.EnvironmentTextureName, P.name = P.url;
            return;
          }
          if (fe == gi.Environment.SkyboxTextureCDNUrl || fe == gi.Environment.GroundTextureCDNUrl)
            return;
          let X = !1;
          fe.startsWith("blob:") && P.metadata && P.metadata.fileUrl && (fe = P.metadata.fileUrl);
          for (let Ee = 0; Ee < s.length; Ee++) {
            let He = s[Ee].replace(/-/g, ""), ft = fe.indexOf(He);
            if (ft != -1) {
              X = !0, P.name = fe.substring(ft), P.url = P.name, Logger.info("texture url: " + P.url);
              break;
            }
          }
          let W = !1;
          const je = this._zkScene.get("rootUrl") || "";
          if (P.materialMapping) {
            W = !0;
            const Ee = ((le = (J = P.name) == null ? void 0 : J.split("/")) == null ? void 0 : le.pop()) || P.name, He = P.materialMapping, ft = He.libraryMaterialID.replace(/-/g, ""), Le = He.sceneMaterialID.replace(/-/g, "");
            P.url = `textures/${Le}/${Ee}`, P.name = P.url;
            const $e = `textures/${ft}/${Ee}`;
            if (oa(h, $e) || h.push($e), P.metadata && P.metadata.mobileUrl) {
              const ut = P.metadata.mobileUrl.split("/").pop();
              P.metadata.mobileUrl = `${je}textures/${Le}/${ut}`;
              const ze = `textures/${ft}/${ut}`;
              oa(h, ze) || h.push(ze);
            }
          }
          if (!X && !W) {
            const Ee = this.extractTextureNameAndUrl(fe, n, o);
            if (Ee.url && Ee.name && (P.url = Ee.url, P.name = Ee.name, oa(h, P.url) || h.push(P.url)), P.metadata && P.metadata.mobileUrl && P.materialMapping) {
              const He = this.extractTextureNameAndUrl(
                P.metadata.mobileUrl,
                n,
                o
              );
              He.url && He.name && (P.metadata.mobileUrl = He.url, oa(h, P.metadata.mobileUrl) || h.push(P.metadata.mobileUrl), oa(m, P.metadata.mobileUrl) || m.push(P.metadata.mobileUrl), oa(c, P.url) || c.push(P.url));
            }
          }
        }
      });
      const I = ["px", "py", "pz", "nx", "ny", "nz"], F = (P) => {
        let K = P.lastIndexOf("."), J = P;
        if (K !== -1) {
          let le = P.substring(0, K);
          for (let fe = 0; fe < I.length; fe++) {
            const X = I[fe];
            if (K = le.lastIndexOf("_" + X), K != -1) {
              J = le.substring(0, K);
              break;
            }
          }
        }
        return J;
      }, M = (P) => {
        const K = F(P);
        for (let J = 0; J < h.length; J++) {
          const le = h[J];
          if (K.endsWith(le))
            return !0;
        }
        return !1;
      }, Z = (P) => {
        const K = F(P);
        for (let J = 0; J < c.length; J++) {
          const le = c[J];
          if (K.endsWith(le))
            return !0;
        }
        return !1;
      }, V = (P) => {
        const K = F(P);
        for (let J = 0; J < m.length; J++) {
          const le = m[J];
          if (K.endsWith(le))
            return !0;
        }
        return !1;
      }, te = [];
      for (let P = 0; P < this._zkScene.get("textures").length; P++) {
        const K = this._zkScene.get("textures").at(P), J = K.get("url");
        J && M(J) ? Z(J) ? K.set("usage", Zakeke.TextureUsage.Desktop) : V(J) ? K.set("usage", Zakeke.TextureUsage.Mobile) : K.set("usage", Zakeke.TextureUsage.Any) : te.push(K);
      }
      te.length > 0 && this._zkScene.get("textures").remove(te), this._zkScene.set("usedTextureUrls", h);
    }
  }
  // Metodo da usare per le texture caricate dall'utente, per trasformre il percorso assoluto
  // del tipo ..../textures/{ materialID }/{filename.xxx} nel percorso relativo textures/{materialID}/{filename.xxx}
  // Utilizza ed aggiorna eventualmente un dictionary per riutilizzare lo stesso percorso a parità di nome
  extractTextureNameAndUrl(e, t, n) {
    const s = { name: "", url: "" };
    let o = e.lastIndexOf("/");
    if (o !== -1) {
      const h = e.substring(o + 1);
      if (n.hasOwnProperty(h))
        s.url = n[h], s.name = s.url;
      else if (o = e.lastIndexOf("/", o - 1), o !== -1 && (o = e.lastIndexOf("/", o - 1), o !== -1)) {
        const c = e.substring(o + 1);
        s.url = c, s.name = c, t && (n[h] = c);
      }
    }
    return s;
  }
  removeDisabledFresnelParameters() {
    const e = function(t) {
      return t && t.isEnabled != null && !t.isEnabled && t.leftColor != null && t.leftColor != null && t.leftColor instanceof BABYLON.Color3 && t.leftColor.equals(BABYLON.Color3.White()) && t.rightColor != null && t.rightColor != null && t.rightColor instanceof BABYLON.Color3 && t.rightColor.equals(BABYLON.Color3.Black()) && t.bias != null && t.bias == 0 && t.power != null && t.power == 1;
    };
    this._scene && this._scene.materials.forEach(function(t) {
      t instanceof BABYLON.StandardMaterial ? (t.diffuseFresnelParameters && e(t.diffuseFresnelParameters) && (t.diffuseFresnelParameters = new BABYLON.FresnelParameters(), t.diffuseFresnelParameters.isEnabled = !1), t.emissiveFresnelParameters && e(t.emissiveFresnelParameters) && (t.emissiveFresnelParameters = new BABYLON.FresnelParameters(), t.emissiveFresnelParameters.isEnabled = !1), t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = new BABYLON.FresnelParameters(), t.opacityFresnelParameters.isEnabled = !1), t.reflectionFresnelParameters && e(t.reflectionFresnelParameters) && (t.reflectionFresnelParameters = new BABYLON.FresnelParameters(), t.reflectionFresnelParameters.isEnabled = !1), t.refractionFresnelParameters && e(t.refractionFresnelParameters) && (t.refractionFresnelParameters = new BABYLON.FresnelParameters(), t.refractionFresnelParameters.isEnabled = !1)) : t instanceof BABYLON.PBRMaterial || t instanceof Zakeke.PBRMaterial && t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = void 0);
    });
  }
  // Versione che utilizza un webworker (incapsulato in IncrementalFiles) per produrre i file incrementali (ed eventualmente
  // codificarli con Draco). In futuro si potrebbe convertire in async.
  uploadSceneIncrementalFiles(e, t, n, s) {
    if (!this._scene || !this._zkScene || !this._sceneHelper) {
      t && t("No scene to upload");
      return;
    }
    const o = this._zkScene, h = this._sceneHelper;
    let c = o.get("version"), m = this.envMode;
    this.setEnvironmentMode(Ir.Editor), this.disableAntialiasing(!0);
    let x = this.resetCameraRotationLimits();
    this.deleteHighlightLayer(), this.adjustSceneForSerialization(), h.setDummyMaterialToInvisibleMeshes();
    let B = this.getUseDelayedMaterialLoading(), I = this.getUseMaterialOffloading(), F = {}, M = {};
    B ? this.getAllMaterials().forEach((P) => {
      const K = this.getMeshesUsingMaterial(P.id);
      P.id !== "default material" && K.length === 0 && (F[P.id] = {
        name: P.name,
        file: "material_" + c + "_" + P.id.replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".json"
      });
    }) : I && this.getAllMaterials().forEach((P) => {
      const K = this.getMeshesUsingMaterial(P.id);
      P.id !== "default material" && K.length === 0 && (M[P.id] = h.getOffloadedMaterialInfo(P));
    }), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials = M, this._scene.metadata.delayedMaterials = F;
    let Z = BABYLON.SceneSerializer.Serialize(this._scene);
    if (Z.postProcesses = [], Z.metadata && Z.metadata.originalMeshMaterials) {
      const te = JSON.parse(JSON.stringify(Z.metadata.originalMeshMaterials));
      h.unsetAllDummyMaterials(), Z.metadata.originalMeshMaterials = te;
    }
    const V = {
      useDraco: this._dracoEnabled,
      forceDraco: o.getForceDracoCompression() ?? !1,
      dracoEncodingSpeed: this._dracoEncodingSpeed,
      dracoDecodingSpeed: this._dracoDecodingSpeed,
      excludedMeshes: [],
      delayMatarialLoading: Object.keys(F),
      offloadedMaterialIDs: Object.keys(M)
    };
    console.log(V), this.getSceneIncrementalFilesAsync(c, Z, V, n).then(
      (te) => {
        let P = new FormData();
        for (let J = 0; J < te.length; J++) {
          const le = te[J];
          let fe = le.name, X = le.data, W = !1;
          !le.dracoEncoded && le.data.length > 180 && le.data.length < 45e4 && (Logger.info("Uncompressed file length: " + le.data.length), X = LZString.compressToUint8Array(le.data), Logger.info("Compressed file length: " + X.length), fe = "compressed_" + le.name, W = !0);
          let je;
          if (!le.dracoEncoded && !W)
            je = new Blob([X], { type: "text/plain" });
          else {
            var K = X.buffer;
            je = new Blob([K]);
          }
          P.append("file_" + J, je, fe);
        }
        fetch(o.getSceneIncrementalFileUploadUrl(), {
          method: "POST",
          headers: {
            Authorization: "Bearer " + this._authorizationToken
          },
          body: P
        }).then((J) => {
          if (!J.ok)
            throw new Error("HTTP error " + J.status);
          return J.json();
        }).then((J) => {
          e && e(J);
        }).catch(function(J) {
          t && t(J.message);
        }), m != Ir.Editor && this.setEnvironmentMode(m), this.enableAntialiasing(), this.createHighlightLayer(), this.setCameraRotationLimits(x);
      }
    );
  }
  // Utilizza il web worker MakeIncrementalFiles per ottenere i file incrementali (eventualmente codificati con Draco)
  async getSceneIncrementalFilesAsync(e, t, n, s) {
    let o = [];
    return this._incrementalFilesMaker || (this._incrementalFilesMaker = new Dw(this._incrementalWorkersScriptsUrls)), this._incrementalFilesMaker && (await this._incrementalFilesMaker.whenReadyAsync(), o = await this._incrementalFilesMaker.getIncrementalFilesAsync(t, e, n)), o;
  }
  // Fine funzioni salvataggio scena
  // --------------------------------------------------------
  async setNewSceneModelAsync(e, t) {
    this._zkModel = e, this._zkScene = t, await this.init3DEngineAsync(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  getSceneConfig() {
    var e;
    return ((e = this._zkScene) == null ? void 0 : e.getSceneConfig()) ?? null;
  }
  preSceneFileLoading() {
    this.resetRealVisibility();
  }
  postSceneFileLoading() {
    this.fireSceneCreatedEvent(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  // ==============================================================================
  // Importazione Assets
  // ==============================================================================
  // I file "uploadati" dall'utente non vengono caricati immediatamente nella scena
  // ma viene creato un task di elaborazione lato server il cui stato verrà controllato tramite polling.
  // Per ogni task server di caricamento verrà creato un oggetto task lato client che è utile
  // per il recupero tramite polling delle informazioni.
  // I task lato client avranno uno degli stati:
  //   uploading         - Task avviato per l'uploading dei file
  //   progress          - Task in elaborazione
  //   checking          - Chimata Ajax di controllo stato in corso
  //   success           - Task server completato con successo, si possono importare i relativi file nella scena Babylon JS corrente
  //   completed_success - Task eseguito correttamente e file importati nella scena Babylon JS
  //   completed_error   - Task in errore, può essere eliminato dalla lista dei task da controllare
  loadSceneSourceFiles(e, t, n, s) {
    if (this._zkScene) {
      const x = this._zkScene, B = new FormData();
      if (t)
        B.append("url", t);
      else if (e) {
        for (let K = 0; K < e.length; K++)
          B.append("file-" + K, e[K]);
        var o = this._zkScene.getTexturesConfig();
        if (o) {
          var h = new Zakeke.SceneSourceTaskOptions();
          h.set("textures", o);
          var c = JSON.stringify(h), m = new Blob([c], {
            type: "application/json"
          });
          B.append("task-options", m, "task-options.json");
        }
      }
      const I = {
        downloadProgress: 0,
        uploadProgress: 0,
        status: 0,
        message: "",
        sceneSourceInfo: {},
        taskID: void 0,
        sourceID: void 0,
        meshes: []
      };
      this._sceneSourceTasks.push(I);
      const F = x.getSourceTasksUrl(), M = new AbortController();
      this._sceneSourceTaskAbortControllers.set(I, M);
      const Z = new Request(F, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        },
        body: B,
        signal: M.signal
      }), V = (K) => {
        const J = K.loaded / K.total;
        I.uploadProgress = J * 100, this.fireSceneSourceTaskCheckEvent();
      }, te = (K) => {
        const J = K.loaded / K.total;
        I.downloadProgress = J * 100, this.fireSceneSourceTaskCheckEvent();
      }, P = new XMLHttpRequest();
      P.upload.addEventListener("progress", V), P.addEventListener("progress", te), this._sceneSourceTaskXhrs.set(I, P), Z.signal.addEventListener("fetch", () => P.send()), fetch(Z).then((K) => K.json()).then((K) => {
        K && K.hasOwnProperty("taskID") && K.hasOwnProperty("sourceID") ? (I.taskID = K.taskID, I.sourceID = K.sourceID, I.status = 1, this.fireSceneSourceTaskCheckEvent()) : Logger.info("task creation process did not go well"), this._sceneSourceTaskXhrs.delete(I), this._sceneSourceTaskAbortControllers.delete(I), n && n(I);
      }).catch((K) => {
        this._sceneSourceTasks = this._sceneSourceTasks.filter((J) => {
        }), this._sceneSourceTaskXhrs.delete(I), this._sceneSourceTaskAbortControllers.delete(I), this.fireSceneSourceTaskCheckEvent(), (K == null ? void 0 : K.name) !== "AbortError" && s && s(K);
      }), this.fireSceneSourceTaskCheckEvent();
    }
  }
  // Interrompe gli upload in corso e le chiamate di polling per i task di caricamento file
  // avviati tramite loadSceneSourceFiles. I task attualmente in coda vengono svuotati.
  cancelSceneSourceTasks() {
    for (const e of this._sceneSourceTasks) {
      const t = this._sceneSourceTaskXhrs.get(e);
      if (t)
        try {
          t.abort();
        } catch (s) {
          console.warn("Failed to abort scene source task upload", s);
        }
      const n = this._sceneSourceTaskAbortControllers.get(e);
      if (n)
        try {
          n.abort();
        } catch (s) {
          console.warn("Failed to abort scene source task request", s);
        }
      e.status = 5;
    }
    this._sceneSourceTaskXhrs.clear(), this._sceneSourceTaskAbortControllers.clear(), this._sceneSourceTasks = [], this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskCheckEvent();
  }
  // Il metodo viene richiamato ogni secondo per il controllo dei task di caricamento file
  // eventualmente presenti in coda
  checkSceneSourceTasks() {
    if (this._scene && this._zkScene && this._sceneSourceTasks && this._sceneSourceTasks.length > 0) {
      const t = this._zkScene;
      for (let n = 0; n < this._sceneSourceTasks.length; n++) {
        let s = this._sceneSourceTasks[n];
        if (s.status == 5 || s.status == 4) {
          this._sceneSourceTasks.splice(n--, 1), this.fireSceneSourceTaskCheckEvent();
          continue;
        }
        if (!(s.status == 2 || s.status == 0)) {
          if (s.status == 1) {
            s.status = 2;
            const o = (h) => {
              h.status = 5, this.fireSceneSourceTaskErrorEvent(h.taskID), this.fireSceneSourceTaskCheckEvent();
            };
            var e = async (h) => {
              const c = new AbortController();
              this._sceneSourceTaskAbortControllers.set(h, c);
              try {
                const m = await fetch(t.getSourceTaskResultUrl(h.taskID), {
                  method: "GET",
                  cache: "no-cache",
                  headers: {
                    Authorization: "Bearer " + this._authorizationToken
                  },
                  signal: c.signal
                });
                if (m.ok) {
                  const x = await m.json();
                  if (x && x.hasOwnProperty("taskID") && x.hasOwnProperty("state") && x.hasOwnProperty("message") && x.hasOwnProperty("sourceFile"))
                    if (x.state == 2) {
                      h.sceneSourceInfo = {
                        sourceID: x.sourceFile.sourceID,
                        fileObjectID: x.sourceFile.fileObjectID,
                        fileLength: x.sourceFile.fileLength,
                        url: x.sourceFile.url,
                        rootUrl: x.sourceFile.rootUrl,
                        sceneFileName: x.sourceFile.sceneFileName,
                        textureFiles: []
                      };
                      for (let B = 0; B < x.sourceFile.textureFiles.length; B++)
                        h.sceneSourceInfo.textureFiles.push({
                          textureID: x.sourceFile.textureFiles[B].textureID,
                          fileObjectID: x.sourceFile.textureFiles[B].fileObjectID,
                          fileLength: x.sourceFile.textureFiles[B].fileLength,
                          url: x.sourceFile.textureFiles[B].url
                        });
                      h.status = 3;
                    } else
                      x.state == 3 ? o(h) : h.status = 1;
                  else
                    o(h);
                } else
                  o(h);
              } catch (m) {
                if ((m == null ? void 0 : m.name) === "AbortError")
                  return;
                o(h);
              } finally {
                this._sceneSourceTaskAbortControllers.get(h) === c && this._sceneSourceTaskAbortControllers.delete(h);
              }
            };
            e(s);
          }
          s.status == 3 && (this._isLoadingSourceFiles || (this._isLoadingSourceFiles = !0, s.sceneSourceInfo.rootUrl && s.sceneSourceInfo.sceneFileName ? (this.updateSceneModelFromSourceTask(s), this.loadMeshesFromRemoteFiles(
            s.sceneSourceInfo.rootUrl,
            s.sceneSourceInfo.sceneFileName,
            (o) => {
              o && Object.prototype.toString.call(o) === "[object Array]" && o.forEach((h) => {
                h.isPickable = !0;
              }), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskSuccessEvent(o), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), s.meshes = o, s.status = 4;
            },
            (o) => {
              Logger.info("Errore nel caricamento delle mesh: " + o), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(s.taskID), s.status = 5;
            }
          )) : (Logger.info("Risultato del task di caricamento non valido"), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(s.taskID), s.status = 5), this.fireSceneSourceTaskCheckEvent()));
        }
      }
    }
    setTimeout(() => this.checkSceneSourceTasks(), 500);
  }
  updateSceneModelFromSourceTask(e) {
    if (this._zkScene) {
      const t = new Zakeke.SceneSource();
      t.set("sourceID", e.sceneSourceInfo.sourceID), t.set("fileObjectID", e.sceneSourceInfo.fileObjectID), t.set("fileLength", e.sceneSourceInfo.fileLength), t.set("url", e.sceneSourceInfo.url), t.set("rootUrl", e.sceneSourceInfo.rootUrl), t.set("sceneFileName", e.sceneSourceInfo.sceneFileName);
      for (let n = 0; n < e.sceneSourceInfo.textureFiles.length; n++) {
        const s = e.sceneSourceInfo.textureFiles[n];
        if (s.textureID && (s.fileObjectID || s.fileLength) && s.url) {
          const o = new Zakeke.SceneSourceTexture();
          o.set("textureID", s.textureID), o.set("fileObjectID", s.fileObjectID), o.set("fileLength", s.fileLength), o.set("url", s.url), t.get("textures").push(o);
        }
      }
      this._zkScene.get("sources").push(t);
    }
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles(e, t, n, s) {
    if (!this._scene || !this._sceneHelper) {
      s && s("No scene to fill with imported meshes");
      return;
    }
    this._scene;
    const o = this._sceneHelper;
    let h = e + t;
    o.importMeshesFromUrlAsync(h, null, void 0).then(async (c) => (Logger.info("Uploading embedded textures..."), await this.uploadEmbeddedTexturesAsync(), c)).then((c) => (Logger.info("File imported successfully."), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), c)).then((c) => {
      Logger.info("Operation completed successfully."), n == null || n(c);
    }).catch((c) => {
      Logger.info("Error loading file"), s && s(c);
    }), Logger.info("loading finished");
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles_OLD(e, t, n, s) {
    if (!this._scene || !this._sceneHelper) {
      s && s("No scene to fill with imported meshes");
      return;
    }
    const o = this._scene, h = this._sceneHelper;
    let c = t, m = t.lastIndexOf(".");
    m !== -1 && (c = t.substr(0, m));
    const x = this._scene.materials.map((M) => M.id);
    let B;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((M) => {
      B = M.name;
    });
    const I = new BABYLON.AssetsManager(this._scene), F = I.addMeshTask("mesh-task", "", e, t);
    F.onSuccess = (M) => {
      Logger.info("task completed successfully");
      const Z = M.loadedMeshes, V = new BABYLON.Mesh(c, o);
      V.id = Zakeke.generateUUID(), V.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, Z.forEach((te) => {
        te.parent || (te.parent = V), te.material || (te.material = new BABYLON.StandardMaterial(te.name + "Mat", o)), te.id = Zakeke.generateUUID();
      }), o.materials.forEach((te) => {
        oa(x, te.id) || (te.id = Zakeke.generateUUID());
      }), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), h.adjustCamera(B, !1, !1), h.setupShaderMaterialsCameraPosition(), n && n(Z);
    }, F.onError = (M, Z, V) => {
      Logger.info("task completed with errors"), s && s(Z);
    }, I.onFinish = function() {
      Logger.info("loading finished");
    }, I.load();
  }
  // Fine importazione Assets
  // ==============================================================================
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  onMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onSubMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onMaterialChanged(e) {
    this.setRenderingNeeded();
  }
  onLightChanged(e) {
    this.setRenderingNeeded();
  }
  getSceneMeshesByName(e) {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshesByName(e) : [];
  }
  getSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshes() : [];
  }
  getMeshesUsingMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesUsingMaterial(e) : [];
  }
  getMeshesMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesMaterials(e) : [];
  }
  getMeshMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshMaterials(e) : [];
  }
  getAllMaterials() {
    return this._sceneHelper ? this._sceneHelper.getAllMaterials() : [];
  }
  // restituisce un array di gruppi di materiali
  // ogni gruppo è del tipo MaterialGroup, con proprietà
  // "group"(nome del gruppo)
  // "materials"(elenco materiali)
  getGroupedMaterials() {
    const e = [], t = {}, n = this.getAllMaterials();
    for (let s = 0; s < n.length; s++) {
      let o = n[s];
      if (o.id == "groundMaterial")
        continue;
      const h = this.getMaterialGroup(o.id);
      let c = null;
      t.hasOwnProperty(h) ? c = t[h] : (c = new j1(h), e.push(c), t[h] = c), c && c.materials.push(o);
    }
    return e.sort(function(s, o) {
      var h = s.groupName.toLowerCase(), c = o.groupName.toLowerCase();
      return h < c ? -1 : h > c ? 1 : 0;
    });
  }
  // Assegna il gruppo ad un array di materiali
  setMaterialsGroup(e, t, n = !0) {
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      this.setMaterialGroup(o, t, n);
    }
  }
  // Assegna il gruppo ad un singolo materiale
  setMaterialGroup(e, t, n = !0) {
    !this._scene || !this._scene.getMaterialByID(e) || (this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.groups || (this._scene.metadata.groups = {}), this._scene.metadata.groups[e] = t, n && this.fireMaterialsUpdateEvent());
  }
  // Restituisce il gruppo di un materiale
  getMaterialGroup(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) ? this._scene.metadata.groups[e] : pl.EmptyGroupName;
  }
  // Elimina il gruppo di un materiale
  removeMaterialGroup(e) {
    this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) && (delete this._scene.metadata.groups[e], this.fireMaterialsUpdateEvent());
  }
  getMaterialsByGroup(e) {
    const t = [], n = e || pl.EmptyGroupName;
    return this._scene && this._sceneHelper && this._sceneHelper.getAllMaterials().forEach((s) => {
      this.getMaterialGroup(s.id) === n && t.push(s);
    }), t;
  }
  getGroupCenter(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshHierarchyCenter(e) : null;
  }
  getGroupBoundingInfo(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return new BABYLON.BoundingInfo(t.min, t.max);
  }
  showHideBoundingBox(e) {
    this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded();
  }
  updateBoundingBox() {
    this.deleteBoundingBox(), this.showBoundingBox && this.createSceneBoundingBox(!0);
  }
  deleteBoundingBox() {
    let e = this.getSceneBoundingBox();
    e && e.dispose();
  }
  setCameraPositionScale(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraPositionScale(e), this._sceneHelper.setCameraPositionScale(e, !0), this.setRenderingNeeded());
  }
  setCameraPositionFOV(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraPositionFOV(e), this._sceneHelper.setCameraPositionFOV(e), this.setRenderingNeeded());
  }
  setCameraLimitLowerRadius(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLimitLowerRadius(e), this._sceneHelper.setCameraLimitLowerRadius(e, !0), this.setRenderingNeeded());
  }
  setCameraZoomEnabled(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraZoomEnabled(e), this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  setCameraUseMinZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMinZoomPerc(e), this._sceneHelper.setMinZoomPerc(e ? this._zkScene.getCameraMinZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMinZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMinZoomPerc(e);
      var t = this._zkScene.getCameraUseMinZoomPerc();
      this._sceneHelper.setMinZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  setCameraUseMaxZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMaxZoomPerc(e), this._sceneHelper.setMaxZoomPerc(e ? this._zkScene.getCameraMaxZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMaxZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMaxZoomPerc(e);
      const t = this._zkScene.getCameraUseMaxZoomPerc();
      this._sceneHelper.setMaxZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  lockCameraAlphaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha ?? 0;
      this._zkScene.setCameraLowerAlphaLimit(e), this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraAlphaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraAlphaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraAlphaLimits(null, null), this.setRenderingNeeded());
  }
  lockCameraBetaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.beta ?? -1.57;
      this._zkScene.setCameraLowerBetaLimit(e), this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraBetaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraBetaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraBetaLimits(null, null), this.setRenderingNeeded());
  }
  setCameraLowerAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha;
      this._zkScene.setCameraLowerAlphaLimit(e), this._sceneHelper.setCameraLowerAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._sceneHelper.setCameraLowerAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.alpha;
      this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraUpperAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraUpperAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraLowerBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraLowerBetaLimit(e), this._sceneHelper.setCameraLowerBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerBetaLimit() {
    this._zkScene && this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._sceneHelper.setCameraLowerBetaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraUpperBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperBetaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraUpperBetaLimit(null), this.setRenderingNeeded());
  }
  // Mesh selection overrides (the selection logic si a little bit different
  // respect the parent SceneViewer one)
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && this._scene.meshes.forEach((e) => this.unselectSingleMesh(e));
  }
  selectUnselectMesh(e, t) {
    if (this._scene) {
      if (this.deleteBoundingBox(), this.unselectAllMeshes(), t) {
        const n = (o) => {
          this.selectSingleMesh(o), o.getChildMeshes().forEach((h) => n(h));
        };
        let s = this._scene.getMeshByID(e);
        this._isSelectionMode || (s = this.getDAMMainMesh() ?? s), s && n(s), this.setManipulatedNode(s);
      } else
        this.setManipulatedNode(null);
      this.fireSelectionChangedEvent();
    }
  }
  selectSingleMesh(e) {
    e.selected = !0, this.highlightMesh(e, !0), this.setRenderingNeeded();
  }
  unselectSingleMesh(e) {
    e.selected = !1, this.highlightMesh(e, !1), this.setRenderingNeeded();
  }
  isMeshSelected(e) {
    return e && e.selected != null && e.selected;
  }
  // Show-hide mesh methods
  showMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !0, !0);
  }
  hideMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !1, !0);
  }
  showHideMesh(e, t, n = !0) {
    var s;
    if (this._scene && this._sceneHelper && this._camera) {
      this._scene;
      const o = this._sceneHelper, h = this._camera, c = (B, I) => {
        B.isVisible = I, Logger.info(B.name), B.getChildMeshes().forEach((F) => c(F, I));
      }, m = (B, I) => {
        c(B, I), !(o && h && B.metadata && B.metadata.isGroup && B.getChildMeshes().length === 0) && I && !h.isCompletelyInFrustum(B) && (o.adjustCamera(void 0, !1, !1), o.setupShaderMaterialsCameraPosition()), n && this.fireMeshesUpdateEvent(), this.setRenderingNeeded();
      }, x = this._scene.getMeshByID(e);
      if (x) {
        const B = (s = this._zkScene) == null ? void 0 : s.get("rootUrl");
        B ? o.unsetMeshDummyMaterialAsync(x, B, !0).then(() => m(x, t)) : m(x, t);
      }
      this.refreshInfoPoints();
    }
  }
  // Permette di mostrare esclusivamente la mesh selezionata (e i suoi figli)
  // Lo stato precedente delle mesh viene memorizzato in modo da poter essere
  // ripristinato con la funzione resetRealVisibility
  setTemporaryExclusivelyVisible(e) {
    this._scene && (this.resetRealVisibility(), this._realMeshVisibility = {}, this._scene.meshes.forEach((t) => {
      this._realMeshVisibility[t.id] = t.isVisible, this.isRealMesh(t) && (t.isVisible = !1);
    }), this.showHideMesh(e, !0, !1));
  }
  // Reimposto lo stato di visibilità come era precedentemente alla chiamata
  // a setTempraryExclusiveVisible
  resetRealVisibility() {
    this._scene && this._sceneHelper && this._realMeshVisibility && (this._sceneHelper.getSceneMeshes().forEach((t) => {
      this._realMeshVisibility.hasOwnProperty(t.id) && (t.isVisible = this._realMeshVisibility[t.id]);
    }), this.setRenderingNeeded());
  }
  // Funzione per modificare il colore di un materiale in modo progressivo (tramite animazione)
  changeMaterialColor(e, t, n) {
    this._sceneHelper && this._sceneHelper.changeMaterialColor(e, t, n);
  }
  renameMesh(e, t) {
    if (this._scene) {
      const n = this._scene.getMeshByID(e);
      n && (n.name = t, this.fireMeshesUpdateEvent());
    }
  }
  //#region Events
  // PreUpdateEvent
  firePreUpdateEvent() {
    this._preUpdateListeners.forEach((e) => e());
  }
  addPreUpdateListener(e) {
    this._preUpdateListeners.push(e);
  }
  removePreUpdateListener(e) {
    for (let t = 0; t < this._preUpdateListeners.length; t++)
      if (this._preUpdateListeners[t] == e) {
        this._preUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // PostUpdateEvent
  firePostUpdateEvent() {
    this._postUpdateListeners.forEach((e) => e());
  }
  addPostUpdateListener(e) {
    this._postUpdateListeners.push(e);
  }
  removePostUpdateListener(e) {
    for (let t = 0; t < this._postUpdateListeners.length; t++)
      if (this._postUpdateListeners[t] == e) {
        this._postUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // MeshSelected
  fireMeshSelectedEvent(e) {
    this._meshSelectedListeners.forEach((t) => t(e));
  }
  addMeshSelectedListener(e) {
    this._meshSelectedListeners.push(e);
  }
  removeMeshSelectedListener(e) {
    const t = this._meshSelectedListeners.indexOf(e);
    t != -1 && this._meshSelectedListeners.splice(t, 1);
  }
  // SelectionChanged
  fireSelectionChangedEvent() {
    this._selectionChangedListeners.forEach((e) => e());
  }
  addSelectionChangedListener(e) {
    this._selectionChangedListeners.push(e);
  }
  removeSelectionChangedListener(e) {
    const t = this._selectionChangedListeners.indexOf(e);
    t != -1 && this._selectionChangedListeners.splice(t, 1);
  }
  // LightsSelected
  fireLightSelectedEvent(e) {
    this._lightSelectedListeners.forEach((t) => t(e));
  }
  addLightSelectedListener(e) {
    this._lightSelectedListeners.push(e);
  }
  // SceneCreated
  fireSceneCreatedEvent() {
    this._sceneCreatedListeners.forEach((e) => e());
  }
  addSceneCreatedListener(e) {
    this._sceneCreatedListeners.push(e);
  }
  // CameraLocationCreated
  fireCameraLocationCreatedEvent(e) {
    this._cameraLocationCreatedListeners.forEach((t) => t(e));
  }
  addCameraLocationCreatedListener(e) {
    this._cameraLocationCreatedListeners.push(e);
  }
  // CameraLocationsUpdate
  fireCameraLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllCameraLocations()), !e)
      throw "Failed firing positions update event: lights are null and no scene present";
    this._cameraLocationsUpdateListeners.forEach((t) => t(e));
  }
  addCameraLocationsUpdateListener(e) {
    this._cameraLocationsUpdateListeners.push(e);
  }
  removeCameraLocationsUpdateListener(e) {
    const t = this._cameraLocationsUpdateListeners.indexOf(e);
    t != -1 && this._cameraLocationsUpdateListeners.splice(t, 1);
  }
  // SceneSourceTaskSuccess
  fireSceneSourceTaskSuccessEvent(e) {
    this._sceneSourceTaskSuccessListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskSuccessListener(e) {
    this._sceneSourceTaskSuccessListeners.push(e);
  }
  // SceneSourceTaskError
  fireSceneSourceTaskErrorEvent(e) {
    this._sceneSourceTaskErrorListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskErrorListener(e) {
    this._sceneSourceTaskErrorListeners.push(e);
  }
  removeSceneSourceTaskErrorListener(e) {
    const t = this._sceneSourceTaskErrorListeners.indexOf(e);
    t != -1 && this._sceneSourceTaskErrorListeners.splice(t, 1);
  }
  // SceneSourceTaskCheck
  fireSceneSourceTaskCheckEvent() {
    this._sceneSourceTasksCheckListeners.forEach((e) => e());
  }
  addSceneSourceTaskCheckListener(e) {
    this._sceneSourceTasksCheckListeners.push(e);
  }
  removeSceneSourceTaskCheckListener(e) {
    const t = this._sceneSourceTasksCheckListeners.indexOf(e);
    t != -1 && this._sceneSourceTasksCheckListeners.splice(t, 1);
  }
  // MeshesUpdate
  fireMeshesUpdateEvent(e) {
    if (!e && this._scene && (e = this.getSceneMeshes()), !e)
      throw "Failed firing mesh update event: meshes are null and no scene present";
    this._meshesUpdateListeners.forEach((t) => t(e));
  }
  addMeshesUpdateListener(e) {
    this._meshesUpdateListeners.push(e);
  }
  removeMeshesUpdateListener(e) {
    const t = this._meshesUpdateListeners.indexOf(e);
    t != -1 && this._meshesUpdateListeners.splice(t, 1);
  }
  // MaterialsUpdate
  fireMaterialsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getGroupedMaterials()), !e)
      throw "Failed firing materials update event: materials are null and no scene present";
    this._materialsUpdateListeners.forEach((t) => t(e));
  }
  addMaterialsUpdateListener(e) {
    this._materialsUpdateListeners.push(e);
  }
  removeMaterialsUpdateListener(e) {
    const t = this._materialsUpdateListeners.indexOf(e);
    t != -1 && this._materialsUpdateListeners.splice(t, 1);
  }
  // LightsUpdate
  fireLightsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllLights()), !e)
      throw "Failed firing lights update event: lights are null and no scene present";
    this._lightsUpdateListeners.forEach((t) => t(e));
  }
  addLightsUpdateListener(e) {
    this._lightsUpdateListeners.push(e);
  }
  removeLightsUpdateListener(e) {
    const t = this._lightsUpdateListeners.indexOf(e);
    t != -1 && this._lightsUpdateListeners.splice(t, 1);
  }
  // MeshLocationCreated
  fireMeshLocationCreatedEvent(e) {
    this._meshLocationCreatedListeners.forEach((t) => t(e));
  }
  addMeshLocationCreatedListener(e) {
    this._meshLocationCreatedListeners.push(e);
  }
  // MeshLocationsUpdate
  fireMeshLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllMeshLocations()), e)
      this._meshLocationsUpdateListeners.forEach((t) => t(e));
    else
      throw "Failed firing mesh positions update event: positions are null and no scene present";
  }
  addMeshLocatonsUpdateListener(e) {
    this._meshLocationsUpdateListeners.push(e);
  }
  // ArTaskSuccess
  fireArTaskSuccessEvent() {
    this._arTaskSuccessListeners.forEach((e) => e());
  }
  addArTaskSuccessListener(e) {
    this._arTaskSuccessListeners.push(e);
  }
  // ArTaskError
  fireArTaskErrorEvent() {
    this._arTaskErrorListeners.forEach((e) => e());
  }
  addArTaskErrorListener(e) {
    this._arTaskErrorListeners.push(e);
  }
  // ArTaskCheck
  fireArTaskCheckEvent() {
    this._arTasksCheckListeners.forEach((e) => e());
  }
  addArTaskCheckListener(e) {
    this._arTasksCheckListeners.push(e);
  }
  fireFineTuningSettingEvent(e) {
    this._tryOnFineTuningSettingListeners.forEach((t) => t(e));
  }
  addFineTuningSettingListener(e) {
    return this._tryOnFineTuningSettingListeners.push(e), this._tryOnFineTuningSettingListeners.length - 1;
  }
  removeFineTuningSettingListener(e) {
    this._tryOnFineTuningSettingListeners.splice(e, 1);
  }
  removeAllFineTuningSettingListeners() {
    this._tryOnFineTuningSettingListeners = [];
  }
  fireFineTuningCloseEvent() {
    this._tryOnFineTuningCloseListeners.forEach((e) => e());
  }
  addFineTuningCloseListener(e) {
    this._tryOnFineTuningCloseListeners.push(e);
  }
  // Clear
  clearListeners() {
    this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [];
  }
  //#endregion
  //#region Interazione utente (Pointer Down/Move)
  onPointerDown(e, t) {
    if (!(!this._scene || !this._sceneHelper || this._envMode != Ir.Editor) && this._selectOnPick && t && t.hit && t.pickedMesh && t.pickedMesh !== this._ground) {
      this.selectMesh(t.pickedMesh.id);
      const n = this.convertSceneToScreenPoint(this._scene.pointerX, this._scene.pointerY);
      if (n) {
        const s = {
          name: t.pickedMesh.name,
          id: t.pickedMesh.id,
          scenePointerX: this._scene.pointerX,
          scenePointerY: this._scene.pointerY,
          screenPointerX: n.X,
          screenPointerY: n.Y
        };
        this.fireMeshSelectedEvent(s);
      }
    }
  }
  onPointerMove(e, t) {
    if (!this._scene || !this._sceneHelper || this._envMode != Ir.Editor)
      return;
    if (this.highlightMeshOver(!1), !this._highlightOver) {
      this._meshOver = null;
      return;
    }
    const n = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
    n && n.hit && n.pickedMesh && this._sceneHelper.isRealMesh(n.pickedMesh) && (this._meshOver = n.pickedMesh, this.highlightMeshOver(!0));
  }
  //#endregion
  //#region Element Selection
  getSubMesh(e, t) {
    return this._sceneHelper ? this._sceneHelper.getSubMesh(e, t) : null;
  }
  getLightByID(e) {
    return this._scene ? this._scene.getLightByID(e) : null;
  }
  //#endregion
  //#region Apply material
  applyMaterialByName(e, t) {
    this._sceneHelper && this._sceneHelper.applyMaterialByName(e, t);
  }
  applyMaterial(e, t) {
    this._sceneHelper && (this._sceneHelper.applyMaterial(e, t), this.setLongRenderingNeeded());
  }
  applyMaterialToSubMeshByName(e, t, n) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMeshByName(e, t, n);
  }
  applyMaterialToSubMesh(e, t, n) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMesh(e, t, n);
  }
  resetMeshMaterial(e, t) {
    t ? this._initialMeshMaterials : this._lastMeshMaterials;
  }
  resetSubMeshMaterial(e, t, n) {
    const s = n ? this._initialSubMeshMaterials : this._lastSubMeshMaterials;
    if (e && t && e.material instanceof BABYLON.MultiMaterial) {
      const o = t.materialIndex;
      if (o >= 0 && o < e.material.subMaterials.length) {
        const h = `${e.id}_${o}`;
        if (s.hasOwnProperty(h)) {
          const c = s[h], m = this.getMaterialByID(c);
          m && (e.material.subMaterials[o] = m);
        }
      }
    }
    this.setRenderingNeeded();
  }
  //#endregion
  getExtension(e) {
    var t = e.lastIndexOf(".");
    if (t !== -1) {
      var n = e.substring(t).toLowerCase();
      return n;
    }
  }
  //#region Caricamento texture da file esterni
  loadMobileTextureFilesAsync(e, t, n, s) {
    return new Promise((o, h) => {
      this.loadMobileTextureFiles(
        e,
        t,
        n,
        s,
        () => o(),
        (c) => h()
      );
    });
  }
  loadMobileTextureFiles(e, t, n, s, o, h) {
    const c = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      n,
      (m) => {
        m.length > 0 && (c ? this.setMobileCubeTextureImages(m, t, n) : this.setMobileTextureImage(m[0], t, n, s)), o && o();
      },
      h,
      !1
    );
  }
  loadTextureFilesAsync(e, t, n, s) {
    return new Promise((o, h) => {
      this.loadTextureFiles(
        e,
        t,
        n,
        s,
        () => o(),
        (c) => h(c)
      );
    });
  }
  // Per il caso di texture di ambiente si suppone che material sia null e che type sia
  // uno di "environment", "skybox", "ground"
  loadTextureFiles(e, t, n, s, o, h) {
    const c = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      n,
      async (m) => {
        var x, B, I;
        if (m.length > 0) {
          if (c)
            await this.setCubeTextureImages(m, t, n);
          else {
            await this.setTextureImage(m[0], t, n, s);
            const M = ((Z) => {
              const V = {
                clearCoat_textureRoughness: "textureRoughness",
                clearCoat_bump: "bumpTexture",
                clearCoat_tint: "tintTexture",
                clearCoat_texture: "texture",
                sheen_texture: "texture",
                sheen_textureRoughness: "textureRoughness",
                anisotropy_texture: "texture",
                subSurface_thickness: "thicknessTexture",
                subSurface_refractionIntensity: "refractionIntensityTexture",
                subSurface_translucencyIntensity: "translucencyIntensityTexture"
              };
              return V[Z] ? V[Z] : Z.toLowerCase().includes("texture") ? "texture" : Z.split("_")[1] + "Texture";
            })(n);
            (!n.includes("sheen") && !n.includes("clearCoat") && !n.includes("subSurface") && !n.includes("anisotropy") && (!t[n + "Texture"].metadata || !t[n + "Texture"].metadata.mobileUrl) || !((x = t[n.split("_")[0]][M]) != null && x.metadata) || !((I = (B = t[n.split("_")[0]][M]) == null ? void 0 : B.metadata) != null && I.mobileUrl)) && await new Promise(async (Z) => {
              this.uploadTextureFiles(
                e,
                t,
                n,
                async (V) => {
                  this.setMobileTextureImage(V[0], t, n, s), Z();
                },
                h,
                !0
              );
            });
          }
          o && o();
        }
      },
      h,
      !1
    );
  }
  getRecursiveBoundingBox(e) {
    this.calculateRecursiveBoundingBox(e);
    const t = e.getBoundingInfo().boundingBox.scale(2);
    return e.setBoundingInfo(new BABYLON.BoundingInfo(BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero())), new BABYLON.BoundingBox(t.minimum, t.maximum);
  }
  calculateRecursiveBoundingBox(e) {
    const t = (s) => {
      s.refreshBoundingInfo();
      for (const o of s.getChildMeshes(!0))
        t(o);
    };
    t(e);
    const n = e.getHierarchyBoundingVectors(!0);
    e.setBoundingInfo(new BABYLON.BoundingInfo(n.min, n.max));
  }
  calculateBoundingBox(e) {
    let { min: t, max: n } = e[0].getHierarchyBoundingVectors(!1);
    for (let s = 1; s < e.length; s++) {
      const o = e[s].getHierarchyBoundingVectors(!1);
      t = BABYLON.Vector3.Minimize(t, o.min), n = BABYLON.Vector3.Maximize(n, o.max);
    }
    return new BABYLON.BoundingBox(t, n).extendSizeWorld.length();
  }
  // VERIFICA SE CI SONO MESH CHE SUPERANO I BOUNDS DELLE MESH DI RIFERIMENTO
  // Ritorna 1 se la mesh supera il volume di tutte le altre mesh
  // Ritorna -1 se la mesh è superata da almeno una delle altre mesh
  // Ritorna 0 se la mesh non supera il volume di nessuna delle altre mesh o se il volume è simile
  //maxThreshold percentuale di sensibilità del controllo
  //minThreshold aumentondolo aumenta la sensibilità del controllo
  checkMeshHiddenByMeshes(e, t, n, s) {
    const o = this.calculateBoundingBox(t), h = this.calculateBoundingBox(e);
    return h - h * n > o ? 1 : h + h * s < o ? -1 : 0;
  }
  uploadTextureFileAsync(e, t) {
    return new Promise((n, s) => {
      if (!this._scene || !this._zkScene || !e) {
        n(null);
        return;
      }
      const o = t ? t.id : Zakeke.getEmptyUUID(), h = (x) => {
        if (this._zkScene && x && x.textureID && x.materialID && (x.fileObjectID || x.fileLength) && x.url) {
          const B = new Zakeke.SceneTexture();
          return B.set("textureID", x.textureID), B.set("materialID", x.materialID), B.set("fileObjectID", x.fileObjectID), B.set("fileLength", x.fileLength), B.set("url", x.url), this._zkScene.get("textures").push(B), B;
        }
        return null;
      }, c = new FormData();
      c.append("file", e);
      const m = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this._authorizationToken}`
        },
        body: c
      };
      fetch(this.getTexturesUploadUrl(o), m).then((x) => {
        if (x.ok)
          return x.json();
        throw new Error("An error occurred");
      }).then((x) => {
        if (Array.isArray(x)) {
          const B = h(x[0]);
          B ? n(B) : s("Invalid image");
        } else
          s("Invalid image");
      }).catch((x) => {
        s("An error occurred: " + x.message);
      });
    });
  }
  async uploadTextureFiles(e, t, n, s, o, h) {
    if (!this._scene || !this._zkScene || !e || e.length == 0)
      return;
    const c = t ? t.id : Zakeke.getEmptyUUID(), m = (J) => {
      if (this._zkScene && J && J.textureID && J.materialID && (J.fileObjectID || J.fileLength) && J.url) {
        const le = new Zakeke.SceneTexture();
        return le.set("textureID", J.textureID), le.set("materialID", J.materialID), le.set("fileObjectID", J.fileObjectID), le.set("fileLength", J.fileLength), le.set("url", J.url), this._zkScene.get("textures").push(le), le;
      }
      return null;
    }, x = (J) => {
      const le = J.lastIndexOf(".");
      return le !== -1 ? J.substring(le) : null;
    }, B = (J, le) => {
      const fe = J.lastIndexOf(".");
      return fe !== -1 ? J.substring(0, fe).endsWith("_" + le) : !1;
    }, I = x(e[0].name), F = this.canLoadCubemap(t, n) && (e.length == 6 || I === ".dds" || I === ".hdr" || I === ".env" || I === ".basis"), M = [];
    if (F && e.length == 6) {
      const J = ["px", "py", "pz", "nx", "ny", "nz"];
      for (let le = 0; le < e.length; le++) {
        const fe = e[le];
        let X = -1;
        for (let W = 0; W < J.length; W++)
          if (B(fe.name, J[W])) {
            M.push(fe), X = W;
            break;
          }
        X !== -1 && J.splice(X, 1);
      }
      if (J.length != 0) {
        const le = "Immagini per la cube map non valide";
        o && o(le), Logger.info(le);
        return;
      }
    } else
      M.push(e[0]);
    const Z = new FormData();
    for (let J = 0; J < M.length; J++)
      Z.append("file-" + J, M[J]);
    var V = this._zkScene.getTexturesConfig();
    if (V) {
      var te = JSON.stringify(V), P = new Blob([te], {
        type: "application/json"
      });
      Z.append("options", P, "options.json");
    }
    Z.forEach((J) => console.log("File: ", J));
    const K = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this._authorizationToken}`
        // 'Content-Type': 'multipart/form-data',
      },
      body: Z
    };
    fetch(this.getTexturesUploadUrl(c) + "?resize=" + h, K).then((J) => {
      if (!J.ok)
        throw new Error("An error occurred: " + J.status);
      return J.json();
    }).then((J) => {
      const le = [];
      if (Object.prototype.toString.call(J) === "[object Array]")
        for (let fe = 0; fe < J.length; fe++) {
          const X = m(J[fe]);
          if (!X) {
            const W = "Immagini non valide";
            if (o) {
              o(W);
              return;
            }
          }
          X && le.push(X);
        }
      s && s(le);
    }).catch((J) => {
      const le = "An error occurred: " + J.message;
      o && o(le);
    });
  }
  getTexturesUploadUrl(e) {
    return this._zkScene ? this._zkScene.getTexturesUrl(e) : "";
  }
  removeAllMaterialPhotos(e) {
    if (this._zkScene) {
      const t = [];
      for (let n = 0; n < this._zkScene.get("materialPhotos").length; n++)
        this._zkScene.get("materialPhotos").at(n).get("materialID") === e.id && t.push(this._zkScene.get("materialPhotos").at(n));
      t.length > 0 && this._zkScene.get("materialPhotos").remove(t);
    }
  }
  removeMaterialPhotoAtIndex(e, t) {
    if (this._zkScene) {
      const n = [];
      for (let s = 0; s < this._zkScene.get("materialPhotos").length; s++)
        this._zkScene.get("materialPhotos").at(s).get("materialID") === e.id && n.push(this._zkScene.get("materialPhotos").at(s));
      if (n.length > 0) {
        const s = n[t];
        this._zkScene.get("materialPhotos").remove(s);
      }
    }
  }
  loadMaterialPhotoFiles(e, t, n, s) {
    this.uploadMaterialPhotoFiles(
      e,
      t,
      (o) => {
        this.refreshInfoPoints(), n && n();
      },
      s
    );
  }
  uploadMaterialPhotoFiles(e, t, n, s) {
    if (!this._scene || !this._zkScene || !e || e.length === 0)
      return;
    const o = t.id, h = (x) => {
      if (this._zkScene && x && x.photoID && x.materialID && (x.fileObjectID || x.fileLength) && x.url) {
        const B = new Zakeke.SceneMaterialPhoto();
        return B.set("photoID", x.photoID), B.set("materialID", x.materialID), B.set("fileObjectID", x.fileObjectID), B.set("fileLength", x.fileLength), B.set("url", x.url), this._zkScene.get("materialPhotos").push(B), B;
      }
      return null;
    }, c = (x) => {
      const B = x.lastIndexOf(".");
      return B !== -1 ? x.substring(B) : null;
    }, m = new FormData();
    for (let x = 0; x < e.length; x++) {
      const B = c(e[x].name);
      (B === ".png" || B === ".jpg") && m.append("file-" + x, e[x]);
    }
    jQuery.ajax({
      url: this.getMaterialPhotosUploadUrl(o),
      data: m,
      cache: !1,
      contentType: !1,
      processData: !1,
      type: "POST",
      success: (x) => {
        const B = [];
        if (Object.prototype.toString.call(x) === "[object Array]")
          for (let I = 0; I < x.length; I++) {
            const F = h(x[I]);
            if (!F) {
              const M = "Immagini non valide";
              if (s) {
                s(M);
                return;
              }
            }
            F && B.push(F);
          }
        n && n(B);
      },
      error: (x, B, I) => {
        const F = "An error occurred: " + B + " Error: " + I;
        s && s(F);
      }
    });
  }
  getMaterialPhotosUploadUrl(e) {
    return this._zkScene ? this._zkScene.getMaterialPhotosUrl(e) : "";
  }
  // Verifica se il material può caricare una cubemap per il tipo di proprietà specificato (type)
  canLoadCubemap(e, t) {
    return e ? e instanceof BABYLON.StandardMaterial && (t == "reflection" || t == "refraction") ? !0 : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? t === "environment" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? t === "reflection" : e instanceof BABYLON.ShaderMaterial : t == "environment" || t == "skybox";
  }
  // Aggiorna la configurazione di ambiente impostando l'url di una texture caricata
  async setEnvironmentTexture(e, t, n, s) {
    t === "environment" ? await this.setSceneEnvironmentTexture(e, void 0, n, s) : t === "skybox" ? this.setViewerSkyboxTexture(e, n, s) : t === "ground" && this.setViewerGroundTexture(e);
  }
  removeSceneEnvironmentTexture() {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null, this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY), this.setRenderingNeeded();
  }
  setSceneEnvironmentTextureRotationY(e) {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture) && (this._scene.environmentTexture.rotationY = e * Math.PI / 180, this.setLongRenderingNeeded());
  }
  // Crea e imposta la singola texture sul materiale per il tipo di proprietà specificato
  async setTextureImage(e, t, n, s) {
    return new Promise(async (o) => {
      if (this._scene && e && e instanceof Zakeke.SceneTexture) {
        const h = e.get("url");
        if (h)
          if (!t)
            await this.setEnvironmentTexture(h, n, void 0, void 0), o();
          else {
            const c = this.getMaterialTexture(t, n);
            let m = !0;
            c && c instanceof BABYLON.Texture && (m = c.invertY);
            const x = new BABYLON.Texture(
              h,
              this._scene,
              s,
              m,
              void 0,
              () => this.setRenderingNeeded()
            );
            c && c instanceof BABYLON.Texture && (x.uScale = c.uScale, x.vScale = c.vScale, x.uOffset = c.uOffset, x.vOffset = c.vOffset, x.uAng = c.uAng, x.vAng = c.vAng, x.level = c.level, x.coordinatesIndex = c.coordinatesIndex, x.coordinatesMode = c.coordinatesMode, x.hasAlpha = c.hasAlpha, x.wrapU = c.wrapU, x.wrapV = c.wrapV, x.gammaSpace = c.gammaSpace), yi.whenTextureIsReadyAsync(x).then(() => {
              this.applyTexture(x, t, n), c && !this.isTextureUsed(c) && c.dispose(), this.setRenderingNeeded(), o();
            });
          }
      }
    });
  }
  // Crea la cubemap e la imposta sul materiale e tipo di poprietà specificato
  async setCubeTextureImages(e, t, n) {
    return new Promise(async (s) => {
      (!this._scene || Object.prototype.toString.call(e) != "[object Array]") && s();
      for (let m = 0; m < e.length; m++) {
        const x = e[m];
        (!x || !(x instanceof Zakeke.SceneTexture)) && s();
      }
      const o = () => this.setLongRenderingNeeded();
      let h = null;
      const c = this.getCubeTextureInfo(e);
      if (c.url && this._scene)
        if (e.length === 1) {
          const m = c.url;
          m && (t ? m.endsWith(".dds") ? h = BABYLON.CubeTexture.CreateFromPrefilteredData(m, this._scene) : m.endsWith(".hdr") ? h = new BABYLON.HDRCubeTexture(
            m,
            this._scene,
            128,
            void 0,
            void 0,
            void 0,
            void 0,
            o
          ) : m.endsWith(".env") ? h = new BABYLON.CubeTexture(
            m,
            this._scene,
            null,
            !1,
            null,
            o,
            null,
            void 0,
            !0,
            void 0,
            !0
          ) : m.endsWith(".basis") && (h = BABYLON.CubeTexture.CreateFromPrefilteredData(m, this._scene)) : (await this.setEnvironmentTexture(m, n, void 0, void 0), this.setLongRenderingNeeded()));
        } else
          e.length === 6 && c.files.length === 6 && c.extensions.length === 6 && (t ? h = new BABYLON.CubeTexture(
            c.url,
            this._scene,
            c.extensions,
            !1,
            c.files,
            o
          ) : await this.setEnvironmentTexture(
            c.url,
            n,
            c.extensions,
            c.files
          ));
      h ? yi.whenTextureIsReadyAsync(h).then(() => {
        if (t) {
          const m = this.getMaterialTexture(t, n);
          this.applyTexture(h, t, n), m && !this.isTextureUsed(m) && m.dispose(), this.setRenderingNeeded();
        }
        s();
      }) : s();
    });
  }
  setMobileTextureImage(e, t, n, s) {
    if (this._scene && this._sceneHelper) {
      const o = e.get("url");
      if (o) {
        let h = null;
        t ? h = this.getMaterialTexture(t, n) : h = this._scene.environmentTexture, h !== null && this._sceneHelper.isTextureWithUrl(h) && (h.metadata || (h.metadata = {}), h.metadata.mobileUrl = o);
      }
    }
  }
  setMobileCubeTextureImages(e, t, n) {
    if (!this._scene || Object.prototype.toString.call(e) != "[object Array]")
      return;
    for (let o = 0; o < e.length; o++) {
      const h = e[o];
      if (!h || !(h instanceof Zakeke.SceneTexture))
        return;
    }
    const s = this.getCubeTextureInfo(e);
    if (s.url) {
      let o = null;
      t ? o = this.getMaterialTexture(t, n) : o = this._scene.environmentTexture, o && o instanceof BABYLON.CubeTexture && (o.metadata || (o.metadata = {}), o.metadata.mobileUrl = s.url, s.files.length === 6 && (o.metadata.mobileFiles = s.files, o.metadata.mobileExtensions = s.extensions));
    }
  }
  // Costruisce l'url della cubemap da utilizzare per la costruzione della texture di Babylon JS
  // Nel caso di cubemap con 6 immagini (_px _nx...), restituisce l'url senza il suffisso
  getCubeTextureInfo(e) {
    const t = {
      url: null,
      files: [],
      extensions: []
    };
    if (e.length === 1)
      t.url = e[0].get("url") || null;
    else if (e.length === 6) {
      const n = ["px", "py", "pz", "nx", "ny", "nz"];
      let s = null;
      const o = [], h = [], c = (B, I) => {
        const F = B.lastIndexOf(".");
        return F !== -1 ? B.substring(0, F).endsWith("_" + I) : !1;
      }, m = (B, I) => {
        const F = B.lastIndexOf(".");
        if (F !== -1) {
          const M = B.substring(0, F);
          if (M.endsWith("_" + I))
            return M.substring(0, M.length - ("_" + I).length);
        }
        return null;
      }, x = (B, I) => {
        const F = B.lastIndexOf("_" + I);
        return F !== -1 ? B.substr(F) : null;
      };
      for (let B = 0; B < n.length; B++) {
        const I = n[B];
        for (let F = 0; F < e.length; F++) {
          const M = e[F].get("url");
          if (M && c(M, I)) {
            o.push(M);
            const Z = x(M, I);
            Z && h.push(Z), s || (s = m(M, I));
            break;
          }
        }
      }
      t.url = s, t.files = o, t.extensions = h;
    }
    return t;
  }
  isTextureUsed(e) {
    if (this._scene && e)
      for (let t = 0; t < this._scene.materials.length; t++) {
        const s = this._scene.materials[t].getActiveTextures();
        for (let o = 0; o < s.length; o++)
          if (s[o].uid === e.uid)
            return !0;
      }
    return !1;
  }
  async changeTextureInvertYAsync(e, t, n) {
    if (this._scene && this._sceneHelper) {
      var s = this._sceneHelper.getMaterialTexture(e, t);
      if (s && s instanceof BABYLON.Texture && s.invertY != n) {
        let h = s.url;
        if (h) {
          let c = h;
          if (!/^(?:\/|[a-z]+:\/\/)/.test(h)) {
            var o = await this.getSceneRootUrl();
            o && (c = o + h);
          }
          const x = new BABYLON.Texture(
            c,
            this._scene,
            void 0,
            n,
            void 0,
            () => this.setRenderingNeeded()
          );
          s && s instanceof BABYLON.Texture && (x.uScale = s.uScale, x.vScale = s.vScale, x.uOffset = s.uOffset, x.vOffset = s.vOffset, x.uAng = s.uAng, x.vAng = s.vAng, x.level = s.level, x.coordinatesIndex = s.coordinatesIndex, x.coordinatesMode = s.coordinatesMode, x.hasAlpha = s.hasAlpha, x.wrapU = s.wrapU, x.wrapV = s.wrapV, x.gammaSpace = s.gammaSpace), await yi.whenTextureIsReadyAsync(x), this.applyTexture(x, e, t), s && !this.isTextureUsed(s) && s.dispose(), this.setRenderingNeeded();
        }
      }
    }
  }
  applyTextureByName(e, t, n) {
    if (this._scene) {
      const s = this._scene.textures.find((o) => o.name === e);
      s && this.applyTexture(s, t, n);
    }
  }
  applyTexture(e, t, n) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (n) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${n}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(n, e) : t.removeTexture(n);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (n) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
    this.setLongRenderingNeeded();
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "base":
          return e.baseTexture;
        case "metallicRoughness":
          return e.metallicRoughnessTexture;
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "diffuse":
          return e.diffuseTexture;
        case "specularGlossiness":
          return e.specularGlossinessTexture;
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
          return e.albedoTexture;
        case "ambient":
          return e.ambientTexture;
        case "opacity":
          return e.opacityTexture;
        case "reflection":
          return e.reflectionTexture;
        case "emissive":
          return e.emissiveTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "metallic":
          return e.metallicTexture;
        case "microSurface":
          return e.microSurfaceTexture;
        case "bump":
          return e.bumpTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "refraction":
          return e.refractionTexture;
        case "clearCoat":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  removeMaterialTexture(e, t) {
    this.applyTexture(null, e, t);
  }
  removeMaterialMobileTexture(e, t) {
    const n = this.getMaterialTexture(e, t);
    n && n.metadata && n.metadata.mobileUrl && (delete n.metadata.mobileUrl, n.metadata.hasOwnProperty("mobileFiles") && delete n.metadata.mobileFiles, n.metadata.hasOwnProperty("mobileExtensions") && delete n.metadata.mobileExtensions, Object.keys(n.metadata).length === 0 && n.metadata.constructor === Object && delete n.metadata);
  }
  //#endregion
  //#region Operazioni sugli elementi della scena
  /**
   * Create a group of meshes
   * @param parentId Id of the parent node of the group
   * @param name Name of the group
   * @param children Array of meshes to be included in the group
   */
  createGroup(e, t, n) {
    if (this._scene) {
      const s = new BABYLON.Mesh(t, this._scene);
      if (s.id = Zakeke.generateUUID(), s.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, e) {
        const o = this._scene.getMeshByID(e);
        o && (s.parent = o);
      }
      return n && n.forEach((o) => o.parent = s), this.fireMeshesUpdateEvent(), s;
    }
    return null;
  }
  deleteMesh(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const s = this._scene, o = this._sceneHelper, h = this._zkScene, c = s.getMeshByID(e);
      if (c) {
        const m = (B) => {
          const I = this.getMeshMaterials(B);
          for (let F = 0; F < I.length; F++) {
            const M = I[F];
            if (!M)
              continue;
            const Z = this.getMeshesUsingMaterial(M.id);
            Z.length === 1 && Z.every((V) => o.meshHasParent(V.id, c.id)) && (n.materialIDs.push(I[F].id), I[F].dispose());
          }
          B.getChildMeshes().forEach((F) => m(F));
        };
        t && (m(c), this.fireMaterialsUpdateEvent());
        const x = o.getCameraPivot();
        x && x === c && this.setCameraPivot(null), this.isMeshSelected(c) && this.unselectMesh(c.id), c.dispose(), n.meshIDs.push(e);
      }
      this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), n.materialIDs.forEach((m) => {
        const x = h.getLibraryShaderMaterialIDForSceneMaterial(m);
        x && h.unregisterShaderMaterial(x);
      });
    }
    return n;
  }
  // Cancella tutte le mesh
  deleteAllMeshes() {
    if (this._scene && this._sceneHelper) {
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        this._sceneHelper.isRealMesh(t) && (this._scene.meshes.splice(e--, 1), t.dispose());
      }
      this.setCameraPivot(null), this.setRenderingNeeded();
    }
  }
  deleteDuplicatedMeshesWithDifferentParent(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const s = this._scene, o = this._sceneHelper, h = this._zkScene, c = (x) => {
        const B = this.getSceneMeshesByName(x.name);
        let I = !1;
        for (let M = 0; M < B.length; M++) {
          var F = B[M];
          if (F.id != x.id && !o.meshHasParent(F.id, e)) {
            if (t) {
              const Z = this.getMeshMaterials(F);
              for (let V = 0; V < Z.length; V++)
                this.getMeshesUsingMaterial(Z[V].id).length == 1 && (n.materialIDs.push(Z[V].id), Z[V].dispose());
            }
            n.meshIDs.push(F.id), F.dispose(), B.splice(M--, 1), I = !0;
            break;
          }
        }
        I || x.getChildMeshes().forEach((M) => c(M));
      }, m = s.getMeshByID(e);
      m && m.getChildMeshes().forEach((x) => c(x)), this.setRenderingNeeded(), n.materialIDs.forEach((x) => {
        const B = h.getLibraryShaderMaterialIDForSceneMaterial(x);
        B && h.unregisterShaderMaterial(B);
      });
    }
    return n;
  }
  // Cancella tutte le mesh figlie di quella in input
  // che hanno lo stesso nome di altre mesh con id diverso
  // Questa funzione può essere utile per elminiare oggetti duplicati importati
  // con file diversi
  deleteDuplicatedChildMeshes(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const s = this._scene, o = this._sceneHelper, h = this._zkScene, c = (x) => {
        const B = this.getSceneMeshesByName(x.name);
        let I = !1;
        for (let F = 0; F < B.length; F++) {
          const M = B[F];
          if (M.id != x.id && !o.meshHasParent(M.id, e)) {
            if (t) {
              const Z = this.getMeshMaterials(x);
              for (let V = 0; V < Z.length; V++)
                this.getMeshesUsingMaterial(Z[V].id).length == 1 && (n.materialIDs.push(Z[V].id), Z[V].dispose());
            }
            n.meshIDs.push(x.id), x.dispose(), I = !0;
            break;
          }
        }
        if (!I) {
          const F = x.getChildMeshes();
          for (let M = 0; M < F.length; M++)
            c(F[M]);
        }
      }, m = s.getMeshByID(e);
      m && m.getChildMeshes().forEach((x) => c(x)), this.setRenderingNeeded(), n.materialIDs.forEach((x) => {
        const B = h.getLibraryShaderMaterialIDForSceneMaterial(x);
        B && h.unregisterShaderMaterial(B);
      });
    }
    return n;
  }
  deleteMaterial(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMaterialByID(e);
      t && (this.deleteMaterialInternal(t), this.fireMaterialsUpdateEvent(), this.setRenderingNeeded());
    }
  }
  deleteMaterialInternal(e) {
    if (this._scene && this._sceneHelper && e) {
      const t = e.id;
      if (this._zkScene) {
        const s = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e.id);
        s && this._zkScene.unregisterShaderMaterial(s);
      }
      const n = this._sceneHelper.getTexturesExclusivelyForMaterial(e);
      e.dispose();
      for (let s = 0; s < n.length; s++)
        n[s].dispose();
      this._sceneHelper.removeSceneMaterialMetadata(t);
    }
  }
  deleteAllMaterials() {
    if (this._scene) {
      for (; this._scene.materials.length > 0; ) {
        const e = this._scene.materials.pop();
        e && this.deleteMaterialInternal(e);
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
  }
  renameMaterial(e, t) {
    if (this._scene) {
      const n = this._scene.getMaterialByID(e);
      n && (n.name = t), this.fireMaterialsUpdateEvent();
    }
  }
  cloneMesh(e) {
    let t = null;
    return this._scene && this._sceneHelper && (t = this._sceneHelper.cloneMesh(e, !1, !1), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), t;
  }
  // Same as clone but with duplicated geometry data too
  duplicateMesh(e, t = !1) {
    let n = null;
    return this._scene && this._sceneHelper && (n = this._sceneHelper.cloneMesh(e, !0, t), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), n;
  }
  cloneMaterial(e, t, n) {
    let s = null;
    if (this._scene && this._sceneHelper) {
      const h = this._scene.getMaterialById(e);
      if (h) {
        const c = n || h.name + " - clone";
        if (s = h.clone(c), s) {
          const m = t || Zakeke.generateUUID();
          s.id = m;
          const x = this._sceneHelper.getTexturesForMaterial(h), B = this._sceneHelper.getTexturesForMaterial(s);
          for (let I = 0; I < B.length; I++) {
            const F = B[I], M = x[I];
            M && M.metadata && (F.metadata = JSON.parse(JSON.stringify(M.metadata)));
          }
          if (this._zkScene) {
            const I = this._zkScene.getMappingForSceneMaterial(h.id);
            if (I) {
              var o = I.get("libraryMaterialID");
              this._zkScene.mapLibraryMaterial(o, s.id);
              const F = this._sceneHelper.getTexturesForMaterial(h), M = this._sceneHelper.getTexturesForMaterial(s);
              for (let Z = 0; Z < M.length; Z++) {
                const V = M[Z], te = F[Z];
                V.materialMapping = te.materialMapping;
              }
            }
          }
        }
      }
      this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return s;
  }
  createMaterial(e, t, n) {
    let s = null;
    if (this._scene) {
      const o = e || "new material", h = t || "Standard";
      h === "Standard" ? s = new BABYLON.StandardMaterial(o, this._scene) : h === "PBRMetallicRoughness" ? (s = new BABYLON.PBRMetallicRoughnessMaterial(o, this._scene), s.subSurface.indexOfRefraction = 1, s._imageProcessingConfiguration.contrast = 1) : h === "PBRSpecularGlossiness" ? s = new BABYLON.PBRSpecularGlossinessMaterial(o, this._scene) : h === "PBR" ? (s = new BABYLON.PBRMaterial(o, this._scene), s.enableSpecularAntiAliasing = !0, s.metallic = 0.9, s.roughness = 0.3, s.indexOfRefraction = 1.5) : h === "NewPBR" && (s = new Zakeke.PBRMaterial(o, this._scene)), s && (s.id = Zakeke.generateUUID(), n && (s.metadata || (s.metadata = {}), s.metadata.group = n)), this.checkSceneEmptyEnvironmentTexture(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return s;
  }
  changeMeshParent(e, t) {
    if (this._scene) {
      const n = this._scene.getMeshById(e);
      if (n && (!n.parent || n.parent.id != t)) {
        const s = this._scene.getMeshById(t);
        n.setParent(s), this.setRenderingNeeded(), this.fireMeshesUpdateEvent();
      }
    }
  }
  removeMeshParent(e) {
    if (this._scene) {
      const t = this._scene.getMeshByID(e);
      t && (t.parent = null, this.fireMeshesUpdateEvent());
    }
  }
  setManipulatedNode(e) {
    e !== this._manipulatedNode && (this._manipulatedNode = e, this.showHideEditControl(this._editControlVisible), this.setRenderingNeeded());
  }
  importLibraryMaterial(e) {
    if (this._scene && this._sceneHelper && this._zkScene && e && e instanceof Zakeke.Material) {
      e.get("shaders") && this.checkShaderMaterial(e);
      const n = e.get("JSON") || e.get("json"), s = e.get("rootUrl");
      if (n && s) {
        const o = JSON.parse(n), h = BABYLON.Material.Parse(o, this._scene, s);
        if (h) {
          if (h.id = Zakeke.generateUUID(), this._zkScene.mapLibraryMaterial(e.getMaterialID(), h.id), e.get("shaders")) {
            const x = e.get("shaders"), B = x.get("name"), I = x.get("vertex"), F = x.get("fragment");
            B && I && F && this._zkScene.registerShaderMaterial(
              e.getMaterialID(),
              B,
              I,
              F
            ), this.setupShaderMaterialCameraPosition(h);
          }
          e.get("sourceTextureImages").forEach(async (x) => {
            var I, F;
            if ((I = this._zkScene) != null && I.get("textures").find((M) => M.get("url") === x.get("url")))
              return;
            let B = new Zakeke.SceneTexture();
            B.set("textureID", Zakeke.generateUUID()), B.set("materialID", h.id), B.set("fileObjectID", x.get("fileObjectID")), B.set("fileLength", (x == null ? void 0 : x.get("fileLength")) || -1), B.set("url", x.get("url")), (F = this.zkScene) == null || F.get("textures").push(B);
          });
          const m = this._sceneHelper.getTexturesForMaterial(h);
          for (let x = 0; x < m.length; x++) {
            var t = m[x];
            t.materialMapping = {
              libraryMaterialRootUrl: s,
              libraryMaterialID: e.getMaterialID(),
              sceneMaterialID: h.id
            }, t.url && !t.url.startsWith("http") && (t.name = t.url, t.url = s + t.url), t.metadata && t.metadata.mobileUrl && !t.metadata.mobileUrl.startsWith("http") && (t.metadata.mobileUrl = s + t.metadata.mobileUrl);
          }
        }
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Recupero Texture
  // I metodi per il recupero delle texture sono stati spostati in SceneHelper
  // Li lascio qui solo momentaneamente
  getTexturesForMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getTexturesForMaterial(e) : [];
  }
  getStandardMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getStandardMaterialTextures(e) : [];
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRBaseSimpleMaterialTextures(e) : [];
  }
  getPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMaterialTextures(e) : [];
  }
  getNewPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getNewPBRMaterialTextures(e) : [];
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMetallicRoughnessMaterialTextures(e) : [];
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRSpecularGlossinessMaterialTextures(e) : [];
  }
  //#endregion
  //#region Camera Location
  removeCameraLocation(e) {
    var t;
    (t = this._zkScene) == null || t.get("cameraLocations").remove(e), this.fireCameraLocationsUpdateEvent();
  }
  saveCameraLocation(e) {
    if (this._zkScene && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.position, n = this._camera.target, s = new Zakeke.SceneCameraLocation();
      s.set("name", e), s.set("px", t.x), s.set("py", t.y), s.set("pz", t.z), s.set("tx", n.x), s.set("ty", n.y), s.set("tz", n.z), this._zkScene.get("cameraLocations").push(s), this.fireCameraLocationCreatedEvent(s), this.fireCameraLocationsUpdateEvent();
    }
  }
  clearCameraLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("cameraLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
      this.fireCameraLocationsUpdateEvent();
    }
  }
  //public setCameraLocation(locationID: string) {
  //    if (this._sceneHelper && this._zkScene) {
  //        const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
  //        if (zkCameraLocation) {
  //            const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
  //            const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
  //            this._sceneHelper.animateCamera(target, position, 0.5);
  //        }
  //    }
  //    this.setRenderingNeeded();
  //}
  getAllCameraLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("cameraLocations").length; t++)
        e.push(this._zkScene.get("cameraLocations").at(t));
    return e;
  }
  //#endregion
  //#region Collapse / Explode (Mesh Locations)
  saveMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.saveMeshLocation(e);
  }
  saveExplodedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveExplodedMeshLocation();
  }
  saveCollapsedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveCollapsedMeshLocation();
  }
  onBeforeSaveMeshLocation() {
    this._oldManipulatedNode = this._manipulatedNode, this.setManipulatedNode(null);
  }
  onAfterSaveMeshLocation() {
    this.fireMeshLocationsUpdateEvent(), this.setManipulatedNode(this._oldManipulatedNode);
  }
  clearMeshLocations() {
    this._meshLocationsManager && this._meshLocationsManager.clearMeshLocations();
  }
  getAllMeshLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("meshLocations").length; t++)
        e.push(this._zkScene.get("meshLocations").at(t));
    return e;
  }
  //#endregion
  //#region Material Library
  // Nota Bene
  // E' un po' incasinato, c'è da mettere ordine, primo abbozzo di implementazione.
  // Il problema principale è la gestione delle texture
  // che possono provenire da fonti diverse (sorgenti, librerie e caricate singolarmente dall'utente).
  // In breve: innanzitutto scatta una screenshot del materiale. per fare questo nasconde tutte le mesh,
  // crea una sfera temporanea e una camera temporanea prende la screenshot e poi rattiva le mesh così
  // come erano inialmente. Poi, clona il materiale iniziale (babylon) e lo associa ad un nuovo materiale lato server (zkMaterial).
  // Recupera le texture (babylon) associate al materiale di scena.
  // Per copiare le immagini lato server, recupera i fileObjectID per ognuna delle texture.
  // (Per una texture babylon possono esserci più file fileObjectID associati. Ad esempio, per una cubemap, ci saranno 6 fileObjectID associati.)
  // Per ogni fileObjectID, memorizza su skMaterial anche la provenienza, in modo che lato server il path possa essere costruito correttamente.
  // Salva il nuovo zkMaterial (lato server avverrà la copia dei file di immagini texture).
  // Alla fine elimina il nuovo materiale creato come clone.
  makeLibraryMaterial(e, t) {
    return new Promise((n, s) => {
      this.getMaterialScreenShotForLibrary(e, (o) => {
        o ? this.createLibraryMaterial(e, t, o, n) : s("No data generated for screenshot");
      });
    });
  }
  getMaterialScreenShotForLibrary(e, t) {
    if (this._scene && this._sceneHelper) {
      this.resetEditorEnvironment(), this.removeGround(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
      const n = 500, s = 500;
      this._sceneHelper.takeMaterialScreenshotAsync(e, n, s).then((o) => {
        Yw(o, n, s, (h) => {
          this.refreshEnvironment(), t && t(h);
        });
      });
    } else
      t && t(null);
  }
  createLibraryMaterial(e, t, n, s) {
    let o = null;
    const h = () => {
      o && this.deleteMaterial(o.id), s && s();
    };
    if (!this._scene || !this._sceneHelper || !this._zkScene) {
      h();
      return;
    }
    const c = this._scene, m = this._sceneHelper, x = this._zkScene;
    if (!c.getMaterialById(e)) {
      h();
      return;
    }
    const I = new Zakeke.Material();
    I.set("name", t), I.set("imageData", n);
    let F = e, M = F.replace(/-/g, "");
    const Z = I.getMaterialID(), V = Z.replace(/-/g, "");
    if (o = this.cloneMaterial(e, Z, t), !o) {
      h();
      return;
    }
    const te = x.getSourcesIDs(), P = m.getTexturesForMaterial(o), K = [];
    for (let je = 0; je < P.length; je++) {
      const Ee = P[je];
      if (Ee.materialMapping) {
        const He = Ee.materialMapping.libraryMaterialID;
        He && K.push(He);
      }
    }
    let J = new Zakeke.Materials();
    const le = ["px", "py", "pz", "nx", "ny", "nz"], fe = function(je) {
      const Ee = je.lastIndexOf(".");
      if (Ee !== -1) {
        const He = je.substring(0, Ee);
        if (le.some((ft) => He.endsWith("_" + ft)))
          return He.substring(0, He.length - 3);
      }
      return je;
    }, X = (je, Ee) => fe(je).endsWith(Ee), W = async () => {
      var Ee;
      for (let He = 0; He < P.length; He++) {
        const ft = P[He];
        if (ft && m.isTextureWithUrl(ft) && ft.url) {
          let Le = null, $e = null;
          for (let We = 0; We < te.length; We++) {
            const Et = te[We].replace(/-/g, "");
            if (ft.url.indexOf(Et) != -1) {
              Le = te[We], $e = Et;
              break;
            }
          }
          const ce = [];
          for (let We = 0; We < x.get("textures").length; We++) {
            const Et = x.get("textures").at(We);
            Et.get("url") && X(Et.get("url"), ft.url) && ce.push({
              fileObjectID: Et.get("fileObjectID"),
              url: Et.get("url"),
              fileLength: Et.get("fileLength")
            });
          }
          const ut = (ft.url.startsWith("http") ? ft.url : x.get("rootUrl") + ft.url) || "";
          ut && ce.filter((We) => We.url === ut).length === 0 && ce.push({
            url: ut,
            fileLength: ((Ee = ft == null ? void 0 : ft._texture) == null ? void 0 : Ee._size) || -1
          });
          for (let We = 0; We < ce.length; We++) {
            const Et = new Zakeke.MaterialSourceTextureImage();
            Et.set("fileObjectID", ce[We].fileObjectID), Et.set("url", ce[We].url || ""), Et.set("fileLength", ce[We].fileLength || -1), Le ? (Et.set("sceneID", x.getSceneID()), Et.set("sourceID", Le)) : (Et.set("sceneID", x.getSceneID()), Et.set("materialID", F)), I.get("sourceTextureImages").push(Et);
          }
          if (ft.metadata && ft.metadata.mobileUrl) {
            const We = ft.metadata.mobileUrl, Et = new Zakeke.MaterialSourceTextureImage(), rt = We.startsWith("http") ? We : (I.get("rootUrl") || x.get("rootUrl")) + We;
            if (Et.set("url", rt), Et.set("sceneID", x.getSceneID()), Et.set("materialID", F), I.get("sourceTextureImages").push(Et), console.log("#2 scene texture", ft), ft.metadata && ft.metadata.mobileUrl) {
              const it = ft.metadata.mobileUrl;
              ft.metadata.mobileUrl = "textures/" + V + "/" + it.substring(it.lastIndexOf("/") + 1);
            }
          }
          let ze = "", pt = "", qt = ft.name;
          if (Le && $e) {
            const We = ft.url.indexOf($e);
            We != -1 && (qt = ft.url.substring(We)), ze = $e, pt = "textures/" + V, ft.name = qt.replace(new RegExp(ze, "g"), pt);
          } else {
            var je = ft.url.lastIndexOf("/");
            je !== -1 && (je = ft.url.lastIndexOf("/", je - 1), je !== -1 && (je = ft.url.lastIndexOf("/", je - 1), je != -1 && (qt = ft.url.substring(je + 1)))), ze = M, pt = V, ft.name = qt.replace(
              new RegExp("textures/([A-Za-z0-9]*)/(.*)", "g"),
              "textures/" + pt + "/$2"
            );
          }
          ft.url = ft.name;
        }
      }
      if (o) {
        const He = o.serialize(), ft = JSON.stringify(He);
        I.set("JSON", ft), I.save(null, {
          success: function(Le, $e, ce) {
            h();
          },
          error: function(Le, $e, ce) {
            h();
          }
        });
      } else
        h();
    };
    if (K.length > 0) {
      const je = { ids: K.join(",") };
      try {
        J.fetch({
          success: (Ee, He, ft) => {
            J = Ee, W();
          },
          error: (Ee, He, ft) => {
            Logger.info("Errore nel salvataggio del materiale di libreria"), h();
          },
          data: je
        });
      } catch {
      }
    } else
      W();
  }
  //#endregion
  //#region Lights
  lightsLayer_onLightSelected(e) {
    this.fireLightSelectedEvent(e);
  }
  isDefaultLight(e) {
    return this._sceneHelper ? this._sceneHelper.isDefaultLight(e) : !1;
  }
  createLight(e, t) {
    let n = null;
    if (this._scene) {
      const s = e || "new light", o = t || "Point", h = BABYLON.Vector3.Zero(), c = BABYLON.Vector3.Zero(), m = 25 * Math.PI / 180, x = 2;
      o == "Point" ? n = new BABYLON.PointLight(s, h, this._scene) : o == "Directional" ? n = new BABYLON.DirectionalLight(s, c, this._scene) : o == "Spot" ? n = new BABYLON.SpotLight(s, h, c, m, x, this._scene) : o == "Hemispheric" && (n = new BABYLON.HemisphericLight(s, c, this._scene)), n && (n.id = Zakeke.generateUUID()), this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return n;
  }
  cloneLight(e, t, n) {
    let s = null;
    if (this._scene) {
      const o = this._scene.getLightByID(e);
      if (o) {
        const h = n || o.name + " - clone";
        if (s = o.clone(h), s) {
          s.name = h;
          const c = t || Zakeke.generateUUID();
          s.id = c, this._lightsLayer && this._lightsLayer.refresh();
        }
      }
      this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return s;
  }
  renameLight(e, t) {
    if (this._scene) {
      const n = this._scene.getLightByID(e);
      n && (n.name = t, this._lightsLayer && this._lightsLayer.refresh()), this.fireLightsUpdateEvent();
    }
  }
  deleteLight(e) {
    if (this._scene) {
      const t = this._scene.getLightByID(e);
      t && (t.dispose(), this._scene.meshes.forEach((n) => n._markSubMeshesAsLightDirty()), this._lightsLayer && this._lightsLayer.refresh()), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
  }
  getAllLights() {
    return this._scene ? this._scene.lights : [];
  }
  canShowLights() {
    return this._showLights && this._envMode == Ir.Editor;
  }
  showHideLights(e) {
    this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Ground
  canShowGround() {
    return this._showGround && this._envMode == Ir.Editor;
  }
  removeGround() {
    this._ground && (this._ground.dispose(), this._ground = null), this.setRenderingNeeded();
  }
  refreshGround() {
    if (!this._scene)
      return;
    if (this.removeGround(), !this.canShowGround()) {
      this.setRenderingNeeded();
      return;
    }
    const e = this._scene.clearColor, t = e.toHexString(), n = Vw(t) ? 0.8 : -0.5, s = BABYLON.Color3.FromHexString(Hw(t, n));
    let o = 1e3, h = 1;
    if (this.countSceneMeshes() > 0) {
      const m = this._scene.getWorldExtends((I) => this.isRealMesh(I)), B = m.max.subtract(m.min).length() * 1.5;
      isFinite(B) && (o = B * 20, h = o / 100);
    }
    this._ground = BABYLON.Mesh.CreateGround("ground", o, o, 10, this._scene), this._ground.doNotSerialize = !0, this._ground.isVisible = this.showGround, this._ground.isPickable = !1, this._ground.metadata = {
      isRealMesh: !1,
      isGround: !0
    };
    const c = new BABYLON.GridMaterial("groundMaterial", this._scene);
    c.doNotSerialize = !0, c.backFaceCulling = !1, c.mainColor = new BABYLON.Color3(e.r, e.g, e.b), c.opacity = 1, c.gridRatio = h, c.lineColor = s, c.metadata = { isRealMaterial: !1 }, this._ground.material = c, this.setRenderingNeeded();
  }
  showHideGround(e) {
    this.showGround = e, this.refreshGround();
  }
  //#endregion
  //#region Axes
  canShowAxes() {
    return this._showAxes && this._envMode == Ir.Editor;
  }
  showHideAxes(e) {
    this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Highlights
  showHideHighlight(e) {
    this._showHighlight = e;
    const t = this.getSelectedRootMesh();
    this.highlightMesh(t, e), this.setRenderingNeeded();
  }
  setHighlightOver(e) {
    this._highlightOver = e;
  }
  highlightMesh(e, t) {
    if (!this._showHighlight || this._envMode != Ir.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    e && e instanceof BABYLON.Mesh && (t ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && this._highlightLayer.addMesh(e, BABYLON.Color3.FromHexString(this._highlightColor))) : this._highlightLayer && this._highlightLayer.removeMesh(e)), this.setLongRenderingNeeded();
  }
  highlightMeshOver(e) {
    if (!this._showHighlight || this._envMode != Ir.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    this._meshOver && this._meshOver instanceof BABYLON.Mesh && !this.isMeshSelected(this._meshOver) && (e && this._highlightOver ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && !this._highlightLayer.hasMesh(this._meshOver) && this._highlightLayer.addMesh(this._meshOver, BABYLON.Color3.FromHexString(this.highlightOverColor))) : this._highlightLayer && this._highlightLayer.removeMesh(this._meshOver)), this.setLongRenderingNeeded();
  }
  //#endregion
  //#region Edit control (Gizmo)
  showHideEditControl(e) {
    this._scene && this._camera && this._canvas && (this._editControlVisible = e, this._editControl && (!e || this._manipulatedNode == null) && (this._editControl.detach(), this._editControl = null), e && this._manipulatedNode && (this._editControl ? this._editControl.switchTo(this._manipulatedNode) : (this._editControl = new this._EditControl(
      this._manipulatedNode,
      this._camera,
      this._canvas,
      0.75,
      !0
    ), this._editControl.setRotSnapValue(3.14 / 18), this._editControl.setTransSnapValue(0.5), this._editControl.setScaleSnapValue(0.25), this._editControl.addActionEndListener((t) => {
      this.fireMeshesUpdateEvent();
    })), this.setEditingMode(this._editingMode)), this.setRenderingNeeded());
  }
  setEditingMode(e) {
    this._editingMode = e, this._editControl && (e === Ja.Translate ? this._editControl.enableTranslation() : e === Ja.Rotate ? this._editControl.enableRotation() : e === Ja.Scaling && this._editControl.enableScaling()), this.setRenderingNeeded();
  }
  undoEditing() {
    this._editControl && this._editControl.undo();
  }
  redoEditing() {
    this._editControl && this._editControl.redo();
  }
  //#endregion
  //#region Environment
  setEnvironmentMode(e) {
    e != this._envMode && (this._envMode = e, this.refreshEnvironment());
  }
  async refreshEnvironment() {
    this._scene && (this.setRenderingNeeded(), this._envMode == Ir.Editor ? (this.disableAntialiasing(), this.resetEditorEnvironment(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null)) : (this.deleteHighlightLayer(), this.refreshGround(), this._zkScene && ((!this._environmentManager || this._environmentManager.scene != this._scene || this._environmentManager.zkScene != this._zkScene) && (this._environmentManager = new cg(this._zkScene, this._scene)), this._environmentManager.update(), this.setLongRenderingNeeded())), this.refreshGround(), this._lightsLayer && this._lightsLayer.refresh(), this._axesLayer && this._axesLayer.refresh(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this.autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded());
  }
  //#endregion
  //#region Zoom & Move camera
  zoomOnMesh(e) {
    this._sceneHelper && this._sceneHelper.zoomOnMesh(e);
  }
  // Sperimentale (è difficile capire come muovere la camera per inquadrare un oggetto)
  moveCameraToMeshPosition(e) {
    if (this._scene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this._sceneHelper.getMeshHierarchyCenter(e), s = this._camera.target, o = this._camera.radius, h = n.subtract(s), c = h.length();
      if (isFinite(c)) {
        let m = h.normalize(), x = s.add(m.scale(o));
        const B = new BABYLON.Ray(x, m.scale(-1), o), I = this._scene.pickWithRay(B, (F) => F === e);
        if (I && I.hit) {
          const F = new BABYLON.Vector3(), M = new BABYLON.Quaternion(), Z = new BABYLON.Vector3();
          e.getWorldMatrix().decompose(F, M, Z), 0.1 / F.length() * 100, I.pickedPoint;
          var t = I.getNormal();
          t && (m = t.normalize(), x = s.add(m.scale(o)));
        }
        this._sceneHelper.animateCamera(s, x, 1);
      }
      this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Scene & Mesh Export: USDZ, glTF, Obj, AR
  exportMeshToOBJ(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const n = BABYLON.OBJExport.OBJ([t]);
    this.saveTextAsFile(n, t.name + ".obj");
  }
  exportMeshGeometryToJson(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const n = {
      positions: t.getVerticesData(BABYLON.VertexBuffer.PositionKind),
      normals: t.getVerticesData(BABYLON.VertexBuffer.NormalKind),
      colors: t.getVerticesData(BABYLON.VertexBuffer.ColorKind),
      uvs: t.getVerticesData(BABYLON.VertexBuffer.UVKind),
      uvs2: t.getVerticesData(BABYLON.VertexBuffer.UV2Kind),
      indices: t.getIndices()
    }, s = JSON.stringify(n, null, 0);
    this.saveTextAsFile(s, t.name + ".json");
  }
  enableDisableARForMesh(e, t) {
    const n = this.getMeshByID(e);
    n && (n.metadata || (n.metadata = {}), n.metadata.AR = t);
  }
  isAREnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.AR !== void 0 ? t.metadata.AR : !0 : !1;
  }
  enableDisableTryOnForMesh(e, t) {
    const n = this.getMeshByID(e);
    n && (n.metadata || (n.metadata = {}), n.metadata.AR = t);
  }
  isTryOnEnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.TryOn !== void 0 ? t.metadata.TryOn : !0 : !1;
  }
  //#endregion
  //#region Utilities
  splitSubMeshes(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      t && this._sceneHelper.createMeshesFromSubMeshes(t);
    }
  }
  flipMeshFaces(e) {
    const t = this.getMeshByID(e);
    if (!t)
      return;
    const n = (s) => {
      s instanceof BABYLON.Mesh && s.flipFaces(!0), s.getChildMeshes().forEach((o) => n(o));
    };
    n(t);
  }
  convertSceneToScreenPoint(e, t) {
    if (this._canvas) {
      let n = 0, s = 0, o = this._canvas;
      do
        n += o.offsetLeft, s += o.offsetTop, o = o.offsetParent;
      while (o);
      return { X: e + n, Y: t + s };
    }
    return null;
  }
  saveTextAsFile(e, t) {
    const n = e, s = new Blob([n], { type: "text/plain" }), o = window.URL.createObjectURL(s), h = t;
    this.downloadFile(h, o);
  }
  saveBytesAsFile(e, t) {
    const n = new Blob([e]), s = window.URL.createObjectURL(n);
    this.downloadFile(t, s);
  }
  saveBlobAsFile(e, t, n) {
    let s = null;
    n ? s = window.URL.createObjectURL(new Blob([e], { type: n })) : s = window.URL.createObjectURL(new Blob([e])), this.downloadFile(t, s);
  }
  downloadFile(e, t) {
    var n = document.createElement("a");
    n.download = e, n.innerHTML = "Download File", n.href = t, n.onclick = (s) => {
      document.body.removeChild(n);
    }, n.style.display = "none", document.body.appendChild(n), n.click();
  }
  //#endregion
  //#region Draco
  // Test Draco encoding
  exportDracoEncodedToFile(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t)
      return;
    const n = this.getDracoEncodedGeometry(t);
    n && this.saveBytesAsFile(n, t.name + "_draco.dat");
  }
  // Funzione utile per testare la codifica Draco delle geometrie
  // La codifica reale delle mesh avviene durante il salvataggio e se ne
  // occupa la classe MakeIncremental, utilizzata in un worker thread
  getDracoEncodedGeometry(e) {
    let t = null;
    if (this._scene && e && e instanceof BABYLON.Mesh) {
      const s = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), o = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), h = e.getVerticesData(BABYLON.VertexBuffer.ColorKind), c = e.getVerticesData(BABYLON.VertexBuffer.UVKind), m = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind), x = e.getIndices(), B = {};
      x && (B.indices = new Uint32Array(x)), s && (B.positions = new Float32Array(s)), o && (B.normals = new Float32Array(o)), c && (B.uvs = new Float32Array(c)), m && (B.uvs2 = new Float32Array(m)), h && (B.colors = new Uint32Array(h));
      const I = DracoEncoderModule(), F = new I.Encoder(), M = new I.MeshBuilder(), Z = new I.Mesh(), V = B.indices.length / 3, te = B.positions.length / 3;
      M.AddFacesToMesh(Z, V, B.indices), M.AddFloatAttributeToMesh(Z, I.POSITION, te, 3, B.positions), B.normals && M.AddFloatAttributeToMesh(Z, I.NORMAL, te, 3, B.normals), B.colors && M.AddFloatAttributeToMesh(Z, I.COLOR, te, 4, B.colors), B.uvs && M.AddFloatAttributeToMesh(Z, I.TEX_COORD, te, 2, B.uvs), B.uvs2 && M.AddFloatAttributeToMesh(Z, I.TEX_COORD, te, 2, B.uvs2), F.SetSpeedOptions(5, 5), F.SetAttributeQuantization(I.POSITION, 14), F.SetAttributeQuantization(I.TEX_COORD, 12), F.SetAttributeQuantization(I.NORMAL, 10), F.SetAttributeQuantization(I.COLOR, 10), F.SetAttributeQuantization(I.GENERIC, 8), F.SetEncodingMethod(I.MESH_EDGEBREAKER_ENCODING);
      const P = new I.DracoInt8Array(), K = F.EncodeMeshToDracoBuffer(Z, P);
      t = new ArrayBuffer(K);
      var n = new Int8Array(t);
      for (let J = 0; J < K; ++J)
        n[J] = P.GetValue(J);
      I.destroy(Z), I.destroy(P), I.destroy(F), I.destroy(M);
    }
    return t;
  }
  // Decodifica dei dati Draco ereditata da SceneViewer
  //#endregion
  //#region Mesh Creation
  // Crea una mesh (cubo) custom specificandone la geometria
  // utile per comprendere il modo in cui Babylon JS organizza i dati delle geomtrie
  createCustomMesh() {
    let e = null;
    if (this._scene) {
      e = new BABYLON.Mesh("custom", this._scene);
      var t = [-5, 2, -3, -7, -2, -3, -3, -2, -3, 5, 2, 3, 7, -2, 3, 3, -2, 3], n = [0, 1, 2, 3, 4, 5], s = [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1], o = [0, 1, 0, 0, 1, 0], h = [];
      BABYLON.VertexData.ComputeNormals(t, n, h);
      const c = new BABYLON.VertexData();
      c.positions = t, c.indices = n, c.colors = s, c.normals = h, c.uvs = o, c.applyToMesh(e);
    }
    return e;
  }
  createBox(e, t) {
    let n = null, s = null;
    return this._scene && this._sceneHelper && (e && (s = this._scene.getMeshByID(e)), n = this._sceneHelper.createBox(s, t), this.setLongRenderingNeeded()), n;
  }
  getSceneBoundingBox() {
    let e = null;
    if (this._scene)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const n = this._scene.meshes[t];
        if (n && n.metadata && n.metadata.sceneBoundingBox) {
          e = n;
          break;
        }
      }
    return e;
  }
  getOrCreateSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t || (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t ? t.isVisible = e : (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createBoundingBox(e, t, n = !0) {
    let s = null;
    if (e && (s = this.getMeshByID(e)), this._sceneHelper) {
      var o = this._sceneHelper.createBoundingBox(s, t);
      return o && (o.isVisible = n), this.setLongRenderingNeeded(), o;
    }
    return null;
  }
  createSphere(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createSphere(s, t), this.setLongRenderingNeeded()), n;
  }
  createPlane(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createPlane(s, t), this.setLongRenderingNeeded()), n;
  }
  createDisc(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createDisc(s, t), this.setLongRenderingNeeded()), n;
  }
  createCylinder(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createCylinder(s, t), this.setLongRenderingNeeded()), n;
  }
  createTorus(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createTorus(s, t), this.setLongRenderingNeeded()), n;
  }
  createKnot(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createKnot(s, t), this.setLongRenderingNeeded()), n;
  }
  createRibbon(e, t) {
    let n = null, s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createRibbon(s, t), this.setLongRenderingNeeded()), n;
  }
  async createRoundedCubeAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createRoundedCubeAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createRoundedCylinderAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createRoundedCylinderAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createMatBallAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createMatBallAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createMaleHeadAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createMaleHeadAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createFemaleHeadAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createFemaleHeadAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createPokemonBallAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createPokemonBallAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createShaderBallAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createShaderBallAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createBootsAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createBootsAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createSuzanneAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createSuzanneAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createStepPyramidAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createStepPyramidAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createTeapotAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createTeapotAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createAlloyWheelAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createAlloyWheelAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  async createTryonReferenceGlassesFrameAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createTryonReferenceGlassesFrameAsync(s, t), this.setLongRenderingNeeded()), n;
  }
  removeAllVTOReferenceMeshes() {
    if (!this.scene)
      return [];
    const e = [], t = [...this.scene.meshes];
    for (const n of t)
      n.name && n.name.toLowerCase().includes("vto_reference") ? n.dispose(!1, !0) : e.push(n);
    return e;
  }
  hideAllVTOFiles(e) {
    for (const t of e)
      t.name && t.name.toLowerCase().includes("vto_reference") && (t.metadata || (t.metadata = {}), t.metadata.TryOn = !1);
  }
  async createTryOnReferenceModelsAsync(e, t, n) {
    let s = null, o = [];
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (o = await this._sceneHelper.createTryOnReferenceModelsAsync(s, t, n), this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), this.hideAllVTOFiles(o)), o;
  }
  setTryOnReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setTryOnReferenceVisible(e), this.setRenderingNeeded());
  }
  isTryOnReferenceVisible() {
    return this._sceneHelper ? this._sceneHelper.isTryOnReferenceVisible() : !1;
  }
  scaleSceneToTryonReferenceModels(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.scaleSceneToTryonReferenceModels(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneScalingPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneScalingPercentageForVTO() : 100;
  }
  setSceneScalePercentageForVTO(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setSceneScalePercentageForVTO(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getScenePositionPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getScenePositionPercentageForVTO() : { x: 0, y: 0, z: 0 };
  }
  setScenePositionPercentageForVTO(e, t, n) {
    var s;
    this._sceneHelper && (this._sceneHelper.setScenePositionPercentageForVTO(e, t, n), (s = this._sceneHelper) == null || s.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneRotationForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneRotationForVTO() : { x: 0, y: 0, z: 0 };
  }
  setSceneRotationForVTO(e, t, n) {
    var s;
    this._sceneHelper && (this._sceneHelper.setSceneRotationForVTO(e, t, n), (s = this._sceneHelper) == null || s.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  setVTOReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setVTOReferenceVisible(e), this.setRenderingNeeded());
  }
  setShadowsVisibility(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setShadowsVisibility(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  async importMeshesFromUrlAsync(e, t) {
    let n = [], s = null;
    return this._scene && e && (s = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.importMeshesFromUrlAsync(t, s), this.checkSceneEmptyEnvironmentTexture(), this.setLongRenderingNeeded()), n;
  }
  //#endregion
  //#region 2D Design Rendering
  async connectMeshToModelSideAsync(e, t, n) {
    this._sceneDesignManager && this._sceneDesignManager.connectMeshToModelSideAsync(e, t, n);
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  getMeshDesignMananger(e, t) {
    var n;
    return this._sceneDesignManager && this.scene ? (n = this._sceneDesignManager) == null ? void 0 : n.getMeshDesignMananger(e, t) : null;
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, n, s) {
    this._sceneDesignManager && this._sceneDesignManager.translateDesignView(e, t, n, s);
  }
  rotateDesignView(e, t, n, s, o) {
    this._sceneDesignManager && this._sceneDesignManager.rotateDesignView(e, t, n, s, o);
  }
  scaleDesignView(e, t, n, s, o, h) {
    this._sceneDesignManager && this._sceneDesignManager.scaleDesignView(e, t, n, s, o, h);
  }
  async setDesignViewTextureUVChannelAsync(e, t, n) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewTextureUVChannelAsync(e, t, n);
  }
  async setDesignViewFormFactorAsync(e, t, n, s) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewFormFactorAsync(e, t, n, s);
  }
  //#endregion
  //#region Mesh measuring
  getCurrentARMeshUsedForMeasure() {
    var t;
    return (t = this.scene) == null ? void 0 : t.meshes.find((n) => n.metadata && n.metadata.sizecm);
  }
  getCurrentARSizeCm() {
    var t;
    const e = this.getCurrentARMeshUsedForMeasure();
    return (t = e == null ? void 0 : e.metadata) == null ? void 0 : t.sizecm;
  }
  setSceneSizeCm(e, t) {
    const n = this.getOrCreateSceneBoundingBox(!1);
    n && this.setMeshSizeCm(n.id, e, t);
  }
  getSceneWidthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.width ? e.metadata.sizecm.width : null;
  }
  getSceneHeightCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.height ? e.metadata.sizecm.height : null;
  }
  getSceneDepthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.depth ? e.metadata.sizecm.depth : null;
  }
  setMeshSizeCm(e, t, n) {
    const s = this.getMeshByID(e);
    if (s) {
      let o = null;
      t && typeof t == "number" && !isNaN(t) && (n === "width" ? o = { width: t } : n === "height" ? o = { height: t } : n === "depth" && (o = { depth: t })), s.metadata || (s.metadata = {}), s.metadata.sizecm = o;
    }
  }
  getMeshWidthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.width ? t.metadata.sizecm.width : null;
  }
  getMeshHeightCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.height ? t.metadata.sizecm.height : null;
  }
  getMeshDepthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.depth ? t.metadata.sizecm.depth : null;
  }
  //#endregion
  //#region Material Previews
  async getMaterialsPreviewsAsync(e, t, n, s, o = !0) {
    const h = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const m = await this.getSceneRootUrl();
      if (m) {
        const x = await fo.getPreviewsAsync(
          this._scene,
          m,
          e,
          { width: t, height: n },
          !0
        );
        for (var c in x.previewFiles)
          h.push(x.previewFiles[c]);
      }
    }
    return h;
  }
  async getAllMaterialsPreviewsAsync(e, t, n, s = !0) {
    const o = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const c = this._sceneHelper.getAllMaterials().map((m) => m.id);
      return this.getMaterialsPreviewsAsync(c, e, t, n, s);
    }
    return o;
  }
  async downloadMaterialsPreviewsAsync(e, t, n, s) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = await this.getSceneRootUrl();
      o && await fo.downloadPreviewsAsync(this._scene, o, e, {
        width: t,
        height: n,
        crop: s
      });
    }
  }
  async downloadAllMaterialsPreviewsAsync(e, t, n) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._sceneHelper.getAllMaterials().map((h) => h.id);
      await this.downloadMaterialsPreviewsAsync(o, e, t, n);
    }
  }
  //#endregion
  createEnvelopeMesh(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      if (t && t instanceof BABYLON.Mesh)
        return this._sceneHelper.createEnvelopeMesh(t);
    }
    return null;
  }
  expandMesh(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && n instanceof BABYLON.Mesh && this._sceneHelper.expandMesh(n, t);
    }
  }
  enableDisableMeshFacetData(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && (t ? n.updateFacetData() : n.disableFacetData());
    }
  }
  enableDisableDepthSortFacets(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && (n.mustDepthSortFacets = t);
    }
  }
};
Lg.EmptyGroupName = "_dummy_";
let q1 = Lg;
var Z1 = /* @__PURE__ */ ((y) => (y[y.Box = 0] = "Box", y[y.RoundedBox = 1] = "RoundedBox", y[y.Sphere = 2] = "Sphere", y[y.Plane = 3] = "Plane", y[y.Cylinder = 4] = "Cylinder", y[y.RoundedCylinder = 5] = "RoundedCylinder", y[y.Torus = 6] = "Torus", y[y.Knot = 7] = "Knot", y[y.Ribbon = 8] = "Ribbon", y[y.Custom = 9] = "Custom", y))(Z1 || {});
class Bg extends q1 {
  constructor(e) {
    super(e), this._zkMaterial = null, this._material = null, this._meshType = 0, this._mesh = null, this._materialCreatedListeners = [], this._filesInput = null;
  }
  get zkMaterial() {
    return this._zkMaterial;
  }
  get material() {
    return this._material;
  }
  static async createMaterialEditorAsync(e) {
    e || (e = {
      authorizationToken: "",
      showGround: !1,
      editorBackgroundColor: "#33334c",
      showHighlight: !1,
      incrementalWorkersScriptsUrls: []
    });
    const t = new Bg(e);
    return await t.initAsync(), t;
  }
  deleteComponents() {
    super.deleteComponents(), this.deleteEditorMaterial(), this.deleteEditorMesh();
  }
  deleteEditorMaterial() {
    this._material && (this._material.dispose(), this._material = null, this.fireMaterialCreatedEvent());
  }
  deleteEditorMesh() {
    this._mesh && (this._mesh.dispose(), this._mesh = null), this._scene && this._sceneHelper && this._sceneHelper.getSceneMeshes().forEach((t) => t.dispose());
  }
  dispose() {
    super.dispose();
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this.createEditorMaterial(void 0, "Standard"), await this.createEditorMeshAsync();
  }
  createEditorMaterial(e, t, n) {
    let s = null;
    return t != "ShaderMaterial" ? s = super.createMaterial(e, t, n) : (s = this.createShaderMaterial(), s && (s.id = Zakeke.generateUUID(), this.checkSceneEmptyEnvironmentTexture())), this._material = s, this.setRenderingNeeded(), this.fireMaterialCreatedEvent(), s;
  }
  applyEditorMaterial() {
    this._material && this._mesh && this.applyMaterial(this._material, this._mesh);
  }
  async replaceSceneAsync(e) {
    var t = null, n = null;
    this._material && this._zkMaterial && (t = this._material.serialize(), n = this._zkMaterial.get("rootUrl")), this.deleteScene(), this._scene = e, await this.setupSceneAsync(), t && n ? (this._material = BABYLON.Material.Parse(t, this._scene, n), this.fireMaterialCreatedEvent()) : this.createEditorMaterial(void 0, "Standard"), this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  createShaderMaterial() {
    let e = null;
    if (this._scene && this._zkMaterial && this._zkMaterial.get("shaders")) {
      const n = this._zkMaterial.get("name") || "ShaderMaterial - " + Zakeke.makeID(5);
      var t = {
        vertex: this._zkMaterial.get("shaders").get("name"),
        fragment: this._zkMaterial.get("shaders").get("name")
      };
      const s = {
        attributes: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Attribute),
        uniforms: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Uniform),
        samplers: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Sampler)
      };
      e = new BABYLON.ShaderMaterial(n, this._scene, t, s), this.setupShaderMaterialCameraPosition(e);
    }
    return e;
  }
  createEditorMaterialFromJson(e, t) {
    if (this._scene) {
      var n = JSON.parse(e);
      this._material = BABYLON.Material.Parse(n, this._scene, t), this._material && this.setupShaderMaterialCameraPosition(this._material), this.checkSceneEmptyEnvironmentTexture(), this.fireMaterialCreatedEvent();
    }
  }
  async createEditorMeshAsync() {
    switch (this.deleteEditorMesh(), this._meshType) {
      case 0:
        this._mesh = this.createBox(null, "box");
        break;
      case 1:
        {
          const e = await this.createRoundedCubeAsync(null, "rounded box");
          e.length == 1 ? this._mesh = e[0] : this._mesh = this.createGroup(null, "rounded box group", e);
        }
        break;
      case 2:
        this._mesh = this.createSphere(null, "sphere");
        break;
      case 3:
        this._mesh = this.createPlane(null, "plane");
        break;
      case 4:
        this._mesh = this.createCylinder(null, "cylinder");
        break;
      case 5:
        {
          const e = await this.createRoundedCylinderAsync(null, "rounded cylinder");
          e.length == 1 ? this._mesh = e[0] : (this._mesh = this.createGroup(null, "rounded cylinder group"), e.forEach((t) => t.parent = this._mesh));
        }
        break;
      case 6:
        this._mesh = this.createTorus(null, "torus");
        break;
      case 7:
        this._mesh = this.createKnot(null, "knot");
        break;
      case 8:
        this._mesh = this.createRibbon(null, "ribbon");
        break;
    }
    this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  async setEditorMeshType(e) {
    this._meshType = e, await this.createEditorMeshAsync();
  }
  async updateMaterialModelAsync() {
    if (this._zkMaterial && this._material && this._sceneHelper) {
      const t = await this._sceneHelper.takeMaterialScreenshotAsync(this._material.id, 500, 450);
      this._zkMaterial.set("imageData", t);
      const n = this._zkMaterial.get("name");
      n && n != this._material.name && (this._material.name = n);
      var e = this.getEditorMaterialJson();
      e && this._zkMaterial.set("JSON", e);
    }
  }
  getEditorMaterialJson() {
    if (this._scene && this._sceneHelper && this._material) {
      const n = this._sceneHelper;
      this._scene.textures.forEach((s) => {
        if (n.isTextureWithUrl(s) && s.url) {
          var o = s.url.lastIndexOf("/");
          if (o !== -1 && (o = s.url.lastIndexOf("/", o - 1), o !== -1 && (o = s.url.lastIndexOf("/", o - 1), o != -1))) {
            var h = s.url.substring(o + 1);
            s.name = h, s.url = s.name;
          }
        }
      });
      var e = this._material.serialize(), t = JSON.stringify(e);
      return t;
    }
    return null;
  }
  setMaterialModel(e, t) {
    if (this._zkMaterial = e, this.deleteEditorMaterial(), this._zkMaterial && this._zkMaterial instanceof Zakeke.Material) {
      const o = this._zkMaterial.get("shaders");
      if (o) {
        const h = o.get("name"), c = o.get("vertex"), m = o.get("fragment");
        h && c && m && this.setupShadersStore({ name: h, vertex: c, fragment: m });
      }
      var n = this._zkMaterial.get("JSON"), s = this._zkMaterial.get("rootUrl");
      n && s ? this.createEditorMaterialFromJson(n, s) : this.createEditorMaterial(this._zkMaterial.get("name") || void 0, t), this._material && (this._material.id = this._zkMaterial.getMaterialID());
    } else
      this.createEditorMaterial(void 0, t);
    this.applyEditorMaterial(), this.adjustCamera(!1), this.setupShaderMaterialsCameraPosition();
  }
  getTexturesUploadUrl(e) {
    return this._zkMaterial ? this._zkMaterial.getTexturesUrl() : "";
  }
  loadEditorMaterialTextureFiles__(e, t, n, s) {
    this.loadTextureFiles(e, this._material, t, !1, n, s);
  }
  loadEditorMaterialTextureFiles(e, t, n, s) {
    if (!this._material)
      return;
    const o = (M) => {
      let Z = M.lastIndexOf(".");
      if (Z !== -1)
        return M.substring(Z);
    }, h = (M, Z) => {
      const V = M.lastIndexOf(".");
      return V !== -1 ? M.substring(0, V).endsWith("_" + Z) : !1;
    };
    if (!(!e || e.length == 0)) {
      var c = this.canLoadCubemap(this._material, t) && (e.length == 6 || o(e[0].name) == ".dds" || o(e[0].name) == ".hdr"), m = [];
      if (c && e.length == 6) {
        var x = ["px", "py", "pz", "nx", "ny", "nz"];
        for (let M = 0; M < e.length; M++) {
          const Z = e[M];
          let V = -1;
          for (var B = 0; B < x.length; B++)
            if (h(Z.name, x[B])) {
              m.push(Z), V = B;
              break;
            }
          V !== -1 && x.splice(V, 1);
        }
        if (x.length != 0) {
          var I = "Immagini per la cube map non valide";
          s && s(I), Logger.info(I);
          return;
        }
      } else
        m.push(e[0]);
      var F = new FormData();
      for (let M = 0; M < m.length; M++)
        F.append("file-" + M, m[M]);
      jQuery.ajax({
        url: this.getTexturesUploadUrl(this._material.id),
        data: F,
        cache: !1,
        contentType: !1,
        processData: !1,
        type: "POST",
        success: (M) => {
          Object.prototype.toString.call(M) === "[object Array]" && (c ? this.setEditorMaterialCubeTextureImages(M, t) : this.setEditorMaterialTextureImage(M[0], t)), n && n();
        },
        error: (M, Z, V) => {
          var te = "An error occurred: " + Z + "nError: " + V;
          s && s(te);
        }
      });
    }
  }
  setEditorMaterialTextureImage(e, t) {
    if (this._scene && this._zkMaterial && this._material && e && e.imageUrl && e.fileObjectID) {
      const n = new Zakeke.MaterialTextureImage();
      n.set("textureImageID", Zakeke.generateUUID()), n.set("fileObjectID", e.fileObjectID), n.set("imageUrl", e.imageUrl), this._zkMaterial.get("textureImages").push(n);
      const s = e.imageUrl, o = new BABYLON.Texture(s, this._scene), h = this.getMaterialTexture(this._material, t);
      h && h instanceof BABYLON.Texture && (o.uScale = h.uScale, o.vScale = h.vScale, o.uOffset = h.uOffset, o.vOffset = h.vOffset, o.uAng = h.uAng, o.vAng = h.vAng, o.level = h.level, o.coordinatesIndex = h.coordinatesIndex, o.coordinatesMode = h.coordinatesMode, o.hasAlpha = h.hasAlpha, o.wrapU = h.wrapU, o.wrapV = h.wrapV), this.applyTexture(o, this._material, t), h && !this.isTextureUsed(h) && h.dispose();
    }
  }
  setEditorMaterialCubeTextureImages(e, t) {
    if (!this._scene || !this._zkMaterial || !this._material || Object.prototype.toString.call(e) != "[object Array]")
      return;
    let n = null;
    const s = () => this.setRenderingNeeded();
    if (e.length == 1) {
      let m = e[0];
      if (m.imageUrl && m.fileObjectID) {
        m.imageUrl.endsWith(".dds") ? n = BABYLON.CubeTexture.CreateFromPrefilteredData(m.imageUrl, this._scene) : m.imageUrl.endsWith(".hdr") && (n = new BABYLON.HDRCubeTexture(
          m.imageUrl,
          this._scene,
          512,
          void 0,
          void 0,
          void 0,
          void 0,
          s
        ));
        var o = new Zakeke.MaterialTextureImage();
        o.set("textureImageID", Zakeke.generateUUID()), o.set("fileObjectID", m.fileObjectID), o.set("imageUrl", m.imageUrl), this._zkMaterial.get("textureImages").push(o);
      }
    } else if (e.length == 6) {
      const m = ["px", "py", "pz", "nx", "ny", "nz"];
      let x = "";
      const B = [], I = [], F = (V, te) => {
        var P = V.lastIndexOf(".");
        if (P !== -1) {
          var K = V.substring(0, P);
          return K.endsWith("_" + te);
        }
        return !1;
      }, M = (V, te) => {
        const P = V.lastIndexOf(".");
        if (P !== -1) {
          var K = V.substring(0, P);
          if (K.endsWith("_" + te))
            return K.substring(0, K.length - ("_" + te).length);
        }
        return null;
      }, Z = (V, te) => {
        const P = V.lastIndexOf("_" + te);
        return P !== -1 ? V.substr(P) : null;
      };
      for (let V = 0; V < m.length; V++) {
        var h = m[V];
        for (let te = 0; te < e.length; te++) {
          const K = e[te].imageUrl;
          if (K && F(K, h)) {
            B.push(K), I.push(Z(K, h) ?? ""), x || (x = M(K, h) ?? "");
            break;
          }
        }
      }
      for (let V = 0; V < e.length; V++) {
        const te = e[V];
        if (te.imageUrl && te.fileObjectID != null) {
          const P = te.imageUrl, K = te.fileObjectID, J = new Zakeke.MaterialTextureImage();
          J.set("textureImageID", Zakeke.generateUUID()), J.set("fileObjectID", K), J.set("imageUrl", P), this._zkMaterial.get("textureImages").push(J);
        }
      }
      n = new BABYLON.CubeTexture(x, this._scene, I, !1, B);
    }
    if (n) {
      var c = this.getMaterialTexture(this._material, t);
      this.applyTexture(n, this._material, t), c && !this.isTextureUsed(c) && c.dispose();
    }
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireMaterialCreatedEvent() {
    for (let e = 0; e < this._materialCreatedListeners.length; ++e)
      this._materialCreatedListeners[e]();
  }
  addMaterialCreatedListener(e) {
    this._materialCreatedListeners.push(e);
  }
  //#region Load Custom Mesh
  loadFiles(e, t, n) {
    if (!this._engine || !this._scene || !this._sceneHelper)
      return;
    const s = this._engine, o = this._scene, h = this._sceneHelper;
    this._filesInput || (this._filesInput = new BABYLON.FilesInput(
      s,
      o,
      async (c, m) => {
        await this.replaceSceneAsync(m);
        const x = h.getSceneMeshes();
        this._meshType = 9, this._mesh = this.createGroup(null, "group", x), this.applyEditorMaterial(), t && t();
      },
      null,
      //(progress: BABYLON.SceneLoaderProgressEvent) => { }, // progressCallback
      null,
      //() => { },  // additionalRenderLoopLogicCallback
      null,
      //(remaining: number) => { }, // textureLoadingCallback
      null,
      //(files?: File[]) => { },  // startingProcessingFilesCallback
      null,
      //(sceneFile: File) => { }, // onReloadCallback
      (c, m, x) => {
        n && n(x);
      }
    )), this._filesInput && this._filesInput.loadFiles(e);
  }
  //#endregion
}
const $1 = "https://3dviewer-img.futurefashionsolution.com/_common/envMap/default.env", dS = {
  general: {
    backgroundAlpha: 1,
    backgroundColor: "#ffffff",
    screenshotBackgroundColor: null,
    removeDefaultBackground: !0,
    environmentTexture: $1,
    matchSameNameTextures: null,
    antialiasEnabled: null,
    tryOnEnabled: null,
    tryOnSettings: null,
    arEnabled: !0,
    arOnTheFly: !1,
    arAnchor: null,
    arScale: null,
    meshSize: {
      height: null,
      width: null,
      depth: null
    },
    antialias: {
      desktop: {
        enabled: !0,
        inRotationEnabled: !0
      }
    },
    frameDAMSettings: null,
    useDelayedTextureLoading: null,
    useDelayedMaterialLoading: null,
    useMaterialOffloading: null,
    prefetchMeshes: null,
    prefetchMaterials: null,
    exposure: 1,
    contrast: 1,
    preventDefaultLights: !0,
    forceDracoCompression: null,
    fitToScreenMargin: 1,
    environmentOptions: {
      mipMaps: !1,
      generateHarmonics: !1,
      gammaSpace: !0,
      prefilterOnLoad: !0,
      rotationY: 1.57,
      intensity: 1,
      // environment intensity
      pbrIntensity: 1
      // pbr intensity
    }
  },
  environment: {
    sizeAuto: null,
    mainColor: "#CB0E00",
    backgroundColor: "#5CA0B5",
    skybox: {
      createSkybox: !1,
      size: null,
      texture: null,
      extensions: null,
      files: null,
      color: null,
      blur: 0
    },
    ground: {
      createGround: !1,
      size: null,
      texture: null,
      color: null,
      opacity: null,
      enableShadow: !1,
      shadowLevel: null,
      enableMirror: !0,
      mirrorBlurKernel: null
    },
    shadows: {
      enableShadows: !1,
      groundSizeMultiplierWidth: 1.2,
      groundSizeMultiplierLength: 1.5,
      shadowMapSize: 51,
      shadowHexColor: "#454545",
      contactHardeningUVRatio: 0.4,
      useContactHardeningShadow: !0,
      useBlurCloseExponentialShadowMap: !1,
      usePercentageCloserFiltering: !1,
      useKernelBlur: !0,
      usePoissonSampling: !1,
      blurBoxOffset: 10,
      blurScale: 4,
      blurKernel: 10,
      depthScale: 1,
      shadowDarkness: 0.3
    }
  },
  camera: {
    autoRotate: !1,
    rotationSpeed: 0.2,
    changeRotationDirection: !1,
    contrast: 1.6,
    exposure: 0.8,
    toneMappingEnabled: !0,
    toneMappingType: 0,
    setInitialZoomToBoundingBox: !0,
    initialZoomToBBInertiaDamping: 0.9,
    initialZoomToBBModelSizeRadius: 0.7,
    initialZoomToBBScrollZoomEnabled: !0,
    initialZoomToBBScrollLowerLimit: 2,
    initialZoomToBBScrollUpperLimit: 2,
    positionScale: null,
    limitLowerRadius: !0,
    zoomEnabled: null,
    useMinZoomPerc: !0,
    minZoomPerc: 0.5,
    useMaxZoomPerc: !0,
    maxZoomPerc: 1.5,
    lowerAlphaLimit: null,
    upperAlphaLimit: null,
    fixedAlphaAngle: null,
    fixedBetaAngle: null,
    useLowerAlphaLimit: null,
    lowerBetaLimit: 0,
    upperBetaLimit: 3,
    useLowerBetaLimit: null,
    useUpperAlphaLimit: null,
    useUpperBetaLimit: null,
    zoom: 0,
    position: {
      alpha: 1.57,
      beta: 1.55,
      fov: 0.4
    },
    animateIntro: !1
  },
  model: {
    rotation: {
      x: 0,
      y: 0,
      z: 0
    },
    position: {
      x: 0,
      y: 0,
      z: 0
    },
    scale: {
      x: 1,
      y: 1,
      z: 1
    },
    config: {
      doubleSided: !1
    }
  },
  glow: null,
  infoPoints: null,
  uiConfig: {
    urlARIcon: "",
    urlLoader: ""
  },
  lights: {
    directionalLightBack: {
      position: {
        x: -1,
        y: 0,
        z: -1
      },
      general: {
        intensity: 3,
        visible: !0
      }
    },
    directionalLightLeft: {
      position: {
        x: 0,
        y: 0,
        z: 1
      },
      general: {
        intensity: 1.2,
        visible: !0
      }
    },
    pointLightBack: {
      position: {
        x: 1,
        y: 0.5,
        z: 0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    pointLightFront: {
      position: {
        x: -1,
        y: 0.5,
        z: -0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    hemisphereLight: {
      position: {
        x: 0,
        y: 30.76964,
        z: 0
      },
      general: {
        intensity: 0.5,
        visible: !1
      }
    }
  },
  textures: null,
  animations: {
    runAtStart: !0,
    loop: !0,
    speed: 1
  }
};
export {
  Nl as AndroidAR,
  u1 as AxesLayer,
  eg as BlendProceduralTexture,
  ho as BlurXProceduralTexture,
  uo as BlurYProceduralTexture,
  G1 as BroadcastChannelEventType,
  h1 as DAMViewerAnalyticsEventType,
  ed as Database,
  gi as DefaultAssetUrls,
  n1 as DracoCompression,
  Ja as EditingMode,
  Z1 as EditorMeshType,
  tg as ElementSelector,
  cg as EnvironmentManager,
  Ir as EnvironmentMode,
  f1 as EventState,
  co as ForegroundBackgroundProceduralTexture,
  Pw as GlowManager,
  Jf as IS_ANDROID,
  Qf as IS_IOS,
  Dw as IncrementalFiles,
  o1 as InfoPointsManager,
  Jw as InnerShadow,
  c1 as LightsLayer,
  Bg as MaterialEditor,
  j1 as MaterialGroup,
  $w as MaterialPreviewData,
  fo as MaterialsPreview,
  hg as MeshDesignManager,
  hw as MeshExpander,
  Ow as MeshLocationsManager,
  bu as MoveProceduralTexture,
  vg as MultiObserver,
  ro as MultiplyProceduralTexture,
  Kd as NormalMapProceduralTexture,
  yg as Observable,
  d1 as Observer,
  Cw as OpacityProceduralTexture,
  Qw as OuterShadow,
  dl as OverlayProceduralTexture,
  fS as Preview3DConfigurationManager,
  Kw as ProceduralNormalMap,
  Iw as SceneActionsExecutor,
  e1 as SceneDesignManager,
  q1 as SceneEditor,
  yi as SceneHelper,
  a1 as SceneToBlobs,
  ku as SceneViewer,
  W1 as SourceTaskStatus,
  Ms as StringTools,
  l1 as TryOnFineTuningMazingEnvironment,
  _g as TryOnProvider,
  Ds as TryOnSettingsType,
  mg as TryOnType,
  uw as UsdzHelper,
  Au as WorkerPool,
  Py as ZakekeEnvironment,
  oa as arrayContains,
  Hw as changeColorLuminosity,
  aS as chunkString,
  Yw as cropImageTransparency,
  rS as cropImageTransparencyAsync,
  jw as cropToContentAsync,
  og as dataURItoBlob,
  Rh as debounce,
  dS as defaultSceneConfig,
  uS as flipImage,
  lS as getAbsoluteUrl,
  Uw as getColorBrightness,
  sS as getColorImage,
  iS as getContrastYIQ,
  nS as getContrastYIQHex,
  cS as getNavigatorQueryParams,
  hS as getRandomString,
  oS as getStringHashCode,
  tS as getViewport,
  Q1 as isAndroid,
  Vw as isColorDark,
  J1 as isIPhoneX,
  Fw as isMobile,
  rl as isPBRMaterial,
  eS as isiOS,
  ag as removeBlanks,
  Zw as resizeImageFromDataUri,
  Gw as trimCanvas,
  Zh as trimImageAsync
};
